export const naicsCodes = [
    {
      NAICS22: "111110",
      "INDEX ITEM DESCRIPTION": "Soybean farming, field and seed production",
    },
    {
      NAICS22: "111120",
      "INDEX ITEM DESCRIPTION": "Canola farming, field and seed production",
    },
    {
      NAICS22: "111120",
      "INDEX ITEM DESCRIPTION": "Flaxseed farming, field and seed production",
    },
    {
      NAICS22: "111120",
      "INDEX ITEM DESCRIPTION": "Mustard seed farming, field and seed production",
    },
    {
      NAICS22: "111120",
      "INDEX ITEM DESCRIPTION":
        "Oilseed farming (except soybean), field and seed production",
    },
    {
      NAICS22: "111120",
      "INDEX ITEM DESCRIPTION": "Rapeseed farming, field and seed production",
    },
    {
      NAICS22: "111120",
      "INDEX ITEM DESCRIPTION": "Safflower farming, field and seed production",
    },
    {
      NAICS22: "111120",
      "INDEX ITEM DESCRIPTION": "Sesame farming, field and seed production",
    },
    {
      NAICS22: "111120",
      "INDEX ITEM DESCRIPTION": "Sunflower farming, field and seed production",
    },
    {
      NAICS22: "111130",
      "INDEX ITEM DESCRIPTION": "Bean farming, dry, field and seed production",
    },
    {
      NAICS22: "111130",
      "INDEX ITEM DESCRIPTION": "Cowpea farming, dry, field and seed production",
    },
    {
      NAICS22: "111130",
      "INDEX ITEM DESCRIPTION":
        "Garbanzo farming, dry, field and seed production",
    },
    {
      NAICS22: "111130",
      "INDEX ITEM DESCRIPTION": "Lentil farming, dry, field and seed production",
    },
    {
      NAICS22: "111130",
      "INDEX ITEM DESCRIPTION":
        "Lima bean farming, dry, field and seed production",
    },
    {
      NAICS22: "111130",
      "INDEX ITEM DESCRIPTION": "Pea farming, dry, field and seed production",
    },
    {
      NAICS22: "111140",
      "INDEX ITEM DESCRIPTION": "Wheat farming, field and seed production",
    },
    {
      NAICS22: "111150",
      "INDEX ITEM DESCRIPTION":
        "Corn farming (except sweet corn), field and seed production",
    },
    {
      NAICS22: "111150",
      "INDEX ITEM DESCRIPTION": "Popcorn farming, field and seed production",
    },
    {
      NAICS22: "111160",
      "INDEX ITEM DESCRIPTION":
        "Rice (except wild rice) farming, field and seed production",
    },
    {
      NAICS22: "111191",
      "INDEX ITEM DESCRIPTION":
        "Oilseed and grain combination farming, field and seed production",
    },
    {
      NAICS22: "111199",
      "INDEX ITEM DESCRIPTION": "Barley farming, field and seed production",
    },
    {
      NAICS22: "111199",
      "INDEX ITEM DESCRIPTION": "Broomcorn farming",
    },
    {
      NAICS22: "111199",
      "INDEX ITEM DESCRIPTION": "Buckwheat farming",
    },
    {
      NAICS22: "111199",
      "INDEX ITEM DESCRIPTION": "Milo farming, field and seed production",
    },
    {
      NAICS22: "111199",
      "INDEX ITEM DESCRIPTION": "Oat farming, field and seed production",
    },
    {
      NAICS22: "111199",
      "INDEX ITEM DESCRIPTION": "Rye farming, field and seed production",
    },
    {
      NAICS22: "111199",
      "INDEX ITEM DESCRIPTION": "Sorghum farming, field and seed production",
    },
    {
      NAICS22: "111199",
      "INDEX ITEM DESCRIPTION": "Wild rice farming, field and seed production",
    },
    {
      NAICS22: "111211",
      "INDEX ITEM DESCRIPTION":
        "Potato farming, field and seed potato production",
    },
    {
      NAICS22: "111211",
      "INDEX ITEM DESCRIPTION":
        "Sweet potato farming, field and seed potato production",
    },
    {
      NAICS22: "111211",
      "INDEX ITEM DESCRIPTION":
        "Vegetable and melon farming, potato dominant crop, field and seed production",
    },
    {
      NAICS22: "111211",
      "INDEX ITEM DESCRIPTION":
        "Vegetable and potato farming, potato dominant crop, field and seed potato production",
    },
    {
      NAICS22: "111211",
      "INDEX ITEM DESCRIPTION": "Yam farming, field and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Acorn squash farming, field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Artichoke farming, field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Asparagus farming, field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Bean (except dry) farming, field and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Beet farming (except sugar beets), field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Broccoli farming, field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Brussel sprout farming, field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Butternut squash farming, field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Cabbage farming, field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Cantaloupe farming, field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Carrot farming, field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Casaba melon farming, field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION": "Cassava farming, field and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Cauliflower farming, field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Celery farming, field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Chinese pea farming, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Chive farming, field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Collard farming, field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Cowpea (except dry) farming, field and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Crenshaw melon farming, field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Cucumber farming (except under cover), field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION": "Dill farming, field and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Eggplant farming (except under cover), field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Endive farming (except under cover), field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "English pea farming (except under cover), field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Escarole farming (except under cover), field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Garlic farming (except under cover), field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Gingerroot farming (except under cover), field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Ginseng farming (except under cover), field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION": "Green bean farming, field and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION": "Green cowpea farming, field and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Green lima bean farming, field and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION": "Green pea farming, field and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Honeydew melon farming, field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Kale farming, field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Leek farming, field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Lettuce farming, field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Melon farming (e.g., cantaloupe, casaba, honeydew, watermelon), field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Muskmelon farming, field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Okra farming, field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Onion farming, field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Parsley farming, field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Parsnip farming, field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Pea (except dry) farming, field and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Pepper (e.g., bell, chili, green, hot, red, sweet) farming",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION": "Pumpkin farming, field and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION": "Radish farming, field and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION": "Rhubarb farming, field and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Romaine lettuce farming, field and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION": "Rutabaga farming, field and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION": "Shallot farming, field and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Snap bean farming (i.e., bush and pole), field and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION": "Snow pea farming, field and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Spaghetti squash farming, field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Spinach farming, field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Squash farming, field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION": "String bean farming, field and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION": "Sweet corn farming, field and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Sweet pepper farming, field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION": "Taro farming, field and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Tomato farming (except under cover), field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Truck farming, field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Turnip farming, field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Vegetable and melon farming, vegetable (except potato) and melon dominant crops, field, bedding plants and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Vegetable and potato farming, vegetable (except potato) dominant crops, field, bedding plants and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Watermelon farming, field, bedding plant and seed production",
    },
    {
      NAICS22: "111219",
      "INDEX ITEM DESCRIPTION":
        "Zucchini farming, field, bedding plant and seed production",
    },
    {
      NAICS22: "111310",
      "INDEX ITEM DESCRIPTION": "Orange groves",
    },
    {
      NAICS22: "111320",
      "INDEX ITEM DESCRIPTION": "Citrus groves (except orange)",
    },
    {
      NAICS22: "111320",
      "INDEX ITEM DESCRIPTION": "Grapefruit groves",
    },
    {
      NAICS22: "111320",
      "INDEX ITEM DESCRIPTION": "Lemon groves",
    },
    {
      NAICS22: "111320",
      "INDEX ITEM DESCRIPTION": "Lime groves",
    },
    {
      NAICS22: "111320",
      "INDEX ITEM DESCRIPTION": "Mandarin groves",
    },
    {
      NAICS22: "111320",
      "INDEX ITEM DESCRIPTION": "Tangelo groves",
    },
    {
      NAICS22: "111320",
      "INDEX ITEM DESCRIPTION": "Tangerine groves",
    },
    {
      NAICS22: "111331",
      "INDEX ITEM DESCRIPTION": "Apple orchards",
    },
    {
      NAICS22: "111332",
      "INDEX ITEM DESCRIPTION": "Grape farming without making wine",
    },
    {
      NAICS22: "111332",
      "INDEX ITEM DESCRIPTION": "Raisin farming",
    },
    {
      NAICS22: "111333",
      "INDEX ITEM DESCRIPTION": "Strawberry farming",
    },
    {
      NAICS22: "111334",
      "INDEX ITEM DESCRIPTION": "Berry (except strawberry) farming",
    },
    {
      NAICS22: "111334",
      "INDEX ITEM DESCRIPTION": "Blackberry farming",
    },
    {
      NAICS22: "111334",
      "INDEX ITEM DESCRIPTION": "Blueberry farming",
    },
    {
      NAICS22: "111334",
      "INDEX ITEM DESCRIPTION": "Boysenberry farming",
    },
    {
      NAICS22: "111334",
      "INDEX ITEM DESCRIPTION": "Cranberry farming",
    },
    {
      NAICS22: "111334",
      "INDEX ITEM DESCRIPTION": "Currant farming",
    },
    {
      NAICS22: "111334",
      "INDEX ITEM DESCRIPTION": "Dewberry farming",
    },
    {
      NAICS22: "111334",
      "INDEX ITEM DESCRIPTION": "Gooseberry farming",
    },
    {
      NAICS22: "111334",
      "INDEX ITEM DESCRIPTION": "Huckleberry farming",
    },
    {
      NAICS22: "111334",
      "INDEX ITEM DESCRIPTION": "Loganberry farming",
    },
    {
      NAICS22: "111334",
      "INDEX ITEM DESCRIPTION": "Raspberry farming",
    },
    {
      NAICS22: "111334",
      "INDEX ITEM DESCRIPTION": "Youngberry farming",
    },
    {
      NAICS22: "111335",
      "INDEX ITEM DESCRIPTION": "Almond farming",
    },
    {
      NAICS22: "111335",
      "INDEX ITEM DESCRIPTION": "Brazil nut farming",
    },
    {
      NAICS22: "111335",
      "INDEX ITEM DESCRIPTION": "Cashew farming",
    },
    {
      NAICS22: "111335",
      "INDEX ITEM DESCRIPTION": "Filbert farming",
    },
    {
      NAICS22: "111335",
      "INDEX ITEM DESCRIPTION": "Hazelnut farming",
    },
    {
      NAICS22: "111335",
      "INDEX ITEM DESCRIPTION": "Macadamia farming",
    },
    {
      NAICS22: "111335",
      "INDEX ITEM DESCRIPTION": "Pecan farming",
    },
    {
      NAICS22: "111335",
      "INDEX ITEM DESCRIPTION": "Pistachio farming",
    },
    {
      NAICS22: "111335",
      "INDEX ITEM DESCRIPTION": "Tree nut farming",
    },
    {
      NAICS22: "111335",
      "INDEX ITEM DESCRIPTION": "Walnut farming",
    },
    {
      NAICS22: "111336",
      "INDEX ITEM DESCRIPTION": "Fruit and tree nut combination farming",
    },
    {
      NAICS22: "111339",
      "INDEX ITEM DESCRIPTION": "Apricot farming",
    },
    {
      NAICS22: "111339",
      "INDEX ITEM DESCRIPTION": "Avocado farming",
    },
    {
      NAICS22: "111339",
      "INDEX ITEM DESCRIPTION": "Banana farming",
    },
    {
      NAICS22: "111339",
      "INDEX ITEM DESCRIPTION": "Cactus fruit farming",
    },
    {
      NAICS22: "111339",
      "INDEX ITEM DESCRIPTION": "Cherry farming",
    },
    {
      NAICS22: "111339",
      "INDEX ITEM DESCRIPTION": "Coconut tree farming",
    },
    {
      NAICS22: "111339",
      "INDEX ITEM DESCRIPTION": "Coffee farming",
    },
    {
      NAICS22: "111339",
      "INDEX ITEM DESCRIPTION": "Date farming",
    },
    {
      NAICS22: "111339",
      "INDEX ITEM DESCRIPTION":
        "Deciduous tree fruit (except apples, citrus) farming",
    },
    {
      NAICS22: "111339",
      "INDEX ITEM DESCRIPTION": "Fig farming",
    },
    {
      NAICS22: "111339",
      "INDEX ITEM DESCRIPTION": "Guava farming",
    },
    {
      NAICS22: "111339",
      "INDEX ITEM DESCRIPTION": "Kiwi fruit farming",
    },
    {
      NAICS22: "111339",
      "INDEX ITEM DESCRIPTION": "Mango farming",
    },
    {
      NAICS22: "111339",
      "INDEX ITEM DESCRIPTION": "Nectarine farming",
    },
    {
      NAICS22: "111339",
      "INDEX ITEM DESCRIPTION": "Noncitrus fruit farming",
    },
    {
      NAICS22: "111339",
      "INDEX ITEM DESCRIPTION": "Olive farming",
    },
    {
      NAICS22: "111339",
      "INDEX ITEM DESCRIPTION": "Papaya farming",
    },
    {
      NAICS22: "111339",
      "INDEX ITEM DESCRIPTION": "Passion fruit farming",
    },
    {
      NAICS22: "111339",
      "INDEX ITEM DESCRIPTION": "Peach farming",
    },
    {
      NAICS22: "111339",
      "INDEX ITEM DESCRIPTION": "Pear farming",
    },
    {
      NAICS22: "111339",
      "INDEX ITEM DESCRIPTION": "Persimmon farming",
    },
    {
      NAICS22: "111339",
      "INDEX ITEM DESCRIPTION": "Pineapple farming",
    },
    {
      NAICS22: "111339",
      "INDEX ITEM DESCRIPTION": "Plantain farming",
    },
    {
      NAICS22: "111339",
      "INDEX ITEM DESCRIPTION": "Plum farming",
    },
    {
      NAICS22: "111339",
      "INDEX ITEM DESCRIPTION": "Pomegranate farming",
    },
    {
      NAICS22: "111339",
      "INDEX ITEM DESCRIPTION": "Prickly pear farming",
    },
    {
      NAICS22: "111339",
      "INDEX ITEM DESCRIPTION": "Prune farming",
    },
    {
      NAICS22: "111339",
      "INDEX ITEM DESCRIPTION": "Quince farming",
    },
    {
      NAICS22: "111411",
      "INDEX ITEM DESCRIPTION": "Mushroom farming",
    },
    {
      NAICS22: "111411",
      "INDEX ITEM DESCRIPTION": "Mushroom spawn farming",
    },
    {
      NAICS22: "111411",
      "INDEX ITEM DESCRIPTION": "Shitake mushroom farming",
    },
    {
      NAICS22: "111419",
      "INDEX ITEM DESCRIPTION": "Alfalfa sprout farming, grown under cover",
    },
    {
      NAICS22: "111419",
      "INDEX ITEM DESCRIPTION": "Bean sprout farming,  grown under cover",
    },
    {
      NAICS22: "111419",
      "INDEX ITEM DESCRIPTION": "Cannabis, grown under cover",
    },
    {
      NAICS22: "111419",
      "INDEX ITEM DESCRIPTION": "Cucumber farming, grown under cover",
    },
    {
      NAICS22: "111419",
      "INDEX ITEM DESCRIPTION": "Eggplant farming, grown under cover",
    },
    {
      NAICS22: "111419",
      "INDEX ITEM DESCRIPTION": "Endive farming, grown under cover",
    },
    {
      NAICS22: "111419",
      "INDEX ITEM DESCRIPTION": "English pea farming, grown under cover",
    },
    {
      NAICS22: "111419",
      "INDEX ITEM DESCRIPTION": "Escarole farming, grown under cover",
    },
    {
      NAICS22: "111419",
      "INDEX ITEM DESCRIPTION": "Fruit farming, grown under cover",
    },
    {
      NAICS22: "111419",
      "INDEX ITEM DESCRIPTION": "Garlic farming, grown under cover",
    },
    {
      NAICS22: "111419",
      "INDEX ITEM DESCRIPTION": "Gingerroot farming, grown under cover",
    },
    {
      NAICS22: "111419",
      "INDEX ITEM DESCRIPTION": "Ginseng farming, grown under cover",
    },
    {
      NAICS22: "111419",
      "INDEX ITEM DESCRIPTION": "Hemp, grown under cover",
    },
    {
      NAICS22: "111419",
      "INDEX ITEM DESCRIPTION": "Herb farming, grown under cover",
    },
    {
      NAICS22: "111419",
      "INDEX ITEM DESCRIPTION": "Hydroponic crop farming",
    },
    {
      NAICS22: "111419",
      "INDEX ITEM DESCRIPTION": "Marijuana, grown under cover",
    },
    {
      NAICS22: "111419",
      "INDEX ITEM DESCRIPTION": "Melon farming, grown under cover",
    },
    {
      NAICS22: "111419",
      "INDEX ITEM DESCRIPTION": "Rhubarb, grown under cover",
    },
    {
      NAICS22: "111419",
      "INDEX ITEM DESCRIPTION": "Spice farming, grown under cover",
    },
    {
      NAICS22: "111419",
      "INDEX ITEM DESCRIPTION": "Tomato farming, grown under cover",
    },
    {
      NAICS22: "111419",
      "INDEX ITEM DESCRIPTION": "Truffles farming, grown under cover",
    },
    {
      NAICS22: "111419",
      "INDEX ITEM DESCRIPTION": "Vegetable farming, grown under cover",
    },
    {
      NAICS22: "111421",
      "INDEX ITEM DESCRIPTION": "Azalea farming",
    },
    {
      NAICS22: "111421",
      "INDEX ITEM DESCRIPTION": "Christmas tree growing",
    },
    {
      NAICS22: "111421",
      "INDEX ITEM DESCRIPTION": "Corms farming",
    },
    {
      NAICS22: "111421",
      "INDEX ITEM DESCRIPTION":
        "Field nurseries (i.e., growing of flowers and shrubbery)",
    },
    {
      NAICS22: "111421",
      "INDEX ITEM DESCRIPTION": "Flower bulb growing",
    },
    {
      NAICS22: "111421",
      "INDEX ITEM DESCRIPTION":
        "Fruit stock (e.g., plants, seedlings, trees) growing",
    },
    {
      NAICS22: "111421",
      "INDEX ITEM DESCRIPTION": "Herbaceous perennial growing",
    },
    {
      NAICS22: "111421",
      "INDEX ITEM DESCRIPTION": "Nursery stock growing",
    },
    {
      NAICS22: "111421",
      "INDEX ITEM DESCRIPTION":
        "Nursery with tree production (except for reforestation)",
    },
    {
      NAICS22: "111421",
      "INDEX ITEM DESCRIPTION": "Preseeded mat farming",
    },
    {
      NAICS22: "111421",
      "INDEX ITEM DESCRIPTION": "Propagation material farming",
    },
    {
      NAICS22: "111421",
      "INDEX ITEM DESCRIPTION": "Rose bush growing",
    },
    {
      NAICS22: "111421",
      "INDEX ITEM DESCRIPTION":
        "Short rotation woody tree growing (i.e., growing and harvesting cycle ten years or less)",
    },
    {
      NAICS22: "111421",
      "INDEX ITEM DESCRIPTION": "Shrubbery farming",
    },
    {
      NAICS22: "111421",
      "INDEX ITEM DESCRIPTION": "Sod farming",
    },
    {
      NAICS22: "111421",
      "INDEX ITEM DESCRIPTION": "Tissue culture farming",
    },
    {
      NAICS22: "111421",
      "INDEX ITEM DESCRIPTION":
        "Tree crop farming (except forestry), short rotation growing and harvesting cycle",
    },
    {
      NAICS22: "111421",
      "INDEX ITEM DESCRIPTION": "Turf farming",
    },
    {
      NAICS22: "111422",
      "INDEX ITEM DESCRIPTION":
        "Bedding plant growing (except vegetable and melon bedding plants)",
    },
    {
      NAICS22: "111422",
      "INDEX ITEM DESCRIPTION": "Cultivated florist greens growing",
    },
    {
      NAICS22: "111422",
      "INDEX ITEM DESCRIPTION": "Cut flower growing",
    },
    {
      NAICS22: "111422",
      "INDEX ITEM DESCRIPTION": "Cut rose growing",
    },
    {
      NAICS22: "111422",
      "INDEX ITEM DESCRIPTION": "Cuttings farming",
    },
    {
      NAICS22: "111422",
      "INDEX ITEM DESCRIPTION": "Flower growing",
    },
    {
      NAICS22: "111422",
      "INDEX ITEM DESCRIPTION": "Flower seed production",
    },
    {
      NAICS22: "111422",
      "INDEX ITEM DESCRIPTION": "Foliage growing",
    },
    {
      NAICS22: "111422",
      "INDEX ITEM DESCRIPTION": "Hanging basket plant growing",
    },
    {
      NAICS22: "111422",
      "INDEX ITEM DESCRIPTION": "House plant growing",
    },
    {
      NAICS22: "111422",
      "INDEX ITEM DESCRIPTION": "Ornamental plant growing",
    },
    {
      NAICS22: "111422",
      "INDEX ITEM DESCRIPTION": "Plant, ornamental, growing",
    },
    {
      NAICS22: "111422",
      "INDEX ITEM DESCRIPTION": "Plant, potted flower and foliage, growing",
    },
    {
      NAICS22: "111422",
      "INDEX ITEM DESCRIPTION": "Plug (i.e., floriculture products) growing",
    },
    {
      NAICS22: "111910",
      "INDEX ITEM DESCRIPTION": "Tobacco farming, field and seed production",
    },
    {
      NAICS22: "111920",
      "INDEX ITEM DESCRIPTION": "Cotton farming, field and seed production",
    },
    {
      NAICS22: "111920",
      "INDEX ITEM DESCRIPTION": "Cottonseed farming",
    },
    {
      NAICS22: "111930",
      "INDEX ITEM DESCRIPTION": "Cane farming, sugar, field production",
    },
    {
      NAICS22: "111930",
      "INDEX ITEM DESCRIPTION": "Sugarcane farming, field production",
    },
    {
      NAICS22: "111940",
      "INDEX ITEM DESCRIPTION": "Alfalfa hay farming",
    },
    {
      NAICS22: "111940",
      "INDEX ITEM DESCRIPTION": "Clover hay farming",
    },
    {
      NAICS22: "111940",
      "INDEX ITEM DESCRIPTION": "Grass hay farming",
    },
    {
      NAICS22: "111940",
      "INDEX ITEM DESCRIPTION":
        "Hay farming (e.g., alfalfa hay, clover hay, grass hay)",
    },
    {
      NAICS22: "111940",
      "INDEX ITEM DESCRIPTION": "Mixed hay farming",
    },
    {
      NAICS22: "111991",
      "INDEX ITEM DESCRIPTION": "Sugar beet farming",
    },
    {
      NAICS22: "111992",
      "INDEX ITEM DESCRIPTION": "Peanut farming",
    },
    {
      NAICS22: "111998",
      "INDEX ITEM DESCRIPTION": "Agave farming",
    },
    {
      NAICS22: "111998",
      "INDEX ITEM DESCRIPTION": "Alfalfa seed farming",
    },
    {
      NAICS22: "111998",
      "INDEX ITEM DESCRIPTION": "Aloe farming",
    },
    {
      NAICS22: "111998",
      "INDEX ITEM DESCRIPTION": "Amaranth farming",
    },
    {
      NAICS22: "111998",
      "INDEX ITEM DESCRIPTION": "Bentgrass seed farming",
    },
    {
      NAICS22: "111998",
      "INDEX ITEM DESCRIPTION": "Bluegrass-Kentucky seed farming",
    },
    {
      NAICS22: "111998",
      "INDEX ITEM DESCRIPTION": "Cannabis, grown in an open field",
    },
    {
      NAICS22: "111998",
      "INDEX ITEM DESCRIPTION": "Chicory farming",
    },
    {
      NAICS22: "111998",
      "INDEX ITEM DESCRIPTION": "Clover seed farming",
    },
    {
      NAICS22: "111998",
      "INDEX ITEM DESCRIPTION": "Crimson cloves seed farming",
    },
    {
      NAICS22: "111998",
      "INDEX ITEM DESCRIPTION": "Fescue seed farming",
    },
    {
      NAICS22: "111998",
      "INDEX ITEM DESCRIPTION":
        "General combination crop farming (except fruit and nut combinations, oilseed and grain, vegetable)",
    },
    {
      NAICS22: "111998",
      "INDEX ITEM DESCRIPTION": "Grass seed farming",
    },
    {
      NAICS22: "111998",
      "INDEX ITEM DESCRIPTION": "Guar farming",
    },
    {
      NAICS22: "111998",
      "INDEX ITEM DESCRIPTION": "Hay seed farming",
    },
    {
      NAICS22: "111998",
      "INDEX ITEM DESCRIPTION": "Hemp, grown in an open field",
    },
    {
      NAICS22: "111998",
      "INDEX ITEM DESCRIPTION": "Herb farming, open field",
    },
    {
      NAICS22: "111998",
      "INDEX ITEM DESCRIPTION": "Hop farming",
    },
    {
      NAICS22: "111998",
      "INDEX ITEM DESCRIPTION": "Jojoba farming",
    },
    {
      NAICS22: "111998",
      "INDEX ITEM DESCRIPTION": "Kenaf farming",
    },
    {
      NAICS22: "111998",
      "INDEX ITEM DESCRIPTION":
        "Maple sap concentrating (i.e., producing pure maple syrup in the field)",
    },
    {
      NAICS22: "111998",
      "INDEX ITEM DESCRIPTION": "Maple sap gathering",
    },
    {
      NAICS22: "111998",
      "INDEX ITEM DESCRIPTION": "Maple syrup (i.e., maple sap reducing)",
    },
    {
      NAICS22: "111998",
      "INDEX ITEM DESCRIPTION": "Marijuana, grown in an open field",
    },
    {
      NAICS22: "111998",
      "INDEX ITEM DESCRIPTION": "Mint farming",
    },
    {
      NAICS22: "111998",
      "INDEX ITEM DESCRIPTION": "Orchard grass seed farming",
    },
    {
      NAICS22: "111998",
      "INDEX ITEM DESCRIPTION": "Ryegrass seed farming",
    },
    {
      NAICS22: "111998",
      "INDEX ITEM DESCRIPTION": "Sorghum sudan seed farming",
    },
    {
      NAICS22: "111998",
      "INDEX ITEM DESCRIPTION": "Spice farming",
    },
    {
      NAICS22: "111998",
      "INDEX ITEM DESCRIPTION": "Syrup, pure maple (i.e., maple syrup reducing)",
    },
    {
      NAICS22: "111998",
      "INDEX ITEM DESCRIPTION": "Tea farming",
    },
    {
      NAICS22: "112111",
      "INDEX ITEM DESCRIPTION": "Backgrounding, cattle",
    },
    {
      NAICS22: "112111",
      "INDEX ITEM DESCRIPTION": "Beef cattle ranching or farming",
    },
    {
      NAICS22: "112111",
      "INDEX ITEM DESCRIPTION": "Calf (e.g., feeder, stocker, veal) production",
    },
    {
      NAICS22: "112111",
      "INDEX ITEM DESCRIPTION": "Cattle conditioning operations",
    },
    {
      NAICS22: "112111",
      "INDEX ITEM DESCRIPTION": "Cattle farming or ranching",
    },
    {
      NAICS22: "112111",
      "INDEX ITEM DESCRIPTION": "Dairy heifer replacement production",
    },
    {
      NAICS22: "112111",
      "INDEX ITEM DESCRIPTION": "Feeder calf production",
    },
    {
      NAICS22: "112111",
      "INDEX ITEM DESCRIPTION": "Stocker calf production",
    },
    {
      NAICS22: "112111",
      "INDEX ITEM DESCRIPTION": "Veal calf production",
    },
    {
      NAICS22: "112112",
      "INDEX ITEM DESCRIPTION":
        "Beef cattle feedlots (except stockyards for transportation)",
    },
    {
      NAICS22: "112112",
      "INDEX ITEM DESCRIPTION":
        "Cattle feedlots (except stockyards for transportation)",
    },
    {
      NAICS22: "112112",
      "INDEX ITEM DESCRIPTION": "Fattening cattle",
    },
    {
      NAICS22: "112112",
      "INDEX ITEM DESCRIPTION":
        "Feed yards (except stockyards for transportation), cattle",
    },
    {
      NAICS22: "112112",
      "INDEX ITEM DESCRIPTION":
        "Feedlots (except stockyards for transportation), cattle",
    },
    {
      NAICS22: "112120",
      "INDEX ITEM DESCRIPTION": "Dairy cattle farming",
    },
    {
      NAICS22: "112120",
      "INDEX ITEM DESCRIPTION": "Milk production, dairy cattle",
    },
    {
      NAICS22: "112120",
      "INDEX ITEM DESCRIPTION": "Milking dairy cattle",
    },
    {
      NAICS22: "112210",
      "INDEX ITEM DESCRIPTION": "Farrow-to-finish operations",
    },
    {
      NAICS22: "112210",
      "INDEX ITEM DESCRIPTION": "Feeder pig farming",
    },
    {
      NAICS22: "112210",
      "INDEX ITEM DESCRIPTION":
        "Feedlots (except stockyards for transportation), hog",
    },
    {
      NAICS22: "112210",
      "INDEX ITEM DESCRIPTION":
        "Hog and pig (including breeding, farrowing, nursery, and finishing activities) farming",
    },
    {
      NAICS22: "112210",
      "INDEX ITEM DESCRIPTION":
        "Hog feedlots (except stockyards for transportation)",
    },
    {
      NAICS22: "112210",
      "INDEX ITEM DESCRIPTION": "Pig farming",
    },
    {
      NAICS22: "112210",
      "INDEX ITEM DESCRIPTION": "Swine farming",
    },
    {
      NAICS22: "112210",
      "INDEX ITEM DESCRIPTION": "Weaning pig operations",
    },
    {
      NAICS22: "112310",
      "INDEX ITEM DESCRIPTION": "Chicken egg production",
    },
    {
      NAICS22: "112310",
      "INDEX ITEM DESCRIPTION": "Chicken eggs (table, hatching) production",
    },
    {
      NAICS22: "112310",
      "INDEX ITEM DESCRIPTION": "Cull hen production",
    },
    {
      NAICS22: "112310",
      "INDEX ITEM DESCRIPTION": "Egg production, chicken",
    },
    {
      NAICS22: "112310",
      "INDEX ITEM DESCRIPTION": "Eggs, chicken (table, hatching) production",
    },
    {
      NAICS22: "112310",
      "INDEX ITEM DESCRIPTION": "Layer-type chicken production",
    },
    {
      NAICS22: "112310",
      "INDEX ITEM DESCRIPTION": "Started pullet production",
    },
    {
      NAICS22: "112320",
      "INDEX ITEM DESCRIPTION": "Broiler chicken production",
    },
    {
      NAICS22: "112320",
      "INDEX ITEM DESCRIPTION": "Chicken production (except egg laying)",
    },
    {
      NAICS22: "112320",
      "INDEX ITEM DESCRIPTION": "Cornish hen production",
    },
    {
      NAICS22: "112320",
      "INDEX ITEM DESCRIPTION": "Fryer chicken production",
    },
    {
      NAICS22: "112320",
      "INDEX ITEM DESCRIPTION": "Roaster chicken production",
    },
    {
      NAICS22: "112330",
      "INDEX ITEM DESCRIPTION": "Egg production, turkey",
    },
    {
      NAICS22: "112330",
      "INDEX ITEM DESCRIPTION": "Turkey egg production",
    },
    {
      NAICS22: "112330",
      "INDEX ITEM DESCRIPTION": "Turkey production",
    },
    {
      NAICS22: "112340",
      "INDEX ITEM DESCRIPTION": "Chicken hatcheries",
    },
    {
      NAICS22: "112340",
      "INDEX ITEM DESCRIPTION": "Egg hatcheries, poultry",
    },
    {
      NAICS22: "112340",
      "INDEX ITEM DESCRIPTION": "Hatcheries, poultry",
    },
    {
      NAICS22: "112340",
      "INDEX ITEM DESCRIPTION": "Poultry hatcheries",
    },
    {
      NAICS22: "112340",
      "INDEX ITEM DESCRIPTION": "Turkey hatcheries",
    },
    {
      NAICS22: "112390",
      "INDEX ITEM DESCRIPTION": "Chukar partridge production",
    },
    {
      NAICS22: "112390",
      "INDEX ITEM DESCRIPTION": "Duck production",
    },
    {
      NAICS22: "112390",
      "INDEX ITEM DESCRIPTION": "Emu production",
    },
    {
      NAICS22: "112390",
      "INDEX ITEM DESCRIPTION": "Geese production",
    },
    {
      NAICS22: "112390",
      "INDEX ITEM DESCRIPTION": "Hungarian partridge production",
    },
    {
      NAICS22: "112390",
      "INDEX ITEM DESCRIPTION": "Ostrich production",
    },
    {
      NAICS22: "112390",
      "INDEX ITEM DESCRIPTION": "Partridge production",
    },
    {
      NAICS22: "112390",
      "INDEX ITEM DESCRIPTION": "Pheasant production",
    },
    {
      NAICS22: "112390",
      "INDEX ITEM DESCRIPTION": "Quail production",
    },
    {
      NAICS22: "112390",
      "INDEX ITEM DESCRIPTION": "Ratite production",
    },
    {
      NAICS22: "112410",
      "INDEX ITEM DESCRIPTION": "Dairy sheep farming",
    },
    {
      NAICS22: "112410",
      "INDEX ITEM DESCRIPTION":
        "Feedlots (except stockyards for transportation), lamb",
    },
    {
      NAICS22: "112410",
      "INDEX ITEM DESCRIPTION":
        "Lamb feedlots (except stockyards for transportation)",
    },
    {
      NAICS22: "112410",
      "INDEX ITEM DESCRIPTION": "Milking dairy sheep",
    },
    {
      NAICS22: "112410",
      "INDEX ITEM DESCRIPTION":
        "Sheep farming (e.g., meat, milk, wool production)",
    },
    {
      NAICS22: "112420",
      "INDEX ITEM DESCRIPTION": "Angora goat farming",
    },
    {
      NAICS22: "112420",
      "INDEX ITEM DESCRIPTION": "Dairy goat farming",
    },
    {
      NAICS22: "112420",
      "INDEX ITEM DESCRIPTION":
        "Goat farming (e.g., meat, milk, mohair production)",
    },
    {
      NAICS22: "112420",
      "INDEX ITEM DESCRIPTION": "Milking dairy goat",
    },
    {
      NAICS22: "112420",
      "INDEX ITEM DESCRIPTION": "Mohair farming",
    },
    {
      NAICS22: "112511",
      "INDEX ITEM DESCRIPTION": "Baitfish production, farm raising",
    },
    {
      NAICS22: "112511",
      "INDEX ITEM DESCRIPTION": "Catfish production, farm raising",
    },
    {
      NAICS22: "112511",
      "INDEX ITEM DESCRIPTION": "Finfish production, farm raising",
    },
    {
      NAICS22: "112511",
      "INDEX ITEM DESCRIPTION": "Finfish, hatcheries",
    },
    {
      NAICS22: "112511",
      "INDEX ITEM DESCRIPTION": "Fish farms, finfish",
    },
    {
      NAICS22: "112511",
      "INDEX ITEM DESCRIPTION": "Goldfish production, farm raising",
    },
    {
      NAICS22: "112511",
      "INDEX ITEM DESCRIPTION": "Hatcheries, finfish",
    },
    {
      NAICS22: "112511",
      "INDEX ITEM DESCRIPTION": "Hybrid striped bass production",
    },
    {
      NAICS22: "112511",
      "INDEX ITEM DESCRIPTION": "Minnow production, farm raising",
    },
    {
      NAICS22: "112511",
      "INDEX ITEM DESCRIPTION": "Ornamental fish production, farm raising",
    },
    {
      NAICS22: "112511",
      "INDEX ITEM DESCRIPTION": "Tilapia production",
    },
    {
      NAICS22: "112511",
      "INDEX ITEM DESCRIPTION": "Tropical fish production, farm raising",
    },
    {
      NAICS22: "112511",
      "INDEX ITEM DESCRIPTION": "Trout production, farm raising",
    },
    {
      NAICS22: "112512",
      "INDEX ITEM DESCRIPTION": "Clam production, farm raising",
    },
    {
      NAICS22: "112512",
      "INDEX ITEM DESCRIPTION": "Crawfish production, farm raising",
    },
    {
      NAICS22: "112512",
      "INDEX ITEM DESCRIPTION": "Crustacean production, farm raising",
    },
    {
      NAICS22: "112512",
      "INDEX ITEM DESCRIPTION": "Cultured pearl production, farm raising",
    },
    {
      NAICS22: "112512",
      "INDEX ITEM DESCRIPTION": "Fish farms, shellfish",
    },
    {
      NAICS22: "112512",
      "INDEX ITEM DESCRIPTION": "Hatcheries, shellfish",
    },
    {
      NAICS22: "112512",
      "INDEX ITEM DESCRIPTION": "Mollusk production, farm raising",
    },
    {
      NAICS22: "112512",
      "INDEX ITEM DESCRIPTION": "Mussel production, farm raising",
    },
    {
      NAICS22: "112512",
      "INDEX ITEM DESCRIPTION": "Oyster production, farm raising",
    },
    {
      NAICS22: "112512",
      "INDEX ITEM DESCRIPTION": "Shellfish hatcheries",
    },
    {
      NAICS22: "112512",
      "INDEX ITEM DESCRIPTION": "Shrimp production, farm raising",
    },
    {
      NAICS22: "112519",
      "INDEX ITEM DESCRIPTION": "Algae farming",
    },
    {
      NAICS22: "112519",
      "INDEX ITEM DESCRIPTION": "Alligator production, farm raising",
    },
    {
      NAICS22: "112519",
      "INDEX ITEM DESCRIPTION": "Animal aquaculture (except finfish, shellfish)",
    },
    {
      NAICS22: "112519",
      "INDEX ITEM DESCRIPTION": "Frog production, farm raising",
    },
    {
      NAICS22: "112519",
      "INDEX ITEM DESCRIPTION": "Plant aquaculture",
    },
    {
      NAICS22: "112519",
      "INDEX ITEM DESCRIPTION": "Sea plant agriculture",
    },
    {
      NAICS22: "112519",
      "INDEX ITEM DESCRIPTION": "Seaweed farming",
    },
    {
      NAICS22: "112519",
      "INDEX ITEM DESCRIPTION": "Turtle production, farm raising",
    },
    {
      NAICS22: "112910",
      "INDEX ITEM DESCRIPTION": "Bee pollen collection",
    },
    {
      NAICS22: "112910",
      "INDEX ITEM DESCRIPTION": "Bee production (i.e., apiculture)",
    },
    {
      NAICS22: "112910",
      "INDEX ITEM DESCRIPTION": "Beeswax production",
    },
    {
      NAICS22: "112910",
      "INDEX ITEM DESCRIPTION": "Honey bee production",
    },
    {
      NAICS22: "112910",
      "INDEX ITEM DESCRIPTION": "Propolis production, bees",
    },
    {
      NAICS22: "112910",
      "INDEX ITEM DESCRIPTION": "Queen bee production",
    },
    {
      NAICS22: "112910",
      "INDEX ITEM DESCRIPTION": "Royal jelly production, bees",
    },
    {
      NAICS22: "112920",
      "INDEX ITEM DESCRIPTION": "Burro production",
    },
    {
      NAICS22: "112920",
      "INDEX ITEM DESCRIPTION": "Donkey production",
    },
    {
      NAICS22: "112920",
      "INDEX ITEM DESCRIPTION": "Horse (including thoroughbreds) production",
    },
    {
      NAICS22: "112920",
      "INDEX ITEM DESCRIPTION": "Mule production",
    },
    {
      NAICS22: "112920",
      "INDEX ITEM DESCRIPTION": "Pony production",
    },
    {
      NAICS22: "112930",
      "INDEX ITEM DESCRIPTION": "Chinchilla production",
    },
    {
      NAICS22: "112930",
      "INDEX ITEM DESCRIPTION": "Fox production",
    },
    {
      NAICS22: "112930",
      "INDEX ITEM DESCRIPTION": "Fur-bearing animal production",
    },
    {
      NAICS22: "112930",
      "INDEX ITEM DESCRIPTION": "Mink production",
    },
    {
      NAICS22: "112930",
      "INDEX ITEM DESCRIPTION": "Rabbit production",
    },
    {
      NAICS22: "112990",
      "INDEX ITEM DESCRIPTION": "Alpaca production",
    },
    {
      NAICS22: "112990",
      "INDEX ITEM DESCRIPTION": "Aviaries (i.e., raising birds for sale)",
    },
    {
      NAICS22: "112990",
      "INDEX ITEM DESCRIPTION":
        "Bird production (e.g., canaries, love birds, parakeets, parrots)",
    },
    {
      NAICS22: "112990",
      "INDEX ITEM DESCRIPTION": "Bison production",
    },
    {
      NAICS22: "112990",
      "INDEX ITEM DESCRIPTION": "Breeding of butterflies",
    },
    {
      NAICS22: "112990",
      "INDEX ITEM DESCRIPTION": "Breeding of pets (e.g., birds, cats, dogs)",
    },
    {
      NAICS22: "112990",
      "INDEX ITEM DESCRIPTION": "Buffalo production",
    },
    {
      NAICS22: "112990",
      "INDEX ITEM DESCRIPTION": "Cat production",
    },
    {
      NAICS22: "112990",
      "INDEX ITEM DESCRIPTION":
        "Combination livestock farming (except dairy, poultry)",
    },
    {
      NAICS22: "112990",
      "INDEX ITEM DESCRIPTION":
        "Companion animals production (e.g., cats, dogs, parakeets, parrots)",
    },
    {
      NAICS22: "112990",
      "INDEX ITEM DESCRIPTION": "Cricket production",
    },
    {
      NAICS22: "112990",
      "INDEX ITEM DESCRIPTION": "Deer production",
    },
    {
      NAICS22: "112990",
      "INDEX ITEM DESCRIPTION": "Dog production",
    },
    {
      NAICS22: "112990",
      "INDEX ITEM DESCRIPTION": "Earthworm hatcheries",
    },
    {
      NAICS22: "112990",
      "INDEX ITEM DESCRIPTION": "Elk production",
    },
    {
      NAICS22: "112990",
      "INDEX ITEM DESCRIPTION": "General combination animal farming",
    },
    {
      NAICS22: "112990",
      "INDEX ITEM DESCRIPTION": "Kennels, breeding and raising stock for sale",
    },
    {
      NAICS22: "112990",
      "INDEX ITEM DESCRIPTION":
        "Laboratory animal production (e.g., guinea pigs, mice, rats)",
    },
    {
      NAICS22: "112990",
      "INDEX ITEM DESCRIPTION": "Llama production",
    },
    {
      NAICS22: "112990",
      "INDEX ITEM DESCRIPTION":
        "Raising swans, peacocks, flamingos, or other adornment birds",
    },
    {
      NAICS22: "112990",
      "INDEX ITEM DESCRIPTION": "Rattlesnake production",
    },
    {
      NAICS22: "112990",
      "INDEX ITEM DESCRIPTION": "Worm production",
    },
    {
      NAICS22: "113110",
      "INDEX ITEM DESCRIPTION": "Timber tract operations",
    },
    {
      NAICS22: "113210",
      "INDEX ITEM DESCRIPTION": "Aromatic wood gathering",
    },
    {
      NAICS22: "113210",
      "INDEX ITEM DESCRIPTION": "Balsam needles gathering",
    },
    {
      NAICS22: "113210",
      "INDEX ITEM DESCRIPTION": "Bark gathering",
    },
    {
      NAICS22: "113210",
      "INDEX ITEM DESCRIPTION": "Cherry gum, gathering",
    },
    {
      NAICS22: "113210",
      "INDEX ITEM DESCRIPTION": "Chestnut gum, gathering",
    },
    {
      NAICS22: "113210",
      "INDEX ITEM DESCRIPTION":
        "Forest nurseries for reforestation, growing trees",
    },
    {
      NAICS22: "113210",
      "INDEX ITEM DESCRIPTION":
        "Gathering of forest products (e.g., barks, gums, needles, seeds)",
    },
    {
      NAICS22: "113210",
      "INDEX ITEM DESCRIPTION": "Gathering, extracting, and selling tree seeds",
    },
    {
      NAICS22: "113210",
      "INDEX ITEM DESCRIPTION": "Ginseng gathering",
    },
    {
      NAICS22: "113210",
      "INDEX ITEM DESCRIPTION": "Gum (i.e., forest product) gathering",
    },
    {
      NAICS22: "113210",
      "INDEX ITEM DESCRIPTION":
        "Harvesting berries or nuts from native and non-cultivated plants",
    },
    {
      NAICS22: "113210",
      "INDEX ITEM DESCRIPTION": "Hemlock gum gathering",
    },
    {
      NAICS22: "113210",
      "INDEX ITEM DESCRIPTION": "Huckleberry greens, gathering of",
    },
    {
      NAICS22: "113210",
      "INDEX ITEM DESCRIPTION": "Moss gathering",
    },
    {
      NAICS22: "113210",
      "INDEX ITEM DESCRIPTION": "Nurseries for reforestation growing trees",
    },
    {
      NAICS22: "113210",
      "INDEX ITEM DESCRIPTION": "Pine gum extracting",
    },
    {
      NAICS22: "113210",
      "INDEX ITEM DESCRIPTION": "Spanish moss gathering",
    },
    {
      NAICS22: "113210",
      "INDEX ITEM DESCRIPTION": "Sphagnum moss gathering",
    },
    {
      NAICS22: "113210",
      "INDEX ITEM DESCRIPTION": "Spruce gum gathering",
    },
    {
      NAICS22: "113210",
      "INDEX ITEM DESCRIPTION": "Teaberries gathering",
    },
    {
      NAICS22: "113210",
      "INDEX ITEM DESCRIPTION": "Tree seed extracting",
    },
    {
      NAICS22: "113210",
      "INDEX ITEM DESCRIPTION": "Tree seed gathering",
    },
    {
      NAICS22: "113210",
      "INDEX ITEM DESCRIPTION": "Tree seed growing for reforestation",
    },
    {
      NAICS22: "113210",
      "INDEX ITEM DESCRIPTION": "Truffles gathering",
    },
    {
      NAICS22: "113310",
      "INDEX ITEM DESCRIPTION": "Cutting and transporting timber",
    },
    {
      NAICS22: "113310",
      "INDEX ITEM DESCRIPTION": "Cutting timber",
    },
    {
      NAICS22: "113310",
      "INDEX ITEM DESCRIPTION": "Log harvesting",
    },
    {
      NAICS22: "113310",
      "INDEX ITEM DESCRIPTION": "Logging",
    },
    {
      NAICS22: "113310",
      "INDEX ITEM DESCRIPTION": "Pulpwood logging camps",
    },
    {
      NAICS22: "113310",
      "INDEX ITEM DESCRIPTION": "Rails, rough wood, manufacturing",
    },
    {
      NAICS22: "113310",
      "INDEX ITEM DESCRIPTION": "Stump removing in the field",
    },
    {
      NAICS22: "113310",
      "INDEX ITEM DESCRIPTION": "Timber piling",
    },
    {
      NAICS22: "113310",
      "INDEX ITEM DESCRIPTION": "Timber pole cutting",
    },
    {
      NAICS22: "113310",
      "INDEX ITEM DESCRIPTION": "Tree chipping in the field",
    },
    {
      NAICS22: "113310",
      "INDEX ITEM DESCRIPTION": "Wood chipping in the field",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Anchovy fishing",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Bluefish fishing",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Cod catching",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Cod fishing",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Croaker fishing",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Dolphin fishing",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Eel fishing",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Finfish fishing (e.g., flounder, salmon, trout)",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Fisheries, finfish",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Flounder fishing",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Grouper fishing",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Haddock fishing",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Hake fishing",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Halibut fishing",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Herring fishing",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Lingcod fishing",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Mackerel fishing",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Mahimahi fishing",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Menhaden fishing",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Mullet fishing",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Perch fishing",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Pilchard fishing",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Pollock fishing",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Porgy fishing",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Ray fishing",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Rockfish fishing",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Sablefish fishing",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Salmon fishing",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Sea bass fishing",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Sea herring fishing",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Sea trout fishing",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Shark fishing",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Snapper fishing",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Swordfish fishing",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Tilefish fishing",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Trout fishing",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Tuna fishing",
    },
    {
      NAICS22: "114111",
      "INDEX ITEM DESCRIPTION": "Whiting fishing",
    },
    {
      NAICS22: "114112",
      "INDEX ITEM DESCRIPTION": "Clam digging",
    },
    {
      NAICS22: "114112",
      "INDEX ITEM DESCRIPTION": "Crabbing",
    },
    {
      NAICS22: "114112",
      "INDEX ITEM DESCRIPTION": "Crayfish fishing",
    },
    {
      NAICS22: "114112",
      "INDEX ITEM DESCRIPTION": "Fisheries, shellfish",
    },
    {
      NAICS22: "114112",
      "INDEX ITEM DESCRIPTION": "Lobster fishing",
    },
    {
      NAICS22: "114112",
      "INDEX ITEM DESCRIPTION": "Mussel fishing",
    },
    {
      NAICS22: "114112",
      "INDEX ITEM DESCRIPTION": "Octopus fishing",
    },
    {
      NAICS22: "114112",
      "INDEX ITEM DESCRIPTION": "Oyster dredging",
    },
    {
      NAICS22: "114112",
      "INDEX ITEM DESCRIPTION": "Scallop fishing",
    },
    {
      NAICS22: "114112",
      "INDEX ITEM DESCRIPTION": "Sea urchin fishing",
    },
    {
      NAICS22: "114112",
      "INDEX ITEM DESCRIPTION":
        "Shellfish fishing (e.g., clam, crab, oyster, shrimp)",
    },
    {
      NAICS22: "114112",
      "INDEX ITEM DESCRIPTION": "Shrimp fishing",
    },
    {
      NAICS22: "114112",
      "INDEX ITEM DESCRIPTION": "Squid fishing",
    },
    {
      NAICS22: "114119",
      "INDEX ITEM DESCRIPTION": "Frog fishing",
    },
    {
      NAICS22: "114119",
      "INDEX ITEM DESCRIPTION": "Seaweed gathering",
    },
    {
      NAICS22: "114119",
      "INDEX ITEM DESCRIPTION": "Sponge gathering",
    },
    {
      NAICS22: "114119",
      "INDEX ITEM DESCRIPTION": "Terrapin fishing",
    },
    {
      NAICS22: "114119",
      "INDEX ITEM DESCRIPTION": "Turtle fishing",
    },
    {
      NAICS22: "114210",
      "INDEX ITEM DESCRIPTION": "Animal trapping, commercial",
    },
    {
      NAICS22: "114210",
      "INDEX ITEM DESCRIPTION": "Fishing preserves",
    },
    {
      NAICS22: "114210",
      "INDEX ITEM DESCRIPTION": "Game preserves, commercial",
    },
    {
      NAICS22: "114210",
      "INDEX ITEM DESCRIPTION": "Game propagation",
    },
    {
      NAICS22: "114210",
      "INDEX ITEM DESCRIPTION": "Game retreats",
    },
    {
      NAICS22: "114210",
      "INDEX ITEM DESCRIPTION": "Hunting preserves",
    },
    {
      NAICS22: "115111",
      "INDEX ITEM DESCRIPTION": "Cotton ginning",
    },
    {
      NAICS22: "115111",
      "INDEX ITEM DESCRIPTION": "Ginning cotton",
    },
    {
      NAICS22: "115112",
      "INDEX ITEM DESCRIPTION":
        "Aerial crop dusting or spraying (i.e., using specialized or dedicated aircraft)",
    },
    {
      NAICS22: "115112",
      "INDEX ITEM DESCRIPTION": "Bracing of orchard trees and vines",
    },
    {
      NAICS22: "115112",
      "INDEX ITEM DESCRIPTION": "Chemical treatment of soil for crops",
    },
    {
      NAICS22: "115112",
      "INDEX ITEM DESCRIPTION": "Citrus grove cultivation services",
    },
    {
      NAICS22: "115112",
      "INDEX ITEM DESCRIPTION": "Crop dusting",
    },
    {
      NAICS22: "115112",
      "INDEX ITEM DESCRIPTION": "Crop spraying",
    },
    {
      NAICS22: "115112",
      "INDEX ITEM DESCRIPTION": "Cultivation services",
    },
    {
      NAICS22: "115112",
      "INDEX ITEM DESCRIPTION": "Detasseling corn",
    },
    {
      NAICS22: "115112",
      "INDEX ITEM DESCRIPTION": "Disease control for crops",
    },
    {
      NAICS22: "115112",
      "INDEX ITEM DESCRIPTION": "Dusting crops",
    },
    {
      NAICS22: "115112",
      "INDEX ITEM DESCRIPTION": "Entomological service, agricultural",
    },
    {
      NAICS22: "115112",
      "INDEX ITEM DESCRIPTION": "Fertilizer application for crops",
    },
    {
      NAICS22: "115112",
      "INDEX ITEM DESCRIPTION": "Hoeing",
    },
    {
      NAICS22: "115112",
      "INDEX ITEM DESCRIPTION": "Insect control for crops",
    },
    {
      NAICS22: "115112",
      "INDEX ITEM DESCRIPTION":
        "Orchard cultivation services (e.g., bracing, planting, pruning, removal, spraying, surgery)",
    },
    {
      NAICS22: "115112",
      "INDEX ITEM DESCRIPTION": "Pest control services, agricultural",
    },
    {
      NAICS22: "115112",
      "INDEX ITEM DESCRIPTION": "Planting crops",
    },
    {
      NAICS22: "115112",
      "INDEX ITEM DESCRIPTION": "Plowing",
    },
    {
      NAICS22: "115112",
      "INDEX ITEM DESCRIPTION": "Pollinating",
    },
    {
      NAICS22: "115112",
      "INDEX ITEM DESCRIPTION": "Pruning of orchard trees and vines",
    },
    {
      NAICS22: "115112",
      "INDEX ITEM DESCRIPTION": "Seed bed preparing",
    },
    {
      NAICS22: "115112",
      "INDEX ITEM DESCRIPTION": "Seeding crops",
    },
    {
      NAICS22: "115112",
      "INDEX ITEM DESCRIPTION": "Spraying crops",
    },
    {
      NAICS22: "115112",
      "INDEX ITEM DESCRIPTION": "Spreading lime for crops",
    },
    {
      NAICS22: "115112",
      "INDEX ITEM DESCRIPTION": "Surgery on trees and vines",
    },
    {
      NAICS22: "115112",
      "INDEX ITEM DESCRIPTION": "Thinning of crops, mechanical and chemical",
    },
    {
      NAICS22: "115112",
      "INDEX ITEM DESCRIPTION": "Transplanting services",
    },
    {
      NAICS22: "115112",
      "INDEX ITEM DESCRIPTION": "Vineyard cultivation services",
    },
    {
      NAICS22: "115112",
      "INDEX ITEM DESCRIPTION": "Weed control services for crops",
    },
    {
      NAICS22: "115113",
      "INDEX ITEM DESCRIPTION": "Berries, machine harvesting",
    },
    {
      NAICS22: "115113",
      "INDEX ITEM DESCRIPTION": "Chopping and silo filling",
    },
    {
      NAICS22: "115113",
      "INDEX ITEM DESCRIPTION": "Combining, agricultural",
    },
    {
      NAICS22: "115113",
      "INDEX ITEM DESCRIPTION": "Cotton, machine harvesting",
    },
    {
      NAICS22: "115113",
      "INDEX ITEM DESCRIPTION": "Fruit, machine harvesting",
    },
    {
      NAICS22: "115113",
      "INDEX ITEM DESCRIPTION": "Grain, machine harvesting",
    },
    {
      NAICS22: "115113",
      "INDEX ITEM DESCRIPTION": "Hay mowing, raking, baling, and chopping",
    },
    {
      NAICS22: "115113",
      "INDEX ITEM DESCRIPTION": "Nuts, machine harvesting",
    },
    {
      NAICS22: "115113",
      "INDEX ITEM DESCRIPTION": "Peanut, machine harvesting",
    },
    {
      NAICS22: "115113",
      "INDEX ITEM DESCRIPTION": "Sugar beets, machine harvesting",
    },
    {
      NAICS22: "115113",
      "INDEX ITEM DESCRIPTION": "Sugarcane, machine harvesting",
    },
    {
      NAICS22: "115113",
      "INDEX ITEM DESCRIPTION": "Threshing service",
    },
    {
      NAICS22: "115113",
      "INDEX ITEM DESCRIPTION": "Vegetables, machine harvesting",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Almond hulling and shelling",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Banana ripening",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Bean cleaning",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Corn drying",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Corn shelling",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Crop cleaning",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Decorticating flax",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Delinting cottonseed",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Filbert hulling and shelling",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Fruit precooling",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Fruit sorting, grading, and packing",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Fruit, sun drying",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Fruit, vacuum cooling",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Fumigating grain",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Grain cleaning",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Grain drying",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Grain fumigation",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION":
        "Grain grinding (except custom grinding for animal feed)",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Hulling and shelling of nuts",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Irradiation of fruits and vegetables",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Nut hulling and shelling",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION":
        "Packaging fresh or farm-dried fruits and vegetables",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Packing fruits and vegetables",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Peanut shelling",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Pecan hulling and shelling",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Potato curing",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Retting flax",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Rice drying",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Seed cleaning",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Seed processing, postharvest for propagation",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION":
        "Sorting, grading, cleaning, and packing of fruits and vegetables",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION":
        "Sun drying of dates, prunes, raisins, and olives",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Sun drying of fruits and vegetables",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Sun drying of tomatoes",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Sweet potato curing",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Tobacco grading",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Vegetable precooling",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Vegetable sorting, grading, and packing",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Vegetable sun drying",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Vegetable vacuum cooling",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Walnut hulling and shelling",
    },
    {
      NAICS22: "115114",
      "INDEX ITEM DESCRIPTION": "Waxing, fruits or vegetables",
    },
    {
      NAICS22: "115115",
      "INDEX ITEM DESCRIPTION": "Agriculture production or harvesting crews",
    },
    {
      NAICS22: "115115",
      "INDEX ITEM DESCRIPTION": "Crew leaders, farm labor",
    },
    {
      NAICS22: "115115",
      "INDEX ITEM DESCRIPTION": "Farm labor contractors",
    },
    {
      NAICS22: "115115",
      "INDEX ITEM DESCRIPTION": "Labor contractors, farm",
    },
    {
      NAICS22: "115116",
      "INDEX ITEM DESCRIPTION": "Farm management services",
    },
    {
      NAICS22: "115116",
      "INDEX ITEM DESCRIPTION": "Management services, farm",
    },
    {
      NAICS22: "115210",
      "INDEX ITEM DESCRIPTION": "Animal semen banks",
    },
    {
      NAICS22: "115210",
      "INDEX ITEM DESCRIPTION": "Artificial insemination services for livestock",
    },
    {
      NAICS22: "115210",
      "INDEX ITEM DESCRIPTION": "Artificial insemination services for pets",
    },
    {
      NAICS22: "115210",
      "INDEX ITEM DESCRIPTION": "Boarding horses (except racehorses)",
    },
    {
      NAICS22: "115210",
      "INDEX ITEM DESCRIPTION": "Branding",
    },
    {
      NAICS22: "115210",
      "INDEX ITEM DESCRIPTION": "Breeding, animal, services",
    },
    {
      NAICS22: "115210",
      "INDEX ITEM DESCRIPTION": "Bull testing stations",
    },
    {
      NAICS22: "115210",
      "INDEX ITEM DESCRIPTION": "Cattle spraying",
    },
    {
      NAICS22: "115210",
      "INDEX ITEM DESCRIPTION": "Cleaning poultry houses",
    },
    {
      NAICS22: "115210",
      "INDEX ITEM DESCRIPTION": "Corralling, drovers",
    },
    {
      NAICS22: "115210",
      "INDEX ITEM DESCRIPTION": "Dairy herd improvement associations",
    },
    {
      NAICS22: "115210",
      "INDEX ITEM DESCRIPTION": "Equine boarding",
    },
    {
      NAICS22: "115210",
      "INDEX ITEM DESCRIPTION": "Farriers",
    },
    {
      NAICS22: "115210",
      "INDEX ITEM DESCRIPTION": "Hoof trimming",
    },
    {
      NAICS22: "115210",
      "INDEX ITEM DESCRIPTION": "Horses (except racehorses), boarding",
    },
    {
      NAICS22: "115210",
      "INDEX ITEM DESCRIPTION": "Horses, training (except racehorses)",
    },
    {
      NAICS22: "115210",
      "INDEX ITEM DESCRIPTION": "Horseshoeing",
    },
    {
      NAICS22: "115210",
      "INDEX ITEM DESCRIPTION": "Livestock breeding services (except consulting)",
    },
    {
      NAICS22: "115210",
      "INDEX ITEM DESCRIPTION": "Livestock spraying",
    },
    {
      NAICS22: "115210",
      "INDEX ITEM DESCRIPTION": "Milk testing for butterfat and milk solids",
    },
    {
      NAICS22: "115210",
      "INDEX ITEM DESCRIPTION":
        "Pedigree (i.e., livestock, pets, poultry) record services",
    },
    {
      NAICS22: "115210",
      "INDEX ITEM DESCRIPTION": "Poultry catching services",
    },
    {
      NAICS22: "115210",
      "INDEX ITEM DESCRIPTION": "Reproductive flushing services for animals",
    },
    {
      NAICS22: "115210",
      "INDEX ITEM DESCRIPTION": "Semen collection",
    },
    {
      NAICS22: "115210",
      "INDEX ITEM DESCRIPTION":
        "Sexing services for poultry (e.g., separating males/females)",
    },
    {
      NAICS22: "115210",
      "INDEX ITEM DESCRIPTION": "Sheep dipping and shearing",
    },
    {
      NAICS22: "115210",
      "INDEX ITEM DESCRIPTION":
        "Showing of cattle, hogs, sheep, goats, and poultry",
    },
    {
      NAICS22: "115210",
      "INDEX ITEM DESCRIPTION": "Stud services",
    },
    {
      NAICS22: "115210",
      "INDEX ITEM DESCRIPTION": "Training horses (except racehorses)",
    },
    {
      NAICS22: "115210",
      "INDEX ITEM DESCRIPTION": "Vaccinating livestock (except by veterinarians)",
    },
    {
      NAICS22: "115310",
      "INDEX ITEM DESCRIPTION": "Aerial forest firefighting",
    },
    {
      NAICS22: "115310",
      "INDEX ITEM DESCRIPTION": "Aerial forest mulching or seeding",
    },
    {
      NAICS22: "115310",
      "INDEX ITEM DESCRIPTION": "Aerial wildland firefighting",
    },
    {
      NAICS22: "115310",
      "INDEX ITEM DESCRIPTION": "Cruising timber",
    },
    {
      NAICS22: "115310",
      "INDEX ITEM DESCRIPTION": "Estimating timber",
    },
    {
      NAICS22: "115310",
      "INDEX ITEM DESCRIPTION": "Fire prevention, forest",
    },
    {
      NAICS22: "115310",
      "INDEX ITEM DESCRIPTION": "Firefighting, forest",
    },
    {
      NAICS22: "115310",
      "INDEX ITEM DESCRIPTION": "Forest management plans preparation",
    },
    {
      NAICS22: "115310",
      "INDEX ITEM DESCRIPTION": "Forest thinning",
    },
    {
      NAICS22: "115310",
      "INDEX ITEM DESCRIPTION": "Forestry services",
    },
    {
      NAICS22: "115310",
      "INDEX ITEM DESCRIPTION": "Pest control services, forestry",
    },
    {
      NAICS22: "115310",
      "INDEX ITEM DESCRIPTION": "Reforestation (except forest nurseries)",
    },
    {
      NAICS22: "115310",
      "INDEX ITEM DESCRIPTION": "Timber valuation",
    },
    {
      NAICS22: "211120",
      "INDEX ITEM DESCRIPTION": "Crude petroleum from oil sand",
    },
    {
      NAICS22: "211120",
      "INDEX ITEM DESCRIPTION": "Crude petroleum from oil shale",
    },
    {
      NAICS22: "211120",
      "INDEX ITEM DESCRIPTION": "Crude petroleum lease condensate production",
    },
    {
      NAICS22: "211120",
      "INDEX ITEM DESCRIPTION": "Crude petroleum production",
    },
    {
      NAICS22: "211120",
      "INDEX ITEM DESCRIPTION": "Kerogen processing",
    },
    {
      NAICS22: "211120",
      "INDEX ITEM DESCRIPTION": "Offshore crude petroleum production",
    },
    {
      NAICS22: "211120",
      "INDEX ITEM DESCRIPTION": "Oil field development for own account",
    },
    {
      NAICS22: "211120",
      "INDEX ITEM DESCRIPTION": "Oil field exploration for own account",
    },
    {
      NAICS22: "211120",
      "INDEX ITEM DESCRIPTION": "Oil shale mining and/or beneficiating",
    },
    {
      NAICS22: "211120",
      "INDEX ITEM DESCRIPTION":
        "Operating crude petroleum field gathering lines, except on a contract basis",
    },
    {
      NAICS22: "211120",
      "INDEX ITEM DESCRIPTION": "Petroleum, crude, production (i.e., extraction)",
    },
    {
      NAICS22: "211120",
      "INDEX ITEM DESCRIPTION": "Shale, oil, mining and/or beneficiating",
    },
    {
      NAICS22: "211120",
      "INDEX ITEM DESCRIPTION": "Stripper oil well production",
    },
    {
      NAICS22: "211120",
      "INDEX ITEM DESCRIPTION": "Tar sands mining",
    },
    {
      NAICS22: "211130",
      "INDEX ITEM DESCRIPTION": "Butane, natural, mining",
    },
    {
      NAICS22: "211130",
      "INDEX ITEM DESCRIPTION": "Casing-head butane and propane production",
    },
    {
      NAICS22: "211130",
      "INDEX ITEM DESCRIPTION": "Coal gasification at mine site",
    },
    {
      NAICS22: "211130",
      "INDEX ITEM DESCRIPTION": "Coal liquefaction at mine site",
    },
    {
      NAICS22: "211130",
      "INDEX ITEM DESCRIPTION": "Coal pyrolysis",
    },
    {
      NAICS22: "211130",
      "INDEX ITEM DESCRIPTION": "Condensate, cycle, natural gas production",
    },
    {
      NAICS22: "211130",
      "INDEX ITEM DESCRIPTION": "Cycle condensate production",
    },
    {
      NAICS22: "211130",
      "INDEX ITEM DESCRIPTION": "Ethane recovered from oil and gas field gases",
    },
    {
      NAICS22: "211130",
      "INDEX ITEM DESCRIPTION": "Fractionating natural gas liquids",
    },
    {
      NAICS22: "211130",
      "INDEX ITEM DESCRIPTION": "Gas field development for own account",
    },
    {
      NAICS22: "211130",
      "INDEX ITEM DESCRIPTION": "Gas field exploration for own account",
    },
    {
      NAICS22: "211130",
      "INDEX ITEM DESCRIPTION": "Gas, natural liquefied petroleum, extraction",
    },
    {
      NAICS22: "211130",
      "INDEX ITEM DESCRIPTION": "Gas, natural, extraction",
    },
    {
      NAICS22: "211130",
      "INDEX ITEM DESCRIPTION": "Gas, natural, liquids, extraction",
    },
    {
      NAICS22: "211130",
      "INDEX ITEM DESCRIPTION": "Gas, residue, extraction",
    },
    {
      NAICS22: "211130",
      "INDEX ITEM DESCRIPTION": "Gases, petroleum, liquefied, extraction",
    },
    {
      NAICS22: "211130",
      "INDEX ITEM DESCRIPTION": "Gasoline, natural, production",
    },
    {
      NAICS22: "211130",
      "INDEX ITEM DESCRIPTION":
        "Isobutane recovered from oil and gas field gases",
    },
    {
      NAICS22: "211130",
      "INDEX ITEM DESCRIPTION":
        "Isopentane recovered from oil and gas field gases",
    },
    {
      NAICS22: "211130",
      "INDEX ITEM DESCRIPTION": "Liquefied petroleum gases (LPG), natural",
    },
    {
      NAICS22: "211130",
      "INDEX ITEM DESCRIPTION":
        "Liquid hydrocarbons recovered from oil and gas field gases",
    },
    {
      NAICS22: "211130",
      "INDEX ITEM DESCRIPTION":
        "Liquids, natural gas (e.g., ethane, isobutane, natural gasoline, propane) recovered from oil and gas field gases",
    },
    {
      NAICS22: "211130",
      "INDEX ITEM DESCRIPTION": "Natural gas liquid lease condensate production",
    },
    {
      NAICS22: "211130",
      "INDEX ITEM DESCRIPTION":
        "Natural gas liquids (e.g., ethane, isobutane, natural gasoline, propane) recovered from oil and gas field gases",
    },
    {
      NAICS22: "211130",
      "INDEX ITEM DESCRIPTION": "Natural gas production",
    },
    {
      NAICS22: "211130",
      "INDEX ITEM DESCRIPTION": "Natural gas, offshore production",
    },
    {
      NAICS22: "211130",
      "INDEX ITEM DESCRIPTION":
        "Natural gasoline recovered from oil and gas field gases",
    },
    {
      NAICS22: "211130",
      "INDEX ITEM DESCRIPTION": "Offshore natural gas production",
    },
    {
      NAICS22: "211130",
      "INDEX ITEM DESCRIPTION": "Oil line drip, natural gas liquid",
    },
    {
      NAICS22: "211130",
      "INDEX ITEM DESCRIPTION":
        "Operating natural gas liquid field gathering lines, except on a contract basis",
    },
    {
      NAICS22: "211130",
      "INDEX ITEM DESCRIPTION":
        "Petroleum gases, liquefied, recovering from oil and gas field gases",
    },
    {
      NAICS22: "211130",
      "INDEX ITEM DESCRIPTION": "Propane recovered from oil and gas field gases",
    },
    {
      NAICS22: "211130",
      "INDEX ITEM DESCRIPTION": "Residue gas production",
    },
    {
      NAICS22: "211130",
      "INDEX ITEM DESCRIPTION": "Stripper gas well production",
    },
    {
      NAICS22: "211130",
      "INDEX ITEM DESCRIPTION": "Sulfur recovered from natural gas",
    },
    {
      NAICS22: "212114",
      "INDEX ITEM DESCRIPTION":
        "Bituminous coal, lignite, or anthracite beneficiating (e.g., cleaning, crushing, screening, washing, sizing)",
    },
    {
      NAICS22: "212114",
      "INDEX ITEM DESCRIPTION":
        "Bituminous coal, lignite, or anthracite surface mine site development for own account",
    },
    {
      NAICS22: "212114",
      "INDEX ITEM DESCRIPTION":
        "Bituminous coal, lignite, or anthracite surface mining and/or beneficiating",
    },
    {
      NAICS22: "212114",
      "INDEX ITEM DESCRIPTION": "Brown coal mining and/or beneficiating",
    },
    {
      NAICS22: "212114",
      "INDEX ITEM DESCRIPTION":
        "Coal beneficiating plants (e.g., cleaning, crushing, screening, washing)",
    },
    {
      NAICS22: "212114",
      "INDEX ITEM DESCRIPTION":
        "Coal stripping (except on a contract, fee, or other basis)",
    },
    {
      NAICS22: "212114",
      "INDEX ITEM DESCRIPTION":
        "Coal, bituminous, lignite, or anthracite, surface mining and/or beneficiating",
    },
    {
      NAICS22: "212114",
      "INDEX ITEM DESCRIPTION": "Coal, brown, mining and/or beneficiating",
    },
    {
      NAICS22: "212114",
      "INDEX ITEM DESCRIPTION":
        "Culm bank recovery, bituminous coal, lignite, or anthracite (except on a contract basis)",
    },
    {
      NAICS22: "212114",
      "INDEX ITEM DESCRIPTION":
        "Hard coal (i.e., anthracite) surface mining and/or beneficiating",
    },
    {
      NAICS22: "212114",
      "INDEX ITEM DESCRIPTION": "Lignite surface mining and/or beneficiating",
    },
    {
      NAICS22: "212114",
      "INDEX ITEM DESCRIPTION": "Preparation plants, coal",
    },
    {
      NAICS22: "212114",
      "INDEX ITEM DESCRIPTION":
        "Semianthracite surface mining and/or beneficiating",
    },
    {
      NAICS22: "212114",
      "INDEX ITEM DESCRIPTION":
        "Semibituminous coal surface mining and/or beneficiating",
    },
    {
      NAICS22: "212114",
      "INDEX ITEM DESCRIPTION":
        "Strip mining, bituminous coal, lignite, or anthracite, on own account",
    },
    {
      NAICS22: "212114",
      "INDEX ITEM DESCRIPTION":
        "Subbituminous coal surface mining and/or beneficiating",
    },
    {
      NAICS22: "212114",
      "INDEX ITEM DESCRIPTION":
        "Tipple operation, bituminous coal mining and/or beneficiating",
    },
    {
      NAICS22: "212115",
      "INDEX ITEM DESCRIPTION":
        "Bituminous coal or anthracite underground mine site development for own account",
    },
    {
      NAICS22: "212115",
      "INDEX ITEM DESCRIPTION":
        "Bituminous coal or anthracite underground mining",
    },
    {
      NAICS22: "212115",
      "INDEX ITEM DESCRIPTION":
        "Coal, bituminous or anthracite, underground mining",
    },
    {
      NAICS22: "212115",
      "INDEX ITEM DESCRIPTION": "Hard coal (i.e., anthracite) underground mining",
    },
    {
      NAICS22: "212115",
      "INDEX ITEM DESCRIPTION": "Semianthracite underground mining",
    },
    {
      NAICS22: "212115",
      "INDEX ITEM DESCRIPTION": "Semibituminous coal underground mining",
    },
    {
      NAICS22: "212115",
      "INDEX ITEM DESCRIPTION": "Subbituminous coal underground mining",
    },
    {
      NAICS22: "212210",
      "INDEX ITEM DESCRIPTION": "Agglomerates, iron ore, beneficiating",
    },
    {
      NAICS22: "212210",
      "INDEX ITEM DESCRIPTION": "Briquets, iron, mining and/or beneficiating",
    },
    {
      NAICS22: "212210",
      "INDEX ITEM DESCRIPTION": "Brown ore mining and/or beneficiating",
    },
    {
      NAICS22: "212210",
      "INDEX ITEM DESCRIPTION": "Hematite mining and/or beneficiating",
    },
    {
      NAICS22: "212210",
      "INDEX ITEM DESCRIPTION":
        "Iron ore (e.g., hematite, magnetite, siderite, taconite) mining and/or beneficiating",
    },
    {
      NAICS22: "212210",
      "INDEX ITEM DESCRIPTION":
        "Iron ore agglomerates mining and/or beneficiating",
    },
    {
      NAICS22: "212210",
      "INDEX ITEM DESCRIPTION":
        "Iron ore beneficiating plants (e.g., agglomeration, sintering)",
    },
    {
      NAICS22: "212210",
      "INDEX ITEM DESCRIPTION": "Iron ore mine site development for own account",
    },
    {
      NAICS22: "212210",
      "INDEX ITEM DESCRIPTION": "Iron ore, blocked, mining and/or beneficiating",
    },
    {
      NAICS22: "212210",
      "INDEX ITEM DESCRIPTION": "Limonite mining and/or beneficiating",
    },
    {
      NAICS22: "212210",
      "INDEX ITEM DESCRIPTION":
        "Manganiferous ores valued for iron content, mining and/or beneficiating",
    },
    {
      NAICS22: "212210",
      "INDEX ITEM DESCRIPTION": "Siderite mining and/or beneficiating",
    },
    {
      NAICS22: "212210",
      "INDEX ITEM DESCRIPTION": "Sintered iron ore produced at the mine",
    },
    {
      NAICS22: "212210",
      "INDEX ITEM DESCRIPTION":
        "Taconite concentrates or agglomerates beneficiating",
    },
    {
      NAICS22: "212210",
      "INDEX ITEM DESCRIPTION": "Taconite ores mining and/or beneficiating",
    },
    {
      NAICS22: "212220",
      "INDEX ITEM DESCRIPTION": "Bullion, gold, produced at the mine",
    },
    {
      NAICS22: "212220",
      "INDEX ITEM DESCRIPTION": "Bullion, silver, produced at the mine",
    },
    {
      NAICS22: "212220",
      "INDEX ITEM DESCRIPTION": "Calaverite mining and/or beneficiating",
    },
    {
      NAICS22: "212220",
      "INDEX ITEM DESCRIPTION": "Gold lode mining and/or beneficiating",
    },
    {
      NAICS22: "212220",
      "INDEX ITEM DESCRIPTION": "Gold ore mine site development for own account",
    },
    {
      NAICS22: "212220",
      "INDEX ITEM DESCRIPTION": "Gold ore mining and/or beneficiating plants",
    },
    {
      NAICS22: "212220",
      "INDEX ITEM DESCRIPTION":
        "Gold ores, concentrates, bullion, and/or precipitates mining and/or beneficiating",
    },
    {
      NAICS22: "212220",
      "INDEX ITEM DESCRIPTION": "Gold placer mining and/or beneficiating",
    },
    {
      NAICS22: "212220",
      "INDEX ITEM DESCRIPTION": "Lode gold mining and/or beneficiating",
    },
    {
      NAICS22: "212220",
      "INDEX ITEM DESCRIPTION": "Placer gold mining and/or beneficiating",
    },
    {
      NAICS22: "212220",
      "INDEX ITEM DESCRIPTION": "Placer silver mining and/or beneficiating",
    },
    {
      NAICS22: "212220",
      "INDEX ITEM DESCRIPTION":
        "Silver ore mine site development for own account",
    },
    {
      NAICS22: "212220",
      "INDEX ITEM DESCRIPTION": "Silver ores mining and/or beneficiating",
    },
    {
      NAICS22: "212220",
      "INDEX ITEM DESCRIPTION": "Sylvanite mining and/or beneficiating",
    },
    {
      NAICS22: "212220",
      "INDEX ITEM DESCRIPTION": "Telluride (gold) mining and/or beneficiating",
    },
    {
      NAICS22: "212230",
      "INDEX ITEM DESCRIPTION": "Blende (zinc) mining and/or beneficiating",
    },
    {
      NAICS22: "212230",
      "INDEX ITEM DESCRIPTION": "Calamine mining and/or beneficiating",
    },
    {
      NAICS22: "212230",
      "INDEX ITEM DESCRIPTION": "Cerussite mining and/or beneficiating",
    },
    {
      NAICS22: "212230",
      "INDEX ITEM DESCRIPTION": "Chalcocite mining and/or beneficiating",
    },
    {
      NAICS22: "212230",
      "INDEX ITEM DESCRIPTION": "Chalcopyrite mining and/or beneficiating",
    },
    {
      NAICS22: "212230",
      "INDEX ITEM DESCRIPTION": "Copper beneficiating plants",
    },
    {
      NAICS22: "212230",
      "INDEX ITEM DESCRIPTION": "Copper ore concentrates recovery",
    },
    {
      NAICS22: "212230",
      "INDEX ITEM DESCRIPTION":
        "Copper ore mine site development for own account",
    },
    {
      NAICS22: "212230",
      "INDEX ITEM DESCRIPTION": "Copper ores mining and/or beneficiating",
    },
    {
      NAICS22: "212230",
      "INDEX ITEM DESCRIPTION": "Copper-water precipitates",
    },
    {
      NAICS22: "212230",
      "INDEX ITEM DESCRIPTION": "Cuprite mining and/or beneficiating",
    },
    {
      NAICS22: "212230",
      "INDEX ITEM DESCRIPTION": "Galena mining and/or beneficiating",
    },
    {
      NAICS22: "212230",
      "INDEX ITEM DESCRIPTION": "Lead ore mine site development for own account",
    },
    {
      NAICS22: "212230",
      "INDEX ITEM DESCRIPTION": "Lead ore mining and/or beneficiating",
    },
    {
      NAICS22: "212230",
      "INDEX ITEM DESCRIPTION": "Lead-zinc ore mining and/or beneficiating",
    },
    {
      NAICS22: "212230",
      "INDEX ITEM DESCRIPTION": "Nickel concentrates recovery",
    },
    {
      NAICS22: "212230",
      "INDEX ITEM DESCRIPTION": "Nickel ore beneficiating plants",
    },
    {
      NAICS22: "212230",
      "INDEX ITEM DESCRIPTION":
        "Nickel ore mine site development for own account",
    },
    {
      NAICS22: "212230",
      "INDEX ITEM DESCRIPTION": "Nickel ores mining and/or beneficiating",
    },
    {
      NAICS22: "212230",
      "INDEX ITEM DESCRIPTION": "Smithsonite mining and/or beneficiating",
    },
    {
      NAICS22: "212230",
      "INDEX ITEM DESCRIPTION": "Sphalerite mining and/or beneficiating",
    },
    {
      NAICS22: "212230",
      "INDEX ITEM DESCRIPTION": "Willemite mining and/or beneficiating",
    },
    {
      NAICS22: "212230",
      "INDEX ITEM DESCRIPTION": "Zinc ore mine site development for own account",
    },
    {
      NAICS22: "212230",
      "INDEX ITEM DESCRIPTION": "Zinc ores mining and/or beneficiating",
    },
    {
      NAICS22: "212230",
      "INDEX ITEM DESCRIPTION":
        "Zinc-blende (sphalerite) mining and/or beneficiating",
    },
    {
      NAICS22: "212230",
      "INDEX ITEM DESCRIPTION": "Zincite mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Antimony concentrates beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Antimony ores mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Bastnaesite mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Bauxite mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Beryl mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Beryllium concentrates beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Beryllium ores mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Carnotite mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Cerium concentrates beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Cerium ores mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Chromite mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Chromium concentrates beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Chromium ore mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Cinnabar mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Cobalt concentrates beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Cobalt ores mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Columbite mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Columbium ores mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION":
        "Ferberite ores and concentrates mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION":
        "Ferroalloy ores (e.g., chromium, columbium, molybdenum, tungsten) mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Hafnium mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Huebnerite mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Ilmenite ores mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Iridium mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Leaching of uranium, radium, or vanadium ores",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Manganese concentrates beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Manganese ores mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION":
        "Manganiferous ores (not valued for iron content) mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Manganite mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION":
        "Mercury (quicksilver) mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Mercury ores mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Microlite mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Molybdenite mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Molybdenum ores mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Molybdite mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Monazite mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Osmium mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Palladium mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Pitchblende mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Platinum mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Psilomelane mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Pyrolusite mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION":
        "Quicksilver ores and metal mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Radium ores mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Rare earth metal concentrates beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION":
        "Rare earth metal ores mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Rhodium mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Rhodochrosite mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION":
        "Roscoelite (vanadium hydromica) mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Ruthenium ore mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Rutile mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Scheelite mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Tantalite mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Tantalum ores mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Thallium mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Thorite mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Thorium ores mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Tin metal concentrates beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Tin metal ores mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION":
        "Titaniferous-magnetite ores, valued chiefly for titanium content, mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Titanium concentrates beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Titanium ores mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Tungsten concentrates beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Tungsten ores mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Tyuyamunite mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION":
        "Uraninite (pitchblende) mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Uranium ores mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION":
        "Uranium-radium-vanadium ore mine site development for own account",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION":
        "Uranium-radium-vanadium ores mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Vanadium ores mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Wolframite mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Wulfenite mining and/or beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Zirconium concentrates beneficiating",
    },
    {
      NAICS22: "212290",
      "INDEX ITEM DESCRIPTION": "Zirconium ores mining and/or beneficiating",
    },
    {
      NAICS22: "212311",
      "INDEX ITEM DESCRIPTION": "Argillite mining or quarrying",
    },
    {
      NAICS22: "212311",
      "INDEX ITEM DESCRIPTION": "Basalt mining or quarrying",
    },
    {
      NAICS22: "212311",
      "INDEX ITEM DESCRIPTION": "Bluestone mining or quarrying",
    },
    {
      NAICS22: "212311",
      "INDEX ITEM DESCRIPTION": "Calcareous tufa mining or quarrying",
    },
    {
      NAICS22: "212311",
      "INDEX ITEM DESCRIPTION": "Diabase mining or quarrying",
    },
    {
      NAICS22: "212311",
      "INDEX ITEM DESCRIPTION": "Dimension stone mining or quarrying",
    },
    {
      NAICS22: "212311",
      "INDEX ITEM DESCRIPTION": "Diorite mining or quarrying",
    },
    {
      NAICS22: "212311",
      "INDEX ITEM DESCRIPTION": "Dolomite mining or quarrying",
    },
    {
      NAICS22: "212311",
      "INDEX ITEM DESCRIPTION": "Dolomitic marble mining or quarrying",
    },
    {
      NAICS22: "212311",
      "INDEX ITEM DESCRIPTION": "Flagstone mining or quarrying",
    },
    {
      NAICS22: "212311",
      "INDEX ITEM DESCRIPTION": "Gabbro mining or quarrying",
    },
    {
      NAICS22: "212311",
      "INDEX ITEM DESCRIPTION": "Gneiss mining or quarrying",
    },
    {
      NAICS22: "212311",
      "INDEX ITEM DESCRIPTION": "Granite mining or quarrying",
    },
    {
      NAICS22: "212311",
      "INDEX ITEM DESCRIPTION": "Greenstone mining or quarrying",
    },
    {
      NAICS22: "212311",
      "INDEX ITEM DESCRIPTION": "Limestone mining or quarrying",
    },
    {
      NAICS22: "212311",
      "INDEX ITEM DESCRIPTION": "Marble mining or quarrying",
    },
    {
      NAICS22: "212311",
      "INDEX ITEM DESCRIPTION": "Mica schist mining or quarrying",
    },
    {
      NAICS22: "212311",
      "INDEX ITEM DESCRIPTION": "Onyx marble mining or quarrying",
    },
    {
      NAICS22: "212311",
      "INDEX ITEM DESCRIPTION": "Quartzite dimension stone mining or quarrying",
    },
    {
      NAICS22: "212311",
      "INDEX ITEM DESCRIPTION": "Sandstone mining or quarrying",
    },
    {
      NAICS22: "212311",
      "INDEX ITEM DESCRIPTION": "Schist, mica, mining or quarrying",
    },
    {
      NAICS22: "212311",
      "INDEX ITEM DESCRIPTION": "Serpentine mining or quarrying",
    },
    {
      NAICS22: "212311",
      "INDEX ITEM DESCRIPTION": "Slate mining or quarrying",
    },
    {
      NAICS22: "212311",
      "INDEX ITEM DESCRIPTION": "Stone, dimension, mining or quarrying",
    },
    {
      NAICS22: "212311",
      "INDEX ITEM DESCRIPTION": "Syenite (except nepheline) mining or quarrying",
    },
    {
      NAICS22: "212311",
      "INDEX ITEM DESCRIPTION": "Trap rock mining or quarrying",
    },
    {
      NAICS22: "212311",
      "INDEX ITEM DESCRIPTION": "Travertine mining or quarrying",
    },
    {
      NAICS22: "212311",
      "INDEX ITEM DESCRIPTION": "Tufa, calcareous, mining or quarrying",
    },
    {
      NAICS22: "212311",
      "INDEX ITEM DESCRIPTION": "Verde' antique mining or quarrying",
    },
    {
      NAICS22: "212311",
      "INDEX ITEM DESCRIPTION": "Volcanic rock, mining or quarrying",
    },
    {
      NAICS22: "212312",
      "INDEX ITEM DESCRIPTION":
        "Agricultural limestone mining and/or beneficiating",
    },
    {
      NAICS22: "212312",
      "INDEX ITEM DESCRIPTION":
        "Calcareous tufa crushed and broken stone mining and/or beneficiating",
    },
    {
      NAICS22: "212312",
      "INDEX ITEM DESCRIPTION":
        "Cement rock crushed and broken stone mining and/or beneficiating",
    },
    {
      NAICS22: "212312",
      "INDEX ITEM DESCRIPTION":
        "Chalk crushed and broken stone mining and/or beneficiating",
    },
    {
      NAICS22: "212312",
      "INDEX ITEM DESCRIPTION":
        "Chalk, ground or otherwise treated, mining and/or beneficiating",
    },
    {
      NAICS22: "212312",
      "INDEX ITEM DESCRIPTION":
        "Dolomite crushed and broken stone mining and/or beneficiating",
    },
    {
      NAICS22: "212312",
      "INDEX ITEM DESCRIPTION": "Lime rock, ground, mining and/or beneficiating",
    },
    {
      NAICS22: "212312",
      "INDEX ITEM DESCRIPTION":
        "Limestone (except bituminous) crushed and broken stone mining and/or beneficiating",
    },
    {
      NAICS22: "212312",
      "INDEX ITEM DESCRIPTION":
        "Limestone beneficiating plants (e.g., grinding or pulverizing)",
    },
    {
      NAICS22: "212312",
      "INDEX ITEM DESCRIPTION":
        "Marl crushed and broken stone mining and/or beneficiating",
    },
    {
      NAICS22: "212312",
      "INDEX ITEM DESCRIPTION": "Riprap, limestone, mining or quarrying",
    },
    {
      NAICS22: "212312",
      "INDEX ITEM DESCRIPTION": "Riprap, limestone, preparation plants",
    },
    {
      NAICS22: "212312",
      "INDEX ITEM DESCRIPTION":
        "Travertine crushed and broken stone mining and/or beneficiating",
    },
    {
      NAICS22: "212312",
      "INDEX ITEM DESCRIPTION":
        "Tufa, calcareous, crushed and broken stone, mining and/or beneficiating",
    },
    {
      NAICS22: "212312",
      "INDEX ITEM DESCRIPTION":
        "Whiting crushed and broken stone, mining and/or beneficiating",
    },
    {
      NAICS22: "212313",
      "INDEX ITEM DESCRIPTION":
        "Diorite crushed and broken stone mining and/or beneficiating",
    },
    {
      NAICS22: "212313",
      "INDEX ITEM DESCRIPTION":
        "Gneiss crushed and broken stone mining and/or beneficiating",
    },
    {
      NAICS22: "212313",
      "INDEX ITEM DESCRIPTION":
        "Granite beneficiating plants (e.g., grinding or pulverizing)",
    },
    {
      NAICS22: "212313",
      "INDEX ITEM DESCRIPTION":
        "Granite crushed and broken stone mining and/or beneficiating",
    },
    {
      NAICS22: "212313",
      "INDEX ITEM DESCRIPTION": "Riprap, granite, mining or quarrying",
    },
    {
      NAICS22: "212313",
      "INDEX ITEM DESCRIPTION": "Riprap, granite, preparation plants",
    },
    {
      NAICS22: "212313",
      "INDEX ITEM DESCRIPTION":
        "Syenite (except nepheline) crushed and broken stone mining and/or beneficiating",
    },
    {
      NAICS22: "212319",
      "INDEX ITEM DESCRIPTION":
        "Basalt crushed and broken stone mining and/or beneficiating",
    },
    {
      NAICS22: "212319",
      "INDEX ITEM DESCRIPTION":
        "Bituminous limestone mining and/or beneficiating",
    },
    {
      NAICS22: "212319",
      "INDEX ITEM DESCRIPTION":
        "Bituminous sandstone mining and/or beneficiating",
    },
    {
      NAICS22: "212319",
      "INDEX ITEM DESCRIPTION":
        "Boulder crushed and broken mining and/or beneficiating",
    },
    {
      NAICS22: "212319",
      "INDEX ITEM DESCRIPTION":
        "Diabase crushed and broken stone mining and/or beneficiating",
    },
    {
      NAICS22: "212319",
      "INDEX ITEM DESCRIPTION":
        "Dolomitic marble crushed and broken stone mining and/or beneficiating",
    },
    {
      NAICS22: "212319",
      "INDEX ITEM DESCRIPTION":
        "Gabbro crushed and broken stone mining and/or beneficiating",
    },
    {
      NAICS22: "212319",
      "INDEX ITEM DESCRIPTION":
        "Ganister crushed and broken stone mining and/or beneficiating",
    },
    {
      NAICS22: "212319",
      "INDEX ITEM DESCRIPTION": "Granules, slate, mining and/or beneficiating",
    },
    {
      NAICS22: "212319",
      "INDEX ITEM DESCRIPTION":
        "Grits crushed and broken stone mining and/or beneficiating",
    },
    {
      NAICS22: "212319",
      "INDEX ITEM DESCRIPTION":
        "Limestone, bituminous, mining and/or beneficiating",
    },
    {
      NAICS22: "212319",
      "INDEX ITEM DESCRIPTION":
        "Marble crushed and broken stone mining and/or beneficiating",
    },
    {
      NAICS22: "212319",
      "INDEX ITEM DESCRIPTION":
        "Mica schist crushed and broken stone mining and/or beneficiating",
    },
    {
      NAICS22: "212319",
      "INDEX ITEM DESCRIPTION":
        "Onyx marble crushed and broken stone mining and/or beneficiating",
    },
    {
      NAICS22: "212319",
      "INDEX ITEM DESCRIPTION":
        "Quartzite crushed and broken stone mining and/or beneficiating",
    },
    {
      NAICS22: "212319",
      "INDEX ITEM DESCRIPTION":
        "Riprap (except granite, limestone) preparation plants",
    },
    {
      NAICS22: "212319",
      "INDEX ITEM DESCRIPTION":
        "Riprap (except limestone and granite) mining or quarrying",
    },
    {
      NAICS22: "212319",
      "INDEX ITEM DESCRIPTION": "Sandstone crushed and broken stone mining",
    },
    {
      NAICS22: "212319",
      "INDEX ITEM DESCRIPTION":
        "Schist, mica, crushed and broken stone, mining and/or beneficiating",
    },
    {
      NAICS22: "212319",
      "INDEX ITEM DESCRIPTION":
        "Serpentine crushed and broken stone mining and/or beneficiating",
    },
    {
      NAICS22: "212319",
      "INDEX ITEM DESCRIPTION":
        "Slate crushed and broken stone mining and/or beneficiating",
    },
    {
      NAICS22: "212319",
      "INDEX ITEM DESCRIPTION":
        "Stone (except limestone and granite) beneficiating plants (e.g., grinding)",
    },
    {
      NAICS22: "212319",
      "INDEX ITEM DESCRIPTION":
        "Stone, crushed and broken (except granite or limestone), mining and/or beneficiating",
    },
    {
      NAICS22: "212319",
      "INDEX ITEM DESCRIPTION":
        "Trap rock crushed and broken stone mining and/or beneficiating",
    },
    {
      NAICS22: "212319",
      "INDEX ITEM DESCRIPTION":
        "Verde' antique crushed and broken stone mining and/or beneficiating",
    },
    {
      NAICS22: "212319",
      "INDEX ITEM DESCRIPTION":
        "Volcanic rock crushed and broken stone mining and/or beneficiating",
    },
    {
      NAICS22: "212321",
      "INDEX ITEM DESCRIPTION": "Common sand quarrying and/or beneficiating",
    },
    {
      NAICS22: "212321",
      "INDEX ITEM DESCRIPTION":
        "Construction sand and gravel beneficiating (e.g., grinding, screening, washing)",
    },
    {
      NAICS22: "212321",
      "INDEX ITEM DESCRIPTION": "Construction sand or gravel dredging",
    },
    {
      NAICS22: "212321",
      "INDEX ITEM DESCRIPTION": "Gravel quarrying and/or beneficiating",
    },
    {
      NAICS22: "212321",
      "INDEX ITEM DESCRIPTION":
        "Pebbles (except grinding) mining and/or beneficiating",
    },
    {
      NAICS22: "212321",
      "INDEX ITEM DESCRIPTION":
        "Sand and gravel quarrying (i.e., construction grade) and/or beneficiating",
    },
    {
      NAICS22: "212321",
      "INDEX ITEM DESCRIPTION":
        "Sand, construction grade, quarrying and/or beneficiating",
    },
    {
      NAICS22: "212322",
      "INDEX ITEM DESCRIPTION": "Abrasive sand quarrying and/or beneficiating",
    },
    {
      NAICS22: "212322",
      "INDEX ITEM DESCRIPTION": "Blast sand quarrying and/or beneficiating",
    },
    {
      NAICS22: "212322",
      "INDEX ITEM DESCRIPTION": "Enamel sand quarrying and/or beneficiating",
    },
    {
      NAICS22: "212322",
      "INDEX ITEM DESCRIPTION": "Filtration sand quarrying and/or beneficiating",
    },
    {
      NAICS22: "212322",
      "INDEX ITEM DESCRIPTION": "Foundry sand quarrying and/or beneficiating",
    },
    {
      NAICS22: "212322",
      "INDEX ITEM DESCRIPTION": "Glass sand quarrying and/or beneficiating",
    },
    {
      NAICS22: "212322",
      "INDEX ITEM DESCRIPTION": "Grinding sand quarrying and/or beneficiating",
    },
    {
      NAICS22: "212322",
      "INDEX ITEM DESCRIPTION":
        "Industrial sand beneficiating (e.g., screening, washing)",
    },
    {
      NAICS22: "212322",
      "INDEX ITEM DESCRIPTION": "Industrial sand sandpits and dredging",
    },
    {
      NAICS22: "212322",
      "INDEX ITEM DESCRIPTION": "Molding sand quarrying and/or beneficiating",
    },
    {
      NAICS22: "212322",
      "INDEX ITEM DESCRIPTION": "Sand, blast, quarrying and/or beneficiating",
    },
    {
      NAICS22: "212322",
      "INDEX ITEM DESCRIPTION":
        "Sand, industrial (e.g., engine, filtration, glass grinding, proppant), quarrying and/or beneficiating",
    },
    {
      NAICS22: "212322",
      "INDEX ITEM DESCRIPTION": "Silica mining and/or beneficiating",
    },
    {
      NAICS22: "212322",
      "INDEX ITEM DESCRIPTION": "Silica sand quarrying and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Andalusite mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Aplite mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Ball clay mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Bentonite mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Bleaching clay mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Brucite mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Burley mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "China clay mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Clay bleaching",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Clay mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Clay, ball, mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION":
        "Clay, ceramic and refractory minerals, mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Clay, fire, mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Clay, natural, mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Common clay mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Common shale mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Cornwall stone mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Cyanite mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Diaspore mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Dumortierite mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION":
        "Earth, fuller's (e.g., all natural bleaching clays), mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Feldspar mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Fire clay mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Flint clay mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Fuller's earth mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Kaolin mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Kyanite mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Laterite mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Magnesite mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Nepheline syenite mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Olivine, non-gem, mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Paper clay mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION":
        "Pegmatite, feldspar, mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Pinite mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Plastic fire clay mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Refractory minerals mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Rubber clay mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION":
        "Shale (except oil shale) mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Sillimanite mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Slip clay mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Stoneware clay mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Syenite, nepheline, mining and/or beneficiating",
    },
    {
      NAICS22: "212323",
      "INDEX ITEM DESCRIPTION": "Topaz, non-gem, mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION":
        "Abrasive stones (e.g., emery, grindstones, hones, pumice) mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION":
        "Abrasives, natural (except sand), mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Agate mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Alabaster mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Alum, natural, mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Alunite mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Amblygonite mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Amethyst mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Apatite mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Arsenic mineral mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Asbestos mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Ash, volcanic, mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Asphalt rock mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Asphalt, native, mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Barite mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Barium ores mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Barytes mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Borate, natural, mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION":
        "Borax, crude, ground or pulverized, mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION":
        "Boron compounds prepared at beneficiating plants",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Boron mineral mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Brimstone mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION":
        "Burrstones, natural, mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION":
        "Calcined phosphate rock mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Calcite mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Catlinite mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Celestite mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Chasers mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Colemanite mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Corundum mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Cryolite mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION":
        "Diamonds, industrial, mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Diatomaceous earth mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Diatomite mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Dragstones mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION":
        "Dried phosphate rock mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION":
        "Earth, diatomaceous, mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Emery mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION":
        "Fertilizer minerals, natural, mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Fill dirt pits mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Fluorite mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Fluorspar mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Garnet mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION":
        "Gem stone (e.g., amethyst, garnet, agate, ruby, sapphire, jade) mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Gilsonite mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Glauber's salt mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Grahamite mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Graphite mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Greensand mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Grinding pebbles mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Grindstones mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Guano mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Gypsite mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Gypsum mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Hones mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Humus, peat, mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION":
        "Iceland spar (i.e., optical grade calcite), mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Jade mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Kernite mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Lepidolite mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Lithium mineral mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Marcasite mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Meerschaum mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Mica mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Millstones mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION":
        "Mineral pigments, natural, mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Muriate of potash, mining",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Muscovite mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Native asphalt mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION":
        "Natural abrasives (e.g., emery, grindstones, hones, pumice) (except sand) mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Ocher mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Oilstones mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION":
        "Optical grade calcite mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Ozokerite mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Pavers mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Peat grinding",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Peat humus mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Peat mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Pebbles grinding",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Perlite mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Phlogopite mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Phosphate rock mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION":
        "Pigments, natural, mineral, mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Pipestones mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Potash mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION":
        "Potassium bromide, natural, mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Potassium chloride mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION":
        "Potassium compounds prepared at beneficiating plants",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION":
        "Potassium compounds, natural, mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION":
        "Potassium salts, natural, mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Pozzolana mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Precious stones mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Probertite mining and/or quarrying",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION":
        "Pulpstones, natural, mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Pumice mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Pumicite mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Pyrite concentrates mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Pyrite mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Pyrophyllite mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Pyrrhotite mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION":
        "Quartz crystal, pure, mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Reed peat mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Rock salt mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Rubbing stones mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Ruby mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Salines mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Salt, common, mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Salt, rock, mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Sapphire mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Scoria mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Screening peat",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Scythestones mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Sedge peat mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Selenite mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Semiprecious stones mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Shell mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Shredding peat mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Sienna mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION":
        "Sintered phosphate rock mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Soapstone mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Soda ash mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Soda ash, natural, mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION":
        "Sodium borates, natural, mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION":
        "Sodium carbonates, natural, mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION":
        "Sodium chloride, rock salt, mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION":
        "Sodium compounds prepared at beneficiating plants",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION":
        "Sodium compounds, natural, mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION":
        "Sodium sulfate, natural, mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Spar, iceland, mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Spodumene mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Staurolite mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Steatite mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION":
        "Stones, abrasive (e.g., emery, grindstones, hones, pumice), mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Strontianite mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Strontium mineral mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Sulfate, sodium, mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Sulfur mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Sulfur, native, mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Talc mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Tripoli mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Trona mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Turquoise mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Ulexite mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Umber mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Vermiculite mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Volcanic ash mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Whetstones mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Wollastonite mining and/or beneficiating",
    },
    {
      NAICS22: "212390",
      "INDEX ITEM DESCRIPTION": "Wurtzilite mining and/or beneficiating",
    },
    {
      NAICS22: "213111",
      "INDEX ITEM DESCRIPTION":
        "Directional drilling of oil and gas wells on a contract basis",
    },
    {
      NAICS22: "213111",
      "INDEX ITEM DESCRIPTION":
        "Drilling directional oil and gas field wells on a contract basis",
    },
    {
      NAICS22: "213111",
      "INDEX ITEM DESCRIPTION": "Drilling for gas on a contract basis",
    },
    {
      NAICS22: "213111",
      "INDEX ITEM DESCRIPTION": "Drilling for oil on a contract basis",
    },
    {
      NAICS22: "213111",
      "INDEX ITEM DESCRIPTION":
        "Drilling gas and oil field wells on a contract basis",
    },
    {
      NAICS22: "213111",
      "INDEX ITEM DESCRIPTION":
        "Drilling oil and gas field service wells on a contract basis",
    },
    {
      NAICS22: "213111",
      "INDEX ITEM DESCRIPTION":
        "Drilling water intake wells, oil and gas field on a contract basis",
    },
    {
      NAICS22: "213111",
      "INDEX ITEM DESCRIPTION": "Gas well drilling on a contract basis",
    },
    {
      NAICS22: "213111",
      "INDEX ITEM DESCRIPTION":
        "Oil and gas well drilling services (redrilling, spudding, tailing) on a contract basis",
    },
    {
      NAICS22: "213111",
      "INDEX ITEM DESCRIPTION": "Oil well drilling on a contract basis",
    },
    {
      NAICS22: "213111",
      "INDEX ITEM DESCRIPTION":
        "Reconditioning oil and gas field wells on a contract basis",
    },
    {
      NAICS22: "213111",
      "INDEX ITEM DESCRIPTION": "Reworking oil and gas wells on a contract basis",
    },
    {
      NAICS22: "213111",
      "INDEX ITEM DESCRIPTION": "Service well drilling on a contract basis",
    },
    {
      NAICS22: "213111",
      "INDEX ITEM DESCRIPTION":
        "Spudding in oil and gas wells on a contract basis",
    },
    {
      NAICS22: "213111",
      "INDEX ITEM DESCRIPTION":
        "Tailing in oil and gas field wells on a contract basis",
    },
    {
      NAICS22: "213111",
      "INDEX ITEM DESCRIPTION":
        "Water intake well drilling, oil and gas field on a contract basis",
    },
    {
      NAICS22: "213111",
      "INDEX ITEM DESCRIPTION":
        "Well drilling (i.e., oil, gas, water intake wells) on a contract basis",
    },
    {
      NAICS22: "213111",
      "INDEX ITEM DESCRIPTION":
        "Workover of oil and gas wells on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Acidizing oil and gas field wells on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Building oil and gas well foundations on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Building, erecting, repairing, and dismantling oil and gas field rigs and derricks on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Cementing oil and gas well casings on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Chemically treating oil and gas wells (e.g., acidizing, bailing, swabbing) on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Cleaning oil and gas field lease tanks on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Cleaning out (e.g., bailing out, steam cleaning, swabbing) wells on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION": "Cleaning wells on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Cleaning, repairing, and dismantling oil and gas field lease tanks on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Contract services (except geophysical surveying and mapping, site preparation, construction, and transportation activities) for oil and gas fields",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Core cutting in oil and gas wells, on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Core drilling, exploration services, oil and gas field",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Cutting cores in oil and gas wells on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Derrick building, repairing, and dismantling at oil and gas fields on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Dismantling of oil well rigs on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Drilling rat holes and mouse holes at oil and gas fields on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Drilling shot holes at oil and gas fields on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Drilling site preparation at oil and gas fields on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Drill-stem testing in oil, gas, dry, and service well drilling on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Excavating mud pits, slush pits, and cellars at oil and gas fields on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Exploration services for oil and gas (except geophysical surveying and mapping) on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Fishing for tools at oil and gas fields on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Gas well rig building, repairing, and dismantling on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Gas, compressing natural, in the field on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Geological exploration (except surveying) for oil and gas on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Geophysical exploration (except surveying) for oil and gas on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Hard banding oil and gas field service on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Hot oil treating of oil field tanks on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Hot shot oil field services (on- and off-road) on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION": "Hydraulic fracturing wells on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Impounding and storing salt water in connection with petroleum production",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Installing production equipment at the oil or gas field on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Lease tank cleaning and repairing on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION": "Logging wells on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Mouse hole and rat hole drilling at oil and gas fields on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Mud service for oil field drilling on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Oil and gas field services on a contract basis (except geophysical surveying and mapping, site preparation, construction, and transportation activities)",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Oil field exploration (except surveying) on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION": "Oil sampling services on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION": "Oil well logging on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Oil well rig building, repairing, and dismantling, on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Operating condensate gasoline field gathering lines on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Paraffin services, oil and gas field, on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Perforating oil and gas well casings on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Pipe testing services, oil and gas field, on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Plugging and abandoning wells on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Preparation of oil and gas field drilling sites (except site preparation and related construction contractor activities) on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Pulling oil and gas field casings, tubes, or rods on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION": "Pumping oil and gas wells on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Rathole and mousehole drilling at oil and gas fields on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Rig skidding, oil and gas field, on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION": "Roustabout mining services, on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Salt water disposal systems, oil and gas field, on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Sandblasting pipelines on lease, oil and gas field, on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Seismograph exploration (except surveying) for oil and gas on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION": "Servicing oil and gas wells on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Shot hole drilling, oil and gas field, on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Skidding of rigs, oil and gas field, on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Slush pits and cellars, excavation of, on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Steam cleaning oil and gas wells on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Stratigraphic drilling, oil and gas field exploration on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Surveying (except seismographic) oil or gas wells on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION": "Swabbing oil or gas wells on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Well casing running, cutting and pulling, oil and gas field on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Well logging, oil and gas field, on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Well plugging, oil and gas field, on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Well pumping, oil and gas field, on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Well servicing, oil and gas field, on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Well surveying, oil and gas field, on a contract basis",
    },
    {
      NAICS22: "213112",
      "INDEX ITEM DESCRIPTION":
        "Wireline services, oil and gas field, on a contract basis",
    },
    {
      NAICS22: "213113",
      "INDEX ITEM DESCRIPTION": "Anthracite mine tunneling on a contract basis",
    },
    {
      NAICS22: "213113",
      "INDEX ITEM DESCRIPTION":
        "Anthracite mining services on a contract basis (except geophysical surveying and mapping, site preparation, construction, and transportation activities)",
    },
    {
      NAICS22: "213113",
      "INDEX ITEM DESCRIPTION":
        "Auger coal mining services on a contract basis (except geophysical surveying and mapping, site preparation, construction, and transportation activities)",
    },
    {
      NAICS22: "213113",
      "INDEX ITEM DESCRIPTION":
        "Bituminous coal mining services on a contract basis (except geophysical surveying and mapping, site preparation, construction, and transportation activities)",
    },
    {
      NAICS22: "213113",
      "INDEX ITEM DESCRIPTION":
        "Bituminous coal or lignite surface mine site development (except site preparation and related construction contractor activities) on a contract basis",
    },
    {
      NAICS22: "213113",
      "INDEX ITEM DESCRIPTION":
        "Bituminous coal stripping service on a contract basis",
    },
    {
      NAICS22: "213113",
      "INDEX ITEM DESCRIPTION":
        "Bituminous or lignite auger mining service on a contract basis",
    },
    {
      NAICS22: "213113",
      "INDEX ITEM DESCRIPTION":
        "Blasting services, coal mining, on a contract basis",
    },
    {
      NAICS22: "213113",
      "INDEX ITEM DESCRIPTION":
        "Coal mining services on a contract basis (except geophysical surveying and mapping, site preparation, construction, and transportation activities)",
    },
    {
      NAICS22: "213113",
      "INDEX ITEM DESCRIPTION":
        "Coal mining support services on a contract basis (e.g., tunneling, blasting, training, overburden removal) (except geophysical surveying and mapping, site preparation, construction, and transportation activities)",
    },
    {
      NAICS22: "213113",
      "INDEX ITEM DESCRIPTION":
        "Culm bank recovery, anthracite, on a contract basis",
    },
    {
      NAICS22: "213113",
      "INDEX ITEM DESCRIPTION": "Culm bank recovery, coal, on a contract basis",
    },
    {
      NAICS22: "213113",
      "INDEX ITEM DESCRIPTION":
        "Draining or pumping coal mines on a contract basis",
    },
    {
      NAICS22: "213113",
      "INDEX ITEM DESCRIPTION":
        "Drilling services for coal mining on a contract basis",
    },
    {
      NAICS22: "213113",
      "INDEX ITEM DESCRIPTION":
        "Exploration services for coal (except geophysical surveying and mapping) on a contract basis",
    },
    {
      NAICS22: "213113",
      "INDEX ITEM DESCRIPTION":
        "Lignite mining services on a contract basis (except geophysical surveying and mapping, site preparation, construction, and transportation activities)",
    },
    {
      NAICS22: "213113",
      "INDEX ITEM DESCRIPTION":
        "Mine shaft sinking services for coal mining on a contract basis",
    },
    {
      NAICS22: "213113",
      "INDEX ITEM DESCRIPTION":
        "Mine tunneling services for coal mining on a contract basis",
    },
    {
      NAICS22: "213113",
      "INDEX ITEM DESCRIPTION":
        "Overburden removal for coal mining on a contract basis",
    },
    {
      NAICS22: "213113",
      "INDEX ITEM DESCRIPTION":
        "Prospect and test drilling services for coal mining on contract basis",
    },
    {
      NAICS22: "213113",
      "INDEX ITEM DESCRIPTION":
        "Pumping or draining coal mines on a contract basis",
    },
    {
      NAICS22: "213113",
      "INDEX ITEM DESCRIPTION":
        "Removal of overburden for coal mining on a contract basis",
    },
    {
      NAICS22: "213113",
      "INDEX ITEM DESCRIPTION":
        "Shaft sinking for coal mines on a contract basis",
    },
    {
      NAICS22: "213113",
      "INDEX ITEM DESCRIPTION":
        "Sinking shafts for coal mining on a contract basis",
    },
    {
      NAICS22: "213113",
      "INDEX ITEM DESCRIPTION":
        "Stripping overburden services for coal mining on a contract basis",
    },
    {
      NAICS22: "213113",
      "INDEX ITEM DESCRIPTION":
        "Tunneling services for coal mining on a contract basis",
    },
    {
      NAICS22: "213114",
      "INDEX ITEM DESCRIPTION":
        "Blasting services, metal mining, on a contract basis",
    },
    {
      NAICS22: "213114",
      "INDEX ITEM DESCRIPTION":
        "Boring test holes for metal mining on a contract basis",
    },
    {
      NAICS22: "213114",
      "INDEX ITEM DESCRIPTION":
        "Draining or pumping of metal mines on a contract basis",
    },
    {
      NAICS22: "213114",
      "INDEX ITEM DESCRIPTION":
        "Drilling services for metal mining on a contract basis",
    },
    {
      NAICS22: "213114",
      "INDEX ITEM DESCRIPTION":
        "Exploration services for metal (except geophysical surveying and mapping) on a contract basis",
    },
    {
      NAICS22: "213114",
      "INDEX ITEM DESCRIPTION":
        "Metal mining support services on a contract basis (e.g., shaft sinking, tunneling, blasting) (except geophysical surveying and mapping, site preparation, construction, and transportation activities)",
    },
    {
      NAICS22: "213114",
      "INDEX ITEM DESCRIPTION":
        "Mine development (except site preparation and related construction contractor activities) for metal mining on a contract basis",
    },
    {
      NAICS22: "213114",
      "INDEX ITEM DESCRIPTION":
        "Mine shaft sinking services for metal mining on a contract basis",
    },
    {
      NAICS22: "213114",
      "INDEX ITEM DESCRIPTION":
        "Mine tunneling services for metal mining on a contract basis",
    },
    {
      NAICS22: "213114",
      "INDEX ITEM DESCRIPTION":
        "Overburden removal for metal mining on a contract basis",
    },
    {
      NAICS22: "213114",
      "INDEX ITEM DESCRIPTION":
        "Prospect and test drilling services for metal mining on contract basis",
    },
    {
      NAICS22: "213114",
      "INDEX ITEM DESCRIPTION":
        "Pumping or draining metal mines on a contract basis",
    },
    {
      NAICS22: "213114",
      "INDEX ITEM DESCRIPTION":
        "Removal of overburden for metal mining on a contract basis",
    },
    {
      NAICS22: "213114",
      "INDEX ITEM DESCRIPTION":
        "Shaft sinking for metal mines on a contract basis",
    },
    {
      NAICS22: "213114",
      "INDEX ITEM DESCRIPTION":
        "Sinking shafts for metal mining on a contract basis",
    },
    {
      NAICS22: "213114",
      "INDEX ITEM DESCRIPTION":
        "Stripping overburden services for metal mining on a contract basis",
    },
    {
      NAICS22: "213114",
      "INDEX ITEM DESCRIPTION":
        "Test drilling for metal mining on a contract basis",
    },
    {
      NAICS22: "213115",
      "INDEX ITEM DESCRIPTION":
        "Blasting services, nonmetallic minerals mining (except fuels) on a contract basis",
    },
    {
      NAICS22: "213115",
      "INDEX ITEM DESCRIPTION":
        "Boring test holes for nonmetallic minerals mining (except fuels) on a contract basis",
    },
    {
      NAICS22: "213115",
      "INDEX ITEM DESCRIPTION":
        "Draining or pumping of nonmetallic mineral mines (except fuels) on a contract basis",
    },
    {
      NAICS22: "213115",
      "INDEX ITEM DESCRIPTION":
        "Drilling services for nonmetallic mineral (except fuels) mining on a contract basis",
    },
    {
      NAICS22: "213115",
      "INDEX ITEM DESCRIPTION":
        "Exploration services for nonmetallic minerals (except geophysical surveying and mapping) on a contract basis",
    },
    {
      NAICS22: "213115",
      "INDEX ITEM DESCRIPTION":
        "Mine shaft sinking services for nonmetallic minerals (except fuels) on a contract basis",
    },
    {
      NAICS22: "213115",
      "INDEX ITEM DESCRIPTION":
        "Mine tunneling services for nonmetallic minerals (except fuels) on a contract basis",
    },
    {
      NAICS22: "213115",
      "INDEX ITEM DESCRIPTION":
        "Nonmetallic minerals mine development on a contract basis (except site preparation and related construction activities)",
    },
    {
      NAICS22: "213115",
      "INDEX ITEM DESCRIPTION":
        "Nonmetallic minerals mining support services on a contract basis (e.g., blasting, shaft sinking, tunneling) (except geophysical surveying and mapping, site preparation, construction, and transportation activities)",
    },
    {
      NAICS22: "213115",
      "INDEX ITEM DESCRIPTION":
        "Overburden removal for nonmetallic minerals mining (except fuels) on a contract basis",
    },
    {
      NAICS22: "213115",
      "INDEX ITEM DESCRIPTION":
        "Prospect and test drilling services for nonmetallic mineral mining (except fuels) on a contract basis",
    },
    {
      NAICS22: "213115",
      "INDEX ITEM DESCRIPTION":
        "Pumping or draining nonmetallic mineral mines (except fuel) on a contract basis",
    },
    {
      NAICS22: "213115",
      "INDEX ITEM DESCRIPTION":
        "Removal of overburden for nonmetallic minerals mining (except fuels) on a contract basis",
    },
    {
      NAICS22: "213115",
      "INDEX ITEM DESCRIPTION":
        "Stripping overburden services for nonmetallic minerals mining (except fuels) on a contract basis",
    },
    {
      NAICS22: "213115",
      "INDEX ITEM DESCRIPTION":
        "Test drilling for nonmetallic minerals mining (except fuel) on a contract basis",
    },
    {
      NAICS22: "221111",
      "INDEX ITEM DESCRIPTION": "Electric power generation, hydroelectric",
    },
    {
      NAICS22: "221111",
      "INDEX ITEM DESCRIPTION": "Hydroelectric power generation",
    },
    {
      NAICS22: "221111",
      "INDEX ITEM DESCRIPTION": "Power generation, hydroelectric",
    },
    {
      NAICS22: "221112",
      "INDEX ITEM DESCRIPTION":
        "Electric power generation, fossil fuel (e.g., coal, oil, gas)",
    },
    {
      NAICS22: "221112",
      "INDEX ITEM DESCRIPTION":
        "Power generation, fossil fuel (e.g., coal, gas, oil), electric",
    },
    {
      NAICS22: "221113",
      "INDEX ITEM DESCRIPTION": "Electric power generation, nuclear",
    },
    {
      NAICS22: "221113",
      "INDEX ITEM DESCRIPTION": "Power generation, nuclear electric",
    },
    {
      NAICS22: "221114",
      "INDEX ITEM DESCRIPTION": "Electric power generation, solar  ",
    },
    {
      NAICS22: "221114",
      "INDEX ITEM DESCRIPTION": "Power generation, solar electric",
    },
    {
      NAICS22: "221114",
      "INDEX ITEM DESCRIPTION": "Solar farms",
    },
    {
      NAICS22: "221115",
      "INDEX ITEM DESCRIPTION": "Electric power generation, wind",
    },
    {
      NAICS22: "221115",
      "INDEX ITEM DESCRIPTION": "Power generation, wind electric",
    },
    {
      NAICS22: "221116",
      "INDEX ITEM DESCRIPTION": "Electric power generation, geothermal",
    },
    {
      NAICS22: "221116",
      "INDEX ITEM DESCRIPTION": "Geothermal electric power generation",
    },
    {
      NAICS22: "221116",
      "INDEX ITEM DESCRIPTION": "Power generation, geothermal",
    },
    {
      NAICS22: "221117",
      "INDEX ITEM DESCRIPTION": "Biomass electric power generation",
    },
    {
      NAICS22: "221117",
      "INDEX ITEM DESCRIPTION": "Electric power generation, biomass",
    },
    {
      NAICS22: "221117",
      "INDEX ITEM DESCRIPTION": "Power generation, biomass",
    },
    {
      NAICS22: "221118",
      "INDEX ITEM DESCRIPTION": "Electric power generation, tidal",
    },
    {
      NAICS22: "221118",
      "INDEX ITEM DESCRIPTION": "Power generation, tidal electric",
    },
    {
      NAICS22: "221121",
      "INDEX ITEM DESCRIPTION": "Electric power control",
    },
    {
      NAICS22: "221121",
      "INDEX ITEM DESCRIPTION": "Electric power transmission systems",
    },
    {
      NAICS22: "221121",
      "INDEX ITEM DESCRIPTION": "Transmission of electric power",
    },
    {
      NAICS22: "221122",
      "INDEX ITEM DESCRIPTION": "Distribution of electric power",
    },
    {
      NAICS22: "221122",
      "INDEX ITEM DESCRIPTION": "Electric power brokers",
    },
    {
      NAICS22: "221122",
      "INDEX ITEM DESCRIPTION": "Electric power distribution systems",
    },
    {
      NAICS22: "221210",
      "INDEX ITEM DESCRIPTION": "Blue gas, carbureted, distribution",
    },
    {
      NAICS22: "221210",
      "INDEX ITEM DESCRIPTION": "Coke oven gas distribution",
    },
    {
      NAICS22: "221210",
      "INDEX ITEM DESCRIPTION": "Distribution of manufactured gas",
    },
    {
      NAICS22: "221210",
      "INDEX ITEM DESCRIPTION": "Distribution of natural gas",
    },
    {
      NAICS22: "221210",
      "INDEX ITEM DESCRIPTION": "Distribution of renewable natural gas (RNG)",
    },
    {
      NAICS22: "221210",
      "INDEX ITEM DESCRIPTION": "Gas, manufactured, distribution",
    },
    {
      NAICS22: "221210",
      "INDEX ITEM DESCRIPTION":
        "Gas, mixed natural and manufactured, distribution",
    },
    {
      NAICS22: "221210",
      "INDEX ITEM DESCRIPTION": "Gas, natural, distribution",
    },
    {
      NAICS22: "221210",
      "INDEX ITEM DESCRIPTION":
        "Liquefied petroleum gas (LPG) distribution through mains",
    },
    {
      NAICS22: "221210",
      "INDEX ITEM DESCRIPTION": "Manufactured gas distribution",
    },
    {
      NAICS22: "221210",
      "INDEX ITEM DESCRIPTION": "Natural gas brokers",
    },
    {
      NAICS22: "221210",
      "INDEX ITEM DESCRIPTION": "Natural gas distribution systems",
    },
    {
      NAICS22: "221210",
      "INDEX ITEM DESCRIPTION": "Natural gas distribution with transmission",
    },
    {
      NAICS22: "221210",
      "INDEX ITEM DESCRIPTION": "Natural gas marketers",
    },
    {
      NAICS22: "221310",
      "INDEX ITEM DESCRIPTION": "Canal, irrigation",
    },
    {
      NAICS22: "221310",
      "INDEX ITEM DESCRIPTION": "Filtration plant, water",
    },
    {
      NAICS22: "221310",
      "INDEX ITEM DESCRIPTION": "Impounding reservoirs, irrigation",
    },
    {
      NAICS22: "221310",
      "INDEX ITEM DESCRIPTION": "Irrigation system operation",
    },
    {
      NAICS22: "221310",
      "INDEX ITEM DESCRIPTION": "Water distribution (except irrigation)",
    },
    {
      NAICS22: "221310",
      "INDEX ITEM DESCRIPTION": "Water distribution for irrigation",
    },
    {
      NAICS22: "221310",
      "INDEX ITEM DESCRIPTION": "Water filtration plant operation",
    },
    {
      NAICS22: "221310",
      "INDEX ITEM DESCRIPTION": "Water supply systems",
    },
    {
      NAICS22: "221310",
      "INDEX ITEM DESCRIPTION": "Water treatment and distribution",
    },
    {
      NAICS22: "221310",
      "INDEX ITEM DESCRIPTION": "Water treatment plants",
    },
    {
      NAICS22: "221320",
      "INDEX ITEM DESCRIPTION":
        "Collection, treatment, and disposal of waste through a sewer system",
    },
    {
      NAICS22: "221320",
      "INDEX ITEM DESCRIPTION": "Sewage disposal plants",
    },
    {
      NAICS22: "221320",
      "INDEX ITEM DESCRIPTION": "Sewage treatment plants or facilities",
    },
    {
      NAICS22: "221320",
      "INDEX ITEM DESCRIPTION": "Sewer systems",
    },
    {
      NAICS22: "221320",
      "INDEX ITEM DESCRIPTION":
        "Waste collection, treatment, and disposal through a sewer system",
    },
    {
      NAICS22: "221330",
      "INDEX ITEM DESCRIPTION": "Air-conditioning supply",
    },
    {
      NAICS22: "221330",
      "INDEX ITEM DESCRIPTION": "Cooled air distribution",
    },
    {
      NAICS22: "221330",
      "INDEX ITEM DESCRIPTION": "Distribution of cooled air",
    },
    {
      NAICS22: "221330",
      "INDEX ITEM DESCRIPTION": "Distribution of heated air",
    },
    {
      NAICS22: "221330",
      "INDEX ITEM DESCRIPTION": "Distribution of steam heat",
    },
    {
      NAICS22: "221330",
      "INDEX ITEM DESCRIPTION": "Geothermal steam production",
    },
    {
      NAICS22: "221330",
      "INDEX ITEM DESCRIPTION": "Heat, steam, distribution",
    },
    {
      NAICS22: "221330",
      "INDEX ITEM DESCRIPTION": "Heated air distribution",
    },
    {
      NAICS22: "221330",
      "INDEX ITEM DESCRIPTION": "Heating steam (suppliers of heat) providers",
    },
    {
      NAICS22: "221330",
      "INDEX ITEM DESCRIPTION": "Steam heat distribution",
    },
    {
      NAICS22: "221330",
      "INDEX ITEM DESCRIPTION": "Steam heating systems (i.e., suppliers of heat)",
    },
    {
      NAICS22: "221330",
      "INDEX ITEM DESCRIPTION": "Steam production and distribution",
    },
    {
      NAICS22: "221330",
      "INDEX ITEM DESCRIPTION": "Steam supply systems, including geothermal",
    },
    {
      NAICS22: "236115",
      "INDEX ITEM DESCRIPTION": "Cabin construction general contractors",
    },
    {
      NAICS22: "236115",
      "INDEX ITEM DESCRIPTION":
        "Condominium, single-family, construction general contractors",
    },
    {
      NAICS22: "236115",
      "INDEX ITEM DESCRIPTION": "Construction management, single-family building",
    },
    {
      NAICS22: "236115",
      "INDEX ITEM DESCRIPTION": "Cottage construction general contractors",
    },
    {
      NAICS22: "236115",
      "INDEX ITEM DESCRIPTION":
        "Custom builders (except for-sale), single-family home",
    },
    {
      NAICS22: "236115",
      "INDEX ITEM DESCRIPTION":
        "Duplex (i.e., side-by-side) construction general contractors",
    },
    {
      NAICS22: "236115",
      "INDEX ITEM DESCRIPTION": "Home builders (except for-sale), single-family",
    },
    {
      NAICS22: "236115",
      "INDEX ITEM DESCRIPTION":
        "Housing, single-family, construction general contractors",
    },
    {
      NAICS22: "236115",
      "INDEX ITEM DESCRIPTION": "Log home construction general contractors",
    },
    {
      NAICS22: "236115",
      "INDEX ITEM DESCRIPTION":
        "Low income housing, single-family, construction general contractors",
    },
    {
      NAICS22: "236115",
      "INDEX ITEM DESCRIPTION":
        "Modular single-family housing assembled on site by general contractors",
    },
    {
      NAICS22: "236115",
      "INDEX ITEM DESCRIPTION":
        "Panelized single-family housing assembled on site by general contractors",
    },
    {
      NAICS22: "236115",
      "INDEX ITEM DESCRIPTION":
        "Precut single-family housing assembled on site by general contractors",
    },
    {
      NAICS22: "236115",
      "INDEX ITEM DESCRIPTION":
        "Prefabricated residential building erection, single-family",
    },
    {
      NAICS22: "236115",
      "INDEX ITEM DESCRIPTION":
        "Premanufactured single-family housing assembled on site by general contractors",
    },
    {
      NAICS22: "236115",
      "INDEX ITEM DESCRIPTION":
        "Residential construction, single-family, general contractors",
    },
    {
      NAICS22: "236115",
      "INDEX ITEM DESCRIPTION":
        "Row house (i.e., single-family type) construction general contractors",
    },
    {
      NAICS22: "236115",
      "INDEX ITEM DESCRIPTION":
        "Single-family attached housing construction general contractors",
    },
    {
      NAICS22: "236115",
      "INDEX ITEM DESCRIPTION":
        "Single-family detached housing construction general contractors",
    },
    {
      NAICS22: "236115",
      "INDEX ITEM DESCRIPTION":
        "Single-family homes built on land owned by others, general contractors of",
    },
    {
      NAICS22: "236115",
      "INDEX ITEM DESCRIPTION":
        "Single-family house construction by general contractors",
    },
    {
      NAICS22: "236115",
      "INDEX ITEM DESCRIPTION":
        "Time-share condominium construction general contractors",
    },
    {
      NAICS22: "236115",
      "INDEX ITEM DESCRIPTION":
        "Town house (i.e., single-family type) construction by general contractors",
    },
    {
      NAICS22: "236115",
      "INDEX ITEM DESCRIPTION":
        "Vacation home, single-family, construction by general contractors",
    },
    {
      NAICS22: "236116",
      "INDEX ITEM DESCRIPTION":
        "Apartment building construction general contractors",
    },
    {
      NAICS22: "236116",
      "INDEX ITEM DESCRIPTION":
        "Condominium, multifamily, construction general contractors",
    },
    {
      NAICS22: "236116",
      "INDEX ITEM DESCRIPTION": "Construction management, multifamily building",
    },
    {
      NAICS22: "236116",
      "INDEX ITEM DESCRIPTION":
        "Cooperative apartment, construction general contractors",
    },
    {
      NAICS22: "236116",
      "INDEX ITEM DESCRIPTION":
        "Custom builders (except for-sale), multifamily buildings",
    },
    {
      NAICS22: "236116",
      "INDEX ITEM DESCRIPTION":
        "Duplex (i.e., one unit above the other), construction general contractors",
    },
    {
      NAICS22: "236116",
      "INDEX ITEM DESCRIPTION":
        "Garden apartment construction general contractors",
    },
    {
      NAICS22: "236116",
      "INDEX ITEM DESCRIPTION":
        "High-rise apartment construction general contractors",
    },
    {
      NAICS22: "236116",
      "INDEX ITEM DESCRIPTION": "Home builders (except for-sale), multifamily",
    },
    {
      NAICS22: "236116",
      "INDEX ITEM DESCRIPTION":
        "Housing, multifamily, construction general contractors",
    },
    {
      NAICS22: "236116",
      "INDEX ITEM DESCRIPTION":
        "Low income housing, multifamily, construction general contractors",
    },
    {
      NAICS22: "236116",
      "INDEX ITEM DESCRIPTION":
        "Low-rise apartment  construction general contractors",
    },
    {
      NAICS22: "236116",
      "INDEX ITEM DESCRIPTION":
        "Multifamily building construction general contractors",
    },
    {
      NAICS22: "236116",
      "INDEX ITEM DESCRIPTION":
        "Panelized multifamily housing assembled on site by general contractors",
    },
    {
      NAICS22: "236116",
      "INDEX ITEM DESCRIPTION":
        "Precut multifamily housing assembled on site by general contractors",
    },
    {
      NAICS22: "236116",
      "INDEX ITEM DESCRIPTION":
        "Prefabricated residential building erection, multifamily",
    },
    {
      NAICS22: "236116",
      "INDEX ITEM DESCRIPTION":
        "Residential construction, multifamily, general contractors",
    },
    {
      NAICS22: "236117",
      "INDEX ITEM DESCRIPTION": "Apartment building for-sale builders",
    },
    {
      NAICS22: "236117",
      "INDEX ITEM DESCRIPTION": "Cabin for-sale builders",
    },
    {
      NAICS22: "236117",
      "INDEX ITEM DESCRIPTION": "Condominium for-sale builders",
    },
    {
      NAICS22: "236117",
      "INDEX ITEM DESCRIPTION": "Cooperative apartment for-sale builders",
    },
    {
      NAICS22: "236117",
      "INDEX ITEM DESCRIPTION": "Cottage for-sale builders",
    },
    {
      NAICS22: "236117",
      "INDEX ITEM DESCRIPTION":
        "Custom builders, for-sale builders, multifamily buildings",
    },
    {
      NAICS22: "236117",
      "INDEX ITEM DESCRIPTION":
        "Custom builders, for-sale builders, single-family home",
    },
    {
      NAICS22: "236117",
      "INDEX ITEM DESCRIPTION": "Duplex for-sale builders",
    },
    {
      NAICS22: "236117",
      "INDEX ITEM DESCRIPTION":
        "For-sale builders (i.e., building on own land, for sale), residential",
    },
    {
      NAICS22: "236117",
      "INDEX ITEM DESCRIPTION":
        "For-sale builders (i.e., building on own land, for sale), single-family housing",
    },
    {
      NAICS22: "236117",
      "INDEX ITEM DESCRIPTION": "Garden apartment for-sale builders",
    },
    {
      NAICS22: "236117",
      "INDEX ITEM DESCRIPTION": "High-rise apartment for-sale builders",
    },
    {
      NAICS22: "236117",
      "INDEX ITEM DESCRIPTION": "Home builders, for-sale",
    },
    {
      NAICS22: "236117",
      "INDEX ITEM DESCRIPTION": "Housing construction, for-sale builder",
    },
    {
      NAICS22: "236117",
      "INDEX ITEM DESCRIPTION": "Housing construction, merchant builder",
    },
    {
      NAICS22: "236117",
      "INDEX ITEM DESCRIPTION": "Log home for-sale builders",
    },
    {
      NAICS22: "236117",
      "INDEX ITEM DESCRIPTION":
        "Low income housing construction for-sale builders",
    },
    {
      NAICS22: "236117",
      "INDEX ITEM DESCRIPTION": "Low-rise apartment for-sale builders",
    },
    {
      NAICS22: "236117",
      "INDEX ITEM DESCRIPTION":
        "Merchant builders (i.e., building on own land, for sale), residential",
    },
    {
      NAICS22: "236117",
      "INDEX ITEM DESCRIPTION":
        "Modular housing, residential, assembled on site by for-sale builders",
    },
    {
      NAICS22: "236117",
      "INDEX ITEM DESCRIPTION": "Multifamily building for-sale builders",
    },
    {
      NAICS22: "236117",
      "INDEX ITEM DESCRIPTION":
        "Panelized housing, residential, assembled on site by for-sale builders",
    },
    {
      NAICS22: "236117",
      "INDEX ITEM DESCRIPTION":
        "Panelized multifamily housing assembled on site by for-sale builders",
    },
    {
      NAICS22: "236117",
      "INDEX ITEM DESCRIPTION":
        "Precut housing, residential, assembled on site by for-sale builders",
    },
    {
      NAICS22: "236117",
      "INDEX ITEM DESCRIPTION":
        "Premanufactured housing assembled on site by for-sale builders",
    },
    {
      NAICS22: "236117",
      "INDEX ITEM DESCRIPTION": "Residential for-sale builders",
    },
    {
      NAICS22: "236117",
      "INDEX ITEM DESCRIPTION": "Row house construction for-sale builders",
    },
    {
      NAICS22: "236117",
      "INDEX ITEM DESCRIPTION":
        "Single-family housing built on own land for sale (i.e., for-sale builders)",
    },
    {
      NAICS22: "236117",
      "INDEX ITEM DESCRIPTION":
        "Single-family housing construction for-sale builders",
    },
    {
      NAICS22: "236117",
      "INDEX ITEM DESCRIPTION":
        "Speculative builders (i.e., building on own land, for sale), multifamily housing",
    },
    {
      NAICS22: "236117",
      "INDEX ITEM DESCRIPTION":
        "Speculative builders (i.e., building on own land, for sale), residential",
    },
    {
      NAICS22: "236117",
      "INDEX ITEM DESCRIPTION":
        "Speculative builders (i.e., building on own land, for sale), single-family housing",
    },
    {
      NAICS22: "236117",
      "INDEX ITEM DESCRIPTION":
        "Time-share condominium construction for-sale builders",
    },
    {
      NAICS22: "236117",
      "INDEX ITEM DESCRIPTION": "Town house construction for-sale builders",
    },
    {
      NAICS22: "236117",
      "INDEX ITEM DESCRIPTION": "Vacation housing construction for-sale builders",
    },
    {
      NAICS22: "236118",
      "INDEX ITEM DESCRIPTION":
        "Addition, alteration and renovation (i.e., construction), multifamily building",
    },
    {
      NAICS22: "236118",
      "INDEX ITEM DESCRIPTION":
        "Addition, alteration and renovation (i.e., construction), residential building",
    },
    {
      NAICS22: "236118",
      "INDEX ITEM DESCRIPTION":
        "Addition, alteration and renovation of single-family dwellings",
    },
    {
      NAICS22: "236118",
      "INDEX ITEM DESCRIPTION":
        "Addition, alteration and renovation, multifamily building, for-sale builders",
    },
    {
      NAICS22: "236118",
      "INDEX ITEM DESCRIPTION":
        "Addition, alteration and renovation, multifamily building, general contractors",
    },
    {
      NAICS22: "236118",
      "INDEX ITEM DESCRIPTION":
        "Addition, alteration and renovation, residential building, for-sale builders",
    },
    {
      NAICS22: "236118",
      "INDEX ITEM DESCRIPTION":
        "Addition, alteration and renovation, residential building, general contractors",
    },
    {
      NAICS22: "236118",
      "INDEX ITEM DESCRIPTION":
        "Addition, alteration and renovation, single-family housing, for-sale builders",
    },
    {
      NAICS22: "236118",
      "INDEX ITEM DESCRIPTION":
        "Addition, alteration and renovation, single-family housing, general contractors",
    },
    {
      NAICS22: "236118",
      "INDEX ITEM DESCRIPTION":
        "Building, residential, addition, alteration and renovation",
    },
    {
      NAICS22: "236118",
      "INDEX ITEM DESCRIPTION": "Construction management, residential remodeling",
    },
    {
      NAICS22: "236118",
      "INDEX ITEM DESCRIPTION":
        "Fire and flood restoration, multifamily building, general contractors",
    },
    {
      NAICS22: "236118",
      "INDEX ITEM DESCRIPTION":
        "Fire and flood restoration, single-family housing, general contractors",
    },
    {
      NAICS22: "236118",
      "INDEX ITEM DESCRIPTION":
        "Handyman construction service, residential building",
    },
    {
      NAICS22: "236118",
      "INDEX ITEM DESCRIPTION":
        "Home improvement (e.g., adding on, remodeling, renovating)",
    },
    {
      NAICS22: "236118",
      "INDEX ITEM DESCRIPTION":
        "Home improvement (e.g., adding on, remodeling, renovating), multifamily building, for-sale builders",
    },
    {
      NAICS22: "236118",
      "INDEX ITEM DESCRIPTION":
        "Home improvement (e.g., adding on, remodeling, renovating), multifamily building, general contractors",
    },
    {
      NAICS22: "236118",
      "INDEX ITEM DESCRIPTION":
        "Home improvement (e.g., adding on, remodeling, renovating), single-family housing, for-sale builders",
    },
    {
      NAICS22: "236118",
      "INDEX ITEM DESCRIPTION":
        "Home improvement (e.g., adding on, remodeling, renovating), single-family housing, general contractors",
    },
    {
      NAICS22: "236118",
      "INDEX ITEM DESCRIPTION": "Home renovation",
    },
    {
      NAICS22: "236118",
      "INDEX ITEM DESCRIPTION": "Porch construction, residential-type",
    },
    {
      NAICS22: "236118",
      "INDEX ITEM DESCRIPTION": "Remodeling and renovating for-sale builders",
    },
    {
      NAICS22: "236118",
      "INDEX ITEM DESCRIPTION":
        "Remodeling and renovating general contractors, multifamily building",
    },
    {
      NAICS22: "236118",
      "INDEX ITEM DESCRIPTION":
        "Remodeling and renovating general contractors, residential",
    },
    {
      NAICS22: "236118",
      "INDEX ITEM DESCRIPTION":
        "Remodeling and renovating general contractors, single-family housing",
    },
    {
      NAICS22: "236118",
      "INDEX ITEM DESCRIPTION": "Remodeling and renovating single-family housing",
    },
    {
      NAICS22: "236118",
      "INDEX ITEM DESCRIPTION": "Remodeling and renovating, residential building",
    },
    {
      NAICS22: "236118",
      "INDEX ITEM DESCRIPTION": "Sunroom additions, residential",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION": "Acid plant construction",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION":
        "Addition, alteration and renovation, for-sale builders, industrial building (except warehouses)",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION":
        "Addition, alteration and renovation, general contractors, industrial building (except warehouses)",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION":
        "Addition, alteration and renovation, industrial building (except warehouses)",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION": "Aluminum plant construction",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION": "Ammonium plant construction",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION": "Assembly plant construction",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION": "Blast furnace construction",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION": "Cannery construction",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION": "Cement plant construction",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION":
        "Chemical (except petrochemical process-type) plant construction",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION": "Clean room construction",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION":
        "Construction management, industrial building (except warehouses)",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION": "Factory construction",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION": "Fish processing plant construction",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION": "Food processing plant construction",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION":
        "For-sale builders (i.e., building on own land, for sale), industrial building (except warehouses)",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION": "Foundry construction",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION":
        "Furnace (i.e., industrial plant structure) construction",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION": "Garbage disposal plant construction",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION": "Incinerator, mass-burn type, construction",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION":
        "Incinerator, municipal waste disposal, construction",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION":
        "Industrial building (except warehouses) construction",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION":
        "Industrial building (except warehouses) construction, for-sale builders",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION":
        "Industrial building (except warehouses) construction, general contractors",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION": "Kiln construction",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION": "Manufacturing building construction",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION": "Materials recovery facility construction",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION": "Metal processing plant construction",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION":
        "Mine loading and discharging station construction",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION": "Motor vehicle assembly plant construction",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION": "Ore and metal refinery construction",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION": "Oven, industrial plant, construction",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION": "Paper or pulp mill construction",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION": "Pharmaceutical manufacturing plant construction",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION":
        "Prefabricated industrial building (except warehouses) erection",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION": "Printing plant construction",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION":
        "Refuse disposal plant (except sewage treatment) construction",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION": "Smelter construction",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION":
        "Speculative builders (i.e., building on own land, for sale), industrial building (except warehouses)",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION": "Steel mill construction",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION": "Textile mill construction",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION": "Tipple, mining, construction",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION": "Washery, mining, construction",
    },
    {
      NAICS22: "236210",
      "INDEX ITEM DESCRIPTION":
        "Waste disposal plant (except sewage treatment) construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION":
        "Addition, alteration and renovation, commercial and institutional building",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION":
        "Addition, alteration and renovation, commercial warehouse",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION":
        "Addition, alteration and renovation, for-sale builders, commercial and institutional building",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION":
        "Addition, alteration and renovation, for-sale builders, commercial warehouse",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION":
        "Addition, alteration and renovation, for-sale builders, hotel and motel",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION":
        "Addition, alteration and renovation, for-sale builders, industrial warehouse",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION":
        "Addition, alteration and renovation, general contractors, commercial and institutional building",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION":
        "Addition, alteration and renovation, general contractors, commercial warehouse",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION":
        "Addition, alteration and renovation, general contractors, hotel and motel",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION":
        "Addition, alteration and renovation, general contractors, industrial warehouse",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION":
        "Addition, alteration and renovation, hotel and motel",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION":
        "Addition, alteration and renovation, industrial warehouse",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Administration building construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Airport building construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Airport terminal construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Amusement facility construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Animal shelter and clinic construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Arena construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Armory construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Athletic court, indoor, construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Auditorium construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Bank building construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Barber shop construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Barrack construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Beauty salon construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Broadcasting station construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Bunkhouse construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Bus shelter construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Bus terminal construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Casino construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Cinema construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Civic center construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Clinic construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Cold storage plant construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Commercial building construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION":
        "Commercial building construction for-sale builders",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION":
        "Commercial building construction general contractors",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION":
        "Construction management, commercial and institutional building",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Data center construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Dormitory construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Drycleaning plant construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Educational building construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Farm building construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION":
        "Fire and flood restoration of commercial and institutional buildings",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Fire station construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION":
        "For-sale builders (i.e., building on own land, for sale), commercial and institutional building",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION":
        "Garage and service station, commercial, construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Grain bin construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Grain elevator construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION":
        "Handyman construction service, commercial and institutional building",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Hangar construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Hatchery construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Health and athletic club construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Hospital construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Hotel construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Ice rink, indoor, construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Indoor swimming pool construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Institutional building construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION":
        "Institutional building construction for-sale builders",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION":
        "Institutional building construction general contractors",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Jail construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Laboratory construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Library construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Logging camp construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Mausoleum (i.e., building) construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Monument (i.e., building) construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Motel construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Museum construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Office building construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Parking garage construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Penitentiary construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Post office construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Prefabricated commercial building erection",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Prefabricated institutional building erection",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Prison construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Public warehouse construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION":
        "Radio and television broadcast studio construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Radio station construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Railway station construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Recreational facility building construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION":
        "Religious building (e.g., church, synagogue, mosque, temple) construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Restaurant construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Salon construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "School building construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Self-storage facility construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Service station construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Shopping center construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Shopping mall construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Silo construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION":
        "Speculative builders (i.e., building on own land, for sale), commercial and institutional building",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Stadium and arena construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Storage elevator construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Store construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Swimming facility, indoor, construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Television station construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Tennis court, indoor, construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Theater construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Truck terminal construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION":
        "Warehouse construction (e.g., commercial, industrial, manufacturing, private)",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION":
        "Warehouse, commercial and institutional, construction",
    },
    {
      NAICS22: "236220",
      "INDEX ITEM DESCRIPTION": "Warehouse, industrial, construction",
    },
    {
      NAICS22: "237110",
      "INDEX ITEM DESCRIPTION": "Aqueduct construction",
    },
    {
      NAICS22: "237110",
      "INDEX ITEM DESCRIPTION": "Artesian well construction",
    },
    {
      NAICS22: "237110",
      "INDEX ITEM DESCRIPTION": "Capping of water wells",
    },
    {
      NAICS22: "237110",
      "INDEX ITEM DESCRIPTION":
        "Construction management, water and sewage treatment plant",
    },
    {
      NAICS22: "237110",
      "INDEX ITEM DESCRIPTION": "Construction management, water and sewer line",
    },
    {
      NAICS22: "237110",
      "INDEX ITEM DESCRIPTION":
        "Distribution line, sewer and water, construction",
    },
    {
      NAICS22: "237110",
      "INDEX ITEM DESCRIPTION":
        "Drilling water wells (except water intake wells in oil and gas fields)",
    },
    {
      NAICS22: "237110",
      "INDEX ITEM DESCRIPTION": "Fire hydrant installation",
    },
    {
      NAICS22: "237110",
      "INDEX ITEM DESCRIPTION": "Geothermal drilling",
    },
    {
      NAICS22: "237110",
      "INDEX ITEM DESCRIPTION": "Hydrant and flushing hydrant installation",
    },
    {
      NAICS22: "237110",
      "INDEX ITEM DESCRIPTION": "Irrigation project construction (except lawn)",
    },
    {
      NAICS22: "237110",
      "INDEX ITEM DESCRIPTION": "Lagoon, sewage treatment construction",
    },
    {
      NAICS22: "237110",
      "INDEX ITEM DESCRIPTION":
        "Pumping station, water and sewage system, construction",
    },
    {
      NAICS22: "237110",
      "INDEX ITEM DESCRIPTION": "Reservoir construction",
    },
    {
      NAICS22: "237110",
      "INDEX ITEM DESCRIPTION": "Sanitary sewer construction",
    },
    {
      NAICS22: "237110",
      "INDEX ITEM DESCRIPTION":
        "Sewage collection and disposal line construction",
    },
    {
      NAICS22: "237110",
      "INDEX ITEM DESCRIPTION": "Sewage disposal plant construction",
    },
    {
      NAICS22: "237110",
      "INDEX ITEM DESCRIPTION": "Sewage treatment plant construction",
    },
    {
      NAICS22: "237110",
      "INDEX ITEM DESCRIPTION": "Sewer construction",
    },
    {
      NAICS22: "237110",
      "INDEX ITEM DESCRIPTION": "Sewer main, pipe and connection, construction",
    },
    {
      NAICS22: "237110",
      "INDEX ITEM DESCRIPTION": "Storm sewer construction",
    },
    {
      NAICS22: "237110",
      "INDEX ITEM DESCRIPTION": "Utility line (i.e., sewer, water), construction",
    },
    {
      NAICS22: "237110",
      "INDEX ITEM DESCRIPTION": "Water desalination plant construction",
    },
    {
      NAICS22: "237110",
      "INDEX ITEM DESCRIPTION": "Water filtration plant construction",
    },
    {
      NAICS22: "237110",
      "INDEX ITEM DESCRIPTION": "Water main and line construction",
    },
    {
      NAICS22: "237110",
      "INDEX ITEM DESCRIPTION": "Water pumping or lift station construction",
    },
    {
      NAICS22: "237110",
      "INDEX ITEM DESCRIPTION": "Water sampling station installation",
    },
    {
      NAICS22: "237110",
      "INDEX ITEM DESCRIPTION":
        "Water system storage tank and tower construction",
    },
    {
      NAICS22: "237110",
      "INDEX ITEM DESCRIPTION": "Water treatment plant construction",
    },
    {
      NAICS22: "237110",
      "INDEX ITEM DESCRIPTION":
        "Water well drilling, digging, boring or sinking (except water intake wells in oil and gas fields)",
    },
    {
      NAICS22: "237110",
      "INDEX ITEM DESCRIPTION":
        "Water well pump and well piping system installation",
    },
    {
      NAICS22: "237120",
      "INDEX ITEM DESCRIPTION":
        "Compressor, metering and pumping station, gas and oil pipeline, construction",
    },
    {
      NAICS22: "237120",
      "INDEX ITEM DESCRIPTION": "Construction management, oil and gas pipeline",
    },
    {
      NAICS22: "237120",
      "INDEX ITEM DESCRIPTION":
        "Construction management, oil refinery and petrochemical complex",
    },
    {
      NAICS22: "237120",
      "INDEX ITEM DESCRIPTION":
        "Corrosion protection, underground pipeline and oil storage tank",
    },
    {
      NAICS22: "237120",
      "INDEX ITEM DESCRIPTION": "Distribution line, gas and oil, construction",
    },
    {
      NAICS22: "237120",
      "INDEX ITEM DESCRIPTION": "Gas main construction",
    },
    {
      NAICS22: "237120",
      "INDEX ITEM DESCRIPTION": "Gathering line, gas and oil field, construction",
    },
    {
      NAICS22: "237120",
      "INDEX ITEM DESCRIPTION": "Manhole, oil and gas, construction",
    },
    {
      NAICS22: "237120",
      "INDEX ITEM DESCRIPTION": "Natural gas pipeline construction",
    },
    {
      NAICS22: "237120",
      "INDEX ITEM DESCRIPTION": "Natural gas processing plant construction",
    },
    {
      NAICS22: "237120",
      "INDEX ITEM DESCRIPTION":
        "Oil and gas field distribution line construction",
    },
    {
      NAICS22: "237120",
      "INDEX ITEM DESCRIPTION": "Oil pipeline construction",
    },
    {
      NAICS22: "237120",
      "INDEX ITEM DESCRIPTION": "Oil refinery construction",
    },
    {
      NAICS22: "237120",
      "INDEX ITEM DESCRIPTION": "Petrochemical plant construction",
    },
    {
      NAICS22: "237120",
      "INDEX ITEM DESCRIPTION": "Petroleum refinery construction",
    },
    {
      NAICS22: "237120",
      "INDEX ITEM DESCRIPTION":
        "Pipe lining (except thermal insulating) contractors",
    },
    {
      NAICS22: "237120",
      "INDEX ITEM DESCRIPTION":
        "Pipeline construction on oil and gas field gathering lines to point of distribution on a contract basis",
    },
    {
      NAICS22: "237120",
      "INDEX ITEM DESCRIPTION": "Pipeline rehabilitation contractors",
    },
    {
      NAICS22: "237120",
      "INDEX ITEM DESCRIPTION": "Pipeline wrapping contractors",
    },
    {
      NAICS22: "237120",
      "INDEX ITEM DESCRIPTION": "Pipeline, gas and oil, construction",
    },
    {
      NAICS22: "237120",
      "INDEX ITEM DESCRIPTION":
        "Pumping station, gas and oil transmission, construction",
    },
    {
      NAICS22: "237120",
      "INDEX ITEM DESCRIPTION": "Refinery, petroleum, construction",
    },
    {
      NAICS22: "237120",
      "INDEX ITEM DESCRIPTION": "Service line, gas and oil, construction",
    },
    {
      NAICS22: "237120",
      "INDEX ITEM DESCRIPTION":
        "Storage tank, natural gas or oil, tank farm or field, construction",
    },
    {
      NAICS22: "237130",
      "INDEX ITEM DESCRIPTION":
        "Alternative energy (e.g., geothermal, ocean wave, solar, wind) structure construction",
    },
    {
      NAICS22: "237130",
      "INDEX ITEM DESCRIPTION":
        "Cable laying (e.g., fiber optic, electricity, marine, telephone, cable television), including underground",
    },
    {
      NAICS22: "237130",
      "INDEX ITEM DESCRIPTION": "Cellular phone tower construction",
    },
    {
      NAICS22: "237130",
      "INDEX ITEM DESCRIPTION": "Co-generation plant construction",
    },
    {
      NAICS22: "237130",
      "INDEX ITEM DESCRIPTION": "Communication antenna construction",
    },
    {
      NAICS22: "237130",
      "INDEX ITEM DESCRIPTION": "Communication tower construction",
    },
    {
      NAICS22: "237130",
      "INDEX ITEM DESCRIPTION":
        "Construction management, power and communication transmission line",
    },
    {
      NAICS22: "237130",
      "INDEX ITEM DESCRIPTION":
        "Electric light and power plant (except hydroelectric) construction",
    },
    {
      NAICS22: "237130",
      "INDEX ITEM DESCRIPTION":
        "Electric power transmission line and tower construction",
    },
    {
      NAICS22: "237130",
      "INDEX ITEM DESCRIPTION":
        "Electricity generating plant (except hydroelectric) construction",
    },
    {
      NAICS22: "237130",
      "INDEX ITEM DESCRIPTION":
        "Fiber optic cable transmission line construction",
    },
    {
      NAICS22: "237130",
      "INDEX ITEM DESCRIPTION": "Microwave relay tower construction",
    },
    {
      NAICS22: "237130",
      "INDEX ITEM DESCRIPTION": "Nuclear power plant construction",
    },
    {
      NAICS22: "237130",
      "INDEX ITEM DESCRIPTION": "Pole line construction",
    },
    {
      NAICS22: "237130",
      "INDEX ITEM DESCRIPTION": "Power line stringing",
    },
    {
      NAICS22: "237130",
      "INDEX ITEM DESCRIPTION": "Power plant (except hydroelectric) construction",
    },
    {
      NAICS22: "237130",
      "INDEX ITEM DESCRIPTION": "Radio transmitting tower construction",
    },
    {
      NAICS22: "237130",
      "INDEX ITEM DESCRIPTION": "Satellite receiving station construction",
    },
    {
      NAICS22: "237130",
      "INDEX ITEM DESCRIPTION": "Solar power structure construction",
    },
    {
      NAICS22: "237130",
      "INDEX ITEM DESCRIPTION":
        "Substation and switching station, power transmission line, construction",
    },
    {
      NAICS22: "237130",
      "INDEX ITEM DESCRIPTION": "Telephone line construction",
    },
    {
      NAICS22: "237130",
      "INDEX ITEM DESCRIPTION": "Telephone line stringing",
    },
    {
      NAICS22: "237130",
      "INDEX ITEM DESCRIPTION": "Television transmitting tower construction",
    },
    {
      NAICS22: "237130",
      "INDEX ITEM DESCRIPTION": "Thermal power plant construction",
    },
    {
      NAICS22: "237130",
      "INDEX ITEM DESCRIPTION":
        "Tower, power distribution and communication, construction",
    },
    {
      NAICS22: "237130",
      "INDEX ITEM DESCRIPTION":
        "Transformer station and substation, electric power, construction",
    },
    {
      NAICS22: "237130",
      "INDEX ITEM DESCRIPTION": "Transmission and distribution line construction",
    },
    {
      NAICS22: "237130",
      "INDEX ITEM DESCRIPTION":
        "Underground cable (e.g., fiber optic, electricity, telephone, cable television) laying",
    },
    {
      NAICS22: "237130",
      "INDEX ITEM DESCRIPTION":
        "Utility line (i.e., communication, electric power), construction",
    },
    {
      NAICS22: "237130",
      "INDEX ITEM DESCRIPTION": "Wind power structure construction",
    },
    {
      NAICS22: "237210",
      "INDEX ITEM DESCRIPTION": "Building lot subdividing",
    },
    {
      NAICS22: "237210",
      "INDEX ITEM DESCRIPTION": "Land (except cemeteries) subdividers",
    },
    {
      NAICS22: "237210",
      "INDEX ITEM DESCRIPTION": "Land acquisition, assembling and subdividing",
    },
    {
      NAICS22: "237210",
      "INDEX ITEM DESCRIPTION":
        "Land developers (i.e., subdividing and installing infrastructure)",
    },
    {
      NAICS22: "237210",
      "INDEX ITEM DESCRIPTION":
        "Land subdividing and utility installation (e.g., electric, sewer and water)",
    },
    {
      NAICS22: "237210",
      "INDEX ITEM DESCRIPTION": "Preparing and subdividing land for sale",
    },
    {
      NAICS22: "237210",
      "INDEX ITEM DESCRIPTION": "Real estate (except cemeteries) subdividers",
    },
    {
      NAICS22: "237210",
      "INDEX ITEM DESCRIPTION": "Real property (except cemeteries) subdivision",
    },
    {
      NAICS22: "237210",
      "INDEX ITEM DESCRIPTION": "Subdividers, real estate",
    },
    {
      NAICS22: "237210",
      "INDEX ITEM DESCRIPTION": "Subdividing and preparing land owned by others",
    },
    {
      NAICS22: "237210",
      "INDEX ITEM DESCRIPTION": "Subdividing real estate",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION": "Abutment construction",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION": "Airport runway construction",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION": "Airport runway line painting (e.g., striping)",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION":
        "Asphalt paving (i.e., highway, road, street, public sidewalk)",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION": "Bridge approach construction",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION": "Bridge construction",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION": "Bridge decking construction",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION": "Causeway construction",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION":
        "Concrete paving (i.e., highway, road, street, public sidewalk)",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION":
        "Construction management, highway, road, street and bridge",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION":
        "Culverts, highway, road and street, construction",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION":
        "Curbs and street gutters, highway, road and street, construction",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION": "Elevated highway construction",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION":
        "Grading, highway, road, street and airport runway",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION": "Guardrail construction",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION": "Highway construction",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION": "Highway line painting",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION": "Logging road construction",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION": "Oil field road construction",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION": "Overpass construction",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION": "Painting lines on highways, streets and bridges",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION": "Painting traffic lanes or parking lots",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION": "Parking lot marking and line painting",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION": "Parkway construction",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION":
        "Pavement, highway, road, street, bridge or airport runway, construction",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION":
        "Pothole filling, highway, road, street or bridge",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION":
        "Repair, highway, road, street, bridge or airport runway",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION":
        "Resurfacing, highway, road, street, bridge or airport runway",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION": "Road construction",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION": "Runway, airport, line painting (e.g., striping)",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION": "Sidewalk, public, construction",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION": "Sign erection, highway, road, street, or bridge",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION": "Street construction",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION":
        "Surfacing, highway, road, street, bridge or airport runway",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION": "Tarring roads",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION": "Traffic lane painting",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION": "Trestle construction",
    },
    {
      NAICS22: "237310",
      "INDEX ITEM DESCRIPTION": "Underpass construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Anchored earth retention contractors",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Athletic field (except stadium) construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION":
        "Avalanche, rockslide, mudslide, or roadside protection construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Breakwater construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Bridle path construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Bulkhead wall or embankment construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION":
        "Caisson (i.e., marine or pneumatic structures) construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Canal construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Channel construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Cofferdam construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Construction management, dam",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Construction management, marine structure",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Construction management, mass transit",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION":
        "Construction management, outdoor recreation facility",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Construction management, tunnel",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Cribbing (i.e., shore protection), construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Dam construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION":
        "Dike and other flood control structure construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Dock construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Drainage canal and ditch construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Drainage project construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION":
        "Dredging (e.g., canal, channel, ditch, waterway)",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Drive-in movie facility construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Earth retention system construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Earth-filled dam construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION":
        "Electricity generating plant, hydroelectric, construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Embankment construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Farm drainage tile installation",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Flood control project construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Floodway canal and ditch construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Gabion construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Golf course construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Harbor construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION":
        "Helical pier (i.e., marine or pneumatic structures) construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION":
        "Horizontal drilling (e.g., underground cable, pipeline, sewer installation)",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Hydroelectric generating facility construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Ice rink (except indoor) construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Jetty construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Land drainage contractors",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Levee construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Light rail system construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Lock and waterway construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Marine construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Microtunneling contractors",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Missile facility construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Monorail construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Nuclear waste disposal site construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Outdoor recreation facility construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION":
        "Park and recreational open space improvement construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Pier construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Pile driving, marine",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Pipe-jacking contractors",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Playground construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Port facility construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Power plant, hydroelectric, construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Railroad construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION":
        "Railway construction (e.g., interlocker, roadbed, signal, track)",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Railway roadbed construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Recreation area, open space, construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Recreational vehicle park construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION":
        "Retaining walls, anchored (e.g., with piles, soil nails, tieback anchors), construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Revetment construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Riprap installation",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Rock removal, underwater",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Seawall, wave protection, construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Sediment control system construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Ski tow construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Spillway, floodwater, construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Sports field construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Streetcar line construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Subway construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Tennis courts, outdoor, construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Timber removal, underwater",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Trail construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Trenching, underwater",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Tunnel construction",
    },
    {
      NAICS22: "237990",
      "INDEX ITEM DESCRIPTION": "Wharf construction",
    },
    {
      NAICS22: "238110",
      "INDEX ITEM DESCRIPTION": "Chimney, concrete, construction",
    },
    {
      NAICS22: "238110",
      "INDEX ITEM DESCRIPTION": "Concrete finishing",
    },
    {
      NAICS22: "238110",
      "INDEX ITEM DESCRIPTION": "Concrete floor surfacing",
    },
    {
      NAICS22: "238110",
      "INDEX ITEM DESCRIPTION": "Concrete pouring",
    },
    {
      NAICS22: "238110",
      "INDEX ITEM DESCRIPTION": "Concrete pumping (i.e., placement)",
    },
    {
      NAICS22: "238110",
      "INDEX ITEM DESCRIPTION": "Concrete repair",
    },
    {
      NAICS22: "238110",
      "INDEX ITEM DESCRIPTION": "Concrete resurfacing",
    },
    {
      NAICS22: "238110",
      "INDEX ITEM DESCRIPTION": "Footing and foundation concrete contractors",
    },
    {
      NAICS22: "238110",
      "INDEX ITEM DESCRIPTION":
        "Foundation, building, poured concrete, contractors",
    },
    {
      NAICS22: "238110",
      "INDEX ITEM DESCRIPTION": "Grouting (i.e., reinforcing with concrete)",
    },
    {
      NAICS22: "238110",
      "INDEX ITEM DESCRIPTION": "Gunite contractors",
    },
    {
      NAICS22: "238110",
      "INDEX ITEM DESCRIPTION": "Gunning shotcrete",
    },
    {
      NAICS22: "238110",
      "INDEX ITEM DESCRIPTION": "Mud-jacking contractors",
    },
    {
      NAICS22: "238110",
      "INDEX ITEM DESCRIPTION":
        "Retaining wall (except anchored earth), poured concrete, construction",
    },
    {
      NAICS22: "238110",
      "INDEX ITEM DESCRIPTION": "Shotcrete contractors",
    },
    {
      NAICS22: "238120",
      "INDEX ITEM DESCRIPTION": "Balcony, precast concrete, installation",
    },
    {
      NAICS22: "238120",
      "INDEX ITEM DESCRIPTION":
        "Concrete product (e.g., structural precast, structural prestressed) installation",
    },
    {
      NAICS22: "238120",
      "INDEX ITEM DESCRIPTION": "Concrete reinforcement placement",
    },
    {
      NAICS22: "238120",
      "INDEX ITEM DESCRIPTION": "Curtain wall, precast concrete, installation",
    },
    {
      NAICS22: "238120",
      "INDEX ITEM DESCRIPTION": "Erecting structural steel",
    },
    {
      NAICS22: "238120",
      "INDEX ITEM DESCRIPTION": "Iron work, structural, contractors",
    },
    {
      NAICS22: "238120",
      "INDEX ITEM DESCRIPTION":
        "Placing and tying reinforcing rod at a construction site",
    },
    {
      NAICS22: "238120",
      "INDEX ITEM DESCRIPTION":
        "Precast concrete panel, slab, or form installation",
    },
    {
      NAICS22: "238120",
      "INDEX ITEM DESCRIPTION":
        "Prestressed concrete beam, slab or other component installation",
    },
    {
      NAICS22: "238120",
      "INDEX ITEM DESCRIPTION": "Rebar contractors",
    },
    {
      NAICS22: "238120",
      "INDEX ITEM DESCRIPTION":
        "Reinforcing rod, bar, mesh and cage installation",
    },
    {
      NAICS22: "238120",
      "INDEX ITEM DESCRIPTION": "Reinforcing steel contractors",
    },
    {
      NAICS22: "238120",
      "INDEX ITEM DESCRIPTION": "Stairway, precast concrete, installation",
    },
    {
      NAICS22: "238120",
      "INDEX ITEM DESCRIPTION": "Steel reinforcing contractors",
    },
    {
      NAICS22: "238120",
      "INDEX ITEM DESCRIPTION":
        "Structural steel erecting or iron work contractors",
    },
    {
      NAICS22: "238130",
      "INDEX ITEM DESCRIPTION": "Building framing (except structural steel)",
    },
    {
      NAICS22: "238130",
      "INDEX ITEM DESCRIPTION": "Carpentry, framing",
    },
    {
      NAICS22: "238130",
      "INDEX ITEM DESCRIPTION": "Ceiling beam, wood, installation",
    },
    {
      NAICS22: "238130",
      "INDEX ITEM DESCRIPTION": "Foundation, building, wood, contractors",
    },
    {
      NAICS22: "238130",
      "INDEX ITEM DESCRIPTION": "Framework, house, contractors",
    },
    {
      NAICS22: "238130",
      "INDEX ITEM DESCRIPTION": "Framing contractors",
    },
    {
      NAICS22: "238130",
      "INDEX ITEM DESCRIPTION": "House framing",
    },
    {
      NAICS22: "238130",
      "INDEX ITEM DESCRIPTION": "Permanent wood foundation installation",
    },
    {
      NAICS22: "238130",
      "INDEX ITEM DESCRIPTION": "Post framing contractors",
    },
    {
      NAICS22: "238130",
      "INDEX ITEM DESCRIPTION":
        "Prefabricated wood frame component (e.g., trusses) installation",
    },
    {
      NAICS22: "238130",
      "INDEX ITEM DESCRIPTION": "Roof truss (wood) installation",
    },
    {
      NAICS22: "238130",
      "INDEX ITEM DESCRIPTION": "Sheathing, wood, installation",
    },
    {
      NAICS22: "238130",
      "INDEX ITEM DESCRIPTION": "Steel framing contractors",
    },
    {
      NAICS22: "238130",
      "INDEX ITEM DESCRIPTION": "Stud wall (e.g., wood, steel) installation",
    },
    {
      NAICS22: "238130",
      "INDEX ITEM DESCRIPTION":
        "Wall component (i.e., exterior, interior), prefabricated, installation",
    },
    {
      NAICS22: "238130",
      "INDEX ITEM DESCRIPTION":
        "Wood frame component (e.g., truss) fabrication on site",
    },
    {
      NAICS22: "238140",
      "INDEX ITEM DESCRIPTION": "Brick veneer, installation",
    },
    {
      NAICS22: "238140",
      "INDEX ITEM DESCRIPTION": "Bricklaying contractors",
    },
    {
      NAICS22: "238140",
      "INDEX ITEM DESCRIPTION": "Cement block laying",
    },
    {
      NAICS22: "238140",
      "INDEX ITEM DESCRIPTION": "Chimney, brick, block or stone, contractors",
    },
    {
      NAICS22: "238140",
      "INDEX ITEM DESCRIPTION": "Cinder block installation",
    },
    {
      NAICS22: "238140",
      "INDEX ITEM DESCRIPTION": "Concrete block laying",
    },
    {
      NAICS22: "238140",
      "INDEX ITEM DESCRIPTION": "Field stone (i.e., masonry) installation",
    },
    {
      NAICS22: "238140",
      "INDEX ITEM DESCRIPTION": "Fireplace, masonry, installation",
    },
    {
      NAICS22: "238140",
      "INDEX ITEM DESCRIPTION":
        "Foundation (e.g., brick, block, stone), building, contractors",
    },
    {
      NAICS22: "238140",
      "INDEX ITEM DESCRIPTION": "Glass block laying",
    },
    {
      NAICS22: "238140",
      "INDEX ITEM DESCRIPTION": "Glass unit (i.e., glass block) masonry",
    },
    {
      NAICS22: "238140",
      "INDEX ITEM DESCRIPTION": "Granite, exterior, contractors",
    },
    {
      NAICS22: "238140",
      "INDEX ITEM DESCRIPTION":
        "Marble, granite and slate, exterior, contractors",
    },
    {
      NAICS22: "238140",
      "INDEX ITEM DESCRIPTION": "Masonry contractors",
    },
    {
      NAICS22: "238140",
      "INDEX ITEM DESCRIPTION": "Masonry pointing, cleaning or caulking",
    },
    {
      NAICS22: "238140",
      "INDEX ITEM DESCRIPTION": "Refractory brick contractors",
    },
    {
      NAICS22: "238140",
      "INDEX ITEM DESCRIPTION":
        "Retaining wall, masonry (i.e., block, brick, stone), construction",
    },
    {
      NAICS22: "238140",
      "INDEX ITEM DESCRIPTION": "Slate (i.e., masonry) contractors",
    },
    {
      NAICS22: "238140",
      "INDEX ITEM DESCRIPTION": "Stonework (i.e., masonry) contractors",
    },
    {
      NAICS22: "238140",
      "INDEX ITEM DESCRIPTION": "Stucco contractors",
    },
    {
      NAICS22: "238140",
      "INDEX ITEM DESCRIPTION": "Tuck pointing contractors",
    },
    {
      NAICS22: "238150",
      "INDEX ITEM DESCRIPTION": "Curtain wall, glass, installation",
    },
    {
      NAICS22: "238150",
      "INDEX ITEM DESCRIPTION": "Decorative glass and mirror installation",
    },
    {
      NAICS22: "238150",
      "INDEX ITEM DESCRIPTION":
        "Glass cladding (i.e., curtain wall), installation",
    },
    {
      NAICS22: "238150",
      "INDEX ITEM DESCRIPTION":
        "Glass coating and tinting (except automotive) contractors",
    },
    {
      NAICS22: "238150",
      "INDEX ITEM DESCRIPTION":
        "Glass installation (except automotive) contractors",
    },
    {
      NAICS22: "238150",
      "INDEX ITEM DESCRIPTION": "Glass partitions, installation",
    },
    {
      NAICS22: "238150",
      "INDEX ITEM DESCRIPTION": "Glazing contractors",
    },
    {
      NAICS22: "238150",
      "INDEX ITEM DESCRIPTION":
        "Hermetically sealed window unit, commercial-type, installation",
    },
    {
      NAICS22: "238150",
      "INDEX ITEM DESCRIPTION": "Mirror installation",
    },
    {
      NAICS22: "238150",
      "INDEX ITEM DESCRIPTION": "Stained glass installation",
    },
    {
      NAICS22: "238150",
      "INDEX ITEM DESCRIPTION": "Window pane or sheet installation",
    },
    {
      NAICS22: "238160",
      "INDEX ITEM DESCRIPTION": "Asphalt roof shingle installation",
    },
    {
      NAICS22: "238160",
      "INDEX ITEM DESCRIPTION": "Copper roofing installation",
    },
    {
      NAICS22: "238160",
      "INDEX ITEM DESCRIPTION": "Corrugated metal roofing installation",
    },
    {
      NAICS22: "238160",
      "INDEX ITEM DESCRIPTION": "Galvanized iron roofing installation",
    },
    {
      NAICS22: "238160",
      "INDEX ITEM DESCRIPTION": "Low slope roofing installation",
    },
    {
      NAICS22: "238160",
      "INDEX ITEM DESCRIPTION": "Painting, spraying, or coating, roof",
    },
    {
      NAICS22: "238160",
      "INDEX ITEM DESCRIPTION": "Roll roofing installation",
    },
    {
      NAICS22: "238160",
      "INDEX ITEM DESCRIPTION": "Roof membrane installation",
    },
    {
      NAICS22: "238160",
      "INDEX ITEM DESCRIPTION": "Roof painting, spraying, or coating",
    },
    {
      NAICS22: "238160",
      "INDEX ITEM DESCRIPTION": "Roofing contractors",
    },
    {
      NAICS22: "238160",
      "INDEX ITEM DESCRIPTION": "Roofing, built-up tar and gravel, installation",
    },
    {
      NAICS22: "238160",
      "INDEX ITEM DESCRIPTION": "Shake and shingle, roof, installation",
    },
    {
      NAICS22: "238160",
      "INDEX ITEM DESCRIPTION": "Sheet metal roofing installation",
    },
    {
      NAICS22: "238160",
      "INDEX ITEM DESCRIPTION": "Skylight installation",
    },
    {
      NAICS22: "238160",
      "INDEX ITEM DESCRIPTION": "Solar reflecting coating, roof, application",
    },
    {
      NAICS22: "238160",
      "INDEX ITEM DESCRIPTION": "Steep slope roofing installation",
    },
    {
      NAICS22: "238160",
      "INDEX ITEM DESCRIPTION":
        "Treating roofs (by spraying, painting or coating)",
    },
    {
      NAICS22: "238170",
      "INDEX ITEM DESCRIPTION": "Aluminum siding installation",
    },
    {
      NAICS22: "238170",
      "INDEX ITEM DESCRIPTION":
        "Downspout, gutter, and gutter guard installation",
    },
    {
      NAICS22: "238170",
      "INDEX ITEM DESCRIPTION": "Eavestrough installation",
    },
    {
      NAICS22: "238170",
      "INDEX ITEM DESCRIPTION": "Fascia and soffit installation",
    },
    {
      NAICS22: "238170",
      "INDEX ITEM DESCRIPTION": "Flashing contractors",
    },
    {
      NAICS22: "238170",
      "INDEX ITEM DESCRIPTION": "Gutter and downspout contractors",
    },
    {
      NAICS22: "238170",
      "INDEX ITEM DESCRIPTION":
        "Gutters, seamless roof, formed and installed on site",
    },
    {
      NAICS22: "238170",
      "INDEX ITEM DESCRIPTION": "Ice apron, roof, installation",
    },
    {
      NAICS22: "238170",
      "INDEX ITEM DESCRIPTION": "Metal siding installation",
    },
    {
      NAICS22: "238170",
      "INDEX ITEM DESCRIPTION":
        "Siding (e.g., vinyl, wood, aluminum) installation",
    },
    {
      NAICS22: "238170",
      "INDEX ITEM DESCRIPTION": "Siding contractors",
    },
    {
      NAICS22: "238170",
      "INDEX ITEM DESCRIPTION": "Vinyl siding, soffit and fascia, installation",
    },
    {
      NAICS22: "238170",
      "INDEX ITEM DESCRIPTION": "Wood siding, installation",
    },
    {
      NAICS22: "238190",
      "INDEX ITEM DESCRIPTION": "Awning installation",
    },
    {
      NAICS22: "238190",
      "INDEX ITEM DESCRIPTION": "Balcony, metal, installation",
    },
    {
      NAICS22: "238190",
      "INDEX ITEM DESCRIPTION": "Cathodic protection, installation",
    },
    {
      NAICS22: "238190",
      "INDEX ITEM DESCRIPTION": "Concrete form contractors",
    },
    {
      NAICS22: "238190",
      "INDEX ITEM DESCRIPTION": "Curtain wall, metal, installation",
    },
    {
      NAICS22: "238190",
      "INDEX ITEM DESCRIPTION":
        "Deck and grate (except roof), metal, installation",
    },
    {
      NAICS22: "238190",
      "INDEX ITEM DESCRIPTION":
        "Decorative steel and wrought iron work installation",
    },
    {
      NAICS22: "238190",
      "INDEX ITEM DESCRIPTION": "Epoxy application contractors",
    },
    {
      NAICS22: "238190",
      "INDEX ITEM DESCRIPTION": "Erection and dismantling, poured concrete form",
    },
    {
      NAICS22: "238190",
      "INDEX ITEM DESCRIPTION": "Falsework construction",
    },
    {
      NAICS22: "238190",
      "INDEX ITEM DESCRIPTION": "Fire escape installation",
    },
    {
      NAICS22: "238190",
      "INDEX ITEM DESCRIPTION": "Forming contractor",
    },
    {
      NAICS22: "238190",
      "INDEX ITEM DESCRIPTION":
        "Forms for poured concrete, erecting and dismantling",
    },
    {
      NAICS22: "238190",
      "INDEX ITEM DESCRIPTION": "Metal furring contractors",
    },
    {
      NAICS22: "238190",
      "INDEX ITEM DESCRIPTION": "Ornamental metal work installation",
    },
    {
      NAICS22: "238190",
      "INDEX ITEM DESCRIPTION": "Shutter installation",
    },
    {
      NAICS22: "238190",
      "INDEX ITEM DESCRIPTION": "Stairway, metal, installation",
    },
    {
      NAICS22: "238190",
      "INDEX ITEM DESCRIPTION": "Storefront, metal or metal frame, installation",
    },
    {
      NAICS22: "238190",
      "INDEX ITEM DESCRIPTION": "Urethane slabjacking contractors",
    },
    {
      NAICS22: "238190",
      "INDEX ITEM DESCRIPTION": "Urethane soil stabilization contractors",
    },
    {
      NAICS22: "238190",
      "INDEX ITEM DESCRIPTION": "Welding, on-site, contractors",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION": "Airport runway lighting contractors",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION":
        "Alarm system (e.g., fire, burglar), electric, installation only",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION":
        "Audio equipment installation (except automotive) contractors",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION": "Audio visual equipment installation",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION":
        "Building automation system installation contractors",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION":
        "Burglar alarm system, electric, installation only",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION": "Cable splicing, electrical or fiber optic",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION": "Cable television hookup contractors",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION": "Communication equipment installation",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION": "Computer and network cable installation",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION":
        "Control system (e.g., environmental, humidity, temperature) installation",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION": "Electric contracting",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION":
        "Electric power control panel and outlet installation",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION": "Electrical contractors",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION": "Electrical equipment and appliance installation",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION": "Electrical wiring contractors",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION": "Electrical work",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION":
        "Electrical, electrical wiring, and low voltage electrical work",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION": "Electrician",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION":
        "Electronic containment fencing for pets, installation",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION": "Electronic control installation and service",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION": "Electronic control system installation",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION": "Environmental control system installation",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION":
        "Fiber optic cable (except transmission lines) installation",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION": "Fire alarm system, electric, installation only",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION":
        "Highway, street and bridge lighting and electrical signal installation",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION": "Home automation system installation",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION": "Home standby power generator installation",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION": "Home theater installation",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION": "Humidity control system installation",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION": "Installation of photovoltaic panels",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION":
        "Intercommunication (intercom) system installation",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION": "Lighting system installation",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION": "Low voltage electrical work",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION":
        "Private driveway or parking area lighting contractors",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION": "Public address system installation",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION": "Railroad signaling equipment installation",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION": "Security and fire system, installation only",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION": "Smoke detection system, installation only",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION": "Snow melting cable, electric, installation",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION": "Solar panel installation",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION": "Sound equipment installation",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION": "Surveillance system, installation only",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION":
        "Telecommunications equipment and wiring (except transmission line) installation contractors",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION":
        "Telephone equipment and building wiring installation",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION": "Telephone installation contractors",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION": "Temperature control system installation",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION": "Traffic signal installation",
    },
    {
      NAICS22: "238210",
      "INDEX ITEM DESCRIPTION": "Tunnel lighting contractors",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Air system balancing and testing",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Air vent installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION":
        "Air-conditioning system (except window) installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION":
        "Bathroom plumbing fixture and sanitary ware installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION":
        "Blower or fan, cooling and dry heating, installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Boiler chipping, cleaning and scaling",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Boiler, heating, installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Central air-conditioning equipment installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION":
        "Central cooling equipment and piping installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION":
        "Central heating equipment and piping installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Chilled water system installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Chimney liner installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Commercial freezer installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Commercial refrigeration system installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Cooling tower installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Drain, waste and vent system installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Drinking fountain installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Dry heating equipment installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION":
        "Duct work (e.g., cooling, dust collection, exhaust, heating, ventilation) installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION":
        "Dust collecting and bag house equipment installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION":
        "Exhaust system (e.g., kitchens, industrial work areas) installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Fire extinguisher installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Fire extinguisher installation and repair",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Fire sprinkler system installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Fireplace, natural gas, installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Fuel oil burner installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION":
        "Furnace conversion (i.e., from one fuel to another)",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Furnace humidifier installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Furnace installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Furnace, forced air, installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Gas fitting contractor",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION":
        "Gas line installation, individual hookup, contractors",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Heat pump installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Heating and cooling duct work installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION":
        "Heating and ventilation system component (e.g., air registers, diffusers, filters, grilles, sound attenuators) installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Heating boiler installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Heating contractors",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Heating equipment installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION":
        "Heating, ventilation and air-conditioning (HVAC) contractors",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Hot water heating system installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Hot water tank installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Household oil storage tank installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION":
        "HVAC (heating, ventilation and air-conditioning) contractors",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Hydronic heating system installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Industrial process piping installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Kitchen sink and hardware installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Lawn sprinkler system installation ",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Mechanical contractors",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Natural gas piping installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Oil burner installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Pipe fitting contractors",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Plumbers",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Plumbing and heating contractors",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Plumbing contractors",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Plumbing fixture installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Process piping installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Pumping system, water, installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Radiant floor heating equipment installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION":
        "Refrigeration system (e.g., commercial, industrial, scientific) installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Sanitary ware installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Scrubber, air purification, installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Sewer hookup and connection, building",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Sheet metal duct work installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION":
        "Snow melting system (e.g., hot water, glycol) installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Solar heating equipment installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Sprinkler system, building, installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Steam fitting contractors",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Sump pump installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Ventilating contractors",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Warehouse refrigeration system installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Warm air heating system installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Water heater installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Water meter installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Water softener installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Water system balancing and testing contractors",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION": "Waterless fire suppression system installation",
    },
    {
      NAICS22: "238220",
      "INDEX ITEM DESCRIPTION":
        "Waterless fire suppression system installation and repair",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION": "Antenna, household-type, installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION": "ATMs (automated teller machines) installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION": "Automated and revolving door installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION":
        "Automatic gate (e.g., garage, parking lot) installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION": "Boiler and pipe insulation installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION": "Boiler covering installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION": "Bowling alley equipment installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION": "Church bell and tower clock installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION":
        "Commercial kitchen food preparation equipment (e.g., mixers, ovens, stoves) installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION": "Commercial-type door installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION": "Conveyor system installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION":
        "Deodorization (i.e., air filtration) system installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION": "Dismantling large-scale machinery and equipment",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION":
        "Door, commercial- or industrial-type, installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION": "Duct insulation installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION": "Dumbwaiter installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION": "Elevator installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION": "Escalator installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION":
        "Garage door, commercial- or industrial-type, installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION": "Gasoline pump, service station, installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION": "Hoisting and placement of large-scale apparatus",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION":
        "Incinerators, building equipment type, installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION": "Insulation, boiler, duct and pipe, installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION":
        "Lightning protection equipment (e.g., lightning rod) installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION": "Lightning rod and conductor installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION": "Machine rigging",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION":
        "Machinery and equipment, large-scale, installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION": "Material handling equipment installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION": "Mechanical equipment insulation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION": "Millwrights",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION":
        "Motor vehicle garage and service station mechanical equipment (e.g., gasoline pumps, hoists) installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION": "Moving sidewalk installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION":
        "Overhead door, commercial- or industrial-type, installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION": "Pipe covering",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION": "Pipe, duct and boiler insulation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION": "Pneumatic tube conveyor system installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION": "Power boiler, installation only",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION":
        "Power generating equipment (except home standby power generator) installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION": "Revolving door installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION": "Rigging large-scale equipment",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION": "Rubber door installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION": "Satellite dish, household-type, installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION": "Vacuum cleaning system, built-in, installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION": "Vault, safe and banking machine installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION": "Vehicle lift installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION": "Vending machine installation",
    },
    {
      NAICS22: "238290",
      "INDEX ITEM DESCRIPTION": "Water pipe insulating",
    },
    {
      NAICS22: "238310",
      "INDEX ITEM DESCRIPTION": "Acoustical ceiling tile and panel installation",
    },
    {
      NAICS22: "238310",
      "INDEX ITEM DESCRIPTION":
        "Acoustical foam (i.e., sound barrier) installation",
    },
    {
      NAICS22: "238310",
      "INDEX ITEM DESCRIPTION": "Attic space insulating",
    },
    {
      NAICS22: "238310",
      "INDEX ITEM DESCRIPTION":
        "Blown-in insulation (e.g., cellulose, vermiculite) installation",
    },
    {
      NAICS22: "238310",
      "INDEX ITEM DESCRIPTION": "Building fireproofing contractors",
    },
    {
      NAICS22: "238310",
      "INDEX ITEM DESCRIPTION": "Building insulation contractors",
    },
    {
      NAICS22: "238310",
      "INDEX ITEM DESCRIPTION": "Ceiling tile installation",
    },
    {
      NAICS22: "238310",
      "INDEX ITEM DESCRIPTION": "Cellulosic fiber insulation installation",
    },
    {
      NAICS22: "238310",
      "INDEX ITEM DESCRIPTION": "Drop ceiling installation",
    },
    {
      NAICS22: "238310",
      "INDEX ITEM DESCRIPTION": "Drywall contractors",
    },
    {
      NAICS22: "238310",
      "INDEX ITEM DESCRIPTION":
        "Drywall finishing (e.g., sanding, spackling, stippling, taping, texturing)",
    },
    {
      NAICS22: "238310",
      "INDEX ITEM DESCRIPTION": "Drywall hanging",
    },
    {
      NAICS22: "238310",
      "INDEX ITEM DESCRIPTION": "Drywall installation",
    },
    {
      NAICS22: "238310",
      "INDEX ITEM DESCRIPTION": "Exterior insulation finish system installation",
    },
    {
      NAICS22: "238310",
      "INDEX ITEM DESCRIPTION":
        "Fabric wall system, noise insulating, installation",
    },
    {
      NAICS22: "238310",
      "INDEX ITEM DESCRIPTION": "Finishing drywall contractors",
    },
    {
      NAICS22: "238310",
      "INDEX ITEM DESCRIPTION": "Fireproof flooring installation",
    },
    {
      NAICS22: "238310",
      "INDEX ITEM DESCRIPTION": "Fireproofing buildings",
    },
    {
      NAICS22: "238310",
      "INDEX ITEM DESCRIPTION": "Firestop contractors ",
    },
    {
      NAICS22: "238310",
      "INDEX ITEM DESCRIPTION": "Foam insulation installation",
    },
    {
      NAICS22: "238310",
      "INDEX ITEM DESCRIPTION":
        "Fresco (i.e., decorative plaster finishing) contractors",
    },
    {
      NAICS22: "238310",
      "INDEX ITEM DESCRIPTION": "Glass fiber insulation installation",
    },
    {
      NAICS22: "238310",
      "INDEX ITEM DESCRIPTION": "Gypsum board installation",
    },
    {
      NAICS22: "238310",
      "INDEX ITEM DESCRIPTION": "Insulation contractors",
    },
    {
      NAICS22: "238310",
      "INDEX ITEM DESCRIPTION": "Lathing contractors",
    },
    {
      NAICS22: "238310",
      "INDEX ITEM DESCRIPTION": "Mineral wool insulation installation",
    },
    {
      NAICS22: "238310",
      "INDEX ITEM DESCRIPTION": "Panel or rigid board insulation installation",
    },
    {
      NAICS22: "238310",
      "INDEX ITEM DESCRIPTION":
        "Plastering (i.e., ornamental, plain) contractors",
    },
    {
      NAICS22: "238310",
      "INDEX ITEM DESCRIPTION": "Polystyrene board insulation installation",
    },
    {
      NAICS22: "238310",
      "INDEX ITEM DESCRIPTION": "Roof insulation contractor",
    },
    {
      NAICS22: "238310",
      "INDEX ITEM DESCRIPTION": "Soundproofing contractors",
    },
    {
      NAICS22: "238310",
      "INDEX ITEM DESCRIPTION": "Styrofoam insulation installation",
    },
    {
      NAICS22: "238310",
      "INDEX ITEM DESCRIPTION": "Suspended ceiling installation",
    },
    {
      NAICS22: "238310",
      "INDEX ITEM DESCRIPTION": "Taping and finishing drywall",
    },
    {
      NAICS22: "238310",
      "INDEX ITEM DESCRIPTION": "Urethane foam insulation application",
    },
    {
      NAICS22: "238310",
      "INDEX ITEM DESCRIPTION":
        "Wall cavity and attic space insulation installation",
    },
    {
      NAICS22: "238320",
      "INDEX ITEM DESCRIPTION": "Bridge painting",
    },
    {
      NAICS22: "238320",
      "INDEX ITEM DESCRIPTION": "Electrostatic painting, on-site, contractors",
    },
    {
      NAICS22: "238320",
      "INDEX ITEM DESCRIPTION":
        "Engineering structure (e.g., oil storage tank, water tower) painting",
    },
    {
      NAICS22: "238320",
      "INDEX ITEM DESCRIPTION": "House painting",
    },
    {
      NAICS22: "238320",
      "INDEX ITEM DESCRIPTION": "Paint and wallpaper stripping",
    },
    {
      NAICS22: "238320",
      "INDEX ITEM DESCRIPTION": "Painting (except roof) contractors",
    },
    {
      NAICS22: "238320",
      "INDEX ITEM DESCRIPTION": "Painting and wallpapering",
    },
    {
      NAICS22: "238320",
      "INDEX ITEM DESCRIPTION": "Paperhanging and removal contractors",
    },
    {
      NAICS22: "238320",
      "INDEX ITEM DESCRIPTION": "Paperhanging or removal contractors",
    },
    {
      NAICS22: "238320",
      "INDEX ITEM DESCRIPTION": "Rustproofing (except automotive)",
    },
    {
      NAICS22: "238320",
      "INDEX ITEM DESCRIPTION": "Ship painting contractors",
    },
    {
      NAICS22: "238320",
      "INDEX ITEM DESCRIPTION": "Wall covering or removal contractors",
    },
    {
      NAICS22: "238320",
      "INDEX ITEM DESCRIPTION": "Wallpaper hanging and removal contractors",
    },
    {
      NAICS22: "238320",
      "INDEX ITEM DESCRIPTION": "Wallpaper stripping",
    },
    {
      NAICS22: "238320",
      "INDEX ITEM DESCRIPTION": "Whitewashing contractors",
    },
    {
      NAICS22: "238330",
      "INDEX ITEM DESCRIPTION": "Access flooring installation",
    },
    {
      NAICS22: "238330",
      "INDEX ITEM DESCRIPTION": "Asphalt flooring, installation only",
    },
    {
      NAICS22: "238330",
      "INDEX ITEM DESCRIPTION": "Carpet, installation only",
    },
    {
      NAICS22: "238330",
      "INDEX ITEM DESCRIPTION": "Computer flooring installation",
    },
    {
      NAICS22: "238330",
      "INDEX ITEM DESCRIPTION":
        "Floor laying, scraping, finishing and refinishing",
    },
    {
      NAICS22: "238330",
      "INDEX ITEM DESCRIPTION": "Floor tile and sheets, installation only",
    },
    {
      NAICS22: "238330",
      "INDEX ITEM DESCRIPTION": "Hardwood flooring, installation only",
    },
    {
      NAICS22: "238330",
      "INDEX ITEM DESCRIPTION": "Linoleum, installation only",
    },
    {
      NAICS22: "238330",
      "INDEX ITEM DESCRIPTION": "Parquet flooring installation",
    },
    {
      NAICS22: "238330",
      "INDEX ITEM DESCRIPTION":
        "Resilient floor tile or sheet (e.g., linoleum, rubber, vinyl), installation only",
    },
    {
      NAICS22: "238330",
      "INDEX ITEM DESCRIPTION": "Resurfacing hardwood flooring",
    },
    {
      NAICS22: "238330",
      "INDEX ITEM DESCRIPTION": "Vinyl flooring contractors",
    },
    {
      NAICS22: "238330",
      "INDEX ITEM DESCRIPTION": "Wood floor finishing (e.g., coating, sanding)",
    },
    {
      NAICS22: "238330",
      "INDEX ITEM DESCRIPTION": "Wood flooring, installation only",
    },
    {
      NAICS22: "238340",
      "INDEX ITEM DESCRIPTION": "Ceramic tile installation",
    },
    {
      NAICS22: "238340",
      "INDEX ITEM DESCRIPTION":
        "Countertop (ceramic tile, stone), residential-type, installation",
    },
    {
      NAICS22: "238340",
      "INDEX ITEM DESCRIPTION": "Granite, interior, installation",
    },
    {
      NAICS22: "238340",
      "INDEX ITEM DESCRIPTION": "Mantel, marble or stone, installation",
    },
    {
      NAICS22: "238340",
      "INDEX ITEM DESCRIPTION":
        "Marble, granite, and slate, interior installation contractors",
    },
    {
      NAICS22: "238340",
      "INDEX ITEM DESCRIPTION": "Mosaic work",
    },
    {
      NAICS22: "238340",
      "INDEX ITEM DESCRIPTION": "Slate, interior, installation",
    },
    {
      NAICS22: "238340",
      "INDEX ITEM DESCRIPTION": "Stone flooring installation",
    },
    {
      NAICS22: "238340",
      "INDEX ITEM DESCRIPTION": "Terrazzo and tile refinishing",
    },
    {
      NAICS22: "238340",
      "INDEX ITEM DESCRIPTION": "Terrazzo contractors",
    },
    {
      NAICS22: "238340",
      "INDEX ITEM DESCRIPTION": "Tile (except resilient) contractors",
    },
    {
      NAICS22: "238340",
      "INDEX ITEM DESCRIPTION": "Tile (except resilient) laying and setting",
    },
    {
      NAICS22: "238350",
      "INDEX ITEM DESCRIPTION":
        "Aluminum door and window, residential-type, installation",
    },
    {
      NAICS22: "238350",
      "INDEX ITEM DESCRIPTION": "Built-in wood cabinets constructed on site",
    },
    {
      NAICS22: "238350",
      "INDEX ITEM DESCRIPTION": "Cabinet work performed at the construction site",
    },
    {
      NAICS22: "238350",
      "INDEX ITEM DESCRIPTION":
        "Cabinetry work performed at the construction site",
    },
    {
      NAICS22: "238350",
      "INDEX ITEM DESCRIPTION": "Cabinets, wood built-in, constructed on site",
    },
    {
      NAICS22: "238350",
      "INDEX ITEM DESCRIPTION": "Carpenters (except framing)",
    },
    {
      NAICS22: "238350",
      "INDEX ITEM DESCRIPTION": "Carpentry work (except framing)",
    },
    {
      NAICS22: "238350",
      "INDEX ITEM DESCRIPTION":
        "Countertop (except ceramic tile or stone), residential-type, installation",
    },
    {
      NAICS22: "238350",
      "INDEX ITEM DESCRIPTION": "Deck construction, residential-type",
    },
    {
      NAICS22: "238350",
      "INDEX ITEM DESCRIPTION": "Door and window frame construction",
    },
    {
      NAICS22: "238350",
      "INDEX ITEM DESCRIPTION": "Door and window, prefabricated, installation",
    },
    {
      NAICS22: "238350",
      "INDEX ITEM DESCRIPTION": "Door, folding, installation",
    },
    {
      NAICS22: "238350",
      "INDEX ITEM DESCRIPTION": "Finish carpentry",
    },
    {
      NAICS22: "238350",
      "INDEX ITEM DESCRIPTION": "Garage door, residential-type, installation",
    },
    {
      NAICS22: "238350",
      "INDEX ITEM DESCRIPTION":
        "Hermetically sealed window unit, residential-type, installation",
    },
    {
      NAICS22: "238350",
      "INDEX ITEM DESCRIPTION":
        "Kitchen cabinets and counters, constructed on site",
    },
    {
      NAICS22: "238350",
      "INDEX ITEM DESCRIPTION": "Millwork installation",
    },
    {
      NAICS22: "238350",
      "INDEX ITEM DESCRIPTION": "Molding or trim, wood or plastic, installation",
    },
    {
      NAICS22: "238350",
      "INDEX ITEM DESCRIPTION": "Overhead door, residential-type, installation",
    },
    {
      NAICS22: "238350",
      "INDEX ITEM DESCRIPTION": "Paneling installation",
    },
    {
      NAICS22: "238350",
      "INDEX ITEM DESCRIPTION":
        "Prefabricated kitchen and bath cabinet, residential-type, installation",
    },
    {
      NAICS22: "238350",
      "INDEX ITEM DESCRIPTION": "Prefabricated sash and door installation",
    },
    {
      NAICS22: "238350",
      "INDEX ITEM DESCRIPTION": "Shelving, wood, constructed on site",
    },
    {
      NAICS22: "238350",
      "INDEX ITEM DESCRIPTION": "Ship joinery contractors",
    },
    {
      NAICS22: "238350",
      "INDEX ITEM DESCRIPTION": "Stairway, wood, installation",
    },
    {
      NAICS22: "238350",
      "INDEX ITEM DESCRIPTION": "Trim and finish carpentry contractors",
    },
    {
      NAICS22: "238350",
      "INDEX ITEM DESCRIPTION":
        "Window and door (residential-type) of any material, prefabricated, installation",
    },
    {
      NAICS22: "238350",
      "INDEX ITEM DESCRIPTION": "Window installation",
    },
    {
      NAICS22: "238350",
      "INDEX ITEM DESCRIPTION":
        "Window, metal frame residential-type, installation",
    },
    {
      NAICS22: "238350",
      "INDEX ITEM DESCRIPTION": "Window, wood, installation",
    },
    {
      NAICS22: "238390",
      "INDEX ITEM DESCRIPTION": "Bathtub refinishing, on-site",
    },
    {
      NAICS22: "238390",
      "INDEX ITEM DESCRIPTION": "Bleacher installation",
    },
    {
      NAICS22: "238390",
      "INDEX ITEM DESCRIPTION":
        "Building fixture and fitting (except mechanical equipment) installation",
    },
    {
      NAICS22: "238390",
      "INDEX ITEM DESCRIPTION": "Caulking (i.e., waterproofing) contractors",
    },
    {
      NAICS22: "238390",
      "INDEX ITEM DESCRIPTION": "Ceiling, metal, installation",
    },
    {
      NAICS22: "238390",
      "INDEX ITEM DESCRIPTION": "Closet organizer system installation",
    },
    {
      NAICS22: "238390",
      "INDEX ITEM DESCRIPTION": "Coating concrete structures with plastics",
    },
    {
      NAICS22: "238390",
      "INDEX ITEM DESCRIPTION": "Concrete coating, glazing or sealing",
    },
    {
      NAICS22: "238390",
      "INDEX ITEM DESCRIPTION":
        "Countertop and cabinet, metal (except residential-type), installation",
    },
    {
      NAICS22: "238390",
      "INDEX ITEM DESCRIPTION": "Dampproofing contractors",
    },
    {
      NAICS22: "238390",
      "INDEX ITEM DESCRIPTION":
        "Drapery fixture (e.g., hardware, rods, tracks) installation",
    },
    {
      NAICS22: "238390",
      "INDEX ITEM DESCRIPTION":
        "Fabrication, metal cabinet or countertop, on site",
    },
    {
      NAICS22: "238390",
      "INDEX ITEM DESCRIPTION":
        "Foundation dampproofing (including installing rigid foam insulation)",
    },
    {
      NAICS22: "238390",
      "INDEX ITEM DESCRIPTION": "Laboratory furniture and equipment installation",
    },
    {
      NAICS22: "238390",
      "INDEX ITEM DESCRIPTION": "Lead lining walls for X-ray room contractors",
    },
    {
      NAICS22: "238390",
      "INDEX ITEM DESCRIPTION":
        "Modular furniture system attachment and installation",
    },
    {
      NAICS22: "238390",
      "INDEX ITEM DESCRIPTION":
        "Museum exhibit installation and dismantling contractors",
    },
    {
      NAICS22: "238390",
      "INDEX ITEM DESCRIPTION": "Office furniture, modular system, installation",
    },
    {
      NAICS22: "238390",
      "INDEX ITEM DESCRIPTION": "Panel, metal, installation",
    },
    {
      NAICS22: "238390",
      "INDEX ITEM DESCRIPTION":
        "Partition (e.g., office, washroom), metal, installation",
    },
    {
      NAICS22: "238390",
      "INDEX ITEM DESCRIPTION":
        "Partition, moveable and/or demountable, installation",
    },
    {
      NAICS22: "238390",
      "INDEX ITEM DESCRIPTION": "Shelving, metal, constructed on site",
    },
    {
      NAICS22: "238390",
      "INDEX ITEM DESCRIPTION": "Spectator seating installation",
    },
    {
      NAICS22: "238390",
      "INDEX ITEM DESCRIPTION":
        "Trade show exhibit installation and dismantling contractors",
    },
    {
      NAICS22: "238390",
      "INDEX ITEM DESCRIPTION":
        "Ventilated wire shelving (i.e., closet organizing-type) installation",
    },
    {
      NAICS22: "238390",
      "INDEX ITEM DESCRIPTION": "Vibration isolation contractors",
    },
    {
      NAICS22: "238390",
      "INDEX ITEM DESCRIPTION": "Waterproofing contractors",
    },
    {
      NAICS22: "238390",
      "INDEX ITEM DESCRIPTION": "Weatherproofing concrete",
    },
    {
      NAICS22: "238390",
      "INDEX ITEM DESCRIPTION": "Weatherstripping installation",
    },
    {
      NAICS22: "238390",
      "INDEX ITEM DESCRIPTION": "Window shade and blind installation",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION":
        "Aerial or picker truck, construction, rental with operator",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Backfilling, construction",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Backhoe rental with operator",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Blast hole drilling (except mining)",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Blasting, building demolition",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Blasting, construction site",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Boring, for building construction",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Building demolition",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Building interior gutting and stripping",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Bulldozer rental with operator",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION":
        "Caisson (i.e., drilled building foundations) construction",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Cesspool construction",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Concrete breaking and cutting for demolition",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION":
        "Construction equipment (except crane) rental with operator",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Core drilling and test boring for construction",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Crawler tractor rental with operator",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Culvert or bridge removal",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Cutting new rights of way",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Demolition contractor",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Demolition, building and structure",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Dewatering contractors",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Digging foundations",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Dirt moving for construction",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION":
        "Dismantling engineering structures (e.g., oil storage tank)",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION":
        "Drainage system (e.g., cesspool, septic tank) installation",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION":
        "Drilled pier (i.e., for building foundations) contractors",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION":
        "Drilled shaft (i.e., drilled building foundations) construction",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Dry well construction",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION":
        "Equipment rental (except crane), construction, with operator",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION":
        "Excavating, earthmoving or land clearing, mining (except overburden removal at open pit mine sites or quarries)",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION":
        "Excavating, earthmoving, or land clearing contractors",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Excavation contractors",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Exterior demolition contractors",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Foundation digging (i.e., excavation)",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Foundation drilling contractors",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Grading construction sites",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Grave excavation contractors",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Ground thawing for construction site digging",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION":
        "Helical pier (i.e., drilled building foundations) construction",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "House demolishing",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "House razing",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION":
        "Hydrodemolition (i.e., demolition with pressurized water) contractors",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Interior demolition contractors",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Land clearing",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Land leveling contractors",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Line slashing or cutting (except maintenance)",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION":
        "Machinery, construction (except cranes), rental with operator",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION":
        "Mine site preparation and related construction activities, construction contractors",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Pile driving, building foundation",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION":
        "Piling (i.e., bored, cast-in-place, drilled), building foundation, contractors",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION":
        "Power shovel, construction, rental with operator",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION":
        "Power, communication and pipe line right of way clearance (except maintenance)",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION":
        "Removal of dams, dikes, and other heavy and civil engineering constructions",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Right of way cutting (except maintenance)",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Road decommissioning",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Septic system contractors",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Septic tank and weeping tile installation",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Soil compacting",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Soil test drilling",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Test boring for construction",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Trenching (except underwater)",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION":
        "Underground tank (except hazardous material) removal",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Weeping tile installation",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Whole building deconstruction",
    },
    {
      NAICS22: "238910",
      "INDEX ITEM DESCRIPTION": "Wrecking, building or other structure",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION": "Artificial turf installation",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION":
        "Asphalt coating and sealing, residential and commercial parking lot and driveway",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION":
        "Asphalting, residential and commercial driveway and parking area",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION": "Billboard erection",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION":
        "Blacktop work, residential and commercial driveway and parking area",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION": "Boat lift installation",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION": "Brick driveway contractors",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION":
        "Brick paver (e.g., driveways, patios, sidewalks) installation",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION":
        "Cable splicing (except electrical or fiber optic)",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION": "Chain link fence installation",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION": "Concrete patio construction",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION":
        "Concrete paving, residential and commercial driveway and parking area",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION":
        "Concrete sawing and drilling (except demolition)",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION":
        "Construction elevator (i.e., temporary use during construction) erection and dismantling",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION": "Crane rental with operator",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION":
        "Culvert, concrete, residential and commercial paved area",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION":
        "Curb and gutter construction, residential and commercial driveway and parking area, concrete",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION": "Driveway paving or sealing",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION":
        "Fence installation (except electronic containment fencing for pets)",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION":
        "Fencing contractors (except electronic containment fencing for pets)",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION": "Flagpole installation",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION":
        "House moving (i.e., raising from one site, moving, and placing on a new foundation)",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION": "Interlocking brick and block installation",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION":
        "Mail box units, outdoor, multiple box-type, erection",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION":
        "Manufactured (mobile) home set up and tie-down work",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION": "Parking lot paving and sealing",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION": "Patio construction",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION":
        "Paver, brick (e.g., driveway, patio, sidewalk), installation",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION":
        "Paving, residential and commercial driveway and parking lot",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION": "Playground equipment installation",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION": "Pole (e.g., telephone) removal",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION": "Posthole digging",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION": "Radon gas alleviation contractors",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION":
        "Safety net system, erecting and dismantling at construction site",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION": "Sandblasting, building exterior",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION": "Scaffold erecting and dismantling",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION": "Shoring, construction",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION":
        "Sidewalk construction, residential and commercial",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION":
        "Sign (except on highways, streets, bridges and tunnels) erection",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION": "Sign, building, erection",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION": "Statue erection",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION": "Steeplejack work",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION":
        "Street, interlocking brick (i.e., not mortared), installation",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION": "Swimming pool screen enclosure construction",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION": "Swimming pool, outdoor, construction",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION": "Tank lining contractors",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION": "Turf, artificial, installation",
    },
    {
      NAICS22: "238990",
      "INDEX ITEM DESCRIPTION": "Underpinning, construction",
    },
    {
      NAICS22: "311111",
      "INDEX ITEM DESCRIPTION": "Animal feed mills, dog and cat, manufacturing",
    },
    {
      NAICS22: "311111",
      "INDEX ITEM DESCRIPTION":
        "Animal feeds, prepared, dog and cat, manufacturing",
    },
    {
      NAICS22: "311111",
      "INDEX ITEM DESCRIPTION": "Cat food manufacturing",
    },
    {
      NAICS22: "311111",
      "INDEX ITEM DESCRIPTION":
        "Dog and cat food (e.g., canned, dry, frozen, semimoist), manufacturing",
    },
    {
      NAICS22: "311111",
      "INDEX ITEM DESCRIPTION": "Dog food manufacturing",
    },
    {
      NAICS22: "311111",
      "INDEX ITEM DESCRIPTION": "Feed supplements, dog and cat, manufacturing",
    },
    {
      NAICS22: "311111",
      "INDEX ITEM DESCRIPTION": "Feeds, prepared for dog and cat, manufacturing",
    },
    {
      NAICS22: "311111",
      "INDEX ITEM DESCRIPTION": "Horsemeat, processing, for dog and cat food",
    },
    {
      NAICS22: "311111",
      "INDEX ITEM DESCRIPTION":
        "Meat canning, dog and cat, pet food, made from purchased carcasses",
    },
    {
      NAICS22: "311111",
      "INDEX ITEM DESCRIPTION":
        "Meat products, dog and cat, pet food, canning, made from purchased carcasses",
    },
    {
      NAICS22: "311111",
      "INDEX ITEM DESCRIPTION": "Pet food, dog and cat, manufacturing",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION": "Alfalfa meal, dehydrated, manufacturing",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION": "Alfalfa prepared as feed for animals",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION": "Alfalfa, cubed, manufacturing",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION":
        "Animal feed mills (except dog and cat) manufacturing",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION":
        "Animal feeds, prepared (except dog and cat), manufacturing",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION":
        "Barley feed, chopped, crushed or ground, manufacturing",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION": "Bird feed, prepared, manufacturing",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION": "Blending animal feed",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION":
        "Bone meal prepared as feed for animals and fowls",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION":
        "Cattle feeds, supplements, concentrates, and premixes, manufacturing",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION": "Chicken feeds, prepared, manufacturing",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION": "Citrus pulp, cattle feed, manufacturing",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION": "Complete feed, livestock, manufacturing",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION": "Custom milling of animal feed",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION":
        "Dairy cattle feeds, supplements, concentrates, and premixes, manufacturing",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION": "Earthworm food and bedding manufacturing",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION": "Feed concentrates, animal, manufacturing",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION": "Feed premixes, animal, manufacturing",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION":
        "Feed supplements, animal (except cat, dog), manufacturing",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION":
        "Feeds, prepared, for animals (except cat, dog) manufacturing",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION":
        "Feeds, specialty (e.g., guinea pig, mice, mink), manufacturing",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION": "Fish food for feeding fish manufacturing",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION": "Grain grinding, custom, for animal feed",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION": "Grain mills, animal feed",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION": "Hay, cubed, manufacturing",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION":
        "Kelp meal and pellets, animal feed manufacturing",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION": "Laboratory animal feed manufacturing",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION":
        "Livestock feeds, supplements, concentrates and premixes, manufacturing",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION": "Meal, alfalfa, manufacturing",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION":
        "Meal, bone, prepared as feed for animals and fowls, manufacturing",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION":
        "Micro and macro premixes, livestock, manufacturing",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION":
        "Mineral feed supplements (except cat, dog) manufacturing",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION":
        "Mineral supplements, animal (except cat, dog), manufacturing",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION": "Mobile feed mill",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION": "Pet food (except cat, dog) manufacturing",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION":
        "Poultry feeds, supplements, and concentrates manufacturing",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION": "Rabbit food manufacturing",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION": "Shell crushing and grinding for animal feed",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION": "Shell crushing for feed",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION": "Swine feed, complete, manufacturing",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION":
        "Swine feed, supplements, concentrates, and premixes, manufacturing",
    },
    {
      NAICS22: "311119",
      "INDEX ITEM DESCRIPTION": "Turkey feeds, prepared, manufacturing",
    },
    {
      NAICS22: "311211",
      "INDEX ITEM DESCRIPTION": "Barley flour manufacturing",
    },
    {
      NAICS22: "311211",
      "INDEX ITEM DESCRIPTION": "Batters, prepared, made in flour mills",
    },
    {
      NAICS22: "311211",
      "INDEX ITEM DESCRIPTION": "Blended flour made in flour mills",
    },
    {
      NAICS22: "311211",
      "INDEX ITEM DESCRIPTION":
        "Brewers' and distillers' flakes and grits, corn, manufacturing",
    },
    {
      NAICS22: "311211",
      "INDEX ITEM DESCRIPTION": "Buckwheat flour manufacturing",
    },
    {
      NAICS22: "311211",
      "INDEX ITEM DESCRIPTION": "Bulgur (flour) manufacturing",
    },
    {
      NAICS22: "311211",
      "INDEX ITEM DESCRIPTION": "Cereal grain flour manufacturing",
    },
    {
      NAICS22: "311211",
      "INDEX ITEM DESCRIPTION": "Cereal grain germ manufacturing",
    },
    {
      NAICS22: "311211",
      "INDEX ITEM DESCRIPTION": "Corn flour manufacturing",
    },
    {
      NAICS22: "311211",
      "INDEX ITEM DESCRIPTION": "Corn meal made in flour mills",
    },
    {
      NAICS22: "311211",
      "INDEX ITEM DESCRIPTION": "Doughs, prepared, made in flour mills",
    },
    {
      NAICS22: "311211",
      "INDEX ITEM DESCRIPTION": "Durum flour manufacturing",
    },
    {
      NAICS22: "311211",
      "INDEX ITEM DESCRIPTION":
        "Farina (except breakfast food) made in flour mills",
    },
    {
      NAICS22: "311211",
      "INDEX ITEM DESCRIPTION":
        "Flour mills, cereals grains (except breakfast cereals, rice)",
    },
    {
      NAICS22: "311211",
      "INDEX ITEM DESCRIPTION": "Flour mixes made in flour mills",
    },
    {
      NAICS22: "311211",
      "INDEX ITEM DESCRIPTION":
        "Flour, blended, prepared, or self-rising (except rice), made in flour mills",
    },
    {
      NAICS22: "311211",
      "INDEX ITEM DESCRIPTION": "Fruit flour, meal, and powders, manufacturing",
    },
    {
      NAICS22: "311211",
      "INDEX ITEM DESCRIPTION": "Graham flour manufacturing",
    },
    {
      NAICS22: "311211",
      "INDEX ITEM DESCRIPTION":
        "Grain mills (except animal feed, breakfast cereal, rice)",
    },
    {
      NAICS22: "311211",
      "INDEX ITEM DESCRIPTION": "Grits and flakes, corn brewer's, manufacturing",
    },
    {
      NAICS22: "311211",
      "INDEX ITEM DESCRIPTION":
        "Hominy grits (except breakfast food), manufacturing",
    },
    {
      NAICS22: "311211",
      "INDEX ITEM DESCRIPTION":
        "Meal, corn, for human consumption made in flour mills",
    },
    {
      NAICS22: "311211",
      "INDEX ITEM DESCRIPTION":
        "Mixes, flour (e.g., biscuit, cake, doughnut, pancake) made in flour mills",
    },
    {
      NAICS22: "311211",
      "INDEX ITEM DESCRIPTION": "Oat flour manufacturing",
    },
    {
      NAICS22: "311211",
      "INDEX ITEM DESCRIPTION": "Potato flour manufacturing",
    },
    {
      NAICS22: "311211",
      "INDEX ITEM DESCRIPTION": "Prepared flour mixes made in flour mills",
    },
    {
      NAICS22: "311211",
      "INDEX ITEM DESCRIPTION": "Rye flour manufacturing",
    },
    {
      NAICS22: "311211",
      "INDEX ITEM DESCRIPTION": "Semolina flour manufacturing",
    },
    {
      NAICS22: "311211",
      "INDEX ITEM DESCRIPTION": "Sorghum flour manufacturing",
    },
    {
      NAICS22: "311211",
      "INDEX ITEM DESCRIPTION": "Vegetable flour manufacturing",
    },
    {
      NAICS22: "311211",
      "INDEX ITEM DESCRIPTION":
        "Vegetable flour, meal, and powders, made in flour mills",
    },
    {
      NAICS22: "311211",
      "INDEX ITEM DESCRIPTION": "Wheat bran manufacturing",
    },
    {
      NAICS22: "311211",
      "INDEX ITEM DESCRIPTION": "Wheat flour manufacturing",
    },
    {
      NAICS22: "311211",
      "INDEX ITEM DESCRIPTION": "Wheat germ manufacturing",
    },
    {
      NAICS22: "311212",
      "INDEX ITEM DESCRIPTION": "Bran and other residues of milling rice",
    },
    {
      NAICS22: "311212",
      "INDEX ITEM DESCRIPTION": "Brewers' rice manufacturing",
    },
    {
      NAICS22: "311212",
      "INDEX ITEM DESCRIPTION": "Cleaning and polishing rice",
    },
    {
      NAICS22: "311212",
      "INDEX ITEM DESCRIPTION": "Flour, rice, manufacturing",
    },
    {
      NAICS22: "311212",
      "INDEX ITEM DESCRIPTION": "Grain mills, rice",
    },
    {
      NAICS22: "311212",
      "INDEX ITEM DESCRIPTION": "Head rice manufacturing",
    },
    {
      NAICS22: "311212",
      "INDEX ITEM DESCRIPTION": "Milling rice",
    },
    {
      NAICS22: "311212",
      "INDEX ITEM DESCRIPTION": "Polished rice manufacturing",
    },
    {
      NAICS22: "311212",
      "INDEX ITEM DESCRIPTION": "Rice bran, flour, and meals, manufacturing",
    },
    {
      NAICS22: "311212",
      "INDEX ITEM DESCRIPTION": "Rice cleaning and polishing",
    },
    {
      NAICS22: "311212",
      "INDEX ITEM DESCRIPTION": "Rice flour manufacturing",
    },
    {
      NAICS22: "311212",
      "INDEX ITEM DESCRIPTION": "Rice meal manufacturing",
    },
    {
      NAICS22: "311212",
      "INDEX ITEM DESCRIPTION": "Rice milling",
    },
    {
      NAICS22: "311212",
      "INDEX ITEM DESCRIPTION":
        "Rice mixes (i.e., uncooked and packaged with other ingredients) made in rice mills",
    },
    {
      NAICS22: "311212",
      "INDEX ITEM DESCRIPTION": "Rice, brewer's, manufacturing",
    },
    {
      NAICS22: "311212",
      "INDEX ITEM DESCRIPTION": "Rice, brown, manufacturing",
    },
    {
      NAICS22: "311213",
      "INDEX ITEM DESCRIPTION": "Barley, malt, manufacturing",
    },
    {
      NAICS22: "311213",
      "INDEX ITEM DESCRIPTION": "Brewers' malt manufacturing",
    },
    {
      NAICS22: "311213",
      "INDEX ITEM DESCRIPTION": "Corn, malt, manufacturing",
    },
    {
      NAICS22: "311213",
      "INDEX ITEM DESCRIPTION": "Distiller's malt manufacturing",
    },
    {
      NAICS22: "311213",
      "INDEX ITEM DESCRIPTION": "Flour, malt, manufacturing",
    },
    {
      NAICS22: "311213",
      "INDEX ITEM DESCRIPTION": "Malt flour manufacturing",
    },
    {
      NAICS22: "311213",
      "INDEX ITEM DESCRIPTION": "Malt manufacturing",
    },
    {
      NAICS22: "311213",
      "INDEX ITEM DESCRIPTION": "Malt sprouts manufacturing",
    },
    {
      NAICS22: "311213",
      "INDEX ITEM DESCRIPTION": "Malting (germinating and drying grains)",
    },
    {
      NAICS22: "311213",
      "INDEX ITEM DESCRIPTION": "Rice malt manufacturing",
    },
    {
      NAICS22: "311213",
      "INDEX ITEM DESCRIPTION": "Rye malt manufacturing",
    },
    {
      NAICS22: "311213",
      "INDEX ITEM DESCRIPTION": "Wheat malt manufacturing",
    },
    {
      NAICS22: "311221",
      "INDEX ITEM DESCRIPTION": "Corn dextrin manufacturing",
    },
    {
      NAICS22: "311221",
      "INDEX ITEM DESCRIPTION": "Corn gluten feed manufacturing",
    },
    {
      NAICS22: "311221",
      "INDEX ITEM DESCRIPTION": "Corn gluten meal manufacturing",
    },
    {
      NAICS22: "311221",
      "INDEX ITEM DESCRIPTION": "Corn oil cake and meal manufacturing",
    },
    {
      NAICS22: "311221",
      "INDEX ITEM DESCRIPTION": "Corn oil mills",
    },
    {
      NAICS22: "311221",
      "INDEX ITEM DESCRIPTION":
        "Corn oil, crude and refined, made by wet milling corn",
    },
    {
      NAICS22: "311221",
      "INDEX ITEM DESCRIPTION": "Corn starch manufacturing",
    },
    {
      NAICS22: "311221",
      "INDEX ITEM DESCRIPTION":
        "Corn sweeteners (e.g., dextrose, fructose, glucose) made by wet milling corn",
    },
    {
      NAICS22: "311221",
      "INDEX ITEM DESCRIPTION": "Crude corn oil manufacturing",
    },
    {
      NAICS22: "311221",
      "INDEX ITEM DESCRIPTION": "Dextrin made by wet milling corn",
    },
    {
      NAICS22: "311221",
      "INDEX ITEM DESCRIPTION":
        "Gluten feed, flour, and meal, made by wet milling corn",
    },
    {
      NAICS22: "311221",
      "INDEX ITEM DESCRIPTION": "Gluten manufacturing",
    },
    {
      NAICS22: "311221",
      "INDEX ITEM DESCRIPTION": "HFCS (high fructose corn syrup) manufacturing",
    },
    {
      NAICS22: "311221",
      "INDEX ITEM DESCRIPTION": "High fructose corn syrup (HFCS) manufacturing",
    },
    {
      NAICS22: "311221",
      "INDEX ITEM DESCRIPTION": "Maltodextrins manufacturing",
    },
    {
      NAICS22: "311221",
      "INDEX ITEM DESCRIPTION":
        "Margarine and other corn oils made by wet milling corn",
    },
    {
      NAICS22: "311221",
      "INDEX ITEM DESCRIPTION":
        "Oil, corn crude and refined, made by wet milling corn",
    },
    {
      NAICS22: "311221",
      "INDEX ITEM DESCRIPTION": "Potato starches manufacturing",
    },
    {
      NAICS22: "311221",
      "INDEX ITEM DESCRIPTION": "Rice starches manufacturing",
    },
    {
      NAICS22: "311221",
      "INDEX ITEM DESCRIPTION": "Root starches manufacturing",
    },
    {
      NAICS22: "311221",
      "INDEX ITEM DESCRIPTION": "Starches (except laundry) manufacturing",
    },
    {
      NAICS22: "311221",
      "INDEX ITEM DESCRIPTION": "Steepwater concentrate manufacturing",
    },
    {
      NAICS22: "311221",
      "INDEX ITEM DESCRIPTION": "Sugar made by wet milling corn",
    },
    {
      NAICS22: "311221",
      "INDEX ITEM DESCRIPTION": "Syrup, corn, made by wet milling",
    },
    {
      NAICS22: "311221",
      "INDEX ITEM DESCRIPTION": "Table oil, corn, made by wet milling",
    },
    {
      NAICS22: "311221",
      "INDEX ITEM DESCRIPTION": "Tapioca manufacturing",
    },
    {
      NAICS22: "311221",
      "INDEX ITEM DESCRIPTION": "Vegetable starches manufacturing",
    },
    {
      NAICS22: "311221",
      "INDEX ITEM DESCRIPTION": "Wet milling corn and other vegetables",
    },
    {
      NAICS22: "311224",
      "INDEX ITEM DESCRIPTION":
        "Canola (rapeseed) oil, cake and meal, made in crushing mills",
    },
    {
      NAICS22: "311224",
      "INDEX ITEM DESCRIPTION": "Castor oil and pomace made in crushing mills",
    },
    {
      NAICS22: "311224",
      "INDEX ITEM DESCRIPTION": "Coconut oil made in crushing mills",
    },
    {
      NAICS22: "311224",
      "INDEX ITEM DESCRIPTION":
        "Cottonseed oil, cake and meal, made in crushing mills",
    },
    {
      NAICS22: "311224",
      "INDEX ITEM DESCRIPTION": "Flaxseed oil made in crushing mills",
    },
    {
      NAICS22: "311224",
      "INDEX ITEM DESCRIPTION": "Lecithin, cottonseed, made in crushing mills",
    },
    {
      NAICS22: "311224",
      "INDEX ITEM DESCRIPTION": "Lecithin, soybean, made in crushing mills",
    },
    {
      NAICS22: "311224",
      "INDEX ITEM DESCRIPTION":
        "Linseed oil, cake and meal, made in crushing mills",
    },
    {
      NAICS22: "311224",
      "INDEX ITEM DESCRIPTION": "Olive oil made in crushing mills",
    },
    {
      NAICS22: "311224",
      "INDEX ITEM DESCRIPTION":
        "Palm-kernel oil, cake, and meal made in crushing mills",
    },
    {
      NAICS22: "311224",
      "INDEX ITEM DESCRIPTION":
        "Peanut cake, meal, and oil made in crushing mills",
    },
    {
      NAICS22: "311224",
      "INDEX ITEM DESCRIPTION":
        "Rapeseed (i.e., canola) oil made in crushing mills",
    },
    {
      NAICS22: "311224",
      "INDEX ITEM DESCRIPTION": "Safflower oil made in crushing mills",
    },
    {
      NAICS22: "311224",
      "INDEX ITEM DESCRIPTION": "Shortening made in crushing mills",
    },
    {
      NAICS22: "311224",
      "INDEX ITEM DESCRIPTION": "Soybean cakes and meal manufacturing",
    },
    {
      NAICS22: "311224",
      "INDEX ITEM DESCRIPTION": "Soybean flour and grits manufacturing",
    },
    {
      NAICS22: "311224",
      "INDEX ITEM DESCRIPTION": "Soybean millfeed made in oil mills",
    },
    {
      NAICS22: "311224",
      "INDEX ITEM DESCRIPTION": "Soybean oil mills",
    },
    {
      NAICS22: "311224",
      "INDEX ITEM DESCRIPTION":
        "Soybean oil, cake, and meal, made in crushing mills",
    },
    {
      NAICS22: "311224",
      "INDEX ITEM DESCRIPTION": "Soybean oil, crude, manufacturing",
    },
    {
      NAICS22: "311224",
      "INDEX ITEM DESCRIPTION": "Soybean oil, deodorized, made in oil mills",
    },
    {
      NAICS22: "311224",
      "INDEX ITEM DESCRIPTION": "Soybean oil, refined, made in crushing mills",
    },
    {
      NAICS22: "311224",
      "INDEX ITEM DESCRIPTION":
        "Soybean protein concentrates made in crushing mills",
    },
    {
      NAICS22: "311224",
      "INDEX ITEM DESCRIPTION": "Soybean protein isolates made in crushing mills",
    },
    {
      NAICS22: "311224",
      "INDEX ITEM DESCRIPTION":
        "Sunflower seed oil, cake and meal, made in crushing mills",
    },
    {
      NAICS22: "311224",
      "INDEX ITEM DESCRIPTION":
        "Tree nut oils (e.g., tung, walnut) made in crushing mill",
    },
    {
      NAICS22: "311224",
      "INDEX ITEM DESCRIPTION": "Vegetable oils made in crushing mills",
    },
    {
      NAICS22: "311225",
      "INDEX ITEM DESCRIPTION": "Butter substitutes made from purchased oils",
    },
    {
      NAICS22: "311225",
      "INDEX ITEM DESCRIPTION":
        "Canola (rapeseed) oil, cake and meal, made from purchased oils",
    },
    {
      NAICS22: "311225",
      "INDEX ITEM DESCRIPTION": "Coconut oil made from purchased oils",
    },
    {
      NAICS22: "311225",
      "INDEX ITEM DESCRIPTION":
        "Cooking and baking oil sprays made from purchased oils",
    },
    {
      NAICS22: "311225",
      "INDEX ITEM DESCRIPTION": "Corn oil made from purchased oils",
    },
    {
      NAICS22: "311225",
      "INDEX ITEM DESCRIPTION": "Cottonseed oil made from purchased oils",
    },
    {
      NAICS22: "311225",
      "INDEX ITEM DESCRIPTION": "Flaxseed oil made from purchased oils",
    },
    {
      NAICS22: "311225",
      "INDEX ITEM DESCRIPTION":
        "Grease, inedible, animal and vegetable, refining and blending purchased oils",
    },
    {
      NAICS22: "311225",
      "INDEX ITEM DESCRIPTION": "Hydrogenating purchased oil",
    },
    {
      NAICS22: "311225",
      "INDEX ITEM DESCRIPTION": "Lecithin made from purchased oils",
    },
    {
      NAICS22: "311225",
      "INDEX ITEM DESCRIPTION": "Linseed oil made from purchased oils",
    },
    {
      NAICS22: "311225",
      "INDEX ITEM DESCRIPTION":
        "Margarine-butter blend made from purchased fats and oils",
    },
    {
      NAICS22: "311225",
      "INDEX ITEM DESCRIPTION":
        "Margarines (including imitation) made from purchased fats and oils",
    },
    {
      NAICS22: "311225",
      "INDEX ITEM DESCRIPTION": "Nondairy butter made from purchased oils",
    },
    {
      NAICS22: "311225",
      "INDEX ITEM DESCRIPTION": "Oil, olive, made from purchased oils",
    },
    {
      NAICS22: "311225",
      "INDEX ITEM DESCRIPTION":
        "Oil, vegetable stearin, made from purchased oils",
    },
    {
      NAICS22: "311225",
      "INDEX ITEM DESCRIPTION": "Olive oil made from purchased oils",
    },
    {
      NAICS22: "311225",
      "INDEX ITEM DESCRIPTION": "Palm-kernel oil made from purchased oils",
    },
    {
      NAICS22: "311225",
      "INDEX ITEM DESCRIPTION": "Peanut oil made from purchased oils",
    },
    {
      NAICS22: "311225",
      "INDEX ITEM DESCRIPTION":
        "Rapeseed (i.e., canola) oil made from purchased oils",
    },
    {
      NAICS22: "311225",
      "INDEX ITEM DESCRIPTION": "Safflower oil made from purchased oils",
    },
    {
      NAICS22: "311225",
      "INDEX ITEM DESCRIPTION": "Shortening made from purchased fats and oils",
    },
    {
      NAICS22: "311225",
      "INDEX ITEM DESCRIPTION": "Soybean cooking oil made from purchased oils",
    },
    {
      NAICS22: "311225",
      "INDEX ITEM DESCRIPTION": "Table oil made from purchased oils",
    },
    {
      NAICS22: "311225",
      "INDEX ITEM DESCRIPTION":
        "Tree nut oils (e.g., tung, walnut) made from purchased oils",
    },
    {
      NAICS22: "311225",
      "INDEX ITEM DESCRIPTION": "Vegetable oils made from purchased oils",
    },
    {
      NAICS22: "311230",
      "INDEX ITEM DESCRIPTION": "Breakfast cereals manufacturing",
    },
    {
      NAICS22: "311230",
      "INDEX ITEM DESCRIPTION": "Corn breakfast foods manufacturing",
    },
    {
      NAICS22: "311230",
      "INDEX ITEM DESCRIPTION": "Farina, breakfast cereal, manufacturing",
    },
    {
      NAICS22: "311230",
      "INDEX ITEM DESCRIPTION": "Flour mills, breakfast cereal, manufacturing",
    },
    {
      NAICS22: "311230",
      "INDEX ITEM DESCRIPTION": "Grain mills, breakfast cereal",
    },
    {
      NAICS22: "311230",
      "INDEX ITEM DESCRIPTION": "Grain, breakfast cereal, manufacturing",
    },
    {
      NAICS22: "311230",
      "INDEX ITEM DESCRIPTION":
        "Granola, cereal (except bars and clusters), manufacturing",
    },
    {
      NAICS22: "311230",
      "INDEX ITEM DESCRIPTION":
        "Hominy grits, prepared as cereal breakfast food, manufacturing",
    },
    {
      NAICS22: "311230",
      "INDEX ITEM DESCRIPTION": "Infant cereals, dry, manufacturing",
    },
    {
      NAICS22: "311230",
      "INDEX ITEM DESCRIPTION": "Instant hot cereals manufacturing",
    },
    {
      NAICS22: "311230",
      "INDEX ITEM DESCRIPTION": "Mix grain breakfast manufacturing",
    },
    {
      NAICS22: "311230",
      "INDEX ITEM DESCRIPTION":
        "Oatmeal (i.e., cereal breakfast food) manufacturing",
    },
    {
      NAICS22: "311230",
      "INDEX ITEM DESCRIPTION": "Oats, breakfast cereal, manufacturing",
    },
    {
      NAICS22: "311230",
      "INDEX ITEM DESCRIPTION":
        "Oats, rolled (i.e., cereal breakfast food), manufacturing",
    },
    {
      NAICS22: "311230",
      "INDEX ITEM DESCRIPTION": "Rice breakfast foods manufacturing",
    },
    {
      NAICS22: "311230",
      "INDEX ITEM DESCRIPTION": "Wheat breakfast cereal manufacturing",
    },
    {
      NAICS22: "311313",
      "INDEX ITEM DESCRIPTION": "Beet pulp, dried, manufacturing",
    },
    {
      NAICS22: "311313",
      "INDEX ITEM DESCRIPTION": "Beet sugar refining",
    },
    {
      NAICS22: "311313",
      "INDEX ITEM DESCRIPTION": "Brown beet sugar refining",
    },
    {
      NAICS22: "311313",
      "INDEX ITEM DESCRIPTION": "Brown sugar made from beet sugar",
    },
    {
      NAICS22: "311313",
      "INDEX ITEM DESCRIPTION": "Confectioner's beet sugar manufacturing",
    },
    {
      NAICS22: "311313",
      "INDEX ITEM DESCRIPTION": "Granulated beet sugar manufacturing",
    },
    {
      NAICS22: "311313",
      "INDEX ITEM DESCRIPTION": "Liquid beet syrup manufacturing",
    },
    {
      NAICS22: "311313",
      "INDEX ITEM DESCRIPTION": "Liquid sugar made from beet sugar",
    },
    {
      NAICS22: "311313",
      "INDEX ITEM DESCRIPTION": "Molasses made from sugar beets",
    },
    {
      NAICS22: "311313",
      "INDEX ITEM DESCRIPTION": "Raw beet sugar manufacturing",
    },
    {
      NAICS22: "311313",
      "INDEX ITEM DESCRIPTION": "Sugar, confectionery, made from sugar beets",
    },
    {
      NAICS22: "311313",
      "INDEX ITEM DESCRIPTION": "Sugar, granulated, made from sugar beets",
    },
    {
      NAICS22: "311313",
      "INDEX ITEM DESCRIPTION": "Sugar, invert, made from sugar beets",
    },
    {
      NAICS22: "311313",
      "INDEX ITEM DESCRIPTION": "Sugar, liquid, made from sugar beets",
    },
    {
      NAICS22: "311313",
      "INDEX ITEM DESCRIPTION": "Syrup made from sugar beets",
    },
    {
      NAICS22: "311314",
      "INDEX ITEM DESCRIPTION": "Blackstrap molasses manufacturing",
    },
    {
      NAICS22: "311314",
      "INDEX ITEM DESCRIPTION": "Brown sugar manufacturing",
    },
    {
      NAICS22: "311314",
      "INDEX ITEM DESCRIPTION": "Cane sugar manufacturing",
    },
    {
      NAICS22: "311314",
      "INDEX ITEM DESCRIPTION": "Cane syrup manufacturing",
    },
    {
      NAICS22: "311314",
      "INDEX ITEM DESCRIPTION": "Confectioner's powdered sugar manufacturing",
    },
    {
      NAICS22: "311314",
      "INDEX ITEM DESCRIPTION": "Granulated cane sugar manufacturing",
    },
    {
      NAICS22: "311314",
      "INDEX ITEM DESCRIPTION": "Invert sugar manufacturing",
    },
    {
      NAICS22: "311314",
      "INDEX ITEM DESCRIPTION": "Liquid sugar manufacturing",
    },
    {
      NAICS22: "311314",
      "INDEX ITEM DESCRIPTION": "Molasses manufacturing",
    },
    {
      NAICS22: "311314",
      "INDEX ITEM DESCRIPTION": "Molasses, blackstrap, manufacturing",
    },
    {
      NAICS22: "311314",
      "INDEX ITEM DESCRIPTION": "Sugar, cane, manufacturing",
    },
    {
      NAICS22: "311314",
      "INDEX ITEM DESCRIPTION":
        "Sugar, clarified, granulated, and raw, manufacturing",
    },
    {
      NAICS22: "311314",
      "INDEX ITEM DESCRIPTION": "Sugar, confectionery, manufacturing",
    },
    {
      NAICS22: "311314",
      "INDEX ITEM DESCRIPTION": "Sugar, granulated, manufacturing",
    },
    {
      NAICS22: "311314",
      "INDEX ITEM DESCRIPTION": "Sugar, invert, manufacturing",
    },
    {
      NAICS22: "311314",
      "INDEX ITEM DESCRIPTION": "Sugar, raw, manufacturing",
    },
    {
      NAICS22: "311314",
      "INDEX ITEM DESCRIPTION": "Sugar, refined, manufacturing",
    },
    {
      NAICS22: "311314",
      "INDEX ITEM DESCRIPTION": "Sugarcane mills",
    },
    {
      NAICS22: "311314",
      "INDEX ITEM DESCRIPTION": "Sugarcane refining",
    },
    {
      NAICS22: "311314",
      "INDEX ITEM DESCRIPTION": "Syrup, cane, manufacturing",
    },
    {
      NAICS22: "311340",
      "INDEX ITEM DESCRIPTION":
        "Breakfast bars, nonchocolate covered, manufacturing",
    },
    {
      NAICS22: "311340",
      "INDEX ITEM DESCRIPTION": "Cake ornaments, confectionery, manufacturing",
    },
    {
      NAICS22: "311340",
      "INDEX ITEM DESCRIPTION": "Candied fruits and fruit peel manufacturing",
    },
    {
      NAICS22: "311340",
      "INDEX ITEM DESCRIPTION": "Candy bars, nonchocolate, manufacturing",
    },
    {
      NAICS22: "311340",
      "INDEX ITEM DESCRIPTION":
        "Candy stores, nonchocolate, candy made on premises, not for immediate consumption",
    },
    {
      NAICS22: "311340",
      "INDEX ITEM DESCRIPTION": "Chewing gum base manufacturing",
    },
    {
      NAICS22: "311340",
      "INDEX ITEM DESCRIPTION": "Chewing gum manufacturing",
    },
    {
      NAICS22: "311340",
      "INDEX ITEM DESCRIPTION": "Confectionery, nonchocolate, manufacturing",
    },
    {
      NAICS22: "311340",
      "INDEX ITEM DESCRIPTION": "Corn confections manufacturing",
    },
    {
      NAICS22: "311340",
      "INDEX ITEM DESCRIPTION": "Cough drops (except medicated) manufacturing",
    },
    {
      NAICS22: "311340",
      "INDEX ITEM DESCRIPTION":
        "Crystallized fruits and fruit peel manufacturing",
    },
    {
      NAICS22: "311340",
      "INDEX ITEM DESCRIPTION": "Dates, sugared and stuffed, manufacturing",
    },
    {
      NAICS22: "311340",
      "INDEX ITEM DESCRIPTION":
        "Fruit peel products (e.g., candied, crystallized, glace, glazed) manufacturing",
    },
    {
      NAICS22: "311340",
      "INDEX ITEM DESCRIPTION":
        "Fruits (e.g., candied, crystallized, glazed) manufacturing",
    },
    {
      NAICS22: "311340",
      "INDEX ITEM DESCRIPTION": "Fudge, nonchocolate, manufacturing",
    },
    {
      NAICS22: "311340",
      "INDEX ITEM DESCRIPTION":
        "Granola bars and clusters, nonchocolate, manufacturing",
    },
    {
      NAICS22: "311340",
      "INDEX ITEM DESCRIPTION": "Gum, chewing, manufacturing",
    },
    {
      NAICS22: "311340",
      "INDEX ITEM DESCRIPTION": "Halvah manufacturing",
    },
    {
      NAICS22: "311340",
      "INDEX ITEM DESCRIPTION": "Hard candies manufacturing",
    },
    {
      NAICS22: "311340",
      "INDEX ITEM DESCRIPTION": "Jelly candies manufacturing",
    },
    {
      NAICS22: "311340",
      "INDEX ITEM DESCRIPTION": "Licorice candy manufacturing",
    },
    {
      NAICS22: "311340",
      "INDEX ITEM DESCRIPTION": "Lozenges, nonmedicated, candy, manufacturing",
    },
    {
      NAICS22: "311340",
      "INDEX ITEM DESCRIPTION": "Marshmallow creme manufacturing",
    },
    {
      NAICS22: "311340",
      "INDEX ITEM DESCRIPTION": "Marshmallows manufacturing",
    },
    {
      NAICS22: "311340",
      "INDEX ITEM DESCRIPTION": "Marzipan (i.e., candy) manufacturing",
    },
    {
      NAICS22: "311340",
      "INDEX ITEM DESCRIPTION":
        "Nuts, covered (except chocolate covered), manufacturing",
    },
    {
      NAICS22: "311340",
      "INDEX ITEM DESCRIPTION": "Popcorn balls manufacturing",
    },
    {
      NAICS22: "311340",
      "INDEX ITEM DESCRIPTION": "Popcorn, candy covered popped, manufacturing",
    },
    {
      NAICS22: "311340",
      "INDEX ITEM DESCRIPTION": "Synthetic chocolate manufacturing",
    },
    {
      NAICS22: "311340",
      "INDEX ITEM DESCRIPTION": "Toffee manufacturing",
    },
    {
      NAICS22: "311351",
      "INDEX ITEM DESCRIPTION": "Baking chocolate made from cacao beans",
    },
    {
      NAICS22: "311351",
      "INDEX ITEM DESCRIPTION":
        "Candy bars, chocolate (including chocolate covered), made from cacao beans",
    },
    {
      NAICS22: "311351",
      "INDEX ITEM DESCRIPTION": "Candy, chocolate, made from cacao beans",
    },
    {
      NAICS22: "311351",
      "INDEX ITEM DESCRIPTION":
        "Chocolate (e.g.,  coatings, instant, liquor, syrups) made from cacao beans",
    },
    {
      NAICS22: "311351",
      "INDEX ITEM DESCRIPTION": "Chocolate bars made from cocoa beans",
    },
    {
      NAICS22: "311351",
      "INDEX ITEM DESCRIPTION": "Chocolate, confectionery, made from cacao beans",
    },
    {
      NAICS22: "311351",
      "INDEX ITEM DESCRIPTION": "Coatings, chocolate, made from cacao beans",
    },
    {
      NAICS22: "311351",
      "INDEX ITEM DESCRIPTION":
        "Cocoa (e.g., instant, mix, mixed with other ingredients, powder drink, powdered) made from cacao beans",
    },
    {
      NAICS22: "311351",
      "INDEX ITEM DESCRIPTION": "Cocoa butter made from cocoa beans",
    },
    {
      NAICS22: "311351",
      "INDEX ITEM DESCRIPTION": "Confectionery chocolate made from cacao beans",
    },
    {
      NAICS22: "311351",
      "INDEX ITEM DESCRIPTION": "Cooking chocolate made from cacao beans",
    },
    {
      NAICS22: "311351",
      "INDEX ITEM DESCRIPTION": "Drink powdered mixes, cocoa, made from cacao",
    },
    {
      NAICS22: "311351",
      "INDEX ITEM DESCRIPTION": "Fudge, chocolate, made from cacao beans",
    },
    {
      NAICS22: "311351",
      "INDEX ITEM DESCRIPTION":
        "Granola bars and clusters, chocolate, made from cacao beans",
    },
    {
      NAICS22: "311351",
      "INDEX ITEM DESCRIPTION": "Liquor, chocolate, made from cacao beans",
    },
    {
      NAICS22: "311351",
      "INDEX ITEM DESCRIPTION": "Nuts, chocolate covered, made from cacao beans",
    },
    {
      NAICS22: "311351",
      "INDEX ITEM DESCRIPTION": "Syrup, chocolate, made from cacao beans",
    },
    {
      NAICS22: "311352",
      "INDEX ITEM DESCRIPTION": "Baking chocolate made from purchased chocolate",
    },
    {
      NAICS22: "311352",
      "INDEX ITEM DESCRIPTION":
        "Candy stores, chocolate, candy made on premises not for immediate consumption",
    },
    {
      NAICS22: "311352",
      "INDEX ITEM DESCRIPTION":
        "Chocolate (coating, instant, liquor, syrups) made from purchased chocolate",
    },
    {
      NAICS22: "311352",
      "INDEX ITEM DESCRIPTION":
        "Chocolate coatings and syrups made from purchased chocolate",
    },
    {
      NAICS22: "311352",
      "INDEX ITEM DESCRIPTION":
        "Chocolate covered candy bars made from purchased chocolate",
    },
    {
      NAICS22: "311352",
      "INDEX ITEM DESCRIPTION":
        "Chocolate covered granola bars made from purchased chocolate",
    },
    {
      NAICS22: "311352",
      "INDEX ITEM DESCRIPTION":
        "Cocoa, powdered drink, prepared, made from purchased chocolate",
    },
    {
      NAICS22: "311352",
      "INDEX ITEM DESCRIPTION": "Cocoa, powdered, made from purchased chocolate",
    },
    {
      NAICS22: "311352",
      "INDEX ITEM DESCRIPTION":
        "Cocoa, powdered, mixed with other ingredients, made from purchased chocolate",
    },
    {
      NAICS22: "311352",
      "INDEX ITEM DESCRIPTION":
        "Drink powdered mixes, cocoa, made from purchased cocoa",
    },
    {
      NAICS22: "311352",
      "INDEX ITEM DESCRIPTION": "Fudge, chocolate, made from purchased chocolate",
    },
    {
      NAICS22: "311352",
      "INDEX ITEM DESCRIPTION":
        "Granola bars and clusters, chocolate, made from purchased chocolate",
    },
    {
      NAICS22: "311352",
      "INDEX ITEM DESCRIPTION":
        "Liquor, chocolate, made from purchased chocolate",
    },
    {
      NAICS22: "311352",
      "INDEX ITEM DESCRIPTION":
        "Nuts, chocolate covered, made from purchased chocolate",
    },
    {
      NAICS22: "311352",
      "INDEX ITEM DESCRIPTION": "Syrup, chocolate, made from purchased chocolate",
    },
    {
      NAICS22: "311411",
      "INDEX ITEM DESCRIPTION": "Blast freezing on a contract basis",
    },
    {
      NAICS22: "311411",
      "INDEX ITEM DESCRIPTION": "Citrus pulp, frozen, manufacturing",
    },
    {
      NAICS22: "311411",
      "INDEX ITEM DESCRIPTION": "Concentrates, frozen fruit juice, manufacturing",
    },
    {
      NAICS22: "311411",
      "INDEX ITEM DESCRIPTION": "French fries, frozen, pre-cooked, manufacturing",
    },
    {
      NAICS22: "311411",
      "INDEX ITEM DESCRIPTION":
        "Frozen ades, drinks and cocktail mixes, manufacturing",
    },
    {
      NAICS22: "311411",
      "INDEX ITEM DESCRIPTION": "Frozen citrus pulp manufacturing",
    },
    {
      NAICS22: "311411",
      "INDEX ITEM DESCRIPTION": "Frozen fruit and vegetable processing",
    },
    {
      NAICS22: "311411",
      "INDEX ITEM DESCRIPTION":
        "Frozen fruits, fruit juices, and vegetables, manufacturing",
    },
    {
      NAICS22: "311411",
      "INDEX ITEM DESCRIPTION": "Fruit juice concentrates, frozen, manufacturing",
    },
    {
      NAICS22: "311411",
      "INDEX ITEM DESCRIPTION": "Fruits, frozen, manufacturing",
    },
    {
      NAICS22: "311411",
      "INDEX ITEM DESCRIPTION":
        "Juices, fruit or vegetable concentrates, frozen, manufacturing",
    },
    {
      NAICS22: "311411",
      "INDEX ITEM DESCRIPTION":
        "Juices, fruit or vegetable, frozen, manufacturing",
    },
    {
      NAICS22: "311411",
      "INDEX ITEM DESCRIPTION":
        "Vegetable juice concentrates, frozen, manufacturing",
    },
    {
      NAICS22: "311411",
      "INDEX ITEM DESCRIPTION": "Vegetables, frozen, manufacturing",
    },
    {
      NAICS22: "311412",
      "INDEX ITEM DESCRIPTION": "Chop suey, frozen, manufacturing",
    },
    {
      NAICS22: "311412",
      "INDEX ITEM DESCRIPTION": "Chow mein, frozen, manufacturing",
    },
    {
      NAICS22: "311412",
      "INDEX ITEM DESCRIPTION":
        "Dinners, frozen (except seafood-based), manufacturing",
    },
    {
      NAICS22: "311412",
      "INDEX ITEM DESCRIPTION": "French toast, frozen, manufacturing",
    },
    {
      NAICS22: "311412",
      "INDEX ITEM DESCRIPTION":
        "Frozen dinners (except seafood-based) manufacturing",
    },
    {
      NAICS22: "311412",
      "INDEX ITEM DESCRIPTION":
        "Frozen food entrees (except seafood-based), packaged, manufacturing",
    },
    {
      NAICS22: "311412",
      "INDEX ITEM DESCRIPTION": "Frozen pizza manufacturing",
    },
    {
      NAICS22: "311412",
      "INDEX ITEM DESCRIPTION": "Frozen pot pies manufacturing",
    },
    {
      NAICS22: "311412",
      "INDEX ITEM DESCRIPTION": "Frozen rice dishes manufacturing",
    },
    {
      NAICS22: "311412",
      "INDEX ITEM DESCRIPTION": "Frozen side dishes manufacturing",
    },
    {
      NAICS22: "311412",
      "INDEX ITEM DESCRIPTION": "Frozen soups (except seafood) manufacturing",
    },
    {
      NAICS22: "311412",
      "INDEX ITEM DESCRIPTION": "Frozen waffles manufacturing",
    },
    {
      NAICS22: "311412",
      "INDEX ITEM DESCRIPTION": "Macaroni, frozen, manufacturing",
    },
    {
      NAICS22: "311412",
      "INDEX ITEM DESCRIPTION": "Meatless patties, frozen, manufacturing",
    },
    {
      NAICS22: "311412",
      "INDEX ITEM DESCRIPTION": "Mexican foods, frozen, manufacturing",
    },
    {
      NAICS22: "311412",
      "INDEX ITEM DESCRIPTION":
        "Nationality specialty foods, frozen, manufacturing",
    },
    {
      NAICS22: "311412",
      "INDEX ITEM DESCRIPTION": "Pancakes, frozen, manufacturing",
    },
    {
      NAICS22: "311412",
      "INDEX ITEM DESCRIPTION": "Pizzas, frozen, manufacturing",
    },
    {
      NAICS22: "311412",
      "INDEX ITEM DESCRIPTION": "Pot pies, frozen, manufacturing",
    },
    {
      NAICS22: "311412",
      "INDEX ITEM DESCRIPTION": "Soups, frozen (except seafood), manufacturing",
    },
    {
      NAICS22: "311412",
      "INDEX ITEM DESCRIPTION": "Vegetable patties, frozen, manufacturing",
    },
    {
      NAICS22: "311412",
      "INDEX ITEM DESCRIPTION": "Waffles, frozen, manufacturing",
    },
    {
      NAICS22: "311412",
      "INDEX ITEM DESCRIPTION": "Whipped topping, frozen, manufacturing",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Artichokes, canned, manufacturing",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Barbecue sauce manufacturing",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Berries, canned, manufacturing",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION":
        "Beverages, fruit and vegetable juice, manufacturing",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Brining of fruits and vegetables",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Canning fruits and vegetables",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Canning jams and jellies",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Catsup manufacturing",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Chili sauce manufacturing",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Fruit brining",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Fruit butters manufacturing",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Fruit juice canning",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Fruit juices, fresh, manufacturing",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Fruit pickling",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Fruit pie fillings, canning",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Fruits pickling",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION":
        "Fruits, canned, bottled, and jarred, manufacturing",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Hominy, canned, manufacturing",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Horseradish (except sauce) canning",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Jellies and jams manufacturing",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION":
        "Juices, fruit or vegetable, canned manufacturing",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION":
        "Juices, fruit or vegetable, fresh, manufacturing",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Ketchup manufacturing",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Marmalade manufacturing",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Mushrooms canning",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Olives brined",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Onions pickled",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Pastes, fruit and vegetable, canning",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Pickles manufacturing",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Pickling fruits and vegetables",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Preserves (e.g., imitation) canning",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Relishes canning",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Salsa canning",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Sauces, tomato-based, canning",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Sauerkraut manufacturing",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Spaghetti sauce canning",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Vegetable brining",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Vegetable canning, bottling, and jarring",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Vegetable juices canning",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Vegetable juices, fresh, manufacturing",
    },
    {
      NAICS22: "311421",
      "INDEX ITEM DESCRIPTION": "Vegetables pickling",
    },
    {
      NAICS22: "311422",
      "INDEX ITEM DESCRIPTION": "Baby foods (including meats) canning",
    },
    {
      NAICS22: "311422",
      "INDEX ITEM DESCRIPTION": "Baked beans canning",
    },
    {
      NAICS22: "311422",
      "INDEX ITEM DESCRIPTION": "Beans, baked, canning",
    },
    {
      NAICS22: "311422",
      "INDEX ITEM DESCRIPTION": "Bouillon canning",
    },
    {
      NAICS22: "311422",
      "INDEX ITEM DESCRIPTION": "Broth (except seafood) canning",
    },
    {
      NAICS22: "311422",
      "INDEX ITEM DESCRIPTION": "Canning soups (except seafood)",
    },
    {
      NAICS22: "311422",
      "INDEX ITEM DESCRIPTION": "Chili con carne canning",
    },
    {
      NAICS22: "311422",
      "INDEX ITEM DESCRIPTION": "Chinese foods canning",
    },
    {
      NAICS22: "311422",
      "INDEX ITEM DESCRIPTION": "Dry beans canning",
    },
    {
      NAICS22: "311422",
      "INDEX ITEM DESCRIPTION": "Gravy canning",
    },
    {
      NAICS22: "311422",
      "INDEX ITEM DESCRIPTION": "Infant and junior food canning",
    },
    {
      NAICS22: "311422",
      "INDEX ITEM DESCRIPTION": "Italian foods canning",
    },
    {
      NAICS22: "311422",
      "INDEX ITEM DESCRIPTION": "Meat canning, baby food, manufacturing",
    },
    {
      NAICS22: "311422",
      "INDEX ITEM DESCRIPTION": "Mexican foods canning",
    },
    {
      NAICS22: "311422",
      "INDEX ITEM DESCRIPTION":
        "Nationality specialty foods canning, bottling, and jarring",
    },
    {
      NAICS22: "311422",
      "INDEX ITEM DESCRIPTION": "Pasta based products canning",
    },
    {
      NAICS22: "311422",
      "INDEX ITEM DESCRIPTION": "Pork and beans canning",
    },
    {
      NAICS22: "311422",
      "INDEX ITEM DESCRIPTION": "Soups (except seafood) canning",
    },
    {
      NAICS22: "311422",
      "INDEX ITEM DESCRIPTION": "Spaghetti canning",
    },
    {
      NAICS22: "311423",
      "INDEX ITEM DESCRIPTION": "Bouillon made in dehydration plants",
    },
    {
      NAICS22: "311423",
      "INDEX ITEM DESCRIPTION": "Dates, dried, made in dehydration plants",
    },
    {
      NAICS22: "311423",
      "INDEX ITEM DESCRIPTION": "Dehydrating fruits and vegetables",
    },
    {
      NAICS22: "311423",
      "INDEX ITEM DESCRIPTION":
        "Dehydrating potato products (e.g., flakes, granules)",
    },
    {
      NAICS22: "311423",
      "INDEX ITEM DESCRIPTION":
        "Freeze-dried, food processing, fruits and vegetables",
    },
    {
      NAICS22: "311423",
      "INDEX ITEM DESCRIPTION":
        "Fruit and vegetables, dehydrating, manufacturing",
    },
    {
      NAICS22: "311423",
      "INDEX ITEM DESCRIPTION": "Fruits dehydrating (except sun drying)",
    },
    {
      NAICS22: "311423",
      "INDEX ITEM DESCRIPTION": "Grapes, artificially drying",
    },
    {
      NAICS22: "311423",
      "INDEX ITEM DESCRIPTION": "Noodle mixes made in dehydration plants",
    },
    {
      NAICS22: "311423",
      "INDEX ITEM DESCRIPTION": "Olives, dried, made in dehydration plants",
    },
    {
      NAICS22: "311423",
      "INDEX ITEM DESCRIPTION":
        "Potato products (e.g., flakes, granules) dehydrating",
    },
    {
      NAICS22: "311423",
      "INDEX ITEM DESCRIPTION": "Prunes, dried, made in dehydration plants",
    },
    {
      NAICS22: "311423",
      "INDEX ITEM DESCRIPTION": "Raisins made in dehydration plants",
    },
    {
      NAICS22: "311423",
      "INDEX ITEM DESCRIPTION":
        "Rice mixes (i.e., uncooked and packaged with other ingredients) made in dehydration plants",
    },
    {
      NAICS22: "311423",
      "INDEX ITEM DESCRIPTION":
        "Salad dressing mixes, dry, made in dehydration plants",
    },
    {
      NAICS22: "311423",
      "INDEX ITEM DESCRIPTION": "Sauce mixes, dry, made in dehydration plants",
    },
    {
      NAICS22: "311423",
      "INDEX ITEM DESCRIPTION": "Soup mixes made in dehydration plants",
    },
    {
      NAICS22: "311423",
      "INDEX ITEM DESCRIPTION": "Sulphured fruits and vegetables manufacturing",
    },
    {
      NAICS22: "311423",
      "INDEX ITEM DESCRIPTION": "Vegetables dehydrating",
    },
    {
      NAICS22: "311511",
      "INDEX ITEM DESCRIPTION": "Acidophilus milk manufacturing",
    },
    {
      NAICS22: "311511",
      "INDEX ITEM DESCRIPTION": "Almond milk manufacturing",
    },
    {
      NAICS22: "311511",
      "INDEX ITEM DESCRIPTION":
        "Beverages, milk based (except dietary), manufacturing",
    },
    {
      NAICS22: "311511",
      "INDEX ITEM DESCRIPTION": "Buttermilk manufacturing",
    },
    {
      NAICS22: "311511",
      "INDEX ITEM DESCRIPTION": "Cheese, cottage,  manufacturing",
    },
    {
      NAICS22: "311511",
      "INDEX ITEM DESCRIPTION": "Chocolate drink (milk based) manufacturing",
    },
    {
      NAICS22: "311511",
      "INDEX ITEM DESCRIPTION": "Chocolate milk manufacturing",
    },
    {
      NAICS22: "311511",
      "INDEX ITEM DESCRIPTION": "Cottage cheese manufacturing",
    },
    {
      NAICS22: "311511",
      "INDEX ITEM DESCRIPTION": "Cream manufacturing",
    },
    {
      NAICS22: "311511",
      "INDEX ITEM DESCRIPTION": "Dips, sour cream based, manufacturing",
    },
    {
      NAICS22: "311511",
      "INDEX ITEM DESCRIPTION": "Drink, chocolate milk, manufacturing",
    },
    {
      NAICS22: "311511",
      "INDEX ITEM DESCRIPTION": "Eggnog, fresh, nonalcoholic, manufacturing",
    },
    {
      NAICS22: "311511",
      "INDEX ITEM DESCRIPTION":
        "Eggnog, nonalcoholic (except canned), manufacturing",
    },
    {
      NAICS22: "311511",
      "INDEX ITEM DESCRIPTION": "Flavored milk drinks manufacturing",
    },
    {
      NAICS22: "311511",
      "INDEX ITEM DESCRIPTION": "Fluid milk substitutes processing",
    },
    {
      NAICS22: "311511",
      "INDEX ITEM DESCRIPTION": "Homogenizing milk",
    },
    {
      NAICS22: "311511",
      "INDEX ITEM DESCRIPTION":
        "Milk based drinks (except dietary) manufacturing",
    },
    {
      NAICS22: "311511",
      "INDEX ITEM DESCRIPTION": "Milk drink, chocolate, manufacturing",
    },
    {
      NAICS22: "311511",
      "INDEX ITEM DESCRIPTION": "Milk pasteurizing",
    },
    {
      NAICS22: "311511",
      "INDEX ITEM DESCRIPTION":
        "Milk processing (e.g., bottling, homogenizing, pasteurizing, vitaminizing) manufacturing",
    },
    {
      NAICS22: "311511",
      "INDEX ITEM DESCRIPTION": "Milk substitutes manufacturing",
    },
    {
      NAICS22: "311511",
      "INDEX ITEM DESCRIPTION": "Milk, acidophilus, manufacturing",
    },
    {
      NAICS22: "311511",
      "INDEX ITEM DESCRIPTION": "Milk, fluid (except canned), manufacturing",
    },
    {
      NAICS22: "311511",
      "INDEX ITEM DESCRIPTION": "Nondairy creamers, liquid, manufacturing",
    },
    {
      NAICS22: "311511",
      "INDEX ITEM DESCRIPTION": "Nondairy yogurt (except frozen) manufacturing",
    },
    {
      NAICS22: "311511",
      "INDEX ITEM DESCRIPTION": "Oat milk manufacturing",
    },
    {
      NAICS22: "311511",
      "INDEX ITEM DESCRIPTION": "Pasteurizing milk",
    },
    {
      NAICS22: "311511",
      "INDEX ITEM DESCRIPTION": "Rice milk manufacturing",
    },
    {
      NAICS22: "311511",
      "INDEX ITEM DESCRIPTION": "Sour cream manufacturing",
    },
    {
      NAICS22: "311511",
      "INDEX ITEM DESCRIPTION": "Sour cream substitutes manufacturing",
    },
    {
      NAICS22: "311511",
      "INDEX ITEM DESCRIPTION": "Soy milk manufacturing",
    },
    {
      NAICS22: "311511",
      "INDEX ITEM DESCRIPTION":
        "Whipped topping (except dry mix, frozen) manufacturing",
    },
    {
      NAICS22: "311511",
      "INDEX ITEM DESCRIPTION": "Whipping cream manufacturing",
    },
    {
      NAICS22: "311511",
      "INDEX ITEM DESCRIPTION": "Yogurt (except frozen) manufacturing",
    },
    {
      NAICS22: "311512",
      "INDEX ITEM DESCRIPTION": "Anhydrous butterfat manufacturing",
    },
    {
      NAICS22: "311512",
      "INDEX ITEM DESCRIPTION": "Butter manufacturing",
    },
    {
      NAICS22: "311512",
      "INDEX ITEM DESCRIPTION": "Butter, creamery and whey, manufacturing",
    },
    {
      NAICS22: "311512",
      "INDEX ITEM DESCRIPTION": "Creamery butter manufacturing",
    },
    {
      NAICS22: "311512",
      "INDEX ITEM DESCRIPTION": "Whey butter manufacturing",
    },
    {
      NAICS22: "311513",
      "INDEX ITEM DESCRIPTION": "Cheese (except cottage cheese) manufacturing",
    },
    {
      NAICS22: "311513",
      "INDEX ITEM DESCRIPTION": "Cheese analogs manufacturing",
    },
    {
      NAICS22: "311513",
      "INDEX ITEM DESCRIPTION":
        "Cheese products, imitation or substitute, manufacturing",
    },
    {
      NAICS22: "311513",
      "INDEX ITEM DESCRIPTION": "Cheese spreads manufacturing",
    },
    {
      NAICS22: "311513",
      "INDEX ITEM DESCRIPTION": "Cheese, imitation or substitute, manufacturing",
    },
    {
      NAICS22: "311513",
      "INDEX ITEM DESCRIPTION":
        "Cheese, natural (except cottage cheese), manufacturing",
    },
    {
      NAICS22: "311513",
      "INDEX ITEM DESCRIPTION":
        "Curds, cheese, made in a cheese plant, manufacturing",
    },
    {
      NAICS22: "311513",
      "INDEX ITEM DESCRIPTION": "Dips, cheese based, manufacturing",
    },
    {
      NAICS22: "311513",
      "INDEX ITEM DESCRIPTION": "Nondairy cheese manufacturing",
    },
    {
      NAICS22: "311513",
      "INDEX ITEM DESCRIPTION": "Nondairy cheese products manufacturing",
    },
    {
      NAICS22: "311513",
      "INDEX ITEM DESCRIPTION": "Processed cheeses manufacturing",
    },
    {
      NAICS22: "311513",
      "INDEX ITEM DESCRIPTION": "Spreads, cheese, manufacturing",
    },
    {
      NAICS22: "311513",
      "INDEX ITEM DESCRIPTION": "Whey, raw, liquid, manufacturing",
    },
    {
      NAICS22: "311514",
      "INDEX ITEM DESCRIPTION":
        "Baby formula, fresh, processed, and bottled, manufacturing",
    },
    {
      NAICS22: "311514",
      "INDEX ITEM DESCRIPTION": "Beverages, dietary, dairy and nondairy based",
    },
    {
      NAICS22: "311514",
      "INDEX ITEM DESCRIPTION": "Casein, dry and wet, manufacturing",
    },
    {
      NAICS22: "311514",
      "INDEX ITEM DESCRIPTION": "Condensed milk manufacturing",
    },
    {
      NAICS22: "311514",
      "INDEX ITEM DESCRIPTION":
        "Condensed, evaporated or powdered whey, manufacturing",
    },
    {
      NAICS22: "311514",
      "INDEX ITEM DESCRIPTION": "Cream, dried and powdered, manufacturing",
    },
    {
      NAICS22: "311514",
      "INDEX ITEM DESCRIPTION": "Dairy food canning",
    },
    {
      NAICS22: "311514",
      "INDEX ITEM DESCRIPTION": "Dehydrated milk manufacturing",
    },
    {
      NAICS22: "311514",
      "INDEX ITEM DESCRIPTION":
        "Dietary drinks, dairy and nondairy based, manufacturing",
    },
    {
      NAICS22: "311514",
      "INDEX ITEM DESCRIPTION": "Dry milk manufacturing",
    },
    {
      NAICS22: "311514",
      "INDEX ITEM DESCRIPTION": "Dry milk products and mixture manufacturing",
    },
    {
      NAICS22: "311514",
      "INDEX ITEM DESCRIPTION": "Dry milk products for animal feed manufacturing",
    },
    {
      NAICS22: "311514",
      "INDEX ITEM DESCRIPTION": "Eggnog, canned, nonalcoholic, manufacturing",
    },
    {
      NAICS22: "311514",
      "INDEX ITEM DESCRIPTION": "Evaporated milk manufacturing",
    },
    {
      NAICS22: "311514",
      "INDEX ITEM DESCRIPTION": "Feed grade dry milk products manufacturing",
    },
    {
      NAICS22: "311514",
      "INDEX ITEM DESCRIPTION": "Ice cream mix manufacturing",
    },
    {
      NAICS22: "311514",
      "INDEX ITEM DESCRIPTION": "Ice milk mix manufacturing",
    },
    {
      NAICS22: "311514",
      "INDEX ITEM DESCRIPTION": "Infant's formulas manufacturing",
    },
    {
      NAICS22: "311514",
      "INDEX ITEM DESCRIPTION": "Lactose manufacturing",
    },
    {
      NAICS22: "311514",
      "INDEX ITEM DESCRIPTION": "Malted milk manufacturing",
    },
    {
      NAICS22: "311514",
      "INDEX ITEM DESCRIPTION": "Milk based drinks, dietary, manufacturing",
    },
    {
      NAICS22: "311514",
      "INDEX ITEM DESCRIPTION":
        "Milk, concentrated, condensed, dried, evaporated, and powdered, manufacturing",
    },
    {
      NAICS22: "311514",
      "INDEX ITEM DESCRIPTION": "Milk, malted, manufacturing",
    },
    {
      NAICS22: "311514",
      "INDEX ITEM DESCRIPTION": "Milk, powdered, manufacturing",
    },
    {
      NAICS22: "311514",
      "INDEX ITEM DESCRIPTION": "Milk, ultra high temperature, manufacturing",
    },
    {
      NAICS22: "311514",
      "INDEX ITEM DESCRIPTION": "Milkshake mixes manufacturing",
    },
    {
      NAICS22: "311514",
      "INDEX ITEM DESCRIPTION": "Mix, ice cream, manufacturing",
    },
    {
      NAICS22: "311514",
      "INDEX ITEM DESCRIPTION": "Nondairy creamers, dry, manufacturing",
    },
    {
      NAICS22: "311514",
      "INDEX ITEM DESCRIPTION": "Nonfat dry milk manufacturing",
    },
    {
      NAICS22: "311514",
      "INDEX ITEM DESCRIPTION": "Powdered milk manufacturing",
    },
    {
      NAICS22: "311514",
      "INDEX ITEM DESCRIPTION": "UHT (ultra high temperature) milk manufacturing",
    },
    {
      NAICS22: "311514",
      "INDEX ITEM DESCRIPTION":
        "Whey, condensed, dried, evaporated, and powdered, manufacturing",
    },
    {
      NAICS22: "311514",
      "INDEX ITEM DESCRIPTION": "Whipped topping, dry mix, manufacturing",
    },
    {
      NAICS22: "311514",
      "INDEX ITEM DESCRIPTION": "Yogurt mix manufacturing",
    },
    {
      NAICS22: "311520",
      "INDEX ITEM DESCRIPTION": "Custard, frozen, manufacturing",
    },
    {
      NAICS22: "311520",
      "INDEX ITEM DESCRIPTION": "Desserts, frozen (except bakery), manufacturing",
    },
    {
      NAICS22: "311520",
      "INDEX ITEM DESCRIPTION": "Frozen custard manufacturing",
    },
    {
      NAICS22: "311520",
      "INDEX ITEM DESCRIPTION": "Frozen dairy product substitutes manufacturing",
    },
    {
      NAICS22: "311520",
      "INDEX ITEM DESCRIPTION": "Frozen desserts (except bakery) manufacturing",
    },
    {
      NAICS22: "311520",
      "INDEX ITEM DESCRIPTION": "Fruit pops, frozen, manufacturing",
    },
    {
      NAICS22: "311520",
      "INDEX ITEM DESCRIPTION": "Ice cream manufacturing",
    },
    {
      NAICS22: "311520",
      "INDEX ITEM DESCRIPTION": "Ice cream specialties manufacturing",
    },
    {
      NAICS22: "311520",
      "INDEX ITEM DESCRIPTION": "Ice milk manufacturing",
    },
    {
      NAICS22: "311520",
      "INDEX ITEM DESCRIPTION": "Ice milk specialties manufacturing",
    },
    {
      NAICS22: "311520",
      "INDEX ITEM DESCRIPTION": "Ices, flavored sherbets, manufacturing",
    },
    {
      NAICS22: "311520",
      "INDEX ITEM DESCRIPTION": "Juice pops, frozen, manufacturing",
    },
    {
      NAICS22: "311520",
      "INDEX ITEM DESCRIPTION":
        "Nondairy frozen desserts (except bakery) manufacturing",
    },
    {
      NAICS22: "311520",
      "INDEX ITEM DESCRIPTION": "Nondairy frozen yogurt manufacturing",
    },
    {
      NAICS22: "311520",
      "INDEX ITEM DESCRIPTION": "Nondairy ice cream manufacturing",
    },
    {
      NAICS22: "311520",
      "INDEX ITEM DESCRIPTION": "Pudding pops, frozen, manufacturing",
    },
    {
      NAICS22: "311520",
      "INDEX ITEM DESCRIPTION": "Sherbets manufacturing",
    },
    {
      NAICS22: "311520",
      "INDEX ITEM DESCRIPTION": "Tofu frozen desserts manufacturing",
    },
    {
      NAICS22: "311520",
      "INDEX ITEM DESCRIPTION": "Yogurt, frozen, manufacturing",
    },
    {
      NAICS22: "311611",
      "INDEX ITEM DESCRIPTION": "Abattoirs",
    },
    {
      NAICS22: "311611",
      "INDEX ITEM DESCRIPTION":
        "Animal fats (except poultry and small game) produced in slaughtering plants",
    },
    {
      NAICS22: "311611",
      "INDEX ITEM DESCRIPTION":
        "Bacon, slab and sliced, produced in slaughtering plants",
    },
    {
      NAICS22: "311611",
      "INDEX ITEM DESCRIPTION":
        "Beef carcasses, half carcasses, primal and sub-primal cuts, produced in slaughtering plants",
    },
    {
      NAICS22: "311611",
      "INDEX ITEM DESCRIPTION": "Beef produced in slaughtering plants",
    },
    {
      NAICS22: "311611",
      "INDEX ITEM DESCRIPTION": "Boxed beef produced in slaughtering plants",
    },
    {
      NAICS22: "311611",
      "INDEX ITEM DESCRIPTION": "Boxed meats produced in slaughtering plants",
    },
    {
      NAICS22: "311611",
      "INDEX ITEM DESCRIPTION":
        "Canned meats (except poultry) produced in slaughtering plants",
    },
    {
      NAICS22: "311611",
      "INDEX ITEM DESCRIPTION":
        "Cured hides and skins produced in slaughtering plants",
    },
    {
      NAICS22: "311611",
      "INDEX ITEM DESCRIPTION": "Custom slaughtering",
    },
    {
      NAICS22: "311611",
      "INDEX ITEM DESCRIPTION":
        "Fats, animal (except poultry, small game), produced in slaughtering plants",
    },
    {
      NAICS22: "311611",
      "INDEX ITEM DESCRIPTION":
        "Hams (except poultry) produced in slaughtering plants",
    },
    {
      NAICS22: "311611",
      "INDEX ITEM DESCRIPTION": "Hides and skins produced in slaughtering plants",
    },
    {
      NAICS22: "311611",
      "INDEX ITEM DESCRIPTION": "Horsemeat produced in slaughtering plants",
    },
    {
      NAICS22: "311611",
      "INDEX ITEM DESCRIPTION":
        "Hot dogs (except poultry) produced in slaughtering plants",
    },
    {
      NAICS22: "311611",
      "INDEX ITEM DESCRIPTION":
        "Inedible products (e.g., hides, skins, pulled wool, wool grease) produced in slaughtering plants",
    },
    {
      NAICS22: "311611",
      "INDEX ITEM DESCRIPTION":
        "Lamb carcasses, half carcasses, primal and sub-primal cuts, produced in slaughtering plants",
    },
    {
      NAICS22: "311611",
      "INDEX ITEM DESCRIPTION": "Lard produced in slaughtering plants",
    },
    {
      NAICS22: "311611",
      "INDEX ITEM DESCRIPTION":
        "Luncheon meat (except poultry) produced in slaughtering plants",
    },
    {
      NAICS22: "311611",
      "INDEX ITEM DESCRIPTION":
        "Meat canning (except poultry) produced in slaughtering plants",
    },
    {
      NAICS22: "311611",
      "INDEX ITEM DESCRIPTION":
        "Meats fresh, chilled or frozen (except poultry and small game), produced in slaughtering plants",
    },
    {
      NAICS22: "311611",
      "INDEX ITEM DESCRIPTION":
        "Meats, cured or smoked, produced in slaughtering plants",
    },
    {
      NAICS22: "311611",
      "INDEX ITEM DESCRIPTION":
        "Pork carcasses, half carcasses, and primal and sub-primal cuts produced in slaughtering plants",
    },
    {
      NAICS22: "311611",
      "INDEX ITEM DESCRIPTION":
        "Sausage casings, natural, produced in slaughtering plant",
    },
    {
      NAICS22: "311611",
      "INDEX ITEM DESCRIPTION": "Slaughtering, custom",
    },
    {
      NAICS22: "311611",
      "INDEX ITEM DESCRIPTION": "Tallow produced in a slaughtering plant",
    },
    {
      NAICS22: "311611",
      "INDEX ITEM DESCRIPTION":
        "Variety meats, edible organs, made in slaughtering plants",
    },
    {
      NAICS22: "311611",
      "INDEX ITEM DESCRIPTION":
        "Veal carcasses, half carcasses, primal and sub-primal cuts, produced in slaughtering plants",
    },
    {
      NAICS22: "311612",
      "INDEX ITEM DESCRIPTION":
        "Bacon, slab and sliced, made from purchased carcasses",
    },
    {
      NAICS22: "311612",
      "INDEX ITEM DESCRIPTION": "Beef stew made from purchased carcasses",
    },
    {
      NAICS22: "311612",
      "INDEX ITEM DESCRIPTION":
        "Beef, primal and sub-primal cuts, made from purchased carcasses",
    },
    {
      NAICS22: "311612",
      "INDEX ITEM DESCRIPTION": "Bologna made from purchased carcasses",
    },
    {
      NAICS22: "311612",
      "INDEX ITEM DESCRIPTION": "Boxed beef made from purchased carcasses",
    },
    {
      NAICS22: "311612",
      "INDEX ITEM DESCRIPTION": "Boxed meat produced from purchased carcasses",
    },
    {
      NAICS22: "311612",
      "INDEX ITEM DESCRIPTION":
        "Collagen sausage casings made from purchased hides",
    },
    {
      NAICS22: "311612",
      "INDEX ITEM DESCRIPTION": "Cooked meats made from purchased carcasses",
    },
    {
      NAICS22: "311612",
      "INDEX ITEM DESCRIPTION": "Corned meats made from purchases carcasses",
    },
    {
      NAICS22: "311612",
      "INDEX ITEM DESCRIPTION":
        "Cured meats (e.g., brined, dried, and salted) made from purchased carcasses",
    },
    {
      NAICS22: "311612",
      "INDEX ITEM DESCRIPTION": "Dried meats made from purchased carcasses",
    },
    {
      NAICS22: "311612",
      "INDEX ITEM DESCRIPTION":
        "Frozen meat pies (i.e., tourtiere) made from purchased carcasses",
    },
    {
      NAICS22: "311612",
      "INDEX ITEM DESCRIPTION": "Hams, canned, made from purchased carcasses",
    },
    {
      NAICS22: "311612",
      "INDEX ITEM DESCRIPTION":
        "Hams, preserved (except poultry), made from purchased carcasses",
    },
    {
      NAICS22: "311612",
      "INDEX ITEM DESCRIPTION":
        "Hot dogs (except poultry) made from purchased carcasses",
    },
    {
      NAICS22: "311612",
      "INDEX ITEM DESCRIPTION":
        "Lamb, primal and sub-primal cuts, made from purchased carcasses",
    },
    {
      NAICS22: "311612",
      "INDEX ITEM DESCRIPTION":
        "Luncheon meat (except poultry) made from purchased carcasses",
    },
    {
      NAICS22: "311612",
      "INDEX ITEM DESCRIPTION":
        "Meat canning (except baby food, pet food, poultry), made from purchased carcasses",
    },
    {
      NAICS22: "311612",
      "INDEX ITEM DESCRIPTION": "Meat extracts made from purchased carcasses",
    },
    {
      NAICS22: "311612",
      "INDEX ITEM DESCRIPTION":
        "Meat products canning (except baby food, pet food, poultry) made from purchased carcasses",
    },
    {
      NAICS22: "311612",
      "INDEX ITEM DESCRIPTION":
        "Meats (except poultry), cured or smoked, made from purchased carcasses",
    },
    {
      NAICS22: "311612",
      "INDEX ITEM DESCRIPTION":
        "Meats, fresh or chilled  (except poultry and small game), frozen, made from purchased carcasses",
    },
    {
      NAICS22: "311612",
      "INDEX ITEM DESCRIPTION": "Pastrami made from purchased carcasses",
    },
    {
      NAICS22: "311612",
      "INDEX ITEM DESCRIPTION":
        "Pig's feet, cooked and pickled, made from purchased carcasses",
    },
    {
      NAICS22: "311612",
      "INDEX ITEM DESCRIPTION":
        "Pork, primal and sub-primal cuts, made from purchased carcasses",
    },
    {
      NAICS22: "311612",
      "INDEX ITEM DESCRIPTION": "Potted meats made from purchased carcasses",
    },
    {
      NAICS22: "311612",
      "INDEX ITEM DESCRIPTION": "Processed meats manufacturing",
    },
    {
      NAICS22: "311612",
      "INDEX ITEM DESCRIPTION": "Salted meats made from purchased carcasses",
    },
    {
      NAICS22: "311612",
      "INDEX ITEM DESCRIPTION":
        "Sandwich spreads, meat, made from purchased carcasses",
    },
    {
      NAICS22: "311612",
      "INDEX ITEM DESCRIPTION":
        "Sausage and similar cased products made from purchased carcasses",
    },
    {
      NAICS22: "311612",
      "INDEX ITEM DESCRIPTION":
        "Sausage casings, collagen, made from purchased hides",
    },
    {
      NAICS22: "311612",
      "INDEX ITEM DESCRIPTION": "Smoked meats made from purchased carcasses",
    },
    {
      NAICS22: "311612",
      "INDEX ITEM DESCRIPTION":
        "Variety meats, edible organs, made from purchased meats",
    },
    {
      NAICS22: "311612",
      "INDEX ITEM DESCRIPTION":
        "Veal, primal and sub-primal cuts, made from purchased carcasses",
    },
    {
      NAICS22: "311613",
      "INDEX ITEM DESCRIPTION": "Animal fats rendering",
    },
    {
      NAICS22: "311613",
      "INDEX ITEM DESCRIPTION": "Animal oil rendering",
    },
    {
      NAICS22: "311613",
      "INDEX ITEM DESCRIPTION": "Bones, fat, rendering",
    },
    {
      NAICS22: "311613",
      "INDEX ITEM DESCRIPTION": "Fats, animal, rendering",
    },
    {
      NAICS22: "311613",
      "INDEX ITEM DESCRIPTION": "Grease rendering",
    },
    {
      NAICS22: "311613",
      "INDEX ITEM DESCRIPTION": "Lard made from purchased fat",
    },
    {
      NAICS22: "311613",
      "INDEX ITEM DESCRIPTION":
        "Meat and bone meal and tankage, produced in rendering plant",
    },
    {
      NAICS22: "311613",
      "INDEX ITEM DESCRIPTION": "Neatsfoot oil rendering",
    },
    {
      NAICS22: "311613",
      "INDEX ITEM DESCRIPTION": "Oil, animal, rendering",
    },
    {
      NAICS22: "311613",
      "INDEX ITEM DESCRIPTION": "Rendering animals (carrion) for feed",
    },
    {
      NAICS22: "311613",
      "INDEX ITEM DESCRIPTION": "Rendering fats",
    },
    {
      NAICS22: "311613",
      "INDEX ITEM DESCRIPTION": "Rendering plants",
    },
    {
      NAICS22: "311613",
      "INDEX ITEM DESCRIPTION": "Stearin, animal, rendering",
    },
    {
      NAICS22: "311613",
      "INDEX ITEM DESCRIPTION": "Tallow produced in rendering plant",
    },
    {
      NAICS22: "311615",
      "INDEX ITEM DESCRIPTION": "Canning poultry (except baby and pet food)",
    },
    {
      NAICS22: "311615",
      "INDEX ITEM DESCRIPTION":
        "Chickens, processing, fresh, frozen, canned, or cooked (except baby and pet food)",
    },
    {
      NAICS22: "311615",
      "INDEX ITEM DESCRIPTION": "Chickens, slaughtering and dressing",
    },
    {
      NAICS22: "311615",
      "INDEX ITEM DESCRIPTION": "Dressing small game",
    },
    {
      NAICS22: "311615",
      "INDEX ITEM DESCRIPTION":
        "Ducks, processing, fresh, frozen, canned, or cooked",
    },
    {
      NAICS22: "311615",
      "INDEX ITEM DESCRIPTION": "Ducks, slaughtering and dressing",
    },
    {
      NAICS22: "311615",
      "INDEX ITEM DESCRIPTION":
        "Geese, processing, fresh, frozen, canned, or cooked",
    },
    {
      NAICS22: "311615",
      "INDEX ITEM DESCRIPTION": "Geese, slaughtering and dressing",
    },
    {
      NAICS22: "311615",
      "INDEX ITEM DESCRIPTION": "Hams, poultry, manufacturing",
    },
    {
      NAICS22: "311615",
      "INDEX ITEM DESCRIPTION": "Hot dogs, poultry, manufacturing",
    },
    {
      NAICS22: "311615",
      "INDEX ITEM DESCRIPTION": "Luncheon meat, poultry, manufacturing",
    },
    {
      NAICS22: "311615",
      "INDEX ITEM DESCRIPTION":
        "Meat canning, poultry (except baby and pet food), manufacturing",
    },
    {
      NAICS22: "311615",
      "INDEX ITEM DESCRIPTION":
        "Meat products (e.g., hot dogs, luncheon meats, sausages) made from a combination of poultry and other meats",
    },
    {
      NAICS22: "311615",
      "INDEX ITEM DESCRIPTION":
        "Poultry (e.g., canned, cooked, fresh, frozen) manufacturing",
    },
    {
      NAICS22: "311615",
      "INDEX ITEM DESCRIPTION":
        "Poultry (e.g., canned, cooked, fresh, frozen) processing",
    },
    {
      NAICS22: "311615",
      "INDEX ITEM DESCRIPTION": "Poultry canning (except baby and pet food)",
    },
    {
      NAICS22: "311615",
      "INDEX ITEM DESCRIPTION": "Poultry slaughtering, dressing, and packing",
    },
    {
      NAICS22: "311615",
      "INDEX ITEM DESCRIPTION": "Processed poultry manufacturing",
    },
    {
      NAICS22: "311615",
      "INDEX ITEM DESCRIPTION":
        "Rabbits processing (i.e., canned, cooked, fresh, frozen)",
    },
    {
      NAICS22: "311615",
      "INDEX ITEM DESCRIPTION": "Rabbits slaughtering and dressing",
    },
    {
      NAICS22: "311615",
      "INDEX ITEM DESCRIPTION":
        "Small game, processing, fresh, frozen, canned or cooked",
    },
    {
      NAICS22: "311615",
      "INDEX ITEM DESCRIPTION": "Small game, slaughtering, dressing and packing",
    },
    {
      NAICS22: "311615",
      "INDEX ITEM DESCRIPTION":
        "Turkeys, processing, fresh, frozen, canned, or cooked",
    },
    {
      NAICS22: "311615",
      "INDEX ITEM DESCRIPTION": "Turkeys, slaughtering and dressing",
    },
    {
      NAICS22: "311710",
      "INDEX ITEM DESCRIPTION": "Cannery, seafood",
    },
    {
      NAICS22: "311710",
      "INDEX ITEM DESCRIPTION": "Canning, fish, crustacea, and mollusks",
    },
    {
      NAICS22: "311710",
      "INDEX ITEM DESCRIPTION": "Chowders, seafood, manufacturing",
    },
    {
      NAICS22: "311710",
      "INDEX ITEM DESCRIPTION": "Cod liver oil extraction, crude, processing",
    },
    {
      NAICS22: "311710",
      "INDEX ITEM DESCRIPTION": "Curing fish and seafood",
    },
    {
      NAICS22: "311710",
      "INDEX ITEM DESCRIPTION": "Dinners, frozen seafood, manufacturing",
    },
    {
      NAICS22: "311710",
      "INDEX ITEM DESCRIPTION": "Drying fish and seafood",
    },
    {
      NAICS22: "311710",
      "INDEX ITEM DESCRIPTION": "Fish and marine animal oils processing",
    },
    {
      NAICS22: "311710",
      "INDEX ITEM DESCRIPTION": "Fish egg bait canning",
    },
    {
      NAICS22: "311710",
      "INDEX ITEM DESCRIPTION":
        "Fish freezing (e.g., blocks, fillets, ready-to-serve products)",
    },
    {
      NAICS22: "311710",
      "INDEX ITEM DESCRIPTION": "Fish manufacturing",
    },
    {
      NAICS22: "311710",
      "INDEX ITEM DESCRIPTION": "Fish meal processing",
    },
    {
      NAICS22: "311710",
      "INDEX ITEM DESCRIPTION":
        "Fish, curing, drying, pickling, salting, and smoking",
    },
    {
      NAICS22: "311710",
      "INDEX ITEM DESCRIPTION": "Floating factory ships, seafood processing",
    },
    {
      NAICS22: "311710",
      "INDEX ITEM DESCRIPTION":
        "Freezing fish (e.g., blocks, fillets, ready-to-serve products)",
    },
    {
      NAICS22: "311710",
      "INDEX ITEM DESCRIPTION": "Picking crab meat",
    },
    {
      NAICS22: "311710",
      "INDEX ITEM DESCRIPTION": "Seafood and seafood products canning",
    },
    {
      NAICS22: "311710",
      "INDEX ITEM DESCRIPTION": "Seafood and seafood products curing",
    },
    {
      NAICS22: "311710",
      "INDEX ITEM DESCRIPTION": "Seafood and seafood products manufacturing",
    },
    {
      NAICS22: "311710",
      "INDEX ITEM DESCRIPTION": "Seafood dinners, frozen, manufacturing",
    },
    {
      NAICS22: "311710",
      "INDEX ITEM DESCRIPTION": "Seaweed processing (e.g., dulse)",
    },
    {
      NAICS22: "311710",
      "INDEX ITEM DESCRIPTION": "Shellfish and shellfish products canning",
    },
    {
      NAICS22: "311710",
      "INDEX ITEM DESCRIPTION": "Shellfish and shellfish products manufacturing",
    },
    {
      NAICS22: "311710",
      "INDEX ITEM DESCRIPTION": "Shellfish curing",
    },
    {
      NAICS22: "311710",
      "INDEX ITEM DESCRIPTION": "Shucking and packing fresh shellfish",
    },
    {
      NAICS22: "311710",
      "INDEX ITEM DESCRIPTION": "Soups, seafood, manufacturing",
    },
    {
      NAICS22: "311710",
      "INDEX ITEM DESCRIPTION": "Surimi manufacturing",
    },
    {
      NAICS22: "311811",
      "INDEX ITEM DESCRIPTION":
        "Bakeries with baking from flour on the premises, retailing not for immediate consumption",
    },
    {
      NAICS22: "311812",
      "INDEX ITEM DESCRIPTION": "Bagels made in commercial bakeries",
    },
    {
      NAICS22: "311812",
      "INDEX ITEM DESCRIPTION":
        "Bakery products, fresh (i.e., bread, cakes, doughnuts, pastries), made in commercial bakeries",
    },
    {
      NAICS22: "311812",
      "INDEX ITEM DESCRIPTION":
        "Biscuits, bread-type, made in commercial bakeries",
    },
    {
      NAICS22: "311812",
      "INDEX ITEM DESCRIPTION":
        "Bread and bread-type rolls made in commercial bakeries",
    },
    {
      NAICS22: "311812",
      "INDEX ITEM DESCRIPTION":
        "Cakes, baking (except frozen), made in commercial bakeries",
    },
    {
      NAICS22: "311812",
      "INDEX ITEM DESCRIPTION": "Commercial bakeries",
    },
    {
      NAICS22: "311812",
      "INDEX ITEM DESCRIPTION": "Communion wafer manufacturing",
    },
    {
      NAICS22: "311812",
      "INDEX ITEM DESCRIPTION": "Croissants, baking, made in commercial bakeries",
    },
    {
      NAICS22: "311812",
      "INDEX ITEM DESCRIPTION":
        "Croutons and bread crumbs made in commercial bakeries",
    },
    {
      NAICS22: "311812",
      "INDEX ITEM DESCRIPTION":
        "Crullers (except frozen) made in commercial bakeries",
    },
    {
      NAICS22: "311812",
      "INDEX ITEM DESCRIPTION":
        "Doughnuts (except frozen) made in commercial bakeries",
    },
    {
      NAICS22: "311812",
      "INDEX ITEM DESCRIPTION":
        "Frozen bread and bread-type rolls, made in commercial bakeries",
    },
    {
      NAICS22: "311812",
      "INDEX ITEM DESCRIPTION":
        "Knishes (except frozen) made in commercial bakeries",
    },
    {
      NAICS22: "311812",
      "INDEX ITEM DESCRIPTION": "Matzo baking made in commercial bakeries",
    },
    {
      NAICS22: "311812",
      "INDEX ITEM DESCRIPTION":
        "Pastries (e.g., Danish, French), fresh, made in commercial bakeries",
    },
    {
      NAICS22: "311812",
      "INDEX ITEM DESCRIPTION": "Pies, fresh, made in commercial bakeries",
    },
    {
      NAICS22: "311812",
      "INDEX ITEM DESCRIPTION": "Pretzels, soft, manufacturing",
    },
    {
      NAICS22: "311812",
      "INDEX ITEM DESCRIPTION":
        "Rolls and buns (including frozen) made in commercial bakeries",
    },
    {
      NAICS22: "311812",
      "INDEX ITEM DESCRIPTION": "Soft pretzels made in a commercial bakery",
    },
    {
      NAICS22: "311812",
      "INDEX ITEM DESCRIPTION": "Sweet yeast goods (except frozen) manufacturing",
    },
    {
      NAICS22: "311812",
      "INDEX ITEM DESCRIPTION": "Unleavened bread made in commercial bakeries",
    },
    {
      NAICS22: "311813",
      "INDEX ITEM DESCRIPTION":
        "Baked goods (except bread, bread-type rolls), frozen, manufacturing",
    },
    {
      NAICS22: "311813",
      "INDEX ITEM DESCRIPTION": "Cake, frozen, manufacturing",
    },
    {
      NAICS22: "311813",
      "INDEX ITEM DESCRIPTION": "Crullers, frozen, made in a commercial bakery",
    },
    {
      NAICS22: "311813",
      "INDEX ITEM DESCRIPTION": "Desserts, frozen bakery, manufacturing",
    },
    {
      NAICS22: "311813",
      "INDEX ITEM DESCRIPTION": "Doughnuts, frozen, manufacturing",
    },
    {
      NAICS22: "311813",
      "INDEX ITEM DESCRIPTION": "Frozen cake manufacturing",
    },
    {
      NAICS22: "311813",
      "INDEX ITEM DESCRIPTION": "Knishes, frozen, manufacturing",
    },
    {
      NAICS22: "311813",
      "INDEX ITEM DESCRIPTION":
        "Pastries (e.g., Danish, French), frozen, manufacturing",
    },
    {
      NAICS22: "311813",
      "INDEX ITEM DESCRIPTION": "Pies, frozen, manufacturing",
    },
    {
      NAICS22: "311813",
      "INDEX ITEM DESCRIPTION": "Sweet yeast goods, frozen, manufacturing",
    },
    {
      NAICS22: "311821",
      "INDEX ITEM DESCRIPTION":
        "Bakery products, dry (e.g., biscuits, cookies, crackers), manufacturing",
    },
    {
      NAICS22: "311821",
      "INDEX ITEM DESCRIPTION": "Cones, ice cream, manufacturing",
    },
    {
      NAICS22: "311821",
      "INDEX ITEM DESCRIPTION": "Cookies manufacturing",
    },
    {
      NAICS22: "311821",
      "INDEX ITEM DESCRIPTION": "Cookies, filled, manufacturing",
    },
    {
      NAICS22: "311821",
      "INDEX ITEM DESCRIPTION": "Crackers (e.g., graham, soda) manufacturing",
    },
    {
      NAICS22: "311821",
      "INDEX ITEM DESCRIPTION": "Graham wafers manufacturing",
    },
    {
      NAICS22: "311821",
      "INDEX ITEM DESCRIPTION": "Ice cream cones manufacturing",
    },
    {
      NAICS22: "311821",
      "INDEX ITEM DESCRIPTION": "Saltines manufacturing",
    },
    {
      NAICS22: "311821",
      "INDEX ITEM DESCRIPTION": "Soda crackers manufacturing",
    },
    {
      NAICS22: "311824",
      "INDEX ITEM DESCRIPTION": "Batters, prepared, made from purchased flour",
    },
    {
      NAICS22: "311824",
      "INDEX ITEM DESCRIPTION":
        "Bread and bread-type roll mixes made from purchased flour",
    },
    {
      NAICS22: "311824",
      "INDEX ITEM DESCRIPTION": "Cake mixes made from purchased flour",
    },
    {
      NAICS22: "311824",
      "INDEX ITEM DESCRIPTION": "Cookie dough made from purchased flour",
    },
    {
      NAICS22: "311824",
      "INDEX ITEM DESCRIPTION":
        "Doughs, refrigerated or frozen, made from purchased flour",
    },
    {
      NAICS22: "311824",
      "INDEX ITEM DESCRIPTION": "Dry mixes made from purchased flour",
    },
    {
      NAICS22: "311824",
      "INDEX ITEM DESCRIPTION": "Dry pasta manufacturing",
    },
    {
      NAICS22: "311824",
      "INDEX ITEM DESCRIPTION":
        "Dry pasta packaged with other ingredients made in dry pasta plants",
    },
    {
      NAICS22: "311824",
      "INDEX ITEM DESCRIPTION": "Egg noodles, dry, manufacturing",
    },
    {
      NAICS22: "311824",
      "INDEX ITEM DESCRIPTION":
        "Flour, blended or self-rising, made from purchased flour",
    },
    {
      NAICS22: "311824",
      "INDEX ITEM DESCRIPTION": "Frozen doughs made from purchased flour",
    },
    {
      NAICS22: "311824",
      "INDEX ITEM DESCRIPTION": "Macaroni, dry, manufacturing",
    },
    {
      NAICS22: "311824",
      "INDEX ITEM DESCRIPTION":
        "Mixes, flour (e.g., biscuit, cake, doughnut, pancake), made from purchased flour",
    },
    {
      NAICS22: "311824",
      "INDEX ITEM DESCRIPTION": "Noodle mixes made in dry pasta plants",
    },
    {
      NAICS22: "311824",
      "INDEX ITEM DESCRIPTION": "Noodles, dry, manufacturing",
    },
    {
      NAICS22: "311824",
      "INDEX ITEM DESCRIPTION": "Pancake mixes made from purchased flour",
    },
    {
      NAICS22: "311824",
      "INDEX ITEM DESCRIPTION": "Pasta, dry, manufacturing",
    },
    {
      NAICS22: "311824",
      "INDEX ITEM DESCRIPTION": "Pastries, uncooked, manufacturing",
    },
    {
      NAICS22: "311824",
      "INDEX ITEM DESCRIPTION":
        "Pie crust shells, uncooked, made from purchased flour",
    },
    {
      NAICS22: "311824",
      "INDEX ITEM DESCRIPTION": "Pizza doughs made from purchased flour",
    },
    {
      NAICS22: "311824",
      "INDEX ITEM DESCRIPTION": "Prepared flour mixes made from purchased flour",
    },
    {
      NAICS22: "311824",
      "INDEX ITEM DESCRIPTION": "Refrigerated doughs made from purchased flour",
    },
    {
      NAICS22: "311824",
      "INDEX ITEM DESCRIPTION": "Spaghetti, dry, manufacturing",
    },
    {
      NAICS22: "311830",
      "INDEX ITEM DESCRIPTION": "Tortillas manufacturing",
    },
    {
      NAICS22: "311911",
      "INDEX ITEM DESCRIPTION": "Canned nuts manufacturing",
    },
    {
      NAICS22: "311911",
      "INDEX ITEM DESCRIPTION":
        "Nuts, kernels and seeds, roasting and processing",
    },
    {
      NAICS22: "311911",
      "INDEX ITEM DESCRIPTION":
        "Nuts, salted, roasted, cooked, canned, manufacturing",
    },
    {
      NAICS22: "311911",
      "INDEX ITEM DESCRIPTION": "Peanut butter blended with jelly manufacturing",
    },
    {
      NAICS22: "311911",
      "INDEX ITEM DESCRIPTION": "Peanut butter manufacturing",
    },
    {
      NAICS22: "311911",
      "INDEX ITEM DESCRIPTION": "Roasted nuts and seeds manufacturing",
    },
    {
      NAICS22: "311911",
      "INDEX ITEM DESCRIPTION":
        "Seeds, snack (e.g., canned, cooked, roasted, salted) manufacturing",
    },
    {
      NAICS22: "311919",
      "INDEX ITEM DESCRIPTION": "Cheese curls and puffs manufacturing",
    },
    {
      NAICS22: "311919",
      "INDEX ITEM DESCRIPTION":
        "Corn chips and related corn snacks manufacturing",
    },
    {
      NAICS22: "311919",
      "INDEX ITEM DESCRIPTION":
        "Popcorn (except candy covered), popped, manufacturing",
    },
    {
      NAICS22: "311919",
      "INDEX ITEM DESCRIPTION": "Pork rinds manufacturing",
    },
    {
      NAICS22: "311919",
      "INDEX ITEM DESCRIPTION": "Potato chips manufacturing",
    },
    {
      NAICS22: "311919",
      "INDEX ITEM DESCRIPTION": "Potato sticks manufacturing",
    },
    {
      NAICS22: "311919",
      "INDEX ITEM DESCRIPTION": "Pretzels (except soft) manufacturing",
    },
    {
      NAICS22: "311919",
      "INDEX ITEM DESCRIPTION": "Tortilla chips manufacturing",
    },
    {
      NAICS22: "311920",
      "INDEX ITEM DESCRIPTION":
        "Coffee concentrates (i.e., instant coffee) manufacturing",
    },
    {
      NAICS22: "311920",
      "INDEX ITEM DESCRIPTION": "Coffee extracts manufacturing",
    },
    {
      NAICS22: "311920",
      "INDEX ITEM DESCRIPTION":
        "Coffee flavoring and syrups (i.e., made from coffee) manufacturing",
    },
    {
      NAICS22: "311920",
      "INDEX ITEM DESCRIPTION": "Coffee roasting",
    },
    {
      NAICS22: "311920",
      "INDEX ITEM DESCRIPTION": "Coffee substitute manufacturing",
    },
    {
      NAICS22: "311920",
      "INDEX ITEM DESCRIPTION": "Coffee, blended, manufacturing",
    },
    {
      NAICS22: "311920",
      "INDEX ITEM DESCRIPTION": "Coffee, instant and freeze-dried, manufacturing",
    },
    {
      NAICS22: "311920",
      "INDEX ITEM DESCRIPTION":
        "Extracts, essences and preparations, coffee, manufacturing",
    },
    {
      NAICS22: "311920",
      "INDEX ITEM DESCRIPTION":
        "Extracts, essences and preparations, tea, manufacturing",
    },
    {
      NAICS22: "311920",
      "INDEX ITEM DESCRIPTION": "Instant coffee manufacturing",
    },
    {
      NAICS22: "311920",
      "INDEX ITEM DESCRIPTION": "Instant tea manufacturing",
    },
    {
      NAICS22: "311920",
      "INDEX ITEM DESCRIPTION": "Roasting coffee",
    },
    {
      NAICS22: "311920",
      "INDEX ITEM DESCRIPTION": "Syrup, flavoring, coffee based, manufacturing",
    },
    {
      NAICS22: "311920",
      "INDEX ITEM DESCRIPTION": "Tea (except herbal) manufacturing",
    },
    {
      NAICS22: "311920",
      "INDEX ITEM DESCRIPTION": "Tea blending",
    },
    {
      NAICS22: "311920",
      "INDEX ITEM DESCRIPTION": "Tea, herbal, manufacturing",
    },
    {
      NAICS22: "311920",
      "INDEX ITEM DESCRIPTION": "Tea, instant, manufacturing",
    },
    {
      NAICS22: "311930",
      "INDEX ITEM DESCRIPTION": "Beverage bases manufacturing",
    },
    {
      NAICS22: "311930",
      "INDEX ITEM DESCRIPTION":
        "Beverage flavorings (except coffee based) manufacturing",
    },
    {
      NAICS22: "311930",
      "INDEX ITEM DESCRIPTION":
        "Beverage syrups (except coffee based) manufacturing",
    },
    {
      NAICS22: "311930",
      "INDEX ITEM DESCRIPTION":
        "Concentrates, drink (except frozen fruit juice), manufacturing",
    },
    {
      NAICS22: "311930",
      "INDEX ITEM DESCRIPTION":
        "Concentrates, flavoring (except coffee based), manufacturing",
    },
    {
      NAICS22: "311930",
      "INDEX ITEM DESCRIPTION":
        "Flavoring concentrates (except coffee based) manufacturing",
    },
    {
      NAICS22: "311930",
      "INDEX ITEM DESCRIPTION":
        "Flavoring pastes, powders, and syrups for soft drink manufacturing",
    },
    {
      NAICS22: "311930",
      "INDEX ITEM DESCRIPTION": "Fruit syrups, flavoring, manufacturing",
    },
    {
      NAICS22: "311930",
      "INDEX ITEM DESCRIPTION": "Soda fountain syrups manufacturing",
    },
    {
      NAICS22: "311930",
      "INDEX ITEM DESCRIPTION":
        "Soft drink concentrates (i.e., syrup) manufacturing",
    },
    {
      NAICS22: "311930",
      "INDEX ITEM DESCRIPTION": "Syrup, beverage, manufacturing",
    },
    {
      NAICS22: "311930",
      "INDEX ITEM DESCRIPTION":
        "Syrup, flavoring (except coffee based), manufacturing",
    },
    {
      NAICS22: "311941",
      "INDEX ITEM DESCRIPTION": "Cheese based salad dressing manufacturing",
    },
    {
      NAICS22: "311941",
      "INDEX ITEM DESCRIPTION": "Cider vinegar manufacturing",
    },
    {
      NAICS22: "311941",
      "INDEX ITEM DESCRIPTION": "Cider, nonalcoholic, manufacturing",
    },
    {
      NAICS22: "311941",
      "INDEX ITEM DESCRIPTION":
        "Dips (except cheese and sour cream based) manufacturing",
    },
    {
      NAICS22: "311941",
      "INDEX ITEM DESCRIPTION": "Horseradish, prepared sauce, manufacturing",
    },
    {
      NAICS22: "311941",
      "INDEX ITEM DESCRIPTION": "Mayonnaise manufacturing",
    },
    {
      NAICS22: "311941",
      "INDEX ITEM DESCRIPTION":
        "Mayonnaise, imitation or substitute, manufacturing",
    },
    {
      NAICS22: "311941",
      "INDEX ITEM DESCRIPTION": "Mustard, prepared, manufacturing",
    },
    {
      NAICS22: "311941",
      "INDEX ITEM DESCRIPTION":
        "Prepared sauces (except gravy, tomato-based) manufacturing",
    },
    {
      NAICS22: "311941",
      "INDEX ITEM DESCRIPTION": "Salad dressings manufacturing",
    },
    {
      NAICS22: "311941",
      "INDEX ITEM DESCRIPTION":
        "Sandwich spreads, salad dressing based, manufacturing",
    },
    {
      NAICS22: "311941",
      "INDEX ITEM DESCRIPTION": "Sauces (except tomato-based) manufacturing",
    },
    {
      NAICS22: "311941",
      "INDEX ITEM DESCRIPTION":
        "Sauces for meat (except tomato-based) manufacturing",
    },
    {
      NAICS22: "311941",
      "INDEX ITEM DESCRIPTION":
        "Sauces for seafood (except tomato-based) manufacturing",
    },
    {
      NAICS22: "311941",
      "INDEX ITEM DESCRIPTION":
        "Sauces for vegetable (except tomato-based) manufacturing",
    },
    {
      NAICS22: "311941",
      "INDEX ITEM DESCRIPTION": "Soy sauce manufacturing",
    },
    {
      NAICS22: "311941",
      "INDEX ITEM DESCRIPTION": "Tartar sauce manufacturing",
    },
    {
      NAICS22: "311941",
      "INDEX ITEM DESCRIPTION": "Vinegar manufacturing",
    },
    {
      NAICS22: "311941",
      "INDEX ITEM DESCRIPTION": "Worcestershire sauce manufacturing",
    },
    {
      NAICS22: "311942",
      "INDEX ITEM DESCRIPTION": "Cake frosting mixes manufacturing",
    },
    {
      NAICS22: "311942",
      "INDEX ITEM DESCRIPTION": "Chili pepper or powder manufacturing",
    },
    {
      NAICS22: "311942",
      "INDEX ITEM DESCRIPTION":
        "Extracts, food (except coffee, meat), manufacturing",
    },
    {
      NAICS22: "311942",
      "INDEX ITEM DESCRIPTION": "Extracts, malt, manufacturing",
    },
    {
      NAICS22: "311942",
      "INDEX ITEM DESCRIPTION": "Flavor extracts (except coffee) manufacturing",
    },
    {
      NAICS22: "311942",
      "INDEX ITEM DESCRIPTION": "Food coloring, natural, manufacturing",
    },
    {
      NAICS22: "311942",
      "INDEX ITEM DESCRIPTION":
        "Food extracts (except coffee, meat) manufacturing",
    },
    {
      NAICS22: "311942",
      "INDEX ITEM DESCRIPTION": "Fruit extracts manufacturing",
    },
    {
      NAICS22: "311942",
      "INDEX ITEM DESCRIPTION": "Gravy mixes, dry, manufacturing",
    },
    {
      NAICS22: "311942",
      "INDEX ITEM DESCRIPTION": "Grinding spices",
    },
    {
      NAICS22: "311942",
      "INDEX ITEM DESCRIPTION": "Hop extract manufacturing",
    },
    {
      NAICS22: "311942",
      "INDEX ITEM DESCRIPTION": "Malt extract and syrups manufacturing",
    },
    {
      NAICS22: "311942",
      "INDEX ITEM DESCRIPTION": "Pectin manufacturing",
    },
    {
      NAICS22: "311942",
      "INDEX ITEM DESCRIPTION": "Pepper (i.e., spice) manufacturing",
    },
    {
      NAICS22: "311942",
      "INDEX ITEM DESCRIPTION": "Salad dressing mixes, dry, manufacturing",
    },
    {
      NAICS22: "311942",
      "INDEX ITEM DESCRIPTION": "Salt substitute manufacturing",
    },
    {
      NAICS22: "311942",
      "INDEX ITEM DESCRIPTION": "Salt, table, manufacturing",
    },
    {
      NAICS22: "311942",
      "INDEX ITEM DESCRIPTION": "Sauce mixes, dry, manufacturing",
    },
    {
      NAICS22: "311942",
      "INDEX ITEM DESCRIPTION": "Seasoning salt manufacturing",
    },
    {
      NAICS22: "311942",
      "INDEX ITEM DESCRIPTION": "Spice grinding and blending",
    },
    {
      NAICS22: "311942",
      "INDEX ITEM DESCRIPTION": "Spice mixtures manufacturing",
    },
    {
      NAICS22: "311942",
      "INDEX ITEM DESCRIPTION": "Spices and spice mix manufacturing",
    },
    {
      NAICS22: "311942",
      "INDEX ITEM DESCRIPTION": "Table salt manufacturing",
    },
    {
      NAICS22: "311991",
      "INDEX ITEM DESCRIPTION":
        "Box lunches (for sale off premises) manufacturing",
    },
    {
      NAICS22: "311991",
      "INDEX ITEM DESCRIPTION":
        "Carrots, cut, peeled or sliced fresh, manufacturing",
    },
    {
      NAICS22: "311991",
      "INDEX ITEM DESCRIPTION": "Cole slaw, fresh, manufacturing",
    },
    {
      NAICS22: "311991",
      "INDEX ITEM DESCRIPTION": "Egg noodles, fresh, manufacturing",
    },
    {
      NAICS22: "311991",
      "INDEX ITEM DESCRIPTION":
        "Food, prepared, perishable, packaged for individual resale",
    },
    {
      NAICS22: "311991",
      "INDEX ITEM DESCRIPTION": "Fruit, cut or peeled, fresh, manufacturing",
    },
    {
      NAICS22: "311991",
      "INDEX ITEM DESCRIPTION": "Macaroni, fresh, manufacturing",
    },
    {
      NAICS22: "311991",
      "INDEX ITEM DESCRIPTION": "Noodles, fresh, manufacturing",
    },
    {
      NAICS22: "311991",
      "INDEX ITEM DESCRIPTION": "Pasta, fresh, manufacturing",
    },
    {
      NAICS22: "311991",
      "INDEX ITEM DESCRIPTION": "Pizzas, fresh, manufacturing",
    },
    {
      NAICS22: "311991",
      "INDEX ITEM DESCRIPTION": "Potatoes, peeled or cut, manufacturing",
    },
    {
      NAICS22: "311991",
      "INDEX ITEM DESCRIPTION":
        "Prepared meals, perishable, packaged for individual resale",
    },
    {
      NAICS22: "311991",
      "INDEX ITEM DESCRIPTION": "Salads, fresh or refrigerated, manufacturing",
    },
    {
      NAICS22: "311991",
      "INDEX ITEM DESCRIPTION":
        "Sandwiches, fresh (i.e., assembled and packaged for wholesale market), manufacturing",
    },
    {
      NAICS22: "311991",
      "INDEX ITEM DESCRIPTION": "Slaw, cole, fresh, manufacturing",
    },
    {
      NAICS22: "311991",
      "INDEX ITEM DESCRIPTION":
        "Tofu (i.e., bean curd) (except frozen desserts) manufacturing",
    },
    {
      NAICS22: "311991",
      "INDEX ITEM DESCRIPTION": "Vegetables, cut or peeled, fresh, manufacturing",
    },
    {
      NAICS22: "311999",
      "INDEX ITEM DESCRIPTION": "Almond pastes manufacturing",
    },
    {
      NAICS22: "311999",
      "INDEX ITEM DESCRIPTION": "Baking powder manufacturing",
    },
    {
      NAICS22: "311999",
      "INDEX ITEM DESCRIPTION": "Bread crumbs not made in bakeries",
    },
    {
      NAICS22: "311999",
      "INDEX ITEM DESCRIPTION": "Cake frosting manufacturing",
    },
    {
      NAICS22: "311999",
      "INDEX ITEM DESCRIPTION": "Chinese noodles, fried, manufacturing",
    },
    {
      NAICS22: "311999",
      "INDEX ITEM DESCRIPTION": "Cocktail mixes, dry, manufacturing",
    },
    {
      NAICS22: "311999",
      "INDEX ITEM DESCRIPTION": "Coconut, desiccated and shredded, manufacturing",
    },
    {
      NAICS22: "311999",
      "INDEX ITEM DESCRIPTION": "Corn syrups made from purchased sweeteners",
    },
    {
      NAICS22: "311999",
      "INDEX ITEM DESCRIPTION":
        "Drink powder mixes (except chocolate, coffee, milk based, tea) manufacturing",
    },
    {
      NAICS22: "311999",
      "INDEX ITEM DESCRIPTION": "Egg substitutes manufacturing",
    },
    {
      NAICS22: "311999",
      "INDEX ITEM DESCRIPTION": "Eggs, processed, manufacturing",
    },
    {
      NAICS22: "311999",
      "INDEX ITEM DESCRIPTION":
        "Fillings, cake or pie (except fruits, meat, vegetables), manufacturing",
    },
    {
      NAICS22: "311999",
      "INDEX ITEM DESCRIPTION": "Frosting, prepared, manufacturing",
    },
    {
      NAICS22: "311999",
      "INDEX ITEM DESCRIPTION": "Gelatin dessert preparations manufacturing",
    },
    {
      NAICS22: "311999",
      "INDEX ITEM DESCRIPTION": "Gelatin for cooking manufacturing",
    },
    {
      NAICS22: "311999",
      "INDEX ITEM DESCRIPTION": "Honey processing",
    },
    {
      NAICS22: "311999",
      "INDEX ITEM DESCRIPTION": "Maple syrup mixing into other products",
    },
    {
      NAICS22: "311999",
      "INDEX ITEM DESCRIPTION":
        "Noodle mixes made from purchased dry ingredients",
    },
    {
      NAICS22: "311999",
      "INDEX ITEM DESCRIPTION": "Noodles, fried, manufacturing",
    },
    {
      NAICS22: "311999",
      "INDEX ITEM DESCRIPTION":
        "Pancake syrups (except pure maple) manufacturing",
    },
    {
      NAICS22: "311999",
      "INDEX ITEM DESCRIPTION": "Pasta mixes made from purchased dry ingredients",
    },
    {
      NAICS22: "311999",
      "INDEX ITEM DESCRIPTION": "Popcorn (except popped) manufacturing",
    },
    {
      NAICS22: "311999",
      "INDEX ITEM DESCRIPTION":
        "Potato mixes made from purchased dry ingredients",
    },
    {
      NAICS22: "311999",
      "INDEX ITEM DESCRIPTION":
        "Powdered drink mixes (except chocolate, coffee, tea, milk based) manufacturing",
    },
    {
      NAICS22: "311999",
      "INDEX ITEM DESCRIPTION": "Powders, baking, manufacturing",
    },
    {
      NAICS22: "311999",
      "INDEX ITEM DESCRIPTION": "Puddings, canned dessert, manufacturing",
    },
    {
      NAICS22: "311999",
      "INDEX ITEM DESCRIPTION": "Puddings, dessert, manufacturing",
    },
    {
      NAICS22: "311999",
      "INDEX ITEM DESCRIPTION":
        "Rice mixes (i.e., uncooked and packaged with other ingredients) made from purchased rice and dry ingredients",
    },
    {
      NAICS22: "311999",
      "INDEX ITEM DESCRIPTION": "Sorghum syrup manufacturing",
    },
    {
      NAICS22: "311999",
      "INDEX ITEM DESCRIPTION":
        "Soup mixes, dry, made from purchased dry ingredients",
    },
    {
      NAICS22: "311999",
      "INDEX ITEM DESCRIPTION":
        "Sweetening syrups (except pure maple) manufacturing",
    },
    {
      NAICS22: "311999",
      "INDEX ITEM DESCRIPTION": "Syrup, corn (except wet milled), manufacturing",
    },
    {
      NAICS22: "311999",
      "INDEX ITEM DESCRIPTION":
        "Syrup, sweetening (except pure maple), manufacturing",
    },
    {
      NAICS22: "311999",
      "INDEX ITEM DESCRIPTION":
        "Syrup, table, artificially flavored, manufacturing",
    },
    {
      NAICS22: "311999",
      "INDEX ITEM DESCRIPTION": "Yeast manufacturing",
    },
    {
      NAICS22: "312111",
      "INDEX ITEM DESCRIPTION": "Artificially carbonated waters manufacturing",
    },
    {
      NAICS22: "312111",
      "INDEX ITEM DESCRIPTION":
        "Beverages, fruit and vegetable drinks, cocktails, and ades, manufacturing",
    },
    {
      NAICS22: "312111",
      "INDEX ITEM DESCRIPTION":
        "Beverages, soft drink (including artificially carbonated waters), manufacturing",
    },
    {
      NAICS22: "312111",
      "INDEX ITEM DESCRIPTION": "Carbonated soda manufacturing",
    },
    {
      NAICS22: "312111",
      "INDEX ITEM DESCRIPTION": "Carbonated soft drinks manufacturing",
    },
    {
      NAICS22: "312111",
      "INDEX ITEM DESCRIPTION": "Coffee, iced, manufacturing",
    },
    {
      NAICS22: "312111",
      "INDEX ITEM DESCRIPTION": "Drinks, fruit (except juice), manufacturing",
    },
    {
      NAICS22: "312111",
      "INDEX ITEM DESCRIPTION": "Flavored water manufacturing",
    },
    {
      NAICS22: "312111",
      "INDEX ITEM DESCRIPTION": "Fruit drinks (except juice), manufacturing",
    },
    {
      NAICS22: "312111",
      "INDEX ITEM DESCRIPTION": "Iced coffee manufacturing",
    },
    {
      NAICS22: "312111",
      "INDEX ITEM DESCRIPTION": "Iced tea manufacturing",
    },
    {
      NAICS22: "312111",
      "INDEX ITEM DESCRIPTION": "Pop, soda, manufacturing",
    },
    {
      NAICS22: "312111",
      "INDEX ITEM DESCRIPTION": "Soda carbonated, manufacturing",
    },
    {
      NAICS22: "312111",
      "INDEX ITEM DESCRIPTION": "Soda pop manufacturing",
    },
    {
      NAICS22: "312111",
      "INDEX ITEM DESCRIPTION": "Soft drinks manufacturing",
    },
    {
      NAICS22: "312111",
      "INDEX ITEM DESCRIPTION": "Tea, iced, manufacturing",
    },
    {
      NAICS22: "312111",
      "INDEX ITEM DESCRIPTION": "Water, artificially carbonated, manufacturing",
    },
    {
      NAICS22: "312111",
      "INDEX ITEM DESCRIPTION": "Water, flavored, manufacturing",
    },
    {
      NAICS22: "312112",
      "INDEX ITEM DESCRIPTION":
        "Beverages, naturally carbonated bottled water, manufacturing",
    },
    {
      NAICS22: "312112",
      "INDEX ITEM DESCRIPTION":
        "Naturally carbonated water, purifying and bottling",
    },
    {
      NAICS22: "312112",
      "INDEX ITEM DESCRIPTION": "Spring waters, purifying and bottling",
    },
    {
      NAICS22: "312112",
      "INDEX ITEM DESCRIPTION":
        "Water, naturally carbonated, purifying and bottling",
    },
    {
      NAICS22: "312113",
      "INDEX ITEM DESCRIPTION": "Block ice manufacturing",
    },
    {
      NAICS22: "312113",
      "INDEX ITEM DESCRIPTION": "Ice (except dry ice) manufacturing",
    },
    {
      NAICS22: "312120",
      "INDEX ITEM DESCRIPTION": "Ale brewing",
    },
    {
      NAICS22: "312120",
      "INDEX ITEM DESCRIPTION": "Beer brewing",
    },
    {
      NAICS22: "312120",
      "INDEX ITEM DESCRIPTION":
        "Beverages, beer, ale, and malt liquors, manufacturing",
    },
    {
      NAICS22: "312120",
      "INDEX ITEM DESCRIPTION": "Breweries",
    },
    {
      NAICS22: "312120",
      "INDEX ITEM DESCRIPTION": "Grain, brewers' spent, manufacturing",
    },
    {
      NAICS22: "312120",
      "INDEX ITEM DESCRIPTION": "Lager brewing",
    },
    {
      NAICS22: "312120",
      "INDEX ITEM DESCRIPTION": "Malt liquor brewing",
    },
    {
      NAICS22: "312120",
      "INDEX ITEM DESCRIPTION": "Microbreweries without restaurant or bar",
    },
    {
      NAICS22: "312120",
      "INDEX ITEM DESCRIPTION": "Near beer brewing",
    },
    {
      NAICS22: "312120",
      "INDEX ITEM DESCRIPTION": "Nonalcoholic beer brewing",
    },
    {
      NAICS22: "312120",
      "INDEX ITEM DESCRIPTION": "Porter brewing",
    },
    {
      NAICS22: "312120",
      "INDEX ITEM DESCRIPTION": "Stout brewing",
    },
    {
      NAICS22: "312130",
      "INDEX ITEM DESCRIPTION": "Alcoholic beverages, brandy, distilling",
    },
    {
      NAICS22: "312130",
      "INDEX ITEM DESCRIPTION": "Applejack distilling",
    },
    {
      NAICS22: "312130",
      "INDEX ITEM DESCRIPTION": "Beverages, wines and brandies, manufacturing",
    },
    {
      NAICS22: "312130",
      "INDEX ITEM DESCRIPTION": "Blending brandy",
    },
    {
      NAICS22: "312130",
      "INDEX ITEM DESCRIPTION": "Blending wines",
    },
    {
      NAICS22: "312130",
      "INDEX ITEM DESCRIPTION": "Brandy distilling",
    },
    {
      NAICS22: "312130",
      "INDEX ITEM DESCRIPTION": "Champagne method sparkling wine, manufacturing",
    },
    {
      NAICS22: "312130",
      "INDEX ITEM DESCRIPTION": "Cider, alcoholic, manufacturing",
    },
    {
      NAICS22: "312130",
      "INDEX ITEM DESCRIPTION": "Distilling brandy",
    },
    {
      NAICS22: "312130",
      "INDEX ITEM DESCRIPTION": "Fortified wines manufacturing",
    },
    {
      NAICS22: "312130",
      "INDEX ITEM DESCRIPTION": "Grape farming and making wine",
    },
    {
      NAICS22: "312130",
      "INDEX ITEM DESCRIPTION": "Ice wine",
    },
    {
      NAICS22: "312130",
      "INDEX ITEM DESCRIPTION": "Liquors, brandy, distilling and blending",
    },
    {
      NAICS22: "312130",
      "INDEX ITEM DESCRIPTION": "Nonalcoholic wines manufacturing",
    },
    {
      NAICS22: "312130",
      "INDEX ITEM DESCRIPTION": "Sake manufacturing",
    },
    {
      NAICS22: "312130",
      "INDEX ITEM DESCRIPTION": "Sparkling wines manufacturing",
    },
    {
      NAICS22: "312130",
      "INDEX ITEM DESCRIPTION": "Vermouth manufacturing",
    },
    {
      NAICS22: "312130",
      "INDEX ITEM DESCRIPTION": "Wine coolers manufacturing",
    },
    {
      NAICS22: "312130",
      "INDEX ITEM DESCRIPTION": "Wineries",
    },
    {
      NAICS22: "312130",
      "INDEX ITEM DESCRIPTION": "Wines manufacturing",
    },
    {
      NAICS22: "312130",
      "INDEX ITEM DESCRIPTION": "Wines, cooking, manufacturing",
    },
    {
      NAICS22: "312140",
      "INDEX ITEM DESCRIPTION": "Alcoholic beverages (except brandy) distilling",
    },
    {
      NAICS22: "312140",
      "INDEX ITEM DESCRIPTION":
        "Beverages, liquors (except brandies), manufacturing",
    },
    {
      NAICS22: "312140",
      "INDEX ITEM DESCRIPTION": "Blending distilled beverages (except brandy)",
    },
    {
      NAICS22: "312140",
      "INDEX ITEM DESCRIPTION": "Distilleries",
    },
    {
      NAICS22: "312140",
      "INDEX ITEM DESCRIPTION": "Distilling alcoholic beverages (except brandy)",
    },
    {
      NAICS22: "312140",
      "INDEX ITEM DESCRIPTION": "Distilling potable liquor (except brandy)",
    },
    {
      NAICS22: "312140",
      "INDEX ITEM DESCRIPTION": "Eggnog, alcoholic, manufacturing",
    },
    {
      NAICS22: "312140",
      "INDEX ITEM DESCRIPTION": "Ethyl alcohol, potable, manufacturing",
    },
    {
      NAICS22: "312140",
      "INDEX ITEM DESCRIPTION": "Grain alcohol, beverage, manufacturing",
    },
    {
      NAICS22: "312140",
      "INDEX ITEM DESCRIPTION":
        "Liquors, distilling and blending (except brandy)",
    },
    {
      NAICS22: "312140",
      "INDEX ITEM DESCRIPTION": "Mixed drinks, alcoholic, manufacturing",
    },
    {
      NAICS22: "312140",
      "INDEX ITEM DESCRIPTION":
        "Neutral spirit, beverages (except fruit), manufacturing",
    },
    {
      NAICS22: "312140",
      "INDEX ITEM DESCRIPTION":
        "Spirits, distilled (except brandy), manufacturing",
    },
    {
      NAICS22: "312230",
      "INDEX ITEM DESCRIPTION": "Chewing tobacco manufacturing",
    },
    {
      NAICS22: "312230",
      "INDEX ITEM DESCRIPTION": "Cigar manufacturing",
    },
    {
      NAICS22: "312230",
      "INDEX ITEM DESCRIPTION": "Cigarettes manufacturing",
    },
    {
      NAICS22: "312230",
      "INDEX ITEM DESCRIPTION": "Imitation tobacco cigarettes, manufacturing",
    },
    {
      NAICS22: "312230",
      "INDEX ITEM DESCRIPTION": "Pipe tobacco, prepared, manufacturing",
    },
    {
      NAICS22: "312230",
      "INDEX ITEM DESCRIPTION": "Reconstituting tobacco",
    },
    {
      NAICS22: "312230",
      "INDEX ITEM DESCRIPTION":
        "Smoking tobacco (e.g., cigarette, pipe) manufacturing",
    },
    {
      NAICS22: "312230",
      "INDEX ITEM DESCRIPTION": "Snuff manufacturing",
    },
    {
      NAICS22: "312230",
      "INDEX ITEM DESCRIPTION": "Tobacco leaf processing and aging",
    },
    {
      NAICS22: "312230",
      "INDEX ITEM DESCRIPTION":
        "Tobacco products (e.g., chewing, smoking, snuff) manufacturing",
    },
    {
      NAICS22: "312230",
      "INDEX ITEM DESCRIPTION": "Tobacco products, imitation, manufacturing",
    },
    {
      NAICS22: "312230",
      "INDEX ITEM DESCRIPTION": "Tobacco sheeting services",
    },
    {
      NAICS22: "312230",
      "INDEX ITEM DESCRIPTION": "Tobacco stemming and redrying",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Acetate spun yarns made from purchased fiber",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION":
        "Acrylic and modacrylic filament yarn throwing, twisting, texturizing, or winding of purchased yarn",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Acrylic spun yarns made from purchased fiber",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION":
        "Animal fiber yarn twisting or winding of purchased yarn",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Bags, hemp, made from purchased fiber",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Beaming yarn",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Carded yarn manufacturing",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Carpet and rug yarn spinning",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION":
        "Cotton cordage spun yarns made from purchased fiber",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Cotton spun yarns made from purchased fiber",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Cotton thread manufacturing",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION":
        "Crochet spun yarns (e.g., cotton, manmade fiber, silk, wool) made from purchased fiber",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION":
        "Darning thread (e.g., cotton, manmade fibers, silk, wool) manufacturing",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION":
        "Embroidery spun yarns (e.g., cotton, manmade fiber, silk, wool) made from purchased fiber",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION":
        "Embroidery thread (e.g., cotton, manmade fibers, silk, wool) manufacturing",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Flax spun yarns made from purchased fiber",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Hard fiber spun yarns made from purchased fiber",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Hard fiber thread manufacturing",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Hemp bags made from purchased fiber",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Hemp ropes made from purchased fiber",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Hemp spun yarns made from purchased fiber",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Knitting and crocheting thread manufacturing",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION":
        "Knitting spun yarns (e.g., cotton, manmade fiber, silk, wool) made from purchased fiber",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Manmade fiber thread manufacturing",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION":
        "Manmade staple spun yarns made from purchased fiber",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Modacrylic spun yarns made from purchased fiber",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION":
        "Mohair yarn twisting or winding of purchased yarn",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION":
        "Natural fiber (i.e., hemp, linen, ramie) thread manufacturing",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION":
        "Natural fiber spun yarns (i.e., hemp, jute, ramie, flax) made from purchased fiber",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Nylon spun yarns made from purchased fiber",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Nylon thread manufacturing",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION":
        "Nylon yarn twisting or winding of purchased yarn",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Paper yarn manufacturing",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION":
        "Polyester filament yarn throwing, twisting, texturizing, or winding of purchased yarn",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Polyester spun yarns made from purchased fiber",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Polyester thread manufacturing",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION":
        "Polypropylene filament yarn throwing, twisting, texturizing, or winding of purchased yarn",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION":
        "Polypropylene spun yarns made from purchased fiber",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Ramie spun yarns made from purchased fiber",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Rayon spun yarns made from purchased fiber",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Rayon thread manufacturing",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION":
        "Rayon yarn throwing, twisting, texturizing, or winding purchased filament",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Sewing threads manufacturing",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Silk spun yarns made from purchased fiber",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Silk thread manufacturing",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION":
        "Silk throwing, spooling, twisting, or winding of purchased yarn",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION":
        "Spinning carpet and rug yarn from purchased fiber",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Spinning yarn from purchased fiber",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Spooling of yarn",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Spooling of yarns for the trade",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Texturizing purchased yarn",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Thread mills",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Thread, all fibers, manufacturing",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Throwing purchased yarn",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Winding purchased yarn",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION":
        "Winding, spooling, beaming and rewinding of purchased yarn",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Wool spun yarn made from purchased fiber",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION":
        "Wool yarn, twisting or winding of purchased yarn",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Yarn spinning mills",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Yarn spun from purchased fiber",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION":
        "Yarn throwing, twisting, and winding of purchased yarn",
    },
    {
      NAICS22: "313110",
      "INDEX ITEM DESCRIPTION": "Yarn, carpet and rug, spun from purchased fiber",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION":
        "Blankets and bedspreads made in broadwoven fabric mills",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION":
        "Broadwoven fabrics (except rugs, tire fabrics) weaving",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION": "Brocades weaving",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION": "Canvases weaving",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION": "Carpet linings (except felt) weaving",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION": "Chambrays weaving",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION": "Cheesecloths weaving",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION": "Chintzes weaving",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION": "Corduroys weaving",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION": "Cotton fabrics, broadwoven, weaving",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION":
        "Curtains and draperies made in broadwoven fabric mills",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION": "Denims weaving",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION": "Drills weaving",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION": "Ducks weaving",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION":
        "Elastic fabrics, more than 12 inches in width, weaving",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION":
        "Fabrics (except rug, tire fabrics), broadwoven, weaving",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION": "Felts, broadwoven, weaving",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION": "Fiberglass fabrics weaving",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION": "Flannels, broadwoven, weaving",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION":
        "Gauzes, surgical, made in broadwoven fabric mills",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION": "Glass broadwoven fabrics weaving",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION":
        "Hand weaving fabrics, more than 12 inches (30 cm) in width",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION": "Hard fiber fabrics, broadwoven, weaving",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION": "Jacquard woven fabrics weaving",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION": "Jute bags made in broadwoven mills",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION": "Manmade fabrics, broadwoven, weaving",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION":
        "Natural fiber fabrics (i.e., jute, linen, hemp, ramie), broadwoven, weaving",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION":
        "Nets and nettings, more than 12 inches in width, weaving",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION": "Paper fabrics, broadwoven, weaving",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION": "Percales weaving",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION": "Poplins weaving",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION":
        "Sheets and pillowcases made in broadwoven fabric mills",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION": "Silk fabrics, broadwoven, weaving",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION": "Spandex broadwoven fabrics",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION": "Tablecloths made in broadwoven fabric mills",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION": "Terry broadwoven fabrics weaving",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION": "Textile broadwoven fabrics mills",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION": "Textile mills, broadwoven fabrics",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION":
        "Textile products (except apparel) made in broadwoven fabric mills",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION":
        "Towels and washcloths made in broadwoven fabric mills",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION": "Twills weaving",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION": "Velvets, manmade fiber and silk, weaving",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION":
        "Weaving and finishing of broadwoven fabrics (except rugs, tire fabric)",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION":
        "Weaving broadwoven fabrics (except rugs, tire fabrics)",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION": "Weaving broadwoven felts",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION":
        "Weaving fabrics more than 12 inches (30cm) in width",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION": "Wool fabrics, broadwoven, weaving",
    },
    {
      NAICS22: "313210",
      "INDEX ITEM DESCRIPTION": "Worsted fabrics weaving",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION": "Apparel webbings manufacturing",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION": "Belting fabrics, narrow woven",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION": "Bias bindings, woven, manufacturing",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION": "Bindings, narrow woven, manufacturing",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION": "Braiding narrow fabrics",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION": "Cords and braids, narrow woven, manufacturing",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION": "Cotton fabrics, narrow woven weaving",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION": "Elastic fabrics, narrow woven, manufacturing",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION": "Embroideries, Schiffli machine, manufacturing",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION": "Fabrics, narrow woven, weaving",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION": "Fiberglasses, narrow woven, weaving",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION": "Fringes weaving",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION": "Glass fabrics, narrow woven weaving",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION": "Hand weaving fabric, 12 inches or less (30cm)",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION": "Hard fiber, narrow woven, weaving",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION": "Hook and loop fastener fabric manufacturing",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION": "Hose fabrics, tubular, weaving",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION": "Labels weaving",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION": "Laces (e.g., shoe), textile, manufacturing",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION": "Manmade fabric, narrow woven, weaving",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION": "Narrow fabrics weaving",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION":
        "Natural fiber fabrics (i.e., jute, linen, hemp, ramie), narrow woven, weaving",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION": "Paper fabric, narrow woven, weaving",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION": "Ribbons made in narrow woven fabric mills",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION":
        "Rubber thread and yarns, fabric covered, manufacturing",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION": "Schiffli machine embroideries manufacturing",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION": "Tapes weaving",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION": "Textile mills, narrow woven fabric",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION": "Textile narrow woven fabric mills",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION":
        "Textile products (except apparel) made in narrow woven fabric mills",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION": "Weaving and finishing narrow fabrics",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION": "Weaving fabric less than 12 inches (30cm)",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION": "Weaving narrow fabrics",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION": "Webbing weaving",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION": "Wicks manufacturing",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION": "Wool fabrics, narrow woven, weaving",
    },
    {
      NAICS22: "313220",
      "INDEX ITEM DESCRIPTION": "Zipper tape weaving",
    },
    {
      NAICS22: "313230",
      "INDEX ITEM DESCRIPTION": "Air laid nonwoven fabrics manufacturing",
    },
    {
      NAICS22: "313230",
      "INDEX ITEM DESCRIPTION": "Blankets, nonwoven fabric, manufacturing",
    },
    {
      NAICS22: "313230",
      "INDEX ITEM DESCRIPTION": "Bonded-fiber fabrics manufacturing",
    },
    {
      NAICS22: "313230",
      "INDEX ITEM DESCRIPTION": "Carded nonwoven fabrics manufacturing",
    },
    {
      NAICS22: "313230",
      "INDEX ITEM DESCRIPTION": "Carpet paddings, nonwoven, manufacturing",
    },
    {
      NAICS22: "313230",
      "INDEX ITEM DESCRIPTION": "Fabrics, nonwoven, manufacturing",
    },
    {
      NAICS22: "313230",
      "INDEX ITEM DESCRIPTION": "Felts, nonwoven, manufacturing",
    },
    {
      NAICS22: "313230",
      "INDEX ITEM DESCRIPTION": "Melt blown nonwoven fabrics manufacturing",
    },
    {
      NAICS22: "313230",
      "INDEX ITEM DESCRIPTION": "Nonwoven fabric tapes manufacturing",
    },
    {
      NAICS22: "313230",
      "INDEX ITEM DESCRIPTION": "Nonwoven fabrics manufacturing",
    },
    {
      NAICS22: "313230",
      "INDEX ITEM DESCRIPTION": "Nonwoven felts manufacturing",
    },
    {
      NAICS22: "313230",
      "INDEX ITEM DESCRIPTION": "Pads and wadding, nonwoven, manufacturing",
    },
    {
      NAICS22: "313230",
      "INDEX ITEM DESCRIPTION": "Pressed felts manufacturing",
    },
    {
      NAICS22: "313230",
      "INDEX ITEM DESCRIPTION": "Punched felts manufacturing",
    },
    {
      NAICS22: "313230",
      "INDEX ITEM DESCRIPTION": "Ribbons made in nonwoven fabric mills",
    },
    {
      NAICS22: "313230",
      "INDEX ITEM DESCRIPTION": "Spunbonded fabrics manufacturing",
    },
    {
      NAICS22: "313230",
      "INDEX ITEM DESCRIPTION": "Tapes, nonwoven fabric, manufacturing",
    },
    {
      NAICS22: "313230",
      "INDEX ITEM DESCRIPTION": "Wet laid nonwoven fabrics manufacturing",
    },
    {
      NAICS22: "313230",
      "INDEX ITEM DESCRIPTION": "Wipes, nonwoven fabric, manufacturing",
    },
    {
      NAICS22: "313240",
      "INDEX ITEM DESCRIPTION":
        "Bags and bagging fabrics made in warp or weft knitting mills",
    },
    {
      NAICS22: "313240",
      "INDEX ITEM DESCRIPTION": "Bedspreads and bed sets made in lace mills",
    },
    {
      NAICS22: "313240",
      "INDEX ITEM DESCRIPTION":
        "Bedspreads and bed sets made in warp or weft knitting mills",
    },
    {
      NAICS22: "313240",
      "INDEX ITEM DESCRIPTION": "Circular (i.e., weft) fabrics knitting",
    },
    {
      NAICS22: "313240",
      "INDEX ITEM DESCRIPTION": "Curtains made in lace mills",
    },
    {
      NAICS22: "313240",
      "INDEX ITEM DESCRIPTION": "Curtains made in warp or weft knitting mills",
    },
    {
      NAICS22: "313240",
      "INDEX ITEM DESCRIPTION": "Dishcloths made in warp or weft knitting mills",
    },
    {
      NAICS22: "313240",
      "INDEX ITEM DESCRIPTION":
        "Fabrics, knit, made in warp or weft knit fabric mills",
    },
    {
      NAICS22: "313240",
      "INDEX ITEM DESCRIPTION": "Fabrics, lace, made in lace mills",
    },
    {
      NAICS22: "313240",
      "INDEX ITEM DESCRIPTION": "Flat (i.e., warp) fabrics knitting",
    },
    {
      NAICS22: "313240",
      "INDEX ITEM DESCRIPTION": "Hand knitting lace or warp fabric products",
    },
    {
      NAICS22: "313240",
      "INDEX ITEM DESCRIPTION": "Knitting and finishing lace",
    },
    {
      NAICS22: "313240",
      "INDEX ITEM DESCRIPTION": "Knitting and finishing warp or weft fabric",
    },
    {
      NAICS22: "313240",
      "INDEX ITEM DESCRIPTION": "Knitting lace",
    },
    {
      NAICS22: "313240",
      "INDEX ITEM DESCRIPTION": "Knitting warp or weft fabric",
    },
    {
      NAICS22: "313240",
      "INDEX ITEM DESCRIPTION": "Lace manufacturing",
    },
    {
      NAICS22: "313240",
      "INDEX ITEM DESCRIPTION":
        "Lace products (except apparel) made in lace mills",
    },
    {
      NAICS22: "313240",
      "INDEX ITEM DESCRIPTION": "Netting made in warp or weft knitting mills",
    },
    {
      NAICS22: "313240",
      "INDEX ITEM DESCRIPTION": "Netting made on a lace or net machine",
    },
    {
      NAICS22: "313240",
      "INDEX ITEM DESCRIPTION":
        "Pile fabrics made in warp or weft knitting mills",
    },
    {
      NAICS22: "313240",
      "INDEX ITEM DESCRIPTION": "Tablecloths made in lace mills",
    },
    {
      NAICS22: "313240",
      "INDEX ITEM DESCRIPTION": "Tablecloths made in warp or weft knitting mills",
    },
    {
      NAICS22: "313240",
      "INDEX ITEM DESCRIPTION":
        "Textile products (except apparel) made in lace mills",
    },
    {
      NAICS22: "313240",
      "INDEX ITEM DESCRIPTION":
        "Textile products (except apparel) made in warp or weft knitting mills",
    },
    {
      NAICS22: "313240",
      "INDEX ITEM DESCRIPTION":
        "Towels and washcloths made in warp or weft knitting mills",
    },
    {
      NAICS22: "313240",
      "INDEX ITEM DESCRIPTION": "Warp or weft fabrics knitting",
    },
    {
      NAICS22: "313310",
      "INDEX ITEM DESCRIPTION":
        "Bleaching textile products, apparel, and fabrics ",
    },
    {
      NAICS22: "313310",
      "INDEX ITEM DESCRIPTION": "Broadwoven fabrics finishing",
    },
    {
      NAICS22: "313310",
      "INDEX ITEM DESCRIPTION": "Burling and mending fabrics ",
    },
    {
      NAICS22: "313310",
      "INDEX ITEM DESCRIPTION":
        "Calendering textile products, apparel, and fabrics",
    },
    {
      NAICS22: "313310",
      "INDEX ITEM DESCRIPTION": "Carbonizing textile fibers",
    },
    {
      NAICS22: "313310",
      "INDEX ITEM DESCRIPTION": "Carding textile fibers",
    },
    {
      NAICS22: "313310",
      "INDEX ITEM DESCRIPTION":
        "Chemical finishing (e.g., fire, mildew, water resistance) fabrics",
    },
    {
      NAICS22: "313310",
      "INDEX ITEM DESCRIPTION": "Combing and converting top",
    },
    {
      NAICS22: "313310",
      "INDEX ITEM DESCRIPTION": "Combing textile fibers",
    },
    {
      NAICS22: "313310",
      "INDEX ITEM DESCRIPTION": "Converters, piece goods",
    },
    {
      NAICS22: "313310",
      "INDEX ITEM DESCRIPTION": "Converting textiles",
    },
    {
      NAICS22: "313310",
      "INDEX ITEM DESCRIPTION": "Crease resistant finishing of fabrics ",
    },
    {
      NAICS22: "313310",
      "INDEX ITEM DESCRIPTION": "Dyeing gloves, woven or knit, for the trade",
    },
    {
      NAICS22: "313310",
      "INDEX ITEM DESCRIPTION": "Dyeing textile products and fabrics ",
    },
    {
      NAICS22: "313310",
      "INDEX ITEM DESCRIPTION": "Embossing textile products and fabrics ",
    },
    {
      NAICS22: "313310",
      "INDEX ITEM DESCRIPTION": "Fabric finishing",
    },
    {
      NAICS22: "313310",
      "INDEX ITEM DESCRIPTION": "Fabric mercerizing",
    },
    {
      NAICS22: "313310",
      "INDEX ITEM DESCRIPTION": "Gassing yarn (i.e., singeing)",
    },
    {
      NAICS22: "313310",
      "INDEX ITEM DESCRIPTION": "Mechanical finishing of fabrics",
    },
    {
      NAICS22: "313310",
      "INDEX ITEM DESCRIPTION": "Mercerizing textile products and fabrics ",
    },
    {
      NAICS22: "313310",
      "INDEX ITEM DESCRIPTION": "Napping textile products and fabrics",
    },
    {
      NAICS22: "313310",
      "INDEX ITEM DESCRIPTION": "Preshrinking textile products and fabrics ",
    },
    {
      NAICS22: "313310",
      "INDEX ITEM DESCRIPTION": "Printing fabric grey goods ",
    },
    {
      NAICS22: "313310",
      "INDEX ITEM DESCRIPTION":
        "Printing textile banners (except screen printing)",
    },
    {
      NAICS22: "313310",
      "INDEX ITEM DESCRIPTION":
        "Printing textile products (except screen and apparel printing)",
    },
    {
      NAICS22: "313310",
      "INDEX ITEM DESCRIPTION": "Scouring and combing textile fibers",
    },
    {
      NAICS22: "313310",
      "INDEX ITEM DESCRIPTION": "Screen printing fabric grey goods",
    },
    {
      NAICS22: "313310",
      "INDEX ITEM DESCRIPTION": "Shrinking textile products and fabrics ",
    },
    {
      NAICS22: "313310",
      "INDEX ITEM DESCRIPTION": "Sizing of fabrics",
    },
    {
      NAICS22: "313310",
      "INDEX ITEM DESCRIPTION": "Sponging textile products and fabrics ",
    },
    {
      NAICS22: "313310",
      "INDEX ITEM DESCRIPTION":
        "Stone washing textile products, apparel, and fabrics ",
    },
    {
      NAICS22: "313310",
      "INDEX ITEM DESCRIPTION": "Sueding textile products and fabrics",
    },
    {
      NAICS22: "313310",
      "INDEX ITEM DESCRIPTION": "Teaseling fabrics",
    },
    {
      NAICS22: "313310",
      "INDEX ITEM DESCRIPTION": "Textile products finishing",
    },
    {
      NAICS22: "313310",
      "INDEX ITEM DESCRIPTION": "Thread finishing",
    },
    {
      NAICS22: "313310",
      "INDEX ITEM DESCRIPTION": "Wool tops and noils manufacturing",
    },
    {
      NAICS22: "313320",
      "INDEX ITEM DESCRIPTION": "Garments, oiling (i.e., waterproofing)",
    },
    {
      NAICS22: "313320",
      "INDEX ITEM DESCRIPTION": "Laminating purchased textiles",
    },
    {
      NAICS22: "313320",
      "INDEX ITEM DESCRIPTION": "Leather, artificial, made from purchased fabric",
    },
    {
      NAICS22: "313320",
      "INDEX ITEM DESCRIPTION": "Metallizing purchased textiles",
    },
    {
      NAICS22: "313320",
      "INDEX ITEM DESCRIPTION": "Oilcloth manufacturing",
    },
    {
      NAICS22: "313320",
      "INDEX ITEM DESCRIPTION": "Oiling of purchased textiles and apparel",
    },
    {
      NAICS22: "313320",
      "INDEX ITEM DESCRIPTION": "Plastics coating of textiles and apparel",
    },
    {
      NAICS22: "313320",
      "INDEX ITEM DESCRIPTION": "Raincoats waterproofing (i.e., oiling)",
    },
    {
      NAICS22: "313320",
      "INDEX ITEM DESCRIPTION": "Rubberizing purchased capes",
    },
    {
      NAICS22: "313320",
      "INDEX ITEM DESCRIPTION": "Rubberizing purchased cloaks",
    },
    {
      NAICS22: "313320",
      "INDEX ITEM DESCRIPTION": "Rubberizing purchased clothing",
    },
    {
      NAICS22: "313320",
      "INDEX ITEM DESCRIPTION": "Rubberizing purchased coats",
    },
    {
      NAICS22: "313320",
      "INDEX ITEM DESCRIPTION": "Rubberizing purchased textiles and apparel",
    },
    {
      NAICS22: "313320",
      "INDEX ITEM DESCRIPTION":
        "Tapes, varnished and coated (except magnetic), made from purchased fabric",
    },
    {
      NAICS22: "313320",
      "INDEX ITEM DESCRIPTION": "Textile waterproofing",
    },
    {
      NAICS22: "313320",
      "INDEX ITEM DESCRIPTION": "Varnishing purchased textiles and apparel",
    },
    {
      NAICS22: "313320",
      "INDEX ITEM DESCRIPTION": "Vinyl coated fabrics manufacturing",
    },
    {
      NAICS22: "313320",
      "INDEX ITEM DESCRIPTION":
        "Waterproofing apparel, fabrics and textile products (e.g., oiling, rubberizing, waxing, varnishing)",
    },
    {
      NAICS22: "313320",
      "INDEX ITEM DESCRIPTION": "Waxing purchased textiles and apparel",
    },
    {
      NAICS22: "314110",
      "INDEX ITEM DESCRIPTION":
        "Automobile and aircraft carpet and rug manufacturing",
    },
    {
      NAICS22: "314110",
      "INDEX ITEM DESCRIPTION": "Bath mats and bath sets made in carpet mills",
    },
    {
      NAICS22: "314110",
      "INDEX ITEM DESCRIPTION": "Carpets and rugs made from textile materials",
    },
    {
      NAICS22: "314110",
      "INDEX ITEM DESCRIPTION":
        "Doormats, all materials (except entirely of rubber or plastics), manufacturing",
    },
    {
      NAICS22: "314110",
      "INDEX ITEM DESCRIPTION": "Finishing (e.g., dyeing) rugs and carpets",
    },
    {
      NAICS22: "314110",
      "INDEX ITEM DESCRIPTION": "Rugs and carpets made from textile materials",
    },
    {
      NAICS22: "314110",
      "INDEX ITEM DESCRIPTION": "Synthetic or artificial turf manufacturing",
    },
    {
      NAICS22: "314110",
      "INDEX ITEM DESCRIPTION": "Weaving rugs, carpets, and mats",
    },
    {
      NAICS22: "314120",
      "INDEX ITEM DESCRIPTION":
        "Bedspreads and bed sets made from purchased fabrics",
    },
    {
      NAICS22: "314120",
      "INDEX ITEM DESCRIPTION":
        "Blankets (except electric) made from purchased fabrics or felts",
    },
    {
      NAICS22: "314120",
      "INDEX ITEM DESCRIPTION": "Comforters made from purchased fabrics",
    },
    {
      NAICS22: "314120",
      "INDEX ITEM DESCRIPTION":
        "Curtains and draperies, window, made from purchased fabrics",
    },
    {
      NAICS22: "314120",
      "INDEX ITEM DESCRIPTION":
        "Cushions (except carpet, springs) made from purchased fabrics",
    },
    {
      NAICS22: "314120",
      "INDEX ITEM DESCRIPTION":
        "Draperies made from purchased fabrics or sheet goods",
    },
    {
      NAICS22: "314120",
      "INDEX ITEM DESCRIPTION": "Linens made from purchased materials",
    },
    {
      NAICS22: "314120",
      "INDEX ITEM DESCRIPTION": "Napkins made from purchased fabrics",
    },
    {
      NAICS22: "314120",
      "INDEX ITEM DESCRIPTION":
        "Pads and protectors (e.g., ironing board, mattress, table), textile, made from purchased fabrics or felts",
    },
    {
      NAICS22: "314120",
      "INDEX ITEM DESCRIPTION": "Pillowcases, bed, made from purchased fabrics",
    },
    {
      NAICS22: "314120",
      "INDEX ITEM DESCRIPTION": "Pillows made from purchased materials",
    },
    {
      NAICS22: "314120",
      "INDEX ITEM DESCRIPTION":
        "Placemats, all materials, made from purchased materials",
    },
    {
      NAICS22: "314120",
      "INDEX ITEM DESCRIPTION": "Quilts made from purchased materials",
    },
    {
      NAICS22: "314120",
      "INDEX ITEM DESCRIPTION":
        "Sheets and pillowcases made from purchased fabrics",
    },
    {
      NAICS22: "314120",
      "INDEX ITEM DESCRIPTION":
        "Shower and bath curtains, all materials, made from purchased fabric or sheet goods",
    },
    {
      NAICS22: "314120",
      "INDEX ITEM DESCRIPTION":
        "Slipcovers, all materials, made from purchased materials",
    },
    {
      NAICS22: "314120",
      "INDEX ITEM DESCRIPTION":
        "Tablecloths (except paper) made from purchased materials",
    },
    {
      NAICS22: "314120",
      "INDEX ITEM DESCRIPTION":
        "Towels or washcloths made from purchased fabrics",
    },
    {
      NAICS22: "314910",
      "INDEX ITEM DESCRIPTION":
        "Awnings and canopies, outdoor, made from purchased fabrics",
    },
    {
      NAICS22: "314910",
      "INDEX ITEM DESCRIPTION":
        "Bags, plastics, made from purchased woven plastics",
    },
    {
      NAICS22: "314910",
      "INDEX ITEM DESCRIPTION": "Bags, rubberized fabric, manufacturing",
    },
    {
      NAICS22: "314910",
      "INDEX ITEM DESCRIPTION":
        "Bags, textile, made from purchased woven or knitted materials",
    },
    {
      NAICS22: "314910",
      "INDEX ITEM DESCRIPTION": "Blanket bags manufacturing",
    },
    {
      NAICS22: "314910",
      "INDEX ITEM DESCRIPTION": "Canvas bags manufacturing",
    },
    {
      NAICS22: "314910",
      "INDEX ITEM DESCRIPTION":
        "Canvas products made from purchased canvas or canvas substitutes",
    },
    {
      NAICS22: "314910",
      "INDEX ITEM DESCRIPTION":
        "Covers (e.g., boat, swimming pool, truck) made from purchased fabrics",
    },
    {
      NAICS22: "314910",
      "INDEX ITEM DESCRIPTION":
        "Feed bags made from purchased woven or knitted materials",
    },
    {
      NAICS22: "314910",
      "INDEX ITEM DESCRIPTION":
        "Flour bags made from purchased woven or knitted materials",
    },
    {
      NAICS22: "314910",
      "INDEX ITEM DESCRIPTION": "Garment storage bags manufacturing",
    },
    {
      NAICS22: "314910",
      "INDEX ITEM DESCRIPTION":
        "Knapsacks (e.g., backpacks, book bags) manufacturing",
    },
    {
      NAICS22: "314910",
      "INDEX ITEM DESCRIPTION":
        "Knapsacks, made from purchased woven or knitted materials",
    },
    {
      NAICS22: "314910",
      "INDEX ITEM DESCRIPTION":
        "Laundry bags made from purchased woven or knitted materials",
    },
    {
      NAICS22: "314910",
      "INDEX ITEM DESCRIPTION": "Sails made from purchased fabrics",
    },
    {
      NAICS22: "314910",
      "INDEX ITEM DESCRIPTION":
        "Seed bags made from purchased woven or knitted materials",
    },
    {
      NAICS22: "314910",
      "INDEX ITEM DESCRIPTION":
        "Shipping bags made from purchased woven or knitted materials",
    },
    {
      NAICS22: "314910",
      "INDEX ITEM DESCRIPTION": "Tarpaulins made from purchased fabrics",
    },
    {
      NAICS22: "314910",
      "INDEX ITEM DESCRIPTION": "Tents made from purchased fabrics",
    },
    {
      NAICS22: "314910",
      "INDEX ITEM DESCRIPTION":
        "Textile bags made from purchased woven or knitted materials",
    },
    {
      NAICS22: "314994",
      "INDEX ITEM DESCRIPTION": "Cord (except wire) manufacturing",
    },
    {
      NAICS22: "314994",
      "INDEX ITEM DESCRIPTION":
        "Cord for reinforcing rubber tires, industrial belting, and fuel cells manufacturing",
    },
    {
      NAICS22: "314994",
      "INDEX ITEM DESCRIPTION": "Cordage (except wire) manufacturing",
    },
    {
      NAICS22: "314994",
      "INDEX ITEM DESCRIPTION":
        "Fabricated rope products (e.g., nets, slings) made in cordage or twine mills",
    },
    {
      NAICS22: "314994",
      "INDEX ITEM DESCRIPTION":
        "Fabrics for reinforcing rubber tires, industrial belting, and fuel cells manufacturing",
    },
    {
      NAICS22: "314994",
      "INDEX ITEM DESCRIPTION":
        "Industrial belting reinforcement, cord and fabric, manufacturing",
    },
    {
      NAICS22: "314994",
      "INDEX ITEM DESCRIPTION": "Ropes (except wire rope) manufacturing",
    },
    {
      NAICS22: "314994",
      "INDEX ITEM DESCRIPTION":
        "Strings (except musical instrument) manufacturing",
    },
    {
      NAICS22: "314994",
      "INDEX ITEM DESCRIPTION":
        "Tire cord and fabric, all materials, manufacturing",
    },
    {
      NAICS22: "314994",
      "INDEX ITEM DESCRIPTION": "Twines manufacturing",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION":
        "Aircraft tie-down strap assemblies (except leather) manufacturing",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION":
        "Apparel fillings (e.g., cotton mill waste, kapok) manufacturing",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION":
        "Appliqueing on textile products (except apparel)",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Art needlework contractors on apparel",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Art needlework on clothing for the trade",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION":
        "Automotive pad and upholstery filling (except foam rubber and plastics) manufacturing",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Badges, fabric, manufacturing",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Bags, sleeping, manufacturing",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION":
        "Banners made from purchased fabrics (except banner printing)",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION":
        "Batts and batting (except nonwoven fabrics) manufacturing",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION":
        "Beading on textile products (except apparel) for the trade",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Belting made from purchased fabrics",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Bias bindings made from purchased fabrics",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Binding carpets and rugs for the trade",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Bindings, bias, made from purchased fabrics",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Bows made from purchased fabrics",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Burnt-out laces manufacturing",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Carpet cutting and binding",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION":
        "Cotton battings (except nonwoven batting) manufacturing",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Crochet ware made from purchased materials",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Decorative stitching contractors on apparel",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION":
        "Decorative stitching on textile articles and apparel",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION":
        "Diapers (except disposable) made from purchased fabrics",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Dust cloths made from purchased fabrics",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Embroidering contractors on apparel",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION":
        "Embroidering on textile products or apparel for the trade",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION":
        "Fiber, textile recovery from textile mill waste and rags",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION":
        "Filling (except nonwoven textile), upholstery, manufacturing",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION":
        "Fire hose, textile, made from purchased materials",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Fishing nets made from purchased materials",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION":
        "Flags, textile (e.g., banners, bunting, emblems, pennants), made from purchased fabrics",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Furniture trimmings made from purchased fabrics",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Garnetting of textile waste and rags",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Hammocks, fabric, manufacturing",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Lace, burnt-out, manufacturing",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Laundry nets made from purchased materials",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Linings, casket, manufacturing",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Linings, luggage, manufacturing",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Luggage linings manufacturing",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Military insignia, textile, manufacturing",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Mill menders, contract, woven fabrics",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Needlework art contractors on apparel",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Novelty stitching contractors on apparel",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION":
        "Padding and wadding (except nonwoven fabric) manufacturing",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Parachutes manufacturing",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Powder puffs and mitts manufacturing",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION":
        "Processing of textile mill waste and recovering fibers",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Quilting of textiles",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Reclaimed wool processing",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Recovered fibers processing",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Ribbons made from purchased fabrics",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Sleeping bags manufacturing",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION":
        "Stitching, decorative and novelty, contractors on apparel",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION":
        "Stitching, decorative and novelty, on textile articles and apparel",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Tassels manufacturing",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Textile fire hose made from purchased material",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION":
        "Upholstering filling (except nonwoven fabric) manufacturing",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Weatherstripping made from purchased textiles",
    },
    {
      NAICS22: "314999",
      "INDEX ITEM DESCRIPTION": "Wool waste processing",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION":
        "Anklets, sheer hosiery or socks, knitting or knitting and finishing",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION":
        "Athletic clothing made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION":
        "Athletic socks knitting or knitting and finishing",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Bathing suits made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Bathrobes made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Beachwear made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Blouses made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Body stockings made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Boys' socks manufacturing",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION":
        "Briefs, underwear, made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION":
        "Calf high sheer hosiery knitting or knitting and finishing",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Caps made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Chemises made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Children's socks manufacturing",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION":
        "Clerical vestments made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION":
        "Collar and cuff sets made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Crew socks knitting or knitting and finishing",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION":
        "Drawers, apparel, made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION":
        "Dress and semidress gloves made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Dresses made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Dresses, hand-knit, manufacturing",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Ensemble dresses made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION":
        "Footies, sheer, knitting or knitting and finishing",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION":
        "Girdles and other foundation garments made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION":
        "Girls' hosiery, sheer, full-length and knee-length, knitting or knitting and finishing",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Girls' socks manufacturing",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Gloves, knit, made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Hats made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION":
        "Hosiery, sheer, women's, misses', and girls' full-length and knee-length, knitting or knitting and finishing",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION":
        "Hosiery, women's, girls', and infants', manufacturing",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Housecoats made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Jackets made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Jerseys made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Jogging suits made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Knit gloves made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Leggings knitting or knitting and finishing",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Leotards made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION":
        "Lounging robes and dressing gowns made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Men's socks knitting or knitting and finishing",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Mittens, knit, made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Mufflers made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Neckties made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Neckwear made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Negligees made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Nightgowns made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Nightshirts made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Nightwear made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION":
        "Nylon hosiery, sheer, women's, misses', and girls' full-length and knee-length, knitting or knitting and finishing",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION":
        "Nylons, sheer, women's, misses', and girls' full-length and knee-length, knitting or knitting and finishing",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Outerwear handknitted for the trade",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Pajamas made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Panties made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Pants, athletic, made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION":
        "Pants, outerwear, made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION":
        "Panty hose, women's and girls', knitting or knitting and finishing",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Polo shirts made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Prayer shawls made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Robes, lounging, made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Scarves made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION":
        "Shirts, outerwear, made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION":
        "Shirts, underwear, made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION":
        "Shorts, outerwear, made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION":
        "Shorts, underwear, made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Ski pants made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Ski suits made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Skirts made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Slacks made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION":
        "Slacks, jean-cut casual, made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Slipper socks made in sock mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Slips made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Snowsuits made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Socks knitting or knitting and finishing",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Socks, men's and boy's, manufacturing",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Socks, slipper, made in sock mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Sports clothing made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Sports shirts made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Stockings, sheer, manufacturing",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION":
        "Stockings, sheer, women's, misses', and girls', full-length and knee-length, knitting or knitting and finishing",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Suits made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Sweat bands made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Sweat pants made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Sweat suits made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Sweater jackets made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Sweater vests made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Sweaters made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Sweatshirts made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Swimsuits made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION":
        "Tank tops, outerwear, made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION":
        "Tank tops, underwear, made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Tennis shirts made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Tennis skirts made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Ties made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Tights knitting or knitting and finishing",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Trousers made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION":
        "T-shirts, outerwear, made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION":
        "T-shirts, underwear, made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Underwear made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Underwear shirts made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Underwear shorts made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION":
        "Uniforms, nontailored, made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Union suits made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION": "Warmup suits made in apparel knitting mills",
    },
    {
      NAICS22: "315120",
      "INDEX ITEM DESCRIPTION":
        "Work gloves and mittens, knit, made in apparel knitting mills",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Apparel cut and sew contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Apparel trimmings and findings cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Apparel, fur, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Appliqueing on apparel",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Aprons, waterproof (including rubberized fabric, plastics), cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Aprons, work (except leather), cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Arm bands cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Ascots cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Athletic clothing cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Athletic uniforms, team, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Bakers' service apparel, washable, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Band uniforms cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Bandeaux cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Barbers' service apparel, washable, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Baseball caps (except plastics) cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Baseball uniforms cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Basketball uniforms cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Bathing suits cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Bathrobes cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Beachwear cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Bedjackets cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Belts, apparel (e.g., fabric, leather, vinyl), cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Belts, money, any material, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Bibs and aprons, waterproof (e.g., plastics, rubber, similar materials), cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Blouses cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Body stockings cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Bow ties cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Bra-slips cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Brassieres cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Bridal dresses or gowns cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Briefs cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Buntings cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Burial garments cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Buttonhole making apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Buttonhole making, fur goods, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Buttonholing and button covering apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Caftans cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Camisoles cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Capes cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Caps (i.e., apparel accessory) cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Caps and gowns, academic, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Caps, textiles, straw, fur-felt, and wool-felt, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Chauffeurs' hats and caps cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Chemises cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Clerical vestments cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Clothing, fur, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Clothing, leather or sheep-lined, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Clothing, water resistant, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Clothing, waterproof, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Clothing, water-repellent, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Coat linings, fur, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Coat trimmings, fabric, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Coats (e.g., tailored, fur, artificial leather, leather, sheep-lined), cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Coats, nontailored service apparel (e.g., laboratory, medical, mechanics'), cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Coats, waterproof (i.e., plastics, rubberized fabric, similar materials), cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Collar and cuff sets cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Contractors, cut and sew apparel",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Corselets cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Corsets and allied garments (except surgical) cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Costumes (e.g., lodge, masquerade, theatrical) cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Coveralls, work, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Culottes cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Cummerbunds cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Cutting fabric owned by others for apparel",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Diaper covers, water resistant and waterproof, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Dickeys cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Down-filled clothing cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Drawers cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Dress and semidress gloves cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Dress trimmings cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Dresses cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Dressing gowns cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Dungarees cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Dusters (i.e., apparel) cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Ensemble dresses cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Eyelet making contractors on apparel",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Feather-filled clothing cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Field jackets, military, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Findings, suit and coat (e.g., coat fronts, pockets), cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Firefighters' dress uniforms cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Flannel shirts cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Formal jackets cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Foundation garments cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Fur accessories and trimmings cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Fur apparel (e.g., capes, coats, hats, jackets, neckpieces) cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Fur clothing cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Fur finishers, liners, and buttonhole makers cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Fur plates and trimmings cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Garments, leather or sheep-lined, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Garter belts cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Garters cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Girdles cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Glove linings, fur, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Gloves and mittens (except athletic), leather, fabric, fur, or combinations, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Gloves and mittens, woven or knit, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Gowns (e.g., academic, choir, clerical) cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Gowns, formal, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Gowns, hospital, surgical and patient, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Gowns, wedding, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Graduation caps and gowns cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Handkerchiefs (except paper) cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Hat bodies (e.g., fur-felt, straw, wool-felt) cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Hat findings cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Hat linings and trimmings cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Hats (e.g., cloth, fur, fur-felt, leather, straw, wool-felt) cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Hats, trimmed, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Headbands cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Hemstitching apparel contractors on apparel",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Hospital service apparel, washable, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Housecoats cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Housedresses cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Hunting coats and vests cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Industrial garments cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Infants' cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Jackets cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Jackets, fur, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Jackets, leather (except welders') or sheep-lined, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Jackets, service apparel (e.g., laboratory, medical), cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Jackets, ski, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Jean-cut casual slacks cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Jeans cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Jerseys cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Jogging suits cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Jumpsuits cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Knickers cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Knit gloves cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Laboratory coats cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Leather apparel (e.g., capes, coats, hats, jackets) cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Leather clothing cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Leather gloves or mittens (except athletic) cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Leggings cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Leotards cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Lingerie cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Linings, hat, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Lounging robes and dressing gowns cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Mackinaws cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Maternity bras and corsets cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Medical service apparel cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Melton jackets cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Middies cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Military dress uniforms cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Millinery cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Millinery trimmings cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Mittens (e.g., leather, woven or knit) cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Mufflers cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Neckpieces, fur, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Neckties cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Neckwear cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Negligees cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Nightgowns cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Nightshirts cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Nightwear cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Opera hats cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Overall jackets, work, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Overalls, work, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Overcoats cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Pajamas cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Panama hats cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Panties cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Pants (e.g., athletic, dress, leather, sweat, waterproof outerwear, work) cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Pants outfits cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Pantsuits cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Panty girdles cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Paper dresses cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Plastics gowns cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Plastics rainwear cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Playsuits cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Pleating contractors on apparel",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Pockets (e.g., coat, suit) cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Police caps and hats (except protective head gear) cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Police uniforms cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Polo shirts cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Ponchos and similar waterproof raincoats cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Prayer shawls cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Professional service apparel, washable, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Raincoats (e.g., water resistant, waterproof, water-repellent) cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Riding clothes cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Robes, lounging, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Rompers cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Scarves cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Service apparel, washable, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Sewing fabric owned by others for apparel",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Shirts, outerwear, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Shirts, underwear, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Shorts, outerwear, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Shorts, underwear, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Ski pants cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Ski suits cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Skirts cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Slacks cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Slacks, jean-cut casual, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Slips cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Snowsuits cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Sport coats cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Sport coats, fur, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Sport coats, leather (including artificial and tailored), cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Sport shirts cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Sports clothing cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Suit trimmings cut and sew  apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Suits (i.e., nontailored, tailored, work) cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Suspenders cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Sweat bands cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Sweat pants cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Sweat suits cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Sweater jackets cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Sweater vests cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Sweaters cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Sweatshirts cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Swimsuits cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Tailored dress and sport coats cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Tank tops cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Team athletic uniforms cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Teddies cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Tennis shirts cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Tennis skirts cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Theatrical costumes cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Ties cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Topcoats cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Training pants (i.e., underwear) cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Trimmings, fur, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Trousers cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "T-shirts, outerwear, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "T-shirts, underwear, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Tuxedos cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Underwear cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Underwear shirts cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Underwear shorts cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Uniform hats and caps cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Uniform shirts cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Uniforms, band, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Uniforms, dress (e.g., military, police, firefighter), cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Uniforms, nontailored, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Uniforms, team athletic, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Union suits cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Vestments, academic and clerical, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Vests cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Vests, leather, fur, or sheep-lined, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Warmup suits cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Washable service apparel (e.g., barbers', hospital, professional) cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Water resistant apparel cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Water resistant outerwear cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Waterproof outerwear cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Water-repellent outerwear cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Wedding dresses cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Windbreakers cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Work coats and jackets cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION":
        "Work gloves, leather, cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Work pants cut and sew apparel contractors",
    },
    {
      NAICS22: "315210",
      "INDEX ITEM DESCRIPTION": "Work shirts cut and sew apparel contractors",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Apparel, fur (except apparel contractors), manufacturing",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Aprons, work (except leather, waterproof), men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Aprons, work (except waterproof, leather), women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Athletic clothing, men's, boys' and unisex (i.e., sized without regard to gender), cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Athletic clothing, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Athletic uniforms, team, cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Bakers' service apparel, washable, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Bakers' service apparel, washable, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Band uniforms cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Bandeaux, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Barbers' service apparel, washable, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Baseball uniforms cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Basketball uniforms cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Bathing suits, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Bathing suits, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Bathrobes, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Bathrobes, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Beachwear, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Beachwear, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Bedjackets, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Blouses, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Body stockings, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Bra-slips, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Brassieres cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION": "Bridal dresses or gowns, custom made",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Bridal dresses or gowns, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Briefs, underwear, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Briefs, underwear, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Buntings, infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Burial garments cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Caftans, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Caftans, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Camisoles, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Capes, fur (except apparel contractors), manufacturing",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Capes, waterproof (e.g., plastics, rubber, similar materials), cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Capes, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Caps and gowns, academic, cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Caps, fur (except apparel contractors), manufacturing",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Caps, leather (except apparel contractors), manufacturing",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Chemises, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Clerical vestments cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Clothing, fur (except apparel contractors), manufacturing",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Clothing, leather or sheep-lined (except apparel contractors), manufacturing",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Clothing, water resistant, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Clothing, water resistant, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Clothing, waterproof, cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Clothing, water-repellent, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Clothing, water-repellent, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Coat linings, fur (except apparel contractors), manufacturing",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Coats (including tailored), leather or sheep-lined (except apparel contractors), manufacturing",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Coats, artificial leather, cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Coats, fur (except apparel contractors), manufacturing",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Coats, leather (except apparel contractors), manufacturing",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Coats, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Coats, nontailored service apparel (e.g., laboratory, mechanics', medical), men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Coats, nontailored service apparel (e.g., laboratory, medical, mechanics'), women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Coats, tailored, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Coats, tailored, women's and girls', cut and sewn from purchased fabric",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Coats, waterproof (e.g., plastics, rubberized fabric, similar materials), cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Coats, waterproof (e.g., plastics, rubberized fabric, similar materials), rubberizing fabric and manufacturing coats",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Coats, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Collar and cuff sets, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Corselets, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Corsets and allied garments (except surgical), women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Costumes (e.g., lodge, masquerade, theatrical) cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Coveralls, work, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Coveralls, work, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Culottes, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Custom tailors, men's and boys' dress shirts, cut and sewn from purchased fabric",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Custom tailors, men's and boys' suits, cut and sewn from purchased fabric",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Custom tailors, women's and girls' dresses cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Diaper covers, infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Dickeys, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Down-filled clothing, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Down-filled clothing, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Drawers, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Drawers, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Dresses, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Dressing gowns, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Dungarees, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Dungarees, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Dusters (i.e., apparel), women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Ensemble dresses, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Feather-filled clothing, jackets, and vests, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Feather-filled clothing, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Field jackets, military, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Firefighters' dress uniforms, men's, cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Firefighters' dress uniforms, women's, cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Flannel shirts, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Flannel shirts, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Formal jackets, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Foundation garments, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Fur accessories and trimmings (except apparel contractors) manufacturing",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Fur apparel (e.g., capes, coats, hats, jackets, neckpieces) (except apparel contractors) manufacturing",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Fur clothing (except apparel contractors) manufacturing",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Fur plates and trimmings (except apparel contractors) manufacturing",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Garments, leather or sheep-lined (except apparel contractors), manufacturing",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Garter belts cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Garters, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Girdles, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION": "Glazing furs",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Glove linings, fur (except apparel contractors), manufacturing",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Gowns (e.g., academic, choir, clerical) cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Gowns, formal, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Gowns, hospital, surgical and patient, cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Gowns, wedding, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Graduation caps and gowns cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Hats, fur (except apparel contractors), manufacturing",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Hats, leather (except apparel contractors), manufacturing",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Hospital service apparel, washable, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Hospital service apparel, washable, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Housecoats, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Housedresses, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Hunting coats and vests, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Industrial garments, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Industrial garments, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Infants' apparel cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Infants' water resistant outerwear cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Jackets, fur (except apparel contractors), manufacturing",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Jackets, leather (except welders') or sheep-lined (except apparel contractors), manufacturing",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Jackets, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Jackets, service apparel (e.g., laboratory, medical), men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Jackets, service apparel (e.g., laboratory, medical), women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Jackets, ski, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Jackets, ski, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Jackets, tailored, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Jackets, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Jean-cut casual slacks, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Jean-cut casual slacks, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Jeans, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Jerseys, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Jerseys, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Jogging suits, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Jogging suits, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Jumpsuits, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Knickers, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Knickers, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Laboratory coats, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Laboratory coats, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Leather apparel (e.g., capes, coats, hats, jackets) (except apparel contractors) manufacturing",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Leather clothing (except apparel contractors) manufacturing",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Leggings, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Leotards, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Lingerie, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Lounging robes and dressing gowns, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Lounging robes and dressing gowns, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Mackinaws, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Mackinaws, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Maternity bras and corsets, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Medical service apparel, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Medical service apparel, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Melton jackets, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Melton jackets, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Middies, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Military dress uniforms, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Military dress uniforms, tailored, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Neckpieces, fur (except apparel contractors), manufacturing",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Negligees, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Nightgowns, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Nightgowns, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Nightshirts, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Nightshirts, women's, girls', and infants', cut and sewn from purchased fabric (except contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Nightwear, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Nightwear, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Overall jackets, work, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Overalls, work, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Overcoats, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Overcoats, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Pajamas, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Pajamas, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Panties, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Pants (e.g., athletic, dress, sweat, work), men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Pants outfits, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Pants, athletic, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Pants, leather (except apparel contractors), manufacturing",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Pants, rubber and rubberized fabric, made in the same establishment as the basic material",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Pants, sweat, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION": "Pants, vulcanized rubber, manufacturing",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Pants, waterproof outerwear, cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Pants, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Pantsuits, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Panty girdles, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Paper dresses, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Plastics gowns cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Plastics rainwear cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Playsuits, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION": "Pointing furs",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Police dress uniforms, men's, cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Police dress uniforms, women's, cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Polo shirts, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Polo shirts, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Ponchos and similar waterproof raincoats cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Prayer shawls cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Professional service apparel, washable, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Professional service apparel, washable, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Raincoats, rubber or rubberized fabric, manufacturing",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Raincoats, water resistant, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Raincoats, water resistant, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Raincoats, waterproof, cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Raincoats, water-repellent, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Raincoats, water-repellent, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Riding clothes, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Riding clothes, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Robes, lounging, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Robes, lounging, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Rompers, infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Service apparel, washable, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Service apparel, washable, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Shirts, outerwear, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Shirts, outerwear, unisex (i.e., sized without regard to gender), cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Shirts, outerwear, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Shirts, underwear, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Shirts, underwear, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Shorts, outerwear, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Shorts, outerwear, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Shorts, underwear, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Ski pants, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Ski pants, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Ski suits, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Ski suits, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Skirts, tennis, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Skirts, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Slacks, jean-cut casual, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Slacks, jean-cut casual, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Slacks, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Slacks, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Slips, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Snowsuits, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Snowsuits, women's, girls, and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Sport coats, fur (except apparel contractors), manufacturing",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Sport coats, leather (including artificial and tailored) (except apparel contractors), manufacturing",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Sport coats, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Sport shirts, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Sports clothing, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Sports clothing, team uniforms, cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Sports clothing, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Suits (e.g., jogging, snowsuit, warmup), women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Suits, nontailored (e.g., jogging, snow, ski, warmup), men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Suits, tailored, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Suits, tailored, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Sunsuits, infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Sweat bands cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Sweat pants, men's, boys', and unisex (i.e., sized without regard to gender), cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Sweat pants, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Sweat suits, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Sweat suits, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Sweater jackets, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Sweater jackets, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Sweater vests, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Sweater vests, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Sweaters, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Sweaters, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Sweatshirts, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Sweatshirts, outerwear, unisex (sized without regard to gender), cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Sweatshirts, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Swimsuits, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Swimsuits, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Tailored dress and sport coats, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Tank tops, outerwear, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Tank tops, underwear, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Tank tops, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Team athletic uniforms cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Teddies, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Tennis shirts, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Tennis shirts, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Tennis skirts, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Theatrical costumes cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Topcoats, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Training pants (i.e., underwear), infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Trimmings, fur (except apparel contractors), manufacturing",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Trousers, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "T-shirts, outerwear, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "T-shirts, outerwear, unisex (i.e., sized without regard to gender), cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "T-shirts, outerwear, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "T-shirts, underwear, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "T-shirts, underwear, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Tuxedos cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Underwear shirts, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Underwear shirts, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Underwear shorts, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Underwear shorts, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Underwear, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Underwear, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Uniform shirts, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Uniform shirts, team athletic, cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Uniform shirts, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Uniforms, band, cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Uniforms, dress (e.g., firefighter, military, police), men's, cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Uniforms, dress, tailored (e.g., firefighter, military, police), women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Uniforms, nontailored, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Uniforms, nontailored, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Uniforms, team athletic, cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Union suits, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Union suits, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Vestments, academic and clerical, cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Vests, leather, fur, or sheep-lined (except apparel contractors), manufacturing",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Vests, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Vests, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Warmup suits, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Warmup suits, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Washable service apparel (e.g., barbers', hospital, professional), men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Washable service apparel, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Water resistant jackets and windbreakers, nontailored, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Water resistant jackets and windbreakers, nontailored, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Water resistant outerwear, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Water resistant outerwear, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Water resistant overcoats, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Water resistant overcoats, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Waterproof outerwear cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Waterproof outerwear, rubberizing fabric and manufacturing outerwear",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Water-repellent outerwear, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Water-repellent outerwear, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Water-repellent overcoats, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Water-repellent overcoats, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Wedding dresses, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Windbreakers, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Windbreakers, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Work coats and jackets, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Work pants, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315250",
      "INDEX ITEM DESCRIPTION":
        "Work shirts, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Apparel findings and trimmings cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Aprons, waterproof (e.g., plastics, rubberized fabric), rubberizing fabric and manufacturing aprons",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Aprons, waterproof (including rubberized fabric, plastics), cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Arm bands, elastic, cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Ascots, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Baseball caps cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION": "Bathing caps, rubber, manufacturing",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Belts, apparel (e.g., fabric, leather, vinyl), cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Belts, money, any material, cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Bibs and aprons, waterproof (e.g., plastics, rubber, similar materials), cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Bibs and aprons, waterproof (e.g., plastics, rubber, similar materials), rubberizing fabric and manufacturing bibs and aprons",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Bow ties, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Caps (except fur, leather) cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Caps (i.e., apparel accessory) cut and sewn from purchased fabric (except fur, leather, apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Caps, textiles, straw, fur-felt, and wool-felt, cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Chauffeurs' hats and caps cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Coat trimmings fabric cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Cummerbunds cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Dress and semidress gloves cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Dress trimmings cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Findings, suit and coat (e.g., coat fronts, pockets), cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION": "Glove linings (except fur) manufacturing",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Gloves and mittens (except athletic), leather, fabric, fur, or combinations, cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Gloves and mittens, woven or knit, cut and sewn from purchased fabric (except apparel contractors), manufacturing",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Gloves, leather (except athletic, cut and sewn apparel contractors), manufacturing",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Handkerchiefs (except paper) cut and sewn from purchased fabric",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION": "Harvest hats, straw, manufacturing",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Hat bodies (e.g., fur-felt, straw, wool-felt) cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Hat findings cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Hat linings and trimmings cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Hats (except fur, knitting mill products, leather) cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Hats, cloth, cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Hats, fur-felt, straw, and wool-felt, cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Hats, trimmed, cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Headbands, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Knit gloves cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Leather gloves or mittens (except athletic, cut and sewn apparel contractors) manufacturing",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Linings, hat, men's, cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Millinery cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Millinery trimmings cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Mittens cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Mittens, leather (except apparel contractors), manufacturing",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Mittens, woven or knit, cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Mufflers cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Neckties cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Neckwear cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Opera hats cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Panama hats cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Police caps and hats (except protective head gear) cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Scarves cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION": "Straw hats manufacturing",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Suit trimmings cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Suspenders cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Ties, men's and boys' hand sewn (except apparel contractors), manufacturing",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Uniform hats and caps cut and sewn from purchased fabric (except apparel contractors)",
    },
    {
      NAICS22: "315990",
      "INDEX ITEM DESCRIPTION":
        "Work gloves, leather (except apparel contractors), manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Bag leather manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Belting butts, curried or rough, manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Belting leather, manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Bookbinder's leather manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Bridle leather manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Buffings, russet, manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Case leather manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Chamois leather manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Collar leather, manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Coloring leather",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Converters, leather",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Currying furs",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Currying leather",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Cutting of leather",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION":
        "Dressing (i.e., bleaching, blending, currying, scraping, tanning) furs",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Dressing hides",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Dyeing furs",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Dyeing leather",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Embossing leather",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Exotic leathers manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Fancy leathers manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Finishing hides and skins on a contract basis",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Finishing leather",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION":
        "Fleshers, leather (i.e., flesh side of split leather), manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Fur stripping",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION":
        "Furs, dressed (e.g., bleached, curried, dyed, scraped, tanned), manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Garment leather manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Glove leather manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Handbag leather manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Harness leather manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Hides and skins, finishing on a contract basis",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION":
        "Hides, tanning, currying, dressing, and finishing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Japanning of leather",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Lace leather manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Latigo leather manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION":
        "Leather coloring, cutting, embossing, and japanning",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Leather converters",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Leather tanning, currying, and finishing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Lining leather manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Mechanical leather manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Parchment leather manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Patent leather manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION":
        "Pelts bleaching, currying, dyeing, scraping, and tanning",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Rawhide manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Roller leather manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Saddlery leather manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION":
        "Shearling (i.e., prepared sheepskin) manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Skins, tanning, currying and finishing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Skirting leather manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Skivers, leather, manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Slitting leather for the trade",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Sole leather manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Specialty leathers manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Splits, leather, manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Strap leather manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Sweatband leather manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Tannery leather manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Tanning and currying furs",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Upholstery leather manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Upper leather manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Vellum leather manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Welting leather manufacturing",
    },
    {
      NAICS22: "316110",
      "INDEX ITEM DESCRIPTION": "Wet blues manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Arctics, plastics or plastics soled fabric upper, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Arctics, rubber or rubber soled fabric, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "Athletic shoes manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Athletic shoes, plastics or plastics soled fabric upper, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Athletic shoes, rubber or rubber soled fabric upper, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "Ballet slippers manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Beach sandals, plastics or plastics soled fabric upper, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Beach sandals, rubber or rubber soled fabric upper, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Boots, dress and casual, children's and infants', manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "Boots, dress and casual, men's, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "Boots, dress and casual, women's, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Boots, hiking, children's and infants', manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "Boots, hiking, men's, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "Boots, hiking, women's, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Boots, plastics or plastics soled fabric upper, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Boots, rubber or rubber soled fabric upper, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Canvas shoes, plastics soled fabric upper, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Canvas shoes, rubber soled fabric upper, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Casual shoes, children's and infants', manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "Casual shoes, men's, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "Casual shoes, women's, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Children's shoes (except orthopedic extension) manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "Cleated athletic shoes manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Climbing shoes, plastics or plastics soled fabric upper, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Climbing shoes, rubber or rubber soled fabric upper, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Dress shoes, children's and infants', manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "Dress shoes, men's, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "Dress shoes, women's, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Footholds, plastics or plastics soled fabric upper, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Footholds, rubber or rubber soled fabric upper, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "Footwear, athletic, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Footwear, children's (except orthopedic extension), manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Footwear, children's, leather or vinyl upper with rubber or plastics soles, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Footwear, men's (except orthopedic extension), manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Footwear, men's leather or vinyl upper with rubber or plastics soles, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Footwear, plastics or plastics soled fabric uppers, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Footwear, women's (except orthopedic extension), manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Footwear, women's leather or vinyl upper with rubber or plastics soles, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Gaiters, plastics or plastics soled fabric upper, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Gaiters, rubber or rubber soled fabric upper, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Galoshes, plastics or plastics soled fabric upper, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Galoshes, rubber, or rubber soled fabric upper, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "Golf shoes, men's cleated, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "Golf shoes, women's cleated, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "House slippers manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "House slippers, plastics or plastics soled fabric upper, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "House slippers, rubber or rubber soled fabric upper, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "Infant's shoes manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "Leather footwear manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "Leather footwear, men's, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "Leather footwear, slippers, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "Leather footwear, women's, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "Leather house slippers manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "Leather upper athletic footwear manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "Moccasins manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Orthopedic shoes (except extension shoes), children's, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Orthopedic shoes (except extension shoes), men's, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Orthopedic shoes (except extension shoes), women's, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Overshoes, plastics or plastics soled fabric upper, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Overshoes, rubber, or rubber soled fabric, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Pacs, plastics or plastics soled fabric upper, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Pacs, rubber or rubber soled fabric upper, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Protective footwear, plastics or plastics soled fabric upper, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Protective footwear, rubber or rubber soled fabric upper, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "Pumps (i.e., dress shoes) manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "Sandals, children's, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "Sandals, men's footwear, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Sandals, plastics or plastics soled fabric upper, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Sandals, rubber or rubber soled fabric upper, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "Sandals, women's footwear, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "Shoes, athletic, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "Shoes, ballet, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Shoes, children's and infant's (except orthopedic extension), manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Shoes, cleated or spiked, all materials, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Shoes, men's (except orthopedic extension), manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Shoes, plastics or plastics soled fabric upper, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Shoes, rubber or rubber soled fabric upper, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "Shoes, theatrical, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Shoes, women's (except orthopedic extension), manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "Shoes, wooden, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Shower sandals or slippers, rubber, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "Slipper socks made from purchased socks",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "Slippers, ballet, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "Slippers, house, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "Socks, slipper, made from purchased socks",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "Vinyl upper athletic footwear manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Water shoes, plastics or plastics soled fabric upper, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION":
        "Water shoes, rubber or rubber soled fabric upper, manufacturing",
    },
    {
      NAICS22: "316210",
      "INDEX ITEM DESCRIPTION": "Work shoes manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION":
        "Aprons for textile machinery, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION":
        "Aprons, leather (e.g., blacksmith's, welder's), manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Attache cases, all materials, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION":
        "Bags (i.e., luggage), all materials, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Bags, athletic, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Belt laces, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Belting for machinery, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Belts, leather safety, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Billfolds (except metal) manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Binocular cases manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Blacksmith's aprons, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION":
        "Boot and shoe cut stock and findings, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Bows, shoe, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION":
        "Box toes (i.e., shoe cut stock), leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION":
        "Boxes, hat (except paper or paperboard), manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Boxes, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Briefcases, all materials, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION":
        "Camera carrying bags, all materials, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Caps, heel and toe, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Card cases (except metal) manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Cases, jewelry (except metal), manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Cases, luggage, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Cases, musical instrument, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Checkbook covers (except metal) manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Cigar cases (except metal) manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Cigarette cases (except metal) manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Clasps, shoe (leather), manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Coin purses (except metal) manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION":
        "Collars and collar pads (i.e., harness) manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Collars, dog, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Comb cases (except metal) manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Compacts, solid leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Corners, luggage, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Cosmetic bags (except metal) manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION":
        "Counters (i.e., shoe cut stock), leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Crops, riding, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Cut stock for boots and shoes manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Desk sets, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION":
        "Dog furnishings (e.g., collars, harnesses, leashes, muzzles) manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Eyeglass cases (except metal) manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Feed bags for horses manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Findings, boot and shoe, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION":
        "Handbags, all materials (except precious metal), manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION":
        "Handles (e.g., luggage, whip), leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION":
        "Harnesses and harness parts, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Harnesses, dog, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Heel caps, leather or metal, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Heel lifts, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Heels, boot and shoe, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Holsters, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Horse boots and muzzles manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Inner soles, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Jackets, welder's, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Key cases (except metal) manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Laces (e.g., shoe), leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Lashes (i.e., whips) manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Leashes, dog, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Leather belting manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION":
        "Leather cut stock for shoe and boot manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION":
        "Leather goods, small personal (e.g., coin purses, eyeglass cases, key cases), manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Leather handbags and purses manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Leather luggage manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Leather welting manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Leggings, welder's, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Lifts, heel, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Linings, boot and shoe, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Luggage, all materials, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION":
        "Mill strapping for textile mills, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION":
        "Musical instrument cases, all materials, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION":
        "Novelties, leather (e.g., cigarette lighter covers, key fobs), manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Pegs, leather shoe, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION":
        "Personal leather goods (e.g., coin purses, eyeglass cases, key cases), small, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Purses (except precious metal) manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION":
        "Quarters (i.e., shoe cut stock), leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION":
        "Rands (i.e., shoe cut stock), leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Razor strops manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Riding crops manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Saddles and parts, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Safety belts, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Sample cases, all materials, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Satchels, all materials, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Seatbelts, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Sewing cases (except metal) manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Shanks, shoe, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION":
        "Shoe kits (i.e., cases), all materials, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Shoe soles, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Sleeves, welder's, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Soles, boot and shoe, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Spats, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Stays, shoe, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Straps, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Straps, watch (except metal), manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Suitcases, all materials, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Taps, shoe, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION":
        "Textile leathers (e.g., apron picker leather, mill strapping) manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Tips, shoe, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Tobacco pouches (except metal) manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Toe caps, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION":
        "Toilet kits and cases (except metal) manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Tongues, boot and shoe, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION":
        "Top lifts, boot and shoe, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Transmission belting, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Traveling bags, all materials, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Trimmings, shoe, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION":
        "Trunks (i.e., luggage), all materials, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION":
        "Uppers (i.e., shoe cut stock), leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Valises, all materials, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Vamps, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Vanity cases, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Wallets (except metal) manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Wardrobe bags (i.e., luggage) manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Watch bands (except metal) manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Welders' aprons, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION":
        "Welders' jackets, leggings, and sleeves, leather, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Whips, horse, manufacturing",
    },
    {
      NAICS22: "316990",
      "INDEX ITEM DESCRIPTION": "Whipstocks manufacturing",
    },
    {
      NAICS22: "321113",
      "INDEX ITEM DESCRIPTION": "Beams, wood, made from logs or bolts",
    },
    {
      NAICS22: "321113",
      "INDEX ITEM DESCRIPTION": "Boards, wood, made from logs or bolts",
    },
    {
      NAICS22: "321113",
      "INDEX ITEM DESCRIPTION": "Ceiling lumber, made from logs or bolts",
    },
    {
      NAICS22: "321113",
      "INDEX ITEM DESCRIPTION": "Chipper mills (except portable)",
    },
    {
      NAICS22: "321113",
      "INDEX ITEM DESCRIPTION": "Custom sawmills",
    },
    {
      NAICS22: "321113",
      "INDEX ITEM DESCRIPTION":
        "Dimension lumber, hardwood, made from logs or bolts",
    },
    {
      NAICS22: "321113",
      "INDEX ITEM DESCRIPTION": "Dimension lumber, made from logs or bolts",
    },
    {
      NAICS22: "321113",
      "INDEX ITEM DESCRIPTION":
        "Dimension lumber, softwood, made from logs or bolts",
    },
    {
      NAICS22: "321113",
      "INDEX ITEM DESCRIPTION": "Flitches (i.e., veneer stock) made in sawmills",
    },
    {
      NAICS22: "321113",
      "INDEX ITEM DESCRIPTION":
        "Lumber (i.e., rough, dressed) made from logs or bolts",
    },
    {
      NAICS22: "321113",
      "INDEX ITEM DESCRIPTION":
        "Lumber, hardwood dimension, made from logs or bolts",
    },
    {
      NAICS22: "321113",
      "INDEX ITEM DESCRIPTION":
        "Lumber, softwood dimension, made from logs or bolts",
    },
    {
      NAICS22: "321113",
      "INDEX ITEM DESCRIPTION": "Poles, wood, made from log or bolts",
    },
    {
      NAICS22: "321113",
      "INDEX ITEM DESCRIPTION":
        "Pressure treated lumber made from logs or bolts and treated",
    },
    {
      NAICS22: "321113",
      "INDEX ITEM DESCRIPTION":
        "Sawdust and shavings (i.e., sawmill byproducts) manufacturing",
    },
    {
      NAICS22: "321113",
      "INDEX ITEM DESCRIPTION": "Sawed lumber made in sawmills",
    },
    {
      NAICS22: "321113",
      "INDEX ITEM DESCRIPTION": "Sawmills",
    },
    {
      NAICS22: "321113",
      "INDEX ITEM DESCRIPTION":
        "Shakes (i.e., hand split shingles) manufacturing",
    },
    {
      NAICS22: "321113",
      "INDEX ITEM DESCRIPTION": "Shingle mills, wood",
    },
    {
      NAICS22: "321113",
      "INDEX ITEM DESCRIPTION":
        "Shingles, wood, sawed or hand split, manufacturing",
    },
    {
      NAICS22: "321113",
      "INDEX ITEM DESCRIPTION": "Siding mills, wood",
    },
    {
      NAICS22: "321113",
      "INDEX ITEM DESCRIPTION": "Siding, dressed lumber, manufacturing",
    },
    {
      NAICS22: "321113",
      "INDEX ITEM DESCRIPTION": "Stud mills",
    },
    {
      NAICS22: "321113",
      "INDEX ITEM DESCRIPTION": "Ties, railroad, made from logs or bolts",
    },
    {
      NAICS22: "321113",
      "INDEX ITEM DESCRIPTION": "Ties, wood, made from logs or bolts",
    },
    {
      NAICS22: "321113",
      "INDEX ITEM DESCRIPTION": "Timbers, made from logs or bolts",
    },
    {
      NAICS22: "321113",
      "INDEX ITEM DESCRIPTION": "Wood chips made in sawmills",
    },
    {
      NAICS22: "321114",
      "INDEX ITEM DESCRIPTION": "Bridge and trestle parts, wood, treating",
    },
    {
      NAICS22: "321114",
      "INDEX ITEM DESCRIPTION": "Creosoting of wood",
    },
    {
      NAICS22: "321114",
      "INDEX ITEM DESCRIPTION": "Crossties, treating",
    },
    {
      NAICS22: "321114",
      "INDEX ITEM DESCRIPTION": "Flooring, wood block, treating",
    },
    {
      NAICS22: "321114",
      "INDEX ITEM DESCRIPTION": "Millwork, treating",
    },
    {
      NAICS22: "321114",
      "INDEX ITEM DESCRIPTION": "Mine props, treating",
    },
    {
      NAICS22: "321114",
      "INDEX ITEM DESCRIPTION": "Mine ties, wood, treated, manufacturing",
    },
    {
      NAICS22: "321114",
      "INDEX ITEM DESCRIPTION":
        "Pilings, foundation and marine construction, treating",
    },
    {
      NAICS22: "321114",
      "INDEX ITEM DESCRIPTION": "Pilings, round wood, cutting and treating",
    },
    {
      NAICS22: "321114",
      "INDEX ITEM DESCRIPTION": "Pilings, wood, treating",
    },
    {
      NAICS22: "321114",
      "INDEX ITEM DESCRIPTION": "Poles, round wood, cutting and treating",
    },
    {
      NAICS22: "321114",
      "INDEX ITEM DESCRIPTION": "Poles, wood, treating",
    },
    {
      NAICS22: "321114",
      "INDEX ITEM DESCRIPTION": "Posts, round wood, cutting and treating",
    },
    {
      NAICS22: "321114",
      "INDEX ITEM DESCRIPTION": "Posts, wood, treating",
    },
    {
      NAICS22: "321114",
      "INDEX ITEM DESCRIPTION": "Preserving purchased wood and wood products",
    },
    {
      NAICS22: "321114",
      "INDEX ITEM DESCRIPTION":
        "Pressure treated lumber made from purchased lumber",
    },
    {
      NAICS22: "321114",
      "INDEX ITEM DESCRIPTION":
        "Railroad ties (i.e., bridge, cross, switch) treating",
    },
    {
      NAICS22: "321114",
      "INDEX ITEM DESCRIPTION": "Structural lumber and timber, treating",
    },
    {
      NAICS22: "321114",
      "INDEX ITEM DESCRIPTION":
        "Ties, wood railroad bridge, cross, and switch, treating",
    },
    {
      NAICS22: "321114",
      "INDEX ITEM DESCRIPTION": "Timber, structural, treating",
    },
    {
      NAICS22: "321114",
      "INDEX ITEM DESCRIPTION": "Treating purchased wood and wood products",
    },
    {
      NAICS22: "321114",
      "INDEX ITEM DESCRIPTION":
        "Treating wood products with creosote or other preservatives",
    },
    {
      NAICS22: "321114",
      "INDEX ITEM DESCRIPTION": "Trestle parts, wood, treating",
    },
    {
      NAICS22: "321114",
      "INDEX ITEM DESCRIPTION":
        "Wood fence (i.e., pickets, poling, rails), treating",
    },
    {
      NAICS22: "321114",
      "INDEX ITEM DESCRIPTION":
        "Wood products, creosoting purchased wood products",
    },
    {
      NAICS22: "321211",
      "INDEX ITEM DESCRIPTION": "Hardwood plywood composites manufacturing",
    },
    {
      NAICS22: "321211",
      "INDEX ITEM DESCRIPTION": "Hardwood veneer or plywood manufacturing",
    },
    {
      NAICS22: "321211",
      "INDEX ITEM DESCRIPTION": "Panels, hardwood plywood, manufacturing",
    },
    {
      NAICS22: "321211",
      "INDEX ITEM DESCRIPTION":
        "Plywood, faced with nonwood materials, hardwood, manufacturing",
    },
    {
      NAICS22: "321211",
      "INDEX ITEM DESCRIPTION": "Plywood, hardwood faced, manufacturing",
    },
    {
      NAICS22: "321211",
      "INDEX ITEM DESCRIPTION": "Plywood, hardwood, manufacturing",
    },
    {
      NAICS22: "321211",
      "INDEX ITEM DESCRIPTION": "Prefinished hardwood plywood manufacturing",
    },
    {
      NAICS22: "321211",
      "INDEX ITEM DESCRIPTION": "Reconstituted hardwood veneer manufacturing",
    },
    {
      NAICS22: "321211",
      "INDEX ITEM DESCRIPTION": "Veneer mills, hardwood",
    },
    {
      NAICS22: "321212",
      "INDEX ITEM DESCRIPTION": "Panels, softwood plywood, manufacturing",
    },
    {
      NAICS22: "321212",
      "INDEX ITEM DESCRIPTION":
        "Plywood, faced with nonwood materials, softwood, manufacturing",
    },
    {
      NAICS22: "321212",
      "INDEX ITEM DESCRIPTION": "Plywood, softwood faced, manufacturing",
    },
    {
      NAICS22: "321212",
      "INDEX ITEM DESCRIPTION": "Plywood, softwood, manufacturing",
    },
    {
      NAICS22: "321212",
      "INDEX ITEM DESCRIPTION": "Prefinished softwood plywood manufacturing",
    },
    {
      NAICS22: "321212",
      "INDEX ITEM DESCRIPTION": "Softwood plywood composites manufacturing",
    },
    {
      NAICS22: "321212",
      "INDEX ITEM DESCRIPTION": "Softwood veneer or plywood manufacturing",
    },
    {
      NAICS22: "321212",
      "INDEX ITEM DESCRIPTION": "Veneer mills, softwood",
    },
    {
      NAICS22: "321215",
      "INDEX ITEM DESCRIPTION":
        "Arches, glue laminated or pre-engineered wood, manufacturing",
    },
    {
      NAICS22: "321215",
      "INDEX ITEM DESCRIPTION":
        "Fabricated structural wood members manufacturing",
    },
    {
      NAICS22: "321215",
      "INDEX ITEM DESCRIPTION": "Finger joint lumber manufacturing",
    },
    {
      NAICS22: "321215",
      "INDEX ITEM DESCRIPTION": "Floor trusses, wood, manufacturing",
    },
    {
      NAICS22: "321215",
      "INDEX ITEM DESCRIPTION": "I-joists, wood, fabricating",
    },
    {
      NAICS22: "321215",
      "INDEX ITEM DESCRIPTION": "Laminated structural wood members manufacturing",
    },
    {
      NAICS22: "321215",
      "INDEX ITEM DESCRIPTION": "Laminated veneer lumber (LVL) manufacturing",
    },
    {
      NAICS22: "321215",
      "INDEX ITEM DESCRIPTION": "Lumber, parallel strand, manufacturing",
    },
    {
      NAICS22: "321215",
      "INDEX ITEM DESCRIPTION": "LVL (laminated veneer lumber) manufacturing",
    },
    {
      NAICS22: "321215",
      "INDEX ITEM DESCRIPTION": "Parallel strand lumber manufacturing",
    },
    {
      NAICS22: "321215",
      "INDEX ITEM DESCRIPTION": "Roof trusses, wood, manufacturing",
    },
    {
      NAICS22: "321215",
      "INDEX ITEM DESCRIPTION":
        "Structural members, glue laminated or pre-engineered wood, manufacturing",
    },
    {
      NAICS22: "321215",
      "INDEX ITEM DESCRIPTION":
        "Structural wood members, fabricated, manufacturing",
    },
    {
      NAICS22: "321215",
      "INDEX ITEM DESCRIPTION":
        "Timbers, structural, glue laminated or pre-engineered wood, manufacturing",
    },
    {
      NAICS22: "321215",
      "INDEX ITEM DESCRIPTION":
        "Trusses, glue laminated or pre-engineered wood, manufacturing",
    },
    {
      NAICS22: "321215",
      "INDEX ITEM DESCRIPTION": "Trusses, wood roof or floor, manufacturing",
    },
    {
      NAICS22: "321215",
      "INDEX ITEM DESCRIPTION":
        "Trusses, wood, glue laminated or metal connected, manufacturing",
    },
    {
      NAICS22: "321215",
      "INDEX ITEM DESCRIPTION": "Wood I-joists manufacturing",
    },
    {
      NAICS22: "321219",
      "INDEX ITEM DESCRIPTION": "Board, bagasse, manufacturing",
    },
    {
      NAICS22: "321219",
      "INDEX ITEM DESCRIPTION": "Board, particle, manufacturing",
    },
    {
      NAICS22: "321219",
      "INDEX ITEM DESCRIPTION":
        "Chipboard (i.e., particle core, wood chip face) manufacturing",
    },
    {
      NAICS22: "321219",
      "INDEX ITEM DESCRIPTION": "Compression modified wood manufacturing",
    },
    {
      NAICS22: "321219",
      "INDEX ITEM DESCRIPTION": "Densified wood manufacturing",
    },
    {
      NAICS22: "321219",
      "INDEX ITEM DESCRIPTION": "Fiberboard manufacturing",
    },
    {
      NAICS22: "321219",
      "INDEX ITEM DESCRIPTION": "Flakeboard manufacturing",
    },
    {
      NAICS22: "321219",
      "INDEX ITEM DESCRIPTION": "Hardboard manufacturing",
    },
    {
      NAICS22: "321219",
      "INDEX ITEM DESCRIPTION":
        "Insulation board, cellular fiber or hard pressed wood, manufacturing",
    },
    {
      NAICS22: "321219",
      "INDEX ITEM DESCRIPTION": "Lath, fiber, manufacturing",
    },
    {
      NAICS22: "321219",
      "INDEX ITEM DESCRIPTION": "MDF (medium density fiberboard) manufacturing",
    },
    {
      NAICS22: "321219",
      "INDEX ITEM DESCRIPTION": "Medium density fiberboard (MDF) manufacturing",
    },
    {
      NAICS22: "321219",
      "INDEX ITEM DESCRIPTION": "Oriented strandboard (OSB) manufacturing",
    },
    {
      NAICS22: "321219",
      "INDEX ITEM DESCRIPTION": "OSB (oriented strandboard) manufacturing",
    },
    {
      NAICS22: "321219",
      "INDEX ITEM DESCRIPTION": "Particleboard manufacturing",
    },
    {
      NAICS22: "321219",
      "INDEX ITEM DESCRIPTION": "Reconstituted wood panels manufacturing",
    },
    {
      NAICS22: "321219",
      "INDEX ITEM DESCRIPTION":
        "Reconstituted wood sheets and boards manufacturing",
    },
    {
      NAICS22: "321219",
      "INDEX ITEM DESCRIPTION": "Strandboard, oriented, manufacturing",
    },
    {
      NAICS22: "321219",
      "INDEX ITEM DESCRIPTION": "Waferboard manufacturing",
    },
    {
      NAICS22: "321911",
      "INDEX ITEM DESCRIPTION":
        "Door frames and sash, wood and covered wood, manufacturing",
    },
    {
      NAICS22: "321911",
      "INDEX ITEM DESCRIPTION": "Door jambs, wood, manufacturing",
    },
    {
      NAICS22: "321911",
      "INDEX ITEM DESCRIPTION":
        "Door units, prehung, wood and covered wood, manufacturing",
    },
    {
      NAICS22: "321911",
      "INDEX ITEM DESCRIPTION":
        "Doors, combination screen-storm, wood, manufacturing",
    },
    {
      NAICS22: "321911",
      "INDEX ITEM DESCRIPTION": "Doors, wood and covered wood, manufacturing",
    },
    {
      NAICS22: "321911",
      "INDEX ITEM DESCRIPTION": "Frames, door and window, wood, manufacturing",
    },
    {
      NAICS22: "321911",
      "INDEX ITEM DESCRIPTION": "Garage doors, wood, manufacturing",
    },
    {
      NAICS22: "321911",
      "INDEX ITEM DESCRIPTION":
        "Louver windows and doors, made from purchased glass with wood frame",
    },
    {
      NAICS22: "321911",
      "INDEX ITEM DESCRIPTION":
        "Sash, door and window, wood and covered wood, manufacturing",
    },
    {
      NAICS22: "321911",
      "INDEX ITEM DESCRIPTION":
        "Screens, door and window, wood framed, manufacturing",
    },
    {
      NAICS22: "321911",
      "INDEX ITEM DESCRIPTION":
        "Storm doors and windows, wood framed, manufacturing",
    },
    {
      NAICS22: "321911",
      "INDEX ITEM DESCRIPTION":
        "Window frames and sash, wood and covered wood, manufacturing",
    },
    {
      NAICS22: "321911",
      "INDEX ITEM DESCRIPTION": "Window screens, wood framed, manufacturing",
    },
    {
      NAICS22: "321911",
      "INDEX ITEM DESCRIPTION":
        "Window units, wood and covered wood, manufacturing",
    },
    {
      NAICS22: "321911",
      "INDEX ITEM DESCRIPTION": "Windows, louver, wood, manufacturing",
    },
    {
      NAICS22: "321911",
      "INDEX ITEM DESCRIPTION": "Windows, wood and covered wood, manufacturing",
    },
    {
      NAICS22: "321911",
      "INDEX ITEM DESCRIPTION": "Wood door frames and sash manufacturing",
    },
    {
      NAICS22: "321911",
      "INDEX ITEM DESCRIPTION": "Wood window frames and sash manufacturing",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION":
        "Blanks, wood (e.g., bowling pins, handles, textile machinery accessories), manufacturing",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION": "Boards, wood, resawing purchased lumber",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION": "Bobbin blocks and blanks, wood, manufacturing",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION": "Bowling pin blanks manufacturing",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION": "Brush blocks, wood, turned and shaped",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION": "Cants, resawed (lumber), manufacturing",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION":
        "Ceiling lumber, dressed, resawing purchased lumber",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION": "Cut stock manufacturing",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION":
        "Dimension lumber, hardwood, resawing purchased lumber",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION": "Dimension lumber, resawing purchased lumber",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION":
        "Dimension lumber, softwood, resawing purchased lumber",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION": "Dimension stock, hardwood, manufacturing",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION": "Dimension stock, softwood, manufacturing",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION": "Dimension stock, wood, manufacturing",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION":
        "Furniture dimension stock, hardwood, unfinished, manufacturing",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION":
        "Furniture dimension stock, softwood, unfinished, manufacturing",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION":
        "Furniture dimension stock, unfinished wood, manufacturing",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION":
        "Furniture squares, unfinished hardwood, manufacturing",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION": "Gun stock blanks manufacturing",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION": "Handle blanks, wood, manufacturing",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION": "Handle stock, sawed or planed, manufacturing",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION":
        "Hardwood dimension lumber and stock, resawing purchased lumber",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION": "Ladder rounds or rungs, hardwood, manufacturing",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION": "Lath, wood, manufacturing",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION": "Lathmills, wood",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION":
        "Lumber, hardwood dimension, resawing purchased lumber",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION":
        "Lumber, softwood dimension, resawing purchased lumber",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION": "Planing mills (except millwork)",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION": "Planing purchased lumber",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION": "Resawing purchased lumber",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION":
        "Rounds or rungs, furniture, hardwood, manufacturing",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION": "Sawed lumber, resawing purchased lumber",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION": "Snow fence lath manufacturing",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION":
        "Softwood dimension lumber and stock, resawing purchased lumber",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION":
        "Stock, chair, unfinished hardwood, manufacturing",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION": "Studs, resawing purchased lumber",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION":
        "Turnings, furniture, unfinished wood, manufacturing",
    },
    {
      NAICS22: "321912",
      "INDEX ITEM DESCRIPTION": "Vehicle stock, hardwood, manufacturing",
    },
    {
      NAICS22: "321918",
      "INDEX ITEM DESCRIPTION": "Bamboo flooring manufacturing",
    },
    {
      NAICS22: "321918",
      "INDEX ITEM DESCRIPTION": "Baseboards, floor, wood, manufacturing",
    },
    {
      NAICS22: "321918",
      "INDEX ITEM DESCRIPTION": "Brackets, wood, manufacturing",
    },
    {
      NAICS22: "321918",
      "INDEX ITEM DESCRIPTION":
        "Clear and finger joint wood moldings manufacturing",
    },
    {
      NAICS22: "321918",
      "INDEX ITEM DESCRIPTION": "Columns, porch, wood, manufacturing",
    },
    {
      NAICS22: "321918",
      "INDEX ITEM DESCRIPTION": "Cornices, wood, manufacturing",
    },
    {
      NAICS22: "321918",
      "INDEX ITEM DESCRIPTION":
        "Decorative wood moldings (e.g., base, chair rail, crown, shoe) manufacturing",
    },
    {
      NAICS22: "321918",
      "INDEX ITEM DESCRIPTION": "Door shutters, wood, manufacturing",
    },
    {
      NAICS22: "321918",
      "INDEX ITEM DESCRIPTION": "Door trim, wood molding, manufacturing",
    },
    {
      NAICS22: "321918",
      "INDEX ITEM DESCRIPTION": "Exterior wood shutters manufacturing",
    },
    {
      NAICS22: "321918",
      "INDEX ITEM DESCRIPTION": "Floor baseboards, wood, manufacturing",
    },
    {
      NAICS22: "321918",
      "INDEX ITEM DESCRIPTION": "Flooring, wood, manufacturing",
    },
    {
      NAICS22: "321918",
      "INDEX ITEM DESCRIPTION":
        "Moldings, clear and finger joint wood, manufacturing",
    },
    {
      NAICS22: "321918",
      "INDEX ITEM DESCRIPTION": "Moldings, wood and covered wood, manufacturing",
    },
    {
      NAICS22: "321918",
      "INDEX ITEM DESCRIPTION": "Newel posts, wood, manufacturing",
    },
    {
      NAICS22: "321918",
      "INDEX ITEM DESCRIPTION":
        "Ornamental woodwork (e.g., cornices, mantels) manufacturing",
    },
    {
      NAICS22: "321918",
      "INDEX ITEM DESCRIPTION": "Panel work, wood millwork, manufacturing",
    },
    {
      NAICS22: "321918",
      "INDEX ITEM DESCRIPTION": "Parquet flooring, hardwood, manufacturing",
    },
    {
      NAICS22: "321918",
      "INDEX ITEM DESCRIPTION": "Parquetry, hardwood, manufacturing",
    },
    {
      NAICS22: "321918",
      "INDEX ITEM DESCRIPTION": "Planing mills, millwork",
    },
    {
      NAICS22: "321918",
      "INDEX ITEM DESCRIPTION":
        "Porch work (e.g., columns, newels, rails, trellises), wood, manufacturing",
    },
    {
      NAICS22: "321918",
      "INDEX ITEM DESCRIPTION": "Railings, wood stair, manufacturing",
    },
    {
      NAICS22: "321918",
      "INDEX ITEM DESCRIPTION":
        "Shutters, door and window, wood and covered wood, manufacturing",
    },
    {
      NAICS22: "321918",
      "INDEX ITEM DESCRIPTION": "Shutters, wood, manufacturing",
    },
    {
      NAICS22: "321918",
      "INDEX ITEM DESCRIPTION": "Stair railings, wood, manufacturing",
    },
    {
      NAICS22: "321918",
      "INDEX ITEM DESCRIPTION":
        "Stairwork (e.g., newel posts, railings, staircases, stairs), wood, manufacturing",
    },
    {
      NAICS22: "321918",
      "INDEX ITEM DESCRIPTION": "Trellises, wood, manufacturing",
    },
    {
      NAICS22: "321918",
      "INDEX ITEM DESCRIPTION": "Trim, wood and covered wood, manufacturing",
    },
    {
      NAICS22: "321918",
      "INDEX ITEM DESCRIPTION": "Venetian blind slats, wood, manufacturing",
    },
    {
      NAICS22: "321918",
      "INDEX ITEM DESCRIPTION": "Wainscots, wood, manufacturing",
    },
    {
      NAICS22: "321918",
      "INDEX ITEM DESCRIPTION": "Weatherstrip, wood, manufacturing",
    },
    {
      NAICS22: "321918",
      "INDEX ITEM DESCRIPTION":
        "Window trim, wood and covered wood moldings, manufacturing",
    },
    {
      NAICS22: "321918",
      "INDEX ITEM DESCRIPTION":
        "Wood flooring (including laminate and wood composite) manufacturing",
    },
    {
      NAICS22: "321918",
      "INDEX ITEM DESCRIPTION":
        "Wood moldings (e.g., prefinished, unfinished), clear and finger joint, manufacturing",
    },
    {
      NAICS22: "321918",
      "INDEX ITEM DESCRIPTION": "Wood shutters manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Ammunition boxes, wood, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Barrel heading and staves manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Barrels, wood, coopered, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION":
        "Baskets, wood (e.g., round stave, veneer), manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Berry crates, wood, wirebound, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Berry cups, veneer and splint, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Box cleats, wood, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Box shook manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Boxes, cigar, wood or part wood, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION":
        "Boxes, jewelry, wood or part wood, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Boxes, wood, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION":
        "Boxes, wood, plain or fabric covered, nailed or lock corner, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Buckets, wood, coopered, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Cases, shipping, wood, wirebound, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION":
        "Cases, wood packing, nailed or lock corner, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION":
        "Cases, wood shipping, nailed or lock corner, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Casks, wood, coopered, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Chests for tools, wood, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION":
        "Chicken coops (i.e., crates), wood, wirebound for shipping poultry, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Cigar boxes, wood and part wood, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Containers, wood, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Cooperage manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION":
        "Cooperage stock (e.g., heading, hoops, staves) manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Cooperage stock mills",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Coopered tubs manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION":
        "Crates (e.g., berry, butter, fruit, vegetable) made of wood, wirebound, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Drums, plywood, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Drums, shipping, wood, wirebound, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Egg cases, wood, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Firkins and kits, wood, coopered, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Flats, wood, greenhouse, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Fruit baskets, veneer and splint, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Fruit crates, wood, wirebound, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION":
        "Heading, barrel (i.e., cooperage stock), wood, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Hogsheads, coopered wood, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION":
        "Hoops, sawed or split wood for tight or slack cooperage, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Hot tubs, coopered, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Kegs, wood, coopered, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION":
        "Packing cases, wood, nailed or lock corner, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Packing crates, wood, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Pails, coopered wood, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Pails, plywood, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Pails, wood, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION":
        "Pallet containers, wood or wood and metal combination, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Pallet parts, wood, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION":
        "Pallets, wood or wood and metal combination, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION":
        "Round stave baskets (e.g., fruit, vegetable) manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION":
        "Shipping cases and drums, wood, wirebound, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION":
        "Shipping cases, wood, nailed or lock corner, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Shipping crates, wood, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Shook, box, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION":
        "Skids and pallets, wood or wood and metal combination, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION":
        "Splint baskets for fruits and vegetables, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Staves, barrel, sawed or split, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Tanks, wood, coopered, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Tobacco hogshead stock, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Tobacco hogsheads, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Tool chests, wood, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION": "Trays, carrier, wood, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION":
        "Vegetable baskets, veneer and splint, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION":
        "Vegetable crates, wood, wirebound, manufacturing",
    },
    {
      NAICS22: "321920",
      "INDEX ITEM DESCRIPTION":
        "Veneer baskets, for fruits and vegetables, manufacturing",
    },
    {
      NAICS22: "321991",
      "INDEX ITEM DESCRIPTION":
        "Buildings, mobile, commercial use, manufacturing",
    },
    {
      NAICS22: "321991",
      "INDEX ITEM DESCRIPTION":
        "Houses, prefabricated mobile homes, manufacturing",
    },
    {
      NAICS22: "321991",
      "INDEX ITEM DESCRIPTION":
        "Manufactured (mobile) buildings for commercial use (e.g., banks, offices) manufacturing",
    },
    {
      NAICS22: "321991",
      "INDEX ITEM DESCRIPTION": "Manufactured (mobile) classrooms manufacturing",
    },
    {
      NAICS22: "321991",
      "INDEX ITEM DESCRIPTION": "Manufactured (mobile) homes manufacturing",
    },
    {
      NAICS22: "321991",
      "INDEX ITEM DESCRIPTION": "Mobile homes manufacturing",
    },
    {
      NAICS22: "321992",
      "INDEX ITEM DESCRIPTION": "Buildings, prefabricated, wood, manufacturing",
    },
    {
      NAICS22: "321992",
      "INDEX ITEM DESCRIPTION":
        "Chicken coops, prefabricated, wood, manufacturing",
    },
    {
      NAICS22: "321992",
      "INDEX ITEM DESCRIPTION": "Corn cribs, prefabricated, wood, manufacturing",
    },
    {
      NAICS22: "321992",
      "INDEX ITEM DESCRIPTION":
        "Farm buildings, prefabricated wood, manufacturing",
    },
    {
      NAICS22: "321992",
      "INDEX ITEM DESCRIPTION": "Garages, prefabricated wood, manufacturing",
    },
    {
      NAICS22: "321992",
      "INDEX ITEM DESCRIPTION":
        "Geodesic domes, prefabricated, wood, manufacturing",
    },
    {
      NAICS22: "321992",
      "INDEX ITEM DESCRIPTION":
        "Houses, prefabricated, wood (except mobile homes), manufacturing",
    },
    {
      NAICS22: "321992",
      "INDEX ITEM DESCRIPTION": "Log cabins, prefabricated wood, manufacturing",
    },
    {
      NAICS22: "321992",
      "INDEX ITEM DESCRIPTION":
        "Panels, prefabricated wood building, manufacturing",
    },
    {
      NAICS22: "321992",
      "INDEX ITEM DESCRIPTION":
        "Prefabricated homes (except mobile homes), wood, manufacturing",
    },
    {
      NAICS22: "321992",
      "INDEX ITEM DESCRIPTION": "Prefabricated wood buildings manufacturing",
    },
    {
      NAICS22: "321992",
      "INDEX ITEM DESCRIPTION": "Sauna rooms, prefabricated, wood, manufacturing",
    },
    {
      NAICS22: "321992",
      "INDEX ITEM DESCRIPTION":
        "Sections, prefabricated wood building, manufacturing",
    },
    {
      NAICS22: "321992",
      "INDEX ITEM DESCRIPTION":
        "Sheds (e.g., garden, storage, utility), prefabricated wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Applicators, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION":
        "Audio cabinets (i.e., housings), wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION":
        "Bentwood (steam bent) products (except furniture) manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Blocks, tackle, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Blocks, tailors' pressing wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Boards, bulletin, wood and cork, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION":
        "Boards, wood (e.g., clip, ironing, meat, pastry), manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION":
        "Boot and shoe lasts, all materials, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Bottle corks manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION":
        "Bottle covers, willow, rattan, and reed, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Bowls, wood, turned and shaped, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Bulletin boards, wood and cork, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Bungs, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Buoys, cork, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Burnt wood articles manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Bushings, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION":
        "Cabinets (i.e., housings), wood (e.g., sewing machines, stereo, television), manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Carpets, cork, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Clipboards, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Cloth winding reels, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION":
        "Clothes dryers (clothes horses), wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Clothes poles, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Clothespins, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Cork products (except gaskets) manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Corks, bottle, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION":
        "Covers, bottle and demijohn, willow, rattan, and reed, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Curtain stretchers, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Dishes, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Dowels, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Excelsior (e.g., pads, wrappers) manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Extension ladders, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Extension planks, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION":
        "Fencing, prefabricated sections, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION":
        "Fencing, wood (except rough pickets, poles, and rails), manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION":
        "Firewood and fuel wood containing fuel binder manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Flagpoles, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Flour, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION":
        "Forms, display, boot and shoe, all materials, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Furniture inlays manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Garment hangers, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Gavels, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION":
        "Grain measures, wood, turned and shaped, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Hammers, wood, meat, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION":
        "Handles (e.g., broom, mop, handtool), wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Hangers, wooden, garment, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION":
        "Heels, boot and shoe, finished wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Household-type woodenware manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Hubs, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Insulating materials, cork, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Ironing boards, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Kiln drying lumber",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Kitchenware, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Knobs, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Ladder jacks, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Ladders, extension, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION":
        "Last sole patterns, all materials, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Lumber, kiln drying",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Mallets, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Marquetry, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Mashers, potato, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Masts, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Mauls, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Novelties, wood fiber, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Oars, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Paddles, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Pads, excelsior, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION":
        "Pads, table, rattan, reed, and willow, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Paint sticks, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Pastry boards, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Pencil slats, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Plugs, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION":
        "Pressed logs of sawdust and other wood particles, nonpetroleum binder, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Pressing blocks, wood, tailor's, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Pulleys, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Rails (except rough), wood fence, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Rattan ware (except furniture) manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Reed ware (except furniture) manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Reels, plywood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Reels, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Rollers, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Rolling pins, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION":
        "Rulers and rules (except slide), wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Saddle trees, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Sawdust, regrinding",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Scoops, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Seat covers, rattan, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Seats, toilet, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Sewing machine cabinets, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION":
        "Shoe display forms, all materials, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Shoe stretchers manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Shoe trees manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Skewers, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Snow fence, sections or rolls, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Spars, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION":
        "Speaker cabinets (i.e., housings), wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Spigots, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Spokes, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION":
        "Spools (except for textile machinery), wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Stakes, surveyor's, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Stepladders, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION":
        "Stereo cabinets (i.e., housings), wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Stoppers, cork, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Straw baskets manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Stretchers, curtain, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Surveyor's stakes, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Tackle blocks, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION":
        "Television cabinets (i.e., housings), wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Tent poles, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Tile, cork, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Toilet seats, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION":
        "Tool handles, wood, turned and shaped, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Toothpicks, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Trays, wood, wicker, and bagasse, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Trophy bases, wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Veneer work, inlaid, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Washboards, wood and part wood, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Webbing, cane, reed, and rattan, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Willow ware (except furniture) manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Wood flour manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Wood heel blocks manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Wood heels, finished, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Wood pellets manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Wood wool (excelsior) manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION":
        "Woodenware, kitchen and household, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Wrappers, excelsior, manufacturing",
    },
    {
      NAICS22: "321999",
      "INDEX ITEM DESCRIPTION": "Yardsticks, wood, manufacturing",
    },
    {
      NAICS22: "322110",
      "INDEX ITEM DESCRIPTION": "Deinking plants",
    },
    {
      NAICS22: "322110",
      "INDEX ITEM DESCRIPTION": "Deinking recovered paper",
    },
    {
      NAICS22: "322110",
      "INDEX ITEM DESCRIPTION": "Groundwood pulp manufacturing",
    },
    {
      NAICS22: "322110",
      "INDEX ITEM DESCRIPTION":
        "Pulp manufacturing (i.e., chemical, mechanical, or semichemical processes) without making paper",
    },
    {
      NAICS22: "322110",
      "INDEX ITEM DESCRIPTION":
        "Pulp manufacturing (made from bagasse, linters, rags, straw, wastepaper, or wood) without making paper",
    },
    {
      NAICS22: "322110",
      "INDEX ITEM DESCRIPTION": "Pulp mills not making paper or paperboard",
    },
    {
      NAICS22: "322110",
      "INDEX ITEM DESCRIPTION": "Wood pulp manufacturing",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Absorbent paper stock manufacturing",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Asphalt paper made in paper mills",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Bond paper made in paper mills",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Book paper, coated, made in paper mills",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Bristols paper stock manufacturing",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Building paper stock manufacturing",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Cigarette paper made in paper mills",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION":
        "Construction paper, school and art, made in paper mills",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Cotton fiber paper stock manufacturing",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Diapers, disposable, made in paper mills",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Facial tissues made in paper mills",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Felts, asphalt, made in paper mills",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Glassine wrapping paper made in paper mills",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION":
        "Groundwood paper products (e.g., publication and printing paper, tablet stock, wallpaper base) made in newsprint mills",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION":
        "Groundwood paper, coated, laminated, or treated in paper mills",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Groundwood paper, coated, made in paper mills",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION":
        "Groundwood paper, newsprint, made in paper mills",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Kraft paper stock manufacturing",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Looseleaf fillers and paper made in paper mills",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Napkins, table, made in paper mills",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Newsprint mills",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Newsprint paper, manufacturing",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION":
        "Office paper (e.g., computer printer, photocopy, plain paper) made in paper mills",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Paper manufacturing",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Paper mills",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Paper mills, newsprint",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Paper mills, uncoated groundwood",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Paper products made in paper mills",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION":
        "Paper stock for conversion into paper products (e.g., bag and sack stock, envelope stock, tissue stock, wallpaper stock) manufacturing",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Paper towels made in paper mills",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Paper, asphalt, made in paper mills",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION":
        "Paper, coated, laminated or treated, made in paper mills",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION":
        "Paper, newsprint and uncoated groundwood, manufacturing",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Pulp and newsprint combined manufacturing",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Pulp and paper combined manufacturing",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION":
        "Pulp mills and groundwood paper, uncoated and untreated, manufacturing",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Pulp mills producing newsprint paper",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Pulp mills producing paper",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION":
        "Sanitary napkins and tampons made in paper mills",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Sanitary paper products made in paper mills",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Sanitary paper stock manufacturing",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Sanitary products made in paper mills",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Saturated felts made in paper mills",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Sheathing paper made in paper mills",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION":
        "Tablets (e.g., memo, note, writing) made in paper mills",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION":
        "Tar paper, building and roofing, made in paper mills",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Tissue paper stock manufacturing",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Toilet paper made in paper mills",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Towels, paper, made in paper mills",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Uncoated groundwood paper mills",
    },
    {
      NAICS22: "322120",
      "INDEX ITEM DESCRIPTION": "Writing paper made in paper mills",
    },
    {
      NAICS22: "322130",
      "INDEX ITEM DESCRIPTION": "Binder's board manufacturing",
    },
    {
      NAICS22: "322130",
      "INDEX ITEM DESCRIPTION": "Bristols board stock manufacturing",
    },
    {
      NAICS22: "322130",
      "INDEX ITEM DESCRIPTION": "Cardboard stock manufacturing",
    },
    {
      NAICS22: "322130",
      "INDEX ITEM DESCRIPTION":
        "Chipboard (i.e., paperboard) stock manufacturing",
    },
    {
      NAICS22: "322130",
      "INDEX ITEM DESCRIPTION": "Coated board made in paperboard mills",
    },
    {
      NAICS22: "322130",
      "INDEX ITEM DESCRIPTION": "Container board stock manufacturing",
    },
    {
      NAICS22: "322130",
      "INDEX ITEM DESCRIPTION": "Folding boxboard stock manufacturing",
    },
    {
      NAICS22: "322130",
      "INDEX ITEM DESCRIPTION": "Kraft linerboard manufacturing",
    },
    {
      NAICS22: "322130",
      "INDEX ITEM DESCRIPTION":
        "Leatherboard (i.e., paperboard based) made in paperboard mills",
    },
    {
      NAICS22: "322130",
      "INDEX ITEM DESCRIPTION": "Milk carton board made in paperboard mills",
    },
    {
      NAICS22: "322130",
      "INDEX ITEM DESCRIPTION":
        "Paperboard (e.g., can/drum stock, container board, corrugating medium, folding carton stock, linerboard, tube) manufacturing",
    },
    {
      NAICS22: "322130",
      "INDEX ITEM DESCRIPTION":
        "Paperboard coating, laminating, or treating in paperboard mills",
    },
    {
      NAICS22: "322130",
      "INDEX ITEM DESCRIPTION": "Paperboard mills",
    },
    {
      NAICS22: "322130",
      "INDEX ITEM DESCRIPTION":
        "Paperboard products (e.g., containers) made in paperboard mills",
    },
    {
      NAICS22: "322130",
      "INDEX ITEM DESCRIPTION": "Pulp and paperboard combined manufacturing",
    },
    {
      NAICS22: "322130",
      "INDEX ITEM DESCRIPTION": "Pulp mills producing paperboard",
    },
    {
      NAICS22: "322130",
      "INDEX ITEM DESCRIPTION": "Setup boxboard stock manufacturing",
    },
    {
      NAICS22: "322130",
      "INDEX ITEM DESCRIPTION": "Wet machine board mills",
    },
    {
      NAICS22: "322211",
      "INDEX ITEM DESCRIPTION":
        "Boxes, corrugated and solid fiber, made from purchased paper or paperboard",
    },
    {
      NAICS22: "322211",
      "INDEX ITEM DESCRIPTION":
        "Boxes, shipping, laminated paper and paperboard, made from purchased paperboard",
    },
    {
      NAICS22: "322211",
      "INDEX ITEM DESCRIPTION":
        "Corrugated and solid fiber boxes made from purchased paper or paperboard",
    },
    {
      NAICS22: "322211",
      "INDEX ITEM DESCRIPTION":
        "Corrugated and solid fiberboard pads made from purchased paper or paperboard",
    },
    {
      NAICS22: "322211",
      "INDEX ITEM DESCRIPTION":
        "Corrugated paper made from purchased paper or paperboard",
    },
    {
      NAICS22: "322211",
      "INDEX ITEM DESCRIPTION":
        "Pads, corrugated and solid fiberboard, made from purchased paper or paperboard",
    },
    {
      NAICS22: "322211",
      "INDEX ITEM DESCRIPTION":
        "Pallets, corrugated and solid fiber, made from purchased paper or paperboard",
    },
    {
      NAICS22: "322211",
      "INDEX ITEM DESCRIPTION":
        "Paper, corrugated, made from purchased paper or paperboard",
    },
    {
      NAICS22: "322211",
      "INDEX ITEM DESCRIPTION":
        "Partitions, corrugated and solid fiber, made from purchased paper or paperboard",
    },
    {
      NAICS22: "322211",
      "INDEX ITEM DESCRIPTION":
        "Shipping containers made from purchased paperboard",
    },
    {
      NAICS22: "322211",
      "INDEX ITEM DESCRIPTION":
        "Shipping containers, corrugated, made from purchased paper or paperboard",
    },
    {
      NAICS22: "322212",
      "INDEX ITEM DESCRIPTION":
        "Boxes, folding (except corrugated), made from purchased paperboard",
    },
    {
      NAICS22: "322212",
      "INDEX ITEM DESCRIPTION":
        "Cartons, folding (except milk), made from purchased paperboard",
    },
    {
      NAICS22: "322212",
      "INDEX ITEM DESCRIPTION":
        "Folding boxes (except corrugated) made from purchased paperboard",
    },
    {
      NAICS22: "322212",
      "INDEX ITEM DESCRIPTION":
        "Folding paper and paperboard containers (except corrugated) made from purchased paperboard",
    },
    {
      NAICS22: "322212",
      "INDEX ITEM DESCRIPTION":
        "Food containers, sanitary, folding, made from purchased paperboard",
    },
    {
      NAICS22: "322212",
      "INDEX ITEM DESCRIPTION":
        "Sanitary food container, folding, made from purchased paperboard",
    },
    {
      NAICS22: "322212",
      "INDEX ITEM DESCRIPTION":
        "Shoe boxes, folding, made from purchased paperboard",
    },
    {
      NAICS22: "322219",
      "INDEX ITEM DESCRIPTION": "Bobbins, fiber, made from purchased paperboard",
    },
    {
      NAICS22: "322219",
      "INDEX ITEM DESCRIPTION":
        "Boxes, sanitary food (except folding), made from purchased paper or paperboard",
    },
    {
      NAICS22: "322219",
      "INDEX ITEM DESCRIPTION":
        "Boxes, setup (i.e., not shipped flat), made from purchased paperboard",
    },
    {
      NAICS22: "322219",
      "INDEX ITEM DESCRIPTION":
        "Cartons, milk, made from purchased paper or paperboard",
    },
    {
      NAICS22: "322219",
      "INDEX ITEM DESCRIPTION":
        "Composite cans (i.e., foil-fiber and other combinations) manufacturing",
    },
    {
      NAICS22: "322219",
      "INDEX ITEM DESCRIPTION":
        "Cones (e.g., winding yarn, string, ribbon, cloth), fiber, made from purchased paperboard",
    },
    {
      NAICS22: "322219",
      "INDEX ITEM DESCRIPTION":
        "Cores (i.e., all-fiber, nonfiber ends of any material), fiber, made from purchased paperboard",
    },
    {
      NAICS22: "322219",
      "INDEX ITEM DESCRIPTION":
        "Fiber cans and drums (i.e., all-fiber, nonfiber ends of any material) made from purchased paperboard",
    },
    {
      NAICS22: "322219",
      "INDEX ITEM DESCRIPTION": "Fiber drums made from purchased paperboard",
    },
    {
      NAICS22: "322219",
      "INDEX ITEM DESCRIPTION":
        "Fiber spools, reels, blocks made from purchased paperboard",
    },
    {
      NAICS22: "322219",
      "INDEX ITEM DESCRIPTION": "Fiber tubes made from purchased paperboard",
    },
    {
      NAICS22: "322219",
      "INDEX ITEM DESCRIPTION":
        "Food containers, sanitary (except folding), made from purchased paper or paperboard",
    },
    {
      NAICS22: "322219",
      "INDEX ITEM DESCRIPTION":
        "Mailing cases and tubes, paper fiber (i.e., all-fiber, nonfiber ends of any material), made from purchased paperboard",
    },
    {
      NAICS22: "322219",
      "INDEX ITEM DESCRIPTION":
        "Milk cartons made from purchased paper or paperboard",
    },
    {
      NAICS22: "322219",
      "INDEX ITEM DESCRIPTION":
        "Paper cups made from purchased paper or paperboard",
    },
    {
      NAICS22: "322219",
      "INDEX ITEM DESCRIPTION":
        "Paper dishes (e.g., cups, plates) made from purchased paper or paperboard",
    },
    {
      NAICS22: "322219",
      "INDEX ITEM DESCRIPTION":
        "Paper plates made from purchased paper or paperboard",
    },
    {
      NAICS22: "322219",
      "INDEX ITEM DESCRIPTION":
        "Sanitary food containers (except folding) made from purchased paper or paperboard",
    },
    {
      NAICS22: "322219",
      "INDEX ITEM DESCRIPTION":
        "Setup (i.e., not shipped flat) boxes made from purchased paperboard",
    },
    {
      NAICS22: "322219",
      "INDEX ITEM DESCRIPTION":
        "Shoe boxes, setup, made from purchased paperboard",
    },
    {
      NAICS22: "322219",
      "INDEX ITEM DESCRIPTION":
        "Vulcanized fiber products made from purchased paperboard",
    },
    {
      NAICS22: "322219",
      "INDEX ITEM DESCRIPTION":
        "Wastebaskets, fiber made from purchased paperboard",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION":
        "Adhesive tape (except medical) made from purchased materials",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION":
        "Bags (except plastics only) made by laminating or coating combinations of purchased plastics, foil and paper",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION": "Bags, coated paper, made from purchased paper",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION": "Bags, foil, made from purchased foil",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION":
        "Bags, multiwall, made from purchased uncoated paper",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION":
        "Bags, paper, uncoated, made from purchased paper",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION": "Bags, uncoated paper, made from purchased paper",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION": "Book paper made by coating purchased paper",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION": "Book paper, coated, made from purchased paper",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION":
        "Cardboard, laminated or surface coated, made from purchased paperboard",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION":
        "Chipboard, laminated or surface coated, made from purchased paperboard",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION": "Coated board made from purchased paperboard",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION":
        "Coating purchased papers for nonpackaging applications (except photosensitive paper)",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION":
        "Coating purchased papers for packaging applications",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION": "Duct tape made from purchased materials",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION":
        "Flexible packaging sheet materials made by coating or laminating purchased paper",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION":
        "Flexible packaging sheet materials made by laminating purchased foil",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION": "Foil bags made from purchased foil",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION":
        "Foil sheet, laminating purchased foil sheets for packaging applications",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION": "Gift wrap made from purchased materials",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION":
        "Grocers' bags and sacks made from purchased uncoated paper",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION":
        "Groundwood paper, coated, made from purchased paper",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION":
        "Gummed paper products (e.g., labels, sheets, tapes) made from purchased paper",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION":
        "Laminating foil for flexible packaging applications",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION":
        "Laminating purchased foil sheets for nonpackaging applications",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION": "Laminating purchased paperboard",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION":
        "Laminating purchased papers for nonpackaging applications",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION":
        "Laminating purchased papers for packaging applications",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION":
        "Leatherboard (i.e., paperboard based) made from purchased paperboard",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION": "Masking tape made from purchased paper",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION":
        "Milk carton board stock made from purchased paperboard",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION": "Paper bags, coated, made from purchased paper",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION": "Paper bags, uncoated, made from purchased paper",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION":
        "Paperboard, pasted, lined, laminated, or surface coated, made from purchased paperboard",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION":
        "Pressure sensitive paper and tape (except medical) made from purchased materials",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION":
        "Sacks, multiwall, made from purchased uncoated paper",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION":
        "Slitting adhesive-type tapes other than medical types for the trade",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION": "Surface coating purchased paperboard",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION":
        "Tapes, pressure sensitive (e.g., cellophane, masking), gummed, made from purchased paper or other materials",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION":
        "Wallpaper made from purchased papers or other materials",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION":
        "Waxed paper for nonpackaging applications made from purchased paper",
    },
    {
      NAICS22: "322220",
      "INDEX ITEM DESCRIPTION":
        "Waxed paper for packaging applications made from purchased paper",
    },
    {
      NAICS22: "322230",
      "INDEX ITEM DESCRIPTION": "Bond paper made from purchased paper",
    },
    {
      NAICS22: "322230",
      "INDEX ITEM DESCRIPTION":
        "Cards, die-cut office supply (e.g., index, library, time recording), made from purchased paper or paperboard",
    },
    {
      NAICS22: "322230",
      "INDEX ITEM DESCRIPTION":
        "Computer paper, die-cut, made from purchased paper",
    },
    {
      NAICS22: "322230",
      "INDEX ITEM DESCRIPTION":
        "Construction paper, school and art, made from purchased paper",
    },
    {
      NAICS22: "322230",
      "INDEX ITEM DESCRIPTION":
        "Die-cut paper products for office use made from purchased paper or paperboard",
    },
    {
      NAICS22: "322230",
      "INDEX ITEM DESCRIPTION":
        "Envelopes (i.e., mailing, stationery) made from any material",
    },
    {
      NAICS22: "322230",
      "INDEX ITEM DESCRIPTION":
        "File folders (e.g., accordion, expanding, hanging, manila) made from purchased paper and paperboard",
    },
    {
      NAICS22: "322230",
      "INDEX ITEM DESCRIPTION": "Letters, die-cut, made from purchased cardboard",
    },
    {
      NAICS22: "322230",
      "INDEX ITEM DESCRIPTION":
        "Looseleaf fillers and paper made from purchased paper",
    },
    {
      NAICS22: "322230",
      "INDEX ITEM DESCRIPTION":
        "Manila folders, die-cut, made from purchased paper or paperboard",
    },
    {
      NAICS22: "322230",
      "INDEX ITEM DESCRIPTION":
        "Notebooks (including mechanically bound by wire, or plastics) made from purchased paper",
    },
    {
      NAICS22: "322230",
      "INDEX ITEM DESCRIPTION":
        "Office paper (e.g., computer printer, photocopy, plain paper), cut sheet, made from purchased paper",
    },
    {
      NAICS22: "322230",
      "INDEX ITEM DESCRIPTION":
        "Office supplies, die-cut paper, made from purchased paper or paperboard",
    },
    {
      NAICS22: "322230",
      "INDEX ITEM DESCRIPTION": "Padded envelopes manufacturing",
    },
    {
      NAICS22: "322230",
      "INDEX ITEM DESCRIPTION": "Pads, desk, made from purchased paper",
    },
    {
      NAICS22: "322230",
      "INDEX ITEM DESCRIPTION":
        "Paper products, die-cut office supply, made from purchased paper or paperboard",
    },
    {
      NAICS22: "322230",
      "INDEX ITEM DESCRIPTION":
        "Pocket folders made from purchased paper or paperboard",
    },
    {
      NAICS22: "322230",
      "INDEX ITEM DESCRIPTION":
        "Report covers made from purchased paper or paperboard",
    },
    {
      NAICS22: "322230",
      "INDEX ITEM DESCRIPTION": "Seed packets made from purchased paper",
    },
    {
      NAICS22: "322230",
      "INDEX ITEM DESCRIPTION": "Stationery made from purchased paper",
    },
    {
      NAICS22: "322230",
      "INDEX ITEM DESCRIPTION":
        "Tablets (e.g., memo, note, writing) made from purchased paper",
    },
    {
      NAICS22: "322230",
      "INDEX ITEM DESCRIPTION":
        "Tapes (e.g., adding machine, calculator, cash register) made from purchased paper",
    },
    {
      NAICS22: "322230",
      "INDEX ITEM DESCRIPTION":
        "Writing paper and envelopes, boxed sets, made from purchased paper",
    },
    {
      NAICS22: "322230",
      "INDEX ITEM DESCRIPTION":
        "Writing paper, cut sheet, made from purchased paper",
    },
    {
      NAICS22: "322291",
      "INDEX ITEM DESCRIPTION":
        "Diapers, disposable, made from purchased paper or textile fiber",
    },
    {
      NAICS22: "322291",
      "INDEX ITEM DESCRIPTION": "Facial tissues made from purchased paper",
    },
    {
      NAICS22: "322291",
      "INDEX ITEM DESCRIPTION": "Handkerchiefs, paper, made from purchased paper",
    },
    {
      NAICS22: "322291",
      "INDEX ITEM DESCRIPTION": "Napkins, table, made from purchased paper",
    },
    {
      NAICS22: "322291",
      "INDEX ITEM DESCRIPTION": "Pads, incontinent and bed, manufacturing",
    },
    {
      NAICS22: "322291",
      "INDEX ITEM DESCRIPTION":
        "Paper napkins and tablecloths made from purchased paper",
    },
    {
      NAICS22: "322291",
      "INDEX ITEM DESCRIPTION": "Paper towels made from purchased paper",
    },
    {
      NAICS22: "322291",
      "INDEX ITEM DESCRIPTION":
        "Sanitary napkins and tampons made from purchased paper or textile fiber",
    },
    {
      NAICS22: "322291",
      "INDEX ITEM DESCRIPTION":
        "Sanitary products made from purchased sanitary paper stock",
    },
    {
      NAICS22: "322291",
      "INDEX ITEM DESCRIPTION": "Tablecloths, paper, made from purchased paper",
    },
    {
      NAICS22: "322291",
      "INDEX ITEM DESCRIPTION": "Toilet paper made from purchased paper",
    },
    {
      NAICS22: "322291",
      "INDEX ITEM DESCRIPTION": "Towels, paper, made from purchased paper",
    },
    {
      NAICS22: "322299",
      "INDEX ITEM DESCRIPTION":
        "Cards, die-cut (except office supply) made from purchased paper or paperboard",
    },
    {
      NAICS22: "322299",
      "INDEX ITEM DESCRIPTION": "Cartons, egg, molded pulp manufacturing",
    },
    {
      NAICS22: "322299",
      "INDEX ITEM DESCRIPTION": "Cigarette paper made from purchased paper",
    },
    {
      NAICS22: "322299",
      "INDEX ITEM DESCRIPTION":
        "Cigarette paper, book, made from purchased paper",
    },
    {
      NAICS22: "322299",
      "INDEX ITEM DESCRIPTION": "Coffee filters made from purchased paper",
    },
    {
      NAICS22: "322299",
      "INDEX ITEM DESCRIPTION": "Confetti made from purchased paper",
    },
    {
      NAICS22: "322299",
      "INDEX ITEM DESCRIPTION": "Crepe paper made from purchased paper",
    },
    {
      NAICS22: "322299",
      "INDEX ITEM DESCRIPTION": "Cups, molded pulp, manufacturing",
    },
    {
      NAICS22: "322299",
      "INDEX ITEM DESCRIPTION":
        "Die-cut paper products (except for office use) made from purchased paper or paperboard",
    },
    {
      NAICS22: "322299",
      "INDEX ITEM DESCRIPTION": "Doilies, paper, made from purchased paper",
    },
    {
      NAICS22: "322299",
      "INDEX ITEM DESCRIPTION": "Filters, paper, made from purchased paper",
    },
    {
      NAICS22: "322299",
      "INDEX ITEM DESCRIPTION": "Food containers made from molded pulp",
    },
    {
      NAICS22: "322299",
      "INDEX ITEM DESCRIPTION": "Food trays, molded pulp, manufacturing",
    },
    {
      NAICS22: "322299",
      "INDEX ITEM DESCRIPTION":
        "Glassine wrapping paper made from purchased paper",
    },
    {
      NAICS22: "322299",
      "INDEX ITEM DESCRIPTION": "Hats made from purchased paper",
    },
    {
      NAICS22: "322299",
      "INDEX ITEM DESCRIPTION":
        "Insulating batts, fills, or blankets made from purchased paper",
    },
    {
      NAICS22: "322299",
      "INDEX ITEM DESCRIPTION":
        "Molded pulp products (e.g., egg cartons, food containers, food trays) manufacturing",
    },
    {
      NAICS22: "322299",
      "INDEX ITEM DESCRIPTION":
        "Paper dishes (e.g., cups, plates) made from molded pulp",
    },
    {
      NAICS22: "322299",
      "INDEX ITEM DESCRIPTION": "Paper novelties made from purchased paper",
    },
    {
      NAICS22: "322299",
      "INDEX ITEM DESCRIPTION":
        "Paper products (except office supply), die-cut, made from purchased paper or paperboard",
    },
    {
      NAICS22: "322299",
      "INDEX ITEM DESCRIPTION":
        "Photograph folders, mats, and mounts manufacturing",
    },
    {
      NAICS22: "322299",
      "INDEX ITEM DESCRIPTION": "Plates, molded pulp, manufacturing",
    },
    {
      NAICS22: "322299",
      "INDEX ITEM DESCRIPTION": "Pulp products, molded, manufacturing",
    },
    {
      NAICS22: "322299",
      "INDEX ITEM DESCRIPTION": "Trays, food, molded pulp, manufacturing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Address lists commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Advertising materials (e.g., coupons, flyers) commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Agricultural magazines and periodicals commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Albums (e.g., photo, scrap) and refills manufacturing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Appointment books and refills manufacturing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Art prints commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Atlases commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Blankbooks and refills manufacturing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Books, sales, manifold, printing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Business directories commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Business forms commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Business forms, manifold, printing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Calendars commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Cards (e.g., business, greeting, playing, postcards, trading) commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Catalogs commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Catalogs of collections commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Checkbooks and refills printing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Comic books commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Commercial digital printing (except books)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Commercial engraving printing (except books)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Commercial flexographic printing (except books)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Commercial gravure printing (except books)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Commercial letterpress printing (except books)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Commercial lithographic (offset) printing (except books)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Commercial printing (except screen, books)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Commercial quick printing (except books)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Computer forms (manifold or continuous) printing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Credit and identification card imprinting, embossing, and encoding",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Databases commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Diaries manufacturing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Digital printing (e.g., billboards, other large format graphic materials, high resolution) (except books)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Directories commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Discount coupon books commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Financial magazines and periodicals commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Flexographic printing (except books, grey goods)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Globe covers and maps commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Gravure printing (except books, grey goods)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Greeting cards (e.g., birthday, holiday, sympathy) commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Guides, street map, commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Heat press printing apparel and textile products (e.g., caps, napkins, placemats, T-shirts, towels) (except grey goods and T-shirt shops)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Hydrographic printing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Instant printing (i.e., quick printing) (except books)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Intaglio printing (except books)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Job printing (except screen, books)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Job printing, engraving (except books)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Job printing, flexographic (except books)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Job printing, gravure (except books)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Job printing, letterpress (except books)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Job printing, lithographic (except books)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Job printing, offset (except books)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Juvenile magazines and periodicals commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Labels, commercial printing (except screen), on a job-order basis",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Lithographic printing (except books, grey goods)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Looseleaf binders and devices manufacturing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Magazines and periodicals commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Manifold business forms printing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Maps commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Music, sheet, commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Newsletters commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Newspapers commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Offset printing (except books, grey goods)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Patterns and plans (e.g., clothing patterns) commercial printing (except blueprinting, screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Periodicals commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Photo albums and refills manufacturing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Postcards commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Posters commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Print shops, digital (except printing books)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Print shops, engraving (except printing books)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Print shops, flexographic (except printing books)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Print shops, gravure (except printing books)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Print shops, letterpress (except printing books)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Print shops, lithographic (offset) (except printing books)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Print shops, quick (except printing books)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Printing apparel (except screen printing)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Printing manifold business forms",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Printing, digital (e.g., billboards, other large format graphical materials, high resolution) (except books, grey goods)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Printing, engraving, on paper products",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Printing, flexographic (except books, grey goods)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Printing, gravure (except books, grey goods)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Printing, letterpress (except books, grey goods)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Printing, lithographic (except books, grey goods)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Printing, photo-offset (except books, grey goods)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Printing, quick (except books, grey goods)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Professional magazines and periodicals commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Quick printing (except books)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Racetrack programs commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Racing forms commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Radio guides commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Radio schedules commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Religious magazines and periodicals commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Rotogravure printing (except books)",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Sales books, manifold, printing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Scholarly journals commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Scholastic magazines and periodicals commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION": "Scrapbooks and refills manufacturing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Sheet music commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Shipping registers commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Stationery, commercial printing (except screen), on a job-order basis",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Technical magazines and periodicals commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Telephone directories commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Television guides commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Time planners/organizers and refills manufacturing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Trade journals commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Trade magazines and periodicals commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Unit set forms (e.g., manifold credit card slips) printing",
    },
    {
      NAICS22: "323111",
      "INDEX ITEM DESCRIPTION":
        "Yearbooks commercial printing (except screen) without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION":
        "Address lists screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION":
        "Agricultural magazines and periodicals screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION": "Art prints screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION": "Atlases screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION":
        "Business directories screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION":
        "Business forms (except manifold) screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION": "Calendars screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION":
        "Cards (e.g., business, greeting, playing, postcards, trading) screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION":
        "Catalogs of collections screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION": "Catalogs screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION": "Comic books screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION":
        "Commercial screen printing (except books, manifold business forms, grey goods)",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION": "Databases screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION": "Directories screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION":
        "Discount coupon books screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION":
        "Financial magazines and periodicals screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION":
        "Globe covers and maps screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION":
        "Greeting cards (e.g., birthday, holiday, sympathy) screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION":
        "Guides, street map, screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION": "Job printing, screen",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION":
        "Juvenile magazines and periodicals screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION":
        "Magazines and periodicals screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION": "Maps screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION":
        "Music, sheet, screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION": "Newsletters screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION": "Newspapers screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION":
        "Patterns and plans (e.g., clothing patterns) screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION": "Periodicals screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION": "Postcards screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION": "Posters screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION": "Print shops, screen",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION":
        "Printing, screen (except books, manifold business forms, grey goods)",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION":
        "Professional magazines and periodicals screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION":
        "Racetrack programs screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION": "Racing forms screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION": "Radio guides screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION":
        "Radio schedules screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION":
        "Religious magazines and periodicals screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION":
        "Scholarly journals screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION":
        "Scholastic magazines and periodicals screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION":
        "Screen printing (except books, manifold business forms, grey goods)",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION":
        "Screen printing apparel and textile products (e.g., caps, napkins, placemats, T-shirts, towels) (except grey goods and T-shirt shops)",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION": "Screen printing textile banners",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION": "Sheet music screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION":
        "Shipping registers screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION":
        "Stationery, screen printing, on a job-order basis",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION":
        "Technical magazines and periodicals screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION":
        "Telephone directories screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION":
        "Television guides screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION":
        "Trade journals screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION":
        "Trade magazines and periodicals screen printing without publishing",
    },
    {
      NAICS22: "323113",
      "INDEX ITEM DESCRIPTION": "Yearbooks screen printing without publishing",
    },
    {
      NAICS22: "323117",
      "INDEX ITEM DESCRIPTION":
        "Almanacs printing and binding without publishing",
    },
    {
      NAICS22: "323117",
      "INDEX ITEM DESCRIPTION": "Almanacs printing without publishing",
    },
    {
      NAICS22: "323117",
      "INDEX ITEM DESCRIPTION": "Books printing and binding without publishing",
    },
    {
      NAICS22: "323117",
      "INDEX ITEM DESCRIPTION": "Books printing without publishing",
    },
    {
      NAICS22: "323117",
      "INDEX ITEM DESCRIPTION":
        "Dictionaries printing and binding without publishing",
    },
    {
      NAICS22: "323117",
      "INDEX ITEM DESCRIPTION": "Dictionaries printing without publishing",
    },
    {
      NAICS22: "323117",
      "INDEX ITEM DESCRIPTION":
        "Encyclopedias printing and binding without publishing",
    },
    {
      NAICS22: "323117",
      "INDEX ITEM DESCRIPTION": "Encyclopedias printing without publishing",
    },
    {
      NAICS22: "323117",
      "INDEX ITEM DESCRIPTION":
        "Fiction books printing and binding without publishing",
    },
    {
      NAICS22: "323117",
      "INDEX ITEM DESCRIPTION": "Fiction books printing without publishing",
    },
    {
      NAICS22: "323117",
      "INDEX ITEM DESCRIPTION":
        "Music books printing or printing and binding without publishing",
    },
    {
      NAICS22: "323117",
      "INDEX ITEM DESCRIPTION":
        "Nonfiction books printing and binding without publishing",
    },
    {
      NAICS22: "323117",
      "INDEX ITEM DESCRIPTION": "Nonfiction books printing without publishing",
    },
    {
      NAICS22: "323117",
      "INDEX ITEM DESCRIPTION":
        "Pamphlets printing and binding without publishing",
    },
    {
      NAICS22: "323117",
      "INDEX ITEM DESCRIPTION": "Pamphlets printing without publishing",
    },
    {
      NAICS22: "323117",
      "INDEX ITEM DESCRIPTION": "Printing and binding books without publishing",
    },
    {
      NAICS22: "323117",
      "INDEX ITEM DESCRIPTION": "Printing books without publishing",
    },
    {
      NAICS22: "323117",
      "INDEX ITEM DESCRIPTION":
        "Professional books printing and binding without publishing",
    },
    {
      NAICS22: "323117",
      "INDEX ITEM DESCRIPTION": "Professional books printing without publishing",
    },
    {
      NAICS22: "323117",
      "INDEX ITEM DESCRIPTION":
        "Religious books printing and binding without publishing",
    },
    {
      NAICS22: "323117",
      "INDEX ITEM DESCRIPTION": "Religious books printing without publishing",
    },
    {
      NAICS22: "323117",
      "INDEX ITEM DESCRIPTION":
        "School books printing and binding without publishing",
    },
    {
      NAICS22: "323117",
      "INDEX ITEM DESCRIPTION": "School books printing without publishing",
    },
    {
      NAICS22: "323117",
      "INDEX ITEM DESCRIPTION":
        "Technical manuals and papers (books) printing and binding without publishing",
    },
    {
      NAICS22: "323117",
      "INDEX ITEM DESCRIPTION":
        "Technical manuals and papers (books) printing without publishing",
    },
    {
      NAICS22: "323117",
      "INDEX ITEM DESCRIPTION":
        "Textbooks printing and binding without publishing",
    },
    {
      NAICS22: "323117",
      "INDEX ITEM DESCRIPTION": "Textbooks printing without publishing",
    },
    {
      NAICS22: "323117",
      "INDEX ITEM DESCRIPTION":
        "Travel guide books printing and binding without publishing",
    },
    {
      NAICS22: "323117",
      "INDEX ITEM DESCRIPTION": "Travel guide books printing without publishing",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION": "Almanac binding without printing",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION": "Bookbinding shops",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION": "Bookbinding without printing",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION":
        "Color separation services, for the printing trade",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION": "Dictionary binding without printing",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION":
        "Electronic prepress services for the printing trade",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION": "Electrotype plate preparation services",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION": "Embossing plate preparation services",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION": "Encyclopedia binding without printing",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION":
        "Engraving printing plate, for the printing trade",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION": "Fiction bookbinding without printing",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION": "Flexographic plate preparation services",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION": "Gold stamping books for the trade",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION": "Gravure plate and cylinder preparation services",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION": "Imagesetting services, prepress",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION": "Letterpress plate preparation services",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION": "Lithographic plate preparation services",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION": "Nonfiction bookbinding without printing",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION": "Offset plate preparation services",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION": "Pamphlet binding without printing",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION":
        "Photocomposition services, for the printing trade",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION": "Photoengraving plate preparation services",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION": "Phototypesetting services",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION":
        "Postpress services (e.g., beveling, bronzing, folding, gluing, edging, foil stamping, gilding) on printed materials",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION":
        "Prepress printing services (e.g., color separation, imagesetting, photocomposition, typesetting)",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION": "Printing plate preparation services",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION":
        "Printing postpress services (e.g., beveling, bronzing, folding, gluing, edging, foil stamping) to printed products (e.g., books, cards, paper)",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION":
        "Printing prepress services (e.g., color separation, imagesetting, photocomposition, typesetting)",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION": "Professional bookbinding without printing",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION": "Rebinding books, magazines, or pamphlets",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION": "Religious bookbinding without printing",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION": "Repairing books",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION":
        "Rotogravure printing plates and cylinders preparation services",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION": "Samples mounting",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION": "School textbooks binding without printing",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION": "Screen for printing, preparation services",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION": "Swatches and samples, mounting for the trade",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION":
        "Technical manual paper (books) binding without printing",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION": "Trade binding services",
    },
    {
      NAICS22: "323120",
      "INDEX ITEM DESCRIPTION":
        "Typesetting (i.e., computer controlled, hand, machine)",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Acid oils made in petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION":
        "Aliphatic chemicals (i.e., acyclic) made in petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Alkylates made in petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION":
        "Asphalt and asphaltic materials made in petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION":
        "Asphalt paving mixtures made in petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Aviation fuels manufacturing",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Benzene made in petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Biodiesel fuels made in petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION":
        "Butylene (i.e., butene) made in petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Coke, petroleum, made in petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Crude oil refining",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Crude petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Cumene made in petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION":
        "Cyclic aromatic hydrocarbons made in petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Diesel fuels made in petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Ethylene made in petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Fuel oils manufacturing",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Fuels, jet, manufacturing",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Gasoline made in petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Heating oils made in petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Hydraulic fluids made in petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Jet fuels manufacturing",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Kerosene manufacturing",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION":
        "Liquefied petroleum gas (LPG) made in refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION":
        "Lubricating oils and greases made in petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Naphtha made in petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Naphthenic acids made in petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Oil (i.e., petroleum) refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Oil additives made in petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Oils, fuel, manufacturing",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Paraffin waxes made in petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION":
        "Petrochemical feedstocks made in petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Petrochemicals made in petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Petroleum coke made in petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Petroleum cracking and reforming",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Petroleum distillation",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Petroleum jelly made in petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION":
        "Petroleum lubricating oils made in petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Propane gases made in petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION":
        "Propylene (i.e., propene) made in petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Refineries, petroleum",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Refinery gases made in petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Road oils made in petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Solvents made in petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Still gases made in petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Styrene made in petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Tar made in petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Toluene made in petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Waxes, petroleum, made in petroleum refineries",
    },
    {
      NAICS22: "324110",
      "INDEX ITEM DESCRIPTION": "Xylene made in petroleum refineries",
    },
    {
      NAICS22: "324121",
      "INDEX ITEM DESCRIPTION":
        "Asphalt paving blocks made from purchased asphaltic materials",
    },
    {
      NAICS22: "324121",
      "INDEX ITEM DESCRIPTION":
        "Asphalt paving mixtures made from purchased asphaltic materials",
    },
    {
      NAICS22: "324121",
      "INDEX ITEM DESCRIPTION":
        "Asphalt road compounds made from purchased asphaltic materials",
    },
    {
      NAICS22: "324121",
      "INDEX ITEM DESCRIPTION":
        "Blocks, asphalt paving, made from purchased asphaltic materials",
    },
    {
      NAICS22: "324121",
      "INDEX ITEM DESCRIPTION":
        "Coal tar paving materials made from purchased coal tar",
    },
    {
      NAICS22: "324121",
      "INDEX ITEM DESCRIPTION":
        "Paving blocks and mixtures made from purchased asphaltic materials",
    },
    {
      NAICS22: "324121",
      "INDEX ITEM DESCRIPTION":
        "Tar and asphalt paving mixtures made from purchased asphaltic materials",
    },
    {
      NAICS22: "324122",
      "INDEX ITEM DESCRIPTION":
        "Asphalt roofing cements made from purchased asphaltic materials",
    },
    {
      NAICS22: "324122",
      "INDEX ITEM DESCRIPTION":
        "Asphalt roofing coatings made from purchased asphaltic materials",
    },
    {
      NAICS22: "324122",
      "INDEX ITEM DESCRIPTION":
        "Asphalt saturated boards made from purchased asphaltic materials",
    },
    {
      NAICS22: "324122",
      "INDEX ITEM DESCRIPTION":
        "Asphalt saturated mats and felts made from purchased asphaltic materials and paper",
    },
    {
      NAICS22: "324122",
      "INDEX ITEM DESCRIPTION":
        "Asphalt shingles made from purchased asphaltic materials",
    },
    {
      NAICS22: "324122",
      "INDEX ITEM DESCRIPTION":
        "Boards, asphalt saturated, made from purchased asphaltic materials",
    },
    {
      NAICS22: "324122",
      "INDEX ITEM DESCRIPTION":
        "Cements, asphalt roofing, made from purchased asphaltic materials",
    },
    {
      NAICS22: "324122",
      "INDEX ITEM DESCRIPTION":
        "Coating compounds, tar, made from purchased asphaltic materials",
    },
    {
      NAICS22: "324122",
      "INDEX ITEM DESCRIPTION":
        "Pitch, roofing, made from purchased asphaltic materials",
    },
    {
      NAICS22: "324122",
      "INDEX ITEM DESCRIPTION":
        "Roofing cements, asphalt, made from purchased asphaltic materials",
    },
    {
      NAICS22: "324122",
      "INDEX ITEM DESCRIPTION":
        "Roofing coatings made from purchased asphaltic materials",
    },
    {
      NAICS22: "324122",
      "INDEX ITEM DESCRIPTION":
        "Roofing felts made from purchased asphaltic materials",
    },
    {
      NAICS22: "324122",
      "INDEX ITEM DESCRIPTION": "Saturated felts made from purchased paper",
    },
    {
      NAICS22: "324122",
      "INDEX ITEM DESCRIPTION":
        "Sheathing, asphalt saturated, made from refined petroleum",
    },
    {
      NAICS22: "324122",
      "INDEX ITEM DESCRIPTION":
        "Shingles made from purchased asphaltic materials",
    },
    {
      NAICS22: "324122",
      "INDEX ITEM DESCRIPTION": "Siding made from purchased asphaltic materials",
    },
    {
      NAICS22: "324122",
      "INDEX ITEM DESCRIPTION":
        "Tar paper made from purchased asphaltic materials and paper",
    },
    {
      NAICS22: "324122",
      "INDEX ITEM DESCRIPTION":
        "Tar paper, building and roofing, made from purchased paper",
    },
    {
      NAICS22: "324122",
      "INDEX ITEM DESCRIPTION":
        "Tar roofing cements and coatings made from purchased asphaltic materials",
    },
    {
      NAICS22: "324191",
      "INDEX ITEM DESCRIPTION":
        "Brake fluids, petroleum, made from refined petroleum",
    },
    {
      NAICS22: "324191",
      "INDEX ITEM DESCRIPTION": "Cutting oils made from refined petroleum",
    },
    {
      NAICS22: "324191",
      "INDEX ITEM DESCRIPTION":
        "Greases, petroleum lubricating, made from refined petroleum",
    },
    {
      NAICS22: "324191",
      "INDEX ITEM DESCRIPTION":
        "Grinding oils, petroleum, made from refined petroleum",
    },
    {
      NAICS22: "324191",
      "INDEX ITEM DESCRIPTION":
        "Hydraulic fluids, petroleum, made from refined petroleum",
    },
    {
      NAICS22: "324191",
      "INDEX ITEM DESCRIPTION":
        "Lubricating oils and greases, petroleum, made from refined petroleum",
    },
    {
      NAICS22: "324191",
      "INDEX ITEM DESCRIPTION":
        "Motor oils, petroleum, made from refined petroleum",
    },
    {
      NAICS22: "324191",
      "INDEX ITEM DESCRIPTION":
        "Oils, lubricating petroleum, made from refined petroleum",
    },
    {
      NAICS22: "324191",
      "INDEX ITEM DESCRIPTION": "Oils, petroleum lubricating, re-refining used",
    },
    {
      NAICS22: "324191",
      "INDEX ITEM DESCRIPTION":
        "Petroleum lubricating oils made from refined petroleum",
    },
    {
      NAICS22: "324191",
      "INDEX ITEM DESCRIPTION": "Re-refining used petroleum lubricating oils",
    },
    {
      NAICS22: "324191",
      "INDEX ITEM DESCRIPTION":
        "Rust arresting petroleum compounds made from refined petroleum",
    },
    {
      NAICS22: "324191",
      "INDEX ITEM DESCRIPTION":
        "Transmission fluids, petroleum, made from refined petroleum",
    },
    {
      NAICS22: "324199",
      "INDEX ITEM DESCRIPTION":
        "Biodiesel fuels not made in petroleum refineries and blended with purchased refined petroleum",
    },
    {
      NAICS22: "324199",
      "INDEX ITEM DESCRIPTION":
        "Biofuels not made in petroleum refineries and blended with purchased refined petroleum",
    },
    {
      NAICS22: "324199",
      "INDEX ITEM DESCRIPTION":
        "Boulets (i.e., fuel bricks) made from refined petroleum",
    },
    {
      NAICS22: "324199",
      "INDEX ITEM DESCRIPTION":
        "Briquettes, petroleum, made from refined petroleum",
    },
    {
      NAICS22: "324199",
      "INDEX ITEM DESCRIPTION": "Calcining petroleum coke from refined petroleum",
    },
    {
      NAICS22: "324199",
      "INDEX ITEM DESCRIPTION":
        "Coke oven products (e.g., coke, gases, tars) made in coke oven establishments",
    },
    {
      NAICS22: "324199",
      "INDEX ITEM DESCRIPTION":
        "Fuel briquettes or boulets made from refined petroleum",
    },
    {
      NAICS22: "324199",
      "INDEX ITEM DESCRIPTION": "Oil-based additives made from refined petroleum",
    },
    {
      NAICS22: "324199",
      "INDEX ITEM DESCRIPTION": "Petroleum jelly made from refined petroleum",
    },
    {
      NAICS22: "324199",
      "INDEX ITEM DESCRIPTION": "Petroleum waxes made from refined petroleum",
    },
    {
      NAICS22: "324199",
      "INDEX ITEM DESCRIPTION": "Road oils made from refined petroleum",
    },
    {
      NAICS22: "324199",
      "INDEX ITEM DESCRIPTION": "Waxes, petroleum, made from refined petroleum",
    },
    {
      NAICS22: "325110",
      "INDEX ITEM DESCRIPTION":
        "Acyclic hydrocarbons (e.g., butene, ethylene, propene) (except acetylene) made from refined petroleum or liquid hydrocarbons",
    },
    {
      NAICS22: "325110",
      "INDEX ITEM DESCRIPTION":
        "Aliphatic (e.g., hydrocarbons) (except acetylene) made from refined petroleum or liquid hydrocarbons",
    },
    {
      NAICS22: "325110",
      "INDEX ITEM DESCRIPTION":
        "Aromatic petrochemicals made from refined petroleum or liquid hydrocarbons",
    },
    {
      NAICS22: "325110",
      "INDEX ITEM DESCRIPTION":
        "Benzene made from refined petroleum or liquid hydrocarbons",
    },
    {
      NAICS22: "325110",
      "INDEX ITEM DESCRIPTION":
        "Butadiene made from refined petroleum or liquid hydrocarbons",
    },
    {
      NAICS22: "325110",
      "INDEX ITEM DESCRIPTION":
        "Butane made from refined petroleum or liquid hydrocarbons",
    },
    {
      NAICS22: "325110",
      "INDEX ITEM DESCRIPTION":
        "Butylene made from refined petroleum or liquid hydrocarbons",
    },
    {
      NAICS22: "325110",
      "INDEX ITEM DESCRIPTION":
        "Cumene made from refined petroleum or liquid hydrocarbons",
    },
    {
      NAICS22: "325110",
      "INDEX ITEM DESCRIPTION":
        "Cyclic aromatic hydrocarbons made from refined petroleum or liquid hydrocarbons",
    },
    {
      NAICS22: "325110",
      "INDEX ITEM DESCRIPTION":
        "Dodecene made from refined petroleum or liquid hydrocarbons",
    },
    {
      NAICS22: "325110",
      "INDEX ITEM DESCRIPTION":
        "Ethane made from refined petroleum or liquid hydrocarbons",
    },
    {
      NAICS22: "325110",
      "INDEX ITEM DESCRIPTION":
        "Ethylbenzene made from refined petroleum or liquid hydrocarbons",
    },
    {
      NAICS22: "325110",
      "INDEX ITEM DESCRIPTION":
        "Ethylene made from refined petroleum or liquid hydrocarbons",
    },
    {
      NAICS22: "325110",
      "INDEX ITEM DESCRIPTION":
        "Heptanes made from refined petroleum or liquid hydrocarbons",
    },
    {
      NAICS22: "325110",
      "INDEX ITEM DESCRIPTION":
        "Heptenes made from refined petroleum or liquid hydrocarbons",
    },
    {
      NAICS22: "325110",
      "INDEX ITEM DESCRIPTION":
        "Isobutane made from refined petroleum or liquid hydrocarbons",
    },
    {
      NAICS22: "325110",
      "INDEX ITEM DESCRIPTION":
        "Isobutene made from refined petroleum or liquid hydrocarbons",
    },
    {
      NAICS22: "325110",
      "INDEX ITEM DESCRIPTION":
        "Isoprene made from refined petroleum or liquid hydrocarbons",
    },
    {
      NAICS22: "325110",
      "INDEX ITEM DESCRIPTION":
        "Nonene made from refined petroleum or liquid hydrocarbons",
    },
    {
      NAICS22: "325110",
      "INDEX ITEM DESCRIPTION":
        "Olefins made from refined petroleum or liquid hydrocarbons",
    },
    {
      NAICS22: "325110",
      "INDEX ITEM DESCRIPTION":
        "Paraffins made from refined petroleum or liquid hydrocarbons",
    },
    {
      NAICS22: "325110",
      "INDEX ITEM DESCRIPTION":
        "Pentanes made from refined petroleum or liquid hydrocarbons",
    },
    {
      NAICS22: "325110",
      "INDEX ITEM DESCRIPTION":
        "Pentenes made from refined petroleum or liquid hydrocarbons",
    },
    {
      NAICS22: "325110",
      "INDEX ITEM DESCRIPTION":
        "Propylene made from refined petroleum or liquid hydrocarbons",
    },
    {
      NAICS22: "325110",
      "INDEX ITEM DESCRIPTION":
        "Styrene made from refined petroleum or liquid hydrocarbons",
    },
    {
      NAICS22: "325110",
      "INDEX ITEM DESCRIPTION":
        "Toluene made from refined petroleum or liquid hydrocarbons",
    },
    {
      NAICS22: "325110",
      "INDEX ITEM DESCRIPTION":
        "Xylene made from refined petroleum or liquid hydrocarbons",
    },
    {
      NAICS22: "325120",
      "INDEX ITEM DESCRIPTION": "Acetylene manufacturing",
    },
    {
      NAICS22: "325120",
      "INDEX ITEM DESCRIPTION": "Argon manufacturing",
    },
    {
      NAICS22: "325120",
      "INDEX ITEM DESCRIPTION":
        "Biogases, industrial (i.e., compressed, liquefied, solid), manufacturing",
    },
    {
      NAICS22: "325120",
      "INDEX ITEM DESCRIPTION": "Carbon dioxide manufacturing",
    },
    {
      NAICS22: "325120",
      "INDEX ITEM DESCRIPTION": "Chlorodifluoromethane manufacturing",
    },
    {
      NAICS22: "325120",
      "INDEX ITEM DESCRIPTION": "Chlorofluorocarbon (CFC) gases manufacturing",
    },
    {
      NAICS22: "325120",
      "INDEX ITEM DESCRIPTION":
        "Compressed and liquefied industrial gas manufacturing",
    },
    {
      NAICS22: "325120",
      "INDEX ITEM DESCRIPTION": "Dichlorodifluoromethane manufacturing",
    },
    {
      NAICS22: "325120",
      "INDEX ITEM DESCRIPTION":
        "Dry ice (i.e., solid carbon dioxide) manufacturing",
    },
    {
      NAICS22: "325120",
      "INDEX ITEM DESCRIPTION": "Fluorinated hydrocarbon gases manufacturing",
    },
    {
      NAICS22: "325120",
      "INDEX ITEM DESCRIPTION": "Fluorocarbon gases manufacturing",
    },
    {
      NAICS22: "325120",
      "INDEX ITEM DESCRIPTION":
        "Gases, industrial (i.e., compressed, liquefied, solid), manufacturing",
    },
    {
      NAICS22: "325120",
      "INDEX ITEM DESCRIPTION": "Helium manufacturing",
    },
    {
      NAICS22: "325120",
      "INDEX ITEM DESCRIPTION": "Helium recovery from natural gas",
    },
    {
      NAICS22: "325120",
      "INDEX ITEM DESCRIPTION":
        "Hydrochlorofluorocarbon (HCFC) gases manufacturing",
    },
    {
      NAICS22: "325120",
      "INDEX ITEM DESCRIPTION": "Hydrofluorocarbon (HFC) gases manufacturing",
    },
    {
      NAICS22: "325120",
      "INDEX ITEM DESCRIPTION": "Hydrogen manufacturing",
    },
    {
      NAICS22: "325120",
      "INDEX ITEM DESCRIPTION": "Ice, dry, manufacturing",
    },
    {
      NAICS22: "325120",
      "INDEX ITEM DESCRIPTION": "Industrial gases manufacturing",
    },
    {
      NAICS22: "325120",
      "INDEX ITEM DESCRIPTION": "Liquid air manufacturing",
    },
    {
      NAICS22: "325120",
      "INDEX ITEM DESCRIPTION": "Monochlorodifluoromethane manufacturing",
    },
    {
      NAICS22: "325120",
      "INDEX ITEM DESCRIPTION": "Neon manufacturing",
    },
    {
      NAICS22: "325120",
      "INDEX ITEM DESCRIPTION": "Nitrogen manufacturing",
    },
    {
      NAICS22: "325120",
      "INDEX ITEM DESCRIPTION": "Nitrous oxide manufacturing",
    },
    {
      NAICS22: "325120",
      "INDEX ITEM DESCRIPTION": "Oxygen manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Acid dyes, synthetic organic, manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Anthraquinone dyes manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Antimony based pigments manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Arsenic based pigments manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Azine dyes manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Azo dyes manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Barytes based pigments manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION":
        "Black pigments (except carbon black, bone black, lamp black) manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION":
        "Blanc fixe (i.e., barium sulfate, precipitated) manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Ceramic colors manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION":
        "Chrome pigments (e.g., chrome green, chrome orange, chrome yellow) manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION":
        "Color pigments, inorganic (except bone black, carbon black, lamp black), manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION":
        "Color pigments, organic (except animal black, bone black), manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Copper base pigments manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Direct dyes manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Disperse dyes manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Dyes, inorganic, manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Dyes, synthetic organic, manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Eosin dyes manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Ferric oxide pigments manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Fluorescent dyes manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Food coloring, synthetic, manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION":
        "Inorganic pigments (except bone black, carbon black, lamp black) manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Iron based pigments manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Lakes (i.e., organic pigments) manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Lead based pigments manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Lead pigments manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Litharge manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Lithopone manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Metallic pigments, inorganic, manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Methyl violet toners manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Mineral colors and pigments manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Mordant dyes manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Nitroso dyes manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Ocher pigments manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION":
        "Organic pigments, dyes, lakes, and toners manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Pararosaniline dyes manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Peacock blue lake manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Pearl essence pigment, synthetic, manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Persian orange lake manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION":
        "Phosphomolybdic acid lakes and toners manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION":
        "Phosphotungstic acid lakes and toners manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Phthalocyanine pigments manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Pigment, scarlet lake, manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION":
        "Pigments (except animal black, bone black), organic, manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION":
        "Pigments (except bone black, carbon black, lamp black), inorganic, manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Prussian blue pigments manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Satin white pigments manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Scarlet 2 R lake manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Sienna pigment manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Solvent dyes manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Stains, biological, manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Stilbene dyes manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Titanium based pigments manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION":
        "Toners (except electrostatic, photographic) manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Ultramarine pigments manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Umber manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Vat dyes, synthetic, manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Vermilion pigments manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION":
        "White extender pigments (e.g., barytes, blanc fixe, whiting) manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Whiting manufacturing",
    },
    {
      NAICS22: "325130",
      "INDEX ITEM DESCRIPTION": "Zinc based pigments manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Alkalies manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Aluminum chloride manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Aluminum compounds, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Aluminum hydroxide (i.e., alumina trihydrate) manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Aluminum sulfate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Alums (e.g., aluminum ammonium sulfate, aluminum potassium sulfate) manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Ammonium chloride manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Ammonium compounds, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Ammonium hydroxide manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Ammonium molybdate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Ammonium perchlorate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Ammonium thiosulfate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Animal black manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Antimony oxide (except pigments) manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Arsenates (except insecticides) manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Arsenic compounds, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Arsenites (except insecticides) manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Barium compounds, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Barium hydroxide manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Beryllium oxide manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Bleaching agents, inorganic, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Bone black manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Borax (i.e., sodium borate) manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Boric acid manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Boron compounds, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Borosilicate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Bromine manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Calcium carbide, chloride, and hypochlorite manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Calcium hypochlorite manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Calcium inorganic compounds, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Carbides (e.g., boron, calcium, silicon, tungsten) manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Carbon black manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Carbon disulfide manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Carbon inorganic compounds manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Carbonic acid manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Caustic potash manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Caustic soda (i.e., sodium hydroxide) manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Cerium salts manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Cesium and cesium compounds, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Channel black manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Chloride of lime manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Chlorine compounds, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Chlorine dioxide manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Chlorine manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Chlorosulfonic acid manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Chromic acid manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Chromium compounds, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Chromium oxide manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Chromium salts manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Cobalt 60 (i.e., radioactive cobalt) manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Cobalt chloride manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Cobalt compounds, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Cobalt sulfate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Copper chloride manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Copper compounds, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Copper iodide manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Copper sulfate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Cyanides manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Deuterium oxide (i.e., heavy water) manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Dichromates manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Ferric chloride manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Ferric oxide manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Ferrocyanides manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Fluoboric acid manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Fluorine manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Fuel propellants, solid inorganic, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Furnace black manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Glauber's salt manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Heavy water (i.e., deuterium oxide) manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Hydrazine manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Hydrochloric acid manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Hydrocyanic acid manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Hydrofluoric acid manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Hydrofluosilicic acid manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Hydrogen peroxide manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Hydrogen sulfide manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Hydrosulfites manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Hypochlorites manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Hypophosphites manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Indium chloride manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Iodides manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Iodine, crude or resublimed, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Iron compounds, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Iron sulphate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Lamp black manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Lead oxides (except pigments) manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Lead silicate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Lithium compounds, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Magnesium carbonate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Magnesium chloride manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Magnesium compounds, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Manganese dioxide manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Mercury chloride manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Mercury compounds, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Mercury oxide manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Nickel ammonium sulfate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Nickel carbonate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Nickel compounds, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Nickel sulfate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Nuclear fuel scrap reprocessing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Nuclear fuels, inorganic, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Oleum (i.e., fuming sulfuric acid) manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Perchloric acid manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Peroxides, inorganic, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Phosphorus compounds, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Phosphorus oxychloride manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Potassium aluminum sulfate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Potassium bichromate and chromate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Potassium bromide manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Potassium carbonate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Potassium chlorate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Potassium chloride manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Potassium cyanide manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Potassium hydroxide (i.e., caustic potash) manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Potassium hypochlorate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Potassium inorganic compounds, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Potassium iodide manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Potassium nitrate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Potassium permanganate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Potassium salts manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Potassium sulfate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Radioactive elements manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Radioactive isotopes manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Radium chloride manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Radium luminous compounds manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Rare earth compounds, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Rare earth salts manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Sal soda (i.e., washing soda) manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Selenium compounds, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Selenium dioxide manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Silica gel manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Silica, amorphous, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Silicofluorides manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Silver bromide manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Silver chloride manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Silver compounds, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Silver nitrate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Soda ash manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Sodium aluminate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Sodium aluminum sulfate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Sodium antimoniate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Sodium arsenite (except insecticides) manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Sodium bicarbonate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Sodium bichromate and chromate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Sodium borate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Sodium borohydride manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Sodium bromide manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Sodium carbonate (i.e., soda ash) manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Sodium chlorate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Sodium cyanide manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Sodium hydrosulfite manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Sodium hydroxide (i.e., caustic soda) manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Sodium hypochlorite manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Sodium inorganic compounds, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Sodium molybdate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Sodium perborate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Sodium peroxide manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Sodium phosphate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Sodium polyphosphate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Sodium silicate (i.e., water glass) manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Sodium silicofluoride manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Sodium stannate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Sodium sulfate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Sodium tetraborate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Sodium thiosulfate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Sodium tungstate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Sodium uranate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Solid fuel propellants, inorganic, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Stannic and stannous chloride manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Strontium carbonate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Strontium compounds, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Strontium nitrate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Sulfides and sulfites manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Sulfocyanides manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Sulfur and sulfur compounds, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Sulfur chloride manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Sulfur dioxide manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Sulfur hexafluoride gas manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Sulfur recovering or refining (except from sour natural gas)",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Sulfuric acid manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Tanning agents, inorganic, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Thiocyanate manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Tin chloride manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Tin compounds, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Tin oxide manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Tin salts manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Titanium dioxide manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Tungstates (e.g., ammonium tungstate, sodium tungstate) manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Tungsten compounds, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Uranium compounds, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Uranium oxide manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Uranium, enriched, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Zinc ammonium chloride manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Zinc chloride manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Zinc compounds, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION":
        "Zinc hydrosulfite (i.e., zinc dithionite) manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Zinc oxide (except pigments) manufacturing",
    },
    {
      NAICS22: "325180",
      "INDEX ITEM DESCRIPTION": "Zinc sulfide manufacturing",
    },
    {
      NAICS22: "325193",
      "INDEX ITEM DESCRIPTION": "Denatured alcohol manufacturing",
    },
    {
      NAICS22: "325193",
      "INDEX ITEM DESCRIPTION": "Ethanol, nonpotable, manufacturing",
    },
    {
      NAICS22: "325193",
      "INDEX ITEM DESCRIPTION": "Ethyl alcohol, nonpotable, manufacturing",
    },
    {
      NAICS22: "325193",
      "INDEX ITEM DESCRIPTION": "Grain alcohol, nonpotable, manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION":
        "Acetate of lime, natural, made by distillation of wood",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Acetone, natural, manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Aminoanthraquinone manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Aminoazobenzene manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Aminoazotoluene manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Aminophenol manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Aniline manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Annatto extract manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Anthracene manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Azobenzene manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Benzaldehyde manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Benzoic acid manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Brazilwood extract manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Brewers' pitch made by distillation of wood",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Camphor, natural, manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Charcoal (except activated) manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Charcoal briquettes, wood, manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Chestnut extract manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Chlorobenzene manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Chloronaphthalene manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Chlorophenol manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Chlorotoluene manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Coal tar distillates manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Creosote made by distillation of coal tar",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Creosote made by distillation of wood tar",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Cresols made by distillation of coal tar",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION":
        "Cresylic acids made from refined petroleum or natural gas",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Cyclic crudes made by distillation of coal tar",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION":
        "Cyclic intermediates made from refined petroleum or natural gas (except aromatic petrochemicals)",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Cyclohexane manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION":
        "Cyclopentane made from refined petroleum or natural gas",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION":
        "Cyclopropane made from refined petroleum or natural gas",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Cycloterpenes manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Diethylcyclohexane manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Diphenylamine manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Distillates, wood, manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Dragon's blood manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Dyes, natural, manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Ethyl acetate, natural, manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION":
        "Extracts, natural dyeing and tanning, manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Fustic wood extract manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Gambier extract manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Gum and wood chemicals manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION":
        "Halogenated aromatic hydrocarbon derivatives manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Hardwood distillates manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Hemlock extract manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Hydroquinone manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Isocyanates manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Logwood extract manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Maleic anhydride manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Mangrove extract manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Methyl acetone manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION":
        "Methyl alcohol (methanol), natural, manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Myrobalans extract manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Naphtha made by distillation of coal tar",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION":
        "Naphtha, solvent, made by distillation of coal tar",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION":
        "Naphthalene made from refined petroleum or natural gas",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Naphthalenesulfonic acid manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION":
        "Naphthenic acids made from refined petroleum or natural gas",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Naphthol sulfonic acids manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Naphthol, alpha and beta, manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Naval stores, gum or wood, manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Nitrated hydrocarbon derivatives manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Nitroaniline manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Nitrobenzene manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Nitrophenol manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION":
        "Nitrosated hydrocarbon derivatives manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Oak extract manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Oils made by distillation of coal tar",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Oils, wood, made by distillation of wood",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Orthodichlorobenzene manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Pentachlorophenol manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Phenol manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Phthalic anhydride manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Pine oil manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Pinene manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Pitch made by distillation of coal tar",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Pitch, wood, manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Pyroligneous acids manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Quebracho extracts manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Quercitron extracts manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Resorcinol manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION":
        "Rosins made by distillation of pine gum or pine wood",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Softwood distillates manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Sulfonated naphthalene manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Sulphonated derivatives manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Sumac extract manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Tall oil (except skimmings) manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Tannic acid (i.e., tannins) manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION":
        "Tanning extracts and materials, natural, manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Tar and tar oils made by distillation of wood",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Tar made by distillation of coal tar",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Toluidines manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION":
        "Turpentine made by distillation of pine gum or pine wood",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Valonia extract manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Wattle extract manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Witch hazel extract manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Wood alcohol, natural, manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Wood distillates manufacturing",
    },
    {
      NAICS22: "325194",
      "INDEX ITEM DESCRIPTION": "Wood oils manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION":
        "Accelerators (i.e., basic synthetic chemical) manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Acetaldehyde manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION":
        "Acetates, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Acetic acid manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Acetic anhydride manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Acetin manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Acetone, synthetic, manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION":
        "Acid esters, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION":
        "Acids, organic, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Acrolein manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Acrylonitrile manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Adipic acid esters or amines manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Adipic acid manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Adiponitrile manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Aldehydes manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION":
        "Alginates (e.g., calcium, potassium, sodium) manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Alginic acid manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Amyl acetate manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION":
        "Biodiesel fuels not made in petroleum refineries and not blended with petroleum",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION":
        "Biofuels not made in petroleum refineries and not blended with petroleum",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Bleaching agents, organic, manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Bromochloromethane manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Butadiene made from alcohol",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Butyl acetate manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Calcium citrate manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION":
        "Calcium organic compounds, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Calcium oxalate manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Camphor, synthetic, manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Caprolactam manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Carbinol manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION":
        "Carbon organic compounds, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Carbon tetrachloride manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Cellulose acetate (except resins) manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Cetyl alcohol manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Chloral manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Chloroacetic acid manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Chloroform manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Chloropicrin manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Citral manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION":
        "Citrates, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Citric acid manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Citronellal manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Coumarin manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Cream of tartar manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Decahydronaphthalene manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Diethylene glycol manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION":
        "Dimethyl divinyl acetylene (di-isopropenyl acetylene) manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Dimethylhydrazine manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION":
        "Enzyme proteins (i.e., basic synthetic chemicals) (except pharmaceutical use) manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Essential oils, synthetic, manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION":
        "Esters, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Ethyl acetate, synthetic, manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Ethyl butyrate manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Ethyl cellulose (except resins) manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Ethyl chloride manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Ethyl ether manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Ethyl formate manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Ethyl nitrite manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Ethyl perhydrophenanthrene manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Ethylene glycol ether manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Ethylene glycol manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Ethylene oxide manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Fatty acid esters and amines manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION":
        "Fatty acids (e.g., margaric, oleic, stearic) manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Fatty alcohols manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION":
        "Flavoring materials (i.e., basic synthetic chemicals such as coumarin) manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Formaldehyde manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Formalin manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Formic acid manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION":
        "Fuel propellants, solid organic, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Geraniol manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION":
        "Glycerin (i.e., glycerol), synthetic, manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION":
        "Halogenated hydrocarbon derivatives (except aromatic) manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION":
        "Heterocyclic chemicals, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Hexadecanol manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Hexamethylenediamine manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Hexamethylenetetramine manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Hexanol manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Ionone manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Isopropyl alcohol manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION":
        "Ketone compounds, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Lactic acid manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Lauric acid esters and amines manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Linoleic acid esters and amines manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Malonic dinitrile manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Margaric acid manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Metallic soap manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION":
        "Methyl alcohol (i.e., methanol), synthetic, manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Methyl chloride manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Methyl perhydrofluorine manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Methyl salicylate manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Methylamine manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Methylene chloride manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Monomethylparaminophenol sulfate manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Monosodium glutamate manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Naphthenic acid soaps manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Natural nonfood coloring manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Nitrous ether manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Oleic acid (i.e., red oil) manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Oleic acid esters manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Organo-inorganic compound manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION":
        "Oxalates (e.g., ammonium oxalate, ethyl oxalate, sodium oxalate) manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Oxalic acid manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Palmitic acid esters and amines manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Pentaerythritol manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Perchloroethylene manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION":
        "Perfume materials (i.e., basic synthetic chemicals, such as terpineol) manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Peroxides, organic, manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Phosgene manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Phosphoric acid esters manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Phthalate acid manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION":
        "Plasticizers (i.e., basic synthetic chemicals) manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION":
        "Polyhydric alcohol esters and amines manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Polyhydric alcohols manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Potassium bitartrate manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION":
        "Potassium organic compounds, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Propylcarbinol manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Propylene glycol manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Raw organic waxes manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Red oil (i.e., oleic acid) manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Refrigerant mixtures and blends manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Saccharin manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Salicylic acid (except medicinal) manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Sebacic acid esters manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Sebacic acid manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Silicone (except resins) manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Sodium acetate manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Sodium alginate manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Sodium benzoate manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Sodium glutamate manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION":
        "Sodium organic compounds, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Sodium pentachlorophenate manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Sodium sulfoxalate formaldehyde manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Sorbitol manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Stearic acid esters manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Stearic acid manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Stearic acid salts manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION":
        "Sugar substitutes (i.e., synthetic sweeteners blended with other ingredients) made in synthetic sweetener establishments",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION":
        "Synthetic sweeteners (i.e., sweetening agents) manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION":
        "Tanning agents, synthetic organic, manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Tartaric acid manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION":
        "Tartrates, not specified elsewhere by process, manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Tear gas manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Terpineol manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION":
        "Tert-butylated bis (p-phenoxyphenyl) ether fluid manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Tetrachloroethylene manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Tetraethyl lead manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Thioglycolic acid manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION":
        "Transesterification of vegetable oils to produce fuels or fuel additives",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Trichloroethylene manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Trichlorophenoxyacetic acid manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Tricresyl phosphate manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Tridecyl alcohol manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Triphenyl phosphate manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Vanillin, synthetic, manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Vinyl acetate (except resins) manufacturing",
    },
    {
      NAICS22: "325199",
      "INDEX ITEM DESCRIPTION": "Wood alcohol, synthetic, manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Acetal resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Acrylic resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION":
        "Acrylonitrile-butadiene-styrene (ABS) resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Alkyd resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Allyl resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Amino resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Amino-aldehyde resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION":
        "Butadiene copolymers containing less than 50 percent butadiene manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Carbohydrate plastics manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Casein plastics manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Cellulose acetate resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Cellulose nitrate resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Cellulose propionate resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Cellulose resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Cellulose xanthate (viscose) manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Coal tar resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Coumarone-indene resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Cresol resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Cresol-furfural resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Dicyandiamine resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Diisocyanate resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION":
        "Elastomers (except synthetic rubber) manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Epichlorohydrin bisphenol manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Epichlorohydrin diphenol manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Epoxy resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Ester gum manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Ethylcellulose plastics manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Ethylene-vinyl acetate resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Fluorohydrocarbon resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Fluoro-polymer resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Ion exchange resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Ionomer resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Isobutylene polymer resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Lignin plastics manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Melamine resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Methyl acrylate resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Methyl cellulose resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Methyl methacrylate resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION":
        "Nitrocellulose (i.e., pyroxylin) resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Nylon resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Petroleum polymer resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Phenol-formaldehyde resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Phenol-furfural resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Phenolic resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Phenoxy resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Phthalic alkyd resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Phthalic anhydride resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION":
        "Plastics and synthetic resins regenerating, precipitating, and coagulating",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Polyacrylonitrile resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Polyamide resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Polycarbonate resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Polyester resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Polyethylene resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION":
        "Polyethylene terephthalate (PET) resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION":
        "Polyhexamethylenediamine adipamide resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Polyisobutylene resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Polymethacrylate resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Polypropylene resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Polystyrene resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Polytetrafluoroethylene resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Polyurethane resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Polyvinyl alcohol resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Polyvinyl chloride (PVC) resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Polyvinyl halide resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Polyvinyl resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Propylene resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Protein plastics manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION":
        "Pyroxylin (i.e., nitrocellulose) resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION":
        "Resins, plastics (except custom compounding purchased resins), manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Rosins (i.e., modified resins) manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Silicone resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Soybean plastics manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Styrene resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Styrene-acrylonitrile resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Tar acid resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION":
        "Thermoplastic resins and plastics materials manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Thermosetting plastics resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Urea resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Urea-formaldehyde resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Vinyl acetate resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Vinyl chloride resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Vinyl resins manufacturing",
    },
    {
      NAICS22: "325211",
      "INDEX ITEM DESCRIPTION": "Vinylidene resins manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION": "Acrylate rubber manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION": "Acrylate-butadiene rubber manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION": "Acrylic rubber manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION":
        "Butadiene copolymers containing more than 50 percent butadiene manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION":
        "Butadiene rubber (i.e., polybutadiene) manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION": "Butyl rubber manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION": "Chlorinated rubber, synthetic, manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION": "Chloroprene rubber manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION": "Chlorosulfonated polyethylenes manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION": "Cyclo rubber, synthetic, manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION": "Elastomers, synthetic rubber, manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION": "Epichlorohydrin elastomers manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION": "Ethylene-propylene rubber manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION":
        "Ethylene-propylene-nonconjugated diene (EPDM) rubber manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION": "Fluoro rubbers manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION": "Fluorocarbon derivative rubbers manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION": "Isobutylene-isoprene rubber manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION": "Isocyanate rubber manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION": "Latex rubber, synthetic, manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION": "Neoprene manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION": "Nitrile rubber manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION": "Nitrile-butadiene rubber manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION": "Nitrile-chloroprene rubbers manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION": "N-type rubber manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION": "Polyethylene rubber manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION": "Polyisobutylene rubber manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION": "Polyisobutylene-isoprene rubber manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION": "Polymethylene rubber manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION": "Polysulfide rubber manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION": "Rubber, synthetic, manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION": "Silicone rubber manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION": "Stereo rubber manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION": "S-type rubber manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION":
        "Styrene-butadiene rubber containing less than 50 percent styrene manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION": "Styrene-chloroprene rubber manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION": "Styrene-isoprene rubber manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION":
        "Synthetic rubber (i.e., vulcanizable elastomers) manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION":
        "Thermosetting vulcanizable elastomers manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION": "Thiol rubber manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION": "Urethane rubber manufacturing",
    },
    {
      NAICS22: "325212",
      "INDEX ITEM DESCRIPTION": "Vulcanized oils manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION": "Acetate fibers and filaments manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION": "Acrylic fibers and filaments manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION":
        "Acrylonitrile fibers and filaments manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION": "Anidex fibers and filaments manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION": "Casein fibers and filaments manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION": "Cellophane film or sheet manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION": "Cellulosic fibers and filaments manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION": "Cellulosic filament yarn manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION": "Cellulosic staple fibers manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION": "Cigarette tow, cellulosic fiber, manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION": "Elastomeric fibers and filaments manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION":
        "Fibers and filaments, cellulosic, manufacturing and texturizing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION":
        "Fibers and filaments, noncellulosic, manufacturing and texturizing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION": "Fluorocarbon fibers and filaments manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION":
        "Linear esters fibers and filaments manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION": "Manmade cellulosic fibers manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION":
        "Manmade noncellulosic fibers and filaments manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION": "Modacrylic fibers and filaments manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION": "Nitrocellulose fibers manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION":
        "Noncellulosic fibers and filaments manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION": "Noncellulosic filament yarn manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION":
        "Noncellulosic staple fibers and filaments manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION": "Nylon fibers and filaments manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION": "Olefin fibers and filaments manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION":
        "Organic noncellulosic fibers and filaments manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION": "Polyester fibers and filaments manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION":
        "Polyethylene terephthalate (PET) fibers and filaments manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION": "Polyolefin fibers and filaments manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION":
        "Polyvinyl ester fibers and filaments manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION":
        "Polyvinylidene chloride (i.e., saran) fibers and filaments manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION": "Protein fibers and filaments manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION": "Rayon fibers and filaments manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION": "Regenerated cellulosic fibers manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION":
        "Saran (i.e., polyvinylidene chloride) fibers and filaments manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION": "Soybean fibers and filaments manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION":
        "Spandex fiber, filaments, and yarn manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION":
        "Texturizing cellulosic yarn made in the same establishment",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION":
        "Texturizing noncellulosic yarn made in the same establishment",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION":
        "Throwing cellulosic yarn made in the same establishment",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION":
        "Throwing noncellulosic yarn made in the same establishment",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION": "Triacetate fibers and yarns manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION": "Vinyl fibers and filaments manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION":
        "Vinylidene chloride fiber and filament manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION":
        "Viscose fibers, bands, strips, and yarn manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION": "Yarn, cellulosic filament, manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION":
        "Yarn, cellulosic filament, manufacturing and texturizing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION":
        "Yarn, noncellulosic fiber and filament, manufacturing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION":
        "Yarn, noncellulosic fiber and filament, manufacturing and texturizing",
    },
    {
      NAICS22: "325220",
      "INDEX ITEM DESCRIPTION": "Zein fibers and filaments manufacturing",
    },
    {
      NAICS22: "325311",
      "INDEX ITEM DESCRIPTION": "Ammonia, anhydrous and aqueous, manufacturing",
    },
    {
      NAICS22: "325311",
      "INDEX ITEM DESCRIPTION": "Ammonium nitrate manufacturing",
    },
    {
      NAICS22: "325311",
      "INDEX ITEM DESCRIPTION": "Ammonium sulfate manufacturing",
    },
    {
      NAICS22: "325311",
      "INDEX ITEM DESCRIPTION": "Anhydrous ammonia manufacturing",
    },
    {
      NAICS22: "325311",
      "INDEX ITEM DESCRIPTION":
        "Fertilizers, mixed, made in plants producing nitrogenous fertilizer materials",
    },
    {
      NAICS22: "325311",
      "INDEX ITEM DESCRIPTION":
        "Fertilizers, natural organic (except compost), manufacturing",
    },
    {
      NAICS22: "325311",
      "INDEX ITEM DESCRIPTION":
        "Fertilizers, of animal waste origin, manufacturing",
    },
    {
      NAICS22: "325311",
      "INDEX ITEM DESCRIPTION": "Fertilizers, of sewage origin, manufacturing",
    },
    {
      NAICS22: "325311",
      "INDEX ITEM DESCRIPTION": "Nitric acid manufacturing",
    },
    {
      NAICS22: "325311",
      "INDEX ITEM DESCRIPTION": "Nitrogenous fertilizer materials manufacturing",
    },
    {
      NAICS22: "325311",
      "INDEX ITEM DESCRIPTION":
        "Plant foods, mixed, made in plants producing nitrogenous fertilizer materials",
    },
    {
      NAICS22: "325311",
      "INDEX ITEM DESCRIPTION": "Urea manufacturing",
    },
    {
      NAICS22: "325312",
      "INDEX ITEM DESCRIPTION": "Ammonium phosphates manufacturing",
    },
    {
      NAICS22: "325312",
      "INDEX ITEM DESCRIPTION": "Defluorinated phosphates manufacturing",
    },
    {
      NAICS22: "325312",
      "INDEX ITEM DESCRIPTION": "Diammonium phosphates manufacturing",
    },
    {
      NAICS22: "325312",
      "INDEX ITEM DESCRIPTION":
        "Fertilizers, mixed, made in plants producing phosphatic fertilizer materials",
    },
    {
      NAICS22: "325312",
      "INDEX ITEM DESCRIPTION": "Phosphatic fertilizer materials manufacturing",
    },
    {
      NAICS22: "325312",
      "INDEX ITEM DESCRIPTION": "Phosphoric acid manufacturing",
    },
    {
      NAICS22: "325312",
      "INDEX ITEM DESCRIPTION":
        "Plant foods, mixed, made in plants producing phosphatic fertilizer materials",
    },
    {
      NAICS22: "325312",
      "INDEX ITEM DESCRIPTION": "Superphosphates manufacturing",
    },
    {
      NAICS22: "325314",
      "INDEX ITEM DESCRIPTION":
        "Fertilizers, mixed, made in plants not manufacturing fertilizer materials",
    },
    {
      NAICS22: "325314",
      "INDEX ITEM DESCRIPTION": "Mixing purchased fertilizer materials",
    },
    {
      NAICS22: "325314",
      "INDEX ITEM DESCRIPTION":
        "Nitrogenous fertilizers made by mixing purchased materials",
    },
    {
      NAICS22: "325314",
      "INDEX ITEM DESCRIPTION":
        "Phosphatic fertilizers made by mixing purchased materials",
    },
    {
      NAICS22: "325314",
      "INDEX ITEM DESCRIPTION":
        "Potassic fertilizers made by mixing purchased materials",
    },
    {
      NAICS22: "325314",
      "INDEX ITEM DESCRIPTION": "Potting soil manufacturing",
    },
    {
      NAICS22: "325315",
      "INDEX ITEM DESCRIPTION": "Compost manufacturing",
    },
    {
      NAICS22: "325315",
      "INDEX ITEM DESCRIPTION": "Sewage and animal waste compost manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION": "Ant poisons manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION": "Arsenate insecticides manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION": "Arsenite insecticides manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION":
        "Benzene hexachloride (BHC) insecticides manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION": "Bordeaux mixture insecticides manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION": "Botanical insecticides manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION": "Chlordane insecticides manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION":
        "Cholinesterase inhibitors used as insecticides manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION":
        "DDT (dichlorodiphenyltrichloroethane) insecticides manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION": "Defoliants manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION":
        "Dips (i.e., pesticides), cattle and sheep, manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION": "Endrin insecticides manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION":
        "Exterminating chemical products (e.g., fungicides, insecticides, pesticides) manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION": "Flea powders or sprays manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION": "Fly sprays manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION": "Fungicides manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION": "Herbicides manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION": "Household-type insecticides manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION": "Insecticides manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION": "Lime-sulfur fungicides manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION": "Lindane pesticides manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION": "Malathion insecticides manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION": "Methoxychlor insecticides manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION": "Moth repellents manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION": "Nicotine insecticides manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION":
        "Organo-phosphate based insecticides manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION": "Parathion insecticides manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION": "Paris green insecticides manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION":
        "Pest (e.g., ant, rat, roach, rodent) control poison manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION": "Pesticides manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION": "Plant growth regulants manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION": "Pyrethrin insecticides manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION": "Roach poisons manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION": "Rodent poisons manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION": "Rodenticides manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION": "Root removing chemicals manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION": "Rotenone insecticides manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION": "Seed treatment preparations manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION": "Sodium arsenite insecticides manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION": "Sulfur insecticides manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION": "Termite poisons manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION": "Tick powders or sprays manufacturing",
    },
    {
      NAICS22: "325320",
      "INDEX ITEM DESCRIPTION": "Xanthone insecticides manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION": "Acetylsalicylic acid manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION":
        "Adrenal derivatives, uncompounded, manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION": "Agar-agar manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION": "Amphetamines, uncompounded, manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION": "Anesthetics, uncompounded, manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION": "Antibiotics, uncompounded, manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION": "Anticholinergics, uncompounded, manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION": "Anticonvulsants, uncompounded, manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION": "Antidepressants, uncompounded, manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION":
        "Ascorbic acid (i.e., vitamin C), uncompounded, manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION": "Atropine and derivatives manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION": "Barbiturates, uncompounded, manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION": "Barbituric acid manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION": "Brucine manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION":
        "Caffeine and derivatives (i.e., basic chemicals) manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION": "Cephalosporin, uncompounded, manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION":
        "Cinchona and derivatives (i.e., basic chemicals) manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION":
        "Cocaine and derivatives (i.e., basic chemicals) manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION":
        "Cod liver oil, medicinal, uncompounded, manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION":
        "Codeine and derivatives (i.e., basic chemicals) manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION":
        "Concentrated medicinal chemicals, uncompounded, manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION": "Cortisone, uncompounded, manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION":
        "Dietary supplements, uncompounded, manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION": "Digitoxin, uncompounded, manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION": "Endocrine products, uncompounded, manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION":
        "Enzyme proteins (i.e., basic synthetic chemicals), pharmaceutical use, manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION":
        "Ephedrine and derivatives (i.e., basic chemicals) manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION":
        "Ergot alkaloids (i.e., basic chemicals) manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION":
        "Fish liver oils, medicinal, uncompounded, manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION":
        "Glandular derivatives, uncompounded, manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION": "Glycosides, uncompounded, manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION":
        "Grinding and milling botanicals (i.e., for medicinal or dietary supplement use)",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION": "Herbal supplements, uncompounded, manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION":
        "Hormones and derivatives, uncompounded, manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION": "Hypnotic drugs, uncompounded, manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION": "Insulin, uncompounded, manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION":
        "Magnesia, medicinal, uncompounded, manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION":
        "Medicinal chemicals, uncompounded, manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION": "Medicinal gelatins manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION":
        "Morphine and derivatives (i.e., basic chemicals) manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION":
        "Nicotine and derivatives (i.e., basic chemicals) manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION": "N-methylpiperazine manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION":
        "Oils, vegetable and animal, medicinal, uncompounded, manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION": "Ophthalmic agents, uncompounded, manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION":
        "Opium and opium derivatives (i.e., basic chemicals) manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION": "Penicillin, uncompounded, manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION":
        "Physostigmine and derivatives (i.e., basic chemicals) manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION":
        "Pituitary gland derivatives, uncompounded, manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION":
        "Procaine and derivatives (i.e., basic chemicals) manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION":
        "Quinine and derivatives (i.e., basic chemicals) manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION":
        "Reserpines (i.e., basic chemicals) manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION":
        "Salicylic acid, medicinal, uncompounded, manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION": "Steroids, uncompounded, manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION":
        "Strychnine and derivatives (i.e., basic chemicals) manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION": "Sulfa drugs, uncompounded, manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION": "Sulfonamides, uncompounded, manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION": "Tetracycline, uncompounded, manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION":
        "Theobromine and derivatives (i.e., basic chemicals) manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION":
        "Vegetable alkaloids (i.e., basic chemicals) (e.g., caffeine, codeine, morphine, nicotine), manufacturing",
    },
    {
      NAICS22: "325411",
      "INDEX ITEM DESCRIPTION": "Vitamins, uncompounded, manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Adrenal medicinal preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Analgesic preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Anesthetic preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION":
        "Angiourographic diagnostic preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Antacid preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Anthelmintic preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Antibacterial preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Antibiotic preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Antidepressant preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Antihistamine preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Antineoplastic preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Antipyretic preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Antiseptic preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Antispasmodic preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Astringent preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Barbiturate preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION":
        "Barium in-vivo diagnostic substances manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Belladonna preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Birth control pills manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION":
        "Botanical extract preparations (except in-vitro diagnostics) manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Cardiac preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Cathartic preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION":
        "Central nervous system stimulant preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION":
        "Coagulation in-vivo diagnostic substances manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Cold remedies manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Contraceptive preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION":
        "Contrast media in-vivo diagnostic substances (e.g., iodine, barium) manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Cough drops, medicated, manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Cough medicines manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION":
        "Cyclopropane medicinal preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Dermatological preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION":
        "Diagnostic biological preparations (except in-vitro) manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Dietary supplements, compounded, manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Digestive system preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Digitalis medicinal preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Diuretic preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Effervescent salts manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION":
        "Electrolyte in-vivo diagnostic substances manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Eye and ear preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Fever remedy preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Glandular medicinal preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION":
        "Hematology in-vivo diagnostic substances manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Herbal supplements, compounded, manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION":
        "Hormone preparations (except in-vitro diagnostics) manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Insulin preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION":
        "Intravenous (IV) solution preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "In-vivo diagnostic substances manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION":
        "Iodinated in-vivo diagnostic substances manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Laxative preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Lip balms manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION":
        "Metabolite in-vivo diagnostic substances manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Mouthwashes, medicated, manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Muscle relaxant preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Nonprescription drug preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION":
        "Nuclear medicine (e.g., radioactive isotopes) preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Oral contraceptive preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Patent medicine preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Penicillin preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION":
        "Pharmaceutical preparations (e.g., capsules, liniments, ointments, tablets) manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Pituitary gland preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION":
        "Radioactive in-vivo diagnostic substances manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Sedative preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION":
        "Sodium chloride pharmaceutical preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Sodium salicylate preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Suppositories manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Technetium medicinal preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Thyroid preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Tincture of iodine preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Tranquilizer preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Vermifuge preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Veterinary medicinal preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Vitamin preparations manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION":
        "Water (i.e., drinking) decontamination or purification tablets manufacturing",
    },
    {
      NAICS22: "325412",
      "INDEX ITEM DESCRIPTION": "Zinc oxide medicinal preparations manufacturing",
    },
    {
      NAICS22: "325413",
      "INDEX ITEM DESCRIPTION":
        "Blood derivative in-vitro diagnostic substances manufacturing",
    },
    {
      NAICS22: "325413",
      "INDEX ITEM DESCRIPTION": "Blood glucose test kits manufacturing",
    },
    {
      NAICS22: "325413",
      "INDEX ITEM DESCRIPTION":
        "Coagulation in-vitro diagnostic substances manufacturing",
    },
    {
      NAICS22: "325413",
      "INDEX ITEM DESCRIPTION":
        "Cytology and histology in-vitro diagnostic substances manufacturing",
    },
    {
      NAICS22: "325413",
      "INDEX ITEM DESCRIPTION": "Diagnostic substances, in-vitro, manufacturing",
    },
    {
      NAICS22: "325413",
      "INDEX ITEM DESCRIPTION":
        "Enzyme and isoenzyme in-vitro diagnostic substances manufacturing",
    },
    {
      NAICS22: "325413",
      "INDEX ITEM DESCRIPTION":
        "Hematology in-vitro diagnostic substances manufacturing",
    },
    {
      NAICS22: "325413",
      "INDEX ITEM DESCRIPTION": "HIV test kits manufacturing",
    },
    {
      NAICS22: "325413",
      "INDEX ITEM DESCRIPTION":
        "Hormone in-vitro diagnostic substances manufacturing",
    },
    {
      NAICS22: "325413",
      "INDEX ITEM DESCRIPTION": "In-vitro diagnostic substances manufacturing",
    },
    {
      NAICS22: "325413",
      "INDEX ITEM DESCRIPTION":
        "Microbiology, virology, and serology in-vitro diagnostic substances manufacturing",
    },
    {
      NAICS22: "325413",
      "INDEX ITEM DESCRIPTION": "Pregnancy test kits manufacturing",
    },
    {
      NAICS22: "325413",
      "INDEX ITEM DESCRIPTION":
        "Viral in-vitro diagnostic test substances manufacturing",
    },
    {
      NAICS22: "325414",
      "INDEX ITEM DESCRIPTION": "Agar culture media manufacturing",
    },
    {
      NAICS22: "325414",
      "INDEX ITEM DESCRIPTION": "Aggressins (except in-vitro) manufacturing",
    },
    {
      NAICS22: "325414",
      "INDEX ITEM DESCRIPTION":
        "Allergenic extracts (except diagnostic substances) manufacturing",
    },
    {
      NAICS22: "325414",
      "INDEX ITEM DESCRIPTION": "Allergens manufacturing",
    },
    {
      NAICS22: "325414",
      "INDEX ITEM DESCRIPTION": "Antigens manufacturing",
    },
    {
      NAICS22: "325414",
      "INDEX ITEM DESCRIPTION": "Antiserums manufacturing",
    },
    {
      NAICS22: "325414",
      "INDEX ITEM DESCRIPTION": "Antitoxins manufacturing",
    },
    {
      NAICS22: "325414",
      "INDEX ITEM DESCRIPTION": "Antivenoms manufacturing",
    },
    {
      NAICS22: "325414",
      "INDEX ITEM DESCRIPTION": "Bacterial vaccines manufacturing",
    },
    {
      NAICS22: "325414",
      "INDEX ITEM DESCRIPTION":
        "Bacterins (i.e., bacterial vaccines) manufacturing",
    },
    {
      NAICS22: "325414",
      "INDEX ITEM DESCRIPTION": "Blood derivatives manufacturing",
    },
    {
      NAICS22: "325414",
      "INDEX ITEM DESCRIPTION": "Blood fractions manufacturing",
    },
    {
      NAICS22: "325414",
      "INDEX ITEM DESCRIPTION": "Cholera serums manufacturing",
    },
    {
      NAICS22: "325414",
      "INDEX ITEM DESCRIPTION": "Culture media manufacturing",
    },
    {
      NAICS22: "325414",
      "INDEX ITEM DESCRIPTION": "Gene therapy preparations manufacturing",
    },
    {
      NAICS22: "325414",
      "INDEX ITEM DESCRIPTION":
        "Hematology products (except diagnostic substances) manufacturing",
    },
    {
      NAICS22: "325414",
      "INDEX ITEM DESCRIPTION": "Plasmas manufacturing",
    },
    {
      NAICS22: "325414",
      "INDEX ITEM DESCRIPTION":
        "Serums (except diagnostic substances) manufacturing",
    },
    {
      NAICS22: "325414",
      "INDEX ITEM DESCRIPTION":
        "Toxoids (e.g., diphtheria, tetanus) manufacturing",
    },
    {
      NAICS22: "325414",
      "INDEX ITEM DESCRIPTION":
        "Tuberculin (i.e., tuberculo-protein derived) manufacturing",
    },
    {
      NAICS22: "325414",
      "INDEX ITEM DESCRIPTION": "Vaccines (i.e., bacterial, virus) manufacturing",
    },
    {
      NAICS22: "325414",
      "INDEX ITEM DESCRIPTION": "Virus vaccines manufacturing",
    },
    {
      NAICS22: "325510",
      "INDEX ITEM DESCRIPTION":
        "Architectural coatings (i.e., paint) manufacturing",
    },
    {
      NAICS22: "325510",
      "INDEX ITEM DESCRIPTION": "Calcimines manufacturing",
    },
    {
      NAICS22: "325510",
      "INDEX ITEM DESCRIPTION": "Dispersions, pigment, manufacturing",
    },
    {
      NAICS22: "325510",
      "INDEX ITEM DESCRIPTION": "Dopes, paint, and lacquer manufacturing",
    },
    {
      NAICS22: "325510",
      "INDEX ITEM DESCRIPTION": "Driers, paint and varnish, manufacturing",
    },
    {
      NAICS22: "325510",
      "INDEX ITEM DESCRIPTION": "Enamel paints manufacturing",
    },
    {
      NAICS22: "325510",
      "INDEX ITEM DESCRIPTION": "Epoxy coatings made from purchased resins",
    },
    {
      NAICS22: "325510",
      "INDEX ITEM DESCRIPTION":
        "Fillers, wood (e.g., dry, liquid, paste), manufacturing",
    },
    {
      NAICS22: "325510",
      "INDEX ITEM DESCRIPTION": "Frit manufacturing",
    },
    {
      NAICS22: "325510",
      "INDEX ITEM DESCRIPTION": "Glaziers' putty manufacturing",
    },
    {
      NAICS22: "325510",
      "INDEX ITEM DESCRIPTION":
        "Industrial product finishes and coatings (i.e., paint) manufacturing",
    },
    {
      NAICS22: "325510",
      "INDEX ITEM DESCRIPTION": "Lacquers manufacturing",
    },
    {
      NAICS22: "325510",
      "INDEX ITEM DESCRIPTION": "Latex paint (i.e., water based) manufacturing",
    },
    {
      NAICS22: "325510",
      "INDEX ITEM DESCRIPTION": "Marine paints manufacturing",
    },
    {
      NAICS22: "325510",
      "INDEX ITEM DESCRIPTION": "Motor vehicle paints manufacturing",
    },
    {
      NAICS22: "325510",
      "INDEX ITEM DESCRIPTION": "Paint and varnish removers manufacturing",
    },
    {
      NAICS22: "325510",
      "INDEX ITEM DESCRIPTION":
        "Paint thinner and reducer preparations manufacturing",
    },
    {
      NAICS22: "325510",
      "INDEX ITEM DESCRIPTION": "Paintbrush cleaners manufacturing",
    },
    {
      NAICS22: "325510",
      "INDEX ITEM DESCRIPTION": "Paints (except artist's) manufacturing",
    },
    {
      NAICS22: "325510",
      "INDEX ITEM DESCRIPTION":
        "Paints, emulsion (i.e., latex paint), manufacturing",
    },
    {
      NAICS22: "325510",
      "INDEX ITEM DESCRIPTION": "Paints, oil and alkyd vehicle, manufacturing",
    },
    {
      NAICS22: "325510",
      "INDEX ITEM DESCRIPTION": "Plastic wood fillers manufacturing",
    },
    {
      NAICS22: "325510",
      "INDEX ITEM DESCRIPTION": "Plastisol coating compounds manufacturing",
    },
    {
      NAICS22: "325510",
      "INDEX ITEM DESCRIPTION": "Polyurethane coatings manufacturing",
    },
    {
      NAICS22: "325510",
      "INDEX ITEM DESCRIPTION": "Powder coatings manufacturing",
    },
    {
      NAICS22: "325510",
      "INDEX ITEM DESCRIPTION": "Primers, paint, manufacturing",
    },
    {
      NAICS22: "325510",
      "INDEX ITEM DESCRIPTION": "Shellac manufacturing",
    },
    {
      NAICS22: "325510",
      "INDEX ITEM DESCRIPTION": "Stains (except biological) manufacturing",
    },
    {
      NAICS22: "325510",
      "INDEX ITEM DESCRIPTION": "Varnishes manufacturing",
    },
    {
      NAICS22: "325510",
      "INDEX ITEM DESCRIPTION":
        "Water-repellent coatings for wood, concrete and masonry manufacturing",
    },
    {
      NAICS22: "325510",
      "INDEX ITEM DESCRIPTION": "Wood fillers manufacturing",
    },
    {
      NAICS22: "325520",
      "INDEX ITEM DESCRIPTION":
        "Adhesives (except asphalt, dental, gypsum base) manufacturing",
    },
    {
      NAICS22: "325520",
      "INDEX ITEM DESCRIPTION":
        "Caulking compounds (except gypsum base) manufacturing",
    },
    {
      NAICS22: "325520",
      "INDEX ITEM DESCRIPTION": "Cement, rubber, manufacturing",
    },
    {
      NAICS22: "325520",
      "INDEX ITEM DESCRIPTION":
        "Construction adhesives (except asphalt, gypsum base) manufacturing",
    },
    {
      NAICS22: "325520",
      "INDEX ITEM DESCRIPTION": "Dextrin glues manufacturing",
    },
    {
      NAICS22: "325520",
      "INDEX ITEM DESCRIPTION": "Epoxy adhesives manufacturing",
    },
    {
      NAICS22: "325520",
      "INDEX ITEM DESCRIPTION": "Glues (except dental) manufacturing",
    },
    {
      NAICS22: "325520",
      "INDEX ITEM DESCRIPTION":
        "Joint compounds (except gypsum base) manufacturing",
    },
    {
      NAICS22: "325520",
      "INDEX ITEM DESCRIPTION": "Mucilage adhesives manufacturing",
    },
    {
      NAICS22: "325520",
      "INDEX ITEM DESCRIPTION": "Pastes, adhesive, manufacturing",
    },
    {
      NAICS22: "325520",
      "INDEX ITEM DESCRIPTION": "Pipe sealing compounds manufacturing",
    },
    {
      NAICS22: "325520",
      "INDEX ITEM DESCRIPTION": "Plumbers' putty manufacturing",
    },
    {
      NAICS22: "325520",
      "INDEX ITEM DESCRIPTION": "Rubber cements manufacturing",
    },
    {
      NAICS22: "325520",
      "INDEX ITEM DESCRIPTION":
        "Sealing compounds for pipe threads and joints manufacturing",
    },
    {
      NAICS22: "325520",
      "INDEX ITEM DESCRIPTION": "Starch glues manufacturing",
    },
    {
      NAICS22: "325520",
      "INDEX ITEM DESCRIPTION": "Tile adhesives manufacturing",
    },
    {
      NAICS22: "325611",
      "INDEX ITEM DESCRIPTION": "Bar soaps manufacturing",
    },
    {
      NAICS22: "325611",
      "INDEX ITEM DESCRIPTION": "Dentifrices manufacturing",
    },
    {
      NAICS22: "325611",
      "INDEX ITEM DESCRIPTION":
        "Detergents (e.g., dishwashing, industrial, laundry) manufacturing",
    },
    {
      NAICS22: "325611",
      "INDEX ITEM DESCRIPTION": "Dishwasher detergents manufacturing",
    },
    {
      NAICS22: "325611",
      "INDEX ITEM DESCRIPTION":
        "Glycerin (i.e., glycerol), natural, manufacturing",
    },
    {
      NAICS22: "325611",
      "INDEX ITEM DESCRIPTION": "Hand sanitizers manufacturing",
    },
    {
      NAICS22: "325611",
      "INDEX ITEM DESCRIPTION":
        "Hand soaps (e.g., hard, liquid, soft) manufacturing",
    },
    {
      NAICS22: "325611",
      "INDEX ITEM DESCRIPTION": "Laundry soap, chips, and powder manufacturing",
    },
    {
      NAICS22: "325611",
      "INDEX ITEM DESCRIPTION": "Mechanic's hand soaps and pastes manufacturing",
    },
    {
      NAICS22: "325611",
      "INDEX ITEM DESCRIPTION": "Presoaks manufacturing",
    },
    {
      NAICS22: "325611",
      "INDEX ITEM DESCRIPTION":
        "Scouring cleansers (e.g., pastes, powders) manufacturing",
    },
    {
      NAICS22: "325611",
      "INDEX ITEM DESCRIPTION": "Soaps (e.g., bar, chip, powder) manufacturing",
    },
    {
      NAICS22: "325611",
      "INDEX ITEM DESCRIPTION":
        "Teeth whiteners (e.g., pastes, gels) manufacturing",
    },
    {
      NAICS22: "325611",
      "INDEX ITEM DESCRIPTION": "Toilet soaps manufacturing",
    },
    {
      NAICS22: "325611",
      "INDEX ITEM DESCRIPTION":
        "Toothpastes, gels, and tooth powders manufacturing",
    },
    {
      NAICS22: "325611",
      "INDEX ITEM DESCRIPTION": "Waterless hand soaps manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION": "Air fresheners manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION": "Ammonia, household-type, manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION": "Automobile polishes and cleaners manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION": "Beeswax polishes and waxes manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION":
        "Bleaches, formulated for household use, manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION": "Brass polishes manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION": "Buffing compounds manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION":
        "Cloths, dusting and polishing, chemically treated, manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION": "Copper cleaners manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION":
        "Degreasing preparations, household-type, manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION": "Deodorants (except personal) manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION":
        "Disinfectants, household-type and industrial, manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION": "Drain pipe cleaners manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION": "Drycleaning preparations manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION": "Fabric softeners manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION": "Floor polishes and waxes manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION": "Furniture polishes and waxes manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION":
        "Glass and tile cleaning preparations manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION": "Gun cleaning preparations",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION": "Ink eradicators manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION":
        "Kitchen degreasing and cleaning preparations manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION": "Laundry bluing manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION": "Lye, household-type, manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION":
        "Metal polishes (i.e., tarnish removers) manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION": "Oven cleaners manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION":
        "Polishes (e.g., automobile, furniture, metal, shoe) manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION": "Polishing preparations manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION": "Recycling drycleaning fluids",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION": "Rug cleaning preparations manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION": "Rust removers manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION": "Saddle soaps manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION": "Shoe polishes and cleaners manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION": "Silver polishes manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION": "Soot removing chemicals manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION":
        "Spot removers (except laundry presoaks) manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION": "Starches, laundry, manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION": "Sweeping compounds, absorbent, manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION": "Toilet bowl cleaners manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION":
        "Tub and tile cleaning preparations manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION": "Wallpaper cleaners manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION": "Wax removers manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION":
        "Waxes, polishing (e.g., floor, furniture), manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION": "Window cleaning preparations manufacturing",
    },
    {
      NAICS22: "325612",
      "INDEX ITEM DESCRIPTION": "Windshield washer fluid manufacturing",
    },
    {
      NAICS22: "325613",
      "INDEX ITEM DESCRIPTION":
        "Assistants, textile and leather finishing, manufacturing",
    },
    {
      NAICS22: "325613",
      "INDEX ITEM DESCRIPTION":
        "Emulsifiers (i.e., surface active agents) manufacturing",
    },
    {
      NAICS22: "325613",
      "INDEX ITEM DESCRIPTION":
        "Finishing agents, textile and leather, manufacturing",
    },
    {
      NAICS22: "325613",
      "INDEX ITEM DESCRIPTION": "Mordants manufacturing",
    },
    {
      NAICS22: "325613",
      "INDEX ITEM DESCRIPTION":
        "Oils, soluble (i.e., textile finishing assistants), manufacturing",
    },
    {
      NAICS22: "325613",
      "INDEX ITEM DESCRIPTION": "Penetrants manufacturing",
    },
    {
      NAICS22: "325613",
      "INDEX ITEM DESCRIPTION": "Softeners, leather or textile, manufacturing",
    },
    {
      NAICS22: "325613",
      "INDEX ITEM DESCRIPTION": "Surface active agents manufacturing",
    },
    {
      NAICS22: "325613",
      "INDEX ITEM DESCRIPTION": "Textile finishing assistants manufacturing",
    },
    {
      NAICS22: "325613",
      "INDEX ITEM DESCRIPTION": "Textile scouring agents manufacturing",
    },
    {
      NAICS22: "325613",
      "INDEX ITEM DESCRIPTION": "Turkey-red oil manufacturing",
    },
    {
      NAICS22: "325613",
      "INDEX ITEM DESCRIPTION": "Wetting agents manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION": "After-shave preparations manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION": "Antiperspirants, personal, manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION": "Baby powder and baby oil manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION": "Bath salts manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION": "Blending and compounding perfume bases",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION": "Blushes, face, manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION": "Bubble bath preparations manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION": "Colognes manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION":
        "Cosmetic creams, lotions, and oils manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION": "Dental floss manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION": "Denture adhesives manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION": "Denture cleaners, effervescent, manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION": "Deodorants, personal, manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION": "Depilatory preparations manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION":
        "Eye makeup (e.g., eye shadow, eyebrow pencil, mascara) manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION":
        "Face creams (e.g., cleansing, moisturizing) manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION": "Foundations (i.e., makeup) manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION": "Hair coloring preparations manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION":
        "Hair preparations (e.g., conditioners, dyes, rinses, shampoos) manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION": "Hair sprays manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION": "Hand lotions manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION": "Lipsticks manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION": "Lotions (e.g., body, face, hand) manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION": "Makeup (i.e., cosmetics) manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION": "Manicure preparations manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION": "Mouthwashes (except medicinal) manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION": "Nail polish remover manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION": "Nail polishes manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION": "Perfumes manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION": "Permanent wave preparations manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION":
        "Powders (e.g., baby, body, face, talcum, toilet) manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION": "Rouge, cosmetic, manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION": "Sachet, scented, manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION": "Shampoos and conditioners, hair, manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION":
        "Shaving preparations (e.g., creams, gels, lotions, powders) manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION": "Sunscreen lotions and oils manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION": "Suntan lotions and oils manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION": "Talcum powders manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION": "Tints, dyes, and rinses, hair, manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION":
        "Toilet preparations (e.g., cosmetics, deodorants, perfumes) manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION": "Toilet water manufacturing",
    },
    {
      NAICS22: "325620",
      "INDEX ITEM DESCRIPTION": "Towelettes, premoistened, manufacturing",
    },
    {
      NAICS22: "325910",
      "INDEX ITEM DESCRIPTION": "Bronze printing inks manufacturing",
    },
    {
      NAICS22: "325910",
      "INDEX ITEM DESCRIPTION": "Duplicating inks manufacturing",
    },
    {
      NAICS22: "325910",
      "INDEX ITEM DESCRIPTION": "Flexographic inks manufacturing",
    },
    {
      NAICS22: "325910",
      "INDEX ITEM DESCRIPTION": "Gold printing inks manufacturing",
    },
    {
      NAICS22: "325910",
      "INDEX ITEM DESCRIPTION": "Gravure inks manufacturing",
    },
    {
      NAICS22: "325910",
      "INDEX ITEM DESCRIPTION": "Inkjet cartridges manufacturing",
    },
    {
      NAICS22: "325910",
      "INDEX ITEM DESCRIPTION": "Inkjet inks manufacturing",
    },
    {
      NAICS22: "325910",
      "INDEX ITEM DESCRIPTION": "Inks, printing, manufacturing",
    },
    {
      NAICS22: "325910",
      "INDEX ITEM DESCRIPTION": "Letterpress inks manufacturing",
    },
    {
      NAICS22: "325910",
      "INDEX ITEM DESCRIPTION": "Lithographic inks manufacturing",
    },
    {
      NAICS22: "325910",
      "INDEX ITEM DESCRIPTION": "Offset inks manufacturing",
    },
    {
      NAICS22: "325910",
      "INDEX ITEM DESCRIPTION": "Printing inks manufacturing",
    },
    {
      NAICS22: "325910",
      "INDEX ITEM DESCRIPTION": "Screen process inks manufacturing",
    },
    {
      NAICS22: "325910",
      "INDEX ITEM DESCRIPTION": "Stencil inks manufacturing",
    },
    {
      NAICS22: "325910",
      "INDEX ITEM DESCRIPTION": "Textile printing inks manufacturing",
    },
    {
      NAICS22: "325920",
      "INDEX ITEM DESCRIPTION": "Amatols manufacturing",
    },
    {
      NAICS22: "325920",
      "INDEX ITEM DESCRIPTION": "Azides explosive materials manufacturing",
    },
    {
      NAICS22: "325920",
      "INDEX ITEM DESCRIPTION":
        "Blasting accessories (e.g., caps, fuses, ignitors, squibbs) manufacturing",
    },
    {
      NAICS22: "325920",
      "INDEX ITEM DESCRIPTION": "Blasting powders manufacturing",
    },
    {
      NAICS22: "325920",
      "INDEX ITEM DESCRIPTION": "Caps, blasting and detonating, manufacturing",
    },
    {
      NAICS22: "325920",
      "INDEX ITEM DESCRIPTION": "Cordite explosive materials manufacturing",
    },
    {
      NAICS22: "325920",
      "INDEX ITEM DESCRIPTION":
        "Detonating caps, cord, fuses, and primers manufacturing",
    },
    {
      NAICS22: "325920",
      "INDEX ITEM DESCRIPTION": "Detonators (except ammunition) manufacturing",
    },
    {
      NAICS22: "325920",
      "INDEX ITEM DESCRIPTION": "Dynamite manufacturing",
    },
    {
      NAICS22: "325920",
      "INDEX ITEM DESCRIPTION": "Explosives manufacturing",
    },
    {
      NAICS22: "325920",
      "INDEX ITEM DESCRIPTION": "Gunpowder manufacturing",
    },
    {
      NAICS22: "325920",
      "INDEX ITEM DESCRIPTION":
        "Mannitol hexanitrate explosive materials manufacturing",
    },
    {
      NAICS22: "325920",
      "INDEX ITEM DESCRIPTION":
        "Mercury fulminate explosive materials manufacturing",
    },
    {
      NAICS22: "325920",
      "INDEX ITEM DESCRIPTION":
        "Nitrocellulose explosive materials manufacturing",
    },
    {
      NAICS22: "325920",
      "INDEX ITEM DESCRIPTION": "Nitroglycerin explosive materials manufacturing",
    },
    {
      NAICS22: "325920",
      "INDEX ITEM DESCRIPTION": "Nitrostarch explosive materials manufacturing",
    },
    {
      NAICS22: "325920",
      "INDEX ITEM DESCRIPTION": "Pentolite explosive materials manufacturing",
    },
    {
      NAICS22: "325920",
      "INDEX ITEM DESCRIPTION": "Picric acid explosive materials manufacturing",
    },
    {
      NAICS22: "325920",
      "INDEX ITEM DESCRIPTION": "Safety fuses, blasting, manufacturing",
    },
    {
      NAICS22: "325920",
      "INDEX ITEM DESCRIPTION": "Styphnic acid explosive materials manufacturing",
    },
    {
      NAICS22: "325920",
      "INDEX ITEM DESCRIPTION": "Tetryl explosive materials manufacturing",
    },
    {
      NAICS22: "325920",
      "INDEX ITEM DESCRIPTION": "TNT (trinitrotoluene) manufacturing",
    },
    {
      NAICS22: "325920",
      "INDEX ITEM DESCRIPTION": "Trinitrotoluene (TNT) manufacturing",
    },
    {
      NAICS22: "325991",
      "INDEX ITEM DESCRIPTION":
        "Custom compounding (i.e., blending and mixing) of purchased plastics resins",
    },
    {
      NAICS22: "325991",
      "INDEX ITEM DESCRIPTION":
        "Plastics resins compounding from recycled materials",
    },
    {
      NAICS22: "325991",
      "INDEX ITEM DESCRIPTION":
        "Plastics resins, custom compounding of purchased",
    },
    {
      NAICS22: "325991",
      "INDEX ITEM DESCRIPTION":
        "Reformulating plastics resins from recycled plastics products",
    },
    {
      NAICS22: "325992",
      "INDEX ITEM DESCRIPTION": "Computer printer toner cartridges manufacturing",
    },
    {
      NAICS22: "325992",
      "INDEX ITEM DESCRIPTION":
        "Developers, prepared photographic, manufacturing",
    },
    {
      NAICS22: "325992",
      "INDEX ITEM DESCRIPTION":
        "Diazo (i.e., whiteprint) paper and cloth, sensitized, manufacturing",
    },
    {
      NAICS22: "325992",
      "INDEX ITEM DESCRIPTION": "Driers, photographic chemical, manufacturing",
    },
    {
      NAICS22: "325992",
      "INDEX ITEM DESCRIPTION": "Facsimile toner cartridges manufacturing",
    },
    {
      NAICS22: "325992",
      "INDEX ITEM DESCRIPTION":
        "Film, sensitized (e.g., camera, motion picture, X-ray), manufacturing",
    },
    {
      NAICS22: "325992",
      "INDEX ITEM DESCRIPTION": "Fixers, prepared photographic, manufacturing",
    },
    {
      NAICS22: "325992",
      "INDEX ITEM DESCRIPTION": "Graphic arts plates, sensitized, manufacturing",
    },
    {
      NAICS22: "325992",
      "INDEX ITEM DESCRIPTION":
        "Heat sensitized (i.e., thermal) paper made from purchased paper",
    },
    {
      NAICS22: "325992",
      "INDEX ITEM DESCRIPTION": "Motion picture film manufacturing",
    },
    {
      NAICS22: "325992",
      "INDEX ITEM DESCRIPTION": "Paper, photographic sensitized, manufacturing",
    },
    {
      NAICS22: "325992",
      "INDEX ITEM DESCRIPTION": "Photocopying toner cartridges manufacturing",
    },
    {
      NAICS22: "325992",
      "INDEX ITEM DESCRIPTION": "Photographic chemicals manufacturing",
    },
    {
      NAICS22: "325992",
      "INDEX ITEM DESCRIPTION":
        "Photographic film, cloth, paper, and plate, sensitized, manufacturing",
    },
    {
      NAICS22: "325992",
      "INDEX ITEM DESCRIPTION": "Photomasks manufacturing",
    },
    {
      NAICS22: "325992",
      "INDEX ITEM DESCRIPTION": "Photosensitized paper manufacturing",
    },
    {
      NAICS22: "325992",
      "INDEX ITEM DESCRIPTION":
        "Sensitized cloth or paper (e.g., blueprint, photographic) manufacturing",
    },
    {
      NAICS22: "325992",
      "INDEX ITEM DESCRIPTION": "Toner cartridges manufacturing",
    },
    {
      NAICS22: "325992",
      "INDEX ITEM DESCRIPTION": "Toner cartridges rebuilding",
    },
    {
      NAICS22: "325992",
      "INDEX ITEM DESCRIPTION":
        "Toners, electrostatic and photographic, manufacturing",
    },
    {
      NAICS22: "325992",
      "INDEX ITEM DESCRIPTION":
        "X-ray film and plates, sensitized, manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Activated carbon or charcoal manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION":
        "Additive preparations for gasoline (e.g., antiknock preparations, detergents, gum inhibitors) manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION":
        "Aerosol can filling on a job-order or contract basis",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Aerosol packaging services",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Anise oil manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Antifreeze preparations manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Antiscaling compounds manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Bay oil manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Brake fluid, synthetic, manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Cannabidiol (CBD oil) manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Caps for toy pistols manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Capsules, gelatin, empty, manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Carbon, activated, manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Carburetor cleaners manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Cat litter manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Cedar oil manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Charcoal, activated, manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Citronella oil manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Clove oil manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION":
        "Concrete additive preparations (e.g., curing, hardening) manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION":
        "Correction fluids (i.e., typewriter) manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Crankcase additive preparations manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Cutting oils, synthetic, manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Defoamers and antifoaming agents manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION":
        "Degreasing preparations for machinery parts manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Deicing preparations manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Desalination kits manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Distilled water manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Drawing inks manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION":
        "Drilling mud compounds, conditioners, and additives (except bentonites) manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION":
        "Dye preparations, clothing, household-type, manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION":
        "Electronic cigarette vapor liquids, including closed refills, manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Embalming fluids manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Engine degreasers manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Engine starting fluids manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Essential oils manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Eucalyptus oil manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION":
        "Fire extinguisher chemical preparations manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION":
        "Fire retardant chemical preparations manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Fireworks manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Flares manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION":
        "Fluxes (e.g., brazing, galvanizing, soldering, welding) manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Foundry core oil, wash, and wax manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION":
        "Gelatin (except dessert preparations) manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Gelatin capsules, empty, manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Grapefruit oil manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Greases, synthetic lubricating, manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Hydraulic fluids, synthetic, manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Incense manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Indelible inks manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "India inks manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Industrial salt manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION":
        "Inhibitors (e.g., corrosion, oxidation, polymerization) manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Inks, writing, manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Insulating oils manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Lemon oil manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION":
        "Lighter fluids (e.g., charcoal, cigarette) manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Lime oil manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION":
        "Lubricating oils and greases, synthetic, manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Matches and match books manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Motor oils, synthetic, manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Napalm manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Oil additive preparations manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION":
        "Oils (e.g., cutting, lubricating), synthetic, manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Oils, lubricating, synthetic, manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Orange oil manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Orris oil manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Ossein manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Packer's fluids manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Penetrating fluids, synthetic, manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Peppermint oil manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION":
        "Pyrotechnics (e.g., flares, flashlight bombs, signals) manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Radiator additive preparations manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION":
        "Recycling services for degreasing solvents (e.g., engine, machinery) manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION":
        "Retarders (e.g., flameproofing agents, mildewproofing agents) manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION":
        "Rubber processing preparations (e.g., accelerators, stabilizers) manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Rust preventive preparations manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Salt (except table) manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Soil testing kits manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Spearmint oil manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Stamp pad ink manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION":
        "Sugar substitutes (i.e., synthetic sweeteners blended with other ingredients) made from purchased synthetic sweeteners",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION":
        "Swimming pool chemical preparations manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION":
        "Tint and dye preparations, household-type (except hair), manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Tire inflators, aerosol, manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Transmission fluids, synthetic, manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Water, distilled, manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Wintergreen oil manufacturing",
    },
    {
      NAICS22: "325998",
      "INDEX ITEM DESCRIPTION": "Writing inks manufacturing",
    },
    {
      NAICS22: "326111",
      "INDEX ITEM DESCRIPTION":
        "Bags, plastics film, single wall or multiwall, manufacturing",
    },
    {
      NAICS22: "326111",
      "INDEX ITEM DESCRIPTION":
        "Food storage bags, plastics film, single wall or multiwall, manufacturing",
    },
    {
      NAICS22: "326111",
      "INDEX ITEM DESCRIPTION":
        "Frozen food bags, plastics film, single wall or multiwall, manufacturing",
    },
    {
      NAICS22: "326111",
      "INDEX ITEM DESCRIPTION":
        "Grocery bags, plastics film, single wall or multiwall, manufacturing",
    },
    {
      NAICS22: "326111",
      "INDEX ITEM DESCRIPTION":
        "Merchandise bags, plastics film, single wall or multiwall, manufacturing",
    },
    {
      NAICS22: "326111",
      "INDEX ITEM DESCRIPTION":
        "Trash bags, plastics film, single wall or multiwall, manufacturing",
    },
    {
      NAICS22: "326112",
      "INDEX ITEM DESCRIPTION": "Film, plastics, packaging, manufacturing",
    },
    {
      NAICS22: "326112",
      "INDEX ITEM DESCRIPTION":
        "Flexible packaging, plastics film, manufacturing",
    },
    {
      NAICS22: "326112",
      "INDEX ITEM DESCRIPTION":
        "Packaging film, plastics, single-web or multiweb, manufacturing",
    },
    {
      NAICS22: "326113",
      "INDEX ITEM DESCRIPTION":
        "Acrylic film and unlaminated sheet (except packaging) manufacturing",
    },
    {
      NAICS22: "326113",
      "INDEX ITEM DESCRIPTION":
        "Cellulosic plastics film and unlaminated sheet (except packaging) manufacturing",
    },
    {
      NAICS22: "326113",
      "INDEX ITEM DESCRIPTION":
        "Film, plastics (except packaging), manufacturing",
    },
    {
      NAICS22: "326113",
      "INDEX ITEM DESCRIPTION":
        "Photographic, micrographic, and X-ray plastics, sheet, and film (except sensitized), manufacturing",
    },
    {
      NAICS22: "326113",
      "INDEX ITEM DESCRIPTION":
        "Plastics film and unlaminated sheet (except packaging) manufacturing",
    },
    {
      NAICS22: "326113",
      "INDEX ITEM DESCRIPTION":
        "Polyester film and unlaminated sheet (except packaging) manufacturing",
    },
    {
      NAICS22: "326113",
      "INDEX ITEM DESCRIPTION":
        "Polyethylene film and unlaminated sheet (except packaging) manufacturing",
    },
    {
      NAICS22: "326113",
      "INDEX ITEM DESCRIPTION":
        "Polypropylene film and unlaminated sheet (except packaging) manufacturing",
    },
    {
      NAICS22: "326113",
      "INDEX ITEM DESCRIPTION":
        "Polyvinyl film and unlaminated sheet (except packaging) manufacturing",
    },
    {
      NAICS22: "326113",
      "INDEX ITEM DESCRIPTION":
        "Sheet, plastics, unlaminated (except packaging), manufacturing",
    },
    {
      NAICS22: "326113",
      "INDEX ITEM DESCRIPTION":
        "Vinyl and vinyl copolymer film and unlaminated sheet (except packaging) manufacturing",
    },
    {
      NAICS22: "326121",
      "INDEX ITEM DESCRIPTION":
        "Casings, sausage, nonrigid plastics, manufacturing",
    },
    {
      NAICS22: "326121",
      "INDEX ITEM DESCRIPTION":
        "Profile shapes (e.g., rod, tube), nonrigid plastics, manufacturing",
    },
    {
      NAICS22: "326121",
      "INDEX ITEM DESCRIPTION": "Rod, nonrigid plastics, manufacturing",
    },
    {
      NAICS22: "326121",
      "INDEX ITEM DESCRIPTION": "Sausage casings, plastics, manufacturing",
    },
    {
      NAICS22: "326121",
      "INDEX ITEM DESCRIPTION": "Tube, nonrigid plastics, manufacturing",
    },
    {
      NAICS22: "326122",
      "INDEX ITEM DESCRIPTION":
        "Fittings and unions, rigid plastics pipe, manufacturing",
    },
    {
      NAICS22: "326122",
      "INDEX ITEM DESCRIPTION": "Fittings, rigid plastics pipe, manufacturing",
    },
    {
      NAICS22: "326122",
      "INDEX ITEM DESCRIPTION": "Pipe fittings, rigid plastics, manufacturing",
    },
    {
      NAICS22: "326122",
      "INDEX ITEM DESCRIPTION": "Pipe, rigid plastics, manufacturing",
    },
    {
      NAICS22: "326122",
      "INDEX ITEM DESCRIPTION": "PVC pipe manufacturing",
    },
    {
      NAICS22: "326130",
      "INDEX ITEM DESCRIPTION":
        "Laminated plastics plate, rod, and sheet, manufacturing",
    },
    {
      NAICS22: "326130",
      "INDEX ITEM DESCRIPTION": "Plate, laminated plastics, manufacturing",
    },
    {
      NAICS22: "326130",
      "INDEX ITEM DESCRIPTION":
        "Profile shapes (e.g., plate, rod, sheet), laminated plastics, manufacturing",
    },
    {
      NAICS22: "326130",
      "INDEX ITEM DESCRIPTION": "Rod, laminated plastics, manufacturing",
    },
    {
      NAICS22: "326130",
      "INDEX ITEM DESCRIPTION":
        "Sheet, laminated plastics (except flexible packaging), manufacturing",
    },
    {
      NAICS22: "326140",
      "INDEX ITEM DESCRIPTION":
        "Coolers or ice chests, polystyrene foam, manufacturing",
    },
    {
      NAICS22: "326140",
      "INDEX ITEM DESCRIPTION": "Cups, polystyrene foam, manufacturing",
    },
    {
      NAICS22: "326140",
      "INDEX ITEM DESCRIPTION": "Dinnerware, polystyrene foam, manufacturing",
    },
    {
      NAICS22: "326140",
      "INDEX ITEM DESCRIPTION": "Foam polystyrene products manufacturing",
    },
    {
      NAICS22: "326140",
      "INDEX ITEM DESCRIPTION":
        "Food containers, polystyrene foam, manufacturing",
    },
    {
      NAICS22: "326140",
      "INDEX ITEM DESCRIPTION": "Ice buckets, polystyrene foam, manufacturing",
    },
    {
      NAICS22: "326140",
      "INDEX ITEM DESCRIPTION":
        "Ice chests or coolers, polystyrene foam, manufacturing",
    },
    {
      NAICS22: "326140",
      "INDEX ITEM DESCRIPTION":
        "Insulation and cushioning, polystyrene foam plastics, manufacturing",
    },
    {
      NAICS22: "326140",
      "INDEX ITEM DESCRIPTION":
        "Jugs, vacuum, polystyrene foam plastics, manufacturing",
    },
    {
      NAICS22: "326140",
      "INDEX ITEM DESCRIPTION": "Plates, polystyrene foam, manufacturing",
    },
    {
      NAICS22: "326140",
      "INDEX ITEM DESCRIPTION": "Polystyrene foam packaging manufacturing",
    },
    {
      NAICS22: "326140",
      "INDEX ITEM DESCRIPTION":
        "Sheet (i.e., board), polystyrene foam insulation, manufacturing",
    },
    {
      NAICS22: "326140",
      "INDEX ITEM DESCRIPTION":
        "Shipping pads and shaped cushioning, polystyrene foam, manufacturing",
    },
    {
      NAICS22: "326140",
      "INDEX ITEM DESCRIPTION":
        "Thermal insulation, polystyrene foam, manufacturing",
    },
    {
      NAICS22: "326150",
      "INDEX ITEM DESCRIPTION":
        "Cushions, carpet and rug, urethane and other foam plastics (except polystyrene), manufacturing",
    },
    {
      NAICS22: "326150",
      "INDEX ITEM DESCRIPTION":
        "Foam plastics products (except polystyrene) manufacturing",
    },
    {
      NAICS22: "326150",
      "INDEX ITEM DESCRIPTION":
        "Ice buckets, urethane or other plastics foam (except polystyrene), manufacturing",
    },
    {
      NAICS22: "326150",
      "INDEX ITEM DESCRIPTION":
        "Ice chests or coolers, urethane or other plastics foam (except polystyrene) manufacturing",
    },
    {
      NAICS22: "326150",
      "INDEX ITEM DESCRIPTION":
        "Insulation and cushioning, foam plastics (except polystyrene), manufacturing",
    },
    {
      NAICS22: "326150",
      "INDEX ITEM DESCRIPTION":
        "Jugs, vacuum, foam plastics (except polystyrene), manufacturing",
    },
    {
      NAICS22: "326150",
      "INDEX ITEM DESCRIPTION":
        "Packaging, foam plastics (except polystyrene), manufacturing",
    },
    {
      NAICS22: "326150",
      "INDEX ITEM DESCRIPTION": "Polyurethane foam products manufacturing",
    },
    {
      NAICS22: "326150",
      "INDEX ITEM DESCRIPTION":
        "Seat cushions, foam plastics (except polystyrene), manufacturing",
    },
    {
      NAICS22: "326150",
      "INDEX ITEM DESCRIPTION":
        "Shipping pads and shaped cushioning, foam plastics (except polystyrene), manufacturing",
    },
    {
      NAICS22: "326150",
      "INDEX ITEM DESCRIPTION": "Urethane foam products manufacturing",
    },
    {
      NAICS22: "326160",
      "INDEX ITEM DESCRIPTION": "Bottles, plastics, manufacturing",
    },
    {
      NAICS22: "326191",
      "INDEX ITEM DESCRIPTION": "Bathtubs, plastics, manufacturing",
    },
    {
      NAICS22: "326191",
      "INDEX ITEM DESCRIPTION": "Chemical toilets, plastics, manufacturing",
    },
    {
      NAICS22: "326191",
      "INDEX ITEM DESCRIPTION": "Cultured marble plumbing fixtures manufacturing",
    },
    {
      NAICS22: "326191",
      "INDEX ITEM DESCRIPTION":
        "Drinking fountains (except mechanically refrigerated), plastics, manufacturing",
    },
    {
      NAICS22: "326191",
      "INDEX ITEM DESCRIPTION": "Hot tubs, plastics or fiberglass, manufacturing",
    },
    {
      NAICS22: "326191",
      "INDEX ITEM DESCRIPTION": "Laundry tubs, plastics, manufacturing",
    },
    {
      NAICS22: "326191",
      "INDEX ITEM DESCRIPTION":
        "Plumbing fixtures (e.g., shower stalls, toilets, urinals), plastics or fiberglass, manufacturing",
    },
    {
      NAICS22: "326191",
      "INDEX ITEM DESCRIPTION": "Portable toilets, plastics, manufacturing",
    },
    {
      NAICS22: "326191",
      "INDEX ITEM DESCRIPTION":
        "Shower stalls, plastics or fiberglass, manufacturing",
    },
    {
      NAICS22: "326191",
      "INDEX ITEM DESCRIPTION": "Sinks, plastics, manufacturing",
    },
    {
      NAICS22: "326191",
      "INDEX ITEM DESCRIPTION": "Toilet fixtures, plastics, manufacturing",
    },
    {
      NAICS22: "326191",
      "INDEX ITEM DESCRIPTION": "Urinals, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION":
        "Awnings, rigid plastics or fiberglass, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Badges, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Balloons, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION":
        "Bathroom and toilet accessories, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION":
        "Bolts, nuts, and rivets, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Bottle caps and lids, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Bowls and bowl covers, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION":
        "Bubble packaging materials, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION":
        "Building materials (e.g., fascia, panels, siding, soffit), plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION":
        "Building panels, corrugated and flat, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Bushings, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION":
        "Cigar and cigarette holders, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Clothes hangers, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Clothespins, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Combs, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION":
        "Coolers or ice chests, plastics (except foam), manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Countertops, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION":
        "Credit and identification card stock, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION":
        "Cultured marble products (except plumbing fixtures) manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION":
        "Cultured stone products (except plumbing fixtures) manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Cups, plastics (except foam), manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION":
        "Dinnerware, plastics (except polystyrene foam), manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Doormats, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Doors and door frames, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION":
        "Drums, plastics (i.e., containers), manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Floor coverings, linoleum, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Floor coverings, resilient, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Floor coverings, rubber, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Floor coverings, vinyl, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION":
        "Footwear parts (e.g., heels, soles), plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION":
        "Fruits and vegetables, artificial, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Gloves, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION":
        "Gutters and down spouts, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Hampers, laundry, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION":
        "Handles (e.g., brush, tool, umbrella), plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Hardware, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION":
        "Ice buckets, plastics (except foam), manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION":
        "Ice chests or coolers, plastics (except plastics foam), manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Jars, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Kitchen utensils, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Ladders, fiberglass, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Lamp shades, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION":
        "Lens blanks, plastics ophthalmic or optical, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Linoleum floor coverings manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Mattresses, air, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Microwaveware, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION":
        "Motor vehicle moldings and extrusions, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Netting, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Nozzles, aerosol spray, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION":
        "Organizers for closets, drawers, and shelves, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION":
        "Packaging, plastics (e.g., blister, bubble), manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Pails, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Paint sticks, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION":
        "Picnic jugs, plastics (except foam), manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION":
        "Prefabricated buildings, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Radio housings, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Reels, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Reflectors, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION":
        "Resilient floor coverings (e.g., sheet, tile) manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Rubber floor coverings manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Rulers, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Screening, window, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION":
        "Septic tanks, plastics or fiberglass, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION":
        "Shoe parts (e.g., heels, soles), plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Shutters, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Siding, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Sponges, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION":
        "Swimming pool covers and liners, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Swimming pools, fiberglass, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION":
        "Tanks, storage, plastics or fiberglass, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Television housings, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION":
        "Tiles, floor (i.e., linoleum, rubber, vinyl), manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Tires, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Trash containers, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Tumblers, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION":
        "Utility containers (e.g., baskets, bins, boxes, buckets, dishpans, pails), plastics (except foam), manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Vinyl floor coverings manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Watch crystals, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Watering cans, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Window sashes, vinyl, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION":
        "Windows and window frames, plastics, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Windows and window frames, vinyl, manufacturing",
    },
    {
      NAICS22: "326199",
      "INDEX ITEM DESCRIPTION": "Windshields, plastics, manufacturing",
    },
    {
      NAICS22: "326211",
      "INDEX ITEM DESCRIPTION": "Aircraft tire manufacturing",
    },
    {
      NAICS22: "326211",
      "INDEX ITEM DESCRIPTION":
        "Camelback (i.e., retreading material) manufacturing",
    },
    {
      NAICS22: "326211",
      "INDEX ITEM DESCRIPTION": "Inner tubes manufacturing",
    },
    {
      NAICS22: "326211",
      "INDEX ITEM DESCRIPTION": "Motor vehicle tires manufacturing",
    },
    {
      NAICS22: "326211",
      "INDEX ITEM DESCRIPTION": "Retreading materials, tire, manufacturing",
    },
    {
      NAICS22: "326211",
      "INDEX ITEM DESCRIPTION": "Tire repair materials manufacturing",
    },
    {
      NAICS22: "326211",
      "INDEX ITEM DESCRIPTION":
        "Tires (e.g., pneumatic, semi-pneumatic, solid rubber) manufacturing",
    },
    {
      NAICS22: "326211",
      "INDEX ITEM DESCRIPTION": "Tread rubber (i.e., camelback) manufacturing",
    },
    {
      NAICS22: "326212",
      "INDEX ITEM DESCRIPTION": "Rebuilding tires",
    },
    {
      NAICS22: "326212",
      "INDEX ITEM DESCRIPTION": "Recapping tires",
    },
    {
      NAICS22: "326212",
      "INDEX ITEM DESCRIPTION": "Retreading tires",
    },
    {
      NAICS22: "326212",
      "INDEX ITEM DESCRIPTION": "Tire retreading, recapping or rebuilding",
    },
    {
      NAICS22: "326220",
      "INDEX ITEM DESCRIPTION":
        "Belting, rubber (e.g., conveyor, elevator, transmission), manufacturing",
    },
    {
      NAICS22: "326220",
      "INDEX ITEM DESCRIPTION": "Conveyor belts, rubber, manufacturing",
    },
    {
      NAICS22: "326220",
      "INDEX ITEM DESCRIPTION": "Fan belts, rubber or plastics, manufacturing",
    },
    {
      NAICS22: "326220",
      "INDEX ITEM DESCRIPTION": "Garden hose, rubber or plastics, manufacturing",
    },
    {
      NAICS22: "326220",
      "INDEX ITEM DESCRIPTION":
        "Hoses, reinforced, rubber or plastics, manufacturing",
    },
    {
      NAICS22: "326220",
      "INDEX ITEM DESCRIPTION": "Hoses, rubberized fabric, manufacturing",
    },
    {
      NAICS22: "326220",
      "INDEX ITEM DESCRIPTION":
        "Hydraulic hoses (without fitting), rubber or plastics, manufacturing",
    },
    {
      NAICS22: "326220",
      "INDEX ITEM DESCRIPTION":
        "Motor vehicle belts, rubber or plastics, manufacturing",
    },
    {
      NAICS22: "326220",
      "INDEX ITEM DESCRIPTION":
        "Motor vehicle hoses, rubber or plastics, manufacturing",
    },
    {
      NAICS22: "326220",
      "INDEX ITEM DESCRIPTION":
        "Plastics and rubber belts and hoses (without fittings) manufacturing",
    },
    {
      NAICS22: "326220",
      "INDEX ITEM DESCRIPTION":
        "Pneumatic hose (without fittings), rubber or plastics, manufacturing",
    },
    {
      NAICS22: "326220",
      "INDEX ITEM DESCRIPTION":
        "Radiator and heater hoses, rubber or plastics, manufacturing",
    },
    {
      NAICS22: "326220",
      "INDEX ITEM DESCRIPTION":
        "Rubber and plastics belts and hoses (without fittings) manufacturing",
    },
    {
      NAICS22: "326220",
      "INDEX ITEM DESCRIPTION": "Timing belt, rubber or plastics, manufacturing",
    },
    {
      NAICS22: "326220",
      "INDEX ITEM DESCRIPTION": "Transmission belts, rubber, manufacturing",
    },
    {
      NAICS22: "326220",
      "INDEX ITEM DESCRIPTION":
        "Vacuum cleaner belts, rubber or plastics, manufacturing",
    },
    {
      NAICS22: "326220",
      "INDEX ITEM DESCRIPTION": "V-belts, rubber or plastics, manufacturing",
    },
    {
      NAICS22: "326220",
      "INDEX ITEM DESCRIPTION": "Water hoses, rubber or plastics, manufacturing",
    },
    {
      NAICS22: "326291",
      "INDEX ITEM DESCRIPTION":
        "Extruded, molded or lathe-cut rubber goods manufacturing",
    },
    {
      NAICS22: "326291",
      "INDEX ITEM DESCRIPTION":
        "Mechanical rubber goods (i.e., extruded, lathe-cut, molded) manufacturing",
    },
    {
      NAICS22: "326291",
      "INDEX ITEM DESCRIPTION":
        "Rubber goods, mechanical (i.e.,  extruded, lathe-cut, molded), manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION": "Balloons, rubber, manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION": "Bath mats, rubber, manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION":
        "Birth control devices (i.e., diaphragms, prophylactics) manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION": "Brushes, rubber, manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION": "Combs, rubber, manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION": "Condom manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION": "Curlers, hair, rubber, manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION":
        "Diaphragms (i.e., birth control device), rubber, manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION": "Doormats, rubber, manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION":
        "Erasers, rubber or rubber and abrasive combined, manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION":
        "Floor mats (e.g., bath, door), rubber, manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION":
        "Footwear parts (e.g., heels, soles, soling strips), rubber, manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION": "Fuel bladders, rubber, manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION": "Grips and handles, rubber, manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION": "Grommets, rubber, manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION":
        "Hair care products (e.g., combs, curlers), rubber, manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION": "Hairpins, rubber, manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION": "Hot water bottles, rubber, manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION": "Latex foam rubber manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION": "Latex foam rubber products manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION": "Mattress protectors, rubber, manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION": "Mattresses, air, rubber, manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION":
        "Nipples and teething rings, rubber, manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION": "Pacifiers, rubber, manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION":
        "Pipe bits and stems, tobacco, hard rubber, manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION": "Prophylactics manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION":
        "Rafts, swimming pool-type, rubber inflatable, manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION": "Reclaiming rubber from waste or scrap",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION": "Rods, hard rubber, manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION":
        "Rolls and roll coverings, rubber (e.g., industrial, papermill, painters', steelmill) manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION":
        "Roofing (i.e., single ply rubber membrane) manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION": "Rubber bands manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION": "Rubber tubing manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION": "Sheeting, rubber, manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION":
        "Shoe and boot parts (e.g., heels, soles, soling strips), rubber, manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION": "Spatulas, rubber, manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION": "Sponges, rubber, manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION": "Stair treads, rubber, manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION": "Stoppers, rubber, manufacturing",
    },
    {
      NAICS22: "326299",
      "INDEX ITEM DESCRIPTION":
        "Thread, rubber (except fabric covered), manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION":
        "Advanced and technical ceramic products manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Alumina porcelain insulators manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Architectural sculptures, clay, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Ashtrays, pottery, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION":
        "Bathroom accessories, vitreous china and earthenware, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Beryllia porcelain insulators manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Bidets, vitreous china, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Bone china manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION":
        "Chemical stoneware (i.e., pottery products) manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "China cooking ware manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "China tableware, vitreous, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Clay and ceramic statuary manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Cones, pyrometric, earthenware, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION":
        "Cooking ware (e.g., stoneware, coarse earthenware, pottery), manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Cooking ware, china, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Cooking ware, fine earthenware, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Crockery manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Decalcomania on china and glass for the trade",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION":
        "Decorating china (e.g., encrusting gold, silver, other metal on china) for the trade",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Dishes, pottery, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION":
        "Drinking fountains, vitreous china, non-refrigerated, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION":
        "Earthenware table and kitchen articles, coarse, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION":
        "Earthenware, commercial and household, semivitreous, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Ecclesiastical statuary, clay, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Electrical insulators, ceramic, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Electrical supplies, ceramic, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION":
        "Faucet handles, vitreous china and earthenware, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Filtering media, pottery, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Firing china for the trade",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION":
        "Florists' articles, red earthenware, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Flower pots, red earthenware, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION":
        "Forms for dipped rubber products, pottery, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Garden pottery manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION":
        "Handles, faucet, vitreous china and earthenware, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION":
        "Hotel tableware and kitchen articles, vitreous china, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION":
        "Household-type earthenware, semivitreous, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION":
        "Household-type tableware and kitchen articles, vitreous china, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Insulators, electrical porcelain, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION":
        "Kitchen articles, coarse earthenware, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION":
        "Kitchenware, commercial and household-type, vitreous china, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION":
        "Kitchenware, semivitreous earthenware, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Lamp bases, pottery, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Lavatories, vitreous china, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION":
        "Magnets, permanent, ceramic or ferrite, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION":
        "Plumbing fixtures, vitreous china, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION":
        "Porcelain parts, electrical and electronic device, molded, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Porcelain, chemical, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Pottery made and sold on site ",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Pottery products manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Pyrometer tubes manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Pyrometric cones, earthenware, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Sculptures, architectural, clay, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Sinks, vitreous china, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION":
        "Soap dishes, vitreous china and earthenware, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Spark plug insulators, porcelain, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Stationery articles, pottery, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Statuary, clay and ceramic, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Steatite porcelain insulators manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION":
        "Stoneware (i.e., pottery products) manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION":
        "Table articles, coarse earthenware, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Table articles, earthenware, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION":
        "Table articles, fine earthenware (i.e., whiteware), manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Table articles, vitreous china, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Tableware, vitreous china, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Tanks, flush, vitreous china, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Textile guides, porcelain, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Titania porcelain insulators manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Toilet fixtures, vitreous china, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION":
        "Towel bar holders, vitreous china and earthenware, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION": "Urinals, vitreous china, manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION":
        "Vases, pottery (e.g., china, earthenware, stoneware), manufacturing",
    },
    {
      NAICS22: "327110",
      "INDEX ITEM DESCRIPTION":
        "Water closet bowls, vitreous china, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Adobe bricks manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Alumina fused refractories manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Aluminous refractory cement manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Architectural terra cotta manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Bauxite brick manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Blocks, fire clay, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION":
        "Bricks (i.e., common, face, glazed, hollow, vitrified), clay, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Bricks, adobe, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Bricks, clay refractory, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Bricks, nonclay refractory, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Building tile, clay, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Carbon brick manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Castable refractories, clay, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Castable refractories, nonclay, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Cement, clay refractory, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Ceramic tiles, floor and wall, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION":
        "Clay refractories (e.g., mortar, brick, tile, block) manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Conduit, vitrified clay, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Coping, wall, clay, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Crucibles, fire clay, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION":
        "Crucibles, graphite, magnesite, chrome, silica, or other nonclay materials, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Drain tile, clay, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Firebrick, clay refractories, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Floaters, glasshouse, clay, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Floor tile, ceramic, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Flue lining, clay, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Glasshouse refractories manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION":
        "Insulating firebrick and shapes, clay, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Kiln furniture, clay, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION":
        "Liner brick and plates, vitrified clay, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Magnesia refractory cement manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Mortar, nonclay refractory, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Mortars, clay refractory, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Mosaic tile, ceramic, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION":
        "Nonclay refractories (e.g., block, brick, mortar, tile) manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Paving brick, clay, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION":
        "Pots, glasshouse, clay refractory, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Quarry tiles, clay, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION":
        "Refractories (e.g., block, brick, mortar, tile), clay, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION":
        "Refractories (e.g., block, brick, mortar, tile), nonclay, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Refractory cement, nonclay, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Roofing tile, clay, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Sewer pipe and fittings, clay, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Stove lining, clay, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Structural clay tile manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Tile, ceramic wall and floor, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Tile, clay, refractory, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Tile, clay, structural, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Tile, roofing and drain, clay, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Tile, sewer, clay, manufacturing",
    },
    {
      NAICS22: "327120",
      "INDEX ITEM DESCRIPTION": "Wall tile, ceramic, manufacturing",
    },
    {
      NAICS22: "327211",
      "INDEX ITEM DESCRIPTION": "Flat glass (e.g., float, plate) manufacturing",
    },
    {
      NAICS22: "327211",
      "INDEX ITEM DESCRIPTION": "Glass, plate, made in glass making plants",
    },
    {
      NAICS22: "327211",
      "INDEX ITEM DESCRIPTION":
        "Insulating glass, sealed units, made in glass making plants",
    },
    {
      NAICS22: "327211",
      "INDEX ITEM DESCRIPTION": "Laminated glass made in glass making plants",
    },
    {
      NAICS22: "327211",
      "INDEX ITEM DESCRIPTION":
        "Stained glass and stained glass products made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION": "Ashtrays, glass, made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION":
        "Blanks for electric light bulbs, glass, made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION":
        "Blanks, ophthalmic lens and optical glass, made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION": "Blocks, glass, made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION": "Bricks, glass, made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION":
        "Christmas tree ornaments, glass, made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION":
        "Cooking utensils, glass and glass ceramic, made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION": "Cooking ware made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION":
        "Decorative glassware made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION":
        "Electron tube parts, glass blanks, made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION":
        "Fibers, glass, textile, made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION": "Fruits, artificial, made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION":
        "Glass blanks for electric light bulbs made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION":
        "Glass fiber, optical, made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION":
        "Glass fiber, textile type, made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION":
        "Glass fiber, unsheathed, made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION": "Glass making and blowing by hand",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION":
        "Glass products (except packaging containers) made in a glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION": "Glass, automotive, made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION":
        "Glassware for industrial, scientific, and technical use made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION":
        "Glassware for lighting fixtures made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION":
        "Glassware, art, decorative, and novelty made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION":
        "Industrial glassware and glass products, pressed or blown, made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION":
        "Insulators, electrical, glass, made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION":
        "Laboratory glassware (e.g., beakers, test tubes, vials) made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION": "Lamp shades made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION":
        "Lens blanks, optical and ophthalmic, made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION": "Medical glassware made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION":
        "Ornaments, Christmas tree, glass, made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION": "Ovenware, glass, made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION":
        "Photomask blanks, glass, made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION":
        "Scientific glassware, pressed or blown, made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION": "Stemware, glass, made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION": "Tableware made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION":
        "Teakettles, glass and glass ceramic, made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION":
        "Technical glassware and glass products, pressed or blown, made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION":
        "Textile glass fibers made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION":
        "Vacuum tube blanks, glass, made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION": "Vases, glass, made in glass making plants",
    },
    {
      NAICS22: "327212",
      "INDEX ITEM DESCRIPTION": "Yarn, fiberglass, made in glass making plants",
    },
    {
      NAICS22: "327213",
      "INDEX ITEM DESCRIPTION": "Beer bottles, glass, manufacturing",
    },
    {
      NAICS22: "327213",
      "INDEX ITEM DESCRIPTION": "Beverage containers, glass, manufacturing",
    },
    {
      NAICS22: "327213",
      "INDEX ITEM DESCRIPTION":
        "Bottles (i.e., bottling, canning, packaging), glass, manufacturing",
    },
    {
      NAICS22: "327213",
      "INDEX ITEM DESCRIPTION":
        "Containers for packaging, bottling, and canning, glass, manufacturing",
    },
    {
      NAICS22: "327213",
      "INDEX ITEM DESCRIPTION": "Food packaging, glass, manufacturing",
    },
    {
      NAICS22: "327213",
      "INDEX ITEM DESCRIPTION": "Glass packaging containers manufacturing",
    },
    {
      NAICS22: "327213",
      "INDEX ITEM DESCRIPTION":
        "Jars for packaging, bottling, and canning, glass, manufacturing",
    },
    {
      NAICS22: "327213",
      "INDEX ITEM DESCRIPTION": "Soda bottles, glass, manufacturing",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION": "Aquariums made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION": "Ashtrays made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION":
        "Blanks, ophthalmic lens and optical glass, made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION": "Bricks, glass, made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION":
        "Christmas tree ornaments made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION": "Cooking ware made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION":
        "Cut and engraved glassware made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION":
        "Cutting, engraving, etching, painting or polishing purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION": "Decorated glassware made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION":
        "Doors, unframed glass, made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION":
        "Electron tube parts, glass blanks, made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION": "Fruits, artificial, made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION":
        "Furniture tops, glass (e.g., beveled, cut, polished), made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION":
        "Glass blanks for electric light bulbs made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION":
        "Glass products (except packaging containers) made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION": "Glass, automotive, made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION":
        "Glassware for industrial, scientific, and technical use made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION":
        "Glassware for lighting fixtures made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION":
        "Glassware, art decorative and novelty, made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION":
        "Glassware, cutting and engraving, made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION": "Hand blowing purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION": "Industrial glassware made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION":
        "Insulating glass, sealed units, made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION":
        "Insulators, electrical, glass, made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION":
        "Laboratory glassware (e.g., beakers, test tubes, vials) made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION": "Laminated glass made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION": "Lamp shades made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION":
        "Lens blanks, optical and ophthalmic, made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION": "Medical glassware made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION":
        "Mirrors, framed (except automotive) or unframed, made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION":
        "Ornaments, Christmas tree, made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION": "Ovenware made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION":
        "Safety glass (including motor vehicle) made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION":
        "Scientific apparatus glassware made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION": "Scientific glassware made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION":
        "Stained glass products made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION": "Stemware made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION": "Tableware made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION": "Technical glassware made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION": "Tempered glass made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION":
        "Vacuum tube blanks, glass, made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION": "Vases, glass, made from purchased glass",
    },
    {
      NAICS22: "327215",
      "INDEX ITEM DESCRIPTION": "Watch crystals made from purchased glass",
    },
    {
      NAICS22: "327310",
      "INDEX ITEM DESCRIPTION":
        "Cement (e.g., hydraulic, masonry, Portland, pozzolana) manufacturing",
    },
    {
      NAICS22: "327310",
      "INDEX ITEM DESCRIPTION": "Cement clinker manufacturing",
    },
    {
      NAICS22: "327310",
      "INDEX ITEM DESCRIPTION":
        "Natural (i.e., calcined earth) cement manufacturing",
    },
    {
      NAICS22: "327320",
      "INDEX ITEM DESCRIPTION": "Central-mixed concrete manufacturing",
    },
    {
      NAICS22: "327320",
      "INDEX ITEM DESCRIPTION": "Concrete batch plants (including temporary)",
    },
    {
      NAICS22: "327320",
      "INDEX ITEM DESCRIPTION":
        "Ready-mix concrete manufacturing and distributing",
    },
    {
      NAICS22: "327320",
      "INDEX ITEM DESCRIPTION": "Transit-mixed concrete manufacturing",
    },
    {
      NAICS22: "327320",
      "INDEX ITEM DESCRIPTION": "Truck-mixed concrete manufacturing",
    },
    {
      NAICS22: "327331",
      "INDEX ITEM DESCRIPTION":
        "Architectural block, concrete (e.g., fluted, ground face, screen, slump, split), manufacturing",
    },
    {
      NAICS22: "327331",
      "INDEX ITEM DESCRIPTION": "Blocks, concrete and cinder, manufacturing",
    },
    {
      NAICS22: "327331",
      "INDEX ITEM DESCRIPTION": "Bricks, concrete, manufacturing",
    },
    {
      NAICS22: "327331",
      "INDEX ITEM DESCRIPTION": "Cinder (clinker) block, concrete, manufacturing",
    },
    {
      NAICS22: "327331",
      "INDEX ITEM DESCRIPTION": "Patio block, concrete, manufacturing",
    },
    {
      NAICS22: "327331",
      "INDEX ITEM DESCRIPTION": "Paving blocks, concrete, manufacturing",
    },
    {
      NAICS22: "327331",
      "INDEX ITEM DESCRIPTION": "Plinth blocks, precast terrazzo, manufacturing",
    },
    {
      NAICS22: "327331",
      "INDEX ITEM DESCRIPTION": "Precast concrete block and brick manufacturing",
    },
    {
      NAICS22: "327331",
      "INDEX ITEM DESCRIPTION":
        "Prestressed concrete blocks or bricks manufacturing",
    },
    {
      NAICS22: "327331",
      "INDEX ITEM DESCRIPTION": "Slumped brick manufacturing",
    },
    {
      NAICS22: "327332",
      "INDEX ITEM DESCRIPTION": "Conduits, concrete, manufacturing",
    },
    {
      NAICS22: "327332",
      "INDEX ITEM DESCRIPTION": "Culvert pipe, concrete, manufacturing",
    },
    {
      NAICS22: "327332",
      "INDEX ITEM DESCRIPTION":
        "Cylinder pipe, prestressed concrete, manufacturing",
    },
    {
      NAICS22: "327332",
      "INDEX ITEM DESCRIPTION": "Irrigation pipe, concrete, manufacturing",
    },
    {
      NAICS22: "327332",
      "INDEX ITEM DESCRIPTION": "Pipe, concrete, manufacturing",
    },
    {
      NAICS22: "327332",
      "INDEX ITEM DESCRIPTION": "Precast concrete pipe manufacturing",
    },
    {
      NAICS22: "327332",
      "INDEX ITEM DESCRIPTION":
        "Pressure pipe, reinforced concrete, manufacturing",
    },
    {
      NAICS22: "327332",
      "INDEX ITEM DESCRIPTION": "Prestressed concrete pipes manufacturing",
    },
    {
      NAICS22: "327332",
      "INDEX ITEM DESCRIPTION": "Sewer pipe, concrete, manufacturing",
    },
    {
      NAICS22: "327390",
      "INDEX ITEM DESCRIPTION":
        "Architectural wall panels, precast concrete, manufacturing",
    },
    {
      NAICS22: "327390",
      "INDEX ITEM DESCRIPTION":
        "Burial vaults, concrete and precast terrazzo, manufacturing",
    },
    {
      NAICS22: "327390",
      "INDEX ITEM DESCRIPTION":
        "Cast stone, concrete (except structural), manufacturing",
    },
    {
      NAICS22: "327390",
      "INDEX ITEM DESCRIPTION": "Chimney caps, concrete, manufacturing",
    },
    {
      NAICS22: "327390",
      "INDEX ITEM DESCRIPTION":
        "Concrete furniture (e.g., benches, tables) manufacturing",
    },
    {
      NAICS22: "327390",
      "INDEX ITEM DESCRIPTION":
        "Concrete products, precast (except block, brick and pipe), manufacturing",
    },
    {
      NAICS22: "327390",
      "INDEX ITEM DESCRIPTION": "Concrete tanks manufacturing",
    },
    {
      NAICS22: "327390",
      "INDEX ITEM DESCRIPTION": "Copings, concrete, manufacturing",
    },
    {
      NAICS22: "327390",
      "INDEX ITEM DESCRIPTION":
        "Garbage incinerators, precast concrete, manufacturing",
    },
    {
      NAICS22: "327390",
      "INDEX ITEM DESCRIPTION":
        "Garden furniture, precast concrete, manufacturing",
    },
    {
      NAICS22: "327390",
      "INDEX ITEM DESCRIPTION":
        "Girders and beams, prestressed concrete, manufacturing",
    },
    {
      NAICS22: "327390",
      "INDEX ITEM DESCRIPTION": "Girders, prestressed concrete, manufacturing",
    },
    {
      NAICS22: "327390",
      "INDEX ITEM DESCRIPTION": "Incinerators, precast concrete, manufacturing",
    },
    {
      NAICS22: "327390",
      "INDEX ITEM DESCRIPTION": "Lintels, concrete, manufacturing",
    },
    {
      NAICS22: "327390",
      "INDEX ITEM DESCRIPTION":
        "Ornamental and statuary precast concrete products manufacturing",
    },
    {
      NAICS22: "327390",
      "INDEX ITEM DESCRIPTION": "Poles, concrete, manufacturing",
    },
    {
      NAICS22: "327390",
      "INDEX ITEM DESCRIPTION": "Posts, concrete, manufacturing",
    },
    {
      NAICS22: "327390",
      "INDEX ITEM DESCRIPTION":
        "Precast concrete products (except brick, block, pipe) manufacturing",
    },
    {
      NAICS22: "327390",
      "INDEX ITEM DESCRIPTION":
        "Prestressed concrete products (except blocks, bricks, pipes) manufacturing",
    },
    {
      NAICS22: "327390",
      "INDEX ITEM DESCRIPTION": "Roofing tile, concrete, manufacturing",
    },
    {
      NAICS22: "327390",
      "INDEX ITEM DESCRIPTION": "Sills, concrete, manufacturing",
    },
    {
      NAICS22: "327390",
      "INDEX ITEM DESCRIPTION": "Silos, prefabricated concrete, manufacturing",
    },
    {
      NAICS22: "327390",
      "INDEX ITEM DESCRIPTION": "Tanks, concrete, manufacturing",
    },
    {
      NAICS22: "327390",
      "INDEX ITEM DESCRIPTION":
        "Terrazzo products, precast (except brick, block and pipe), manufacturing",
    },
    {
      NAICS22: "327390",
      "INDEX ITEM DESCRIPTION": "Ties, concrete, railroad, manufacturing",
    },
    {
      NAICS22: "327410",
      "INDEX ITEM DESCRIPTION": "Agricultural lime manufacturing",
    },
    {
      NAICS22: "327410",
      "INDEX ITEM DESCRIPTION":
        "Calcium hydroxide (i.e., hydrated lime) manufacturing",
    },
    {
      NAICS22: "327410",
      "INDEX ITEM DESCRIPTION": "Calcium oxide (i.e., quicklime) manufacturing",
    },
    {
      NAICS22: "327410",
      "INDEX ITEM DESCRIPTION": "Dolomite, dead-burned, manufacturing",
    },
    {
      NAICS22: "327410",
      "INDEX ITEM DESCRIPTION": "Dolomitic lime manufacturing",
    },
    {
      NAICS22: "327410",
      "INDEX ITEM DESCRIPTION":
        "Hydrated lime (i.e., calcium hydroxide) manufacturing",
    },
    {
      NAICS22: "327410",
      "INDEX ITEM DESCRIPTION": "Lime production",
    },
    {
      NAICS22: "327410",
      "INDEX ITEM DESCRIPTION": "Quicklime (i.e., calcium oxide) manufacturing",
    },
    {
      NAICS22: "327420",
      "INDEX ITEM DESCRIPTION":
        "Art goods (e.g., gypsum, plaster of paris) manufacturing",
    },
    {
      NAICS22: "327420",
      "INDEX ITEM DESCRIPTION": "Board, gypsum, manufacturing",
    },
    {
      NAICS22: "327420",
      "INDEX ITEM DESCRIPTION":
        "Cement, Keene's (i.e., tiling plaster), manufacturing",
    },
    {
      NAICS22: "327420",
      "INDEX ITEM DESCRIPTION":
        "Columns, architectural or ornamental plaster work, manufacturing",
    },
    {
      NAICS22: "327420",
      "INDEX ITEM DESCRIPTION": "Ecclesiastical statuary, gypsum, manufacturing",
    },
    {
      NAICS22: "327420",
      "INDEX ITEM DESCRIPTION": "Flower boxes, plaster of paris, manufacturing",
    },
    {
      NAICS22: "327420",
      "INDEX ITEM DESCRIPTION": "Fountains, plaster of paris, manufacturing",
    },
    {
      NAICS22: "327420",
      "INDEX ITEM DESCRIPTION": "Gypsum building products manufacturing",
    },
    {
      NAICS22: "327420",
      "INDEX ITEM DESCRIPTION":
        "Gypsum products (e.g., block, board, plaster, lath, rock, tile) manufacturing",
    },
    {
      NAICS22: "327420",
      "INDEX ITEM DESCRIPTION": "Gypsum statuary manufacturing",
    },
    {
      NAICS22: "327420",
      "INDEX ITEM DESCRIPTION": "Images, small gypsum, manufacturing",
    },
    {
      NAICS22: "327420",
      "INDEX ITEM DESCRIPTION": "Joint compounds, gypsum based, manufacturing",
    },
    {
      NAICS22: "327420",
      "INDEX ITEM DESCRIPTION": "Keene's cement manufacturing",
    },
    {
      NAICS22: "327420",
      "INDEX ITEM DESCRIPTION": "Lath, gypsum, manufacturing",
    },
    {
      NAICS22: "327420",
      "INDEX ITEM DESCRIPTION":
        "Ornamental and architectural plaster work (e.g., columns, mantels, molding) manufacturing",
    },
    {
      NAICS22: "327420",
      "INDEX ITEM DESCRIPTION": "Orthopedic plaster, gypsum, manufacturing",
    },
    {
      NAICS22: "327420",
      "INDEX ITEM DESCRIPTION": "Plaster and plasterboard, gypsum, manufacturing",
    },
    {
      NAICS22: "327420",
      "INDEX ITEM DESCRIPTION": "Plaster of paris manufacturing",
    },
    {
      NAICS22: "327420",
      "INDEX ITEM DESCRIPTION":
        "Plaster of paris products (e.g., columns, statuary, urns) manufacturing",
    },
    {
      NAICS22: "327420",
      "INDEX ITEM DESCRIPTION": "Plaster, gypsum, manufacturing",
    },
    {
      NAICS22: "327420",
      "INDEX ITEM DESCRIPTION":
        "Sculptures (e.g., gypsum, plaster of paris) manufacturing",
    },
    {
      NAICS22: "327420",
      "INDEX ITEM DESCRIPTION":
        "Statuary (e.g., gypsum, plaster of paris) manufacturing",
    },
    {
      NAICS22: "327420",
      "INDEX ITEM DESCRIPTION":
        "Urns (e.g., gypsum, plaster of paris) manufacturing",
    },
    {
      NAICS22: "327420",
      "INDEX ITEM DESCRIPTION":
        "Vases (e.g., gypsum, plaster of paris) manufacturing",
    },
    {
      NAICS22: "327420",
      "INDEX ITEM DESCRIPTION": "Wallboard, gypsum, manufacturing",
    },
    {
      NAICS22: "327910",
      "INDEX ITEM DESCRIPTION": "Abrasive products manufacturing",
    },
    {
      NAICS22: "327910",
      "INDEX ITEM DESCRIPTION": "Aluminum oxide (fused) abrasives manufacturing",
    },
    {
      NAICS22: "327910",
      "INDEX ITEM DESCRIPTION":
        "Buffing and polishing wheels, abrasive and nonabrasive, manufacturing",
    },
    {
      NAICS22: "327910",
      "INDEX ITEM DESCRIPTION":
        "Cloth (e.g., aluminum oxide, garnet, emery, silicon carbide), abrasive-coated, made from purchased cloth",
    },
    {
      NAICS22: "327910",
      "INDEX ITEM DESCRIPTION": "Diamond dressing wheels manufacturing",
    },
    {
      NAICS22: "327910",
      "INDEX ITEM DESCRIPTION":
        "Grains, abrasive, natural and artificial, manufacturing",
    },
    {
      NAICS22: "327910",
      "INDEX ITEM DESCRIPTION": "Grinding balls, ceramic, manufacturing",
    },
    {
      NAICS22: "327910",
      "INDEX ITEM DESCRIPTION": "Grinding wheels manufacturing",
    },
    {
      NAICS22: "327910",
      "INDEX ITEM DESCRIPTION":
        "Paper (e.g., aluminum oxide, emery, garnet, silicon carbide), abrasive-coated, made from purchased paper",
    },
    {
      NAICS22: "327910",
      "INDEX ITEM DESCRIPTION": "Polishing wheels manufacturing",
    },
    {
      NAICS22: "327910",
      "INDEX ITEM DESCRIPTION": "Pumice and pumicite abrasives manufacturing",
    },
    {
      NAICS22: "327910",
      "INDEX ITEM DESCRIPTION": "Sandpaper manufacturing",
    },
    {
      NAICS22: "327910",
      "INDEX ITEM DESCRIPTION": "Silicon carbide abrasives manufacturing",
    },
    {
      NAICS22: "327910",
      "INDEX ITEM DESCRIPTION": "Steel shot abrasives manufacturing",
    },
    {
      NAICS22: "327910",
      "INDEX ITEM DESCRIPTION": "Wheels, abrasive, manufacturing",
    },
    {
      NAICS22: "327910",
      "INDEX ITEM DESCRIPTION": "Wheels, polishing and grinding, manufacturing",
    },
    {
      NAICS22: "327910",
      "INDEX ITEM DESCRIPTION": "Whetstones manufacturing",
    },
    {
      NAICS22: "327991",
      "INDEX ITEM DESCRIPTION": "Architectural sculptures, stone, manufacturing",
    },
    {
      NAICS22: "327991",
      "INDEX ITEM DESCRIPTION": "Baptismal fonts, cut stone, manufacturing",
    },
    {
      NAICS22: "327991",
      "INDEX ITEM DESCRIPTION": "Blackboards, unframed, slate, manufacturing",
    },
    {
      NAICS22: "327991",
      "INDEX ITEM DESCRIPTION": "Burial vaults, stone, manufacturing",
    },
    {
      NAICS22: "327991",
      "INDEX ITEM DESCRIPTION": "Countertops, stone, manufacturing",
    },
    {
      NAICS22: "327991",
      "INDEX ITEM DESCRIPTION": "Curbing, granite and stone, manufacturing",
    },
    {
      NAICS22: "327991",
      "INDEX ITEM DESCRIPTION":
        "Cut stone bases (e.g., desk sets pedestals, lamps, plaques and similar small particles) manufacturing",
    },
    {
      NAICS22: "327991",
      "INDEX ITEM DESCRIPTION":
        "Cut stone products (e.g., blocks, statuary) manufacturing",
    },
    {
      NAICS22: "327991",
      "INDEX ITEM DESCRIPTION": "Dimension stone dressing and manufacturing",
    },
    {
      NAICS22: "327991",
      "INDEX ITEM DESCRIPTION": "Dimension stone for buildings manufacturing",
    },
    {
      NAICS22: "327991",
      "INDEX ITEM DESCRIPTION": "Ecclesiastical statuary, stone, manufacturing",
    },
    {
      NAICS22: "327991",
      "INDEX ITEM DESCRIPTION": "Flagstones cutting",
    },
    {
      NAICS22: "327991",
      "INDEX ITEM DESCRIPTION":
        "Furniture, cut stone (i.e., benches, tables, church), manufacturing",
    },
    {
      NAICS22: "327991",
      "INDEX ITEM DESCRIPTION": "Garden furniture, stone, manufacturing",
    },
    {
      NAICS22: "327991",
      "INDEX ITEM DESCRIPTION":
        "Monuments and tombstones, cut stone, manufacturing",
    },
    {
      NAICS22: "327991",
      "INDEX ITEM DESCRIPTION": "Slate products manufacturing",
    },
    {
      NAICS22: "327991",
      "INDEX ITEM DESCRIPTION": "Statuary, marble, manufacturing",
    },
    {
      NAICS22: "327991",
      "INDEX ITEM DESCRIPTION": "Table tops, marble, manufacturing",
    },
    {
      NAICS22: "327992",
      "INDEX ITEM DESCRIPTION": "Barite processing beyond beneficiation",
    },
    {
      NAICS22: "327992",
      "INDEX ITEM DESCRIPTION": "Barium processing beyond beneficiation",
    },
    {
      NAICS22: "327992",
      "INDEX ITEM DESCRIPTION": "Blast furnace slag processing",
    },
    {
      NAICS22: "327992",
      "INDEX ITEM DESCRIPTION": "Desiccants, activated clay, manufacturing",
    },
    {
      NAICS22: "327992",
      "INDEX ITEM DESCRIPTION":
        "Diatomaceous earth processing beyond beneficiation",
    },
    {
      NAICS22: "327992",
      "INDEX ITEM DESCRIPTION": "Feldspar processing beyond beneficiation",
    },
    {
      NAICS22: "327992",
      "INDEX ITEM DESCRIPTION": "Flint processing beyond beneficiation",
    },
    {
      NAICS22: "327992",
      "INDEX ITEM DESCRIPTION": "Fuller's earth processing beyond beneficiating",
    },
    {
      NAICS22: "327992",
      "INDEX ITEM DESCRIPTION":
        "Graphite, natural (e.g., ground, pulverized, refined, blended), manufacturing",
    },
    {
      NAICS22: "327992",
      "INDEX ITEM DESCRIPTION": "Kaolin, processing beyond beneficiation",
    },
    {
      NAICS22: "327992",
      "INDEX ITEM DESCRIPTION":
        "Lead, black (i.e., natural graphite), ground, refined, or blended, manufacturing",
    },
    {
      NAICS22: "327992",
      "INDEX ITEM DESCRIPTION":
        "Magnesite, crude (e.g., calcined, dead-burned, ground), manufacturing",
    },
    {
      NAICS22: "327992",
      "INDEX ITEM DESCRIPTION": "Mica processing beyond beneficiation",
    },
    {
      NAICS22: "327992",
      "INDEX ITEM DESCRIPTION": "Perlite aggregates manufacturing",
    },
    {
      NAICS22: "327992",
      "INDEX ITEM DESCRIPTION": "Perlite, expanded, manufacturing",
    },
    {
      NAICS22: "327992",
      "INDEX ITEM DESCRIPTION":
        "Pumice (except abrasives) processing beyond beneficiation",
    },
    {
      NAICS22: "327992",
      "INDEX ITEM DESCRIPTION": "Pyrophyllite processing beyond beneficiation",
    },
    {
      NAICS22: "327992",
      "INDEX ITEM DESCRIPTION": "Shale, expanded, manufacturing",
    },
    {
      NAICS22: "327992",
      "INDEX ITEM DESCRIPTION": "Silicon, ultra high purity, manufacturing",
    },
    {
      NAICS22: "327992",
      "INDEX ITEM DESCRIPTION": "Soapstone processing beyond beneficiation",
    },
    {
      NAICS22: "327992",
      "INDEX ITEM DESCRIPTION": "Talc processing beyond beneficiation",
    },
    {
      NAICS22: "327992",
      "INDEX ITEM DESCRIPTION": "Vermiculite, exfoliated, manufacturing",
    },
    {
      NAICS22: "327993",
      "INDEX ITEM DESCRIPTION": "Fiberglass insulation products manufacturing",
    },
    {
      NAICS22: "327993",
      "INDEX ITEM DESCRIPTION":
        "Insulating batts, fills, or blankets, fiberglass, manufacturing",
    },
    {
      NAICS22: "327993",
      "INDEX ITEM DESCRIPTION": "Mineral wool insulation materials manufacturing",
    },
    {
      NAICS22: "327993",
      "INDEX ITEM DESCRIPTION":
        "Mineral wool products (e.g., board, insulation, tile) manufacturing",
    },
    {
      NAICS22: "327999",
      "INDEX ITEM DESCRIPTION":
        "Asbestos products (except brake shoes and clutches) manufacturing",
    },
    {
      NAICS22: "327999",
      "INDEX ITEM DESCRIPTION":
        "Asphalt concrete crushing and grinding (except at construction site)",
    },
    {
      NAICS22: "327999",
      "INDEX ITEM DESCRIPTION": "Built-up mica manufacturing",
    },
    {
      NAICS22: "327999",
      "INDEX ITEM DESCRIPTION": "Ceramic fiber manufacturing",
    },
    {
      NAICS22: "327999",
      "INDEX ITEM DESCRIPTION":
        "Concrete crushing and grinding (except at construction site)",
    },
    {
      NAICS22: "327999",
      "INDEX ITEM DESCRIPTION": "Concrete, dry mixture, manufacturing",
    },
    {
      NAICS22: "327999",
      "INDEX ITEM DESCRIPTION": "Dry mix concrete manufacturing",
    },
    {
      NAICS22: "327999",
      "INDEX ITEM DESCRIPTION":
        "Ecclesiastical statuary, papier-mache, manufacturing",
    },
    {
      NAICS22: "327999",
      "INDEX ITEM DESCRIPTION": "Images, small papier-mache, manufacturing",
    },
    {
      NAICS22: "327999",
      "INDEX ITEM DESCRIPTION":
        "Manmade and engineered proppants (e.g., resin-coated sand, ceramic materials) manufacturing",
    },
    {
      NAICS22: "327999",
      "INDEX ITEM DESCRIPTION": "Mica products manufacturing",
    },
    {
      NAICS22: "327999",
      "INDEX ITEM DESCRIPTION":
        "Papier-mache statuary and related art goods (e.g., urns, vases) manufacturing",
    },
    {
      NAICS22: "327999",
      "INDEX ITEM DESCRIPTION": "Peat pots, molded pulp, manufacturing",
    },
    {
      NAICS22: "327999",
      "INDEX ITEM DESCRIPTION":
        "Statuary, vases, and urns, papier-mache, manufacturing",
    },
    {
      NAICS22: "327999",
      "INDEX ITEM DESCRIPTION":
        "Stones, synthetic, for gem stones and industrial use, manufacturing",
    },
    {
      NAICS22: "327999",
      "INDEX ITEM DESCRIPTION": "Stucco and stucco products manufacturing",
    },
    {
      NAICS22: "327999",
      "INDEX ITEM DESCRIPTION":
        "Synthetic stones, for gem stones and industrial use, manufacturing",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Armor plate made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Axles, rolled or forged, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Balls, steel, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Bars, concrete reinforcing (rebar) made in steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Bars, iron, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Bars, steel, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Billets, steel, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Blackplate made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Blast furnaces",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Blooms, steel, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Car wheels, rolled steel, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Coke oven products made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Concrete reinforcing bar (rebar) made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Direct reduction of iron ore",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Electrometallurgical ferroalloy manufacturing",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Electrometallurgical steel manufacturing",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Fence posts, iron or steel, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Ferroalloys manufacturing",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Ferrochromium manufacturing",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Ferromanganese manufacturing",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Ferromolybdenum manufacturing",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Ferrophosphorus manufacturing",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Ferrosilicon manufacturing",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Ferrotitanium manufacturing",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Ferrotungsten manufacturing",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Ferrovanadium manufacturing",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Flakes, iron or steel, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Flats, iron or steel, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Forgings, iron or steel, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Frogs, iron or steel, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Galvanizing metals and metal formed products made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Gun forgings made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "High percentage nonferrous alloying elements (i.e., ferroalloys) manufacturing",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Hoops made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Hoops, galvanized, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Hot-rolling iron or steel products in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Ingot made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Iron ore recovery from open hearth slag",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Iron sinter made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Iron, pig, manufacturing",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Manganese metal ferroalloys manufacturing",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Mesh, wire, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Mini-mills, steel",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Molybdenum silicon ferroalloys manufacturing",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Nut rods, iron or steel, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Paste, iron or steel, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Pig iron manufacturing",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Pilings, iron or steel plain sheet, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Pipe, iron or steel, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Plate, iron or steel, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Powder, iron or steel, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Rail joints and fastenings made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Railroad crossings, iron or steel, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Rails rerolled or renewed in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Rails, iron or steel, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Rods, iron or steel, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Rounds, tube, steel, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Sheet pilings, plain, iron or steel, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Sheets, steel, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Shell slugs, steel, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Silicomanganese ferroalloys manufacturing",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Skelp, iron or steel, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Slab, steel, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Spiegeleisen ferroalloys manufacturing",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Spike rods made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Sponge iron",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Stainless steel made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Steel balls made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Steel manufacturing",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Steel mill products (e.g., bar, plate, rod, sheet, structural shapes) manufacturing",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Steel, from pig iron, manufacturing",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Strip, galvanized iron or steel, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Strip, iron or steel, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Structural shapes, iron or steel, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Superalloys, iron or steel, manufacturing",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Template, made in iron and steel mills, manufacturing",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Terneplate made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Ternes, iron or steel, long or short, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Tie plates, iron or steel, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Tin-free steel made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Tinplate made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION": "Tool steel made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Tube rounds, iron or steel, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Tube, iron or steel, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Tubing, seamless steel, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Tubing, wrought iron or steel, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Well casings, iron or steel, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Wheels, car and locomotive, iron or steel, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Wire products, iron or steel, made in iron and steel mills",
    },
    {
      NAICS22: "331110",
      "INDEX ITEM DESCRIPTION":
        "Wrought iron or steel pipe and tubing made in iron and steel mills",
    },
    {
      NAICS22: "331210",
      "INDEX ITEM DESCRIPTION": "Boiler tubes, wrought, made from purchased iron",
    },
    {
      NAICS22: "331210",
      "INDEX ITEM DESCRIPTION":
        "Conduit, welded and lock joint, made from purchased iron or steel",
    },
    {
      NAICS22: "331210",
      "INDEX ITEM DESCRIPTION":
        "Pipe (e.g., heavy riveted, lock joint, seamless, welded) made from purchased iron or steel",
    },
    {
      NAICS22: "331210",
      "INDEX ITEM DESCRIPTION":
        "Tube (e.g., heavy riveted, lock joint, seamless, welded) made from purchased iron or steel",
    },
    {
      NAICS22: "331210",
      "INDEX ITEM DESCRIPTION":
        "Tubing, mechanical and hypodermic sizes, cold-drawn stainless steel, made from purchased steel",
    },
    {
      NAICS22: "331210",
      "INDEX ITEM DESCRIPTION":
        "Well casings (e.g., heavy riveted, lock joint, welded, wrought) made from purchased iron or steel",
    },
    {
      NAICS22: "331221",
      "INDEX ITEM DESCRIPTION":
        "Bars, concrete reinforcing (rebar), made from purchased steel in steel rolling mills",
    },
    {
      NAICS22: "331221",
      "INDEX ITEM DESCRIPTION":
        "Bars, steel, made from purchased steel in cold rolling mills",
    },
    {
      NAICS22: "331221",
      "INDEX ITEM DESCRIPTION":
        "Cold rolling steel shapes (e.g., bar, plate, rod, sheet, strip) made from purchased steel",
    },
    {
      NAICS22: "331221",
      "INDEX ITEM DESCRIPTION":
        "Concrete reinforcing bar (rebar), made from purchased steel in cold rolling mills ",
    },
    {
      NAICS22: "331221",
      "INDEX ITEM DESCRIPTION":
        "Concrete reinforcing bar (rebar), made from purchased steel in steel rolling mills",
    },
    {
      NAICS22: "331221",
      "INDEX ITEM DESCRIPTION":
        "Corrugating iron or steel in cold rolling mills made from purchased iron or steel",
    },
    {
      NAICS22: "331221",
      "INDEX ITEM DESCRIPTION":
        "Ferrous metal powder, paste, and flake made from purchased iron or steel",
    },
    {
      NAICS22: "331221",
      "INDEX ITEM DESCRIPTION": "Flakes made from purchased iron or steel",
    },
    {
      NAICS22: "331221",
      "INDEX ITEM DESCRIPTION":
        "Flat bright steel strip made in cold rolling mills made from purchased steel",
    },
    {
      NAICS22: "331221",
      "INDEX ITEM DESCRIPTION": "Hot-rolling purchased steel",
    },
    {
      NAICS22: "331221",
      "INDEX ITEM DESCRIPTION":
        "Metal powder and flake made from purchased iron or steel",
    },
    {
      NAICS22: "331221",
      "INDEX ITEM DESCRIPTION":
        "Nut rods, iron or steel, made in cold rolling mills",
    },
    {
      NAICS22: "331221",
      "INDEX ITEM DESCRIPTION": "Paste made from purchased iron or steel",
    },
    {
      NAICS22: "331221",
      "INDEX ITEM DESCRIPTION": "Powder made from purchased iron or steel",
    },
    {
      NAICS22: "331221",
      "INDEX ITEM DESCRIPTION":
        "Razor blade strip steel made in cold rolling mills",
    },
    {
      NAICS22: "331221",
      "INDEX ITEM DESCRIPTION":
        "Wire, flat, rolled strip, made in cold rolling mills",
    },
    {
      NAICS22: "331222",
      "INDEX ITEM DESCRIPTION":
        "Barbed and twisted wire made in wire drawing plants",
    },
    {
      NAICS22: "331222",
      "INDEX ITEM DESCRIPTION":
        "Baskets, iron or steel, made in wire drawing plants",
    },
    {
      NAICS22: "331222",
      "INDEX ITEM DESCRIPTION":
        "Brads, iron or steel, wire or cut, made in wire drawing plants",
    },
    {
      NAICS22: "331222",
      "INDEX ITEM DESCRIPTION":
        "Cable, iron or steel, insulated or armored, made in wire drawing plants",
    },
    {
      NAICS22: "331222",
      "INDEX ITEM DESCRIPTION":
        "Chain link fencing, iron or steel, made in wire drawing plants",
    },
    {
      NAICS22: "331222",
      "INDEX ITEM DESCRIPTION":
        "Drawing iron or steel wire from purchased iron or steel",
    },
    {
      NAICS22: "331222",
      "INDEX ITEM DESCRIPTION":
        "Drawing iron or steel wire from purchased iron or steel and fabricating wire products",
    },
    {
      NAICS22: "331222",
      "INDEX ITEM DESCRIPTION":
        "Fence gates, posts, and fittings, iron or steel, made in wire drawing plants",
    },
    {
      NAICS22: "331222",
      "INDEX ITEM DESCRIPTION": "Form ties made in wire drawing plants",
    },
    {
      NAICS22: "331222",
      "INDEX ITEM DESCRIPTION":
        "Horseshoe nails, iron or steel, made in wire drawing plants",
    },
    {
      NAICS22: "331222",
      "INDEX ITEM DESCRIPTION": "Mesh, wire, made in wire drawing mills",
    },
    {
      NAICS22: "331222",
      "INDEX ITEM DESCRIPTION":
        "Nails, iron or steel, made in wire drawing plants",
    },
    {
      NAICS22: "331222",
      "INDEX ITEM DESCRIPTION":
        "Paper clips, iron or steel, made in wire drawing plants",
    },
    {
      NAICS22: "331222",
      "INDEX ITEM DESCRIPTION":
        "Spikes, iron or steel, made in wire drawing plants",
    },
    {
      NAICS22: "331222",
      "INDEX ITEM DESCRIPTION":
        "Staples, iron or steel, made in wire drawing plants",
    },
    {
      NAICS22: "331222",
      "INDEX ITEM DESCRIPTION":
        "Tacks, iron or steel, made in wire drawing plants",
    },
    {
      NAICS22: "331222",
      "INDEX ITEM DESCRIPTION": "Tie wires made in wire drawing plants",
    },
    {
      NAICS22: "331222",
      "INDEX ITEM DESCRIPTION":
        "Welded iron or steel wire fabric made in wire drawing plants",
    },
    {
      NAICS22: "331222",
      "INDEX ITEM DESCRIPTION":
        "Wire cages, iron or steel, made in wire drawing plants",
    },
    {
      NAICS22: "331222",
      "INDEX ITEM DESCRIPTION":
        "Wire carts (e.g., grocery, household, industrial), iron or steel, made in wire drawing plants",
    },
    {
      NAICS22: "331222",
      "INDEX ITEM DESCRIPTION":
        "Wire cloth, iron or steel, made in wire drawing plants",
    },
    {
      NAICS22: "331222",
      "INDEX ITEM DESCRIPTION":
        "Wire garment hangers, iron or steel, made in wire drawing plants",
    },
    {
      NAICS22: "331222",
      "INDEX ITEM DESCRIPTION":
        "Wire products, iron or steel, made in wire drawing plants",
    },
    {
      NAICS22: "331222",
      "INDEX ITEM DESCRIPTION":
        "Wire, iron or steel (e.g., armored, bare, insulated), made in wire drawing plants",
    },
    {
      NAICS22: "331313",
      "INDEX ITEM DESCRIPTION": "Alumina refining",
    },
    {
      NAICS22: "331313",
      "INDEX ITEM DESCRIPTION":
        "Aluminum alloys made from bauxite or alumina producing primary aluminum and manufacturing",
    },
    {
      NAICS22: "331313",
      "INDEX ITEM DESCRIPTION":
        "Aluminum ingot and other primary aluminum production shapes made from bauxite or alumina",
    },
    {
      NAICS22: "331313",
      "INDEX ITEM DESCRIPTION": "Aluminum oxide refining",
    },
    {
      NAICS22: "331313",
      "INDEX ITEM DESCRIPTION": "Aluminum producing from alumina",
    },
    {
      NAICS22: "331313",
      "INDEX ITEM DESCRIPTION":
        "Aluminum shapes (e.g., bar, ingot, rod, sheet) made by producing primary aluminum and manufacturing",
    },
    {
      NAICS22: "331313",
      "INDEX ITEM DESCRIPTION":
        "Extrusion ingot, primary aluminum, manufacturing",
    },
    {
      NAICS22: "331313",
      "INDEX ITEM DESCRIPTION": "Ingot, primary aluminum, manufacturing",
    },
    {
      NAICS22: "331313",
      "INDEX ITEM DESCRIPTION":
        "Primary aluminum production and manufacturing aluminum alloys",
    },
    {
      NAICS22: "331313",
      "INDEX ITEM DESCRIPTION":
        "Primary aluminum production and manufacturing aluminum shapes (e.g., bar, ingot, rod, sheet)",
    },
    {
      NAICS22: "331313",
      "INDEX ITEM DESCRIPTION": "Primary refining of aluminum",
    },
    {
      NAICS22: "331313",
      "INDEX ITEM DESCRIPTION": "Primary smelting of aluminum",
    },
    {
      NAICS22: "331313",
      "INDEX ITEM DESCRIPTION": "Refining aluminum, primary",
    },
    {
      NAICS22: "331313",
      "INDEX ITEM DESCRIPTION": "Slab, primary aluminum, manufacturing",
    },
    {
      NAICS22: "331314",
      "INDEX ITEM DESCRIPTION": "Alloying purchased aluminum metals",
    },
    {
      NAICS22: "331314",
      "INDEX ITEM DESCRIPTION": "Aluminum alloys made from scrap or dross",
    },
    {
      NAICS22: "331314",
      "INDEX ITEM DESCRIPTION": "Aluminum billet made from purchased aluminum",
    },
    {
      NAICS22: "331314",
      "INDEX ITEM DESCRIPTION":
        "Aluminum billet made in integrated secondary smelting and rolling mills",
    },
    {
      NAICS22: "331314",
      "INDEX ITEM DESCRIPTION":
        "Aluminum extrusion ingot (i.e., billet), secondary",
    },
    {
      NAICS22: "331314",
      "INDEX ITEM DESCRIPTION": "Aluminum flakes made from purchased aluminum",
    },
    {
      NAICS22: "331314",
      "INDEX ITEM DESCRIPTION": "Aluminum ingot made from purchased aluminum",
    },
    {
      NAICS22: "331314",
      "INDEX ITEM DESCRIPTION":
        "Aluminum ingot, secondary smelting of aluminum and manufacturing",
    },
    {
      NAICS22: "331314",
      "INDEX ITEM DESCRIPTION": "Aluminum ingot, secondary, manufacturing",
    },
    {
      NAICS22: "331314",
      "INDEX ITEM DESCRIPTION":
        "Aluminum recovering from scrap and making ingot and billet (except by rolling)",
    },
    {
      NAICS22: "331314",
      "INDEX ITEM DESCRIPTION":
        "Aluminum smelting, secondary, and making ingot and billet (except by rolling)",
    },
    {
      NAICS22: "331314",
      "INDEX ITEM DESCRIPTION": "Flakes, aluminum, made from purchased aluminum",
    },
    {
      NAICS22: "331314",
      "INDEX ITEM DESCRIPTION":
        "Metal powder and flake made from purchased aluminum",
    },
    {
      NAICS22: "331314",
      "INDEX ITEM DESCRIPTION": "Paste made from purchased aluminum",
    },
    {
      NAICS22: "331314",
      "INDEX ITEM DESCRIPTION": "Powder made from purchased aluminum",
    },
    {
      NAICS22: "331314",
      "INDEX ITEM DESCRIPTION": "Refining aluminum, secondary",
    },
    {
      NAICS22: "331315",
      "INDEX ITEM DESCRIPTION":
        "Aluminum foil made by flat rolling purchased aluminum",
    },
    {
      NAICS22: "331315",
      "INDEX ITEM DESCRIPTION":
        "Aluminum foil made in integrated secondary smelting and flat rolling mills",
    },
    {
      NAICS22: "331315",
      "INDEX ITEM DESCRIPTION":
        "Aluminum plate made by continuous casting purchased aluminum",
    },
    {
      NAICS22: "331315",
      "INDEX ITEM DESCRIPTION":
        "Aluminum plate made by flat rolling purchased aluminum",
    },
    {
      NAICS22: "331315",
      "INDEX ITEM DESCRIPTION":
        "Aluminum plate made in integrated secondary smelting and continuous casting mills",
    },
    {
      NAICS22: "331315",
      "INDEX ITEM DESCRIPTION":
        "Aluminum plate made in integrated secondary smelting and flat rolling mills",
    },
    {
      NAICS22: "331315",
      "INDEX ITEM DESCRIPTION":
        "Aluminum sheet made by flat rolling purchased aluminum",
    },
    {
      NAICS22: "331315",
      "INDEX ITEM DESCRIPTION":
        "Aluminum sheet made in integrated secondary smelting and flat rolling mills",
    },
    {
      NAICS22: "331315",
      "INDEX ITEM DESCRIPTION":
        "Aluminum welded tube made by flat rolling purchased aluminum",
    },
    {
      NAICS22: "331315",
      "INDEX ITEM DESCRIPTION":
        "Aluminum welded tube made in integrated secondary smelting and flat rolling mills",
    },
    {
      NAICS22: "331315",
      "INDEX ITEM DESCRIPTION":
        "Foil, aluminum, made by flat rolling purchased aluminum",
    },
    {
      NAICS22: "331315",
      "INDEX ITEM DESCRIPTION":
        "Foil, aluminum, made in integrated secondary smelting and flat rolling mills",
    },
    {
      NAICS22: "331315",
      "INDEX ITEM DESCRIPTION":
        "Plate, aluminum, made by continuous casting purchased aluminum",
    },
    {
      NAICS22: "331315",
      "INDEX ITEM DESCRIPTION":
        "Plate, aluminum, made by flat rolling purchased aluminum",
    },
    {
      NAICS22: "331315",
      "INDEX ITEM DESCRIPTION":
        "Plate, aluminum, made in integrated secondary smelting and continuous casting mills",
    },
    {
      NAICS22: "331315",
      "INDEX ITEM DESCRIPTION":
        "Plate, aluminum, made in integrated secondary smelting and flat rolling mills",
    },
    {
      NAICS22: "331315",
      "INDEX ITEM DESCRIPTION":
        "Sheet, aluminum, made by flat rolling purchased aluminum",
    },
    {
      NAICS22: "331315",
      "INDEX ITEM DESCRIPTION":
        "Sheet, aluminum, made in integrated secondary smelting and flat rolling mills",
    },
    {
      NAICS22: "331315",
      "INDEX ITEM DESCRIPTION":
        "Tube, welded, aluminum, made by flat rolling purchased aluminum",
    },
    {
      NAICS22: "331315",
      "INDEX ITEM DESCRIPTION":
        "Tube, welded, aluminum, made in integrated secondary smelting and flat rolling mills",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Aluminum bar made by extruding purchased aluminum",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Aluminum bar made in integrated secondary smelting and extruding mills",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Aluminum pipe made by extruding purchased aluminum",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Aluminum pipe made in integrated secondary smelting and extruding mills",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Aluminum rod made by extruding purchased aluminum",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Aluminum rod made in integrated secondary smelting and extruding mills",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Aluminum tube blooms made by extruding purchased aluminum",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Aluminum tube blooms made in integrated secondary smelting and extruding mills",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Aluminum tube made by drawing or extruding purchased aluminum",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Aluminum tube made in integrated secondary smelting and drawing plants",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Aluminum tube made in integrated secondary smelting and extruding mills",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Apparatus wire or cord made in aluminum wire drawing plants",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Automotive or aircraft wire and cable made in aluminum wire drawing plants",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION": "Bar made by extruding purchased aluminum",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION": "Bar made by rolling purchased aluminum",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Bar, aluminum, made in integrated secondary smelting and extruding mills",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Bar, aluminum, made in integrated secondary smelting and rolling mills",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Coaxial cable made in aluminum wire drawing plants",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Communications wire or cable made in aluminum wire drawing plants",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Cord sets, flexible, made in aluminum wire drawing plants",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Energy wire or cable made in aluminum wire drawing plants",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Extrusion billet made by rolling purchased aluminum",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Extrusion billet, aluminum, made in integrated secondary smelting and rolling mills",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Extrusion ingot made by rolling purchased aluminum",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Extrusion ingot, aluminum, made in integrated secondary smelting and rolling mills",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION": "Ingot made by rolling purchased aluminum",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Ingot, aluminum, made in integrated secondary smelting and rolling mills",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Insulated wire or cable made in aluminum wire drawing plants",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Magnet wire, insulated, made in aluminum wire drawing plants",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Mesh, wire, made in aluminum wire drawing plants",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION": "Nails, aluminum, made in wire drawing plants",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION": "Pipe made by extruding purchased aluminum",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Pipe, aluminum, made in integrated secondary smelting and extruding mills",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Rails made by rolling or drawing purchased aluminum",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Rails, aluminum, made in integrated secondary smelting and drawing plants",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Rails, aluminum, made in integrated secondary smelting and rolling mills",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION": "Rod made by extruding purchased aluminum",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION": "Rod made by rolling purchased aluminum",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Rod, aluminum, made in integrated secondary smelting and extruding mills",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Rod, aluminum, made in integrated secondary smelting and rolling mills",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Shipboard cable made in aluminum wire drawing plants",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Signal and control cable made in aluminum wire drawing plants",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Structural shapes made by rolling purchased aluminum",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Structural shapes, aluminum, made in integrated secondary smelting and rolling mills",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Tube blooms made by extruding purchased aluminum",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Tube blooms, aluminum, made in integrated secondary smelting and extruding mills",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Tube made by drawing or extruding purchased aluminum",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Tube, aluminum, made in integrated secondary smelting and drawing plants",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Tube, aluminum, made in integrated secondary smelting and extruding mills",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Weatherproof wire or cable made in aluminum wire drawing plants",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION": "Wire cloth made in aluminum wire drawing plants",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Wire screening, aluminum, made in integrated secondary smelting and drawing plants",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Wire, armored, made in aluminum wire drawing plants",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Wire, bare, made in aluminum wire drawing plants",
    },
    {
      NAICS22: "331318",
      "INDEX ITEM DESCRIPTION":
        "Wire, insulated, made in aluminum wire drawing plants",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION": "Antimony refining, primary",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION":
        "Bars made in primary copper smelting and refining mills",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION": "Beryllium refining, primary",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION": "Bismuth refining, primary",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION": "Blister copper manufacturing",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION": "Cadmium refining, primary",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION": "Chromium refining, primary",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION": "Cobalt refining, primary",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION":
        "Copper alloys made in primary copper smelting and refining mills",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION": "Copper concentrate refining",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION":
        "Copper shapes (e.g., bar, billet, ingot, plate, sheet) made in primary copper smelting and refining mills",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION": "Copper smelting and refining, primary",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION": "Germanium refining, primary",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION":
        "Gold bullion or dore bar produced at primary metal refineries",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION": "Gold refining, primary",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION":
        "Ingot, primary, nonferrous metals (except aluminum), manufacturing",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION": "Iridium refining, primary",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION": "Lead smelting and refining, primary",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION": "Magnesium refining, primary",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION": "Nickel refining, primary",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION": "Niobium refining, primary",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION":
        "Nonferrous metal (except aluminum) shapes made in primary nonferrous metal smelting and refining mills",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION":
        "Nonferrous metals (except aluminum) made in primary nonferrous metal smelting and refining mills",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION":
        "Nonferrous metals (except aluminum) smelting and refining, primary",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION": "Platinum refining, primary",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION": "Precious metals refining, primary",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION": "Primary refining of copper",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION":
        "Primary refining of nonferrous metals (except aluminum)",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION": "Primary smelting of copper",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION":
        "Primary smelting of nonferrous metals (except aluminum)",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION": "Refining copper, primary",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION":
        "Refining nonferrous metals and alloys (except aluminum), primary",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION": "Rhenium refining, primary",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION": "Selenium refining, primary",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION":
        "Silver bullion or dore bar produced at primary metal refineries",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION": "Silver refining, primary",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION":
        "Slab, nonferrous metals (except aluminum) primary",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION":
        "Smelting of nonferrous metals (except aluminum), primary",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION": "Tantalum refining, primary",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION": "Tellurium refining, primary",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION":
        "Tin base alloys made in primary tin smelting and refining mills",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION": "Tin refining, primary",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION": "Titanium refining, primary",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION": "Uranium refining, primary",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION": "Zinc refining, primary",
    },
    {
      NAICS22: "331410",
      "INDEX ITEM DESCRIPTION": "Zirconium refining, primary",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Aircraft and automotive wire or cable made from purchased copper in wire drawing plants",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION": "Alloying purchased copper",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION": "Alloying purchased copper metals",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Apparatus wire or cord made from purchased copper in wire drawing plants",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Armored cable made from purchased copper in wire drawing plants",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Armored cable, copper, made in integrated secondary smelting and drawing plants",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Bar, copper and copper alloy, made from purchased copper or in integrated secondary smelting and rolling, drawing or extruding plants",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Brass products, rolling, drawing, or extruding, made from purchased copper or in integrated secondary smelting and rolling, drawing or extruding plants",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Bronze products, rolling, drawing, or extruding, made from purchased copper or in integrated secondary smelting and rolling, drawing or extruding plants",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Cable, copper (e.g., armored, bare, insulated), made from purchased copper in wire drawing plants",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Cable, copper (e.g., armored, bare, insulated), made in integrated secondary smelting and wire drawing plants",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Cartridge cups, discs, and sheets, copper and copper alloy, made from purchased copper or in integrated secondary smelting and rolling, drawing or extruding plants",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Coaxial cable, copper, made from purchased copper in wire drawing plants",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Communications wire or cable, copper, made from purchased copper in wire drawing plants",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Copper alloys (e.g., brass, bronze) made from purchased metal or scrap",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Copper and copper-based shapes (e.g., cake, ingot, slag, wire bar) made from purchased metal or scrap",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION": "Copper foil made from purchased metal or scrap",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Copper powder, flakes, and paste made from purchased copper",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Copper products made by drawing purchased copper",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Copper products made by rolling, drawing, or extruding purchased copper",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Copper products made in integrated secondary smelting and extruding mills",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Copper products made in integrated secondary smelting mills and drawing plants",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION": "Copper secondary smelting and alloying",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Copper secondary smelting and refining from purchased metal or scrap",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Cord sets, flexible, made from purchased copper in wire drawing plants",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Energy wire or cable, copper, made from purchased copper in wire drawing plants",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Foil, copper, made from purchased metal or scrap",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Insulated wire or cable made from purchased copper in wire drawing plants",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Insulated wire or cable, copper, made in integrated secondary smelting and wire drawing plants",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Magnet wire, insulated, made from purchased copper in wire drawing plants",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Mesh, wire, made from purchased copper in wire drawing plants",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Metal powder and flake made from purchased copper",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION": "Paste made from purchased copper",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Pipe, extruded and drawn, brass, bronze, and copper, made from purchased copper or in integrated secondary smelting and rolling, drawing or extruding plants",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Plate, copper and copper alloy, made from purchased copper or in integrated secondary smelting and rolling, drawing or extruding plants",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION": "Powder made from purchased copper",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION": "Refining copper, secondary",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Rod, copper and copper alloy, made from purchased copper or in integrated secondary smelting and rolling, drawing or extruding plants",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Sheet, copper and copper alloy, made from purchased copper or in integrated secondary smelting and rolling, drawing or extruding plants",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Shipboard cable made from purchased copper in wire drawing plants",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Signal and control cable made from purchased copper in wire drawing plants",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Strip, copper and copper alloy, made from purchased copper or in integrated secondary smelting and rolling, drawing or extruding plants",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Tubing, copper and copper alloy, made from purchased copper or in integrated secondary smelting and rolling, drawing or extruding plants",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Weatherproof wire or cable made from purchased copper in wire drawing plants",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Wire cloth made from purchased copper in wire drawing plants",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Wire cloth, copper, made in integrated secondary smelting and wire drawing plants",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Wire, copper  (e.g., armored, bare, insulated), made from purchased copper in wire drawing plants",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Wire, copper (e.g., armored, bare, insulated), made in integrated secondary smelting and wire drawing plants",
    },
    {
      NAICS22: "331420",
      "INDEX ITEM DESCRIPTION":
        "Wire, mechanical, copper and copper alloy, made from purchased copper or in integrated secondary smelting and rolling, drawing or extruding plants",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Aircraft and automotive wire and cable (except aluminum, copper) made from purchased nonferrous metals (except aluminum, copper) in wire drawing plants",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Apparatus wire and cord (except aluminum, copper) made from purchased nonferrous metals (except aluminum, copper) in wire drawing plants",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Bar, nonferrous metals (except aluminum, copper), made from purchased metals in wire drawing plants or in integrated secondary smelting and rolling, drawing, or extruding plants",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Coaxial cable, nonferrous metals (except aluminum, copper), made from purchased nonferrous metals (except aluminum, copper) in wire drawing plants",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Communications wire or cable, nonferrous metals (except aluminum, copper), made from purchased nonferrous metals (except aluminum, copper) in wire drawing plants",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Cord sets, flexible, nonferrous metals (except aluminum, copper), made from purchased nonferrous metals (except aluminum, copper) in wire drawing plants",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Energy wire or cable, nonferrous metals (except aluminum, copper), made from purchased nonferrous metals (except aluminum, copper) in wire drawing plants",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Foil, gold, made by rolling purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Foil, nickel, made by rolling purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Foil, silver, made by rolling purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Gold and gold alloy bar, sheet, strip, and tubing made from purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Gold foil made by rolling purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Gold rolling and drawing purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Iridium bar, rod, sheet, strip and tubing made from purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Lead and lead alloy bar, pipe, plate, rod, sheet, strip, and tubing made from purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Lead rolling, drawing, or extruding purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Magnesium and magnesium alloy bar, rod, shape, sheet, strip, and tubing made from purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Magnesium foil made by rolling purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Magnesium rolling, drawing, or extruding purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Magnet wire, nonferrous metals (except aluminum, copper), made from purchased nonferrous metals (except aluminum, copper) in wire drawing plants",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Mesh, wire, nonferrous metals (except aluminum, copper), made from purchased nonferrous metals (except aluminum, copper) in wire drawing plants",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Molybdenum and molybdenum alloy bar, plate, pipe, rod, sheet, tubing, and wire made from purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Molybdenum rolling, drawing, or extruding purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Nails, nonferrous metals (except aluminum, copper), made from purchased nonferrous metals (except aluminum, copper) in wire drawing plants",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Nickel and nickel alloy pipe, plate, sheet, strip, and tubing made from purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Nickel rolling, drawing, or extruding purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Nonferrous metal shapes (except aluminum, copper) made by rolling, drawing, or extruding purchased nonferrous metal",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Nonferrous metal shapes (except aluminum, copper) made in integrated secondary smelting and extruding mills",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Nonferrous metal shapes (except aluminum, copper) made in integrated secondary smelting and rolling mills",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Nonferrous metal shapes (except aluminum, copper) made in integrated secondary smelting mills and wire drawing plants",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Nonferrous wire (except aluminum, copper) made from purchased nonferrous metals (except aluminum, copper) in wire drawing plants",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Nonferrous wire (except aluminum, copper) made in integrated secondary smelting mills and wire drawing plants",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Pipe, nonferrous metals (except aluminum, copper), made from purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Plate, nonferrous metals (except aluminum, copper), made from purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Platinum and platinum alloy rolling, drawing, or extruding from purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Platinum and platinum alloy sheet and tubing made from purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Precious metal bar, rod, sheet, strip, and tubing made from purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Rod, nonferrous metals (except aluminum, copper), made from purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Selenium bar, rod, sheet, strip, and tubing made from purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Silver and silver alloy bar, rod, sheet, strip, and tubing made from purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Silver foil made by rolling purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Silver rolling, drawing, or extruding purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Solder wire, nonferrous metals (except aluminum, copper), made from purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Strip, nonferrous metals (except aluminum, copper), made from purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Tin and tin alloy bar, pipe, rod, sheet, strip, and tubing made from purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Tin rolling, drawing, or extruding purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Titanium and titanium alloy bar, billet, rod, sheet, strip, and tubing made from purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Titanium rolling, drawing, or extruding purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Tubing, nonferrous metals (except aluminum, copper), made from purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Tungsten bar, rod, sheet, strip, and tubing made by rolling, drawing, or extruding purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Welding rod, uncoated, nonferrous metals (except aluminum, copper), made from purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Wire cloth, nonferrous metals (except aluminum, copper), made from purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Wire screening, nonferrous metals (except aluminum, copper), made from purchased nonferrous metals (except aluminum, copper) in wire drawing plants",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Wire, nonferrous metals (except aluminum, copper), made from purchased nonferrous metals (except aluminum, copper) in wire drawing plants",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Wire, nonferrous metals (except aluminum, copper), made in integrated secondary smelting mills and wire drawing plants",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Zinc and zinc alloy bar, plate, pipe, rod, sheet, tubing, and wire made from purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Zinc rolling, drawing, or extruding purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Zirconium and zirconium alloy bar, rod, billet, sheet, strip, and tubing made from purchased metals or scrap",
    },
    {
      NAICS22: "331491",
      "INDEX ITEM DESCRIPTION":
        "Zirconium rolling, drawing, or extruding purchased metals or scrap",
    },
    {
      NAICS22: "331492",
      "INDEX ITEM DESCRIPTION":
        "Alloying purchased nonferrous metals (except aluminum, copper)",
    },
    {
      NAICS22: "331492",
      "INDEX ITEM DESCRIPTION": "Detinning scrap (e.g., cans)",
    },
    {
      NAICS22: "331492",
      "INDEX ITEM DESCRIPTION":
        "Germanium recovering from scrap and/or alloying purchased metals",
    },
    {
      NAICS22: "331492",
      "INDEX ITEM DESCRIPTION":
        "Gold recovering from scrap and/or alloying purchased metals",
    },
    {
      NAICS22: "331492",
      "INDEX ITEM DESCRIPTION":
        "Ingot, nonferrous metals (except aluminum, copper), secondary smelting and refining",
    },
    {
      NAICS22: "331492",
      "INDEX ITEM DESCRIPTION":
        "Iridium recovering from scrap and/or alloying purchased metals",
    },
    {
      NAICS22: "331492",
      "INDEX ITEM DESCRIPTION":
        "Lead recovering from scrap and/or alloying purchased metals",
    },
    {
      NAICS22: "331492",
      "INDEX ITEM DESCRIPTION":
        "Magnesium recovering from scrap and/or alloying purchased metals",
    },
    {
      NAICS22: "331492",
      "INDEX ITEM DESCRIPTION":
        "Metal powder and flake nonferrous (except aluminum, copper) made from purchased metal",
    },
    {
      NAICS22: "331492",
      "INDEX ITEM DESCRIPTION":
        "Nickel recovering from scrap and/or alloying purchased metals",
    },
    {
      NAICS22: "331492",
      "INDEX ITEM DESCRIPTION":
        "Nonferrous alloys (except aluminum, copper) made from purchased nonferrous metals",
    },
    {
      NAICS22: "331492",
      "INDEX ITEM DESCRIPTION":
        "Nonferrous alloys (except aluminum, copper) made in integrated secondary smelting and alloying plants",
    },
    {
      NAICS22: "331492",
      "INDEX ITEM DESCRIPTION":
        "Nonferrous metals (except aluminum, copper) secondary smelting and refining",
    },
    {
      NAICS22: "331492",
      "INDEX ITEM DESCRIPTION":
        "Paste, nonferrous metals (except aluminum, copper), made from purchased metal",
    },
    {
      NAICS22: "331492",
      "INDEX ITEM DESCRIPTION":
        "Platinum recovering from scrap and/or alloying purchased metals",
    },
    {
      NAICS22: "331492",
      "INDEX ITEM DESCRIPTION":
        "Powder, nonferrous metals (except aluminum, copper), made from purchased metal",
    },
    {
      NAICS22: "331492",
      "INDEX ITEM DESCRIPTION":
        "Precious metals recovering from scrap and/or alloying purchased metals",
    },
    {
      NAICS22: "331492",
      "INDEX ITEM DESCRIPTION":
        "Recovering and refining of nonferrous metals (except aluminum, copper) from scrap",
    },
    {
      NAICS22: "331492",
      "INDEX ITEM DESCRIPTION":
        "Recovering silver from used photographic film or X-ray plates",
    },
    {
      NAICS22: "331492",
      "INDEX ITEM DESCRIPTION":
        "Refining nonferrous metals and alloys (except aluminum, copper), secondary",
    },
    {
      NAICS22: "331492",
      "INDEX ITEM DESCRIPTION":
        "Secondary refining of nonferrous metals (except aluminum, copper)",
    },
    {
      NAICS22: "331492",
      "INDEX ITEM DESCRIPTION":
        "Secondary smelting of nonferrous metals (except aluminum, copper)",
    },
    {
      NAICS22: "331492",
      "INDEX ITEM DESCRIPTION":
        "Selenium recovering from scrap and/or alloying purchased metals",
    },
    {
      NAICS22: "331492",
      "INDEX ITEM DESCRIPTION":
        "Silver recovering from scrap and/or alloying purchased metals",
    },
    {
      NAICS22: "331492",
      "INDEX ITEM DESCRIPTION":
        "Silver recovering from used photographic film or X-ray plates",
    },
    {
      NAICS22: "331492",
      "INDEX ITEM DESCRIPTION":
        "Smelting and refining of nonferrous metals (except aluminum, copper), secondary",
    },
    {
      NAICS22: "331492",
      "INDEX ITEM DESCRIPTION":
        "Smelting nonferrous metals (except aluminum, copper), secondary",
    },
    {
      NAICS22: "331492",
      "INDEX ITEM DESCRIPTION":
        "Superalloys, nonferrous based, made from purchased metals or scrap",
    },
    {
      NAICS22: "331492",
      "INDEX ITEM DESCRIPTION":
        "Tin recovering from scrap and/or alloying purchased metals",
    },
    {
      NAICS22: "331492",
      "INDEX ITEM DESCRIPTION":
        "Tungsten carbide powder made by metallurgical process",
    },
    {
      NAICS22: "331492",
      "INDEX ITEM DESCRIPTION": "Zinc dust reclaiming",
    },
    {
      NAICS22: "331492",
      "INDEX ITEM DESCRIPTION":
        "Zinc recovering from scrap and/or alloying purchased metals",
    },
    {
      NAICS22: "331511",
      "INDEX ITEM DESCRIPTION": "Cast iron brake shoes, railroad, manufacturing",
    },
    {
      NAICS22: "331511",
      "INDEX ITEM DESCRIPTION": "Cast iron pipe and pipe fittings manufacturing",
    },
    {
      NAICS22: "331511",
      "INDEX ITEM DESCRIPTION": "Cast iron railroad car wheels manufacturing",
    },
    {
      NAICS22: "331511",
      "INDEX ITEM DESCRIPTION":
        "Castings, compacted graphite iron, unfinished, manufacturing",
    },
    {
      NAICS22: "331511",
      "INDEX ITEM DESCRIPTION":
        "Castings, malleable iron, unfinished, manufacturing",
    },
    {
      NAICS22: "331511",
      "INDEX ITEM DESCRIPTION":
        "Castings, unfinished iron (e.g., ductile, gray, malleable, semisteel), manufacturing",
    },
    {
      NAICS22: "331511",
      "INDEX ITEM DESCRIPTION": "Cooking utensils, cast iron, manufacturing",
    },
    {
      NAICS22: "331511",
      "INDEX ITEM DESCRIPTION":
        "Ductile iron castings, unfinished, manufacturing",
    },
    {
      NAICS22: "331511",
      "INDEX ITEM DESCRIPTION": "Ductile iron foundries",
    },
    {
      NAICS22: "331511",
      "INDEX ITEM DESCRIPTION":
        "Fittings, soil and pressure pipe, cast iron, manufacturing",
    },
    {
      NAICS22: "331511",
      "INDEX ITEM DESCRIPTION":
        "Foundries, iron (i.e., ductile, gray, malleable, semisteel)",
    },
    {
      NAICS22: "331511",
      "INDEX ITEM DESCRIPTION": "Gray iron foundries",
    },
    {
      NAICS22: "331511",
      "INDEX ITEM DESCRIPTION": "Industrial molds, steel ingot, manufacturing",
    },
    {
      NAICS22: "331511",
      "INDEX ITEM DESCRIPTION": "Iron castings, unfinished, manufacturing",
    },
    {
      NAICS22: "331511",
      "INDEX ITEM DESCRIPTION": "Iron foundries",
    },
    {
      NAICS22: "331511",
      "INDEX ITEM DESCRIPTION": "Malleable iron foundries",
    },
    {
      NAICS22: "331511",
      "INDEX ITEM DESCRIPTION": "Manhole covers, cast iron, manufacturing",
    },
    {
      NAICS22: "331511",
      "INDEX ITEM DESCRIPTION": "Molds for casting steel ingots manufacturing",
    },
    {
      NAICS22: "331511",
      "INDEX ITEM DESCRIPTION": "Molds, steel ingot, industrial, manufacturing",
    },
    {
      NAICS22: "331511",
      "INDEX ITEM DESCRIPTION":
        "Pearlitic castings, malleable iron, unfinished, manufacturing",
    },
    {
      NAICS22: "331511",
      "INDEX ITEM DESCRIPTION":
        "Pipe and pipe fittings, cast iron, manufacturing",
    },
    {
      NAICS22: "331511",
      "INDEX ITEM DESCRIPTION": "Pipe couplings, cast iron, manufacturing",
    },
    {
      NAICS22: "331511",
      "INDEX ITEM DESCRIPTION": "Rolling mill rolls, iron, manufacturing",
    },
    {
      NAICS22: "331511",
      "INDEX ITEM DESCRIPTION": "Semisteel foundries",
    },
    {
      NAICS22: "331511",
      "INDEX ITEM DESCRIPTION": "Sewer pipe, cast iron, manufacturing",
    },
    {
      NAICS22: "331511",
      "INDEX ITEM DESCRIPTION": "Soil pipe, cast iron, manufacturing",
    },
    {
      NAICS22: "331511",
      "INDEX ITEM DESCRIPTION": "Water pipe, cast iron, manufacturing",
    },
    {
      NAICS22: "331512",
      "INDEX ITEM DESCRIPTION": "Foundries, steel investment",
    },
    {
      NAICS22: "331512",
      "INDEX ITEM DESCRIPTION":
        "Investment castings, steel, unfinished, manufacturing",
    },
    {
      NAICS22: "331512",
      "INDEX ITEM DESCRIPTION":
        "Steel investment castings, unfinished, manufacturing",
    },
    {
      NAICS22: "331512",
      "INDEX ITEM DESCRIPTION": "Steel investment foundries",
    },
    {
      NAICS22: "331513",
      "INDEX ITEM DESCRIPTION":
        "Alloy steel castings (except investment), unfinished, manufacturing",
    },
    {
      NAICS22: "331513",
      "INDEX ITEM DESCRIPTION":
        "Cast steel railroad car wheels, unfinished, manufacturing",
    },
    {
      NAICS22: "331513",
      "INDEX ITEM DESCRIPTION":
        "Castings, steel (except investment), unfinished, manufacturing",
    },
    {
      NAICS22: "331513",
      "INDEX ITEM DESCRIPTION": "Foundries, steel (except investment)",
    },
    {
      NAICS22: "331513",
      "INDEX ITEM DESCRIPTION": "Rolling mill rolls, steel, manufacturing",
    },
    {
      NAICS22: "331513",
      "INDEX ITEM DESCRIPTION":
        "Stainless steel castings (except investment), unfinished, manufacturing",
    },
    {
      NAICS22: "331513",
      "INDEX ITEM DESCRIPTION":
        "Steel castings (except investment), unfinished, manufacturing",
    },
    {
      NAICS22: "331513",
      "INDEX ITEM DESCRIPTION": "Steel foundries (except investment)",
    },
    {
      NAICS22: "331523",
      "INDEX ITEM DESCRIPTION": "Aluminum die-casting foundries",
    },
    {
      NAICS22: "331523",
      "INDEX ITEM DESCRIPTION":
        "Aluminum die-castings, unfinished, manufacturing",
    },
    {
      NAICS22: "331523",
      "INDEX ITEM DESCRIPTION":
        "Beryllium die-castings, unfinished, manufacturing",
    },
    {
      NAICS22: "331523",
      "INDEX ITEM DESCRIPTION": "Brass die-castings, unfinished, manufacturing",
    },
    {
      NAICS22: "331523",
      "INDEX ITEM DESCRIPTION": "Bronze die-castings, unfinished, manufacturing",
    },
    {
      NAICS22: "331523",
      "INDEX ITEM DESCRIPTION": "Copper die-casting foundries",
    },
    {
      NAICS22: "331523",
      "INDEX ITEM DESCRIPTION": "Copper die-castings, unfinished, manufacturing",
    },
    {
      NAICS22: "331523",
      "INDEX ITEM DESCRIPTION":
        "Die-castings, aluminum, unfinished, manufacturing",
    },
    {
      NAICS22: "331523",
      "INDEX ITEM DESCRIPTION":
        "Die-castings, nonferrous metals, unfinished, manufacturing",
    },
    {
      NAICS22: "331523",
      "INDEX ITEM DESCRIPTION": "Foundries, die-casting, aluminum",
    },
    {
      NAICS22: "331523",
      "INDEX ITEM DESCRIPTION": "Foundries, die-casting, nonferrous metals ",
    },
    {
      NAICS22: "331523",
      "INDEX ITEM DESCRIPTION": "Lead die-castings, unfinished, manufacturing",
    },
    {
      NAICS22: "331523",
      "INDEX ITEM DESCRIPTION":
        "Magnesium die-castings, unfinished, manufacturing",
    },
    {
      NAICS22: "331523",
      "INDEX ITEM DESCRIPTION":
        "Nickel alloy die-castings, unfinished, manufacturing",
    },
    {
      NAICS22: "331523",
      "INDEX ITEM DESCRIPTION": "Nickel die-castings, unfinished, manufacturing",
    },
    {
      NAICS22: "331523",
      "INDEX ITEM DESCRIPTION": "Nonferrous die-casting foundries",
    },
    {
      NAICS22: "331523",
      "INDEX ITEM DESCRIPTION":
        "Titanium die-castings, unfinished, manufacturing",
    },
    {
      NAICS22: "331523",
      "INDEX ITEM DESCRIPTION": "Zinc die-castings, unfinished, manufacturing",
    },
    {
      NAICS22: "331524",
      "INDEX ITEM DESCRIPTION":
        "Aluminum castings (except die-castings), unfinished, manufacturing",
    },
    {
      NAICS22: "331524",
      "INDEX ITEM DESCRIPTION": "Aluminum foundries (except die-casting)",
    },
    {
      NAICS22: "331524",
      "INDEX ITEM DESCRIPTION":
        "Castings (except die-castings), unfinished, aluminum, manufacturing",
    },
    {
      NAICS22: "331524",
      "INDEX ITEM DESCRIPTION": "Foundries, aluminum (except die-casting)",
    },
    {
      NAICS22: "331524",
      "INDEX ITEM DESCRIPTION":
        "Investment castings, aluminum, unfinished, manufacturing",
    },
    {
      NAICS22: "331524",
      "INDEX ITEM DESCRIPTION":
        "Permanent mold castings, aluminum, unfinished, manufacturing",
    },
    {
      NAICS22: "331524",
      "INDEX ITEM DESCRIPTION":
        "Sand castings, aluminum, unfinished, manufacturing",
    },
    {
      NAICS22: "331529",
      "INDEX ITEM DESCRIPTION":
        "Beryllium castings (except die-castings), unfinished manufacturing",
    },
    {
      NAICS22: "331529",
      "INDEX ITEM DESCRIPTION": "Brass foundries (except die-casting)",
    },
    {
      NAICS22: "331529",
      "INDEX ITEM DESCRIPTION": "Bronze foundries (except die-casting)",
    },
    {
      NAICS22: "331529",
      "INDEX ITEM DESCRIPTION":
        "Castings (except die-castings), nonferrous metals (except aluminum), unfinished, manufacturing",
    },
    {
      NAICS22: "331529",
      "INDEX ITEM DESCRIPTION":
        "Copper alloy castings (except die-castings), unfinished, manufacturing",
    },
    {
      NAICS22: "331529",
      "INDEX ITEM DESCRIPTION": "Copper foundries (except die-casting)",
    },
    {
      NAICS22: "331529",
      "INDEX ITEM DESCRIPTION":
        "Foundries (except die-casting), nonferrous metals (except aluminum)",
    },
    {
      NAICS22: "331529",
      "INDEX ITEM DESCRIPTION":
        "Investment castings, nonferrous metal (except aluminum), unfinished, manufacturing",
    },
    {
      NAICS22: "331529",
      "INDEX ITEM DESCRIPTION":
        "Lead castings (except die-castings), unfinished, manufacturing",
    },
    {
      NAICS22: "331529",
      "INDEX ITEM DESCRIPTION":
        "Magnesium castings (except die-castings), unfinished, manufacturing",
    },
    {
      NAICS22: "331529",
      "INDEX ITEM DESCRIPTION":
        "Nickel castings (except die-castings), unfinished, manufacturing",
    },
    {
      NAICS22: "331529",
      "INDEX ITEM DESCRIPTION":
        "Nonferrous metals (except aluminum) foundries (except die-casting)",
    },
    {
      NAICS22: "331529",
      "INDEX ITEM DESCRIPTION":
        "Nonferrous metals (except aluminum) unfinished castings (except die-castings) manufacturing",
    },
    {
      NAICS22: "331529",
      "INDEX ITEM DESCRIPTION":
        "Permanent mold castings, nonferrous metal (except aluminum), unfinished, manufacturing",
    },
    {
      NAICS22: "331529",
      "INDEX ITEM DESCRIPTION":
        "Sand castings, nonferrous metals (except aluminum), unfinished, manufacturing",
    },
    {
      NAICS22: "331529",
      "INDEX ITEM DESCRIPTION":
        "Ship and boat propellers, cast brass, bronze and copper (except die-casting), unfinished, manufacturing",
    },
    {
      NAICS22: "331529",
      "INDEX ITEM DESCRIPTION":
        "Titanium castings (except die-castings), unfinished, manufacturing",
    },
    {
      NAICS22: "331529",
      "INDEX ITEM DESCRIPTION":
        "White metal castings (except die-castings), unfinished, manufacturing",
    },
    {
      NAICS22: "331529",
      "INDEX ITEM DESCRIPTION":
        "Zinc castings (except die-castings), unfinished, manufacturing",
    },
    {
      NAICS22: "332111",
      "INDEX ITEM DESCRIPTION":
        "Cold forgings made from purchased iron or steel, unfinished",
    },
    {
      NAICS22: "332111",
      "INDEX ITEM DESCRIPTION":
        "Drop forgings made from purchased iron or steel, unfinished",
    },
    {
      NAICS22: "332111",
      "INDEX ITEM DESCRIPTION":
        "Ferrous forgings made from purchased iron or steel, unfinished",
    },
    {
      NAICS22: "332111",
      "INDEX ITEM DESCRIPTION":
        "Forgings made from purchased iron or steel, unfinished",
    },
    {
      NAICS22: "332111",
      "INDEX ITEM DESCRIPTION":
        "Gun forgings made from purchased iron or steel, unfinished",
    },
    {
      NAICS22: "332111",
      "INDEX ITEM DESCRIPTION":
        "Hammer forgings made from purchased iron or steel, unfinished",
    },
    {
      NAICS22: "332111",
      "INDEX ITEM DESCRIPTION":
        "Horseshoes, ferrous forged, made from purchased iron or steel",
    },
    {
      NAICS22: "332111",
      "INDEX ITEM DESCRIPTION":
        "Hot forgings made from purchased iron or steel, unfinished",
    },
    {
      NAICS22: "332111",
      "INDEX ITEM DESCRIPTION":
        "Iron forgings made from purchased iron, unfinished",
    },
    {
      NAICS22: "332111",
      "INDEX ITEM DESCRIPTION":
        "Press forgings made from purchased iron or steel, unfinished",
    },
    {
      NAICS22: "332111",
      "INDEX ITEM DESCRIPTION":
        "Steel forgings made from purchased steel, unfinished",
    },
    {
      NAICS22: "332111",
      "INDEX ITEM DESCRIPTION":
        "Upset forgings made from purchased iron or steel, unfinished",
    },
    {
      NAICS22: "332112",
      "INDEX ITEM DESCRIPTION":
        "Aluminum forgings made from purchased metals, unfinished",
    },
    {
      NAICS22: "332112",
      "INDEX ITEM DESCRIPTION":
        "Cold forgings made from purchased nonferrous metals, unfinished",
    },
    {
      NAICS22: "332112",
      "INDEX ITEM DESCRIPTION":
        "Copper forgings made from purchased metals, unfinished",
    },
    {
      NAICS22: "332112",
      "INDEX ITEM DESCRIPTION":
        "Hammer forgings made from purchased nonferrous metals, unfinished",
    },
    {
      NAICS22: "332112",
      "INDEX ITEM DESCRIPTION":
        "Hot forgings made from purchased nonferrous metals, unfinished",
    },
    {
      NAICS22: "332112",
      "INDEX ITEM DESCRIPTION":
        "Press forgings made from purchased nonferrous metals, unfinished",
    },
    {
      NAICS22: "332112",
      "INDEX ITEM DESCRIPTION":
        "Titanium forgings made from purchased metals, unfinished",
    },
    {
      NAICS22: "332112",
      "INDEX ITEM DESCRIPTION":
        "Upset forgings made from purchased nonferrous metals, unfinished",
    },
    {
      NAICS22: "332114",
      "INDEX ITEM DESCRIPTION": "Custom roll forming metal products",
    },
    {
      NAICS22: "332114",
      "INDEX ITEM DESCRIPTION":
        "Gutters and down spouts sheet metal, custom roll formed, manufacturing",
    },
    {
      NAICS22: "332117",
      "INDEX ITEM DESCRIPTION":
        "Powder metallurgy products manufactured on a job or order basis",
    },
    {
      NAICS22: "332119",
      "INDEX ITEM DESCRIPTION": "Bottle caps and tops, metal, stamping",
    },
    {
      NAICS22: "332119",
      "INDEX ITEM DESCRIPTION": "Caps and tops, bottle, metal, stamping",
    },
    {
      NAICS22: "332119",
      "INDEX ITEM DESCRIPTION": "Closures, metal, stamping",
    },
    {
      NAICS22: "332119",
      "INDEX ITEM DESCRIPTION": "Crowns, metal (e.g., bottle, can), stamping",
    },
    {
      NAICS22: "332119",
      "INDEX ITEM DESCRIPTION": "Home canning lids and rings, metal stamping",
    },
    {
      NAICS22: "332119",
      "INDEX ITEM DESCRIPTION": "Lids, jar, metal, stamping",
    },
    {
      NAICS22: "332119",
      "INDEX ITEM DESCRIPTION":
        "Metal stampings (except automotive, cans, coins), unfinished, manufacturing",
    },
    {
      NAICS22: "332119",
      "INDEX ITEM DESCRIPTION": "Spinning unfinished metal products",
    },
    {
      NAICS22: "332119",
      "INDEX ITEM DESCRIPTION":
        "Stampings (except automotive, cans, coins), metal, unfinished, manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION": "Barber's scissors, manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION": "Blades, knife and razor, manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION": "Butcher's knives manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION": "Carving sets manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION": "Cleavers manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION": "Clippers, fingernail and toenail, manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION":
        "Cooking utensils, fabricated metal, manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION": "Cookware, fabricated metal, manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION":
        "Cutlery, nonprecious and precious plated metal, manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION": "Enameled metal cutting utensils",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION": "Fishing knives manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION":
        "Flatware, nonprecious and precious plated metal, manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION":
        "Forks, table, nonprecious and precious plated metal, manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION":
        "Hair clippers for human use, nonelectric, manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION": "Hunting knives manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION":
        "Kitchen cutlery, nonprecious and precious plated metal, manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION":
        "Kitchen utensils, fabricated metal (e.g., colanders, garlic presses, ice cream scoops, spatulas), manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION": "Knife blades manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION": "Knife blanks manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION":
        "Knives (e.g., hunting, pocket, table nonprecious, table precious plated) manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION": "Nonstick metal cooking utensils",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION": "Plated metal cutlery manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION": "Plated metal flatware manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION": "Pocket knives manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION": "Potato mashers manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION": "Pots and pans, fabricated metal, manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION": "Pressure cookers, household-type, manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION": "Razor blades manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION": "Razors (except electric) manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION": "Safety razor blades manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION": "Safety razors manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION": "Scissors, nonelectric, manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION":
        "Shears, nonelectric, household-type (e.g., kitchen, barber, tailor) manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION":
        "Spoons, table, nonprecious and precious plated metal, manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION": "Straight razors manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION":
        "Swords, nonprecious and precious plated metal, manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION":
        "Table cutlery, nonprecious and precious plated metal, manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION": "Tailors' scissors, nonelectric, manufacturing",
    },
    {
      NAICS22: "332215",
      "INDEX ITEM DESCRIPTION":
        "Teakettles and coffee pots, fabricated metal (except electric, glass), manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Agricultural handtools (e.g., hay forks, hoes, rakes, spades), nonpowered, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Augers, nonpowered, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Awls manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Axes manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Bearing pullers, handtools, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Bits, edge tool, woodworking, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Blades, saw, all types, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Blow torches manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Calipers and dividers, machinists' precision tools, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Can openers (except electric) manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Carpenter's handtools, nonelectric, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Caulking guns, nonpowered, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "C-clamps manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Chain saw blades manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Chisels manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Clippers for animal use, nonelectric, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Coordinate and contour measuring machines, machinists' precision tools, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Counterbores and countersinking bits, woodworking, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Cutters, glass, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Cutting dies (e.g., paper, leather, textile) manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Cutting dies (except metal cutting) manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Dial indicators, machinists' precision tools, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Dies, cutting (except metal cutting), manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Dies, steel rule (except metal cutting), manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Dividers, machinists' precision tools, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Drawknives manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Drill bits, woodworking, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Drills, handheld, nonelectric, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Edge tools, woodworking (e.g., augers, bits, countersinks), manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Engraver's handtools, nonpowered, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Files, handheld, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Fish wire (i.e., electrical wiring tool) manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Forks, handtools (e.g., garden, hay, manure), manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Gauge blocks, machinists' precision tools, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Gauges, machinists' precision tools (except optical), manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Gear pullers, handtools, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Gouges, woodworking, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Grass mowing equipment, nonpowered lawn and garden, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Guns, caulking, nonpowered, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Hair clippers for animal use, nonelectric, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Hammers, handtools, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Handheld edge tools (except scissors-type), nonelectric, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Handtool metal blades (e.g., putty knives, scrapers, screwdrivers) manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Handtools, machinists' precision, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Handtools, motor vehicle mechanics', manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Hatchets manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Hedge shears and trimmers, nonelectric, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Hoes, garden and mason's handtools, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Hooks, handtools (e.g., baling, bush, grass, husking), manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Jacks (except hydraulic, pneumatic) manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Jeweler's handtools, nonelectric, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Knives and bits for woodworking lathes, planers, and shapers manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Lawn edgers, nonpowered, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Lawnmowers, nonpowered, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Leaf skimmers and rakes, nonpowered swimming pool, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Levels, carpenter's, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Machetes manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Machine knives (except metal cutting) manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Machinists' precision measuring tools (except optical) manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Mallets (e.g., rubber, wood) manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Mason's handtools manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Mattocks (i.e., handtools) manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Mauls, metal, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Measuring tools, machinist's (except optical), manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Mechanic's handtools, nonpowered, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Metal cutting saw blades manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Micrometers, machinist's precision tools, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Miter boxes manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Picks (i.e., handtools) manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Planes, handheld, nonpowered, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Pliers, handtools, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Plumbers' handtools, nonpowered, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Post hole diggers, nonpowered, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Precision tools, machinist's (except optical), manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Pruners manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Pry (i.e., crow) bars manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Punches (except paper), nonpowered handtool, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Putty knives manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Rakes, nonpowered handtool, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Rasps, handheld, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Ratchets, nonpowered, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Rulers, metal, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Saw blades, all types, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Saws, hand, nonpowered, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Scoops, metal (except kitchen-type), manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Screwdrivers, nonelectric, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Screwjacks manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Scythes manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Shears, nonelectric, tool-type (e.g., garden, pruners, tinsnip), manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Shovels, handheld, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Sickles manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Sledgehammers manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Sockets and socket sets manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Soldering guns and irons, handheld (including electric), manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Soldering iron tips and tiplets manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Spades and shovels, handheld, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Squares, carpenters', metal, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Stone cutting saw blades manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Stonecutters' handtools, nonpowered, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Tape measures, metal, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Tinners' snips manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Tools, hand, metal blade (e.g., putty knives, scrapers, screwdrivers)",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Tools, handheld, nonpowered (except kitchen-type), manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Tools, woodworking edge (e.g., augers, bits, countersinks), manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Trimmers, hedge, nonelectric, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Trowels manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION":
        "Vises (except machine tool attachments) manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Wheel pullers, handtools, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Wood cutting saw blades manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Wrenches, handtools, nonpowered, manufacturing",
    },
    {
      NAICS22: "332216",
      "INDEX ITEM DESCRIPTION": "Yardsticks, metal, manufacturing",
    },
    {
      NAICS22: "332311",
      "INDEX ITEM DESCRIPTION": "Buildings, prefabricated metal, manufacturing",
    },
    {
      NAICS22: "332311",
      "INDEX ITEM DESCRIPTION": "Carports, prefabricated metal, manufacturing",
    },
    {
      NAICS22: "332311",
      "INDEX ITEM DESCRIPTION": "Dwellings, prefabricated metal, manufacturing",
    },
    {
      NAICS22: "332311",
      "INDEX ITEM DESCRIPTION":
        "Farm buildings, prefabricated metal, manufacturing",
    },
    {
      NAICS22: "332311",
      "INDEX ITEM DESCRIPTION": "Garages, prefabricated metal, manufacturing",
    },
    {
      NAICS22: "332311",
      "INDEX ITEM DESCRIPTION": "Greenhouses, prefabricated metal, manufacturing",
    },
    {
      NAICS22: "332311",
      "INDEX ITEM DESCRIPTION": "Houses, prefabricated metal, manufacturing",
    },
    {
      NAICS22: "332311",
      "INDEX ITEM DESCRIPTION":
        "Panels, prefabricated metal building, manufacturing",
    },
    {
      NAICS22: "332311",
      "INDEX ITEM DESCRIPTION":
        "Portable buildings, prefabricated metal, manufacturing",
    },
    {
      NAICS22: "332311",
      "INDEX ITEM DESCRIPTION": "Prefabricated buildings, metal, manufacturing",
    },
    {
      NAICS22: "332311",
      "INDEX ITEM DESCRIPTION": "Prefabricated homes, metal, manufacturing",
    },
    {
      NAICS22: "332311",
      "INDEX ITEM DESCRIPTION":
        "Sections for prefabricated metal buildings manufacturing",
    },
    {
      NAICS22: "332311",
      "INDEX ITEM DESCRIPTION":
        "Sheds (e.g., garden, storage, utility), prefabricated metal, manufacturing",
    },
    {
      NAICS22: "332311",
      "INDEX ITEM DESCRIPTION": "Silos, prefabricated metal, manufacturing",
    },
    {
      NAICS22: "332311",
      "INDEX ITEM DESCRIPTION":
        "Utility buildings, prefabricated metal, manufacturing",
    },
    {
      NAICS22: "332311",
      "INDEX ITEM DESCRIPTION": "Warehouses, prefabricated metal, manufacturing",
    },
    {
      NAICS22: "332312",
      "INDEX ITEM DESCRIPTION":
        "Barge sections, prefabricated metal, manufacturing",
    },
    {
      NAICS22: "332312",
      "INDEX ITEM DESCRIPTION": "Bars, concrete reinforcing, manufacturing",
    },
    {
      NAICS22: "332312",
      "INDEX ITEM DESCRIPTION":
        "Boat sections, prefabricated metal, manufacturing",
    },
    {
      NAICS22: "332312",
      "INDEX ITEM DESCRIPTION":
        "Bridge sections, prefabricated metal, manufacturing",
    },
    {
      NAICS22: "332312",
      "INDEX ITEM DESCRIPTION":
        "Concrete reinforcing bar (rebar) assemblies, fabrication",
    },
    {
      NAICS22: "332312",
      "INDEX ITEM DESCRIPTION": "Dam gates, metal plate, manufacturing",
    },
    {
      NAICS22: "332312",
      "INDEX ITEM DESCRIPTION": "Expansion joints, metal, manufacturing",
    },
    {
      NAICS22: "332312",
      "INDEX ITEM DESCRIPTION": "Fabricated bar joists manufacturing",
    },
    {
      NAICS22: "332312",
      "INDEX ITEM DESCRIPTION": "Fabricated structural metal manufacturing",
    },
    {
      NAICS22: "332312",
      "INDEX ITEM DESCRIPTION": "Flood gates, metal plate, manufacturing",
    },
    {
      NAICS22: "332312",
      "INDEX ITEM DESCRIPTION": "Floor jacks, metal, manufacturing",
    },
    {
      NAICS22: "332312",
      "INDEX ITEM DESCRIPTION": "Floor posts, adjustable metal, manufacturing",
    },
    {
      NAICS22: "332312",
      "INDEX ITEM DESCRIPTION":
        "Highway bridge sections, prefabricated metal, manufacturing",
    },
    {
      NAICS22: "332312",
      "INDEX ITEM DESCRIPTION": "Joists, fabricated bar, manufacturing",
    },
    {
      NAICS22: "332312",
      "INDEX ITEM DESCRIPTION": "Landing mats, aircraft, metal, manufacturing",
    },
    {
      NAICS22: "332312",
      "INDEX ITEM DESCRIPTION":
        "Radio and television tower sections, fabricated structural metal, manufacturing",
    },
    {
      NAICS22: "332312",
      "INDEX ITEM DESCRIPTION":
        "Railway bridge sections, prefabricated metal, manufacturing",
    },
    {
      NAICS22: "332312",
      "INDEX ITEM DESCRIPTION":
        "Ship sections, prefabricated metal, manufacturing",
    },
    {
      NAICS22: "332312",
      "INDEX ITEM DESCRIPTION": "Steel joists manufacturing",
    },
    {
      NAICS22: "332312",
      "INDEX ITEM DESCRIPTION": "Steel railroad car racks manufacturing",
    },
    {
      NAICS22: "332312",
      "INDEX ITEM DESCRIPTION": "Structural steel, fabricated, manufacturing",
    },
    {
      NAICS22: "332312",
      "INDEX ITEM DESCRIPTION":
        "Television tower sections, fabricated structural metal, manufacturing",
    },
    {
      NAICS22: "332312",
      "INDEX ITEM DESCRIPTION":
        "Transmission tower sections, fabricated structural metal, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION":
        "Airlocks, fabricated metal plate work, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION":
        "Baffles, fabricated metal plate work, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION":
        "Bins, fabricated metal plate work, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION":
        "Breechings, fabricated metal plate work, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION":
        "Buoys, fabricated plate work metal, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION":
        "Casings, scroll, fabricated metal plate work, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION":
        "Chutes, fabricated metal plate work, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION":
        "Covers, annealing, fabricated metal plate work, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION":
        "Covers, floating, fabricated metal plate work, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION":
        "Culverts, fabricated metal plate work, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION":
        "Cupolas, fabricated metal plate work, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION":
        "Cyclones, industrial, fabricated metal plate work, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION":
        "Ducting, fabricated metal plate work, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION": "Fabricated plate work manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION":
        "Floating covers, fabricated metal plate work, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION":
        "Flumes, fabricated metal plate work, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION":
        "Fumigating chambers, fabricated metal plate work, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION":
        "Hoods, industrial, fabricated metal plate work, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION":
        "Hoppers, fabricated metal plate work, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION":
        "Jackets, industrial, fabricated metal plate work, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION":
        "Ladle bails, fabricated metal plate work, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION":
        "Ladles, fabricated metal plate work, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION":
        "Liners, industrial, fabricated metal plate work, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION":
        "Nuclear shielding, fabricated metal plate work, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION":
        "Penstocks, fabricated metal plate, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION":
        "Pile shells, fabricated metal plate, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION": "Pipe, fabricated metal plate, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION":
        "Plate work (e.g., bending, cutting, punching, shaping, welding), fabricated metal, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION":
        "Racks (e.g., trash), fabricated metal plate, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION":
        "Reactor containment vessels, fabricated metal plate, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION":
        "Rocket casings, fabricated metal work, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION":
        "Smokestacks, fabricated metal boiler plate, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION":
        "Space simulation chambers, fabricated metal plate work, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION":
        "Sterilizing chambers, fabricated metal plate work, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION":
        "Trash racks, fabricated metal plate work, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION":
        "Troughs, industrial, fabricated metal plate work, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION": "Truss plates, metal, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION":
        "Tunnel lining, fabricated metal plate work, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION":
        "Tunnels, wind, fabricated metal plate work, manufacturing",
    },
    {
      NAICS22: "332313",
      "INDEX ITEM DESCRIPTION": "Weldments manufacturing",
    },
    {
      NAICS22: "332321",
      "INDEX ITEM DESCRIPTION": "Baseboards, metal, manufacturing",
    },
    {
      NAICS22: "332321",
      "INDEX ITEM DESCRIPTION": "Casements, metal, manufacturing",
    },
    {
      NAICS22: "332321",
      "INDEX ITEM DESCRIPTION": "Door and jamb assemblies, metal, manufacturing",
    },
    {
      NAICS22: "332321",
      "INDEX ITEM DESCRIPTION": "Door frames and sash, metal, manufacturing",
    },
    {
      NAICS22: "332321",
      "INDEX ITEM DESCRIPTION": "Doors, metal, manufacturing",
    },
    {
      NAICS22: "332321",
      "INDEX ITEM DESCRIPTION": "Fire doors, metal, manufacturing",
    },
    {
      NAICS22: "332321",
      "INDEX ITEM DESCRIPTION": "Frames, door and window, metal, manufacturing",
    },
    {
      NAICS22: "332321",
      "INDEX ITEM DESCRIPTION": "Garage doors, metal, manufacturing",
    },
    {
      NAICS22: "332321",
      "INDEX ITEM DESCRIPTION": "Hangar doors, metal, manufacturing",
    },
    {
      NAICS22: "332321",
      "INDEX ITEM DESCRIPTION": "Jalousies, metal, manufacturing",
    },
    {
      NAICS22: "332321",
      "INDEX ITEM DESCRIPTION": "Louver windows, metal, manufacturing",
    },
    {
      NAICS22: "332321",
      "INDEX ITEM DESCRIPTION":
        "Molding and trim (except motor vehicle), metal, manufacturing",
    },
    {
      NAICS22: "332321",
      "INDEX ITEM DESCRIPTION":
        "Rolling doors for industrial buildings and warehouses, metal, manufacturing",
    },
    {
      NAICS22: "332321",
      "INDEX ITEM DESCRIPTION": "Sash, door and window, metal, manufacturing",
    },
    {
      NAICS22: "332321",
      "INDEX ITEM DESCRIPTION": "Screen doors, metal frame, manufacturing",
    },
    {
      NAICS22: "332321",
      "INDEX ITEM DESCRIPTION":
        "Screens, door and window, metal frame, manufacturing",
    },
    {
      NAICS22: "332321",
      "INDEX ITEM DESCRIPTION": "Shutters, door and window, metal, manufacturing",
    },
    {
      NAICS22: "332321",
      "INDEX ITEM DESCRIPTION": "Skylights, metal, manufacturing",
    },
    {
      NAICS22: "332321",
      "INDEX ITEM DESCRIPTION": "Storm doors and windows, metal, manufacturing",
    },
    {
      NAICS22: "332321",
      "INDEX ITEM DESCRIPTION":
        "Trim and molding (except motor vehicle), metal, manufacturing",
    },
    {
      NAICS22: "332321",
      "INDEX ITEM DESCRIPTION": "Trim, metal, manufacturing",
    },
    {
      NAICS22: "332321",
      "INDEX ITEM DESCRIPTION": "Weatherstrip, metal, manufacturing",
    },
    {
      NAICS22: "332321",
      "INDEX ITEM DESCRIPTION": "Window frames and sash, metal, manufacturing",
    },
    {
      NAICS22: "332321",
      "INDEX ITEM DESCRIPTION": "Window screens, metal frame, manufacturing",
    },
    {
      NAICS22: "332321",
      "INDEX ITEM DESCRIPTION": "Windows, metal, manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Air cowls, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Awnings, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Canopies, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Casings, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Coal chutes, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Concrete forms, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Cornices, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Cowls, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Culverts, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Dampers, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Door hoods, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Downspouts, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION": "Ducts, sheet metal, manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Eaves, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Elbows for conductor pipe, hot air ducts, and stovepipe, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Flooring, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Flues, stove and furnace, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Flumes, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Forms, concrete, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Furnace casings, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Furnace flues, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Guardrails, highway, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Gutters, sheet metal (except custom roll formed), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Hampers, laundry, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Highway guardrails, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Hoods, range (except household-type), sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Irrigation pipe, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Joists, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Louvers, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Machine guards, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Mail chutes, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Pile shells, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Pipe, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Radiator shields and enclosures, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Roof deck, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Roof ventilators, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Roofing, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Sheet metal work (except stampings) manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Siding, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Spouts, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Stove boards, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Stove pipes and flues, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Studs, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Troughs, elevator, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332322",
      "INDEX ITEM DESCRIPTION":
        "Wells, light, sheet metal (except stampings), manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION":
        "Acoustical suspension systems, metal, manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION": "Architectural metalwork manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION": "Balcony railings, metal, manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION": "Bank fixtures, ornamental metal, manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION": "Bannisters, metal, manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION": "Barn stanchions and standards manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION": "Brasswork, ornamental, manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION": "Chain ladders, metal, manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION": "Channels, furring metal, manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION": "Corrals, metal, manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION": "Curtain wall, metal, manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION": "Elevator guide rails, metal, manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION":
        "Fences and gates (except wire), metal, manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION": "Fire escapes, metal, manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION": "Flagpoles, metal, manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION":
        "Flooring, open steel (i.e., grating), manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION": "Furring channels, sheet metal, manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION": "Gates, holding, sheet metal, manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION": "Gates, metal (except wire), manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION":
        "Gratings (i.e., open steel flooring) manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION":
        "Grills and grillwork, sheet metal, manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION": "Grillwork, ornamental metal, manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION":
        "Guards, bannisters, and railings, sheet metal, manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION": "Ladders, metal chain, manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION":
        "Ladders, permanently installed, metal, manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION": "Lath, expanded metal, manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION": "Ornamental metalwork manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION": "Partitions, ornamental metal, manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION": "Pipe bannisters, metal, manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION": "Pipe guards, metal, manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION": "Pipe railings, metal, manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION": "Purlins, metal, manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION": "Railings, metal, manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION": "Registers, metal air, manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION": "Scaffolds, metal, manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION": "Stair railings, metal, manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION": "Stair treads, metal, manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION": "Staircases, metal, manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION": "Stairs, metal, manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION": "Stalls, metal, manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION": "Treads, metal stair, manufacturing",
    },
    {
      NAICS22: "332323",
      "INDEX ITEM DESCRIPTION": "Wrought iron fences manufacturing",
    },
    {
      NAICS22: "332410",
      "INDEX ITEM DESCRIPTION":
        "Aftercoolers (i.e., heat exchangers) manufacturing",
    },
    {
      NAICS22: "332410",
      "INDEX ITEM DESCRIPTION": "Barometric condensers manufacturing",
    },
    {
      NAICS22: "332410",
      "INDEX ITEM DESCRIPTION": "Boiler casings manufacturing",
    },
    {
      NAICS22: "332410",
      "INDEX ITEM DESCRIPTION": "Boilers, power, manufacturing",
    },
    {
      NAICS22: "332410",
      "INDEX ITEM DESCRIPTION": "Condenser boxes, metal, manufacturing",
    },
    {
      NAICS22: "332410",
      "INDEX ITEM DESCRIPTION": "Condensers, steam, manufacturing",
    },
    {
      NAICS22: "332410",
      "INDEX ITEM DESCRIPTION":
        "Economizers (i.e., power boiler accessory) manufacturing",
    },
    {
      NAICS22: "332410",
      "INDEX ITEM DESCRIPTION": "Exchangers, heat, manufacturing",
    },
    {
      NAICS22: "332410",
      "INDEX ITEM DESCRIPTION": "Heat exchangers manufacturing",
    },
    {
      NAICS22: "332410",
      "INDEX ITEM DESCRIPTION": "Intercooler shells manufacturing",
    },
    {
      NAICS22: "332410",
      "INDEX ITEM DESCRIPTION": "Marine power boilers manufacturing",
    },
    {
      NAICS22: "332410",
      "INDEX ITEM DESCRIPTION": "Nuclear control drive mechanisms manufacturing",
    },
    {
      NAICS22: "332410",
      "INDEX ITEM DESCRIPTION":
        "Nuclear reactor steam supply systems manufacturing",
    },
    {
      NAICS22: "332410",
      "INDEX ITEM DESCRIPTION":
        "Nuclear reactors control rod drive mechanisms manufacturing",
    },
    {
      NAICS22: "332410",
      "INDEX ITEM DESCRIPTION": "Nuclear reactors manufacturing",
    },
    {
      NAICS22: "332410",
      "INDEX ITEM DESCRIPTION": "Power boilers manufacturing",
    },
    {
      NAICS22: "332410",
      "INDEX ITEM DESCRIPTION": "Reactors, nuclear, manufacturing",
    },
    {
      NAICS22: "332410",
      "INDEX ITEM DESCRIPTION": "Stationary power boilers manufacturing",
    },
    {
      NAICS22: "332410",
      "INDEX ITEM DESCRIPTION": "Steam condensers manufacturing",
    },
    {
      NAICS22: "332420",
      "INDEX ITEM DESCRIPTION":
        "Absorbers, gas, heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332420",
      "INDEX ITEM DESCRIPTION":
        "Accumulators, industrial pressure vessels, heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332420",
      "INDEX ITEM DESCRIPTION":
        "Acetylene cylinders, heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332420",
      "INDEX ITEM DESCRIPTION":
        "Air receiver tanks, heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332420",
      "INDEX ITEM DESCRIPTION":
        "Annealing vats, heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332420",
      "INDEX ITEM DESCRIPTION":
        "Autoclaves, industrial-type, heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332420",
      "INDEX ITEM DESCRIPTION":
        "Bulk storage tanks, heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332420",
      "INDEX ITEM DESCRIPTION":
        "Caissons, underwater work, heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332420",
      "INDEX ITEM DESCRIPTION":
        "Columns, fractionating, heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332420",
      "INDEX ITEM DESCRIPTION":
        "Cryogenic tanks, heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332420",
      "INDEX ITEM DESCRIPTION":
        "Cylinders, pressure, heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332420",
      "INDEX ITEM DESCRIPTION":
        "Digesters, industrial-type, heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332420",
      "INDEX ITEM DESCRIPTION":
        "Farm storage tanks, heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332420",
      "INDEX ITEM DESCRIPTION":
        "Fermentation tanks, heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332420",
      "INDEX ITEM DESCRIPTION":
        "Gas storage tanks, heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332420",
      "INDEX ITEM DESCRIPTION": "Kettles, heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332420",
      "INDEX ITEM DESCRIPTION":
        "Liquefied petroleum gas (LPG) cylinders manufacturing",
    },
    {
      NAICS22: "332420",
      "INDEX ITEM DESCRIPTION": "Liquid oxygen tanks manufacturing",
    },
    {
      NAICS22: "332420",
      "INDEX ITEM DESCRIPTION":
        "Nuclear waste casks, heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332420",
      "INDEX ITEM DESCRIPTION":
        "Oil storage tanks, heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332420",
      "INDEX ITEM DESCRIPTION":
        "Petroleum storage tanks, heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332420",
      "INDEX ITEM DESCRIPTION":
        "Pots (e.g., annealing, melting, smelting), heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332420",
      "INDEX ITEM DESCRIPTION": "Retorts, heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332420",
      "INDEX ITEM DESCRIPTION": "Septic tanks, heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332420",
      "INDEX ITEM DESCRIPTION": "Smelting pots and retorts manufacturing",
    },
    {
      NAICS22: "332420",
      "INDEX ITEM DESCRIPTION": "Stills, heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332420",
      "INDEX ITEM DESCRIPTION": "Storage tanks, heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332420",
      "INDEX ITEM DESCRIPTION": "Tanks, heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332420",
      "INDEX ITEM DESCRIPTION": "Vacuum tanks, heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332420",
      "INDEX ITEM DESCRIPTION": "Vats, heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332420",
      "INDEX ITEM DESCRIPTION": "Vessels, heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332420",
      "INDEX ITEM DESCRIPTION": "Water tanks, heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332431",
      "INDEX ITEM DESCRIPTION": "Aerosol cans, light gauge metal, manufacturing",
    },
    {
      NAICS22: "332431",
      "INDEX ITEM DESCRIPTION": "Aluminum cans, light gauge metal, manufacturing",
    },
    {
      NAICS22: "332431",
      "INDEX ITEM DESCRIPTION": "Beer cans, light gauge metal, manufacturing",
    },
    {
      NAICS22: "332431",
      "INDEX ITEM DESCRIPTION":
        "Can lids and ends, light gauge metal, manufacturing",
    },
    {
      NAICS22: "332431",
      "INDEX ITEM DESCRIPTION":
        "Cans, aluminum, light gauge metal, manufacturing",
    },
    {
      NAICS22: "332431",
      "INDEX ITEM DESCRIPTION": "Cans, light gauge metal, manufacturing",
    },
    {
      NAICS22: "332431",
      "INDEX ITEM DESCRIPTION": "Cans, steel, light gauge metal, manufacturing",
    },
    {
      NAICS22: "332431",
      "INDEX ITEM DESCRIPTION":
        "Lids and ends, can, light gauge metal, manufacturing",
    },
    {
      NAICS22: "332431",
      "INDEX ITEM DESCRIPTION": "Metal cans, light gauge metal, manufacturing",
    },
    {
      NAICS22: "332431",
      "INDEX ITEM DESCRIPTION": "Soft drink cans manufacturing",
    },
    {
      NAICS22: "332431",
      "INDEX ITEM DESCRIPTION": "Soup cans, light gauge metal, manufacturing",
    },
    {
      NAICS22: "332431",
      "INDEX ITEM DESCRIPTION": "Steel cans, light gauge metal, manufacturing",
    },
    {
      NAICS22: "332431",
      "INDEX ITEM DESCRIPTION":
        "Tin plate cans, light gauge metal, manufacturing",
    },
    {
      NAICS22: "332439",
      "INDEX ITEM DESCRIPTION":
        "Air cargo containers, light gauge metal, manufacturing",
    },
    {
      NAICS22: "332439",
      "INDEX ITEM DESCRIPTION":
        "Ammunition boxes, light gauge metal, manufacturing",
    },
    {
      NAICS22: "332439",
      "INDEX ITEM DESCRIPTION": "Barrels, light gauge metal, manufacturing",
    },
    {
      NAICS22: "332439",
      "INDEX ITEM DESCRIPTION": "Beer kegs, light gauge metal, manufacturing",
    },
    {
      NAICS22: "332439",
      "INDEX ITEM DESCRIPTION": "Bins, light gauge metal, manufacturing",
    },
    {
      NAICS22: "332439",
      "INDEX ITEM DESCRIPTION":
        "Bottles, vacuum, light gauge metal, manufacturing",
    },
    {
      NAICS22: "332439",
      "INDEX ITEM DESCRIPTION": "Boxes, light gauge metal, manufacturing",
    },
    {
      NAICS22: "332439",
      "INDEX ITEM DESCRIPTION": "Cash boxes, light gauge metal, manufacturing",
    },
    {
      NAICS22: "332439",
      "INDEX ITEM DESCRIPTION":
        "Collapsible tubes (e.g., toothpaste, glue), light gauge metal, manufacturing",
    },
    {
      NAICS22: "332439",
      "INDEX ITEM DESCRIPTION":
        "Containers, air cargo, light gauge metal, manufacturing",
    },
    {
      NAICS22: "332439",
      "INDEX ITEM DESCRIPTION":
        "Containers, light gauge metal (except cans), manufacturing",
    },
    {
      NAICS22: "332439",
      "INDEX ITEM DESCRIPTION": "Drums, light gauge metal, manufacturing",
    },
    {
      NAICS22: "332439",
      "INDEX ITEM DESCRIPTION":
        "Fluid milk shipping containers, light gauge metal, manufacturing",
    },
    {
      NAICS22: "332439",
      "INDEX ITEM DESCRIPTION": "Garbage cans, light gauge metal, manufacturing",
    },
    {
      NAICS22: "332439",
      "INDEX ITEM DESCRIPTION": "Hoppers, light gauge metal, manufacturing",
    },
    {
      NAICS22: "332439",
      "INDEX ITEM DESCRIPTION":
        "Ice chests or coolers, light gauge metal, manufacturing",
    },
    {
      NAICS22: "332439",
      "INDEX ITEM DESCRIPTION": "Jugs, vacuum, light gauge metal, manufacturing",
    },
    {
      NAICS22: "332439",
      "INDEX ITEM DESCRIPTION":
        "Laundry hampers, light gauge metal, manufacturing",
    },
    {
      NAICS22: "332439",
      "INDEX ITEM DESCRIPTION": "Lunch boxes, light gauge metal, manufacturing",
    },
    {
      NAICS22: "332439",
      "INDEX ITEM DESCRIPTION": "Mailboxes, light gauge metal, manufacturing",
    },
    {
      NAICS22: "332439",
      "INDEX ITEM DESCRIPTION":
        "Shipping barrels, drums, kegs, and pails, light gauge metal, manufacturing",
    },
    {
      NAICS22: "332439",
      "INDEX ITEM DESCRIPTION": "Tool boxes, light gauge metal, manufacturing",
    },
    {
      NAICS22: "332439",
      "INDEX ITEM DESCRIPTION":
        "Vacuum bottles and jugs, light gauge metal, manufacturing",
    },
    {
      NAICS22: "332439",
      "INDEX ITEM DESCRIPTION": "Vats, light gauge metal, manufacturing",
    },
    {
      NAICS22: "332510",
      "INDEX ITEM DESCRIPTION": "Aircraft hardware, metal, manufacturing",
    },
    {
      NAICS22: "332510",
      "INDEX ITEM DESCRIPTION": "Appliance hardware, metal, manufacturing",
    },
    {
      NAICS22: "332510",
      "INDEX ITEM DESCRIPTION": "Automobile hardware, metal, manufacturing",
    },
    {
      NAICS22: "332510",
      "INDEX ITEM DESCRIPTION":
        "Brackets (i.e., builder's hardware-type), metal, manufacturing",
    },
    {
      NAICS22: "332510",
      "INDEX ITEM DESCRIPTION": "Builder's hardware, metal, manufacturing",
    },
    {
      NAICS22: "332510",
      "INDEX ITEM DESCRIPTION": "Cabinet hardware, metal, manufacturing",
    },
    {
      NAICS22: "332510",
      "INDEX ITEM DESCRIPTION": "Casket hardware, metal, manufacturing",
    },
    {
      NAICS22: "332510",
      "INDEX ITEM DESCRIPTION": "Casters, furniture, metal manufacturing",
    },
    {
      NAICS22: "332510",
      "INDEX ITEM DESCRIPTION": "Casters, industrial, metal, manufacturing",
    },
    {
      NAICS22: "332510",
      "INDEX ITEM DESCRIPTION": "Dead bolts, metal, manufacturing",
    },
    {
      NAICS22: "332510",
      "INDEX ITEM DESCRIPTION": "Door locks, metal, manufacturing",
    },
    {
      NAICS22: "332510",
      "INDEX ITEM DESCRIPTION":
        "Door opening and closing devices (except electrical), metal, manufacturing",
    },
    {
      NAICS22: "332510",
      "INDEX ITEM DESCRIPTION": "Furniture hardware, metal, manufacturing",
    },
    {
      NAICS22: "332510",
      "INDEX ITEM DESCRIPTION": "Gun trigger locks, metal, manufacturing",
    },
    {
      NAICS22: "332510",
      "INDEX ITEM DESCRIPTION": "Hinges, metal, manufacturing",
    },
    {
      NAICS22: "332510",
      "INDEX ITEM DESCRIPTION": "Key blanks, metal, manufacturing",
    },
    {
      NAICS22: "332510",
      "INDEX ITEM DESCRIPTION":
        "Locks (except coin- or card-operated, time locks), metal, manufacturing",
    },
    {
      NAICS22: "332510",
      "INDEX ITEM DESCRIPTION": "Luggage hardware, metal, manufacturing",
    },
    {
      NAICS22: "332510",
      "INDEX ITEM DESCRIPTION": "Marine hardware, metal, manufacturing",
    },
    {
      NAICS22: "332510",
      "INDEX ITEM DESCRIPTION": "Motor vehicle hardware, metal, manufacturing",
    },
    {
      NAICS22: "332510",
      "INDEX ITEM DESCRIPTION": "Padlocks, metal, manufacturing",
    },
    {
      NAICS22: "332510",
      "INDEX ITEM DESCRIPTION": "Piano hardware, metal, manufacturing",
    },
    {
      NAICS22: "332510",
      "INDEX ITEM DESCRIPTION": "Suitcase hardware, metal, manufacturing",
    },
    {
      NAICS22: "332613",
      "INDEX ITEM DESCRIPTION":
        "Automobile suspension springs, heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332613",
      "INDEX ITEM DESCRIPTION":
        "Coiled springs (except clock, watch), light gauge, made from purchased wire or strip, manufacturing",
    },
    {
      NAICS22: "332613",
      "INDEX ITEM DESCRIPTION":
        "Coiled springs, heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332613",
      "INDEX ITEM DESCRIPTION":
        "Disk and ring springs, heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332613",
      "INDEX ITEM DESCRIPTION":
        "Flat springs (except clock, watch), light gauge, made from purchased wire or strip, manufacturing",
    },
    {
      NAICS22: "332613",
      "INDEX ITEM DESCRIPTION": "Flat springs, heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332613",
      "INDEX ITEM DESCRIPTION":
        "Furniture springs, light gauge, unassembled, made from purchased wire or strip",
    },
    {
      NAICS22: "332613",
      "INDEX ITEM DESCRIPTION":
        "Gun springs, light gauge, made from purchased wire or strip, manufacturing",
    },
    {
      NAICS22: "332613",
      "INDEX ITEM DESCRIPTION":
        "Hairsprings (except clock, watch), light gauge, made from purchased wire or strip, manufacturing",
    },
    {
      NAICS22: "332613",
      "INDEX ITEM DESCRIPTION":
        "Helical springs, hot wound heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332613",
      "INDEX ITEM DESCRIPTION":
        "Helical springs, light gauge, made from purchased wire or strip, manufacturing",
    },
    {
      NAICS22: "332613",
      "INDEX ITEM DESCRIPTION":
        "Instrument springs, precision (except clock, watch), light gauge, made from purchased wire or strip, manufacturing",
    },
    {
      NAICS22: "332613",
      "INDEX ITEM DESCRIPTION": "Leaf springs, heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332613",
      "INDEX ITEM DESCRIPTION":
        "Mattress springs and spring units, light gauge, made from purchased wire or strip",
    },
    {
      NAICS22: "332613",
      "INDEX ITEM DESCRIPTION":
        "Sash balance springs, light gauge, made from purchased wire or strip",
    },
    {
      NAICS22: "332613",
      "INDEX ITEM DESCRIPTION":
        "Springs and spring units for seats, light gauge, made from purchased wire or strip",
    },
    {
      NAICS22: "332613",
      "INDEX ITEM DESCRIPTION": "Springs, heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332613",
      "INDEX ITEM DESCRIPTION":
        "Springs, light gauge (except clock, watch), made from purchased wire or strip",
    },
    {
      NAICS22: "332613",
      "INDEX ITEM DESCRIPTION":
        "Springs, precision (except clock, watch), light gauge, made from purchased wire or strip",
    },
    {
      NAICS22: "332613",
      "INDEX ITEM DESCRIPTION": "Torsion bar, heavy gauge metal, manufacturing",
    },
    {
      NAICS22: "332613",
      "INDEX ITEM DESCRIPTION":
        "Upholstery springs and spring units, light gauge, made from purchased wire or strip",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Automobile skid chains made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Bale ties made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Barbed wire made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Baskets, metal, made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Belts, conveyor, made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Belts, drying, made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Brackets made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Brads, metal, made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION":
        "Cable, noninsulated wire, made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Cages made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Can keys made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION":
        "Chain link fencing and fence gates made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Chain made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Chain, welded, made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Chicken netting made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Cloth, woven wire, made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Coat hangers made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION":
        "Concrete reinforcing mesh made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Crab traps made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Cylinder wire cloth made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Delivery cases made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Diamond cloths made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Fabrics, woven wire, made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION":
        "Fencing and fence gates made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Fourdrinier wire cloth made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Grilles and grillwork made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Guards, wire, made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION":
        "Hardware cloth, woven wire, made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Insect screening made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Key rings made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Lamp frames, wire, made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Mats and matting made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Mesh made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION":
        "Nails, brads, and staples made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Netting, woven, made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Paper clips made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION":
        "Paper machine wire cloth made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Poultry netting made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Racks, household-type, made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION":
        "Reinforcing mesh, concrete, made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Rope, wire, made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Shelving, wire, made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Sieves, made from purchased wire, manufacturing",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Slings, lifting, made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Spikes made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Spiral cloth made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Staples made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION":
        "Stranded wire, uninsulated, made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Tacks, metal, made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Tire chains made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION":
        "Traps, animal and fish, made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION": "Trays, wire, made from purchased wire",
    },
    {
      NAICS22: "332618",
      "INDEX ITEM DESCRIPTION":
        "Window screening, woven, made from purchased wire",
    },
    {
      NAICS22: "332710",
      "INDEX ITEM DESCRIPTION": "Automotive machine shops",
    },
    {
      NAICS22: "332710",
      "INDEX ITEM DESCRIPTION": "Chemical milling job shops",
    },
    {
      NAICS22: "332710",
      "INDEX ITEM DESCRIPTION": "Machine shops",
    },
    {
      NAICS22: "332721",
      "INDEX ITEM DESCRIPTION": "Precision turned product manufacturing",
    },
    {
      NAICS22: "332722",
      "INDEX ITEM DESCRIPTION": "Bolts, metal, manufacturing",
    },
    {
      NAICS22: "332722",
      "INDEX ITEM DESCRIPTION": "Cotter pins, metal, manufacturing",
    },
    {
      NAICS22: "332722",
      "INDEX ITEM DESCRIPTION": "Dowel pins, metal, manufacturing",
    },
    {
      NAICS22: "332722",
      "INDEX ITEM DESCRIPTION": "Hook and eye latches, metal, manufacturing",
    },
    {
      NAICS22: "332722",
      "INDEX ITEM DESCRIPTION":
        "Hooks (i.e., general purpose fasteners), metal, manufacturing",
    },
    {
      NAICS22: "332722",
      "INDEX ITEM DESCRIPTION": "Hooks, metal screw, manufacturing",
    },
    {
      NAICS22: "332722",
      "INDEX ITEM DESCRIPTION": "Hose clamps, metal, manufacturing",
    },
    {
      NAICS22: "332722",
      "INDEX ITEM DESCRIPTION": "Lock washers, metal, manufacturing",
    },
    {
      NAICS22: "332722",
      "INDEX ITEM DESCRIPTION": "Machine keys, metal, manufacturing",
    },
    {
      NAICS22: "332722",
      "INDEX ITEM DESCRIPTION": "Nuts, metal, manufacturing",
    },
    {
      NAICS22: "332722",
      "INDEX ITEM DESCRIPTION": "Rivets, metal, manufacturing",
    },
    {
      NAICS22: "332722",
      "INDEX ITEM DESCRIPTION": "Screw eyes, metal, manufacturing",
    },
    {
      NAICS22: "332722",
      "INDEX ITEM DESCRIPTION": "Screws, metal, manufacturing",
    },
    {
      NAICS22: "332722",
      "INDEX ITEM DESCRIPTION": "Spring pins, metal, manufacturing",
    },
    {
      NAICS22: "332722",
      "INDEX ITEM DESCRIPTION": "Spring washers, metal, manufacturing",
    },
    {
      NAICS22: "332722",
      "INDEX ITEM DESCRIPTION": "Toggle bolts, metal, manufacturing",
    },
    {
      NAICS22: "332722",
      "INDEX ITEM DESCRIPTION": "Turnbuckles, metal, manufacturing",
    },
    {
      NAICS22: "332722",
      "INDEX ITEM DESCRIPTION": "Washers, metal, manufacturing",
    },
    {
      NAICS22: "332811",
      "INDEX ITEM DESCRIPTION":
        "Annealing metals and metal products for the trade",
    },
    {
      NAICS22: "332811",
      "INDEX ITEM DESCRIPTION":
        "Brazing (i.e., hardening) metals and metal products for the trade",
    },
    {
      NAICS22: "332811",
      "INDEX ITEM DESCRIPTION": "Burning metals and metal products for the trade",
    },
    {
      NAICS22: "332811",
      "INDEX ITEM DESCRIPTION": "Cold treating metals for the trade",
    },
    {
      NAICS22: "332811",
      "INDEX ITEM DESCRIPTION": "Cryogenic treating metals for the trade",
    },
    {
      NAICS22: "332811",
      "INDEX ITEM DESCRIPTION":
        "Hardening (i.e., heat treating) metals and metal products for the trade",
    },
    {
      NAICS22: "332811",
      "INDEX ITEM DESCRIPTION":
        "Heat treating metals and metal products for the trade",
    },
    {
      NAICS22: "332811",
      "INDEX ITEM DESCRIPTION":
        "Shot peening metal and metal products for the trade",
    },
    {
      NAICS22: "332811",
      "INDEX ITEM DESCRIPTION":
        "Tempering metals and metal products for the trade",
    },
    {
      NAICS22: "332812",
      "INDEX ITEM DESCRIPTION":
        "Aluminum coating of metal products for the trade",
    },
    {
      NAICS22: "332812",
      "INDEX ITEM DESCRIPTION":
        "Bonderizing metal and metal products for the trade",
    },
    {
      NAICS22: "332812",
      "INDEX ITEM DESCRIPTION":
        "Chasing metals and metal products (except printing plates) for the trade",
    },
    {
      NAICS22: "332812",
      "INDEX ITEM DESCRIPTION": "Coating metals and metal products for the trade",
    },
    {
      NAICS22: "332812",
      "INDEX ITEM DESCRIPTION":
        "Coating of metal and metal products with plastics for the trade",
    },
    {
      NAICS22: "332812",
      "INDEX ITEM DESCRIPTION":
        "Enameling metals and metal products for the trade",
    },
    {
      NAICS22: "332812",
      "INDEX ITEM DESCRIPTION":
        "Engraving metals and metal products (except printing plates) for the trade",
    },
    {
      NAICS22: "332812",
      "INDEX ITEM DESCRIPTION":
        "Etching metals and metal products (except printing plates) for the trade",
    },
    {
      NAICS22: "332812",
      "INDEX ITEM DESCRIPTION":
        "Flocking metals and metal products for the trade",
    },
    {
      NAICS22: "332812",
      "INDEX ITEM DESCRIPTION":
        "Galvanizing metals and metal products for the trade",
    },
    {
      NAICS22: "332812",
      "INDEX ITEM DESCRIPTION": "Glazing metals and metal products for the trade",
    },
    {
      NAICS22: "332812",
      "INDEX ITEM DESCRIPTION":
        "Hot dip galvanizing metals and metal products for the trade",
    },
    {
      NAICS22: "332812",
      "INDEX ITEM DESCRIPTION":
        "Japanning metals and metal products for the trade",
    },
    {
      NAICS22: "332812",
      "INDEX ITEM DESCRIPTION":
        "Lacquering metals and metal products for the trade",
    },
    {
      NAICS22: "332812",
      "INDEX ITEM DESCRIPTION":
        "Painting metals and metal products for the trade",
    },
    {
      NAICS22: "332812",
      "INDEX ITEM DESCRIPTION":
        "Parkerizing metals and metal products for the trade",
    },
    {
      NAICS22: "332812",
      "INDEX ITEM DESCRIPTION":
        "Powder coating metals and metal products for the trade",
    },
    {
      NAICS22: "332812",
      "INDEX ITEM DESCRIPTION":
        "Rustproofing metals and metal products for the trade",
    },
    {
      NAICS22: "332812",
      "INDEX ITEM DESCRIPTION":
        "Sherardizing of metals and metal products for the trade",
    },
    {
      NAICS22: "332812",
      "INDEX ITEM DESCRIPTION":
        "Varnishing metals and metal products for the trade",
    },
    {
      NAICS22: "332813",
      "INDEX ITEM DESCRIPTION":
        "Anodizing metals and metal products for the trade",
    },
    {
      NAICS22: "332813",
      "INDEX ITEM DESCRIPTION": "Buffing metals and metal products for the trade",
    },
    {
      NAICS22: "332813",
      "INDEX ITEM DESCRIPTION":
        "Chrome plating metals and metal products for the trade",
    },
    {
      NAICS22: "332813",
      "INDEX ITEM DESCRIPTION":
        "Cleaning and descaling metals and metal products for the trade",
    },
    {
      NAICS22: "332813",
      "INDEX ITEM DESCRIPTION":
        "Coloring metals and metal products (except coating) for the trade",
    },
    {
      NAICS22: "332813",
      "INDEX ITEM DESCRIPTION":
        "Depolishing metals and metal products for the trade",
    },
    {
      NAICS22: "332813",
      "INDEX ITEM DESCRIPTION":
        "Electroplating metals and formed products for the trade",
    },
    {
      NAICS22: "332813",
      "INDEX ITEM DESCRIPTION":
        "Gold and silver plating metals and metal products for the trade",
    },
    {
      NAICS22: "332813",
      "INDEX ITEM DESCRIPTION":
        "Laminating metals and metal formed products without fabricating",
    },
    {
      NAICS22: "332813",
      "INDEX ITEM DESCRIPTION":
        "Pickling metals and metal products for the trade",
    },
    {
      NAICS22: "332813",
      "INDEX ITEM DESCRIPTION":
        "Plastic, glass, or other media blasting services",
    },
    {
      NAICS22: "332813",
      "INDEX ITEM DESCRIPTION": "Plating metals and metal products for the trade",
    },
    {
      NAICS22: "332813",
      "INDEX ITEM DESCRIPTION":
        "Polishing metals and metal products for the trade",
    },
    {
      NAICS22: "332813",
      "INDEX ITEM DESCRIPTION":
        "Sandblasting metals and metal products for the trade",
    },
    {
      NAICS22: "332813",
      "INDEX ITEM DESCRIPTION":
        "Tumbling (i.e., cleaning and polishing) metal and metal products for the trade",
    },
    {
      NAICS22: "332911",
      "INDEX ITEM DESCRIPTION": "Angle valves, industrial-type, manufacturing",
    },
    {
      NAICS22: "332911",
      "INDEX ITEM DESCRIPTION":
        "Automatic (i.e., controlling-type, regulating) valves, industrial-type, manufacturing",
    },
    {
      NAICS22: "332911",
      "INDEX ITEM DESCRIPTION": "Ball valves, industrial-type, manufacturing",
    },
    {
      NAICS22: "332911",
      "INDEX ITEM DESCRIPTION":
        "Boiler gauge cocks, industrial-type, manufacturing",
    },
    {
      NAICS22: "332911",
      "INDEX ITEM DESCRIPTION":
        "Butterfly valves, industrial-type, manufacturing",
    },
    {
      NAICS22: "332911",
      "INDEX ITEM DESCRIPTION": "Check valves, industrial-type, manufacturing",
    },
    {
      NAICS22: "332911",
      "INDEX ITEM DESCRIPTION": "Compressed gas cylinder valves manufacturing",
    },
    {
      NAICS22: "332911",
      "INDEX ITEM DESCRIPTION": "Control valves, industrial-type, manufacturing",
    },
    {
      NAICS22: "332911",
      "INDEX ITEM DESCRIPTION": "Cross valves, industrial-type, manufacturing",
    },
    {
      NAICS22: "332911",
      "INDEX ITEM DESCRIPTION": "Fire hydrant valves manufacturing",
    },
    {
      NAICS22: "332911",
      "INDEX ITEM DESCRIPTION": "Fire hydrants, complete, manufacturing",
    },
    {
      NAICS22: "332911",
      "INDEX ITEM DESCRIPTION": "Flushing hydrant manufacturing",
    },
    {
      NAICS22: "332911",
      "INDEX ITEM DESCRIPTION": "Gas valves, industrial-type, manufacturing",
    },
    {
      NAICS22: "332911",
      "INDEX ITEM DESCRIPTION": "Gate valves, industrial-type, manufacturing",
    },
    {
      NAICS22: "332911",
      "INDEX ITEM DESCRIPTION": "Globe valves, industrial-type, manufacturing",
    },
    {
      NAICS22: "332911",
      "INDEX ITEM DESCRIPTION": "Nuclear application valves manufacturing",
    },
    {
      NAICS22: "332911",
      "INDEX ITEM DESCRIPTION": "Plug valves, industrial-type, manufacturing",
    },
    {
      NAICS22: "332911",
      "INDEX ITEM DESCRIPTION":
        "Pressure control valves (except fluid power), industrial-type, manufacturing",
    },
    {
      NAICS22: "332911",
      "INDEX ITEM DESCRIPTION":
        "Safety (i.e., pop-off) valves, industrial-type, manufacturing",
    },
    {
      NAICS22: "332911",
      "INDEX ITEM DESCRIPTION":
        "Solenoid valves (except fluid power), industrial-type, manufacturing",
    },
    {
      NAICS22: "332911",
      "INDEX ITEM DESCRIPTION": "Steam traps, industrial-type, manufacturing",
    },
    {
      NAICS22: "332911",
      "INDEX ITEM DESCRIPTION": "Stop valves, industrial-type, manufacturing",
    },
    {
      NAICS22: "332911",
      "INDEX ITEM DESCRIPTION":
        "Straightway (i.e., Y-type) valves, industrial-type, manufacturing",
    },
    {
      NAICS22: "332911",
      "INDEX ITEM DESCRIPTION":
        "Thermostatic traps, industrial-type, manufacturing",
    },
    {
      NAICS22: "332911",
      "INDEX ITEM DESCRIPTION": "Valves for nuclear applications manufacturing",
    },
    {
      NAICS22: "332911",
      "INDEX ITEM DESCRIPTION":
        "Valves for water works and municipal water systems manufacturing",
    },
    {
      NAICS22: "332911",
      "INDEX ITEM DESCRIPTION":
        "Valves, industrial-type (e.g., check, gate, globe, relief, safety), manufacturing",
    },
    {
      NAICS22: "332911",
      "INDEX ITEM DESCRIPTION": "Water sampling station manufacturing",
    },
    {
      NAICS22: "332911",
      "INDEX ITEM DESCRIPTION":
        "Waterworks and municipal water system valves manufacturing",
    },
    {
      NAICS22: "332912",
      "INDEX ITEM DESCRIPTION": "Control valves, fluid power, manufacturing",
    },
    {
      NAICS22: "332912",
      "INDEX ITEM DESCRIPTION":
        "Electrohydraulic servo valves, fluid power, manufacturing",
    },
    {
      NAICS22: "332912",
      "INDEX ITEM DESCRIPTION":
        "Fluid power aircraft subassemblies manufacturing",
    },
    {
      NAICS22: "332912",
      "INDEX ITEM DESCRIPTION": "Fluid power hose assemblies manufacturing",
    },
    {
      NAICS22: "332912",
      "INDEX ITEM DESCRIPTION":
        "Fluid power valves and hose fittings manufacturing",
    },
    {
      NAICS22: "332912",
      "INDEX ITEM DESCRIPTION":
        "Hose assemblies for fluid power systems manufacturing",
    },
    {
      NAICS22: "332912",
      "INDEX ITEM DESCRIPTION":
        "Hose couplings and fittings, fluid power, manufacturing",
    },
    {
      NAICS22: "332912",
      "INDEX ITEM DESCRIPTION": "Hydraulic aircraft subassemblies manufacturing",
    },
    {
      NAICS22: "332912",
      "INDEX ITEM DESCRIPTION":
        "Hydraulic hose fittings, fluid power, manufacturing",
    },
    {
      NAICS22: "332912",
      "INDEX ITEM DESCRIPTION": "Hydraulic valves, fluid power, manufacturing",
    },
    {
      NAICS22: "332912",
      "INDEX ITEM DESCRIPTION": "Pneumatic aircraft subassemblies manufacturing",
    },
    {
      NAICS22: "332912",
      "INDEX ITEM DESCRIPTION":
        "Pneumatic hose fittings, fluid power, manufacturing",
    },
    {
      NAICS22: "332912",
      "INDEX ITEM DESCRIPTION": "Pneumatic valves, fluid power, manufacturing",
    },
    {
      NAICS22: "332912",
      "INDEX ITEM DESCRIPTION":
        "Pressure control valves, fluid power, manufacturing",
    },
    {
      NAICS22: "332912",
      "INDEX ITEM DESCRIPTION": "Solenoid valves, fluid power, manufacturing",
    },
    {
      NAICS22: "332912",
      "INDEX ITEM DESCRIPTION":
        "Tube and hose fittings, fluid power, manufacturing",
    },
    {
      NAICS22: "332912",
      "INDEX ITEM DESCRIPTION":
        "Valves, hydraulic and pneumatic, fluid power, manufacturing",
    },
    {
      NAICS22: "332913",
      "INDEX ITEM DESCRIPTION":
        "Antiscald bath and shower valves, plumbing, manufacturing",
    },
    {
      NAICS22: "332913",
      "INDEX ITEM DESCRIPTION": "Backflow preventers, plumbing, manufacturing",
    },
    {
      NAICS22: "332913",
      "INDEX ITEM DESCRIPTION": "Cocks, drain, plumbing, manufacturing",
    },
    {
      NAICS22: "332913",
      "INDEX ITEM DESCRIPTION": "Drain cocks, plumbing, manufacturing",
    },
    {
      NAICS22: "332913",
      "INDEX ITEM DESCRIPTION": "Faucets, plumbing, manufacturing",
    },
    {
      NAICS22: "332913",
      "INDEX ITEM DESCRIPTION": "Flush valves, plumbing, manufacturing",
    },
    {
      NAICS22: "332913",
      "INDEX ITEM DESCRIPTION":
        "Plumbing fittings and couplings (e.g., compression fittings, metal elbows, metal unions) manufacturing",
    },
    {
      NAICS22: "332913",
      "INDEX ITEM DESCRIPTION":
        "Plumbing fixture fittings and trim, all materials, manufacturing",
    },
    {
      NAICS22: "332913",
      "INDEX ITEM DESCRIPTION": "Shower heads, plumbing, manufacturing",
    },
    {
      NAICS22: "332913",
      "INDEX ITEM DESCRIPTION":
        "Spigots, plumbing fixture fitting, manufacturing",
    },
    {
      NAICS22: "332913",
      "INDEX ITEM DESCRIPTION": "Stopcock drains, plumbing, manufacturing",
    },
    {
      NAICS22: "332913",
      "INDEX ITEM DESCRIPTION":
        "Supply line assemblies, plumbing (i.e., flexible hose with fittings), manufacturing",
    },
    {
      NAICS22: "332919",
      "INDEX ITEM DESCRIPTION": "Aerosol valves manufacturing",
    },
    {
      NAICS22: "332919",
      "INDEX ITEM DESCRIPTION":
        "Boiler couplings and drains, plumbing and heating-type, manufacturing",
    },
    {
      NAICS22: "332919",
      "INDEX ITEM DESCRIPTION": "Breakers, vacuum, plumbing, manufacturing",
    },
    {
      NAICS22: "332919",
      "INDEX ITEM DESCRIPTION":
        "Couplings, hose, metal (except fluid power), manufacturing",
    },
    {
      NAICS22: "332919",
      "INDEX ITEM DESCRIPTION":
        "Elbows, pipe, metal (except made from purchased pipe), manufacturing",
    },
    {
      NAICS22: "332919",
      "INDEX ITEM DESCRIPTION":
        "Flanges and flange unions, pipe, metal, manufacturing",
    },
    {
      NAICS22: "332919",
      "INDEX ITEM DESCRIPTION":
        "Hose couplings, metal (except fluid power), manufacturing",
    },
    {
      NAICS22: "332919",
      "INDEX ITEM DESCRIPTION":
        "Lawn hose nozzles and lawn sprinklers manufacturing",
    },
    {
      NAICS22: "332919",
      "INDEX ITEM DESCRIPTION": "Nozzles, firefighting, manufacturing",
    },
    {
      NAICS22: "332919",
      "INDEX ITEM DESCRIPTION": "Nozzles, lawn hose, manufacturing",
    },
    {
      NAICS22: "332919",
      "INDEX ITEM DESCRIPTION":
        "Plumbing and heating inline valves (e.g., check, cutoffs, stop) manufacturing",
    },
    {
      NAICS22: "332919",
      "INDEX ITEM DESCRIPTION": "Sprinklers, lawn, manufacturing",
    },
    {
      NAICS22: "332919",
      "INDEX ITEM DESCRIPTION": "Steam fittings, metal, manufacturing",
    },
    {
      NAICS22: "332919",
      "INDEX ITEM DESCRIPTION": "Traps, water, manufacturing",
    },
    {
      NAICS22: "332919",
      "INDEX ITEM DESCRIPTION":
        "Unions, pipe, metal (except made from purchased pipe), manufacturing",
    },
    {
      NAICS22: "332919",
      "INDEX ITEM DESCRIPTION":
        "Valves, inline plumbing and heating (e.g., cutoffs, stop), manufacturing",
    },
    {
      NAICS22: "332919",
      "INDEX ITEM DESCRIPTION": "Water traps manufacturing",
    },
    {
      NAICS22: "332991",
      "INDEX ITEM DESCRIPTION": "Annular ball bearings manufacturing",
    },
    {
      NAICS22: "332991",
      "INDEX ITEM DESCRIPTION": "Ball bearings manufacturing",
    },
    {
      NAICS22: "332991",
      "INDEX ITEM DESCRIPTION": "Bearings, ball and roller, manufacturing",
    },
    {
      NAICS22: "332991",
      "INDEX ITEM DESCRIPTION": "Cylindrical roller bearings manufacturing",
    },
    {
      NAICS22: "332991",
      "INDEX ITEM DESCRIPTION":
        "Flange units, ball or roller bearing, manufacturing",
    },
    {
      NAICS22: "332991",
      "INDEX ITEM DESCRIPTION": "Linear ball bearings manufacturing",
    },
    {
      NAICS22: "332991",
      "INDEX ITEM DESCRIPTION": "Linear roller bearings manufacturing",
    },
    {
      NAICS22: "332991",
      "INDEX ITEM DESCRIPTION": "Needle roller bearings manufacturing",
    },
    {
      NAICS22: "332991",
      "INDEX ITEM DESCRIPTION":
        "Pillow blocks with ball or roller bearings manufacturing",
    },
    {
      NAICS22: "332991",
      "INDEX ITEM DESCRIPTION": "Races, ball or roller bearings, manufacturing",
    },
    {
      NAICS22: "332991",
      "INDEX ITEM DESCRIPTION": "Roller bearings manufacturing",
    },
    {
      NAICS22: "332991",
      "INDEX ITEM DESCRIPTION": "Tapered roller bearings manufacturing",
    },
    {
      NAICS22: "332991",
      "INDEX ITEM DESCRIPTION": "Thrust roller bearings manufacturing",
    },
    {
      NAICS22: "332992",
      "INDEX ITEM DESCRIPTION":
        "Ammunition, small arms (i.e., 30 mm. or less, 1.18 inch or less), manufacturing",
    },
    {
      NAICS22: "332992",
      "INDEX ITEM DESCRIPTION": "BB shot manufacturing",
    },
    {
      NAICS22: "332992",
      "INDEX ITEM DESCRIPTION":
        "Blank cartridges (i.e., 30 mm. or less, 1.18 inch or less) manufacturing",
    },
    {
      NAICS22: "332992",
      "INDEX ITEM DESCRIPTION":
        "Bullet jackets and cores (i.e., 30 mm. or less, 1.18 inch or less) manufacturing",
    },
    {
      NAICS22: "332992",
      "INDEX ITEM DESCRIPTION":
        "Cartridge cases for ammunition (i.e., 30 mm. or less, 1.18 inch or less) manufacturing",
    },
    {
      NAICS22: "332992",
      "INDEX ITEM DESCRIPTION":
        "Cartridges (i.e., 30 mm. or less, 1.18 inch or less) manufacturing",
    },
    {
      NAICS22: "332992",
      "INDEX ITEM DESCRIPTION":
        "Cores, bullet (i.e., 30 mm. or less, 1.18 inch or less), manufacturing",
    },
    {
      NAICS22: "332992",
      "INDEX ITEM DESCRIPTION":
        "Jackets, bullet (i.e., 30 mm. or less, 1.18 inch or less), manufacturing",
    },
    {
      NAICS22: "332992",
      "INDEX ITEM DESCRIPTION":
        "Paper shells (i.e., 30 mm. or less, 1.18 inch or less) manufacturing",
    },
    {
      NAICS22: "332992",
      "INDEX ITEM DESCRIPTION": "Pellets, air rifle and pistol, manufacturing",
    },
    {
      NAICS22: "332992",
      "INDEX ITEM DESCRIPTION":
        "Percussion caps (i.e., 30 mm. or less, 1.18 inch or less), ammunition, manufacturing",
    },
    {
      NAICS22: "332992",
      "INDEX ITEM DESCRIPTION":
        "Shells, small arms (i.e., 30 mm. or less, 1.18 inch or less), manufacturing",
    },
    {
      NAICS22: "332992",
      "INDEX ITEM DESCRIPTION": "Shot, BB, manufacturing",
    },
    {
      NAICS22: "332992",
      "INDEX ITEM DESCRIPTION": "Shot, lead, manufacturing",
    },
    {
      NAICS22: "332992",
      "INDEX ITEM DESCRIPTION": "Shot, pellet, manufacturing",
    },
    {
      NAICS22: "332992",
      "INDEX ITEM DESCRIPTION": "Shot, steel, manufacturing",
    },
    {
      NAICS22: "332992",
      "INDEX ITEM DESCRIPTION": "Shotgun shells manufacturing",
    },
    {
      NAICS22: "332992",
      "INDEX ITEM DESCRIPTION":
        "Small arms ammunition (i.e., 30 mm. or less, 1.18 inch or less) manufacturing",
    },
    {
      NAICS22: "332992",
      "INDEX ITEM DESCRIPTION": "Wads, ammunition, manufacturing",
    },
    {
      NAICS22: "332993",
      "INDEX ITEM DESCRIPTION": "Adapters, bombcluster, manufacturing",
    },
    {
      NAICS22: "332993",
      "INDEX ITEM DESCRIPTION":
        "Ammunition (i.e., more than 30 mm., more than 1.18 inch) manufacturing",
    },
    {
      NAICS22: "332993",
      "INDEX ITEM DESCRIPTION": "Ammunition loading and assembling plants",
    },
    {
      NAICS22: "332993",
      "INDEX ITEM DESCRIPTION":
        "Arming and fusing devices, missile, manufacturing",
    },
    {
      NAICS22: "332993",
      "INDEX ITEM DESCRIPTION":
        "Artillery ammunition (i.e., more than 30 mm., more than 1.18 inch) manufacturing",
    },
    {
      NAICS22: "332993",
      "INDEX ITEM DESCRIPTION": "Bag loading plants, ammunition, manufacturing",
    },
    {
      NAICS22: "332993",
      "INDEX ITEM DESCRIPTION": "Bomb loading and assembling plants",
    },
    {
      NAICS22: "332993",
      "INDEX ITEM DESCRIPTION": "Bombcluster adapters manufacturing",
    },
    {
      NAICS22: "332993",
      "INDEX ITEM DESCRIPTION": "Bombs manufacturing",
    },
    {
      NAICS22: "332993",
      "INDEX ITEM DESCRIPTION": "Boosters and bursters, artillery, manufacturing",
    },
    {
      NAICS22: "332993",
      "INDEX ITEM DESCRIPTION": "Canisters, ammunition, manufacturing",
    },
    {
      NAICS22: "332993",
      "INDEX ITEM DESCRIPTION": "Caps, bomb, manufacturing",
    },
    {
      NAICS22: "332993",
      "INDEX ITEM DESCRIPTION": "Depth charges manufacturing",
    },
    {
      NAICS22: "332993",
      "INDEX ITEM DESCRIPTION":
        "Detonators, ammunition (i.e., more than 30 mm., more than 1.18 inch), manufacturing",
    },
    {
      NAICS22: "332993",
      "INDEX ITEM DESCRIPTION": "Fin assemblies, mortar, manufacturing",
    },
    {
      NAICS22: "332993",
      "INDEX ITEM DESCRIPTION": "Fin assemblies, torpedo and bomb, manufacturing",
    },
    {
      NAICS22: "332993",
      "INDEX ITEM DESCRIPTION":
        "Fuses ammunition (i.e., more than 30 mm., more than 1.18 inch) manufacturing",
    },
    {
      NAICS22: "332993",
      "INDEX ITEM DESCRIPTION": "Grenades, hand or projectile, manufacturing",
    },
    {
      NAICS22: "332993",
      "INDEX ITEM DESCRIPTION":
        "Igniters, ammunition tracer (i.e., more than 30 mm., more than 1.18 inch), manufacturing",
    },
    {
      NAICS22: "332993",
      "INDEX ITEM DESCRIPTION":
        "Jet propulsion projectiles (except guided missiles) manufacturing",
    },
    {
      NAICS22: "332993",
      "INDEX ITEM DESCRIPTION": "Loading and assembling bombs",
    },
    {
      NAICS22: "332993",
      "INDEX ITEM DESCRIPTION": "Mines, ammunition, manufacturing",
    },
    {
      NAICS22: "332993",
      "INDEX ITEM DESCRIPTION": "Missile warheads manufacturing",
    },
    {
      NAICS22: "332993",
      "INDEX ITEM DESCRIPTION": "Mortar shells manufacturing",
    },
    {
      NAICS22: "332993",
      "INDEX ITEM DESCRIPTION":
        "Primers (i.e., more than 30 mm., more than 1.18 inch), ammunition, manufacturing",
    },
    {
      NAICS22: "332993",
      "INDEX ITEM DESCRIPTION":
        "Projectiles (except guided missile), jet propulsion, manufacturing",
    },
    {
      NAICS22: "332993",
      "INDEX ITEM DESCRIPTION":
        "Rockets, ammunition (except guided missiles, pyrotechnic), manufacturing",
    },
    {
      NAICS22: "332993",
      "INDEX ITEM DESCRIPTION": "Shell loading and assembly plants",
    },
    {
      NAICS22: "332993",
      "INDEX ITEM DESCRIPTION": "Shells, artillery, manufacturing",
    },
    {
      NAICS22: "332993",
      "INDEX ITEM DESCRIPTION": "Torpedoes manufacturing",
    },
    {
      NAICS22: "332993",
      "INDEX ITEM DESCRIPTION":
        "Tracer igniters, ammunition (i.e., more than 30 mm., more than 1.18 inch), manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Aircraft artillery manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Ammunition carts manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Antiaircraft artillery manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Antisubmarine projectors manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Antitank rocket launchers manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Barrels, gun, manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "BB guns manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Belts, machine gun, manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Bofors guns manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Cannons manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Carbines manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Catapult guns manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Clips, gun, manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Cylinders and clips, gun, manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Dart guns manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Depth charge projectors manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Field artillery manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Firearms, small, manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Flame throwers manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Generators, smoke, manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Grenade launchers manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Gun barrels manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Gun cleaning kits manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Gun magazines manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Gun turrets manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Guns manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Guns, BB and pellet, manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Howitzers manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Links, ammunition, manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION":
        "Livens projectors (i.e., ordnance) manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Machine gun belts manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Machine guns manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Mortars manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Naval artillery manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Oerlikon guns manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Pellet guns manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Pistols manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION":
        "Projectors (e.g., antisub, depth charge release, grenade, livens, rocket), ordnance, manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION":
        "Pyrotechnic pistols and projectors manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Recoil mechanisms, gun, manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Recoilless rifles manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Revolvers manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Rifles (except toy) manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Rifles, BB and pellet, manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Rifles, pneumatic, manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Rifles, recoilless, manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Rocket launchers manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Shotguns manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Small arms manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Smoke generators manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Submachine guns manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Tampion guns manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Tank artillery manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Torpedo tubes manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Tranquilizer guns, manufacturing",
    },
    {
      NAICS22: "332994",
      "INDEX ITEM DESCRIPTION": "Turrets, gun, manufacturing",
    },
    {
      NAICS22: "332996",
      "INDEX ITEM DESCRIPTION": "Bends, pipe, made from purchased metal pipe",
    },
    {
      NAICS22: "332996",
      "INDEX ITEM DESCRIPTION": "Coils, pipe, made from purchased metal pipe",
    },
    {
      NAICS22: "332996",
      "INDEX ITEM DESCRIPTION": "Couplings, pipe, made from purchased metal pipe",
    },
    {
      NAICS22: "332996",
      "INDEX ITEM DESCRIPTION":
        "Fabricated pipe and pipe fittings made from purchased pipe",
    },
    {
      NAICS22: "332996",
      "INDEX ITEM DESCRIPTION": "Manifolds, pipe, made from purchased metal pipe",
    },
    {
      NAICS22: "332996",
      "INDEX ITEM DESCRIPTION": "Nipples, metal, made from purchased pipe",
    },
    {
      NAICS22: "332996",
      "INDEX ITEM DESCRIPTION":
        "Pipe and pipe fittings made from purchased metal pipe",
    },
    {
      NAICS22: "332996",
      "INDEX ITEM DESCRIPTION": "Pipe couplings made from purchased metal pipe",
    },
    {
      NAICS22: "332996",
      "INDEX ITEM DESCRIPTION":
        "Pipe fabricating (i.e., bending, cutting, threading) made from purchased metal pipe",
    },
    {
      NAICS22: "332996",
      "INDEX ITEM DESCRIPTION": "Pipe headers made from purchased metal pipe",
    },
    {
      NAICS22: "332996",
      "INDEX ITEM DESCRIPTION": "Tubes made from purchased metal pipe",
    },
    {
      NAICS22: "332996",
      "INDEX ITEM DESCRIPTION":
        "Wrought iron or steel pipe and tubing made from purchased metal pipe",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Aluminum freezer foil not made in rolling mills",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Aluminum ladders manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Andirons manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Angle irons, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION":
        "Animal traps, metal (except wire), manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Aquarium accessories, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Badges, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Bank chests, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Barricades, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Bathroom fixtures, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Bathtubs, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Bellows, hand, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Book ends, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Car seals, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Chain fittings manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION":
        "Chests, fire or burglary resistive, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Chests, money, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Chests, safe deposit, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Combs, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Containers, foil (except bags), manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Copper foil not made in rolling mills",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Cores, sand foundry, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Cuffs, leg, iron, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Doors, safe and vault, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Drain plugs, magnetic, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Drill stands, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION":
        "Drinking fountains (except mechanically refrigerated), metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION":
        "Ecclesiastical ware, precious plated metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Fireplace fixtures and equipment manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Flexible metal hose and tubing manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Flush tanks, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Foil containers (except bags) manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Foil not made in rolling mills",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Foundry cores manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Foundry pattern making",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION":
        "Fountains (except drinking), metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION":
        "Fountains, drinking (except mechanically refrigerated), metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION":
        "Frames and handles, handbag and luggage, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Frames, metal, lamp shade, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION":
        "Frames, metal, umbrella and parasol, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Gold beating (i.e., foil, leaf)",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Gold foil and leaf not made in rolling mills",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Hair curlers, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Handcuffs manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION":
        "Handles (e.g., parasol, umbrella), metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Harness parts, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION":
        "Hollowware, precious plated metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION":
        "Hoops, metal (except wire), fabricated from purchased metal",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Horse bits manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Hose, flexible metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Identification plates, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Industrial pattern manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Ironing boards, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Ladder jacks, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Ladders, portable metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Lamp shade frames, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Laundry tubs, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Lavatories, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Lead foil not made in rolling mills",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Leaf, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Linings, metal safe and vault, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Machine bases, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Magnesium foil not made in rolling mills",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Magnets, permanent, metallic, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION":
        "Marine horns, compressed air or steam, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION":
        "Metal foil containers (except bags) manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Military insignia, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Money chests, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Name plate blanks, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Nickel foil not made in rolling mills",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION":
        "Novelties and specialties, nonprecious metal and precious plated, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Pads, soap impregnated scouring, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Paint sticks, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Pallet parts, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Pallets, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION":
        "Patterns (except shoe), industrial, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Pipe hangers and supports, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION":
        "Plated ware (e.g., ecclesiastical ware, hollowware, toilet ware) manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION":
        "Platinum foil and leaf not made in rolling mills",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Plugs, magnetic metal drain, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Plumbing fixtures, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Portable chemical toilets, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION":
        "Propellers, ship and boat, made from purchased metal",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Reels, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Rope fittings manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Saddlery parts, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION":
        "Safe deposit boxes and chests, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Safe doors and linings, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Safes, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION":
        "Sanitary ware (e.g., bathtubs, lavatories, sinks), metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Scouring pads, soap impregnated, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Shims, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Shower receptors, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Shower rods, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Shower stalls, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Silver beating (i.e., foil, leaf)",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Silver foil and leaf not made in rolling mills",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Sinks, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Skids, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Soap dispensers, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Sponges, metal scouring, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Stabilizing bars, cargo, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Steel wool manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Stepladders, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Strappings, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Tablets, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Thimbles for wire rope manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Tinfoil not made in rolling mills",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Toilet fixtures, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION":
        "Toilet ware, precious plated metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION":
        "Trophies, nonprecious and precious plated metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Tubing, flexible metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Tubs, laundry and bath, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Urinals, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Vault doors and linings, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Vaults (except burial), metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Water closets, metal, manufacturing",
    },
    {
      NAICS22: "332999",
      "INDEX ITEM DESCRIPTION": "Zinc foil and leaf not made in rolling mills",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Bale throwers manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION":
        "Balers, farm-type (e.g., cotton, hay, straw), manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Berry harvesting machines manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Blowers, forage, manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Cabs for agricultural machinery manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION":
        "Cattle feeding and watering equipment manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Chicken brooders manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Chicken feeders manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION":
        "Combines (i.e., harvester-threshers) manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Corn heads for combines manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Corn pickers and shellers manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Cotton balers and presses manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Cotton ginning machinery manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION":
        "Cotton picker and stripper harvesting machinery manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Cream separators, farm-type, manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Crop driers manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Cultivators, farm-type, manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Curers, tobacco, manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Drags, farm-type equipment, manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Dusters, farm-type, manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Farm tractors and attachments manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Farm wagons manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION":
        "Feed processing equipment, farm-type, manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Fertilizing machinery, farm-type, manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Fruit harvesting machines manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION":
        "Grading, cleaning, and sorting machinery, farm-type, manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Grain drills manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Grain stackers manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION":
        "Grass mowing equipment (except lawn and garden) manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION":
        "Hair clippers for animal use, electric, manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION":
        "Harrows (e.g., disc, spring, tine) manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION":
        "Harvesting machinery and equipment, agriculture, manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Hay balers and presses manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Haying machines manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION":
        "Hog feeding and watering equipment manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Hulling machinery, farm-type, manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Incubators, poultry, manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION":
        "Irrigation equipment, agriculture, manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION":
        "Lawnmowers, agricultural-type, powered, manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Milking machines manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Nut shellers, farm-type, manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION":
        "Peanut combines (i.e., diggers, packers, threshers) manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Planting machines, farm-type, manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Plows, farm-type, manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION":
        "Potato diggers, harvesters, and planters manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION":
        "Poultry brooders, feeders, and waterers manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Presses, farm-type, manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Rakes, hay, manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Rotary hoes manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Rotary tillers, farm-type, manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Seeders, farm-type, manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION":
        "Shears, powered, for use on animals, manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Sheep shears, powered, manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Shredders, farm-type, manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Sod harvesting machines manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Sprayers and dusters, farm-type, manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Spreaders, farm-type, manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Stalk choppers (i.e., shredders) manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Tobacco harvester machines manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Tomato harvesting machines manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION":
        "Tractors and attachments, farm-type, manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Transplanters, farm-type, manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION":
        "Tree shakers (e.g., citrus, nut, soft fruit) manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Wagons, farm-type, manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Weeding machines, farm-type, manufacturing",
    },
    {
      NAICS22: "333111",
      "INDEX ITEM DESCRIPTION": "Windmills, farm-type, manufacturing",
    },
    {
      NAICS22: "333112",
      "INDEX ITEM DESCRIPTION":
        "Attachments, powered lawn and garden equipment, manufacturing",
    },
    {
      NAICS22: "333112",
      "INDEX ITEM DESCRIPTION": "Blowers, leaf, manufacturing",
    },
    {
      NAICS22: "333112",
      "INDEX ITEM DESCRIPTION": "Carts, lawn and garden-type, manufacturing",
    },
    {
      NAICS22: "333112",
      "INDEX ITEM DESCRIPTION":
        "Chippers (i.e., shredders), lawn and garden-type, manufacturing",
    },
    {
      NAICS22: "333112",
      "INDEX ITEM DESCRIPTION":
        "Cultivators, powered, lawn and garden-type, manufacturing",
    },
    {
      NAICS22: "333112",
      "INDEX ITEM DESCRIPTION":
        "Garden machinery and equipment, powered, manufacturing",
    },
    {
      NAICS22: "333112",
      "INDEX ITEM DESCRIPTION":
        "Grass mowing equipment, powered lawn and garden, manufacturing",
    },
    {
      NAICS22: "333112",
      "INDEX ITEM DESCRIPTION": "Hedge trimmers, powered, manufacturing",
    },
    {
      NAICS22: "333112",
      "INDEX ITEM DESCRIPTION": "Lawn and garden equipment manufacturing",
    },
    {
      NAICS22: "333112",
      "INDEX ITEM DESCRIPTION": "Lawn edgers, powered, manufacturing",
    },
    {
      NAICS22: "333112",
      "INDEX ITEM DESCRIPTION":
        "Lawnmowers (except agricultural-type), powered, manufacturing",
    },
    {
      NAICS22: "333112",
      "INDEX ITEM DESCRIPTION": "Leaf blowers manufacturing",
    },
    {
      NAICS22: "333112",
      "INDEX ITEM DESCRIPTION": "Mulchers, lawn and garden-type, manufacturing",
    },
    {
      NAICS22: "333112",
      "INDEX ITEM DESCRIPTION": "Seeders, lawn and garden-type, manufacturing",
    },
    {
      NAICS22: "333112",
      "INDEX ITEM DESCRIPTION":
        "Snow plow attachments, lawn and garden-type, manufacturing",
    },
    {
      NAICS22: "333112",
      "INDEX ITEM DESCRIPTION":
        "Snowblowers and throwers, residential-type, manufacturing",
    },
    {
      NAICS22: "333112",
      "INDEX ITEM DESCRIPTION": "Spreaders, lawn and garden-type, manufacturing",
    },
    {
      NAICS22: "333112",
      "INDEX ITEM DESCRIPTION": "Tillers, lawn and garden-type, manufacturing",
    },
    {
      NAICS22: "333112",
      "INDEX ITEM DESCRIPTION":
        "Tractors and attachments, lawn and garden-type, manufacturing",
    },
    {
      NAICS22: "333112",
      "INDEX ITEM DESCRIPTION": "Trimmers, hedge, electric, manufacturing",
    },
    {
      NAICS22: "333112",
      "INDEX ITEM DESCRIPTION":
        "Trimmers, string, lawn and garden-type, manufacturing",
    },
    {
      NAICS22: "333112",
      "INDEX ITEM DESCRIPTION": "Vacuums, yard, manufacturing",
    },
    {
      NAICS22: "333112",
      "INDEX ITEM DESCRIPTION": "Wagons, lawn and garden-type, manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Aggregate spreaders manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION":
        "Asphalt roofing construction machinery manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Augers (except mining-type) manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Backhoes manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION":
        "Bits, rock drill, construction and surface mining-type, manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION":
        "Blades for graders, scrapers, bulldozers, and snowplows manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Bucket and scarifier teeth manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION":
        "Buckets, excavating (e.g., clamshell, concrete, drag scraper, dragline, shovel), manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Bulldozers manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Cabs for construction machinery manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION":
        "Chippers, portable, commercial (e.g., brush, limb, log), manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Concrete finishing machinery manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Concrete gunning equipment manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION":
        "Concrete mixing machinery, portable, manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Construction machinery manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION":
        "Construction-type tractors and attachments manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Cranes, construction-type, manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Crushing machinery, portable, manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION":
        "Crushing, pulverizing, and screening machinery, portable, manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION":
        "Ditchers and trenchers, self-propelled, manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Draglines, crawler, manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION":
        "Drags, road construction and road maintenance equipment, manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Dredging machinery manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Excavators (e.g., power shovels) manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Extractors, piling, manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Grader attachments manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Graders, road, manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION":
        "Hammer mill machinery (i.e., rock and ore crushing machines), portable, manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Highway line marking machinery manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Jack hammers manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION":
        "Land preparation machinery, construction, manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Loaders, shovel, manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION":
        "Log debarking machinery, portable, manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Log splitters, portable, manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Mixers, concrete, portable, manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Mortar mixers, portable, manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Off-highway trucks manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Paving machinery manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Pile-driving equipment manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Planers, bituminous, manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION":
        "Plows, construction (e.g., excavating, grading), manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Post hole diggers, powered, manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION":
        "Rock crushing machinery, portable, manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION":
        "Rock drills, construction and surface mining-type, manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION":
        "Rollers, road construction and maintenance machinery, manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Sand mixers manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Scarifiers, road, manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Scrapers, construction-type, manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Screening machinery, portable, manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Shovel loaders manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Shovels, power, manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Slag mixers, portable, manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION":
        "Snow plow attachments (except lawn, garden-type) manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION":
        "Surface mining machinery (except drilling) manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Tampers, powered, manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION":
        "Tractors and attachments, construction-type, manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Tractors, crawler, manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Trenching machines manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Trucks, off-highway, manufacturing",
    },
    {
      NAICS22: "333120",
      "INDEX ITEM DESCRIPTION": "Vibrators, concrete, manufacturing",
    },
    {
      NAICS22: "333131",
      "INDEX ITEM DESCRIPTION":
        "Amalgamators (i.e., metallurgical and mining machinery) manufacturing",
    },
    {
      NAICS22: "333131",
      "INDEX ITEM DESCRIPTION": "Augers, mining-type, manufacturing",
    },
    {
      NAICS22: "333131",
      "INDEX ITEM DESCRIPTION":
        "Bits, rock drill, underground mining-type, manufacturing",
    },
    {
      NAICS22: "333131",
      "INDEX ITEM DESCRIPTION": "Breakers, coal, manufacturing",
    },
    {
      NAICS22: "333131",
      "INDEX ITEM DESCRIPTION": "Cars, mining, manufacturing",
    },
    {
      NAICS22: "333131",
      "INDEX ITEM DESCRIPTION": "Cleaning machinery, mining-type, manufacturing",
    },
    {
      NAICS22: "333131",
      "INDEX ITEM DESCRIPTION":
        "Coal breakers, cutters, and pulverizers manufacturing",
    },
    {
      NAICS22: "333131",
      "INDEX ITEM DESCRIPTION":
        "Concentration machinery, mining-type, manufacturing",
    },
    {
      NAICS22: "333131",
      "INDEX ITEM DESCRIPTION":
        "Core drills, underground mining-type, manufacturing",
    },
    {
      NAICS22: "333131",
      "INDEX ITEM DESCRIPTION": "Crushing machinery, stationary, manufacturing",
    },
    {
      NAICS22: "333131",
      "INDEX ITEM DESCRIPTION": "Cutters, coal, manufacturing",
    },
    {
      NAICS22: "333131",
      "INDEX ITEM DESCRIPTION":
        "Drilling equipment, underground mining-type, manufacturing",
    },
    {
      NAICS22: "333131",
      "INDEX ITEM DESCRIPTION":
        "Drills, core, underground mining-type, manufacturing",
    },
    {
      NAICS22: "333131",
      "INDEX ITEM DESCRIPTION":
        "Drills, rock, underground mining-type, manufacturing",
    },
    {
      NAICS22: "333131",
      "INDEX ITEM DESCRIPTION": "Dumpers, mining car, manufacturing",
    },
    {
      NAICS22: "333131",
      "INDEX ITEM DESCRIPTION":
        "Feeders, mineral beneficiating-type, manufacturing",
    },
    {
      NAICS22: "333131",
      "INDEX ITEM DESCRIPTION": "Flotation machinery, mining-type, manufacturing",
    },
    {
      NAICS22: "333131",
      "INDEX ITEM DESCRIPTION":
        "Hammer mill machinery (i.e., rock and ore crushing machines), stationary, manufacturing",
    },
    {
      NAICS22: "333131",
      "INDEX ITEM DESCRIPTION":
        "Loading machines, underground mining, manufacturing",
    },
    {
      NAICS22: "333131",
      "INDEX ITEM DESCRIPTION":
        "Mineral processing and beneficiating machinery manufacturing",
    },
    {
      NAICS22: "333131",
      "INDEX ITEM DESCRIPTION": "Mining cars manufacturing",
    },
    {
      NAICS22: "333131",
      "INDEX ITEM DESCRIPTION":
        "Ore crushing, washing, screening, and loading machinery manufacturing",
    },
    {
      NAICS22: "333131",
      "INDEX ITEM DESCRIPTION":
        "Pellet mills machinery, mining-type, manufacturing",
    },
    {
      NAICS22: "333131",
      "INDEX ITEM DESCRIPTION": "Quarrying machinery and equipment manufacturing",
    },
    {
      NAICS22: "333131",
      "INDEX ITEM DESCRIPTION":
        "Rock crushing machinery, stationary, manufacturing",
    },
    {
      NAICS22: "333131",
      "INDEX ITEM DESCRIPTION":
        "Rock drills, underground mining-type, manufacturing",
    },
    {
      NAICS22: "333131",
      "INDEX ITEM DESCRIPTION":
        "Scraper loaders, underground mining-type, manufacturing",
    },
    {
      NAICS22: "333131",
      "INDEX ITEM DESCRIPTION": "Screening machinery, stationary, manufacturing",
    },
    {
      NAICS22: "333131",
      "INDEX ITEM DESCRIPTION": "Sedimentary mineral machinery manufacturing",
    },
    {
      NAICS22: "333131",
      "INDEX ITEM DESCRIPTION":
        "Sieves and screening equipment, mineral beneficiating, manufacturing",
    },
    {
      NAICS22: "333131",
      "INDEX ITEM DESCRIPTION": "Stone beneficiating machinery manufacturing",
    },
    {
      NAICS22: "333131",
      "INDEX ITEM DESCRIPTION": "Underground mining machinery manufacturing",
    },
    {
      NAICS22: "333131",
      "INDEX ITEM DESCRIPTION":
        "Washers, aggregate and sand, stationary, manufacturing",
    },
    {
      NAICS22: "333132",
      "INDEX ITEM DESCRIPTION":
        "Bits, rock drill, oil and gas field-type, manufacturing",
    },
    {
      NAICS22: "333132",
      "INDEX ITEM DESCRIPTION":
        "Christmas tree assemblies, oil and gas field-type, manufacturing",
    },
    {
      NAICS22: "333132",
      "INDEX ITEM DESCRIPTION": "Derricks, oil and gas field-type, manufacturing",
    },
    {
      NAICS22: "333132",
      "INDEX ITEM DESCRIPTION":
        "Drilling equipment, oil and gas field-type, manufacturing",
    },
    {
      NAICS22: "333132",
      "INDEX ITEM DESCRIPTION":
        "Drilling rigs, oil and gas field-type, manufacturing",
    },
    {
      NAICS22: "333132",
      "INDEX ITEM DESCRIPTION": "Gas well machinery and equipment manufacturing",
    },
    {
      NAICS22: "333132",
      "INDEX ITEM DESCRIPTION":
        "Oil and gas field-type drilling machinery and equipment (except offshore floating platforms) manufacturing",
    },
    {
      NAICS22: "333132",
      "INDEX ITEM DESCRIPTION":
        "Rock drill bits, oil and gas field-type, manufacturing",
    },
    {
      NAICS22: "333132",
      "INDEX ITEM DESCRIPTION": "Water well drilling machinery manufacturing",
    },
    {
      NAICS22: "333132",
      "INDEX ITEM DESCRIPTION": "Well logging equipment manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION": "Bakery machinery and equipment manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION": "Bakery ovens manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION": "Bread slicing machinery manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION": "Brewery machinery manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION": "Butter processing machinery manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION": "Cheese processing machinery manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION": "Chewing gum machinery manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION": "Chocolate processing machinery manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION": "Cider presses manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION":
        "Coffee roasting and grinding machinery (i.e., food manufacturing-type) manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION":
        "Condensed and evaporated milk machinery manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION": "Confectionery machinery manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION":
        "Corn popping machinery (i.e., food manufacturing-type) manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION": "Cracker making machinery manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION": "Cream separators, industrial, manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION": "Dairy product plant machinery and equipment",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION": "Distilling equipment, beverage, manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION":
        "Dough mixing machinery (i.e., food manufacturing-type) manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION": "Dry milk processing machinery manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION": "Flour milling machinery manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION":
        "Food choppers, grinders, mixers, and slicers (i.e., food manufacturing-type) manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION":
        "Food dehydrating equipment (except household-type) manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION": "Food product machinery manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION":
        "Grading, cleaning, and sorting machinery (i.e., food manufacturing-type) manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION": "Grain milling machinery manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION": "Homogenizing machinery, food, manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION": "Ice cream making machinery manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION":
        "Juice extractors (i.e., food manufacturing-type) manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION": "Malt milling machinery manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION":
        "Meat and poultry processing and preparation machinery",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION": "Meat grinders, food-type, manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION":
        "Milk processing (except farm-type) machinery manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION":
        "Oilseed crushing and extracting machinery manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION": "Ovens, bakery, manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION":
        "Pasta making machinery (i.e., food manufacturing-type) manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION": "Pasteurizing equipment, food, manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION":
        "Peanut roasting machines (i.e., food manufacturing-type) manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION":
        "Presses (i.e., food manufacturing-type) manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION": "Roasting machinery manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION":
        "Sieves and screening equipment (i.e., food manufacturing-type) manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION":
        "Sifting machine (i.e., food manufacturing-type) manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION":
        "Slicing machinery (i.e., food manufacturing-type) manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION": "Stuffer, sausage machinery, manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION": "Sugar refining machinery manufacturing",
    },
    {
      NAICS22: "333241",
      "INDEX ITEM DESCRIPTION":
        "Vegetable oil processing machinery manufacturing",
    },
    {
      NAICS22: "333242",
      "INDEX ITEM DESCRIPTION": "Etching equipment, semiconductor, manufacturing",
    },
    {
      NAICS22: "333242",
      "INDEX ITEM DESCRIPTION":
        "Micro-lithography equipment, semiconductor, manufacturing",
    },
    {
      NAICS22: "333242",
      "INDEX ITEM DESCRIPTION":
        "Nanoindentation equipment, semiconductor, manufacturing",
    },
    {
      NAICS22: "333242",
      "INDEX ITEM DESCRIPTION":
        "Semiconductor assembly and packaging machinery manufacturing",
    },
    {
      NAICS22: "333242",
      "INDEX ITEM DESCRIPTION": "Semiconductor making machinery manufacturing",
    },
    {
      NAICS22: "333242",
      "INDEX ITEM DESCRIPTION":
        "Surface mount machinery for making printed circuit boards manufacturing",
    },
    {
      NAICS22: "333242",
      "INDEX ITEM DESCRIPTION":
        "Thin layer deposition equipment, semiconductor, manufacturing",
    },
    {
      NAICS22: "333242",
      "INDEX ITEM DESCRIPTION":
        "Vapor deposition equipment, semiconductor, manufacturing",
    },
    {
      NAICS22: "333242",
      "INDEX ITEM DESCRIPTION":
        "Wafer processing equipment, semiconductor, manufacturing",
    },
    {
      NAICS22: "333243",
      "INDEX ITEM DESCRIPTION": "Bandsaws, woodworking-type, manufacturing",
    },
    {
      NAICS22: "333243",
      "INDEX ITEM DESCRIPTION": "Chippers, stationary (e.g., log), manufacturing",
    },
    {
      NAICS22: "333243",
      "INDEX ITEM DESCRIPTION":
        "Circular saws, woodworking-type, stationary, manufacturing",
    },
    {
      NAICS22: "333243",
      "INDEX ITEM DESCRIPTION":
        "Dovetailing machines, woodworking-type, manufacturing",
    },
    {
      NAICS22: "333243",
      "INDEX ITEM DESCRIPTION": "Drill presses, woodworking-type, manufacturing",
    },
    {
      NAICS22: "333243",
      "INDEX ITEM DESCRIPTION": "Envelope making machinery manufacturing",
    },
    {
      NAICS22: "333243",
      "INDEX ITEM DESCRIPTION": "Fourdrinier machinery manufacturing",
    },
    {
      NAICS22: "333243",
      "INDEX ITEM DESCRIPTION":
        "Jigsaws, woodworking-type, stationary, manufacturing",
    },
    {
      NAICS22: "333243",
      "INDEX ITEM DESCRIPTION": "Jointers, woodworking-type, manufacturing",
    },
    {
      NAICS22: "333243",
      "INDEX ITEM DESCRIPTION": "Lathes, woodworking-type, manufacturing",
    },
    {
      NAICS22: "333243",
      "INDEX ITEM DESCRIPTION":
        "Log debarking machinery, stationary, manufacturing",
    },
    {
      NAICS22: "333243",
      "INDEX ITEM DESCRIPTION": "Log splitters, stationary, manufacturing",
    },
    {
      NAICS22: "333243",
      "INDEX ITEM DESCRIPTION": "Mortisers, woodworking-type, manufacturing",
    },
    {
      NAICS22: "333243",
      "INDEX ITEM DESCRIPTION":
        "Paper and paperboard coating and finishing machinery manufacturing",
    },
    {
      NAICS22: "333243",
      "INDEX ITEM DESCRIPTION":
        "Paper and paperboard converting machinery manufacturing",
    },
    {
      NAICS22: "333243",
      "INDEX ITEM DESCRIPTION":
        "Paper and paperboard corrugating machinery manufacturing",
    },
    {
      NAICS22: "333243",
      "INDEX ITEM DESCRIPTION":
        "Paper and paperboard cutting and folding machinery manufacturing",
    },
    {
      NAICS22: "333243",
      "INDEX ITEM DESCRIPTION":
        "Paper and paperboard die-cutting and stamping machinery manufacturing",
    },
    {
      NAICS22: "333243",
      "INDEX ITEM DESCRIPTION": "Paper bag making machinery manufacturing",
    },
    {
      NAICS22: "333243",
      "INDEX ITEM DESCRIPTION": "Paper making machinery manufacturing",
    },
    {
      NAICS22: "333243",
      "INDEX ITEM DESCRIPTION": "Paperboard box making machinery manufacturing",
    },
    {
      NAICS22: "333243",
      "INDEX ITEM DESCRIPTION": "Paperboard making machinery manufacturing",
    },
    {
      NAICS22: "333243",
      "INDEX ITEM DESCRIPTION":
        "Planers woodworking-type, stationary, manufacturing",
    },
    {
      NAICS22: "333243",
      "INDEX ITEM DESCRIPTION":
        "Presses for making composite woods (e.g., hardboard, medium density fiberboard (MDF), particleboard, plywood) manufacturing",
    },
    {
      NAICS22: "333243",
      "INDEX ITEM DESCRIPTION": "Pulp making machinery manufacturing",
    },
    {
      NAICS22: "333243",
      "INDEX ITEM DESCRIPTION":
        "Pulp, paper, and paperboard molding machinery manufacturing",
    },
    {
      NAICS22: "333243",
      "INDEX ITEM DESCRIPTION":
        "Sanding machines, woodworking-type, stationary, manufacturing",
    },
    {
      NAICS22: "333243",
      "INDEX ITEM DESCRIPTION": "Sandpaper making machines manufacturing",
    },
    {
      NAICS22: "333243",
      "INDEX ITEM DESCRIPTION": "Sawmill equipment manufacturing",
    },
    {
      NAICS22: "333243",
      "INDEX ITEM DESCRIPTION":
        "Saws, bench and table, power-driven, woodworking-type, manufacturing",
    },
    {
      NAICS22: "333243",
      "INDEX ITEM DESCRIPTION":
        "Scarfing machines, woodworking-type, manufacturing",
    },
    {
      NAICS22: "333243",
      "INDEX ITEM DESCRIPTION": "Shapers, woodworking-type, manufacturing",
    },
    {
      NAICS22: "333243",
      "INDEX ITEM DESCRIPTION":
        "Veneer and plywood forming machinery manufacturing",
    },
    {
      NAICS22: "333243",
      "INDEX ITEM DESCRIPTION":
        "Wood veneer laminating and gluing machines manufacturing",
    },
    {
      NAICS22: "333243",
      "INDEX ITEM DESCRIPTION":
        "Woodworking machines (except handheld) manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Additive manufacturing machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Anodizing equipment manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Beaming machinery for yarn manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Bindery machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Bleaching machinery for textiles manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Blow molding machinery for plastics manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Bobbins, textile machinery, manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Bookbinding machines manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Boot making and repairing machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Braiding machinery for textiles manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Buttonhole and eyelet machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Calendering machinery for plastics manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Calendering machinery for textiles manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Camelback (i.e., retreading materials) machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Carbonizing equipment for processing wool manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Carding machinery for textiles manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Cement kilns manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Chemical kilns manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Chemical processing machinery and equipment manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Chip placement machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Cigarette making machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Circuit board making machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Circular knitting machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Clayworking and tempering machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Cloth spreading machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Collating machinery for printing and bookbinding manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Combing machinery for textiles manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Compression molding machinery for plastics manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Concrete products forming machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Cordage and rope (except wire) making machines manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Digital printing presses manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Distilling equipment (except beverage), including laboratory-type, manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Drawing machinery for textiles manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Drying kilns, lumber, manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Drying machinery for textiles manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Dyeing machinery for textiles manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Electron tube machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Electroplating machinery and equipment manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Electrotyping machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Embroidery machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Extruding machinery for plastics and rubber manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Extruding machinery for yarn manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Fermentation equipment, chemical, manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Finishing machinery for textile manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Flexographic printing presses manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Footwear making or repairing machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Fractionating equipment, chemical, manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Frames for textile making machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Garnetting machinery for textiles manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Gas liquefying machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Gem stone processing machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Glass making machinery (e.g., blowing, forming, molding) manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Granulator and pelletizer machinery for plastics manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Gravure printing presses manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Hosiery machines manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Injection molding machinery for plastics manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Jacquard card cutting machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Kilns (i.e., cement, chemical, wood) manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Knitting machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Knot tying machinery for textiles manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Lace and net making machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Leather working machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Letterpress printing presses manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Light bulb and tube (i.e., electric lamp) machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Linotype machines manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Lithographic printing presses manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Loom bobbins manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Loom reeds manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Looms for textiles manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Loopers for textiles manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Mercerizing machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Metal casting machinery and equipment manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Napping machinery for textiles manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Needles for knitting machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Net and lace making machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Newspaper inserting equipment manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Offset printing presses manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Optical lens making and grinding machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Petroleum refining machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Photoengraving machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Picker machinery for textiles manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Picker sticks for looms manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Plastics working machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Presses, printing, manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Printer machinery, 3D, manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Printing machinery for textiles manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Printing plate engraving machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Printing plates, blank (except photosensitive), manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Printing press rollers manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Printing presses manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Rectifying equipment, chemical, manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Recycling sorting machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Roving machinery for textiles manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Rubber working machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Schiffli machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Sewing machines (including household-type) manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Shoe making and repairing machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Shuttles for textile weaving machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Sieves and screening equipment, chemical preparation-type, manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Silk screens for textile fabrics manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Spindles for textile machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Spinning machinery for textiles manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Spools for textile machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Stitchers and trimmers bookbinding equipment manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Stone working machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Tannery machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Textile finishing machinery (e.g., bleaching, dyeing, mercerizing, printing) manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Textile making machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Textile printing machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Texturizing machinery for textiles manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Thermoforming machinery for plastics manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Thread making machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Through-hole machinery, printed circuit board loading, manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Tile making machinery (except kilns) manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Tire making machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Tire recapping machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Tire shredding machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Tobacco processing machinery (except farm-type) manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Tufting machinery for textiles manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Typesetting machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Vulcanizing machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Warping machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Weaving machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Winding machinery for textiles manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Wire and cable insulating machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Wood drying kilns manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION":
        "Wool and worsted finishing machinery manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Yarn texturizing machines manufacturing",
    },
    {
      NAICS22: "333248",
      "INDEX ITEM DESCRIPTION": "Zipper making machinery manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Adding machines manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Aerial cameras manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Alignment equipment, motor vehicle, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Balancing equipment, motor vehicle, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Beauty and barber shop equipment (except chairs) manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Binding equipment (i.e., plastics or tape binding), office-type, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Binoculars manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Blueprint equipment manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Brake service equipment (except mechanic's handtools), motor vehicle, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Bundling machinery (e.g., box strapping, mail, newspaper) manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Calculators manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Camera lenses manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Cameras (except television, video) manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Canceling machinery, postal office-type, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Car washing machinery manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Carnival and amusement park rides manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Carnival and amusement park shooting gallery machinery manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Carousels (i.e., merry-go-rounds) manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Carpet and floor cleaning equipment, electric commercial-type, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Carpet sweepers, mechanical, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Cash registers (except point of sales terminals) manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Central vacuuming systems, commercial-type, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Change making machines manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Check writing machines manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Cigarette vending machines manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Coffee makers and urns, commercial-type, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Coin counting machinery manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Coin- or card-operated vending machines manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Coin wrapping machines manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Collating machinery, office-type, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Comparators, optical, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Cooking equipment (i.e., fryers, microwave ovens, ovens, ranges), commercial-type, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Corn popping machines, commercial-type, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Currency counting machinery manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Deep-fat fryers, commercial-type, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Densitometers (except laboratory analytical) manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Developing equipment, film, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Dictating machines manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Digital cameras manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Dishwashing machines, commercial-type, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Driers, photographic, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Drycleaning equipment and machinery manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Dryers, laundry (except household-type), manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Editing equipment, motion picture (e.g., rewinders, splicers, titlers, viewers), manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Enlargers, photographic, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Envelope stuffing, sealing, and addressing machinery manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Exposure meters, photographic, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Ferris wheels manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Film developing equipment manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Flash apparatus, photographic, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Flight simulation machinery manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Floor sanding, washing, and polishing machines, commercial-type, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Food warming equipment, commercial-type, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Frame and body alignment equipment, motor vehicle, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Garbage disposal units, commercial-type, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Gas ranges, commercial-type, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Gauges, machinist's precision tool, optical, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Glasses, field or opera, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Gratings, diffraction, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Gun sighting and fire control equipment and instruments, optical, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Gun sights, optical, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Hair dryers, beauty parlor-type, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Holepunchers (except hand operated), office-type, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Hot beverage vending machines manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Hotplates, commercial-type, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Ice cream vending machines manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Incoming mail handling equipment (e.g., opening, scanning, sorting) manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Instrument lenses manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Interferometers manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Laboratory analytical optical instruments (e.g., microscopes) manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Laundry extractors manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Laundry machinery and equipment (except household-type) manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Laundry pressing machines (except household-type) manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Lens coating (except ophthalmic)",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Lens grinding (except ophthalmic)",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Lens hoods, camera, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Lens mounting (except ophthalmic)",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Lens polishing (except ophthalmic)",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Lenses (except ophthalmic) manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Letter folding, stuffing, and sealing machinery manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Light meters, photographic, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Locks, coin- or card-operated, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Loupes (e.g., jewelers) manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Magnifying glasses (except corrective vision-type) manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Magnifying instruments, optical, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Mail handling machinery, post office-type, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Mechanisms for coin- or card-operated machines manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Microfiche equipment (e.g., cameras, projectors, readers) manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Microfilm equipment (e.g., cameras, projectors, readers) manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Microscopes (except electron, proton) manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Microwave ovens, commercial-type, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Mirrors, optical, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Mop wringers manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Motion picture cameras manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Motion picture theater projectors manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Night vision optical devices manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Oil water separators manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Optical alignment and display instruments manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Optical gun sighting and fire control equipment and instruments manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Optical test and inspection equipment manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Ovens, commercial-type, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Overhead projectors (except computer peripheral) manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Ozone machines for water purification manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Periscopes manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Photocopying machines manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Photoflash equipment manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Photographic equipment manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Photographic lenses manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Postage meters manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Postage stamp vending machines manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Power washer cleaning equipment manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Prisms, optical, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Projection equipment (e.g., motion picture, slide), photographic, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Projection lenses manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Projection screens (i.e., motion picture, overhead, slide) manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Range finders, photographic, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Ranges, commercial-type, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Readers, microfilm or microfiche, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Reflectors, optical, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Sanding machines, floor, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Screens, projection (i.e., motion picture, overhead, slide), manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Sensitometers, photographic, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Sewage treatment equipment manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Sights, telescopic, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Snack and confection vending machines manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Soft drink vending machines manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Steam cookers, commercial-type, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Steam tables manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Stenography machinery manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Stoves, commercial-type, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Swimming pool filter systems manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Tanks, photographic developing, fixing, and washing, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Teaching machines (e.g., flight simulators) manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Telescopes manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Theodolites manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Tire mounting machines, motor vehicle, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Trash and garbage compactors, commercial-type, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Trays, photographic printing and processing, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Tripods, camera and projector, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Typewriters manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Vacuum cleaners, industrial and commercial-type, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Vending machines manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Voting machines manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Wash water recycling machinery manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Washing machines, laundry (except household-type), manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Water heaters (except boilers), commercial-type, manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Water purification equipment manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Water softening equipment manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION": "Water treatment equipment manufacturing",
    },
    {
      NAICS22: "333310",
      "INDEX ITEM DESCRIPTION":
        "Word processing equipment, dedicated, manufacturing",
    },
    {
      NAICS22: "333413",
      "INDEX ITEM DESCRIPTION":
        "Air purification equipment, stationary, manufacturing",
    },
    {
      NAICS22: "333413",
      "INDEX ITEM DESCRIPTION": "Air scrubbing systems manufacturing",
    },
    {
      NAICS22: "333413",
      "INDEX ITEM DESCRIPTION": "Air washers (i.e., air scrubbers) manufacturing",
    },
    {
      NAICS22: "333413",
      "INDEX ITEM DESCRIPTION": "Aircurtains manufacturing",
    },
    {
      NAICS22: "333413",
      "INDEX ITEM DESCRIPTION": "Attic fans manufacturing",
    },
    {
      NAICS22: "333413",
      "INDEX ITEM DESCRIPTION": "Blower filter units manufacturing",
    },
    {
      NAICS22: "333413",
      "INDEX ITEM DESCRIPTION":
        "Dust and fume collecting equipment manufacturing",
    },
    {
      NAICS22: "333413",
      "INDEX ITEM DESCRIPTION":
        "Electrostatic precipitation equipment manufacturing",
    },
    {
      NAICS22: "333413",
      "INDEX ITEM DESCRIPTION":
        "Exhaust fans, industrial and commercial-type, manufacturing",
    },
    {
      NAICS22: "333413",
      "INDEX ITEM DESCRIPTION":
        "Fans, industrial and commercial-type, manufacturing",
    },
    {
      NAICS22: "333413",
      "INDEX ITEM DESCRIPTION": "Filters, air-conditioner, manufacturing",
    },
    {
      NAICS22: "333413",
      "INDEX ITEM DESCRIPTION": "Filters, furnace, manufacturing",
    },
    {
      NAICS22: "333413",
      "INDEX ITEM DESCRIPTION": "Furnace filters manufacturing",
    },
    {
      NAICS22: "333413",
      "INDEX ITEM DESCRIPTION":
        "Ventilating fans, industrial and commercial-type, manufacturing",
    },
    {
      NAICS22: "333414",
      "INDEX ITEM DESCRIPTION": "Baseboard heating equipment manufacturing",
    },
    {
      NAICS22: "333414",
      "INDEX ITEM DESCRIPTION": "Boilers, heating, manufacturing",
    },
    {
      NAICS22: "333414",
      "INDEX ITEM DESCRIPTION": "Burners, heating, manufacturing",
    },
    {
      NAICS22: "333414",
      "INDEX ITEM DESCRIPTION":
        "Fireplace inserts (i.e., heat directing) manufacturing",
    },
    {
      NAICS22: "333414",
      "INDEX ITEM DESCRIPTION":
        "Furnaces (except forced air), heating, manufacturing",
    },
    {
      NAICS22: "333414",
      "INDEX ITEM DESCRIPTION": "Furnaces, floor and wall, manufacturing",
    },
    {
      NAICS22: "333414",
      "INDEX ITEM DESCRIPTION": "Gas burners, heating, manufacturing",
    },
    {
      NAICS22: "333414",
      "INDEX ITEM DESCRIPTION": "Gas fireplaces manufacturing",
    },
    {
      NAICS22: "333414",
      "INDEX ITEM DESCRIPTION": "Gas space heaters manufacturing",
    },
    {
      NAICS22: "333414",
      "INDEX ITEM DESCRIPTION": "Gas-oil burners, combination, manufacturing",
    },
    {
      NAICS22: "333414",
      "INDEX ITEM DESCRIPTION":
        "Heaters, space (except portable electric), manufacturing",
    },
    {
      NAICS22: "333414",
      "INDEX ITEM DESCRIPTION": "Heaters, swimming pool, manufacturing",
    },
    {
      NAICS22: "333414",
      "INDEX ITEM DESCRIPTION":
        "Heating equipment, hot water (except hot water heaters), manufacturing",
    },
    {
      NAICS22: "333414",
      "INDEX ITEM DESCRIPTION": "Heating units, baseboard, manufacturing",
    },
    {
      NAICS22: "333414",
      "INDEX ITEM DESCRIPTION": "Hydronic heating equipment manufacturing",
    },
    {
      NAICS22: "333414",
      "INDEX ITEM DESCRIPTION": "Kerosene space heaters manufacturing",
    },
    {
      NAICS22: "333414",
      "INDEX ITEM DESCRIPTION": "Logs, gas fireplace, manufacturing",
    },
    {
      NAICS22: "333414",
      "INDEX ITEM DESCRIPTION": "Oil burners, heating, manufacturing",
    },
    {
      NAICS22: "333414",
      "INDEX ITEM DESCRIPTION":
        "Radiators (except motor vehicle, portable electric) manufacturing",
    },
    {
      NAICS22: "333414",
      "INDEX ITEM DESCRIPTION":
        "Room heaters (except portable electric) manufacturing",
    },
    {
      NAICS22: "333414",
      "INDEX ITEM DESCRIPTION": "Solar energy heating equipment manufacturing",
    },
    {
      NAICS22: "333414",
      "INDEX ITEM DESCRIPTION": "Solar heating systems manufacturing",
    },
    {
      NAICS22: "333414",
      "INDEX ITEM DESCRIPTION":
        "Space heaters (except portable electric) manufacturing",
    },
    {
      NAICS22: "333414",
      "INDEX ITEM DESCRIPTION": "Steam heating equipment manufacturing",
    },
    {
      NAICS22: "333414",
      "INDEX ITEM DESCRIPTION": "Swimming pool heaters manufacturing",
    },
    {
      NAICS22: "333414",
      "INDEX ITEM DESCRIPTION":
        "Unit heaters (except portable electric) manufacturing",
    },
    {
      NAICS22: "333414",
      "INDEX ITEM DESCRIPTION": "Wood stoves manufacturing",
    },
    {
      NAICS22: "333415",
      "INDEX ITEM DESCRIPTION":
        "Air-conditioners, unit (e.g., motor home, travel trailer, window), manufacturing",
    },
    {
      NAICS22: "333415",
      "INDEX ITEM DESCRIPTION":
        "Air-conditioning and warm air heating combination units manufacturing",
    },
    {
      NAICS22: "333415",
      "INDEX ITEM DESCRIPTION":
        "Air-conditioning compressors (except motor vehicle) manufacturing",
    },
    {
      NAICS22: "333415",
      "INDEX ITEM DESCRIPTION":
        "Air-conditioning condensers and condensing units manufacturing",
    },
    {
      NAICS22: "333415",
      "INDEX ITEM DESCRIPTION":
        "Air-conditioning equipment (except motor vehicle) manufacturing",
    },
    {
      NAICS22: "333415",
      "INDEX ITEM DESCRIPTION":
        "Beer cooling and dispensing equipment manufacturing",
    },
    {
      NAICS22: "333415",
      "INDEX ITEM DESCRIPTION": "Coolers, refrigeration, manufacturing",
    },
    {
      NAICS22: "333415",
      "INDEX ITEM DESCRIPTION": "Coolers, water, manufacturing",
    },
    {
      NAICS22: "333415",
      "INDEX ITEM DESCRIPTION": "Cooling towers manufacturing",
    },
    {
      NAICS22: "333415",
      "INDEX ITEM DESCRIPTION":
        "Counters and display cases, refrigerated, manufacturing",
    },
    {
      NAICS22: "333415",
      "INDEX ITEM DESCRIPTION":
        "Dehumidifiers (except portable electric) manufacturing",
    },
    {
      NAICS22: "333415",
      "INDEX ITEM DESCRIPTION": "Display cases, refrigerated, manufacturing",
    },
    {
      NAICS22: "333415",
      "INDEX ITEM DESCRIPTION": "Drinking fountains, refrigerated, manufacturing",
    },
    {
      NAICS22: "333415",
      "INDEX ITEM DESCRIPTION":
        "Electric warm air (i.e., forced air) furnaces manufacturing",
    },
    {
      NAICS22: "333415",
      "INDEX ITEM DESCRIPTION":
        "Evaporative condensers (i.e., heat transfer equipment) manufacturing",
    },
    {
      NAICS22: "333415",
      "INDEX ITEM DESCRIPTION": "Fountains, refrigerated drinking, manufacturing",
    },
    {
      NAICS22: "333415",
      "INDEX ITEM DESCRIPTION":
        "Freezing equipment, industrial and commercial-type, manufacturing",
    },
    {
      NAICS22: "333415",
      "INDEX ITEM DESCRIPTION":
        "Furnaces, warm air (i.e., forced air), manufacturing",
    },
    {
      NAICS22: "333415",
      "INDEX ITEM DESCRIPTION": "Heat pumps manufacturing",
    },
    {
      NAICS22: "333415",
      "INDEX ITEM DESCRIPTION":
        "Heating and air-conditioning combination units manufacturing",
    },
    {
      NAICS22: "333415",
      "INDEX ITEM DESCRIPTION":
        "Heating equipment, warm air (i.e., forced air), manufacturing",
    },
    {
      NAICS22: "333415",
      "INDEX ITEM DESCRIPTION":
        "Humidifying equipment (except portable) manufacturing",
    },
    {
      NAICS22: "333415",
      "INDEX ITEM DESCRIPTION": "Ice making machinery manufacturing",
    },
    {
      NAICS22: "333415",
      "INDEX ITEM DESCRIPTION": "Laboratory-type freezers manufacturing",
    },
    {
      NAICS22: "333415",
      "INDEX ITEM DESCRIPTION": "Lockers, refrigerated, manufacturing",
    },
    {
      NAICS22: "333415",
      "INDEX ITEM DESCRIPTION": "Refrigerated lockers manufacturing",
    },
    {
      NAICS22: "333415",
      "INDEX ITEM DESCRIPTION": "Refrigeration compressors manufacturing",
    },
    {
      NAICS22: "333415",
      "INDEX ITEM DESCRIPTION":
        "Refrigeration equipment, industrial and commercial-type, manufacturing",
    },
    {
      NAICS22: "333415",
      "INDEX ITEM DESCRIPTION": "Refrigeration units, truck-type, manufacturing",
    },
    {
      NAICS22: "333415",
      "INDEX ITEM DESCRIPTION": "Room air-conditioners manufacturing",
    },
    {
      NAICS22: "333415",
      "INDEX ITEM DESCRIPTION": "Showcases, refrigerated, manufacturing",
    },
    {
      NAICS22: "333415",
      "INDEX ITEM DESCRIPTION": "Snow making machinery manufacturing",
    },
    {
      NAICS22: "333415",
      "INDEX ITEM DESCRIPTION":
        "Soda fountain cooling and dispensing equipment manufacturing",
    },
    {
      NAICS22: "333415",
      "INDEX ITEM DESCRIPTION":
        "Water (i.e., drinking) coolers, mechanical, manufacturing",
    },
    {
      NAICS22: "333511",
      "INDEX ITEM DESCRIPTION": "Die-casting dies manufacturing",
    },
    {
      NAICS22: "333511",
      "INDEX ITEM DESCRIPTION": "Foundry casting molds manufacturing",
    },
    {
      NAICS22: "333511",
      "INDEX ITEM DESCRIPTION":
        "Industrial molds (except steel ingot) manufacturing",
    },
    {
      NAICS22: "333511",
      "INDEX ITEM DESCRIPTION":
        "Molds (except steel ingot), industrial, manufacturing",
    },
    {
      NAICS22: "333511",
      "INDEX ITEM DESCRIPTION":
        "Molds for forming materials (e.g., glass, plastics, rubber) manufacturing",
    },
    {
      NAICS22: "333511",
      "INDEX ITEM DESCRIPTION":
        "Molds for metal casting (except steel ingot) manufacturing",
    },
    {
      NAICS22: "333511",
      "INDEX ITEM DESCRIPTION":
        "Molds for plastics and rubber working machinery manufacturing",
    },
    {
      NAICS22: "333514",
      "INDEX ITEM DESCRIPTION": "Cutting dies, metalworking, manufacturing",
    },
    {
      NAICS22: "333514",
      "INDEX ITEM DESCRIPTION": "Diamond dies, metalworking, manufacturing",
    },
    {
      NAICS22: "333514",
      "INDEX ITEM DESCRIPTION":
        "Die sets for metal stamping presses manufacturing",
    },
    {
      NAICS22: "333514",
      "INDEX ITEM DESCRIPTION":
        "Dies and die holders for metal cutting and forming (except threading) manufacturing",
    },
    {
      NAICS22: "333514",
      "INDEX ITEM DESCRIPTION":
        "Dies, metalworking (except threading), manufacturing",
    },
    {
      NAICS22: "333514",
      "INDEX ITEM DESCRIPTION": "Dies, plastics forming, manufacturing",
    },
    {
      NAICS22: "333514",
      "INDEX ITEM DESCRIPTION": "Dies, steel rule, metal cutting, manufacturing",
    },
    {
      NAICS22: "333514",
      "INDEX ITEM DESCRIPTION":
        "Extrusion dies for use with all materials manufacturing",
    },
    {
      NAICS22: "333514",
      "INDEX ITEM DESCRIPTION":
        "Jigs (e.g., checking, gauging, inspection) manufacturing",
    },
    {
      NAICS22: "333514",
      "INDEX ITEM DESCRIPTION":
        "Jigs and fixtures for use with machine tools manufacturing",
    },
    {
      NAICS22: "333514",
      "INDEX ITEM DESCRIPTION":
        "Punches for use with machine tools manufacturing",
    },
    {
      NAICS22: "333514",
      "INDEX ITEM DESCRIPTION": "Subpresses, machine tool, manufacturing",
    },
    {
      NAICS22: "333514",
      "INDEX ITEM DESCRIPTION": "Welding positioners (i.e., jigs) manufacturing",
    },
    {
      NAICS22: "333514",
      "INDEX ITEM DESCRIPTION":
        "Wire drawing and straightening dies manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION":
        "Angle rings (i.e., a machine tool accessory) manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION":
        "Arbors (i.e., a machine tool accessory) manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION":
        "Bits and knives for metalworking lathes, planers, and shapers manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION": "Bits, drill, metalworking, manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION": "Blanks, cutting tool, manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION":
        "Broaches (i.e., a machine tool accessory) manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION":
        "Cams (i.e., a machine tool accessory) manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION":
        "Chasers (i.e., a machine tool accessory) manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION":
        "Chucks (i.e., a machine tool accessory) manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION":
        "Clamps (i.e., a machine tool accessory) manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION":
        "Collars (i.e., a machine tool accessory) manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION":
        "Collets (i.e., a machine tool accessory) manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION":
        "Counterbores (i.e., a machine tool accessory), metalworking, manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION":
        "Countersinks (i.e., a machine tool accessory) manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION": "Cutters, metal milling, manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION":
        "Dies and taps (i.e., a machine tool accessory) manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION": "Drill bits, metalworking, manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION":
        "Files (i.e., a machine tool accessory) manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION":
        "Hobs (i.e., metal gear cutting tool) manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION":
        "Honing heads (i.e., a machine tool accessory) manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION":
        "Hopper feed devices (i.e., a machine tool accessory) manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION":
        "Indexing, rotary tables (i.e., a machine tool accessory) manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION": "Inserts, cutting tool, manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION":
        "Knives and bits for metalworking lathes, planers, and shapers manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION":
        "Letter pins (e.g., gauging, measuring) manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION": "Machine knives, metal cutting, manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION":
        "Machine tool attachments and accessories manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION":
        "Mandrels (i.e., a machine tool accessory) manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION":
        "Measuring attachments (e.g., sine bars) for machine tool manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION":
        "Pushers (i.e., a machine tool accessory) manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION":
        "Reamers (i.e., a machine tool accessory) manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION":
        "Sine bars (i.e., a machine tool accessory) manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION":
        "Taps and dies (i.e., a machine tool accessory) manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION":
        "Thread cutting dies (i.e., a machine tool accessory) manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION":
        "Toolholders (i.e., a machine tool accessory) manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION":
        "Tools and accessories for machine tools manufacturing",
    },
    {
      NAICS22: "333515",
      "INDEX ITEM DESCRIPTION":
        "Tracer and tapering machine tool attachments manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Arbor presses, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Automatic screw machines, metal cutting type, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Beader machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Bending and forming machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Boring machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Boring, drilling, and milling machine combinations, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Brakes, press, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Broaching machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Brushing machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Buffing and polishing machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Burnishing machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Can forming machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Centering machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Chamfering machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Chemical milling machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Chucking machines, automatic, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Crankshaft grinding machines metal cutting type, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Custom roll forming machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Cut-off machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Cutting machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Cylinder boring machines metal cutting type, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Deburring machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Die sinking machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Die-casting machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Drill presses, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Drilling machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Drop hammers, metal forging and shaping, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Duplicating machines (e.g., key cutting), metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Electrochemical milling machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Electrode discharge metal cutting machines manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Electrolytic metal cutting machines manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Electron-discharge metal cutting machines manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Extruding machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Facing machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Filing machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Flange facing machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Forging machinery and hammers manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Forming machines (except drawing), metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Gear cutting and finishing machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Gear rolling machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Grinding machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Home workshop metal cutting machine tools (except handtools, welding equipment) manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Honing and lapping machines, metal cutting type, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Key cutting machines, metal cutting type, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Knurling machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Laser boring, drilling, and cutting machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Lathes, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Machine tools, metal cutting, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Machine tools, metal forming, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Magnetic forming machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Metal cutting machine tools manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Metal deposit forming machines manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Metal forming machine tools manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Metalworking lathes manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Milling machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Nail heading machines manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Numerically controlled metal cutting machine tools manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Pipe cutting and threading machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Planers, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Plasma jet spray metal forming machines manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Plasma process metal cutting machines (except welding equipment) manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Polishing and buffing machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Powder metal forming presses manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Press brakes, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Presses (e.g., bending, punching, shearing, stamping), metal forming, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Punching machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Reaming machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Rifling machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Riveting machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Sawing machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Screw and nut slotting machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Shaving machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Shearing machines, metal forming, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Sheet metal forming machines manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Slotting machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Spinning machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Spline rolling machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Spring winding and forming machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Stamping machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Stretching machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Swaging machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Tapping machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Thread rolling machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Threading machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Turning machines (i.e., lathes), metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Turret lathes, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Ultrasonic boring, drilling, and cutting machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION": "Ultrasonic metal forming machines manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Upsetters (i.e., forging machines) manufacturing",
    },
    {
      NAICS22: "333517",
      "INDEX ITEM DESCRIPTION":
        "Valve grinding machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333519",
      "INDEX ITEM DESCRIPTION":
        "Assembly machines (i.e., wire making equipment) manufacturing",
    },
    {
      NAICS22: "333519",
      "INDEX ITEM DESCRIPTION": "Bar mill machinery, metalworking, manufacturing",
    },
    {
      NAICS22: "333519",
      "INDEX ITEM DESCRIPTION":
        "Billet mill machinery, metalworking, manufacturing",
    },
    {
      NAICS22: "333519",
      "INDEX ITEM DESCRIPTION":
        "Blooming and slabbing mill machinery, metalworking, manufacturing",
    },
    {
      NAICS22: "333519",
      "INDEX ITEM DESCRIPTION":
        "Coil winding and cutting machinery, metalworking, manufacturing",
    },
    {
      NAICS22: "333519",
      "INDEX ITEM DESCRIPTION":
        "Cold rolling mill machinery, metalworking, manufacturing",
    },
    {
      NAICS22: "333519",
      "INDEX ITEM DESCRIPTION":
        "Cradle assembly machinery (i.e., wire making equipment) manufacturing",
    },
    {
      NAICS22: "333519",
      "INDEX ITEM DESCRIPTION": "Draw bench machines manufacturing",
    },
    {
      NAICS22: "333519",
      "INDEX ITEM DESCRIPTION": "Galvanizing machinery manufacturing",
    },
    {
      NAICS22: "333519",
      "INDEX ITEM DESCRIPTION":
        "Hot strip mill machinery, metalworking, manufacturing",
    },
    {
      NAICS22: "333519",
      "INDEX ITEM DESCRIPTION":
        "Hot-rolling mill machinery, metalworking, manufacturing",
    },
    {
      NAICS22: "333519",
      "INDEX ITEM DESCRIPTION": "Marking machines, metal, manufacturing",
    },
    {
      NAICS22: "333519",
      "INDEX ITEM DESCRIPTION":
        "Picklers and pickling machinery, metalworking, manufacturing",
    },
    {
      NAICS22: "333519",
      "INDEX ITEM DESCRIPTION":
        "Pipe and tube rolling mill machinery, metalworking, manufacturing",
    },
    {
      NAICS22: "333519",
      "INDEX ITEM DESCRIPTION":
        "Plate rolling mill machinery, metalworking, manufacturing",
    },
    {
      NAICS22: "333519",
      "INDEX ITEM DESCRIPTION": "Propeller straightening presses manufacturing",
    },
    {
      NAICS22: "333519",
      "INDEX ITEM DESCRIPTION":
        "Rod rolling mill machinery, metalworking, manufacturing",
    },
    {
      NAICS22: "333519",
      "INDEX ITEM DESCRIPTION":
        "Rolling mill machinery and equipment, metalworking, manufacturing",
    },
    {
      NAICS22: "333519",
      "INDEX ITEM DESCRIPTION":
        "Rolling mill roll machines, metalworking, manufacturing",
    },
    {
      NAICS22: "333519",
      "INDEX ITEM DESCRIPTION":
        "Scarfing units, rolling mill machinery, metalworking, manufacturing",
    },
    {
      NAICS22: "333519",
      "INDEX ITEM DESCRIPTION":
        "Screwdowns and boxes machinery, metal, manufacturing",
    },
    {
      NAICS22: "333519",
      "INDEX ITEM DESCRIPTION": "Screwdriving machines manufacturing",
    },
    {
      NAICS22: "333519",
      "INDEX ITEM DESCRIPTION":
        "Structural rolling mill machinery, metalworking, manufacturing",
    },
    {
      NAICS22: "333519",
      "INDEX ITEM DESCRIPTION":
        "Tube rolling mill machinery, metalworking, manufacturing",
    },
    {
      NAICS22: "333519",
      "INDEX ITEM DESCRIPTION":
        "Wire drawing and fabricating machinery and equipment (except dies) manufacturing",
    },
    {
      NAICS22: "333611",
      "INDEX ITEM DESCRIPTION": "Gas turbine generator set units manufacturing",
    },
    {
      NAICS22: "333611",
      "INDEX ITEM DESCRIPTION": "Gas turbines (except aircraft) manufacturing",
    },
    {
      NAICS22: "333611",
      "INDEX ITEM DESCRIPTION":
        "Generator sets, turbine (e.g., gas, hydraulic, steam), manufacturing",
    },
    {
      NAICS22: "333611",
      "INDEX ITEM DESCRIPTION": "Governors, steam, manufacturing",
    },
    {
      NAICS22: "333611",
      "INDEX ITEM DESCRIPTION":
        "Hydraulic turbine generator set units manufacturing",
    },
    {
      NAICS22: "333611",
      "INDEX ITEM DESCRIPTION": "Hydraulic turbines manufacturing",
    },
    {
      NAICS22: "333611",
      "INDEX ITEM DESCRIPTION":
        "Motor generator sets, turbo generators, manufacturing",
    },
    {
      NAICS22: "333611",
      "INDEX ITEM DESCRIPTION": "Steam turbine generator set units manufacturing",
    },
    {
      NAICS22: "333611",
      "INDEX ITEM DESCRIPTION": "Steam turbines manufacturing",
    },
    {
      NAICS22: "333611",
      "INDEX ITEM DESCRIPTION": "Turbine generator set units manufacturing",
    },
    {
      NAICS22: "333611",
      "INDEX ITEM DESCRIPTION": "Turbines (except aircraft) manufacturing",
    },
    {
      NAICS22: "333611",
      "INDEX ITEM DESCRIPTION": "Water turbines manufacturing",
    },
    {
      NAICS22: "333611",
      "INDEX ITEM DESCRIPTION":
        "Wind powered turbine generator sets manufacturing",
    },
    {
      NAICS22: "333611",
      "INDEX ITEM DESCRIPTION": "Wind turbines (i.e., windmill) manufacturing",
    },
    {
      NAICS22: "333611",
      "INDEX ITEM DESCRIPTION":
        "Windmills, electric power, generation-type, manufacturing",
    },
    {
      NAICS22: "333612",
      "INDEX ITEM DESCRIPTION":
        "Drives, high-speed industrial (except hydrostatic), manufacturing",
    },
    {
      NAICS22: "333612",
      "INDEX ITEM DESCRIPTION":
        "Gearmotors (i.e., power transmission equipment) manufacturing",
    },
    {
      NAICS22: "333612",
      "INDEX ITEM DESCRIPTION":
        "Gears, power transmission (except aircraft, motor vehicle), manufacturing",
    },
    {
      NAICS22: "333612",
      "INDEX ITEM DESCRIPTION": "Motors, gear, manufacturing",
    },
    {
      NAICS22: "333612",
      "INDEX ITEM DESCRIPTION": "Reducers, speed, manufacturing",
    },
    {
      NAICS22: "333612",
      "INDEX ITEM DESCRIPTION":
        "Reduction gears and gear units (except aircraft power transmission equipment, automotive) manufacturing",
    },
    {
      NAICS22: "333612",
      "INDEX ITEM DESCRIPTION":
        "Speed changers (i.e., power transmission equipment) manufacturing",
    },
    {
      NAICS22: "333612",
      "INDEX ITEM DESCRIPTION":
        "Speed reducers (i.e., power transmission equipment) manufacturing",
    },
    {
      NAICS22: "333613",
      "INDEX ITEM DESCRIPTION":
        "Ball joints (except aircraft, motor vehicle) manufacturing",
    },
    {
      NAICS22: "333613",
      "INDEX ITEM DESCRIPTION":
        "Bearings, plain (except internal combustion engine), manufacturing",
    },
    {
      NAICS22: "333613",
      "INDEX ITEM DESCRIPTION":
        "Bushings, plain (except internal combustion engine), manufacturing",
    },
    {
      NAICS22: "333613",
      "INDEX ITEM DESCRIPTION": "Chains, power transmission, manufacturing",
    },
    {
      NAICS22: "333613",
      "INDEX ITEM DESCRIPTION":
        "Collars, shaft for power transmission equipment, manufacturing",
    },
    {
      NAICS22: "333613",
      "INDEX ITEM DESCRIPTION":
        "Couplings, mechanical power transmission, manufacturing",
    },
    {
      NAICS22: "333613",
      "INDEX ITEM DESCRIPTION":
        "Drive chains, bicycle and motorcycle, manufacturing",
    },
    {
      NAICS22: "333613",
      "INDEX ITEM DESCRIPTION":
        "Joints, swivel (except aircraft, motor vehicle), manufacturing",
    },
    {
      NAICS22: "333613",
      "INDEX ITEM DESCRIPTION":
        "Joints, universal (except aircraft, motor vehicle), manufacturing",
    },
    {
      NAICS22: "333613",
      "INDEX ITEM DESCRIPTION": "Pulleys, power transmission, manufacturing",
    },
    {
      NAICS22: "333613",
      "INDEX ITEM DESCRIPTION":
        "Railroad car journal bearings, plain, manufacturing",
    },
    {
      NAICS22: "333613",
      "INDEX ITEM DESCRIPTION":
        "Sheaves, mechanical power transmission, manufacturing",
    },
    {
      NAICS22: "333613",
      "INDEX ITEM DESCRIPTION":
        "Sprockets, power transmission equipment, manufacturing",
    },
    {
      NAICS22: "333613",
      "INDEX ITEM DESCRIPTION":
        "Universal joints (except aircraft, motor vehicle) manufacturing",
    },
    {
      NAICS22: "333618",
      "INDEX ITEM DESCRIPTION": "Diesel and semidiesel engines manufacturing",
    },
    {
      NAICS22: "333618",
      "INDEX ITEM DESCRIPTION": "Electric outboard motors manufacturing",
    },
    {
      NAICS22: "333618",
      "INDEX ITEM DESCRIPTION": "Engines, diesel and semidiesel, manufacturing",
    },
    {
      NAICS22: "333618",
      "INDEX ITEM DESCRIPTION": "Engines, diesel locomotive, manufacturing",
    },
    {
      NAICS22: "333618",
      "INDEX ITEM DESCRIPTION":
        "Engines, internal combustion (except aircraft, nondiesel automotive), manufacturing",
    },
    {
      NAICS22: "333618",
      "INDEX ITEM DESCRIPTION": "Engines, natural gas, manufacturing",
    },
    {
      NAICS22: "333618",
      "INDEX ITEM DESCRIPTION":
        "Gasoline engines (except aircraft, automotive, truck) manufacturing",
    },
    {
      NAICS22: "333618",
      "INDEX ITEM DESCRIPTION": "Governors, diesel engine, manufacturing",
    },
    {
      NAICS22: "333618",
      "INDEX ITEM DESCRIPTION":
        "Governors, gasoline engine (except automotive), manufacturing",
    },
    {
      NAICS22: "333618",
      "INDEX ITEM DESCRIPTION":
        "Internal combustion engines (except aircraft, nondiesel automotive, nondiesel truck) manufacturing",
    },
    {
      NAICS22: "333618",
      "INDEX ITEM DESCRIPTION":
        "Internal combustion engines for hybrid drive systems (except automotive) manufacturing",
    },
    {
      NAICS22: "333618",
      "INDEX ITEM DESCRIPTION": "Locomotive diesel engines manufacturing",
    },
    {
      NAICS22: "333618",
      "INDEX ITEM DESCRIPTION": "Marine engines manufacturing",
    },
    {
      NAICS22: "333618",
      "INDEX ITEM DESCRIPTION": "Motors, outboard, manufacturing",
    },
    {
      NAICS22: "333618",
      "INDEX ITEM DESCRIPTION": "Natural gas engines manufacturing",
    },
    {
      NAICS22: "333618",
      "INDEX ITEM DESCRIPTION": "Outboard motors manufacturing",
    },
    {
      NAICS22: "333618",
      "INDEX ITEM DESCRIPTION": "Semidiesel engines manufacturing",
    },
    {
      NAICS22: "333912",
      "INDEX ITEM DESCRIPTION":
        "Air compressors (except air-conditioning, refrigeration) manufacturing",
    },
    {
      NAICS22: "333912",
      "INDEX ITEM DESCRIPTION": "Bicycle pumps manufacturing",
    },
    {
      NAICS22: "333912",
      "INDEX ITEM DESCRIPTION":
        "Compressors, air and gas, general purpose-type, manufacturing",
    },
    {
      NAICS22: "333912",
      "INDEX ITEM DESCRIPTION":
        "Paint sprayers (i.e., compressor and spray gun unit) manufacturing",
    },
    {
      NAICS22: "333912",
      "INDEX ITEM DESCRIPTION":
        "Power (i.e., pressure) washer units manufacturing",
    },
    {
      NAICS22: "333912",
      "INDEX ITEM DESCRIPTION":
        "Sprayers, manual pump, general purpose-type, manufacturing",
    },
    {
      NAICS22: "333912",
      "INDEX ITEM DESCRIPTION": "Vacuum pumps (except laboratory) manufacturing",
    },
    {
      NAICS22: "333914",
      "INDEX ITEM DESCRIPTION": "Centrifugal pumps manufacturing",
    },
    {
      NAICS22: "333914",
      "INDEX ITEM DESCRIPTION":
        "Dispensing and measuring pumps (e.g., gasoline, lubricants) manufacturing",
    },
    {
      NAICS22: "333914",
      "INDEX ITEM DESCRIPTION":
        "Gasoline measuring and dispensing pumps manufacturing",
    },
    {
      NAICS22: "333914",
      "INDEX ITEM DESCRIPTION":
        "Oil measuring and dispensing pumps manufacturing",
    },
    {
      NAICS22: "333914",
      "INDEX ITEM DESCRIPTION": "Oil well and oil field pumps manufacturing",
    },
    {
      NAICS22: "333914",
      "INDEX ITEM DESCRIPTION":
        "Pumps (except fluid power), general purpose, manufacturing",
    },
    {
      NAICS22: "333914",
      "INDEX ITEM DESCRIPTION":
        "Pumps for railroad equipment lubrication systems manufacturing",
    },
    {
      NAICS22: "333914",
      "INDEX ITEM DESCRIPTION":
        "Pumps, industrial and commercial-type, general purpose, manufacturing",
    },
    {
      NAICS22: "333914",
      "INDEX ITEM DESCRIPTION":
        "Pumps, measuring and dispensing (e.g., gasoline), manufacturing",
    },
    {
      NAICS22: "333914",
      "INDEX ITEM DESCRIPTION": "Pumps, oil field or well, manufacturing",
    },
    {
      NAICS22: "333914",
      "INDEX ITEM DESCRIPTION":
        "Pumps, sump or water, residential-type, manufacturing",
    },
    {
      NAICS22: "333914",
      "INDEX ITEM DESCRIPTION": "Sump pumps, residential-type, manufacturing",
    },
    {
      NAICS22: "333921",
      "INDEX ITEM DESCRIPTION":
        "Automobile lifts (i.e., garage-type, service station) manufacturing",
    },
    {
      NAICS22: "333921",
      "INDEX ITEM DESCRIPTION": "Dumbwaiters manufacturing",
    },
    {
      NAICS22: "333921",
      "INDEX ITEM DESCRIPTION": "Elevators, passenger and freight, manufacturing",
    },
    {
      NAICS22: "333921",
      "INDEX ITEM DESCRIPTION": "Escalators manufacturing",
    },
    {
      NAICS22: "333921",
      "INDEX ITEM DESCRIPTION": "Stairways, moving, manufacturing",
    },
    {
      NAICS22: "333921",
      "INDEX ITEM DESCRIPTION": "Walkways, moving, manufacturing",
    },
    {
      NAICS22: "333922",
      "INDEX ITEM DESCRIPTION": "Belt conveyor systems manufacturing",
    },
    {
      NAICS22: "333922",
      "INDEX ITEM DESCRIPTION": "Buckets, elevator or conveyor, manufacturing",
    },
    {
      NAICS22: "333922",
      "INDEX ITEM DESCRIPTION":
        "Carousel conveyors (e.g., luggage) manufacturing",
    },
    {
      NAICS22: "333922",
      "INDEX ITEM DESCRIPTION": "Coal and ore conveyors manufacturing",
    },
    {
      NAICS22: "333922",
      "INDEX ITEM DESCRIPTION": "Conveyors and conveying equipment manufacturing",
    },
    {
      NAICS22: "333922",
      "INDEX ITEM DESCRIPTION": "Elevators, farm, manufacturing",
    },
    {
      NAICS22: "333922",
      "INDEX ITEM DESCRIPTION": "Farm-type conveyors manufacturing",
    },
    {
      NAICS22: "333922",
      "INDEX ITEM DESCRIPTION": "Mine conveyors manufacturing",
    },
    {
      NAICS22: "333922",
      "INDEX ITEM DESCRIPTION": "Overhead conveyors manufacturing",
    },
    {
      NAICS22: "333922",
      "INDEX ITEM DESCRIPTION":
        "Passenger baggage belt loaders (except industrial truck) manufacturing",
    },
    {
      NAICS22: "333922",
      "INDEX ITEM DESCRIPTION": "Pneumatic tube conveyors manufacturing",
    },
    {
      NAICS22: "333922",
      "INDEX ITEM DESCRIPTION": "Screw conveyors manufacturing",
    },
    {
      NAICS22: "333923",
      "INDEX ITEM DESCRIPTION": "Aerial work platforms manufacturing",
    },
    {
      NAICS22: "333923",
      "INDEX ITEM DESCRIPTION":
        "Automobile wrecker (i.e., tow truck) hoists manufacturing",
    },
    {
      NAICS22: "333923",
      "INDEX ITEM DESCRIPTION": "Block and tackle manufacturing",
    },
    {
      NAICS22: "333923",
      "INDEX ITEM DESCRIPTION": "Boat lifts manufacturing",
    },
    {
      NAICS22: "333923",
      "INDEX ITEM DESCRIPTION": "Chain hoists manufacturing",
    },
    {
      NAICS22: "333923",
      "INDEX ITEM DESCRIPTION": "Cranes, overhead traveling, manufacturing",
    },
    {
      NAICS22: "333923",
      "INDEX ITEM DESCRIPTION": "Davits manufacturing",
    },
    {
      NAICS22: "333923",
      "INDEX ITEM DESCRIPTION": "Hoists (except aircraft loading) manufacturing",
    },
    {
      NAICS22: "333923",
      "INDEX ITEM DESCRIPTION": "Locomotive cranes manufacturing",
    },
    {
      NAICS22: "333923",
      "INDEX ITEM DESCRIPTION":
        "Monorail systems (except passenger-type) manufacturing",
    },
    {
      NAICS22: "333923",
      "INDEX ITEM DESCRIPTION": "Overhead traveling cranes manufacturing",
    },
    {
      NAICS22: "333923",
      "INDEX ITEM DESCRIPTION":
        "Pulleys (except power transmission), metal, manufacturing",
    },
    {
      NAICS22: "333923",
      "INDEX ITEM DESCRIPTION": "Ship cranes and derricks manufacturing",
    },
    {
      NAICS22: "333923",
      "INDEX ITEM DESCRIPTION": "Winches manufacturing",
    },
    {
      NAICS22: "333923",
      "INDEX ITEM DESCRIPTION": "Wire rope hoists manufacturing",
    },
    {
      NAICS22: "333924",
      "INDEX ITEM DESCRIPTION": "Aircraft engine cradles manufacturing",
    },
    {
      NAICS22: "333924",
      "INDEX ITEM DESCRIPTION": "Aircraft loading hoists manufacturing",
    },
    {
      NAICS22: "333924",
      "INDEX ITEM DESCRIPTION": "Bomb lifts manufacturing",
    },
    {
      NAICS22: "333924",
      "INDEX ITEM DESCRIPTION": "Cabs for industrial trucks manufacturing",
    },
    {
      NAICS22: "333924",
      "INDEX ITEM DESCRIPTION": "Carts, grocery, made from purchased wire",
    },
    {
      NAICS22: "333924",
      "INDEX ITEM DESCRIPTION": "Cranes, industrial truck, manufacturing",
    },
    {
      NAICS22: "333924",
      "INDEX ITEM DESCRIPTION": "Dollies manufacturing",
    },
    {
      NAICS22: "333924",
      "INDEX ITEM DESCRIPTION": "Drum cradles manufacturing",
    },
    {
      NAICS22: "333924",
      "INDEX ITEM DESCRIPTION": "Forklifts manufacturing",
    },
    {
      NAICS22: "333924",
      "INDEX ITEM DESCRIPTION": "Grocery carts made from purchased wire",
    },
    {
      NAICS22: "333924",
      "INDEX ITEM DESCRIPTION": "Hand trucks manufacturing",
    },
    {
      NAICS22: "333924",
      "INDEX ITEM DESCRIPTION": "Hoists, aircraft loading, manufacturing",
    },
    {
      NAICS22: "333924",
      "INDEX ITEM DESCRIPTION": "Industrial trucks and tractors manufacturing",
    },
    {
      NAICS22: "333924",
      "INDEX ITEM DESCRIPTION": "Mechanic's creepers manufacturing",
    },
    {
      NAICS22: "333924",
      "INDEX ITEM DESCRIPTION": "Mobile straddle carriers manufacturing",
    },
    {
      NAICS22: "333924",
      "INDEX ITEM DESCRIPTION": "Pallet movers manufacturing",
    },
    {
      NAICS22: "333924",
      "INDEX ITEM DESCRIPTION": "Pallet or skid jacks manufacturing",
    },
    {
      NAICS22: "333924",
      "INDEX ITEM DESCRIPTION": "Stackers, industrial, truck-type, manufacturing",
    },
    {
      NAICS22: "333924",
      "INDEX ITEM DESCRIPTION": "Stackers, portable (except farm), manufacturing",
    },
    {
      NAICS22: "333924",
      "INDEX ITEM DESCRIPTION": "Straddle carriers, mobile, manufacturing",
    },
    {
      NAICS22: "333924",
      "INDEX ITEM DESCRIPTION": "Tractors, industrial, manufacturing",
    },
    {
      NAICS22: "333924",
      "INDEX ITEM DESCRIPTION": "Trucks, industrial, manufacturing",
    },
    {
      NAICS22: "333924",
      "INDEX ITEM DESCRIPTION": "Unmanned and robotic forklifts manufacturing",
    },
    {
      NAICS22: "333924",
      "INDEX ITEM DESCRIPTION":
        "Unmanned and robotic pallet loaders and unloaders manufacturing",
    },
    {
      NAICS22: "333924",
      "INDEX ITEM DESCRIPTION": "Wheelbarrows manufacturing",
    },
    {
      NAICS22: "333991",
      "INDEX ITEM DESCRIPTION":
        "Buffing machines, handheld power-driven, manufacturing",
    },
    {
      NAICS22: "333991",
      "INDEX ITEM DESCRIPTION":
        "Cartridge (i.e., powder) handheld power-driven tools manufacturing",
    },
    {
      NAICS22: "333991",
      "INDEX ITEM DESCRIPTION":
        "Chain saws, handheld power-driven, manufacturing",
    },
    {
      NAICS22: "333991",
      "INDEX ITEM DESCRIPTION": "Chisels, handheld power-driven, manufacturing",
    },
    {
      NAICS22: "333991",
      "INDEX ITEM DESCRIPTION":
        "Circular saws, handheld power-driven, manufacturing",
    },
    {
      NAICS22: "333991",
      "INDEX ITEM DESCRIPTION":
        "Drills, handheld power-driven (except heavy construction and mining-type), manufacturing",
    },
    {
      NAICS22: "333991",
      "INDEX ITEM DESCRIPTION": "Grinders, handheld power-driven, manufacturing",
    },
    {
      NAICS22: "333991",
      "INDEX ITEM DESCRIPTION": "Handtools, power-driven, manufacturing",
    },
    {
      NAICS22: "333991",
      "INDEX ITEM DESCRIPTION":
        "Impact wrenches, handheld power-driven, manufacturing",
    },
    {
      NAICS22: "333991",
      "INDEX ITEM DESCRIPTION": "Jigsaws, handheld power-driven, manufacturing",
    },
    {
      NAICS22: "333991",
      "INDEX ITEM DESCRIPTION": "Nail guns, handheld power-driven, manufacturing",
    },
    {
      NAICS22: "333991",
      "INDEX ITEM DESCRIPTION":
        "Nailers and staplers, handheld power-driven, manufacturing",
    },
    {
      NAICS22: "333991",
      "INDEX ITEM DESCRIPTION":
        "Paint spray guns, handheld pneumatic, manufacturing",
    },
    {
      NAICS22: "333991",
      "INDEX ITEM DESCRIPTION": "Planers, handheld power-driven, manufacturing",
    },
    {
      NAICS22: "333991",
      "INDEX ITEM DESCRIPTION": "Polishers, handheld power-driven, manufacturing",
    },
    {
      NAICS22: "333991",
      "INDEX ITEM DESCRIPTION":
        "Powder actuated handheld power tools manufacturing",
    },
    {
      NAICS22: "333991",
      "INDEX ITEM DESCRIPTION": "Power-driven handtools manufacturing",
    },
    {
      NAICS22: "333991",
      "INDEX ITEM DESCRIPTION":
        "Riveting guns, handheld power-driven, manufacturing",
    },
    {
      NAICS22: "333991",
      "INDEX ITEM DESCRIPTION": "Routers, handheld power-driven, manufacturing",
    },
    {
      NAICS22: "333991",
      "INDEX ITEM DESCRIPTION": "Sanders, handheld power-driven, manufacturing",
    },
    {
      NAICS22: "333991",
      "INDEX ITEM DESCRIPTION": "Saws, handheld power-driven, manufacturing",
    },
    {
      NAICS22: "333991",
      "INDEX ITEM DESCRIPTION":
        "Screwdrivers and nut drivers, handheld power-driven, manufacturing",
    },
    {
      NAICS22: "333991",
      "INDEX ITEM DESCRIPTION":
        "Shears and nibblers, handheld power-driven, manufacturing",
    },
    {
      NAICS22: "333991",
      "INDEX ITEM DESCRIPTION":
        "Staplers and nailers, handheld power-driven, manufacturing",
    },
    {
      NAICS22: "333991",
      "INDEX ITEM DESCRIPTION": "Tools, handheld power-driven, manufacturing",
    },
    {
      NAICS22: "333991",
      "INDEX ITEM DESCRIPTION":
        "Wrenches, impact, handheld power-driven, manufacturing",
    },
    {
      NAICS22: "333992",
      "INDEX ITEM DESCRIPTION": "Arc-welding equipment manufacturing",
    },
    {
      NAICS22: "333992",
      "INDEX ITEM DESCRIPTION": "Electrode holders, welding, manufacturing",
    },
    {
      NAICS22: "333992",
      "INDEX ITEM DESCRIPTION": "Electrodes, welding, manufacturing",
    },
    {
      NAICS22: "333992",
      "INDEX ITEM DESCRIPTION": "Electron beam welding equipment manufacturing",
    },
    {
      NAICS22: "333992",
      "INDEX ITEM DESCRIPTION": "Gas welding equipment manufacturing",
    },
    {
      NAICS22: "333992",
      "INDEX ITEM DESCRIPTION":
        "Gas welding rods, coated or cored, manufacturing",
    },
    {
      NAICS22: "333992",
      "INDEX ITEM DESCRIPTION":
        "Generating apparatus and parts, welding, electrical, manufacturing",
    },
    {
      NAICS22: "333992",
      "INDEX ITEM DESCRIPTION": "Laser welding equipment manufacturing",
    },
    {
      NAICS22: "333992",
      "INDEX ITEM DESCRIPTION": "Plasma welding equipment manufacturing",
    },
    {
      NAICS22: "333992",
      "INDEX ITEM DESCRIPTION": "Resistance welding equipment manufacturing",
    },
    {
      NAICS22: "333992",
      "INDEX ITEM DESCRIPTION": "Seam welding equipment manufacturing",
    },
    {
      NAICS22: "333992",
      "INDEX ITEM DESCRIPTION":
        "Soldering equipment (except handheld) manufacturing",
    },
    {
      NAICS22: "333992",
      "INDEX ITEM DESCRIPTION": "Spot welding equipment manufacturing",
    },
    {
      NAICS22: "333992",
      "INDEX ITEM DESCRIPTION": "Ultrasonic welding equipment manufacturing",
    },
    {
      NAICS22: "333992",
      "INDEX ITEM DESCRIPTION": "Welding equipment manufacturing",
    },
    {
      NAICS22: "333992",
      "INDEX ITEM DESCRIPTION":
        "Welding wire or rods (i.e., coated, cored) manufacturing",
    },
    {
      NAICS22: "333993",
      "INDEX ITEM DESCRIPTION":
        "Bag opening, filling, and closing machines manufacturing",
    },
    {
      NAICS22: "333993",
      "INDEX ITEM DESCRIPTION":
        "Bottle washers, packaging machinery, manufacturing",
    },
    {
      NAICS22: "333993",
      "INDEX ITEM DESCRIPTION":
        "Bottling machinery (e.g., capping, filling, labeling, sterilizing, washing) manufacturing",
    },
    {
      NAICS22: "333993",
      "INDEX ITEM DESCRIPTION": "Bread wrapping machines manufacturing",
    },
    {
      NAICS22: "333993",
      "INDEX ITEM DESCRIPTION": "Canning machinery manufacturing",
    },
    {
      NAICS22: "333993",
      "INDEX ITEM DESCRIPTION":
        "Capping, sealing, and lidding packaging machinery manufacturing",
    },
    {
      NAICS22: "333993",
      "INDEX ITEM DESCRIPTION": "Carton filling machinery manufacturing",
    },
    {
      NAICS22: "333993",
      "INDEX ITEM DESCRIPTION":
        "Coding, dating, and imprinting packaging machinery manufacturing",
    },
    {
      NAICS22: "333993",
      "INDEX ITEM DESCRIPTION": "Food packaging machinery manufacturing",
    },
    {
      NAICS22: "333993",
      "INDEX ITEM DESCRIPTION":
        "Labeling (i.e., packaging) machinery manufacturing",
    },
    {
      NAICS22: "333993",
      "INDEX ITEM DESCRIPTION": "Packaging machinery manufacturing",
    },
    {
      NAICS22: "333993",
      "INDEX ITEM DESCRIPTION":
        "Testing, weighing, inspecting, packaging machinery manufacturing",
    },
    {
      NAICS22: "333993",
      "INDEX ITEM DESCRIPTION":
        "Thermoform, blister, and skin packaging machinery manufacturing",
    },
    {
      NAICS22: "333993",
      "INDEX ITEM DESCRIPTION":
        "Wrapping (i.e., packaging) machinery manufacturing",
    },
    {
      NAICS22: "333994",
      "INDEX ITEM DESCRIPTION": "Ceramic kilns and furnaces manufacturing",
    },
    {
      NAICS22: "333994",
      "INDEX ITEM DESCRIPTION": "Core baking and mold drying ovens manufacturing",
    },
    {
      NAICS22: "333994",
      "INDEX ITEM DESCRIPTION":
        "Dielectric industrial heating equipment manufacturing",
    },
    {
      NAICS22: "333994",
      "INDEX ITEM DESCRIPTION":
        "Distillation ovens, charcoal and coke, manufacturing",
    },
    {
      NAICS22: "333994",
      "INDEX ITEM DESCRIPTION": "Enameling ovens manufacturing",
    },
    {
      NAICS22: "333994",
      "INDEX ITEM DESCRIPTION":
        "Furnaces and ovens for drying and redrying, industrial process-type, manufacturing",
    },
    {
      NAICS22: "333994",
      "INDEX ITEM DESCRIPTION":
        "Furnaces and ovens, semiconductor wafer, manufacturing",
    },
    {
      NAICS22: "333994",
      "INDEX ITEM DESCRIPTION":
        "Furnaces, industrial and laboratory-type (except dental), manufacturing",
    },
    {
      NAICS22: "333994",
      "INDEX ITEM DESCRIPTION":
        "Garbage incinerators (except precast concrete) manufacturing",
    },
    {
      NAICS22: "333994",
      "INDEX ITEM DESCRIPTION":
        "Heat treating ovens, industrial process-type, manufacturing",
    },
    {
      NAICS22: "333994",
      "INDEX ITEM DESCRIPTION":
        "Incinerators (except precast concrete) manufacturing",
    },
    {
      NAICS22: "333994",
      "INDEX ITEM DESCRIPTION":
        "Induction heating equipment, industrial process-type, manufacturing",
    },
    {
      NAICS22: "333994",
      "INDEX ITEM DESCRIPTION": "Infrared ovens, industrial, manufacturing",
    },
    {
      NAICS22: "333994",
      "INDEX ITEM DESCRIPTION": "Japanning ovens manufacturing",
    },
    {
      NAICS22: "333994",
      "INDEX ITEM DESCRIPTION":
        "Kilns (except cement, chemical, wood) manufacturing",
    },
    {
      NAICS22: "333994",
      "INDEX ITEM DESCRIPTION": "Lacquering ovens manufacturing",
    },
    {
      NAICS22: "333994",
      "INDEX ITEM DESCRIPTION":
        "Metal melting furnaces, industrial, manufacturing",
    },
    {
      NAICS22: "333994",
      "INDEX ITEM DESCRIPTION":
        "Ovens, industrial process and laboratory-type, manufacturing",
    },
    {
      NAICS22: "333994",
      "INDEX ITEM DESCRIPTION": "Paint baking and drying ovens manufacturing",
    },
    {
      NAICS22: "333994",
      "INDEX ITEM DESCRIPTION": "Smelting ovens manufacturing",
    },
    {
      NAICS22: "333994",
      "INDEX ITEM DESCRIPTION": "Tile making kilns manufacturing",
    },
    {
      NAICS22: "333995",
      "INDEX ITEM DESCRIPTION": "Actuators, fluid power, manufacturing",
    },
    {
      NAICS22: "333995",
      "INDEX ITEM DESCRIPTION": "Cylinders, fluid power, manufacturing",
    },
    {
      NAICS22: "333995",
      "INDEX ITEM DESCRIPTION": "Electric linear actuators manufacturing",
    },
    {
      NAICS22: "333995",
      "INDEX ITEM DESCRIPTION": "Fluid power actuators manufacturing",
    },
    {
      NAICS22: "333995",
      "INDEX ITEM DESCRIPTION": "Fluid power cylinders manufacturing",
    },
    {
      NAICS22: "333995",
      "INDEX ITEM DESCRIPTION": "Gas spring cylinders manufacturing",
    },
    {
      NAICS22: "333995",
      "INDEX ITEM DESCRIPTION": "Hydraulic cylinders, fluid power, manufacturing",
    },
    {
      NAICS22: "333995",
      "INDEX ITEM DESCRIPTION": "Pneumatic cylinders, fluid power, manufacturing",
    },
    {
      NAICS22: "333996",
      "INDEX ITEM DESCRIPTION": "Fluid power motors manufacturing",
    },
    {
      NAICS22: "333996",
      "INDEX ITEM DESCRIPTION": "Fluid power pumps manufacturing",
    },
    {
      NAICS22: "333996",
      "INDEX ITEM DESCRIPTION": "Hydraulic pumps, fluid power, manufacturing",
    },
    {
      NAICS22: "333996",
      "INDEX ITEM DESCRIPTION": "Hydrostatic drives manufacturing",
    },
    {
      NAICS22: "333996",
      "INDEX ITEM DESCRIPTION": "Hydrostatic transmissions manufacturing",
    },
    {
      NAICS22: "333996",
      "INDEX ITEM DESCRIPTION": "Motors, fluid power, manufacturing",
    },
    {
      NAICS22: "333996",
      "INDEX ITEM DESCRIPTION": "Pneumatic pumps, fluid power, manufacturing",
    },
    {
      NAICS22: "333996",
      "INDEX ITEM DESCRIPTION": "Pumps, fluid power, manufacturing",
    },
    {
      NAICS22: "333998",
      "INDEX ITEM DESCRIPTION": "Aircraft carrier catapults manufacturing",
    },
    {
      NAICS22: "333998",
      "INDEX ITEM DESCRIPTION": "Baby scales manufacturing",
    },
    {
      NAICS22: "333998",
      "INDEX ITEM DESCRIPTION":
        "Balances, including laboratory-type, manufacturing",
    },
    {
      NAICS22: "333998",
      "INDEX ITEM DESCRIPTION":
        "Baling machinery (e.g., paper, scrap metal) manufacturing",
    },
    {
      NAICS22: "333998",
      "INDEX ITEM DESCRIPTION": "Bathroom scales manufacturing",
    },
    {
      NAICS22: "333998",
      "INDEX ITEM DESCRIPTION": "Bellows, industrial-type, manufacturing",
    },
    {
      NAICS22: "333998",
      "INDEX ITEM DESCRIPTION": "Bridge and gate lifting machinery manufacturing",
    },
    {
      NAICS22: "333998",
      "INDEX ITEM DESCRIPTION":
        "Centrifuges, industrial and laboratory-type, manufacturing",
    },
    {
      NAICS22: "333998",
      "INDEX ITEM DESCRIPTION": "Cremating ovens manufacturing",
    },
    {
      NAICS22: "333998",
      "INDEX ITEM DESCRIPTION": "Delicatessen scales manufacturing",
    },
    {
      NAICS22: "333998",
      "INDEX ITEM DESCRIPTION":
        "Filters, industrial and general purpose-type (except internal combustion engine, warm air furnace), manufacturing",
    },
    {
      NAICS22: "333998",
      "INDEX ITEM DESCRIPTION":
        "Gas generating machinery, general purpose-type, manufacturing",
    },
    {
      NAICS22: "333998",
      "INDEX ITEM DESCRIPTION": "Gas separating machinery manufacturing",
    },
    {
      NAICS22: "333998",
      "INDEX ITEM DESCRIPTION": "Gate and bridge lifting machinery manufacturing",
    },
    {
      NAICS22: "333998",
      "INDEX ITEM DESCRIPTION":
        "Ice crushers, industrial and commercial-type, manufacturing",
    },
    {
      NAICS22: "333998",
      "INDEX ITEM DESCRIPTION": "Industrial robot cells manufacturing",
    },
    {
      NAICS22: "333998",
      "INDEX ITEM DESCRIPTION": "Industrial robots manufacturing",
    },
    {
      NAICS22: "333998",
      "INDEX ITEM DESCRIPTION": "Industrial scales manufacturing",
    },
    {
      NAICS22: "333998",
      "INDEX ITEM DESCRIPTION": "Jacks, hydraulic and pneumatic, manufacturing",
    },
    {
      NAICS22: "333998",
      "INDEX ITEM DESCRIPTION": "Motor truck scales manufacturing",
    },
    {
      NAICS22: "333998",
      "INDEX ITEM DESCRIPTION": "Parcel post scales manufacturing",
    },
    {
      NAICS22: "333998",
      "INDEX ITEM DESCRIPTION": "Post office-type scales manufacturing",
    },
    {
      NAICS22: "333998",
      "INDEX ITEM DESCRIPTION": "Presses, metal baling, manufacturing",
    },
    {
      NAICS22: "333998",
      "INDEX ITEM DESCRIPTION": "Railroad track scales manufacturing",
    },
    {
      NAICS22: "333998",
      "INDEX ITEM DESCRIPTION":
        "Retail scales (e.g., butcher, delicatessen, produce) manufacturing",
    },
    {
      NAICS22: "333998",
      "INDEX ITEM DESCRIPTION":
        "Scales, including laboratory-type, manufacturing",
    },
    {
      NAICS22: "333998",
      "INDEX ITEM DESCRIPTION":
        "Screening and sifting machinery for general industrial use manufacturing",
    },
    {
      NAICS22: "333998",
      "INDEX ITEM DESCRIPTION":
        "Sieves and screening equipment, general purpose-type, manufacturing",
    },
    {
      NAICS22: "333998",
      "INDEX ITEM DESCRIPTION": "Sludge tables manufacturing",
    },
    {
      NAICS22: "333998",
      "INDEX ITEM DESCRIPTION":
        "Sprinkler systems, automatic fire, manufacturing",
    },
    {
      NAICS22: "333998",
      "INDEX ITEM DESCRIPTION": "Steam separating machinery manufacturing",
    },
    {
      NAICS22: "333998",
      "INDEX ITEM DESCRIPTION": "Strainers, pipeline, manufacturing",
    },
    {
      NAICS22: "333998",
      "INDEX ITEM DESCRIPTION": "Vapor separating machinery manufacturing",
    },
    {
      NAICS22: "333998",
      "INDEX ITEM DESCRIPTION": "Vehicle scales manufacturing",
    },
    {
      NAICS22: "333998",
      "INDEX ITEM DESCRIPTION": "Weather vanes manufacturing",
    },
    {
      NAICS22: "334111",
      "INDEX ITEM DESCRIPTION": "Analog computers manufacturing",
    },
    {
      NAICS22: "334111",
      "INDEX ITEM DESCRIPTION": "Computer servers manufacturing",
    },
    {
      NAICS22: "334111",
      "INDEX ITEM DESCRIPTION": "Computers manufacturing",
    },
    {
      NAICS22: "334111",
      "INDEX ITEM DESCRIPTION": "Digital computers manufacturing",
    },
    {
      NAICS22: "334111",
      "INDEX ITEM DESCRIPTION": "Hybrid computers manufacturing",
    },
    {
      NAICS22: "334111",
      "INDEX ITEM DESCRIPTION": "Laptop computers manufacturing",
    },
    {
      NAICS22: "334111",
      "INDEX ITEM DESCRIPTION": "Mainframe computers manufacturing",
    },
    {
      NAICS22: "334111",
      "INDEX ITEM DESCRIPTION": "Microcomputers manufacturing",
    },
    {
      NAICS22: "334111",
      "INDEX ITEM DESCRIPTION": "Minicomputers manufacturing",
    },
    {
      NAICS22: "334111",
      "INDEX ITEM DESCRIPTION": "Notebook computers manufacturing",
    },
    {
      NAICS22: "334111",
      "INDEX ITEM DESCRIPTION": "Personal computers manufacturing",
    },
    {
      NAICS22: "334111",
      "INDEX ITEM DESCRIPTION": "Portable computers manufacturing",
    },
    {
      NAICS22: "334111",
      "INDEX ITEM DESCRIPTION": "Tablet computers manufacturing",
    },
    {
      NAICS22: "334111",
      "INDEX ITEM DESCRIPTION": "Workstations, computer, manufacturing",
    },
    {
      NAICS22: "334112",
      "INDEX ITEM DESCRIPTION": "CD-ROM drives manufacturing",
    },
    {
      NAICS22: "334112",
      "INDEX ITEM DESCRIPTION": "Direct access storage devices manufacturing",
    },
    {
      NAICS22: "334112",
      "INDEX ITEM DESCRIPTION": "Disk drives, computer, manufacturing",
    },
    {
      NAICS22: "334112",
      "INDEX ITEM DESCRIPTION":
        "DVD (digital video disc) drives, computer peripheral equipment, manufacturing",
    },
    {
      NAICS22: "334112",
      "INDEX ITEM DESCRIPTION":
        "Flexible (i.e., floppy) magnetic disk drives manufacturing",
    },
    {
      NAICS22: "334112",
      "INDEX ITEM DESCRIPTION": "Floppy disk drives manufacturing",
    },
    {
      NAICS22: "334112",
      "INDEX ITEM DESCRIPTION":
        "Hard disk drives, computer peripheral equipment, manufacturing",
    },
    {
      NAICS22: "334112",
      "INDEX ITEM DESCRIPTION":
        "Magnetic/optical combination storage units for computers manufacturing",
    },
    {
      NAICS22: "334112",
      "INDEX ITEM DESCRIPTION": "Optical disk drives manufacturing",
    },
    {
      NAICS22: "334112",
      "INDEX ITEM DESCRIPTION": "Storage devices, computer, manufacturing",
    },
    {
      NAICS22: "334112",
      "INDEX ITEM DESCRIPTION":
        "Tape storage units (e.g., drive backups), computer peripheral equipment, manufacturing",
    },
    {
      NAICS22: "334112",
      "INDEX ITEM DESCRIPTION":
        "USB flash drives (e.g., thumbdrives, jumpdrives) manufacturing",
    },
    {
      NAICS22: "334118",
      "INDEX ITEM DESCRIPTION": "ATMs (automated teller machines) manufacturing",
    },
    {
      NAICS22: "334118",
      "INDEX ITEM DESCRIPTION": "Automated teller machines (ATM) manufacturing",
    },
    {
      NAICS22: "334118",
      "INDEX ITEM DESCRIPTION": "Bar code scanners manufacturing",
    },
    {
      NAICS22: "334118",
      "INDEX ITEM DESCRIPTION":
        "Biometrics system input devices (e.g., retinal scan, iris pattern recognition, hand geometry) manufacturing",
    },
    {
      NAICS22: "334118",
      "INDEX ITEM DESCRIPTION": "Computer input/output equipment manufacturing",
    },
    {
      NAICS22: "334118",
      "INDEX ITEM DESCRIPTION": "Computer terminals manufacturing",
    },
    {
      NAICS22: "334118",
      "INDEX ITEM DESCRIPTION":
        "Flat panel displays (i.e., complete units), computer peripheral equipment, manufacturing",
    },
    {
      NAICS22: "334118",
      "INDEX ITEM DESCRIPTION": "Funds transfer devices manufacturing",
    },
    {
      NAICS22: "334118",
      "INDEX ITEM DESCRIPTION": "Input/output equipment, computer, manufacturing",
    },
    {
      NAICS22: "334118",
      "INDEX ITEM DESCRIPTION": "Joystick devices manufacturing",
    },
    {
      NAICS22: "334118",
      "INDEX ITEM DESCRIPTION":
        "Keyboards, computer peripheral equipment, manufacturing",
    },
    {
      NAICS22: "334118",
      "INDEX ITEM DESCRIPTION": "Lottery ticket sales terminals manufacturing",
    },
    {
      NAICS22: "334118",
      "INDEX ITEM DESCRIPTION":
        "Magnetic ink recognition devices, computer peripheral equipment, manufacturing",
    },
    {
      NAICS22: "334118",
      "INDEX ITEM DESCRIPTION":
        "Monitors, computer peripheral equipment, manufacturing",
    },
    {
      NAICS22: "334118",
      "INDEX ITEM DESCRIPTION":
        "Mouse devices, computer peripheral equipment, manufacturing",
    },
    {
      NAICS22: "334118",
      "INDEX ITEM DESCRIPTION": "Optical readers and scanners manufacturing",
    },
    {
      NAICS22: "334118",
      "INDEX ITEM DESCRIPTION":
        "Overhead projectors, computer peripheral-type, manufacturing",
    },
    {
      NAICS22: "334118",
      "INDEX ITEM DESCRIPTION": "Plotters, computer, manufacturing",
    },
    {
      NAICS22: "334118",
      "INDEX ITEM DESCRIPTION": "Point of sale terminals manufacturing",
    },
    {
      NAICS22: "334118",
      "INDEX ITEM DESCRIPTION":
        "Pointing devices, computer peripheral equipment, manufacturing",
    },
    {
      NAICS22: "334118",
      "INDEX ITEM DESCRIPTION": "Printers, computer, manufacturing",
    },
    {
      NAICS22: "334118",
      "INDEX ITEM DESCRIPTION": "Smart card readers manufacturing",
    },
    {
      NAICS22: "334118",
      "INDEX ITEM DESCRIPTION":
        "Teleprinters (i.e., computer terminals) manufacturing",
    },
    {
      NAICS22: "334118",
      "INDEX ITEM DESCRIPTION": "Terminals, computer, manufacturing",
    },
    {
      NAICS22: "334210",
      "INDEX ITEM DESCRIPTION":
        "Carrier equipment (i.e., analog, digital), telephone, manufacturing",
    },
    {
      NAICS22: "334210",
      "INDEX ITEM DESCRIPTION":
        "Central office and switching equipment, telephone, manufacturing",
    },
    {
      NAICS22: "334210",
      "INDEX ITEM DESCRIPTION":
        "Communications headgear, telephone, manufacturing",
    },
    {
      NAICS22: "334210",
      "INDEX ITEM DESCRIPTION":
        "Cordless telephones (except cellular) manufacturing",
    },
    {
      NAICS22: "334210",
      "INDEX ITEM DESCRIPTION":
        "Data communications equipment (e.g., bridges, gateways, routers) manufacturing",
    },
    {
      NAICS22: "334210",
      "INDEX ITEM DESCRIPTION": "Facsimile equipment, stand-alone, manufacturing",
    },
    {
      NAICS22: "334210",
      "INDEX ITEM DESCRIPTION": "Keysets, telephone, manufacturing",
    },
    {
      NAICS22: "334210",
      "INDEX ITEM DESCRIPTION":
        "Local area network (LAN) communications equipment (e.g., bridges, gateways, routers) manufacturing",
    },
    {
      NAICS22: "334210",
      "INDEX ITEM DESCRIPTION": "Modems, carrier equipment, manufacturing",
    },
    {
      NAICS22: "334210",
      "INDEX ITEM DESCRIPTION": "Multiplex equipment, telephone, manufacturing",
    },
    {
      NAICS22: "334210",
      "INDEX ITEM DESCRIPTION":
        "PBX (private branch exchange) equipment manufacturing",
    },
    {
      NAICS22: "334210",
      "INDEX ITEM DESCRIPTION":
        "Private branch exchange (PBX) equipment manufacturing",
    },
    {
      NAICS22: "334210",
      "INDEX ITEM DESCRIPTION":
        "Repeater and transceiver equipment, carrier line, manufacturing",
    },
    {
      NAICS22: "334210",
      "INDEX ITEM DESCRIPTION":
        "Subscriber loop equipment, telephone, manufacturing",
    },
    {
      NAICS22: "334210",
      "INDEX ITEM DESCRIPTION": "Switching equipment, telephone, manufacturing",
    },
    {
      NAICS22: "334210",
      "INDEX ITEM DESCRIPTION": "Telephone answering machines manufacturing",
    },
    {
      NAICS22: "334210",
      "INDEX ITEM DESCRIPTION": "Telephone carrier line equipment manufacturing",
    },
    {
      NAICS22: "334210",
      "INDEX ITEM DESCRIPTION":
        "Telephone carrier switching equipment manufacturing",
    },
    {
      NAICS22: "334210",
      "INDEX ITEM DESCRIPTION":
        "Telephones (except cellular telephone) manufacturing",
    },
    {
      NAICS22: "334210",
      "INDEX ITEM DESCRIPTION":
        "Telephones, coin- or card-operated, manufacturing",
    },
    {
      NAICS22: "334210",
      "INDEX ITEM DESCRIPTION":
        "Toll switching equipment, telephone, manufacturing",
    },
    {
      NAICS22: "334210",
      "INDEX ITEM DESCRIPTION":
        "Wide area network communications equipment (e.g., bridges, gateways, routers) manufacturing",
    },
    {
      NAICS22: "334220",
      "INDEX ITEM DESCRIPTION":
        "Airborne radio communications equipment manufacturing",
    },
    {
      NAICS22: "334220",
      "INDEX ITEM DESCRIPTION":
        "Amplifiers (e.g., RF power and IF), broadcast and studio equipment, manufacturing",
    },
    {
      NAICS22: "334220",
      "INDEX ITEM DESCRIPTION": "Antennas, satellite, manufacturing",
    },
    {
      NAICS22: "334220",
      "INDEX ITEM DESCRIPTION":
        "Antennas, transmitting and receiving, manufacturing",
    },
    {
      NAICS22: "334220",
      "INDEX ITEM DESCRIPTION": "Automobile antennas manufacturing",
    },
    {
      NAICS22: "334220",
      "INDEX ITEM DESCRIPTION":
        "Broadcast equipment (including studio), for radio and television, manufacturing",
    },
    {
      NAICS22: "334220",
      "INDEX ITEM DESCRIPTION": "Cable decoders manufacturing",
    },
    {
      NAICS22: "334220",
      "INDEX ITEM DESCRIPTION":
        "Cable television transmission and receiving equipment manufacturing",
    },
    {
      NAICS22: "334220",
      "INDEX ITEM DESCRIPTION": "Cameras, television, manufacturing",
    },
    {
      NAICS22: "334220",
      "INDEX ITEM DESCRIPTION": "CB (citizens' band) radios manufacturing",
    },
    {
      NAICS22: "334220",
      "INDEX ITEM DESCRIPTION":
        "Cellular telephones (new and rebuilt) manufacturing",
    },
    {
      NAICS22: "334220",
      "INDEX ITEM DESCRIPTION": "Citizens' band (CB) radios manufacturing",
    },
    {
      NAICS22: "334220",
      "INDEX ITEM DESCRIPTION":
        "Closed-circuit television equipment manufacturing",
    },
    {
      NAICS22: "334220",
      "INDEX ITEM DESCRIPTION":
        "Communications equipment, mobile and microwave, manufacturing",
    },
    {
      NAICS22: "334220",
      "INDEX ITEM DESCRIPTION":
        "Earth station communications equipment manufacturing",
    },
    {
      NAICS22: "334220",
      "INDEX ITEM DESCRIPTION":
        "Global positioning system (GPS) equipment manufacturing",
    },
    {
      NAICS22: "334220",
      "INDEX ITEM DESCRIPTION":
        "GPS (global positioning system) equipment manufacturing",
    },
    {
      NAICS22: "334220",
      "INDEX ITEM DESCRIPTION":
        "Marine radio communications equipment manufacturing",
    },
    {
      NAICS22: "334220",
      "INDEX ITEM DESCRIPTION":
        "Microphones, broadcast and studio equipment, manufacturing",
    },
    {
      NAICS22: "334220",
      "INDEX ITEM DESCRIPTION":
        "Microwave communications equipment manufacturing",
    },
    {
      NAICS22: "334220",
      "INDEX ITEM DESCRIPTION": "Mobile communications equipment manufacturing",
    },
    {
      NAICS22: "334220",
      "INDEX ITEM DESCRIPTION": "Pagers manufacturing",
    },
    {
      NAICS22: "334220",
      "INDEX ITEM DESCRIPTION":
        "Radio transmitting antennas and ground equipment manufacturing",
    },
    {
      NAICS22: "334220",
      "INDEX ITEM DESCRIPTION":
        "Receiver-transmitter units (i.e., transceivers) manufacturing",
    },
    {
      NAICS22: "334220",
      "INDEX ITEM DESCRIPTION": "Satellite antennas manufacturing",
    },
    {
      NAICS22: "334220",
      "INDEX ITEM DESCRIPTION":
        "Satellite communications equipment manufacturing",
    },
    {
      NAICS22: "334220",
      "INDEX ITEM DESCRIPTION": "Smartphones (new and rebuilt) manufacturing",
    },
    {
      NAICS22: "334220",
      "INDEX ITEM DESCRIPTION": "Smartwatches manufacturing",
    },
    {
      NAICS22: "334220",
      "INDEX ITEM DESCRIPTION": "Space satellites, communications, manufacturing",
    },
    {
      NAICS22: "334220",
      "INDEX ITEM DESCRIPTION":
        "Studio equipment, radio and television broadcasting, manufacturing",
    },
    {
      NAICS22: "334220",
      "INDEX ITEM DESCRIPTION":
        "Telephones, cellular (new and rebuilt), manufacturing",
    },
    {
      NAICS22: "334220",
      "INDEX ITEM DESCRIPTION":
        "Television transmitting antennas and ground equipment manufacturing",
    },
    {
      NAICS22: "334220",
      "INDEX ITEM DESCRIPTION":
        "Television, closed-circuit equipment, manufacturing",
    },
    {
      NAICS22: "334220",
      "INDEX ITEM DESCRIPTION":
        "Transceivers (i.e., transmitter-receiver units) manufacturing",
    },
    {
      NAICS22: "334220",
      "INDEX ITEM DESCRIPTION":
        "Video cameras (except household-type) manufacturing",
    },
    {
      NAICS22: "334220",
      "INDEX ITEM DESCRIPTION":
        "Video projectors (except household-type, motion picture theater) manufacturing",
    },
    {
      NAICS22: "334290",
      "INDEX ITEM DESCRIPTION":
        "Alarm system central monitoring equipment manufacturing",
    },
    {
      NAICS22: "334290",
      "INDEX ITEM DESCRIPTION": "Alarm systems and equipment manufacturing",
    },
    {
      NAICS22: "334290",
      "INDEX ITEM DESCRIPTION": "Automotive theft alarm systems manufacturing",
    },
    {
      NAICS22: "334290",
      "INDEX ITEM DESCRIPTION":
        "Burglar alarm systems and equipment manufacturing",
    },
    {
      NAICS22: "334290",
      "INDEX ITEM DESCRIPTION": "Car alarm manufacturing",
    },
    {
      NAICS22: "334290",
      "INDEX ITEM DESCRIPTION": "Carbon monoxide detectors manufacturing",
    },
    {
      NAICS22: "334290",
      "INDEX ITEM DESCRIPTION":
        "Controlling equipment, street light, manufacturing",
    },
    {
      NAICS22: "334290",
      "INDEX ITEM DESCRIPTION": "Fire detection and alarm systems manufacturing",
    },
    {
      NAICS22: "334290",
      "INDEX ITEM DESCRIPTION": "Glass breakage detection and signaling devices",
    },
    {
      NAICS22: "334290",
      "INDEX ITEM DESCRIPTION": "Intercom systems and equipment manufacturing",
    },
    {
      NAICS22: "334290",
      "INDEX ITEM DESCRIPTION":
        "Motion alarms (e.g., swimming pool, perimeter) manufacturing",
    },
    {
      NAICS22: "334290",
      "INDEX ITEM DESCRIPTION":
        "Motion detectors, security system, manufacturing",
    },
    {
      NAICS22: "334290",
      "INDEX ITEM DESCRIPTION":
        "Portable intrusion detection and signaling devices manufacturing",
    },
    {
      NAICS22: "334290",
      "INDEX ITEM DESCRIPTION": "Railroad signaling equipment manufacturing",
    },
    {
      NAICS22: "334290",
      "INDEX ITEM DESCRIPTION":
        "Remote control units (e.g., garage door, television) manufacturing",
    },
    {
      NAICS22: "334290",
      "INDEX ITEM DESCRIPTION":
        "Signals (e.g., highway, pedestrian, railway, traffic) manufacturing",
    },
    {
      NAICS22: "334290",
      "INDEX ITEM DESCRIPTION":
        "Sirens (e.g., air raid, industrial, marine, vehicle) manufacturing",
    },
    {
      NAICS22: "334290",
      "INDEX ITEM DESCRIPTION": "Smoke detectors manufacturing",
    },
    {
      NAICS22: "334290",
      "INDEX ITEM DESCRIPTION":
        "Theft prevention signaling devices (e.g., door entrance annunciation, holdup signaling devices, personal duress signaling devices), manufacturing",
    },
    {
      NAICS22: "334290",
      "INDEX ITEM DESCRIPTION":
        "Traffic advisory and signalling systems manufacturing",
    },
    {
      NAICS22: "334290",
      "INDEX ITEM DESCRIPTION": "Traffic signals manufacturing",
    },
    {
      NAICS22: "334290",
      "INDEX ITEM DESCRIPTION": "Video-based stadium displays manufacturing",
    },
    {
      NAICS22: "334310",
      "INDEX ITEM DESCRIPTION":
        "Amplifiers (e.g., auto, home, musical instrument, public address) manufacturing",
    },
    {
      NAICS22: "334310",
      "INDEX ITEM DESCRIPTION": "Automobile radio receivers manufacturing",
    },
    {
      NAICS22: "334310",
      "INDEX ITEM DESCRIPTION": "Camcorders manufacturing",
    },
    {
      NAICS22: "334310",
      "INDEX ITEM DESCRIPTION": "Car stereos manufacturing",
    },
    {
      NAICS22: "334310",
      "INDEX ITEM DESCRIPTION": "Clock radios manufacturing",
    },
    {
      NAICS22: "334310",
      "INDEX ITEM DESCRIPTION": "Coin- or card-operated jukebox manufacturing",
    },
    {
      NAICS22: "334310",
      "INDEX ITEM DESCRIPTION":
        "Compact disc players (e.g., automotive, household-type) manufacturing",
    },
    {
      NAICS22: "334310",
      "INDEX ITEM DESCRIPTION": "Digital video disc players manufacturing",
    },
    {
      NAICS22: "334310",
      "INDEX ITEM DESCRIPTION": "DVD (digital video disc) players manufacturing",
    },
    {
      NAICS22: "334310",
      "INDEX ITEM DESCRIPTION": "E-book readers (i.e., dedicated) manufacturing",
    },
    {
      NAICS22: "334310",
      "INDEX ITEM DESCRIPTION": "Home stereo systems manufacturing",
    },
    {
      NAICS22: "334310",
      "INDEX ITEM DESCRIPTION":
        "Home tape recorders and players (e.g., cartridge, cassette, reel) manufacturing",
    },
    {
      NAICS22: "334310",
      "INDEX ITEM DESCRIPTION":
        "Home theater audio and video equipment manufacturing",
    },
    {
      NAICS22: "334310",
      "INDEX ITEM DESCRIPTION": "Jukeboxes manufacturing",
    },
    {
      NAICS22: "334310",
      "INDEX ITEM DESCRIPTION": "Loudspeakers manufacturing",
    },
    {
      NAICS22: "334310",
      "INDEX ITEM DESCRIPTION":
        "Microphones (except broadcast and studio equipment) manufacturing",
    },
    {
      NAICS22: "334310",
      "INDEX ITEM DESCRIPTION":
        "Personal audio and video headsets, including virtual reality headsets, manufacturing",
    },
    {
      NAICS22: "334310",
      "INDEX ITEM DESCRIPTION": "Portable stereo systems manufacturing",
    },
    {
      NAICS22: "334310",
      "INDEX ITEM DESCRIPTION": "Projection television manufacturing",
    },
    {
      NAICS22: "334310",
      "INDEX ITEM DESCRIPTION":
        "Public address systems and equipment manufacturing",
    },
    {
      NAICS22: "334310",
      "INDEX ITEM DESCRIPTION": "Radio headphones manufacturing",
    },
    {
      NAICS22: "334310",
      "INDEX ITEM DESCRIPTION": "Radio receiving sets manufacturing",
    },
    {
      NAICS22: "334310",
      "INDEX ITEM DESCRIPTION": "Speaker systems manufacturing",
    },
    {
      NAICS22: "334310",
      "INDEX ITEM DESCRIPTION":
        "Tape players and recorders, household-type, manufacturing",
    },
    {
      NAICS22: "334310",
      "INDEX ITEM DESCRIPTION": "Television (TV) sets manufacturing",
    },
    {
      NAICS22: "334310",
      "INDEX ITEM DESCRIPTION": "TV (television) sets manufacturing",
    },
    {
      NAICS22: "334310",
      "INDEX ITEM DESCRIPTION": "VCR (video cassette recorder) manufacturing",
    },
    {
      NAICS22: "334310",
      "INDEX ITEM DESCRIPTION": "Video cameras, household-type, manufacturing",
    },
    {
      NAICS22: "334310",
      "INDEX ITEM DESCRIPTION": "Video cassette recorders (VCR) manufacturing",
    },
    {
      NAICS22: "334310",
      "INDEX ITEM DESCRIPTION": "Video projectors, household-type, manufacturing",
    },
    {
      NAICS22: "334412",
      "INDEX ITEM DESCRIPTION": "Circuit boards, printed, bare, manufacturing",
    },
    {
      NAICS22: "334412",
      "INDEX ITEM DESCRIPTION": "Flexible wiring boards, bare, manufacturing",
    },
    {
      NAICS22: "334412",
      "INDEX ITEM DESCRIPTION": "Printed circuit boards, bare, manufacturing",
    },
    {
      NAICS22: "334413",
      "INDEX ITEM DESCRIPTION":
        "Diodes, solid-state (e.g., germanium, silicon), manufacturing",
    },
    {
      NAICS22: "334413",
      "INDEX ITEM DESCRIPTION": "Fuel cells, solid-state, manufacturing",
    },
    {
      NAICS22: "334413",
      "INDEX ITEM DESCRIPTION": "Gunn effect devices manufacturing",
    },
    {
      NAICS22: "334413",
      "INDEX ITEM DESCRIPTION": "Hall effect devices manufacturing",
    },
    {
      NAICS22: "334413",
      "INDEX ITEM DESCRIPTION": "Hybrid integrated circuits manufacturing",
    },
    {
      NAICS22: "334413",
      "INDEX ITEM DESCRIPTION": "Infrared sensors, solid-state, manufacturing",
    },
    {
      NAICS22: "334413",
      "INDEX ITEM DESCRIPTION": "Integrated microcircuits manufacturing",
    },
    {
      NAICS22: "334413",
      "INDEX ITEM DESCRIPTION": "Laser diodes manufacturing",
    },
    {
      NAICS22: "334413",
      "INDEX ITEM DESCRIPTION": "LED (light emitting diode) manufacturing",
    },
    {
      NAICS22: "334413",
      "INDEX ITEM DESCRIPTION": "Light emitting diodes (LED) manufacturing",
    },
    {
      NAICS22: "334413",
      "INDEX ITEM DESCRIPTION": "Memory chip, semiconductor, manufacturing",
    },
    {
      NAICS22: "334413",
      "INDEX ITEM DESCRIPTION": "Metal oxide silicon (MOS) devices manufacturing",
    },
    {
      NAICS22: "334413",
      "INDEX ITEM DESCRIPTION": "Microcontroller chip manufacturing",
    },
    {
      NAICS22: "334413",
      "INDEX ITEM DESCRIPTION": "Microprocessor chip manufacturing",
    },
    {
      NAICS22: "334413",
      "INDEX ITEM DESCRIPTION":
        "Monolithic integrated circuits (solid-state) manufacturing",
    },
    {
      NAICS22: "334413",
      "INDEX ITEM DESCRIPTION": "MOS (metal oxide silicon) devices manufacturing",
    },
    {
      NAICS22: "334413",
      "INDEX ITEM DESCRIPTION": "Optoelectronic devices manufacturing",
    },
    {
      NAICS22: "334413",
      "INDEX ITEM DESCRIPTION":
        "Photoelectric cells, solid-state (e.g., electronic eye), manufacturing",
    },
    {
      NAICS22: "334413",
      "INDEX ITEM DESCRIPTION": "Photonic integrated circuits manufacturing",
    },
    {
      NAICS22: "334413",
      "INDEX ITEM DESCRIPTION": "Photovoltaic cells manufacturing",
    },
    {
      NAICS22: "334413",
      "INDEX ITEM DESCRIPTION":
        "Photovoltaic devices, solid-state, manufacturing",
    },
    {
      NAICS22: "334413",
      "INDEX ITEM DESCRIPTION": "Rectifiers, semiconductor, manufacturing",
    },
    {
      NAICS22: "334413",
      "INDEX ITEM DESCRIPTION":
        "Semiconductor circuit networks (i.e., solid-state integrated circuits) manufacturing",
    },
    {
      NAICS22: "334413",
      "INDEX ITEM DESCRIPTION": "Semiconductor devices manufacturing",
    },
    {
      NAICS22: "334413",
      "INDEX ITEM DESCRIPTION": "Semiconductor dice and wafers manufacturing",
    },
    {
      NAICS22: "334413",
      "INDEX ITEM DESCRIPTION": "Semiconductor memory chips manufacturing",
    },
    {
      NAICS22: "334413",
      "INDEX ITEM DESCRIPTION": "Silicon wafers, chemically doped, manufacturing",
    },
    {
      NAICS22: "334413",
      "INDEX ITEM DESCRIPTION": "Silicon wave guides manufacturing",
    },
    {
      NAICS22: "334413",
      "INDEX ITEM DESCRIPTION": "Solar cells manufacturing",
    },
    {
      NAICS22: "334413",
      "INDEX ITEM DESCRIPTION":
        "Static converters, integrated circuits, manufacturing",
    },
    {
      NAICS22: "334413",
      "INDEX ITEM DESCRIPTION": "Thin film integrated circuits manufacturing",
    },
    {
      NAICS22: "334413",
      "INDEX ITEM DESCRIPTION": "Thyristors manufacturing",
    },
    {
      NAICS22: "334413",
      "INDEX ITEM DESCRIPTION": "Transistors manufacturing",
    },
    {
      NAICS22: "334413",
      "INDEX ITEM DESCRIPTION":
        "Voltage regulators, integrated circuits, manufacturing",
    },
    {
      NAICS22: "334413",
      "INDEX ITEM DESCRIPTION": "Wafers (semiconductor devices) manufacturing",
    },
    {
      NAICS22: "334416",
      "INDEX ITEM DESCRIPTION":
        "Capacitors, electronic, fixed and variable, manufacturing",
    },
    {
      NAICS22: "334416",
      "INDEX ITEM DESCRIPTION": "Chokes for electronic circuitry manufacturing",
    },
    {
      NAICS22: "334416",
      "INDEX ITEM DESCRIPTION": "Condensers, electronic, manufacturing",
    },
    {
      NAICS22: "334416",
      "INDEX ITEM DESCRIPTION":
        "Inductors, electronic component-type (e.g., chokes, coils, transformers), manufacturing",
    },
    {
      NAICS22: "334416",
      "INDEX ITEM DESCRIPTION": "Resistors, electronic, manufacturing",
    },
    {
      NAICS22: "334416",
      "INDEX ITEM DESCRIPTION":
        "Telephone and telegraph transformers, electronic component-type, manufacturing",
    },
    {
      NAICS22: "334416",
      "INDEX ITEM DESCRIPTION": "Thermistors manufacturing",
    },
    {
      NAICS22: "334416",
      "INDEX ITEM DESCRIPTION":
        "Transformers, electronic component-types, manufacturing",
    },
    {
      NAICS22: "334416",
      "INDEX ITEM DESCRIPTION": "Varistors manufacturing",
    },
    {
      NAICS22: "334417",
      "INDEX ITEM DESCRIPTION": "Coaxial connectors manufacturing",
    },
    {
      NAICS22: "334417",
      "INDEX ITEM DESCRIPTION":
        "Connectors, electronic (e.g., coaxial, cylindrical, printed circuit, rack and panel), manufacturing",
    },
    {
      NAICS22: "334417",
      "INDEX ITEM DESCRIPTION":
        "Cylindrical connectors, electronic, manufacturing",
    },
    {
      NAICS22: "334417",
      "INDEX ITEM DESCRIPTION": "Fiber optic connectors manufacturing",
    },
    {
      NAICS22: "334417",
      "INDEX ITEM DESCRIPTION": "Planar cable connectors manufacturing",
    },
    {
      NAICS22: "334417",
      "INDEX ITEM DESCRIPTION": "Rack and panel connectors manufacturing",
    },
    {
      NAICS22: "334418",
      "INDEX ITEM DESCRIPTION": "Loaded computer boards manufacturing",
    },
    {
      NAICS22: "334418",
      "INDEX ITEM DESCRIPTION": "Loading printed circuit boards",
    },
    {
      NAICS22: "334418",
      "INDEX ITEM DESCRIPTION": "Memory boards manufacturing",
    },
    {
      NAICS22: "334418",
      "INDEX ITEM DESCRIPTION": "Peripheral controller boards manufacturing",
    },
    {
      NAICS22: "334418",
      "INDEX ITEM DESCRIPTION": "Personal computer modems manufacturing",
    },
    {
      NAICS22: "334418",
      "INDEX ITEM DESCRIPTION": "Plotter controller boards manufacturing",
    },
    {
      NAICS22: "334418",
      "INDEX ITEM DESCRIPTION": "Printed circuit assemblies manufacturing",
    },
    {
      NAICS22: "334418",
      "INDEX ITEM DESCRIPTION": "Printed circuit boards loading",
    },
    {
      NAICS22: "334419",
      "INDEX ITEM DESCRIPTION": "Cathode ray tubes (CRT) manufacturing",
    },
    {
      NAICS22: "334419",
      "INDEX ITEM DESCRIPTION":
        "Computer cable sets (e.g., monitor, printer) manufacturing",
    },
    {
      NAICS22: "334419",
      "INDEX ITEM DESCRIPTION": "CRT (cathode ray tube) manufacturing",
    },
    {
      NAICS22: "334419",
      "INDEX ITEM DESCRIPTION":
        "Crystals and crystal assemblies, electronic, manufacturing",
    },
    {
      NAICS22: "334419",
      "INDEX ITEM DESCRIPTION":
        "Electron tube parts (e.g., bases, getters, guns) (except glass blanks) manufacturing",
    },
    {
      NAICS22: "334419",
      "INDEX ITEM DESCRIPTION": "Electron tubes manufacturing",
    },
    {
      NAICS22: "334419",
      "INDEX ITEM DESCRIPTION":
        "Filters, electronic component-type, manufacturing",
    },
    {
      NAICS22: "334419",
      "INDEX ITEM DESCRIPTION":
        "Harness assemblies for electronic use manufacturing",
    },
    {
      NAICS22: "334419",
      "INDEX ITEM DESCRIPTION":
        "Heads (e.g., recording, read/write) manufacturing",
    },
    {
      NAICS22: "334419",
      "INDEX ITEM DESCRIPTION": "Klystron tubes manufacturing",
    },
    {
      NAICS22: "334419",
      "INDEX ITEM DESCRIPTION":
        "LCD (liquid crystal display) unit screens manufacturing",
    },
    {
      NAICS22: "334419",
      "INDEX ITEM DESCRIPTION": "Magnetron tubes manufacturing",
    },
    {
      NAICS22: "334419",
      "INDEX ITEM DESCRIPTION": "Microwave components manufacturing",
    },
    {
      NAICS22: "334419",
      "INDEX ITEM DESCRIPTION": "Needles, phonograph and styli, manufacturing",
    },
    {
      NAICS22: "334419",
      "INDEX ITEM DESCRIPTION": "Piezoelectric crystals manufacturing",
    },
    {
      NAICS22: "334419",
      "INDEX ITEM DESCRIPTION": "Piezoelectric devices manufacturing",
    },
    {
      NAICS22: "334419",
      "INDEX ITEM DESCRIPTION": "Printed circuit laminates manufacturing",
    },
    {
      NAICS22: "334419",
      "INDEX ITEM DESCRIPTION":
        "Quartz crystals, electronic application, manufacturing",
    },
    {
      NAICS22: "334419",
      "INDEX ITEM DESCRIPTION":
        "Radio frequency identification (RFID) devices manufacturing",
    },
    {
      NAICS22: "334419",
      "INDEX ITEM DESCRIPTION":
        "Rectifiers, electronic component-type (except semiconductor), manufacturing",
    },
    {
      NAICS22: "334419",
      "INDEX ITEM DESCRIPTION":
        "Resonant reed devices, electronic, manufacturing",
    },
    {
      NAICS22: "334419",
      "INDEX ITEM DESCRIPTION": "Rheostats, electronic, manufacturing",
    },
    {
      NAICS22: "334419",
      "INDEX ITEM DESCRIPTION":
        "Screens for liquid crystal display (LCD) manufacturing",
    },
    {
      NAICS22: "334419",
      "INDEX ITEM DESCRIPTION":
        "Solenoids for electronic applications manufacturing",
    },
    {
      NAICS22: "334419",
      "INDEX ITEM DESCRIPTION":
        "Switches for electronic applications manufacturing",
    },
    {
      NAICS22: "334419",
      "INDEX ITEM DESCRIPTION": "Television picture tubes manufacturing",
    },
    {
      NAICS22: "334419",
      "INDEX ITEM DESCRIPTION": "Transducers (except pressure) manufacturing",
    },
    {
      NAICS22: "334419",
      "INDEX ITEM DESCRIPTION": "Traveling wave tubes manufacturing",
    },
    {
      NAICS22: "334419",
      "INDEX ITEM DESCRIPTION": "Tubes, cathode ray, manufacturing",
    },
    {
      NAICS22: "334419",
      "INDEX ITEM DESCRIPTION": "Tubes, electron, manufacturing",
    },
    {
      NAICS22: "334419",
      "INDEX ITEM DESCRIPTION": "Tubes, electronic, manufacturing",
    },
    {
      NAICS22: "334419",
      "INDEX ITEM DESCRIPTION": "Tubes, klystron, manufacturing",
    },
    {
      NAICS22: "334419",
      "INDEX ITEM DESCRIPTION": "Vacuum tubes manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION":
        "Arc lamp units, electrotherapeutic (except infrared, ultraviolet), manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION":
        "Audiological equipment, electromedical, manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION":
        "Automated blood and body fluid analyzers (except laboratory) manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION": "Bronchoscopes, electromedical, manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION":
        "Carbon arc lamp units, electrotherapeutic (except infrared and ultraviolet), manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION": "Cardiodynameter manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION": "Cardiographs manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION": "Cardiophone, electric, manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION": "Cardioscope manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION": "Cardiotachometer manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION": "Colonscopes, electromedical, manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION": "Cystoscopes, electromedical, manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION": "Defibrillators manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION":
        "Diagnostic equipment, electromedical, manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION":
        "Diagnostic equipment, MRI (magnetic resonance imaging), manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION":
        "Dialysis equipment, electromedical, manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION":
        "Diathermy apparatus, electromedical, manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION": "Diathermy units manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION": "Electrocardiographs manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION": "Electroencephalographs manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION": "Electrogastrograph manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION":
        "Electromedical diagnostic equipment manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION": "Electromedical equipment manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION": "Electromedical therapy equipment manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION": "Electromyographs manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION": "Electrosurgical units manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION": "Electrotherapeutic apparatus manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION": "Electrotherapy units manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION":
        "Endoscopic equipment, electromedical (e.g., bronchoscopes, colonoscopes, cystoscopes), manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION": "Gastroscopes, electromedical, manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION": "Hearing aids, electronic, manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION": "Heart-lung machine manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION": "Laser equipment, electromedical, manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION":
        "Laser systems and equipment, medical, manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION": "Lithotripters manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION":
        "Magnetic resonance imaging (MRI) medical diagnostic equipment manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION":
        "Medical cleaning equipment, ultrasonic, manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION": "Medical ultrasound equipment manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION":
        "MRI (magnetic resonance imaging) medical diagnostic equipment manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION": "Otoscopes, electromedical, manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION": "Pacemakers manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION":
        "Patient monitoring equipment (e.g., intensive care, coronary care unit) manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION":
        "PET (positron emission tomography) scanners manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION": "Phonocardiographs manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION":
        "Positron emission tomography (PET) scanners manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION": "Probes, electric medical, manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION":
        "Respiratory analysis equipment, electromedical, manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION": "Retinoscopes, electromedical, manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION": "Sentinel, cardiac, manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION":
        "Surgical support systems, electromedical, manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION":
        "TENS (transcutaneous electrical nerve stimulator) manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION":
        "Transcutaneous electrical nerve stimulators (TENS) manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION": "Ultrasonic medical equipment manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION":
        "Ultrasonic scanning devices, medical, manufacturing",
    },
    {
      NAICS22: "334510",
      "INDEX ITEM DESCRIPTION": "Ventilators, electromedical, manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION":
        "Acceleration indicators and systems components, aerospace type, manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION":
        "Aeronautical systems and instruments manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION":
        "Aeronautical systems and instruments overhauling, conversion, or rebuilding",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION":
        "Air traffic control radar systems and equipment manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION": "Airborne navigational systems manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION":
        "Aircraft flight instruments (except engine instruments) manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION": "Airframe equipment instruments manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION":
        "Airspeed instruments (aeronautical) manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION": "Altimeters, aeronautical, manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION": "Angle-of-attack instrumentation manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION": "Angle-of-yaw instrumentation manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION":
        "Artificial horizon instrumentation manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION":
        "Bank and turn indicators and components (aeronautical instruments) manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION":
        "Cabin environment indicators, transmitters, and sensors manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION":
        "Compasses, gyroscopic and magnetic (except portable), manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION":
        "Countermeasure sets (e.g., active countermeasures, jamming equipment) manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION":
        "Distance measuring equipment (DME), aeronautical, manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION": "Driftmeters, aeronautical, manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION":
        "Electronic guidance systems and equipment manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION": "Fathometers manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION": "Fish finders (i.e., sonar) manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION":
        "Flight and navigation sensors, transmitters, and displays manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION":
        "Flight recorders (i.e., black boxes) manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION": "Glide slope instrumentation manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION": "Gyrocompasses manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION": "Gyrogimbals manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION": "Gyroscopes manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION":
        "Heads-up display (HUD) systems, aeronautical, manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION": "Horizon situation instrumentation manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION":
        "HUD (heads-up display) systems, aeronautical, manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION": "Hydrophones manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION":
        "Inertial navigation systems, aeronautical, manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION":
        "Infrared homing systems, aeronautical, manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION":
        "Instrument landing system instrumentation, airborne or airport, manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION": "Instruments, aeronautical, manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION":
        "Light reconnaissance and surveillance systems and equipment manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION": "Machmeters manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION": "Nautical systems and  instruments manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION": "Navigational instruments manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION": "Omnibearing instrumentation manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION":
        "Pictorial situation instrumentation manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION":
        "Position indicators (e.g., for landing gear, stabilizers), airframe equipment, manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION":
        "Proximity warning (i.e., collision avoidance) equipment manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION": "Radar detectors manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION": "Radar systems and equipment manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION":
        "Radio magnetic instrumentation (RMI) manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION": "Rate-of-climb instrumentation manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION":
        "Search and detection systems and instruments manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION": "Sextants (except surveying) manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION": "Sonabuoys manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION": "Sonar fish finders manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION": "Sonar systems and equipment manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION":
        "Space vehicle guidance systems and equipment manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION":
        "Speed, pitch, and roll navigational instruments and systems manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION": "Taffrail logs manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION": "Underwater navigational systems manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION": "Warfare countermeasures equipment manufacturing",
    },
    {
      NAICS22: "334511",
      "INDEX ITEM DESCRIPTION":
        "Wheel position indicators and transmitters, aircraft, manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Air flow controllers (except valves), air-conditioning and refrigeration, manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION": "Appliance controls manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Appliance regulators (except switches) manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Building services monitoring controls, automatic, manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Clothes dryer controls, including dryness controls, manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Combination limit and fan controls manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Combination oil and hydronic controls manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Computerized environmental control systems for buildings manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Damper operators (e.g., electric, pneumatic, thermostatic) manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Electric air cleaner controls, automatic, manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Electric heat proportioning controls, modulating controls, manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Electric space heater controls, automatic, manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Energy cutoff controls, residential and commercial types, manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Fan controls, temperature responsive, manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Flame safety controls for furnaces and boilers manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Float controls, residential and commercial types, manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Gas burner automatic controls (except valves) manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION": "Gradual switches, pneumatic, manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Heating and cooling system controls, residential and commercial, manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION": "Heating regulators manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Humidistats (e.g., duct, skeleton, wall) manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Humidity controls, air-conditioning-type, manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Hydronic circulator control, automatic, manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION": "Hydronic limit control manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Hydronic limit, pressure, and temperature controls, manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION": "Ice bank controls manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION": "Ice maker controls manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Ignition controls for gas appliances and furnaces, automatic, manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "In-built thermostats, filled system and bimetal types, manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Incinerator control systems, residential and commercial-type, manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Light responsive appliance controls manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Limit controls (e.g., air-conditioning, appliance, heating) manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Line or limit control for electric heat manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Liquid level controls, residential and commercial heating-type, manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Oven temperature controls, nonindustrial, manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Pneumatic relays, air-conditioning-type, manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Pressure controllers, air-conditioning system-type, manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION": "Pressurestats manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Primary oil burner controls (e.g., cadmium cells, stack controls) manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Refrigeration controls, residential and commercial-type, manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION": "Refrigeration thermostats manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Refrigeration/air-conditioning defrost controls manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION": "Room thermostats manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Sequencing controls for electric heating equipment manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION": "Static pressure regulators manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Steam pressure controls, residential and commercial heating-type, manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Surface burner controls, temperature, manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Switches, pneumatic positioning remote, manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION": "Switches, thermostatic, manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Temperature controls, automatic, residential and commercial-types, manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Temperature sensors for motor windings manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION": "Thermocouples, glass vacuum, manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Thermostats (e.g., air-conditioning, appliance, comfort heating, refrigeration) manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION":
        "Time program controls, air-conditioning systems, manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION": "Vapor heating controls manufacturing",
    },
    {
      NAICS22: "334512",
      "INDEX ITEM DESCRIPTION": "Water heater controls manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Absorption analyzers, industrial process type (e.g., infrared), manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Acidity (i.e., pH) instruments, industrial process type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Analyzers, industrial process control type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Annunciators, relay and solid-state types, industrial display, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Boiler controls, industrial, power, and marine-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Buoyancy instruments, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Chromatographs, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Combustion control instruments (except commercial, household furnace-type) manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Controllers for process variables (e.g., electric, electronic, mechanical, pneumatic operation) manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Coulometric analyzers, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Data loggers, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Density and specific gravity instruments, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Differential pressure instruments, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Digital displays of process variables manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Display instruments, industrial process control-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Draft gauges, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Electric and electronic controllers, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Electrodes used in industrial process measurement manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Electrolytic conductivity instruments, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION": "Electromagnetic flowmeters manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Flow instruments, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Fluidic devices, circuits, and systems for process control, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Gas analyzers, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Gas and liquid analysis instruments, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Gas chromatographic instruments, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Gas flow instrumentation, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Gauges (i.e., analog, digital), industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Humidity instruments, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Hydrometers, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Hygrometers, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Indicators, industrial process control-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Industrial process control instruments manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Infrared instruments, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Instruments for industrial process control manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Level and bulk measuring instruments, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Liquid analysis instruments, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Liquid concentration instruments, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Liquid level instruments, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Magnetic flow meters, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Manometers, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Measuring instruments, industrial process control-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Mechanical measuring instruments, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Meters, industrial process control-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Moisture meters, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Nanofluidic measurement and control devices manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Panelboard indicators, recorders, and controllers, receiver industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Pneumatic controllers, industrial process type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Potentiometric instruments (except X-Y recorders), industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Pressure gauges (e.g., dial, digital), industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Pressure instruments, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Primary elements for process flow measurement (i.e., orifice plates) manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Primary process temperature sensors manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Process control instruments, industrial, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION": "Programmers, process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Pyrometers, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Recorders, industrial process control-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Refractometers, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Resistance thermometers and bulbs, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Telemetering instruments, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Temperature instruments, industrial process-type (except glass and bimetal thermometers), manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Thermal conductivity instruments, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Thermistors, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Thermocouples, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Thermometers, filled system industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Time cycle and program controllers, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Transmitters, industrial process control-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Turbidity instruments, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Turbine flow meters, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Variable control instruments, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Viscosimeters, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Viscosity instruments, industrial process-type, manufacturing",
    },
    {
      NAICS22: "334513",
      "INDEX ITEM DESCRIPTION":
        "Water quality monitoring and control systems manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION":
        "Consumption meters (e.g., gas, water) manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION":
        "Controls, revolution and timing instruments, manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION": "Counter type registers manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION":
        "Counters (e.g., electrical, electronic, mechanical), totalizing, manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION": "Counters, revolution, manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION": "Counting devices manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION": "Electromechanical counters manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION": "Electronic totalizing counters manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION": "Fare collection equipment manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION":
        "Gasmeters, consumption registering, manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION":
        "Gasmeters, large capacity, domestic and industrial, manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION":
        "Gasoline dispensing meters (except pumps) manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION":
        "Gauges (e.g., oil pressure, water temperature, speedometer, tachometer), motor vehicle, manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION":
        "Gauges for computing pressure-temperature corrections manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION":
        "Impeller and counter driven flow meters manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION":
        "Instrument panels, assembling gauges made in the same establishment",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION": "Integrating meters, nonelectric, manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION": "Linear counters manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION": "Liquid flow meters manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION": "Magnetic counters manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION": "Measuring wheels manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION":
        "Metering devices (except electrical and industrial process control) manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION":
        "Meters (except electrical and industrial process control) manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION": "Meters, parking, manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION":
        "Motor vehicle instruments (e.g., fuel level gauges, oil pressure, speedometers, tachometers, water temperature) manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION": "Parking meters manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION": "Pedometers manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION": "Positive displacement meters manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION": "Predetermined counters manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION": "Production counters manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION":
        "Propeller type meters with registers manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION": "Registers, linear tallying, manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION":
        "Rotary type meters, consumption registering, manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION": "Tally counters manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION":
        "Tallying meters (except clocks, electricity meters, watches) manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION": "Tank truck meters manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION": "Taximeters manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION": "Totalizing fluid meters manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION":
        "Totalizing meters (except aircraft), consumption registering, manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION":
        "Turbine meters, consumption registering, manufacturing",
    },
    {
      NAICS22: "334514",
      "INDEX ITEM DESCRIPTION":
        "Watermeters, consumption registering, manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Alternator and generator testers manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Ampere-hour meters manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Analyzers for testing electrical characteristics manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Audiofrequency oscillators manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Audiometers (except medical) manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Automotive ammeters and voltmeters manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Automotive electrical engine diagnostic equipment manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Battery testers, electrical, manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Bridges, electrical (e.g., Kelvin, megohm, vacuum tube, Wheatstone), manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Circuit testers manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Communications signal testing and evaluation equipment manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Current measuring equipment manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Decade boxes (i.e., capacitance, inductance, resistance) manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Demand meters, electric, manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Digital panel meters, electricity measuring, manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Digital test equipment (e.g., electronic and electrical circuits and equipment testing) manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Diode and transistor testers manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Distortion meters and analyzers manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Elapsed time meters, electronic, manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Electrical network analyzers manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Electrical power measuring equipment manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Electricity and electrical signal measuring instruments manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Electricity and electrical signal testing equipment manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Electron tube test equipment manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Electronic test equipment for testing electrical characteristics manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Energy measuring equipment, electrical, manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Field strength and intensity measuring equipment, electrical, manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Frequency meters (e.g., electrical, electronic, mechanical) manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Frequency synthesizers manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Function generators manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Galvanometers (except geophysical) manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Graphic recording meters, electric, manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Ignition testing instruments manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Impedance measuring equipment manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Indicating instruments, electric, manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Instrument shunts manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Instruments for measuring electrical quantities manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Instruments, electric (i.e., testing electrical characteristics), manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Integrated-circuit testers manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Integrating electricity meters manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Internal combustion engine analyzers (i.e., testing electrical characteristics) manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Kelvin bridges (i.e., electrical measuring instruments) manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Laboratory standards testing instruments (e.g., capacitance, electrical resistance, inductance) manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Logic circuit testers manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Measuring equipment for electronic and electrical circuits and equipment manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Measuring instruments and meters, electric, manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Meters, electrical (i.e., graphic recording, panelboard, pocket, portable), manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Meters, power factor and phase angle, manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Microwave test equipment manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Multimeters manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Ohmmeters manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Oscillators (e.g., instrument type audiofrequency and radiofrequency) manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Oscilloscopes manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Phase angle meters manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Portable test meters manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Potentiometric instruments (except industrial process-type) manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Power factor meters manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Power measuring equipment, electrical, manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Pulse (i.e., signal) generators manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Radar testing instruments, electric, manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Radiofrequency measuring equipment manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Radiofrequency oscillators manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Recorders, oscillographic, manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Relays (except electrical, electronic), instrument, manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Resistance measuring equipment manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Semiconductor test equipment manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Shunts, instrument, manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Signal generators and averagers manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Spark plug testing instruments, electric, manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Spectrum analyzers manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Standards and calibration equipment for electrical measuring manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Standing wave ratio measuring equipment manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Stroboscopes manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Sweep generators manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Sweep oscillators manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Synchroscopes manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Tachometer generators manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Test equipment for electronic and electrical circuits and equipment manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Test sets, ignition harness, manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Voltmeters manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Watt-hour and demand meters, combined, manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Watt-hour and time switch meters, combined, manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Watt-hour meters, electric, manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION": "Wattmeters manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Waveform measuring and/or analyzing equipment manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "Wheatstone bridges (i.e., electrical measuring instruments) manufacturing",
    },
    {
      NAICS22: "334515",
      "INDEX ITEM DESCRIPTION":
        "X-Y recorders (i.e., plotters (except computer peripheral equipment)) manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION":
        "Acidity (i.e., pH) measuring equipment, laboratory analysis-type, manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION":
        "Amino acid analyzers, laboratory-type, manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION": "Atomic force microscopes manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION":
        "Automatic chemical analyzers, laboratory-type, manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION": "Blood bank process equipment manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION":
        "Chromatographic instruments, laboratory-type, manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION": "Chronoscopes manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION": "Colorimeters, laboratory-type, manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION":
        "Coulometric analyzers, laboratory-type, manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION":
        "Densitometers, laboratory analytical, manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION":
        "Differential thermal analysis instruments, laboratory-type, manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION":
        "Electrolytic conductivity instruments, laboratory-type, manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION":
        "Electron microprobes, laboratory-type, manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION": "Electron microscopes manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION":
        "Electron paramagnetic spin-type apparatus manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION": "Electrophoresis instruments manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION": "Elemental analyzers manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION": "Flame photometers manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION": "Gas analyzers, laboratory-type, manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION":
        "Gas chromatographic instruments, laboratory-type, manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION": "Hematology instruments manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION":
        "Immunology instruments, laboratory, manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION":
        "Infrared analytical instruments, laboratory-type, manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION":
        "Laboratory analytical instruments (except optical) manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION":
        "Liquid chromatographic instruments, laboratory-type, manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION":
        "Magnetic resonance imaging (MRI) type apparatus (except medical diagnostic) manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION": "Mass spectrometers manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION": "Mass spectroscopy instrumentation manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION": "Microbiology instruments manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION":
        "Microprobes (e.g., electron, ion, laser, X-ray) manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION": "Microscopes, electron and proton, manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION":
        "Moisture analyzers, laboratory-type, manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION": "Monochrometers, laboratory-type, manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION": "Nanomanipulator equipment manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION": "Nanosensor instruments manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION":
        "Nephelometers (except meteorological) manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION":
        "Neutron activation analysis instruments manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION": "Osmometers manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION":
        "Particle beam excitation instruments, laboratory-type, manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION": "Particle size analyzers manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION":
        "Photometers (except photographic exposure meters) manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION": "Photonexcitation analyzers manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION": "Polariscopes manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION": "Polarizers manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION": "Polarographic equipment manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION":
        "Protein analyzers, laboratory-type, manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION":
        "Redox (i.e., oxidation-reduction potential) instruments manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION": "Refractometers, laboratory-type, manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION":
        "Resonance instruments (i.e., laboratory-type) manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION":
        "Sample analysis instruments (except medical) manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION": "Scanning tunneling microscopes manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION":
        "Specific ion measuring instruments, laboratory-type, manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION": "Spectrofluorometers manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION": "Spectrographs manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION":
        "Spectrometers (e.g., electron diffraction, mass, NMR, Raman) manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION":
        "Spectrophotometers (e.g., atomic absorption, atomic emission, flame, fluorescence, infrared, Raman, visible) manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION": "Surface area analyzers manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION":
        "Thermal analysis instruments, laboratory-type, manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION":
        "Thermal conductivity instruments and sensors manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION": "Thermogravimetric analyzers manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION": "Titrimeters manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION": "Turbidometers, laboratory-type, manufacturing",
    },
    {
      NAICS22: "334516",
      "INDEX ITEM DESCRIPTION":
        "Ultraviolet-type analytical instruments manufacturing",
    },
    {
      NAICS22: "334517",
      "INDEX ITEM DESCRIPTION": "Beta-ray irradiation equipment manufacturing",
    },
    {
      NAICS22: "334517",
      "INDEX ITEM DESCRIPTION":
        "Computerized axial tomography (CT/CAT) scanners manufacturing",
    },
    {
      NAICS22: "334517",
      "INDEX ITEM DESCRIPTION":
        "CT/CAT (computerized axial tomography) scanners manufacturing",
    },
    {
      NAICS22: "334517",
      "INDEX ITEM DESCRIPTION": "Fluoroscopes manufacturing",
    },
    {
      NAICS22: "334517",
      "INDEX ITEM DESCRIPTION":
        "Fluoroscopic X-ray apparatus and tubes manufacturing",
    },
    {
      NAICS22: "334517",
      "INDEX ITEM DESCRIPTION": "Gamma-ray irradiation equipment manufacturing",
    },
    {
      NAICS22: "334517",
      "INDEX ITEM DESCRIPTION": "Generators, X-ray, manufacturing",
    },
    {
      NAICS22: "334517",
      "INDEX ITEM DESCRIPTION":
        "Irradiation apparatus and tubes (e.g., industrial, medical diagnostic, medical therapeutic, research, scientific), manufacturing",
    },
    {
      NAICS22: "334517",
      "INDEX ITEM DESCRIPTION": "Irradiation equipment manufacturing",
    },
    {
      NAICS22: "334517",
      "INDEX ITEM DESCRIPTION": "Lamps, X-ray, manufacturing",
    },
    {
      NAICS22: "334517",
      "INDEX ITEM DESCRIPTION":
        "Medical radiation therapy equipment manufacturing",
    },
    {
      NAICS22: "334517",
      "INDEX ITEM DESCRIPTION": "Nuclear irradiation equipment manufacturing",
    },
    {
      NAICS22: "334517",
      "INDEX ITEM DESCRIPTION": "Radium equipment manufacturing",
    },
    {
      NAICS22: "334517",
      "INDEX ITEM DESCRIPTION":
        "Therapeutic X-ray apparatus and tubes (e.g., medical, industrial, research) manufacturing",
    },
    {
      NAICS22: "334517",
      "INDEX ITEM DESCRIPTION": "Tubes, X-ray, manufacturing",
    },
    {
      NAICS22: "334517",
      "INDEX ITEM DESCRIPTION":
        "X-ray apparatus and tubes (e.g., control, industrial, medical, research) manufacturing",
    },
    {
      NAICS22: "334517",
      "INDEX ITEM DESCRIPTION": "X-ray generators manufacturing",
    },
    {
      NAICS22: "334517",
      "INDEX ITEM DESCRIPTION": "X-ray irradiation equipment manufacturing",
    },
    {
      NAICS22: "334517",
      "INDEX ITEM DESCRIPTION": "X-ray tubes manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Abrasion testing machines manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Accelerometers (except aerospace type) manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Actinometers, meteorological, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Aircraft engine instruments manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Alarm clocks manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Alidades, surveying, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Appliance timers manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Automotive emissions testing equipment manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Barographs manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Barometers manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Breath alcohol testing devices manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Breathalyzers manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Ceilometers manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Chains, surveyor's, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Chronographs manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Chronometers manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Clock materials and parts (except crystals) manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Clock or watch springs, precision, made from purchased wire",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Clocks assembling",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Clocks assembling from purchased components",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Commercial timing mechanisms manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Compasses, portable magnetic-type, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Count rate meters, nuclear radiation, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Dating devices and machines (except rubber stamps) manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Detectors, scintillation, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Dosimetry devices manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Drafting instruments manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Dynamometers manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Evaporation meters manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Fatigue testing machines, industrial, mechanical, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Fire detector systems, nonelectric, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Fuel densitometers, aircraft engine, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Fuel mixture indicators, aircraft engine, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Fuel system instruments, aircraft, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Fuel totalizers, aircraft engine, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Galvanometers, geophysical, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Gas leak detectors manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Geiger counters manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Geophysical instruments manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Hand stamps (e.g., date, time), timing mechanism operated, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Hardness testing equipment manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Household-type timing mechanisms manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Humidity instruments (except industrial process and air-conditioning type) manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Hydrometers (except industrial process-type) manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Hygrometers (except industrial process-type) manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Hygrothermographs manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Indicator testers, turntable, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Instrumentation for reactor controls, auxiliary, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Ion chambers manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Kinematic test and measuring equipment manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Leak detectors, water, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Level gauges, radiation-type, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Levels and tapes, surveying, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Lie detectors manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Magnetometers manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Mechanisms, clockwork operated device, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Metal detectors manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Meteorologic tracking systems manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Meteorological instruments manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Modules for clocks and watches manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Movements, watch or clock, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Nephoscopes manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Nuclear instrument modules manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Physical properties testing and inspection equipment manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Pitometers manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Polygraph machines manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Pressure and vacuum indicators, aircraft engine, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Pressure transducers manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Pulse analyzers, nuclear monitoring, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Pyrheliometers manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "RADIAC (radioactivity detection, identification, and computation) equipment manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Radiation detection and monitoring instruments manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Radioactivity detection, identification, and computation (RADIAC) equipment manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Rain gauges manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Rods, surveyor's, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Rules, slide, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Sample changers, nuclear radiation, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Scalers, nuclear radiation, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Scintillation detectors manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Seismographs manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Seismometers manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Seismoscopes manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Sextants, surveying, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Solarimeters manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Spectrometers (e.g., liquid scintillation, nuclear) manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Springs, clock and watch, made from purchased wire",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Surveying instruments manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Tapes, surveyor's, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Templates, drafting, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Tensile strength testing equipment manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Testers for checking hydraulic controls on aircraft manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Testing equipment (e.g., abrasion, shearing strength, tensile strength, torsion) manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Theodolites, surveying, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Thermocouples (except industrial process, aircraft type, glass vacuum) manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Thermometer, liquid-in-glass and bimetal types (except medical), manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Thickness gauging instruments, ultrasonic, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Thrust power indicators, aircraft engine, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Time clocks and time recording devices manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Time locks manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Time stamps containing clock mechanisms manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Timers for industrial use, clockwork mechanism, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Timing mechanisms, clockwork, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Torsion testing equipment manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Transducers, pressure, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Transits, surveying, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "T-squares (drafting) manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Ultrasonic testing equipment (except medical) manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Vibration meters, analyzers, and calibrators, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Viscosimeters (except industrial process type) manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Wall clocks manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Watch jewels manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Watchcase manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION":
        "Watches (except smartwatches) and parts (except crystals) manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Water leak detectors manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Weather tracking equipment manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Whole body counters, nuclear, manufacturing",
    },
    {
      NAICS22: "334519",
      "INDEX ITEM DESCRIPTION": "Wind direction indicators manufacturing",
    },
    {
      NAICS22: "334610",
      "INDEX ITEM DESCRIPTION": "Audiotape, blank, manufacturing",
    },
    {
      NAICS22: "334610",
      "INDEX ITEM DESCRIPTION": "Blank tapes, audio and video, manufacturing",
    },
    {
      NAICS22: "334610",
      "INDEX ITEM DESCRIPTION":
        "Cassette tapes, prerecorded audio, mass reproducing",
    },
    {
      NAICS22: "334610",
      "INDEX ITEM DESCRIPTION": "CD-ROM, software, mass reproducing",
    },
    {
      NAICS22: "334610",
      "INDEX ITEM DESCRIPTION":
        "Compact discs (i.e., CD-ROM), software, mass reproducing",
    },
    {
      NAICS22: "334610",
      "INDEX ITEM DESCRIPTION":
        "Compact discs, prerecorded audio, mass reproducing",
    },
    {
      NAICS22: "334610",
      "INDEX ITEM DESCRIPTION":
        "Compact discs, recordable or rewritable, blank, manufacturing",
    },
    {
      NAICS22: "334610",
      "INDEX ITEM DESCRIPTION":
        "Computer software tapes and disks, blank, rigid and floppy, manufacturing",
    },
    {
      NAICS22: "334610",
      "INDEX ITEM DESCRIPTION": "Diskettes, blank, manufacturing",
    },
    {
      NAICS22: "334610",
      "INDEX ITEM DESCRIPTION": "Game cartridge software, mass reproducing",
    },
    {
      NAICS22: "334610",
      "INDEX ITEM DESCRIPTION": "Games, computer software, mass reproducing",
    },
    {
      NAICS22: "334610",
      "INDEX ITEM DESCRIPTION":
        "Hard drive media (disk drive platters) manufacturing",
    },
    {
      NAICS22: "334610",
      "INDEX ITEM DESCRIPTION":
        "Head cleaners for magnetic tape equipment, manufacturing",
    },
    {
      NAICS22: "334610",
      "INDEX ITEM DESCRIPTION":
        "Laser disks, prerecorded video, mass reproducing",
    },
    {
      NAICS22: "334610",
      "INDEX ITEM DESCRIPTION":
        "Magnetic and optical media, blank, manufacturing",
    },
    {
      NAICS22: "334610",
      "INDEX ITEM DESCRIPTION":
        "Magnetic recording media for tapes, cassettes, and disks, manufacturing",
    },
    {
      NAICS22: "334610",
      "INDEX ITEM DESCRIPTION":
        "Magnetic tapes, cassettes and disks, blank, manufacturing",
    },
    {
      NAICS22: "334610",
      "INDEX ITEM DESCRIPTION": "Phonograph records manufacturing",
    },
    {
      NAICS22: "334610",
      "INDEX ITEM DESCRIPTION": "Prepackaged software, mass reproducing",
    },
    {
      NAICS22: "334610",
      "INDEX ITEM DESCRIPTION":
        "Prerecorded magnetic audio tapes and cassettes mass reproducing",
    },
    {
      NAICS22: "334610",
      "INDEX ITEM DESCRIPTION": "Software, packaged, mass reproducing",
    },
    {
      NAICS22: "334610",
      "INDEX ITEM DESCRIPTION":
        "Tapes, magnetic recording (i.e., audio, data, video), blank, manufacturing",
    },
    {
      NAICS22: "334610",
      "INDEX ITEM DESCRIPTION": "Video cassettes, blank, manufacturing",
    },
    {
      NAICS22: "334610",
      "INDEX ITEM DESCRIPTION": "Video cassettes, prerecorded, mass reproducing",
    },
    {
      NAICS22: "334610",
      "INDEX ITEM DESCRIPTION": "Video tape or disk mass reproducing",
    },
    {
      NAICS22: "334610",
      "INDEX ITEM DESCRIPTION": "Video tapes, blank, manufacturing",
    },
    {
      NAICS22: "335131",
      "INDEX ITEM DESCRIPTION": "Boudoir lamp fixtures manufacturing",
    },
    {
      NAICS22: "335131",
      "INDEX ITEM DESCRIPTION":
        "Ceiling lighting fixtures, residential, manufacturing",
    },
    {
      NAICS22: "335131",
      "INDEX ITEM DESCRIPTION": "Chandeliers, residential, manufacturing",
    },
    {
      NAICS22: "335131",
      "INDEX ITEM DESCRIPTION":
        "Decorative area lighting fixtures, residential, manufacturing",
    },
    {
      NAICS22: "335131",
      "INDEX ITEM DESCRIPTION":
        "Desk lamps, residential, electric, manufacturing",
    },
    {
      NAICS22: "335131",
      "INDEX ITEM DESCRIPTION":
        "Floor lamps (i.e., lighting fixtures), residential, manufacturing",
    },
    {
      NAICS22: "335131",
      "INDEX ITEM DESCRIPTION":
        "Fluorescent lighting fixtures, residential, manufacturing",
    },
    {
      NAICS22: "335131",
      "INDEX ITEM DESCRIPTION":
        "Grow light fixtures, residential, electric, manufacturing",
    },
    {
      NAICS22: "335131",
      "INDEX ITEM DESCRIPTION":
        "Lamp shades (except glass, plastics), residential, manufacturing",
    },
    {
      NAICS22: "335131",
      "INDEX ITEM DESCRIPTION":
        "Lamps (i.e., lighting fixtures), residential, electric, manufacturing",
    },
    {
      NAICS22: "335131",
      "INDEX ITEM DESCRIPTION":
        "Lighting fixtures, residential electric, manufacturing",
    },
    {
      NAICS22: "335131",
      "INDEX ITEM DESCRIPTION":
        "Low voltage lighting equipment, residential, electric, manufacturing",
    },
    {
      NAICS22: "335131",
      "INDEX ITEM DESCRIPTION":
        "Pendant lamps fixtures, residential electric, manufacturing",
    },
    {
      NAICS22: "335131",
      "INDEX ITEM DESCRIPTION":
        "Recessed lighting housings and trim, residential electric, manufacturing",
    },
    {
      NAICS22: "335131",
      "INDEX ITEM DESCRIPTION":
        "Shades, lamp (except glass, plastics), residential-type, manufacturing",
    },
    {
      NAICS22: "335131",
      "INDEX ITEM DESCRIPTION":
        "Solar lighting fixtures, residential, electric, manufacturing",
    },
    {
      NAICS22: "335131",
      "INDEX ITEM DESCRIPTION":
        "Table lamps (i.e., lighting fixtures) manufacturing",
    },
    {
      NAICS22: "335131",
      "INDEX ITEM DESCRIPTION":
        "Track lighting fixtures and equipment, residential, electric, manufacturing",
    },
    {
      NAICS22: "335131",
      "INDEX ITEM DESCRIPTION":
        "Wall lamps (i.e., lighting fixtures), residential electric, manufacturing",
    },
    {
      NAICS22: "335131",
      "INDEX ITEM DESCRIPTION":
        "Yard lights, residential electric, manufacturing",
    },
    {
      NAICS22: "335132",
      "INDEX ITEM DESCRIPTION":
        "Ceiling lighting fixtures, commercial, industrial, and institutional, manufacturing",
    },
    {
      NAICS22: "335132",
      "INDEX ITEM DESCRIPTION":
        "Chandeliers, commercial, industrial, and institutional electric, manufacturing",
    },
    {
      NAICS22: "335132",
      "INDEX ITEM DESCRIPTION":
        "Commercial lighting fixtures, electric, manufacturing",
    },
    {
      NAICS22: "335132",
      "INDEX ITEM DESCRIPTION": "Desk lamps, commercial, electric, manufacturing",
    },
    {
      NAICS22: "335132",
      "INDEX ITEM DESCRIPTION":
        "Emergency lighting (i.e., battery backup) manufacturing",
    },
    {
      NAICS22: "335132",
      "INDEX ITEM DESCRIPTION":
        "Fluorescent lighting fixtures, commercial, institutional, and industrial electric, manufacturing",
    },
    {
      NAICS22: "335132",
      "INDEX ITEM DESCRIPTION":
        "Grow light fixtures (except residential) manufacturing",
    },
    {
      NAICS22: "335132",
      "INDEX ITEM DESCRIPTION":
        "Illuminated indoor lighting fixtures (e.g., directional, exit) manufacturing",
    },
    {
      NAICS22: "335132",
      "INDEX ITEM DESCRIPTION":
        "Industrial lighting fixtures, electric, manufacturing",
    },
    {
      NAICS22: "335132",
      "INDEX ITEM DESCRIPTION":
        "Industrial mercury lighting fixtures, electric, manufacturing",
    },
    {
      NAICS22: "335132",
      "INDEX ITEM DESCRIPTION":
        "Institutional lighting fixtures, electric, manufacturing",
    },
    {
      NAICS22: "335132",
      "INDEX ITEM DESCRIPTION":
        "Lamps (i.e., lighting fixtures), commercial, industrial, and institutional, manufacturing",
    },
    {
      NAICS22: "335132",
      "INDEX ITEM DESCRIPTION":
        "Lighting fixtures, commercial electric, manufacturing",
    },
    {
      NAICS22: "335132",
      "INDEX ITEM DESCRIPTION":
        "Lighting fixtures, industrial electric, manufacturing",
    },
    {
      NAICS22: "335132",
      "INDEX ITEM DESCRIPTION":
        "Lighting fixtures, institutional electric, manufacturing",
    },
    {
      NAICS22: "335132",
      "INDEX ITEM DESCRIPTION":
        "Luminous panel ceilings, electric, manufacturing",
    },
    {
      NAICS22: "335132",
      "INDEX ITEM DESCRIPTION":
        "Pendant lamps (except residential), electric, manufacturing",
    },
    {
      NAICS22: "335132",
      "INDEX ITEM DESCRIPTION":
        "Recessed lighting housings and trim (except residential), electric, manufacturing",
    },
    {
      NAICS22: "335132",
      "INDEX ITEM DESCRIPTION":
        "Solar lighting fixtures (except residential), electric, manufacturing",
    },
    {
      NAICS22: "335132",
      "INDEX ITEM DESCRIPTION":
        "Wall lamps (i.e., lighting fixtures), commercial, institutional, and industrial electric, manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION":
        "Arc lighting fixtures (except electrotherapeutic), electric, manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION":
        "Area and sports luminaries (e.g., stadium lighting fixtures), electric, manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION": "Automotive light bulbs manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION": "Bulbs, electric light, complete, manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION": "Christmas tree light bulbs manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION":
        "Christmas tree lighting sets, electric, manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION": "Coating purchased light bulbs",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION":
        "Cold cathode fluorescent lamp tubes manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION": "Compact fluorescent light bulbs manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION":
        "Decorative area lighting fixtures (except residential) manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION": "Decorative lamp bulbs manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION":
        "Electric lamp bulb parts (except glass blanks and light emitting diodes (LEDs)) manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION":
        "Electric lamps (i.e., light bulbs) manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION": "Electric light bulbs, complete, manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION":
        "Electrodes, cold cathode fluorescent lamp, manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION":
        "Electrotherapeutic lamp bulbs for ultraviolet and infrared radiation manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION": "Filaments for electric lamp bulbs manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION": "Fireplace logs, electric, manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION": "Flash bulbs, photographic, manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION": "Flashlight bulb manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION": "Flashlights manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION":
        "Floodlights (i.e., lighting fixtures) manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION":
        "Fluorescent lamp electrodes, cold cathode, manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION": "Fluorescent lamp tubes, electric, manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION": "Flytraps, electrical, manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION": "Fountain lighting fixtures manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION": "Gas lighting fixtures manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION": "Glow lamp bulbs manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION": "Halogen light bulbs manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION":
        "Health lamp bulbs, infrared and ultraviolet radiation, manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION": "High intensity lamp bulbs manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION":
        "Incandescent filament lamp bulbs, complete, manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION": "Infrared lamp bulbs manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION": "Infrared lamp fixtures manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION": "Insect lamps, electric, manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION":
        "Lamp bulb parts (except glass blanks and light emitting diodes (LEDs)), electric, manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION":
        "Lamp bulbs and tubes, electric (i.e., fluorescent, incandescent filament, vapor), manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION":
        "Lamp bulbs and tubes, health, infrared and ultraviolet radiation, manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION": "Lamps, insect, electric fixture, manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION":
        "Lanterns (e.g., carbide, electric, gas, gasoline, kerosene) manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION":
        "Lead-in wires, electric lamp, made from purchased wire",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION":
        "LED (light emitting diode) light bulbs manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION": "Light bulbs manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION":
        "Light bulbs, sealed beam automotive, manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION":
        "Lighting fixtures, airport (e.g., approach, ramp, runway, taxi), manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION":
        "Lighting fixtures, nonelectric (e.g., propane, kerosene, carbide), manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION": "Mercury halide lamp bulbs manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION": "Miner's lamps manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION":
        "Ornaments, Christmas tree, electric, manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION":
        "Photoflash and photoflood lamp bulbs and tubes manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION":
        "Prewired poles, brackets, and accessories for electric lighting, manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION":
        "Reflectors for lighting equipment, metal, manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION":
        "Sealed beam automotive light bulbs manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION":
        "Searchlights, electric and nonelectric, manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION": "Sodium vapor lamp bulbs manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION": "Spotlights (except vehicular) manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION": "Stage lighting equipment manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION":
        "Street lighting fixtures (except traffic signals) manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION": "Strobotrons manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION": "Swimming pool lighting fixtures manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION": "Trouble lights manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION": "Ultraviolet lamp bulbs manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION": "Ultraviolet lamp fixtures manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION": "Underwater lighting fixtures manufacturing",
    },
    {
      NAICS22: "335139",
      "INDEX ITEM DESCRIPTION": "Vapor lamps, electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Air purification equipment, portable, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Bath fans with integral lighting fixture, residential, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION": "Bath fans, residential, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION": "Bedcoverings, electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION": "Blankets, electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Blenders, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Blow dryers, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Bottle warmers, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Bread machines, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Can openers, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Carpet and floor cleaning equipment, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Casseroles, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Ceiling fans with integral lighting fixture, residential, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION": "Ceiling fans, residential, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Central vacuuming systems, household-type, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Chafing dishes, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Cleaners, household-type electric vacuum, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Coffee makers, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Cooking appliances (except convection, microwave ovens), household-type electric portable, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Corn poppers, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Crock pots, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Curling irons, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Deep-fat fryers, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION": "Dehumidifiers, portable electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION": "Desk fans, electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Dry shavers (i.e., electric razors) manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Egg cookers, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION": "Electric blankets manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Electric comfort heating equipment, portable, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION": "Electric space heaters, portable, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION": "Electrically heated bed coverings manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Fans (except attic), household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION": "Fans, household-type kitchen, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Floor scrubbing and shampooing machines, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Floor standing fans, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Floor waxers and polishers, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Food mixers, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION": "Fryers, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Griddles and grills, household-type portable electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Hair clippers for human use, electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Hair curlers, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Hair dryers, electric (except equipment designed for beauty parlor use), manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION": "Hassock fans, electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION": "Heaters, portable electric space, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION": "Heaters, tape, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION": "Heating pads, electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Heating units for electric appliances manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION": "Hoods, range, household-type, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Hotplates, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION": "Humidifiers, portable electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Ice crushers, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Immersion heaters, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION": "Irons, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Juice extractors, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Knives, household-type electric carving, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Massage machines, electric (except designed for beauty and barber shop use), manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Ovens, portable household-type (except microwave and convection ovens), manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Percolators, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Popcorn poppers, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Portable cooking appliances (except convection, microwave ovens), household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION": "Portable electric space heaters manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION": "Portable hair dryers, electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Portable humidifiers and dehumidifiers manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION": "Radiators, portable electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Range hoods with integral lighting fixtures, household-type, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION": "Range hoods, household-type, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION": "Razors, electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Roasters (i.e., cooking appliances), household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION": "Room heaters, portable electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Sandwich toasters and grills, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION": "Sauna heaters, electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION": "Scissors, electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Shoe polishers, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION": "Steam cookers, household-type, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Sweepers, household-type electric vacuum, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION": "Teakettles, electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Toaster ovens, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Toasters, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION": "Toothbrushes, electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Trouser pressers, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION": "Unit heaters, portable electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION": "Urns, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Vacuum cleaners (e.g., canister, handheld, upright) household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Vacuum cleaners and sweepers, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Vaporizers, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Ventilating kitchen fans, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Ventilation and exhaust fans (except attic fans), household-type, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Waffle irons, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION": "Warming trays, electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Water pulsating devices, household-type electric, manufacturing",
    },
    {
      NAICS22: "335210",
      "INDEX ITEM DESCRIPTION":
        "Whippers, household-type electric, manufacturing",
    },
    {
      NAICS22: "335220",
      "INDEX ITEM DESCRIPTION": "Barbecues, grills, and braziers manufacturing",
    },
    {
      NAICS22: "335220",
      "INDEX ITEM DESCRIPTION": "Braziers, barbecue, manufacturing",
    },
    {
      NAICS22: "335220",
      "INDEX ITEM DESCRIPTION":
        "Convection ovens (including portable), household-type, manufacturing",
    },
    {
      NAICS22: "335220",
      "INDEX ITEM DESCRIPTION": "Dishwashers, household-type, manufacturing",
    },
    {
      NAICS22: "335220",
      "INDEX ITEM DESCRIPTION":
        "Dishwashing machines, household-type, manufacturing",
    },
    {
      NAICS22: "335220",
      "INDEX ITEM DESCRIPTION":
        "Drycleaning and laundry machines, household-type, manufacturing",
    },
    {
      NAICS22: "335220",
      "INDEX ITEM DESCRIPTION":
        "Dryers, clothes, household-type, gas and electric, manufacturing",
    },
    {
      NAICS22: "335220",
      "INDEX ITEM DESCRIPTION": "Dryers, household-type laundry, manufacturing",
    },
    {
      NAICS22: "335220",
      "INDEX ITEM DESCRIPTION":
        "Food waste disposal units, household-type, manufacturing",
    },
    {
      NAICS22: "335220",
      "INDEX ITEM DESCRIPTION":
        "Freezers, chest and upright household-type, manufacturing",
    },
    {
      NAICS22: "335220",
      "INDEX ITEM DESCRIPTION":
        "Garbage disposal units, household-type, manufacturing",
    },
    {
      NAICS22: "335220",
      "INDEX ITEM DESCRIPTION": "Gas ranges, household-type, manufacturing",
    },
    {
      NAICS22: "335220",
      "INDEX ITEM DESCRIPTION":
        "Hot water heaters (including nonelectric), household-type, manufacturing",
    },
    {
      NAICS22: "335220",
      "INDEX ITEM DESCRIPTION": "Ice boxes, household-type, manufacturing",
    },
    {
      NAICS22: "335220",
      "INDEX ITEM DESCRIPTION":
        "Ironers and mangles, household-type (except portable irons), manufacturing",
    },
    {
      NAICS22: "335220",
      "INDEX ITEM DESCRIPTION":
        "Laundry equipment (e.g., dryers, washers), household-type, manufacturing",
    },
    {
      NAICS22: "335220",
      "INDEX ITEM DESCRIPTION":
        "Microwave ovens (including portable), household-type, manufacturing",
    },
    {
      NAICS22: "335220",
      "INDEX ITEM DESCRIPTION":
        "Ovens, freestanding household-type, manufacturing",
    },
    {
      NAICS22: "335220",
      "INDEX ITEM DESCRIPTION":
        "Ovens, portable household-type convection and microwave, manufacturing",
    },
    {
      NAICS22: "335220",
      "INDEX ITEM DESCRIPTION": "Ranges, household-type cooking, manufacturing",
    },
    {
      NAICS22: "335220",
      "INDEX ITEM DESCRIPTION":
        "Refrigerator/freezer combinations, household-type, manufacturing",
    },
    {
      NAICS22: "335220",
      "INDEX ITEM DESCRIPTION":
        "Refrigerators (e.g., absorption, mechanical), household-type, manufacturing",
    },
    {
      NAICS22: "335220",
      "INDEX ITEM DESCRIPTION":
        "Stoves, ceramic disk element, household-type, manufacturing",
    },
    {
      NAICS22: "335220",
      "INDEX ITEM DESCRIPTION": "Stoves, household-type cooking, manufacturing",
    },
    {
      NAICS22: "335220",
      "INDEX ITEM DESCRIPTION":
        "Trash and garbage compactors, household-type, manufacturing",
    },
    {
      NAICS22: "335220",
      "INDEX ITEM DESCRIPTION": "Washing machines, household-type, manufacturing",
    },
    {
      NAICS22: "335220",
      "INDEX ITEM DESCRIPTION":
        "Water heaters (including nonelectric), household-type, manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION": "Airport lighting transformers manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION":
        "Arc-welding transformers, separate solid-state, manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION":
        "Autotransformers for switchboards (except telephone switchboards) manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION": "Autotransformers manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION": "Ballasts (i.e., transformers) manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION":
        "Boosters, feeder voltage (i.e., electrical transformers), manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION": "Burner ignition transformers manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION": "Control transformers manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION":
        "Current limiting reactors, electrical, manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION":
        "Distribution transformers, electric, manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION": "Electric furnace transformers manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION":
        "Feeder voltage regulators and boosters (i.e., electrical transformers) manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION":
        "Fluorescent ballasts (i.e., transformers) manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION": "Fluorescent lighting transformers manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION":
        "Generator voltage regulators, electric induction and step-type (except engine electrical equipment), manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION":
        "Instrument transformers (except complete instruments) for metering or protective relaying use manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION": "Isolation transformers manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION": "Lamp ballasts manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION": "Lighting transformers manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION":
        "Lighting transformers, street and airport, manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION":
        "Line voltage regulators (i.e., electric transformers) manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION": "Luminous tube transformers manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION": "Machine tool transformers manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION": "Power transformers, electric, manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION":
        "Regulating transformers, power system-type, manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION":
        "Regulators (i.e., electric transformers), feeder voltage, manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION": "Saturable transformers manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION": "Signaling transformers, electric, manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION": "Specialty transformers, electric, manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION":
        "Substation transformers, electric power distribution, manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION": "Transformers, electric power, manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION":
        "Transformers, ignition, for use on domestic fuel burners, manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION": "Transformers, reactor, manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION":
        "Transformers, separate solid-state arc-welding, manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION":
        "Transmission and distribution voltage regulators manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION":
        "Voltage regulating transformers, electric power, manufacturing",
    },
    {
      NAICS22: "335311",
      "INDEX ITEM DESCRIPTION":
        "Voltage regulators, transmission and distribution, manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION": "Armature rewinding on a factory basis",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION": "Armatures, industrial, manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION": "Coils for motors and generators manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION":
        "Collector rings for motors and generators manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION": "Commutators, electric motor, manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION":
        "Condensers, synchronous, electric, manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION":
        "Converters, phase and rotary, electrical equipment, manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION":
        "Dynamos, electric (except automotive), manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION": "Dynamotors manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION":
        "Exciter assemblies, motor and generator, manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION":
        "Fractional horsepower electric motors manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION":
        "Frequency converters (i.e., electric generators) manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION":
        "Generating apparatus and parts, electrical (except internal combustion engine and welding), manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION":
        "Generator sets, prime mover (except turbine generator sets), manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION":
        "Generators and sets, electric (except internal combustion engine, welding, turbine generator sets), manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION":
        "Generators for gas-electric and oil-electric vehicles, manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION":
        "Generators for storage battery chargers (except internal combustion engine and aircraft) manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION": "Ground Power Units (GPU) manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION":
        "Integral horsepower electric motors manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION": "Inverters, rotating electrical, manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION":
        "Land transportation motors and generators manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION":
        "Motor generator sets (except automotive, turbine generator sets) manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION":
        "Motors, electric (except engine starting motors, gearmotors, outboard), manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION":
        "Phase converters (i.e., electrical equipment) manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION": "Power generators manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION":
        "Prime mover generator sets (except turbine generator sets) manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION":
        "Railway motors and control equipment, electric, manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION": "Resolvers manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION": "Rotor retainers and housings manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION": "Rotors (i.e., for motors) manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION": "Servomotors manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION":
        "Slip rings for motors and generators manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION": "Stators for motors manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION":
        "Storage battery chargers (except internal combustion engine-type) manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION":
        "Synchronous condensers and timing motors, electric, manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION": "Synchronous motors manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION":
        "Timing motors, synchronous, electric, manufacturing",
    },
    {
      NAICS22: "335312",
      "INDEX ITEM DESCRIPTION": "Torque motors, electric, manufacturing",
    },
    {
      NAICS22: "335313",
      "INDEX ITEM DESCRIPTION": "Air circuit breakers manufacturing",
    },
    {
      NAICS22: "335313",
      "INDEX ITEM DESCRIPTION":
        "Bus bar structures, switchgear-type, manufacturing",
    },
    {
      NAICS22: "335313",
      "INDEX ITEM DESCRIPTION": "Circuit breakers, air, manufacturing",
    },
    {
      NAICS22: "335313",
      "INDEX ITEM DESCRIPTION": "Circuit breakers, power, manufacturing",
    },
    {
      NAICS22: "335313",
      "INDEX ITEM DESCRIPTION": "Connectors, power, manufacturing",
    },
    {
      NAICS22: "335313",
      "INDEX ITEM DESCRIPTION":
        "Control panels, electric power distribution, manufacturing",
    },
    {
      NAICS22: "335313",
      "INDEX ITEM DESCRIPTION":
        "Cubicles (i.e., electric switchboard equipment) manufacturing",
    },
    {
      NAICS22: "335313",
      "INDEX ITEM DESCRIPTION": "Distribution boards, electric, manufacturing",
    },
    {
      NAICS22: "335313",
      "INDEX ITEM DESCRIPTION": "Distribution cutouts manufacturing",
    },
    {
      NAICS22: "335313",
      "INDEX ITEM DESCRIPTION":
        "Ducts for electrical switchboard apparatus manufacturing",
    },
    {
      NAICS22: "335313",
      "INDEX ITEM DESCRIPTION": "Fuse clips and blocks, electric, manufacturing",
    },
    {
      NAICS22: "335313",
      "INDEX ITEM DESCRIPTION": "Fuse mountings, electric power, manufacturing",
    },
    {
      NAICS22: "335313",
      "INDEX ITEM DESCRIPTION": "Fuses, electrical, manufacturing",
    },
    {
      NAICS22: "335313",
      "INDEX ITEM DESCRIPTION":
        "Generator control and metering panels, switchgear-type, manufacturing",
    },
    {
      NAICS22: "335313",
      "INDEX ITEM DESCRIPTION":
        "Knife switches, electric power switchgear-type, manufacturing",
    },
    {
      NAICS22: "335313",
      "INDEX ITEM DESCRIPTION": "Metering panels, electric, manufacturing",
    },
    {
      NAICS22: "335313",
      "INDEX ITEM DESCRIPTION":
        "Panelboards, electric power distribution, manufacturing",
    },
    {
      NAICS22: "335313",
      "INDEX ITEM DESCRIPTION":
        "Panels, generator control and metering, manufacturing",
    },
    {
      NAICS22: "335313",
      "INDEX ITEM DESCRIPTION": "Power circuit breakers manufacturing",
    },
    {
      NAICS22: "335313",
      "INDEX ITEM DESCRIPTION": "Power connectors manufacturing",
    },
    {
      NAICS22: "335313",
      "INDEX ITEM DESCRIPTION":
        "Power fuses (i.e., 600 volts and over) manufacturing",
    },
    {
      NAICS22: "335313",
      "INDEX ITEM DESCRIPTION": "Power switchboards manufacturing",
    },
    {
      NAICS22: "335313",
      "INDEX ITEM DESCRIPTION": "Power switching equipment manufacturing",
    },
    {
      NAICS22: "335313",
      "INDEX ITEM DESCRIPTION": "Regulators, power, manufacturing",
    },
    {
      NAICS22: "335313",
      "INDEX ITEM DESCRIPTION": "Switchboards and parts, power, manufacturing",
    },
    {
      NAICS22: "335313",
      "INDEX ITEM DESCRIPTION":
        "Switches, electric power (except pushbutton, snap, solenoid, tumbler), manufacturing",
    },
    {
      NAICS22: "335313",
      "INDEX ITEM DESCRIPTION":
        "Switchgear and switchgear accessories manufacturing",
    },
    {
      NAICS22: "335313",
      "INDEX ITEM DESCRIPTION": "Switching equipment, power, manufacturing",
    },
    {
      NAICS22: "335313",
      "INDEX ITEM DESCRIPTION":
        "Time switches, electrical switchgear apparatus, manufacturing",
    },
    {
      NAICS22: "335314",
      "INDEX ITEM DESCRIPTION": "Armature relays manufacturing",
    },
    {
      NAICS22: "335314",
      "INDEX ITEM DESCRIPTION":
        "Brakes and clutches, electromagnetic, manufacturing",
    },
    {
      NAICS22: "335314",
      "INDEX ITEM DESCRIPTION": "Brakes, electromagnetic, manufacturing",
    },
    {
      NAICS22: "335314",
      "INDEX ITEM DESCRIPTION":
        "Control circuit devices, magnet and solid-state, manufacturing",
    },
    {
      NAICS22: "335314",
      "INDEX ITEM DESCRIPTION":
        "Control circuit relays, industrial, manufacturing",
    },
    {
      NAICS22: "335314",
      "INDEX ITEM DESCRIPTION": "Control equipment, electric, manufacturing",
    },
    {
      NAICS22: "335314",
      "INDEX ITEM DESCRIPTION":
        "Controls and control accessories, industrial, manufacturing",
    },
    {
      NAICS22: "335314",
      "INDEX ITEM DESCRIPTION":
        "Controls for adjustable speed drives manufacturing",
    },
    {
      NAICS22: "335314",
      "INDEX ITEM DESCRIPTION":
        "Crane and hoist controls, including metal mill, manufacturing",
    },
    {
      NAICS22: "335314",
      "INDEX ITEM DESCRIPTION": "Flow actuated electrical switches manufacturing",
    },
    {
      NAICS22: "335314",
      "INDEX ITEM DESCRIPTION":
        "Industrial controls (e.g., pushbutton, selector, and pilot switches) manufacturing",
    },
    {
      NAICS22: "335314",
      "INDEX ITEM DESCRIPTION":
        "Marine and navy auxiliary controls, manufacturing",
    },
    {
      NAICS22: "335314",
      "INDEX ITEM DESCRIPTION":
        "Motor control accessories (including overload relays) manufacturing",
    },
    {
      NAICS22: "335314",
      "INDEX ITEM DESCRIPTION": "Motor control centers, manufacturing",
    },
    {
      NAICS22: "335314",
      "INDEX ITEM DESCRIPTION": "Motor controls, electric, manufacturing",
    },
    {
      NAICS22: "335314",
      "INDEX ITEM DESCRIPTION":
        "Motor starters, contactors, and controllers, industrial, manufacturing",
    },
    {
      NAICS22: "335314",
      "INDEX ITEM DESCRIPTION": "Numerical controls, manufacturing",
    },
    {
      NAICS22: "335314",
      "INDEX ITEM DESCRIPTION":
        "Relays, electrical and electronic, manufacturing",
    },
    {
      NAICS22: "335314",
      "INDEX ITEM DESCRIPTION": "Rheostats, industrial control, manufacturing",
    },
    {
      NAICS22: "335314",
      "INDEX ITEM DESCRIPTION": "Solenoid switches, industrial, manufacturing",
    },
    {
      NAICS22: "335314",
      "INDEX ITEM DESCRIPTION":
        "Timing devices, mechanical and solid-state (except clockwork), manufacturing",
    },
    {
      NAICS22: "335314",
      "INDEX ITEM DESCRIPTION": "Vacuum relays manufacturing",
    },
    {
      NAICS22: "335910",
      "INDEX ITEM DESCRIPTION": "Alkaline cell primary batteries manufacturing",
    },
    {
      NAICS22: "335910",
      "INDEX ITEM DESCRIPTION":
        "Alkaline cell storage batteries (i.e., nickel-cadmium, nickel-iron, silver oxide-zinc) manufacturing",
    },
    {
      NAICS22: "335910",
      "INDEX ITEM DESCRIPTION":
        "Alkaline manganese primary batteries manufacturing",
    },
    {
      NAICS22: "335910",
      "INDEX ITEM DESCRIPTION": "Automobile storage batteries manufacturing",
    },
    {
      NAICS22: "335910",
      "INDEX ITEM DESCRIPTION": "Batteries, primary, dry or wet, manufacturing",
    },
    {
      NAICS22: "335910",
      "INDEX ITEM DESCRIPTION": "Batteries, rechargeable, manufacturing",
    },
    {
      NAICS22: "335910",
      "INDEX ITEM DESCRIPTION": "Batteries, storage, manufacturing",
    },
    {
      NAICS22: "335910",
      "INDEX ITEM DESCRIPTION": "Button cells, primary batteries, manufacturing",
    },
    {
      NAICS22: "335910",
      "INDEX ITEM DESCRIPTION": "Disposable flashlight batteries manufacturing",
    },
    {
      NAICS22: "335910",
      "INDEX ITEM DESCRIPTION":
        "Dry cell primary batteries, single and multiple cell, manufacturing",
    },
    {
      NAICS22: "335910",
      "INDEX ITEM DESCRIPTION":
        "Dry cells, primary (e.g., AAA, AA, C, D, 9V), manufacturing",
    },
    {
      NAICS22: "335910",
      "INDEX ITEM DESCRIPTION": "Flashlight batteries, disposable, manufacturing",
    },
    {
      NAICS22: "335910",
      "INDEX ITEM DESCRIPTION": "Lead acid storage batteries manufacturing",
    },
    {
      NAICS22: "335910",
      "INDEX ITEM DESCRIPTION": "Lithium batteries manufacturing",
    },
    {
      NAICS22: "335910",
      "INDEX ITEM DESCRIPTION": "Marine storage batteries manufacturing",
    },
    {
      NAICS22: "335910",
      "INDEX ITEM DESCRIPTION": "Mercuric oxide batteries manufacturing",
    },
    {
      NAICS22: "335910",
      "INDEX ITEM DESCRIPTION": "Nickel-cadmium storage batteries manufacturing",
    },
    {
      NAICS22: "335910",
      "INDEX ITEM DESCRIPTION": "Primary batteries manufacturing",
    },
    {
      NAICS22: "335910",
      "INDEX ITEM DESCRIPTION":
        "Rechargeable battery packs made from purchased battery cells and housings",
    },
    {
      NAICS22: "335910",
      "INDEX ITEM DESCRIPTION":
        "Rechargeable nickel-cadmium (NICAD) batteries manufacturing",
    },
    {
      NAICS22: "335910",
      "INDEX ITEM DESCRIPTION": "Storage batteries manufacturing",
    },
    {
      NAICS22: "335910",
      "INDEX ITEM DESCRIPTION": "Transistor radio batteries manufacturing",
    },
    {
      NAICS22: "335910",
      "INDEX ITEM DESCRIPTION": "Watch batteries manufacturing",
    },
    {
      NAICS22: "335910",
      "INDEX ITEM DESCRIPTION": "Zinc carbon batteries manufacturing",
    },
    {
      NAICS22: "335921",
      "INDEX ITEM DESCRIPTION":
        "Fiber optic cable made from purchased fiber optic strand",
    },
    {
      NAICS22: "335929",
      "INDEX ITEM DESCRIPTION":
        "Cable, nonferrous, insulated, or armored, made from purchased nonferrous wire",
    },
    {
      NAICS22: "335929",
      "INDEX ITEM DESCRIPTION":
        "Coaxial cable, nonferrous, made from purchased nonferrous wire",
    },
    {
      NAICS22: "335929",
      "INDEX ITEM DESCRIPTION":
        "Communications wire and cable, nonferrous, made from purchased nonferrous wire",
    },
    {
      NAICS22: "335929",
      "INDEX ITEM DESCRIPTION": "Insulating purchased nonferrous wire",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION": "Arrestors and coils, lighting, manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION": "Automotive electrical switches manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION":
        "Bus bars, electrical conductors (except switchgear-type), manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION":
        "Caps and plugs, attachment, electric, manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION":
        "Conductor connectors, solderless connectors, sleeves, or soldering lugs, manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION":
        "Connectors and terminals for electrical devices manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION": "Connectors, electric cord, manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION":
        "Connectors, solderless (wiring devices), manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION":
        "Connectors, twist on wire (i.e., nuts), manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION":
        "Contacts, electrical (except carbon and graphite), manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION": "Convenience outlets, electric, manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION": "Cord connectors, electric, manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION":
        "Current taps, attachment plug and screw shell types, manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION": "Cutouts, switch and fuse, manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION":
        "Dimmer switches, outlet box mounting-type, manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION": "Duplex receptacles, electrical, manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION": "Fuse cutouts manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION":
        "GFCI (ground fault circuit interrupters) manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION":
        "Ground clamps (i.e., electric wiring devices) manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION":
        "Ground fault circuit interrupters (GFCI) manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION": "Lamp holders manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION":
        "Lamp sockets and receptacles (i.e., electric wiring devices) manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION": "Lightning arrestors and coils manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION": "Lightning protection equipment manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION": "Lugs and connectors, electrical, manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION":
        "Outlets (i.e., receptacles), electrical, manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION": "Outlets, convenience, electrical, manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION": "Plugs, electric cord, manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION":
        "Rail bonds, propulsion and signal circuit electric, manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION":
        "Receptacles (i.e., outlets), electrical, manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION":
        "Rheostats (i.e., dimmer switches), current-carrying wiring device, manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION":
        "Snap switches (i.e., electric wiring devices) manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION": "Sockets, electric, manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION":
        "Solderless connectors (electric wiring devices) manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION": "Switch cutouts manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION":
        "Switches for electrical wiring (e.g., pressure, pushbutton, snap, tumbler) manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION":
        "Switches, outlet box mounting-type, manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION":
        "Taps, current, attachment plug and screw shell types, manufacturing",
    },
    {
      NAICS22: "335931",
      "INDEX ITEM DESCRIPTION":
        "Terminals and connectors for electrical devices manufacturing",
    },
    {
      NAICS22: "335932",
      "INDEX ITEM DESCRIPTION":
        "Boxes, electrical wiring (e.g., junction, outlet, switch), manufacturing",
    },
    {
      NAICS22: "335932",
      "INDEX ITEM DESCRIPTION":
        "Conduits and fittings, electrical, manufacturing",
    },
    {
      NAICS22: "335932",
      "INDEX ITEM DESCRIPTION": "Electrical metallic tube (EMTs) manufacturing",
    },
    {
      NAICS22: "335932",
      "INDEX ITEM DESCRIPTION": "EMTs (electrical metallic tube) manufacturing",
    },
    {
      NAICS22: "335932",
      "INDEX ITEM DESCRIPTION":
        "Face plates (i.e., outlet or switch covers) manufacturing",
    },
    {
      NAICS22: "335932",
      "INDEX ITEM DESCRIPTION":
        "Hardware, transmission pole and line, manufacturing",
    },
    {
      NAICS22: "335932",
      "INDEX ITEM DESCRIPTION":
        "Insulators, electrical (except glass, porcelain), manufacturing",
    },
    {
      NAICS22: "335932",
      "INDEX ITEM DESCRIPTION":
        "Junction boxes, electrical wiring, manufacturing",
    },
    {
      NAICS22: "335932",
      "INDEX ITEM DESCRIPTION": "Outlet boxes, electrical wiring, manufacturing",
    },
    {
      NAICS22: "335932",
      "INDEX ITEM DESCRIPTION":
        "Plates (i.e., outlet or switch covers), face, manufacturing",
    },
    {
      NAICS22: "335932",
      "INDEX ITEM DESCRIPTION": "Raceways manufacturing",
    },
    {
      NAICS22: "335932",
      "INDEX ITEM DESCRIPTION": "Switch boxes, electrical wiring, manufacturing",
    },
    {
      NAICS22: "335932",
      "INDEX ITEM DESCRIPTION":
        "Transmission pole and line hardware manufacturing",
    },
    {
      NAICS22: "335991",
      "INDEX ITEM DESCRIPTION":
        "Brush blocks, carbon or molded graphite, manufacturing",
    },
    {
      NAICS22: "335991",
      "INDEX ITEM DESCRIPTION":
        "Brushes and brush stock contacts, electric, carbon and graphite, manufacturing",
    },
    {
      NAICS22: "335991",
      "INDEX ITEM DESCRIPTION": "Brushplates, carbon or graphite, manufacturing",
    },
    {
      NAICS22: "335991",
      "INDEX ITEM DESCRIPTION":
        "Carbon electrodes and contacts, electric, manufacturing",
    },
    {
      NAICS22: "335991",
      "INDEX ITEM DESCRIPTION":
        "Carbon specialties for aerospace use (except gaskets) manufacturing",
    },
    {
      NAICS22: "335991",
      "INDEX ITEM DESCRIPTION":
        "Carbon specialties for electrical use manufacturing",
    },
    {
      NAICS22: "335991",
      "INDEX ITEM DESCRIPTION":
        "Carbon specialties for mechanical use (except gaskets) manufacturing",
    },
    {
      NAICS22: "335991",
      "INDEX ITEM DESCRIPTION": "Carbons, electric, manufacturing",
    },
    {
      NAICS22: "335991",
      "INDEX ITEM DESCRIPTION": "Carbons, lighting, manufacturing",
    },
    {
      NAICS22: "335991",
      "INDEX ITEM DESCRIPTION":
        "Contacts, electrical, carbon and graphite, manufacturing",
    },
    {
      NAICS22: "335991",
      "INDEX ITEM DESCRIPTION":
        "Electrodes for thermal and electrolytic uses, carbon and graphite, manufacturing",
    },
    {
      NAICS22: "335991",
      "INDEX ITEM DESCRIPTION": "Fibers, carbon and graphite, manufacturing",
    },
    {
      NAICS22: "335991",
      "INDEX ITEM DESCRIPTION":
        "Graphite electrodes and contacts, electric, manufacturing",
    },
    {
      NAICS22: "335991",
      "INDEX ITEM DESCRIPTION":
        "Graphite specialties for aerospace use (except gaskets) manufacturing",
    },
    {
      NAICS22: "335991",
      "INDEX ITEM DESCRIPTION":
        "Graphite specialties for electrical use manufacturing",
    },
    {
      NAICS22: "335991",
      "INDEX ITEM DESCRIPTION":
        "Graphite specialties for mechanical use (except gaskets) manufacturing",
    },
    {
      NAICS22: "335991",
      "INDEX ITEM DESCRIPTION": "Heat shields, carbon or graphite, manufacturing",
    },
    {
      NAICS22: "335991",
      "INDEX ITEM DESCRIPTION": "Lighting carbons manufacturing",
    },
    {
      NAICS22: "335991",
      "INDEX ITEM DESCRIPTION": "Metal-graphite products manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION":
        "Amplifiers, magnetic, pulse, and maser, manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION":
        "Appliance cords made from purchased insulated wire",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION":
        "Atom smashers (i.e., particle accelerators) manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION": "Battery chargers, solid-state, manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION": "Bells, electric, manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION": "Betatrons manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION":
        "Capacitors (except electronic), fixed and variable, manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION": "Cathodic protection equipment manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION": "Chimes, electric, manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION":
        "Cleaning equipment, ultrasonic (except dental, medical), manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION":
        "Condensers (except electronic), fixed and variable, manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION": "Cyclotrons manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION":
        "Door opening and closing devices, electrical, manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION": "Electric bells manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION": "Electric fence chargers manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION":
        "Electrochemical generators (i.e., fuel cells) manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION": "Electron linear accelerators manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION":
        "Electrostatic particle accelerators manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION":
        "Extension cords made from purchased insulated wire",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION":
        "Fuel cells, electrochemical generators, manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION": "Garage door openers manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION": "Gongs, electric, manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION": "Inverters, solid-state, manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION": "Linear accelerators manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION":
        "Maser (i.e., microwave amplification by stimulated emission of radiation) amplifiers manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION":
        "Mercury arc rectifiers (i.e., electrical apparatus) manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION":
        "Particle accelerators, high-voltage, manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION": "Photovoltaic panels made from purchased cells",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION":
        "Power converter units (i.e., AC to DC), static, manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION":
        "Power supplies, regulated and unregulated, manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION":
        "Rectifiers (except electronic component-type, semiconductor) manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION": "Semiconductor battery chargers manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION":
        "Semiconductor high-voltage power supplies manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION":
        "Series capacitors (except electronic) manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION": "Surge suppressors manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION": "Thermoelectric generators manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION":
        "Ultrasonic cleaning equipment (except dental, medical) manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION":
        "Ultrasonic generators sold separately for inclusion in tools and equipment manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION":
        "Uninterruptible power supplies (UPS) manufacturing",
    },
    {
      NAICS22: "335999",
      "INDEX ITEM DESCRIPTION":
        "UPS (uninterruptible power supplies) manufacturing",
    },
    {
      NAICS22: "336110",
      "INDEX ITEM DESCRIPTION":
        "Assembly plants, light trucks on chassis of own manufacture",
    },
    {
      NAICS22: "336110",
      "INDEX ITEM DESCRIPTION":
        "Assembly plants, minivans on chassis of own manufacture",
    },
    {
      NAICS22: "336110",
      "INDEX ITEM DESCRIPTION":
        "Assembly plants, passenger car on chassis of own manufacture",
    },
    {
      NAICS22: "336110",
      "INDEX ITEM DESCRIPTION":
        "Assembly plants, sport utility vehicles on chassis of own manufacture",
    },
    {
      NAICS22: "336110",
      "INDEX ITEM DESCRIPTION":
        "Automobiles assembling on chassis of own manufacture",
    },
    {
      NAICS22: "336110",
      "INDEX ITEM DESCRIPTION":
        "Cab and chassis, light trucks and vans, manufacturing",
    },
    {
      NAICS22: "336110",
      "INDEX ITEM DESCRIPTION":
        "Cars, electric, for highway use, assembling on chassis of own manufacture",
    },
    {
      NAICS22: "336110",
      "INDEX ITEM DESCRIPTION": "Chassis, automobile, manufacturing",
    },
    {
      NAICS22: "336110",
      "INDEX ITEM DESCRIPTION": "Chassis, light truck and utility, manufacturing",
    },
    {
      NAICS22: "336110",
      "INDEX ITEM DESCRIPTION":
        "Electric automobiles for highway use manufacturing",
    },
    {
      NAICS22: "336110",
      "INDEX ITEM DESCRIPTION":
        "Hearses assembling on chassis of own manufacture",
    },
    {
      NAICS22: "336110",
      "INDEX ITEM DESCRIPTION":
        "Light utility trucks assembling on chassis of own manufacture",
    },
    {
      NAICS22: "336110",
      "INDEX ITEM DESCRIPTION":
        "Minivans assembling on chassis of own manufacture",
    },
    {
      NAICS22: "336110",
      "INDEX ITEM DESCRIPTION":
        "Motor homes, self-contained, mounted on light duty truck chassis of own manufacture",
    },
    {
      NAICS22: "336110",
      "INDEX ITEM DESCRIPTION":
        "Pick-up trucks, light duty, assembling on chassis of own manufacture",
    },
    {
      NAICS22: "336110",
      "INDEX ITEM DESCRIPTION":
        "Sport utility vehicles assembling on chassis of own manufacture",
    },
    {
      NAICS22: "336110",
      "INDEX ITEM DESCRIPTION":
        "Trucks, light duty, assembling on chassis of own manufacture",
    },
    {
      NAICS22: "336110",
      "INDEX ITEM DESCRIPTION": "Unmanned and robotic automobiles manufacturing",
    },
    {
      NAICS22: "336110",
      "INDEX ITEM DESCRIPTION":
        "Vans, commercial and passenger light duty, assembling on chassis of own manufacture",
    },
    {
      NAICS22: "336120",
      "INDEX ITEM DESCRIPTION":
        "Assembly plants, heavy trucks, and buses on chassis of own manufacture",
    },
    {
      NAICS22: "336120",
      "INDEX ITEM DESCRIPTION":
        "Buses (except trackless trolley) assembling on chassis of own manufacture",
    },
    {
      NAICS22: "336120",
      "INDEX ITEM DESCRIPTION":
        "Chassis, heavy truck, with or without cabs, manufacturing",
    },
    {
      NAICS22: "336120",
      "INDEX ITEM DESCRIPTION":
        "Garbage trucks assembling on chassis of own manufacture",
    },
    {
      NAICS22: "336120",
      "INDEX ITEM DESCRIPTION":
        "Heavy trucks assembling on chassis of own manufacture",
    },
    {
      NAICS22: "336120",
      "INDEX ITEM DESCRIPTION":
        "Highway tractors assembled on chassis of own manufacture",
    },
    {
      NAICS22: "336120",
      "INDEX ITEM DESCRIPTION":
        "Motor homes, self-contained, mounted on heavy truck chassis of own manufacture",
    },
    {
      NAICS22: "336120",
      "INDEX ITEM DESCRIPTION":
        "Special purpose highway vehicles (e.g., firefighting vehicles) assembling on heavy chassis of own manufacture",
    },
    {
      NAICS22: "336120",
      "INDEX ITEM DESCRIPTION":
        "Tractors, truck for highway use, assembled on chassis of own manufacture",
    },
    {
      NAICS22: "336120",
      "INDEX ITEM DESCRIPTION":
        "Truck tractors for highway use, assembling on chassis of own manufacture",
    },
    {
      NAICS22: "336120",
      "INDEX ITEM DESCRIPTION":
        "Trucks, heavy, assembling on chassis of own manufacture",
    },
    {
      NAICS22: "336211",
      "INDEX ITEM DESCRIPTION": "Ambulance bodies manufacturing",
    },
    {
      NAICS22: "336211",
      "INDEX ITEM DESCRIPTION": "Ambulances assembling on purchased chassis",
    },
    {
      NAICS22: "336211",
      "INDEX ITEM DESCRIPTION": "Automobile bodies, passenger car, manufacturing",
    },
    {
      NAICS22: "336211",
      "INDEX ITEM DESCRIPTION": "Automobile wrecker truck bodies manufacturing",
    },
    {
      NAICS22: "336211",
      "INDEX ITEM DESCRIPTION":
        "Automobile wreckers assembling on purchased chassis",
    },
    {
      NAICS22: "336211",
      "INDEX ITEM DESCRIPTION":
        "Boxes, truck (e.g., cargo, dump, utility, van), assembled on purchased chassis",
    },
    {
      NAICS22: "336211",
      "INDEX ITEM DESCRIPTION": "Bus bodies assembling on purchased chassis",
    },
    {
      NAICS22: "336211",
      "INDEX ITEM DESCRIPTION": "Bus bodies manufacturing",
    },
    {
      NAICS22: "336211",
      "INDEX ITEM DESCRIPTION": "Car bodies, kit, manufacturing",
    },
    {
      NAICS22: "336211",
      "INDEX ITEM DESCRIPTION": "Dump-truck lifting mechanisms manufacturing",
    },
    {
      NAICS22: "336211",
      "INDEX ITEM DESCRIPTION": "Fifth-wheel assemblies manufacturing",
    },
    {
      NAICS22: "336211",
      "INDEX ITEM DESCRIPTION": "Garbage truck bodies manufacturing",
    },
    {
      NAICS22: "336211",
      "INDEX ITEM DESCRIPTION": "Garbage trucks assembling on purchased chassis",
    },
    {
      NAICS22: "336211",
      "INDEX ITEM DESCRIPTION": "Hearse bodies manufacturing",
    },
    {
      NAICS22: "336211",
      "INDEX ITEM DESCRIPTION": "Hearses assembling on purchased chassis",
    },
    {
      NAICS22: "336211",
      "INDEX ITEM DESCRIPTION": "Heavy trucks assembling on purchased chassis",
    },
    {
      NAICS22: "336211",
      "INDEX ITEM DESCRIPTION":
        "Highway tractors assembling on purchased chassis",
    },
    {
      NAICS22: "336211",
      "INDEX ITEM DESCRIPTION": "Kit car bodies manufacturing",
    },
    {
      NAICS22: "336211",
      "INDEX ITEM DESCRIPTION":
        "Ready-mix concrete trucks assembling on purchased chassis",
    },
    {
      NAICS22: "336211",
      "INDEX ITEM DESCRIPTION": "School buses assembling on purchased chassis",
    },
    {
      NAICS22: "336211",
      "INDEX ITEM DESCRIPTION":
        "Special purpose highway vehicle (e.g., firefighting vehicles) assembling on purchased chassis",
    },
    {
      NAICS22: "336211",
      "INDEX ITEM DESCRIPTION":
        "Special purpose highway vehicle (e.g., firefighting vehicles) bodies manufacturing",
    },
    {
      NAICS22: "336211",
      "INDEX ITEM DESCRIPTION":
        "Stretch limousines assembling on purchased chassis",
    },
    {
      NAICS22: "336211",
      "INDEX ITEM DESCRIPTION": "Tank bodies for trucks manufacturing",
    },
    {
      NAICS22: "336211",
      "INDEX ITEM DESCRIPTION":
        "Tank trucks (e.g., fuel oil, milk, water) assembling on purchased chassis",
    },
    {
      NAICS22: "336211",
      "INDEX ITEM DESCRIPTION":
        "Tow trucks (including tilt and load) assembling on purchased chassis",
    },
    {
      NAICS22: "336211",
      "INDEX ITEM DESCRIPTION": "Truck bodies and cabs manufacturing",
    },
    {
      NAICS22: "336211",
      "INDEX ITEM DESCRIPTION": "Truck bodies assembling on purchased chassis",
    },
    {
      NAICS22: "336211",
      "INDEX ITEM DESCRIPTION":
        "Truck tractors for highway use, assembling on purchased chassis",
    },
    {
      NAICS22: "336212",
      "INDEX ITEM DESCRIPTION":
        "Automobile transporter trailers, multi-car, manufacturing",
    },
    {
      NAICS22: "336212",
      "INDEX ITEM DESCRIPTION":
        "Boat transporter trailers, multi-unit, manufacturing",
    },
    {
      NAICS22: "336212",
      "INDEX ITEM DESCRIPTION": "Demountable cargo containers manufacturing",
    },
    {
      NAICS22: "336212",
      "INDEX ITEM DESCRIPTION": "Dump trailers manufacturing",
    },
    {
      NAICS22: "336212",
      "INDEX ITEM DESCRIPTION": "Flatbed trailers, commercial, manufacturing",
    },
    {
      NAICS22: "336212",
      "INDEX ITEM DESCRIPTION": "Horse trailers, fifth-wheel-type, manufacturing",
    },
    {
      NAICS22: "336212",
      "INDEX ITEM DESCRIPTION": "Logging trailers manufacturing",
    },
    {
      NAICS22: "336212",
      "INDEX ITEM DESCRIPTION": "Semi-trailers manufacturing",
    },
    {
      NAICS22: "336212",
      "INDEX ITEM DESCRIPTION":
        "Tank trailers, liquid and dry bulk, manufacturing",
    },
    {
      NAICS22: "336212",
      "INDEX ITEM DESCRIPTION":
        "Trailers, fifth-wheel-type, for transporting horses, manufacturing",
    },
    {
      NAICS22: "336212",
      "INDEX ITEM DESCRIPTION": "Truck trailers manufacturing",
    },
    {
      NAICS22: "336213",
      "INDEX ITEM DESCRIPTION":
        "Assembly line conversions of purchased vans and minivans",
    },
    {
      NAICS22: "336213",
      "INDEX ITEM DESCRIPTION":
        "Motor homes, self-contained, assembling on purchased chassis",
    },
    {
      NAICS22: "336213",
      "INDEX ITEM DESCRIPTION":
        "Van and minivan conversions on purchased chassis",
    },
    {
      NAICS22: "336214",
      "INDEX ITEM DESCRIPTION":
        "Automobile transporter trailers, single car, manufacturing",
    },
    {
      NAICS22: "336214",
      "INDEX ITEM DESCRIPTION":
        "Boat transporter trailers, single-unit, manufacturing",
    },
    {
      NAICS22: "336214",
      "INDEX ITEM DESCRIPTION":
        "Camper units, slide-in, for pick-up trucks, manufacturing",
    },
    {
      NAICS22: "336214",
      "INDEX ITEM DESCRIPTION": "Camping trailers and chassis manufacturing",
    },
    {
      NAICS22: "336214",
      "INDEX ITEM DESCRIPTION": "Caps for pick-up trucks manufacturing",
    },
    {
      NAICS22: "336214",
      "INDEX ITEM DESCRIPTION":
        "Horse trailers (except fifth-wheel-type) manufacturing",
    },
    {
      NAICS22: "336214",
      "INDEX ITEM DESCRIPTION": "Pick-up canopies, caps, or covers manufacturing",
    },
    {
      NAICS22: "336214",
      "INDEX ITEM DESCRIPTION":
        "Tent trailers (hard top and soft top) manufacturing",
    },
    {
      NAICS22: "336214",
      "INDEX ITEM DESCRIPTION":
        "Trailers for transporting horses (except fifth-wheel-type) manufacturing",
    },
    {
      NAICS22: "336214",
      "INDEX ITEM DESCRIPTION": "Trailers, camping, manufacturing",
    },
    {
      NAICS22: "336214",
      "INDEX ITEM DESCRIPTION": "Travel trailers, recreational, manufacturing",
    },
    {
      NAICS22: "336214",
      "INDEX ITEM DESCRIPTION":
        "Truck campers (i.e., slide-in campers) manufacturing",
    },
    {
      NAICS22: "336214",
      "INDEX ITEM DESCRIPTION": "Utility trailers manufacturing",
    },
    {
      NAICS22: "336310",
      "INDEX ITEM DESCRIPTION":
        "Assembly line rebuilding of automotive and truck gasoline engines",
    },
    {
      NAICS22: "336310",
      "INDEX ITEM DESCRIPTION":
        "Bearings (e.g., camshaft, crankshaft, connecting rod), automotive and truck gasoline engine, manufacturing",
    },
    {
      NAICS22: "336310",
      "INDEX ITEM DESCRIPTION": "Carburetors, all types, manufacturing",
    },
    {
      NAICS22: "336310",
      "INDEX ITEM DESCRIPTION":
        "Connecting rods, automotive and truck gasoline engine, manufacturing",
    },
    {
      NAICS22: "336310",
      "INDEX ITEM DESCRIPTION":
        "Crankshaft assemblies, automotive and truck gasoline engine, manufacturing",
    },
    {
      NAICS22: "336310",
      "INDEX ITEM DESCRIPTION":
        "Cylinder heads, automotive and truck gasoline engine, manufacturing",
    },
    {
      NAICS22: "336310",
      "INDEX ITEM DESCRIPTION":
        "Engine block assemblies, automotive and truck gasoline, manufacturing",
    },
    {
      NAICS22: "336310",
      "INDEX ITEM DESCRIPTION": "Engine intake and exhaust valves manufacturing",
    },
    {
      NAICS22: "336310",
      "INDEX ITEM DESCRIPTION":
        "Engines and parts (except diesel), automotive and truck, manufacturing",
    },
    {
      NAICS22: "336310",
      "INDEX ITEM DESCRIPTION":
        "Flywheels and ring gears, automotive and truck gasoline engine, manufacturing",
    },
    {
      NAICS22: "336310",
      "INDEX ITEM DESCRIPTION":
        "Fuel injection systems and parts, automotive and truck gasoline engine, manufacturing",
    },
    {
      NAICS22: "336310",
      "INDEX ITEM DESCRIPTION":
        "Fuel pumps, mechanical, automotive and truck gasoline engine, manufacturing",
    },
    {
      NAICS22: "336310",
      "INDEX ITEM DESCRIPTION":
        "Gasoline engine parts, mechanical, automotive and truck, manufacturing",
    },
    {
      NAICS22: "336310",
      "INDEX ITEM DESCRIPTION":
        "Gasoline engines for hybrid automotive vehicles manufacturing",
    },
    {
      NAICS22: "336310",
      "INDEX ITEM DESCRIPTION":
        "Gasoline engines, automotive and truck, manufacturing",
    },
    {
      NAICS22: "336310",
      "INDEX ITEM DESCRIPTION":
        "Governors for automotive gasoline engines manufacturing",
    },
    {
      NAICS22: "336310",
      "INDEX ITEM DESCRIPTION":
        "Internal combustion engines, automotive and truck gasoline, manufacturing",
    },
    {
      NAICS22: "336310",
      "INDEX ITEM DESCRIPTION":
        "Manifolds (i.e., intake and exhaust), automotive and truck gasoline engine, manufacturing",
    },
    {
      NAICS22: "336310",
      "INDEX ITEM DESCRIPTION": "Pistons and piston rings manufacturing",
    },
    {
      NAICS22: "336310",
      "INDEX ITEM DESCRIPTION":
        "Positive crankcase ventilation (PCV) valves, engine, manufacturing",
    },
    {
      NAICS22: "336310",
      "INDEX ITEM DESCRIPTION":
        "Pumps (e.g., fuel, oil, water), mechanical, automotive and truck gasoline engine (except power steering), manufacturing",
    },
    {
      NAICS22: "336310",
      "INDEX ITEM DESCRIPTION":
        "Rebuilding automotive and truck gasoline engines",
    },
    {
      NAICS22: "336310",
      "INDEX ITEM DESCRIPTION": "Rings, piston, manufacturing",
    },
    {
      NAICS22: "336310",
      "INDEX ITEM DESCRIPTION":
        "Rocker arms and parts, automotive and truck gasoline engine, manufacturing",
    },
    {
      NAICS22: "336310",
      "INDEX ITEM DESCRIPTION":
        "Timing gears and chains, automotive and truck gasoline engine, manufacturing",
    },
    {
      NAICS22: "336310",
      "INDEX ITEM DESCRIPTION":
        "Valves, engine, intake and exhaust, manufacturing",
    },
    {
      NAICS22: "336320",
      "INDEX ITEM DESCRIPTION": "Aircraft lighting fixtures manufacturing",
    },
    {
      NAICS22: "336320",
      "INDEX ITEM DESCRIPTION":
        "Alternators and generators for internal combustion engines manufacturing",
    },
    {
      NAICS22: "336320",
      "INDEX ITEM DESCRIPTION":
        "Automotive harness and ignition sets manufacturing",
    },
    {
      NAICS22: "336320",
      "INDEX ITEM DESCRIPTION": "Automotive lighting fixtures manufacturing",
    },
    {
      NAICS22: "336320",
      "INDEX ITEM DESCRIPTION": "Boat and ship lighting fixtures manufacturing",
    },
    {
      NAICS22: "336320",
      "INDEX ITEM DESCRIPTION":
        "Coils, ignition, internal combustion engines, manufacturing",
    },
    {
      NAICS22: "336320",
      "INDEX ITEM DESCRIPTION":
        "Cruise control mechanisms, electronic, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336320",
      "INDEX ITEM DESCRIPTION":
        "Distributor cap and rotor for internal combustion engines manufacturing",
    },
    {
      NAICS22: "336320",
      "INDEX ITEM DESCRIPTION":
        "Distributors for internal combustion engines manufacturing",
    },
    {
      NAICS22: "336320",
      "INDEX ITEM DESCRIPTION":
        "Electrical control chips (modules), motor vehicle, manufacturing",
    },
    {
      NAICS22: "336320",
      "INDEX ITEM DESCRIPTION":
        "Electrical ignition cable sets for internal combustion engines manufacturing",
    },
    {
      NAICS22: "336320",
      "INDEX ITEM DESCRIPTION":
        "Fans, electric cooling, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336320",
      "INDEX ITEM DESCRIPTION":
        "Fuel pumps, electric, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336320",
      "INDEX ITEM DESCRIPTION":
        "Generating apparatus and parts for internal combustion engines manufacturing",
    },
    {
      NAICS22: "336320",
      "INDEX ITEM DESCRIPTION":
        "Generators for internal combustion engines manufacturing",
    },
    {
      NAICS22: "336320",
      "INDEX ITEM DESCRIPTION":
        "Ignition points and condensers for internal combustion engines manufacturing",
    },
    {
      NAICS22: "336320",
      "INDEX ITEM DESCRIPTION":
        "Ignition wiring harness for internal combustion engines manufacturing",
    },
    {
      NAICS22: "336320",
      "INDEX ITEM DESCRIPTION":
        "Instrument control panels (i.e., assembling purchased gauges), automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336320",
      "INDEX ITEM DESCRIPTION":
        "Keyless entry systems, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336320",
      "INDEX ITEM DESCRIPTION":
        "Locomotive and railroad car light fixtures manufacturing",
    },
    {
      NAICS22: "336320",
      "INDEX ITEM DESCRIPTION":
        "Motors, starter, for internal combustion engines, manufacturing",
    },
    {
      NAICS22: "336320",
      "INDEX ITEM DESCRIPTION":
        "Power window and door lock systems, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336320",
      "INDEX ITEM DESCRIPTION":
        "Regulators, motor vehicle voltage for internal combustion engines manufacturing",
    },
    {
      NAICS22: "336320",
      "INDEX ITEM DESCRIPTION":
        "Spark plugs for internal combustion engines manufacturing",
    },
    {
      NAICS22: "336320",
      "INDEX ITEM DESCRIPTION": "Spotlights, vehicular, manufacturing",
    },
    {
      NAICS22: "336320",
      "INDEX ITEM DESCRIPTION":
        "Starter and starter parts for internal combustion engines manufacturing",
    },
    {
      NAICS22: "336320",
      "INDEX ITEM DESCRIPTION": "Vehicular lighting fixtures manufacturing",
    },
    {
      NAICS22: "336320",
      "INDEX ITEM DESCRIPTION":
        "Voltage regulators for internal combustion engines manufacturing",
    },
    {
      NAICS22: "336320",
      "INDEX ITEM DESCRIPTION":
        "Windshield washer pumps, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336320",
      "INDEX ITEM DESCRIPTION":
        "Windshield wiper systems, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336320",
      "INDEX ITEM DESCRIPTION":
        "Wiring harness and ignition sets for internal combustion engines manufacturing",
    },
    {
      NAICS22: "336330",
      "INDEX ITEM DESCRIPTION":
        "Automotive, truck and bus steering assemblies and parts manufacturing",
    },
    {
      NAICS22: "336330",
      "INDEX ITEM DESCRIPTION":
        "Automotive, truck and bus suspension assemblies and parts (except springs) manufacturing",
    },
    {
      NAICS22: "336330",
      "INDEX ITEM DESCRIPTION": "Power steering hose assemblies manufacturing",
    },
    {
      NAICS22: "336330",
      "INDEX ITEM DESCRIPTION": "Power steering pumps manufacturing",
    },
    {
      NAICS22: "336330",
      "INDEX ITEM DESCRIPTION":
        "Rack and pinion steering assemblies manufacturing",
    },
    {
      NAICS22: "336330",
      "INDEX ITEM DESCRIPTION":
        "Shock absorbers, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336330",
      "INDEX ITEM DESCRIPTION":
        "Steering boxes, manual and power assist, manufacturing",
    },
    {
      NAICS22: "336330",
      "INDEX ITEM DESCRIPTION":
        "Steering columns, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336330",
      "INDEX ITEM DESCRIPTION":
        "Steering wheels, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336330",
      "INDEX ITEM DESCRIPTION":
        "Struts, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336330",
      "INDEX ITEM DESCRIPTION":
        "Wheels, steering, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336340",
      "INDEX ITEM DESCRIPTION":
        "Air brake systems and parts, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336340",
      "INDEX ITEM DESCRIPTION":
        "Brake and brake parts, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336340",
      "INDEX ITEM DESCRIPTION":
        "Brake caliper assemblies, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336340",
      "INDEX ITEM DESCRIPTION":
        "Brake cylinders, master and wheel, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336340",
      "INDEX ITEM DESCRIPTION":
        "Brake discs (rotor), automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336340",
      "INDEX ITEM DESCRIPTION":
        "Brake drums, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336340",
      "INDEX ITEM DESCRIPTION": "Brake hose assemblies manufacturing",
    },
    {
      NAICS22: "336340",
      "INDEX ITEM DESCRIPTION":
        "Brake linings, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336340",
      "INDEX ITEM DESCRIPTION":
        "Brake pads and shoes, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336340",
      "INDEX ITEM DESCRIPTION": "Brake shoes and pads, asbestos, manufacturing",
    },
    {
      NAICS22: "336340",
      "INDEX ITEM DESCRIPTION":
        "Calipers, brake, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336340",
      "INDEX ITEM DESCRIPTION":
        "Cylinders, master brake (new and rebuilt), manufacturing",
    },
    {
      NAICS22: "336340",
      "INDEX ITEM DESCRIPTION":
        "Hydraulic slave cylinders, automotive, truck, and bus clutch, manufacturing",
    },
    {
      NAICS22: "336340",
      "INDEX ITEM DESCRIPTION":
        "Vacuum brake booster, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336350",
      "INDEX ITEM DESCRIPTION":
        "Assembly line rebuilding of automotive, truck, and bus transmissions",
    },
    {
      NAICS22: "336350",
      "INDEX ITEM DESCRIPTION":
        "Automatic transmissions, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336350",
      "INDEX ITEM DESCRIPTION":
        "Axle bearings, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336350",
      "INDEX ITEM DESCRIPTION":
        "Clutches and clutch discs, asbestos, manufacturing",
    },
    {
      NAICS22: "336350",
      "INDEX ITEM DESCRIPTION":
        "Constant velocity joints, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336350",
      "INDEX ITEM DESCRIPTION":
        "Differential and rear axle assemblies, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336350",
      "INDEX ITEM DESCRIPTION":
        "Drive shafts and half shafts, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336350",
      "INDEX ITEM DESCRIPTION":
        "Gears (e.g., crown, pinion, spider), automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336350",
      "INDEX ITEM DESCRIPTION":
        "Joints, universal, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336350",
      "INDEX ITEM DESCRIPTION":
        "Pressure and clutch plate assemblies, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336350",
      "INDEX ITEM DESCRIPTION": "Scattershield, engine, manufacturing",
    },
    {
      NAICS22: "336350",
      "INDEX ITEM DESCRIPTION":
        "Torque converters, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336350",
      "INDEX ITEM DESCRIPTION":
        "Transaxles, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336350",
      "INDEX ITEM DESCRIPTION":
        "Transmissions and parts, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336350",
      "INDEX ITEM DESCRIPTION":
        "Universal joints, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336360",
      "INDEX ITEM DESCRIPTION": "Aircraft seats manufacturing",
    },
    {
      NAICS22: "336360",
      "INDEX ITEM DESCRIPTION": "Automobile seat covers manufacturing",
    },
    {
      NAICS22: "336360",
      "INDEX ITEM DESCRIPTION": "Automobile seat frames, metal, manufacturing",
    },
    {
      NAICS22: "336360",
      "INDEX ITEM DESCRIPTION": "Automobile trimmings, textile, manufacturing",
    },
    {
      NAICS22: "336360",
      "INDEX ITEM DESCRIPTION":
        "Motor vehicle interior systems (e.g., headliners, panels, seats, trims) manufacturing",
    },
    {
      NAICS22: "336360",
      "INDEX ITEM DESCRIPTION": "Motor vehicle seats manufacturing",
    },
    {
      NAICS22: "336360",
      "INDEX ITEM DESCRIPTION":
        "Motor vehicle seats, metal framed, manufacturing",
    },
    {
      NAICS22: "336360",
      "INDEX ITEM DESCRIPTION": "Motor vehicle trimmings manufacturing",
    },
    {
      NAICS22: "336360",
      "INDEX ITEM DESCRIPTION": "Railroad seating manufacturing",
    },
    {
      NAICS22: "336360",
      "INDEX ITEM DESCRIPTION":
        "Seat belts, motor vehicle and aircraft, manufacturing",
    },
    {
      NAICS22: "336360",
      "INDEX ITEM DESCRIPTION": "Seats for public conveyances, manufacturing",
    },
    {
      NAICS22: "336360",
      "INDEX ITEM DESCRIPTION": "Seats, railroad, manufacturing",
    },
    {
      NAICS22: "336360",
      "INDEX ITEM DESCRIPTION": "Tire covers made from purchased fabric",
    },
    {
      NAICS22: "336360",
      "INDEX ITEM DESCRIPTION": "Transportation equipment seating manufacturing",
    },
    {
      NAICS22: "336370",
      "INDEX ITEM DESCRIPTION": "Job stampings, automotive, metal, manufacturing",
    },
    {
      NAICS22: "336370",
      "INDEX ITEM DESCRIPTION": "Metal motor vehicle body parts stamping",
    },
    {
      NAICS22: "336370",
      "INDEX ITEM DESCRIPTION": "Moldings and trim, motor vehicle, stamping",
    },
    {
      NAICS22: "336370",
      "INDEX ITEM DESCRIPTION": "Motor vehicle metal bumper stampings",
    },
    {
      NAICS22: "336370",
      "INDEX ITEM DESCRIPTION": "Motor vehicle metal parts stamping",
    },
    {
      NAICS22: "336370",
      "INDEX ITEM DESCRIPTION":
        "Motor vehicle metal stampings (e.g., body parts, fenders, hub caps, tops, trim) manufacturing",
    },
    {
      NAICS22: "336370",
      "INDEX ITEM DESCRIPTION": "Stamping metal motor vehicle body parts",
    },
    {
      NAICS22: "336370",
      "INDEX ITEM DESCRIPTION": "Stamping metal motor vehicle moldings and trims",
    },
    {
      NAICS22: "336390",
      "INDEX ITEM DESCRIPTION": "Air bag assemblies manufacturing",
    },
    {
      NAICS22: "336390",
      "INDEX ITEM DESCRIPTION": "Air bag initiators manufacturing",
    },
    {
      NAICS22: "336390",
      "INDEX ITEM DESCRIPTION":
        "Air filters, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336390",
      "INDEX ITEM DESCRIPTION": "Air-conditioners, motor vehicle, manufacturing",
    },
    {
      NAICS22: "336390",
      "INDEX ITEM DESCRIPTION": "Automotive mirrors, framed, manufacturing",
    },
    {
      NAICS22: "336390",
      "INDEX ITEM DESCRIPTION":
        "Bumpers and bumperettes assembled, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336390",
      "INDEX ITEM DESCRIPTION":
        "Catalytic converters, engine exhaust, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336390",
      "INDEX ITEM DESCRIPTION":
        "Compressors, motor vehicle air-conditioning, manufacturing",
    },
    {
      NAICS22: "336390",
      "INDEX ITEM DESCRIPTION":
        "Convertible tops for automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336390",
      "INDEX ITEM DESCRIPTION":
        "Exhaust and tail pipes, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336390",
      "INDEX ITEM DESCRIPTION":
        "Exhaust systems and parts, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336390",
      "INDEX ITEM DESCRIPTION":
        "Filters (e.g., air, engine oil, fuel) automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336390",
      "INDEX ITEM DESCRIPTION":
        "Gas tanks assembled, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336390",
      "INDEX ITEM DESCRIPTION":
        "Hitches, trailer, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336390",
      "INDEX ITEM DESCRIPTION":
        "Luggage racks, car top, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336390",
      "INDEX ITEM DESCRIPTION":
        "Mufflers and resonators, automotive, truck, and buses manufacturing",
    },
    {
      NAICS22: "336390",
      "INDEX ITEM DESCRIPTION":
        "Oil filters, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336390",
      "INDEX ITEM DESCRIPTION":
        "Racks (e.g., bicycle, luggage, ski, tire), automotive, truck, and buses manufacturing",
    },
    {
      NAICS22: "336390",
      "INDEX ITEM DESCRIPTION": "Radiators and cores manufacturing",
    },
    {
      NAICS22: "336390",
      "INDEX ITEM DESCRIPTION":
        "Rims, automotive, truck, and bus wheel, manufacturing",
    },
    {
      NAICS22: "336390",
      "INDEX ITEM DESCRIPTION":
        "Sunroofs and parts, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336390",
      "INDEX ITEM DESCRIPTION":
        "Thermostats, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336390",
      "INDEX ITEM DESCRIPTION": "Tops, convertible automotive, manufacturing",
    },
    {
      NAICS22: "336390",
      "INDEX ITEM DESCRIPTION": "Towing bars and systems manufacturing",
    },
    {
      NAICS22: "336390",
      "INDEX ITEM DESCRIPTION": "Trailer hitches, motor vehicle, manufacturing",
    },
    {
      NAICS22: "336390",
      "INDEX ITEM DESCRIPTION": "Transmission coolers manufacturing",
    },
    {
      NAICS22: "336390",
      "INDEX ITEM DESCRIPTION": "Truck and trailer liftgates manufacturing",
    },
    {
      NAICS22: "336390",
      "INDEX ITEM DESCRIPTION":
        "Wheels (i.e., rims), automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336390",
      "INDEX ITEM DESCRIPTION":
        "Windshield wiper blades and refills manufacturing",
    },
    {
      NAICS22: "336390",
      "INDEX ITEM DESCRIPTION":
        "Wipers, windshield, automotive, truck, and bus, manufacturing",
    },
    {
      NAICS22: "336411",
      "INDEX ITEM DESCRIPTION":
        "Aircraft conversions (i.e., major modifications to system)",
    },
    {
      NAICS22: "336411",
      "INDEX ITEM DESCRIPTION": "Aircraft manufacturing",
    },
    {
      NAICS22: "336411",
      "INDEX ITEM DESCRIPTION": "Aircraft overhauling",
    },
    {
      NAICS22: "336411",
      "INDEX ITEM DESCRIPTION":
        "Aircraft rebuilding (i.e., restoration to original design specifications)",
    },
    {
      NAICS22: "336411",
      "INDEX ITEM DESCRIPTION": "Autogiros manufacturing",
    },
    {
      NAICS22: "336411",
      "INDEX ITEM DESCRIPTION": "Blimps (i.e., aircraft) manufacturing",
    },
    {
      NAICS22: "336411",
      "INDEX ITEM DESCRIPTION":
        "Developing and producing prototypes for aircraft",
    },
    {
      NAICS22: "336411",
      "INDEX ITEM DESCRIPTION": "Gliders (i.e., aircraft) manufacturing",
    },
    {
      NAICS22: "336411",
      "INDEX ITEM DESCRIPTION": "Hang gliders manufacturing",
    },
    {
      NAICS22: "336411",
      "INDEX ITEM DESCRIPTION": "Helicopters manufacturing",
    },
    {
      NAICS22: "336411",
      "INDEX ITEM DESCRIPTION": "Target drones, aircraft, manufacturing",
    },
    {
      NAICS22: "336411",
      "INDEX ITEM DESCRIPTION": "Ultra light aircraft manufacturing",
    },
    {
      NAICS22: "336411",
      "INDEX ITEM DESCRIPTION": "Unmanned and robotic aircraft manufacturing",
    },
    {
      NAICS22: "336412",
      "INDEX ITEM DESCRIPTION":
        "Aircraft engine and engine parts (except carburetors, pistons, piston rings, valves) manufacturing",
    },
    {
      NAICS22: "336412",
      "INDEX ITEM DESCRIPTION": "Aircraft engine overhauling",
    },
    {
      NAICS22: "336412",
      "INDEX ITEM DESCRIPTION": "Aircraft engine rebuilding",
    },
    {
      NAICS22: "336412",
      "INDEX ITEM DESCRIPTION": "Aircraft turbines manufacturing",
    },
    {
      NAICS22: "336412",
      "INDEX ITEM DESCRIPTION":
        "Developing and producing prototypes for aircraft engines and engine parts",
    },
    {
      NAICS22: "336412",
      "INDEX ITEM DESCRIPTION":
        "Engines and engine parts, aircraft (except carburetors, pistons, piston rings, valves), manufacturing",
    },
    {
      NAICS22: "336412",
      "INDEX ITEM DESCRIPTION": "Gas turbines, aircraft, manufacturing",
    },
    {
      NAICS22: "336412",
      "INDEX ITEM DESCRIPTION":
        "Gasoline engine parts (except carburetors, pistons, piston rings, valves), aircraft, manufacturing",
    },
    {
      NAICS22: "336412",
      "INDEX ITEM DESCRIPTION": "Gasoline engines, aircraft, manufacturing",
    },
    {
      NAICS22: "336412",
      "INDEX ITEM DESCRIPTION":
        "Internal combustion engines, aircraft, manufacturing",
    },
    {
      NAICS22: "336412",
      "INDEX ITEM DESCRIPTION":
        "Jet propulsion and internal combustion engines and parts, aircraft, manufacturing",
    },
    {
      NAICS22: "336412",
      "INDEX ITEM DESCRIPTION": "Rocket engines, aircraft, manufacturing",
    },
    {
      NAICS22: "336413",
      "INDEX ITEM DESCRIPTION":
        "Aircraft assemblies, subassemblies, and parts (except engines) manufacturing",
    },
    {
      NAICS22: "336413",
      "INDEX ITEM DESCRIPTION":
        "Aircraft auxiliary parts (e.g., crop dusting, external fuel tanks, inflight refueling equipment) manufacturing",
    },
    {
      NAICS22: "336413",
      "INDEX ITEM DESCRIPTION": "Aircraft brakes manufacturing",
    },
    {
      NAICS22: "336413",
      "INDEX ITEM DESCRIPTION":
        "Aircraft control surface assemblies manufacturing",
    },
    {
      NAICS22: "336413",
      "INDEX ITEM DESCRIPTION":
        "Aircraft fuselage wing tail and similar assemblies manufacturing",
    },
    {
      NAICS22: "336413",
      "INDEX ITEM DESCRIPTION": "Aircraft propellers and parts manufacturing",
    },
    {
      NAICS22: "336413",
      "INDEX ITEM DESCRIPTION": "Aircraft wheels manufacturing",
    },
    {
      NAICS22: "336413",
      "INDEX ITEM DESCRIPTION":
        "Airframe assemblies (except for guided missiles) manufacturing",
    },
    {
      NAICS22: "336413",
      "INDEX ITEM DESCRIPTION":
        "Developing and producing prototypes for aircraft parts (except engines) and auxiliary equipment",
    },
    {
      NAICS22: "336413",
      "INDEX ITEM DESCRIPTION": "Joints, universal, aircraft, manufacturing",
    },
    {
      NAICS22: "336413",
      "INDEX ITEM DESCRIPTION": "Targets, trailer type, aircraft, manufacturing",
    },
    {
      NAICS22: "336413",
      "INDEX ITEM DESCRIPTION": "Tow targets, aircraft, manufacturing",
    },
    {
      NAICS22: "336413",
      "INDEX ITEM DESCRIPTION": "Universal joints, aircraft, manufacturing",
    },
    {
      NAICS22: "336414",
      "INDEX ITEM DESCRIPTION":
        "Developing and producing prototypes for complete guided missiles and space vehicles",
    },
    {
      NAICS22: "336414",
      "INDEX ITEM DESCRIPTION": "Guided missile and space vehicle manufacturing",
    },
    {
      NAICS22: "336414",
      "INDEX ITEM DESCRIPTION": "Guided missiles, complete, assembling",
    },
    {
      NAICS22: "336414",
      "INDEX ITEM DESCRIPTION":
        "Rockets (guided missiles), space and military, complete, manufacturing",
    },
    {
      NAICS22: "336414",
      "INDEX ITEM DESCRIPTION": "Space vehicles, complete, manufacturing",
    },
    {
      NAICS22: "336415",
      "INDEX ITEM DESCRIPTION":
        "Developing and producing prototypes for guided missile and space vehicle engines",
    },
    {
      NAICS22: "336415",
      "INDEX ITEM DESCRIPTION":
        "Guided missile and space vehicle engine manufacturing",
    },
    {
      NAICS22: "336415",
      "INDEX ITEM DESCRIPTION":
        "Propulsion units and parts, guided missile and space vehicle, manufacturing",
    },
    {
      NAICS22: "336415",
      "INDEX ITEM DESCRIPTION": "Rocket engines, guided missile, manufacturing",
    },
    {
      NAICS22: "336419",
      "INDEX ITEM DESCRIPTION":
        "Airframe assemblies for guided missiles manufacturing",
    },
    {
      NAICS22: "336419",
      "INDEX ITEM DESCRIPTION":
        "Developing and producing prototypes for guided missile and space vehicle components",
    },
    {
      NAICS22: "336419",
      "INDEX ITEM DESCRIPTION":
        "Guided missile and space vehicle parts (except engines) manufacturing",
    },
    {
      NAICS22: "336419",
      "INDEX ITEM DESCRIPTION": "Space capsules manufacturing",
    },
    {
      NAICS22: "336510",
      "INDEX ITEM DESCRIPTION":
        "Brakes and parts for railroad rolling stock manufacturing",
    },
    {
      NAICS22: "336510",
      "INDEX ITEM DESCRIPTION": "Buses, trackless trolley, manufacturing",
    },
    {
      NAICS22: "336510",
      "INDEX ITEM DESCRIPTION": "Industrial locomotives and parts manufacturing",
    },
    {
      NAICS22: "336510",
      "INDEX ITEM DESCRIPTION": "Light rail cars and equipment manufacturing",
    },
    {
      NAICS22: "336510",
      "INDEX ITEM DESCRIPTION": "Locomotives manufacturing",
    },
    {
      NAICS22: "336510",
      "INDEX ITEM DESCRIPTION": "Locomotives rebuilding",
    },
    {
      NAICS22: "336510",
      "INDEX ITEM DESCRIPTION":
        "Lubrication systems, locomotive (except pumps), manufacturing",
    },
    {
      NAICS22: "336510",
      "INDEX ITEM DESCRIPTION": "Mining locomotives and parts manufacturing",
    },
    {
      NAICS22: "336510",
      "INDEX ITEM DESCRIPTION": "Rail laying and tamping equipment manufacturing",
    },
    {
      NAICS22: "336510",
      "INDEX ITEM DESCRIPTION": "Railroad cars and car equipment manufacturing",
    },
    {
      NAICS22: "336510",
      "INDEX ITEM DESCRIPTION": "Railroad cars, self-propelled, manufacturing",
    },
    {
      NAICS22: "336510",
      "INDEX ITEM DESCRIPTION":
        "Railroad locomotives and parts (except diesel engines) manufacturing",
    },
    {
      NAICS22: "336510",
      "INDEX ITEM DESCRIPTION": "Railroad rolling stock manufacturing",
    },
    {
      NAICS22: "336510",
      "INDEX ITEM DESCRIPTION": "Rapid transit cars and equipment manufacturing",
    },
    {
      NAICS22: "336510",
      "INDEX ITEM DESCRIPTION": "Rolling stock, railroad, rebuilding",
    },
    {
      NAICS22: "336510",
      "INDEX ITEM DESCRIPTION":
        "Streetcars and car equipment, urban transit, manufacturing",
    },
    {
      NAICS22: "336510",
      "INDEX ITEM DESCRIPTION": "Subway cars manufacturing",
    },
    {
      NAICS22: "336611",
      "INDEX ITEM DESCRIPTION": "Barge building",
    },
    {
      NAICS22: "336611",
      "INDEX ITEM DESCRIPTION": "Cargo ship building",
    },
    {
      NAICS22: "336611",
      "INDEX ITEM DESCRIPTION": "Container ship building",
    },
    {
      NAICS22: "336611",
      "INDEX ITEM DESCRIPTION": "Dredge building",
    },
    {
      NAICS22: "336611",
      "INDEX ITEM DESCRIPTION":
        "Drilling and production platforms, floating, oil and gas, building",
    },
    {
      NAICS22: "336611",
      "INDEX ITEM DESCRIPTION": "Drydock, floating, building",
    },
    {
      NAICS22: "336611",
      "INDEX ITEM DESCRIPTION": "Ferryboat building",
    },
    {
      NAICS22: "336611",
      "INDEX ITEM DESCRIPTION": "Fireboat building",
    },
    {
      NAICS22: "336611",
      "INDEX ITEM DESCRIPTION": "Fishing boat, commercial, building",
    },
    {
      NAICS22: "336611",
      "INDEX ITEM DESCRIPTION":
        "Hydrofoil vessel building and repairing in shipyard",
    },
    {
      NAICS22: "336611",
      "INDEX ITEM DESCRIPTION": "Naval ship building",
    },
    {
      NAICS22: "336611",
      "INDEX ITEM DESCRIPTION":
        "Oil and gas offshore floating platforms manufacturing",
    },
    {
      NAICS22: "336611",
      "INDEX ITEM DESCRIPTION": "Passenger ship building",
    },
    {
      NAICS22: "336611",
      "INDEX ITEM DESCRIPTION": "Patrol boat building",
    },
    {
      NAICS22: "336611",
      "INDEX ITEM DESCRIPTION": "Sailing ships, commercial, manufacturing",
    },
    {
      NAICS22: "336611",
      "INDEX ITEM DESCRIPTION": "Ship dismantling at shipyards",
    },
    {
      NAICS22: "336611",
      "INDEX ITEM DESCRIPTION": "Ship repair done in a shipyard",
    },
    {
      NAICS22: "336611",
      "INDEX ITEM DESCRIPTION": "Ship scaling services done at a shipyard",
    },
    {
      NAICS22: "336611",
      "INDEX ITEM DESCRIPTION":
        "Ships (i.e., not suitable or intended for personal use) manufacturing",
    },
    {
      NAICS22: "336611",
      "INDEX ITEM DESCRIPTION":
        "Shipyard (i.e., facility capable of building ships)",
    },
    {
      NAICS22: "336611",
      "INDEX ITEM DESCRIPTION": "Submarine building",
    },
    {
      NAICS22: "336611",
      "INDEX ITEM DESCRIPTION": "Towboat building and repairing",
    },
    {
      NAICS22: "336611",
      "INDEX ITEM DESCRIPTION": "Tugboat building",
    },
    {
      NAICS22: "336611",
      "INDEX ITEM DESCRIPTION":
        "Underwater remotely operated vehicles (ROVs) manufacturing in shipyards",
    },
    {
      NAICS22: "336611",
      "INDEX ITEM DESCRIPTION":
        "Unmanned and robotic watercraft manufacturing in shipyards",
    },
    {
      NAICS22: "336611",
      "INDEX ITEM DESCRIPTION": "Yachts built in shipyards",
    },
    {
      NAICS22: "336612",
      "INDEX ITEM DESCRIPTION": "Air boat building",
    },
    {
      NAICS22: "336612",
      "INDEX ITEM DESCRIPTION":
        "Boat yards (i.e., boat manufacturing facilities)",
    },
    {
      NAICS22: "336612",
      "INDEX ITEM DESCRIPTION":
        "Boats (e.g., motorboats, rowboats, canoes, kayaks) manufacturing ",
    },
    {
      NAICS22: "336612",
      "INDEX ITEM DESCRIPTION":
        "Boats (i.e., suitable or intended for personal use) manufacturing",
    },
    {
      NAICS22: "336612",
      "INDEX ITEM DESCRIPTION":
        "Boats, inflatable plastics (except toy-type), manufacturing",
    },
    {
      NAICS22: "336612",
      "INDEX ITEM DESCRIPTION": "Cabin cruiser building",
    },
    {
      NAICS22: "336612",
      "INDEX ITEM DESCRIPTION": "Dinghies manufacturing",
    },
    {
      NAICS22: "336612",
      "INDEX ITEM DESCRIPTION": "Dories building",
    },
    {
      NAICS22: "336612",
      "INDEX ITEM DESCRIPTION": "Hovercraft building",
    },
    {
      NAICS22: "336612",
      "INDEX ITEM DESCRIPTION":
        "Inflatable plastic boats, heavy-duty, manufacturing",
    },
    {
      NAICS22: "336612",
      "INDEX ITEM DESCRIPTION":
        "Inflatable rubber boats, heavy-duty, manufacturing",
    },
    {
      NAICS22: "336612",
      "INDEX ITEM DESCRIPTION": "Life rafts, inflatable, manufacturing",
    },
    {
      NAICS22: "336612",
      "INDEX ITEM DESCRIPTION": "Motorboat, inboard or outboard, building",
    },
    {
      NAICS22: "336612",
      "INDEX ITEM DESCRIPTION": "Pleasure boats manufacturing",
    },
    {
      NAICS22: "336612",
      "INDEX ITEM DESCRIPTION": "Rigid inflatable boats (RIBs) manufacturing",
    },
    {
      NAICS22: "336612",
      "INDEX ITEM DESCRIPTION": "Sailboat building, not done in shipyards",
    },
    {
      NAICS22: "336612",
      "INDEX ITEM DESCRIPTION":
        "Underwater remotely operated vehicles (ROVs) manufacturing in boat yards",
    },
    {
      NAICS22: "336612",
      "INDEX ITEM DESCRIPTION":
        "Unmanned and robotic watercraft manufacturing in boat yards",
    },
    {
      NAICS22: "336612",
      "INDEX ITEM DESCRIPTION": "Yacht building, not done in shipyards",
    },
    {
      NAICS22: "336991",
      "INDEX ITEM DESCRIPTION": "Bicycles and parts manufacturing",
    },
    {
      NAICS22: "336991",
      "INDEX ITEM DESCRIPTION": "Electric bicycles manufacturing",
    },
    {
      NAICS22: "336991",
      "INDEX ITEM DESCRIPTION": "Mopeds and parts manufacturing",
    },
    {
      NAICS22: "336991",
      "INDEX ITEM DESCRIPTION": "Motor scooters manufacturing",
    },
    {
      NAICS22: "336991",
      "INDEX ITEM DESCRIPTION": "Motorcycles and parts manufacturing",
    },
    {
      NAICS22: "336991",
      "INDEX ITEM DESCRIPTION":
        "Tricycles, metal, adult and children's, manufacturing",
    },
    {
      NAICS22: "336991",
      "INDEX ITEM DESCRIPTION": "Vehicle, children's, metal manufacturing",
    },
    {
      NAICS22: "336992",
      "INDEX ITEM DESCRIPTION":
        "Armored military vehicles (except tanks) and parts manufacturing",
    },
    {
      NAICS22: "336992",
      "INDEX ITEM DESCRIPTION":
        "Tanks, military (including factory rebuilding), manufacturing",
    },
    {
      NAICS22: "336992",
      "INDEX ITEM DESCRIPTION": "Weapons, self-propelled, manufacturing",
    },
    {
      NAICS22: "336999",
      "INDEX ITEM DESCRIPTION":
        "All-terrain vehicles (ATVs), wheeled or tracked, manufacturing",
    },
    {
      NAICS22: "336999",
      "INDEX ITEM DESCRIPTION": "Animal-drawn vehicles and parts manufacturing",
    },
    {
      NAICS22: "336999",
      "INDEX ITEM DESCRIPTION": "Food (vendor) carts on wheels manufacturing",
    },
    {
      NAICS22: "336999",
      "INDEX ITEM DESCRIPTION": "Gocarts (except children's) manufacturing",
    },
    {
      NAICS22: "336999",
      "INDEX ITEM DESCRIPTION":
        "Golf carts and similar motorized passenger carriers manufacturing",
    },
    {
      NAICS22: "336999",
      "INDEX ITEM DESCRIPTION": "Golf carts, powered, manufacturing",
    },
    {
      NAICS22: "336999",
      "INDEX ITEM DESCRIPTION":
        "Off-highway tracked vehicles (except construction, armored military) manufacturing",
    },
    {
      NAICS22: "336999",
      "INDEX ITEM DESCRIPTION":
        "Off-road all-terrain vehicles (ATVs), wheeled or tracked, manufacturing",
    },
    {
      NAICS22: "336999",
      "INDEX ITEM DESCRIPTION": "Personal watercraft manufacturing",
    },
    {
      NAICS22: "336999",
      "INDEX ITEM DESCRIPTION": "Race cars manufacturing",
    },
    {
      NAICS22: "336999",
      "INDEX ITEM DESCRIPTION": "Snowmobiles and parts manufacturing",
    },
    {
      NAICS22: "337110",
      "INDEX ITEM DESCRIPTION":
        "Bathroom vanities (except freestanding), stock or custom wood, manufacturing",
    },
    {
      NAICS22: "337110",
      "INDEX ITEM DESCRIPTION":
        "Cabinets, kitchen (except freestanding), stock or custom wood, manufacturing",
    },
    {
      NAICS22: "337110",
      "INDEX ITEM DESCRIPTION":
        "Countertops (i.e., kitchen, bathroom), wood or plastics laminated on wood, manufacturing",
    },
    {
      NAICS22: "337110",
      "INDEX ITEM DESCRIPTION": "Countertops, wood, manufacturing",
    },
    {
      NAICS22: "337110",
      "INDEX ITEM DESCRIPTION":
        "Drainboards, wood or plastics laminated on wood, manufacturing",
    },
    {
      NAICS22: "337110",
      "INDEX ITEM DESCRIPTION":
        "Kitchen cabinets (except freestanding), stock or custom wood, manufacturing",
    },
    {
      NAICS22: "337110",
      "INDEX ITEM DESCRIPTION":
        "Medicine cabinets (except freestanding), wood household-type, manufacturing",
    },
    {
      NAICS22: "337110",
      "INDEX ITEM DESCRIPTION":
        "Plastics laminated over particleboard (e.g., fixture tops) manufacturing",
    },
    {
      NAICS22: "337110",
      "INDEX ITEM DESCRIPTION":
        "Vanities (except freestanding), stock or custom wood, manufacturing",
    },
    {
      NAICS22: "337110",
      "INDEX ITEM DESCRIPTION":
        "Vanity tops, wood or plastics laminated on wood, manufacturing",
    },
    {
      NAICS22: "337121",
      "INDEX ITEM DESCRIPTION":
        "Chair and couch springs, assembled, manufacturing",
    },
    {
      NAICS22: "337121",
      "INDEX ITEM DESCRIPTION":
        "Chairs, upholstered household-type (except dining room, kitchen), manufacturing",
    },
    {
      NAICS22: "337121",
      "INDEX ITEM DESCRIPTION": "Convertible sofas (except futons) manufacturing",
    },
    {
      NAICS22: "337121",
      "INDEX ITEM DESCRIPTION": "Cot springs, assembled, manufacturing",
    },
    {
      NAICS22: "337121",
      "INDEX ITEM DESCRIPTION": "Couch springs, assembled, manufacturing",
    },
    {
      NAICS22: "337121",
      "INDEX ITEM DESCRIPTION": "Couches, upholstered, manufacturing",
    },
    {
      NAICS22: "337121",
      "INDEX ITEM DESCRIPTION": "Cushion springs, assembled, manufacturing",
    },
    {
      NAICS22: "337121",
      "INDEX ITEM DESCRIPTION":
        "Furniture, household-type, upholstered on frames of any material, manufacturing",
    },
    {
      NAICS22: "337121",
      "INDEX ITEM DESCRIPTION": "Futons with frames manufacturing",
    },
    {
      NAICS22: "337121",
      "INDEX ITEM DESCRIPTION":
        "Household-type furniture, upholstered, manufacturing",
    },
    {
      NAICS22: "337121",
      "INDEX ITEM DESCRIPTION": "Juvenile furniture, upholstered, manufacturing",
    },
    {
      NAICS22: "337121",
      "INDEX ITEM DESCRIPTION":
        "Living room furniture, upholstered, manufacturing",
    },
    {
      NAICS22: "337121",
      "INDEX ITEM DESCRIPTION":
        "Metal framed furniture, household-type, upholstered, manufacturing",
    },
    {
      NAICS22: "337121",
      "INDEX ITEM DESCRIPTION": "Ottomans, upholstered, manufacturing",
    },
    {
      NAICS22: "337121",
      "INDEX ITEM DESCRIPTION": "Recliners, upholstered, manufacturing",
    },
    {
      NAICS22: "337121",
      "INDEX ITEM DESCRIPTION": "Rockers, upholstered, manufacturing",
    },
    {
      NAICS22: "337121",
      "INDEX ITEM DESCRIPTION":
        "Sofa beds and chair beds, upholstered, manufacturing",
    },
    {
      NAICS22: "337121",
      "INDEX ITEM DESCRIPTION":
        "Sofas, convertible (except futons), manufacturing",
    },
    {
      NAICS22: "337121",
      "INDEX ITEM DESCRIPTION": "Sofas, upholstered, manufacturing",
    },
    {
      NAICS22: "337121",
      "INDEX ITEM DESCRIPTION":
        "Upholstered furniture, household-type, custom, manufacturing",
    },
    {
      NAICS22: "337121",
      "INDEX ITEM DESCRIPTION":
        "Upholstered furniture, household-type, on frames of any material, manufacturing",
    },
    {
      NAICS22: "337121",
      "INDEX ITEM DESCRIPTION":
        "Wood framed furniture, upholstered, household-type, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION": "Bed frames, wood household-type, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION":
        "Bedroom furniture (except upholstered), wood household-type, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION":
        "Beds (except hospital), wood household-type, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION": "Beds, wood dormitory-type, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION": "Beds, wood hotel-type, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION": "Bookcases, wood household-type, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION": "Buffets (furniture), wood, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION":
        "Cabinets, wood household-type, freestanding, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION": "Camp furniture, wood, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION":
        "Card table sets (furniture), wood, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION": "Cedar chests manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION":
        "Chairs (except upholstered), wood household-type, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION": "China closets, wood, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION": "Coffee tables, wood, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION":
        "Computer furniture, wood household-type, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION": "Cots, wood household-type, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION": "Cradles, wood, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION": "Cribs (i.e., baby beds), wood, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION": "Desks, wood household-type, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION":
        "Dining room chairs (including upholstered), wood, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION":
        "Dining room furniture, wood household-type, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION": "Dressers, wood, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION": "Dressing tables, wood, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION": "End tables, wood, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION":
        "Furniture, outdoor wood household-type (e.g., beach, garden, lawn, porch), manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION":
        "Furniture, unassembled or knock-down wood household-type, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION":
        "Furniture, unfinished wood household-type, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION":
        "Furniture, wood household-type, not upholstered (except TV and radio housings, and sewing machine cabinets), manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION": "Futon frames manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION": "Garden furniture, wood, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION": "Hammocks, wood framed, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION": "Headboards, wood, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION": "High chairs, wood, children's, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION": "Home entertainment centers, wood, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION":
        "Household-type furniture, wood, not upholstered (except TV and radio housings and sewing machine cabinets), manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION":
        "Juvenile furniture (except upholstered), wood, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION":
        "Kitchen chairs (e.g., upholstered), wood, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION":
        "Kitchen furniture, wood household-type, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION": "Knickknack shelves, wood, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION": "Lawn furniture, wood, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION":
        "Living room furniture (except upholstered), wood, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION": "Magazine racks, wood, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION": "Night stands, wood, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION":
        "Nonupholstered, household-type, custom wood furniture, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION":
        "Nursery furniture (except upholstered), wood, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION": "Playpens, children's wood, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION":
        "Porch furniture (except upholstered), wood, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION":
        "Rockers (except upholstered), wood, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION":
        "Room dividers, wood household-type, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION":
        "Serving carts, wood household-type, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION":
        "Stools, wood household-type (except upholstered), manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION": "Tables, wood household-type, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION":
        "TV stands and similar stands for consumer electronics, wood, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION": "Vanities, freestanding, wood, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION": "Wardrobes, wood household-type, manufacturing",
    },
    {
      NAICS22: "337122",
      "INDEX ITEM DESCRIPTION": "Water bed frames, wood, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION":
        "Bamboo furniture (except upholstered), household-type, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION": "Bassinets, reed and rattan, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION":
        "Beds (including cabinet and folding), metal household-type (except hospital), manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION":
        "Bookcases (except wood), household-type, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION":
        "Cabinets, metal (i.e., bathroom, kitchen), manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION":
        "Cabinets, metal household-type, freestanding, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION":
        "Cabinets, metal, radio and television, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION": "Camp furniture, metal, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION": "Camp furniture, reed and rattan, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION": "Car seats, infant, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION": "Card table sets, metal, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION": "Chairs, cane, household-type, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION":
        "Chairs, metal household-type (except upholstered), manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION":
        "Computer furniture, metal household-type, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION": "Cots, metal household-type, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION": "Cribs (i.e., baby beds), metal, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION":
        "Dinette sets, metal household-type, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION":
        "Dining room chairs (including upholstered), metal, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION":
        "Dining room chairs (including upholstered), plastics, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION":
        "Dining room furniture, metal household-type, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION": "Dressers, metal, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION": "Dressing tables, metal, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION": "End tables, metal, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION":
        "Fiber furniture (except upholstered), household-type, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION":
        "Furniture (except wood, upholstered), indoor and outdoor (e.g., beach, garden, lawn, porch) household-type, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION": "Hammocks, metal framed, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION":
        "Hampers, laundry, reed, wicker, rattan, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION":
        "Home entertainment centers, metal, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION":
        "Juvenile furniture (except wood, upholstered) manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION":
        "Juvenile furniture, rattan and reed, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION":
        "Kitchen chairs (including upholstered), metal, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION":
        "Kitchen chairs (including upholstered), plastics, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION":
        "Kitchen furniture, household-type, metal, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION":
        "Kitchen furniture, metal household-type, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION":
        "Laundry hampers, rattan, reed, wicker or willow, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION":
        "Lawn furniture (except concrete, stone, wood) manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION":
        "Living room furniture (except upholstered), metal, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION":
        "Malacca furniture (except upholstered), household-type, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION":
        "Medicine cabinets, metal household-type, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION": "Nursery furniture, metal, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION":
        "Plastics (including fiberglass) furniture (except upholstered), household-type, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION": "Playpens, children's metal, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION": "Porch swings, metal, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION": "Rattan furniture, household-type, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION":
        "Reed furniture (except upholstered), household-type, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION":
        "Serving carts, metal household-type, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION":
        "Stools, metal household-type (except upholstered), manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION": "Tables, metal household-type, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION":
        "TV stands and similar stands for consumer electronics, metal, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION":
        "TV stands and similar stands for consumer electronics, plastics, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION": "Vanities, metal household-type, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION": "Wardrobes, metal household-type, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION": "Water bed frames, metal, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION":
        "Wicker furniture (except upholstered), household-type, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION":
        "Willow furniture (except upholstered), household-type, manufacturing",
    },
    {
      NAICS22: "337126",
      "INDEX ITEM DESCRIPTION":
        "Wrought iron furniture (except upholstered), household-type, manufacturing",
    },
    {
      NAICS22: "337127",
      "INDEX ITEM DESCRIPTION":
        "Benches, park-type (except concrete, stone), manufacturing",
    },
    {
      NAICS22: "337127",
      "INDEX ITEM DESCRIPTION": "Benches, public building-type, manufacturing",
    },
    {
      NAICS22: "337127",
      "INDEX ITEM DESCRIPTION": "Benches, work, manufacturing",
    },
    {
      NAICS22: "337127",
      "INDEX ITEM DESCRIPTION": "Bleacher seating manufacturing",
    },
    {
      NAICS22: "337127",
      "INDEX ITEM DESCRIPTION": "Bowling center furniture manufacturing",
    },
    {
      NAICS22: "337127",
      "INDEX ITEM DESCRIPTION": "Cafeteria furniture manufacturing",
    },
    {
      NAICS22: "337127",
      "INDEX ITEM DESCRIPTION": "Cafeteria tables and benches manufacturing",
    },
    {
      NAICS22: "337127",
      "INDEX ITEM DESCRIPTION":
        "Chairs, barber, beauty shop (i.e., hydraulic), manufacturing",
    },
    {
      NAICS22: "337127",
      "INDEX ITEM DESCRIPTION":
        "Chairs, portable folding, auditorium-type, manufacturing",
    },
    {
      NAICS22: "337127",
      "INDEX ITEM DESCRIPTION":
        "Chairs, stacking, auditorium-type, manufacturing",
    },
    {
      NAICS22: "337127",
      "INDEX ITEM DESCRIPTION":
        "Church furniture (except concrete, stone) manufacturing",
    },
    {
      NAICS22: "337127",
      "INDEX ITEM DESCRIPTION": "Drafting tables and boards manufacturing",
    },
    {
      NAICS22: "337127",
      "INDEX ITEM DESCRIPTION":
        "Drawing tables and boards, artist's, manufacturing",
    },
    {
      NAICS22: "337127",
      "INDEX ITEM DESCRIPTION":
        "Furniture, factory-type (e.g., cabinets, stools, tool stands, work benches), manufacturing",
    },
    {
      NAICS22: "337127",
      "INDEX ITEM DESCRIPTION": "Furniture, institutional, manufacturing",
    },
    {
      NAICS22: "337127",
      "INDEX ITEM DESCRIPTION":
        "Furniture, laboratory-type (e.g., benches, cabinets, stools, tables), manufacturing",
    },
    {
      NAICS22: "337127",
      "INDEX ITEM DESCRIPTION":
        "Furniture, public building (e.g., church, library, school, theater), manufacturing",
    },
    {
      NAICS22: "337127",
      "INDEX ITEM DESCRIPTION": "Furniture, restaurant-type, manufacturing",
    },
    {
      NAICS22: "337127",
      "INDEX ITEM DESCRIPTION": "Institutional furniture manufacturing",
    },
    {
      NAICS22: "337127",
      "INDEX ITEM DESCRIPTION":
        "Laboratory-type furniture (e.g., benches, cabinets, stools, tables) (except dental) manufacturing",
    },
    {
      NAICS22: "337127",
      "INDEX ITEM DESCRIPTION": "Lunchroom tables and chairs manufacturing",
    },
    {
      NAICS22: "337127",
      "INDEX ITEM DESCRIPTION": "Pews, church, manufacturing",
    },
    {
      NAICS22: "337127",
      "INDEX ITEM DESCRIPTION": "Prison bed manufacturing",
    },
    {
      NAICS22: "337127",
      "INDEX ITEM DESCRIPTION": "Religious furniture manufacturing",
    },
    {
      NAICS22: "337127",
      "INDEX ITEM DESCRIPTION":
        "Restaurant furniture (e.g., carts, chairs, foodwagons, tables) manufacturing",
    },
    {
      NAICS22: "337127",
      "INDEX ITEM DESCRIPTION": "School furniture manufacturing",
    },
    {
      NAICS22: "337127",
      "INDEX ITEM DESCRIPTION": "Ship furniture manufacturing",
    },
    {
      NAICS22: "337127",
      "INDEX ITEM DESCRIPTION": "Stadium seating manufacturing",
    },
    {
      NAICS22: "337127",
      "INDEX ITEM DESCRIPTION": "Theater seating manufacturing",
    },
    {
      NAICS22: "337127",
      "INDEX ITEM DESCRIPTION": "Tool stands, factory, manufacturing",
    },
    {
      NAICS22: "337127",
      "INDEX ITEM DESCRIPTION": "Tray trucks, restaurant, manufacturing",
    },
    {
      NAICS22: "337127",
      "INDEX ITEM DESCRIPTION": "Work benches manufacturing",
    },
    {
      NAICS22: "337211",
      "INDEX ITEM DESCRIPTION": "Bookcases, wood office-type, manufacturing",
    },
    {
      NAICS22: "337211",
      "INDEX ITEM DESCRIPTION":
        "Cabinets, wood office-type, freestanding, manufacturing",
    },
    {
      NAICS22: "337211",
      "INDEX ITEM DESCRIPTION": "Chairs, wood office-type, manufacturing",
    },
    {
      NAICS22: "337211",
      "INDEX ITEM DESCRIPTION": "Desks, wood office-type, manufacturing",
    },
    {
      NAICS22: "337211",
      "INDEX ITEM DESCRIPTION":
        "Filing cabinets, wood, office-type, manufacturing",
    },
    {
      NAICS22: "337211",
      "INDEX ITEM DESCRIPTION":
        "Furniture, office-type, padded, upholstered, or plain wood, manufacturing",
    },
    {
      NAICS22: "337211",
      "INDEX ITEM DESCRIPTION":
        "Modular furniture systems, wood frame office-type, manufacturing",
    },
    {
      NAICS22: "337211",
      "INDEX ITEM DESCRIPTION":
        "Office furniture, padded, upholstered, or plain wood, manufacturing",
    },
    {
      NAICS22: "337211",
      "INDEX ITEM DESCRIPTION": "Tables, wood, office-type, manufacturing",
    },
    {
      NAICS22: "337212",
      "INDEX ITEM DESCRIPTION":
        "Architectural woodwork and fixtures (i.e., custom designed interiors) manufacturing",
    },
    {
      NAICS22: "337212",
      "INDEX ITEM DESCRIPTION":
        "Custom architectural millwork and fixtures, manufacturing on a job shop basis",
    },
    {
      NAICS22: "337212",
      "INDEX ITEM DESCRIPTION":
        "Custom design interiors (i.e., coordinated furniture, architectural woodwork, fixtures), manufacturing",
    },
    {
      NAICS22: "337212",
      "INDEX ITEM DESCRIPTION": "Millwork, custom architectural, manufacturing",
    },
    {
      NAICS22: "337214",
      "INDEX ITEM DESCRIPTION":
        "Bookcases (except wood), office-type, manufacturing",
    },
    {
      NAICS22: "337214",
      "INDEX ITEM DESCRIPTION":
        "Cabinets (except wood), office-type, freestanding, manufacturing",
    },
    {
      NAICS22: "337214",
      "INDEX ITEM DESCRIPTION":
        "Chairs (except wood), office-type, manufacturing",
    },
    {
      NAICS22: "337214",
      "INDEX ITEM DESCRIPTION": "Desks (except wood), office-type, manufacturing",
    },
    {
      NAICS22: "337214",
      "INDEX ITEM DESCRIPTION":
        "Filing cabinets (except wood), office-type, manufacturing",
    },
    {
      NAICS22: "337214",
      "INDEX ITEM DESCRIPTION":
        "Furniture (except wood), office-type, padded, upholstered, or plain, manufacturing",
    },
    {
      NAICS22: "337214",
      "INDEX ITEM DESCRIPTION":
        "Modular furniture systems (except wood frame), office-type, manufacturing",
    },
    {
      NAICS22: "337214",
      "INDEX ITEM DESCRIPTION":
        "Office furniture (except wood), padded, upholstered, or plain (except wood), manufacturing",
    },
    {
      NAICS22: "337214",
      "INDEX ITEM DESCRIPTION":
        "Tables (except wood), office-type, manufacturing",
    },
    {
      NAICS22: "337215",
      "INDEX ITEM DESCRIPTION": "Box spring frames manufacturing",
    },
    {
      NAICS22: "337215",
      "INDEX ITEM DESCRIPTION": "Cafeteria fixtures manufacturing",
    },
    {
      NAICS22: "337215",
      "INDEX ITEM DESCRIPTION": "Chair glides manufacturing",
    },
    {
      NAICS22: "337215",
      "INDEX ITEM DESCRIPTION": "Chair seats for furniture manufacturing",
    },
    {
      NAICS22: "337215",
      "INDEX ITEM DESCRIPTION":
        "Counter units (except refrigerated) manufacturing",
    },
    {
      NAICS22: "337215",
      "INDEX ITEM DESCRIPTION":
        "Countertops (except kitchen and bathroom), wood or plastics laminated on wood, manufacturing",
    },
    {
      NAICS22: "337215",
      "INDEX ITEM DESCRIPTION":
        "Display cases and fixtures (except refrigerated) manufacturing",
    },
    {
      NAICS22: "337215",
      "INDEX ITEM DESCRIPTION": "Fixtures, store display, manufacturing",
    },
    {
      NAICS22: "337215",
      "INDEX ITEM DESCRIPTION":
        "Furniture frames and parts, metal, manufacturing",
    },
    {
      NAICS22: "337215",
      "INDEX ITEM DESCRIPTION": "Furniture frames, wood, manufacturing",
    },
    {
      NAICS22: "337215",
      "INDEX ITEM DESCRIPTION": "Furniture parts, finished metal, manufacturing",
    },
    {
      NAICS22: "337215",
      "INDEX ITEM DESCRIPTION":
        "Furniture parts, finished plastics, manufacturing",
    },
    {
      NAICS22: "337215",
      "INDEX ITEM DESCRIPTION": "Furniture parts, finished wood, manufacturing",
    },
    {
      NAICS22: "337215",
      "INDEX ITEM DESCRIPTION": "Lockers (except refrigerated) manufacturing",
    },
    {
      NAICS22: "337215",
      "INDEX ITEM DESCRIPTION":
        "Mail carrier cases and tables, wood, manufacturing",
    },
    {
      NAICS22: "337215",
      "INDEX ITEM DESCRIPTION":
        "Partitions for floor attachment, prefabricated, manufacturing",
    },
    {
      NAICS22: "337215",
      "INDEX ITEM DESCRIPTION":
        "Partitions, freestanding, prefabricated, manufacturing",
    },
    {
      NAICS22: "337215",
      "INDEX ITEM DESCRIPTION": "Postal service lock boxes manufacturing",
    },
    {
      NAICS22: "337215",
      "INDEX ITEM DESCRIPTION": "Shelving (except wire) manufacturing",
    },
    {
      NAICS22: "337215",
      "INDEX ITEM DESCRIPTION": "Showcases (except refrigerated) manufacturing",
    },
    {
      NAICS22: "337215",
      "INDEX ITEM DESCRIPTION":
        "Sleeper mechanisms, convertible bed, manufacturing",
    },
    {
      NAICS22: "337215",
      "INDEX ITEM DESCRIPTION":
        "Stands (except wire), merchandise display, manufacturing",
    },
    {
      NAICS22: "337215",
      "INDEX ITEM DESCRIPTION": "Store display fixtures manufacturing",
    },
    {
      NAICS22: "337215",
      "INDEX ITEM DESCRIPTION": "Table tops, wood, manufacturing",
    },
    {
      NAICS22: "337215",
      "INDEX ITEM DESCRIPTION": "Telephone booths manufacturing",
    },
    {
      NAICS22: "337910",
      "INDEX ITEM DESCRIPTION":
        "Beds, sleep-system ensembles (i.e., flotation, adjustable), manufacturing",
    },
    {
      NAICS22: "337910",
      "INDEX ITEM DESCRIPTION":
        "Box springs, assembled, made from purchased spring",
    },
    {
      NAICS22: "337910",
      "INDEX ITEM DESCRIPTION": "Innerspring cushions manufacturing",
    },
    {
      NAICS22: "337910",
      "INDEX ITEM DESCRIPTION":
        "Mattresses (i.e., box spring, innerspring, noninnerspring) manufacturing",
    },
    {
      NAICS22: "337910",
      "INDEX ITEM DESCRIPTION":
        "Mattresses made from felt, foam rubber, urethane and similar materials",
    },
    {
      NAICS22: "337910",
      "INDEX ITEM DESCRIPTION":
        "Springs, assembled bed and box, made from purchased springs",
    },
    {
      NAICS22: "337910",
      "INDEX ITEM DESCRIPTION": "Water bed mattresses manufacturing",
    },
    {
      NAICS22: "337920",
      "INDEX ITEM DESCRIPTION": "Bamboo window blinds and shades manufacturing",
    },
    {
      NAICS22: "337920",
      "INDEX ITEM DESCRIPTION":
        "Blinds (e.g., mini, venetian, vertical), all materials, manufacturing",
    },
    {
      NAICS22: "337920",
      "INDEX ITEM DESCRIPTION":
        "Curtain or drapery fixtures (e.g., poles, rods, rollers) manufacturing",
    },
    {
      NAICS22: "337920",
      "INDEX ITEM DESCRIPTION": "Curtain rods and fittings manufacturing",
    },
    {
      NAICS22: "337920",
      "INDEX ITEM DESCRIPTION":
        "Fixtures (e.g., poles, rods, rollers), curtain and drapery, manufacturing",
    },
    {
      NAICS22: "337920",
      "INDEX ITEM DESCRIPTION": "Miniblinds manufacturing",
    },
    {
      NAICS22: "337920",
      "INDEX ITEM DESCRIPTION": "Porch shades, wood slat, manufacturing",
    },
    {
      NAICS22: "337920",
      "INDEX ITEM DESCRIPTION": "Shade pulls, window, manufacturing",
    },
    {
      NAICS22: "337920",
      "INDEX ITEM DESCRIPTION":
        "Shades, window (except outdoor canvas awnings), manufacturing",
    },
    {
      NAICS22: "337920",
      "INDEX ITEM DESCRIPTION": "Venetian blinds manufacturing",
    },
    {
      NAICS22: "337920",
      "INDEX ITEM DESCRIPTION": "Vertical blinds manufacturing",
    },
    {
      NAICS22: "337920",
      "INDEX ITEM DESCRIPTION": "Window shade rollers and fittings manufacturing",
    },
    {
      NAICS22: "337920",
      "INDEX ITEM DESCRIPTION": "Window shades (except awnings) manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION": "Anesthesia apparatus manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION": "Blood pressure apparatus manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION": "Blood transfusion equipment manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION": "Bone drills manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION": "Bone plates and screws manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION": "Bone rongeurs manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION":
        "Bronchoscopes (except electromedical) manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION": "Cannulae manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION": "Catheters manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION": "Clamps, surgical, manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION": "Corneal microscopes manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION":
        "Cystoscopes (except electromedical) manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION":
        "Eye examining instruments and apparatus manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION": "Forceps, surgical, manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION":
        "Gastroscopes (except electromedical) manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION": "Hypodermic needles and syringes manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION": "Inhalation therapy equipment manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION": "Inhalators, surgical and medical, manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION":
        "Instruments, mechanical microsurgical, manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION": "IV apparatus manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION": "Knives, surgical, manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION": "Medical thermometers manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION": "Needles, hypodermic and suture, manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION":
        "Ophthalmic instruments and apparatus (except laser surgical) manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION":
        "Ophthalmometers and ophthalmoscopes manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION": "Optometers manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION": "Oxygen tents manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION": "Pelvimeters manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION":
        "Physiotherapy equipment (except electrotherapeutic) manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION": "Probes, surgical, manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION":
        "Retinoscopes (except electromedical) manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION": "Retractors, medical, manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION": "Saws, surgical, manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION": "Skin grafting equipment manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION": "Speculums manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION": "Sphygmomanometers manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION": "Stethoscopes manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION": "Suction therapy apparatus manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION": "Surgical clamps manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION": "Surgical knife blades and handles manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION": "Surgical stapling devices manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION": "Syringes, hypodermic, manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION": "Thermometers, medical, manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION": "Tonometers, medical, manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION": "Trocars manufacturing",
    },
    {
      NAICS22: "339112",
      "INDEX ITEM DESCRIPTION":
        "Veterinarians' instruments and apparatus manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Adhesive tape, medical, manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Arch supports, orthopedic, manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Artificial limbs manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION":
        "Autoclaves, laboratory-type (except dental), manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION":
        "Bandages and dressings, surgical and orthopedic, manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Beds, hospital, manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION":
        "Biohazard protective clothing and accessories manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION":
        "Blood testing apparatus, laboratory-type, manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Bulletproof vests manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Bunsen burners manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Cervical collars manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Clean room suits and accessories manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Colostomy appliances manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Corn remover and bunion pad manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Corsets, surgical, manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION":
        "Cotton and cotton balls, absorbent, manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Cotton tipped applicators manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Crutches and walkers manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Depressors, tongue, manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Drapes, surgical, disposable, manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Dressings, surgical, manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Dryers, laboratory-type, manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Elastic hosiery, orthopedic, manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION":
        "Firefighting suits and accessories manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION":
        "First-aid, snake bite, or burn kits manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Foot appliances, orthopedic, manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION":
        "Furniture, hospital, specialized (e.g., hospital beds, operating room furniture), manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Gas masks manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Gauze, surgical, made from purchased fabric",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION":
        "Gloves, rubber (e.g., electrician's, examination, household-type, surgeon's), manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION":
        "Gynecological supplies and appliances manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Hard hats manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION":
        "Helmets (except athletic), safety (e.g., motorized vehicle crash helmets, space helmets), manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Hosiery, orthopedic support, manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Hospital beds manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION":
        "Hospital furniture, specialized (e.g., hospital beds, operating room furniture)",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Hydrotherapy equipment manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Implants, surgical, manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Incubators, infant, manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Incubators, laboratory-type, manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Infant incubators manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Intraocular lenses manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Intrauterine devices manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION":
        "Laboratory-type evaporation apparatus manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION":
        "Laboratory-type sample preparation apparatus manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Life preservers manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Limbs, artificial, manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION":
        "Metal fabric and mesh safety gloves manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Noise protectors, personal, manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Nose and ear plugs manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Operating room tables manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Orthopedic canes manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION":
        "Orthopedic device manufacturing and sale in retail environment",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Orthopedic devices manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Orthopedic extension shoes manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Orthopedic hosiery, elastic, manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION":
        "Personal safety devices, not specified elsewhere, manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION":
        "Prosthetic appliances and supplies manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION":
        "Radiation shielding aprons, gloves, and sheeting manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Respiratory protection mask manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Restraints, patient, manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Shoes, orthopedic extension, manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Slitting medical adhesive tapes for the trade",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Space suits manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Splints manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION":
        "Sterilizers, hospital and surgical, manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION":
        "Sterilizers, laboratory-type (except dental), manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Stretchers, medical, manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Suits, firefighting, manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Suits, space, manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION":
        "Supports, orthopedic (e.g., abdominal, ankle, arch, kneecap), manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Surgical and medical masks manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Surgical dressings manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Surgical implants manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION":
        "Surgical supplies (except medical instruments) manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Sutures, surgical, manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Tapes, medical adhesive, manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Tongue depressors manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Traction apparatus manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION":
        "Ultrasonic medical cleaning equipment manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Vacuum pumps, laboratory-type, manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Welder's hoods manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION": "Wheelchairs manufacturing",
    },
    {
      NAICS22: "339113",
      "INDEX ITEM DESCRIPTION":
        "Whirlpool baths (i.e., hydrotherapy equipment) manufacturing",
    },
    {
      NAICS22: "339114",
      "INDEX ITEM DESCRIPTION":
        "Abrasive points, wheels, and disks, dental, manufacturing",
    },
    {
      NAICS22: "339114",
      "INDEX ITEM DESCRIPTION": "Amalgams, dental, manufacturing",
    },
    {
      NAICS22: "339114",
      "INDEX ITEM DESCRIPTION": "Autoclaves, dental, manufacturing",
    },
    {
      NAICS22: "339114",
      "INDEX ITEM DESCRIPTION": "Cements, dental, manufacturing",
    },
    {
      NAICS22: "339114",
      "INDEX ITEM DESCRIPTION": "Chairs, dentist's, manufacturing",
    },
    {
      NAICS22: "339114",
      "INDEX ITEM DESCRIPTION": "Cutting instruments, dental, manufacturing",
    },
    {
      NAICS22: "339114",
      "INDEX ITEM DESCRIPTION": "Dental alloys for amalgams manufacturing",
    },
    {
      NAICS22: "339114",
      "INDEX ITEM DESCRIPTION": "Dental chairs manufacturing",
    },
    {
      NAICS22: "339114",
      "INDEX ITEM DESCRIPTION": "Dental equipment and instruments manufacturing",
    },
    {
      NAICS22: "339114",
      "INDEX ITEM DESCRIPTION": "Dental glues and cements manufacturing",
    },
    {
      NAICS22: "339114",
      "INDEX ITEM DESCRIPTION":
        "Dental hand instruments (e.g., forceps) manufacturing",
    },
    {
      NAICS22: "339114",
      "INDEX ITEM DESCRIPTION": "Dental impression materials manufacturing",
    },
    {
      NAICS22: "339114",
      "INDEX ITEM DESCRIPTION":
        "Dental instrument delivery systems manufacturing",
    },
    {
      NAICS22: "339114",
      "INDEX ITEM DESCRIPTION": "Dental laboratory equipment manufacturing",
    },
    {
      NAICS22: "339114",
      "INDEX ITEM DESCRIPTION": "Dental wax manufacturing",
    },
    {
      NAICS22: "339114",
      "INDEX ITEM DESCRIPTION": "Denture materials manufacturing",
    },
    {
      NAICS22: "339114",
      "INDEX ITEM DESCRIPTION": "Drills, dental, manufacturing",
    },
    {
      NAICS22: "339114",
      "INDEX ITEM DESCRIPTION": "Enamels, dental, manufacturing",
    },
    {
      NAICS22: "339114",
      "INDEX ITEM DESCRIPTION": "Furnaces, dental laboratory, manufacturing",
    },
    {
      NAICS22: "339114",
      "INDEX ITEM DESCRIPTION": "Glue, dental, manufacturing",
    },
    {
      NAICS22: "339114",
      "INDEX ITEM DESCRIPTION": "Impression material, dental, manufacturing",
    },
    {
      NAICS22: "339114",
      "INDEX ITEM DESCRIPTION": "Orthodontic appliances manufacturing",
    },
    {
      NAICS22: "339114",
      "INDEX ITEM DESCRIPTION": "Points, abrasive dental, manufacturing",
    },
    {
      NAICS22: "339114",
      "INDEX ITEM DESCRIPTION": "Sterilizers, dental, manufacturing",
    },
    {
      NAICS22: "339114",
      "INDEX ITEM DESCRIPTION": "Teeth (except customized) manufacturing",
    },
    {
      NAICS22: "339114",
      "INDEX ITEM DESCRIPTION": "Tools, dentists', manufacturing",
    },
    {
      NAICS22: "339114",
      "INDEX ITEM DESCRIPTION": "Ultrasonic dental equipment manufacturing",
    },
    {
      NAICS22: "339115",
      "INDEX ITEM DESCRIPTION": "Contact lenses manufacturing",
    },
    {
      NAICS22: "339115",
      "INDEX ITEM DESCRIPTION":
        "Eyeglass frames (i.e., fronts and temples), ophthalmic, manufacturing",
    },
    {
      NAICS22: "339115",
      "INDEX ITEM DESCRIPTION": "Eyes, glass and plastics, manufacturing",
    },
    {
      NAICS22: "339115",
      "INDEX ITEM DESCRIPTION":
        "Goggles (e.g., industrial, safety, sun, underwater) manufacturing",
    },
    {
      NAICS22: "339115",
      "INDEX ITEM DESCRIPTION": "Lens coating, ophthalmic",
    },
    {
      NAICS22: "339115",
      "INDEX ITEM DESCRIPTION":
        "Lens grinding, ophthalmic (except in retail stores)",
    },
    {
      NAICS22: "339115",
      "INDEX ITEM DESCRIPTION": "Lens mounts, ophthalmic, manufacturing",
    },
    {
      NAICS22: "339115",
      "INDEX ITEM DESCRIPTION": "Lens polishing, ophthalmic",
    },
    {
      NAICS22: "339115",
      "INDEX ITEM DESCRIPTION": "Lenses, ophthalmic, manufacturing",
    },
    {
      NAICS22: "339115",
      "INDEX ITEM DESCRIPTION":
        "Magnifiers, corrective vision-type, manufacturing",
    },
    {
      NAICS22: "339115",
      "INDEX ITEM DESCRIPTION": "Sunglasses and goggles manufacturing",
    },
    {
      NAICS22: "339115",
      "INDEX ITEM DESCRIPTION":
        "Temples and fronts (i.e., eyeglass frames), ophthalmic, manufacturing",
    },
    {
      NAICS22: "339116",
      "INDEX ITEM DESCRIPTION": "Bridges, custom made in dental laboratories",
    },
    {
      NAICS22: "339116",
      "INDEX ITEM DESCRIPTION": "Dental laboratories",
    },
    {
      NAICS22: "339116",
      "INDEX ITEM DESCRIPTION": "Dentures, custom made in dental laboratories",
    },
    {
      NAICS22: "339116",
      "INDEX ITEM DESCRIPTION":
        "Mouth guards and protectors, custom made in dental laboratories",
    },
    {
      NAICS22: "339116",
      "INDEX ITEM DESCRIPTION":
        "Orthodontic appliance, custom made in dental laboratories",
    },
    {
      NAICS22: "339116",
      "INDEX ITEM DESCRIPTION": "Teeth, custom made in dental laboratories",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION": "Bracelets, precious metal, manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION":
        "Buttons, precious metal, precious stones, semiprecious stones, manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION": "Card cases, precious metal, manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION": "Cases, jewelry, metal, manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION":
        "Chains or necklace, precious metal, manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION": "Checkbook covers, precious metal, manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION": "Cigar cases, precious metal, manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION": "Cigarette cases, precious metal, manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION": "Coin purses, precious metal, manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION": "Comb cases, precious metal, manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION": "Compacts, precious metal, manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION": "Cosmetic bags, precious metal, manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION": "Costume jewelry manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION": "Cuff links, precious metal, manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION":
        "Cutlery, precious metal (except precious plated), manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION": "Diamond cutting and polishing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION": "Drilling pearls",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION": "Engraving and etching precious metal flatware",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION": "Engraving and etching precious metal jewelry",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION": "Engraving and/or etching costume jewelry",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION": "Findings, jeweler's, manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION": "Handbags, precious metal, manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION": "Hollowware, precious metal, manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION":
        "Jewel settings and mountings, precious metal, manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION": "Jeweler's findings and materials manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION": "Jewelry, costume, manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION":
        "Jewelry, natural or cultured pearls, manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION": "Jewelry, precious metal, manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION": "Key cases, precious metal, manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION": "Lapidary work manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION":
        "Lighters, cigar and cigarette, clad with precious metal, manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION":
        "Novelties, precious metal (except precious plated), manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION": "Pearl drilling, peeling, or sawing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION": "Pearls, costume, manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION": "Personal goods, metal, manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION": "Pewter ware manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION":
        "Pins and brooches, precious metal, manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION":
        "Pocketbooks, precious metal, men's or women's, manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION":
        "Purses, precious metal or clad with precious metal, manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION":
        "Rosaries and other small religious articles, precious metal, manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION": "Sewing cases, precious metal, manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION": "Stamping coins",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION": "Straps, watch, precious metal, manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION": "Table cutlery, precious metal, manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION": "Tobacco pouches, precious metal, manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION":
        "Toilet kits and cases, precious metal, manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION":
        "Trophies, precious metal (except precious plated), manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION": "Wallets, precious metal, manufacturing",
    },
    {
      NAICS22: "339910",
      "INDEX ITEM DESCRIPTION": "Watch bands, metal, manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Archery equipment manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION":
        "Athletic goods (except ammunition, clothing, footwear, small arms) manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Badminton equipment manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Bags, golf, manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Bags, punching, manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Bait, artificial, fishing, manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION":
        "Balls, baseball, basketball, football, golf, tennis, pool, and bowling, manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION":
        "Baseball equipment and supplies (except footwear, uniforms) manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION":
        "Basketball equipment and supplies (except footwear, uniforms) manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Billiard equipment and supplies manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Bobsleds manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Boomerangs manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Bowling pin machines, automatic, manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Bows, archery, manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Boxing equipment manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Caddy carts manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Carts, caddy, manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION":
        "Clubs, sporting goods (e.g., golf, Indian), manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Croquet sets manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Dumbbells manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Exercise machines manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION":
        "Fencing equipment (sporting goods) manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION":
        "Fishing tackle and equipment (except lines, nets, seines) manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Fitness equipment manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Flies, artificial fishing, manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION":
        "Football equipment and supplies (except footwear, uniforms) manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION":
        "Gloves, sport and athletic (e.g., baseball, boxing, racquetball, handball), manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION":
        "Golfing equipment (e.g., bags, balls, caddy carts, clubs, tees) manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION":
        "Gymnasium and playground equipment, manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION":
        "Helmets, athletic (except motorized vehicle crash helmets), manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Hockey equipment (except apparel) manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Hockey skates manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Hooks, fishing, manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Ice skates manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Jogging machines, manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Leather gloves, athletic, manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION":
        "Protectors, sports (e.g., baseball, basketball, hockey), manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Reels, fishing, manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Rods and rod parts, fishing, manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Roller skates manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Sailboards manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Scuba diving equipment manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Skateboards manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Skates and parts, ice and roller, manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION":
        "Skis and skiing equipment (except apparel) manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Snowshoes manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION":
        "Sporting goods (except ammunition, clothing, footwear, small arms) manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Squash equipment (except apparel) manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION":
        "Sticks, sports (e.g., hockey, lacrosse), manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Surfboards manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Swimming pools, above ground, manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION":
        "Tackle, fishing (except line, nets, seines), manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION":
        "Tennis goods (e.g., balls, frames, rackets) manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Toboggans manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION":
        "Track and field athletic equipment (except apparel, footwear) manufacturing",
    },
    {
      NAICS22: "339920",
      "INDEX ITEM DESCRIPTION": "Wet suits manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION": "Action figures manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION": "Automobiles, children's, manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION":
        "Balls, rubber (except athletic equipment), manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION": "Carriages, baby, manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION": "Carriages, doll, manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION": "Checkers and checkerboards manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION": "Chessmen and chessboards manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION": "Clothing, doll, manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION": "Craft and hobby kits and sets manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION": "Darts and dart games manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION": "Dishes, toy, manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION": "Doll carriages and carts manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION": "Doll clothing manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION":
        "Dolls, doll parts, and doll clothing (except wigs) manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION": "Electronic toys and games manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION": "Electronic video games, handheld, manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION": "Embroidery kits manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION":
        "Games (except coin- or card-operated), children's and adult, manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION": "Gaming consoles manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION": "Gocarts, children's, manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION": "Hobbyhorses manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION": "Kites manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION": "Marbles manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION": "Model kits manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION": "Model railroad manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION":
        "Models, toy and hobby (e.g., airplane, boat, ship), manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION": "Musical instruments, toy, manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION": "Railroad models, hobby and toy, manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION": "Rifles, toy, manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION": "Rocking horses manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION":
        "Science kits (e.g., chemistry sets, microscopes, natural science sets) manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION": "Scooters, children's, manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION": "Sleds, children's, manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION": "Strollers, baby, manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION": "Structural toy sets manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION": "Stuffed toys (including animals) manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION":
        "Toy furniture and household-type equipment manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION": "Toys manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION":
        "Trains and equipment, toy, electric or mechanical, manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION": "Tricycles (except metal) manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION":
        "Vehicles, children's (except bicycles and metal tricycles), manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION": "Video game devices manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION":
        "Video game machines (except coin- or card-operated) manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION":
        "Wagons, children's (e.g., coaster, express, and play), manufacturing",
    },
    {
      NAICS22: "339930",
      "INDEX ITEM DESCRIPTION": "Walkers, baby (vehicles), manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Artist's paint manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Artist's supplies (except paper) manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Ball point pens manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Blackboards, framed, manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION":
        "Branding irons (i.e., marking irons) manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Brushes, artists', manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Canvas board, artist's, manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION":
        "Canvas, artist's, prepared on frames, manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Carbon paper manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION":
        "Chalk (e.g., artist's, blackboard, carpenter's, marking, tailor's), manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Chalkboards, framed, manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Clay, modeling, manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Crayons manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Date stamps, hand operated, manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION":
        "Drafting materials (except instruments and tables) manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Easels, artists', manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Embossing stamps manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Felt tip markers manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Fountain pens manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION":
        "Frames for artist's canvases (i.e., stretchers) manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION":
        "Hand operated stamps (e.g., canceling, postmark, shoe, textile marking) manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Holepunchers, hand operated, manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Inked ribbons manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Label making equipment, handheld, manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION":
        "List finders and roledex address files manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Marker boards (i.e., whiteboards) manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Marking devices manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Mechanical pencil refills manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Mechanical pencils manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Metal hand stamps manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Modeling clay manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Nibs (i.e., pen points) manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Paints, artist's, manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Palettes, artist's, manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Paper cutters, office-type, manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Paper, carbon, manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Paper, stencil, manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Pen refills and cartridges manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Pencil leads manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Pencil sharpeners manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Pencils manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Pens manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION":
        "Ribbons (e.g., cash register, printer, typewriter), inked, manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Ribbons, inked, manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Rubber stamps manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION":
        "Seal presses (e.g., notary), hand operated, manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Stamp pads manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Stamping devices, hand operated, manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Staple removers manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Staplers manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Stencil paper manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION":
        "Stencils for painting and marking (e.g., cardboard, metal) manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Tape dispensers manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Typewriter ribbons manufacturing",
    },
    {
      NAICS22: "339940",
      "INDEX ITEM DESCRIPTION": "Water colors, artist's, manufacturing",
    },
    {
      NAICS22: "339950",
      "INDEX ITEM DESCRIPTION": "Billboards manufacturing",
    },
    {
      NAICS22: "339950",
      "INDEX ITEM DESCRIPTION":
        "Displays (e.g., counter, floor, point-of-purchase) manufacturing",
    },
    {
      NAICS22: "339950",
      "INDEX ITEM DESCRIPTION": "Electrical signs manufacturing",
    },
    {
      NAICS22: "339950",
      "INDEX ITEM DESCRIPTION": "Letters for signs manufacturing",
    },
    {
      NAICS22: "339950",
      "INDEX ITEM DESCRIPTION": "Neon signs manufacturing",
    },
    {
      NAICS22: "339950",
      "INDEX ITEM DESCRIPTION": "Scoreboards manufacturing",
    },
    {
      NAICS22: "339950",
      "INDEX ITEM DESCRIPTION":
        "Signs and signboards (except paper, paperboard) manufacturing",
    },
    {
      NAICS22: "339950",
      "INDEX ITEM DESCRIPTION":
        "Traffic (e.g., highway, road, street, bridge) signs manufacturing",
    },
    {
      NAICS22: "339991",
      "INDEX ITEM DESCRIPTION": "Coaxial mechanical face seals manufacturing",
    },
    {
      NAICS22: "339991",
      "INDEX ITEM DESCRIPTION": "Compression packings manufacturing",
    },
    {
      NAICS22: "339991",
      "INDEX ITEM DESCRIPTION":
        "Gasket, packing, and sealing devices manufacturing",
    },
    {
      NAICS22: "339991",
      "INDEX ITEM DESCRIPTION": "Gaskets manufacturing",
    },
    {
      NAICS22: "339991",
      "INDEX ITEM DESCRIPTION": "Grease seals manufacturing",
    },
    {
      NAICS22: "339991",
      "INDEX ITEM DESCRIPTION": "Molded packings and seals manufacturing",
    },
    {
      NAICS22: "339991",
      "INDEX ITEM DESCRIPTION": "Oil seals manufacturing",
    },
    {
      NAICS22: "339991",
      "INDEX ITEM DESCRIPTION": "Seals, grease or oil, manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Accordions and parts manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION":
        "Autophones (organs with perforated music rolls) manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Banjos and parts manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Bassoons manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Bells (musical instruments) manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Calliopes (steam organs) manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Cellos and parts manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION":
        "Chimes and parts (musical instruments) manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Clarinets and parts manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Cornets and parts manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Cymbals and parts manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION":
        "Drums (musical instruments), parts, and accessories manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Electric musical instruments manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Flutes and parts manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Fretted instruments and parts manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION":
        "Guitars and parts, electric and nonelectric, manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Hammers, piano, manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Harmonicas manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Harps and parts manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Harpsichords manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Instruments, musical, manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Keyboards, piano or organ, manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Knobs, organ, manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Mandolins manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION":
        "Mouthpieces for musical instruments manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Music rolls, perforated, manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION":
        "Musical instrument accessories (e.g., mouthpieces, reeds, stands, traps) manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Musical instruments (except toy) manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Oboes manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Ocarinas manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Octophones manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Percussion musical instruments manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION":
        "Piano parts and materials (except piano hardware) manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Piccolos and parts manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Pipes, organ, manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Reeds, musical instrument, manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Saxophones and parts manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Strings, musical instrument, manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Synthesizers, music, manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Trombones and parts manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Trumpets and parts manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Tuning forks manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Ukuleles and parts manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Vibraphones manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Violas and parts manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Violins and parts manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Xylophones and parts manufacturing",
    },
    {
      NAICS22: "339992",
      "INDEX ITEM DESCRIPTION": "Zithers and parts manufacturing",
    },
    {
      NAICS22: "339993",
      "INDEX ITEM DESCRIPTION":
        "Buckles and buckle parts (including shoe) manufacturing",
    },
    {
      NAICS22: "339993",
      "INDEX ITEM DESCRIPTION":
        "Buttons (except precious metal, precious stones, semiprecious stones) manufacturing",
    },
    {
      NAICS22: "339993",
      "INDEX ITEM DESCRIPTION": "Cuff links (except precious) manufacturing",
    },
    {
      NAICS22: "339993",
      "INDEX ITEM DESCRIPTION": "Eyelets, metal, manufacturing",
    },
    {
      NAICS22: "339993",
      "INDEX ITEM DESCRIPTION":
        "Fasteners (e.g., glove, hook and eye, slide, snap) manufacturing",
    },
    {
      NAICS22: "339993",
      "INDEX ITEM DESCRIPTION": "Hairpins (except rubber) manufacturing",
    },
    {
      NAICS22: "339993",
      "INDEX ITEM DESCRIPTION":
        "Hook and eye fasteners (i.e., sewing accessories) manufacturing",
    },
    {
      NAICS22: "339993",
      "INDEX ITEM DESCRIPTION":
        "Needles (except hypodermic, phonograph, styli) manufacturing",
    },
    {
      NAICS22: "339993",
      "INDEX ITEM DESCRIPTION": "Pins (except precious) manufacturing",
    },
    {
      NAICS22: "339993",
      "INDEX ITEM DESCRIPTION": "Safety pins manufacturing",
    },
    {
      NAICS22: "339993",
      "INDEX ITEM DESCRIPTION": "Slide fasteners (i.e., zippers) manufacturing",
    },
    {
      NAICS22: "339993",
      "INDEX ITEM DESCRIPTION": "Zippers (i.e., slide fasteners) manufacturing",
    },
    {
      NAICS22: "339994",
      "INDEX ITEM DESCRIPTION": "Brooms, hand and machine, manufacturing",
    },
    {
      NAICS22: "339994",
      "INDEX ITEM DESCRIPTION":
        "Brushes, household-type and industrial, manufacturing",
    },
    {
      NAICS22: "339994",
      "INDEX ITEM DESCRIPTION": "Brushes, paint (except artists'), manufacturing",
    },
    {
      NAICS22: "339994",
      "INDEX ITEM DESCRIPTION": "Hairbrushes manufacturing",
    },
    {
      NAICS22: "339994",
      "INDEX ITEM DESCRIPTION": "Mops, floor and dust, manufacturing",
    },
    {
      NAICS22: "339994",
      "INDEX ITEM DESCRIPTION": "Paint rollers manufacturing",
    },
    {
      NAICS22: "339994",
      "INDEX ITEM DESCRIPTION": "Paintbrushes manufacturing",
    },
    {
      NAICS22: "339994",
      "INDEX ITEM DESCRIPTION": "Shaving brushes manufacturing",
    },
    {
      NAICS22: "339994",
      "INDEX ITEM DESCRIPTION": "Toothbrushes (except electric) manufacturing",
    },
    {
      NAICS22: "339995",
      "INDEX ITEM DESCRIPTION": "Burial caskets and cases manufacturing",
    },
    {
      NAICS22: "339995",
      "INDEX ITEM DESCRIPTION":
        "Burial vaults (except concrete, stone) manufacturing",
    },
    {
      NAICS22: "339995",
      "INDEX ITEM DESCRIPTION": "Caskets, burial, manufacturing",
    },
    {
      NAICS22: "339995",
      "INDEX ITEM DESCRIPTION": "Vaults (except concrete) manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION":
        "Amusement machines, coin- or card-operated, manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION":
        "Artificial flower arrangements assembled from purchased components",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Atomizers (e.g., perfumes) manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Beach umbrellas manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Bone novelties manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Candles manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Canes (except orthopedic) manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION":
        "Christmas tree ornaments (except electric, glass) manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Christmas trees, artificial, manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Cigarette holders manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Cigarette lighter flints manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION":
        "Cigarette lighters (except precious metal) manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION":
        "Coin- or card-operated amusement machines (except jukebox) manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION":
        "Coin-or card-operated gambling devices manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Decalcomania work (except on china, glass)",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Electronic cigarettes manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Feather dusters manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION":
        "Feathers, preparing (i.e., for use in apparel and textile products)",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Fire extinguishers, portable, manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Flints, lighter, manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION":
        "Flowers, artificial (except glass, plastics), manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Fly swatters manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION":
        "Frames, mirror and picture, all materials, manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION":
        "Fruits, artificial (except glass, plastics), manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Games, coin- or card-operated, manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Garden umbrellas manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Globes, geographical, manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Hair nets made from purchased netting",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION":
        "Hairpieces (e.g., toupees, wigs, wiglets) manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Hat blocks manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION":
        "Lighters, cigar and cigarette (except motor vehicle, precious metal), manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Mannequins manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Marionettes (i.e., puppets) manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Models, anatomical, manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Music boxes manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION":
        "Novelties, not specified elsewhere, manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION":
        "Ornaments, Christmas tree (except electric, glass), manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Parasols manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Patterns, shoe, manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION":
        "Pinball machines, coin- or card-operated, manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Pipe cleaners manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Pipes, smoker's, manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Potpourri manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Puppets manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Sewing and mending kits assembling",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Shell novelties",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Slot machines manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Theatrical scenery manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Tinsel manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Tobacco pipes manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Toupees manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Trees and plants, artificial, manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Umbrellas manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Wax figures (i.e., mannequins) manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION":
        "Wigs, wiglets, toupees, hairpieces, manufacturing",
    },
    {
      NAICS22: "339999",
      "INDEX ITEM DESCRIPTION": "Wreaths, artificial, manufacturing",
    },
    {
      NAICS22: "423110",
      "INDEX ITEM DESCRIPTION":
        "All-terrain vehicles (ATVs) merchant wholesalers",
    },
    {
      NAICS22: "423110",
      "INDEX ITEM DESCRIPTION": "Ambulance merchant wholesalers",
    },
    {
      NAICS22: "423110",
      "INDEX ITEM DESCRIPTION": "Automobile auction merchant wholesalers",
    },
    {
      NAICS22: "423110",
      "INDEX ITEM DESCRIPTION": "Automobile merchant wholesalers",
    },
    {
      NAICS22: "423110",
      "INDEX ITEM DESCRIPTION": "Bicycle, motorized, merchant wholesalers",
    },
    {
      NAICS22: "423110",
      "INDEX ITEM DESCRIPTION": "Bodies, motor vehicle, merchant wholesalers",
    },
    {
      NAICS22: "423110",
      "INDEX ITEM DESCRIPTION": "Bus merchant wholesalers",
    },
    {
      NAICS22: "423110",
      "INDEX ITEM DESCRIPTION": "Camping trailer merchant wholesalers",
    },
    {
      NAICS22: "423110",
      "INDEX ITEM DESCRIPTION": "Cargo van merchant wholesalers",
    },
    {
      NAICS22: "423110",
      "INDEX ITEM DESCRIPTION": "Chassis, motor vehicle, merchant wholesalers",
    },
    {
      NAICS22: "423110",
      "INDEX ITEM DESCRIPTION": "Minivan merchant wholesalers",
    },
    {
      NAICS22: "423110",
      "INDEX ITEM DESCRIPTION": "Moped merchant wholesalers",
    },
    {
      NAICS22: "423110",
      "INDEX ITEM DESCRIPTION": "Motor home merchant wholesalers",
    },
    {
      NAICS22: "423110",
      "INDEX ITEM DESCRIPTION": "Motor vehicle merchant wholesalers",
    },
    {
      NAICS22: "423110",
      "INDEX ITEM DESCRIPTION": "Motorcycle merchant wholesalers",
    },
    {
      NAICS22: "423110",
      "INDEX ITEM DESCRIPTION": "Recreational vehicle merchant wholesalers",
    },
    {
      NAICS22: "423110",
      "INDEX ITEM DESCRIPTION": "School bus merchant wholesalers",
    },
    {
      NAICS22: "423110",
      "INDEX ITEM DESCRIPTION": "Snowmobile merchant wholesalers",
    },
    {
      NAICS22: "423110",
      "INDEX ITEM DESCRIPTION":
        "Special purpose highway vehicle merchant wholesalers",
    },
    {
      NAICS22: "423110",
      "INDEX ITEM DESCRIPTION": "Sport utility vehicle merchant wholesalers",
    },
    {
      NAICS22: "423110",
      "INDEX ITEM DESCRIPTION": "Taxicab merchant wholesalers",
    },
    {
      NAICS22: "423110",
      "INDEX ITEM DESCRIPTION": "Tractors, highway, merchant wholesalers",
    },
    {
      NAICS22: "423110",
      "INDEX ITEM DESCRIPTION": "Trailers, motor vehicle, merchant wholesalers",
    },
    {
      NAICS22: "423110",
      "INDEX ITEM DESCRIPTION":
        "Transportation equipment, motor vehicle, merchant wholesalers",
    },
    {
      NAICS22: "423110",
      "INDEX ITEM DESCRIPTION":
        "Travel trailer (e.g., tent trailers) merchant wholesalers",
    },
    {
      NAICS22: "423110",
      "INDEX ITEM DESCRIPTION": "Truck tractors, road, merchant wholesalers",
    },
    {
      NAICS22: "423110",
      "INDEX ITEM DESCRIPTION": "Truck trailer merchant wholesalers",
    },
    {
      NAICS22: "423110",
      "INDEX ITEM DESCRIPTION": "Trucks, road, merchant wholesalers",
    },
    {
      NAICS22: "423110",
      "INDEX ITEM DESCRIPTION": "Used car merchant wholesalers",
    },
    {
      NAICS22: "423110",
      "INDEX ITEM DESCRIPTION": "Utility trailer merchant wholesalers",
    },
    {
      NAICS22: "423110",
      "INDEX ITEM DESCRIPTION": "Vehicles, recreational, merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION":
        "Aftermarket parts, automotive, merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION": "Auto body shop supplies merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION":
        "Automobile accessories (except tires, tubes) merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION": "Automobile glass merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION":
        "Automobile service station equipment merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION": "Automotive brakes merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION": "Automotive parts, new, merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION": "Automotive stampings merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION":
        "Balancing equipment, motor vehicle, merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION": "Batteries, automotive, merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION":
        "Engine testing equipment, motor vehicle, merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION":
        "Engines and parts, automotive, new, merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION":
        "Gasoline marketing equipment merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION":
        "Gasoline measuring and dispensing pumps merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION":
        "Gasoline service station equipment merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION":
        "Generators, motor vehicle electrical, new, merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION": "Glass, automotive, merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION":
        "Handtools, motor vehicle mechanics', merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION": "Hardware, motor vehicle, merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION": "Hoists, automotive, merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION": "Mechanic's tools merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION": "Mirrors, automotive, merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION":
        "Motor vehicle instruments, electric, merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION":
        "Motor vehicle parts and accessories, new, merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION": "Motorcycle parts, new, merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION": "Mufflers, exhaust, merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION": "Oil filters, automotive, merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION": "Parts, new, motor vehicle, merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION":
        "Pistons and valves, automotive, merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION":
        "Pumps (e.g., fuel, oil, power steering, water), automotive, merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION": "Radiators, motor vehicle, merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION": "Seat belts, motor vehicle, merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION": "Seat covers, automotive, merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION":
        "Shop equipment, service station, merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION":
        "Testing and measuring equipment, electrical, automotive, merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION":
        "Tools and equipment, motor vehicle, merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION": "Trailer parts, new, merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION": "Truck parts, new, merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION":
        "Voltage regulators, motor vehicle, merchant wholesalers",
    },
    {
      NAICS22: "423120",
      "INDEX ITEM DESCRIPTION":
        "Wheels, motor vehicle, new, merchant wholesalers",
    },
    {
      NAICS22: "423130",
      "INDEX ITEM DESCRIPTION":
        "Heavy truck tires and tubes merchant wholesalers",
    },
    {
      NAICS22: "423130",
      "INDEX ITEM DESCRIPTION":
        "Motor vehicle tire and tube merchant wholesalers",
    },
    {
      NAICS22: "423130",
      "INDEX ITEM DESCRIPTION": "Recapped tires merchant wholesalers",
    },
    {
      NAICS22: "423130",
      "INDEX ITEM DESCRIPTION":
        "Tire and tube repair materials merchant wholesalers",
    },
    {
      NAICS22: "423130",
      "INDEX ITEM DESCRIPTION": "Tire tubes, motor vehicle, merchant wholesalers",
    },
    {
      NAICS22: "423130",
      "INDEX ITEM DESCRIPTION": "Tires, new, motor vehicle, merchant wholesalers",
    },
    {
      NAICS22: "423130",
      "INDEX ITEM DESCRIPTION":
        "Tires, used (except scrap), merchant wholesalers",
    },
    {
      NAICS22: "423130",
      "INDEX ITEM DESCRIPTION": "Used tires, motor vehicle, merchant wholesalers",
    },
    {
      NAICS22: "423140",
      "INDEX ITEM DESCRIPTION": "Automotive parts, used, merchant wholesalers",
    },
    {
      NAICS22: "423140",
      "INDEX ITEM DESCRIPTION":
        "Generators, motor vehicle electrical, used, merchant wholesalers",
    },
    {
      NAICS22: "423140",
      "INDEX ITEM DESCRIPTION": "Junk yards, auto, merchant wholesalers",
    },
    {
      NAICS22: "423140",
      "INDEX ITEM DESCRIPTION": "Motor vehicle parts, used, merchant wholesalers",
    },
    {
      NAICS22: "423140",
      "INDEX ITEM DESCRIPTION":
        "Parts, used, motor vehicle, merchant wholesalers",
    },
    {
      NAICS22: "423140",
      "INDEX ITEM DESCRIPTION": "Used parts, motor vehicle, merchant wholesalers",
    },
    {
      NAICS22: "423210",
      "INDEX ITEM DESCRIPTION": "Antique furniture merchant wholesalers",
    },
    {
      NAICS22: "423210",
      "INDEX ITEM DESCRIPTION": "Baby furniture merchant wholesalers",
    },
    {
      NAICS22: "423210",
      "INDEX ITEM DESCRIPTION": "Beds (except hospital) merchant wholesalers",
    },
    {
      NAICS22: "423210",
      "INDEX ITEM DESCRIPTION": "Box springs merchant wholesalers",
    },
    {
      NAICS22: "423210",
      "INDEX ITEM DESCRIPTION":
        "Cabinets, kitchen, freestanding, merchant wholesalers",
    },
    {
      NAICS22: "423210",
      "INDEX ITEM DESCRIPTION":
        "Furniture (except drafting tables, hospital beds, medical furniture) merchant wholesalers",
    },
    {
      NAICS22: "423210",
      "INDEX ITEM DESCRIPTION": "Furniture parts merchant wholesalers",
    },
    {
      NAICS22: "423210",
      "INDEX ITEM DESCRIPTION": "Hotel furniture merchant wholesalers",
    },
    {
      NAICS22: "423210",
      "INDEX ITEM DESCRIPTION": "Household-type furniture merchant wholesalers",
    },
    {
      NAICS22: "423210",
      "INDEX ITEM DESCRIPTION": "Mattresses merchant wholesalers",
    },
    {
      NAICS22: "423210",
      "INDEX ITEM DESCRIPTION": "Office furniture merchant wholesalers",
    },
    {
      NAICS22: "423210",
      "INDEX ITEM DESCRIPTION": "Outdoor furniture merchant wholesalers",
    },
    {
      NAICS22: "423210",
      "INDEX ITEM DESCRIPTION": "Public building furniture merchant wholesalers",
    },
    {
      NAICS22: "423210",
      "INDEX ITEM DESCRIPTION": "Religious furniture merchant wholesalers",
    },
    {
      NAICS22: "423210",
      "INDEX ITEM DESCRIPTION": "Restaurant furniture merchant wholesalers",
    },
    {
      NAICS22: "423210",
      "INDEX ITEM DESCRIPTION": "School furniture merchant wholesalers",
    },
    {
      NAICS22: "423210",
      "INDEX ITEM DESCRIPTION": "Store furniture merchant wholesalers",
    },
    {
      NAICS22: "423210",
      "INDEX ITEM DESCRIPTION": "Theater seats merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION": "Antique home furnishings merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION": "Antique houseware merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION": "Bathroom accessories merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION": "Blankets (except electric) merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION": "Blinds and shades, window, merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION":
        "Brooms and brushes, household-type, merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION": "Carpet merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION":
        "Ceramic wall (except structural) and floor tile merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION": "Chinaware, household-type, merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION": "Closet accessories merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION":
        "Containers, household (except paper and disposable plastics), merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION":
        "Cooking utensils, household-type, merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION":
        "Cups, plastics (except disposable), merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION": "Curtains merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION":
        "Dishes, household-type (except disposable plastics, paper), merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION": "Draperies merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION":
        "Fireplaces, prefabricated (except gas), merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION":
        "Flatware (except plated, precious) merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION": "Floor coverings merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION": "Frames and pictures merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION":
        "Furniture coverings and protectors merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION": "Glassware, household-type, merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION":
        "Hollowware (except precious metal) merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION": "Home furnishings merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION":
        "Housewares (except electric) merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION": "Ironing boards merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION":
        "Kitchen utensils, household-type, merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION":
        "Lamps (i.e., lighting fixtures) merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION":
        "Linens (e.g., bath, bed, table) merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION":
        "Mirrors (except automotive) merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION": "Mops, household, merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION": "Napkins (except paper) merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION": "Rugs merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION": "Slipcovers merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION":
        "Tableware (except disposable, plated, precious) merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION": "Towels and washcloths merchant wholesalers",
    },
    {
      NAICS22: "423220",
      "INDEX ITEM DESCRIPTION": "Window shades and blinds merchant wholesalers",
    },
    {
      NAICS22: "423310",
      "INDEX ITEM DESCRIPTION":
        "Building board (e.g., fiber, flake, particle) merchant wholesalers",
    },
    {
      NAICS22: "423310",
      "INDEX ITEM DESCRIPTION":
        "Buildings, prefabricated wood, merchant wholesalers",
    },
    {
      NAICS22: "423310",
      "INDEX ITEM DESCRIPTION":
        "Cabinets, kitchen, built-in, merchant wholesalers",
    },
    {
      NAICS22: "423310",
      "INDEX ITEM DESCRIPTION":
        "Countertops, wood and wood fiber, merchant wholesalers",
    },
    {
      NAICS22: "423310",
      "INDEX ITEM DESCRIPTION": "Doors and door frames merchant wholesalers",
    },
    {
      NAICS22: "423310",
      "INDEX ITEM DESCRIPTION": "Drywall board merchant wholesalers",
    },
    {
      NAICS22: "423310",
      "INDEX ITEM DESCRIPTION": "Fencing, wood, merchant wholesalers",
    },
    {
      NAICS22: "423310",
      "INDEX ITEM DESCRIPTION": "Fiberboard merchant wholesalers",
    },
    {
      NAICS22: "423310",
      "INDEX ITEM DESCRIPTION": "Flooring, wood, merchant wholesalers",
    },
    {
      NAICS22: "423310",
      "INDEX ITEM DESCRIPTION":
        "Kitchen cabinets, built-in, merchant wholesalers",
    },
    {
      NAICS22: "423310",
      "INDEX ITEM DESCRIPTION": "Laminates, wood, merchant wholesalers",
    },
    {
      NAICS22: "423310",
      "INDEX ITEM DESCRIPTION":
        "Lumber (e.g., dressed, finished, rough) merchant wholesalers",
    },
    {
      NAICS22: "423310",
      "INDEX ITEM DESCRIPTION": "Millwork merchant wholesalers",
    },
    {
      NAICS22: "423310",
      "INDEX ITEM DESCRIPTION":
        "Molding (e.g., sheet metal, wood) merchant wholesalers",
    },
    {
      NAICS22: "423310",
      "INDEX ITEM DESCRIPTION": "Paneling merchant wholesalers",
    },
    {
      NAICS22: "423310",
      "INDEX ITEM DESCRIPTION": "Particleboard merchant wholesalers",
    },
    {
      NAICS22: "423310",
      "INDEX ITEM DESCRIPTION": "Plywood merchant wholesalers",
    },
    {
      NAICS22: "423310",
      "INDEX ITEM DESCRIPTION":
        "Prefabricated buildings, wood, merchant wholesalers",
    },
    {
      NAICS22: "423310",
      "INDEX ITEM DESCRIPTION": "Railings, wood, merchant wholesalers",
    },
    {
      NAICS22: "423310",
      "INDEX ITEM DESCRIPTION": "Roofing materials, wood, merchant wholesalers",
    },
    {
      NAICS22: "423310",
      "INDEX ITEM DESCRIPTION": "Screens, window and door, merchant wholesalers",
    },
    {
      NAICS22: "423310",
      "INDEX ITEM DESCRIPTION": "Shingles, wood, merchant wholesalers",
    },
    {
      NAICS22: "423310",
      "INDEX ITEM DESCRIPTION": "Siding, wood, merchant wholesalers",
    },
    {
      NAICS22: "423310",
      "INDEX ITEM DESCRIPTION": "Stairs, wood, merchant wholesalers",
    },
    {
      NAICS22: "423310",
      "INDEX ITEM DESCRIPTION":
        "Structural assemblies, prefabricated wood, merchant wholesalers",
    },
    {
      NAICS22: "423310",
      "INDEX ITEM DESCRIPTION": "Veneer, wood, merchant wholesalers",
    },
    {
      NAICS22: "423310",
      "INDEX ITEM DESCRIPTION": "Wallboard merchant wholesalers",
    },
    {
      NAICS22: "423310",
      "INDEX ITEM DESCRIPTION": "Windows and window frames merchant wholesalers",
    },
    {
      NAICS22: "423310",
      "INDEX ITEM DESCRIPTION": "Wood fencing merchant wholesalers",
    },
    {
      NAICS22: "423310",
      "INDEX ITEM DESCRIPTION": "Wood flooring merchant wholesalers",
    },
    {
      NAICS22: "423310",
      "INDEX ITEM DESCRIPTION": "Wood shingles merchant wholesalers",
    },
    {
      NAICS22: "423310",
      "INDEX ITEM DESCRIPTION": "Wood siding merchant wholesalers",
    },
    {
      NAICS22: "423320",
      "INDEX ITEM DESCRIPTION":
        "Asphalt and concrete mixtures merchant wholesalers",
    },
    {
      NAICS22: "423320",
      "INDEX ITEM DESCRIPTION": "Bricks (except refractory) merchant wholesalers",
    },
    {
      NAICS22: "423320",
      "INDEX ITEM DESCRIPTION":
        "Building blocks (e.g., cinder, concrete) merchant wholesalers",
    },
    {
      NAICS22: "423320",
      "INDEX ITEM DESCRIPTION": "Building stone merchant wholesalers",
    },
    {
      NAICS22: "423320",
      "INDEX ITEM DESCRIPTION": "Cement merchant wholesalers",
    },
    {
      NAICS22: "423320",
      "INDEX ITEM DESCRIPTION":
        "Ceramic construction materials (except refractory and ceramic roofing tile) merchant wholesalers",
    },
    {
      NAICS22: "423320",
      "INDEX ITEM DESCRIPTION":
        "Clay construction materials (except refractory and clay roofing tile) merchant wholesalers",
    },
    {
      NAICS22: "423320",
      "INDEX ITEM DESCRIPTION": "Coal tar paving materials merchant wholesalers",
    },
    {
      NAICS22: "423320",
      "INDEX ITEM DESCRIPTION": "Concrete building products merchant wholesalers",
    },
    {
      NAICS22: "423320",
      "INDEX ITEM DESCRIPTION": "Concrete mixtures merchant wholesalers",
    },
    {
      NAICS22: "423320",
      "INDEX ITEM DESCRIPTION":
        "Conduit and pipe, concrete, merchant wholesalers",
    },
    {
      NAICS22: "423320",
      "INDEX ITEM DESCRIPTION":
        "Countertops, stone and concrete, merchant wholesalers",
    },
    {
      NAICS22: "423320",
      "INDEX ITEM DESCRIPTION": "Crushed stone merchant wholesalers",
    },
    {
      NAICS22: "423320",
      "INDEX ITEM DESCRIPTION": "Culvert pipe, concrete, merchant wholesalers",
    },
    {
      NAICS22: "423320",
      "INDEX ITEM DESCRIPTION": "Drywall joint compounds merchant wholesalers",
    },
    {
      NAICS22: "423320",
      "INDEX ITEM DESCRIPTION": "Fireplace linings merchant wholesalers",
    },
    {
      NAICS22: "423320",
      "INDEX ITEM DESCRIPTION": "Flue pipe and linings merchant wholesalers",
    },
    {
      NAICS22: "423320",
      "INDEX ITEM DESCRIPTION": "Gravel, construction, merchant wholesalers",
    },
    {
      NAICS22: "423320",
      "INDEX ITEM DESCRIPTION": "Lime (except agricultural) merchant wholesalers",
    },
    {
      NAICS22: "423320",
      "INDEX ITEM DESCRIPTION": "Mason's materials merchant wholesalers",
    },
    {
      NAICS22: "423320",
      "INDEX ITEM DESCRIPTION": "Paving mixtures merchant wholesalers",
    },
    {
      NAICS22: "423320",
      "INDEX ITEM DESCRIPTION": "Plaster merchant wholesalers",
    },
    {
      NAICS22: "423320",
      "INDEX ITEM DESCRIPTION": "Sand (except industrial) merchant wholesalers",
    },
    {
      NAICS22: "423320",
      "INDEX ITEM DESCRIPTION": "Septic tanks, concrete, merchant wholesalers",
    },
    {
      NAICS22: "423320",
      "INDEX ITEM DESCRIPTION":
        "Sewer pipe, clay (except refractory), merchant wholesalers",
    },
    {
      NAICS22: "423320",
      "INDEX ITEM DESCRIPTION": "Slate and slate products merchant wholesalers",
    },
    {
      NAICS22: "423320",
      "INDEX ITEM DESCRIPTION":
        "Stone, building or crushed, merchant wholesalers",
    },
    {
      NAICS22: "423320",
      "INDEX ITEM DESCRIPTION":
        "Structural clay tile (except refractory and clay roofing tile) merchant wholesalers",
    },
    {
      NAICS22: "423320",
      "INDEX ITEM DESCRIPTION": "Stucco merchant wholesalers",
    },
    {
      NAICS22: "423320",
      "INDEX ITEM DESCRIPTION": "Terra cotta merchant wholesalers",
    },
    {
      NAICS22: "423320",
      "INDEX ITEM DESCRIPTION":
        "Tile, structural clay (except refractory and clay roofing tile) merchant wholesalers",
    },
    {
      NAICS22: "423330",
      "INDEX ITEM DESCRIPTION": "Asphalt felts and coatings merchant wholesalers",
    },
    {
      NAICS22: "423330",
      "INDEX ITEM DESCRIPTION": "Asphalt roofing shingles merchant wholesalers",
    },
    {
      NAICS22: "423330",
      "INDEX ITEM DESCRIPTION":
        "Ceramic and clay roofing materials merchant wholesalers",
    },
    {
      NAICS22: "423330",
      "INDEX ITEM DESCRIPTION": "Eavestroughing merchant wholesalers",
    },
    {
      NAICS22: "423330",
      "INDEX ITEM DESCRIPTION":
        "Fascia, building (except wood), merchant wholesalers",
    },
    {
      NAICS22: "423330",
      "INDEX ITEM DESCRIPTION":
        "Gutters and down spouts (except wood) merchant wholesalers",
    },
    {
      NAICS22: "423330",
      "INDEX ITEM DESCRIPTION":
        "House wrapping insulation materials merchant wholesalers",
    },
    {
      NAICS22: "423330",
      "INDEX ITEM DESCRIPTION":
        "Insulation materials (except wood) merchant wholesalers",
    },
    {
      NAICS22: "423330",
      "INDEX ITEM DESCRIPTION":
        "Roofing materials (except wood) merchant wholesalers",
    },
    {
      NAICS22: "423330",
      "INDEX ITEM DESCRIPTION":
        "Sheet metal roofing materials merchant wholesalers",
    },
    {
      NAICS22: "423330",
      "INDEX ITEM DESCRIPTION": "Shingles (except wood) merchant wholesalers",
    },
    {
      NAICS22: "423330",
      "INDEX ITEM DESCRIPTION": "Siding (except wood) merchant wholesalers",
    },
    {
      NAICS22: "423330",
      "INDEX ITEM DESCRIPTION":
        "Soffit, building (except wood), merchant wholesalers",
    },
    {
      NAICS22: "423330",
      "INDEX ITEM DESCRIPTION": "Solar reflective film merchant wholesalers",
    },
    {
      NAICS22: "423330",
      "INDEX ITEM DESCRIPTION": "Sound insulation merchant wholesalers",
    },
    {
      NAICS22: "423330",
      "INDEX ITEM DESCRIPTION": "Tarred felts merchant wholesalers",
    },
    {
      NAICS22: "423330",
      "INDEX ITEM DESCRIPTION": "Thermal wrap, house, merchant wholesalers",
    },
    {
      NAICS22: "423330",
      "INDEX ITEM DESCRIPTION": "Vinyl siding merchant wholesalers",
    },
    {
      NAICS22: "423330",
      "INDEX ITEM DESCRIPTION": "Weatherstripping merchant wholesalers",
    },
    {
      NAICS22: "423390",
      "INDEX ITEM DESCRIPTION": "Architectural metalwork merchant wholesalers",
    },
    {
      NAICS22: "423390",
      "INDEX ITEM DESCRIPTION": "Awnings (except canvas) merchant wholesalers",
    },
    {
      NAICS22: "423390",
      "INDEX ITEM DESCRIPTION": "Bailey bridges merchant wholesalers",
    },
    {
      NAICS22: "423390",
      "INDEX ITEM DESCRIPTION": "Bins, storage, merchant wholesalers",
    },
    {
      NAICS22: "423390",
      "INDEX ITEM DESCRIPTION":
        "Building materials, fiberglass (except insulation, roofing, siding), merchant wholesalers",
    },
    {
      NAICS22: "423390",
      "INDEX ITEM DESCRIPTION": "Building paper merchant wholesalers",
    },
    {
      NAICS22: "423390",
      "INDEX ITEM DESCRIPTION":
        "Buildings, prefabricated nonwood, merchant wholesalers",
    },
    {
      NAICS22: "423390",
      "INDEX ITEM DESCRIPTION": "Ceiling tile merchant wholesalers",
    },
    {
      NAICS22: "423390",
      "INDEX ITEM DESCRIPTION":
        "Countertops (except wood, wood fiber, stone, concrete) merchant wholesalers",
    },
    {
      NAICS22: "423390",
      "INDEX ITEM DESCRIPTION":
        "Culvert pipe, metal and plastics, merchant wholesalers",
    },
    {
      NAICS22: "423390",
      "INDEX ITEM DESCRIPTION":
        "Fencing and fencing accessories (except wood) merchant wholesalers",
    },
    {
      NAICS22: "423390",
      "INDEX ITEM DESCRIPTION":
        "Fiberglass building materials (except insulation, roofing, siding) merchant wholesalers",
    },
    {
      NAICS22: "423390",
      "INDEX ITEM DESCRIPTION": "Flat glass merchant wholesalers",
    },
    {
      NAICS22: "423390",
      "INDEX ITEM DESCRIPTION": "Gate and fence hardware merchant wholesalers",
    },
    {
      NAICS22: "423390",
      "INDEX ITEM DESCRIPTION": "Glass, block and brick, merchant wholesalers",
    },
    {
      NAICS22: "423390",
      "INDEX ITEM DESCRIPTION": "Glass, plate, merchant wholesalers",
    },
    {
      NAICS22: "423390",
      "INDEX ITEM DESCRIPTION": "Gypsum building products merchant wholesalers",
    },
    {
      NAICS22: "423390",
      "INDEX ITEM DESCRIPTION":
        "Iron and steel architectural shapes merchant wholesalers",
    },
    {
      NAICS22: "423390",
      "INDEX ITEM DESCRIPTION":
        "Manufactured (i.e., mobile) homes merchant wholesalers",
    },
    {
      NAICS22: "423390",
      "INDEX ITEM DESCRIPTION": "Mastics, construction, merchant wholesalers",
    },
    {
      NAICS22: "423390",
      "INDEX ITEM DESCRIPTION": "Metal buildings merchant wholesalers",
    },
    {
      NAICS22: "423390",
      "INDEX ITEM DESCRIPTION": "Ornamental ironwork merchant wholesalers",
    },
    {
      NAICS22: "423390",
      "INDEX ITEM DESCRIPTION": "Paper, building, merchant wholesalers",
    },
    {
      NAICS22: "423390",
      "INDEX ITEM DESCRIPTION": "Plate glass merchant wholesalers",
    },
    {
      NAICS22: "423390",
      "INDEX ITEM DESCRIPTION":
        "Prefabricated buildings (except wood) merchant wholesalers",
    },
    {
      NAICS22: "423390",
      "INDEX ITEM DESCRIPTION":
        "Septic tanks (except concrete) merchant wholesalers",
    },
    {
      NAICS22: "423390",
      "INDEX ITEM DESCRIPTION":
        "Silt fence and other fabrics (e.g., for erosion control) merchant wholesalers",
    },
    {
      NAICS22: "423390",
      "INDEX ITEM DESCRIPTION": "Storage bins merchant wholesalers",
    },
    {
      NAICS22: "423390",
      "INDEX ITEM DESCRIPTION":
        "Structural assemblies, prefabricated (except wood), merchant wholesalers",
    },
    {
      NAICS22: "423410",
      "INDEX ITEM DESCRIPTION":
        "Camcorders (except household-type) merchant wholesalers",
    },
    {
      NAICS22: "423410",
      "INDEX ITEM DESCRIPTION":
        "Camera equipment and supplies, photographic, merchant wholesalers",
    },
    {
      NAICS22: "423410",
      "INDEX ITEM DESCRIPTION": "Cameras, television, merchant wholesalers",
    },
    {
      NAICS22: "423410",
      "INDEX ITEM DESCRIPTION":
        "Cameras, video (except household-type), merchant wholesalers",
    },
    {
      NAICS22: "423410",
      "INDEX ITEM DESCRIPTION":
        "Charged coupled devices (CCD) merchant wholesalers",
    },
    {
      NAICS22: "423410",
      "INDEX ITEM DESCRIPTION":
        "Developing apparatus, photographic, merchant wholesalers",
    },
    {
      NAICS22: "423410",
      "INDEX ITEM DESCRIPTION": "Film developing equipment merchant wholesalers",
    },
    {
      NAICS22: "423410",
      "INDEX ITEM DESCRIPTION": "Film finishing equipment merchant wholesalers",
    },
    {
      NAICS22: "423410",
      "INDEX ITEM DESCRIPTION": "Film, camera, merchant wholesalers",
    },
    {
      NAICS22: "423410",
      "INDEX ITEM DESCRIPTION": "Film, photographic, merchant wholesalers",
    },
    {
      NAICS22: "423410",
      "INDEX ITEM DESCRIPTION": "Identity recorders merchant wholesalers",
    },
    {
      NAICS22: "423410",
      "INDEX ITEM DESCRIPTION":
        "Motion picture cameras, equipment, and supplies merchant wholesalers",
    },
    {
      NAICS22: "423410",
      "INDEX ITEM DESCRIPTION": "Photofinishing equipment merchant wholesalers",
    },
    {
      NAICS22: "423410",
      "INDEX ITEM DESCRIPTION":
        "Photographic equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423410",
      "INDEX ITEM DESCRIPTION":
        "Photographic film and plates merchant wholesalers",
    },
    {
      NAICS22: "423410",
      "INDEX ITEM DESCRIPTION":
        "Printmaking apparatus, photographic, merchant wholesalers",
    },
    {
      NAICS22: "423410",
      "INDEX ITEM DESCRIPTION":
        "Processing and finishing equipment, photographic, merchant wholesalers",
    },
    {
      NAICS22: "423410",
      "INDEX ITEM DESCRIPTION":
        "Projection equipment (e.g., motion picture, slide), photographic, merchant wholesalers",
    },
    {
      NAICS22: "423410",
      "INDEX ITEM DESCRIPTION": "Television cameras merchant wholesalers",
    },
    {
      NAICS22: "423410",
      "INDEX ITEM DESCRIPTION":
        "Theater equipment (except seats) merchant wholesalers",
    },
    {
      NAICS22: "423410",
      "INDEX ITEM DESCRIPTION":
        "Video cameras (except household-type) merchant wholesalers",
    },
    {
      NAICS22: "423410",
      "INDEX ITEM DESCRIPTION":
        "Wearable video cameras (except household-type) merchant wholesalers",
    },
    {
      NAICS22: "423420",
      "INDEX ITEM DESCRIPTION": "Accounting machines merchant wholesalers",
    },
    {
      NAICS22: "423420",
      "INDEX ITEM DESCRIPTION": "Addressing machines merchant wholesalers",
    },
    {
      NAICS22: "423420",
      "INDEX ITEM DESCRIPTION":
        "Automated teller machines (ATM) merchant wholesalers",
    },
    {
      NAICS22: "423420",
      "INDEX ITEM DESCRIPTION": "Bank equipment merchant wholesalers",
    },
    {
      NAICS22: "423420",
      "INDEX ITEM DESCRIPTION": "Blueprinting equipment merchant wholesalers",
    },
    {
      NAICS22: "423420",
      "INDEX ITEM DESCRIPTION": "Bookkeeping machines merchant wholesalers",
    },
    {
      NAICS22: "423420",
      "INDEX ITEM DESCRIPTION":
        "Business machines and equipment (except computers) merchant wholesalers",
    },
    {
      NAICS22: "423420",
      "INDEX ITEM DESCRIPTION":
        "Calculators and calculating machines merchant wholesalers",
    },
    {
      NAICS22: "423420",
      "INDEX ITEM DESCRIPTION": "Cash registers merchant wholesalers",
    },
    {
      NAICS22: "423420",
      "INDEX ITEM DESCRIPTION": "Check handling machines merchant wholesalers",
    },
    {
      NAICS22: "423420",
      "INDEX ITEM DESCRIPTION": "Coin sorting machines merchant wholesalers",
    },
    {
      NAICS22: "423420",
      "INDEX ITEM DESCRIPTION": "Copying machines merchant wholesalers",
    },
    {
      NAICS22: "423420",
      "INDEX ITEM DESCRIPTION": "Currency handling machines merchant wholesalers",
    },
    {
      NAICS22: "423420",
      "INDEX ITEM DESCRIPTION": "Dictating machines merchant wholesalers",
    },
    {
      NAICS22: "423420",
      "INDEX ITEM DESCRIPTION": "Forms handling machines merchant wholesalers",
    },
    {
      NAICS22: "423420",
      "INDEX ITEM DESCRIPTION": "Labeling machines merchant wholesalers",
    },
    {
      NAICS22: "423420",
      "INDEX ITEM DESCRIPTION":
        "Letter and envelope handling machines merchant wholesalers",
    },
    {
      NAICS22: "423420",
      "INDEX ITEM DESCRIPTION": "Machines, office, merchant wholesalers",
    },
    {
      NAICS22: "423420",
      "INDEX ITEM DESCRIPTION": "Mailing machines merchant wholesalers",
    },
    {
      NAICS22: "423420",
      "INDEX ITEM DESCRIPTION":
        "Microfilm equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423420",
      "INDEX ITEM DESCRIPTION": "Office equipment merchant wholesalers",
    },
    {
      NAICS22: "423420",
      "INDEX ITEM DESCRIPTION": "Office machines merchant wholesalers",
    },
    {
      NAICS22: "423420",
      "INDEX ITEM DESCRIPTION": "Paper shredders merchant wholesalers",
    },
    {
      NAICS22: "423420",
      "INDEX ITEM DESCRIPTION": "Perforating machines merchant wholesalers",
    },
    {
      NAICS22: "423420",
      "INDEX ITEM DESCRIPTION": "Point of sale terminals merchant wholesalers",
    },
    {
      NAICS22: "423420",
      "INDEX ITEM DESCRIPTION": "Postage meters merchant wholesalers",
    },
    {
      NAICS22: "423420",
      "INDEX ITEM DESCRIPTION": "Safes, security, merchant wholesalers",
    },
    {
      NAICS22: "423420",
      "INDEX ITEM DESCRIPTION": "Security safes merchant wholesalers",
    },
    {
      NAICS22: "423420",
      "INDEX ITEM DESCRIPTION": "Stapling machines merchant wholesalers",
    },
    {
      NAICS22: "423420",
      "INDEX ITEM DESCRIPTION": "Tape dispensing machines merchant wholesalers",
    },
    {
      NAICS22: "423420",
      "INDEX ITEM DESCRIPTION": "Time recording machines merchant wholesalers",
    },
    {
      NAICS22: "423420",
      "INDEX ITEM DESCRIPTION": "Typewriters merchant wholesalers",
    },
    {
      NAICS22: "423430",
      "INDEX ITEM DESCRIPTION": "Computer boards, loaded, merchant wholesalers",
    },
    {
      NAICS22: "423430",
      "INDEX ITEM DESCRIPTION":
        "Computer data storage devices merchant wholesalers",
    },
    {
      NAICS22: "423430",
      "INDEX ITEM DESCRIPTION":
        "Computer peripheral equipment merchant wholesalers",
    },
    {
      NAICS22: "423430",
      "INDEX ITEM DESCRIPTION": "Computer printers merchant wholesalers",
    },
    {
      NAICS22: "423430",
      "INDEX ITEM DESCRIPTION":
        "Computer software, packaged, merchant wholesalers",
    },
    {
      NAICS22: "423430",
      "INDEX ITEM DESCRIPTION": "Computer terminals merchant wholesalers",
    },
    {
      NAICS22: "423430",
      "INDEX ITEM DESCRIPTION": "Computers merchant wholesalers",
    },
    {
      NAICS22: "423430",
      "INDEX ITEM DESCRIPTION": "Data keying equipment merchant wholesalers",
    },
    {
      NAICS22: "423430",
      "INDEX ITEM DESCRIPTION":
        "Data processing machines, computer, merchant wholesalers",
    },
    {
      NAICS22: "423430",
      "INDEX ITEM DESCRIPTION":
        "Digitizer and light pen tables merchant wholesalers",
    },
    {
      NAICS22: "423430",
      "INDEX ITEM DESCRIPTION": "Disk drives, computer, merchant wholesalers",
    },
    {
      NAICS22: "423430",
      "INDEX ITEM DESCRIPTION": "Diskettes, blank computer, merchant wholesalers",
    },
    {
      NAICS22: "423430",
      "INDEX ITEM DESCRIPTION": "Font cartridges merchant wholesalers",
    },
    {
      NAICS22: "423430",
      "INDEX ITEM DESCRIPTION": "Game software merchant wholesalers",
    },
    {
      NAICS22: "423430",
      "INDEX ITEM DESCRIPTION": "Keyboards, computer, merchant wholesalers",
    },
    {
      NAICS22: "423430",
      "INDEX ITEM DESCRIPTION": "Loaded computer boards merchant wholesalers",
    },
    {
      NAICS22: "423430",
      "INDEX ITEM DESCRIPTION": "Memory boards merchant wholesalers",
    },
    {
      NAICS22: "423430",
      "INDEX ITEM DESCRIPTION": "Microprocessors merchant wholesalers",
    },
    {
      NAICS22: "423430",
      "INDEX ITEM DESCRIPTION":
        "Monitor screen projection devices merchant wholesalers",
    },
    {
      NAICS22: "423430",
      "INDEX ITEM DESCRIPTION": "Monitors, computer, merchant wholesalers",
    },
    {
      NAICS22: "423430",
      "INDEX ITEM DESCRIPTION": "Motherboards, loaded, merchant wholesalers",
    },
    {
      NAICS22: "423430",
      "INDEX ITEM DESCRIPTION":
        "Peripheral equipment, computer, merchant wholesalers",
    },
    {
      NAICS22: "423430",
      "INDEX ITEM DESCRIPTION": "Plotters merchant wholesalers",
    },
    {
      NAICS22: "423430",
      "INDEX ITEM DESCRIPTION": "Printers, computer, merchant wholesalers",
    },
    {
      NAICS22: "423430",
      "INDEX ITEM DESCRIPTION": "Scanners, computer, merchant wholesalers",
    },
    {
      NAICS22: "423430",
      "INDEX ITEM DESCRIPTION":
        "Software, computer, packaged, merchant wholesalers",
    },
    {
      NAICS22: "423430",
      "INDEX ITEM DESCRIPTION": "Sound boards, computer, merchant wholesalers",
    },
    {
      NAICS22: "423430",
      "INDEX ITEM DESCRIPTION":
        "USB flash drives (e.g., thumbdrives, jumpdrives) merchant wholesalers",
    },
    {
      NAICS22: "423430",
      "INDEX ITEM DESCRIPTION": "Video boards merchant wholesalers",
    },
    {
      NAICS22: "423430",
      "INDEX ITEM DESCRIPTION":
        "Voice recognition equipment merchant wholesalers",
    },
    {
      NAICS22: "423440",
      "INDEX ITEM DESCRIPTION":
        "Balances and scales (except laboratory) merchant wholesalers",
    },
    {
      NAICS22: "423440",
      "INDEX ITEM DESCRIPTION": "Bar equipment merchant wholesalers",
    },
    {
      NAICS22: "423440",
      "INDEX ITEM DESCRIPTION": "Chinaware, commercial, merchant wholesalers",
    },
    {
      NAICS22: "423440",
      "INDEX ITEM DESCRIPTION": "Coffee makers, commercial, merchant wholesalers",
    },
    {
      NAICS22: "423440",
      "INDEX ITEM DESCRIPTION":
        "Coin- or card-operated merchandising machine merchant wholesalers",
    },
    {
      NAICS22: "423440",
      "INDEX ITEM DESCRIPTION":
        "Coin- or card-operated phonographs and vending machines merchant wholesalers",
    },
    {
      NAICS22: "423440",
      "INDEX ITEM DESCRIPTION":
        "Cooking equipment, commercial, merchant wholesalers",
    },
    {
      NAICS22: "423440",
      "INDEX ITEM DESCRIPTION":
        "Cups, commercial (except paper and disposable plastics), merchant wholesalers",
    },
    {
      NAICS22: "423440",
      "INDEX ITEM DESCRIPTION":
        "Dishes, commercial (except paper and disposable plastics), merchant wholesalers",
    },
    {
      NAICS22: "423440",
      "INDEX ITEM DESCRIPTION":
        "Dishwashing equipment, commercial-type, merchant wholesalers",
    },
    {
      NAICS22: "423440",
      "INDEX ITEM DESCRIPTION":
        "Display cases (except refrigerated) merchant wholesalers",
    },
    {
      NAICS22: "423440",
      "INDEX ITEM DESCRIPTION": "Electrical signs merchant wholesalers",
    },
    {
      NAICS22: "423440",
      "INDEX ITEM DESCRIPTION":
        "Fixtures, store (except refrigerated), merchant wholesalers",
    },
    {
      NAICS22: "423440",
      "INDEX ITEM DESCRIPTION":
        "Food service equipment (except refrigerated), commercial, merchant wholesalers",
    },
    {
      NAICS22: "423440",
      "INDEX ITEM DESCRIPTION":
        "Garbage disposal units, commercial-type, merchant wholesalers",
    },
    {
      NAICS22: "423440",
      "INDEX ITEM DESCRIPTION":
        "Hotel equipment and supplies (except furniture) merchant wholesalers",
    },
    {
      NAICS22: "423440",
      "INDEX ITEM DESCRIPTION":
        "Kitchen appliances, commercial (except refrigerated), merchant wholesalers",
    },
    {
      NAICS22: "423440",
      "INDEX ITEM DESCRIPTION":
        "Kitchen utensils, commercial, merchant wholesalers",
    },
    {
      NAICS22: "423440",
      "INDEX ITEM DESCRIPTION":
        "Lockers (except refrigerated) merchant wholesalers",
    },
    {
      NAICS22: "423440",
      "INDEX ITEM DESCRIPTION": "Mannequins merchant wholesalers",
    },
    {
      NAICS22: "423440",
      "INDEX ITEM DESCRIPTION":
        "Merchandising machines, coin- or card-operated, merchant wholesalers",
    },
    {
      NAICS22: "423440",
      "INDEX ITEM DESCRIPTION":
        "Microwave ovens, commercial, merchant wholesalers",
    },
    {
      NAICS22: "423440",
      "INDEX ITEM DESCRIPTION": "Ovens, commercial-type, merchant wholesalers",
    },
    {
      NAICS22: "423440",
      "INDEX ITEM DESCRIPTION": "Pans, commercial, merchant wholesalers",
    },
    {
      NAICS22: "423440",
      "INDEX ITEM DESCRIPTION": "Partitions merchant wholesalers",
    },
    {
      NAICS22: "423440",
      "INDEX ITEM DESCRIPTION":
        "Phonographs, coin- or card-operated, merchant wholesalers",
    },
    {
      NAICS22: "423440",
      "INDEX ITEM DESCRIPTION":
        "Restaurant equipment (except furniture) merchant wholesalers",
    },
    {
      NAICS22: "423440",
      "INDEX ITEM DESCRIPTION": "Shelving, commercial, merchant wholesalers",
    },
    {
      NAICS22: "423440",
      "INDEX ITEM DESCRIPTION":
        "Showcases (except refrigerated) merchant wholesalers",
    },
    {
      NAICS22: "423440",
      "INDEX ITEM DESCRIPTION": "Signs, electrical, merchant wholesalers",
    },
    {
      NAICS22: "423440",
      "INDEX ITEM DESCRIPTION":
        "Soda fountain fixtures (except refrigerated) merchant wholesalers",
    },
    {
      NAICS22: "423440",
      "INDEX ITEM DESCRIPTION":
        "Store equipment (except furniture) merchant wholesalers",
    },
    {
      NAICS22: "423440",
      "INDEX ITEM DESCRIPTION":
        "Store fixtures (except refrigerated) merchant wholesalers",
    },
    {
      NAICS22: "423440",
      "INDEX ITEM DESCRIPTION": "Vending machines merchant wholesalers",
    },
    {
      NAICS22: "423440",
      "INDEX ITEM DESCRIPTION": "Window display equipment merchant wholesalers",
    },
    {
      NAICS22: "423440",
      "INDEX ITEM DESCRIPTION": "Woodenware, commercial, merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION": "Appliances, surgical, merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION": "Artificial limbs merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION": "Beds, hospital, merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION": "Crutches merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION": "Dental chairs merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION":
        "Dental equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION":
        "Dentists' professional supplies merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION":
        "Diagnostic equipment, medical, merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION": "Dressings, medical, merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION": "Electromedical equipment merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION":
        "First-aid kits (except household) merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION": "Glassware, medical, merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION": "Hearing aids merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION": "Home health care supplies merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION": "Hospital beds merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION":
        "Hospital equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION": "Hospital furniture merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION": "Hospital gowns merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION":
        "Instruments, dental and medical, merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION":
        "Laboratory equipment, dental and medical, merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION": "Medical equipment merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION": "Medical furniture merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION": "Medical glassware merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION": "Medical instruments merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION":
        "Medical supplies (except household first-aid kits and nonsurgical bandages) merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION":
        "Orthopedic equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION":
        "Patient monitoring equipment merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION":
        "Physicians' equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION":
        "Prosthetic appliances and supplies merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION": "Surgical and medical masks merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION": "Surgical appliances merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION": "Surgical dressings merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION":
        "Surgical instruments and apparatus merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION": "Surgical supplies merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION": "Surgical towels merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION":
        "Tapes, medical and surgical, merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION": "Teeth, dental, merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION": "Therapy equipment merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION": "Thermometers merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION": "Towels, surgical, merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION":
        "Ultrasound equipment, medical, merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION": "Wheelchairs merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION": "Whirlpool baths, hospital, merchant wholesalers",
    },
    {
      NAICS22: "423450",
      "INDEX ITEM DESCRIPTION":
        "X-ray machines and parts, medical and dental, merchant wholesalers",
    },
    {
      NAICS22: "423460",
      "INDEX ITEM DESCRIPTION": "Binoculars merchant wholesalers",
    },
    {
      NAICS22: "423460",
      "INDEX ITEM DESCRIPTION": "Contact lenses merchant wholesalers",
    },
    {
      NAICS22: "423460",
      "INDEX ITEM DESCRIPTION": "Eyeglasses merchant wholesalers",
    },
    {
      NAICS22: "423460",
      "INDEX ITEM DESCRIPTION": "Frames, ophthalmic, merchant wholesalers",
    },
    {
      NAICS22: "423460",
      "INDEX ITEM DESCRIPTION": "Glasses, optical, merchant wholesalers",
    },
    {
      NAICS22: "423460",
      "INDEX ITEM DESCRIPTION": "Lens blanks, ophthalmic, merchant wholesalers",
    },
    {
      NAICS22: "423460",
      "INDEX ITEM DESCRIPTION": "Lenses, optical, merchant wholesalers",
    },
    {
      NAICS22: "423460",
      "INDEX ITEM DESCRIPTION": "Magnifying glasses merchant wholesalers",
    },
    {
      NAICS22: "423460",
      "INDEX ITEM DESCRIPTION":
        "Ophthalmic goods (except cameras) merchant wholesalers",
    },
    {
      NAICS22: "423460",
      "INDEX ITEM DESCRIPTION":
        "Optical goods (except cameras) merchant wholesalers",
    },
    {
      NAICS22: "423460",
      "INDEX ITEM DESCRIPTION":
        "Optometric equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423460",
      "INDEX ITEM DESCRIPTION":
        "Professional equipment and supplies, optical, merchant wholesalers",
    },
    {
      NAICS22: "423460",
      "INDEX ITEM DESCRIPTION": "Sunglasses merchant wholesalers",
    },
    {
      NAICS22: "423490",
      "INDEX ITEM DESCRIPTION":
        "Analytical instruments (e.g., chromatographic, photometers, spectrographs) merchant wholesalers",
    },
    {
      NAICS22: "423490",
      "INDEX ITEM DESCRIPTION":
        "Architects' equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423490",
      "INDEX ITEM DESCRIPTION":
        "Balances and scales, laboratory (except dental, medical), merchant wholesalers",
    },
    {
      NAICS22: "423490",
      "INDEX ITEM DESCRIPTION": "Barometers merchant wholesalers",
    },
    {
      NAICS22: "423490",
      "INDEX ITEM DESCRIPTION": "Blackboards merchant wholesalers",
    },
    {
      NAICS22: "423490",
      "INDEX ITEM DESCRIPTION":
        "Chemical and technical pottery products merchant wholesalers",
    },
    {
      NAICS22: "423490",
      "INDEX ITEM DESCRIPTION":
        "Church supplies (except plated ware, silverware) merchant wholesalers",
    },
    {
      NAICS22: "423490",
      "INDEX ITEM DESCRIPTION": "Drafting instruments merchant wholesalers",
    },
    {
      NAICS22: "423490",
      "INDEX ITEM DESCRIPTION": "Drafting tables merchant wholesalers",
    },
    {
      NAICS22: "423490",
      "INDEX ITEM DESCRIPTION":
        "Engineers' equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423490",
      "INDEX ITEM DESCRIPTION":
        "Instruments, professional and scientific, merchant wholesalers",
    },
    {
      NAICS22: "423490",
      "INDEX ITEM DESCRIPTION":
        "Laboratory equipment (except dental, medical, ophthalmic) merchant wholesalers",
    },
    {
      NAICS22: "423490",
      "INDEX ITEM DESCRIPTION":
        "Professional equipment and supplies (except dental, medical, ophthalmic) merchant wholesalers",
    },
    {
      NAICS22: "423490",
      "INDEX ITEM DESCRIPTION":
        "Professional furniture (except dental, metal, ophthalmic, and school) merchant wholesalers",
    },
    {
      NAICS22: "423490",
      "INDEX ITEM DESCRIPTION": "Professional instruments merchant wholesalers",
    },
    {
      NAICS22: "423490",
      "INDEX ITEM DESCRIPTION": "Religious supplies merchant wholesalers",
    },
    {
      NAICS22: "423490",
      "INDEX ITEM DESCRIPTION":
        "Scales, laboratory (except dental and medical), merchant wholesalers",
    },
    {
      NAICS22: "423490",
      "INDEX ITEM DESCRIPTION":
        "School equipment and supplies (except books, furniture) merchant wholesalers",
    },
    {
      NAICS22: "423490",
      "INDEX ITEM DESCRIPTION": "Scientific instruments merchant wholesalers",
    },
    {
      NAICS22: "423490",
      "INDEX ITEM DESCRIPTION":
        "Scientific laboratory equipment merchant wholesalers",
    },
    {
      NAICS22: "423490",
      "INDEX ITEM DESCRIPTION": "Smartboards merchant wholesalers",
    },
    {
      NAICS22: "423490",
      "INDEX ITEM DESCRIPTION": "Statuary, religious, merchant wholesalers",
    },
    {
      NAICS22: "423490",
      "INDEX ITEM DESCRIPTION":
        "Surveying equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423490",
      "INDEX ITEM DESCRIPTION":
        "Teaching machines (except computers), electronic, merchant wholesalers",
    },
    {
      NAICS22: "423490",
      "INDEX ITEM DESCRIPTION": "Vestments, religious, merchant wholesalers",
    },
    {
      NAICS22: "423490",
      "INDEX ITEM DESCRIPTION":
        "Veterinarians' equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423490",
      "INDEX ITEM DESCRIPTION": "Wall maps merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION":
        "Aluminum and aluminum alloy primary forms merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION":
        "Aluminum foil, plate, sheet, coil, and roll products merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION":
        "Bars, metal (except precious), merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Bearing piles, metal, merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Billets, metal, merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Black plate merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Blooms, metal, merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION":
        "Cable, wire (except insulated), merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION":
        "Carbon and alloy steel primary forms merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Cast iron pipe merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Castings, metal, merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Concrete reinforcing bars merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION":
        "Copper and copper alloy primary forms merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Ferroalloys merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Ferrous metals merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Forgings, metal, merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Foundry products merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION":
        "Galvanized iron and steel products merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Grinding balls merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Ingots (except precious) merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Lead primary forms merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Metal pipe merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION":
        "Metal products (e.g., bars, ingots, plates, rods, shapes, sheets) merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Metals sales offices",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Metals service centers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION":
        "Metals, ferrous and nonferrous, merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Nails merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION":
        "Nickel and nickel alloy primary forms merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION":
        "Nonferrous metals (except precious) merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Noninsulated wire merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Pig iron merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Pilings, metal, merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Pipe, metal, merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Poles, metal, merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Posts, metal, merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION":
        "Rails and accessories, metal, merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION":
        "Reinforcement mesh and wire merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION":
        "Rods, metal (except precious), merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION":
        "Ropes, wire (except insulated), merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION":
        "Semi-finished metal products merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Sewer pipe, metal, merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Spikes, metal, merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Springs, steel, merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Stainless steel merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Steel merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION":
        "Steel wire cloth (screening) merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Steel wool merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Storage tanks, metal, merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION":
        "Strips, metal (except precious), merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION":
        "Structural assemblies, metal, merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Tanks, storage metal, merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Terneplate merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION":
        "Tin and tin alloy primary forms merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Tin plate merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Tubing, metal, merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Wire (except insulated) merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION":
        "Wire and cable (except electrical) merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION":
        "Wire rope (except insulated) merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION": "Wire screening merchant wholesalers",
    },
    {
      NAICS22: "423510",
      "INDEX ITEM DESCRIPTION":
        "Zinc and zinc alloy primary forms merchant wholesalers",
    },
    {
      NAICS22: "423520",
      "INDEX ITEM DESCRIPTION": "Bauxite merchant wholesalers",
    },
    {
      NAICS22: "423520",
      "INDEX ITEM DESCRIPTION": "Coal dust merchant wholesalers",
    },
    {
      NAICS22: "423520",
      "INDEX ITEM DESCRIPTION": "Coal merchant wholesalers",
    },
    {
      NAICS22: "423520",
      "INDEX ITEM DESCRIPTION": "Coke merchant wholesalers",
    },
    {
      NAICS22: "423520",
      "INDEX ITEM DESCRIPTION": "Concentrates, metallic, merchant wholesalers",
    },
    {
      NAICS22: "423520",
      "INDEX ITEM DESCRIPTION": "Fuel, coal and coke, merchant wholesalers",
    },
    {
      NAICS22: "423520",
      "INDEX ITEM DESCRIPTION": "Fuller's earth merchant wholesalers",
    },
    {
      NAICS22: "423520",
      "INDEX ITEM DESCRIPTION": "Magnesium ores merchant wholesalers",
    },
    {
      NAICS22: "423520",
      "INDEX ITEM DESCRIPTION": "Metal ores merchant wholesalers",
    },
    {
      NAICS22: "423520",
      "INDEX ITEM DESCRIPTION": "Metallic concentrates merchant wholesalers",
    },
    {
      NAICS22: "423520",
      "INDEX ITEM DESCRIPTION":
        "Minerals (except construction materials, petroleum) merchant wholesalers",
    },
    {
      NAICS22: "423520",
      "INDEX ITEM DESCRIPTION":
        "Nonmetallic minerals (except precious and semiprecious stones and minerals used in construction, such as sand and gravel)",
    },
    {
      NAICS22: "423520",
      "INDEX ITEM DESCRIPTION": "Nonmetallic ores merchant wholesalers",
    },
    {
      NAICS22: "423520",
      "INDEX ITEM DESCRIPTION": "Ore concentrates merchant wholesalers",
    },
    {
      NAICS22: "423520",
      "INDEX ITEM DESCRIPTION":
        "Ores (e.g., gold, iron, lead, silver, zinc) merchant wholesalers",
    },
    {
      NAICS22: "423520",
      "INDEX ITEM DESCRIPTION": "Precious metal ores merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION": "Alarm apparatus, electric, merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION":
        "Batteries (except automotive) merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION":
        "Boxes and fittings, electrical, merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION": "Bus bars and trolley ducts merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION":
        "Capacitors (except electronic) merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION": "Circuit breakers merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION": "Coaxial cable merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION":
        "Conduit, electric wire and cable, merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION":
        "Conduits and raceways, electrical, merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION": "Connectors, electrical, merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION":
        "Construction materials, electrical, merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION":
        "Current-carrying wiring devices merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION":
        "Distribution equipment, electrical, merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION": "Electric light fixtures merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION":
        "Electric motors, wiring supplies, and lighting fixtures merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION": "Electric prime movers merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION": "Electrical apparatus merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION":
        "Fastening devices, electrical, merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION": "Fittings, electrical, merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION":
        "Fixtures, electric lighting, merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION": "Flashlights merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION": "Fuses, electric, merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION":
        "Generators, electrical (except motor vehicle), merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION":
        "Hanging devices, electrical, merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION":
        "Hardware, transmission pole and line, merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION":
        "Industrial controls, electrical, merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION":
        "Instruments, electric measuring, merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION": "Insulated wire or cable merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION": "Insulators, electrical, merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION": "Light bulbs merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION":
        "Lighting fixtures, electric, merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION": "Lightning arrestors merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION":
        "Lugs and connectors, electrical, merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION": "Meters, electrical, merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION": "Motor controls, electric, merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION": "Motors, electric, merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION":
        "Panelboards, electric power distribution, merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION": "Pole line hardware merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION":
        "Power transmission equipment, electrical, merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION": "Receptacles, electrical, merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION":
        "Regulators, voltage (except motor vehicle), merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION": "Relays merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION": "Security systems merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION": "Signal systems and devices merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION":
        "Storage batteries (except automotive) merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION":
        "Switchboards, electrical distribution, merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION": "Switches, electrical, merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION":
        "Transformers (except electronic) merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION":
        "Transmission equipment, electrical, merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION":
        "Unit substations, electrical, merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION":
        "Voltage regulators (except motor vehicle) merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION": "Wire, insulated, merchant wholesalers",
    },
    {
      NAICS22: "423610",
      "INDEX ITEM DESCRIPTION": "Wiring supplies merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION": "Air-conditioners, room, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION":
        "Appliances, household-type (except water heaters, heating stoves (i.e., noncooking)), gas and electric, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION":
        "Audio equipment, household-type, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION": "Automotive radios merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION": "Blankets, electric, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION": "Clothes dryers merchant wholesalers ",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION":
        "Coffee makers, household-type, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION": "Compact disc players merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION": "Consumer electronics merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION":
        "Cooking equipment, gas and electric, household-type, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION": "Curling irons, electric, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION":
        "Digital video disc (DVD) players merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION":
        "Dishwashers, household-type, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION": "Dryers, clothes, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION": "Dryers, hair, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION": "Electric blankets merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION": "Fans, household-type, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION": "Freezers, household-type, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION":
        "Garbage disposal units, household-type, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION": "Hair dryers, personal, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION":
        "Heaters, portable electric, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION":
        "Household-type appliances (except water heaters, heating stoves (i.e., noncooking)), gas and electric, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION":
        "Household-type laundry equipment (e.g., dryers, washers) merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION":
        "Housewares, gas and electric, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION":
        "Humidifiers and dehumidifiers, portable, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION":
        "Insect control devices, electric, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION":
        "Irons, household-type, electric, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION":
        "Kitchen appliances, household-type, gas and electric, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION":
        "Laundry machinery and equipment, household-type (e.g., dryers, washers), merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION":
        "Microwave ovens, household-type, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION": "Movie apparatus, home, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION": "Outdoor grills merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION":
        "Ovens, gas and electric, household-type, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION":
        "Personal care appliances, electric, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION": "Radios, household-type, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION": "Ranges, gas and electric, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION": "Razors, electric, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION":
        "Recorders (e.g., tape, video), household-type, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION":
        "Refrigerators, household-type, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION": "Room air-conditioners merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION":
        "Sewing machines, household-type, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION":
        "Smoke detectors, household-type, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION":
        "Sound equipment, household-type, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION": "Speaker systems merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION": "Stereo equipment merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION":
        "Stoves, cooking, household-type, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION":
        "Tape players and recorders, household-type, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION":
        "Telephone answering machines merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION": "Television sets merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION": "Toasters, electric, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION": "Toothbrushes, electric, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION":
        "Trail video cameras, household-type, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION":
        "Trash compactors, household-type, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION":
        "Vacuum cleaners, household-type, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION":
        "Video cameras, household-type, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION":
        "Washing machines, household-type, merchant wholesalers",
    },
    {
      NAICS22: "423620",
      "INDEX ITEM DESCRIPTION":
        "Wearable video cameras, household-type, merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION":
        "Amplifiers, audio (except household-type), merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Antennas merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Audiotapes, blank, merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION":
        "Automatic call distributors merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Bipolar transistors merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Blank CDs and DVDs merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Blank diskettes merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION":
        "Blank tapes, audio and video, merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Broadcasting equipment merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Capacitors, electronic, merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION":
        "Carbon monoxide detectors, electronic, merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Cellular telephones merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Circuit boards merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Circuits, integrated, merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Citizens' band (CB) radios merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Coils, electronic, merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Communications equipment merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Computer boards, unloaded, merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Computer chips merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Condensers, electronic, merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Connectors, electronic, merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Diodes merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Diskettes, blank, merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION":
        "Electronic aircraft instruments merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION":
        "Electronic communications equipment merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION":
        "Electronic parts (e.g., condensers, connectors, switches) merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION":
        "Electronic sound equipment (except household-type and automotive) merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION":
        "Electronic tubes (e.g., industrial, receiving, transmitting) merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Facsimile machines merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Integrated circuits merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Klystron tubes merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Liquid crystal displays merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Magnetic bubble memories merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION":
        "Magnetic tapes, cassettes, and disks, blank, merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Modems merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION":
        "Natural gas detectors, electronic, merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION":
        "Navigational instruments, electronic (e.g., radar, sonar), merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Printed circuit boards merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION":
        "Public address systems and equipment merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Radar equipment merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION":
        "Radio frequency identification (RFID) equipment merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION":
        "Radio parts and accessories (e.g., transistors, tubes) merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION":
        "Radios (except household-type) merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION":
        "Random access memory (RAM) chips merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Rectifiers, electronic, merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Resistors, electronic, merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Routers merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Semiconductor devices merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Smartphones merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Smartwatches merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Solar cells merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Sonar equipment merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Switches, electronic, merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION":
        "Tapes, blank, audio and video, merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION":
        "Telecommunications equipment merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION":
        "Teleconferencing equipment, audio or video, merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Telegraph equipment merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Telephone equipment merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Telephones merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION":
        "Touch-screen displays (except computer monitors) merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Transformers, electronic, merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Transistors merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Transmitters merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION":
        "Tubes, electronic (e.g., industrial, receiving, transmitting), merchant wholesalers",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Unloaded computer boards merchant wholesalers ",
    },
    {
      NAICS22: "423690",
      "INDEX ITEM DESCRIPTION": "Video tapes, blank, merchant wholesalers",
    },
    {
      NAICS22: "423710",
      "INDEX ITEM DESCRIPTION": "Appliance hardware merchant wholesalers",
    },
    {
      NAICS22: "423710",
      "INDEX ITEM DESCRIPTION": "Blades (e.g., knife, saw) merchant wholesalers",
    },
    {
      NAICS22: "423710",
      "INDEX ITEM DESCRIPTION":
        "Bolts, nuts, rivets, screws, and other fasteners merchant wholesalers",
    },
    {
      NAICS22: "423710",
      "INDEX ITEM DESCRIPTION": "Brads merchant wholesalers",
    },
    {
      NAICS22: "423710",
      "INDEX ITEM DESCRIPTION":
        "Cabinet hardware and fittings merchant wholesalers",
    },
    {
      NAICS22: "423710",
      "INDEX ITEM DESCRIPTION": "Carpenters' tools merchant wholesalers",
    },
    {
      NAICS22: "423710",
      "INDEX ITEM DESCRIPTION": "Cutlery merchant wholesalers",
    },
    {
      NAICS22: "423710",
      "INDEX ITEM DESCRIPTION": "Drapery hardware merchant wholesalers",
    },
    {
      NAICS22: "423710",
      "INDEX ITEM DESCRIPTION":
        "Fasteners (e.g., bolts, nuts, rivets, screws) merchant wholesalers",
    },
    {
      NAICS22: "423710",
      "INDEX ITEM DESCRIPTION":
        "Handtools (except motor vehicle mechanics', machinists' precision) merchant wholesalers",
    },
    {
      NAICS22: "423710",
      "INDEX ITEM DESCRIPTION":
        "Hardware (except motor vehicle) merchant wholesalers",
    },
    {
      NAICS22: "423710",
      "INDEX ITEM DESCRIPTION": "Hinges merchant wholesalers",
    },
    {
      NAICS22: "423710",
      "INDEX ITEM DESCRIPTION": "Keys and locks merchant wholesalers",
    },
    {
      NAICS22: "423710",
      "INDEX ITEM DESCRIPTION":
        "Knives (except disposable plastics) merchant wholesalers",
    },
    {
      NAICS22: "423710",
      "INDEX ITEM DESCRIPTION": "Locks, security, merchant wholesalers",
    },
    {
      NAICS22: "423710",
      "INDEX ITEM DESCRIPTION":
        "Plumbers' tools and equipment merchant wholesalers",
    },
    {
      NAICS22: "423710",
      "INDEX ITEM DESCRIPTION":
        "Power handtools (e.g., drills, sanders, saws) merchant wholesalers",
    },
    {
      NAICS22: "423710",
      "INDEX ITEM DESCRIPTION": "Specialty-line hardware merchant wholesalers",
    },
    {
      NAICS22: "423710",
      "INDEX ITEM DESCRIPTION": "Staples merchant wholesalers",
    },
    {
      NAICS22: "423710",
      "INDEX ITEM DESCRIPTION": "Tacks merchant wholesalers",
    },
    {
      NAICS22: "423710",
      "INDEX ITEM DESCRIPTION":
        "Tools, hand (except motor vehicle, machinists' precision tools), merchant wholesalers",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION": "Bathtubs merchant wholesalers",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION":
        "Boilers (e.g., heating, hot water, power, steam) merchant wholesalers",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION": "Brass goods, plumbers', merchant wholesalers",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION":
        "Burners, fuel oil and distillate oil, merchant wholesalers",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION": "Convectors merchant wholesalers",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION":
        "Drinking fountains (except refrigerated) merchant wholesalers",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION": "Fireplaces, gas, merchant wholesalers",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION":
        "Fireplaces, prefabricated gas, merchant wholesalers",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION":
        "Fittings and valves, plumbers', merchant wholesalers",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION":
        "Fountains, drinking (except refrigerated), merchant wholesalers",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION":
        "Furnaces (except forced air), heating, merchant wholesalers",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION": "Gas fireplaces merchant wholesalers",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION": "Gas hot water heaters merchant wholesalers",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION":
        "Heating boilers, steam and hot water, merchant wholesalers",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION":
        "Heating equipment, hot water, merchant wholesalers",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION":
        "Hydronic heating equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION": "Lavatory fixtures merchant wholesalers",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION": "Oil burners, heating, merchant wholesalers",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION": "Pipe and boiler coverings merchant wholesalers",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION":
        "Pipe fittings and valves, plumbers', merchant wholesalers",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION": "Plumbers' brass goods merchant wholesalers",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION":
        "Plumbing and heating valves merchant wholesalers",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION": "Plumbing equipment merchant wholesalers",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION": "Plumbing fixtures merchant wholesalers",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION": "Plumbing supplies merchant wholesalers",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION":
        "Radiators, heating, nonelectric, merchant wholesalers",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION":
        "Sanitary ware, china or enameled iron, merchant wholesalers",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION": "Sinks merchant wholesalers",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION":
        "Solar heating panels and equipment merchant wholesalers",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION": "Spa equipment merchant wholesalers",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION":
        "Stoves (i.e., noncooking), heating, merchant wholesalers",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION": "Toilet bowls and tanks merchant wholesalers",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION": "Urinals merchant wholesalers",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION":
        "Valves, plumbing and heating, merchant wholesalers",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION":
        "Water heaters, gas and electric, merchant wholesaler",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION":
        "Water purification equipment, household-type, merchant wholesalers",
    },
    {
      NAICS22: "423720",
      "INDEX ITEM DESCRIPTION":
        "Water softening and conditioning equipment merchant wholesalers",
    },
    {
      NAICS22: "423730",
      "INDEX ITEM DESCRIPTION":
        "Air pollution control equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423730",
      "INDEX ITEM DESCRIPTION":
        "Air-conditioning equipment (except room units) merchant wholesalers",
    },
    {
      NAICS22: "423730",
      "INDEX ITEM DESCRIPTION":
        "Automotive air-conditioners merchant wholesalers",
    },
    {
      NAICS22: "423730",
      "INDEX ITEM DESCRIPTION":
        "Baseboard heaters, electric, nonportable, merchant wholesalers",
    },
    {
      NAICS22: "423730",
      "INDEX ITEM DESCRIPTION":
        "Central heating equipment, warm air, merchant wholesalers",
    },
    {
      NAICS22: "423730",
      "INDEX ITEM DESCRIPTION":
        "Compressors, air-conditioning, merchant wholesalers",
    },
    {
      NAICS22: "423730",
      "INDEX ITEM DESCRIPTION":
        "Condensing units, air-conditioning, merchant wholesalers",
    },
    {
      NAICS22: "423730",
      "INDEX ITEM DESCRIPTION":
        "Cooling equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423730",
      "INDEX ITEM DESCRIPTION":
        "Ductless heating and air-conditioning system equipment merchant wholesalers",
    },
    {
      NAICS22: "423730",
      "INDEX ITEM DESCRIPTION": "Dust collection equipment merchant wholesalers",
    },
    {
      NAICS22: "423730",
      "INDEX ITEM DESCRIPTION":
        "Furnaces, warm air (i.e., forced air), merchant wholesalers",
    },
    {
      NAICS22: "423730",
      "INDEX ITEM DESCRIPTION": "Heat pumps merchant wholesalers",
    },
    {
      NAICS22: "423730",
      "INDEX ITEM DESCRIPTION":
        "Heating equipment, warm air (i.e. forced air), merchant wholesalers",
    },
    {
      NAICS22: "423730",
      "INDEX ITEM DESCRIPTION":
        "Humidifiers and dehumidifiers (except portable) merchant wholesalers",
    },
    {
      NAICS22: "423730",
      "INDEX ITEM DESCRIPTION": "HVAC equipment merchant wholesalers",
    },
    {
      NAICS22: "423730",
      "INDEX ITEM DESCRIPTION":
        "Pollution control equipment, air, merchant wholesalers",
    },
    {
      NAICS22: "423730",
      "INDEX ITEM DESCRIPTION":
        "Sheet metal duct work (heating and air-conditioning) merchant wholesalers",
    },
    {
      NAICS22: "423730",
      "INDEX ITEM DESCRIPTION":
        "Ventilating equipment and supplies (except household-type fans) merchant wholesalers",
    },
    {
      NAICS22: "423730",
      "INDEX ITEM DESCRIPTION": "Warm air heating equipment merchant wholesalers",
    },
    {
      NAICS22: "423740",
      "INDEX ITEM DESCRIPTION":
        "Beverage coolers, mechanical, merchant wholesalers",
    },
    {
      NAICS22: "423740",
      "INDEX ITEM DESCRIPTION": "Cold storage machinery merchant wholesalers",
    },
    {
      NAICS22: "423740",
      "INDEX ITEM DESCRIPTION":
        "Compressors, refrigeration, merchant wholesalers",
    },
    {
      NAICS22: "423740",
      "INDEX ITEM DESCRIPTION":
        "Condensing units, refrigeration, merchant wholesalers",
    },
    {
      NAICS22: "423740",
      "INDEX ITEM DESCRIPTION": "Coolers, mechanical, merchant wholesalers",
    },
    {
      NAICS22: "423740",
      "INDEX ITEM DESCRIPTION":
        "Display cases, refrigerated, merchant wholesalers",
    },
    {
      NAICS22: "423740",
      "INDEX ITEM DESCRIPTION":
        "Drinking fountains, refrigerated, merchant wholesalers",
    },
    {
      NAICS22: "423740",
      "INDEX ITEM DESCRIPTION": "Fixtures, refrigerated, merchant wholesalers",
    },
    {
      NAICS22: "423740",
      "INDEX ITEM DESCRIPTION":
        "Fountains, drinking, refrigerated, merchant wholesalers",
    },
    {
      NAICS22: "423740",
      "INDEX ITEM DESCRIPTION": "Freezers, commercial-type, merchant wholesalers",
    },
    {
      NAICS22: "423740",
      "INDEX ITEM DESCRIPTION": "Ice making machines merchant wholesalers",
    },
    {
      NAICS22: "423740",
      "INDEX ITEM DESCRIPTION": "Lockers, refrigerated, merchant wholesalers",
    },
    {
      NAICS22: "423740",
      "INDEX ITEM DESCRIPTION": "Refrigerated display cases merchant wholesalers",
    },
    {
      NAICS22: "423740",
      "INDEX ITEM DESCRIPTION":
        "Refrigeration equipment and supplies, commercial-type, merchant wholesalers",
    },
    {
      NAICS22: "423740",
      "INDEX ITEM DESCRIPTION":
        "Refrigeration units, motor vehicle, merchant wholesalers",
    },
    {
      NAICS22: "423740",
      "INDEX ITEM DESCRIPTION":
        "Refrigerators (e.g., reach-in, walk-in), commercial-type, merchant wholesalers",
    },
    {
      NAICS22: "423740",
      "INDEX ITEM DESCRIPTION": "Showcases, refrigerated, merchant wholesalers",
    },
    {
      NAICS22: "423740",
      "INDEX ITEM DESCRIPTION":
        "Soda fountain fixtures, refrigerated, merchant wholesalers",
    },
    {
      NAICS22: "423740",
      "INDEX ITEM DESCRIPTION": "Water coolers, mechanical, merchant wholesalers",
    },
    {
      NAICS22: "423810",
      "INDEX ITEM DESCRIPTION":
        "Concrete processing equipment merchant wholesalers",
    },
    {
      NAICS22: "423810",
      "INDEX ITEM DESCRIPTION":
        "Construction machinery and equipment merchant wholesalers",
    },
    {
      NAICS22: "423810",
      "INDEX ITEM DESCRIPTION": "Cranes (except industrial) merchant wholesalers",
    },
    {
      NAICS22: "423810",
      "INDEX ITEM DESCRIPTION": "Cranes, mining, merchant wholesalers",
    },
    {
      NAICS22: "423810",
      "INDEX ITEM DESCRIPTION":
        "Crushing, pulverizing, and screening machinery, construction and mining, merchant wholesalers",
    },
    {
      NAICS22: "423810",
      "INDEX ITEM DESCRIPTION": "Dredges (except ships') merchant wholesalers",
    },
    {
      NAICS22: "423810",
      "INDEX ITEM DESCRIPTION":
        "Excavating machinery and equipment merchant wholesalers",
    },
    {
      NAICS22: "423810",
      "INDEX ITEM DESCRIPTION":
        "Forestry machinery and equipment merchant wholesalers",
    },
    {
      NAICS22: "423810",
      "INDEX ITEM DESCRIPTION":
        "Land preparation machinery, construction, merchant wholesalers",
    },
    {
      NAICS22: "423810",
      "INDEX ITEM DESCRIPTION": "Loaders merchant wholesalers",
    },
    {
      NAICS22: "423810",
      "INDEX ITEM DESCRIPTION": "Logging equipment merchant wholesalers",
    },
    {
      NAICS22: "423810",
      "INDEX ITEM DESCRIPTION": "Mining cranes merchant wholesalers",
    },
    {
      NAICS22: "423810",
      "INDEX ITEM DESCRIPTION":
        "Mining machinery and equipment (except petroleum) merchant wholesalers",
    },
    {
      NAICS22: "423810",
      "INDEX ITEM DESCRIPTION":
        "Mixers, construction and mining, merchant wholesalers",
    },
    {
      NAICS22: "423810",
      "INDEX ITEM DESCRIPTION": "Pavers merchant wholesalers",
    },
    {
      NAICS22: "423810",
      "INDEX ITEM DESCRIPTION":
        "Quarrying machinery and equipment merchant wholesalers",
    },
    {
      NAICS22: "423810",
      "INDEX ITEM DESCRIPTION":
        "Road construction and maintenance machinery merchant wholesalers",
    },
    {
      NAICS22: "423810",
      "INDEX ITEM DESCRIPTION": "Scaffolding merchant wholesalers",
    },
    {
      NAICS22: "423810",
      "INDEX ITEM DESCRIPTION": "Shovels, power, merchant wholesalers",
    },
    {
      NAICS22: "423810",
      "INDEX ITEM DESCRIPTION": "Snow plows merchant wholesalers",
    },
    {
      NAICS22: "423810",
      "INDEX ITEM DESCRIPTION":
        "Snowblowers (except household-type) merchant wholesalers",
    },
    {
      NAICS22: "423810",
      "INDEX ITEM DESCRIPTION":
        "Street sweeping and cleaning equipment merchant wholesalers",
    },
    {
      NAICS22: "423820",
      "INDEX ITEM DESCRIPTION": "Agricultural implements merchant wholesalers",
    },
    {
      NAICS22: "423820",
      "INDEX ITEM DESCRIPTION":
        "Agricultural machinery and equipment merchant wholesalers",
    },
    {
      NAICS22: "423820",
      "INDEX ITEM DESCRIPTION": "Blowers, snow and leaf, merchant wholesalers",
    },
    {
      NAICS22: "423820",
      "INDEX ITEM DESCRIPTION": "Combines merchant wholesalers",
    },
    {
      NAICS22: "423820",
      "INDEX ITEM DESCRIPTION": "Conveying equipment, farm, merchant wholesalers",
    },
    {
      NAICS22: "423820",
      "INDEX ITEM DESCRIPTION":
        "Crop preparation machinery (e.g., cleaning, conditioning, drying) merchant wholesalers",
    },
    {
      NAICS22: "423820",
      "INDEX ITEM DESCRIPTION":
        "Cultivating machinery and equipment merchant wholesalers",
    },
    {
      NAICS22: "423820",
      "INDEX ITEM DESCRIPTION":
        "Farm machinery and equipment merchant wholesalers",
    },
    {
      NAICS22: "423820",
      "INDEX ITEM DESCRIPTION": "Feeders, animal, merchant wholesalers",
    },
    {
      NAICS22: "423820",
      "INDEX ITEM DESCRIPTION": "Frost protection machinery merchant wholesalers",
    },
    {
      NAICS22: "423820",
      "INDEX ITEM DESCRIPTION":
        "Garden machinery and equipment merchant wholesalers",
    },
    {
      NAICS22: "423820",
      "INDEX ITEM DESCRIPTION":
        "Harvesting machinery and equipment, agriculture, merchant wholesalers",
    },
    {
      NAICS22: "423820",
      "INDEX ITEM DESCRIPTION": "Haying machines merchant wholesalers",
    },
    {
      NAICS22: "423820",
      "INDEX ITEM DESCRIPTION": "Irrigation equipment merchant wholesalers",
    },
    {
      NAICS22: "423820",
      "INDEX ITEM DESCRIPTION":
        "Land preparation machinery, agricultural, merchant wholesalers",
    },
    {
      NAICS22: "423820",
      "INDEX ITEM DESCRIPTION":
        "Lawn maintenance machinery and equipment merchant wholesalers",
    },
    {
      NAICS22: "423820",
      "INDEX ITEM DESCRIPTION": "Lawnmowers merchant wholesalers",
    },
    {
      NAICS22: "423820",
      "INDEX ITEM DESCRIPTION":
        "Milking machinery and equipment merchant wholesalers",
    },
    {
      NAICS22: "423820",
      "INDEX ITEM DESCRIPTION":
        "Planting machinery and equipment, farm-type, merchant wholesalers",
    },
    {
      NAICS22: "423820",
      "INDEX ITEM DESCRIPTION": "Plows, farm, merchant wholesalers",
    },
    {
      NAICS22: "423820",
      "INDEX ITEM DESCRIPTION": "Poultry equipment merchant wholesalers",
    },
    {
      NAICS22: "423820",
      "INDEX ITEM DESCRIPTION":
        "Snowblowers, household-type, merchant wholesalers",
    },
    {
      NAICS22: "423820",
      "INDEX ITEM DESCRIPTION": "Sprayers, farm-type, merchant wholesalers",
    },
    {
      NAICS22: "423820",
      "INDEX ITEM DESCRIPTION": "Spreaders, fertilizer, merchant wholesalers",
    },
    {
      NAICS22: "423820",
      "INDEX ITEM DESCRIPTION": "Sprinklers, agricultural, merchant wholesalers",
    },
    {
      NAICS22: "423820",
      "INDEX ITEM DESCRIPTION": "Sprinklers, garden, merchant wholesalers",
    },
    {
      NAICS22: "423820",
      "INDEX ITEM DESCRIPTION": "Tillers, farm and garden, merchant wholesalers",
    },
    {
      NAICS22: "423820",
      "INDEX ITEM DESCRIPTION": "Tractors, farm and garden, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Actuators, fluid power, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Air compressors (except air-conditioning, refrigeration) merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Bakery machinery and equipment merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Balancing machines (except automotive) merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Beverage bottling machinery merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Beverage processing machinery merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Blanks, tips, and inserts merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Blowers, industrial, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Bottling machinery and equipment merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Broaches (i.e., a machine tool accessory) merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Burners, industrial, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Cement making machinery merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Chainsaws merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Chemical industries machinery and equipment merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Coil winding machines, spring, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Commercial fishing equipment and supplies (except boats, ships) merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Compactors, trash, industrial, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Compressors (except air-conditioning, refrigeration) merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Condensing units (except air-conditioning, refrigeration) merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Conveying equipment (except farm) merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Cranes, industrial, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Crushing, pulverizing, and screening machinery, industrial, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Cryogenic cooling devices merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Dies, metalworking, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Diesel engines and parts, industrial, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Distillery machinery merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Dyeing machinery, textile, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Elevators merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Engines, internal combustion (except aircraft, automotive), merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Engraving machinery merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Environmental controlling instruments and equipment merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Escalators merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Fans, industrial, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Fluid meters, industrial, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Fluid power transmission equipment merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Food processing machinery and equipment merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Forklift trucks (except log) merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Foundry machinery and equipment merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Furnaces, industrial process, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Gas detecting equipment and supplies (except household-type) merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "General purpose industrial machinery and equipment merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Handtools, machinists' precision, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Heat exchange equipment, industrial, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Hoists (except automotive) merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Hydraulic power transmission equipment merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Hydraulic pumps and parts merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Industrial machinery and equipment (except electrical) merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Industrial robotics equipment merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Industrial robots merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Industrial trucks, tractors, or trailers merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Instruments (except electrical) (e.g., controlling, indicating, recording) merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Internal combustion engines (except aircraft, nondiesel automotive, nondiesel truck) merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Jigs merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Kilns, industrial, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Ladders merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Lift trucks, industrial, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Machine tools and accessories merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Machinists' precision measuring tools merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Manufacturing machinery and equipment, industrial, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Material handling machinery and equipment merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Measuring and testing equipment (except electric measuring and automotive) merchant wholesalers ",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Metalworking machinery and equipment merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Metalworking tools (drills, taps, dies, grinding wheels) merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Meters (except electrical, parking) merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Mining machinery and equipment, petroleum, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Oil field equipment merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Oil well machinery and equipment merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Oil well supply houses merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Ovens, industrial, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Packing machinery and equipment merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Pallets and skids merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Paper and pulp industries manufacturing machinery merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Patterns (except shoe), industrial, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Petroleum production machinery and equipment merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Pipeline machinery and equipment merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Pistons, hydraulic and pneumatic, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Plastics industries machinery, equipment, and supplies merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Pneumatic pumps and parts merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Pollution control equipment (except air) merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Poultry processing machinery merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Power plant machinery (except electrical) merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Printing trade machinery, equipment, and supplies merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Pulverizing machinery and equipment, industrial, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Pumps and pumping equipment, industrial-type, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Recapping machinery, tire, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Refinery machinery and equipment merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Rolling mill machinery merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Sawmill machinery, equipment, and supplies merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Saws, industrial, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Screening machinery and equipment, industrial, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Sewing machines, industrial, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Shelving, industrial, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Shoe manufacturing and repairing machinery merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Skids merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Smelting machinery and equipment merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Special purpose industrial machinery and equipment merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Spray painting equipment, industrial-type, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Stackers, industrial, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Tanks, pressure, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Testing and measuring equipment, electrical (except automotive), merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Textile machinery and equipment merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Threading tools merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Tire recapping machinery merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Tools, machinists' precision, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Tractors, industrial, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Trailers, industrial, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Trucks, industrial, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Turbines (except transportation) merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Twist drills merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Vacuum pumps merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Valves, hydraulic and pneumatic, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Water treatment equipment, industrial, merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION":
        "Welding machinery and equipment merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Winches merchant wholesalers",
    },
    {
      NAICS22: "423830",
      "INDEX ITEM DESCRIPTION": "Woodworking machinery merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Abrasives merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION":
        "Barrels, new and reconditioned, merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Bearings merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Belting, industrial, merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Bottles (except waste) merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Box shooks merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION":
        "Boxes and crates, industrial (except disposable plastics, paperboard, waste), merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Brushes, industrial, merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Canning supplies merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION":
        "Cartons (except paper and paperboard) merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Closures, industrial, merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Containers, industrial, merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Cooperage stock merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Cordage merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Cork merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION":
        "Crowns and closures, metal, merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Diamonds, industrial, merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Drives and gears merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION":
        "Drums, new and reconditioned, merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION":
        "Excelsior (e.g., pads, wrappers) merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Fire hydrants merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Fittings, industrial, merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Gaskets merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Gears merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION":
        "General-line industrial supplies merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Grommets merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Hose, industrial, merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Industrial containers merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Industrial diamonds merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION":
        "Industrial leather products merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION":
        "Industrial pottery products merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION":
        "Industrial supplies (except disposable plastics, paper) merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Inks, printing, merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION":
        "Lapidary equipment, industrial, merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION":
        "Mechanical power transmission supplies (e.g., gears, pulleys, sprockets) merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Mechanical rubber goods merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Mill supplies merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Packaging materials merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Packing materials merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION":
        "Pipe fittings and valves (except plumbing) merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION":
        "Pistons and valves, industrial, merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION":
        "Plastics foam packing and packaging materials merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION":
        "Power transmission supplies (e.g., gears, pulleys, sprockets), mechanical, merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Printing inks merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION":
        "Reconditioned barrels and drums merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION":
        "Refractory materials (e.g., block, brick, mortar, tile) merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Ropes (except wire rope) merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION":
        "Rubber goods, mechanical (i.e., extruded, lathe-cut, molded), merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Sand, industrial, merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Seals merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION":
        "Shipping containers (except disposable plastics, paper) merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Shipping pails, metal, merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Speed changers merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Sprockets merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Thread, industrial, merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Towels, industrial, merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Twine merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION":
        "Valves (except hydraulic, plumbing, pneumatic) merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION":
        "Welding supplies (except welding gases) merchant wholesalers",
    },
    {
      NAICS22: "423840",
      "INDEX ITEM DESCRIPTION": "Wiping cloths merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION": "Amusement park equipment merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION":
        "Barber shop equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION":
        "Beauty parlor equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION":
        "Boot and shoe cut stock and findings merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION":
        "Brooms (except household-type) merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION": "Burial caskets merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION":
        "Car wash equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION": "Carnival equipment merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION":
        "Carpet cleaning equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION": "Caskets, burial, merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION":
        "Chairs, hydraulic, beauty and barber shop, merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION":
        "Clothes dryers (except household-type) merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION": "Coffins merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION":
        "Drycleaning equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION":
        "Fare boxes, public transit vehicle, merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION":
        "Firefighting equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION":
        "Floor maintenance equipment merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION": "Funeral home supplies merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION":
        "Furriers equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION":
        "Hair preparations, professional, merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION":
        "Janitorial equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION":
        "Laundry machinery, equipment, and supplies, commercial, merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION":
        "Law enforcement equipment (except safety) merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION":
        "Locksmith equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION": "Manicurists supplies merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION": "Massage equipment merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION": "Meters, parking, merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION": "Mops, industrial, merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION":
        "Padding, upholstery filling, merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION": "Patterns, shoe, merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION": "Pressure washers merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION":
        "Service establishment equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION": "Shoe repair materials merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION": "Sprinkler systems, fire, merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION": "Tailors' supplies merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION": "Taxidermy supplies merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION":
        "Undertakers' equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION":
        "Upholsterers' equipment and supplies (except fabrics) merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION":
        "Vacuum cleaning systems, commercial, merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION": "Voting machines merchant wholesalers",
    },
    {
      NAICS22: "423850",
      "INDEX ITEM DESCRIPTION":
        "Water treatment equipment, municipal, merchant wholesalers",
    },
    {
      NAICS22: "423860",
      "INDEX ITEM DESCRIPTION":
        "Aeronautical equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423860",
      "INDEX ITEM DESCRIPTION":
        "Aerospace equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423860",
      "INDEX ITEM DESCRIPTION": "Aircraft engines and parts merchant wholesalers",
    },
    {
      NAICS22: "423860",
      "INDEX ITEM DESCRIPTION":
        "Aircraft equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423860",
      "INDEX ITEM DESCRIPTION": "Aircraft merchant wholesalers",
    },
    {
      NAICS22: "423860",
      "INDEX ITEM DESCRIPTION": "Boats (except pleasure) merchant wholesalers",
    },
    {
      NAICS22: "423860",
      "INDEX ITEM DESCRIPTION":
        "Carts, golf, motorized passenger merchant wholesalers",
    },
    {
      NAICS22: "423860",
      "INDEX ITEM DESCRIPTION": "Draglines, ship, merchant wholesalers",
    },
    {
      NAICS22: "423860",
      "INDEX ITEM DESCRIPTION": "Dredges, ship, merchant wholesalers",
    },
    {
      NAICS22: "423860",
      "INDEX ITEM DESCRIPTION": "Dunnage, marine supplies, merchant wholesalers",
    },
    {
      NAICS22: "423860",
      "INDEX ITEM DESCRIPTION":
        "Engines and parts, aircraft, merchant wholesalers",
    },
    {
      NAICS22: "423860",
      "INDEX ITEM DESCRIPTION":
        "Engines and turbines, marine, merchant wholesalers",
    },
    {
      NAICS22: "423860",
      "INDEX ITEM DESCRIPTION":
        "Golf carts, motorized passenger, merchant wholesalers",
    },
    {
      NAICS22: "423860",
      "INDEX ITEM DESCRIPTION":
        "Guided missiles and space vehicles merchant wholesalers",
    },
    {
      NAICS22: "423860",
      "INDEX ITEM DESCRIPTION": "Locomotives merchant wholesalers",
    },
    {
      NAICS22: "423860",
      "INDEX ITEM DESCRIPTION":
        "Marine supplies (except pleasure) merchant wholesalers",
    },
    {
      NAICS22: "423860",
      "INDEX ITEM DESCRIPTION":
        "Military vehicles (except trucks) merchant wholesalers",
    },
    {
      NAICS22: "423860",
      "INDEX ITEM DESCRIPTION":
        "Motorized passenger golf carts merchant wholesalers",
    },
    {
      NAICS22: "423860",
      "INDEX ITEM DESCRIPTION":
        "Navigational instruments (except electronic) merchant wholesalers",
    },
    {
      NAICS22: "423860",
      "INDEX ITEM DESCRIPTION":
        "Propulsion systems, marine, merchant wholesalers",
    },
    {
      NAICS22: "423860",
      "INDEX ITEM DESCRIPTION": "Railroad cars merchant wholesalers",
    },
    {
      NAICS22: "423860",
      "INDEX ITEM DESCRIPTION":
        "Railroad equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423860",
      "INDEX ITEM DESCRIPTION": "Ships merchant wholesalers",
    },
    {
      NAICS22: "423860",
      "INDEX ITEM DESCRIPTION":
        "Space propulsion units and parts merchant wholesalers",
    },
    {
      NAICS22: "423860",
      "INDEX ITEM DESCRIPTION": "Subway cars merchant wholesalers",
    },
    {
      NAICS22: "423860",
      "INDEX ITEM DESCRIPTION": "Tanks and tank components merchant wholesalers",
    },
    {
      NAICS22: "423860",
      "INDEX ITEM DESCRIPTION":
        "Transportation equipment and supplies (except marine pleasure craft, motor vehicles) merchant wholesalers",
    },
    {
      NAICS22: "423860",
      "INDEX ITEM DESCRIPTION":
        "Transportation machinery, equipment, and supplies (except marine pleasure craft, motor vehicles) merchant wholesalers",
    },
    {
      NAICS22: "423860",
      "INDEX ITEM DESCRIPTION": "Turbines, transportation, merchant wholesalers",
    },
    {
      NAICS22: "423860",
      "INDEX ITEM DESCRIPTION": "Yachts (except pleasure) merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION": "Ammunition, sporting, merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION": "Archery equipment merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION":
        "Athletic goods (except apparel, footwear, nonspecialty) merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION": "Athletic uniforms merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION": "Bait, artificial, merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION":
        "Baseball equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION": "Bicycle tires and tubes merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION":
        "Bicycles (except motorized) merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION":
        "Billiard equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION": "Boat supplies, pleasure, merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION":
        "Boats, pleasure (e.g., canoes, motorboats, sailboats), merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION":
        "Bowling equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION":
        "Camping equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION": "Casino supplies merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION": "Firearms, sporting, merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION":
        "Fishing equipment and supplies (except commercial) merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION":
        "Fitness equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION":
        "Football equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION": "Gocarts merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION":
        "Golf carts (except motorized passenger) merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION":
        "Golf equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION": "Guns, sporting equipment, merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION": "Gymnasium equipment merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION":
        "Hockey equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION": "Hot tubs merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION":
        "Hunting equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION": "Jet skis merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION": "Marine supplies, pleasure, merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION": "Motors, outboard, merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION": "Outboard motors merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION":
        "Playground equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION": "Pleasure boats merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION":
        "Pool (billiards) tables and supplies merchant wholesalers ",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION":
        "Pool (swimming) and equipment merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION":
        "Recreational equipment and supplies (except vehicles) merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION":
        "Skiing equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION":
        "Specialty athletic footwear (e.g., bowling, golf, cleated) merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION":
        "Sporting firearms and ammunition merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION":
        "Sporting goods and supplies merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION":
        "Sports equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION":
        "Swimming pools and equipment merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION":
        "Tennis equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION":
        "Trapshooting equipment and supplies merchant wholesalers",
    },
    {
      NAICS22: "423910",
      "INDEX ITEM DESCRIPTION": "Yachts, pleasure, merchant wholesalers",
    },
    {
      NAICS22: "423920",
      "INDEX ITEM DESCRIPTION": "Board games merchant wholesalers",
    },
    {
      NAICS22: "423920",
      "INDEX ITEM DESCRIPTION": "Card games merchant wholesalers",
    },
    {
      NAICS22: "423920",
      "INDEX ITEM DESCRIPTION":
        "Children's vehicles (except bicycles) merchant wholesalers",
    },
    {
      NAICS22: "423920",
      "INDEX ITEM DESCRIPTION": "Coloring books merchant wholesalers",
    },
    {
      NAICS22: "423920",
      "INDEX ITEM DESCRIPTION": "Craft kits merchant wholesalers",
    },
    {
      NAICS22: "423920",
      "INDEX ITEM DESCRIPTION": "Dolls merchant wholesalers",
    },
    {
      NAICS22: "423920",
      "INDEX ITEM DESCRIPTION": "Electronic games merchant wholesalers",
    },
    {
      NAICS22: "423920",
      "INDEX ITEM DESCRIPTION": "Fireworks merchant wholesalers",
    },
    {
      NAICS22: "423920",
      "INDEX ITEM DESCRIPTION":
        "Games (except coin- or card-operated) merchant wholesalers",
    },
    {
      NAICS22: "423920",
      "INDEX ITEM DESCRIPTION": "Gaming consoles merchant wholesalers",
    },
    {
      NAICS22: "423920",
      "INDEX ITEM DESCRIPTION": "Hobby craft kits merchant wholesalers",
    },
    {
      NAICS22: "423920",
      "INDEX ITEM DESCRIPTION": "Hobbyists' supplies merchant wholesalers",
    },
    {
      NAICS22: "423920",
      "INDEX ITEM DESCRIPTION": "Model kits merchant wholesalers",
    },
    {
      NAICS22: "423920",
      "INDEX ITEM DESCRIPTION": "Playing cards merchant wholesalers",
    },
    {
      NAICS22: "423920",
      "INDEX ITEM DESCRIPTION": "Puzzles merchant wholesalers",
    },
    {
      NAICS22: "423920",
      "INDEX ITEM DESCRIPTION": "Science kits and sets merchant wholesalers",
    },
    {
      NAICS22: "423920",
      "INDEX ITEM DESCRIPTION": "Stamps, philatelist, merchant wholesalers",
    },
    {
      NAICS22: "423920",
      "INDEX ITEM DESCRIPTION": "Toy furniture merchant wholesalers",
    },
    {
      NAICS22: "423920",
      "INDEX ITEM DESCRIPTION":
        "Toys (including electronic) merchant wholesalers",
    },
    {
      NAICS22: "423920",
      "INDEX ITEM DESCRIPTION": "Trading cards merchant wholesalers",
    },
    {
      NAICS22: "423920",
      "INDEX ITEM DESCRIPTION":
        "Vehicles, children's (except bicycles), merchant wholesalers",
    },
    {
      NAICS22: "423920",
      "INDEX ITEM DESCRIPTION": "Video games merchant wholesalers",
    },
    {
      NAICS22: "423930",
      "INDEX ITEM DESCRIPTION": "Bags, reclaimed, merchant wholesalers",
    },
    {
      NAICS22: "423930",
      "INDEX ITEM DESCRIPTION": "Bottles, waste, merchant wholesalers",
    },
    {
      NAICS22: "423930",
      "INDEX ITEM DESCRIPTION": "Boxes, waste, merchant wholesalers",
    },
    {
      NAICS22: "423930",
      "INDEX ITEM DESCRIPTION":
        "Electronics parts, recyclable, merchant wholesalers",
    },
    {
      NAICS22: "423930",
      "INDEX ITEM DESCRIPTION": "Fly ash merchant wholesalers",
    },
    {
      NAICS22: "423930",
      "INDEX ITEM DESCRIPTION": "Fur cuttings and scraps merchant wholesalers",
    },
    {
      NAICS22: "423930",
      "INDEX ITEM DESCRIPTION": "General-line scrap merchant wholesalers",
    },
    {
      NAICS22: "423930",
      "INDEX ITEM DESCRIPTION": "Glass scrap merchant wholesalers",
    },
    {
      NAICS22: "423930",
      "INDEX ITEM DESCRIPTION":
        "Industrial wastes to be reclaimed merchant wholesalers",
    },
    {
      NAICS22: "423930",
      "INDEX ITEM DESCRIPTION": "Metal scrap and waste merchant wholesalers",
    },
    {
      NAICS22: "423930",
      "INDEX ITEM DESCRIPTION": "Oil, waste, merchant wholesalers",
    },
    {
      NAICS22: "423930",
      "INDEX ITEM DESCRIPTION": "Paper, scrap, merchant wholesalers",
    },
    {
      NAICS22: "423930",
      "INDEX ITEM DESCRIPTION": "Plastics scrap merchant wholesalers",
    },
    {
      NAICS22: "423930",
      "INDEX ITEM DESCRIPTION": "Rags merchant wholesalers",
    },
    {
      NAICS22: "423930",
      "INDEX ITEM DESCRIPTION":
        "Recyclable inkjet cartridges merchant wholesalers",
    },
    {
      NAICS22: "423930",
      "INDEX ITEM DESCRIPTION":
        "Recyclable materials (e.g., glass, metal, paper) merchant wholesalers",
    },
    {
      NAICS22: "423930",
      "INDEX ITEM DESCRIPTION":
        "Rubber scrap and scrap tires merchant wholesalers",
    },
    {
      NAICS22: "423930",
      "INDEX ITEM DESCRIPTION": "Salvage, scrap, merchant wholesalers",
    },
    {
      NAICS22: "423930",
      "INDEX ITEM DESCRIPTION":
        "Scrap materials (e.g., automotive, industrial) merchant wholesalers",
    },
    {
      NAICS22: "423930",
      "INDEX ITEM DESCRIPTION":
        "Ship dismantling (except at floating drydocks and shipyards) merchant wholesalers",
    },
    {
      NAICS22: "423930",
      "INDEX ITEM DESCRIPTION": "Textile waste merchant wholesalers",
    },
    {
      NAICS22: "423930",
      "INDEX ITEM DESCRIPTION": "Tires, scrap, merchant wholesalers",
    },
    {
      NAICS22: "423930",
      "INDEX ITEM DESCRIPTION": "Waste materials merchant wholesalers",
    },
    {
      NAICS22: "423940",
      "INDEX ITEM DESCRIPTION": "Antique jewelry merchant wholesalers",
    },
    {
      NAICS22: "423940",
      "INDEX ITEM DESCRIPTION": "Clocks merchant wholesalers",
    },
    {
      NAICS22: "423940",
      "INDEX ITEM DESCRIPTION": "Coins merchant wholesalers",
    },
    {
      NAICS22: "423940",
      "INDEX ITEM DESCRIPTION": "Costume jewelry merchant wholesalers",
    },
    {
      NAICS22: "423940",
      "INDEX ITEM DESCRIPTION":
        "Diamonds (except industrial) merchant wholesalers",
    },
    {
      NAICS22: "423940",
      "INDEX ITEM DESCRIPTION":
        "Flatware, precious and plated, merchant wholesalers",
    },
    {
      NAICS22: "423940",
      "INDEX ITEM DESCRIPTION": "Gem stones merchant wholesalers",
    },
    {
      NAICS22: "423940",
      "INDEX ITEM DESCRIPTION":
        "Hollowware, precious metal, merchant wholesalers",
    },
    {
      NAICS22: "423940",
      "INDEX ITEM DESCRIPTION": "Ingots, precious, merchant wholesalers",
    },
    {
      NAICS22: "423940",
      "INDEX ITEM DESCRIPTION": "Jewelers' findings merchant wholesalers",
    },
    {
      NAICS22: "423940",
      "INDEX ITEM DESCRIPTION": "Jewelry merchant wholesalers",
    },
    {
      NAICS22: "423940",
      "INDEX ITEM DESCRIPTION": "Medallions merchant wholesalers",
    },
    {
      NAICS22: "423940",
      "INDEX ITEM DESCRIPTION": "Metals, precious, merchant wholesalers",
    },
    {
      NAICS22: "423940",
      "INDEX ITEM DESCRIPTION": "Numismatic goods merchant wholesalers",
    },
    {
      NAICS22: "423940",
      "INDEX ITEM DESCRIPTION": "Pearls merchant wholesalers",
    },
    {
      NAICS22: "423940",
      "INDEX ITEM DESCRIPTION":
        "Plated metal cutlery or flatware merchant wholesalers",
    },
    {
      NAICS22: "423940",
      "INDEX ITEM DESCRIPTION":
        "Precious and semiprecious stones merchant wholesalers",
    },
    {
      NAICS22: "423940",
      "INDEX ITEM DESCRIPTION": "Precious metals merchant wholesalers",
    },
    {
      NAICS22: "423940",
      "INDEX ITEM DESCRIPTION":
        "Silverware, precious and plated, merchant wholesalers",
    },
    {
      NAICS22: "423940",
      "INDEX ITEM DESCRIPTION":
        "Stones, precious and semiprecious, merchant wholesalers",
    },
    {
      NAICS22: "423940",
      "INDEX ITEM DESCRIPTION":
        "Tableware, precious and plated, merchant wholesalers",
    },
    {
      NAICS22: "423940",
      "INDEX ITEM DESCRIPTION": "Trophies merchant wholesalers",
    },
    {
      NAICS22: "423940",
      "INDEX ITEM DESCRIPTION": "Watchcases merchant wholesalers",
    },
    {
      NAICS22: "423940",
      "INDEX ITEM DESCRIPTION": "Watches and parts merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION":
        "Ammunition (except sporting) merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION":
        "Audio and video tapes and disks, prerecorded, merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION": "Billboards merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION": "Briefcases merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION": "Bulletproof vests merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION":
        "Cassettes, prerecorded audio and video, merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION":
        "Coin- or card-operated game machines merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION":
        "Compact discs (CDs), prerecorded, merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION":
        "Digital video discs (DVDs), prerecorded, merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION": "Extinguishers, fire, merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION":
        "Fire extinguisher sales combined with rental and/or service, merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION": "Fire extinguishers merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION": "Firearms (except sporting) merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION": "Firewood merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION":
        "Forest products (except lumber) merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION":
        "Games, coin- or card-operated, merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION": "Gas lighting fixtures merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION":
        "General merchandise, durable goods, merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION": "Guns (except sporting) merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION": "Instruments, musical, merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION": "Lighting equipment, gas, merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION": "Logs merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION": "Luggage merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION": "Mailboxes merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION":
        "Monuments and grave markers merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION":
        "Musical instrument accessories and supplies merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION": "Musical instruments merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION":
        "Musical recordings (e.g., compact discs, records, tapes) merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION": "Ordnance and accessories merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION":
        "Personal safety devices and supplies (e.g., eye shields, face shields, nonelectric respirators) merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION": "Phonograph records merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION":
        "Prerecorded audio and video tapes and discs merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION": "Pulpwood merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION": "Railroad ties, wood, merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION": "Roundwood merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION": "Safety deposit boxes merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION": "Signs (except electrical) merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION": "Suitcases merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION":
        "Synthetic or artificial turf merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION":
        "Tapes, prerecorded, audio or video, merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION": "Ties, wood, merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION":
        "Timber and timber products (except lumber) merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION": "Tombstones merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION": "Video tapes, prerecorded, merchant wholesalers",
    },
    {
      NAICS22: "423990",
      "INDEX ITEM DESCRIPTION":
        "Wood products (e.g., chips, posts, shavings, ties) merchant wholesalers",
    },
    {
      NAICS22: "424110",
      "INDEX ITEM DESCRIPTION": "Envelope paper, bulk, merchant wholesalers",
    },
    {
      NAICS22: "424110",
      "INDEX ITEM DESCRIPTION": "Fine paper, bulk, merchant wholesalers",
    },
    {
      NAICS22: "424110",
      "INDEX ITEM DESCRIPTION": "Groundwood paper, bulk, merchant wholesalers",
    },
    {
      NAICS22: "424110",
      "INDEX ITEM DESCRIPTION": "Newsprint merchant wholesalers",
    },
    {
      NAICS22: "424110",
      "INDEX ITEM DESCRIPTION":
        "Paper (e.g., fine, printing, writing), bulk, merchant wholesalers",
    },
    {
      NAICS22: "424110",
      "INDEX ITEM DESCRIPTION": "Printing paper, bulk, merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "Albums, photo, merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "Binders, looseleaf, merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "Blankbooks merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "Books, sales or receipt, merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "Cards, greeting, merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "Cartridge toner merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "Cellophane tape merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION":
        "Commercial stationery supplies merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "Computer paper supplies merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "Desk accessories, office, merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "Envelopes merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "File cards and folders merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "Filler paper, looseleaf, merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "Folders, file, merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION":
        "Forms, paper (e.g., business, office, sales), merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "Gift wrapping paper merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "Greeting cards merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "Gummed tapes, cellophane, merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "Ink, writing, merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "Inked ribbons merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION":
        "Inks, pastes, and solvents, office, merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "Looseleaf binders merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "Manifold business forms merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "Marking devices merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "Notebooks merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION":
        "Office supplies (except furniture, machines) merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION":
        "Paper, office (e.g., printer, copier), merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "Pencils merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "Pens, writing, merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "Photo albums merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "Photocopy supplies merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "Postcards merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION":
        "Printing paper (except bulk) merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "Receipt books merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "Ribbons, inked, merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "Rubber stamps merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "Sales books merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "Scrapbooks merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "Social stationery merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "Stationery supplies merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "Tapes, cellophane, merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "Toner cartridges merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION": "Typewriter paper merchant wholesalers",
    },
    {
      NAICS22: "424120",
      "INDEX ITEM DESCRIPTION":
        "Writing paper (except bulk) merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION":
        "Bags, paper and disposable plastics, merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION":
        "Boxes, paperboard and disposable plastics, merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION": "Cardboard products merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION":
        "Cartons, paper and paperboard, merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION":
        "Closures, paper and disposable plastics, merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION":
        "Containers, paper and disposable plastics, merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION":
        "Converted paper (except stationery and office supplies) merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION": "Corrugated paper merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION":
        "Crates, paperboard and disposable plastics, merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION":
        "Cups, paper and disposable plastics, merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION": "Diapers, disposable, merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION":
        "Dishes, paper and disposable plastics, merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION":
        "Disposable plastics products (e.g., boxes, cups, cutlery, dishes, sanitary food containers) merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION":
        "Eating utensils, disposable plastics, merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION":
        "Egg cartons, paper and disposable plastics, merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION": "Facial tissue merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION": "Fiber cans and drums merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION": "Filter papers merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION": "Foam plastic trays merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION":
        "Gummed tapes (except cellophane) merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION":
        "Industrial supplies, disposable plastics, paper, merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION":
        "Knives, disposable plastics, merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION": "Napkins, paper, merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION":
        "Paper (except office supplies, printing paper, stationery, writing paper) merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION": "Paper bags merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION": "Paper towels merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION":
        "Paperboard and paperboard products (except office supplies) merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION":
        "Personal sanitary paper products merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION": "Plastics bags merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION":
        "Plastics foam products, disposable (except packaging, packing), merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION":
        "Pressed and molded pulp goods (e.g., egg cartons, shipping supplies) merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION": "Sacks, paper, merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION":
        "Sanitary food containers (e.g., disposable plastics, paper, paperboard) merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION": "Sanitary paper products merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION":
        "Shipping supplies, paper and disposable plastics, merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION":
        "Shopping bags, paper and plastics, merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION": "Tableware, disposable, merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION":
        "Tissue paper, toilet and facial, merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION": "Toilet tissue merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION": "Waxed paper merchant wholesalers",
    },
    {
      NAICS22: "424130",
      "INDEX ITEM DESCRIPTION":
        "Wrapping paper (except gift wrap) merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Antibiotics merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Antiseptics merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Bacteriological medicines merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Bandages (except surgical) merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Beauty preparations merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Beauty supplies merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION":
        "Biologicals and allied products merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Blades, razor, merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Blood derivatives merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Blood plasma merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Botanical drugs and herbs merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Botanicals merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Colognes merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Cosmetics merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Dental care preparations merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Dentifrices merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Deodorants, personal, merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Dermatological medicines merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Diagnostic reagents merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION":
        "Diagnostics, in-vitro and in-vivo, merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Dietary supplements merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Drug proprietaries merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Druggists' sundries merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Drugs merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Endocrine substances merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "First-aid kits, household, merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION":
        "First-aid supplies, household, merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Gauze merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "General-line drugs merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Hair care products merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION":
        "Hair preparations (except professional) merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Hand sanitizers merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Herbal supplements merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Hygiene products, oral, merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Medical sundries, rubber, merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Nonprescription drugs merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Perfumes merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Pharmaceuticals merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Plasmas, blood, merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Prescription drugs merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION":
        "Radioactive pharmaceutical isotopes merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Radiopharmaceuticals merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Razor blades merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Razors (except electric) merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Rubber goods, medical, merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Salts, bath, merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Shaving preparations merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Skin care preparations merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION":
        "Specialty-line pharmaceuticals merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Toilet preparations merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Toilet soaps merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Toiletries merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION":
        "Toothbrushes (except electric) merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Toothpastes merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Vaccines merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Veterinarians' medicines merchant wholesalers",
    },
    {
      NAICS22: "424210",
      "INDEX ITEM DESCRIPTION": "Vitamins merchant wholesalers",
    },
    {
      NAICS22: "424310",
      "INDEX ITEM DESCRIPTION": "Apparel trimmings merchant wholesalers",
    },
    {
      NAICS22: "424310",
      "INDEX ITEM DESCRIPTION": "Automotive fabrics merchant wholesalers",
    },
    {
      NAICS22: "424310",
      "INDEX ITEM DESCRIPTION":
        "Belt and buckle assembly kits merchant wholesalers",
    },
    {
      NAICS22: "424310",
      "INDEX ITEM DESCRIPTION": "Binding, textile, merchant wholesalers",
    },
    {
      NAICS22: "424310",
      "INDEX ITEM DESCRIPTION": "Buttons merchant wholesalers",
    },
    {
      NAICS22: "424310",
      "INDEX ITEM DESCRIPTION": "Drapery material merchant wholesalers",
    },
    {
      NAICS22: "424310",
      "INDEX ITEM DESCRIPTION": "Embroidery products merchant wholesalers",
    },
    {
      NAICS22: "424310",
      "INDEX ITEM DESCRIPTION":
        "Fabrics, textile (except burlap, felt), merchant wholesalers",
    },
    {
      NAICS22: "424310",
      "INDEX ITEM DESCRIPTION": "Fasteners, clothing, merchant wholesalers",
    },
    {
      NAICS22: "424310",
      "INDEX ITEM DESCRIPTION": "Fiberglass fabrics merchant wholesalers",
    },
    {
      NAICS22: "424310",
      "INDEX ITEM DESCRIPTION": "Hair accessories merchant wholesalers",
    },
    {
      NAICS22: "424310",
      "INDEX ITEM DESCRIPTION": "Hat and cap materials merchant wholesalers",
    },
    {
      NAICS22: "424310",
      "INDEX ITEM DESCRIPTION":
        "Jute piece goods (except burlap) merchant wholesalers",
    },
    {
      NAICS22: "424310",
      "INDEX ITEM DESCRIPTION": "Labels, textile, merchant wholesalers",
    },
    {
      NAICS22: "424310",
      "INDEX ITEM DESCRIPTION": "Millinery supplies merchant wholesalers",
    },
    {
      NAICS22: "424310",
      "INDEX ITEM DESCRIPTION": "Needles, sewing, merchant wholesalers",
    },
    {
      NAICS22: "424310",
      "INDEX ITEM DESCRIPTION": "Net goods merchant wholesalers",
    },
    {
      NAICS22: "424310",
      "INDEX ITEM DESCRIPTION": "Notions merchant wholesalers",
    },
    {
      NAICS22: "424310",
      "INDEX ITEM DESCRIPTION": "Paddings, apparel, merchant wholesalers",
    },
    {
      NAICS22: "424310",
      "INDEX ITEM DESCRIPTION":
        "Piece goods (except burlap, felt) merchant wholesalers",
    },
    {
      NAICS22: "424310",
      "INDEX ITEM DESCRIPTION": "Remnants, piece goods, merchant wholesalers",
    },
    {
      NAICS22: "424310",
      "INDEX ITEM DESCRIPTION": "Ribbons, textile, merchant wholesalers",
    },
    {
      NAICS22: "424310",
      "INDEX ITEM DESCRIPTION": "Sewing accessories merchant wholesalers",
    },
    {
      NAICS22: "424310",
      "INDEX ITEM DESCRIPTION": "Tapes, textile, merchant wholesalers",
    },
    {
      NAICS22: "424310",
      "INDEX ITEM DESCRIPTION":
        "Textiles (except burlap, felt) merchant wholesalers",
    },
    {
      NAICS22: "424310",
      "INDEX ITEM DESCRIPTION": "Thread (except industrial) merchant wholesalers",
    },
    {
      NAICS22: "424310",
      "INDEX ITEM DESCRIPTION": "Upholstery fabrics merchant wholesalers",
    },
    {
      NAICS22: "424310",
      "INDEX ITEM DESCRIPTION":
        "Yard goods, textile (except burlap, felt), merchant wholesalers",
    },
    {
      NAICS22: "424310",
      "INDEX ITEM DESCRIPTION": "Yarns (except industrial) merchant wholesalers",
    },
    {
      NAICS22: "424310",
      "INDEX ITEM DESCRIPTION": "Zippers merchant wholesalers",
    },
    {
      NAICS22: "424340",
      "INDEX ITEM DESCRIPTION":
        "Athletic footwear (except specialty athletic footwear) merchant wholesalers",
    },
    {
      NAICS22: "424340",
      "INDEX ITEM DESCRIPTION":
        "Boots (e.g., hiking, western, work) merchant wholesalers",
    },
    {
      NAICS22: "424340",
      "INDEX ITEM DESCRIPTION": "Footwear merchant wholesalers",
    },
    {
      NAICS22: "424340",
      "INDEX ITEM DESCRIPTION":
        "Leather cut stock for shoe and boot merchant wholesalers",
    },
    {
      NAICS22: "424340",
      "INDEX ITEM DESCRIPTION": "Shoe accessories merchant wholesalers",
    },
    {
      NAICS22: "424340",
      "INDEX ITEM DESCRIPTION": "Shoes merchant wholesalers",
    },
    {
      NAICS22: "424340",
      "INDEX ITEM DESCRIPTION": "Slippers merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION":
        "Accessories, clothing, men's and boy's, merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION": "Baby and infant car seats merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION":
        "Baby and infant high chairs merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION": "Baby bottles merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION": "Baby clothing merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION": "Booster seats merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION": "Children's clothing merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION":
        "Clothing accessories, women's, children's, and infants', merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION": "Clothing, men's and boys', merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION":
        "Clothing, women's, children's, and infants', merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION": "Coats, men's and boys', merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION":
        "Coats, women's, children's, and infants', merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION":
        "Costumes, clothing, men's and boys', merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION":
        "Costumes, women's, children's, and infants', merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION":
        "Diapers (except disposable) merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION": "Dresses merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION": "Fur clothing merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION":
        "Furnishings (except shoes), men's and boys', merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION":
        "Furnishings (except shoes), women's, girls', and infants', merchant wholesalers ",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION": "Gloves, men's and boys', merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION":
        "Gloves, women's, children's, and infants', merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION": "Handbags merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION":
        "Hats and caps, men's and boys', merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION":
        "Hats and caps, women's, girls', and infants', merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION": "Hosiery, men's and boys', merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION":
        "Hosiery, women's and girls', merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION":
        "Hosiery, women's, children's, and infants', merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION": "Infants' clothing merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION": "Lingerie merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION": "Men's and boys' clothing merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION":
        "Men's and boys' furnishings (except shoes) merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION": "Millinery merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION": "Neckties, men's and boys', merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION":
        "Nightwear, men's and boys', merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION":
        "Nightwear, women's, children's, and infants', merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION":
        "Outerwear, men's and boys', merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION":
        "Outerwear, women's, children's, and infants', merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION": "Purses merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION":
        "Sleepwear, men's and boys', merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION":
        "Sleepwear, women's, children's, and infants', merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION": "Socks, men's and boys', merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION":
        "Socks, women's, children's, and infants', merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION":
        "Sportswear, men's and boys', merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION": "Strollers merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION": "Suits, men's and boys', merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION": "Swimwear, men's and boys', merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION":
        "Swimwear, women's, children's, and infants', merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION":
        "Umbrellas, men's and boys', merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION":
        "Umbrellas, women's and girls', merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION":
        "Underwear, men's and boys', merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION":
        "Underwear, women's, children's, and infants', merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION":
        "Uniforms (except athletic), men's and boys', merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION":
        "Uniforms (except athletic), women's, children's, and infants', merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION": "Unisex clothing merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION":
        "Waterproof garments, men's and boys', merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION":
        "Waterproof garments, women's, children's, and infants', merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION":
        "Women's and children's clothing accessories merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION": "Women's clothing merchant wholesalers",
    },
    {
      NAICS22: "424350",
      "INDEX ITEM DESCRIPTION":
        "Work clothing, men's and boys', merchant wholesalers",
    },
    {
      NAICS22: "424410",
      "INDEX ITEM DESCRIPTION": "Food, general-line, merchant wholesalers",
    },
    {
      NAICS22: "424410",
      "INDEX ITEM DESCRIPTION": "General-line groceries merchant wholesalers",
    },
    {
      NAICS22: "424410",
      "INDEX ITEM DESCRIPTION": "Groceries, general-line, merchant wholesalers",
    },
    {
      NAICS22: "424420",
      "INDEX ITEM DESCRIPTION": "Bakery products, frozen, merchant wholesalers",
    },
    {
      NAICS22: "424420",
      "INDEX ITEM DESCRIPTION": "Dinners, frozen, merchant wholesalers",
    },
    {
      NAICS22: "424420",
      "INDEX ITEM DESCRIPTION": "Doughs, frozen, merchant wholesalers",
    },
    {
      NAICS22: "424420",
      "INDEX ITEM DESCRIPTION": "Fish, packaged frozen, merchant wholesalers",
    },
    {
      NAICS22: "424420",
      "INDEX ITEM DESCRIPTION":
        "Foods, prepared, packaged frozen, merchant wholesalers",
    },
    {
      NAICS22: "424420",
      "INDEX ITEM DESCRIPTION":
        "Frozen foods, packaged (except dairy products), merchant wholesalers",
    },
    {
      NAICS22: "424420",
      "INDEX ITEM DESCRIPTION": "Fruits, frozen, merchant wholesalers",
    },
    {
      NAICS22: "424420",
      "INDEX ITEM DESCRIPTION": "Juices, frozen, merchant wholesalers",
    },
    {
      NAICS22: "424420",
      "INDEX ITEM DESCRIPTION":
        "Meat product substitutes, frozen, merchant wholesalers",
    },
    {
      NAICS22: "424420",
      "INDEX ITEM DESCRIPTION": "Meat substitutes, frozen, merchant wholesalers",
    },
    {
      NAICS22: "424420",
      "INDEX ITEM DESCRIPTION": "Meatless patties, frozen, merchant wholesalers",
    },
    {
      NAICS22: "424420",
      "INDEX ITEM DESCRIPTION": "Meats, packaged frozen, merchant wholesalers",
    },
    {
      NAICS22: "424420",
      "INDEX ITEM DESCRIPTION":
        "Pies (e.g., fruit, meat, poultry), frozen, merchant wholesalers",
    },
    {
      NAICS22: "424420",
      "INDEX ITEM DESCRIPTION": "Pizzas, frozen, merchant wholesalers",
    },
    {
      NAICS22: "424420",
      "INDEX ITEM DESCRIPTION": "Poultry, packaged frozen, merchant wholesalers",
    },
    {
      NAICS22: "424420",
      "INDEX ITEM DESCRIPTION":
        "Prepared foods, frozen (except dairy products), merchant wholesalers",
    },
    {
      NAICS22: "424420",
      "INDEX ITEM DESCRIPTION": "Pretzels, frozen, merchant wholesalers",
    },
    {
      NAICS22: "424420",
      "INDEX ITEM DESCRIPTION": "Seafoods, packaged frozen, merchant wholesalers",
    },
    {
      NAICS22: "424420",
      "INDEX ITEM DESCRIPTION": "Soups, frozen, merchant wholesalers",
    },
    {
      NAICS22: "424420",
      "INDEX ITEM DESCRIPTION": "Vegetable patties, frozen, merchant wholesalers",
    },
    {
      NAICS22: "424420",
      "INDEX ITEM DESCRIPTION": "Vegetables, frozen, merchant wholesalers",
    },
    {
      NAICS22: "424430",
      "INDEX ITEM DESCRIPTION": "Butter merchant wholesalers",
    },
    {
      NAICS22: "424430",
      "INDEX ITEM DESCRIPTION": "Buttermilk merchant wholesalers",
    },
    {
      NAICS22: "424430",
      "INDEX ITEM DESCRIPTION": "Cheese merchant wholesalers",
    },
    {
      NAICS22: "424430",
      "INDEX ITEM DESCRIPTION": "Cream merchant wholesalers",
    },
    {
      NAICS22: "424430",
      "INDEX ITEM DESCRIPTION": "Cream stations merchant wholesalers",
    },
    {
      NAICS22: "424430",
      "INDEX ITEM DESCRIPTION":
        "Creamery products (except canned) merchant wholesalers",
    },
    {
      NAICS22: "424430",
      "INDEX ITEM DESCRIPTION": "Dairy depots merchant wholesalers",
    },
    {
      NAICS22: "424430",
      "INDEX ITEM DESCRIPTION":
        "Dairy products (except canned, dried) merchant wholesalers",
    },
    {
      NAICS22: "424430",
      "INDEX ITEM DESCRIPTION": "Dairy products, frozen, merchant wholesalers",
    },
    {
      NAICS22: "424430",
      "INDEX ITEM DESCRIPTION": "Desserts, dairy, merchant wholesalers",
    },
    {
      NAICS22: "424430",
      "INDEX ITEM DESCRIPTION": "Frozen yogurt merchant wholesalers",
    },
    {
      NAICS22: "424430",
      "INDEX ITEM DESCRIPTION": "Ice cream and ices merchant wholesalers",
    },
    {
      NAICS22: "424430",
      "INDEX ITEM DESCRIPTION": "Ice cream merchant wholesalers",
    },
    {
      NAICS22: "424430",
      "INDEX ITEM DESCRIPTION": "Ice milk merchant wholesalers",
    },
    {
      NAICS22: "424430",
      "INDEX ITEM DESCRIPTION":
        "Milk, fluid (except canned), merchant wholesalers",
    },
    {
      NAICS22: "424430",
      "INDEX ITEM DESCRIPTION":
        "Prepared foods, frozen dairy, merchant wholesalers",
    },
    {
      NAICS22: "424430",
      "INDEX ITEM DESCRIPTION": "Raw milk merchant wholesalers",
    },
    {
      NAICS22: "424430",
      "INDEX ITEM DESCRIPTION": "Yogurt merchant wholesalers",
    },
    {
      NAICS22: "424440",
      "INDEX ITEM DESCRIPTION":
        "Chicken and chicken products (except canned and packaged frozen) merchant wholesalers",
    },
    {
      NAICS22: "424440",
      "INDEX ITEM DESCRIPTION": "Deli meats, poultry, merchant wholesalers",
    },
    {
      NAICS22: "424440",
      "INDEX ITEM DESCRIPTION": "Eggs merchant wholesalers",
    },
    {
      NAICS22: "424440",
      "INDEX ITEM DESCRIPTION": "Fresh poultry merchant wholesalers",
    },
    {
      NAICS22: "424440",
      "INDEX ITEM DESCRIPTION":
        "Frozen poultry (except packaged) merchant wholesalers",
    },
    {
      NAICS22: "424440",
      "INDEX ITEM DESCRIPTION":
        "Packaged poultry (except canned and frozen) merchant wholesalers",
    },
    {
      NAICS22: "424440",
      "INDEX ITEM DESCRIPTION":
        "Poultry and poultry products (except canned, packaged frozen) merchant wholesalers",
    },
    {
      NAICS22: "424440",
      "INDEX ITEM DESCRIPTION":
        "Poultry pies (except packaged frozen) merchant wholesalers",
    },
    {
      NAICS22: "424440",
      "INDEX ITEM DESCRIPTION": "Poultry, live and dressed, merchant wholesalers",
    },
    {
      NAICS22: "424440",
      "INDEX ITEM DESCRIPTION":
        "Processed poultry (e.g., luncheon) merchant wholesalers",
    },
    {
      NAICS22: "424440",
      "INDEX ITEM DESCRIPTION":
        "Turkey and turkey products (except canned and packaged frozen) merchant wholesalers",
    },
    {
      NAICS22: "424450",
      "INDEX ITEM DESCRIPTION": "Candy merchant wholesalers",
    },
    {
      NAICS22: "424450",
      "INDEX ITEM DESCRIPTION":
        "Cheese confections (e.g., curls, puffs) merchant wholesalers",
    },
    {
      NAICS22: "424450",
      "INDEX ITEM DESCRIPTION": "Chewing gum merchant wholesalers",
    },
    {
      NAICS22: "424450",
      "INDEX ITEM DESCRIPTION": "Chips (e.g., corn, potato) merchant wholesalers",
    },
    {
      NAICS22: "424450",
      "INDEX ITEM DESCRIPTION": "Chocolate candy merchant wholesalers",
    },
    {
      NAICS22: "424450",
      "INDEX ITEM DESCRIPTION":
        "Concentrates, fountain (except soft drink), merchant wholesalers",
    },
    {
      NAICS22: "424450",
      "INDEX ITEM DESCRIPTION": "Confectionery merchant wholesalers",
    },
    {
      NAICS22: "424450",
      "INDEX ITEM DESCRIPTION":
        "Corn chips and related corn snacks merchant wholesalers",
    },
    {
      NAICS22: "424450",
      "INDEX ITEM DESCRIPTION":
        "Fountain fruits and syrups (except soft drink) merchant wholesalers",
    },
    {
      NAICS22: "424450",
      "INDEX ITEM DESCRIPTION":
        "Fountain syrups (except soft drink) merchant wholesalers",
    },
    {
      NAICS22: "424450",
      "INDEX ITEM DESCRIPTION":
        "Fruit concentrates, fountain, merchant wholesalers",
    },
    {
      NAICS22: "424450",
      "INDEX ITEM DESCRIPTION": "Gum, chewing, merchant wholesalers",
    },
    {
      NAICS22: "424450",
      "INDEX ITEM DESCRIPTION":
        "Nuts (e.g., canned, roasted, salted) merchant wholesalers",
    },
    {
      NAICS22: "424450",
      "INDEX ITEM DESCRIPTION": "Popcorn merchant wholesalers",
    },
    {
      NAICS22: "424450",
      "INDEX ITEM DESCRIPTION":
        "Potato chips and related snacks merchant wholesalers",
    },
    {
      NAICS22: "424450",
      "INDEX ITEM DESCRIPTION":
        "Seeds (e.g., canned, roasted, salted) merchant wholesalers",
    },
    {
      NAICS22: "424450",
      "INDEX ITEM DESCRIPTION":
        "Syrups, fountain (except soft drink), merchant wholesalers",
    },
    {
      NAICS22: "424450",
      "INDEX ITEM DESCRIPTION": "Toppings, fountain, merchant wholesalers",
    },
    {
      NAICS22: "424460",
      "INDEX ITEM DESCRIPTION": "Cured fish merchant wholesalers",
    },
    {
      NAICS22: "424460",
      "INDEX ITEM DESCRIPTION":
        "Fish (except canned, packaged frozen) merchant wholesalers",
    },
    {
      NAICS22: "424460",
      "INDEX ITEM DESCRIPTION":
        "Fish, salted or preserved (except canned), merchant wholesalers",
    },
    {
      NAICS22: "424460",
      "INDEX ITEM DESCRIPTION": "Fresh fish merchant wholesalers",
    },
    {
      NAICS22: "424460",
      "INDEX ITEM DESCRIPTION": "Fresh seafood merchant wholesalers",
    },
    {
      NAICS22: "424460",
      "INDEX ITEM DESCRIPTION":
        "Frozen fish (except packaged) merchant wholesalers",
    },
    {
      NAICS22: "424460",
      "INDEX ITEM DESCRIPTION":
        "Frozen seafood (except packaged) merchant wholesalers",
    },
    {
      NAICS22: "424460",
      "INDEX ITEM DESCRIPTION":
        "Seafood (except canned, packaged frozen) merchant wholesalers",
    },
    {
      NAICS22: "424470",
      "INDEX ITEM DESCRIPTION":
        "Cutting of purchased carcasses (except boxed meat cut on an assembly line basis) merchant wholesalers",
    },
    {
      NAICS22: "424470",
      "INDEX ITEM DESCRIPTION":
        "Deli meats (except poultry) merchant wholesalers",
    },
    {
      NAICS22: "424470",
      "INDEX ITEM DESCRIPTION": "Fresh meats merchant wholesalers",
    },
    {
      NAICS22: "424470",
      "INDEX ITEM DESCRIPTION":
        "Frozen meats (except packaged) merchant wholesalers",
    },
    {
      NAICS22: "424470",
      "INDEX ITEM DESCRIPTION": "Lard merchant wholesalers",
    },
    {
      NAICS22: "424470",
      "INDEX ITEM DESCRIPTION":
        "Meats and meat products (except canned, packaged frozen) merchant wholesalers",
    },
    {
      NAICS22: "424470",
      "INDEX ITEM DESCRIPTION": "Meats, cured or smoked, merchant wholesalers",
    },
    {
      NAICS22: "424470",
      "INDEX ITEM DESCRIPTION": "Meats, fresh, merchant wholesalers",
    },
    {
      NAICS22: "424470",
      "INDEX ITEM DESCRIPTION":
        "Meats, frozen (except packaged), merchant wholesalers",
    },
    {
      NAICS22: "424470",
      "INDEX ITEM DESCRIPTION":
        "Processed meats (e.g., luncheon, sausage) merchant wholesalers",
    },
    {
      NAICS22: "424480",
      "INDEX ITEM DESCRIPTION": "Berries, fresh, merchant wholesalers",
    },
    {
      NAICS22: "424480",
      "INDEX ITEM DESCRIPTION":
        "Fresh fruits, vegetables, and berries merchant wholesalers",
    },
    {
      NAICS22: "424480",
      "INDEX ITEM DESCRIPTION": "Fruits, fresh, merchant wholesalers",
    },
    {
      NAICS22: "424480",
      "INDEX ITEM DESCRIPTION":
        "Health foods, fresh fruits and vegetables, merchant wholesalers",
    },
    {
      NAICS22: "424480",
      "INDEX ITEM DESCRIPTION": "Produce, fresh, merchant wholesalers",
    },
    {
      NAICS22: "424480",
      "INDEX ITEM DESCRIPTION": "Salads, prepackaged, merchant wholesalers",
    },
    {
      NAICS22: "424480",
      "INDEX ITEM DESCRIPTION": "Vegetables, fresh, merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Baby foods, canned, merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION":
        "Bakery products (except frozen) merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Beans, dry edible, merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Beverage bases merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Beverage concentrates merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION":
        "Bottled water (except water treating) merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION":
        "Bread, packaged (except frozen), merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Breakfast cereals merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Brewers' yeast merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Butter substitutes merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Cane sugar, refined, merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION":
        "Canned foods (e.g., fish, meat, seafood, soups) merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Carbonated beverages merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Cereal products merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION":
        "Cheese, imitation or substitute, merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Chocolate (except candy) merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Chocolate coatings merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION":
        "Chocolate syrups (except fountain) merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Coffee merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Cookies merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Cooking oils merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION":
        "Corn milling products (except pet and livestock feeds) merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Cornmeal, edible, merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Crackers merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Creamery products, canned, merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION":
        "Dairy products, dried or canned, merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Dessert powders merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION":
        "Dried foods (e.g., fruits, milk, vegetables) merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Egg substitutes merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Fish, canned, merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION":
        "Flavoring extracts (except for fountain use) merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Flour merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Fruits, canned, merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Gelatin, edible, merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION":
        "Health foods (except fresh fruits, vegetables) merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Honey merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Hop extract merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Ice cream cones merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Jellies and jams merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Juices, canned or fresh, merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Macaroni merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Malt extract merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Malt merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Maple syrup merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Margarine merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Marmalade merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Meats, canned, merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Milk substitutes merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Milk, canned or dried, merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION":
        "Mixes (e.g., cake, dessert, pie) merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Molasses merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Nondairy creamers merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Nondairy milk merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Nondairy yogurt merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Oils, cooking and salad, merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Pet food merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Pizzas (except frozen) merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Poultry, canned, merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION":
        "Prepared foods (except frozen) merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Pretzels (except frozen) merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Rice, polished, merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Salad dressings merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Salad oils merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Salt, table, merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Sandwiches merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Sausage casings merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Seafood, canned, merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Shortening, vegetable, merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Soft drinks merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Soups (except frozen) merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Spaghetti merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Spices merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Sport energy drinks merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Sugar, refined, merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Syrup (except fountain) merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Tea merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Toppings (except fountain) merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Vegetables, canned, merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION":
        "Water, bottled (except water treating), merchant wholesalers",
    },
    {
      NAICS22: "424490",
      "INDEX ITEM DESCRIPTION": "Yeast merchant wholesalers",
    },
    {
      NAICS22: "424510",
      "INDEX ITEM DESCRIPTION": "Beans, dry inedible, merchant wholesalers",
    },
    {
      NAICS22: "424510",
      "INDEX ITEM DESCRIPTION":
        "Corn, raw (except seed corn), merchant wholesalers",
    },
    {
      NAICS22: "424510",
      "INDEX ITEM DESCRIPTION": "Dry beans, inedible, merchant wholesalers",
    },
    {
      NAICS22: "424510",
      "INDEX ITEM DESCRIPTION": "Grain elevators merchant wholesalers",
    },
    {
      NAICS22: "424510",
      "INDEX ITEM DESCRIPTION": "Grain merchant wholesalers",
    },
    {
      NAICS22: "424510",
      "INDEX ITEM DESCRIPTION": "Rice, unpolished, merchant wholesalers",
    },
    {
      NAICS22: "424510",
      "INDEX ITEM DESCRIPTION": "Soybeans merchant wholesalers",
    },
    {
      NAICS22: "424510",
      "INDEX ITEM DESCRIPTION": "Wheat merchant wholesalers",
    },
    {
      NAICS22: "424520",
      "INDEX ITEM DESCRIPTION":
        "Auction markets, livestock (except horses, mules), merchant wholesalers",
    },
    {
      NAICS22: "424520",
      "INDEX ITEM DESCRIPTION": "Cattle merchant wholesalers",
    },
    {
      NAICS22: "424520",
      "INDEX ITEM DESCRIPTION": "Goats merchant wholesalers",
    },
    {
      NAICS22: "424520",
      "INDEX ITEM DESCRIPTION": "Hogs merchant wholesalers",
    },
    {
      NAICS22: "424520",
      "INDEX ITEM DESCRIPTION":
        "Livestock (except horses, mules, and feedlots) merchant wholesalers",
    },
    {
      NAICS22: "424520",
      "INDEX ITEM DESCRIPTION": "Sheep merchant wholesalers",
    },
    {
      NAICS22: "424520",
      "INDEX ITEM DESCRIPTION": "Swine merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION":
        "Animal hair, wool, or mohair merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION":
        "Auction markets, tobacco, horses, mules, merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION": "Bees merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION": "Bovine semen merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION": "Bristles merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION": "Broomcorn merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION": "Cannabis merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION": "Chicks, live, merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION": "Cocoa beans merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION": "Cotton, raw, merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION": "Feathers merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION": "Fibers, vegetable, merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION": "Furs, raw, merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION": "Hemp merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION": "Hides merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION": "Hops merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION": "Horses merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION": "Leaf tobacco merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION": "Marijuana merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION": "Mohair, raw, merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION": "Mules merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION":
        "Nuts, unprocessed or shelled only, merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION": "Oil kernels merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION": "Oil nuts merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION": "Oilseeds merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION":
        "Peanuts, bulk, unprocessed, merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION": "Pelts, raw, merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION":
        "Raw farm products (except field beans, grains) merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION": "Semen, bovine, merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION": "Silk, raw, merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION": "Skins, raw, merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION": "Sod merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION": "Spices, raw, merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION": "Sugar, raw, merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION": "Tobacco, leaf, merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION": "Wool tops and noils merchant wholesalers",
    },
    {
      NAICS22: "424590",
      "INDEX ITEM DESCRIPTION": "Wool, raw, merchant wholesalers",
    },
    {
      NAICS22: "424610",
      "INDEX ITEM DESCRIPTION": "Cellulose film merchant wholesalers",
    },
    {
      NAICS22: "424610",
      "INDEX ITEM DESCRIPTION":
        "Foam, plastics, resins and shapes, merchant wholesalers",
    },
    {
      NAICS22: "424610",
      "INDEX ITEM DESCRIPTION": "Nylon resins merchant wholesalers",
    },
    {
      NAICS22: "424610",
      "INDEX ITEM DESCRIPTION": "Plasticizers merchant wholesalers",
    },
    {
      NAICS22: "424610",
      "INDEX ITEM DESCRIPTION":
        "Plastics basic shapes (e.g., film, rod, sheet, sheeting, tubing) merchant wholesalers",
    },
    {
      NAICS22: "424610",
      "INDEX ITEM DESCRIPTION": "Plastics foam merchant wholesalers",
    },
    {
      NAICS22: "424610",
      "INDEX ITEM DESCRIPTION": "Plastics materials merchant wholesalers",
    },
    {
      NAICS22: "424610",
      "INDEX ITEM DESCRIPTION": "Plastics resins merchant wholesalers",
    },
    {
      NAICS22: "424610",
      "INDEX ITEM DESCRIPTION": "Polyester resins merchant wholesalers",
    },
    {
      NAICS22: "424610",
      "INDEX ITEM DESCRIPTION": "Resins, plastics, merchant wholesalers",
    },
    {
      NAICS22: "424610",
      "INDEX ITEM DESCRIPTION": "Stabilizers, plastic, merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Acids merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Adhesives and sealants merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Alcohol, industrial, merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Alkalies merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION":
        "Alternative fuels, not blended with petroleum, merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION":
        "Ammonia (except fertilizer material) merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Antifreeze merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Aromatic chemicals merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION":
        "Automotive chemicals (except lubricating greases, lubrication oils) merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION":
        "Biodiesel, not blended with petroleum, merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION":
        "Biofuels, not blended with petroleum, merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Bleaches merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Cannabidiol (CBD oil) merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Carbon black merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Caulking materials merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Caustic soda merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION":
        "Chemical additives (e.g., concrete, food, fuel, oil) merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Chemical gases merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION":
        "Chemicals (except agriculture) (e.g., automotive, household, industrial, photographic) merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Chlorine merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION":
        "Cleaning compounds and preparations merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION":
        "Coal tar distillates and resins merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION":
        "Coal tar products, primary and intermediate, merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION":
        "Compressed gases (except LP gas) merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Concrete additives merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION":
        "Cyclic crudes and intermediates merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION":
        "Deodorants (except personal) merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Detergents merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION":
        "Detonators (except ammunition) merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION":
        "Disinfectants (except agricultural) merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Drilling muds merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Dry ice merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION":
        "Drycleaning solvents and chemicals merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Dyes, industrial, merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Dyestuffs merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Dynamite merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION":
        "Electronic cigarette vapor liquids merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Essential oils merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION":
        "Ethanol, not blended with petroleum, merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION":
        "Explosives (except ammunition, fireworks) merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Fabric softeners merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Fibers, manmade, merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION":
        "Fire extinguisher preparations merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Food additives, chemical, merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Fuel additives merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION":
        "Gases, compressed and liquefied (except liquefied petroleum gas), merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Gelatin, inedible, merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Glues merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Gum and wood chemicals merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Ice, dry, merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Industrial chemicals merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Industrial gases merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Industrial salts merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Inorganic chemicals merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION":
        "Insecticides (except lawn and agricultural) merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Janitorial chemicals merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION":
        "Laundry soap, chips, and powder, merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION":
        "Liquefied gases (except LP) merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Manmade fibers merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION":
        "Mastics (except construction) merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Medical gases merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Metal cyanides merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Metalworking compounds merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Nylon fibers merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Oil additives merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Oil drilling muds merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Organic chemicals merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION":
        "Pesticides (except agricultural) merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION":
        "Polishes (e.g., automobile, furniture, metal, shoe, stove) merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Polyester fibers merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Refrigerants merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Resins, synthetic rubber, merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Rosins merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Salts, industrial, merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Sealants merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Sulfuric acid merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Surface active agents merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Synthetic rubber merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Turpentine merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Water softening compounds merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Waxes (except petroleum) merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Welding gases merchant wholesalers",
    },
    {
      NAICS22: "424690",
      "INDEX ITEM DESCRIPTION": "Wood treating preparations merchant wholesalers",
    },
    {
      NAICS22: "424710",
      "INDEX ITEM DESCRIPTION":
        "Alternative fuels, blended with petroleum, bulk stations and terminals, merchant wholesalers",
    },
    {
      NAICS22: "424710",
      "INDEX ITEM DESCRIPTION":
        "Asphalt binder bulk stations and terminals, merchant wholesalers",
    },
    {
      NAICS22: "424710",
      "INDEX ITEM DESCRIPTION":
        "Asphalt, liquid, bulk stations and terminals, merchant wholesalers",
    },
    {
      NAICS22: "424710",
      "INDEX ITEM DESCRIPTION":
        "Biodiesel, blended with petroleum, bulk stations and terminals, merchant wholesalers",
    },
    {
      NAICS22: "424710",
      "INDEX ITEM DESCRIPTION":
        "Biofuels, blended with petroleum, bulk stations and terminals, merchant wholesalers",
    },
    {
      NAICS22: "424710",
      "INDEX ITEM DESCRIPTION": "Bulk gasoline stations, merchant wholesalers",
    },
    {
      NAICS22: "424710",
      "INDEX ITEM DESCRIPTION": "Bulk stations, petroleum, merchant wholesalers",
    },
    {
      NAICS22: "424710",
      "INDEX ITEM DESCRIPTION":
        "Compressed liquefied petroleum gas (LPG) bulk stations and terminals, merchant wholesalers",
    },
    {
      NAICS22: "424710",
      "INDEX ITEM DESCRIPTION": "Crude oil terminals, merchant wholesalers",
    },
    {
      NAICS22: "424710",
      "INDEX ITEM DESCRIPTION":
        "Diesel fuel bulk stations and terminals, merchant wholesalers",
    },
    {
      NAICS22: "424710",
      "INDEX ITEM DESCRIPTION":
        "Ethanol, blended with petroleum, bulk stations and terminals, merchant wholesalers",
    },
    {
      NAICS22: "424710",
      "INDEX ITEM DESCRIPTION":
        "Fuel oil bulk stations and terminals, merchant wholesalers",
    },
    {
      NAICS22: "424710",
      "INDEX ITEM DESCRIPTION":
        "Gasohol bulk stations and terminals, merchant wholesalers",
    },
    {
      NAICS22: "424710",
      "INDEX ITEM DESCRIPTION":
        "Gasoline bulk stations and terminals, merchant wholesalers",
    },
    {
      NAICS22: "424710",
      "INDEX ITEM DESCRIPTION":
        "Heating oil bulk stations and terminals, merchant wholesalers",
    },
    {
      NAICS22: "424710",
      "INDEX ITEM DESCRIPTION":
        "Jet fuel bulk stations and terminals, merchant wholesalers",
    },
    {
      NAICS22: "424710",
      "INDEX ITEM DESCRIPTION":
        "Kerosene bulk stations and terminals, merchant wholesalers",
    },
    {
      NAICS22: "424710",
      "INDEX ITEM DESCRIPTION":
        "Liquefied petroleum gas (LPG) bulk stations and terminals, merchant wholesalers",
    },
    {
      NAICS22: "424710",
      "INDEX ITEM DESCRIPTION":
        "Lubricating oils and greases bulk stations and terminals, merchant wholesalers",
    },
    {
      NAICS22: "424710",
      "INDEX ITEM DESCRIPTION":
        "Oil, petroleum, bulk stations and terminals, merchant wholesalers",
    },
    {
      NAICS22: "424710",
      "INDEX ITEM DESCRIPTION":
        "Petroleum and petroleum products bulk stations and terminals, merchant wholesalers",
    },
    {
      NAICS22: "424710",
      "INDEX ITEM DESCRIPTION":
        "Propane bulk stations and terminals, merchant wholesalers",
    },
    {
      NAICS22: "424710",
      "INDEX ITEM DESCRIPTION": "Terminals, petroleum, merchant wholesalers",
    },
    {
      NAICS22: "424720",
      "INDEX ITEM DESCRIPTION":
        "Alternative fuels, blended with petroleum, merchant wholesalers (except bulk stations, terminals)",
    },
    {
      NAICS22: "424720",
      "INDEX ITEM DESCRIPTION":
        "Asphalt binder merchant wholesalers (except bulk stations, terminals) ",
    },
    {
      NAICS22: "424720",
      "INDEX ITEM DESCRIPTION":
        "Asphalt, liquid, merchant wholesalers (except bulk stations, terminals)",
    },
    {
      NAICS22: "424720",
      "INDEX ITEM DESCRIPTION":
        "Biodiesel, blended with petroleum, merchant wholesalers (except bulk stations, terminals)",
    },
    {
      NAICS22: "424720",
      "INDEX ITEM DESCRIPTION":
        "Biofuels, blended with petroleum, merchant wholesalers (except bulk stations, terminals)",
    },
    {
      NAICS22: "424720",
      "INDEX ITEM DESCRIPTION":
        "Butane gas merchant wholesalers (except bulk stations, terminals)",
    },
    {
      NAICS22: "424720",
      "INDEX ITEM DESCRIPTION":
        "Crude oil merchant wholesalers (except bulk stations, terminals)",
    },
    {
      NAICS22: "424720",
      "INDEX ITEM DESCRIPTION":
        "Diesel fuel merchant wholesalers (except bulk stations, terminals)",
    },
    {
      NAICS22: "424720",
      "INDEX ITEM DESCRIPTION":
        "Ethanol, blended with petroleum, merchant wholesalers (except bulk stations, terminals)",
    },
    {
      NAICS22: "424720",
      "INDEX ITEM DESCRIPTION":
        "Fuel oil merchant wholesalers (except bulk stations, terminals)",
    },
    {
      NAICS22: "424720",
      "INDEX ITEM DESCRIPTION": "Fuel oil truck jobbers",
    },
    {
      NAICS22: "424720",
      "INDEX ITEM DESCRIPTION":
        "Fuel, aircraft, merchant wholesalers (except bulk stations, terminals)",
    },
    {
      NAICS22: "424720",
      "INDEX ITEM DESCRIPTION":
        "Fueling aircraft (except on contract basis), merchant wholesalers",
    },
    {
      NAICS22: "424720",
      "INDEX ITEM DESCRIPTION":
        "Gasohol merchant wholesalers (except bulk stations, terminals)",
    },
    {
      NAICS22: "424720",
      "INDEX ITEM DESCRIPTION":
        "Gasoline merchant wholesalers (except bulk stations, terminals)",
    },
    {
      NAICS22: "424720",
      "INDEX ITEM DESCRIPTION":
        "Kerosene merchant wholesalers (except bulk stations, terminals)",
    },
    {
      NAICS22: "424720",
      "INDEX ITEM DESCRIPTION":
        "Liquefied petroleum gas (LPG) merchant wholesalers (except bulk stations, terminals)",
    },
    {
      NAICS22: "424720",
      "INDEX ITEM DESCRIPTION":
        "Lubricating oils and greases merchant wholesalers (except bulk stations, terminals)",
    },
    {
      NAICS22: "424720",
      "INDEX ITEM DESCRIPTION":
        "Oil, petroleum, merchant wholesalers (except bulk stations, terminals)",
    },
    {
      NAICS22: "424720",
      "INDEX ITEM DESCRIPTION":
        "Petroleum and petroleum products merchant wholesalers (except bulk stations, terminals)",
    },
    {
      NAICS22: "424720",
      "INDEX ITEM DESCRIPTION": "Petroleum coke merchant wholesalers",
    },
    {
      NAICS22: "424720",
      "INDEX ITEM DESCRIPTION":
        "Propane merchant wholesalers (except bulk stations, terminals)",
    },
    {
      NAICS22: "424810",
      "INDEX ITEM DESCRIPTION":
        "Alcoholic beverages (except distilled spirits, wine) merchant wholesalers",
    },
    {
      NAICS22: "424810",
      "INDEX ITEM DESCRIPTION": "Ale merchant wholesalers",
    },
    {
      NAICS22: "424810",
      "INDEX ITEM DESCRIPTION": "Beer merchant wholesalers",
    },
    {
      NAICS22: "424810",
      "INDEX ITEM DESCRIPTION":
        "Beverages, alcoholic (except distilled spirits, wine), merchant wholesalers",
    },
    {
      NAICS22: "424810",
      "INDEX ITEM DESCRIPTION": "Fermented malt beverages merchant wholesalers",
    },
    {
      NAICS22: "424810",
      "INDEX ITEM DESCRIPTION": "Malt liquor merchant wholesalers",
    },
    {
      NAICS22: "424810",
      "INDEX ITEM DESCRIPTION": "Porter merchant wholesalers",
    },
    {
      NAICS22: "424820",
      "INDEX ITEM DESCRIPTION":
        "Alcoholic beverages, wine, and distilled spirits merchant wholesalers ",
    },
    {
      NAICS22: "424820",
      "INDEX ITEM DESCRIPTION":
        "Beverages, wine and distilled spirits, merchant wholesalers",
    },
    {
      NAICS22: "424820",
      "INDEX ITEM DESCRIPTION": "Brandy and brandy spirits merchant wholesalers",
    },
    {
      NAICS22: "424820",
      "INDEX ITEM DESCRIPTION":
        "Cocktails, alcoholic, premixed, merchant wholesalers",
    },
    {
      NAICS22: "424820",
      "INDEX ITEM DESCRIPTION":
        "Distilled alcoholic beverages merchant wholesalers",
    },
    {
      NAICS22: "424820",
      "INDEX ITEM DESCRIPTION": "Ethyl alcohol merchant wholesalers",
    },
    {
      NAICS22: "424820",
      "INDEX ITEM DESCRIPTION": "Hard cider merchant wholesalers",
    },
    {
      NAICS22: "424820",
      "INDEX ITEM DESCRIPTION": "Liquors merchant wholesalers",
    },
    {
      NAICS22: "424820",
      "INDEX ITEM DESCRIPTION": "Liquors, distilled, merchant wholesalers",
    },
    {
      NAICS22: "424820",
      "INDEX ITEM DESCRIPTION": "Neutral spirits merchant wholesalers",
    },
    {
      NAICS22: "424820",
      "INDEX ITEM DESCRIPTION": "Spirits, distilled, merchant wholesalers",
    },
    {
      NAICS22: "424820",
      "INDEX ITEM DESCRIPTION": "Wine coolers, alcoholic, merchant wholesalers",
    },
    {
      NAICS22: "424820",
      "INDEX ITEM DESCRIPTION": "Wines merchant wholesalers",
    },
    {
      NAICS22: "424910",
      "INDEX ITEM DESCRIPTION": "Agricultural chemicals merchant wholesalers",
    },
    {
      NAICS22: "424910",
      "INDEX ITEM DESCRIPTION": "Agricultural limestone merchant wholesalers",
    },
    {
      NAICS22: "424910",
      "INDEX ITEM DESCRIPTION": "Alfalfa merchant wholesalers",
    },
    {
      NAICS22: "424910",
      "INDEX ITEM DESCRIPTION":
        "Ammonia, fertilizer material, merchant wholesalers",
    },
    {
      NAICS22: "424910",
      "INDEX ITEM DESCRIPTION":
        "Animal feeds (except pet food) merchant wholesalers",
    },
    {
      NAICS22: "424910",
      "INDEX ITEM DESCRIPTION": "Beekeeping supplies merchant wholesalers",
    },
    {
      NAICS22: "424910",
      "INDEX ITEM DESCRIPTION": "Chemicals, agricultural, merchant wholesalers",
    },
    {
      NAICS22: "424910",
      "INDEX ITEM DESCRIPTION": "Farm supplies merchant wholesalers",
    },
    {
      NAICS22: "424910",
      "INDEX ITEM DESCRIPTION": "Feed additives merchant wholesalers",
    },
    {
      NAICS22: "424910",
      "INDEX ITEM DESCRIPTION": "Feeds (except pet) merchant wholesalers",
    },
    {
      NAICS22: "424910",
      "INDEX ITEM DESCRIPTION":
        "Fertilizer and fertilizer materials merchant wholesalers",
    },
    {
      NAICS22: "424910",
      "INDEX ITEM DESCRIPTION": "Flower bulbs merchant wholesalers",
    },
    {
      NAICS22: "424910",
      "INDEX ITEM DESCRIPTION": "Fungicides, agricultural, merchant wholesalers",
    },
    {
      NAICS22: "424910",
      "INDEX ITEM DESCRIPTION":
        "Garden supplies (e.g., fertilizers, pesticides) merchant wholesalers",
    },
    {
      NAICS22: "424910",
      "INDEX ITEM DESCRIPTION": "Harness equipment merchant wholesalers",
    },
    {
      NAICS22: "424910",
      "INDEX ITEM DESCRIPTION": "Hay merchant wholesalers",
    },
    {
      NAICS22: "424910",
      "INDEX ITEM DESCRIPTION": "Herbicides merchant wholesalers",
    },
    {
      NAICS22: "424910",
      "INDEX ITEM DESCRIPTION": "Horticultural products merchant wholesalers",
    },
    {
      NAICS22: "424910",
      "INDEX ITEM DESCRIPTION":
        "Insecticides, agricultural, merchant wholesalers",
    },
    {
      NAICS22: "424910",
      "INDEX ITEM DESCRIPTION":
        "Lawn care supplies (e.g., chemicals, fertilizers, pesticides) merchant wholesalers",
    },
    {
      NAICS22: "424910",
      "INDEX ITEM DESCRIPTION": "Lime, agricultural, merchant wholesalers",
    },
    {
      NAICS22: "424910",
      "INDEX ITEM DESCRIPTION": "Livestock feeds merchant wholesalers",
    },
    {
      NAICS22: "424910",
      "INDEX ITEM DESCRIPTION":
        "Mineral supplements, animal, merchant wholesalers",
    },
    {
      NAICS22: "424910",
      "INDEX ITEM DESCRIPTION": "Mulch merchant wholesalers",
    },
    {
      NAICS22: "424910",
      "INDEX ITEM DESCRIPTION": "Pesticides, agricultural, merchant wholesalers",
    },
    {
      NAICS22: "424910",
      "INDEX ITEM DESCRIPTION": "Phosphate rock, ground, merchant wholesalers",
    },
    {
      NAICS22: "424910",
      "INDEX ITEM DESCRIPTION": "Plant bulbs merchant wholesalers",
    },
    {
      NAICS22: "424910",
      "INDEX ITEM DESCRIPTION": "Produce containers merchant wholesalers",
    },
    {
      NAICS22: "424910",
      "INDEX ITEM DESCRIPTION": "Saddlery merchant wholesalers",
    },
    {
      NAICS22: "424910",
      "INDEX ITEM DESCRIPTION":
        "Seeds (e.g., field, flower, garden) merchant wholesalers",
    },
    {
      NAICS22: "424910",
      "INDEX ITEM DESCRIPTION": "Straw merchant wholesalers",
    },
    {
      NAICS22: "424910",
      "INDEX ITEM DESCRIPTION":
        "Tack (e.g., harnesses, saddlery) merchant wholesalers",
    },
    {
      NAICS22: "424910",
      "INDEX ITEM DESCRIPTION": "Vegetable dusts and sprays merchant wholesalers",
    },
    {
      NAICS22: "424910",
      "INDEX ITEM DESCRIPTION": "Weed killers merchant wholesalers",
    },
    {
      NAICS22: "424920",
      "INDEX ITEM DESCRIPTION": "Antique book merchant wholesalers",
    },
    {
      NAICS22: "424920",
      "INDEX ITEM DESCRIPTION": "Atlases merchant wholesalers",
    },
    {
      NAICS22: "424920",
      "INDEX ITEM DESCRIPTION": "Books merchant wholesalers",
    },
    {
      NAICS22: "424920",
      "INDEX ITEM DESCRIPTION": "Brochures merchant wholesalers",
    },
    {
      NAICS22: "424920",
      "INDEX ITEM DESCRIPTION": "Magazines merchant wholesalers",
    },
    {
      NAICS22: "424920",
      "INDEX ITEM DESCRIPTION":
        "Maps (except globe, school, wall) merchant wholesalers",
    },
    {
      NAICS22: "424920",
      "INDEX ITEM DESCRIPTION": "Newspaper agencies merchant wholesalers",
    },
    {
      NAICS22: "424920",
      "INDEX ITEM DESCRIPTION": "Newspapers merchant wholesalers",
    },
    {
      NAICS22: "424920",
      "INDEX ITEM DESCRIPTION": "Pamphlets merchant wholesalers",
    },
    {
      NAICS22: "424920",
      "INDEX ITEM DESCRIPTION": "Periodicals merchant wholesalers",
    },
    {
      NAICS22: "424920",
      "INDEX ITEM DESCRIPTION": "Textbooks merchant wholesalers",
    },
    {
      NAICS22: "424930",
      "INDEX ITEM DESCRIPTION":
        "Artificial flowers and plants merchant wholesalers",
    },
    {
      NAICS22: "424930",
      "INDEX ITEM DESCRIPTION": "Bedding plants merchant wholesalers",
    },
    {
      NAICS22: "424930",
      "INDEX ITEM DESCRIPTION": "Florist's supplies merchant wholesalers",
    },
    {
      NAICS22: "424930",
      "INDEX ITEM DESCRIPTION": "Flowers merchant wholesalers",
    },
    {
      NAICS22: "424930",
      "INDEX ITEM DESCRIPTION":
        "Nursery stock (except plant bulbs, seeds) merchant wholesalers",
    },
    {
      NAICS22: "424930",
      "INDEX ITEM DESCRIPTION":
        "Ornamental plants and flowers merchant wholesalers",
    },
    {
      NAICS22: "424930",
      "INDEX ITEM DESCRIPTION": "Plants, potted, merchant wholesalers",
    },
    {
      NAICS22: "424930",
      "INDEX ITEM DESCRIPTION": "Soil, top and potting, merchant wholesalers",
    },
    {
      NAICS22: "424930",
      "INDEX ITEM DESCRIPTION": "Trees merchant wholesalers",
    },
    {
      NAICS22: "424940",
      "INDEX ITEM DESCRIPTION": "Chewing tobacco merchant wholesalers",
    },
    {
      NAICS22: "424940",
      "INDEX ITEM DESCRIPTION": "Cigarettes merchant wholesalers",
    },
    {
      NAICS22: "424940",
      "INDEX ITEM DESCRIPTION": "Cigars merchant wholesalers",
    },
    {
      NAICS22: "424940",
      "INDEX ITEM DESCRIPTION": "Electronic cigarettes merchant wholesalers",
    },
    {
      NAICS22: "424940",
      "INDEX ITEM DESCRIPTION": "Pipe tobacco merchant wholesalers",
    },
    {
      NAICS22: "424940",
      "INDEX ITEM DESCRIPTION": "Snuff merchant wholesalers",
    },
    {
      NAICS22: "424940",
      "INDEX ITEM DESCRIPTION": "Tobacco (except leaf) merchant wholesalers",
    },
    {
      NAICS22: "424940",
      "INDEX ITEM DESCRIPTION": "Tobacco products merchant wholesalers",
    },
    {
      NAICS22: "424950",
      "INDEX ITEM DESCRIPTION": "Automotive paints merchant wholesalers",
    },
    {
      NAICS22: "424950",
      "INDEX ITEM DESCRIPTION": "Calcimines merchant wholesalers",
    },
    {
      NAICS22: "424950",
      "INDEX ITEM DESCRIPTION": "Enamels merchant wholesalers",
    },
    {
      NAICS22: "424950",
      "INDEX ITEM DESCRIPTION": "Lacquers merchant wholesalers",
    },
    {
      NAICS22: "424950",
      "INDEX ITEM DESCRIPTION": "Paint removers merchant wholesalers",
    },
    {
      NAICS22: "424950",
      "INDEX ITEM DESCRIPTION": "Paint rollers merchant wholesalers",
    },
    {
      NAICS22: "424950",
      "INDEX ITEM DESCRIPTION": "Paint thinners merchant wholesalers",
    },
    {
      NAICS22: "424950",
      "INDEX ITEM DESCRIPTION": "Paintbrushes merchant wholesalers",
    },
    {
      NAICS22: "424950",
      "INDEX ITEM DESCRIPTION":
        "Painter's supplies (except artists', turpentine) merchant wholesalers",
    },
    {
      NAICS22: "424950",
      "INDEX ITEM DESCRIPTION": "Paints (except artists') merchant wholesalers",
    },
    {
      NAICS22: "424950",
      "INDEX ITEM DESCRIPTION": "Pigments, paint, merchant wholesalers",
    },
    {
      NAICS22: "424950",
      "INDEX ITEM DESCRIPTION": "Shellac merchant wholesalers",
    },
    {
      NAICS22: "424950",
      "INDEX ITEM DESCRIPTION":
        "Spray painting equipment (except industrial-type) merchant wholesalers",
    },
    {
      NAICS22: "424950",
      "INDEX ITEM DESCRIPTION": "Stains merchant wholesalers",
    },
    {
      NAICS22: "424950",
      "INDEX ITEM DESCRIPTION": "Varnishes merchant wholesalers",
    },
    {
      NAICS22: "424950",
      "INDEX ITEM DESCRIPTION":
        "Wall coverings (e.g., fabric, plastics) merchant wholesalers",
    },
    {
      NAICS22: "424950",
      "INDEX ITEM DESCRIPTION": "Wallpaper merchant wholesalers",
    },
    {
      NAICS22: "424950",
      "INDEX ITEM DESCRIPTION": "Wood paste merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Aquarium fish and supplies merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Art goods merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Artificial Christmas trees merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Artists' supplies merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Awnings, canvas, merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Backpacks, textile, merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Bags, textile, merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Bait, live, merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Baskets merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Brushes, artists', merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Burlap merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Candles merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Canvas products merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Cats merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Chamois, leather, merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Charcoal merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Christmas ornaments merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION":
        "Christmas trees (e.g., artificial, cut) merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Cigarette lighters merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Clothes hangers merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Cotton (except raw) merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Crude rubber merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Curios merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Dogs merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Dressed furs and skins merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Felt merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Fish, tropical, merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Foam rubber merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Furs, dressed, merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION":
        "General merchandise, nondurable goods, merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION":
        "Greases, inedible animal and vegetable, merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Hairbrushes merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION":
        "Hairpieces (e.g., toupees, wigs, wiglets) merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION":
        "Handles (e.g., broom, mop, paint) merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Ice (except dry ice) merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Jewelry boxes merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION":
        "Leather cut stock (except boot, shoe) merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION":
        "Leather goods (except belting, footwear, handbags, gloves, luggage) merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION":
        "Lighters, cigar and cigarette, merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Live bait merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Matches and match books merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Music, sheet, merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Novelties merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION":
        "Oils, inedible, animal or vegetable, merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Oilseed cake and meal merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Paints, artist's, merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION":
        "Pet supplies (except pet food) merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Pets merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION":
        "Piece goods, burlap and felt, merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Plant food merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION":
        "Plastics foam products (except disposable and packaging) merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Pottery, novelty, merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION":
        "Pre-paid calling card distribution, merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Rennets merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Rubber, crude, merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Sawdust merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Sheet music merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Ship chandler merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Skins, dressed, merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Smokers' supplies merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Sponges merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION":
        "Statuary (except religious) merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Tents (except camping) merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Textile bags merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Toupees merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Tropical fish merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Vegetable cake and meal merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION":
        "Vegetable oils (except cooking) merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Wigs merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Wood carvings merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Wood pulp merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Worms merchant wholesalers",
    },
    {
      NAICS22: "424990",
      "INDEX ITEM DESCRIPTION": "Yarns, industrial, merchant wholesalers",
    },
    {
      NAICS22: "425120",
      "INDEX ITEM DESCRIPTION":
        "Agents and brokers, durable goods, wholesale trade",
    },
    {
      NAICS22: "425120",
      "INDEX ITEM DESCRIPTION":
        "Agents and brokers, nondurable goods, wholesale trade",
    },
    {
      NAICS22: "425120",
      "INDEX ITEM DESCRIPTION":
        "Automobile auction agents and brokers, wholesale trade",
    },
    {
      NAICS22: "425120",
      "INDEX ITEM DESCRIPTION":
        "Business to business electronic markets, durable goods, wholesale trade",
    },
    {
      NAICS22: "425120",
      "INDEX ITEM DESCRIPTION":
        "Business to business electronic markets, nondurable goods, wholesale trade",
    },
    {
      NAICS22: "425120",
      "INDEX ITEM DESCRIPTION":
        "Durable goods agents and brokers, wholesale trade",
    },
    {
      NAICS22: "425120",
      "INDEX ITEM DESCRIPTION":
        "Durable goods business to business electronic markets, wholesale trade",
    },
    {
      NAICS22: "425120",
      "INDEX ITEM DESCRIPTION":
        "Electronic markets, durable goods, business to business, wholesale trade",
    },
    {
      NAICS22: "425120",
      "INDEX ITEM DESCRIPTION":
        "Electronic markets, nondurable goods, business to business, wholesale trade",
    },
    {
      NAICS22: "425120",
      "INDEX ITEM DESCRIPTION":
        "Group purchasing organizations (acting as agents for goods distribution)",
    },
    {
      NAICS22: "425120",
      "INDEX ITEM DESCRIPTION":
        "Nondurable goods agents and brokers, wholesale trade",
    },
    {
      NAICS22: "425120",
      "INDEX ITEM DESCRIPTION":
        "Nondurable goods business to business electronic markets, wholesale trade",
    },
    {
      NAICS22: "425120",
      "INDEX ITEM DESCRIPTION": "Petroleum brokers",
    },
    {
      NAICS22: "441110",
      "INDEX ITEM DESCRIPTION": "Automobile dealers, new only or new and used",
    },
    {
      NAICS22: "441110",
      "INDEX ITEM DESCRIPTION":
        "Light utility truck dealers, new only or new and used",
    },
    {
      NAICS22: "441110",
      "INDEX ITEM DESCRIPTION": "New car dealers",
    },
    {
      NAICS22: "441120",
      "INDEX ITEM DESCRIPTION": "Antique auto dealers",
    },
    {
      NAICS22: "441120",
      "INDEX ITEM DESCRIPTION": "Automobile dealers, used only",
    },
    {
      NAICS22: "441120",
      "INDEX ITEM DESCRIPTION": "Light utility truck dealers, used only",
    },
    {
      NAICS22: "441120",
      "INDEX ITEM DESCRIPTION": "Used car dealers",
    },
    {
      NAICS22: "441210",
      "INDEX ITEM DESCRIPTION": "Camper dealers, recreational",
    },
    {
      NAICS22: "441210",
      "INDEX ITEM DESCRIPTION": "Camper parts and accessories stores",
    },
    {
      NAICS22: "441210",
      "INDEX ITEM DESCRIPTION": "Motor home dealers",
    },
    {
      NAICS22: "441210",
      "INDEX ITEM DESCRIPTION": "Recreational vehicle (RV) dealers",
    },
    {
      NAICS22: "441210",
      "INDEX ITEM DESCRIPTION":
        "Recreational vehicle (RV) parts and accessories stores",
    },
    {
      NAICS22: "441210",
      "INDEX ITEM DESCRIPTION": "RV dealers",
    },
    {
      NAICS22: "441210",
      "INDEX ITEM DESCRIPTION": "Travel trailer dealers",
    },
    {
      NAICS22: "441210",
      "INDEX ITEM DESCRIPTION": "Used recreational vehicle (RV) dealers",
    },
    {
      NAICS22: "441222",
      "INDEX ITEM DESCRIPTION": "Boat dealers, new and used",
    },
    {
      NAICS22: "441222",
      "INDEX ITEM DESCRIPTION": "Boat trailer dealers",
    },
    {
      NAICS22: "441222",
      "INDEX ITEM DESCRIPTION": "Marine supply dealers",
    },
    {
      NAICS22: "441222",
      "INDEX ITEM DESCRIPTION": "Outboard motor dealers",
    },
    {
      NAICS22: "441222",
      "INDEX ITEM DESCRIPTION": "Power boat dealers",
    },
    {
      NAICS22: "441222",
      "INDEX ITEM DESCRIPTION": "Sailboat dealers",
    },
    {
      NAICS22: "441222",
      "INDEX ITEM DESCRIPTION": "Used boat dealers",
    },
    {
      NAICS22: "441227",
      "INDEX ITEM DESCRIPTION": "Aircraft dealers",
    },
    {
      NAICS22: "441227",
      "INDEX ITEM DESCRIPTION": "All-terrain vehicle (ATV) dealers",
    },
    {
      NAICS22: "441227",
      "INDEX ITEM DESCRIPTION": "Bicycle shops, motorized",
    },
    {
      NAICS22: "441227",
      "INDEX ITEM DESCRIPTION": "Golf cart dealers, powered",
    },
    {
      NAICS22: "441227",
      "INDEX ITEM DESCRIPTION": "Horse trailer dealers",
    },
    {
      NAICS22: "441227",
      "INDEX ITEM DESCRIPTION": "Moped dealers",
    },
    {
      NAICS22: "441227",
      "INDEX ITEM DESCRIPTION": "Motor scooters dealers",
    },
    {
      NAICS22: "441227",
      "INDEX ITEM DESCRIPTION": "Motorbike dealers",
    },
    {
      NAICS22: "441227",
      "INDEX ITEM DESCRIPTION": "Motorcycle dealers",
    },
    {
      NAICS22: "441227",
      "INDEX ITEM DESCRIPTION": "Motorcycle parts and accessories dealers",
    },
    {
      NAICS22: "441227",
      "INDEX ITEM DESCRIPTION":
        "Off-road all-terrain vehicles (ATVs), wheeled or tracked, dealers",
    },
    {
      NAICS22: "441227",
      "INDEX ITEM DESCRIPTION": "Personal watercraft dealers",
    },
    {
      NAICS22: "441227",
      "INDEX ITEM DESCRIPTION": "Snowmobile dealers",
    },
    {
      NAICS22: "441227",
      "INDEX ITEM DESCRIPTION": "Used aircraft dealers",
    },
    {
      NAICS22: "441227",
      "INDEX ITEM DESCRIPTION": "Used motorcycle dealers",
    },
    {
      NAICS22: "441227",
      "INDEX ITEM DESCRIPTION": "Used utility trailer dealers",
    },
    {
      NAICS22: "441227",
      "INDEX ITEM DESCRIPTION": "Utility trailer dealers",
    },
    {
      NAICS22: "441330",
      "INDEX ITEM DESCRIPTION": "Auto supply stores",
    },
    {
      NAICS22: "441330",
      "INDEX ITEM DESCRIPTION": "Automobile parts dealers",
    },
    {
      NAICS22: "441330",
      "INDEX ITEM DESCRIPTION": "Automotive audio equipment stores",
    },
    {
      NAICS22: "441330",
      "INDEX ITEM DESCRIPTION": "Automotive parts and supply stores",
    },
    {
      NAICS22: "441330",
      "INDEX ITEM DESCRIPTION": "Automotive parts dealers, used",
    },
    {
      NAICS22: "441330",
      "INDEX ITEM DESCRIPTION": "Batteries, automotive, dealers",
    },
    {
      NAICS22: "441330",
      "INDEX ITEM DESCRIPTION": "Parts and accessories dealers, automotive",
    },
    {
      NAICS22: "441330",
      "INDEX ITEM DESCRIPTION": "Stereo stores, automotive",
    },
    {
      NAICS22: "441330",
      "INDEX ITEM DESCRIPTION": "Truck cap stores",
    },
    {
      NAICS22: "441330",
      "INDEX ITEM DESCRIPTION": "Used automotive parts stores",
    },
    {
      NAICS22: "441340",
      "INDEX ITEM DESCRIPTION": "Automotive tire dealers",
    },
    {
      NAICS22: "441340",
      "INDEX ITEM DESCRIPTION": "Tire dealers, automotive",
    },
    {
      NAICS22: "441340",
      "INDEX ITEM DESCRIPTION":
        "Truck tires and tubes dealers (except heavy truck)",
    },
    {
      NAICS22: "441340",
      "INDEX ITEM DESCRIPTION": "Used automotive tire dealers",
    },
    {
      NAICS22: "441340",
      "INDEX ITEM DESCRIPTION": "Used tire dealers",
    },
    {
      NAICS22: "444110",
      "INDEX ITEM DESCRIPTION": "Home centers, building materials",
    },
    {
      NAICS22: "444110",
      "INDEX ITEM DESCRIPTION": "Home improvement centers",
    },
    {
      NAICS22: "444120",
      "INDEX ITEM DESCRIPTION": "Paint stores",
    },
    {
      NAICS22: "444120",
      "INDEX ITEM DESCRIPTION": "Wallpaper and wall coverings stores",
    },
    {
      NAICS22: "444140",
      "INDEX ITEM DESCRIPTION": "Handtools, power-driven, stores",
    },
    {
      NAICS22: "444140",
      "INDEX ITEM DESCRIPTION": "Hardware stores",
    },
    {
      NAICS22: "444140",
      "INDEX ITEM DESCRIPTION": "Tool stores, power and hand (except outdoor)",
    },
    {
      NAICS22: "444180",
      "INDEX ITEM DESCRIPTION": "Building materials supply dealers",
    },
    {
      NAICS22: "444180",
      "INDEX ITEM DESCRIPTION":
        "Cabinet stores, kitchen (except custom), to be installed",
    },
    {
      NAICS22: "444180",
      "INDEX ITEM DESCRIPTION": "Ceiling fan stores",
    },
    {
      NAICS22: "444180",
      "INDEX ITEM DESCRIPTION": "Ceramic tile stores",
    },
    {
      NAICS22: "444180",
      "INDEX ITEM DESCRIPTION": "Door stores",
    },
    {
      NAICS22: "444180",
      "INDEX ITEM DESCRIPTION": "Electrical supply stores",
    },
    {
      NAICS22: "444180",
      "INDEX ITEM DESCRIPTION": "Fencing dealers",
    },
    {
      NAICS22: "444180",
      "INDEX ITEM DESCRIPTION":
        "Floor covering stores, hardwood or ceramic tile only",
    },
    {
      NAICS22: "444180",
      "INDEX ITEM DESCRIPTION": "Garage door dealers",
    },
    {
      NAICS22: "444180",
      "INDEX ITEM DESCRIPTION": "Glass (except automotive) stores",
    },
    {
      NAICS22: "444180",
      "INDEX ITEM DESCRIPTION": "Hardwood flooring dealers",
    },
    {
      NAICS22: "444180",
      "INDEX ITEM DESCRIPTION": "Kitchen cabinet (except custom) stores",
    },
    {
      NAICS22: "444180",
      "INDEX ITEM DESCRIPTION": "Lighting fixture (except electric lamps) stores",
    },
    {
      NAICS22: "444180",
      "INDEX ITEM DESCRIPTION": "Lumber retailing yards",
    },
    {
      NAICS22: "444180",
      "INDEX ITEM DESCRIPTION": "Masonry (e.g., block, brick, stone) dealers",
    },
    {
      NAICS22: "444180",
      "INDEX ITEM DESCRIPTION": "Plumbing supply stores",
    },
    {
      NAICS22: "444180",
      "INDEX ITEM DESCRIPTION":
        "Prefabricated building (except manufactured home) dealers",
    },
    {
      NAICS22: "444180",
      "INDEX ITEM DESCRIPTION": "Prefabricated shed dealers",
    },
    {
      NAICS22: "444180",
      "INDEX ITEM DESCRIPTION": "Roofing material dealers",
    },
    {
      NAICS22: "444180",
      "INDEX ITEM DESCRIPTION": "Siding dealers",
    },
    {
      NAICS22: "444180",
      "INDEX ITEM DESCRIPTION": "Tile stores, ceramic",
    },
    {
      NAICS22: "444180",
      "INDEX ITEM DESCRIPTION": "Window stores",
    },
    {
      NAICS22: "444230",
      "INDEX ITEM DESCRIPTION": "Garden power equipment stores",
    },
    {
      NAICS22: "444230",
      "INDEX ITEM DESCRIPTION": "Lawn power equipment stores",
    },
    {
      NAICS22: "444230",
      "INDEX ITEM DESCRIPTION": "Power equipment stores, outdoor",
    },
    {
      NAICS22: "444240",
      "INDEX ITEM DESCRIPTION": "Christmas trees, cut, direct selling",
    },
    {
      NAICS22: "444240",
      "INDEX ITEM DESCRIPTION": "Farm supply stores",
    },
    {
      NAICS22: "444240",
      "INDEX ITEM DESCRIPTION": "Feed stores (except pet)",
    },
    {
      NAICS22: "444240",
      "INDEX ITEM DESCRIPTION": "Garden centers",
    },
    {
      NAICS22: "444240",
      "INDEX ITEM DESCRIPTION": "Lawn supply stores",
    },
    {
      NAICS22: "444240",
      "INDEX ITEM DESCRIPTION":
        "Nurseries, retail, stock primarily grown off premises",
    },
    {
      NAICS22: "444240",
      "INDEX ITEM DESCRIPTION":
        "Nursery and garden centers without tree production",
    },
    {
      NAICS22: "445110",
      "INDEX ITEM DESCRIPTION": "Commissaries, primarily groceries",
    },
    {
      NAICS22: "445110",
      "INDEX ITEM DESCRIPTION":
        "Delicatessens primarily retailing a range of grocery items and meats",
    },
    {
      NAICS22: "445110",
      "INDEX ITEM DESCRIPTION": "Food (i.e., groceries) stores",
    },
    {
      NAICS22: "445110",
      "INDEX ITEM DESCRIPTION": "Grocery stores",
    },
    {
      NAICS22: "445110",
      "INDEX ITEM DESCRIPTION": "Supermarkets",
    },
    {
      NAICS22: "445131",
      "INDEX ITEM DESCRIPTION":
        "Convenience food stores (except those with fuel pumps)",
    },
    {
      NAICS22: "445132",
      "INDEX ITEM DESCRIPTION": "Automatic merchandising machine operators",
    },
    {
      NAICS22: "445132",
      "INDEX ITEM DESCRIPTION": "Vending machine merchandisers, sale of products",
    },
    {
      NAICS22: "445230",
      "INDEX ITEM DESCRIPTION": "Fruit and vegetable stands, permanent",
    },
    {
      NAICS22: "445230",
      "INDEX ITEM DESCRIPTION": "Fruit markets",
    },
    {
      NAICS22: "445230",
      "INDEX ITEM DESCRIPTION": "Fruit stands, permanent",
    },
    {
      NAICS22: "445230",
      "INDEX ITEM DESCRIPTION": "Fruit stands, temporary",
    },
    {
      NAICS22: "445230",
      "INDEX ITEM DESCRIPTION": "Produce markets",
    },
    {
      NAICS22: "445230",
      "INDEX ITEM DESCRIPTION": "Produce stands, permanent",
    },
    {
      NAICS22: "445230",
      "INDEX ITEM DESCRIPTION": "Produce stands, temporary",
    },
    {
      NAICS22: "445230",
      "INDEX ITEM DESCRIPTION": "Vegetable markets",
    },
    {
      NAICS22: "445240",
      "INDEX ITEM DESCRIPTION": "Baked ham stores",
    },
    {
      NAICS22: "445240",
      "INDEX ITEM DESCRIPTION": "Butcher shops",
    },
    {
      NAICS22: "445240",
      "INDEX ITEM DESCRIPTION":
        "Delicatessens (except grocery store, restaurants)",
    },
    {
      NAICS22: "445240",
      "INDEX ITEM DESCRIPTION": "Frozen meat stores",
    },
    {
      NAICS22: "445240",
      "INDEX ITEM DESCRIPTION": "Locker meat provisioners, direct selling",
    },
    {
      NAICS22: "445240",
      "INDEX ITEM DESCRIPTION": "Meat markets",
    },
    {
      NAICS22: "445240",
      "INDEX ITEM DESCRIPTION": "Poultry dealers",
    },
    {
      NAICS22: "445250",
      "INDEX ITEM DESCRIPTION": "Fish markets",
    },
    {
      NAICS22: "445250",
      "INDEX ITEM DESCRIPTION": "Seafood markets",
    },
    {
      NAICS22: "445291",
      "INDEX ITEM DESCRIPTION": "Baked goods (not made on premises) stores",
    },
    {
      NAICS22: "445292",
      "INDEX ITEM DESCRIPTION": "Candy stores, packaged, retailing only",
    },
    {
      NAICS22: "445292",
      "INDEX ITEM DESCRIPTION": "Confectionery stores, packaged, retailing only",
    },
    {
      NAICS22: "445292",
      "INDEX ITEM DESCRIPTION": "Nut (i.e., packaged) stores",
    },
    {
      NAICS22: "445298",
      "INDEX ITEM DESCRIPTION": "Bottled water providers, direct selling",
    },
    {
      NAICS22: "445298",
      "INDEX ITEM DESCRIPTION": "Coffee and tea (i.e., packaged) stores",
    },
    {
      NAICS22: "445298",
      "INDEX ITEM DESCRIPTION": "Dairy product stores",
    },
    {
      NAICS22: "445298",
      "INDEX ITEM DESCRIPTION": "Fix-and-freeze meal stores",
    },
    {
      NAICS22: "445298",
      "INDEX ITEM DESCRIPTION":
        "Frozen food and freezer meal plan providers, direct selling",
    },
    {
      NAICS22: "445298",
      "INDEX ITEM DESCRIPTION": "Gourmet food stores",
    },
    {
      NAICS22: "445298",
      "INDEX ITEM DESCRIPTION": "Ice cream (i.e., packaged) stores",
    },
    {
      NAICS22: "445298",
      "INDEX ITEM DESCRIPTION": "Meal assembly retailers",
    },
    {
      NAICS22: "445298",
      "INDEX ITEM DESCRIPTION": "Soft drink stores, bottled",
    },
    {
      NAICS22: "445298",
      "INDEX ITEM DESCRIPTION": "Specialty food stores",
    },
    {
      NAICS22: "445298",
      "INDEX ITEM DESCRIPTION": "Spice stores",
    },
    {
      NAICS22: "445298",
      "INDEX ITEM DESCRIPTION": "Take-and-bake meal stores",
    },
    {
      NAICS22: "445298",
      "INDEX ITEM DESCRIPTION": "Take-and-bake pizza shops",
    },
    {
      NAICS22: "445298",
      "INDEX ITEM DESCRIPTION": "Tea and coffee (i.e., packaged) stores",
    },
    {
      NAICS22: "445298",
      "INDEX ITEM DESCRIPTION": "Water stores, bottled",
    },
    {
      NAICS22: "445320",
      "INDEX ITEM DESCRIPTION": "Beer stores, packaged",
    },
    {
      NAICS22: "445320",
      "INDEX ITEM DESCRIPTION": "Duty free liquor shops",
    },
    {
      NAICS22: "445320",
      "INDEX ITEM DESCRIPTION": "Liquor stores, package",
    },
    {
      NAICS22: "445320",
      "INDEX ITEM DESCRIPTION": "Package stores (i.e., liquor)",
    },
    {
      NAICS22: "445320",
      "INDEX ITEM DESCRIPTION": "Wine shops, packaged",
    },
    {
      NAICS22: "449110",
      "INDEX ITEM DESCRIPTION": "Bed stores, retail",
    },
    {
      NAICS22: "449110",
      "INDEX ITEM DESCRIPTION":
        "Furniture and appliance stores (i.e., primarily retailing furniture)",
    },
    {
      NAICS22: "449110",
      "INDEX ITEM DESCRIPTION":
        "Furniture stores (e.g., household, office, outdoor)",
    },
    {
      NAICS22: "449110",
      "INDEX ITEM DESCRIPTION": "Mattress stores (including waterbeds)",
    },
    {
      NAICS22: "449110",
      "INDEX ITEM DESCRIPTION": "Office furniture stores",
    },
    {
      NAICS22: "449121",
      "INDEX ITEM DESCRIPTION": "Carpet stores",
    },
    {
      NAICS22: "449121",
      "INDEX ITEM DESCRIPTION":
        "Floor covering stores (except hardwood or ceramic tile only)",
    },
    {
      NAICS22: "449121",
      "INDEX ITEM DESCRIPTION": "Rug stores",
    },
    {
      NAICS22: "449122",
      "INDEX ITEM DESCRIPTION": "Curtain and drapery stores, packaged",
    },
    {
      NAICS22: "449122",
      "INDEX ITEM DESCRIPTION": "Window treatment stores",
    },
    {
      NAICS22: "449129",
      "INDEX ITEM DESCRIPTION": "Bath shops",
    },
    {
      NAICS22: "449129",
      "INDEX ITEM DESCRIPTION": "Chinaware stores",
    },
    {
      NAICS22: "449129",
      "INDEX ITEM DESCRIPTION": "Custom picture frame shops",
    },
    {
      NAICS22: "449129",
      "INDEX ITEM DESCRIPTION": "Glassware stores",
    },
    {
      NAICS22: "449129",
      "INDEX ITEM DESCRIPTION": "Home furnishings stores",
    },
    {
      NAICS22: "449129",
      "INDEX ITEM DESCRIPTION": "Housewares stores",
    },
    {
      NAICS22: "449129",
      "INDEX ITEM DESCRIPTION": "Kitchenware stores",
    },
    {
      NAICS22: "449129",
      "INDEX ITEM DESCRIPTION": "Lamp shops, electric",
    },
    {
      NAICS22: "449129",
      "INDEX ITEM DESCRIPTION": "Linen stores",
    },
    {
      NAICS22: "449129",
      "INDEX ITEM DESCRIPTION": "Picture frame shops, custom",
    },
    {
      NAICS22: "449129",
      "INDEX ITEM DESCRIPTION": "Wood-burning stove stores",
    },
    {
      NAICS22: "449210",
      "INDEX ITEM DESCRIPTION": "Appliance stores, household-type",
    },
    {
      NAICS22: "449210",
      "INDEX ITEM DESCRIPTION": "Audio equipment stores (except automotive)",
    },
    {
      NAICS22: "449210",
      "INDEX ITEM DESCRIPTION": "Camera shops, photographic",
    },
    {
      NAICS22: "449210",
      "INDEX ITEM DESCRIPTION": "Cellular telephone accessories stores",
    },
    {
      NAICS22: "449210",
      "INDEX ITEM DESCRIPTION": "Citizens' band (CB) radio stores",
    },
    {
      NAICS22: "449210",
      "INDEX ITEM DESCRIPTION": "Computer equipment stores",
    },
    {
      NAICS22: "449210",
      "INDEX ITEM DESCRIPTION":
        "Computer software, prepackaged, new, mail-order houses",
    },
    {
      NAICS22: "449210",
      "INDEX ITEM DESCRIPTION": "Computer stores",
    },
    {
      NAICS22: "449210",
      "INDEX ITEM DESCRIPTION":
        "Consumer-type electronic stores (e.g., televisions, computers, cameras)",
    },
    {
      NAICS22: "449210",
      "INDEX ITEM DESCRIPTION": "Electronic part and component stores",
    },
    {
      NAICS22: "449210",
      "INDEX ITEM DESCRIPTION": "Household-type appliance stores",
    },
    {
      NAICS22: "449210",
      "INDEX ITEM DESCRIPTION":
        "Music retailers (e.g., downloadable digital music files (without production or publishing))",
    },
    {
      NAICS22: "449210",
      "INDEX ITEM DESCRIPTION":
        "Music stores (e.g., cassette, compact disc, record, tape)",
    },
    {
      NAICS22: "449210",
      "INDEX ITEM DESCRIPTION": "Photographic supply stores",
    },
    {
      NAICS22: "449210",
      "INDEX ITEM DESCRIPTION":
        "Prerecorded tape, compact disc, and record, new, mail-order houses",
    },
    {
      NAICS22: "449210",
      "INDEX ITEM DESCRIPTION": "Radio and television stores",
    },
    {
      NAICS22: "449210",
      "INDEX ITEM DESCRIPTION": "Record stores, new",
    },
    {
      NAICS22: "449210",
      "INDEX ITEM DESCRIPTION": "Sewing machine stores, household-type",
    },
    {
      NAICS22: "449210",
      "INDEX ITEM DESCRIPTION":
        "Software retailers (e.g., downloadable computer software (without publishing))",
    },
    {
      NAICS22: "449210",
      "INDEX ITEM DESCRIPTION": "Software stores, computer",
    },
    {
      NAICS22: "449210",
      "INDEX ITEM DESCRIPTION": "Stereo stores (except automotive)",
    },
    {
      NAICS22: "449210",
      "INDEX ITEM DESCRIPTION": "Television and radio stores",
    },
    {
      NAICS22: "449210",
      "INDEX ITEM DESCRIPTION": "TV (television) stores",
    },
    {
      NAICS22: "449210",
      "INDEX ITEM DESCRIPTION": "Vacuum cleaner stores, household-type",
    },
    {
      NAICS22: "449210",
      "INDEX ITEM DESCRIPTION": "Video game software stores",
    },
    {
      NAICS22: "449210",
      "INDEX ITEM DESCRIPTION": "Video tape stores",
    },
    {
      NAICS22: "455110",
      "INDEX ITEM DESCRIPTION": "Department stores",
    },
    {
      NAICS22: "455110",
      "INDEX ITEM DESCRIPTION": "Internet department store sites",
    },
    {
      NAICS22: "455211",
      "INDEX ITEM DESCRIPTION": "Internet supercenter sites",
    },
    {
      NAICS22: "455211",
      "INDEX ITEM DESCRIPTION": "Internet warehouse club sites",
    },
    {
      NAICS22: "455211",
      "INDEX ITEM DESCRIPTION": "Supercenters",
    },
    {
      NAICS22: "455211",
      "INDEX ITEM DESCRIPTION":
        "Superstores (i.e., food and general merchandise)",
    },
    {
      NAICS22: "455211",
      "INDEX ITEM DESCRIPTION":
        "Warehouse clubs (i.e., food and general merchandise)",
    },
    {
      NAICS22: "455219",
      "INDEX ITEM DESCRIPTION":
        "Auctions, general merchandise (new and used), Internet retail",
    },
    {
      NAICS22: "455219",
      "INDEX ITEM DESCRIPTION": "Dollar stores",
    },
    {
      NAICS22: "455219",
      "INDEX ITEM DESCRIPTION":
        "Electronic auctions, general merchandise (new and used), retail",
    },
    {
      NAICS22: "455219",
      "INDEX ITEM DESCRIPTION":
        "General merchandise (new and used) auction houses",
    },
    {
      NAICS22: "455219",
      "INDEX ITEM DESCRIPTION": "General stores",
    },
    {
      NAICS22: "455219",
      "INDEX ITEM DESCRIPTION": "Home and auto supply stores",
    },
    {
      NAICS22: "455219",
      "INDEX ITEM DESCRIPTION":
        "Internet auctions, general merchandise (new and used), retail",
    },
    {
      NAICS22: "455219",
      "INDEX ITEM DESCRIPTION":
        "Internet retail sales sites (except department store, warehouse club, and supercenter sites), new general merchandise",
    },
    {
      NAICS22: "455219",
      "INDEX ITEM DESCRIPTION": "Limited price variety stores",
    },
    {
      NAICS22: "455219",
      "INDEX ITEM DESCRIPTION": "Trading posts, general merchandise",
    },
    {
      NAICS22: "455219",
      "INDEX ITEM DESCRIPTION": "Variety stores",
    },
    {
      NAICS22: "456110",
      "INDEX ITEM DESCRIPTION": "Apothecaries",
    },
    {
      NAICS22: "456110",
      "INDEX ITEM DESCRIPTION": "Drug stores",
    },
    {
      NAICS22: "456110",
      "INDEX ITEM DESCRIPTION":
        "Institutional pharmacies, off-site, exclusively on Internet",
    },
    {
      NAICS22: "456110",
      "INDEX ITEM DESCRIPTION": "Institutional pharmacies, off-site, mail-order",
    },
    {
      NAICS22: "456110",
      "INDEX ITEM DESCRIPTION": "Institutional pharmacies, on-site",
    },
    {
      NAICS22: "456110",
      "INDEX ITEM DESCRIPTION": "Pharmacies",
    },
    {
      NAICS22: "456120",
      "INDEX ITEM DESCRIPTION": "Beauty supply stores",
    },
    {
      NAICS22: "456120",
      "INDEX ITEM DESCRIPTION": "Cosmetics stores",
    },
    {
      NAICS22: "456120",
      "INDEX ITEM DESCRIPTION": "Perfume stores",
    },
    {
      NAICS22: "456130",
      "INDEX ITEM DESCRIPTION": "Lens grinding, ophthalmic, in retail stores",
    },
    {
      NAICS22: "456130",
      "INDEX ITEM DESCRIPTION":
        "Optical goods stores (except offices of optometrists, ophthalmologists)",
    },
    {
      NAICS22: "456130",
      "INDEX ITEM DESCRIPTION": "Sunglass stores",
    },
    {
      NAICS22: "456191",
      "INDEX ITEM DESCRIPTION": "Herbal supplement stores",
    },
    {
      NAICS22: "456191",
      "INDEX ITEM DESCRIPTION": "Nutrition (i.e., food supplement) stores",
    },
    {
      NAICS22: "456191",
      "INDEX ITEM DESCRIPTION": "Vitamin stores",
    },
    {
      NAICS22: "456199",
      "INDEX ITEM DESCRIPTION": "Convalescent supply stores",
    },
    {
      NAICS22: "456199",
      "INDEX ITEM DESCRIPTION":
        "Hearing aid stores (except offices of audiologists)",
    },
    {
      NAICS22: "456199",
      "INDEX ITEM DESCRIPTION": "Home health equipment stores",
    },
    {
      NAICS22: "456199",
      "INDEX ITEM DESCRIPTION": "Medical equipment and supplies stores",
    },
    {
      NAICS22: "456199",
      "INDEX ITEM DESCRIPTION": "Personal mobility scooter dealers",
    },
    {
      NAICS22: "456199",
      "INDEX ITEM DESCRIPTION":
        "Prosthetic stores (except offices of prosthetists)",
    },
    {
      NAICS22: "456199",
      "INDEX ITEM DESCRIPTION": "Sick room supply stores",
    },
    {
      NAICS22: "456199",
      "INDEX ITEM DESCRIPTION": "Wheelchair stores",
    },
    {
      NAICS22: "457110",
      "INDEX ITEM DESCRIPTION": "Convenience food with gasoline stations",
    },
    {
      NAICS22: "457110",
      "INDEX ITEM DESCRIPTION": "Gasoline stations with convenience stores",
    },
    {
      NAICS22: "457120",
      "INDEX ITEM DESCRIPTION": "Gasoline stations without convenience stores",
    },
    {
      NAICS22: "457120",
      "INDEX ITEM DESCRIPTION": "Marine service stations",
    },
    {
      NAICS22: "457120",
      "INDEX ITEM DESCRIPTION": "Service stations, gasoline",
    },
    {
      NAICS22: "457120",
      "INDEX ITEM DESCRIPTION": "Truck stops",
    },
    {
      NAICS22: "457210",
      "INDEX ITEM DESCRIPTION": "Alternative fuels, direct selling",
    },
    {
      NAICS22: "457210",
      "INDEX ITEM DESCRIPTION": "Bottled gas dealers, direct selling",
    },
    {
      NAICS22: "457210",
      "INDEX ITEM DESCRIPTION": "Coal dealers, direct selling",
    },
    {
      NAICS22: "457210",
      "INDEX ITEM DESCRIPTION": "Firewood dealers, direct selling",
    },
    {
      NAICS22: "457210",
      "INDEX ITEM DESCRIPTION":
        "Fuel oil (i.e., heating) dealers, direct selling",
    },
    {
      NAICS22: "457210",
      "INDEX ITEM DESCRIPTION": "Heating oil dealers, direct selling",
    },
    {
      NAICS22: "457210",
      "INDEX ITEM DESCRIPTION": "Jet fuel bulk stations, selling for consumption",
    },
    {
      NAICS22: "457210",
      "INDEX ITEM DESCRIPTION":
        "Liquefied petroleum gas (LPG) dealers, direct selling",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "Apparel accessory stores",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION":
        "Apparel stores, children's and infants' clothing",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "Apparel stores, men's and boys' clothing",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "Apparel stores, women's and girls' clothing",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "Baby clothing shops",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "Bridal gown shops (except custom)",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "Clothing accessories stores",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "Clothing stores, children's and infants'",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "Clothing stores, family",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "Clothing stores, men's and boys'",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "Clothing stores, women's and girls'",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "Coat stores",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "Costume jewelry stores",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "Costume stores (including theatrical)",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "Dress shops",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "Family clothing stores",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "Fur apparel stores",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "Furnishings stores, men's and boys'",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "Furnishings stores, women's and girls'",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "Furriers",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "Handbag stores",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "Hat and cap stores",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "Hosiery stores",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "Jewelry stores, costume",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "Leather coat stores",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "Lingerie stores",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "Maternity shops",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "Neckwear stores",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "School uniform stores",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "Sock shops",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "Sports apparel stores (except uniforms)",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "Swimwear stores",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "Tie shops",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "T-shirt shops",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "Uniform stores (except athletic)",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "Unisex clothing stores",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "Western wear stores",
    },
    {
      NAICS22: "458110",
      "INDEX ITEM DESCRIPTION": "Wig and hairpiece stores",
    },
    {
      NAICS22: "458210",
      "INDEX ITEM DESCRIPTION":
        "Athletic shoe (except bowling, golf, cleated) stores",
    },
    {
      NAICS22: "458210",
      "INDEX ITEM DESCRIPTION": "Children's shoe stores",
    },
    {
      NAICS22: "458210",
      "INDEX ITEM DESCRIPTION": "Orthopedic shoes stores",
    },
    {
      NAICS22: "458210",
      "INDEX ITEM DESCRIPTION": "Shoe (except bowling, golf, cleated) stores",
    },
    {
      NAICS22: "458210",
      "INDEX ITEM DESCRIPTION": "Shoe stores, orthopedic",
    },
    {
      NAICS22: "458310",
      "INDEX ITEM DESCRIPTION": "Clock shops",
    },
    {
      NAICS22: "458310",
      "INDEX ITEM DESCRIPTION": "Gem stone shops, precious and semiprecious",
    },
    {
      NAICS22: "458310",
      "INDEX ITEM DESCRIPTION": "Jewelry stores, precious",
    },
    {
      NAICS22: "458310",
      "INDEX ITEM DESCRIPTION": "Watch shops",
    },
    {
      NAICS22: "458320",
      "INDEX ITEM DESCRIPTION": "Leather goods stores",
    },
    {
      NAICS22: "458320",
      "INDEX ITEM DESCRIPTION": "Luggage stores",
    },
    {
      NAICS22: "459110",
      "INDEX ITEM DESCRIPTION":
        "Athletic equipment and supply stores (including uniforms)",
    },
    {
      NAICS22: "459110",
      "INDEX ITEM DESCRIPTION": "Bicycle (except motorized) shops",
    },
    {
      NAICS22: "459110",
      "INDEX ITEM DESCRIPTION": "Bowling equipment and supply stores",
    },
    {
      NAICS22: "459110",
      "INDEX ITEM DESCRIPTION": "Camping and hiking equipment stores",
    },
    {
      NAICS22: "459110",
      "INDEX ITEM DESCRIPTION": "Diving equipment stores",
    },
    {
      NAICS22: "459110",
      "INDEX ITEM DESCRIPTION": "Exercise equipment stores",
    },
    {
      NAICS22: "459110",
      "INDEX ITEM DESCRIPTION": "Fishing supply stores (e.g., bait)",
    },
    {
      NAICS22: "459110",
      "INDEX ITEM DESCRIPTION":
        "Footwear (e.g., bowling, golf, cleated), specialty sports, stores",
    },
    {
      NAICS22: "459110",
      "INDEX ITEM DESCRIPTION": "Golf pro shops",
    },
    {
      NAICS22: "459110",
      "INDEX ITEM DESCRIPTION": "Gun shops",
    },
    {
      NAICS22: "459110",
      "INDEX ITEM DESCRIPTION": "Hunting equipment stores",
    },
    {
      NAICS22: "459110",
      "INDEX ITEM DESCRIPTION": "Outdoor sporting equipment stores",
    },
    {
      NAICS22: "459110",
      "INDEX ITEM DESCRIPTION": "Pro shops (e.g., golf, skiing, tennis)",
    },
    {
      NAICS22: "459110",
      "INDEX ITEM DESCRIPTION": "Saddlery stores",
    },
    {
      NAICS22: "459110",
      "INDEX ITEM DESCRIPTION":
        "Shoe stores, specialty sports footwear (e.g., bowling, golf, cleated)",
    },
    {
      NAICS22: "459110",
      "INDEX ITEM DESCRIPTION": "Sporting goods stores",
    },
    {
      NAICS22: "459110",
      "INDEX ITEM DESCRIPTION":
        "Sports gear stores (e.g., outdoors, scuba, skiing)",
    },
    {
      NAICS22: "459110",
      "INDEX ITEM DESCRIPTION": "Tack (e.g., harnesses, saddlery) shops",
    },
    {
      NAICS22: "459110",
      "INDEX ITEM DESCRIPTION": "Tackle shops (i.e., fishing)",
    },
    {
      NAICS22: "459110",
      "INDEX ITEM DESCRIPTION": "Uniform stores, athletic",
    },
    {
      NAICS22: "459120",
      "INDEX ITEM DESCRIPTION": "Craft supply stores (except needlecraft)",
    },
    {
      NAICS22: "459120",
      "INDEX ITEM DESCRIPTION": "Hobby shops",
    },
    {
      NAICS22: "459120",
      "INDEX ITEM DESCRIPTION": "Magic supply stores",
    },
    {
      NAICS22: "459120",
      "INDEX ITEM DESCRIPTION":
        "Pottery (unfinished pottery to be painted by customer on premises) stores",
    },
    {
      NAICS22: "459120",
      "INDEX ITEM DESCRIPTION": "Toy stores",
    },
    {
      NAICS22: "459120",
      "INDEX ITEM DESCRIPTION": "Toy stores, electronic",
    },
    {
      NAICS22: "459130",
      "INDEX ITEM DESCRIPTION": "Fabric shops",
    },
    {
      NAICS22: "459130",
      "INDEX ITEM DESCRIPTION": "Needlecraft sewing supply stores",
    },
    {
      NAICS22: "459130",
      "INDEX ITEM DESCRIPTION": "Piece goods stores",
    },
    {
      NAICS22: "459130",
      "INDEX ITEM DESCRIPTION": "Quilting supply stores",
    },
    {
      NAICS22: "459130",
      "INDEX ITEM DESCRIPTION": "Sewing supply stores",
    },
    {
      NAICS22: "459130",
      "INDEX ITEM DESCRIPTION": "Upholstery materials stores",
    },
    {
      NAICS22: "459140",
      "INDEX ITEM DESCRIPTION": "Music stores (i.e., instrument)",
    },
    {
      NAICS22: "459140",
      "INDEX ITEM DESCRIPTION": "Musical instrument stores",
    },
    {
      NAICS22: "459140",
      "INDEX ITEM DESCRIPTION": "Piano stores",
    },
    {
      NAICS22: "459140",
      "INDEX ITEM DESCRIPTION": "Sheet music stores",
    },
    {
      NAICS22: "459210",
      "INDEX ITEM DESCRIPTION":
        "Book clubs, not publishing, new books, mail-order",
    },
    {
      NAICS22: "459210",
      "INDEX ITEM DESCRIPTION": "Book stores",
    },
    {
      NAICS22: "459210",
      "INDEX ITEM DESCRIPTION": "Comic book stores",
    },
    {
      NAICS22: "459210",
      "INDEX ITEM DESCRIPTION": "Home delivery newspaper routes, direct selling",
    },
    {
      NAICS22: "459210",
      "INDEX ITEM DESCRIPTION": "Magazine stands (i.e., permanent)",
    },
    {
      NAICS22: "459210",
      "INDEX ITEM DESCRIPTION": "News dealers",
    },
    {
      NAICS22: "459210",
      "INDEX ITEM DESCRIPTION": "Newsstands (i.e., permanent)",
    },
    {
      NAICS22: "459210",
      "INDEX ITEM DESCRIPTION": "Religious book stores",
    },
    {
      NAICS22: "459310",
      "INDEX ITEM DESCRIPTION": "Florists",
    },
    {
      NAICS22: "459310",
      "INDEX ITEM DESCRIPTION": "Flower shops, fresh",
    },
    {
      NAICS22: "459410",
      "INDEX ITEM DESCRIPTION": "Office supply stores",
    },
    {
      NAICS22: "459410",
      "INDEX ITEM DESCRIPTION": "School supply stores",
    },
    {
      NAICS22: "459410",
      "INDEX ITEM DESCRIPTION": "Stationery stores",
    },
    {
      NAICS22: "459420",
      "INDEX ITEM DESCRIPTION": "Balloon shops",
    },
    {
      NAICS22: "459420",
      "INDEX ITEM DESCRIPTION": "Card shops, greeting",
    },
    {
      NAICS22: "459420",
      "INDEX ITEM DESCRIPTION": "Christmas stores",
    },
    {
      NAICS22: "459420",
      "INDEX ITEM DESCRIPTION":
        "Collectible gift shops (e.g., crystal, pewter, porcelain)",
    },
    {
      NAICS22: "459420",
      "INDEX ITEM DESCRIPTION": "Craft (except craft supply) stores",
    },
    {
      NAICS22: "459420",
      "INDEX ITEM DESCRIPTION": "Curio shops",
    },
    {
      NAICS22: "459420",
      "INDEX ITEM DESCRIPTION": "Fruit basket or fruit bouquet stores",
    },
    {
      NAICS22: "459420",
      "INDEX ITEM DESCRIPTION": "Gift shops",
    },
    {
      NAICS22: "459420",
      "INDEX ITEM DESCRIPTION": "Gift stands, permanent location",
    },
    {
      NAICS22: "459420",
      "INDEX ITEM DESCRIPTION": "Greeting card shops",
    },
    {
      NAICS22: "459420",
      "INDEX ITEM DESCRIPTION": "Novelty shops",
    },
    {
      NAICS22: "459420",
      "INDEX ITEM DESCRIPTION":
        "Party goods (e.g., paper supplies, decorations, novelties) stores",
    },
    {
      NAICS22: "459420",
      "INDEX ITEM DESCRIPTION": "Seasonal and holiday decoration stores",
    },
    {
      NAICS22: "459420",
      "INDEX ITEM DESCRIPTION": "Souvenir shops",
    },
    {
      NAICS22: "459510",
      "INDEX ITEM DESCRIPTION": "Antique dealers (except motor vehicles)",
    },
    {
      NAICS22: "459510",
      "INDEX ITEM DESCRIPTION": "Antique shops",
    },
    {
      NAICS22: "459510",
      "INDEX ITEM DESCRIPTION": "Apparel stores, used clothing",
    },
    {
      NAICS22: "459510",
      "INDEX ITEM DESCRIPTION": "Appliance stores, household, used",
    },
    {
      NAICS22: "459510",
      "INDEX ITEM DESCRIPTION": "Architectural salvage dealers",
    },
    {
      NAICS22: "459510",
      "INDEX ITEM DESCRIPTION":
        "Auctions, general merchandise (used), Internet retail",
    },
    {
      NAICS22: "459510",
      "INDEX ITEM DESCRIPTION": "Bicycle (except motorized) shops, used",
    },
    {
      NAICS22: "459510",
      "INDEX ITEM DESCRIPTION":
        "Book clubs, not publishing, used books, mail-order",
    },
    {
      NAICS22: "459510",
      "INDEX ITEM DESCRIPTION": "Book stores, used",
    },
    {
      NAICS22: "459510",
      "INDEX ITEM DESCRIPTION": "Clothing stores, used",
    },
    {
      NAICS22: "459510",
      "INDEX ITEM DESCRIPTION":
        "Computer software, prepackaged, used, mail-order houses",
    },
    {
      NAICS22: "459510",
      "INDEX ITEM DESCRIPTION": "Consignment shops, used merchandise",
    },
    {
      NAICS22: "459510",
      "INDEX ITEM DESCRIPTION":
        "Electronic auctions, general merchandise (used), retail",
    },
    {
      NAICS22: "459510",
      "INDEX ITEM DESCRIPTION": "Flea markets, used merchandise, permanent",
    },
    {
      NAICS22: "459510",
      "INDEX ITEM DESCRIPTION": "Furniture stores, used",
    },
    {
      NAICS22: "459510",
      "INDEX ITEM DESCRIPTION": "General merchandise (used) auction houses",
    },
    {
      NAICS22: "459510",
      "INDEX ITEM DESCRIPTION":
        "Internet auctions, general merchandise (used), retail",
    },
    {
      NAICS22: "459510",
      "INDEX ITEM DESCRIPTION":
        "Internet retail sales sites, used general merchandise",
    },
    {
      NAICS22: "459510",
      "INDEX ITEM DESCRIPTION":
        "Music stores (e.g., cassette, instrument, record, tape), used",
    },
    {
      NAICS22: "459510",
      "INDEX ITEM DESCRIPTION":
        "Prerecorded tape, compact disc, and record, used, mail-order houses",
    },
    {
      NAICS22: "459510",
      "INDEX ITEM DESCRIPTION": "Rare manuscript stores",
    },
    {
      NAICS22: "459510",
      "INDEX ITEM DESCRIPTION": "Record stores, used",
    },
    {
      NAICS22: "459510",
      "INDEX ITEM DESCRIPTION": "Secondhand merchandise stores",
    },
    {
      NAICS22: "459510",
      "INDEX ITEM DESCRIPTION": "Sporting goods stores, used",
    },
    {
      NAICS22: "459510",
      "INDEX ITEM DESCRIPTION": "Thrift shops, used merchandise",
    },
    {
      NAICS22: "459510",
      "INDEX ITEM DESCRIPTION": "Used bicycle (except motorized) shops",
    },
    {
      NAICS22: "459510",
      "INDEX ITEM DESCRIPTION":
        "Used merchandise dealers (except motor vehicles and parts)",
    },
    {
      NAICS22: "459510",
      "INDEX ITEM DESCRIPTION": "Used merchandise stores",
    },
    {
      NAICS22: "459510",
      "INDEX ITEM DESCRIPTION":
        "Used rare collectors' items (e.g., autograph, coin, card, stamps) shops",
    },
    {
      NAICS22: "459510",
      "INDEX ITEM DESCRIPTION":
        "Used rare collectors' items (e.g., autograph, coin, card, stamps), mail-order houses",
    },
    {
      NAICS22: "459910",
      "INDEX ITEM DESCRIPTION": "Feed stores, pet",
    },
    {
      NAICS22: "459910",
      "INDEX ITEM DESCRIPTION": "Pet shops",
    },
    {
      NAICS22: "459910",
      "INDEX ITEM DESCRIPTION": "Pet supply stores",
    },
    {
      NAICS22: "459920",
      "INDEX ITEM DESCRIPTION": "Art auctions",
    },
    {
      NAICS22: "459920",
      "INDEX ITEM DESCRIPTION": "Art dealers",
    },
    {
      NAICS22: "459920",
      "INDEX ITEM DESCRIPTION": "Art galleries retailing art",
    },
    {
      NAICS22: "459920",
      "INDEX ITEM DESCRIPTION": "Galleries, art, retail",
    },
    {
      NAICS22: "459930",
      "INDEX ITEM DESCRIPTION": "Manufactured (mobile) home dealers",
    },
    {
      NAICS22: "459930",
      "INDEX ITEM DESCRIPTION": "Mobile home dealers, manufactured",
    },
    {
      NAICS22: "459930",
      "INDEX ITEM DESCRIPTION": "Used manufactured (mobile) home dealers",
    },
    {
      NAICS22: "459991",
      "INDEX ITEM DESCRIPTION": "Cigar stores",
    },
    {
      NAICS22: "459991",
      "INDEX ITEM DESCRIPTION": "Cigarette stands, permanent",
    },
    {
      NAICS22: "459991",
      "INDEX ITEM DESCRIPTION": "Cigarette stands, temporary",
    },
    {
      NAICS22: "459991",
      "INDEX ITEM DESCRIPTION": "E-cigarette stores",
    },
    {
      NAICS22: "459991",
      "INDEX ITEM DESCRIPTION": "Electronic cigarette stores",
    },
    {
      NAICS22: "459991",
      "INDEX ITEM DESCRIPTION": "Marijuana stores, medical or recreational",
    },
    {
      NAICS22: "459991",
      "INDEX ITEM DESCRIPTION": "Smokers' supply stores",
    },
    {
      NAICS22: "459991",
      "INDEX ITEM DESCRIPTION": "Tobacco stores",
    },
    {
      NAICS22: "459991",
      "INDEX ITEM DESCRIPTION": "Vape shops",
    },
    {
      NAICS22: "459999",
      "INDEX ITEM DESCRIPTION": "Architectural supply stores",
    },
    {
      NAICS22: "459999",
      "INDEX ITEM DESCRIPTION": "Art supply stores",
    },
    {
      NAICS22: "459999",
      "INDEX ITEM DESCRIPTION": "Batteries, except automotive, dealers",
    },
    {
      NAICS22: "459999",
      "INDEX ITEM DESCRIPTION": "Beer making supply stores",
    },
    {
      NAICS22: "459999",
      "INDEX ITEM DESCRIPTION": "Binocular stores",
    },
    {
      NAICS22: "459999",
      "INDEX ITEM DESCRIPTION": "Cake decorating supply stores",
    },
    {
      NAICS22: "459999",
      "INDEX ITEM DESCRIPTION": "Calendar shops",
    },
    {
      NAICS22: "459999",
      "INDEX ITEM DESCRIPTION": "Candle shops",
    },
    {
      NAICS22: "459999",
      "INDEX ITEM DESCRIPTION": "Cannabidiol (CBD oil) retailers",
    },
    {
      NAICS22: "459999",
      "INDEX ITEM DESCRIPTION":
        "Cemetery memorial dealers (e.g., headstones, markers, vaults)",
    },
    {
      NAICS22: "459999",
      "INDEX ITEM DESCRIPTION": "Closet organizer stores",
    },
    {
      NAICS22: "459999",
      "INDEX ITEM DESCRIPTION":
        "Collectors' items (e.g., autograph, card, coin, stamp) shops (except used rare items)",
    },
    {
      NAICS22: "459999",
      "INDEX ITEM DESCRIPTION":
        "Collectors' items (e.g., autograph, card, coin, stamp), mail-order houses (except used rare items)",
    },
    {
      NAICS22: "459999",
      "INDEX ITEM DESCRIPTION": "Emergency preparedness supply stores",
    },
    {
      NAICS22: "459999",
      "INDEX ITEM DESCRIPTION": "Fireworks shops (i.e., permanent location)",
    },
    {
      NAICS22: "459999",
      "INDEX ITEM DESCRIPTION": "Flag and banner shops",
    },
    {
      NAICS22: "459999",
      "INDEX ITEM DESCRIPTION": "Flower shops, artificial or dried",
    },
    {
      NAICS22: "459999",
      "INDEX ITEM DESCRIPTION": "Home security equipment stores",
    },
    {
      NAICS22: "459999",
      "INDEX ITEM DESCRIPTION": "Hot tub stores",
    },
    {
      NAICS22: "459999",
      "INDEX ITEM DESCRIPTION": "Janitorial equipment and supplies stores",
    },
    {
      NAICS22: "459999",
      "INDEX ITEM DESCRIPTION": "Monument (i.e., burial marker) dealers",
    },
    {
      NAICS22: "459999",
      "INDEX ITEM DESCRIPTION": "Police supply stores",
    },
    {
      NAICS22: "459999",
      "INDEX ITEM DESCRIPTION": "Religious goods (except books) stores",
    },
    {
      NAICS22: "459999",
      "INDEX ITEM DESCRIPTION": "Swimming pool (above-ground) and supply stores",
    },
    {
      NAICS22: "459999",
      "INDEX ITEM DESCRIPTION": "Trophy (including awards and plaques) shops",
    },
    {
      NAICS22: "459999",
      "INDEX ITEM DESCRIPTION": "Wine making supply stores",
    },
    {
      NAICS22: "481111",
      "INDEX ITEM DESCRIPTION": "Air commuter carriers, scheduled",
    },
    {
      NAICS22: "481111",
      "INDEX ITEM DESCRIPTION": "Air passenger carriers, scheduled",
    },
    {
      NAICS22: "481111",
      "INDEX ITEM DESCRIPTION": "Commuter air carriers, scheduled",
    },
    {
      NAICS22: "481111",
      "INDEX ITEM DESCRIPTION": "Helicopter passenger carriers, scheduled",
    },
    {
      NAICS22: "481111",
      "INDEX ITEM DESCRIPTION": "Passenger air transportation, scheduled",
    },
    {
      NAICS22: "481111",
      "INDEX ITEM DESCRIPTION": "Passenger carriers, air, scheduled",
    },
    {
      NAICS22: "481111",
      "INDEX ITEM DESCRIPTION": "Scheduled air passenger carriers",
    },
    {
      NAICS22: "481111",
      "INDEX ITEM DESCRIPTION": "Scheduled air passenger transportation",
    },
    {
      NAICS22: "481112",
      "INDEX ITEM DESCRIPTION":
        "Air cargo carriers (except air couriers), scheduled",
    },
    {
      NAICS22: "481112",
      "INDEX ITEM DESCRIPTION": "Airmail carriers, scheduled",
    },
    {
      NAICS22: "481112",
      "INDEX ITEM DESCRIPTION": "Cargo carriers, air, scheduled",
    },
    {
      NAICS22: "481112",
      "INDEX ITEM DESCRIPTION":
        "Freight carriers (except air couriers), air, scheduled",
    },
    {
      NAICS22: "481112",
      "INDEX ITEM DESCRIPTION": "Helicopter freight carriers, scheduled",
    },
    {
      NAICS22: "481112",
      "INDEX ITEM DESCRIPTION": "Scheduled air freight carriers",
    },
    {
      NAICS22: "481112",
      "INDEX ITEM DESCRIPTION": "Scheduled air freight transportation",
    },
    {
      NAICS22: "481211",
      "INDEX ITEM DESCRIPTION": "Air passenger carriers, nonscheduled",
    },
    {
      NAICS22: "481211",
      "INDEX ITEM DESCRIPTION": "Air taxi services",
    },
    {
      NAICS22: "481211",
      "INDEX ITEM DESCRIPTION": "Aircraft charter services, passenger",
    },
    {
      NAICS22: "481211",
      "INDEX ITEM DESCRIPTION": "Charter air passenger services",
    },
    {
      NAICS22: "481211",
      "INDEX ITEM DESCRIPTION":
        "Helicopter passenger carriers (except scenic, sightseeing), nonscheduled",
    },
    {
      NAICS22: "481211",
      "INDEX ITEM DESCRIPTION": "Nonscheduled air passenger transportation",
    },
    {
      NAICS22: "481211",
      "INDEX ITEM DESCRIPTION": "Passenger air transportation, nonscheduled",
    },
    {
      NAICS22: "481211",
      "INDEX ITEM DESCRIPTION": "Passenger carriers, air, nonscheduled",
    },
    {
      NAICS22: "481211",
      "INDEX ITEM DESCRIPTION": "Space transportation, passenger, nonscheduled",
    },
    {
      NAICS22: "481212",
      "INDEX ITEM DESCRIPTION":
        "Air cargo carriers (except air couriers), nonscheduled",
    },
    {
      NAICS22: "481212",
      "INDEX ITEM DESCRIPTION": "Charter air freight services",
    },
    {
      NAICS22: "481212",
      "INDEX ITEM DESCRIPTION": "Freight charter services, air",
    },
    {
      NAICS22: "481212",
      "INDEX ITEM DESCRIPTION": "Freight transportation, air, charter services",
    },
    {
      NAICS22: "481212",
      "INDEX ITEM DESCRIPTION": "Freight transportation, air, nonscheduled",
    },
    {
      NAICS22: "481212",
      "INDEX ITEM DESCRIPTION": "Helicopter carriers, freight, nonscheduled",
    },
    {
      NAICS22: "481212",
      "INDEX ITEM DESCRIPTION": "Nonscheduled air freight transportation",
    },
    {
      NAICS22: "481212",
      "INDEX ITEM DESCRIPTION": "Space transportation, freight, nonscheduled",
    },
    {
      NAICS22: "481212",
      "INDEX ITEM DESCRIPTION": "Transportation by spacecraft, freight",
    },
    {
      NAICS22: "481219",
      "INDEX ITEM DESCRIPTION":
        "Aircraft charter services (i.e., general purpose aircraft used for a variety of specialty air and flying services)",
    },
    {
      NAICS22: "481219",
      "INDEX ITEM DESCRIPTION":
        "Aviation clubs providing a variety of air transportation activities to the general public",
    },
    {
      NAICS22: "482111",
      "INDEX ITEM DESCRIPTION": "Freight railways, line-haul",
    },
    {
      NAICS22: "482111",
      "INDEX ITEM DESCRIPTION": "Passenger railways, line-haul",
    },
    {
      NAICS22: "482111",
      "INDEX ITEM DESCRIPTION": "Railroad transportation, line-haul",
    },
    {
      NAICS22: "482111",
      "INDEX ITEM DESCRIPTION": "Railroads, line-haul",
    },
    {
      NAICS22: "482111",
      "INDEX ITEM DESCRIPTION": "Railway transportation, line-haul",
    },
    {
      NAICS22: "482112",
      "INDEX ITEM DESCRIPTION": "Beltline railroads",
    },
    {
      NAICS22: "482112",
      "INDEX ITEM DESCRIPTION": "Freight railways, short-line or beltline",
    },
    {
      NAICS22: "482112",
      "INDEX ITEM DESCRIPTION": "Logging railroads",
    },
    {
      NAICS22: "482112",
      "INDEX ITEM DESCRIPTION": "Railroad transportation, short-line or beltline",
    },
    {
      NAICS22: "482112",
      "INDEX ITEM DESCRIPTION": "Railroads, short-line or beltline",
    },
    {
      NAICS22: "482112",
      "INDEX ITEM DESCRIPTION": "Railway transportation, short-line or beltline",
    },
    {
      NAICS22: "482112",
      "INDEX ITEM DESCRIPTION": "Short-line railroads",
    },
    {
      NAICS22: "483111",
      "INDEX ITEM DESCRIPTION":
        "Deep sea freight transportation to or from foreign ports",
    },
    {
      NAICS22: "483111",
      "INDEX ITEM DESCRIPTION":
        "Freight transportation, deep sea, to or from foreign ports",
    },
    {
      NAICS22: "483111",
      "INDEX ITEM DESCRIPTION":
        "Ship chartering with crew, deep sea freight transportation to or from foreign ports",
    },
    {
      NAICS22: "483111",
      "INDEX ITEM DESCRIPTION":
        "Shipping freight to or from foreign ports, deep sea",
    },
    {
      NAICS22: "483111",
      "INDEX ITEM DESCRIPTION":
        "Transporting freight to or from foreign ports, deep sea",
    },
    {
      NAICS22: "483112",
      "INDEX ITEM DESCRIPTION":
        "Cruise lines (i.e., deep sea passenger transportation to or from foreign ports)",
    },
    {
      NAICS22: "483112",
      "INDEX ITEM DESCRIPTION":
        "Deep sea passenger transportation to or from foreign ports",
    },
    {
      NAICS22: "483112",
      "INDEX ITEM DESCRIPTION":
        "Passenger transportation, deep sea, to or from foreign ports",
    },
    {
      NAICS22: "483112",
      "INDEX ITEM DESCRIPTION":
        "Ship chartering with crew, deep sea passenger transportation to or from foreign ports",
    },
    {
      NAICS22: "483112",
      "INDEX ITEM DESCRIPTION":
        "Transporting passengers to or from foreign ports, deep sea",
    },
    {
      NAICS22: "483113",
      "INDEX ITEM DESCRIPTION":
        "Barge transportation, coastal or Great Lakes (including St. Lawrence Seaway)",
    },
    {
      NAICS22: "483113",
      "INDEX ITEM DESCRIPTION":
        "Coastal freight transportation to and from domestic ports",
    },
    {
      NAICS22: "483113",
      "INDEX ITEM DESCRIPTION":
        "Coastal shipping of freight to and from domestic ports",
    },
    {
      NAICS22: "483113",
      "INDEX ITEM DESCRIPTION":
        "Deep sea freight transportation to or from domestic ports (including Puerto Rico)",
    },
    {
      NAICS22: "483113",
      "INDEX ITEM DESCRIPTION":
        "Freight shipping on the Great Lakes system (including St. Lawrence Seaway)",
    },
    {
      NAICS22: "483113",
      "INDEX ITEM DESCRIPTION":
        "Freight transportation, deep sea, to and from domestic ports",
    },
    {
      NAICS22: "483113",
      "INDEX ITEM DESCRIPTION":
        "Great Lakes freight transportation (including St. Lawrence Seaway)",
    },
    {
      NAICS22: "483113",
      "INDEX ITEM DESCRIPTION":
        "Intercoastal freight transportation to and from domestic ports",
    },
    {
      NAICS22: "483113",
      "INDEX ITEM DESCRIPTION":
        "Lake freight transportation, Great Lakes (including St. Lawrence Seaway)",
    },
    {
      NAICS22: "483113",
      "INDEX ITEM DESCRIPTION":
        "Ship chartering with crew, coastal or Great Lakes freight transportation (including St. Lawrence Seaway)",
    },
    {
      NAICS22: "483113",
      "INDEX ITEM DESCRIPTION":
        "Shipping freight to and from domestic ports (i.e., coastal, deep sea (including Puerto Rico), Great Lakes system (including St. Lawrence Seaway))",
    },
    {
      NAICS22: "483114",
      "INDEX ITEM DESCRIPTION":
        "Coastal passenger transportation to and from domestic ports",
    },
    {
      NAICS22: "483114",
      "INDEX ITEM DESCRIPTION":
        "Cruise lines (i.e., deep sea passenger transportation to and from domestic ports, including Puerto Rico)",
    },
    {
      NAICS22: "483114",
      "INDEX ITEM DESCRIPTION":
        "Deep sea passenger transportation to and from domestic ports (including Puerto Rico)",
    },
    {
      NAICS22: "483114",
      "INDEX ITEM DESCRIPTION":
        "Ferry passenger transportation, Great Lakes (including St. Lawrence Seaway)",
    },
    {
      NAICS22: "483114",
      "INDEX ITEM DESCRIPTION":
        "Great Lakes passenger transportation (including St. Lawrence Seaway)",
    },
    {
      NAICS22: "483114",
      "INDEX ITEM DESCRIPTION":
        "Intercoastal transportation of passengers to and from domestic ports",
    },
    {
      NAICS22: "483114",
      "INDEX ITEM DESCRIPTION":
        "Lake passenger transportation, Great Lakes (including St. Lawrence Seaway)",
    },
    {
      NAICS22: "483114",
      "INDEX ITEM DESCRIPTION":
        "Passenger transportation, coastal or Great Lakes (including St. Lawrence Seaway)",
    },
    {
      NAICS22: "483114",
      "INDEX ITEM DESCRIPTION":
        "Passenger transportation, deep sea, to and from domestic ports (including Puerto Rico)",
    },
    {
      NAICS22: "483114",
      "INDEX ITEM DESCRIPTION":
        "Ship chartering with crew, coastal or Great Lakes passenger transportation (including St. Lawrence Seaway)",
    },
    {
      NAICS22: "483211",
      "INDEX ITEM DESCRIPTION": "Barge transportation, canal (freight)",
    },
    {
      NAICS22: "483211",
      "INDEX ITEM DESCRIPTION": "Canal barge transportation (freight)",
    },
    {
      NAICS22: "483211",
      "INDEX ITEM DESCRIPTION":
        "Freight transportation, inland waters (except on Great Lakes system)",
    },
    {
      NAICS22: "483211",
      "INDEX ITEM DESCRIPTION": "Intracoastal transportation of freight",
    },
    {
      NAICS22: "483211",
      "INDEX ITEM DESCRIPTION":
        "Lake freight transportation (except on Great Lakes system)",
    },
    {
      NAICS22: "483211",
      "INDEX ITEM DESCRIPTION":
        "Lighterage (i.e., freight transportation except vessel supply services)",
    },
    {
      NAICS22: "483211",
      "INDEX ITEM DESCRIPTION": "River freight transportation",
    },
    {
      NAICS22: "483211",
      "INDEX ITEM DESCRIPTION":
        "Ship chartering with crew, freight transportation, inland waters (except on Great Lakes system)",
    },
    {
      NAICS22: "483211",
      "INDEX ITEM DESCRIPTION":
        "Shipping freight, inland waters (except on Great Lakes system)",
    },
    {
      NAICS22: "483211",
      "INDEX ITEM DESCRIPTION":
        "Towing service, inland waters (except on Great Lakes system)",
    },
    {
      NAICS22: "483212",
      "INDEX ITEM DESCRIPTION": "Canal passenger transportation",
    },
    {
      NAICS22: "483212",
      "INDEX ITEM DESCRIPTION":
        "Car lighters (i.e., ferries), inland waters (except on Great Lakes system)",
    },
    {
      NAICS22: "483212",
      "INDEX ITEM DESCRIPTION": "Intracoastal transportation of passengers",
    },
    {
      NAICS22: "483212",
      "INDEX ITEM DESCRIPTION":
        "Lake passenger transportation (except on Great Lakes system)",
    },
    {
      NAICS22: "483212",
      "INDEX ITEM DESCRIPTION":
        "Passenger transportation, inland waters (except on Great Lakes system)",
    },
    {
      NAICS22: "483212",
      "INDEX ITEM DESCRIPTION": "River passenger transportation",
    },
    {
      NAICS22: "483212",
      "INDEX ITEM DESCRIPTION":
        "Ship chartering with crew, passenger transportation, inland waters (except on Great Lakes system)",
    },
    {
      NAICS22: "483212",
      "INDEX ITEM DESCRIPTION": "Water shuttle services",
    },
    {
      NAICS22: "483212",
      "INDEX ITEM DESCRIPTION": "Water taxi services",
    },
    {
      NAICS22: "484110",
      "INDEX ITEM DESCRIPTION": "Bulk mail truck transportation, contract, local",
    },
    {
      NAICS22: "484110",
      "INDEX ITEM DESCRIPTION": "Container trucking services, local",
    },
    {
      NAICS22: "484110",
      "INDEX ITEM DESCRIPTION": "General freight trucking, local",
    },
    {
      NAICS22: "484110",
      "INDEX ITEM DESCRIPTION": "Motor freight carrier, general, local",
    },
    {
      NAICS22: "484110",
      "INDEX ITEM DESCRIPTION":
        "Transfer (trucking) services, general freight, local",
    },
    {
      NAICS22: "484110",
      "INDEX ITEM DESCRIPTION": "Trucking, general freight, local",
    },
    {
      NAICS22: "484121",
      "INDEX ITEM DESCRIPTION":
        "Bulk mail truck transportation, contract, long-distance (TL)",
    },
    {
      NAICS22: "484121",
      "INDEX ITEM DESCRIPTION": "Container trucking services, long-distance (TL)",
    },
    {
      NAICS22: "484121",
      "INDEX ITEM DESCRIPTION":
        "General freight trucking, long-distance, truckload (TL)",
    },
    {
      NAICS22: "484121",
      "INDEX ITEM DESCRIPTION":
        "Motor freight carrier, general, long-distance, truckload (TL)",
    },
    {
      NAICS22: "484121",
      "INDEX ITEM DESCRIPTION":
        "Trucking, general freight, long-distance, truckload (TL)",
    },
    {
      NAICS22: "484122",
      "INDEX ITEM DESCRIPTION":
        "General freight trucking, long-distance, less-than-truckload (LTL)",
    },
    {
      NAICS22: "484122",
      "INDEX ITEM DESCRIPTION":
        "LTL (less-than-truckload) long-distance freight trucking",
    },
    {
      NAICS22: "484122",
      "INDEX ITEM DESCRIPTION":
        "Motor freight carrier, general, long-distance, less-than-truckload (LTL)",
    },
    {
      NAICS22: "484122",
      "INDEX ITEM DESCRIPTION":
        "Trucking, general freight, long-distance, less-than-truckload (LTL)",
    },
    {
      NAICS22: "484210",
      "INDEX ITEM DESCRIPTION": "Furniture moving, used",
    },
    {
      NAICS22: "484210",
      "INDEX ITEM DESCRIPTION": "Motor freight carrier, used household goods",
    },
    {
      NAICS22: "484210",
      "INDEX ITEM DESCRIPTION":
        "Trucking used household, office, or institutional furniture and equipment",
    },
    {
      NAICS22: "484210",
      "INDEX ITEM DESCRIPTION": "Used household and office goods moving",
    },
    {
      NAICS22: "484210",
      "INDEX ITEM DESCRIPTION": "Van lines, moving and storage services",
    },
    {
      NAICS22: "484220",
      "INDEX ITEM DESCRIPTION": "Agricultural products trucking, local",
    },
    {
      NAICS22: "484220",
      "INDEX ITEM DESCRIPTION":
        "Ash, garbage, recyclable material, refuse, rubbish, trash, or waste hauling (except collection or disposal)",
    },
    {
      NAICS22: "484220",
      "INDEX ITEM DESCRIPTION": "Automobile carrier trucking, local",
    },
    {
      NAICS22: "484220",
      "INDEX ITEM DESCRIPTION": "Boat hauling, truck, local",
    },
    {
      NAICS22: "484220",
      "INDEX ITEM DESCRIPTION": "Bulk liquids trucking, local",
    },
    {
      NAICS22: "484220",
      "INDEX ITEM DESCRIPTION": "Coal hauling, truck, local",
    },
    {
      NAICS22: "484220",
      "INDEX ITEM DESCRIPTION":
        "Dry bulk trucking (except garbage collection, garbage hauling), local",
    },
    {
      NAICS22: "484220",
      "INDEX ITEM DESCRIPTION": "Dump trucking (e.g., gravel, sand, top-soil)",
    },
    {
      NAICS22: "484220",
      "INDEX ITEM DESCRIPTION": "Farm products hauling, local",
    },
    {
      NAICS22: "484220",
      "INDEX ITEM DESCRIPTION": "Flatbed trucking, local",
    },
    {
      NAICS22: "484220",
      "INDEX ITEM DESCRIPTION": "Grain hauling, local",
    },
    {
      NAICS22: "484220",
      "INDEX ITEM DESCRIPTION": "Gravel hauling, local",
    },
    {
      NAICS22: "484220",
      "INDEX ITEM DESCRIPTION": "Livestock trucking, local",
    },
    {
      NAICS22: "484220",
      "INDEX ITEM DESCRIPTION": "Log hauling, local",
    },
    {
      NAICS22: "484220",
      "INDEX ITEM DESCRIPTION": "Milk hauling, local",
    },
    {
      NAICS22: "484220",
      "INDEX ITEM DESCRIPTION": "Mobile home towing services, local",
    },
    {
      NAICS22: "484220",
      "INDEX ITEM DESCRIPTION": "Oil and gas field equipment trucking, local",
    },
    {
      NAICS22: "484220",
      "INDEX ITEM DESCRIPTION": "Refrigerated products trucking, local",
    },
    {
      NAICS22: "484220",
      "INDEX ITEM DESCRIPTION": "Sand hauling, local",
    },
    {
      NAICS22: "484220",
      "INDEX ITEM DESCRIPTION":
        "Tanker trucking (e.g., chemical, juice, milk, petroleum), local",
    },
    {
      NAICS22: "484220",
      "INDEX ITEM DESCRIPTION": "Top-soil hauling, local",
    },
    {
      NAICS22: "484220",
      "INDEX ITEM DESCRIPTION": "Tracked vehicle freight transportation, local",
    },
    {
      NAICS22: "484220",
      "INDEX ITEM DESCRIPTION":
        "Trucking, specialized freight (except used goods), local",
    },
    {
      NAICS22: "484230",
      "INDEX ITEM DESCRIPTION": "Automobile carrier trucking, long-distance",
    },
    {
      NAICS22: "484230",
      "INDEX ITEM DESCRIPTION": "Boat hauling, truck, long-distance",
    },
    {
      NAICS22: "484230",
      "INDEX ITEM DESCRIPTION": "Bulk liquids trucking, long-distance",
    },
    {
      NAICS22: "484230",
      "INDEX ITEM DESCRIPTION": "Dry bulk carrier, truck, long-distance",
    },
    {
      NAICS22: "484230",
      "INDEX ITEM DESCRIPTION": "Farm products trucking, long-distance",
    },
    {
      NAICS22: "484230",
      "INDEX ITEM DESCRIPTION": "Flatbed trucking, long-distance",
    },
    {
      NAICS22: "484230",
      "INDEX ITEM DESCRIPTION": "Forest products trucking, long-distance",
    },
    {
      NAICS22: "484230",
      "INDEX ITEM DESCRIPTION": "Grain hauling, long-distance",
    },
    {
      NAICS22: "484230",
      "INDEX ITEM DESCRIPTION": "Gravel hauling, long-distance",
    },
    {
      NAICS22: "484230",
      "INDEX ITEM DESCRIPTION": "Livestock trucking, long-distance",
    },
    {
      NAICS22: "484230",
      "INDEX ITEM DESCRIPTION": "Log hauling, long-distance",
    },
    {
      NAICS22: "484230",
      "INDEX ITEM DESCRIPTION": "Mobile home towing services, long-distance",
    },
    {
      NAICS22: "484230",
      "INDEX ITEM DESCRIPTION":
        "Oil and gas field equipment trucking, long-distance",
    },
    {
      NAICS22: "484230",
      "INDEX ITEM DESCRIPTION": "Radioactive waste hauling, long-distance",
    },
    {
      NAICS22: "484230",
      "INDEX ITEM DESCRIPTION": "Recyclable material hauling, long-distance",
    },
    {
      NAICS22: "484230",
      "INDEX ITEM DESCRIPTION": "Refrigerated products trucking, long-distance",
    },
    {
      NAICS22: "484230",
      "INDEX ITEM DESCRIPTION": "Refuse hauling, long-distance",
    },
    {
      NAICS22: "484230",
      "INDEX ITEM DESCRIPTION":
        "Rubbish hauling without collection or disposal, truck, long-distance",
    },
    {
      NAICS22: "484230",
      "INDEX ITEM DESCRIPTION": "Sand hauling, long-distance",
    },
    {
      NAICS22: "484230",
      "INDEX ITEM DESCRIPTION":
        "Tanker trucking (e.g., chemical, juice, milk, petroleum), long-distance",
    },
    {
      NAICS22: "484230",
      "INDEX ITEM DESCRIPTION":
        "Tracked vehicle freight transportation, long-distance",
    },
    {
      NAICS22: "484230",
      "INDEX ITEM DESCRIPTION": "Trash hauling, long-distance",
    },
    {
      NAICS22: "484230",
      "INDEX ITEM DESCRIPTION":
        "Trucking, specialized freight (except used goods), long-distance",
    },
    {
      NAICS22: "484230",
      "INDEX ITEM DESCRIPTION": "Waste hauling, hazardous, long-distance",
    },
    {
      NAICS22: "484230",
      "INDEX ITEM DESCRIPTION": "Waste hauling, nonhazardous, long-distance",
    },
    {
      NAICS22: "485111",
      "INDEX ITEM DESCRIPTION":
        "Commuter transit systems, mixed mode (e.g., bus, commuter rail, subway combination)",
    },
    {
      NAICS22: "485111",
      "INDEX ITEM DESCRIPTION":
        "Local transit systems, mixed mode (e.g., bus, commuter rail, subway combinations)",
    },
    {
      NAICS22: "485111",
      "INDEX ITEM DESCRIPTION":
        "Mixed mode transit systems (e.g., bus, commuter rail, subway combinations)",
    },
    {
      NAICS22: "485111",
      "INDEX ITEM DESCRIPTION":
        "Suburban transit systems, mixed mode (e.g., bus, commuter rail, subway combinations)",
    },
    {
      NAICS22: "485111",
      "INDEX ITEM DESCRIPTION":
        "Transit systems, mixed mode (e.g., bus, commuter rail, subway combinations)",
    },
    {
      NAICS22: "485111",
      "INDEX ITEM DESCRIPTION":
        "Urban transit systems, mixed mode (e.g., bus, commuter rail, subway combinations)",
    },
    {
      NAICS22: "485112",
      "INDEX ITEM DESCRIPTION": "Commuter rail systems (except mixed mode)",
    },
    {
      NAICS22: "485112",
      "INDEX ITEM DESCRIPTION":
        "Local passenger rail systems (except mixed mode)",
    },
    {
      NAICS22: "485112",
      "INDEX ITEM DESCRIPTION":
        "Rail transportation (except mixed mode), commuter",
    },
    {
      NAICS22: "485112",
      "INDEX ITEM DESCRIPTION": "Railway systems (except mixed mode), commuter",
    },
    {
      NAICS22: "485112",
      "INDEX ITEM DESCRIPTION":
        "Suburban commuter rail systems (except mixed mode)",
    },
    {
      NAICS22: "485112",
      "INDEX ITEM DESCRIPTION": "Urban commuter rail systems (except mixed mode)",
    },
    {
      NAICS22: "485113",
      "INDEX ITEM DESCRIPTION": "Bus line, local (except mixed mode)",
    },
    {
      NAICS22: "485113",
      "INDEX ITEM DESCRIPTION":
        "Bus services, urban and suburban (except mixed mode)",
    },
    {
      NAICS22: "485113",
      "INDEX ITEM DESCRIPTION": "Bus transit systems (except mixed mode)",
    },
    {
      NAICS22: "485113",
      "INDEX ITEM DESCRIPTION": "City bus services (except mixed mode)",
    },
    {
      NAICS22: "485113",
      "INDEX ITEM DESCRIPTION": "Commuter bus operation (except mixed mode)",
    },
    {
      NAICS22: "485113",
      "INDEX ITEM DESCRIPTION": "Local bus services (except mixed mode)",
    },
    {
      NAICS22: "485113",
      "INDEX ITEM DESCRIPTION": "Suburban bus line services (except mixed mode)",
    },
    {
      NAICS22: "485113",
      "INDEX ITEM DESCRIPTION": "Urban bus line services (except mixed mode)",
    },
    {
      NAICS22: "485119",
      "INDEX ITEM DESCRIPTION": "Cable car systems (except mixed mode), commuter",
    },
    {
      NAICS22: "485119",
      "INDEX ITEM DESCRIPTION":
        "Light rail systems (except mixed mode), commuter",
    },
    {
      NAICS22: "485119",
      "INDEX ITEM DESCRIPTION":
        "Monorail transit systems (except mixed mode), commuter",
    },
    {
      NAICS22: "485119",
      "INDEX ITEM DESCRIPTION":
        "Street railway systems (except mixed mode), commuter",
    },
    {
      NAICS22: "485119",
      "INDEX ITEM DESCRIPTION": "Streetcar systems (except mixed mode), commuter",
    },
    {
      NAICS22: "485119",
      "INDEX ITEM DESCRIPTION": "Subway systems (except mixed mode), commuter",
    },
    {
      NAICS22: "485119",
      "INDEX ITEM DESCRIPTION": "Tramway systems (except mixed mode), commuter",
    },
    {
      NAICS22: "485119",
      "INDEX ITEM DESCRIPTION": "Trolley systems (except mixed mode), commuter",
    },
    {
      NAICS22: "485210",
      "INDEX ITEM DESCRIPTION": "Bus line operation, intercity",
    },
    {
      NAICS22: "485210",
      "INDEX ITEM DESCRIPTION": "Intercity bus line operation",
    },
    {
      NAICS22: "485210",
      "INDEX ITEM DESCRIPTION": "Interstate bus line operation",
    },
    {
      NAICS22: "485210",
      "INDEX ITEM DESCRIPTION": "Interurban bus line operation",
    },
    {
      NAICS22: "485210",
      "INDEX ITEM DESCRIPTION": "Motor coach operation, interurban and rural",
    },
    {
      NAICS22: "485210",
      "INDEX ITEM DESCRIPTION": "Rural bus services",
    },
    {
      NAICS22: "485310",
      "INDEX ITEM DESCRIPTION": "Cab (i.e., taxi) services",
    },
    {
      NAICS22: "485310",
      "INDEX ITEM DESCRIPTION": "Ride hailing arrangement services",
    },
    {
      NAICS22: "485310",
      "INDEX ITEM DESCRIPTION": "Ride hailing services",
    },
    {
      NAICS22: "485310",
      "INDEX ITEM DESCRIPTION": "Ridesharing arrangement services",
    },
    {
      NAICS22: "485310",
      "INDEX ITEM DESCRIPTION": "Ridesharing services",
    },
    {
      NAICS22: "485310",
      "INDEX ITEM DESCRIPTION": "Taxicab dispatch services",
    },
    {
      NAICS22: "485310",
      "INDEX ITEM DESCRIPTION": "Taxicab fleet operators",
    },
    {
      NAICS22: "485310",
      "INDEX ITEM DESCRIPTION": "Taxicab organizations",
    },
    {
      NAICS22: "485310",
      "INDEX ITEM DESCRIPTION": "Taxicab owner-operators",
    },
    {
      NAICS22: "485310",
      "INDEX ITEM DESCRIPTION": "Taxicab services",
    },
    {
      NAICS22: "485320",
      "INDEX ITEM DESCRIPTION":
        "Automobile rental with driver (except shuttle service, taxis)",
    },
    {
      NAICS22: "485320",
      "INDEX ITEM DESCRIPTION": "Hearse rental with driver",
    },
    {
      NAICS22: "485320",
      "INDEX ITEM DESCRIPTION": "Limousine services (except shuttle services)",
    },
    {
      NAICS22: "485320",
      "INDEX ITEM DESCRIPTION": "Limousines for hire with driver (except taxis)",
    },
    {
      NAICS22: "485320",
      "INDEX ITEM DESCRIPTION":
        "Luxury automobiles for hire with driver (except taxis)",
    },
    {
      NAICS22: "485320",
      "INDEX ITEM DESCRIPTION":
        "Passenger limousine rental with driver (except shuttle service, taxi)",
    },
    {
      NAICS22: "485320",
      "INDEX ITEM DESCRIPTION":
        "Passenger van rental with driver (except shuttle service, taxi)",
    },
    {
      NAICS22: "485410",
      "INDEX ITEM DESCRIPTION": "Bus operation, school and employee",
    },
    {
      NAICS22: "485410",
      "INDEX ITEM DESCRIPTION": "Employee bus services",
    },
    {
      NAICS22: "485410",
      "INDEX ITEM DESCRIPTION": "School bus services",
    },
    {
      NAICS22: "485410",
      "INDEX ITEM DESCRIPTION":
        "School or employee bus transportation for the disabled or elderly",
    },
    {
      NAICS22: "485510",
      "INDEX ITEM DESCRIPTION":
        "Bus charter services (except scenic, sightseeing)",
    },
    {
      NAICS22: "485510",
      "INDEX ITEM DESCRIPTION":
        "Charter bus services (except scenic, sightseeing)",
    },
    {
      NAICS22: "485991",
      "INDEX ITEM DESCRIPTION":
        "Disabled or elderly passenger transportation services",
    },
    {
      NAICS22: "485991",
      "INDEX ITEM DESCRIPTION":
        "Nonemergency medical transportation services (except ambulance services)",
    },
    {
      NAICS22: "485991",
      "INDEX ITEM DESCRIPTION": "Paratransit transportation services",
    },
    {
      NAICS22: "485991",
      "INDEX ITEM DESCRIPTION": "Pet transportation services",
    },
    {
      NAICS22: "485991",
      "INDEX ITEM DESCRIPTION": "Senior citizens transportation services",
    },
    {
      NAICS22: "485991",
      "INDEX ITEM DESCRIPTION": "Special needs passenger transportation services",
    },
    {
      NAICS22: "485999",
      "INDEX ITEM DESCRIPTION": "Airport limousine services (i.e., shuttle)",
    },
    {
      NAICS22: "485999",
      "INDEX ITEM DESCRIPTION": "Airport shuttle services",
    },
    {
      NAICS22: "485999",
      "INDEX ITEM DESCRIPTION":
        "Car pool operation (except ridesharing and ridesharing arrangement services)",
    },
    {
      NAICS22: "485999",
      "INDEX ITEM DESCRIPTION": "Shuttle services (except employee bus)",
    },
    {
      NAICS22: "485999",
      "INDEX ITEM DESCRIPTION":
        "Vanpool operation (except ridesharing and ridesharing arrangement services)",
    },
    {
      NAICS22: "486110",
      "INDEX ITEM DESCRIPTION":
        "Booster pumping station, crude oil transportation",
    },
    {
      NAICS22: "486110",
      "INDEX ITEM DESCRIPTION": "Crude oil pipeline transportation",
    },
    {
      NAICS22: "486110",
      "INDEX ITEM DESCRIPTION": "Petroleum pipelines, crude",
    },
    {
      NAICS22: "486110",
      "INDEX ITEM DESCRIPTION": "Pipeline transportation, crude oil",
    },
    {
      NAICS22: "486210",
      "INDEX ITEM DESCRIPTION":
        "Booster pumping station, natural gas transportation",
    },
    {
      NAICS22: "486210",
      "INDEX ITEM DESCRIPTION": "Gas, natural, pipeline operation",
    },
    {
      NAICS22: "486210",
      "INDEX ITEM DESCRIPTION": "Natural gas pipeline transportation",
    },
    {
      NAICS22: "486210",
      "INDEX ITEM DESCRIPTION":
        "Natural gas transmission (i.e., processing plants to local distribution systems)",
    },
    {
      NAICS22: "486210",
      "INDEX ITEM DESCRIPTION": "Pipeline transportation, natural gas",
    },
    {
      NAICS22: "486210",
      "INDEX ITEM DESCRIPTION": "Storage of natural gas",
    },
    {
      NAICS22: "486210",
      "INDEX ITEM DESCRIPTION":
        "Transmission of natural gas via pipeline (i.e., processing plants to local distribution systems)",
    },
    {
      NAICS22: "486910",
      "INDEX ITEM DESCRIPTION":
        "Booster pumping station, refined petroleum products transportation",
    },
    {
      NAICS22: "486910",
      "INDEX ITEM DESCRIPTION": "Gasoline pipeline transportation",
    },
    {
      NAICS22: "486910",
      "INDEX ITEM DESCRIPTION": "Natural gas liquids pipeline transportation",
    },
    {
      NAICS22: "486910",
      "INDEX ITEM DESCRIPTION": "Petroleum pipelines, refined",
    },
    {
      NAICS22: "486910",
      "INDEX ITEM DESCRIPTION":
        "Pipeline transportation, gasoline and other refined petroleum products",
    },
    {
      NAICS22: "486910",
      "INDEX ITEM DESCRIPTION":
        "Refined petroleum products pipeline transportation",
    },
    {
      NAICS22: "486990",
      "INDEX ITEM DESCRIPTION":
        "Booster pumping station (except natural gas, petroleum)",
    },
    {
      NAICS22: "486990",
      "INDEX ITEM DESCRIPTION": "Coal pipeline transportation",
    },
    {
      NAICS22: "486990",
      "INDEX ITEM DESCRIPTION":
        "Pipeline transportation (except crude oil, natural gas, refined petroleum products)",
    },
    {
      NAICS22: "486990",
      "INDEX ITEM DESCRIPTION": "Slurry pipeline transportation",
    },
    {
      NAICS22: "487110",
      "INDEX ITEM DESCRIPTION": "Buses, scenic and sightseeing operation",
    },
    {
      NAICS22: "487110",
      "INDEX ITEM DESCRIPTION":
        "Cable car, land, scenic and sightseeing operation",
    },
    {
      NAICS22: "487110",
      "INDEX ITEM DESCRIPTION": "Carriage, horse-drawn, operation",
    },
    {
      NAICS22: "487110",
      "INDEX ITEM DESCRIPTION": "Cog railway, scenic and sightseeing, operation",
    },
    {
      NAICS22: "487110",
      "INDEX ITEM DESCRIPTION": "Horse-drawn carriage operation",
    },
    {
      NAICS22: "487110",
      "INDEX ITEM DESCRIPTION": "Monorail, scenic and sightseeing, operation",
    },
    {
      NAICS22: "487110",
      "INDEX ITEM DESCRIPTION": "Railroad transportation, scenic and sightseeing",
    },
    {
      NAICS22: "487110",
      "INDEX ITEM DESCRIPTION": "Railroad, scenic and sightseeing, operation",
    },
    {
      NAICS22: "487110",
      "INDEX ITEM DESCRIPTION": "Railway transportation, scenic and sightseeing",
    },
    {
      NAICS22: "487110",
      "INDEX ITEM DESCRIPTION": "Scenic and sightseeing excursions, land",
    },
    {
      NAICS22: "487110",
      "INDEX ITEM DESCRIPTION": "Sightseeing bus operation",
    },
    {
      NAICS22: "487110",
      "INDEX ITEM DESCRIPTION": "Sightseeing operation, human-drawn vehicle",
    },
    {
      NAICS22: "487110",
      "INDEX ITEM DESCRIPTION": "Steam train excursions",
    },
    {
      NAICS22: "487110",
      "INDEX ITEM DESCRIPTION": "Tour bus, scenic and sightseeing, operation",
    },
    {
      NAICS22: "487110",
      "INDEX ITEM DESCRIPTION": "Tracked vehicle sightseeing operation",
    },
    {
      NAICS22: "487110",
      "INDEX ITEM DESCRIPTION": "Trolley, scenic and sightseeing, operation",
    },
    {
      NAICS22: "487210",
      "INDEX ITEM DESCRIPTION": "Airboat (i.e., swamp buggy) operation",
    },
    {
      NAICS22: "487210",
      "INDEX ITEM DESCRIPTION": "Boat, fishing charter, operation",
    },
    {
      NAICS22: "487210",
      "INDEX ITEM DESCRIPTION": "Charter fishing boat operation",
    },
    {
      NAICS22: "487210",
      "INDEX ITEM DESCRIPTION": "Dinner cruises",
    },
    {
      NAICS22: "487210",
      "INDEX ITEM DESCRIPTION": "Excursion boat operation",
    },
    {
      NAICS22: "487210",
      "INDEX ITEM DESCRIPTION": "Fishing boat charter operation",
    },
    {
      NAICS22: "487210",
      "INDEX ITEM DESCRIPTION": "Harbor sightseeing tours",
    },
    {
      NAICS22: "487210",
      "INDEX ITEM DESCRIPTION": "Hovercraft sightseeing operation",
    },
    {
      NAICS22: "487210",
      "INDEX ITEM DESCRIPTION": "Scenic and sightseeing excursions, water",
    },
    {
      NAICS22: "487210",
      "INDEX ITEM DESCRIPTION": "Sightseeing boat operation",
    },
    {
      NAICS22: "487210",
      "INDEX ITEM DESCRIPTION": "Swamp buggy operation",
    },
    {
      NAICS22: "487210",
      "INDEX ITEM DESCRIPTION": "Whale watching excursions",
    },
    {
      NAICS22: "487990",
      "INDEX ITEM DESCRIPTION":
        "Aerial cable car, scenic and sightseeing, operation",
    },
    {
      NAICS22: "487990",
      "INDEX ITEM DESCRIPTION":
        "Aerial tramway, scenic and sightseeing, operation",
    },
    {
      NAICS22: "487990",
      "INDEX ITEM DESCRIPTION": "Glider excursions",
    },
    {
      NAICS22: "487990",
      "INDEX ITEM DESCRIPTION":
        "Helicopter ride, scenic and sightseeing, operation",
    },
    {
      NAICS22: "487990",
      "INDEX ITEM DESCRIPTION":
        "Hot air balloon ride, scenic and sightseeing, operation",
    },
    {
      NAICS22: "487990",
      "INDEX ITEM DESCRIPTION": "Scenic and sightseeing excursions, aerial",
    },
    {
      NAICS22: "487990",
      "INDEX ITEM DESCRIPTION":
        "Tramway, aerial, scenic and sightseeing operation",
    },
    {
      NAICS22: "488111",
      "INDEX ITEM DESCRIPTION": "Air traffic control services (except military)",
    },
    {
      NAICS22: "488119",
      "INDEX ITEM DESCRIPTION": "Aircraft hangar rental",
    },
    {
      NAICS22: "488119",
      "INDEX ITEM DESCRIPTION": "Aircraft parking service",
    },
    {
      NAICS22: "488119",
      "INDEX ITEM DESCRIPTION": "Airport baggage handling services",
    },
    {
      NAICS22: "488119",
      "INDEX ITEM DESCRIPTION": "Airport cargo handling services",
    },
    {
      NAICS22: "488119",
      "INDEX ITEM DESCRIPTION":
        "Airport operators (e.g., civil, international, national)",
    },
    {
      NAICS22: "488119",
      "INDEX ITEM DESCRIPTION": "Airport runway maintenance services",
    },
    {
      NAICS22: "488119",
      "INDEX ITEM DESCRIPTION": "Airports, civil, operation and maintenance",
    },
    {
      NAICS22: "488119",
      "INDEX ITEM DESCRIPTION":
        "Aviation clubs, primarily providing flying field services to the general public",
    },
    {
      NAICS22: "488119",
      "INDEX ITEM DESCRIPTION": "Fixed base operators",
    },
    {
      NAICS22: "488119",
      "INDEX ITEM DESCRIPTION": "Flying field operators",
    },
    {
      NAICS22: "488119",
      "INDEX ITEM DESCRIPTION": "Hangar rental, aircraft",
    },
    {
      NAICS22: "488119",
      "INDEX ITEM DESCRIPTION": "Maintenance services, runway",
    },
    {
      NAICS22: "488119",
      "INDEX ITEM DESCRIPTION": "Parking services, aircraft",
    },
    {
      NAICS22: "488119",
      "INDEX ITEM DESCRIPTION": "Runway maintenance services",
    },
    {
      NAICS22: "488119",
      "INDEX ITEM DESCRIPTION": "Vacuuming of airport runways",
    },
    {
      NAICS22: "488190",
      "INDEX ITEM DESCRIPTION": "Aircraft ferrying services",
    },
    {
      NAICS22: "488190",
      "INDEX ITEM DESCRIPTION": "Aircraft inspection services",
    },
    {
      NAICS22: "488190",
      "INDEX ITEM DESCRIPTION":
        "Aircraft maintenance and repair services (except factory conversion, factory overhaul, factory rebuilding)",
    },
    {
      NAICS22: "488190",
      "INDEX ITEM DESCRIPTION": "Aircraft testing services",
    },
    {
      NAICS22: "488190",
      "INDEX ITEM DESCRIPTION": "Airport passenger screening security services",
    },
    {
      NAICS22: "488190",
      "INDEX ITEM DESCRIPTION": "Fueling aircraft on a contract or fee basis",
    },
    {
      NAICS22: "488190",
      "INDEX ITEM DESCRIPTION": "Independent pilot, air (except owner-operators)",
    },
    {
      NAICS22: "488190",
      "INDEX ITEM DESCRIPTION": "Inspection services, aircraft",
    },
    {
      NAICS22: "488190",
      "INDEX ITEM DESCRIPTION":
        "Maintenance and repair services, aircraft (except factory conversion, factory overhaul, factory rebuilding)",
    },
    {
      NAICS22: "488190",
      "INDEX ITEM DESCRIPTION": "Testing services, aircraft",
    },
    {
      NAICS22: "488210",
      "INDEX ITEM DESCRIPTION": "Freight car cleaning services",
    },
    {
      NAICS22: "488210",
      "INDEX ITEM DESCRIPTION": "Grain leveling and trimming in railroad cars",
    },
    {
      NAICS22: "488210",
      "INDEX ITEM DESCRIPTION":
        "Loading and unloading services at rail terminals",
    },
    {
      NAICS22: "488210",
      "INDEX ITEM DESCRIPTION":
        "Locomotive and rail car repair (except factory conversion, factory overhaul, factory rebuilding)",
    },
    {
      NAICS22: "488210",
      "INDEX ITEM DESCRIPTION":
        "Maintenance of rights of way and structures, railway",
    },
    {
      NAICS22: "488210",
      "INDEX ITEM DESCRIPTION": "Railroad switching services",
    },
    {
      NAICS22: "488210",
      "INDEX ITEM DESCRIPTION": "Railroad terminals, independent operation",
    },
    {
      NAICS22: "488210",
      "INDEX ITEM DESCRIPTION": "Railway terminals, independent operation",
    },
    {
      NAICS22: "488210",
      "INDEX ITEM DESCRIPTION": "Shunting trailers in rail terminals",
    },
    {
      NAICS22: "488210",
      "INDEX ITEM DESCRIPTION": "Switching services, railroad",
    },
    {
      NAICS22: "488310",
      "INDEX ITEM DESCRIPTION": "Canal maintenance services (except dredging)",
    },
    {
      NAICS22: "488310",
      "INDEX ITEM DESCRIPTION": "Canal operation",
    },
    {
      NAICS22: "488310",
      "INDEX ITEM DESCRIPTION": "Docking facility operations",
    },
    {
      NAICS22: "488310",
      "INDEX ITEM DESCRIPTION": "Harbor maintenance services (except dredging)",
    },
    {
      NAICS22: "488310",
      "INDEX ITEM DESCRIPTION": "Harbor operation",
    },
    {
      NAICS22: "488310",
      "INDEX ITEM DESCRIPTION": "Lighthouse operation",
    },
    {
      NAICS22: "488310",
      "INDEX ITEM DESCRIPTION":
        "Maintenance services, waterfront terminal (except dredging)",
    },
    {
      NAICS22: "488310",
      "INDEX ITEM DESCRIPTION": "Port facility operation",
    },
    {
      NAICS22: "488310",
      "INDEX ITEM DESCRIPTION": "Seaway operation",
    },
    {
      NAICS22: "488310",
      "INDEX ITEM DESCRIPTION":
        "Waterfront terminal operation (e.g., docks, piers, wharves)",
    },
    {
      NAICS22: "488310",
      "INDEX ITEM DESCRIPTION": "Wharf operation",
    },
    {
      NAICS22: "488320",
      "INDEX ITEM DESCRIPTION":
        "Loading and unloading services at ports and harbors",
    },
    {
      NAICS22: "488320",
      "INDEX ITEM DESCRIPTION": "Longshoremen services",
    },
    {
      NAICS22: "488320",
      "INDEX ITEM DESCRIPTION": "Marine cargo handling services",
    },
    {
      NAICS22: "488320",
      "INDEX ITEM DESCRIPTION": "Ship hold cleaning services",
    },
    {
      NAICS22: "488320",
      "INDEX ITEM DESCRIPTION": "Stevedoring services",
    },
    {
      NAICS22: "488330",
      "INDEX ITEM DESCRIPTION": "Cargo salvaging, marine",
    },
    {
      NAICS22: "488330",
      "INDEX ITEM DESCRIPTION": "Docking and undocking marine vessel services",
    },
    {
      NAICS22: "488330",
      "INDEX ITEM DESCRIPTION": "Harbor tugboat services",
    },
    {
      NAICS22: "488330",
      "INDEX ITEM DESCRIPTION": "Marine salvaging services",
    },
    {
      NAICS22: "488330",
      "INDEX ITEM DESCRIPTION": "Marine vessel traffic reporting services",
    },
    {
      NAICS22: "488330",
      "INDEX ITEM DESCRIPTION": "Piloting services, water transportation",
    },
    {
      NAICS22: "488330",
      "INDEX ITEM DESCRIPTION": "Radio beacon (i.e., ship navigation) services",
    },
    {
      NAICS22: "488330",
      "INDEX ITEM DESCRIPTION": "Tugboat services, harbor operation",
    },
    {
      NAICS22: "488390",
      "INDEX ITEM DESCRIPTION": "Cargo checkers, marine",
    },
    {
      NAICS22: "488390",
      "INDEX ITEM DESCRIPTION": "Cargo surveyors, marine",
    },
    {
      NAICS22: "488390",
      "INDEX ITEM DESCRIPTION":
        "Drydocks, floating (i.e., routine repair and maintenance of ships)",
    },
    {
      NAICS22: "488390",
      "INDEX ITEM DESCRIPTION": "Marine cargo checkers and surveyors",
    },
    {
      NAICS22: "488390",
      "INDEX ITEM DESCRIPTION": "Ship dismantling at floating drydock",
    },
    {
      NAICS22: "488390",
      "INDEX ITEM DESCRIPTION": "Ship scaling services not done at a shipyard",
    },
    {
      NAICS22: "488410",
      "INDEX ITEM DESCRIPTION": "Emergency road services (i.e., tow service)",
    },
    {
      NAICS22: "488410",
      "INDEX ITEM DESCRIPTION": "Motor vehicle towing services",
    },
    {
      NAICS22: "488410",
      "INDEX ITEM DESCRIPTION": "Tow truck services",
    },
    {
      NAICS22: "488410",
      "INDEX ITEM DESCRIPTION": "Towing services, motor vehicle",
    },
    {
      NAICS22: "488410",
      "INDEX ITEM DESCRIPTION":
        "Wrecker services (i.e., towing services), motor vehicle",
    },
    {
      NAICS22: "488490",
      "INDEX ITEM DESCRIPTION": "Bridge, tunnel, and highway operations",
    },
    {
      NAICS22: "488490",
      "INDEX ITEM DESCRIPTION": "Bus terminal operation, independent",
    },
    {
      NAICS22: "488490",
      "INDEX ITEM DESCRIPTION": "Cargo surveyors, truck transportation",
    },
    {
      NAICS22: "488490",
      "INDEX ITEM DESCRIPTION":
        "Driving services, independent (e.g., automobile, truck delivery)",
    },
    {
      NAICS22: "488490",
      "INDEX ITEM DESCRIPTION":
        "Independent truck driver (except owner-operators)",
    },
    {
      NAICS22: "488490",
      "INDEX ITEM DESCRIPTION":
        "Inspection or weighing services, truck transportation",
    },
    {
      NAICS22: "488490",
      "INDEX ITEM DESCRIPTION": "Loading and unloading at truck terminals",
    },
    {
      NAICS22: "488490",
      "INDEX ITEM DESCRIPTION":
        "Pilot car services (i.e., wide load warning services)",
    },
    {
      NAICS22: "488490",
      "INDEX ITEM DESCRIPTION": "Shunting of trailers in truck terminals",
    },
    {
      NAICS22: "488490",
      "INDEX ITEM DESCRIPTION":
        "Snow clearing, highways and bridges, road transportation",
    },
    {
      NAICS22: "488490",
      "INDEX ITEM DESCRIPTION": "Snow removal, highway",
    },
    {
      NAICS22: "488490",
      "INDEX ITEM DESCRIPTION": "Street cleaning service",
    },
    {
      NAICS22: "488490",
      "INDEX ITEM DESCRIPTION": "Toll road operations, highway",
    },
    {
      NAICS22: "488490",
      "INDEX ITEM DESCRIPTION": "Truck weighing station operation",
    },
    {
      NAICS22: "488490",
      "INDEX ITEM DESCRIPTION": "Trucking terminals, independently operated",
    },
    {
      NAICS22: "488510",
      "INDEX ITEM DESCRIPTION": "Agents, shipping",
    },
    {
      NAICS22: "488510",
      "INDEX ITEM DESCRIPTION": "Customs brokers",
    },
    {
      NAICS22: "488510",
      "INDEX ITEM DESCRIPTION": "Freight forwarding",
    },
    {
      NAICS22: "488510",
      "INDEX ITEM DESCRIPTION": "Marine shipping agency",
    },
    {
      NAICS22: "488510",
      "INDEX ITEM DESCRIPTION": "Shipping agents (freight forwarding)",
    },
    {
      NAICS22: "488991",
      "INDEX ITEM DESCRIPTION": "Crating goods for shipping",
    },
    {
      NAICS22: "488991",
      "INDEX ITEM DESCRIPTION": "Packing and preparing goods for shipping",
    },
    {
      NAICS22: "488991",
      "INDEX ITEM DESCRIPTION":
        "Preparing goods for transportation (i.e., crating, packing)",
    },
    {
      NAICS22: "488999",
      "INDEX ITEM DESCRIPTION":
        "Arrangement of car pools and vanpools (except ridesharing arrangement services)",
    },
    {
      NAICS22: "488999",
      "INDEX ITEM DESCRIPTION":
        "Arrangement of nonemergency medical transportation, without providing social assistance services",
    },
    {
      NAICS22: "488999",
      "INDEX ITEM DESCRIPTION":
        "Car pools, arrangement of (except ridesharing arrangement services)",
    },
    {
      NAICS22: "488999",
      "INDEX ITEM DESCRIPTION":
        "Liquefied natural gas (LNG) terminals (liquefaction and regasification)",
    },
    {
      NAICS22: "488999",
      "INDEX ITEM DESCRIPTION":
        "Pipeline terminal facilities, independently operated",
    },
    {
      NAICS22: "488999",
      "INDEX ITEM DESCRIPTION":
        "Precooling of fruits and vegetables in connection with transportation",
    },
    {
      NAICS22: "488999",
      "INDEX ITEM DESCRIPTION":
        "Stockyards (i.e., not for fattening or selling livestock), transportation",
    },
    {
      NAICS22: "488999",
      "INDEX ITEM DESCRIPTION":
        "Vanpools, arrangement of (except ridesharing arrangement services)",
    },
    {
      NAICS22: "491110",
      "INDEX ITEM DESCRIPTION":
        "Postal delivery services, local, operated by U.S. Postal Service",
    },
    {
      NAICS22: "491110",
      "INDEX ITEM DESCRIPTION":
        "Postal delivery services, local, operated on a contract basis",
    },
    {
      NAICS22: "491110",
      "INDEX ITEM DESCRIPTION": "Postal services operated by U.S. Postal Service",
    },
    {
      NAICS22: "491110",
      "INDEX ITEM DESCRIPTION": "Postal stations operated by U.S. Postal Service",
    },
    {
      NAICS22: "491110",
      "INDEX ITEM DESCRIPTION": "Postal stations operated on a contract basis",
    },
    {
      NAICS22: "492110",
      "INDEX ITEM DESCRIPTION":
        "Air courier services (except establishments operating under a universal service obligation)",
    },
    {
      NAICS22: "492110",
      "INDEX ITEM DESCRIPTION":
        "Courier services (i.e., intercity network) (except establishments operating under a universal service obligation)",
    },
    {
      NAICS22: "492110",
      "INDEX ITEM DESCRIPTION":
        "Express delivery services (except establishments operating under a universal service obligation)",
    },
    {
      NAICS22: "492110",
      "INDEX ITEM DESCRIPTION":
        "Local letter and parcel delivery services as part of intercity courier network",
    },
    {
      NAICS22: "492210",
      "INDEX ITEM DESCRIPTION": "Alcoholic beverage delivery service",
    },
    {
      NAICS22: "492210",
      "INDEX ITEM DESCRIPTION": "Bicycle courier",
    },
    {
      NAICS22: "492210",
      "INDEX ITEM DESCRIPTION":
        "Delivery service (except as part of intercity courier network, U.S. Postal Service)",
    },
    {
      NAICS22: "492210",
      "INDEX ITEM DESCRIPTION":
        "Grocery delivery services (i.e., independent service from grocery store)",
    },
    {
      NAICS22: "492210",
      "INDEX ITEM DESCRIPTION":
        "Local letter and parcel delivery services (except as part of intercity courier network, U.S. Postal Service)",
    },
    {
      NAICS22: "492210",
      "INDEX ITEM DESCRIPTION": "Messenger service",
    },
    {
      NAICS22: "492210",
      "INDEX ITEM DESCRIPTION":
        "Restaurant meals order and delivery services (i.e., independent order and delivery services)",
    },
    {
      NAICS22: "493110",
      "INDEX ITEM DESCRIPTION": "Bonded warehousing, general merchandise",
    },
    {
      NAICS22: "493110",
      "INDEX ITEM DESCRIPTION": "General warehousing and storage",
    },
    {
      NAICS22: "493110",
      "INDEX ITEM DESCRIPTION":
        "Private warehousing and storage, general merchandise",
    },
    {
      NAICS22: "493110",
      "INDEX ITEM DESCRIPTION":
        "Public warehousing and storage (except self-storage), general merchandise",
    },
    {
      NAICS22: "493110",
      "INDEX ITEM DESCRIPTION":
        "Warehousing (including foreign trade zones), general merchandise",
    },
    {
      NAICS22: "493110",
      "INDEX ITEM DESCRIPTION": "Warehousing and storage, general merchandise",
    },
    {
      NAICS22: "493120",
      "INDEX ITEM DESCRIPTION": "Bonded warehousing, refrigerated",
    },
    {
      NAICS22: "493120",
      "INDEX ITEM DESCRIPTION": "Cold storage locker services",
    },
    {
      NAICS22: "493120",
      "INDEX ITEM DESCRIPTION": "Cold storage warehousing",
    },
    {
      NAICS22: "493120",
      "INDEX ITEM DESCRIPTION":
        "Farm product warehousing and storage, refrigerated",
    },
    {
      NAICS22: "493120",
      "INDEX ITEM DESCRIPTION": "Fur storage warehousing for the trade",
    },
    {
      NAICS22: "493120",
      "INDEX ITEM DESCRIPTION": "Private warehousing and storage, refrigerated",
    },
    {
      NAICS22: "493120",
      "INDEX ITEM DESCRIPTION": "Public warehousing and storage, refrigerated",
    },
    {
      NAICS22: "493120",
      "INDEX ITEM DESCRIPTION": "Refrigerated warehousing",
    },
    {
      NAICS22: "493120",
      "INDEX ITEM DESCRIPTION": "Warehousing, refrigerated",
    },
    {
      NAICS22: "493130",
      "INDEX ITEM DESCRIPTION":
        "Bonded warehousing, farm products (except refrigerated)",
    },
    {
      NAICS22: "493130",
      "INDEX ITEM DESCRIPTION":
        "Farm product warehousing and storage (except refrigerated)",
    },
    {
      NAICS22: "493130",
      "INDEX ITEM DESCRIPTION": "Grain elevators, storage only",
    },
    {
      NAICS22: "493130",
      "INDEX ITEM DESCRIPTION":
        "Private warehousing and storage, farm products (except refrigerated)",
    },
    {
      NAICS22: "493130",
      "INDEX ITEM DESCRIPTION":
        "Public warehousing and storage, farm products (except refrigerated)",
    },
    {
      NAICS22: "493130",
      "INDEX ITEM DESCRIPTION":
        "Warehousing, farm products (except refrigerated)",
    },
    {
      NAICS22: "493190",
      "INDEX ITEM DESCRIPTION": "Automobile dead storage",
    },
    {
      NAICS22: "493190",
      "INDEX ITEM DESCRIPTION":
        "Bonded warehousing (except farm products, general merchandise, refrigerated)",
    },
    {
      NAICS22: "493190",
      "INDEX ITEM DESCRIPTION": "Bulk petroleum storage",
    },
    {
      NAICS22: "493190",
      "INDEX ITEM DESCRIPTION": "Document storage and warehousing",
    },
    {
      NAICS22: "493190",
      "INDEX ITEM DESCRIPTION": "Lumber storage terminals",
    },
    {
      NAICS22: "493190",
      "INDEX ITEM DESCRIPTION":
        "Private warehousing and storage (except farm products, general merchandise, refrigerated)",
    },
    {
      NAICS22: "493190",
      "INDEX ITEM DESCRIPTION":
        "Public warehousing and storage (except farm products, general merchandise, refrigerated, self-storage)",
    },
    {
      NAICS22: "493190",
      "INDEX ITEM DESCRIPTION":
        "Warehousing (except farm products, general merchandise, refrigerated)",
    },
    {
      NAICS22: "493190",
      "INDEX ITEM DESCRIPTION": "Whiskey warehousing",
    },
    {
      NAICS22: "512110",
      "INDEX ITEM DESCRIPTION": "Animated cartoon production",
    },
    {
      NAICS22: "512110",
      "INDEX ITEM DESCRIPTION": "Animated cartoon production and distribution",
    },
    {
      NAICS22: "512110",
      "INDEX ITEM DESCRIPTION": "Commercials, television, production",
    },
    {
      NAICS22: "512110",
      "INDEX ITEM DESCRIPTION": "Film studios producing films",
    },
    {
      NAICS22: "512110",
      "INDEX ITEM DESCRIPTION": "Films, motion picture production",
    },
    {
      NAICS22: "512110",
      "INDEX ITEM DESCRIPTION":
        "Films, motion picture production and distribution",
    },
    {
      NAICS22: "512110",
      "INDEX ITEM DESCRIPTION": "Instructional video production",
    },
    {
      NAICS22: "512110",
      "INDEX ITEM DESCRIPTION": "Motion picture and video production",
    },
    {
      NAICS22: "512110",
      "INDEX ITEM DESCRIPTION":
        "Motion picture and video production and distribution",
    },
    {
      NAICS22: "512110",
      "INDEX ITEM DESCRIPTION": "Motion picture production",
    },
    {
      NAICS22: "512110",
      "INDEX ITEM DESCRIPTION": "Motion picture production and distribution",
    },
    {
      NAICS22: "512110",
      "INDEX ITEM DESCRIPTION": "Motion picture production payroll agents",
    },
    {
      NAICS22: "512110",
      "INDEX ITEM DESCRIPTION":
        "Motion picture studios, producing motion pictures",
    },
    {
      NAICS22: "512110",
      "INDEX ITEM DESCRIPTION": "Movie production and distribution",
    },
    {
      NAICS22: "512110",
      "INDEX ITEM DESCRIPTION": "Music video production",
    },
    {
      NAICS22: "512110",
      "INDEX ITEM DESCRIPTION": "Music video production and distribution",
    },
    {
      NAICS22: "512110",
      "INDEX ITEM DESCRIPTION": "Program producing, television",
    },
    {
      NAICS22: "512110",
      "INDEX ITEM DESCRIPTION": "Television commercial production",
    },
    {
      NAICS22: "512110",
      "INDEX ITEM DESCRIPTION": "Television show production",
    },
    {
      NAICS22: "512110",
      "INDEX ITEM DESCRIPTION": "Video production",
    },
    {
      NAICS22: "512110",
      "INDEX ITEM DESCRIPTION": "Video production and distribution",
    },
    {
      NAICS22: "512120",
      "INDEX ITEM DESCRIPTION": "Animated cartoon distribution",
    },
    {
      NAICS22: "512120",
      "INDEX ITEM DESCRIPTION": "Film distribution agencies",
    },
    {
      NAICS22: "512120",
      "INDEX ITEM DESCRIPTION": "Film distribution, motion picture and video",
    },
    {
      NAICS22: "512120",
      "INDEX ITEM DESCRIPTION": "Film libraries, commercial distribution",
    },
    {
      NAICS22: "512120",
      "INDEX ITEM DESCRIPTION":
        "Motion picture distribution exclusive of production",
    },
    {
      NAICS22: "512120",
      "INDEX ITEM DESCRIPTION": "Motion picture film distributors",
    },
    {
      NAICS22: "512120",
      "INDEX ITEM DESCRIPTION":
        "Motion picture film libraries, commercial distribution",
    },
    {
      NAICS22: "512120",
      "INDEX ITEM DESCRIPTION": "Tape distribution for television",
    },
    {
      NAICS22: "512120",
      "INDEX ITEM DESCRIPTION": "Television show syndicators",
    },
    {
      NAICS22: "512131",
      "INDEX ITEM DESCRIPTION": "Cinemas",
    },
    {
      NAICS22: "512131",
      "INDEX ITEM DESCRIPTION": "Film festivals exhibitors",
    },
    {
      NAICS22: "512131",
      "INDEX ITEM DESCRIPTION": "Motion picture exhibition",
    },
    {
      NAICS22: "512131",
      "INDEX ITEM DESCRIPTION": "Motion picture exhibitors for airlines",
    },
    {
      NAICS22: "512131",
      "INDEX ITEM DESCRIPTION": "Motion picture exhibitors, itinerant",
    },
    {
      NAICS22: "512131",
      "INDEX ITEM DESCRIPTION": "Motion picture theaters, indoor",
    },
    {
      NAICS22: "512131",
      "INDEX ITEM DESCRIPTION": "Movie theaters (except drive-in)",
    },
    {
      NAICS22: "512131",
      "INDEX ITEM DESCRIPTION": "Theaters, motion picture (except drive-in)",
    },
    {
      NAICS22: "512131",
      "INDEX ITEM DESCRIPTION": "Theaters, motion picture, indoor",
    },
    {
      NAICS22: "512132",
      "INDEX ITEM DESCRIPTION": "Drive-in motion picture theaters",
    },
    {
      NAICS22: "512132",
      "INDEX ITEM DESCRIPTION": "Motion picture theaters, drive-in",
    },
    {
      NAICS22: "512132",
      "INDEX ITEM DESCRIPTION": "Movie theaters, drive-in",
    },
    {
      NAICS22: "512132",
      "INDEX ITEM DESCRIPTION": "Open air motion picture theaters",
    },
    {
      NAICS22: "512132",
      "INDEX ITEM DESCRIPTION": "Theaters, motion picture, drive-in",
    },
    {
      NAICS22: "512132",
      "INDEX ITEM DESCRIPTION": "Theaters, outdoor motion picture",
    },
    {
      NAICS22: "512191",
      "INDEX ITEM DESCRIPTION": "Closed captioning services, taped material",
    },
    {
      NAICS22: "512191",
      "INDEX ITEM DESCRIPTION": "Film or tape closed captioning",
    },
    {
      NAICS22: "512191",
      "INDEX ITEM DESCRIPTION": "Film or video transfer services",
    },
    {
      NAICS22: "512191",
      "INDEX ITEM DESCRIPTION": "Motion picture animation, postproduction",
    },
    {
      NAICS22: "512191",
      "INDEX ITEM DESCRIPTION": "Motion picture or video editing services",
    },
    {
      NAICS22: "512191",
      "INDEX ITEM DESCRIPTION": "Motion picture or video postproduction services",
    },
    {
      NAICS22: "512191",
      "INDEX ITEM DESCRIPTION": "Motion picture or video titling",
    },
    {
      NAICS22: "512191",
      "INDEX ITEM DESCRIPTION":
        "Motion picture production special effects, postproduction",
    },
    {
      NAICS22: "512191",
      "INDEX ITEM DESCRIPTION":
        "Postproduction facilities, motion picture or video",
    },
    {
      NAICS22: "512191",
      "INDEX ITEM DESCRIPTION": "Post-synchronization sound dubbing",
    },
    {
      NAICS22: "512191",
      "INDEX ITEM DESCRIPTION": "Sound dubbing services, motion picture",
    },
    {
      NAICS22: "512191",
      "INDEX ITEM DESCRIPTION":
        "Special effects for motion picture production, postproduction",
    },
    {
      NAICS22: "512191",
      "INDEX ITEM DESCRIPTION": "Subtitling of motion picture film or video",
    },
    {
      NAICS22: "512191",
      "INDEX ITEM DESCRIPTION": "Tape transfer service",
    },
    {
      NAICS22: "512191",
      "INDEX ITEM DESCRIPTION": "Teleproduction services",
    },
    {
      NAICS22: "512191",
      "INDEX ITEM DESCRIPTION": "Titling of motion picture film or video",
    },
    {
      NAICS22: "512191",
      "INDEX ITEM DESCRIPTION":
        "Video conversion services (i.e., between formats, except technical streaming support services)",
    },
    {
      NAICS22: "512191",
      "INDEX ITEM DESCRIPTION": "Video postproduction services",
    },
    {
      NAICS22: "512191",
      "INDEX ITEM DESCRIPTION":
        "Video tape and film stock digitization services (except technical streaming support services)",
    },
    {
      NAICS22: "512199",
      "INDEX ITEM DESCRIPTION": "Booking agencies, motion picture",
    },
    {
      NAICS22: "512199",
      "INDEX ITEM DESCRIPTION":
        "Booking agencies, motion picture or video productions",
    },
    {
      NAICS22: "512199",
      "INDEX ITEM DESCRIPTION":
        "Film libraries, motion picture or video, stock footage",
    },
    {
      NAICS22: "512199",
      "INDEX ITEM DESCRIPTION": "Film preservation services",
    },
    {
      NAICS22: "512199",
      "INDEX ITEM DESCRIPTION": "Film processing laboratories, motion picture",
    },
    {
      NAICS22: "512199",
      "INDEX ITEM DESCRIPTION": "Film restoration services",
    },
    {
      NAICS22: "512199",
      "INDEX ITEM DESCRIPTION": "Laboratory services, motion picture",
    },
    {
      NAICS22: "512199",
      "INDEX ITEM DESCRIPTION": "Libraries, motion picture stock footage film",
    },
    {
      NAICS22: "512199",
      "INDEX ITEM DESCRIPTION": "Libraries, video tape, stock footage",
    },
    {
      NAICS22: "512199",
      "INDEX ITEM DESCRIPTION": "Motion picture booking agencies",
    },
    {
      NAICS22: "512199",
      "INDEX ITEM DESCRIPTION": "Motion picture film laboratories",
    },
    {
      NAICS22: "512199",
      "INDEX ITEM DESCRIPTION": "Motion picture film libraries, stock footage",
    },
    {
      NAICS22: "512199",
      "INDEX ITEM DESCRIPTION":
        "Motion picture film reproduction for theatrical distribution",
    },
    {
      NAICS22: "512199",
      "INDEX ITEM DESCRIPTION": "Motion picture laboratories",
    },
    {
      NAICS22: "512199",
      "INDEX ITEM DESCRIPTION":
        "Reproduction of motion picture films for theatrical distribution",
    },
    {
      NAICS22: "512199",
      "INDEX ITEM DESCRIPTION": "Stock footage film libraries",
    },
    {
      NAICS22: "512199",
      "INDEX ITEM DESCRIPTION": "Video tape libraries, stock footage",
    },
    {
      NAICS22: "512230",
      "INDEX ITEM DESCRIPTION": "Music book (i.e., bound sheet music) publishers",
    },
    {
      NAICS22: "512230",
      "INDEX ITEM DESCRIPTION":
        "Music book (i.e., bound sheet music) publishers and printing combined",
    },
    {
      NAICS22: "512230",
      "INDEX ITEM DESCRIPTION": "Music copyright authorizing use",
    },
    {
      NAICS22: "512230",
      "INDEX ITEM DESCRIPTION": "Music copyright buying and licensing",
    },
    {
      NAICS22: "512230",
      "INDEX ITEM DESCRIPTION": "Music publishers",
    },
    {
      NAICS22: "512230",
      "INDEX ITEM DESCRIPTION": "Music, sheet, publishers and printing combined",
    },
    {
      NAICS22: "512230",
      "INDEX ITEM DESCRIPTION": "Publishers, music",
    },
    {
      NAICS22: "512230",
      "INDEX ITEM DESCRIPTION": "Sheet music publishers",
    },
    {
      NAICS22: "512230",
      "INDEX ITEM DESCRIPTION": "Sheet music publishers and printing combined",
    },
    {
      NAICS22: "512230",
      "INDEX ITEM DESCRIPTION": "Song publishers",
    },
    {
      NAICS22: "512230",
      "INDEX ITEM DESCRIPTION": "Song publishers and printing combined",
    },
    {
      NAICS22: "512240",
      "INDEX ITEM DESCRIPTION": "Audio recording postproduction services",
    },
    {
      NAICS22: "512240",
      "INDEX ITEM DESCRIPTION": "Audio recording restoration services",
    },
    {
      NAICS22: "512240",
      "INDEX ITEM DESCRIPTION":
        "Recording studios, sound, operating on a contract or fee basis",
    },
    {
      NAICS22: "512240",
      "INDEX ITEM DESCRIPTION":
        "Sound recording studios (except integrated record companies)",
    },
    {
      NAICS22: "512250",
      "INDEX ITEM DESCRIPTION":
        "Integrated record companies (i.e., releasing, promoting, distributing)",
    },
    {
      NAICS22: "512250",
      "INDEX ITEM DESCRIPTION": "Integrated record production and distribution",
    },
    {
      NAICS22: "512250",
      "INDEX ITEM DESCRIPTION": "Master recording leasing and licensing",
    },
    {
      NAICS22: "512250",
      "INDEX ITEM DESCRIPTION":
        "Musical recording, releasing, promoting, and distributing",
    },
    {
      NAICS22: "512250",
      "INDEX ITEM DESCRIPTION":
        "Prerecorded audio tapes and compact discs integrated manufacture, release, and distribution",
    },
    {
      NAICS22: "512250",
      "INDEX ITEM DESCRIPTION": "Record producers (except independent)",
    },
    {
      NAICS22: "512250",
      "INDEX ITEM DESCRIPTION":
        "Record production (except independent record producers) without duplication or distribution",
    },
    {
      NAICS22: "512250",
      "INDEX ITEM DESCRIPTION":
        "Record releasing, promoting, and distributing combined with mass duplication",
    },
    {
      NAICS22: "512250",
      "INDEX ITEM DESCRIPTION":
        "Sound recording, integrated production, reproduction, release, and distribution",
    },
    {
      NAICS22: "512250",
      "INDEX ITEM DESCRIPTION":
        "Sound recording, releasing, promoting, and distributing",
    },
    {
      NAICS22: "512290",
      "INDEX ITEM DESCRIPTION": "Audio recording of meetings or conferences",
    },
    {
      NAICS22: "512290",
      "INDEX ITEM DESCRIPTION":
        "Producers, recorded radio shows (except independent producers)",
    },
    {
      NAICS22: "512290",
      "INDEX ITEM DESCRIPTION":
        "Radio program recording production (except independent producers) ",
    },
    {
      NAICS22: "512290",
      "INDEX ITEM DESCRIPTION":
        "Recording books on tape or disc (except publishers)",
    },
    {
      NAICS22: "512290",
      "INDEX ITEM DESCRIPTION": "Recording seminars and conferences, audio",
    },
    {
      NAICS22: "512290",
      "INDEX ITEM DESCRIPTION": "Stock music and other audio services",
    },
    {
      NAICS22: "512290",
      "INDEX ITEM DESCRIPTION":
        "Stock sound library (e.g., general background sounds, stock music)",
    },
    {
      NAICS22: "513110",
      "INDEX ITEM DESCRIPTION": "Internet newspaper publishing",
    },
    {
      NAICS22: "513110",
      "INDEX ITEM DESCRIPTION": "Newspaper branch offices",
    },
    {
      NAICS22: "513110",
      "INDEX ITEM DESCRIPTION": "Newspaper publishers",
    },
    {
      NAICS22: "513110",
      "INDEX ITEM DESCRIPTION":
        "Newspaper publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513110",
      "INDEX ITEM DESCRIPTION": "Newspaper publishers and printing combined",
    },
    {
      NAICS22: "513110",
      "INDEX ITEM DESCRIPTION": "Newspaper publishing, exclusively on Internet",
    },
    {
      NAICS22: "513110",
      "INDEX ITEM DESCRIPTION": "Publishers, newspaper",
    },
    {
      NAICS22: "513110",
      "INDEX ITEM DESCRIPTION":
        "Publishers, newspaper (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513110",
      "INDEX ITEM DESCRIPTION": "Publishers, newspaper, combined with printing",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Advertising periodical publishers",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Advertising periodical publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Advertising periodical publishers and printing combined",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Advertising periodical publishers, exclusively on Internet",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Agricultural magazine and periodical publishers",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Agricultural magazine and periodical publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Agricultural magazine and periodical publishers and printing combined",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Agricultural magazine and periodical publishers, exclusively on Internet",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Comic book publishers",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Comic book publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Comic book publishers and printing combined",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Comic book publishers, exclusively on Internet",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Financial magazine and periodical publishers",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Financial magazine and periodical publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Financial magazine and periodical publishers and printing combined",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Financial magazine and periodical publishers, exclusively on Internet",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Internet comic book publishing",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Internet magazine publishing",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Internet newsletter publishing",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Internet periodical publishers",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Juvenile magazine and periodical publishers",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Juvenile magazine and periodical publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Juvenile magazine and periodical publishers and printing combined",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Juvenile magazine and periodical publishers, exclusively on Internet",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Magazine publishers",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Magazine publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Magazine publishers and printing combined",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Magazine publishers, exclusively on Internet",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Medical journal and periodical publishers",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Medical journal and periodical publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Medical journal and periodical publishers and printing combined",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Medical journal and periodical publishers, exclusively on Internet ",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Newsletter publishers",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Newsletter publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Newsletter publishers and printing combined",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Newsletter publishers, exclusively on Internet",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Periodical publishers",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Periodical publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Periodical publishers and printing combined",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Periodical publishers, exclusively on Internet",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Professional magazine and periodical publishers",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Professional magazine and periodical publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Professional magazine and periodical publishers and printing combined",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Professional magazine and periodical publishers, exclusively on Internet",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Publishers (except exclusive Internet publishing), magazine",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Publishers (except exclusive Internet publishing), periodical",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Publishers, magazine",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Publishers, magazine, combined with printing",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Publishers, periodical",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Publishers, periodical, combined with printing",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Radio guide publishers",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Radio guide publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Radio guide publishers and printing combined",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Radio guide publishers, exclusively on Internet",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Radio schedule publishers",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Radio schedule publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Radio schedule publishers and printing combined",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Radio schedule publishers, exclusively on Internet",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Religious magazine and periodical publishers",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Religious magazine and periodical publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Religious magazine and periodical publishers and printing combined",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Religious magazine and periodical publishers, exclusively on Internet",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Scholarly journal publishers",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Scholarly journal publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Scholarly journal publishers and printing combined",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Scholarly journal publishers, exclusively on Internet",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Scholastic magazine and periodical publishers",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Scholastic magazine and periodical publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Scholastic magazine and periodical publishers and printing combined",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Scholastic magazine and periodical publishers, exclusively on Internet",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Scientific journal and periodical publishers",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Scientific journal and periodical publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Scientific journal and periodical publishers and printing combined",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Scientific journal and periodical publishers, exclusively on Internet",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Technical magazine and periodical publishers",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Technical magazine and periodical publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Technical magazine and periodical publishers and printing combined",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Technical magazine and periodical publishers, exclusively on Internet",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Television guide publishers",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Television guide publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Television guide publishers and printing combined",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Television guide publishers, exclusively on Internet",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Trade journal publishers",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Trade journal publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Trade journal publishers and printing combined",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Trade journal publishers, exclusively on Internet",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION": "Trade magazine and periodical publishers",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Trade magazine and periodical publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Trade magazine and periodical publishers and printing combined",
    },
    {
      NAICS22: "513120",
      "INDEX ITEM DESCRIPTION":
        "Trade magazine and periodical publishers, exclusively on Internet",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Almanac publishers",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "Almanac publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Almanac publishers and printing combined",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Almanac publishers, exclusively on Internet",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Atlas publishers",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "Atlas publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Atlas publishers and printing combined",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Atlas publishers, exclusively on Internet",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "Book (e.g., hardback, paperback, audio) publishers",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "Book (e.g., hardback, paperback, audio) publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Book publishers and printing combined",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Book publishers, exclusively on Internet",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Book publishers, university press",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "Book publishers, university press (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Dictionary publishers",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "Dictionary publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Dictionary publishers and printing combined",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Dictionary publishers, exclusively on Internet",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Encyclopedia publishers",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "Encyclopedia publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Encyclopedia publishers and printing combined",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "Encyclopedia publishers, exclusively on Internet",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Fiction book publishers",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "Fiction book publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Fiction book publishers and printing combined",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "Fiction book publishers, exclusively on Internet",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Globe cover publishers",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Globe cover publishers and printing combined",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Graphic novel publishers",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Guide, street map, publishers",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "Guide, street map, publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "Guide, street map, publishers and printing combined",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "Guide, street map, publishers, exclusively on Internet",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Internet book publishers",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Map publishers",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "Map publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Map publishers and printing combined",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Map publishers, exclusively on Internet",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Nonfiction book publishers",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "Nonfiction book publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "Nonfiction book publishers and printing combined",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "Nonfiction book publishers, exclusively on Internet",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Pamphlet publishers",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "Pamphlet publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Pamphlet publishers and printing combined",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Pamphlet publishers, exclusively on Internet",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Professional book publishers",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "Professional book publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "Professional book publishers and printing combined",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "Professional book publishers, exclusively on Internet",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "Publishers (except exclusive Internet publishing), book",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "Publishers (except exclusive Internet publishing), map",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Publishers, book",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Publishers, book, combined with printing",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Publishers, Internet map",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Publishers, map",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Religious book publishers",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "Religious book publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Religious book publishers and printing combined",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "Religious book publishers, exclusively on Internet",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "School book publishers",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "School book publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "School book publishers and printing combined",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "School book publishers, exclusively on Internet",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "School textbook publishers",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "School textbook publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "School textbook publishers and printing combined",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "School textbook publishers, exclusively on Internet",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Street map guide publishers",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "Street map guide publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "Street map guide publishers, exclusively on Internet",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Technical manual and paperback book publishers",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "Technical manual and paperback book publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "Technical manual and paperback book publishers and printing combined",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Technical manual publishers",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "Technical manual publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "Technical manual publishers, exclusively on Internet",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "Travel guide book publishers",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "Travel guide book publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "Travel guide book publishers and printing combined",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "Travel guide book publishers, exclusively on Internet",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION": "University press publishers",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "University press publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513130",
      "INDEX ITEM DESCRIPTION":
        "University press publishers, exclusively on Internet",
    },
    {
      NAICS22: "513140",
      "INDEX ITEM DESCRIPTION": "Address list publishers",
    },
    {
      NAICS22: "513140",
      "INDEX ITEM DESCRIPTION":
        "Address list publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513140",
      "INDEX ITEM DESCRIPTION": "Address list publishers and printing combined",
    },
    {
      NAICS22: "513140",
      "INDEX ITEM DESCRIPTION": "Business directory publishers",
    },
    {
      NAICS22: "513140",
      "INDEX ITEM DESCRIPTION":
        "Business directory publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513140",
      "INDEX ITEM DESCRIPTION":
        "Business directory publishers and printing combined",
    },
    {
      NAICS22: "513140",
      "INDEX ITEM DESCRIPTION":
        "Business directory publishers, exclusively on Internet",
    },
    {
      NAICS22: "513140",
      "INDEX ITEM DESCRIPTION": "Catalog of collections publishers",
    },
    {
      NAICS22: "513140",
      "INDEX ITEM DESCRIPTION":
        "Catalog of collections publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513140",
      "INDEX ITEM DESCRIPTION":
        "Catalog of collections publishers and printing combined",
    },
    {
      NAICS22: "513140",
      "INDEX ITEM DESCRIPTION":
        "Catalog of collections publishers, exclusively on Internet",
    },
    {
      NAICS22: "513140",
      "INDEX ITEM DESCRIPTION": "Directory and mailing list publishers",
    },
    {
      NAICS22: "513140",
      "INDEX ITEM DESCRIPTION":
        "Directory and mailing list publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513140",
      "INDEX ITEM DESCRIPTION":
        "Directory and mailing list publishers and printing combined",
    },
    {
      NAICS22: "513140",
      "INDEX ITEM DESCRIPTION": "Directory publishers",
    },
    {
      NAICS22: "513140",
      "INDEX ITEM DESCRIPTION":
        "Directory publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513140",
      "INDEX ITEM DESCRIPTION": "Directory publishers and printing combined",
    },
    {
      NAICS22: "513140",
      "INDEX ITEM DESCRIPTION": "Directory publishers, exclusively on Internet",
    },
    {
      NAICS22: "513140",
      "INDEX ITEM DESCRIPTION": "Electronic directory publishers",
    },
    {
      NAICS22: "513140",
      "INDEX ITEM DESCRIPTION":
        "Electronic directory publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513140",
      "INDEX ITEM DESCRIPTION":
        "Electronic directory publishers, exclusively on Internet",
    },
    {
      NAICS22: "513140",
      "INDEX ITEM DESCRIPTION": "Mailing list publishers",
    },
    {
      NAICS22: "513140",
      "INDEX ITEM DESCRIPTION":
        "Mailing list publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513140",
      "INDEX ITEM DESCRIPTION":
        "Publishers (except exclusive Internet publishing), directory",
    },
    {
      NAICS22: "513140",
      "INDEX ITEM DESCRIPTION": "Publishers, directory",
    },
    {
      NAICS22: "513140",
      "INDEX ITEM DESCRIPTION": "Subscription directory publishers",
    },
    {
      NAICS22: "513140",
      "INDEX ITEM DESCRIPTION": "Telephone directory publishers",
    },
    {
      NAICS22: "513140",
      "INDEX ITEM DESCRIPTION":
        "Telephone directory publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513140",
      "INDEX ITEM DESCRIPTION":
        "Telephone directory publishers and printing combined",
    },
    {
      NAICS22: "513140",
      "INDEX ITEM DESCRIPTION":
        "Telephone directory publishers, exclusively on Internet",
    },
    {
      NAICS22: "513191",
      "INDEX ITEM DESCRIPTION": "Greeting card publishers",
    },
    {
      NAICS22: "513191",
      "INDEX ITEM DESCRIPTION":
        "Greeting card publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513191",
      "INDEX ITEM DESCRIPTION": "Greeting card publishers and printing combined",
    },
    {
      NAICS22: "513191",
      "INDEX ITEM DESCRIPTION":
        "Greeting card publishers, exclusively on Internet",
    },
    {
      NAICS22: "513191",
      "INDEX ITEM DESCRIPTION":
        "Publishers (except exclusive Internet publishing), greeting card",
    },
    {
      NAICS22: "513191",
      "INDEX ITEM DESCRIPTION": "Publishers, greeting card",
    },
    {
      NAICS22: "513191",
      "INDEX ITEM DESCRIPTION":
        "Publishers, greeting card, combined with printing",
    },
    {
      NAICS22: "513191",
      "INDEX ITEM DESCRIPTION": "Publishers, Internet greeting card",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION":
        "Art print (except exclusive Internet publishing) publishers",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION": "Art print publishers",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION": "Art print publishers and printing combined",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION": "Art publishers",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION":
        "Art publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION": "Art publishers, exclusively on Internet",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION": "Calendar publishers",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION":
        "Calendar publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION": "Calendar publishers and printing combined",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION": "Calendar publishers, exclusively on Internet",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION":
        "Catalog (i.e., mail-order, store merchandise) publishers",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION":
        "Catalog (i.e., mail-order, store merchandise) publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION":
        "Catalog (i.e., mail-order, store merchandise) publishers and printing combined",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION": "Children's coloring book publishers",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION":
        "Children's coloring book publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION":
        "Children's coloring book publishers, exclusively on Internet",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION": "Diary and time scheduler publishers",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION":
        "Diary and time scheduler publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION":
        "Diary and time scheduler publishers, exclusively on Internet",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION": "Discount coupon book publishers",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION":
        "Discount coupon book publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION":
        "Discount coupon book publishers and printing combined",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION":
        "Discount coupon book publishers, exclusively on Internet",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION": "Limited editions art print publishers",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION":
        "Limited editions art print publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION":
        "Pattern and plan (e.g., clothing patterns) publishers",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION":
        "Pattern and plan (e.g., clothing patterns) publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION":
        "Pattern and plan (e.g., clothing patterns) publishers and printing combined",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION":
        "Pattern and plan (e.g., clothing patterns) publishers, exclusively on Internet",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION": "Postcard publishers",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION":
        "Postcard publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION": "Postcard publishers and printing combined",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION": "Postcard publishers, exclusively on Internet",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION": "Poster publishers",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION":
        "Poster publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION": "Poster publishers and printing combined",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION": "Poster publishers, exclusively on Internet",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION":
        "Publishers (except exclusive Internet publishing), racing form",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION": "Publishers, Internet racing form",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION": "Publishers, racing form",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION": "Racetrack program publishers",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION":
        "Racetrack program publishers and printing combined",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION":
        "Racetrack program publishers, exclusively on Internet",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION": "Racing form publishers",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION":
        "Racing form publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION": "Racing form publishers and printing combined",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION": "Racing form publishers, exclusively on Internet",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION":
        "Yearbook (e.g., high school, college, university) publishers",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION":
        "Yearbook (e.g., high school, college, university) publishers (except exclusive Internet publishing)",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION":
        "Yearbook (e.g., high school, college, university) publishers and printing combined",
    },
    {
      NAICS22: "513199",
      "INDEX ITEM DESCRIPTION":
        "Yearbook (e.g., high school, college, university) publishers, exclusively on Internet",
    },
    {
      NAICS22: "513210",
      "INDEX ITEM DESCRIPTION":
        "Applications development and publishing, except on a custom basis",
    },
    {
      NAICS22: "513210",
      "INDEX ITEM DESCRIPTION": "Applications software, computer, packaged",
    },
    {
      NAICS22: "513210",
      "INDEX ITEM DESCRIPTION": "Computer software publishers, packaged",
    },
    {
      NAICS22: "513210",
      "INDEX ITEM DESCRIPTION": "Computer software publishing and reproduction",
    },
    {
      NAICS22: "513210",
      "INDEX ITEM DESCRIPTION": "Games, computer software, publishing",
    },
    {
      NAICS22: "513210",
      "INDEX ITEM DESCRIPTION": "Gaming site publishers",
    },
    {
      NAICS22: "513210",
      "INDEX ITEM DESCRIPTION":
        "Mobile applications development and publishing, except on a custom basis",
    },
    {
      NAICS22: "513210",
      "INDEX ITEM DESCRIPTION": "Operating systems software, computer, packaged",
    },
    {
      NAICS22: "513210",
      "INDEX ITEM DESCRIPTION": "Packaged computer software publishers",
    },
    {
      NAICS22: "513210",
      "INDEX ITEM DESCRIPTION":
        "Programming language and compiler software publishers, packaged",
    },
    {
      NAICS22: "513210",
      "INDEX ITEM DESCRIPTION": "Publishers, packaged computer software",
    },
    {
      NAICS22: "513210",
      "INDEX ITEM DESCRIPTION": "Software computer, packaged, publishers",
    },
    {
      NAICS22: "513210",
      "INDEX ITEM DESCRIPTION": "Software publishers",
    },
    {
      NAICS22: "513210",
      "INDEX ITEM DESCRIPTION": "Software publishers, packaged",
    },
    {
      NAICS22: "513210",
      "INDEX ITEM DESCRIPTION": "Utility software, computer, packaged",
    },
    {
      NAICS22: "516110",
      "INDEX ITEM DESCRIPTION":
        "Advertising sales offices of independent and public radio broadcast stations",
    },
    {
      NAICS22: "516110",
      "INDEX ITEM DESCRIPTION": "AM radio stations",
    },
    {
      NAICS22: "516110",
      "INDEX ITEM DESCRIPTION":
        "Broadcasting stations (except exclusively on Internet), radio",
    },
    {
      NAICS22: "516110",
      "INDEX ITEM DESCRIPTION": "Broadcasting studio, radio station",
    },
    {
      NAICS22: "516110",
      "INDEX ITEM DESCRIPTION": "FM radio stations",
    },
    {
      NAICS22: "516110",
      "INDEX ITEM DESCRIPTION":
        "Music program distribution, broadcasting stations (except exclusively on Internet), radio",
    },
    {
      NAICS22: "516110",
      "INDEX ITEM DESCRIPTION": "Piped-in music services, radio transmitted",
    },
    {
      NAICS22: "516110",
      "INDEX ITEM DESCRIPTION":
        "Radio broadcasting (except exclusively on Internet) stations (e.g., AM, FM, shortwave)",
    },
    {
      NAICS22: "516110",
      "INDEX ITEM DESCRIPTION": "Radio stations (except exclusively on Internet)",
    },
    {
      NAICS22: "516110",
      "INDEX ITEM DESCRIPTION":
        "Rebroadcast radio stations (except exclusively on Internet)",
    },
    {
      NAICS22: "516120",
      "INDEX ITEM DESCRIPTION": "Broadcasting stations, television",
    },
    {
      NAICS22: "516120",
      "INDEX ITEM DESCRIPTION": "Television broadcasting stations",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Blog sites, Internet",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Broadcasting exclusively on Internet, audio",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Broadcasting exclusively on Internet, video",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Broadcasting networks, radio",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Broadcasting networks, television",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Cable broadcasting networks",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Cable television networks",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Entertainment broadcasting sites, Internet",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION":
        "Feature syndicates (i.e., advice columns, comic, news)",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Gaming sites, Internet (except publishers)",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Internet broadcasting",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Internet entertainment broadcasting sites",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Internet radio stations",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Internet sports broadcasting sites",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Internet video broadcast sites",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION":
        "Media (e.g., audio, video) streaming distribution services",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Network broadcasting service, radio",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Network radio broadcasting",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Network television broadcasting",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Networks, cable television",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION":
        "News picture gathering and distributing services",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "News reporting services",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "News service syndicates",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "News ticker services",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Newspaper feature syndicates",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Pay television networks",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Pay-per-view cable programming",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Radio broadcasting network services",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Radio broadcasting networks",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Radio broadcasting syndicates",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Road traffic reporting services",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Satellite radio networks",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Satellite television networks",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Social network sites, Internet",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION":
        "Specialty television (e.g., music, sports, news) cable networks",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Stand-alone streaming services",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Subscription television networks",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Subscription Video on Demand (SVOD) services",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Syndicates, news",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Television broadcasting networks",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Television subscription services",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Video broadcasting, exclusively on Internet",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Video on Demand (VOD) programming",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION":
        "Video on Demand (VOD) streaming distribution services",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION":
        "Virtual Multichannel Video Programming Distributors (vMVPDs)",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Web broadcasting",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Wiki sites, Internet",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Wire photo services",
    },
    {
      NAICS22: "516210",
      "INDEX ITEM DESCRIPTION": "Wire services, news",
    },
    {
      NAICS22: "517111",
      "INDEX ITEM DESCRIPTION": "Cable program distribution operators",
    },
    {
      NAICS22: "517111",
      "INDEX ITEM DESCRIPTION": "Cable television distribution services",
    },
    {
      NAICS22: "517111",
      "INDEX ITEM DESCRIPTION": "Cable TV providers (except networks)",
    },
    {
      NAICS22: "517111",
      "INDEX ITEM DESCRIPTION": "Closed-circuit television (CCTV) services",
    },
    {
      NAICS22: "517111",
      "INDEX ITEM DESCRIPTION": "Direct broadcast satellite (DBS) services",
    },
    {
      NAICS22: "517111",
      "INDEX ITEM DESCRIPTION": "Direct-to-home satellite system (DTH) services",
    },
    {
      NAICS22: "517111",
      "INDEX ITEM DESCRIPTION":
        "Internet service providers, using own operated wired telecommunications infrastructure (e.g., cable, DSL)",
    },
    {
      NAICS22: "517111",
      "INDEX ITEM DESCRIPTION": "Local telephone carriers, wired",
    },
    {
      NAICS22: "517111",
      "INDEX ITEM DESCRIPTION": "Long-distance telephone carriers, wired",
    },
    {
      NAICS22: "517111",
      "INDEX ITEM DESCRIPTION":
        "Multichannel multipoint distribution services (MMDS)",
    },
    {
      NAICS22: "517111",
      "INDEX ITEM DESCRIPTION":
        "Online access service providers, using own operated wired telecommunications infrastructure",
    },
    {
      NAICS22: "517111",
      "INDEX ITEM DESCRIPTION":
        "Satellite master antenna television service (SMATV)",
    },
    {
      NAICS22: "517111",
      "INDEX ITEM DESCRIPTION": "Satellite television distribution systems",
    },
    {
      NAICS22: "517111",
      "INDEX ITEM DESCRIPTION": "Telecommunications carriers, wired",
    },
    {
      NAICS22: "517111",
      "INDEX ITEM DESCRIPTION": "Television operations, closed-circuit",
    },
    {
      NAICS22: "517111",
      "INDEX ITEM DESCRIPTION":
        "VoIP service providers, using own operated wired telecommunications infrastructure ",
    },
    {
      NAICS22: "517112",
      "INDEX ITEM DESCRIPTION":
        "Beeper (i.e., radio pager) communication carriers",
    },
    {
      NAICS22: "517112",
      "INDEX ITEM DESCRIPTION": "Cellular telephone communication carriers",
    },
    {
      NAICS22: "517112",
      "INDEX ITEM DESCRIPTION": "Cellular telephone service carriers",
    },
    {
      NAICS22: "517112",
      "INDEX ITEM DESCRIPTION":
        "Mobile telephone communication carriers (except satellite)",
    },
    {
      NAICS22: "517112",
      "INDEX ITEM DESCRIPTION": "Paging services (except satellite)",
    },
    {
      NAICS22: "517112",
      "INDEX ITEM DESCRIPTION": "Radio paging services communications carriers",
    },
    {
      NAICS22: "517112",
      "INDEX ITEM DESCRIPTION":
        "Ship-to-shore broadcasting communication carriers (except satellite)",
    },
    {
      NAICS22: "517112",
      "INDEX ITEM DESCRIPTION": "Telecommunications carriers, cellular telephone",
    },
    {
      NAICS22: "517112",
      "INDEX ITEM DESCRIPTION":
        "Telephone communications carriers, wireless (except satellite)",
    },
    {
      NAICS22: "517112",
      "INDEX ITEM DESCRIPTION":
        "Two-way paging communication carriers (except satellite)",
    },
    {
      NAICS22: "517112",
      "INDEX ITEM DESCRIPTION":
        "Wireless data communication carriers (except satellite)",
    },
    {
      NAICS22: "517112",
      "INDEX ITEM DESCRIPTION":
        "Wireless Internet service providers (except satellite)",
    },
    {
      NAICS22: "517112",
      "INDEX ITEM DESCRIPTION":
        "Wireless telephone communications carriers (except satellite)",
    },
    {
      NAICS22: "517121",
      "INDEX ITEM DESCRIPTION":
        "Long-distance telecommunication resellers (except satellite telecommunications)",
    },
    {
      NAICS22: "517121",
      "INDEX ITEM DESCRIPTION": "Microwave telecommunication resellers",
    },
    {
      NAICS22: "517121",
      "INDEX ITEM DESCRIPTION":
        "Mobile virtual network operators (MVNOs) (except agents)",
    },
    {
      NAICS22: "517121",
      "INDEX ITEM DESCRIPTION":
        "Pre-paid calling cards, telecommunications resellers",
    },
    {
      NAICS22: "517121",
      "INDEX ITEM DESCRIPTION":
        "Resellers, telecommunication (except satellite telecommunications and agents for wireless telecommunications services)",
    },
    {
      NAICS22: "517121",
      "INDEX ITEM DESCRIPTION":
        "Telecommunications resellers (except satellite telecommunications and agents for wireless telecommunications services)",
    },
    {
      NAICS22: "517121",
      "INDEX ITEM DESCRIPTION":
        "Telephone communications resellers (except satellite telecommunications and agents for wireless telecommunications services)",
    },
    {
      NAICS22: "517121",
      "INDEX ITEM DESCRIPTION": "Wired telecommunication resellers",
    },
    {
      NAICS22: "517121",
      "INDEX ITEM DESCRIPTION":
        "Wireless telecommunications resellers (except satellite telecommunications and agents)",
    },
    {
      NAICS22: "517122",
      "INDEX ITEM DESCRIPTION":
        "Agents for mobile virtual network operators (MVNOs)",
    },
    {
      NAICS22: "517122",
      "INDEX ITEM DESCRIPTION": "Agents for wireless telecommunications carriers",
    },
    {
      NAICS22: "517122",
      "INDEX ITEM DESCRIPTION":
        "Cellular telephone stores, selling cellular phone service plans on an agent basis",
    },
    {
      NAICS22: "517122",
      "INDEX ITEM DESCRIPTION":
        "Mobile phone stores, selling mobile phone service plans on an agent basis",
    },
    {
      NAICS22: "517122",
      "INDEX ITEM DESCRIPTION":
        "Wireless phone service plan sales agents, selling on behalf of wireless telecommunications carriers",
    },
    {
      NAICS22: "517122",
      "INDEX ITEM DESCRIPTION":
        "Wireless phone stores, selling wireless phone service plans on an agent basis",
    },
    {
      NAICS22: "517410",
      "INDEX ITEM DESCRIPTION":
        "Earth stations for satellite communication carriers",
    },
    {
      NAICS22: "517410",
      "INDEX ITEM DESCRIPTION":
        "Long-distance telephone satellite communication carriers",
    },
    {
      NAICS22: "517410",
      "INDEX ITEM DESCRIPTION": "Resellers, satellite telecommunication",
    },
    {
      NAICS22: "517410",
      "INDEX ITEM DESCRIPTION": "Satellite telecommunication carriers",
    },
    {
      NAICS22: "517410",
      "INDEX ITEM DESCRIPTION": "Satellite telecommunication resellers",
    },
    {
      NAICS22: "517410",
      "INDEX ITEM DESCRIPTION": "Telephone communications carriers, satellite",
    },
    {
      NAICS22: "517810",
      "INDEX ITEM DESCRIPTION":
        "Dial-up Internet service providers, using client-supplied telecommunications connections",
    },
    {
      NAICS22: "517810",
      "INDEX ITEM DESCRIPTION":
        "Earth stations (except satellite telecommunication carriers)",
    },
    {
      NAICS22: "517810",
      "INDEX ITEM DESCRIPTION":
        "Internet service providers, using client-supplied telecommunications (e.g., dial-up ISPs)",
    },
    {
      NAICS22: "517810",
      "INDEX ITEM DESCRIPTION":
        "Online access service providers, using client-supplied telecommunications (e.g., dial-up ISPs)",
    },
    {
      NAICS22: "517810",
      "INDEX ITEM DESCRIPTION": "Radar station operations",
    },
    {
      NAICS22: "517810",
      "INDEX ITEM DESCRIPTION":
        "Satellite telemetry operations on a contract or fee basis",
    },
    {
      NAICS22: "517810",
      "INDEX ITEM DESCRIPTION": "Satellite tracking stations",
    },
    {
      NAICS22: "517810",
      "INDEX ITEM DESCRIPTION":
        "Telemetry and tracking system operations on a contract or fee basis",
    },
    {
      NAICS22: "517810",
      "INDEX ITEM DESCRIPTION":
        "VoIP service providers, using client-supplied telecommunications connections",
    },
    {
      NAICS22: "518210",
      "INDEX ITEM DESCRIPTION":
        "Application hosting (excluding software publishing)",
    },
    {
      NAICS22: "518210",
      "INDEX ITEM DESCRIPTION": "Automated data processing services",
    },
    {
      NAICS22: "518210",
      "INDEX ITEM DESCRIPTION":
        "Cloud computing services (except software publishing and computer systems design)",
    },
    {
      NAICS22: "518210",
      "INDEX ITEM DESCRIPTION": "Cloud storage services",
    },
    {
      NAICS22: "518210",
      "INDEX ITEM DESCRIPTION":
        "Colocation services (i.e., rental of server and networking space in data centers)",
    },
    {
      NAICS22: "518210",
      "INDEX ITEM DESCRIPTION": "Computer data storage services",
    },
    {
      NAICS22: "518210",
      "INDEX ITEM DESCRIPTION": "Computer input preparation services",
    },
    {
      NAICS22: "518210",
      "INDEX ITEM DESCRIPTION": "Computer time leasing",
    },
    {
      NAICS22: "518210",
      "INDEX ITEM DESCRIPTION": "Computer time rental",
    },
    {
      NAICS22: "518210",
      "INDEX ITEM DESCRIPTION": "Computer time sharing services",
    },
    {
      NAICS22: "518210",
      "INDEX ITEM DESCRIPTION": "Computing infrastructure provision",
    },
    {
      NAICS22: "518210",
      "INDEX ITEM DESCRIPTION": "Computing platform infrastructure provision",
    },
    {
      NAICS22: "518210",
      "INDEX ITEM DESCRIPTION": "Data capture imaging services",
    },
    {
      NAICS22: "518210",
      "INDEX ITEM DESCRIPTION": "Data entry services",
    },
    {
      NAICS22: "518210",
      "INDEX ITEM DESCRIPTION": "Data processing computer services",
    },
    {
      NAICS22: "518210",
      "INDEX ITEM DESCRIPTION":
        "Data processing services (except payroll services, financial transaction processing services)",
    },
    {
      NAICS22: "518210",
      "INDEX ITEM DESCRIPTION": "Disk and diskette conversion services",
    },
    {
      NAICS22: "518210",
      "INDEX ITEM DESCRIPTION": "Disk and diskette recertification services",
    },
    {
      NAICS22: "518210",
      "INDEX ITEM DESCRIPTION": "Electronic data processing services",
    },
    {
      NAICS22: "518210",
      "INDEX ITEM DESCRIPTION": "Game server hosting providers",
    },
    {
      NAICS22: "518210",
      "INDEX ITEM DESCRIPTION": "Infrastructure as a service (IaaS)",
    },
    {
      NAICS22: "518210",
      "INDEX ITEM DESCRIPTION": "Media streaming data storage services",
    },
    {
      NAICS22: "518210",
      "INDEX ITEM DESCRIPTION": "Media streaming technical support services",
    },
    {
      NAICS22: "518210",
      "INDEX ITEM DESCRIPTION": "Microfiche recording and imaging services",
    },
    {
      NAICS22: "518210",
      "INDEX ITEM DESCRIPTION": "Microfilm recording and imaging services",
    },
    {
      NAICS22: "518210",
      "INDEX ITEM DESCRIPTION": "Optical scanning services",
    },
    {
      NAICS22: "518210",
      "INDEX ITEM DESCRIPTION": "Platform as a service (PaaS)",
    },
    {
      NAICS22: "518210",
      "INDEX ITEM DESCRIPTION": "Scanning services, optical",
    },
    {
      NAICS22: "518210",
      "INDEX ITEM DESCRIPTION":
        "Video and audio technical streaming support services",
    },
    {
      NAICS22: "518210",
      "INDEX ITEM DESCRIPTION":
        "Video tape and film stock technical streaming support services",
    },
    {
      NAICS22: "518210",
      "INDEX ITEM DESCRIPTION": "Virtual currency (cryptocurrency) mining",
    },
    {
      NAICS22: "518210",
      "INDEX ITEM DESCRIPTION": "Web hosting (excluding software publishing)",
    },
    {
      NAICS22: "519210",
      "INDEX ITEM DESCRIPTION": "Archives",
    },
    {
      NAICS22: "519210",
      "INDEX ITEM DESCRIPTION": "Bookmobiles",
    },
    {
      NAICS22: "519210",
      "INDEX ITEM DESCRIPTION": "Centers for documentation (i.e., archives)",
    },
    {
      NAICS22: "519210",
      "INDEX ITEM DESCRIPTION": "Circulating libraries",
    },
    {
      NAICS22: "519210",
      "INDEX ITEM DESCRIPTION": "Film archives",
    },
    {
      NAICS22: "519210",
      "INDEX ITEM DESCRIPTION": "Lending libraries",
    },
    {
      NAICS22: "519210",
      "INDEX ITEM DESCRIPTION":
        "Libraries (except motion picture stock footage, motion picture commercial distribution)",
    },
    {
      NAICS22: "519210",
      "INDEX ITEM DESCRIPTION": "Motion picture film libraries, archives",
    },
    {
      NAICS22: "519210",
      "INDEX ITEM DESCRIPTION": "Music archives",
    },
    {
      NAICS22: "519210",
      "INDEX ITEM DESCRIPTION": "Reference libraries",
    },
    {
      NAICS22: "519290",
      "INDEX ITEM DESCRIPTION": "Clipping services, news",
    },
    {
      NAICS22: "519290",
      "INDEX ITEM DESCRIPTION": "Internet search portals",
    },
    {
      NAICS22: "519290",
      "INDEX ITEM DESCRIPTION": "Internet search Web sites",
    },
    {
      NAICS22: "519290",
      "INDEX ITEM DESCRIPTION": "News clipping services",
    },
    {
      NAICS22: "519290",
      "INDEX ITEM DESCRIPTION": "Portals, web search",
    },
    {
      NAICS22: "519290",
      "INDEX ITEM DESCRIPTION": "Press clipping services",
    },
    {
      NAICS22: "519290",
      "INDEX ITEM DESCRIPTION": "Search portals, Internet",
    },
    {
      NAICS22: "519290",
      "INDEX ITEM DESCRIPTION": "Stock photo agencies",
    },
    {
      NAICS22: "519290",
      "INDEX ITEM DESCRIPTION": "Telephone-based recorded information services",
    },
    {
      NAICS22: "519290",
      "INDEX ITEM DESCRIPTION": "Title search services (except real estate)",
    },
    {
      NAICS22: "519290",
      "INDEX ITEM DESCRIPTION": "Web search portals",
    },
    {
      NAICS22: "521110",
      "INDEX ITEM DESCRIPTION": "Banking, central",
    },
    {
      NAICS22: "521110",
      "INDEX ITEM DESCRIPTION": "Banks, Federal Reserve",
    },
    {
      NAICS22: "521110",
      "INDEX ITEM DESCRIPTION": "Branches, Federal Reserve Bank",
    },
    {
      NAICS22: "521110",
      "INDEX ITEM DESCRIPTION": "Central bank, monetary authorities",
    },
    {
      NAICS22: "521110",
      "INDEX ITEM DESCRIPTION": "Check clearing activities of the central bank",
    },
    {
      NAICS22: "521110",
      "INDEX ITEM DESCRIPTION": "Federal Reserve Banks or Branches",
    },
    {
      NAICS22: "521110",
      "INDEX ITEM DESCRIPTION":
        "Financial transactions processing of the central bank",
    },
    {
      NAICS22: "521110",
      "INDEX ITEM DESCRIPTION": "Monetary authorities, central bank",
    },
    {
      NAICS22: "522110",
      "INDEX ITEM DESCRIPTION": "Banks, commercial",
    },
    {
      NAICS22: "522110",
      "INDEX ITEM DESCRIPTION": "Branches of foreign banks",
    },
    {
      NAICS22: "522110",
      "INDEX ITEM DESCRIPTION": "Commercial banking",
    },
    {
      NAICS22: "522110",
      "INDEX ITEM DESCRIPTION": "Commercial banks",
    },
    {
      NAICS22: "522110",
      "INDEX ITEM DESCRIPTION": "Depository trust companies",
    },
    {
      NAICS22: "522110",
      "INDEX ITEM DESCRIPTION": "National commercial banks",
    },
    {
      NAICS22: "522110",
      "INDEX ITEM DESCRIPTION": "State commercial banks",
    },
    {
      NAICS22: "522130",
      "INDEX ITEM DESCRIPTION": "Corporate credit unions",
    },
    {
      NAICS22: "522130",
      "INDEX ITEM DESCRIPTION": "Credit unions",
    },
    {
      NAICS22: "522130",
      "INDEX ITEM DESCRIPTION": "Federal credit unions",
    },
    {
      NAICS22: "522130",
      "INDEX ITEM DESCRIPTION": "State credit unions",
    },
    {
      NAICS22: "522130",
      "INDEX ITEM DESCRIPTION": "Unions, credit",
    },
    {
      NAICS22: "522180",
      "INDEX ITEM DESCRIPTION": "Associations, savings and loan",
    },
    {
      NAICS22: "522180",
      "INDEX ITEM DESCRIPTION": "Banks, industrial (i.e., known as), depository",
    },
    {
      NAICS22: "522180",
      "INDEX ITEM DESCRIPTION": "Banks, private (i.e., unincorporated)",
    },
    {
      NAICS22: "522180",
      "INDEX ITEM DESCRIPTION": "Banks, savings",
    },
    {
      NAICS22: "522180",
      "INDEX ITEM DESCRIPTION": "Federal savings and loan associations (S&L)",
    },
    {
      NAICS22: "522180",
      "INDEX ITEM DESCRIPTION": "Federal savings banks",
    },
    {
      NAICS22: "522180",
      "INDEX ITEM DESCRIPTION": "Industrial banks (i.e., known as), depository",
    },
    {
      NAICS22: "522180",
      "INDEX ITEM DESCRIPTION": "Institutions, savings",
    },
    {
      NAICS22: "522180",
      "INDEX ITEM DESCRIPTION": "Morris Plans (i.e., known as), depository",
    },
    {
      NAICS22: "522180",
      "INDEX ITEM DESCRIPTION": "Mutual savings banks",
    },
    {
      NAICS22: "522180",
      "INDEX ITEM DESCRIPTION": "Plans, Morris (i.e., known as), depository",
    },
    {
      NAICS22: "522180",
      "INDEX ITEM DESCRIPTION": "Private banks (i.e., unincorporated)",
    },
    {
      NAICS22: "522180",
      "INDEX ITEM DESCRIPTION": "Savings and loan associations (S&L)",
    },
    {
      NAICS22: "522180",
      "INDEX ITEM DESCRIPTION": "Savings banks",
    },
    {
      NAICS22: "522180",
      "INDEX ITEM DESCRIPTION": "Savings institutions",
    },
    {
      NAICS22: "522180",
      "INDEX ITEM DESCRIPTION": "State savings and loan associations",
    },
    {
      NAICS22: "522180",
      "INDEX ITEM DESCRIPTION": "State savings banks",
    },
    {
      NAICS22: "522210",
      "INDEX ITEM DESCRIPTION": "Banks, credit card",
    },
    {
      NAICS22: "522210",
      "INDEX ITEM DESCRIPTION": "Charge card issuing",
    },
    {
      NAICS22: "522210",
      "INDEX ITEM DESCRIPTION": "Credit card banks",
    },
    {
      NAICS22: "522210",
      "INDEX ITEM DESCRIPTION": "Credit card issuing",
    },
    {
      NAICS22: "522210",
      "INDEX ITEM DESCRIPTION": "Issuing, credit card",
    },
    {
      NAICS22: "522220",
      "INDEX ITEM DESCRIPTION": "Automobile finance leasing companies",
    },
    {
      NAICS22: "522220",
      "INDEX ITEM DESCRIPTION": "Automobile financing",
    },
    {
      NAICS22: "522220",
      "INDEX ITEM DESCRIPTION":
        "Commercial and inventory financing (except international trade financing)",
    },
    {
      NAICS22: "522220",
      "INDEX ITEM DESCRIPTION": "Equipment finance leasing",
    },
    {
      NAICS22: "522220",
      "INDEX ITEM DESCRIPTION": "Financing, sales",
    },
    {
      NAICS22: "522220",
      "INDEX ITEM DESCRIPTION": "Installment sales financing",
    },
    {
      NAICS22: "522220",
      "INDEX ITEM DESCRIPTION": "Insurance premium financing",
    },
    {
      NAICS22: "522220",
      "INDEX ITEM DESCRIPTION": "Leasing in combination with sales financing",
    },
    {
      NAICS22: "522220",
      "INDEX ITEM DESCRIPTION": "Machinery finance leasing",
    },
    {
      NAICS22: "522220",
      "INDEX ITEM DESCRIPTION": "Sales financing",
    },
    {
      NAICS22: "522220",
      "INDEX ITEM DESCRIPTION": "Truck finance leasing",
    },
    {
      NAICS22: "522291",
      "INDEX ITEM DESCRIPTION":
        "Consumer finance companies (i.e., unsecured cash loans)",
    },
    {
      NAICS22: "522291",
      "INDEX ITEM DESCRIPTION": "Consumer lending",
    },
    {
      NAICS22: "522291",
      "INDEX ITEM DESCRIPTION": "Finance companies (i.e., unsecured cash loans)",
    },
    {
      NAICS22: "522291",
      "INDEX ITEM DESCRIPTION":
        "Loan companies (i.e., consumer, personal, small, student)",
    },
    {
      NAICS22: "522291",
      "INDEX ITEM DESCRIPTION":
        "Personal credit institutions (i.e., unsecured cash loans)",
    },
    {
      NAICS22: "522291",
      "INDEX ITEM DESCRIPTION":
        "Personal finance companies (i.e., unsecured cash loans)",
    },
    {
      NAICS22: "522291",
      "INDEX ITEM DESCRIPTION":
        "Small loan companies (i.e., unsecured cash loans)",
    },
    {
      NAICS22: "522291",
      "INDEX ITEM DESCRIPTION": "Student loan companies",
    },
    {
      NAICS22: "522292",
      "INDEX ITEM DESCRIPTION": "Construction lending",
    },
    {
      NAICS22: "522292",
      "INDEX ITEM DESCRIPTION": "Farm mortgage lending",
    },
    {
      NAICS22: "522292",
      "INDEX ITEM DESCRIPTION": "Federal Land Banks",
    },
    {
      NAICS22: "522292",
      "INDEX ITEM DESCRIPTION": "Home equity credit lending",
    },
    {
      NAICS22: "522292",
      "INDEX ITEM DESCRIPTION":
        "Loan correspondents (i.e., lending funds with real estate as collateral)",
    },
    {
      NAICS22: "522292",
      "INDEX ITEM DESCRIPTION":
        "Mortgage banking (i.e., nondepository mortgage lending)",
    },
    {
      NAICS22: "522292",
      "INDEX ITEM DESCRIPTION": "Mortgage companies",
    },
    {
      NAICS22: "522292",
      "INDEX ITEM DESCRIPTION": "Real estate credit lending",
    },
    {
      NAICS22: "522292",
      "INDEX ITEM DESCRIPTION": "Reverse mortgage lending",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION":
        "Agencies of foreign banks (i.e., trade financing)",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION":
        "Agreement corporations (i.e., international trade financing)",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION":
        "Agricultural credit institutions, making loans or extending credit (except real estate, sales financing)",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION":
        "Agricultural lending (except real estate, sales financing)",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION":
        "Banks, industrial (i.e., known as), nondepository",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION":
        "Banks, trade (i.e., international trade financing)",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION": "Car title lending",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION":
        "Collateralized mortgage obligation (CMO) issuing, private",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION": "Commodity Credit Corporation",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION": "Edge Act corporations",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION":
        "Export trading companies (i.e., international trade financing)",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION": "Export-Import banks",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION": "Factoring accounts receivable",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION": "Federal Agricultural Mortgage Corporation",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION": "Federal Home Loan Banks (FHLB)",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION": "Federal Home Loan Mortgage Corporation (FHLMC)",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION": "Federal Intermediate Credit Bank",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION": "Federal National Mortgage Association (FNMA)",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION": "FHLMC (Federal Home Loan Mortgage Corporation)",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION": "Financing, secondary market",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION": "FNMA (Federal National Mortgage Association)",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION": "GNMA (Government National Mortgage Association)",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION": "Government National Mortgage Association (GNMA)",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION":
        "Government-sponsored enterprises providing secondary market financing",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION":
        "Industrial banks (i.e., known as), nondepository",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION": "Industrial loan companies, nondepository",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION": "International trade financing",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION": "Morris Plans (i.e., known as), nondepository",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION": "National Credit Union Administration (NCUA)",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION": "Pawnshops",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION": "Plans, Morris (i.e., known as), nondepository",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION": "Purchasing of accounts receivable",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION":
        "Real estate mortgage investment conduits (REMICs) issuing, private",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION":
        "REMICs (real estate mortgage investment conduits) issuing, private",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION":
        "Repackaging loans for sale to others (i.e., private conduits)",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION":
        "Secondary market financing (i.e., buying, pooling, repackaging loans for sale to others)",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION": "Short-term inventory credit lending",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION": "SLMA (Student Loan Marketing Association)",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION": "Student Loan Marketing Association (SLMA)",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION":
        "Trade banks (i.e., international trade financing)",
    },
    {
      NAICS22: "522299",
      "INDEX ITEM DESCRIPTION": "Trade financing, international",
    },
    {
      NAICS22: "522310",
      "INDEX ITEM DESCRIPTION": "Agencies, loan",
    },
    {
      NAICS22: "522310",
      "INDEX ITEM DESCRIPTION": "Brokerages, loan",
    },
    {
      NAICS22: "522310",
      "INDEX ITEM DESCRIPTION": "Brokerages, mortgage",
    },
    {
      NAICS22: "522310",
      "INDEX ITEM DESCRIPTION": "Brokers' offices, loan",
    },
    {
      NAICS22: "522310",
      "INDEX ITEM DESCRIPTION": "Brokers' offices, mortgage",
    },
    {
      NAICS22: "522310",
      "INDEX ITEM DESCRIPTION": "Loan brokerages",
    },
    {
      NAICS22: "522310",
      "INDEX ITEM DESCRIPTION":
        "Loan brokers' or agents' offices (i.e., independent)",
    },
    {
      NAICS22: "522310",
      "INDEX ITEM DESCRIPTION": "Mortgage brokerages",
    },
    {
      NAICS22: "522310",
      "INDEX ITEM DESCRIPTION":
        "Mortgage brokers' or agents' offices (i.e., independent)",
    },
    {
      NAICS22: "522320",
      "INDEX ITEM DESCRIPTION":
        "Automated clearinghouses, bank or check (except central bank)",
    },
    {
      NAICS22: "522320",
      "INDEX ITEM DESCRIPTION":
        "Automated Teller Machine (ATM) or Automated Loan Machine (ALM) network operation",
    },
    {
      NAICS22: "522320",
      "INDEX ITEM DESCRIPTION": "Bank clearinghouse associations",
    },
    {
      NAICS22: "522320",
      "INDEX ITEM DESCRIPTION":
        "Central reserve financial institutions (except central bank)",
    },
    {
      NAICS22: "522320",
      "INDEX ITEM DESCRIPTION": "Check clearing services (except central banks)",
    },
    {
      NAICS22: "522320",
      "INDEX ITEM DESCRIPTION":
        "Check clearinghouse services (except central banks)",
    },
    {
      NAICS22: "522320",
      "INDEX ITEM DESCRIPTION": "Check validation services",
    },
    {
      NAICS22: "522320",
      "INDEX ITEM DESCRIPTION": "Clearinghouses, bank or check",
    },
    {
      NAICS22: "522320",
      "INDEX ITEM DESCRIPTION": "Credit card processing services",
    },
    {
      NAICS22: "522320",
      "INDEX ITEM DESCRIPTION": "Electronic financial payment services",
    },
    {
      NAICS22: "522320",
      "INDEX ITEM DESCRIPTION":
        "Electronic funds transfer services, including peer-to-peer payment services",
    },
    {
      NAICS22: "522320",
      "INDEX ITEM DESCRIPTION":
        "Financial transactions processing (except central bank)",
    },
    {
      NAICS22: "522320",
      "INDEX ITEM DESCRIPTION": "Processing financial transactions",
    },
    {
      NAICS22: "522320",
      "INDEX ITEM DESCRIPTION":
        "Reserve and liquidity services (except central bank)",
    },
    {
      NAICS22: "522390",
      "INDEX ITEM DESCRIPTION": "Check cashing services",
    },
    {
      NAICS22: "522390",
      "INDEX ITEM DESCRIPTION": "Loan servicing",
    },
    {
      NAICS22: "522390",
      "INDEX ITEM DESCRIPTION": "Money order issuance services",
    },
    {
      NAICS22: "522390",
      "INDEX ITEM DESCRIPTION": "Money transmission services",
    },
    {
      NAICS22: "522390",
      "INDEX ITEM DESCRIPTION": "Payday lending services",
    },
    {
      NAICS22: "522390",
      "INDEX ITEM DESCRIPTION": "Travelers' check issuance services",
    },
    {
      NAICS22: "523150",
      "INDEX ITEM DESCRIPTION": "Banking, investment",
    },
    {
      NAICS22: "523150",
      "INDEX ITEM DESCRIPTION": "Bond brokerages",
    },
    {
      NAICS22: "523150",
      "INDEX ITEM DESCRIPTION":
        "Bond dealing (i.e., acting as a principal in dealing securities to investors)",
    },
    {
      NAICS22: "523150",
      "INDEX ITEM DESCRIPTION": "Brokerages, securities",
    },
    {
      NAICS22: "523150",
      "INDEX ITEM DESCRIPTION": "Certificate of deposit (CD) brokers' offices",
    },
    {
      NAICS22: "523150",
      "INDEX ITEM DESCRIPTION": "Commercial note brokers' offices",
    },
    {
      NAICS22: "523150",
      "INDEX ITEM DESCRIPTION":
        "Commercial paper dealing (i.e., acting as a principal in dealing securities to investors)",
    },
    {
      NAICS22: "523150",
      "INDEX ITEM DESCRIPTION": "Discount securities brokerages",
    },
    {
      NAICS22: "523150",
      "INDEX ITEM DESCRIPTION": "Investment banking",
    },
    {
      NAICS22: "523150",
      "INDEX ITEM DESCRIPTION": "Making markets for securities",
    },
    {
      NAICS22: "523150",
      "INDEX ITEM DESCRIPTION": "Market making for securities",
    },
    {
      NAICS22: "523150",
      "INDEX ITEM DESCRIPTION": "Mutual fund agencies (i.e., brokerages)",
    },
    {
      NAICS22: "523150",
      "INDEX ITEM DESCRIPTION": "Mutual fund agents' (i.e., brokers') offices",
    },
    {
      NAICS22: "523150",
      "INDEX ITEM DESCRIPTION": "Online securities brokerages",
    },
    {
      NAICS22: "523150",
      "INDEX ITEM DESCRIPTION":
        "Paper, dealing of commercial (i.e., acting as a principal in dealing securities to investors)",
    },
    {
      NAICS22: "523150",
      "INDEX ITEM DESCRIPTION": "Securities brokerages",
    },
    {
      NAICS22: "523150",
      "INDEX ITEM DESCRIPTION": "Securities brokers' offices",
    },
    {
      NAICS22: "523150",
      "INDEX ITEM DESCRIPTION":
        "Securities dealers (i.e., acting as a principal in dealing securities to investors)",
    },
    {
      NAICS22: "523150",
      "INDEX ITEM DESCRIPTION":
        "Securities dealing (i.e., acting as a principal in dealing securities to investors)",
    },
    {
      NAICS22: "523150",
      "INDEX ITEM DESCRIPTION":
        "Securities distributing (i.e., acting as a principal in dealing securities to investors)",
    },
    {
      NAICS22: "523150",
      "INDEX ITEM DESCRIPTION": "Securities floor brokers",
    },
    {
      NAICS22: "523150",
      "INDEX ITEM DESCRIPTION":
        "Securities floor traders (i.e., acting as a principal in dealing securities to investors)",
    },
    {
      NAICS22: "523150",
      "INDEX ITEM DESCRIPTION": "Securities flotation companies",
    },
    {
      NAICS22: "523150",
      "INDEX ITEM DESCRIPTION":
        "Securities originating (i.e., acting as a principal in dealing securities to investors)",
    },
    {
      NAICS22: "523150",
      "INDEX ITEM DESCRIPTION":
        "Securities trading (i.e., acting as a principal in dealing securities to investors)",
    },
    {
      NAICS22: "523150",
      "INDEX ITEM DESCRIPTION": "Securities underwriting",
    },
    {
      NAICS22: "523150",
      "INDEX ITEM DESCRIPTION": "Stock brokerages",
    },
    {
      NAICS22: "523150",
      "INDEX ITEM DESCRIPTION": "Stock brokers' offices",
    },
    {
      NAICS22: "523150",
      "INDEX ITEM DESCRIPTION": "Stock options brokerages",
    },
    {
      NAICS22: "523150",
      "INDEX ITEM DESCRIPTION":
        "Stock options dealing (i.e., acting as a principal in dealing securities to investors)",
    },
    {
      NAICS22: "523150",
      "INDEX ITEM DESCRIPTION":
        "Trading securities (i.e., acting as a principal in dealing securities to investors)",
    },
    {
      NAICS22: "523150",
      "INDEX ITEM DESCRIPTION": "Underwriting securities",
    },
    {
      NAICS22: "523160",
      "INDEX ITEM DESCRIPTION": "Brokerages, commodity contracts",
    },
    {
      NAICS22: "523160",
      "INDEX ITEM DESCRIPTION": "Commodity contract pool operators",
    },
    {
      NAICS22: "523160",
      "INDEX ITEM DESCRIPTION": "Commodity contract trading companies",
    },
    {
      NAICS22: "523160",
      "INDEX ITEM DESCRIPTION": "Commodity contracts brokerages",
    },
    {
      NAICS22: "523160",
      "INDEX ITEM DESCRIPTION": "Commodity contracts brokers' offices",
    },
    {
      NAICS22: "523160",
      "INDEX ITEM DESCRIPTION":
        "Commodity contracts dealing (i.e., acting as a principal in dealing commodities to investors)",
    },
    {
      NAICS22: "523160",
      "INDEX ITEM DESCRIPTION": "Commodity contracts floor brokers",
    },
    {
      NAICS22: "523160",
      "INDEX ITEM DESCRIPTION":
        "Commodity contracts floor traders (i.e., acting as a principal in dealing commodities to investors)",
    },
    {
      NAICS22: "523160",
      "INDEX ITEM DESCRIPTION":
        "Commodity contracts floor trading (i.e., acting as a principal in dealing commodities to investors)",
    },
    {
      NAICS22: "523160",
      "INDEX ITEM DESCRIPTION": "Commodity contracts options brokerages",
    },
    {
      NAICS22: "523160",
      "INDEX ITEM DESCRIPTION":
        "Commodity contracts options dealing (i.e., acting as a principal in dealing commodities to investors)",
    },
    {
      NAICS22: "523160",
      "INDEX ITEM DESCRIPTION":
        "Commodity contracts traders (i.e., acting as a principal in dealing commodities to investors)",
    },
    {
      NAICS22: "523160",
      "INDEX ITEM DESCRIPTION": "Commodity futures brokerages",
    },
    {
      NAICS22: "523160",
      "INDEX ITEM DESCRIPTION": "Financial futures brokerages",
    },
    {
      NAICS22: "523160",
      "INDEX ITEM DESCRIPTION": "Foreign currency exchange brokering services",
    },
    {
      NAICS22: "523160",
      "INDEX ITEM DESCRIPTION":
        "Foreign currency exchange dealing (i.e., acting as a principal in dealing commodities to investors)",
    },
    {
      NAICS22: "523160",
      "INDEX ITEM DESCRIPTION":
        "Foreign currency exchange services (i.e., selling to the public)",
    },
    {
      NAICS22: "523160",
      "INDEX ITEM DESCRIPTION": "Futures commodity contracts brokerages",
    },
    {
      NAICS22: "523160",
      "INDEX ITEM DESCRIPTION": "Futures commodity contracts brokers' offices",
    },
    {
      NAICS22: "523160",
      "INDEX ITEM DESCRIPTION":
        "Futures commodity contracts dealing (i.e., acting as a principal in dealing commodities to investors)",
    },
    {
      NAICS22: "523160",
      "INDEX ITEM DESCRIPTION": "Trading companies, commodity contracts",
    },
    {
      NAICS22: "523160",
      "INDEX ITEM DESCRIPTION": "Virtual currency (cryptocurrency) brokering",
    },
    {
      NAICS22: "523160",
      "INDEX ITEM DESCRIPTION": "Virtual currency (cryptocurrency) dealing",
    },
    {
      NAICS22: "523160",
      "INDEX ITEM DESCRIPTION":
        "Virtual currency exchange services (i.e., selling to the public)",
    },
    {
      NAICS22: "523210",
      "INDEX ITEM DESCRIPTION": "Commodity contracts exchanges",
    },
    {
      NAICS22: "523210",
      "INDEX ITEM DESCRIPTION": "Exchanges, commodity contracts",
    },
    {
      NAICS22: "523210",
      "INDEX ITEM DESCRIPTION": "Exchanges, securities",
    },
    {
      NAICS22: "523210",
      "INDEX ITEM DESCRIPTION": "Futures commodity contracts exchanges",
    },
    {
      NAICS22: "523210",
      "INDEX ITEM DESCRIPTION": "Securities exchanges",
    },
    {
      NAICS22: "523210",
      "INDEX ITEM DESCRIPTION": "Stock exchanges",
    },
    {
      NAICS22: "523210",
      "INDEX ITEM DESCRIPTION": "Stock or commodity options exchanges",
    },
    {
      NAICS22: "523910",
      "INDEX ITEM DESCRIPTION":
        "Individuals investing in financial contracts on own account",
    },
    {
      NAICS22: "523910",
      "INDEX ITEM DESCRIPTION": "Investment clubs",
    },
    {
      NAICS22: "523910",
      "INDEX ITEM DESCRIPTION":
        "Mineral royalties or leases dealing (i.e., acting as a principal in dealing royalties or leases to investors)",
    },
    {
      NAICS22: "523910",
      "INDEX ITEM DESCRIPTION": "Mortgage dealers, buying and selling",
    },
    {
      NAICS22: "523910",
      "INDEX ITEM DESCRIPTION":
        "Oil royalty dealing (i.e., acting as a principal in dealing royalties to investors)",
    },
    {
      NAICS22: "523910",
      "INDEX ITEM DESCRIPTION": "Securities speculators for own account",
    },
    {
      NAICS22: "523910",
      "INDEX ITEM DESCRIPTION":
        "Tax liens dealing (i.e., acting as a principal in dealing tax liens to investors)",
    },
    {
      NAICS22: "523910",
      "INDEX ITEM DESCRIPTION": "Venture capital companies",
    },
    {
      NAICS22: "523910",
      "INDEX ITEM DESCRIPTION": "Viatical settlement companies",
    },
    {
      NAICS22: "523940",
      "INDEX ITEM DESCRIPTION":
        "Certified financial planners, customized, fees paid by client",
    },
    {
      NAICS22: "523940",
      "INDEX ITEM DESCRIPTION":
        "Financial investment advice services, customized, fees paid by client",
    },
    {
      NAICS22: "523940",
      "INDEX ITEM DESCRIPTION":
        "Financial planning services, customized, fees paid by client",
    },
    {
      NAICS22: "523940",
      "INDEX ITEM DESCRIPTION":
        "Investment advice consulting services, customized, fees paid by client",
    },
    {
      NAICS22: "523940",
      "INDEX ITEM DESCRIPTION":
        "Investment advice counseling services, customized, fees paid by client",
    },
    {
      NAICS22: "523940",
      "INDEX ITEM DESCRIPTION":
        "Investment advisory services, customized, fees paid by client",
    },
    {
      NAICS22: "523940",
      "INDEX ITEM DESCRIPTION": "Investment management",
    },
    {
      NAICS22: "523940",
      "INDEX ITEM DESCRIPTION": "Managing investment funds",
    },
    {
      NAICS22: "523940",
      "INDEX ITEM DESCRIPTION": "Managing mutual funds",
    },
    {
      NAICS22: "523940",
      "INDEX ITEM DESCRIPTION": "Managing personal investment trusts",
    },
    {
      NAICS22: "523940",
      "INDEX ITEM DESCRIPTION": "Managing trusts",
    },
    {
      NAICS22: "523940",
      "INDEX ITEM DESCRIPTION": "Mutual fund managing",
    },
    {
      NAICS22: "523940",
      "INDEX ITEM DESCRIPTION": "Pension fund managing",
    },
    {
      NAICS22: "523940",
      "INDEX ITEM DESCRIPTION": "Personal investments trusts, managing",
    },
    {
      NAICS22: "523940",
      "INDEX ITEM DESCRIPTION": "Portfolio fund managing",
    },
    {
      NAICS22: "523940",
      "INDEX ITEM DESCRIPTION": "Private equity fund managing",
    },
    {
      NAICS22: "523991",
      "INDEX ITEM DESCRIPTION": "Administrators of private estates",
    },
    {
      NAICS22: "523991",
      "INDEX ITEM DESCRIPTION": "Bank trust offices",
    },
    {
      NAICS22: "523991",
      "INDEX ITEM DESCRIPTION": "Escrow agencies (except real estate)",
    },
    {
      NAICS22: "523991",
      "INDEX ITEM DESCRIPTION": "Fiduciary agencies (except real estate)",
    },
    {
      NAICS22: "523991",
      "INDEX ITEM DESCRIPTION": "Personal investments trust administration",
    },
    {
      NAICS22: "523991",
      "INDEX ITEM DESCRIPTION": "Securities custodians",
    },
    {
      NAICS22: "523991",
      "INDEX ITEM DESCRIPTION": "Trust administration, personal investment",
    },
    {
      NAICS22: "523991",
      "INDEX ITEM DESCRIPTION": "Trust companies, nondepository",
    },
    {
      NAICS22: "523999",
      "INDEX ITEM DESCRIPTION":
        "Business start-up fundraising using a crowdfunding platform",
    },
    {
      NAICS22: "523999",
      "INDEX ITEM DESCRIPTION":
        "Clearinghouses, commodity exchange or securities exchange",
    },
    {
      NAICS22: "523999",
      "INDEX ITEM DESCRIPTION": "Deposit brokers",
    },
    {
      NAICS22: "523999",
      "INDEX ITEM DESCRIPTION":
        "Exchange clearinghouses, commodities or securities",
    },
    {
      NAICS22: "523999",
      "INDEX ITEM DESCRIPTION": "Gas lease brokers' offices",
    },
    {
      NAICS22: "523999",
      "INDEX ITEM DESCRIPTION": "Oil lease brokers' offices",
    },
    {
      NAICS22: "523999",
      "INDEX ITEM DESCRIPTION": "Protective committees, security holders",
    },
    {
      NAICS22: "523999",
      "INDEX ITEM DESCRIPTION": "Quotation services, securities",
    },
    {
      NAICS22: "523999",
      "INDEX ITEM DESCRIPTION": "Quotation services, stock",
    },
    {
      NAICS22: "523999",
      "INDEX ITEM DESCRIPTION": "Securities holders' protective services",
    },
    {
      NAICS22: "523999",
      "INDEX ITEM DESCRIPTION": "Securities transfer agencies",
    },
    {
      NAICS22: "523999",
      "INDEX ITEM DESCRIPTION": "Stock quotation services",
    },
    {
      NAICS22: "523999",
      "INDEX ITEM DESCRIPTION": "Stock transfer agencies",
    },
    {
      NAICS22: "523999",
      "INDEX ITEM DESCRIPTION": "Transfer agencies, securities",
    },
    {
      NAICS22: "523999",
      "INDEX ITEM DESCRIPTION":
        "Virtual currency trading exchange clearinghouses",
    },
    {
      NAICS22: "524113",
      "INDEX ITEM DESCRIPTION":
        "Accidental death and dismemberment insurance carriers, direct",
    },
    {
      NAICS22: "524113",
      "INDEX ITEM DESCRIPTION":
        "Accidental death and dismemberment insurance underwriting, direct",
    },
    {
      NAICS22: "524113",
      "INDEX ITEM DESCRIPTION": "Annuities underwriting",
    },
    {
      NAICS22: "524113",
      "INDEX ITEM DESCRIPTION": "Cooperative life insurance organizations",
    },
    {
      NAICS22: "524113",
      "INDEX ITEM DESCRIPTION": "Credit life insurance carriers, direct",
    },
    {
      NAICS22: "524113",
      "INDEX ITEM DESCRIPTION": "Disability insurance carriers, direct",
    },
    {
      NAICS22: "524113",
      "INDEX ITEM DESCRIPTION": "Disability insurance underwriting, direct",
    },
    {
      NAICS22: "524113",
      "INDEX ITEM DESCRIPTION": "Fraternal life insurance organizations",
    },
    {
      NAICS22: "524113",
      "INDEX ITEM DESCRIPTION": "Insurance carriers, disability, direct",
    },
    {
      NAICS22: "524113",
      "INDEX ITEM DESCRIPTION": "Insurance carriers, life, direct",
    },
    {
      NAICS22: "524113",
      "INDEX ITEM DESCRIPTION": "Insurance underwriting, disability, direct",
    },
    {
      NAICS22: "524113",
      "INDEX ITEM DESCRIPTION": "Insurance underwriting, life, direct",
    },
    {
      NAICS22: "524113",
      "INDEX ITEM DESCRIPTION": "Life insurance carriers, direct",
    },
    {
      NAICS22: "524113",
      "INDEX ITEM DESCRIPTION": "Savings bank life insurance carriers, direct",
    },
    {
      NAICS22: "524114",
      "INDEX ITEM DESCRIPTION": "Dental insurance carriers, direct",
    },
    {
      NAICS22: "524114",
      "INDEX ITEM DESCRIPTION":
        "Group hospitalization plans without providing health care services",
    },
    {
      NAICS22: "524114",
      "INDEX ITEM DESCRIPTION": "Health insurance carriers, direct",
    },
    {
      NAICS22: "524114",
      "INDEX ITEM DESCRIPTION":
        "Hospital and medical service plans, direct, without providing health care services",
    },
    {
      NAICS22: "524114",
      "INDEX ITEM DESCRIPTION":
        "Hospitalization insurance carriers, direct, without providing health care services",
    },
    {
      NAICS22: "524114",
      "INDEX ITEM DESCRIPTION": "Insurance carriers, health, direct",
    },
    {
      NAICS22: "524114",
      "INDEX ITEM DESCRIPTION":
        "Insurance underwriting, health and medical, direct",
    },
    {
      NAICS22: "524114",
      "INDEX ITEM DESCRIPTION": "Medical insurance carriers, direct",
    },
    {
      NAICS22: "524114",
      "INDEX ITEM DESCRIPTION":
        "Medical service plans without providing health care services",
    },
    {
      NAICS22: "524126",
      "INDEX ITEM DESCRIPTION":
        "Agricultural (i.e., crop, livestock) insurance carriers, direct",
    },
    {
      NAICS22: "524126",
      "INDEX ITEM DESCRIPTION": "Automobile insurance carriers, direct",
    },
    {
      NAICS22: "524126",
      "INDEX ITEM DESCRIPTION": "Bonding, fidelity or surety insurance, direct",
    },
    {
      NAICS22: "524126",
      "INDEX ITEM DESCRIPTION": "Burglary and theft insurance carriers, direct",
    },
    {
      NAICS22: "524126",
      "INDEX ITEM DESCRIPTION": "Casualty insurance carriers, direct",
    },
    {
      NAICS22: "524126",
      "INDEX ITEM DESCRIPTION":
        "Credit and other financial responsibility insurance carriers, direct",
    },
    {
      NAICS22: "524126",
      "INDEX ITEM DESCRIPTION": "Crop insurance carrier, direct",
    },
    {
      NAICS22: "524126",
      "INDEX ITEM DESCRIPTION": "Fidelity insurance carriers, direct",
    },
    {
      NAICS22: "524126",
      "INDEX ITEM DESCRIPTION": "Fire insurance carriers, direct",
    },
    {
      NAICS22: "524126",
      "INDEX ITEM DESCRIPTION": "Guaranteeing international trade loans",
    },
    {
      NAICS22: "524126",
      "INDEX ITEM DESCRIPTION": "Homeowners' insurance carriers, direct",
    },
    {
      NAICS22: "524126",
      "INDEX ITEM DESCRIPTION": "Insurance carriers, fidelity, direct",
    },
    {
      NAICS22: "524126",
      "INDEX ITEM DESCRIPTION":
        "Insurance carriers, property and casualty, direct",
    },
    {
      NAICS22: "524126",
      "INDEX ITEM DESCRIPTION": "Insurance carriers, surety, direct",
    },
    {
      NAICS22: "524126",
      "INDEX ITEM DESCRIPTION":
        "Insurance underwriting, property and casualty, direct",
    },
    {
      NAICS22: "524126",
      "INDEX ITEM DESCRIPTION": "Liability insurance carriers, direct",
    },
    {
      NAICS22: "524126",
      "INDEX ITEM DESCRIPTION": "Malpractice insurance carriers, direct",
    },
    {
      NAICS22: "524126",
      "INDEX ITEM DESCRIPTION": "Marine insurance carriers, direct",
    },
    {
      NAICS22: "524126",
      "INDEX ITEM DESCRIPTION": "Mortgage guaranty insurance carriers, direct",
    },
    {
      NAICS22: "524126",
      "INDEX ITEM DESCRIPTION": "Plate glass insurance carriers, direct",
    },
    {
      NAICS22: "524126",
      "INDEX ITEM DESCRIPTION":
        "Property and casualty insurance carriers, direct",
    },
    {
      NAICS22: "524126",
      "INDEX ITEM DESCRIPTION": "Property damage insurance carriers, direct",
    },
    {
      NAICS22: "524126",
      "INDEX ITEM DESCRIPTION": "Surety insurance carriers, direct",
    },
    {
      NAICS22: "524126",
      "INDEX ITEM DESCRIPTION": "Workers' compensation insurance underwriting",
    },
    {
      NAICS22: "524127",
      "INDEX ITEM DESCRIPTION": "Guaranteeing titles",
    },
    {
      NAICS22: "524127",
      "INDEX ITEM DESCRIPTION": "Insurance carriers, title, direct",
    },
    {
      NAICS22: "524127",
      "INDEX ITEM DESCRIPTION": "Insurance underwriting, title, direct",
    },
    {
      NAICS22: "524127",
      "INDEX ITEM DESCRIPTION": "Real estate title insurance carriers, direct",
    },
    {
      NAICS22: "524127",
      "INDEX ITEM DESCRIPTION": "Title insurance carriers, real estate, direct",
    },
    {
      NAICS22: "524128",
      "INDEX ITEM DESCRIPTION": "Bank deposit insurance carriers, direct",
    },
    {
      NAICS22: "524128",
      "INDEX ITEM DESCRIPTION": "Burial insurance carriers, direct",
    },
    {
      NAICS22: "524128",
      "INDEX ITEM DESCRIPTION": "Contact lens insurance, direct",
    },
    {
      NAICS22: "524128",
      "INDEX ITEM DESCRIPTION": "Deposit or share insurance carriers, direct",
    },
    {
      NAICS22: "524128",
      "INDEX ITEM DESCRIPTION": "Funeral insurance carriers, direct",
    },
    {
      NAICS22: "524128",
      "INDEX ITEM DESCRIPTION": "Homeowners' warranty insurance carriers, direct",
    },
    {
      NAICS22: "524128",
      "INDEX ITEM DESCRIPTION": "Pet health insurance carriers, direct",
    },
    {
      NAICS22: "524128",
      "INDEX ITEM DESCRIPTION": "Product warranty insurance carriers, direct",
    },
    {
      NAICS22: "524128",
      "INDEX ITEM DESCRIPTION":
        "Warranty insurance carriers (e.g., appliance, automobile, homeowners', product), direct",
    },
    {
      NAICS22: "524130",
      "INDEX ITEM DESCRIPTION": "Accidental and health reinsurance carriers",
    },
    {
      NAICS22: "524130",
      "INDEX ITEM DESCRIPTION": "Life reinsurance carriers",
    },
    {
      NAICS22: "524130",
      "INDEX ITEM DESCRIPTION": "Marine reinsurance carriers",
    },
    {
      NAICS22: "524130",
      "INDEX ITEM DESCRIPTION": "Medical reinsurance carriers",
    },
    {
      NAICS22: "524130",
      "INDEX ITEM DESCRIPTION": "Property and casualty reinsurance carriers",
    },
    {
      NAICS22: "524130",
      "INDEX ITEM DESCRIPTION": "Reinsurance carriers",
    },
    {
      NAICS22: "524210",
      "INDEX ITEM DESCRIPTION": "Agencies, insurance",
    },
    {
      NAICS22: "524210",
      "INDEX ITEM DESCRIPTION": "Brokerages, insurance",
    },
    {
      NAICS22: "524210",
      "INDEX ITEM DESCRIPTION": "Brokers' offices, insurance",
    },
    {
      NAICS22: "524210",
      "INDEX ITEM DESCRIPTION": "Insurance agencies",
    },
    {
      NAICS22: "524210",
      "INDEX ITEM DESCRIPTION": "Insurance brokerages",
    },
    {
      NAICS22: "524210",
      "INDEX ITEM DESCRIPTION": "Life insurance agencies",
    },
    {
      NAICS22: "524291",
      "INDEX ITEM DESCRIPTION": "Cause-of-loss investigators, insurance",
    },
    {
      NAICS22: "524291",
      "INDEX ITEM DESCRIPTION": "Claims adjusting, insurance",
    },
    {
      NAICS22: "524291",
      "INDEX ITEM DESCRIPTION": "Fire investigators",
    },
    {
      NAICS22: "524291",
      "INDEX ITEM DESCRIPTION": "Insurance claims adjusting",
    },
    {
      NAICS22: "524291",
      "INDEX ITEM DESCRIPTION": "Insurance claims investigation services",
    },
    {
      NAICS22: "524291",
      "INDEX ITEM DESCRIPTION": "Insurance settlement offices",
    },
    {
      NAICS22: "524291",
      "INDEX ITEM DESCRIPTION": "Loss control consultants",
    },
    {
      NAICS22: "524292",
      "INDEX ITEM DESCRIPTION":
        "Claims processing services, insurance, third party",
    },
    {
      NAICS22: "524292",
      "INDEX ITEM DESCRIPTION":
        "Employee benefit plans, third party administrative processing services",
    },
    {
      NAICS22: "524292",
      "INDEX ITEM DESCRIPTION":
        "Insurance claims processing services, third party",
    },
    {
      NAICS22: "524292",
      "INDEX ITEM DESCRIPTION":
        "Insurance fund, third party administrative services (except claims adjusting only)",
    },
    {
      NAICS22: "524292",
      "INDEX ITEM DESCRIPTION":
        "Insurance plan administrative services (except claims adjusting only), third party",
    },
    {
      NAICS22: "524292",
      "INDEX ITEM DESCRIPTION":
        "Pension fund, third party administrative services",
    },
    {
      NAICS22: "524292",
      "INDEX ITEM DESCRIPTION": "Pharmacy Benefit Management (PBM) services",
    },
    {
      NAICS22: "524298",
      "INDEX ITEM DESCRIPTION": "Actuarial services, insurance",
    },
    {
      NAICS22: "524298",
      "INDEX ITEM DESCRIPTION": "Insurance actuarial services",
    },
    {
      NAICS22: "524298",
      "INDEX ITEM DESCRIPTION": "Insurance advisory services",
    },
    {
      NAICS22: "524298",
      "INDEX ITEM DESCRIPTION": "Insurance coverage consulting services",
    },
    {
      NAICS22: "524298",
      "INDEX ITEM DESCRIPTION": "Insurance exchanges",
    },
    {
      NAICS22: "524298",
      "INDEX ITEM DESCRIPTION":
        "Insurance investigation services (except claims investigation)",
    },
    {
      NAICS22: "524298",
      "INDEX ITEM DESCRIPTION": "Insurance loss prevention services",
    },
    {
      NAICS22: "524298",
      "INDEX ITEM DESCRIPTION": "Insurance ratemaking services",
    },
    {
      NAICS22: "524298",
      "INDEX ITEM DESCRIPTION": "Insurance reporting services",
    },
    {
      NAICS22: "524298",
      "INDEX ITEM DESCRIPTION":
        "Insurance underwriters laboratories and standards services",
    },
    {
      NAICS22: "524298",
      "INDEX ITEM DESCRIPTION": "Medical cost evaluation services",
    },
    {
      NAICS22: "524298",
      "INDEX ITEM DESCRIPTION": "Ratemaking services, insurance",
    },
    {
      NAICS22: "525110",
      "INDEX ITEM DESCRIPTION": "Employee benefit pension plans",
    },
    {
      NAICS22: "525110",
      "INDEX ITEM DESCRIPTION": "Funds, employee benefit pension",
    },
    {
      NAICS22: "525110",
      "INDEX ITEM DESCRIPTION": "Funds, pension",
    },
    {
      NAICS22: "525110",
      "INDEX ITEM DESCRIPTION": "Pension funds",
    },
    {
      NAICS22: "525110",
      "INDEX ITEM DESCRIPTION":
        "Pension plans (e.g., employee benefit, retirement)",
    },
    {
      NAICS22: "525110",
      "INDEX ITEM DESCRIPTION": "Plans, pension",
    },
    {
      NAICS22: "525110",
      "INDEX ITEM DESCRIPTION": "Retirement pension plans",
    },
    {
      NAICS22: "525110",
      "INDEX ITEM DESCRIPTION": "Union pension funds",
    },
    {
      NAICS22: "525120",
      "INDEX ITEM DESCRIPTION": "Employee benefit plans (except pension)",
    },
    {
      NAICS22: "525120",
      "INDEX ITEM DESCRIPTION": "Funds, health and welfare",
    },
    {
      NAICS22: "525120",
      "INDEX ITEM DESCRIPTION": "Health and welfare funds",
    },
    {
      NAICS22: "525120",
      "INDEX ITEM DESCRIPTION":
        "Plans, health- and welfare-related employee benefit",
    },
    {
      NAICS22: "525120",
      "INDEX ITEM DESCRIPTION": "Union health and welfare funds",
    },
    {
      NAICS22: "525190",
      "INDEX ITEM DESCRIPTION": "Compensation, workers, insurance funds",
    },
    {
      NAICS22: "525190",
      "INDEX ITEM DESCRIPTION":
        "Funds, self-insurance (except employee benefit funds)",
    },
    {
      NAICS22: "525190",
      "INDEX ITEM DESCRIPTION":
        "Self-insurance funds (except employee benefit funds)",
    },
    {
      NAICS22: "525190",
      "INDEX ITEM DESCRIPTION": "Workers' compensation insurance funds",
    },
    {
      NAICS22: "525910",
      "INDEX ITEM DESCRIPTION": "Funds, mutual, open-ended",
    },
    {
      NAICS22: "525910",
      "INDEX ITEM DESCRIPTION": "Investment funds, open-ended",
    },
    {
      NAICS22: "525910",
      "INDEX ITEM DESCRIPTION": "Management investment offices, open-ended",
    },
    {
      NAICS22: "525910",
      "INDEX ITEM DESCRIPTION": "Money market mutual funds, open-ended",
    },
    {
      NAICS22: "525910",
      "INDEX ITEM DESCRIPTION": "Mutual funds, open-ended",
    },
    {
      NAICS22: "525920",
      "INDEX ITEM DESCRIPTION": "Bankruptcy estates",
    },
    {
      NAICS22: "525920",
      "INDEX ITEM DESCRIPTION": "Personal estates (i.e., managing assets)",
    },
    {
      NAICS22: "525920",
      "INDEX ITEM DESCRIPTION": "Personal investment trusts",
    },
    {
      NAICS22: "525920",
      "INDEX ITEM DESCRIPTION": "Personal trusts",
    },
    {
      NAICS22: "525920",
      "INDEX ITEM DESCRIPTION":
        "Private estates (i.e., administering on behalf of beneficiaries)",
    },
    {
      NAICS22: "525920",
      "INDEX ITEM DESCRIPTION": "Settlement trust funds",
    },
    {
      NAICS22: "525920",
      "INDEX ITEM DESCRIPTION": "Testamentary trusts",
    },
    {
      NAICS22: "525920",
      "INDEX ITEM DESCRIPTION": "Trusts, estates, and agency accounts",
    },
    {
      NAICS22: "525990",
      "INDEX ITEM DESCRIPTION": "Closed-end investment funds",
    },
    {
      NAICS22: "525990",
      "INDEX ITEM DESCRIPTION": "CMOs (collateralized mortgage obligations)",
    },
    {
      NAICS22: "525990",
      "INDEX ITEM DESCRIPTION": "Collateralized mortgage obligations (CMOs)",
    },
    {
      NAICS22: "525990",
      "INDEX ITEM DESCRIPTION": "Face-amount certificate funds",
    },
    {
      NAICS22: "525990",
      "INDEX ITEM DESCRIPTION": "Funds, mutual, closed-end",
    },
    {
      NAICS22: "525990",
      "INDEX ITEM DESCRIPTION": "Investment funds, closed-end",
    },
    {
      NAICS22: "525990",
      "INDEX ITEM DESCRIPTION": "Money market mutual funds, closed-end",
    },
    {
      NAICS22: "525990",
      "INDEX ITEM DESCRIPTION": "Mortgage real estate investment trusts (REITs)",
    },
    {
      NAICS22: "525990",
      "INDEX ITEM DESCRIPTION": "Mortgage-backed securities",
    },
    {
      NAICS22: "525990",
      "INDEX ITEM DESCRIPTION": "Mutual funds, closed-end",
    },
    {
      NAICS22: "525990",
      "INDEX ITEM DESCRIPTION":
        "Pooled investment vehicle (PIV) funds, closed-end",
    },
    {
      NAICS22: "525990",
      "INDEX ITEM DESCRIPTION": "Profit-sharing funds",
    },
    {
      NAICS22: "525990",
      "INDEX ITEM DESCRIPTION":
        "Real estate mortgage investment conduits (REMICs)",
    },
    {
      NAICS22: "525990",
      "INDEX ITEM DESCRIPTION":
        "REMICs (real estate mortgage investment conduits)",
    },
    {
      NAICS22: "525990",
      "INDEX ITEM DESCRIPTION": "Special purpose financial vehicles",
    },
    {
      NAICS22: "525990",
      "INDEX ITEM DESCRIPTION": "Unit investment trust funds",
    },
    {
      NAICS22: "531110",
      "INDEX ITEM DESCRIPTION": "Apartment building rental or leasing",
    },
    {
      NAICS22: "531110",
      "INDEX ITEM DESCRIPTION": "Apartment hotel rental or leasing",
    },
    {
      NAICS22: "531110",
      "INDEX ITEM DESCRIPTION": "Apartment rental or leasing",
    },
    {
      NAICS22: "531110",
      "INDEX ITEM DESCRIPTION": "Building, apartment, rental or leasing",
    },
    {
      NAICS22: "531110",
      "INDEX ITEM DESCRIPTION": "Building, residential, rental or leasing",
    },
    {
      NAICS22: "531110",
      "INDEX ITEM DESCRIPTION": "Cottage rental or leasing",
    },
    {
      NAICS22: "531110",
      "INDEX ITEM DESCRIPTION":
        "Duplex houses (i.e., single-family) rental or leasing",
    },
    {
      NAICS22: "531110",
      "INDEX ITEM DESCRIPTION": "Dwelling rental or leasing",
    },
    {
      NAICS22: "531110",
      "INDEX ITEM DESCRIPTION":
        "Equity real estate investment trusts (REITs), primarily leasing residential buildings and dwellings",
    },
    {
      NAICS22: "531110",
      "INDEX ITEM DESCRIPTION": "Houses rental or leasing",
    },
    {
      NAICS22: "531110",
      "INDEX ITEM DESCRIPTION":
        "Housing authorities owning and operating residential buildings",
    },
    {
      NAICS22: "531110",
      "INDEX ITEM DESCRIPTION": "Lessors of residential buildings and dwellings",
    },
    {
      NAICS22: "531110",
      "INDEX ITEM DESCRIPTION":
        "Mobile (manufactured) home rental or leasing, on-site",
    },
    {
      NAICS22: "531110",
      "INDEX ITEM DESCRIPTION":
        "Real estate rental or leasing of residential building",
    },
    {
      NAICS22: "531110",
      "INDEX ITEM DESCRIPTION": "Residential building rental or leasing",
    },
    {
      NAICS22: "531110",
      "INDEX ITEM DESCRIPTION": "Residential hotel rental or leasing",
    },
    {
      NAICS22: "531110",
      "INDEX ITEM DESCRIPTION": "Retirement hotel rental or leasing",
    },
    {
      NAICS22: "531110",
      "INDEX ITEM DESCRIPTION": "Single-family house rental or leasing",
    },
    {
      NAICS22: "531110",
      "INDEX ITEM DESCRIPTION": "Town house rental or leasing",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION": "Amusement facility rental or leasing",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION":
        "Arena, no promotion of events, rental or leasing",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION": "Auditorium rental or leasing",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION": "Bank building rental or leasing",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION": "Banquet hall rental or leasing",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION":
        "Building, nonresidential (except miniwarehouse), rental or leasing",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION": "Commercial building rental or leasing",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION":
        "Concert hall, no promotion of events, rental or leasing",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION":
        "Conference center, no promotion of events, rental or leasing",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION":
        "Convention center, no promotion of events, rental or leasing",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION": "Coworking space rental or leasing",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION": "Dance hall rental or leasing",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION": "Dock and associated building rental or leasing",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION":
        "Equity real estate investment trusts (REITs), primarily leasing nonresidential buildings (except miniwarehouses)",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION":
        "Executive suites (i.e., full service office space provision)",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION":
        "Exhibition hall, no promotion of events, rental or leasing",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION":
        "Flea market space, under roof, rental or leasing",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION": "Full service office space provision",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION":
        "Hall and banquet room, nonresidential, rental or leasing",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION": "Hall, nonresidential, rental or leasing",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION":
        "Hotel building rental or leasing, not operating hotel",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION": "Industrial building rental or leasing",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION": "Insurance building rental or leasing",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION":
        "Lessors of nonresidential buildings (except miniwarehouses)",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION":
        "Mall property operation (i.e., not operating contained businesses) rental or leasing",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION": "Manufacturing building rental or leasing",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION": "Medical building rental or leasing",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION": "Meeting hall and room rental or leasing",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION":
        "Mobile office building rental or leasing, on-site",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION":
        "Motel building rental or leasing, not operating motel",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION":
        "Nonresidential building (except miniwarehouse) rental or leasing",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION": "Office building rental or leasing",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION": "Piers and associated building rental or leasing",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION": "Professional office building rental or leasing",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION":
        "Real estate rental or leasing of nonresidential building (except miniwarehouse)",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION": "Reception hall rental or leasing",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION": "Shared workspace provision",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION":
        "Shopping center (i.e., not operating contained businesses) rental or leasing",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION":
        "Stadium rental or leasing without promotion of events",
    },
    {
      NAICS22: "531120",
      "INDEX ITEM DESCRIPTION":
        "Theater property rental or leasing, not operating theater",
    },
    {
      NAICS22: "531130",
      "INDEX ITEM DESCRIPTION":
        "Equity real estate investment trusts (REITs), primarily leasing miniwarehouses and self-storage units",
    },
    {
      NAICS22: "531130",
      "INDEX ITEM DESCRIPTION": "Lessors of miniwarehouses",
    },
    {
      NAICS22: "531130",
      "INDEX ITEM DESCRIPTION": "Lessors of self-storage units",
    },
    {
      NAICS22: "531130",
      "INDEX ITEM DESCRIPTION": "Miniwarehouse rental or leasing",
    },
    {
      NAICS22: "531130",
      "INDEX ITEM DESCRIPTION":
        "Real estate rental or leasing of miniwarehouses and self-storage units",
    },
    {
      NAICS22: "531130",
      "INDEX ITEM DESCRIPTION": "Self-storage unit rental or leasing",
    },
    {
      NAICS22: "531130",
      "INDEX ITEM DESCRIPTION": "Self-storage warehousing",
    },
    {
      NAICS22: "531130",
      "INDEX ITEM DESCRIPTION": "U-lock storage",
    },
    {
      NAICS22: "531130",
      "INDEX ITEM DESCRIPTION": "Warehousing, self-storage",
    },
    {
      NAICS22: "531190",
      "INDEX ITEM DESCRIPTION": "Agricultural property rental or leasing ",
    },
    {
      NAICS22: "531190",
      "INDEX ITEM DESCRIPTION":
        "Airport leasing, not operating airport, rental or leasing",
    },
    {
      NAICS22: "531190",
      "INDEX ITEM DESCRIPTION":
        "Equity real estate investment trusts (REITs), primarily leasing real estate (except residential buildings and dwellings, nonresidential buildings, miniwarehouses, and self-storage units)",
    },
    {
      NAICS22: "531190",
      "INDEX ITEM DESCRIPTION": "Farmland rental or leasing",
    },
    {
      NAICS22: "531190",
      "INDEX ITEM DESCRIPTION":
        "Flea market space (except under roof) rental or leasing",
    },
    {
      NAICS22: "531190",
      "INDEX ITEM DESCRIPTION": "Forest land rental or leasing",
    },
    {
      NAICS22: "531190",
      "INDEX ITEM DESCRIPTION": "Grazing land rental or leasing",
    },
    {
      NAICS22: "531190",
      "INDEX ITEM DESCRIPTION": "Land rental or leasing",
    },
    {
      NAICS22: "531190",
      "INDEX ITEM DESCRIPTION": "Manufactured (mobile) home parks",
    },
    {
      NAICS22: "531190",
      "INDEX ITEM DESCRIPTION":
        "Manufactured (mobile) home sites rental or leasing",
    },
    {
      NAICS22: "531190",
      "INDEX ITEM DESCRIPTION": "Mining property leasing",
    },
    {
      NAICS22: "531190",
      "INDEX ITEM DESCRIPTION": "Mobile (manufactured) home parks",
    },
    {
      NAICS22: "531190",
      "INDEX ITEM DESCRIPTION":
        "Mobile (manufactured) home sites rental or leasing",
    },
    {
      NAICS22: "531190",
      "INDEX ITEM DESCRIPTION": "Railroad right of way leasing",
    },
    {
      NAICS22: "531190",
      "INDEX ITEM DESCRIPTION": "Real estate (except building) rental or leasing",
    },
    {
      NAICS22: "531190",
      "INDEX ITEM DESCRIPTION": "Residential trailer parks",
    },
    {
      NAICS22: "531190",
      "INDEX ITEM DESCRIPTION": "Trailer park or court, residential",
    },
    {
      NAICS22: "531190",
      "INDEX ITEM DESCRIPTION": "Vacant lot rental or leasing",
    },
    {
      NAICS22: "531190",
      "INDEX ITEM DESCRIPTION": "Vacation and recreation land rental or leasing",
    },
    {
      NAICS22: "531210",
      "INDEX ITEM DESCRIPTION": "Agencies, real estate",
    },
    {
      NAICS22: "531210",
      "INDEX ITEM DESCRIPTION": "Agents, real estate",
    },
    {
      NAICS22: "531210",
      "INDEX ITEM DESCRIPTION":
        "Auctioning real estate for others (i.e., agents, brokers)",
    },
    {
      NAICS22: "531210",
      "INDEX ITEM DESCRIPTION": "Brokerages, real estate",
    },
    {
      NAICS22: "531210",
      "INDEX ITEM DESCRIPTION": "Brokers' offices, real estate",
    },
    {
      NAICS22: "531210",
      "INDEX ITEM DESCRIPTION": "Buyers' agents, real estate, offices",
    },
    {
      NAICS22: "531210",
      "INDEX ITEM DESCRIPTION": "Buying agencies, real estate",
    },
    {
      NAICS22: "531210",
      "INDEX ITEM DESCRIPTION":
        "Buying real estate for others (i.e., agents, brokers)",
    },
    {
      NAICS22: "531210",
      "INDEX ITEM DESCRIPTION": "Commercial real estate agencies",
    },
    {
      NAICS22: "531210",
      "INDEX ITEM DESCRIPTION": "Commercial real estate agents' offices",
    },
    {
      NAICS22: "531210",
      "INDEX ITEM DESCRIPTION": "Exclusive buyers' agencies",
    },
    {
      NAICS22: "531210",
      "INDEX ITEM DESCRIPTION": "Exclusive buyers' agents, offices of",
    },
    {
      NAICS22: "531210",
      "INDEX ITEM DESCRIPTION": "Real estate agencies",
    },
    {
      NAICS22: "531210",
      "INDEX ITEM DESCRIPTION": "Real estate agents' offices",
    },
    {
      NAICS22: "531210",
      "INDEX ITEM DESCRIPTION": "Real estate brokerages",
    },
    {
      NAICS22: "531210",
      "INDEX ITEM DESCRIPTION": "Real estate brokers' offices",
    },
    {
      NAICS22: "531210",
      "INDEX ITEM DESCRIPTION":
        "Renting real estate for others (i.e., agents, brokers)",
    },
    {
      NAICS22: "531210",
      "INDEX ITEM DESCRIPTION": "Residential real estate agencies",
    },
    {
      NAICS22: "531210",
      "INDEX ITEM DESCRIPTION": "Residential real estate agents' offices",
    },
    {
      NAICS22: "531210",
      "INDEX ITEM DESCRIPTION": "Residential real estate brokerages",
    },
    {
      NAICS22: "531210",
      "INDEX ITEM DESCRIPTION": "Residential real estate brokers' offices",
    },
    {
      NAICS22: "531210",
      "INDEX ITEM DESCRIPTION":
        "Selling real estate for others (i.e., agents, brokers)",
    },
    {
      NAICS22: "531210",
      "INDEX ITEM DESCRIPTION":
        "Selling time-share condominiums for others (i.e., agents, brokers)",
    },
    {
      NAICS22: "531311",
      "INDEX ITEM DESCRIPTION": "Apartment managers' offices",
    },
    {
      NAICS22: "531311",
      "INDEX ITEM DESCRIPTION": "Condominium managers' offices, residential",
    },
    {
      NAICS22: "531311",
      "INDEX ITEM DESCRIPTION": "Cooperative apartment managers' offices",
    },
    {
      NAICS22: "531311",
      "INDEX ITEM DESCRIPTION": "Managers' offices, residential condominium",
    },
    {
      NAICS22: "531311",
      "INDEX ITEM DESCRIPTION": "Managers' offices, residential real estate",
    },
    {
      NAICS22: "531311",
      "INDEX ITEM DESCRIPTION": "Managing cooperative apartments",
    },
    {
      NAICS22: "531311",
      "INDEX ITEM DESCRIPTION": "Managing residential condominiums",
    },
    {
      NAICS22: "531311",
      "INDEX ITEM DESCRIPTION": "Managing residential real estate",
    },
    {
      NAICS22: "531311",
      "INDEX ITEM DESCRIPTION":
        "Property managers' offices, residential real estate",
    },
    {
      NAICS22: "531311",
      "INDEX ITEM DESCRIPTION": "Property managing, residential real estate",
    },
    {
      NAICS22: "531311",
      "INDEX ITEM DESCRIPTION":
        "Real estate property managers' offices, residential",
    },
    {
      NAICS22: "531311",
      "INDEX ITEM DESCRIPTION": "Residential property managing",
    },
    {
      NAICS22: "531311",
      "INDEX ITEM DESCRIPTION":
        "Residential real estate property managers' offices",
    },
    {
      NAICS22: "531311",
      "INDEX ITEM DESCRIPTION": "Resort or vacation property managers' offices",
    },
    {
      NAICS22: "531312",
      "INDEX ITEM DESCRIPTION": "Commercial property managing",
    },
    {
      NAICS22: "531312",
      "INDEX ITEM DESCRIPTION":
        "Commercial real estate property managers' offices",
    },
    {
      NAICS22: "531312",
      "INDEX ITEM DESCRIPTION": "Condominium managers' offices, commercial",
    },
    {
      NAICS22: "531312",
      "INDEX ITEM DESCRIPTION": "Managers' offices, commercial condominium",
    },
    {
      NAICS22: "531312",
      "INDEX ITEM DESCRIPTION": "Managers' offices, commercial real estate",
    },
    {
      NAICS22: "531312",
      "INDEX ITEM DESCRIPTION": "Managers' offices, nonresidential real estate",
    },
    {
      NAICS22: "531312",
      "INDEX ITEM DESCRIPTION": "Managing commercial condominiums",
    },
    {
      NAICS22: "531312",
      "INDEX ITEM DESCRIPTION": "Managing commercial real estate",
    },
    {
      NAICS22: "531312",
      "INDEX ITEM DESCRIPTION": "Nonresidential property managing",
    },
    {
      NAICS22: "531312",
      "INDEX ITEM DESCRIPTION":
        "Property managers' offices, commercial real estate",
    },
    {
      NAICS22: "531312",
      "INDEX ITEM DESCRIPTION":
        "Property managers' offices, nonresidential real estate",
    },
    {
      NAICS22: "531312",
      "INDEX ITEM DESCRIPTION": "Property managing, commercial real estate",
    },
    {
      NAICS22: "531312",
      "INDEX ITEM DESCRIPTION": "Property managing, nonresidential real estate",
    },
    {
      NAICS22: "531312",
      "INDEX ITEM DESCRIPTION":
        "Real estate property managers' offices, commercial",
    },
    {
      NAICS22: "531320",
      "INDEX ITEM DESCRIPTION": "Appraisal services, real estate",
    },
    {
      NAICS22: "531320",
      "INDEX ITEM DESCRIPTION": "Appraisers' offices, real estate",
    },
    {
      NAICS22: "531320",
      "INDEX ITEM DESCRIPTION": "Real estate appraisal services",
    },
    {
      NAICS22: "531320",
      "INDEX ITEM DESCRIPTION": "Real estate appraisers' offices",
    },
    {
      NAICS22: "531390",
      "INDEX ITEM DESCRIPTION": "Agencies, real estate escrow",
    },
    {
      NAICS22: "531390",
      "INDEX ITEM DESCRIPTION": "Agents' offices, real estate escrow",
    },
    {
      NAICS22: "531390",
      "INDEX ITEM DESCRIPTION":
        "Consultants', real estate (except appraisers), offices",
    },
    {
      NAICS22: "531390",
      "INDEX ITEM DESCRIPTION": "Escrow agencies, real estate",
    },
    {
      NAICS22: "531390",
      "INDEX ITEM DESCRIPTION": "Fiduciaries', real estate, offices",
    },
    {
      NAICS22: "531390",
      "INDEX ITEM DESCRIPTION": "Landman services",
    },
    {
      NAICS22: "531390",
      "INDEX ITEM DESCRIPTION": "Listing services, real estate",
    },
    {
      NAICS22: "531390",
      "INDEX ITEM DESCRIPTION":
        "Real estate asset management services (except property management)",
    },
    {
      NAICS22: "531390",
      "INDEX ITEM DESCRIPTION":
        "Real estate consultants' (except agents, appraisers) offices",
    },
    {
      NAICS22: "531390",
      "INDEX ITEM DESCRIPTION": "Real estate escrow agencies",
    },
    {
      NAICS22: "531390",
      "INDEX ITEM DESCRIPTION": "Real estate escrow agents' offices",
    },
    {
      NAICS22: "531390",
      "INDEX ITEM DESCRIPTION": "Real estate fiduciaries' offices",
    },
    {
      NAICS22: "531390",
      "INDEX ITEM DESCRIPTION": "Real estate listing services",
    },
    {
      NAICS22: "532111",
      "INDEX ITEM DESCRIPTION": "Automobile rental",
    },
    {
      NAICS22: "532111",
      "INDEX ITEM DESCRIPTION": "Car rental",
    },
    {
      NAICS22: "532111",
      "INDEX ITEM DESCRIPTION": "Car rental agencies",
    },
    {
      NAICS22: "532111",
      "INDEX ITEM DESCRIPTION": "Hearse rental without driver",
    },
    {
      NAICS22: "532111",
      "INDEX ITEM DESCRIPTION": "Limousine rental without driver",
    },
    {
      NAICS22: "532111",
      "INDEX ITEM DESCRIPTION": "Luxury automobile rental without driver",
    },
    {
      NAICS22: "532111",
      "INDEX ITEM DESCRIPTION": "Passenger car rental",
    },
    {
      NAICS22: "532111",
      "INDEX ITEM DESCRIPTION": "Passenger truck (light duty) rental",
    },
    {
      NAICS22: "532111",
      "INDEX ITEM DESCRIPTION": "Passenger van rental",
    },
    {
      NAICS22: "532111",
      "INDEX ITEM DESCRIPTION": "Passenger van rental agencies",
    },
    {
      NAICS22: "532111",
      "INDEX ITEM DESCRIPTION": "Sport utility vehicle rental",
    },
    {
      NAICS22: "532111",
      "INDEX ITEM DESCRIPTION": "Van (passenger) rental",
    },
    {
      NAICS22: "532112",
      "INDEX ITEM DESCRIPTION": "Automobile leasing",
    },
    {
      NAICS22: "532112",
      "INDEX ITEM DESCRIPTION": "Car leasing",
    },
    {
      NAICS22: "532112",
      "INDEX ITEM DESCRIPTION": "Fleet leasing, passenger vehicle",
    },
    {
      NAICS22: "532112",
      "INDEX ITEM DESCRIPTION": "Passenger car leasing",
    },
    {
      NAICS22: "532112",
      "INDEX ITEM DESCRIPTION": "Passenger truck (light duty) leasing",
    },
    {
      NAICS22: "532112",
      "INDEX ITEM DESCRIPTION": "Passenger van leasing",
    },
    {
      NAICS22: "532112",
      "INDEX ITEM DESCRIPTION": "Passenger vehicle fleet leasing",
    },
    {
      NAICS22: "532112",
      "INDEX ITEM DESCRIPTION": "Sport utility vehicle leasing",
    },
    {
      NAICS22: "532112",
      "INDEX ITEM DESCRIPTION": "Van (passenger) leasing",
    },
    {
      NAICS22: "532120",
      "INDEX ITEM DESCRIPTION": "Bus rental or leasing",
    },
    {
      NAICS22: "532120",
      "INDEX ITEM DESCRIPTION": "Camper rental",
    },
    {
      NAICS22: "532120",
      "INDEX ITEM DESCRIPTION": "Dump truck rental or leasing without operator",
    },
    {
      NAICS22: "532120",
      "INDEX ITEM DESCRIPTION": "Mobile home rental, off-site",
    },
    {
      NAICS22: "532120",
      "INDEX ITEM DESCRIPTION": "Motor home rental, off-site",
    },
    {
      NAICS22: "532120",
      "INDEX ITEM DESCRIPTION": "Popup camper rental",
    },
    {
      NAICS22: "532120",
      "INDEX ITEM DESCRIPTION": "Recreational trailer rental",
    },
    {
      NAICS22: "532120",
      "INDEX ITEM DESCRIPTION": "Recreational vehicle (RV) rental or leasing",
    },
    {
      NAICS22: "532120",
      "INDEX ITEM DESCRIPTION": "RV (recreational vehicle) rental or leasing",
    },
    {
      NAICS22: "532120",
      "INDEX ITEM DESCRIPTION": "School bus rental or leasing",
    },
    {
      NAICS22: "532120",
      "INDEX ITEM DESCRIPTION": "Semi-trailer rental or leasing",
    },
    {
      NAICS22: "532120",
      "INDEX ITEM DESCRIPTION": "Trailer rental or leasing",
    },
    {
      NAICS22: "532120",
      "INDEX ITEM DESCRIPTION":
        "Truck (except industrial, light duty passenger) rental or leasing",
    },
    {
      NAICS22: "532120",
      "INDEX ITEM DESCRIPTION": "Truck tractor rental or leasing without driver",
    },
    {
      NAICS22: "532120",
      "INDEX ITEM DESCRIPTION": "Utility trailer rental or leasing",
    },
    {
      NAICS22: "532120",
      "INDEX ITEM DESCRIPTION":
        "Van (except passenger) rental or leasing without driver",
    },
    {
      NAICS22: "532210",
      "INDEX ITEM DESCRIPTION": "Air-conditioner rental",
    },
    {
      NAICS22: "532210",
      "INDEX ITEM DESCRIPTION": "Appliance rental",
    },
    {
      NAICS22: "532210",
      "INDEX ITEM DESCRIPTION": "Camcorder rental",
    },
    {
      NAICS22: "532210",
      "INDEX ITEM DESCRIPTION": "Consumer electronics rental",
    },
    {
      NAICS22: "532210",
      "INDEX ITEM DESCRIPTION": "Dryer, clothes, rental",
    },
    {
      NAICS22: "532210",
      "INDEX ITEM DESCRIPTION": "Photographic equipment rental",
    },
    {
      NAICS22: "532210",
      "INDEX ITEM DESCRIPTION": "Refrigerator rental",
    },
    {
      NAICS22: "532210",
      "INDEX ITEM DESCRIPTION": "Stereo equipment rental",
    },
    {
      NAICS22: "532210",
      "INDEX ITEM DESCRIPTION": "Tape recorder rental",
    },
    {
      NAICS22: "532210",
      "INDEX ITEM DESCRIPTION": "Television rental",
    },
    {
      NAICS22: "532210",
      "INDEX ITEM DESCRIPTION": "Video cassette recorder rental",
    },
    {
      NAICS22: "532210",
      "INDEX ITEM DESCRIPTION": "Video disc player rental",
    },
    {
      NAICS22: "532210",
      "INDEX ITEM DESCRIPTION": "Video recorder rental",
    },
    {
      NAICS22: "532210",
      "INDEX ITEM DESCRIPTION": "Video tape player rental",
    },
    {
      NAICS22: "532210",
      "INDEX ITEM DESCRIPTION": "Washer, clothes, rental",
    },
    {
      NAICS22: "532281",
      "INDEX ITEM DESCRIPTION": "Bridal wear rental",
    },
    {
      NAICS22: "532281",
      "INDEX ITEM DESCRIPTION":
        "Clothing rental (except industrial launderer, linen supply)",
    },
    {
      NAICS22: "532281",
      "INDEX ITEM DESCRIPTION": "Costume rental",
    },
    {
      NAICS22: "532281",
      "INDEX ITEM DESCRIPTION": "Dress suit rental",
    },
    {
      NAICS22: "532281",
      "INDEX ITEM DESCRIPTION": "Formal wear rental",
    },
    {
      NAICS22: "532281",
      "INDEX ITEM DESCRIPTION": "Fur rental",
    },
    {
      NAICS22: "532281",
      "INDEX ITEM DESCRIPTION": "Gown rental",
    },
    {
      NAICS22: "532281",
      "INDEX ITEM DESCRIPTION": "Graduation cap and gown rental",
    },
    {
      NAICS22: "532281",
      "INDEX ITEM DESCRIPTION": "Motion picture wardrobe and costume rental",
    },
    {
      NAICS22: "532281",
      "INDEX ITEM DESCRIPTION": "Suit rental",
    },
    {
      NAICS22: "532281",
      "INDEX ITEM DESCRIPTION": "Theatrical wardrobe and costume rental",
    },
    {
      NAICS22: "532281",
      "INDEX ITEM DESCRIPTION": "Tuxedo rental",
    },
    {
      NAICS22: "532281",
      "INDEX ITEM DESCRIPTION": "Wardrobe rental",
    },
    {
      NAICS22: "532282",
      "INDEX ITEM DESCRIPTION": "Cassette, prerecorded video, rental",
    },
    {
      NAICS22: "532282",
      "INDEX ITEM DESCRIPTION": "Computer video game rental",
    },
    {
      NAICS22: "532282",
      "INDEX ITEM DESCRIPTION": "Laser disc, video, rental",
    },
    {
      NAICS22: "532282",
      "INDEX ITEM DESCRIPTION":
        "Video disc rental for home electronic equipment (e.g., DVD)",
    },
    {
      NAICS22: "532282",
      "INDEX ITEM DESCRIPTION": "Video game rental",
    },
    {
      NAICS22: "532282",
      "INDEX ITEM DESCRIPTION":
        "Video tape rental for home electronic equipment (e.g., VCR)",
    },
    {
      NAICS22: "532282",
      "INDEX ITEM DESCRIPTION": "Video tape rental stores",
    },
    {
      NAICS22: "532283",
      "INDEX ITEM DESCRIPTION": "Crutches, invalid, rental",
    },
    {
      NAICS22: "532283",
      "INDEX ITEM DESCRIPTION": "Furniture, home health, rental",
    },
    {
      NAICS22: "532283",
      "INDEX ITEM DESCRIPTION": "Home health furniture and equipment rental",
    },
    {
      NAICS22: "532283",
      "INDEX ITEM DESCRIPTION":
        "Hospital bed rental and leasing (i.e., home use)",
    },
    {
      NAICS22: "532283",
      "INDEX ITEM DESCRIPTION": "Hospital equipment rental (i.e. home use)",
    },
    {
      NAICS22: "532283",
      "INDEX ITEM DESCRIPTION":
        "Hospital furniture and equipment rental (i.e. home use)",
    },
    {
      NAICS22: "532283",
      "INDEX ITEM DESCRIPTION": "Invalid equipment rental (i.e., home use)",
    },
    {
      NAICS22: "532283",
      "INDEX ITEM DESCRIPTION": "Oxygen equipment rental (i.e., home use)",
    },
    {
      NAICS22: "532283",
      "INDEX ITEM DESCRIPTION": "Walker, invalid, rental",
    },
    {
      NAICS22: "532283",
      "INDEX ITEM DESCRIPTION": "Wheelchair rental",
    },
    {
      NAICS22: "532284",
      "INDEX ITEM DESCRIPTION": "Beach chair rental",
    },
    {
      NAICS22: "532284",
      "INDEX ITEM DESCRIPTION": "Beach umbrella rental",
    },
    {
      NAICS22: "532284",
      "INDEX ITEM DESCRIPTION": "Bicycle rental",
    },
    {
      NAICS22: "532284",
      "INDEX ITEM DESCRIPTION": "Bicycle sharing services",
    },
    {
      NAICS22: "532284",
      "INDEX ITEM DESCRIPTION": "Boat rental, pleasure",
    },
    {
      NAICS22: "532284",
      "INDEX ITEM DESCRIPTION": "Canoe rental",
    },
    {
      NAICS22: "532284",
      "INDEX ITEM DESCRIPTION": "Exercise equipment rental",
    },
    {
      NAICS22: "532284",
      "INDEX ITEM DESCRIPTION": "Golf cart rental",
    },
    {
      NAICS22: "532284",
      "INDEX ITEM DESCRIPTION": "Houseboat rental",
    },
    {
      NAICS22: "532284",
      "INDEX ITEM DESCRIPTION": "Moped rental",
    },
    {
      NAICS22: "532284",
      "INDEX ITEM DESCRIPTION": "Motorcycle rental",
    },
    {
      NAICS22: "532284",
      "INDEX ITEM DESCRIPTION": "Personal watercraft rental",
    },
    {
      NAICS22: "532284",
      "INDEX ITEM DESCRIPTION": "Pleasure boat rental",
    },
    {
      NAICS22: "532284",
      "INDEX ITEM DESCRIPTION": "Recreational goods rental",
    },
    {
      NAICS22: "532284",
      "INDEX ITEM DESCRIPTION": "Rowboat rental",
    },
    {
      NAICS22: "532284",
      "INDEX ITEM DESCRIPTION": "Sailboat rental",
    },
    {
      NAICS22: "532284",
      "INDEX ITEM DESCRIPTION": "Ski equipment rental",
    },
    {
      NAICS22: "532284",
      "INDEX ITEM DESCRIPTION": "Snow ski equipment rental",
    },
    {
      NAICS22: "532284",
      "INDEX ITEM DESCRIPTION": "Sporting goods rental",
    },
    {
      NAICS22: "532284",
      "INDEX ITEM DESCRIPTION": "Sports equipment rental",
    },
    {
      NAICS22: "532284",
      "INDEX ITEM DESCRIPTION": "Surfboard rental",
    },
    {
      NAICS22: "532284",
      "INDEX ITEM DESCRIPTION": "Tent, camping, rental",
    },
    {
      NAICS22: "532284",
      "INDEX ITEM DESCRIPTION": "Water ski rental",
    },
    {
      NAICS22: "532284",
      "INDEX ITEM DESCRIPTION": "Yacht rental without crew",
    },
    {
      NAICS22: "532289",
      "INDEX ITEM DESCRIPTION": "Carpet and rug, residential, rental",
    },
    {
      NAICS22: "532289",
      "INDEX ITEM DESCRIPTION": "Furniture (i.e., residential) rental centers",
    },
    {
      NAICS22: "532289",
      "INDEX ITEM DESCRIPTION": "Furniture, residential, rental or leasing",
    },
    {
      NAICS22: "532289",
      "INDEX ITEM DESCRIPTION": "Musical instrument rental",
    },
    {
      NAICS22: "532289",
      "INDEX ITEM DESCRIPTION": "Party (i.e., banquet) equipment rental",
    },
    {
      NAICS22: "532289",
      "INDEX ITEM DESCRIPTION": "Party rental supply centers",
    },
    {
      NAICS22: "532289",
      "INDEX ITEM DESCRIPTION": "Piano rental",
    },
    {
      NAICS22: "532289",
      "INDEX ITEM DESCRIPTION": "Rug and carpet rental",
    },
    {
      NAICS22: "532289",
      "INDEX ITEM DESCRIPTION": "Silverware rental",
    },
    {
      NAICS22: "532289",
      "INDEX ITEM DESCRIPTION": "Table and banquet accessory rental",
    },
    {
      NAICS22: "532289",
      "INDEX ITEM DESCRIPTION": "Tableware rental",
    },
    {
      NAICS22: "532289",
      "INDEX ITEM DESCRIPTION": "Tent, party, rental",
    },
    {
      NAICS22: "532289",
      "INDEX ITEM DESCRIPTION": "Tool rental or leasing for home use",
    },
    {
      NAICS22: "532310",
      "INDEX ITEM DESCRIPTION": "General rental centers",
    },
    {
      NAICS22: "532310",
      "INDEX ITEM DESCRIPTION": "Home and garden equipment rental centers",
    },
    {
      NAICS22: "532310",
      "INDEX ITEM DESCRIPTION": "Rent-all centers",
    },
    {
      NAICS22: "532411",
      "INDEX ITEM DESCRIPTION": "Aircraft rental or leasing without operator",
    },
    {
      NAICS22: "532411",
      "INDEX ITEM DESCRIPTION": "Airplane rental or leasing without operator",
    },
    {
      NAICS22: "532411",
      "INDEX ITEM DESCRIPTION": "Barge rental or leasing without crew",
    },
    {
      NAICS22: "532411",
      "INDEX ITEM DESCRIPTION": "Boat rental (except pleasure) without crew",
    },
    {
      NAICS22: "532411",
      "INDEX ITEM DESCRIPTION": "Boat rental or leasing, commercial",
    },
    {
      NAICS22: "532411",
      "INDEX ITEM DESCRIPTION": "Railroad car rental or leasing",
    },
    {
      NAICS22: "532411",
      "INDEX ITEM DESCRIPTION": "Ship rental or leasing without crew",
    },
    {
      NAICS22: "532411",
      "INDEX ITEM DESCRIPTION": "Steamship rental or leasing without crew",
    },
    {
      NAICS22: "532411",
      "INDEX ITEM DESCRIPTION": "Tanker (boat) rental or leasing without crew",
    },
    {
      NAICS22: "532411",
      "INDEX ITEM DESCRIPTION": "Towboat rental or leasing without crew",
    },
    {
      NAICS22: "532411",
      "INDEX ITEM DESCRIPTION": "Tugboat rental or leasing without crew",
    },
    {
      NAICS22: "532412",
      "INDEX ITEM DESCRIPTION": "Bulldozer rental or leasing without operator",
    },
    {
      NAICS22: "532412",
      "INDEX ITEM DESCRIPTION": "Construction form rental",
    },
    {
      NAICS22: "532412",
      "INDEX ITEM DESCRIPTION":
        "Construction machinery and equipment rental or leasing without operator",
    },
    {
      NAICS22: "532412",
      "INDEX ITEM DESCRIPTION": "Crane rental or leasing without operator",
    },
    {
      NAICS22: "532412",
      "INDEX ITEM DESCRIPTION":
        "Earthmoving equipment rental or leasing without operator",
    },
    {
      NAICS22: "532412",
      "INDEX ITEM DESCRIPTION":
        "Forestry machinery and equipment rental or leasing",
    },
    {
      NAICS22: "532412",
      "INDEX ITEM DESCRIPTION":
        "Heavy construction equipment rental without operator",
    },
    {
      NAICS22: "532412",
      "INDEX ITEM DESCRIPTION":
        "Logging equipment rental or leasing without operator",
    },
    {
      NAICS22: "532412",
      "INDEX ITEM DESCRIPTION":
        "Mining machinery and equipment rental or leasing",
    },
    {
      NAICS22: "532412",
      "INDEX ITEM DESCRIPTION":
        "Oil field machinery and equipment rental or leasing",
    },
    {
      NAICS22: "532412",
      "INDEX ITEM DESCRIPTION":
        "Oil well drilling machinery and equipment rental or leasing",
    },
    {
      NAICS22: "532412",
      "INDEX ITEM DESCRIPTION": "Welding equipment rental or leasing",
    },
    {
      NAICS22: "532412",
      "INDEX ITEM DESCRIPTION":
        "Well drilling machinery and equipment rental or leasing",
    },
    {
      NAICS22: "532420",
      "INDEX ITEM DESCRIPTION": "Cash register rental or leasing",
    },
    {
      NAICS22: "532420",
      "INDEX ITEM DESCRIPTION": "Computer peripheral equipment rental or leasing",
    },
    {
      NAICS22: "532420",
      "INDEX ITEM DESCRIPTION": "Computer rental or leasing",
    },
    {
      NAICS22: "532420",
      "INDEX ITEM DESCRIPTION": "Copier rental or leasing",
    },
    {
      NAICS22: "532420",
      "INDEX ITEM DESCRIPTION":
        "Duplicating machine (e.g., copier) rental or leasing",
    },
    {
      NAICS22: "532420",
      "INDEX ITEM DESCRIPTION": "Facsimile machine rental or leasing",
    },
    {
      NAICS22: "532420",
      "INDEX ITEM DESCRIPTION": "Fax machine rental or leasing",
    },
    {
      NAICS22: "532420",
      "INDEX ITEM DESCRIPTION": "Furniture, office, rental or leasing",
    },
    {
      NAICS22: "532420",
      "INDEX ITEM DESCRIPTION": "Mailing equipment rental or leasing",
    },
    {
      NAICS22: "532420",
      "INDEX ITEM DESCRIPTION": "Office furniture rental or leasing",
    },
    {
      NAICS22: "532420",
      "INDEX ITEM DESCRIPTION":
        "Office machinery and equipment rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION":
        "Agricultural machinery and equipment rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION": "Audio visual equipment rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION": "Carpentry equipment rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION":
        "Carpet and rug cleaning equipment rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION": "Compressor, air and gas, rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION": "Farm equipment rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION": "Farm tractor rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION": "Floor sanding machine rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION": "Floor waxing equipment rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION":
        "Furniture, institutional (i.e. public building), rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION": "Garden tractor rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION": "Generator rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION": "Industrial truck rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION": "Lawnmower rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION":
        "Manufacturing machinery and equipment rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION":
        "Material handling machinery and equipment rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION":
        "Medical equipment (except home health furniture and equipment) rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION":
        "Metalworking machinery and equipment rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION":
        "Mobile office building rental or leasing, off-site",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION": "Modular building rental or leasing, off-site",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION": "Motion picture equipment rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION": "Pallet rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION": "Plumbing equipment rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION": "Power washer rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION": "Public address system rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION":
        "Renting coin- or card-operated amusement devices (except concession operators)",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION": "Sawmill machinery rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION": "Scaffolding rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION": "Scenery, theatrical, rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION": "Skid rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION": "Sound and lighting equipment rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION": "Telecommunications equipment rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION": "Textile machinery rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION":
        "Theatrical equipment (except costumes) rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION": "Tractor, farm, rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION": "Tractor, garden, rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION":
        "Traffic control equipment (e.g., barricades, cones, traffic signs) rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION": "Truck, industrial, rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION":
        "TV broadcasting and studio equipment rental or leasing",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION": "Vending machine rental",
    },
    {
      NAICS22: "532490",
      "INDEX ITEM DESCRIPTION":
        "Woodworking machinery and equipment rental or leasing",
    },
    {
      NAICS22: "533110",
      "INDEX ITEM DESCRIPTION": "Brand name licensing",
    },
    {
      NAICS22: "533110",
      "INDEX ITEM DESCRIPTION":
        "Franchise agreements, leasing, selling or licensing, without providing other services",
    },
    {
      NAICS22: "533110",
      "INDEX ITEM DESCRIPTION": "Industrial design licensing",
    },
    {
      NAICS22: "533110",
      "INDEX ITEM DESCRIPTION": "Oil royalty companies",
    },
    {
      NAICS22: "533110",
      "INDEX ITEM DESCRIPTION": "Oil royalty leasing",
    },
    {
      NAICS22: "533110",
      "INDEX ITEM DESCRIPTION": "Oil royalty traders (except for own account)",
    },
    {
      NAICS22: "533110",
      "INDEX ITEM DESCRIPTION": "Patent buying and licensing",
    },
    {
      NAICS22: "533110",
      "INDEX ITEM DESCRIPTION": "Patent leasing",
    },
    {
      NAICS22: "533110",
      "INDEX ITEM DESCRIPTION": "Performance rights, licensing of",
    },
    {
      NAICS22: "533110",
      "INDEX ITEM DESCRIPTION": "Trademark licensing",
    },
    {
      NAICS22: "541110",
      "INDEX ITEM DESCRIPTION": "Attorneys' offices",
    },
    {
      NAICS22: "541110",
      "INDEX ITEM DESCRIPTION": "Attorneys' private practices",
    },
    {
      NAICS22: "541110",
      "INDEX ITEM DESCRIPTION": "Barristers' offices",
    },
    {
      NAICS22: "541110",
      "INDEX ITEM DESCRIPTION": "Barristers' private practices",
    },
    {
      NAICS22: "541110",
      "INDEX ITEM DESCRIPTION": "Corporate law offices",
    },
    {
      NAICS22: "541110",
      "INDEX ITEM DESCRIPTION": "Counselors' at law offices",
    },
    {
      NAICS22: "541110",
      "INDEX ITEM DESCRIPTION": "Counselors' at law private practices",
    },
    {
      NAICS22: "541110",
      "INDEX ITEM DESCRIPTION": "Criminal law offices",
    },
    {
      NAICS22: "541110",
      "INDEX ITEM DESCRIPTION": "Estate law offices",
    },
    {
      NAICS22: "541110",
      "INDEX ITEM DESCRIPTION": "Family law offices",
    },
    {
      NAICS22: "541110",
      "INDEX ITEM DESCRIPTION": "Law firms",
    },
    {
      NAICS22: "541110",
      "INDEX ITEM DESCRIPTION": "Law offices",
    },
    {
      NAICS22: "541110",
      "INDEX ITEM DESCRIPTION": "Law practices",
    },
    {
      NAICS22: "541110",
      "INDEX ITEM DESCRIPTION": "Lawyers' offices",
    },
    {
      NAICS22: "541110",
      "INDEX ITEM DESCRIPTION": "Lawyers' private practices",
    },
    {
      NAICS22: "541110",
      "INDEX ITEM DESCRIPTION": "Legal aid services",
    },
    {
      NAICS22: "541110",
      "INDEX ITEM DESCRIPTION": "Patent attorneys' offices",
    },
    {
      NAICS22: "541110",
      "INDEX ITEM DESCRIPTION": "Patent attorneys' private practices",
    },
    {
      NAICS22: "541110",
      "INDEX ITEM DESCRIPTION": "Real estate law offices",
    },
    {
      NAICS22: "541110",
      "INDEX ITEM DESCRIPTION": "Solicitors' offices, private",
    },
    {
      NAICS22: "541110",
      "INDEX ITEM DESCRIPTION": "Solicitors' private practices",
    },
    {
      NAICS22: "541110",
      "INDEX ITEM DESCRIPTION": "Tax law attorneys' offices",
    },
    {
      NAICS22: "541110",
      "INDEX ITEM DESCRIPTION": "Tax law attorneys' private practices",
    },
    {
      NAICS22: "541191",
      "INDEX ITEM DESCRIPTION": "Settlement offices, real estate",
    },
    {
      NAICS22: "541191",
      "INDEX ITEM DESCRIPTION": "Title abstract companies, real estate",
    },
    {
      NAICS22: "541191",
      "INDEX ITEM DESCRIPTION": "Title companies, real estate",
    },
    {
      NAICS22: "541191",
      "INDEX ITEM DESCRIPTION": "Title search companies, real estate",
    },
    {
      NAICS22: "541199",
      "INDEX ITEM DESCRIPTION": "Jury consulting services",
    },
    {
      NAICS22: "541199",
      "INDEX ITEM DESCRIPTION": "Notary public services",
    },
    {
      NAICS22: "541199",
      "INDEX ITEM DESCRIPTION": "Notary publics' private practices",
    },
    {
      NAICS22: "541199",
      "INDEX ITEM DESCRIPTION": "Paralegal services",
    },
    {
      NAICS22: "541199",
      "INDEX ITEM DESCRIPTION":
        "Patent agent services (i.e., patent filing and searching services)",
    },
    {
      NAICS22: "541199",
      "INDEX ITEM DESCRIPTION": "Process server services",
    },
    {
      NAICS22: "541199",
      "INDEX ITEM DESCRIPTION": "Process serving services",
    },
    {
      NAICS22: "541199",
      "INDEX ITEM DESCRIPTION": "Trial consulting services",
    },
    {
      NAICS22: "541211",
      "INDEX ITEM DESCRIPTION":
        "Accountants' (i.e., CPAs) offices, certified public",
    },
    {
      NAICS22: "541211",
      "INDEX ITEM DESCRIPTION":
        "Accountants' (i.e., CPAs) private practices, certified public",
    },
    {
      NAICS22: "541211",
      "INDEX ITEM DESCRIPTION":
        "Accounting (i.e., CPAs) services, certified public",
    },
    {
      NAICS22: "541211",
      "INDEX ITEM DESCRIPTION": "Auditing accountants' (i.e., CPAs) offices",
    },
    {
      NAICS22: "541211",
      "INDEX ITEM DESCRIPTION":
        "Auditing accountants' (i.e., CPAs) private practices",
    },
    {
      NAICS22: "541211",
      "INDEX ITEM DESCRIPTION":
        "Auditing services (i.e., CPA services), accounts",
    },
    {
      NAICS22: "541211",
      "INDEX ITEM DESCRIPTION": "Auditors' (i.e., CPAs) offices, accounts",
    },
    {
      NAICS22: "541211",
      "INDEX ITEM DESCRIPTION":
        "Auditors' (i.e., CPAs) private practices, accounts",
    },
    {
      NAICS22: "541211",
      "INDEX ITEM DESCRIPTION": "Certified accountants' offices",
    },
    {
      NAICS22: "541211",
      "INDEX ITEM DESCRIPTION": "Certified public accountants' (CPAs) offices",
    },
    {
      NAICS22: "541211",
      "INDEX ITEM DESCRIPTION": "CPAs' (certified public accountants) offices",
    },
    {
      NAICS22: "541211",
      "INDEX ITEM DESCRIPTION": "Public accountants' (CPAs) offices, certified",
    },
    {
      NAICS22: "541211",
      "INDEX ITEM DESCRIPTION":
        "Public accountants' (CPAs) private practices, certified",
    },
    {
      NAICS22: "541213",
      "INDEX ITEM DESCRIPTION": "Income tax compilation services",
    },
    {
      NAICS22: "541213",
      "INDEX ITEM DESCRIPTION": "Income tax return preparation services",
    },
    {
      NAICS22: "541213",
      "INDEX ITEM DESCRIPTION": "Tax return preparation services",
    },
    {
      NAICS22: "541214",
      "INDEX ITEM DESCRIPTION": "Motion picture production payroll services",
    },
    {
      NAICS22: "541214",
      "INDEX ITEM DESCRIPTION": "Payroll processing services",
    },
    {
      NAICS22: "541214",
      "INDEX ITEM DESCRIPTION": "Talent payment services",
    },
    {
      NAICS22: "541219",
      "INDEX ITEM DESCRIPTION": "Accountants' (except CPAs) offices",
    },
    {
      NAICS22: "541219",
      "INDEX ITEM DESCRIPTION": "Accountants' (except CPAs) private practices",
    },
    {
      NAICS22: "541219",
      "INDEX ITEM DESCRIPTION": "Accounting services (except CPAs)",
    },
    {
      NAICS22: "541219",
      "INDEX ITEM DESCRIPTION": "Billing services",
    },
    {
      NAICS22: "541219",
      "INDEX ITEM DESCRIPTION": "Bookkeepers' offices",
    },
    {
      NAICS22: "541219",
      "INDEX ITEM DESCRIPTION": "Bookkeepers' private practices",
    },
    {
      NAICS22: "541219",
      "INDEX ITEM DESCRIPTION": "Bookkeeping services",
    },
    {
      NAICS22: "541219",
      "INDEX ITEM DESCRIPTION":
        "Medical coding services combined with accounting services (except CPA services)",
    },
    {
      NAICS22: "541219",
      "INDEX ITEM DESCRIPTION": "Public accountants' (except CPAs) offices",
    },
    {
      NAICS22: "541219",
      "INDEX ITEM DESCRIPTION":
        "Public accountants' (except CPAs) private practices",
    },
    {
      NAICS22: "541310",
      "INDEX ITEM DESCRIPTION": "Architects' (except landscape) offices",
    },
    {
      NAICS22: "541310",
      "INDEX ITEM DESCRIPTION":
        "Architects' (except landscape) private practices",
    },
    {
      NAICS22: "541310",
      "INDEX ITEM DESCRIPTION":
        "Architectural (except landscape) consultants' offices",
    },
    {
      NAICS22: "541310",
      "INDEX ITEM DESCRIPTION":
        "Architectural (except landscape) design services",
    },
    {
      NAICS22: "541310",
      "INDEX ITEM DESCRIPTION": "Architectural (except landscape) services",
    },
    {
      NAICS22: "541310",
      "INDEX ITEM DESCRIPTION":
        "Architectural construction specifications consulting services",
    },
    {
      NAICS22: "541310",
      "INDEX ITEM DESCRIPTION": "Building architectural design services",
    },
    {
      NAICS22: "541320",
      "INDEX ITEM DESCRIPTION": "Architects' offices, landscape",
    },
    {
      NAICS22: "541320",
      "INDEX ITEM DESCRIPTION": "Architects' private practices, landscape",
    },
    {
      NAICS22: "541320",
      "INDEX ITEM DESCRIPTION": "Architectural services, landscape",
    },
    {
      NAICS22: "541320",
      "INDEX ITEM DESCRIPTION": "City planning services",
    },
    {
      NAICS22: "541320",
      "INDEX ITEM DESCRIPTION": "Garden planning services",
    },
    {
      NAICS22: "541320",
      "INDEX ITEM DESCRIPTION": "Golf course design services",
    },
    {
      NAICS22: "541320",
      "INDEX ITEM DESCRIPTION": "Industrial land use planning services",
    },
    {
      NAICS22: "541320",
      "INDEX ITEM DESCRIPTION": "Land use design services",
    },
    {
      NAICS22: "541320",
      "INDEX ITEM DESCRIPTION": "Land use planning services",
    },
    {
      NAICS22: "541320",
      "INDEX ITEM DESCRIPTION": "Landscape architects' offices",
    },
    {
      NAICS22: "541320",
      "INDEX ITEM DESCRIPTION": "Landscape architects' private practices",
    },
    {
      NAICS22: "541320",
      "INDEX ITEM DESCRIPTION": "Landscape architectural services",
    },
    {
      NAICS22: "541320",
      "INDEX ITEM DESCRIPTION": "Landscape consulting services",
    },
    {
      NAICS22: "541320",
      "INDEX ITEM DESCRIPTION": "Landscape design services",
    },
    {
      NAICS22: "541320",
      "INDEX ITEM DESCRIPTION": "Landscape planning services",
    },
    {
      NAICS22: "541320",
      "INDEX ITEM DESCRIPTION": "Ski area design services",
    },
    {
      NAICS22: "541320",
      "INDEX ITEM DESCRIPTION": "Ski area planning services",
    },
    {
      NAICS22: "541320",
      "INDEX ITEM DESCRIPTION": "Town planners' offices",
    },
    {
      NAICS22: "541320",
      "INDEX ITEM DESCRIPTION": "Town planning services",
    },
    {
      NAICS22: "541320",
      "INDEX ITEM DESCRIPTION": "Urban planners' offices",
    },
    {
      NAICS22: "541320",
      "INDEX ITEM DESCRIPTION": "Urban planning services",
    },
    {
      NAICS22: "541330",
      "INDEX ITEM DESCRIPTION": "Acoustical engineering consulting services",
    },
    {
      NAICS22: "541330",
      "INDEX ITEM DESCRIPTION": "Acoustical system engineering design services",
    },
    {
      NAICS22: "541330",
      "INDEX ITEM DESCRIPTION": "Audio visual system engineering design services",
    },
    {
      NAICS22: "541330",
      "INDEX ITEM DESCRIPTION": "Boat engineering design services",
    },
    {
      NAICS22: "541330",
      "INDEX ITEM DESCRIPTION": "Chemical engineering services",
    },
    {
      NAICS22: "541330",
      "INDEX ITEM DESCRIPTION": "Civil engineering services",
    },
    {
      NAICS22: "541330",
      "INDEX ITEM DESCRIPTION": "Combustion engineering consulting services",
    },
    {
      NAICS22: "541330",
      "INDEX ITEM DESCRIPTION": "Construction engineering services",
    },
    {
      NAICS22: "541330",
      "INDEX ITEM DESCRIPTION": "Consulting engineers' offices",
    },
    {
      NAICS22: "541330",
      "INDEX ITEM DESCRIPTION": "Consulting engineers' private practices",
    },
    {
      NAICS22: "541330",
      "INDEX ITEM DESCRIPTION": "Electrical engineering services",
    },
    {
      NAICS22: "541330",
      "INDEX ITEM DESCRIPTION": "Engineering consulting services",
    },
    {
      NAICS22: "541330",
      "INDEX ITEM DESCRIPTION": "Engineering design services",
    },
    {
      NAICS22: "541330",
      "INDEX ITEM DESCRIPTION": "Engineering services",
    },
    {
      NAICS22: "541330",
      "INDEX ITEM DESCRIPTION": "Engineers' offices",
    },
    {
      NAICS22: "541330",
      "INDEX ITEM DESCRIPTION": "Engineers' private practices",
    },
    {
      NAICS22: "541330",
      "INDEX ITEM DESCRIPTION": "Environmental engineering services",
    },
    {
      NAICS22: "541330",
      "INDEX ITEM DESCRIPTION": "Erosion control engineering services",
    },
    {
      NAICS22: "541330",
      "INDEX ITEM DESCRIPTION": "Geological engineering services",
    },
    {
      NAICS22: "541330",
      "INDEX ITEM DESCRIPTION": "Geophysical engineering services",
    },
    {
      NAICS22: "541330",
      "INDEX ITEM DESCRIPTION": "Heating engineering consulting services",
    },
    {
      NAICS22: "541330",
      "INDEX ITEM DESCRIPTION": "Industrial engineering services",
    },
    {
      NAICS22: "541330",
      "INDEX ITEM DESCRIPTION": "Logging engineering services",
    },
    {
      NAICS22: "541330",
      "INDEX ITEM DESCRIPTION": "Marine engineering services",
    },
    {
      NAICS22: "541330",
      "INDEX ITEM DESCRIPTION": "Maritime technology engineering services",
    },
    {
      NAICS22: "541330",
      "INDEX ITEM DESCRIPTION": "Mechanical engineering services",
    },
    {
      NAICS22: "541330",
      "INDEX ITEM DESCRIPTION": "Mining engineering services",
    },
    {
      NAICS22: "541330",
      "INDEX ITEM DESCRIPTION": "Petroleum engineering services",
    },
    {
      NAICS22: "541330",
      "INDEX ITEM DESCRIPTION": "Robotics automation engineering services",
    },
    {
      NAICS22: "541330",
      "INDEX ITEM DESCRIPTION":
        "Robotics engineering design and integration services",
    },
    {
      NAICS22: "541330",
      "INDEX ITEM DESCRIPTION": "Traffic engineering consulting services",
    },
    {
      NAICS22: "541340",
      "INDEX ITEM DESCRIPTION": "Blueprint drafting services",
    },
    {
      NAICS22: "541340",
      "INDEX ITEM DESCRIPTION": "Computer-aided design drafting (CADD) services",
    },
    {
      NAICS22: "541340",
      "INDEX ITEM DESCRIPTION": "Drafting services",
    },
    {
      NAICS22: "541340",
      "INDEX ITEM DESCRIPTION": "Draftsmen's offices",
    },
    {
      NAICS22: "541350",
      "INDEX ITEM DESCRIPTION": "Building inspection bureaus",
    },
    {
      NAICS22: "541350",
      "INDEX ITEM DESCRIPTION": "Building inspection services",
    },
    {
      NAICS22: "541350",
      "INDEX ITEM DESCRIPTION": "Energy efficiency inspection services",
    },
    {
      NAICS22: "541350",
      "INDEX ITEM DESCRIPTION": "Home inspection services",
    },
    {
      NAICS22: "541350",
      "INDEX ITEM DESCRIPTION": "Inspection bureaus, building",
    },
    {
      NAICS22: "541350",
      "INDEX ITEM DESCRIPTION": "Inspection services, building or home",
    },
    {
      NAICS22: "541350",
      "INDEX ITEM DESCRIPTION": "Prepurchase home inspection services",
    },
    {
      NAICS22: "541360",
      "INDEX ITEM DESCRIPTION": "Aerial geophysical surveying services",
    },
    {
      NAICS22: "541360",
      "INDEX ITEM DESCRIPTION": "Electrical geophysical surveying services",
    },
    {
      NAICS22: "541360",
      "INDEX ITEM DESCRIPTION": "Electromagnetic geophysical surveying services",
    },
    {
      NAICS22: "541360",
      "INDEX ITEM DESCRIPTION": "Geological surveying services",
    },
    {
      NAICS22: "541360",
      "INDEX ITEM DESCRIPTION": "Geophysical mapping services",
    },
    {
      NAICS22: "541360",
      "INDEX ITEM DESCRIPTION": "Geophysical surveying services",
    },
    {
      NAICS22: "541360",
      "INDEX ITEM DESCRIPTION": "Gravity geophysical surveying services",
    },
    {
      NAICS22: "541360",
      "INDEX ITEM DESCRIPTION": "Magnetic geophysical surveying services",
    },
    {
      NAICS22: "541360",
      "INDEX ITEM DESCRIPTION": "Mapping services, geophysical",
    },
    {
      NAICS22: "541360",
      "INDEX ITEM DESCRIPTION": "Radioactive geophysical surveying services",
    },
    {
      NAICS22: "541360",
      "INDEX ITEM DESCRIPTION": "Remote sensing geophysical surveying services",
    },
    {
      NAICS22: "541360",
      "INDEX ITEM DESCRIPTION": "Seismic geophysical surveying services",
    },
    {
      NAICS22: "541360",
      "INDEX ITEM DESCRIPTION": "Surveying services, geophysical",
    },
    {
      NAICS22: "541370",
      "INDEX ITEM DESCRIPTION": "Aerial surveying (except geophysical) services",
    },
    {
      NAICS22: "541370",
      "INDEX ITEM DESCRIPTION": "Cadastral surveying services",
    },
    {
      NAICS22: "541370",
      "INDEX ITEM DESCRIPTION": "Cartographic surveying services",
    },
    {
      NAICS22: "541370",
      "INDEX ITEM DESCRIPTION": "Construction surveying services",
    },
    {
      NAICS22: "541370",
      "INDEX ITEM DESCRIPTION": "Geodetic surveying services",
    },
    {
      NAICS22: "541370",
      "INDEX ITEM DESCRIPTION":
        "Geographic information system (GIS) base mapping services",
    },
    {
      NAICS22: "541370",
      "INDEX ITEM DESCRIPTION": "Geospatial mapping services",
    },
    {
      NAICS22: "541370",
      "INDEX ITEM DESCRIPTION": "Hydrographic mapping services",
    },
    {
      NAICS22: "541370",
      "INDEX ITEM DESCRIPTION": "Hydrographic surveying services",
    },
    {
      NAICS22: "541370",
      "INDEX ITEM DESCRIPTION": "Land surveying services",
    },
    {
      NAICS22: "541370",
      "INDEX ITEM DESCRIPTION": "Mapping (except geophysical) services",
    },
    {
      NAICS22: "541370",
      "INDEX ITEM DESCRIPTION": "Photogrammetric mapping services",
    },
    {
      NAICS22: "541370",
      "INDEX ITEM DESCRIPTION":
        "Surveying and mapping services (except geophysical)",
    },
    {
      NAICS22: "541370",
      "INDEX ITEM DESCRIPTION": "Topographic mapping services",
    },
    {
      NAICS22: "541370",
      "INDEX ITEM DESCRIPTION": "Topographic surveying services",
    },
    {
      NAICS22: "541380",
      "INDEX ITEM DESCRIPTION": "Acoustics testing laboratories or services",
    },
    {
      NAICS22: "541380",
      "INDEX ITEM DESCRIPTION": "Assaying services",
    },
    {
      NAICS22: "541380",
      "INDEX ITEM DESCRIPTION": "Automobile proving and testing grounds",
    },
    {
      NAICS22: "541380",
      "INDEX ITEM DESCRIPTION":
        "Biological (except medical, veterinary) testing laboratories or services",
    },
    {
      NAICS22: "541380",
      "INDEX ITEM DESCRIPTION":
        "Calibration and certification testing laboratories or services",
    },
    {
      NAICS22: "541380",
      "INDEX ITEM DESCRIPTION": "Electrical testing laboratories or services",
    },
    {
      NAICS22: "541380",
      "INDEX ITEM DESCRIPTION": "Electronic testing laboratories or services",
    },
    {
      NAICS22: "541380",
      "INDEX ITEM DESCRIPTION": "Environmental testing laboratories or services",
    },
    {
      NAICS22: "541380",
      "INDEX ITEM DESCRIPTION":
        "Film badge testing (i.e., radiation testing) laboratories or services",
    },
    {
      NAICS22: "541380",
      "INDEX ITEM DESCRIPTION": "Fire insurance underwriters' laboratories",
    },
    {
      NAICS22: "541380",
      "INDEX ITEM DESCRIPTION": "Food testing laboratories or services",
    },
    {
      NAICS22: "541380",
      "INDEX ITEM DESCRIPTION":
        "Forensic (except medical) laboratories or services",
    },
    {
      NAICS22: "541380",
      "INDEX ITEM DESCRIPTION": "Geotechnical testing laboratories or services",
    },
    {
      NAICS22: "541380",
      "INDEX ITEM DESCRIPTION": "Hydrostatic testing laboratories or services",
    },
    {
      NAICS22: "541380",
      "INDEX ITEM DESCRIPTION": "Industrial testing laboratories or services",
    },
    {
      NAICS22: "541380",
      "INDEX ITEM DESCRIPTION":
        "Laboratory testing (except medical, veterinary) services",
    },
    {
      NAICS22: "541380",
      "INDEX ITEM DESCRIPTION": "Mechanical testing laboratories or services",
    },
    {
      NAICS22: "541380",
      "INDEX ITEM DESCRIPTION": "Metallurgical testing laboratories or services",
    },
    {
      NAICS22: "541380",
      "INDEX ITEM DESCRIPTION": "Nondestructive testing laboratories or services",
    },
    {
      NAICS22: "541380",
      "INDEX ITEM DESCRIPTION":
        "Pollution testing (except automotive emissions testing) services",
    },
    {
      NAICS22: "541380",
      "INDEX ITEM DESCRIPTION": "Product testing laboratories or services",
    },
    {
      NAICS22: "541380",
      "INDEX ITEM DESCRIPTION":
        "Radiation dosimetry (i.e., radiation testing) laboratories or services",
    },
    {
      NAICS22: "541380",
      "INDEX ITEM DESCRIPTION": "Radiation testing laboratories or services",
    },
    {
      NAICS22: "541380",
      "INDEX ITEM DESCRIPTION": "Radiographic testing laboratories or services",
    },
    {
      NAICS22: "541380",
      "INDEX ITEM DESCRIPTION":
        "Radiographing welded joints on pipes and fittings",
    },
    {
      NAICS22: "541380",
      "INDEX ITEM DESCRIPTION": "Radiography inspection services",
    },
    {
      NAICS22: "541380",
      "INDEX ITEM DESCRIPTION": "Radon testing laboratories or services",
    },
    {
      NAICS22: "541380",
      "INDEX ITEM DESCRIPTION": "Seed testing laboratories or services",
    },
    {
      NAICS22: "541380",
      "INDEX ITEM DESCRIPTION": "Soil testing laboratories or services",
    },
    {
      NAICS22: "541380",
      "INDEX ITEM DESCRIPTION":
        "Testing laboratories (except medical, veterinary)",
    },
    {
      NAICS22: "541380",
      "INDEX ITEM DESCRIPTION": "Thermal testing laboratories or services",
    },
    {
      NAICS22: "541380",
      "INDEX ITEM DESCRIPTION": "Vibration testing laboratories or services",
    },
    {
      NAICS22: "541380",
      "INDEX ITEM DESCRIPTION": "X-ray inspection services",
    },
    {
      NAICS22: "541410",
      "INDEX ITEM DESCRIPTION": "Decorating consulting services, interior",
    },
    {
      NAICS22: "541410",
      "INDEX ITEM DESCRIPTION": "Decoration services for special events",
    },
    {
      NAICS22: "541410",
      "INDEX ITEM DESCRIPTION": "Interior decorating consultant services",
    },
    {
      NAICS22: "541410",
      "INDEX ITEM DESCRIPTION": "Interior decorating consulting services",
    },
    {
      NAICS22: "541410",
      "INDEX ITEM DESCRIPTION": "Interior design consulting services",
    },
    {
      NAICS22: "541410",
      "INDEX ITEM DESCRIPTION": "Interior design services",
    },
    {
      NAICS22: "541410",
      "INDEX ITEM DESCRIPTION": "Interior designer services",
    },
    {
      NAICS22: "541420",
      "INDEX ITEM DESCRIPTION": "Automobile industrial design services",
    },
    {
      NAICS22: "541420",
      "INDEX ITEM DESCRIPTION": "Furniture design services",
    },
    {
      NAICS22: "541420",
      "INDEX ITEM DESCRIPTION": "Handtool industrial design services",
    },
    {
      NAICS22: "541420",
      "INDEX ITEM DESCRIPTION": "Industrial design consulting services",
    },
    {
      NAICS22: "541420",
      "INDEX ITEM DESCRIPTION": "Industrial design services",
    },
    {
      NAICS22: "541420",
      "INDEX ITEM DESCRIPTION": "Packaging industrial design services",
    },
    {
      NAICS22: "541420",
      "INDEX ITEM DESCRIPTION": "Tool industrial design services",
    },
    {
      NAICS22: "541430",
      "INDEX ITEM DESCRIPTION": "Art services, commercial",
    },
    {
      NAICS22: "541430",
      "INDEX ITEM DESCRIPTION": "Art services, graphic",
    },
    {
      NAICS22: "541430",
      "INDEX ITEM DESCRIPTION": "Art studios, commercial",
    },
    {
      NAICS22: "541430",
      "INDEX ITEM DESCRIPTION": "Artists, independent commercial",
    },
    {
      NAICS22: "541430",
      "INDEX ITEM DESCRIPTION": "Artists, independent graphic",
    },
    {
      NAICS22: "541430",
      "INDEX ITEM DESCRIPTION": "Artists, independent medical",
    },
    {
      NAICS22: "541430",
      "INDEX ITEM DESCRIPTION": "Commercial art services",
    },
    {
      NAICS22: "541430",
      "INDEX ITEM DESCRIPTION": "Commercial artists, independent",
    },
    {
      NAICS22: "541430",
      "INDEX ITEM DESCRIPTION": "Commercial illustration services",
    },
    {
      NAICS22: "541430",
      "INDEX ITEM DESCRIPTION": "Commercial illustrators, independent",
    },
    {
      NAICS22: "541430",
      "INDEX ITEM DESCRIPTION": "Communication design services, visual",
    },
    {
      NAICS22: "541430",
      "INDEX ITEM DESCRIPTION":
        "Corporate identification (i.e., logo) design services",
    },
    {
      NAICS22: "541430",
      "INDEX ITEM DESCRIPTION": "Graphic art and related design services",
    },
    {
      NAICS22: "541430",
      "INDEX ITEM DESCRIPTION": "Graphic artists, independent",
    },
    {
      NAICS22: "541430",
      "INDEX ITEM DESCRIPTION": "Graphic design services",
    },
    {
      NAICS22: "541430",
      "INDEX ITEM DESCRIPTION": "Illustrators, independent commercial",
    },
    {
      NAICS22: "541430",
      "INDEX ITEM DESCRIPTION": "Medical art services",
    },
    {
      NAICS22: "541430",
      "INDEX ITEM DESCRIPTION": "Medical artists, independent",
    },
    {
      NAICS22: "541430",
      "INDEX ITEM DESCRIPTION": "Medical illustration services",
    },
    {
      NAICS22: "541430",
      "INDEX ITEM DESCRIPTION": "Medical illustrators, independent",
    },
    {
      NAICS22: "541430",
      "INDEX ITEM DESCRIPTION": "Silk screen design services",
    },
    {
      NAICS22: "541430",
      "INDEX ITEM DESCRIPTION": "Studios, commercial art",
    },
    {
      NAICS22: "541490",
      "INDEX ITEM DESCRIPTION": "Clothing design services",
    },
    {
      NAICS22: "541490",
      "INDEX ITEM DESCRIPTION":
        "Costume design services (except independent theatrical costume designers)",
    },
    {
      NAICS22: "541490",
      "INDEX ITEM DESCRIPTION": "Fashion design services",
    },
    {
      NAICS22: "541490",
      "INDEX ITEM DESCRIPTION": "Fashion designer services",
    },
    {
      NAICS22: "541490",
      "INDEX ITEM DESCRIPTION": "Float design services",
    },
    {
      NAICS22: "541490",
      "INDEX ITEM DESCRIPTION": "Fur design services",
    },
    {
      NAICS22: "541490",
      "INDEX ITEM DESCRIPTION": "Jewelry design services",
    },
    {
      NAICS22: "541490",
      "INDEX ITEM DESCRIPTION": "Lighting design services",
    },
    {
      NAICS22: "541490",
      "INDEX ITEM DESCRIPTION": "Shoe design services",
    },
    {
      NAICS22: "541490",
      "INDEX ITEM DESCRIPTION": "Textile design services",
    },
    {
      NAICS22: "541511",
      "INDEX ITEM DESCRIPTION":
        "Applications software programming services, custom computer",
    },
    {
      NAICS22: "541511",
      "INDEX ITEM DESCRIPTION":
        "Computer program or software development, custom",
    },
    {
      NAICS22: "541511",
      "INDEX ITEM DESCRIPTION": "Computer programming services, custom",
    },
    {
      NAICS22: "541511",
      "INDEX ITEM DESCRIPTION":
        "Computer software analysis and design services, custom",
    },
    {
      NAICS22: "541511",
      "INDEX ITEM DESCRIPTION": "Computer software programming services, custom",
    },
    {
      NAICS22: "541511",
      "INDEX ITEM DESCRIPTION": "Computer software support services, custom",
    },
    {
      NAICS22: "541511",
      "INDEX ITEM DESCRIPTION":
        "Industrial robot automation applications/software design and development services",
    },
    {
      NAICS22: "541511",
      "INDEX ITEM DESCRIPTION": "Industrial robot programming services",
    },
    {
      NAICS22: "541511",
      "INDEX ITEM DESCRIPTION":
        "Machine vision software design and development services",
    },
    {
      NAICS22: "541511",
      "INDEX ITEM DESCRIPTION":
        "Material handling robot applications/software design and development services",
    },
    {
      NAICS22: "541511",
      "INDEX ITEM DESCRIPTION": "Programming services, custom computer",
    },
    {
      NAICS22: "541511",
      "INDEX ITEM DESCRIPTION":
        "Robotics applications/software design and development services",
    },
    {
      NAICS22: "541511",
      "INDEX ITEM DESCRIPTION":
        "Robotics process automation software design and development services",
    },
    {
      NAICS22: "541511",
      "INDEX ITEM DESCRIPTION":
        "Search engine optimization (SEO) services, custom (except hosting and infrastructure support services)",
    },
    {
      NAICS22: "541511",
      "INDEX ITEM DESCRIPTION":
        "Software analysis and design services, custom computer",
    },
    {
      NAICS22: "541511",
      "INDEX ITEM DESCRIPTION": "Software programming services, custom computer",
    },
    {
      NAICS22: "541511",
      "INDEX ITEM DESCRIPTION":
        "Web (i.e., Internet) page design services, custom",
    },
    {
      NAICS22: "541511",
      "INDEX ITEM DESCRIPTION":
        "Welding robot applications/software design and development services",
    },
    {
      NAICS22: "541512",
      "INDEX ITEM DESCRIPTION":
        "Audio visual and IT (information technology) systems integration design services",
    },
    {
      NAICS22: "541512",
      "INDEX ITEM DESCRIPTION":
        "CAD (computer-aided design) systems integration design services",
    },
    {
      NAICS22: "541512",
      "INDEX ITEM DESCRIPTION":
        "CAE (computer-aided engineering) systems integration design services",
    },
    {
      NAICS22: "541512",
      "INDEX ITEM DESCRIPTION":
        "CAM (computer-aided manufacturing) systems integration design services",
    },
    {
      NAICS22: "541512",
      "INDEX ITEM DESCRIPTION":
        "Computer hardware consulting services or consultants",
    },
    {
      NAICS22: "541512",
      "INDEX ITEM DESCRIPTION":
        "Computer software consulting services or consultants",
    },
    {
      NAICS22: "541512",
      "INDEX ITEM DESCRIPTION":
        "Computer systems integration analysis and design services",
    },
    {
      NAICS22: "541512",
      "INDEX ITEM DESCRIPTION":
        "Computer systems integration design consulting services",
    },
    {
      NAICS22: "541512",
      "INDEX ITEM DESCRIPTION": "Computer systems integrator services",
    },
    {
      NAICS22: "541512",
      "INDEX ITEM DESCRIPTION":
        "Computer-aided design (CAD) systems integration design services",
    },
    {
      NAICS22: "541512",
      "INDEX ITEM DESCRIPTION":
        "Computer-aided engineering (CAE) systems integration design services",
    },
    {
      NAICS22: "541512",
      "INDEX ITEM DESCRIPTION":
        "Computer-aided manufacturing (CAM) systems integration design services",
    },
    {
      NAICS22: "541512",
      "INDEX ITEM DESCRIPTION":
        "Information management computer systems integration design services",
    },
    {
      NAICS22: "541512",
      "INDEX ITEM DESCRIPTION":
        "Local area network (LAN) computer systems integration design services",
    },
    {
      NAICS22: "541512",
      "INDEX ITEM DESCRIPTION":
        "Network systems integration design services, computer",
    },
    {
      NAICS22: "541512",
      "INDEX ITEM DESCRIPTION":
        "Office automation computer systems integration design services",
    },
    {
      NAICS22: "541512",
      "INDEX ITEM DESCRIPTION":
        "Systems integration design consulting services, computer",
    },
    {
      NAICS22: "541512",
      "INDEX ITEM DESCRIPTION": "Systems integration design services, computer",
    },
    {
      NAICS22: "541513",
      "INDEX ITEM DESCRIPTION":
        "Computer systems facilities (i.e., clients' facilities) management and operation services",
    },
    {
      NAICS22: "541513",
      "INDEX ITEM DESCRIPTION":
        "Data processing facilities (i.e., clients' facilities) management and operation services",
    },
    {
      NAICS22: "541513",
      "INDEX ITEM DESCRIPTION":
        "Facilities (i.e., clients' facilities) management and operation services, computer systems or data processing",
    },
    {
      NAICS22: "541513",
      "INDEX ITEM DESCRIPTION":
        "Facilities (i.e., clients' facilities) support services, computer systems or data processing",
    },
    {
      NAICS22: "541519",
      "INDEX ITEM DESCRIPTION": "Computer disaster recovery services",
    },
    {
      NAICS22: "541519",
      "INDEX ITEM DESCRIPTION": "Software installation services, computer",
    },
    {
      NAICS22: "541611",
      "INDEX ITEM DESCRIPTION": "Administrative management consulting services",
    },
    {
      NAICS22: "541611",
      "INDEX ITEM DESCRIPTION": "Business management consulting services",
    },
    {
      NAICS22: "541611",
      "INDEX ITEM DESCRIPTION": "Business start-up consulting services",
    },
    {
      NAICS22: "541611",
      "INDEX ITEM DESCRIPTION":
        "Financial management consulting (except investment advice) services",
    },
    {
      NAICS22: "541611",
      "INDEX ITEM DESCRIPTION": "General management consulting services",
    },
    {
      NAICS22: "541611",
      "INDEX ITEM DESCRIPTION":
        "Medical office management consulting services or consultants",
    },
    {
      NAICS22: "541611",
      "INDEX ITEM DESCRIPTION": "Records management consulting services",
    },
    {
      NAICS22: "541611",
      "INDEX ITEM DESCRIPTION": "Reorganizational consulting services",
    },
    {
      NAICS22: "541611",
      "INDEX ITEM DESCRIPTION": "Site location consulting services",
    },
    {
      NAICS22: "541611",
      "INDEX ITEM DESCRIPTION": "Site selection consulting services",
    },
    {
      NAICS22: "541611",
      "INDEX ITEM DESCRIPTION": "Strategic planning consulting services",
    },
    {
      NAICS22: "541612",
      "INDEX ITEM DESCRIPTION":
        "Actuarial consulting services (except insurance actuarial services)",
    },
    {
      NAICS22: "541612",
      "INDEX ITEM DESCRIPTION": "Benefit consulting services",
    },
    {
      NAICS22: "541612",
      "INDEX ITEM DESCRIPTION": "Compensation consulting services",
    },
    {
      NAICS22: "541612",
      "INDEX ITEM DESCRIPTION": "Compensation planning services",
    },
    {
      NAICS22: "541612",
      "INDEX ITEM DESCRIPTION": "Employee assessment consulting services",
    },
    {
      NAICS22: "541612",
      "INDEX ITEM DESCRIPTION": "Employee benefit consulting services",
    },
    {
      NAICS22: "541612",
      "INDEX ITEM DESCRIPTION": "Employee compensation consulting services",
    },
    {
      NAICS22: "541612",
      "INDEX ITEM DESCRIPTION": "Human resource consulting services",
    },
    {
      NAICS22: "541612",
      "INDEX ITEM DESCRIPTION": "Labor relations consulting services",
    },
    {
      NAICS22: "541612",
      "INDEX ITEM DESCRIPTION": "Organization development consulting services",
    },
    {
      NAICS22: "541612",
      "INDEX ITEM DESCRIPTION": "Personnel management consulting services",
    },
    {
      NAICS22: "541613",
      "INDEX ITEM DESCRIPTION": "Customer service management consulting services",
    },
    {
      NAICS22: "541613",
      "INDEX ITEM DESCRIPTION": "Marketing consulting services",
    },
    {
      NAICS22: "541613",
      "INDEX ITEM DESCRIPTION": "Marketing management consulting services",
    },
    {
      NAICS22: "541613",
      "INDEX ITEM DESCRIPTION": "New product development consulting services",
    },
    {
      NAICS22: "541613",
      "INDEX ITEM DESCRIPTION": "Sales management consulting services",
    },
    {
      NAICS22: "541614",
      "INDEX ITEM DESCRIPTION": "Customs consulting services",
    },
    {
      NAICS22: "541614",
      "INDEX ITEM DESCRIPTION":
        "Efficiency management (i.e., efficiency expert) consulting services",
    },
    {
      NAICS22: "541614",
      "INDEX ITEM DESCRIPTION": "Freight rate auditor services",
    },
    {
      NAICS22: "541614",
      "INDEX ITEM DESCRIPTION": "Freight rate consulting services",
    },
    {
      NAICS22: "541614",
      "INDEX ITEM DESCRIPTION": "Freight traffic consulting services",
    },
    {
      NAICS22: "541614",
      "INDEX ITEM DESCRIPTION":
        "Inventory planning and control management consulting services",
    },
    {
      NAICS22: "541614",
      "INDEX ITEM DESCRIPTION":
        "Logistics and integrated supply chain management consulting services",
    },
    {
      NAICS22: "541614",
      "INDEX ITEM DESCRIPTION": "Logistics management consulting services",
    },
    {
      NAICS22: "541614",
      "INDEX ITEM DESCRIPTION": "Manufacturing management consulting services",
    },
    {
      NAICS22: "541614",
      "INDEX ITEM DESCRIPTION":
        "Manufacturing operations improvement consulting services",
    },
    {
      NAICS22: "541614",
      "INDEX ITEM DESCRIPTION": "Materials management consulting services",
    },
    {
      NAICS22: "541614",
      "INDEX ITEM DESCRIPTION": "Operations research consulting services",
    },
    {
      NAICS22: "541614",
      "INDEX ITEM DESCRIPTION": "Physical distribution consulting services",
    },
    {
      NAICS22: "541614",
      "INDEX ITEM DESCRIPTION":
        "Production planning and control consulting services",
    },
    {
      NAICS22: "541614",
      "INDEX ITEM DESCRIPTION": "Productivity improvement consulting services",
    },
    {
      NAICS22: "541614",
      "INDEX ITEM DESCRIPTION": "Tariff rate consulting services",
    },
    {
      NAICS22: "541614",
      "INDEX ITEM DESCRIPTION": "Tariff rate information services",
    },
    {
      NAICS22: "541614",
      "INDEX ITEM DESCRIPTION": "Transportation management consulting services",
    },
    {
      NAICS22: "541618",
      "INDEX ITEM DESCRIPTION":
        "Telecommunications management consulting services",
    },
    {
      NAICS22: "541618",
      "INDEX ITEM DESCRIPTION": "Utilities management consulting services",
    },
    {
      NAICS22: "541620",
      "INDEX ITEM DESCRIPTION": "Ecological restoration consulting services",
    },
    {
      NAICS22: "541620",
      "INDEX ITEM DESCRIPTION": "Environmental consulting services",
    },
    {
      NAICS22: "541620",
      "INDEX ITEM DESCRIPTION": "Environmental reclamation planning services",
    },
    {
      NAICS22: "541620",
      "INDEX ITEM DESCRIPTION": "Sanitation consulting services",
    },
    {
      NAICS22: "541620",
      "INDEX ITEM DESCRIPTION": "Site remediation consulting services",
    },
    {
      NAICS22: "541620",
      "INDEX ITEM DESCRIPTION": "Wetland restoration planning services",
    },
    {
      NAICS22: "541690",
      "INDEX ITEM DESCRIPTION": "Agricultural consulting services",
    },
    {
      NAICS22: "541690",
      "INDEX ITEM DESCRIPTION": "Agrology consulting services",
    },
    {
      NAICS22: "541690",
      "INDEX ITEM DESCRIPTION": "Agronomy consulting services",
    },
    {
      NAICS22: "541690",
      "INDEX ITEM DESCRIPTION": "Biological consulting services",
    },
    {
      NAICS22: "541690",
      "INDEX ITEM DESCRIPTION": "Building envelope consulting services",
    },
    {
      NAICS22: "541690",
      "INDEX ITEM DESCRIPTION": "Chemical consulting services",
    },
    {
      NAICS22: "541690",
      "INDEX ITEM DESCRIPTION": "Dairy herd consulting services",
    },
    {
      NAICS22: "541690",
      "INDEX ITEM DESCRIPTION": "Economic consulting services",
    },
    {
      NAICS22: "541690",
      "INDEX ITEM DESCRIPTION": "Energy consulting services",
    },
    {
      NAICS22: "541690",
      "INDEX ITEM DESCRIPTION": "Entomology consulting services",
    },
    {
      NAICS22: "541690",
      "INDEX ITEM DESCRIPTION": "Geochemical consulting services",
    },
    {
      NAICS22: "541690",
      "INDEX ITEM DESCRIPTION": "Horticultural consulting services",
    },
    {
      NAICS22: "541690",
      "INDEX ITEM DESCRIPTION": "Hydrology consulting services",
    },
    {
      NAICS22: "541690",
      "INDEX ITEM DESCRIPTION": "Livestock breeding consulting services",
    },
    {
      NAICS22: "541690",
      "INDEX ITEM DESCRIPTION": "Motion picture consulting services",
    },
    {
      NAICS22: "541690",
      "INDEX ITEM DESCRIPTION": "Nuclear energy consulting services",
    },
    {
      NAICS22: "541690",
      "INDEX ITEM DESCRIPTION": "Physics consulting services",
    },
    {
      NAICS22: "541690",
      "INDEX ITEM DESCRIPTION": "Radio consulting services",
    },
    {
      NAICS22: "541690",
      "INDEX ITEM DESCRIPTION": "Roof consulting services",
    },
    {
      NAICS22: "541690",
      "INDEX ITEM DESCRIPTION": "Safety consulting services",
    },
    {
      NAICS22: "541690",
      "INDEX ITEM DESCRIPTION": "Security consulting services",
    },
    {
      NAICS22: "541690",
      "INDEX ITEM DESCRIPTION": "Veterinary consulting services",
    },
    {
      NAICS22: "541690",
      "INDEX ITEM DESCRIPTION": "Waterproof consulting services",
    },
    {
      NAICS22: "541713",
      "INDEX ITEM DESCRIPTION":
        "Nanobiotechnologies research and experimental development laboratories",
    },
    {
      NAICS22: "541713",
      "INDEX ITEM DESCRIPTION":
        "Nanotechnology research and development laboratories or services, all fields of science",
    },
    {
      NAICS22: "541714",
      "INDEX ITEM DESCRIPTION":
        "Biotechnology research and development laboratories or services (except nanobiotechnology research and development)",
    },
    {
      NAICS22: "541714",
      "INDEX ITEM DESCRIPTION":
        "Biotechnology research and development laboratories or services in agriculture (except nanobiotechnology research and development)",
    },
    {
      NAICS22: "541714",
      "INDEX ITEM DESCRIPTION":
        "Biotechnology research and development laboratories or services in bacteriology (except nanobiotechnology research and development)",
    },
    {
      NAICS22: "541714",
      "INDEX ITEM DESCRIPTION":
        "Biotechnology research and development laboratories or services in biology (except nanobiotechnology research and development)",
    },
    {
      NAICS22: "541714",
      "INDEX ITEM DESCRIPTION":
        "Biotechnology research and development laboratories or services in botany (except nanobiotechnology research and development)",
    },
    {
      NAICS22: "541714",
      "INDEX ITEM DESCRIPTION":
        "Biotechnology research and development laboratories or services in chemical sciences (except nanobiotechnology research and development)",
    },
    {
      NAICS22: "541714",
      "INDEX ITEM DESCRIPTION":
        "Biotechnology research and development laboratories or services in entomology (except nanobiotechnology research and development)",
    },
    {
      NAICS22: "541714",
      "INDEX ITEM DESCRIPTION":
        "Biotechnology research and development laboratories or services in environmental science (except nanobiotechnology research and development)",
    },
    {
      NAICS22: "541714",
      "INDEX ITEM DESCRIPTION":
        "Biotechnology research and development laboratories or services in food science (except nanobiotechnology research and development)",
    },
    {
      NAICS22: "541714",
      "INDEX ITEM DESCRIPTION":
        "Biotechnology research and development laboratories or services in genetics (except nanobiotechnology research and development)",
    },
    {
      NAICS22: "541714",
      "INDEX ITEM DESCRIPTION":
        "Biotechnology research and development laboratories or services in health sciences (except nanobiotechnology research and development)",
    },
    {
      NAICS22: "541714",
      "INDEX ITEM DESCRIPTION":
        "Biotechnology research and development laboratories or services in industrial research (except nanobiotechnology research and development)",
    },
    {
      NAICS22: "541714",
      "INDEX ITEM DESCRIPTION":
        "Biotechnology research and development laboratories or services in the medical sciences (except nanobiotechnology research and development)",
    },
    {
      NAICS22: "541714",
      "INDEX ITEM DESCRIPTION":
        "Biotechnology research and development laboratories or services in the physical sciences (except nanobiotechnology research and development)",
    },
    {
      NAICS22: "541714",
      "INDEX ITEM DESCRIPTION":
        "Biotechnology research and development laboratories or services in the veterinary sciences (except nanobiotechnology research and development)",
    },
    {
      NAICS22: "541714",
      "INDEX ITEM DESCRIPTION":
        "Cloning research and experimental development laboratories ",
    },
    {
      NAICS22: "541714",
      "INDEX ITEM DESCRIPTION":
        "DNA technologies (e.g., microarrays) research and experimental development laboratories ",
    },
    {
      NAICS22: "541714",
      "INDEX ITEM DESCRIPTION":
        "Nucleic acid chemistry research and experimental development laboratories ",
    },
    {
      NAICS22: "541714",
      "INDEX ITEM DESCRIPTION":
        "Protein engineering research and experimental development laboratories ",
    },
    {
      NAICS22: "541714",
      "INDEX ITEM DESCRIPTION":
        "Recombinant DNA research and experimental development laboratories",
    },
    {
      NAICS22: "541715",
      "INDEX ITEM DESCRIPTION":
        "Aerospace research and development (except prototype production)",
    },
    {
      NAICS22: "541715",
      "INDEX ITEM DESCRIPTION":
        "Agriculture research and development laboratories or services (except biotechnology and nanotechnology research and development)",
    },
    {
      NAICS22: "541715",
      "INDEX ITEM DESCRIPTION":
        "Artificial intelligence research and development laboratories or services",
    },
    {
      NAICS22: "541715",
      "INDEX ITEM DESCRIPTION":
        "Bacteriological research and development laboratories or services (except biotechnology and nanotechnology research and development)",
    },
    {
      NAICS22: "541715",
      "INDEX ITEM DESCRIPTION":
        "Biology research and development laboratories or services (except biotechnology and nanotechnology research and development)",
    },
    {
      NAICS22: "541715",
      "INDEX ITEM DESCRIPTION":
        "Botany research and development laboratories or services (except biotechnology and nanotechnology research and development)",
    },
    {
      NAICS22: "541715",
      "INDEX ITEM DESCRIPTION":
        "Chemical research and development laboratories or services (except biotechnology and nanotechnology research and development)",
    },
    {
      NAICS22: "541715",
      "INDEX ITEM DESCRIPTION":
        "Computer and related hardware research and development laboratories or services (except nanotechnology research and development)",
    },
    {
      NAICS22: "541715",
      "INDEX ITEM DESCRIPTION":
        "Dental research and development laboratories or services",
    },
    {
      NAICS22: "541715",
      "INDEX ITEM DESCRIPTION":
        "Electronic research and development laboratories or services (except nanotechnology research and development)",
    },
    {
      NAICS22: "541715",
      "INDEX ITEM DESCRIPTION":
        "Engineering research and development laboratories or services (except nanotechnology research and development)",
    },
    {
      NAICS22: "541715",
      "INDEX ITEM DESCRIPTION":
        "Entomological research and development laboratories or services (except biotechnology and nanotechnology research and development)",
    },
    {
      NAICS22: "541715",
      "INDEX ITEM DESCRIPTION":
        "Environmental research and development laboratories or services (except biotechnology and nanotechnology research and development)",
    },
    {
      NAICS22: "541715",
      "INDEX ITEM DESCRIPTION": "Experimental farms",
    },
    {
      NAICS22: "541715",
      "INDEX ITEM DESCRIPTION":
        "Fisheries research and development laboratories or services",
    },
    {
      NAICS22: "541715",
      "INDEX ITEM DESCRIPTION":
        "Food research and development laboratories or services (except biotechnology and nanotechnology research and development)",
    },
    {
      NAICS22: "541715",
      "INDEX ITEM DESCRIPTION":
        "Forestry research and development laboratories or services",
    },
    {
      NAICS22: "541715",
      "INDEX ITEM DESCRIPTION":
        "Genetics research and development laboratories or services (except biotechnology and nanotechnology research and development)",
    },
    {
      NAICS22: "541715",
      "INDEX ITEM DESCRIPTION":
        "Geological research and development laboratories or services (except nanotechnology research and development)",
    },
    {
      NAICS22: "541715",
      "INDEX ITEM DESCRIPTION":
        "Guided missile and space vehicle engine research and development",
    },
    {
      NAICS22: "541715",
      "INDEX ITEM DESCRIPTION":
        "Guided missile and space vehicle parts (except engines) research and development",
    },
    {
      NAICS22: "541715",
      "INDEX ITEM DESCRIPTION":
        "Health research and development laboratories or services (except biotechnology and nanotechnology research and development)",
    },
    {
      NAICS22: "541715",
      "INDEX ITEM DESCRIPTION":
        "Industrial research and development laboratories or services (except biotechnology and nanotechnology research and development)",
    },
    {
      NAICS22: "541715",
      "INDEX ITEM DESCRIPTION":
        "Life sciences research and development laboratories or services (except biotechnology and nanotechnology research and development)",
    },
    {
      NAICS22: "541715",
      "INDEX ITEM DESCRIPTION":
        "Mathematics research and development laboratories or services",
    },
    {
      NAICS22: "541715",
      "INDEX ITEM DESCRIPTION":
        "Medical research and development laboratories or services (except biotechnology and nanotechnology research and development)",
    },
    {
      NAICS22: "541715",
      "INDEX ITEM DESCRIPTION": "Observatories, research institutions",
    },
    {
      NAICS22: "541715",
      "INDEX ITEM DESCRIPTION":
        "Oceanographic research and development laboratories or services",
    },
    {
      NAICS22: "541715",
      "INDEX ITEM DESCRIPTION":
        "Photonics research and development services (except nanotechnology research and development)",
    },
    {
      NAICS22: "541715",
      "INDEX ITEM DESCRIPTION":
        "Physical science research and development laboratories or services (except biotechnology and nanotechnology research and development)",
    },
    {
      NAICS22: "541715",
      "INDEX ITEM DESCRIPTION":
        "Physics research and development laboratories or services (except nanotechnology research and development)",
    },
    {
      NAICS22: "541715",
      "INDEX ITEM DESCRIPTION":
        "Robotics research and development laboratories or services",
    },
    {
      NAICS22: "541715",
      "INDEX ITEM DESCRIPTION":
        "Veterinary research and development laboratories or services (except biotechnology and nanotechnology research and development)",
    },
    {
      NAICS22: "541720",
      "INDEX ITEM DESCRIPTION": "Archeological research and development services",
    },
    {
      NAICS22: "541720",
      "INDEX ITEM DESCRIPTION": "Behavioral research and development services",
    },
    {
      NAICS22: "541720",
      "INDEX ITEM DESCRIPTION": "Business research and development services",
    },
    {
      NAICS22: "541720",
      "INDEX ITEM DESCRIPTION": "Cognitive research and development services",
    },
    {
      NAICS22: "541720",
      "INDEX ITEM DESCRIPTION": "Demographic research and development services",
    },
    {
      NAICS22: "541720",
      "INDEX ITEM DESCRIPTION": "Economic research and development services",
    },
    {
      NAICS22: "541720",
      "INDEX ITEM DESCRIPTION":
        "Historic and cultural preservation research and development services",
    },
    {
      NAICS22: "541720",
      "INDEX ITEM DESCRIPTION": "Humanities research and development services",
    },
    {
      NAICS22: "541720",
      "INDEX ITEM DESCRIPTION": "Language research and development services",
    },
    {
      NAICS22: "541720",
      "INDEX ITEM DESCRIPTION":
        "Learning disabilities research and development services",
    },
    {
      NAICS22: "541720",
      "INDEX ITEM DESCRIPTION": "Psychology research and development services",
    },
    {
      NAICS22: "541720",
      "INDEX ITEM DESCRIPTION":
        "Social science research and development services",
    },
    {
      NAICS22: "541720",
      "INDEX ITEM DESCRIPTION": "Sociological research and development services",
    },
    {
      NAICS22: "541720",
      "INDEX ITEM DESCRIPTION": "Sociology research and development services",
    },
    {
      NAICS22: "541810",
      "INDEX ITEM DESCRIPTION": "Advertising agencies",
    },
    {
      NAICS22: "541810",
      "INDEX ITEM DESCRIPTION": "Advertising agency consulting services",
    },
    {
      NAICS22: "541810",
      "INDEX ITEM DESCRIPTION": "Digital advertising agencies",
    },
    {
      NAICS22: "541810",
      "INDEX ITEM DESCRIPTION": "Internet advertising agencies",
    },
    {
      NAICS22: "541810",
      "INDEX ITEM DESCRIPTION": "Online advertising agencies",
    },
    {
      NAICS22: "541820",
      "INDEX ITEM DESCRIPTION": "Lobbying services",
    },
    {
      NAICS22: "541820",
      "INDEX ITEM DESCRIPTION": "Lobbyists' offices",
    },
    {
      NAICS22: "541820",
      "INDEX ITEM DESCRIPTION": "Political consulting services",
    },
    {
      NAICS22: "541820",
      "INDEX ITEM DESCRIPTION": "Public relations agencies",
    },
    {
      NAICS22: "541820",
      "INDEX ITEM DESCRIPTION": "Public relations consulting services",
    },
    {
      NAICS22: "541820",
      "INDEX ITEM DESCRIPTION": "Public relations services",
    },
    {
      NAICS22: "541830",
      "INDEX ITEM DESCRIPTION": "Media buying agencies",
    },
    {
      NAICS22: "541830",
      "INDEX ITEM DESCRIPTION": "Media buying services",
    },
    {
      NAICS22: "541840",
      "INDEX ITEM DESCRIPTION":
        "Advertising media representatives (i.e., independent of media owners)",
    },
    {
      NAICS22: "541840",
      "INDEX ITEM DESCRIPTION":
        "Magazine advertising representatives (i.e., independent of media owners)",
    },
    {
      NAICS22: "541840",
      "INDEX ITEM DESCRIPTION":
        "Media advertising representatives (i.e., independent of media owners)",
    },
    {
      NAICS22: "541840",
      "INDEX ITEM DESCRIPTION":
        "Media representatives (i.e., independent of media owners)",
    },
    {
      NAICS22: "541840",
      "INDEX ITEM DESCRIPTION":
        "Newspaper advertising representatives (i.e., independent of media owners)",
    },
    {
      NAICS22: "541840",
      "INDEX ITEM DESCRIPTION":
        "Publishers' advertising representatives (i.e., independent of media owners)",
    },
    {
      NAICS22: "541840",
      "INDEX ITEM DESCRIPTION":
        "Radio advertising representatives (i.e., independent of media owners)",
    },
    {
      NAICS22: "541840",
      "INDEX ITEM DESCRIPTION":
        "Television advertising representatives (i.e., independent of media owners)",
    },
    {
      NAICS22: "541850",
      "INDEX ITEM DESCRIPTION": "Advertising services, indoor or outdoor display",
    },
    {
      NAICS22: "541850",
      "INDEX ITEM DESCRIPTION": "Advertising, aerial",
    },
    {
      NAICS22: "541850",
      "INDEX ITEM DESCRIPTION": "Billboard display advertising services",
    },
    {
      NAICS22: "541850",
      "INDEX ITEM DESCRIPTION": "Bus card advertising services",
    },
    {
      NAICS22: "541850",
      "INDEX ITEM DESCRIPTION": "Bus display advertising services",
    },
    {
      NAICS22: "541850",
      "INDEX ITEM DESCRIPTION": "Indoor display advertising services",
    },
    {
      NAICS22: "541850",
      "INDEX ITEM DESCRIPTION": "Outdoor display advertising services",
    },
    {
      NAICS22: "541850",
      "INDEX ITEM DESCRIPTION":
        "Out-of-home media (i.e., display) advertising services",
    },
    {
      NAICS22: "541850",
      "INDEX ITEM DESCRIPTION": "Store display advertising services",
    },
    {
      NAICS22: "541850",
      "INDEX ITEM DESCRIPTION": "Subway card display advertising services",
    },
    {
      NAICS22: "541850",
      "INDEX ITEM DESCRIPTION": "Taxicab card advertising services",
    },
    {
      NAICS22: "541850",
      "INDEX ITEM DESCRIPTION": "Transit advertising services",
    },
    {
      NAICS22: "541860",
      "INDEX ITEM DESCRIPTION":
        "Advertising material preparation services for mailing or other direct distribution",
    },
    {
      NAICS22: "541860",
      "INDEX ITEM DESCRIPTION": "Direct mail advertising services",
    },
    {
      NAICS22: "541860",
      "INDEX ITEM DESCRIPTION":
        "Direct mail or other direct distribution advertising campaign services",
    },
    {
      NAICS22: "541870",
      "INDEX ITEM DESCRIPTION":
        "Advertising material (e.g., coupons, flyers, samples) direct distribution services",
    },
    {
      NAICS22: "541870",
      "INDEX ITEM DESCRIPTION": "Circular direct distribution services",
    },
    {
      NAICS22: "541870",
      "INDEX ITEM DESCRIPTION": "Coupon direct distribution services",
    },
    {
      NAICS22: "541870",
      "INDEX ITEM DESCRIPTION":
        "Directory, telephone, distribution on a contract basis",
    },
    {
      NAICS22: "541870",
      "INDEX ITEM DESCRIPTION":
        "Door-to-door distribution of advertising materials (e.g., coupons, flyers, samples)",
    },
    {
      NAICS22: "541870",
      "INDEX ITEM DESCRIPTION":
        "Flyer direct distribution (except direct mail) services",
    },
    {
      NAICS22: "541870",
      "INDEX ITEM DESCRIPTION": "Handbill direct distribution services",
    },
    {
      NAICS22: "541870",
      "INDEX ITEM DESCRIPTION": "Sample direct distribution services",
    },
    {
      NAICS22: "541870",
      "INDEX ITEM DESCRIPTION":
        "Telephone directory distribution services, door-to-door",
    },
    {
      NAICS22: "541890",
      "INDEX ITEM DESCRIPTION":
        "Advertising specialty (e.g., keychain, magnet, pen) distribution services",
    },
    {
      NAICS22: "541890",
      "INDEX ITEM DESCRIPTION": "Demonstration services, merchandise",
    },
    {
      NAICS22: "541890",
      "INDEX ITEM DESCRIPTION": "Display lettering services",
    },
    {
      NAICS22: "541890",
      "INDEX ITEM DESCRIPTION": "Mannequin decorating services",
    },
    {
      NAICS22: "541890",
      "INDEX ITEM DESCRIPTION": "Sign lettering and painting services",
    },
    {
      NAICS22: "541890",
      "INDEX ITEM DESCRIPTION": "Welcoming services (i.e., advertising services)",
    },
    {
      NAICS22: "541890",
      "INDEX ITEM DESCRIPTION": "Window dressing or trimming services, store",
    },
    {
      NAICS22: "541910",
      "INDEX ITEM DESCRIPTION": "Broadcast media rating services",
    },
    {
      NAICS22: "541910",
      "INDEX ITEM DESCRIPTION": "Internet media audience research services",
    },
    {
      NAICS22: "541910",
      "INDEX ITEM DESCRIPTION": "Internet traffic monitoring research services",
    },
    {
      NAICS22: "541910",
      "INDEX ITEM DESCRIPTION": "Marketing analysis services",
    },
    {
      NAICS22: "541910",
      "INDEX ITEM DESCRIPTION": "Marketing research services",
    },
    {
      NAICS22: "541910",
      "INDEX ITEM DESCRIPTION": "Opinion research services",
    },
    {
      NAICS22: "541910",
      "INDEX ITEM DESCRIPTION": "Political opinion polling services",
    },
    {
      NAICS22: "541910",
      "INDEX ITEM DESCRIPTION": "Public opinion polling services",
    },
    {
      NAICS22: "541910",
      "INDEX ITEM DESCRIPTION": "Public opinion research services",
    },
    {
      NAICS22: "541910",
      "INDEX ITEM DESCRIPTION": "Sampling services, statistical",
    },
    {
      NAICS22: "541921",
      "INDEX ITEM DESCRIPTION": "Passport photography services",
    },
    {
      NAICS22: "541921",
      "INDEX ITEM DESCRIPTION":
        "Photography services, portrait (e.g., still, video)",
    },
    {
      NAICS22: "541921",
      "INDEX ITEM DESCRIPTION": "Photography studios, portrait",
    },
    {
      NAICS22: "541921",
      "INDEX ITEM DESCRIPTION": "Portrait photography services",
    },
    {
      NAICS22: "541921",
      "INDEX ITEM DESCRIPTION": "Portrait photography studios",
    },
    {
      NAICS22: "541921",
      "INDEX ITEM DESCRIPTION":
        "School photography (i.e., portrait photography) services",
    },
    {
      NAICS22: "541921",
      "INDEX ITEM DESCRIPTION": "Video photography services, portrait",
    },
    {
      NAICS22: "541921",
      "INDEX ITEM DESCRIPTION":
        "Video taping services, special events (e.g., birthdays, weddings)",
    },
    {
      NAICS22: "541921",
      "INDEX ITEM DESCRIPTION": "Wedding photography services",
    },
    {
      NAICS22: "541922",
      "INDEX ITEM DESCRIPTION": "Commercial event videography services",
    },
    {
      NAICS22: "541922",
      "INDEX ITEM DESCRIPTION": "Commercial photography services",
    },
    {
      NAICS22: "541922",
      "INDEX ITEM DESCRIPTION": "Medical photography services",
    },
    {
      NAICS22: "541922",
      "INDEX ITEM DESCRIPTION":
        "Photographers specializing in aerial photography",
    },
    {
      NAICS22: "541922",
      "INDEX ITEM DESCRIPTION": "Photography services, commercial",
    },
    {
      NAICS22: "541922",
      "INDEX ITEM DESCRIPTION": "Photography studios, commercial",
    },
    {
      NAICS22: "541922",
      "INDEX ITEM DESCRIPTION": "Video taping services for legal depositions",
    },
    {
      NAICS22: "541930",
      "INDEX ITEM DESCRIPTION": "Interpretation services, language",
    },
    {
      NAICS22: "541930",
      "INDEX ITEM DESCRIPTION": "Language interpretation services",
    },
    {
      NAICS22: "541930",
      "INDEX ITEM DESCRIPTION":
        "Language services (e.g., interpretation, sign, translation)",
    },
    {
      NAICS22: "541930",
      "INDEX ITEM DESCRIPTION": "Language translation services",
    },
    {
      NAICS22: "541930",
      "INDEX ITEM DESCRIPTION": "Sign language services",
    },
    {
      NAICS22: "541930",
      "INDEX ITEM DESCRIPTION": "Speech (i.e., language) interpretation services",
    },
    {
      NAICS22: "541930",
      "INDEX ITEM DESCRIPTION": "Translation services, language",
    },
    {
      NAICS22: "541940",
      "INDEX ITEM DESCRIPTION": "Animal hospitals",
    },
    {
      NAICS22: "541940",
      "INDEX ITEM DESCRIPTION": "Disease testing services, veterinary",
    },
    {
      NAICS22: "541940",
      "INDEX ITEM DESCRIPTION": "Hospitals, animal",
    },
    {
      NAICS22: "541940",
      "INDEX ITEM DESCRIPTION": "Internists' offices, veterinary",
    },
    {
      NAICS22: "541940",
      "INDEX ITEM DESCRIPTION": "Laboratory testing services, veterinary",
    },
    {
      NAICS22: "541940",
      "INDEX ITEM DESCRIPTION":
        "Livestock inspecting and testing services, veterinary",
    },
    {
      NAICS22: "541940",
      "INDEX ITEM DESCRIPTION": "Livestock veterinary services",
    },
    {
      NAICS22: "541940",
      "INDEX ITEM DESCRIPTION": "Pet hospitals",
    },
    {
      NAICS22: "541940",
      "INDEX ITEM DESCRIPTION": "Small animal veterinary services",
    },
    {
      NAICS22: "541940",
      "INDEX ITEM DESCRIPTION": "Surgeons' offices, veterinary",
    },
    {
      NAICS22: "541940",
      "INDEX ITEM DESCRIPTION": "Surgery services, veterinary",
    },
    {
      NAICS22: "541940",
      "INDEX ITEM DESCRIPTION": "Testing laboratories, veterinary",
    },
    {
      NAICS22: "541940",
      "INDEX ITEM DESCRIPTION": "Testing services for veterinarians",
    },
    {
      NAICS22: "541940",
      "INDEX ITEM DESCRIPTION": "Vaccination services, veterinary",
    },
    {
      NAICS22: "541940",
      "INDEX ITEM DESCRIPTION": "Veterinarians' offices",
    },
    {
      NAICS22: "541940",
      "INDEX ITEM DESCRIPTION": "Veterinarians' practices",
    },
    {
      NAICS22: "541940",
      "INDEX ITEM DESCRIPTION": "Veterinary clinics",
    },
    {
      NAICS22: "541940",
      "INDEX ITEM DESCRIPTION": "Veterinary services",
    },
    {
      NAICS22: "541940",
      "INDEX ITEM DESCRIPTION": "Veterinary services, livestock",
    },
    {
      NAICS22: "541940",
      "INDEX ITEM DESCRIPTION":
        "Veterinary services, pets and other animal specialties",
    },
    {
      NAICS22: "541940",
      "INDEX ITEM DESCRIPTION": "Veterinary testing laboratories",
    },
    {
      NAICS22: "541990",
      "INDEX ITEM DESCRIPTION": "Appraisal (except real estate) services",
    },
    {
      NAICS22: "541990",
      "INDEX ITEM DESCRIPTION":
        "Arbitration and conciliation services (except by attorney, paralegal)",
    },
    {
      NAICS22: "541990",
      "INDEX ITEM DESCRIPTION": "Business brokers (except real estate brokers)",
    },
    {
      NAICS22: "541990",
      "INDEX ITEM DESCRIPTION": "Commodity inspection services",
    },
    {
      NAICS22: "541990",
      "INDEX ITEM DESCRIPTION": "Construction estimation services",
    },
    {
      NAICS22: "541990",
      "INDEX ITEM DESCRIPTION": "Consumer credit counseling services",
    },
    {
      NAICS22: "541990",
      "INDEX ITEM DESCRIPTION":
        "Credit repair (i.e., counseling) services, consumer",
    },
    {
      NAICS22: "541990",
      "INDEX ITEM DESCRIPTION":
        "Electronic communication content verification services ",
    },
    {
      NAICS22: "541990",
      "INDEX ITEM DESCRIPTION": "Estate assessment (i.e., appraisal) services",
    },
    {
      NAICS22: "541990",
      "INDEX ITEM DESCRIPTION":
        "Fire extinguisher testing and/or inspection, without sales, service, or installation",
    },
    {
      NAICS22: "541990",
      "INDEX ITEM DESCRIPTION": "Handwriting analysis services",
    },
    {
      NAICS22: "541990",
      "INDEX ITEM DESCRIPTION": "Handwriting expert services",
    },
    {
      NAICS22: "541990",
      "INDEX ITEM DESCRIPTION": "Marine forecasting services",
    },
    {
      NAICS22: "541990",
      "INDEX ITEM DESCRIPTION": "Marine surveyor (i.e., ship appraiser) services",
    },
    {
      NAICS22: "541990",
      "INDEX ITEM DESCRIPTION":
        "Mediation product services (except by lawyer, attorney, paralegal offices, family and social services)",
    },
    {
      NAICS22: "541990",
      "INDEX ITEM DESCRIPTION": "Meteorological services",
    },
    {
      NAICS22: "541990",
      "INDEX ITEM DESCRIPTION":
        "Patent broker services (i.e., patent marketing services)",
    },
    {
      NAICS22: "541990",
      "INDEX ITEM DESCRIPTION":
        "Patrolling (i.e., visual inspection) of electric transmission or gas lines",
    },
    {
      NAICS22: "541990",
      "INDEX ITEM DESCRIPTION": "Pipeline inspection (i.e., visual) services",
    },
    {
      NAICS22: "541990",
      "INDEX ITEM DESCRIPTION": "Power line inspection (i.e., visual) services",
    },
    {
      NAICS22: "541990",
      "INDEX ITEM DESCRIPTION": "Quantity surveyor services",
    },
    {
      NAICS22: "541990",
      "INDEX ITEM DESCRIPTION":
        "Waterless fire suppression system testing and/or inspection, without sales, service, or installation",
    },
    {
      NAICS22: "541990",
      "INDEX ITEM DESCRIPTION": "Weather forecasting services",
    },
    {
      NAICS22: "551111",
      "INDEX ITEM DESCRIPTION": "Bank holding companies (except managing)",
    },
    {
      NAICS22: "551111",
      "INDEX ITEM DESCRIPTION": "Holding companies, bank (except managing)",
    },
    {
      NAICS22: "551111",
      "INDEX ITEM DESCRIPTION": "Offices of bank holding companies",
    },
    {
      NAICS22: "551112",
      "INDEX ITEM DESCRIPTION":
        "Agreement corporation (except international trade financing)",
    },
    {
      NAICS22: "551112",
      "INDEX ITEM DESCRIPTION": "Financial holding companies",
    },
    {
      NAICS22: "551112",
      "INDEX ITEM DESCRIPTION": "Holding companies (except bank, managing)",
    },
    {
      NAICS22: "551112",
      "INDEX ITEM DESCRIPTION": "Insurance holding companies",
    },
    {
      NAICS22: "551112",
      "INDEX ITEM DESCRIPTION": "Nonbank holding companies (except managing)",
    },
    {
      NAICS22: "551112",
      "INDEX ITEM DESCRIPTION": "Personal holding companies",
    },
    {
      NAICS22: "551112",
      "INDEX ITEM DESCRIPTION": "Public utility holding companies",
    },
    {
      NAICS22: "551112",
      "INDEX ITEM DESCRIPTION": "Railroad holding companies",
    },
    {
      NAICS22: "551112",
      "INDEX ITEM DESCRIPTION": "Savings and loan holding companies",
    },
    {
      NAICS22: "551112",
      "INDEX ITEM DESCRIPTION": "Thrift holding companies",
    },
    {
      NAICS22: "551114",
      "INDEX ITEM DESCRIPTION": "Centralized administrative offices",
    },
    {
      NAICS22: "551114",
      "INDEX ITEM DESCRIPTION": "Corporate offices",
    },
    {
      NAICS22: "551114",
      "INDEX ITEM DESCRIPTION": "District and regional offices",
    },
    {
      NAICS22: "551114",
      "INDEX ITEM DESCRIPTION": "Head offices",
    },
    {
      NAICS22: "551114",
      "INDEX ITEM DESCRIPTION": "Headquarters offices",
    },
    {
      NAICS22: "551114",
      "INDEX ITEM DESCRIPTION": "Holding companies that manage",
    },
    {
      NAICS22: "551114",
      "INDEX ITEM DESCRIPTION": "Subsidiary management offices",
    },
    {
      NAICS22: "561110",
      "INDEX ITEM DESCRIPTION": "Administrative management services",
    },
    {
      NAICS22: "561110",
      "INDEX ITEM DESCRIPTION": "Business management services",
    },
    {
      NAICS22: "561110",
      "INDEX ITEM DESCRIPTION": "Executive management services",
    },
    {
      NAICS22: "561110",
      "INDEX ITEM DESCRIPTION":
        "Hotel management services (except complete operation of client's business)",
    },
    {
      NAICS22: "561110",
      "INDEX ITEM DESCRIPTION": "Industrial management services",
    },
    {
      NAICS22: "561110",
      "INDEX ITEM DESCRIPTION":
        "Management services (except complete operation of client's business)",
    },
    {
      NAICS22: "561110",
      "INDEX ITEM DESCRIPTION": "Managing offices of dentists",
    },
    {
      NAICS22: "561110",
      "INDEX ITEM DESCRIPTION": "Managing offices of physicians and surgeons",
    },
    {
      NAICS22: "561110",
      "INDEX ITEM DESCRIPTION":
        "Managing offices of professionals (e.g., dentists, physicians, surgeons)",
    },
    {
      NAICS22: "561110",
      "INDEX ITEM DESCRIPTION": "Medical office management services",
    },
    {
      NAICS22: "561110",
      "INDEX ITEM DESCRIPTION":
        "Motel management services (except complete operation of client's business)",
    },
    {
      NAICS22: "561110",
      "INDEX ITEM DESCRIPTION": "Office administration services",
    },
    {
      NAICS22: "561110",
      "INDEX ITEM DESCRIPTION": "Office management services",
    },
    {
      NAICS22: "561210",
      "INDEX ITEM DESCRIPTION": "Base facilities operation support services",
    },
    {
      NAICS22: "561210",
      "INDEX ITEM DESCRIPTION": "Correctional facilities, privately operated",
    },
    {
      NAICS22: "561210",
      "INDEX ITEM DESCRIPTION":
        "Correctional facility operation on a contract or fee basis",
    },
    {
      NAICS22: "561210",
      "INDEX ITEM DESCRIPTION":
        "Facilities (except computer operation) support services",
    },
    {
      NAICS22: "561210",
      "INDEX ITEM DESCRIPTION":
        "Government base facilities operation support services",
    },
    {
      NAICS22: "561210",
      "INDEX ITEM DESCRIPTION": "Jail operation on a contract or fee basis",
    },
    {
      NAICS22: "561210",
      "INDEX ITEM DESCRIPTION": "Jails, privately operated",
    },
    {
      NAICS22: "561210",
      "INDEX ITEM DESCRIPTION": "Military base support services",
    },
    {
      NAICS22: "561210",
      "INDEX ITEM DESCRIPTION": "Prison operation on a contract or fee basis",
    },
    {
      NAICS22: "561210",
      "INDEX ITEM DESCRIPTION": "Prisons, privately operated",
    },
    {
      NAICS22: "561311",
      "INDEX ITEM DESCRIPTION": "Babysitting bureaus (i.e., registries)",
    },
    {
      NAICS22: "561311",
      "INDEX ITEM DESCRIPTION":
        "Casting agencies (i.e., motion picture, theatrical, video)",
    },
    {
      NAICS22: "561311",
      "INDEX ITEM DESCRIPTION": "Casting agencies, motion picture or video",
    },
    {
      NAICS22: "561311",
      "INDEX ITEM DESCRIPTION": "Casting agencies, theatrical",
    },
    {
      NAICS22: "561311",
      "INDEX ITEM DESCRIPTION":
        "Casting bureaus (e.g., motion picture, theatrical, video)",
    },
    {
      NAICS22: "561311",
      "INDEX ITEM DESCRIPTION": "Casting bureaus, motion picture or video",
    },
    {
      NAICS22: "561311",
      "INDEX ITEM DESCRIPTION": "Casting bureaus, theatrical",
    },
    {
      NAICS22: "561311",
      "INDEX ITEM DESCRIPTION": "Chauffeur registries",
    },
    {
      NAICS22: "561311",
      "INDEX ITEM DESCRIPTION": "Employee recruitment services (non-executive)",
    },
    {
      NAICS22: "561311",
      "INDEX ITEM DESCRIPTION": "Employment agencies",
    },
    {
      NAICS22: "561311",
      "INDEX ITEM DESCRIPTION": "Employment agencies, motion picture or video",
    },
    {
      NAICS22: "561311",
      "INDEX ITEM DESCRIPTION": "Employment agencies, radio or television",
    },
    {
      NAICS22: "561311",
      "INDEX ITEM DESCRIPTION": "Employment agencies, theatrical",
    },
    {
      NAICS22: "561311",
      "INDEX ITEM DESCRIPTION": "Employment placement agencies or services",
    },
    {
      NAICS22: "561311",
      "INDEX ITEM DESCRIPTION": "Employment referral agencies or services",
    },
    {
      NAICS22: "561311",
      "INDEX ITEM DESCRIPTION": "Employment registries",
    },
    {
      NAICS22: "561311",
      "INDEX ITEM DESCRIPTION":
        "Internet job listing services, including intermediary platform services",
    },
    {
      NAICS22: "561311",
      "INDEX ITEM DESCRIPTION":
        "Internet resume listing services, including intermediary platform services",
    },
    {
      NAICS22: "561311",
      "INDEX ITEM DESCRIPTION": "Maid registries",
    },
    {
      NAICS22: "561311",
      "INDEX ITEM DESCRIPTION": "Model registries",
    },
    {
      NAICS22: "561311",
      "INDEX ITEM DESCRIPTION": "Nurse registries",
    },
    {
      NAICS22: "561311",
      "INDEX ITEM DESCRIPTION":
        "Online employment registries or listing services, including intermediary platform services",
    },
    {
      NAICS22: "561311",
      "INDEX ITEM DESCRIPTION": "Placement agencies or services, employment",
    },
    {
      NAICS22: "561311",
      "INDEX ITEM DESCRIPTION": "Referral agencies or services, employment",
    },
    {
      NAICS22: "561311",
      "INDEX ITEM DESCRIPTION": "Registries, employment",
    },
    {
      NAICS22: "561311",
      "INDEX ITEM DESCRIPTION": "Registries, teacher",
    },
    {
      NAICS22: "561311",
      "INDEX ITEM DESCRIPTION": "Ship crew employment agencies",
    },
    {
      NAICS22: "561311",
      "INDEX ITEM DESCRIPTION": "Ship crew registries",
    },
    {
      NAICS22: "561311",
      "INDEX ITEM DESCRIPTION": "State operated employment job services offices",
    },
    {
      NAICS22: "561311",
      "INDEX ITEM DESCRIPTION": "Teacher registries",
    },
    {
      NAICS22: "561311",
      "INDEX ITEM DESCRIPTION": "Television employment agencies",
    },
    {
      NAICS22: "561311",
      "INDEX ITEM DESCRIPTION": "Theatrical employment agencies",
    },
    {
      NAICS22: "561312",
      "INDEX ITEM DESCRIPTION": "Executive placement consulting services",
    },
    {
      NAICS22: "561312",
      "INDEX ITEM DESCRIPTION": "Executive placement services",
    },
    {
      NAICS22: "561312",
      "INDEX ITEM DESCRIPTION": "Executive search consulting services",
    },
    {
      NAICS22: "561312",
      "INDEX ITEM DESCRIPTION": "Executive search services",
    },
    {
      NAICS22: "561312",
      "INDEX ITEM DESCRIPTION": "Senior executive search services",
    },
    {
      NAICS22: "561320",
      "INDEX ITEM DESCRIPTION": "Construction labor supply services",
    },
    {
      NAICS22: "561320",
      "INDEX ITEM DESCRIPTION": "Contract staffing services",
    },
    {
      NAICS22: "561320",
      "INDEX ITEM DESCRIPTION": "Help supply services",
    },
    {
      NAICS22: "561320",
      "INDEX ITEM DESCRIPTION":
        "Labor (except farm) contractors (i.e., personnel suppliers)",
    },
    {
      NAICS22: "561320",
      "INDEX ITEM DESCRIPTION": "Labor (except farm) pools",
    },
    {
      NAICS22: "561320",
      "INDEX ITEM DESCRIPTION": "Manpower pools",
    },
    {
      NAICS22: "561320",
      "INDEX ITEM DESCRIPTION": "Model supply services",
    },
    {
      NAICS22: "561320",
      "INDEX ITEM DESCRIPTION": "Office help supply services",
    },
    {
      NAICS22: "561320",
      "INDEX ITEM DESCRIPTION": "Office supply pools",
    },
    {
      NAICS22: "561320",
      "INDEX ITEM DESCRIPTION":
        "Online temporary staffing services, including intermediary platform services",
    },
    {
      NAICS22: "561320",
      "INDEX ITEM DESCRIPTION": "Outplacement consulting services",
    },
    {
      NAICS22: "561320",
      "INDEX ITEM DESCRIPTION": "Outplacement services",
    },
    {
      NAICS22: "561320",
      "INDEX ITEM DESCRIPTION":
        "Personnel (e.g., industrial, office, health care, legal, construction) suppliers",
    },
    {
      NAICS22: "561320",
      "INDEX ITEM DESCRIPTION": "Temporary employment services",
    },
    {
      NAICS22: "561320",
      "INDEX ITEM DESCRIPTION": "Temporary help services",
    },
    {
      NAICS22: "561320",
      "INDEX ITEM DESCRIPTION": "Temporary staffing services",
    },
    {
      NAICS22: "561330",
      "INDEX ITEM DESCRIPTION": "Co-employment staffing services",
    },
    {
      NAICS22: "561330",
      "INDEX ITEM DESCRIPTION": "Employee leasing services",
    },
    {
      NAICS22: "561330",
      "INDEX ITEM DESCRIPTION": "Labor leasing services",
    },
    {
      NAICS22: "561330",
      "INDEX ITEM DESCRIPTION": "PEO (professional employer organizations)",
    },
    {
      NAICS22: "561330",
      "INDEX ITEM DESCRIPTION": "Professional employer organizations (PEO)",
    },
    {
      NAICS22: "561330",
      "INDEX ITEM DESCRIPTION": "Staff leasing services",
    },
    {
      NAICS22: "561410",
      "INDEX ITEM DESCRIPTION":
        "Desktop publishing services (i.e., document preparation services)",
    },
    {
      NAICS22: "561410",
      "INDEX ITEM DESCRIPTION": "Dictation services",
    },
    {
      NAICS22: "561410",
      "INDEX ITEM DESCRIPTION": "Document preparation services",
    },
    {
      NAICS22: "561410",
      "INDEX ITEM DESCRIPTION": "Document transcription services",
    },
    {
      NAICS22: "561410",
      "INDEX ITEM DESCRIPTION": "Editing services",
    },
    {
      NAICS22: "561410",
      "INDEX ITEM DESCRIPTION": "Letter writing services",
    },
    {
      NAICS22: "561410",
      "INDEX ITEM DESCRIPTION": "Proofreading services",
    },
    {
      NAICS22: "561410",
      "INDEX ITEM DESCRIPTION": "Radio transcription services",
    },
    {
      NAICS22: "561410",
      "INDEX ITEM DESCRIPTION": "Resume writing services",
    },
    {
      NAICS22: "561410",
      "INDEX ITEM DESCRIPTION": "Secretarial services",
    },
    {
      NAICS22: "561410",
      "INDEX ITEM DESCRIPTION":
        "Stenographic services (except court or stenographic reporting)",
    },
    {
      NAICS22: "561410",
      "INDEX ITEM DESCRIPTION": "Technical editing services",
    },
    {
      NAICS22: "561410",
      "INDEX ITEM DESCRIPTION": "Transcription services",
    },
    {
      NAICS22: "561410",
      "INDEX ITEM DESCRIPTION": "Typing services",
    },
    {
      NAICS22: "561410",
      "INDEX ITEM DESCRIPTION": "Word processing services",
    },
    {
      NAICS22: "561421",
      "INDEX ITEM DESCRIPTION": "Answering services, telephone",
    },
    {
      NAICS22: "561421",
      "INDEX ITEM DESCRIPTION":
        "Emergency telephone dispatch (i.e., contractor) services",
    },
    {
      NAICS22: "561421",
      "INDEX ITEM DESCRIPTION":
        "Local call centers (e.g., answering services, message services)",
    },
    {
      NAICS22: "561421",
      "INDEX ITEM DESCRIPTION": "Message services, telephone answering",
    },
    {
      NAICS22: "561421",
      "INDEX ITEM DESCRIPTION": "Telephone answering services",
    },
    {
      NAICS22: "561421",
      "INDEX ITEM DESCRIPTION": "Telephone call forwarding services",
    },
    {
      NAICS22: "561421",
      "INDEX ITEM DESCRIPTION": "Voice mailbox services",
    },
    {
      NAICS22: "561421",
      "INDEX ITEM DESCRIPTION": "Wakeup call services",
    },
    {
      NAICS22: "561422",
      "INDEX ITEM DESCRIPTION": "Customer service call centers",
    },
    {
      NAICS22: "561422",
      "INDEX ITEM DESCRIPTION":
        "Floral wire services (i.e., telemarketing services)",
    },
    {
      NAICS22: "561422",
      "INDEX ITEM DESCRIPTION": "Online customer service centers",
    },
    {
      NAICS22: "561422",
      "INDEX ITEM DESCRIPTION": "Telemarketing bureaus",
    },
    {
      NAICS22: "561422",
      "INDEX ITEM DESCRIPTION":
        "Telemarketing services on a contract or fee basis",
    },
    {
      NAICS22: "561422",
      "INDEX ITEM DESCRIPTION":
        "Telephone call centers (e.g., customer service centers, telemarketing services)",
    },
    {
      NAICS22: "561422",
      "INDEX ITEM DESCRIPTION":
        "Telephone solicitation services on a contract or fee basis",
    },
    {
      NAICS22: "561422",
      "INDEX ITEM DESCRIPTION":
        "Wire services (i.e., telemarketing services), floral",
    },
    {
      NAICS22: "561431",
      "INDEX ITEM DESCRIPTION": "Mailbox rental centers, private",
    },
    {
      NAICS22: "561431",
      "INDEX ITEM DESCRIPTION":
        "Mailbox rental services combined with one or more other office support services, private",
    },
    {
      NAICS22: "561431",
      "INDEX ITEM DESCRIPTION":
        "Parcel mailing services combined with one or more other office support services, private",
    },
    {
      NAICS22: "561431",
      "INDEX ITEM DESCRIPTION": "Parcel mailing services, private",
    },
    {
      NAICS22: "561431",
      "INDEX ITEM DESCRIPTION": "Private mail centers",
    },
    {
      NAICS22: "561431",
      "INDEX ITEM DESCRIPTION": "Private mailbox rental centers",
    },
    {
      NAICS22: "561439",
      "INDEX ITEM DESCRIPTION": "Blueprinting services",
    },
    {
      NAICS22: "561439",
      "INDEX ITEM DESCRIPTION":
        "Business service centers (except private mail centers)",
    },
    {
      NAICS22: "561439",
      "INDEX ITEM DESCRIPTION":
        "Business service centers (except private mail centers) providing range of office support services (except printing)",
    },
    {
      NAICS22: "561439",
      "INDEX ITEM DESCRIPTION":
        "Copy centers (except combined with printing services)",
    },
    {
      NAICS22: "561439",
      "INDEX ITEM DESCRIPTION":
        "Copy shops (except combined with printing services)",
    },
    {
      NAICS22: "561439",
      "INDEX ITEM DESCRIPTION":
        "Document copying services (except combined with printing services)",
    },
    {
      NAICS22: "561439",
      "INDEX ITEM DESCRIPTION":
        "Document duplicating services (except combined with printing services)",
    },
    {
      NAICS22: "561439",
      "INDEX ITEM DESCRIPTION":
        "Internet cafes (i.e., not serving food and beverages)",
    },
    {
      NAICS22: "561439",
      "INDEX ITEM DESCRIPTION":
        "Photocopying services (except combined with printing services)",
    },
    {
      NAICS22: "561439",
      "INDEX ITEM DESCRIPTION": "Reprographic services",
    },
    {
      NAICS22: "561440",
      "INDEX ITEM DESCRIPTION": "Account collection services",
    },
    {
      NAICS22: "561440",
      "INDEX ITEM DESCRIPTION": "Adjustment agencies (except insurance)",
    },
    {
      NAICS22: "561440",
      "INDEX ITEM DESCRIPTION": "Bill collection services",
    },
    {
      NAICS22: "561440",
      "INDEX ITEM DESCRIPTION": "Collection agencies",
    },
    {
      NAICS22: "561440",
      "INDEX ITEM DESCRIPTION": "Collection agencies, accounts",
    },
    {
      NAICS22: "561440",
      "INDEX ITEM DESCRIPTION": "Credit arrears collection services",
    },
    {
      NAICS22: "561440",
      "INDEX ITEM DESCRIPTION": "Debt collection services",
    },
    {
      NAICS22: "561440",
      "INDEX ITEM DESCRIPTION": "Delinquent account collection services",
    },
    {
      NAICS22: "561440",
      "INDEX ITEM DESCRIPTION":
        "Tax collection services on a contract or fee basis",
    },
    {
      NAICS22: "561450",
      "INDEX ITEM DESCRIPTION": "Commercial credit reporting bureaus",
    },
    {
      NAICS22: "561450",
      "INDEX ITEM DESCRIPTION": "Consumer credit reporting bureaus",
    },
    {
      NAICS22: "561450",
      "INDEX ITEM DESCRIPTION": "Credit agencies",
    },
    {
      NAICS22: "561450",
      "INDEX ITEM DESCRIPTION": "Credit bureaus",
    },
    {
      NAICS22: "561450",
      "INDEX ITEM DESCRIPTION": "Credit clearinghouses",
    },
    {
      NAICS22: "561450",
      "INDEX ITEM DESCRIPTION": "Credit investigation services",
    },
    {
      NAICS22: "561450",
      "INDEX ITEM DESCRIPTION": "Credit rating services",
    },
    {
      NAICS22: "561450",
      "INDEX ITEM DESCRIPTION": "Credit reporting bureaus",
    },
    {
      NAICS22: "561450",
      "INDEX ITEM DESCRIPTION": "Investigation services, credit",
    },
    {
      NAICS22: "561450",
      "INDEX ITEM DESCRIPTION": "Mercantile credit reporting bureaus",
    },
    {
      NAICS22: "561491",
      "INDEX ITEM DESCRIPTION": "Automobile repossession services",
    },
    {
      NAICS22: "561491",
      "INDEX ITEM DESCRIPTION": "Repossession services",
    },
    {
      NAICS22: "561492",
      "INDEX ITEM DESCRIPTION":
        "Closed captioning services, real-time (i.e., simultaneous)",
    },
    {
      NAICS22: "561492",
      "INDEX ITEM DESCRIPTION": "Court reporting services",
    },
    {
      NAICS22: "561492",
      "INDEX ITEM DESCRIPTION": "Deposition services",
    },
    {
      NAICS22: "561492",
      "INDEX ITEM DESCRIPTION": "Public stenography services",
    },
    {
      NAICS22: "561492",
      "INDEX ITEM DESCRIPTION":
        "Real-time (i.e., simultaneous) closed captioning of live television performances, meetings, conferences, and so forth",
    },
    {
      NAICS22: "561492",
      "INDEX ITEM DESCRIPTION": "Stenography services, public",
    },
    {
      NAICS22: "561492",
      "INDEX ITEM DESCRIPTION": "Stenotype recording services",
    },
    {
      NAICS22: "561499",
      "INDEX ITEM DESCRIPTION": "Address bar coding services",
    },
    {
      NAICS22: "561499",
      "INDEX ITEM DESCRIPTION": "Bar code imprinting services",
    },
    {
      NAICS22: "561499",
      "INDEX ITEM DESCRIPTION":
        "Charitable fundraising campaign organization services on a contract or fee basis",
    },
    {
      NAICS22: "561499",
      "INDEX ITEM DESCRIPTION":
        "Charitable fundraising using a crowdfunding platform, on a contract or fee basis",
    },
    {
      NAICS22: "561499",
      "INDEX ITEM DESCRIPTION": "Mail consolidation services",
    },
    {
      NAICS22: "561499",
      "INDEX ITEM DESCRIPTION": "Mail presorting services",
    },
    {
      NAICS22: "561499",
      "INDEX ITEM DESCRIPTION":
        "Medical coding services, not combined with accounting services",
    },
    {
      NAICS22: "561499",
      "INDEX ITEM DESCRIPTION": "Teleconferencing services",
    },
    {
      NAICS22: "561499",
      "INDEX ITEM DESCRIPTION": "Videoconferencing services",
    },
    {
      NAICS22: "561510",
      "INDEX ITEM DESCRIPTION": "Online travel agencies",
    },
    {
      NAICS22: "561510",
      "INDEX ITEM DESCRIPTION": "Travel agencies",
    },
    {
      NAICS22: "561510",
      "INDEX ITEM DESCRIPTION": "Travel management services",
    },
    {
      NAICS22: "561520",
      "INDEX ITEM DESCRIPTION":
        "Tour operators (i.e., arranging and assembling tours)",
    },
    {
      NAICS22: "561520",
      "INDEX ITEM DESCRIPTION": "Travel tour operators",
    },
    {
      NAICS22: "561520",
      "INDEX ITEM DESCRIPTION": "Wholesale tour operators",
    },
    {
      NAICS22: "561591",
      "INDEX ITEM DESCRIPTION": "Convention and visitors bureaus",
    },
    {
      NAICS22: "561591",
      "INDEX ITEM DESCRIPTION": "Convention bureaus",
    },
    {
      NAICS22: "561591",
      "INDEX ITEM DESCRIPTION": "Tourism bureaus",
    },
    {
      NAICS22: "561591",
      "INDEX ITEM DESCRIPTION": "Tourist information bureaus",
    },
    {
      NAICS22: "561591",
      "INDEX ITEM DESCRIPTION": "Visitor information centers",
    },
    {
      NAICS22: "561591",
      "INDEX ITEM DESCRIPTION": "Visitors bureaus",
    },
    {
      NAICS22: "561599",
      "INDEX ITEM DESCRIPTION": "Airline reservation services",
    },
    {
      NAICS22: "561599",
      "INDEX ITEM DESCRIPTION": "Airline ticket offices",
    },
    {
      NAICS22: "561599",
      "INDEX ITEM DESCRIPTION": "Automobile clubs, road and travel services",
    },
    {
      NAICS22: "561599",
      "INDEX ITEM DESCRIPTION":
        "Booking (e.g., airline, car rental, hotel, restaurant) services",
    },
    {
      NAICS22: "561599",
      "INDEX ITEM DESCRIPTION": "Bus ticket offices",
    },
    {
      NAICS22: "561599",
      "INDEX ITEM DESCRIPTION": "Car rental reservation services",
    },
    {
      NAICS22: "561599",
      "INDEX ITEM DESCRIPTION": "Concert ticket offices",
    },
    {
      NAICS22: "561599",
      "INDEX ITEM DESCRIPTION": "Condominium time-share exchange services",
    },
    {
      NAICS22: "561599",
      "INDEX ITEM DESCRIPTION": "Cruise reservation services",
    },
    {
      NAICS22: "561599",
      "INDEX ITEM DESCRIPTION": "Cruise ship ticket offices",
    },
    {
      NAICS22: "561599",
      "INDEX ITEM DESCRIPTION": "Hotel reservation services",
    },
    {
      NAICS22: "561599",
      "INDEX ITEM DESCRIPTION": "Motor travel clubs",
    },
    {
      NAICS22: "561599",
      "INDEX ITEM DESCRIPTION":
        "Online accommodations reservation services (through a website or mobile application)",
    },
    {
      NAICS22: "561599",
      "INDEX ITEM DESCRIPTION":
        "Online airline reservation services (through a website or mobile application)",
    },
    {
      NAICS22: "561599",
      "INDEX ITEM DESCRIPTION":
        "Online cruise reservation services (through a website or mobile application)",
    },
    {
      NAICS22: "561599",
      "INDEX ITEM DESCRIPTION":
        "Online motor vehicle rental reservation services (through a website or mobile application)",
    },
    {
      NAICS22: "561599",
      "INDEX ITEM DESCRIPTION":
        "Online ticket (e.g., airline, bus, cruise ship, sports, theatrical) agencies (through a website or mobile application)",
    },
    {
      NAICS22: "561599",
      "INDEX ITEM DESCRIPTION": "Performing arts ticket offices",
    },
    {
      NAICS22: "561599",
      "INDEX ITEM DESCRIPTION": "Railroad ticket offices",
    },
    {
      NAICS22: "561599",
      "INDEX ITEM DESCRIPTION":
        "Reservation (e.g., airline, car rental, hotel, restaurant) services",
    },
    {
      NAICS22: "561599",
      "INDEX ITEM DESCRIPTION": "Sports ticket offices",
    },
    {
      NAICS22: "561599",
      "INDEX ITEM DESCRIPTION": "Theatrical ticket offices",
    },
    {
      NAICS22: "561599",
      "INDEX ITEM DESCRIPTION":
        "Ticket (e.g., airline, bus, cruise ship, sports, theatrical) offices",
    },
    {
      NAICS22: "561599",
      "INDEX ITEM DESCRIPTION":
        "Ticket (e.g., airline, bus, cruise ship, sports, theatrical) sales offices",
    },
    {
      NAICS22: "561599",
      "INDEX ITEM DESCRIPTION":
        "Ticket (e.g., amusement, sports, theatrical) agencies",
    },
    {
      NAICS22: "561599",
      "INDEX ITEM DESCRIPTION":
        "Ticket (e.g., amusement, sports, theatrical) sales agencies",
    },
    {
      NAICS22: "561599",
      "INDEX ITEM DESCRIPTION": "Ticket agencies, amusement",
    },
    {
      NAICS22: "561599",
      "INDEX ITEM DESCRIPTION": "Ticket agencies, sports",
    },
    {
      NAICS22: "561599",
      "INDEX ITEM DESCRIPTION": "Ticket agencies, theatrical",
    },
    {
      NAICS22: "561599",
      "INDEX ITEM DESCRIPTION":
        "Ticket offices for foreign cruise ship companies",
    },
    {
      NAICS22: "561599",
      "INDEX ITEM DESCRIPTION": "Time-share exchange services, condominium",
    },
    {
      NAICS22: "561611",
      "INDEX ITEM DESCRIPTION": "Background check services",
    },
    {
      NAICS22: "561611",
      "INDEX ITEM DESCRIPTION": "Bounty hunting services",
    },
    {
      NAICS22: "561611",
      "INDEX ITEM DESCRIPTION": "Detective agencies",
    },
    {
      NAICS22: "561611",
      "INDEX ITEM DESCRIPTION": "Fingerprint services",
    },
    {
      NAICS22: "561611",
      "INDEX ITEM DESCRIPTION": "Investigation services (except credit), private",
    },
    {
      NAICS22: "561611",
      "INDEX ITEM DESCRIPTION": "Investigators, private",
    },
    {
      NAICS22: "561611",
      "INDEX ITEM DESCRIPTION": "Lie detection services",
    },
    {
      NAICS22: "561611",
      "INDEX ITEM DESCRIPTION": "Missing person tracing services",
    },
    {
      NAICS22: "561611",
      "INDEX ITEM DESCRIPTION": "Polygraph services",
    },
    {
      NAICS22: "561611",
      "INDEX ITEM DESCRIPTION": "Private detective services",
    },
    {
      NAICS22: "561611",
      "INDEX ITEM DESCRIPTION": "Private investigation services (except credit)",
    },
    {
      NAICS22: "561611",
      "INDEX ITEM DESCRIPTION": "Skip tracing services",
    },
    {
      NAICS22: "561612",
      "INDEX ITEM DESCRIPTION": "Body guard services",
    },
    {
      NAICS22: "561612",
      "INDEX ITEM DESCRIPTION": "Guard dog services",
    },
    {
      NAICS22: "561612",
      "INDEX ITEM DESCRIPTION": "Guard services",
    },
    {
      NAICS22: "561612",
      "INDEX ITEM DESCRIPTION": "Parking security services",
    },
    {
      NAICS22: "561612",
      "INDEX ITEM DESCRIPTION": "Patrol services, security",
    },
    {
      NAICS22: "561612",
      "INDEX ITEM DESCRIPTION":
        "Personal protection services (except security systems services)",
    },
    {
      NAICS22: "561612",
      "INDEX ITEM DESCRIPTION": "Private police services",
    },
    {
      NAICS22: "561612",
      "INDEX ITEM DESCRIPTION":
        "Property protection services (except armored car, security systems)",
    },
    {
      NAICS22: "561612",
      "INDEX ITEM DESCRIPTION":
        "Protection services (except armored car, security systems), personal or property",
    },
    {
      NAICS22: "561612",
      "INDEX ITEM DESCRIPTION": "Protective guard services",
    },
    {
      NAICS22: "561612",
      "INDEX ITEM DESCRIPTION": "Security guard services",
    },
    {
      NAICS22: "561612",
      "INDEX ITEM DESCRIPTION": "Security patrol services",
    },
    {
      NAICS22: "561613",
      "INDEX ITEM DESCRIPTION": "Armored car services",
    },
    {
      NAICS22: "561621",
      "INDEX ITEM DESCRIPTION": "Alarm system monitoring services",
    },
    {
      NAICS22: "561621",
      "INDEX ITEM DESCRIPTION":
        "Alarm systems sales combined with installation, repair, or monitoring services",
    },
    {
      NAICS22: "561621",
      "INDEX ITEM DESCRIPTION": "Burglar alarm monitoring services",
    },
    {
      NAICS22: "561621",
      "INDEX ITEM DESCRIPTION":
        "Burglar alarm sales combined with installation, repair, or monitoring services",
    },
    {
      NAICS22: "561621",
      "INDEX ITEM DESCRIPTION": "Fire alarm monitoring services",
    },
    {
      NAICS22: "561621",
      "INDEX ITEM DESCRIPTION":
        "Fire alarm sales combined with installation, repair, or monitoring services",
    },
    {
      NAICS22: "561621",
      "INDEX ITEM DESCRIPTION":
        "Security alarm systems sales combined with installation, repair, or monitoring services",
    },
    {
      NAICS22: "561621",
      "INDEX ITEM DESCRIPTION": "Security system monitoring services",
    },
    {
      NAICS22: "561622",
      "INDEX ITEM DESCRIPTION": "Lock rekeying services",
    },
    {
      NAICS22: "561622",
      "INDEX ITEM DESCRIPTION": "Locksmith services",
    },
    {
      NAICS22: "561622",
      "INDEX ITEM DESCRIPTION":
        "Locksmith services with or without sales of locking devices, safes, and security vaults",
    },
    {
      NAICS22: "561622",
      "INDEX ITEM DESCRIPTION": "Locksmith shops",
    },
    {
      NAICS22: "561710",
      "INDEX ITEM DESCRIPTION": "Bird proofing services",
    },
    {
      NAICS22: "561710",
      "INDEX ITEM DESCRIPTION": "Exterminating services",
    },
    {
      NAICS22: "561710",
      "INDEX ITEM DESCRIPTION": "Fumigating services (except crop fumigating)",
    },
    {
      NAICS22: "561710",
      "INDEX ITEM DESCRIPTION": "Mosquito eradication services",
    },
    {
      NAICS22: "561710",
      "INDEX ITEM DESCRIPTION": "Pest (e.g., termite) inspection services",
    },
    {
      NAICS22: "561710",
      "INDEX ITEM DESCRIPTION":
        "Pest control (except agricultural, forestry) services",
    },
    {
      NAICS22: "561710",
      "INDEX ITEM DESCRIPTION": "Termite control services",
    },
    {
      NAICS22: "561720",
      "INDEX ITEM DESCRIPTION": "Aircraft janitorial services",
    },
    {
      NAICS22: "561720",
      "INDEX ITEM DESCRIPTION": "Building cleaning services, interior",
    },
    {
      NAICS22: "561720",
      "INDEX ITEM DESCRIPTION": "Building cleaning services, janitorial",
    },
    {
      NAICS22: "561720",
      "INDEX ITEM DESCRIPTION": "Cleaning homes",
    },
    {
      NAICS22: "561720",
      "INDEX ITEM DESCRIPTION": "Cleaning offices",
    },
    {
      NAICS22: "561720",
      "INDEX ITEM DESCRIPTION": "Cleaning shopping centers",
    },
    {
      NAICS22: "561720",
      "INDEX ITEM DESCRIPTION": "Custodial services",
    },
    {
      NAICS22: "561720",
      "INDEX ITEM DESCRIPTION": "Deodorant servicing of rest rooms",
    },
    {
      NAICS22: "561720",
      "INDEX ITEM DESCRIPTION": "Deodorizing services",
    },
    {
      NAICS22: "561720",
      "INDEX ITEM DESCRIPTION": "Disinfecting services",
    },
    {
      NAICS22: "561720",
      "INDEX ITEM DESCRIPTION": "Housekeeping services (i.e., cleaning services)",
    },
    {
      NAICS22: "561720",
      "INDEX ITEM DESCRIPTION": "Janitorial services",
    },
    {
      NAICS22: "561720",
      "INDEX ITEM DESCRIPTION": "Janitorial services, aircraft",
    },
    {
      NAICS22: "561720",
      "INDEX ITEM DESCRIPTION": "Maid services (i.e., cleaning services)",
    },
    {
      NAICS22: "561720",
      "INDEX ITEM DESCRIPTION": "Office cleaning services",
    },
    {
      NAICS22: "561720",
      "INDEX ITEM DESCRIPTION": "Residential cleaning services",
    },
    {
      NAICS22: "561720",
      "INDEX ITEM DESCRIPTION": "Rest room cleaning services",
    },
    {
      NAICS22: "561720",
      "INDEX ITEM DESCRIPTION": "Restaurant kitchen cleaning services",
    },
    {
      NAICS22: "561720",
      "INDEX ITEM DESCRIPTION":
        "Service station cleaning and degreasing services",
    },
    {
      NAICS22: "561720",
      "INDEX ITEM DESCRIPTION": "Venetian blind cleaning services",
    },
    {
      NAICS22: "561720",
      "INDEX ITEM DESCRIPTION": "Washroom sanitation services",
    },
    {
      NAICS22: "561720",
      "INDEX ITEM DESCRIPTION": "Window cleaning services",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION": "Arborist services",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION": "Cemetery plot care services",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION": "Fertilizing lawns",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION": "Garden maintenance services",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION":
        "Hydroseeding services (e.g., decorative, erosion control purposes)",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION": "Interior landscaping services",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION": "Landscape care and maintenance services",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION": "Landscape contractors (except construction)",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION": "Landscape installation services",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION": "Landscaping services (except planning)",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION":
        "Lawn care services (e.g., fertilizing, mowing, seeding, spraying)",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION": "Lawn fertilizing services",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION": "Lawn irrigation services",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION": "Lawn maintenance services",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION": "Lawn mowing services",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION": "Lawn mulching services",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION": "Lawn seeding services",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION": "Lawn spraying services",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION":
        "Line slash (i.e., rights of way) maintenance services",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION": "Maintenance of plants and shrubs in buildings",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION":
        "Mowing services (e.g., highway, lawn, road strip)",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION": "Ornamental tree and shrub services",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION": "Plant and shrub maintenance in buildings",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION": "Plant maintenance services",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION": "Pruning services, ornamental tree and shrub",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION":
        "Seasonal property maintenance services (i.e., snow plowing in winter, landscaping during other seasons)",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION": "Seeding lawns",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION":
        "Shrub services (e.g., bracing, planting, pruning, removal, spraying, surgery, trimming)",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION":
        "Snow plowing services combined with landscaping services (i.e., seasonal property maintenance services)",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION": "Sod laying services",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION": "Spraying lawns",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION": "Tree and brush trimming, overhead utility line",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION": "Tree pruning services",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION": "Tree removal services",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION":
        "Tree services (e.g., bracing, planting, pruning, removal, spraying, surgery, trimming)",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION": "Tree surgery services",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION": "Tree trimming services",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION": "Tropical plant maintenance services",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION": "Turf (except artificial) installation services",
    },
    {
      NAICS22: "561730",
      "INDEX ITEM DESCRIPTION":
        "Weed control and fertilizing services (except crop)",
    },
    {
      NAICS22: "561740",
      "INDEX ITEM DESCRIPTION": "Carpet cleaning on customers' premises",
    },
    {
      NAICS22: "561740",
      "INDEX ITEM DESCRIPTION": "Carpet cleaning plants",
    },
    {
      NAICS22: "561740",
      "INDEX ITEM DESCRIPTION": "Carpet cleaning services",
    },
    {
      NAICS22: "561740",
      "INDEX ITEM DESCRIPTION": "Cleaning carpets",
    },
    {
      NAICS22: "561740",
      "INDEX ITEM DESCRIPTION": "Cleaning plants, carpet and rug",
    },
    {
      NAICS22: "561740",
      "INDEX ITEM DESCRIPTION": "Cleaning rugs",
    },
    {
      NAICS22: "561740",
      "INDEX ITEM DESCRIPTION": "Cleaning services, carpet and rug",
    },
    {
      NAICS22: "561740",
      "INDEX ITEM DESCRIPTION": "Furniture cleaning on customers' premises",
    },
    {
      NAICS22: "561740",
      "INDEX ITEM DESCRIPTION": "Furniture cleaning services",
    },
    {
      NAICS22: "561740",
      "INDEX ITEM DESCRIPTION": "Rug cleaning plants",
    },
    {
      NAICS22: "561740",
      "INDEX ITEM DESCRIPTION": "Rug cleaning services",
    },
    {
      NAICS22: "561740",
      "INDEX ITEM DESCRIPTION": "Upholstery cleaning on customers' premises",
    },
    {
      NAICS22: "561740",
      "INDEX ITEM DESCRIPTION": "Upholstery cleaning services",
    },
    {
      NAICS22: "561790",
      "INDEX ITEM DESCRIPTION":
        "Building exterior cleaning services (except sandblasting, window cleaning) ",
    },
    {
      NAICS22: "561790",
      "INDEX ITEM DESCRIPTION":
        "Building gas systems conversion (e.g., from manufactured to natural gas) services",
    },
    {
      NAICS22: "561790",
      "INDEX ITEM DESCRIPTION": "Chimney cleaning services",
    },
    {
      NAICS22: "561790",
      "INDEX ITEM DESCRIPTION": "Chimney sweep (i.e., cleaning) services",
    },
    {
      NAICS22: "561790",
      "INDEX ITEM DESCRIPTION":
        "Cleaning (e.g., power sweeping, washing) driveways and parking lots",
    },
    {
      NAICS22: "561790",
      "INDEX ITEM DESCRIPTION":
        "Cleaning building exteriors (except sandblasting, window cleaning) ",
    },
    {
      NAICS22: "561790",
      "INDEX ITEM DESCRIPTION": "Cleaning swimming pools",
    },
    {
      NAICS22: "561790",
      "INDEX ITEM DESCRIPTION":
        "Commercial kitchen exhaust hood cleaning services",
    },
    {
      NAICS22: "561790",
      "INDEX ITEM DESCRIPTION": "Drain cleaning services",
    },
    {
      NAICS22: "561790",
      "INDEX ITEM DESCRIPTION":
        "Driveway cleaning (e.g., power sweeping, washing) services",
    },
    {
      NAICS22: "561790",
      "INDEX ITEM DESCRIPTION": "Duct cleaning services",
    },
    {
      NAICS22: "561790",
      "INDEX ITEM DESCRIPTION": "Gutter cleaning services",
    },
    {
      NAICS22: "561790",
      "INDEX ITEM DESCRIPTION":
        "Lighting maintenance services (e.g., bulb and fuse replacement and cleaning)",
    },
    {
      NAICS22: "561790",
      "INDEX ITEM DESCRIPTION":
        "Parking lot cleaning (e.g., power sweeping, washing) services",
    },
    {
      NAICS22: "561790",
      "INDEX ITEM DESCRIPTION": "Power washing building exteriors",
    },
    {
      NAICS22: "561790",
      "INDEX ITEM DESCRIPTION":
        "Pressure washing (e.g., buildings, decks, fences)",
    },
    {
      NAICS22: "561790",
      "INDEX ITEM DESCRIPTION":
        "Snow plowing driveways and parking lots (i.e., not combined with any other service)",
    },
    {
      NAICS22: "561790",
      "INDEX ITEM DESCRIPTION": "Steam cleaning building exteriors",
    },
    {
      NAICS22: "561790",
      "INDEX ITEM DESCRIPTION": "Swimming pool cleaning and maintenance services",
    },
    {
      NAICS22: "561790",
      "INDEX ITEM DESCRIPTION": "Ventilation duct cleaning services",
    },
    {
      NAICS22: "561910",
      "INDEX ITEM DESCRIPTION": "Apparel folding and packaging services",
    },
    {
      NAICS22: "561910",
      "INDEX ITEM DESCRIPTION": "Blister packaging services",
    },
    {
      NAICS22: "561910",
      "INDEX ITEM DESCRIPTION": "Cosmetic kit assembling and packaging services",
    },
    {
      NAICS22: "561910",
      "INDEX ITEM DESCRIPTION":
        "Folding and packaging services, textile and apparel",
    },
    {
      NAICS22: "561910",
      "INDEX ITEM DESCRIPTION": "Gift wrapping services",
    },
    {
      NAICS22: "561910",
      "INDEX ITEM DESCRIPTION": "Kit assembling and packaging services",
    },
    {
      NAICS22: "561910",
      "INDEX ITEM DESCRIPTION": "Labeling services",
    },
    {
      NAICS22: "561910",
      "INDEX ITEM DESCRIPTION": "Mounting merchandise on cards",
    },
    {
      NAICS22: "561910",
      "INDEX ITEM DESCRIPTION":
        "Packaging services (except packing and crating for transportation)",
    },
    {
      NAICS22: "561910",
      "INDEX ITEM DESCRIPTION": "Parcel packing services",
    },
    {
      NAICS22: "561910",
      "INDEX ITEM DESCRIPTION": "Product sterilization and packaging services",
    },
    {
      NAICS22: "561910",
      "INDEX ITEM DESCRIPTION": "Shrink wrapping services",
    },
    {
      NAICS22: "561910",
      "INDEX ITEM DESCRIPTION": "Skin blister packaging services",
    },
    {
      NAICS22: "561910",
      "INDEX ITEM DESCRIPTION": "Textile folding and packaging services",
    },
    {
      NAICS22: "561920",
      "INDEX ITEM DESCRIPTION": "Automobile show managers",
    },
    {
      NAICS22: "561920",
      "INDEX ITEM DESCRIPTION": "Automobile show organizers",
    },
    {
      NAICS22: "561920",
      "INDEX ITEM DESCRIPTION": "Automobile show promoters",
    },
    {
      NAICS22: "561920",
      "INDEX ITEM DESCRIPTION": "Convention managers",
    },
    {
      NAICS22: "561920",
      "INDEX ITEM DESCRIPTION": "Convention or trade show event planners",
    },
    {
      NAICS22: "561920",
      "INDEX ITEM DESCRIPTION": "Convention organizers",
    },
    {
      NAICS22: "561920",
      "INDEX ITEM DESCRIPTION": "Convention promoters",
    },
    {
      NAICS22: "561920",
      "INDEX ITEM DESCRIPTION": "Convention services",
    },
    {
      NAICS22: "561920",
      "INDEX ITEM DESCRIPTION": "Craft fair managers",
    },
    {
      NAICS22: "561920",
      "INDEX ITEM DESCRIPTION": "Craft fair organizers",
    },
    {
      NAICS22: "561920",
      "INDEX ITEM DESCRIPTION": "Craft fair promoters",
    },
    {
      NAICS22: "561920",
      "INDEX ITEM DESCRIPTION": "Event and meeting planning services",
    },
    {
      NAICS22: "561920",
      "INDEX ITEM DESCRIPTION": "Flower show managers",
    },
    {
      NAICS22: "561920",
      "INDEX ITEM DESCRIPTION": "Flower show organizers",
    },
    {
      NAICS22: "561920",
      "INDEX ITEM DESCRIPTION": "Flower show promoters",
    },
    {
      NAICS22: "561920",
      "INDEX ITEM DESCRIPTION": "Home show managers",
    },
    {
      NAICS22: "561920",
      "INDEX ITEM DESCRIPTION": "Home show organizers",
    },
    {
      NAICS22: "561920",
      "INDEX ITEM DESCRIPTION": "Home show promoters",
    },
    {
      NAICS22: "561920",
      "INDEX ITEM DESCRIPTION": "Managers, convention",
    },
    {
      NAICS22: "561920",
      "INDEX ITEM DESCRIPTION": "Managers, trade fair or show",
    },
    {
      NAICS22: "561920",
      "INDEX ITEM DESCRIPTION":
        "Promoters of conventions with or without facilities",
    },
    {
      NAICS22: "561920",
      "INDEX ITEM DESCRIPTION":
        "Promoters of trade fairs or shows with or without facilities",
    },
    {
      NAICS22: "561920",
      "INDEX ITEM DESCRIPTION": "Trade fair managers",
    },
    {
      NAICS22: "561920",
      "INDEX ITEM DESCRIPTION": "Trade fair organizers",
    },
    {
      NAICS22: "561920",
      "INDEX ITEM DESCRIPTION": "Trade fair promoters",
    },
    {
      NAICS22: "561920",
      "INDEX ITEM DESCRIPTION": "Trade show managers",
    },
    {
      NAICS22: "561920",
      "INDEX ITEM DESCRIPTION": "Trade show organizers",
    },
    {
      NAICS22: "561920",
      "INDEX ITEM DESCRIPTION": "Trade show promoters",
    },
    {
      NAICS22: "561990",
      "INDEX ITEM DESCRIPTION": "Auctioneers, independent",
    },
    {
      NAICS22: "561990",
      "INDEX ITEM DESCRIPTION": "Bartering services",
    },
    {
      NAICS22: "561990",
      "INDEX ITEM DESCRIPTION": "Bottle exchanges",
    },
    {
      NAICS22: "561990",
      "INDEX ITEM DESCRIPTION": "Coin pick-up services, parking meter",
    },
    {
      NAICS22: "561990",
      "INDEX ITEM DESCRIPTION": "Coupon processing services",
    },
    {
      NAICS22: "561990",
      "INDEX ITEM DESCRIPTION":
        "Coupon redemption services (i.e., clearinghouse)",
    },
    {
      NAICS22: "561990",
      "INDEX ITEM DESCRIPTION": "Diving services on a contract or fee basis",
    },
    {
      NAICS22: "561990",
      "INDEX ITEM DESCRIPTION": "Document shredding services",
    },
    {
      NAICS22: "561990",
      "INDEX ITEM DESCRIPTION": "Electrical meter reading services, contract",
    },
    {
      NAICS22: "561990",
      "INDEX ITEM DESCRIPTION": "Firefighting services as a commercial activity",
    },
    {
      NAICS22: "561990",
      "INDEX ITEM DESCRIPTION": "Flagging (i.e., traffic control) services",
    },
    {
      NAICS22: "561990",
      "INDEX ITEM DESCRIPTION": "Float decorating services",
    },
    {
      NAICS22: "561990",
      "INDEX ITEM DESCRIPTION": "Gas meter reading services, contract",
    },
    {
      NAICS22: "561990",
      "INDEX ITEM DESCRIPTION": "Inventory computing services",
    },
    {
      NAICS22: "561990",
      "INDEX ITEM DESCRIPTION": "Inventory taking services",
    },
    {
      NAICS22: "561990",
      "INDEX ITEM DESCRIPTION":
        "License issuing services (except government), motor vehicle",
    },
    {
      NAICS22: "561990",
      "INDEX ITEM DESCRIPTION":
        "Locating underground utility lines prior to digging",
    },
    {
      NAICS22: "561990",
      "INDEX ITEM DESCRIPTION": "Lumber grading services",
    },
    {
      NAICS22: "561990",
      "INDEX ITEM DESCRIPTION": "Meter reading services, contract",
    },
    {
      NAICS22: "561990",
      "INDEX ITEM DESCRIPTION":
        "Motor vehicle license issuing services, private franchise",
    },
    {
      NAICS22: "561990",
      "INDEX ITEM DESCRIPTION": "Museum cataloging services",
    },
    {
      NAICS22: "561990",
      "INDEX ITEM DESCRIPTION": "Printing brokers",
    },
    {
      NAICS22: "561990",
      "INDEX ITEM DESCRIPTION": "Private volunteer firefighting",
    },
    {
      NAICS22: "561990",
      "INDEX ITEM DESCRIPTION": "Trading stamp promotion and sale to stores",
    },
    {
      NAICS22: "561990",
      "INDEX ITEM DESCRIPTION": "Trading stamp redemption services",
    },
    {
      NAICS22: "561990",
      "INDEX ITEM DESCRIPTION": "Water softening and conditioning services",
    },
    {
      NAICS22: "562111",
      "INDEX ITEM DESCRIPTION": "Ash collection services",
    },
    {
      NAICS22: "562111",
      "INDEX ITEM DESCRIPTION": "Ash hauling, local",
    },
    {
      NAICS22: "562111",
      "INDEX ITEM DESCRIPTION": "Garbage collection services",
    },
    {
      NAICS22: "562111",
      "INDEX ITEM DESCRIPTION": "Garbage hauling, local",
    },
    {
      NAICS22: "562111",
      "INDEX ITEM DESCRIPTION": "Garbage pick-up services",
    },
    {
      NAICS22: "562111",
      "INDEX ITEM DESCRIPTION": "Recyclable material collection services",
    },
    {
      NAICS22: "562111",
      "INDEX ITEM DESCRIPTION": "Recyclable material hauling, local",
    },
    {
      NAICS22: "562111",
      "INDEX ITEM DESCRIPTION": "Refuse collection services",
    },
    {
      NAICS22: "562111",
      "INDEX ITEM DESCRIPTION": "Refuse hauling, local",
    },
    {
      NAICS22: "562111",
      "INDEX ITEM DESCRIPTION":
        "Rubbish (i.e., nonhazardous solid waste) hauling, local",
    },
    {
      NAICS22: "562111",
      "INDEX ITEM DESCRIPTION": "Rubbish collection services",
    },
    {
      NAICS22: "562111",
      "INDEX ITEM DESCRIPTION": "Trash collection services",
    },
    {
      NAICS22: "562111",
      "INDEX ITEM DESCRIPTION": "Trash hauling, local",
    },
    {
      NAICS22: "562111",
      "INDEX ITEM DESCRIPTION": "Waste collection services, nonhazardous solid",
    },
    {
      NAICS22: "562111",
      "INDEX ITEM DESCRIPTION": "Waste hauling, local, nonhazardous solid",
    },
    {
      NAICS22: "562111",
      "INDEX ITEM DESCRIPTION": "Waste transfer stations, nonhazardous solid",
    },
    {
      NAICS22: "562112",
      "INDEX ITEM DESCRIPTION": "Hazardous waste collection services",
    },
    {
      NAICS22: "562112",
      "INDEX ITEM DESCRIPTION":
        "Radioactive waste collecting and/or local hauling",
    },
    {
      NAICS22: "562112",
      "INDEX ITEM DESCRIPTION": "Waste collection services, hazardous",
    },
    {
      NAICS22: "562112",
      "INDEX ITEM DESCRIPTION": "Waste hauling, local, hazardous",
    },
    {
      NAICS22: "562112",
      "INDEX ITEM DESCRIPTION": "Waste transfer stations, hazardous",
    },
    {
      NAICS22: "562119",
      "INDEX ITEM DESCRIPTION": "Brush collection services",
    },
    {
      NAICS22: "562119",
      "INDEX ITEM DESCRIPTION": "Brush hauling, local",
    },
    {
      NAICS22: "562119",
      "INDEX ITEM DESCRIPTION": "Brush removal services",
    },
    {
      NAICS22: "562119",
      "INDEX ITEM DESCRIPTION": "Debris removal services",
    },
    {
      NAICS22: "562119",
      "INDEX ITEM DESCRIPTION":
        "Dump trucking of rubble or brush with collection or disposal",
    },
    {
      NAICS22: "562119",
      "INDEX ITEM DESCRIPTION": "Rubble hauling, local",
    },
    {
      NAICS22: "562119",
      "INDEX ITEM DESCRIPTION": "Rubble removal services",
    },
    {
      NAICS22: "562119",
      "INDEX ITEM DESCRIPTION":
        "Waste (except solid and hazardous) collection services",
    },
    {
      NAICS22: "562119",
      "INDEX ITEM DESCRIPTION":
        "Waste (except solid and hazardous) hauling, local",
    },
    {
      NAICS22: "562211",
      "INDEX ITEM DESCRIPTION": "Acid waste disposal facilities",
    },
    {
      NAICS22: "562211",
      "INDEX ITEM DESCRIPTION": "Acid waste treatment facilities",
    },
    {
      NAICS22: "562211",
      "INDEX ITEM DESCRIPTION": "Combustors, hazardous waste",
    },
    {
      NAICS22: "562211",
      "INDEX ITEM DESCRIPTION": "Hazardous waste disposal facilities",
    },
    {
      NAICS22: "562211",
      "INDEX ITEM DESCRIPTION":
        "Hazardous waste disposal facilities combined with collection and/or local hauling of hazardous waste",
    },
    {
      NAICS22: "562211",
      "INDEX ITEM DESCRIPTION": "Hazardous waste material disposal facilities",
    },
    {
      NAICS22: "562211",
      "INDEX ITEM DESCRIPTION": "Hazardous waste material treatment facilities",
    },
    {
      NAICS22: "562211",
      "INDEX ITEM DESCRIPTION": "Hazardous waste treatment facilities",
    },
    {
      NAICS22: "562211",
      "INDEX ITEM DESCRIPTION":
        "Hazardous waste treatment facilities combined with collection and/or local hauling of hazardous waste",
    },
    {
      NAICS22: "562211",
      "INDEX ITEM DESCRIPTION": "Incinerators, hazardous waste, operating",
    },
    {
      NAICS22: "562211",
      "INDEX ITEM DESCRIPTION": "Medical waste treatment facilities, hazardous",
    },
    {
      NAICS22: "562211",
      "INDEX ITEM DESCRIPTION":
        "Radioactive waste collecting and/or local hauling in combination with disposal and/or treatment facilities",
    },
    {
      NAICS22: "562211",
      "INDEX ITEM DESCRIPTION": "Radioactive waste disposal facilities",
    },
    {
      NAICS22: "562211",
      "INDEX ITEM DESCRIPTION": "Radioactive waste treatment facilities",
    },
    {
      NAICS22: "562211",
      "INDEX ITEM DESCRIPTION": "Waste disposal facilities, hazardous",
    },
    {
      NAICS22: "562211",
      "INDEX ITEM DESCRIPTION": "Waste treatment facilities, hazardous",
    },
    {
      NAICS22: "562211",
      "INDEX ITEM DESCRIPTION": "Waste treatment plants, hazardous",
    },
    {
      NAICS22: "562212",
      "INDEX ITEM DESCRIPTION": "Dumps, nonhazardous solid waste (e.g., trash)",
    },
    {
      NAICS22: "562212",
      "INDEX ITEM DESCRIPTION": "Garbage disposal landfills",
    },
    {
      NAICS22: "562212",
      "INDEX ITEM DESCRIPTION": "Garbage dumps",
    },
    {
      NAICS22: "562212",
      "INDEX ITEM DESCRIPTION": "Landfills",
    },
    {
      NAICS22: "562212",
      "INDEX ITEM DESCRIPTION":
        "Refuse collecting and operating solid waste landfills",
    },
    {
      NAICS22: "562212",
      "INDEX ITEM DESCRIPTION": "Refuse disposal landfills",
    },
    {
      NAICS22: "562212",
      "INDEX ITEM DESCRIPTION": "Rubbish disposal landfills",
    },
    {
      NAICS22: "562212",
      "INDEX ITEM DESCRIPTION": "Sanitary landfills",
    },
    {
      NAICS22: "562212",
      "INDEX ITEM DESCRIPTION": "Sludge disposal sites",
    },
    {
      NAICS22: "562212",
      "INDEX ITEM DESCRIPTION":
        "Solid waste landfills combined with collection and/or local hauling of nonhazardous waste materials",
    },
    {
      NAICS22: "562212",
      "INDEX ITEM DESCRIPTION": "Solid waste landfills, nonhazardous",
    },
    {
      NAICS22: "562212",
      "INDEX ITEM DESCRIPTION": "Trash disposal landfills",
    },
    {
      NAICS22: "562212",
      "INDEX ITEM DESCRIPTION": "Waste disposal landfills, nonhazardous solid",
    },
    {
      NAICS22: "562213",
      "INDEX ITEM DESCRIPTION": "Combustors, nonhazardous solid waste",
    },
    {
      NAICS22: "562213",
      "INDEX ITEM DESCRIPTION": "Garbage disposal combustors or incinerators",
    },
    {
      NAICS22: "562213",
      "INDEX ITEM DESCRIPTION": "Incinerators, nonhazardous solid waste",
    },
    {
      NAICS22: "562213",
      "INDEX ITEM DESCRIPTION":
        "Power generation, nonhazardous solid waste combustor or incinerator electric",
    },
    {
      NAICS22: "562213",
      "INDEX ITEM DESCRIPTION": "Refuse disposal combustors or incinerators",
    },
    {
      NAICS22: "562213",
      "INDEX ITEM DESCRIPTION": "Rubbish disposal combustors or incinerators",
    },
    {
      NAICS22: "562213",
      "INDEX ITEM DESCRIPTION":
        "Solid waste combustors or incinerators, nonhazardous",
    },
    {
      NAICS22: "562213",
      "INDEX ITEM DESCRIPTION": "Trash disposal combustors or incinerators",
    },
    {
      NAICS22: "562213",
      "INDEX ITEM DESCRIPTION":
        "Waste disposal combustors or incinerators, nonhazardous solid",
    },
    {
      NAICS22: "562219",
      "INDEX ITEM DESCRIPTION": "Compost dumps",
    },
    {
      NAICS22: "562219",
      "INDEX ITEM DESCRIPTION": "Dumps, compost",
    },
    {
      NAICS22: "562219",
      "INDEX ITEM DESCRIPTION": "Lawn waste disposal facilities",
    },
    {
      NAICS22: "562219",
      "INDEX ITEM DESCRIPTION":
        "Nonhazardous waste treatment and disposal facilities (except combustors, incinerators, landfills, sewer systems, sewage treatment facilities)",
    },
    {
      NAICS22: "562219",
      "INDEX ITEM DESCRIPTION":
        "Waste (except sewage) treatment facilities, nonhazardous",
    },
    {
      NAICS22: "562910",
      "INDEX ITEM DESCRIPTION": "Asbestos abatement services",
    },
    {
      NAICS22: "562910",
      "INDEX ITEM DESCRIPTION": "Asbestos removal contractors",
    },
    {
      NAICS22: "562910",
      "INDEX ITEM DESCRIPTION": "Biohazard cleanup services",
    },
    {
      NAICS22: "562910",
      "INDEX ITEM DESCRIPTION": "Crime scene cleanup services",
    },
    {
      NAICS22: "562910",
      "INDEX ITEM DESCRIPTION": "Environmental remediation services",
    },
    {
      NAICS22: "562910",
      "INDEX ITEM DESCRIPTION":
        "Hazardous material storage tank removal and disposal services",
    },
    {
      NAICS22: "562910",
      "INDEX ITEM DESCRIPTION": "Lead paint abatement services",
    },
    {
      NAICS22: "562910",
      "INDEX ITEM DESCRIPTION": "Lead paint removal contractors",
    },
    {
      NAICS22: "562910",
      "INDEX ITEM DESCRIPTION":
        "Mine reclamation services, integrated (e.g., demolition, hazardous material removal, soil remediation, revegetation)",
    },
    {
      NAICS22: "562910",
      "INDEX ITEM DESCRIPTION": "Mold remediation services",
    },
    {
      NAICS22: "562910",
      "INDEX ITEM DESCRIPTION": "Oil spill cleanup services",
    },
    {
      NAICS22: "562910",
      "INDEX ITEM DESCRIPTION": "Radon remediation cleanup services",
    },
    {
      NAICS22: "562910",
      "INDEX ITEM DESCRIPTION":
        "Remediation and cleanup of contaminated buildings, mine sites, soil, or ground water",
    },
    {
      NAICS22: "562910",
      "INDEX ITEM DESCRIPTION": "Remediation services, environmental",
    },
    {
      NAICS22: "562910",
      "INDEX ITEM DESCRIPTION": "Site remediation services",
    },
    {
      NAICS22: "562910",
      "INDEX ITEM DESCRIPTION": "Soil remediation services",
    },
    {
      NAICS22: "562910",
      "INDEX ITEM DESCRIPTION": "Toxic material abatement services",
    },
    {
      NAICS22: "562910",
      "INDEX ITEM DESCRIPTION": "Toxic material removal contractors",
    },
    {
      NAICS22: "562920",
      "INDEX ITEM DESCRIPTION": "Materials recovery facilities (MRF)",
    },
    {
      NAICS22: "562920",
      "INDEX ITEM DESCRIPTION": "MRF (materials recovery facilities)",
    },
    {
      NAICS22: "562920",
      "INDEX ITEM DESCRIPTION": "Recyclable materials recovery facilities",
    },
    {
      NAICS22: "562920",
      "INDEX ITEM DESCRIPTION":
        "Removal of recyclable materials from a waste stream",
    },
    {
      NAICS22: "562920",
      "INDEX ITEM DESCRIPTION": "Waste recovery facilities",
    },
    {
      NAICS22: "562991",
      "INDEX ITEM DESCRIPTION": "Cesspool cleaning services",
    },
    {
      NAICS22: "562991",
      "INDEX ITEM DESCRIPTION":
        "Portable toilet pumping (i.e., cleaning) services",
    },
    {
      NAICS22: "562991",
      "INDEX ITEM DESCRIPTION": "Portable toilet renting and/or servicing",
    },
    {
      NAICS22: "562991",
      "INDEX ITEM DESCRIPTION":
        "Pumping (i.e., cleaning) cesspools and septic tanks",
    },
    {
      NAICS22: "562991",
      "INDEX ITEM DESCRIPTION": "Pumping (i.e., cleaning) portable toilets",
    },
    {
      NAICS22: "562991",
      "INDEX ITEM DESCRIPTION": "Septic tank cleaning services",
    },
    {
      NAICS22: "562991",
      "INDEX ITEM DESCRIPTION": "Septic tank pumping (i.e., cleaning) services",
    },
    {
      NAICS22: "562991",
      "INDEX ITEM DESCRIPTION": "Tank cleaning services, septic",
    },
    {
      NAICS22: "562991",
      "INDEX ITEM DESCRIPTION": "Toilet renting and/or servicing, portable",
    },
    {
      NAICS22: "562998",
      "INDEX ITEM DESCRIPTION": "Beach maintenance and cleaning services",
    },
    {
      NAICS22: "562998",
      "INDEX ITEM DESCRIPTION": "Catch basin cleaning services",
    },
    {
      NAICS22: "562998",
      "INDEX ITEM DESCRIPTION":
        "Disaster recovery services (i.e., cleanup, salvaging), without providing remediation services",
    },
    {
      NAICS22: "562998",
      "INDEX ITEM DESCRIPTION": "Grease trap cleaning",
    },
    {
      NAICS22: "562998",
      "INDEX ITEM DESCRIPTION": "Lake maintenance and cleaning services",
    },
    {
      NAICS22: "562998",
      "INDEX ITEM DESCRIPTION": "Pond maintenance and cleaning services",
    },
    {
      NAICS22: "562998",
      "INDEX ITEM DESCRIPTION": "Reservoir maintenance and cleaning services",
    },
    {
      NAICS22: "562998",
      "INDEX ITEM DESCRIPTION": "Sewer cleaning and rodding services",
    },
    {
      NAICS22: "562998",
      "INDEX ITEM DESCRIPTION": "Sewer cleanout services",
    },
    {
      NAICS22: "562998",
      "INDEX ITEM DESCRIPTION": "Storm basin cleanout services",
    },
    {
      NAICS22: "562998",
      "INDEX ITEM DESCRIPTION":
        "Tank cleaning and disposal services, commercial or industrial",
    },
    {
      NAICS22: "611110",
      "INDEX ITEM DESCRIPTION": "Academies, elementary or secondary",
    },
    {
      NAICS22: "611110",
      "INDEX ITEM DESCRIPTION": "Boarding schools, elementary or secondary",
    },
    {
      NAICS22: "611110",
      "INDEX ITEM DESCRIPTION": "Charter schools",
    },
    {
      NAICS22: "611110",
      "INDEX ITEM DESCRIPTION": "Elementary and secondary schools",
    },
    {
      NAICS22: "611110",
      "INDEX ITEM DESCRIPTION": "Elementary schools",
    },
    {
      NAICS22: "611110",
      "INDEX ITEM DESCRIPTION": "Finishing schools, secondary",
    },
    {
      NAICS22: "611110",
      "INDEX ITEM DESCRIPTION": "High schools",
    },
    {
      NAICS22: "611110",
      "INDEX ITEM DESCRIPTION":
        "High schools offering both academic and technical courses",
    },
    {
      NAICS22: "611110",
      "INDEX ITEM DESCRIPTION":
        "High schools offering both academic and vocational courses",
    },
    {
      NAICS22: "611110",
      "INDEX ITEM DESCRIPTION": "Junior high schools",
    },
    {
      NAICS22: "611110",
      "INDEX ITEM DESCRIPTION": "Kindergartens",
    },
    {
      NAICS22: "611110",
      "INDEX ITEM DESCRIPTION": "Kindergartens, combined with preschools",
    },
    {
      NAICS22: "611110",
      "INDEX ITEM DESCRIPTION": "Middle schools",
    },
    {
      NAICS22: "611110",
      "INDEX ITEM DESCRIPTION": "Military academies, elementary or secondary",
    },
    {
      NAICS22: "611110",
      "INDEX ITEM DESCRIPTION": "Montessori schools, elementary or secondary",
    },
    {
      NAICS22: "611110",
      "INDEX ITEM DESCRIPTION": "Parochial schools, elementary or secondary",
    },
    {
      NAICS22: "611110",
      "INDEX ITEM DESCRIPTION": "Preparatory schools, elementary or secondary",
    },
    {
      NAICS22: "611110",
      "INDEX ITEM DESCRIPTION": "Primary schools",
    },
    {
      NAICS22: "611110",
      "INDEX ITEM DESCRIPTION": "Private schools, elementary or secondary",
    },
    {
      NAICS22: "611110",
      "INDEX ITEM DESCRIPTION": "Public schools, elementary or secondary",
    },
    {
      NAICS22: "611110",
      "INDEX ITEM DESCRIPTION": "School boards, elementary and secondary",
    },
    {
      NAICS22: "611110",
      "INDEX ITEM DESCRIPTION": "School districts, elementary or secondary",
    },
    {
      NAICS22: "611110",
      "INDEX ITEM DESCRIPTION":
        "Schools for the intellectually and developmentally disabled (except preschool, job training, vocational rehabilitation)",
    },
    {
      NAICS22: "611110",
      "INDEX ITEM DESCRIPTION":
        "Schools for the physically disabled, elementary or secondary",
    },
    {
      NAICS22: "611110",
      "INDEX ITEM DESCRIPTION": "Schools, elementary",
    },
    {
      NAICS22: "611110",
      "INDEX ITEM DESCRIPTION":
        "Schools, online, elementary- or secondary-level (through a website or mobile application)",
    },
    {
      NAICS22: "611110",
      "INDEX ITEM DESCRIPTION": "Schools, secondary",
    },
    {
      NAICS22: "611110",
      "INDEX ITEM DESCRIPTION":
        "Secondary schools offering both academic and technical courses",
    },
    {
      NAICS22: "611110",
      "INDEX ITEM DESCRIPTION": "Seminaries, below university grade",
    },
    {
      NAICS22: "611210",
      "INDEX ITEM DESCRIPTION": "Academies, junior college",
    },
    {
      NAICS22: "611210",
      "INDEX ITEM DESCRIPTION": "Colleges, community",
    },
    {
      NAICS22: "611210",
      "INDEX ITEM DESCRIPTION": "Colleges, junior",
    },
    {
      NAICS22: "611210",
      "INDEX ITEM DESCRIPTION": "Community colleges",
    },
    {
      NAICS22: "611210",
      "INDEX ITEM DESCRIPTION":
        "Community colleges offering a wide variety of academic and technical training",
    },
    {
      NAICS22: "611210",
      "INDEX ITEM DESCRIPTION": "Junior colleges",
    },
    {
      NAICS22: "611210",
      "INDEX ITEM DESCRIPTION":
        "Junior colleges offering a wide variety of academic and technical training",
    },
    {
      NAICS22: "611210",
      "INDEX ITEM DESCRIPTION": "Schools, junior college",
    },
    {
      NAICS22: "611210",
      "INDEX ITEM DESCRIPTION": "Schools, junior college vocational",
    },
    {
      NAICS22: "611210",
      "INDEX ITEM DESCRIPTION":
        "Schools, online, junior college-level (through a website or mobile application)",
    },
    {
      NAICS22: "611310",
      "INDEX ITEM DESCRIPTION": "Academies, college or university",
    },
    {
      NAICS22: "611310",
      "INDEX ITEM DESCRIPTION": "Academies, military service (college)",
    },
    {
      NAICS22: "611310",
      "INDEX ITEM DESCRIPTION": "Bible colleges offering baccalaureate degrees",
    },
    {
      NAICS22: "611310",
      "INDEX ITEM DESCRIPTION":
        "Business colleges or schools offering baccalaureate or graduate degrees",
    },
    {
      NAICS22: "611310",
      "INDEX ITEM DESCRIPTION": "Coast Guard Academy",
    },
    {
      NAICS22: "611310",
      "INDEX ITEM DESCRIPTION": "Colleges (except junior colleges)",
    },
    {
      NAICS22: "611310",
      "INDEX ITEM DESCRIPTION":
        "Colleges, universities, and professional schools",
    },
    {
      NAICS22: "611310",
      "INDEX ITEM DESCRIPTION":
        "Conservatories of music (colleges or universities)",
    },
    {
      NAICS22: "611310",
      "INDEX ITEM DESCRIPTION": "Dental schools",
    },
    {
      NAICS22: "611310",
      "INDEX ITEM DESCRIPTION":
        "Hospital management schools offering baccalaureate or graduate degrees",
    },
    {
      NAICS22: "611310",
      "INDEX ITEM DESCRIPTION":
        "Hospitality management schools offering baccalaureate or graduate degrees",
    },
    {
      NAICS22: "611310",
      "INDEX ITEM DESCRIPTION": "Law schools",
    },
    {
      NAICS22: "611310",
      "INDEX ITEM DESCRIPTION": "Medical schools",
    },
    {
      NAICS22: "611310",
      "INDEX ITEM DESCRIPTION": "Military academies, college-level",
    },
    {
      NAICS22: "611310",
      "INDEX ITEM DESCRIPTION": "Military service academies (college)",
    },
    {
      NAICS22: "611310",
      "INDEX ITEM DESCRIPTION": "Parochial schools, college-level",
    },
    {
      NAICS22: "611310",
      "INDEX ITEM DESCRIPTION":
        "Private colleges (except community or junior college)",
    },
    {
      NAICS22: "611310",
      "INDEX ITEM DESCRIPTION":
        "Professional schools (e.g., business administration, dental, law, medical)",
    },
    {
      NAICS22: "611310",
      "INDEX ITEM DESCRIPTION": "Schools, correspondence, college-level",
    },
    {
      NAICS22: "611310",
      "INDEX ITEM DESCRIPTION": "Schools, medical",
    },
    {
      NAICS22: "611310",
      "INDEX ITEM DESCRIPTION": "Schools, music (colleges or universities)",
    },
    {
      NAICS22: "611310",
      "INDEX ITEM DESCRIPTION":
        "Schools, online, college-level (through a website or mobile application)",
    },
    {
      NAICS22: "611310",
      "INDEX ITEM DESCRIPTION":
        "Schools, professional (colleges or universities)",
    },
    {
      NAICS22: "611310",
      "INDEX ITEM DESCRIPTION":
        "Seminaries, theological, offering baccalaureate or graduate degrees",
    },
    {
      NAICS22: "611310",
      "INDEX ITEM DESCRIPTION":
        "Theological seminaries offering baccalaureate or graduate degrees",
    },
    {
      NAICS22: "611310",
      "INDEX ITEM DESCRIPTION": "Universities",
    },
    {
      NAICS22: "611410",
      "INDEX ITEM DESCRIPTION":
        "Business colleges or schools not offering academic degrees",
    },
    {
      NAICS22: "611410",
      "INDEX ITEM DESCRIPTION": "Business schools not offering academic degrees",
    },
    {
      NAICS22: "611410",
      "INDEX ITEM DESCRIPTION": "Clerical schools ",
    },
    {
      NAICS22: "611410",
      "INDEX ITEM DESCRIPTION": "Court reporting schools",
    },
    {
      NAICS22: "611410",
      "INDEX ITEM DESCRIPTION":
        "Schools, business, not offering academic degrees",
    },
    {
      NAICS22: "611410",
      "INDEX ITEM DESCRIPTION": "Secretarial schools",
    },
    {
      NAICS22: "611420",
      "INDEX ITEM DESCRIPTION": "Computer operator training",
    },
    {
      NAICS22: "611420",
      "INDEX ITEM DESCRIPTION": "Computer programming schools",
    },
    {
      NAICS22: "611420",
      "INDEX ITEM DESCRIPTION":
        "Computer programming, software, and systems training, online (through a website or mobile application)",
    },
    {
      NAICS22: "611420",
      "INDEX ITEM DESCRIPTION":
        "Computer programming, software, and systems training, online learning marketplace services (through a website or mobile application)",
    },
    {
      NAICS22: "611420",
      "INDEX ITEM DESCRIPTION": "Computer software training",
    },
    {
      NAICS22: "611420",
      "INDEX ITEM DESCRIPTION": "Computer training (except repair)",
    },
    {
      NAICS22: "611420",
      "INDEX ITEM DESCRIPTION": "Local area network (LAN) management training",
    },
    {
      NAICS22: "611420",
      "INDEX ITEM DESCRIPTION": "Software application training",
    },
    {
      NAICS22: "611430",
      "INDEX ITEM DESCRIPTION":
        "Continuing education online learning marketplace services (through a website or mobile application)",
    },
    {
      NAICS22: "611430",
      "INDEX ITEM DESCRIPTION": "Continuing education seminars or conferences",
    },
    {
      NAICS22: "611430",
      "INDEX ITEM DESCRIPTION":
        "Continuing education training, online (through a website or mobile application)",
    },
    {
      NAICS22: "611430",
      "INDEX ITEM DESCRIPTION": "Management development training",
    },
    {
      NAICS22: "611430",
      "INDEX ITEM DESCRIPTION": "Professional development training",
    },
    {
      NAICS22: "611430",
      "INDEX ITEM DESCRIPTION": "Quality assurance training",
    },
    {
      NAICS22: "611511",
      "INDEX ITEM DESCRIPTION": "Barber colleges",
    },
    {
      NAICS22: "611511",
      "INDEX ITEM DESCRIPTION": "Beauty schools",
    },
    {
      NAICS22: "611511",
      "INDEX ITEM DESCRIPTION": "Colleges, barber and beauty",
    },
    {
      NAICS22: "611511",
      "INDEX ITEM DESCRIPTION": "Cosmetic art schools (e.g., makeup, skin care)",
    },
    {
      NAICS22: "611511",
      "INDEX ITEM DESCRIPTION": "Cosmetology schools",
    },
    {
      NAICS22: "611511",
      "INDEX ITEM DESCRIPTION": "Manicure and pedicure schools",
    },
    {
      NAICS22: "611511",
      "INDEX ITEM DESCRIPTION": "Schools, barber",
    },
    {
      NAICS22: "611511",
      "INDEX ITEM DESCRIPTION": "Schools, beauty",
    },
    {
      NAICS22: "611511",
      "INDEX ITEM DESCRIPTION": "Schools, cosmetology",
    },
    {
      NAICS22: "611512",
      "INDEX ITEM DESCRIPTION": "Aviation schools",
    },
    {
      NAICS22: "611512",
      "INDEX ITEM DESCRIPTION": "Flight simulation training",
    },
    {
      NAICS22: "611512",
      "INDEX ITEM DESCRIPTION": "Flight training schools",
    },
    {
      NAICS22: "611512",
      "INDEX ITEM DESCRIPTION": "Flying instruction",
    },
    {
      NAICS22: "611512",
      "INDEX ITEM DESCRIPTION": "Military flight instruction training",
    },
    {
      NAICS22: "611512",
      "INDEX ITEM DESCRIPTION": "Schools, aviation",
    },
    {
      NAICS22: "611513",
      "INDEX ITEM DESCRIPTION": "Apprenticeship training programs",
    },
    {
      NAICS22: "611513",
      "INDEX ITEM DESCRIPTION": "Carpenters' apprenticeship training",
    },
    {
      NAICS22: "611513",
      "INDEX ITEM DESCRIPTION": "Craft union apprenticeship training programs",
    },
    {
      NAICS22: "611513",
      "INDEX ITEM DESCRIPTION": "Electricians' apprenticeship training",
    },
    {
      NAICS22: "611513",
      "INDEX ITEM DESCRIPTION": "Mechanic's apprenticeship training",
    },
    {
      NAICS22: "611513",
      "INDEX ITEM DESCRIPTION": "Plumbers' apprenticeship training",
    },
    {
      NAICS22: "611513",
      "INDEX ITEM DESCRIPTION": "Sheet metal workers' apprenticeship training",
    },
    {
      NAICS22: "611513",
      "INDEX ITEM DESCRIPTION": "Steam fitters' apprenticeship training",
    },
    {
      NAICS22: "611513",
      "INDEX ITEM DESCRIPTION": "Trade union apprenticeship training programs",
    },
    {
      NAICS22: "611513",
      "INDEX ITEM DESCRIPTION": "Vocational apprenticeship training",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION": "Acupuncture training",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION": "Air traffic control schools",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION": "Art schools, commercial or graphic",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION": "Banking schools (training in banking)",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION": "Bartending schools",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION": "Broadcasting schools",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION": "Bus driver training",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION": "Chauffeur training",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION": "Computer repair training",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION": "Cooking schools",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION": "Culinary arts schools",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION": "Dental hygienist schools",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION": "Dental technician schools",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION": "Electronic equipment repair training",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION": "Firefighter training schools",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION": "Flight attendant schools",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION": "Graphic arts schools",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION": "Heavy equipment operation schools",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION": "Heavy equipment repair training",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION": "Home health aid schools",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION": "Hospital management schools (except academic)",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION":
        "Hospitality management schools (except academic)",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION": "Marine navigational schools",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION": "Massage therapist instruction",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION": "Mechanic's schools (except apprenticeship)",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION": "Medical technician schools",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION": "Modeling schools",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION": "Nurse's aides schools",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION": "Nursing schools (except academic)",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION": "Personal fitness instructor training",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION": "Photography schools, commercial",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION": "Police training schools",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION": "Real estate schools",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION": "Restaurant management schools (except academic)",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION": "Security guard training",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION":
        "Specialized military training (except flight instruction, academies, and basic training)",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION": "Truck driving schools",
    },
    {
      NAICS22: "611519",
      "INDEX ITEM DESCRIPTION": "Yoga instructor training",
    },
    {
      NAICS22: "611610",
      "INDEX ITEM DESCRIPTION": "Art (except commercial or graphic) instruction",
    },
    {
      NAICS22: "611610",
      "INDEX ITEM DESCRIPTION": "Art schools (except academic), fine",
    },
    {
      NAICS22: "611610",
      "INDEX ITEM DESCRIPTION": "Ballet schools (except academic)",
    },
    {
      NAICS22: "611610",
      "INDEX ITEM DESCRIPTION": "Ceramics instruction",
    },
    {
      NAICS22: "611610",
      "INDEX ITEM DESCRIPTION": "Conservatory of music (except academic)",
    },
    {
      NAICS22: "611610",
      "INDEX ITEM DESCRIPTION": "Dance instruction",
    },
    {
      NAICS22: "611610",
      "INDEX ITEM DESCRIPTION": "Dance schools",
    },
    {
      NAICS22: "611610",
      "INDEX ITEM DESCRIPTION": "Dance studios",
    },
    {
      NAICS22: "611610",
      "INDEX ITEM DESCRIPTION": "Drama schools (except academic)",
    },
    {
      NAICS22: "611610",
      "INDEX ITEM DESCRIPTION": "Fine arts schools (except academic)",
    },
    {
      NAICS22: "611610",
      "INDEX ITEM DESCRIPTION": "Handicrafts instruction",
    },
    {
      NAICS22: "611610",
      "INDEX ITEM DESCRIPTION": "Music instruction (e.g., guitar, piano)",
    },
    {
      NAICS22: "611610",
      "INDEX ITEM DESCRIPTION": "Music schools (except academic)",
    },
    {
      NAICS22: "611610",
      "INDEX ITEM DESCRIPTION": "Painting instruction",
    },
    {
      NAICS22: "611610",
      "INDEX ITEM DESCRIPTION": "Performing arts schools (except academic)",
    },
    {
      NAICS22: "611610",
      "INDEX ITEM DESCRIPTION": "Photography schools, art",
    },
    {
      NAICS22: "611610",
      "INDEX ITEM DESCRIPTION": "Schools, drama (except academic)",
    },
    {
      NAICS22: "611610",
      "INDEX ITEM DESCRIPTION": "Schools, music (except academic)",
    },
    {
      NAICS22: "611610",
      "INDEX ITEM DESCRIPTION": "Sculpture instruction",
    },
    {
      NAICS22: "611610",
      "INDEX ITEM DESCRIPTION": "Singing instruction",
    },
    {
      NAICS22: "611610",
      "INDEX ITEM DESCRIPTION": "Theater schools",
    },
    {
      NAICS22: "611610",
      "INDEX ITEM DESCRIPTION": "Voice instruction",
    },
    {
      NAICS22: "611620",
      "INDEX ITEM DESCRIPTION": "Academies, riding instruction",
    },
    {
      NAICS22: "611620",
      "INDEX ITEM DESCRIPTION": "Aerobic dance and exercise instruction",
    },
    {
      NAICS22: "611620",
      "INDEX ITEM DESCRIPTION": "Automobile racing schools",
    },
    {
      NAICS22: "611620",
      "INDEX ITEM DESCRIPTION": "Baseball instruction, camps or schools",
    },
    {
      NAICS22: "611620",
      "INDEX ITEM DESCRIPTION": "Basketball instruction, camps or schools",
    },
    {
      NAICS22: "611620",
      "INDEX ITEM DESCRIPTION": "Baton instruction",
    },
    {
      NAICS22: "611620",
      "INDEX ITEM DESCRIPTION": "Bowling instruction",
    },
    {
      NAICS22: "611620",
      "INDEX ITEM DESCRIPTION": "Boys' camps, sports instruction",
    },
    {
      NAICS22: "611620",
      "INDEX ITEM DESCRIPTION": "Boys' camps, sports instructor",
    },
    {
      NAICS22: "611620",
      "INDEX ITEM DESCRIPTION": "Camps, sports instruction",
    },
    {
      NAICS22: "611620",
      "INDEX ITEM DESCRIPTION": "Cheerleading instruction, camps or schools",
    },
    {
      NAICS22: "611620",
      "INDEX ITEM DESCRIPTION": "Football instruction, camps or schools",
    },
    {
      NAICS22: "611620",
      "INDEX ITEM DESCRIPTION": "Girls' camps, sports instruction",
    },
    {
      NAICS22: "611620",
      "INDEX ITEM DESCRIPTION": "Golf instruction, camps or schools",
    },
    {
      NAICS22: "611620",
      "INDEX ITEM DESCRIPTION": "Gymnastics instruction, camps or schools",
    },
    {
      NAICS22: "611620",
      "INDEX ITEM DESCRIPTION": "Hockey instruction, camps or schools",
    },
    {
      NAICS22: "611620",
      "INDEX ITEM DESCRIPTION": "Jai alai instruction, camps or schools",
    },
    {
      NAICS22: "611620",
      "INDEX ITEM DESCRIPTION": "Judo instruction, camps or schools",
    },
    {
      NAICS22: "611620",
      "INDEX ITEM DESCRIPTION": "Karate instruction, camps or schools",
    },
    {
      NAICS22: "611620",
      "INDEX ITEM DESCRIPTION": "Martial arts instruction, camps or schools",
    },
    {
      NAICS22: "611620",
      "INDEX ITEM DESCRIPTION":
        "Professional sports (e.g., golf, skiing, swimming, tennis) instructors (i.e., not participating in sporting events)",
    },
    {
      NAICS22: "611620",
      "INDEX ITEM DESCRIPTION": "Riding instruction academies or schools",
    },
    {
      NAICS22: "611620",
      "INDEX ITEM DESCRIPTION": "Schools, sports instruction",
    },
    {
      NAICS22: "611620",
      "INDEX ITEM DESCRIPTION": "Scuba instruction, camps or schools",
    },
    {
      NAICS22: "611620",
      "INDEX ITEM DESCRIPTION": "Skiing instruction, camps or schools",
    },
    {
      NAICS22: "611620",
      "INDEX ITEM DESCRIPTION": "Skin diving instruction, camps or schools",
    },
    {
      NAICS22: "611620",
      "INDEX ITEM DESCRIPTION": "Sky diving instruction, camps or schools",
    },
    {
      NAICS22: "611620",
      "INDEX ITEM DESCRIPTION": "Soccer instruction, camps or schools",
    },
    {
      NAICS22: "611620",
      "INDEX ITEM DESCRIPTION":
        "Sports camps (e.g., baseball, basketball, football), instructional",
    },
    {
      NAICS22: "611620",
      "INDEX ITEM DESCRIPTION": "Sports instruction, camps or schools",
    },
    {
      NAICS22: "611620",
      "INDEX ITEM DESCRIPTION":
        "Sports instructors, independent (i.e., not participating in sporting events)",
    },
    {
      NAICS22: "611620",
      "INDEX ITEM DESCRIPTION": "Swimming instruction",
    },
    {
      NAICS22: "611620",
      "INDEX ITEM DESCRIPTION": "Tennis instruction, camps or schools",
    },
    {
      NAICS22: "611630",
      "INDEX ITEM DESCRIPTION": "Foreign language schools",
    },
    {
      NAICS22: "611630",
      "INDEX ITEM DESCRIPTION": "Language schools",
    },
    {
      NAICS22: "611630",
      "INDEX ITEM DESCRIPTION": "Schools, language",
    },
    {
      NAICS22: "611630",
      "INDEX ITEM DESCRIPTION": "Second language instruction",
    },
    {
      NAICS22: "611630",
      "INDEX ITEM DESCRIPTION": "Sign language instruction",
    },
    {
      NAICS22: "611630",
      "INDEX ITEM DESCRIPTION": "Sign language schools",
    },
    {
      NAICS22: "611691",
      "INDEX ITEM DESCRIPTION": "Academic tutoring services",
    },
    {
      NAICS22: "611691",
      "INDEX ITEM DESCRIPTION": "Adult literacy instruction",
    },
    {
      NAICS22: "611691",
      "INDEX ITEM DESCRIPTION": "College board preparation centers",
    },
    {
      NAICS22: "611691",
      "INDEX ITEM DESCRIPTION": "College entrance exam preparation instruction",
    },
    {
      NAICS22: "611691",
      "INDEX ITEM DESCRIPTION":
        "Exam preparation and tutoring online learning marketplace services (through a website or mobile application)",
    },
    {
      NAICS22: "611691",
      "INDEX ITEM DESCRIPTION":
        "Exam preparation and tutoring services, online (through a website or mobile application)",
    },
    {
      NAICS22: "611691",
      "INDEX ITEM DESCRIPTION": "Exam preparation services",
    },
    {
      NAICS22: "611691",
      "INDEX ITEM DESCRIPTION":
        "High school equivalency (e.g., GED) exam instruction",
    },
    {
      NAICS22: "611691",
      "INDEX ITEM DESCRIPTION": "Learning centers offering remedial courses",
    },
    {
      NAICS22: "611691",
      "INDEX ITEM DESCRIPTION": "Professional examination review instruction",
    },
    {
      NAICS22: "611691",
      "INDEX ITEM DESCRIPTION": "Tutoring,  academic",
    },
    {
      NAICS22: "611692",
      "INDEX ITEM DESCRIPTION": "Automobile driving schools",
    },
    {
      NAICS22: "611692",
      "INDEX ITEM DESCRIPTION": "Driver education",
    },
    {
      NAICS22: "611692",
      "INDEX ITEM DESCRIPTION":
        "Driver training schools (except bus, heavy equipment, truck)",
    },
    {
      NAICS22: "611692",
      "INDEX ITEM DESCRIPTION": "Motorcycle driving schools",
    },
    {
      NAICS22: "611699",
      "INDEX ITEM DESCRIPTION": "Bible schools (except degree granting)",
    },
    {
      NAICS22: "611699",
      "INDEX ITEM DESCRIPTION": "Bridge and other card game instruction",
    },
    {
      NAICS22: "611699",
      "INDEX ITEM DESCRIPTION": "Charm schools",
    },
    {
      NAICS22: "611699",
      "INDEX ITEM DESCRIPTION": "Chess instruction",
    },
    {
      NAICS22: "611699",
      "INDEX ITEM DESCRIPTION":
        "CPR (cardiopulmonary resuscitation) training and certification",
    },
    {
      NAICS22: "611699",
      "INDEX ITEM DESCRIPTION": "Diction schools",
    },
    {
      NAICS22: "611699",
      "INDEX ITEM DESCRIPTION": "Firearms training",
    },
    {
      NAICS22: "611699",
      "INDEX ITEM DESCRIPTION": "First-aid instruction",
    },
    {
      NAICS22: "611699",
      "INDEX ITEM DESCRIPTION": "Life guard training",
    },
    {
      NAICS22: "611699",
      "INDEX ITEM DESCRIPTION": "Personal development schools",
    },
    {
      NAICS22: "611699",
      "INDEX ITEM DESCRIPTION": "Pilates instruction, camps or schools",
    },
    {
      NAICS22: "611699",
      "INDEX ITEM DESCRIPTION": "Public speaking training",
    },
    {
      NAICS22: "611699",
      "INDEX ITEM DESCRIPTION": "Self defense (except martial arts) instruction",
    },
    {
      NAICS22: "611699",
      "INDEX ITEM DESCRIPTION": "Speed reading instruction",
    },
    {
      NAICS22: "611699",
      "INDEX ITEM DESCRIPTION": "Survival training instruction",
    },
    {
      NAICS22: "611699",
      "INDEX ITEM DESCRIPTION": "Yoga instruction, camps or schools",
    },
    {
      NAICS22: "611710",
      "INDEX ITEM DESCRIPTION":
        "Career and vocational counseling services (except rehabilitative)",
    },
    {
      NAICS22: "611710",
      "INDEX ITEM DESCRIPTION": "College selection services",
    },
    {
      NAICS22: "611710",
      "INDEX ITEM DESCRIPTION": "Educational consultants",
    },
    {
      NAICS22: "611710",
      "INDEX ITEM DESCRIPTION": "Educational curriculum development services",
    },
    {
      NAICS22: "611710",
      "INDEX ITEM DESCRIPTION": "Educational guidance counseling services",
    },
    {
      NAICS22: "611710",
      "INDEX ITEM DESCRIPTION": "Educational support services",
    },
    {
      NAICS22: "611710",
      "INDEX ITEM DESCRIPTION": "Educational testing evaluation services",
    },
    {
      NAICS22: "611710",
      "INDEX ITEM DESCRIPTION": "Educational testing services",
    },
    {
      NAICS22: "611710",
      "INDEX ITEM DESCRIPTION": "School bus attendant services",
    },
    {
      NAICS22: "611710",
      "INDEX ITEM DESCRIPTION": "Student exchange programs",
    },
    {
      NAICS22: "611710",
      "INDEX ITEM DESCRIPTION": "Study abroad programs",
    },
    {
      NAICS22: "611710",
      "INDEX ITEM DESCRIPTION":
        "Test development and evaluation services, educational",
    },
    {
      NAICS22: "611710",
      "INDEX ITEM DESCRIPTION": "Testing services, educational",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION":
        "Acupuncturists' (MDs or DOs) offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION": "Allergists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION":
        "Anesthesiologists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION": "Cardiologists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION":
        "Clinical pathologists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION":
        "Dermatologists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION":
        "Doctors of osteopathic medicine (DOs, except mental health) offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION":
        "DOs' (doctors of osteopathic medicine, except mental health) offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION":
        "Family physicians' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION": "Forensic pathologists' offices ",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION":
        "Gastroenterologists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION": "Gynecologists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION":
        "Health screening services in physicians' offices",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION": "Immunologists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION": "Internists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION":
        "MDs' (medical doctors, except mental health) offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION":
        "Medical doctors' (MDs, except mental health) offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION": "Nephrologists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION": "Neurologists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION":
        "Neuropathologists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION": "Obstetricians' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION": "Oncologists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION":
        "Ophthalmologists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION":
        "Orthopedic physicians' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION":
        "Orthopedic surgeons' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION":
        "Osteopathic physicians' (except mental health) offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION":
        "Otolaryngologists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION":
        "Pathologists' (except oral, speech, voice) offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION":
        "Pathologists', forensic, offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION":
        "Pathologists', neuropathological, offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION":
        "Pathologists', surgical, offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION":
        "Pediatricians' (except mental health) offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION":
        "Physicians' (except mental health) offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION":
        "Plastic surgeons' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION": "Proctologists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION":
        "Pulmonary specialists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION": "Radiologists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION":
        "Surgeons' (except dental) offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION":
        "Surgical pathologists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION": "Urologists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621111",
      "INDEX ITEM DESCRIPTION":
        "Walk-in physicians' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621112",
      "INDEX ITEM DESCRIPTION":
        "Doctors of osteopathic medicine (DOs), mental health, offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621112",
      "INDEX ITEM DESCRIPTION":
        "DOs' (doctors of osteopathic medicine), mental health, offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621112",
      "INDEX ITEM DESCRIPTION":
        "MDs' (medical doctors), mental health, offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621112",
      "INDEX ITEM DESCRIPTION":
        "Medical doctors' (MDs), mental health, offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621112",
      "INDEX ITEM DESCRIPTION":
        "Mental health physicians' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621112",
      "INDEX ITEM DESCRIPTION":
        "Pediatricians', mental health, offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621112",
      "INDEX ITEM DESCRIPTION":
        "Physicians', mental health, offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621112",
      "INDEX ITEM DESCRIPTION": "Psychiatrists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621112",
      "INDEX ITEM DESCRIPTION":
        "Psychoanalysts' (MDs or DOs) offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621112",
      "INDEX ITEM DESCRIPTION":
        "Psychotherapists' (MDs or DOs) offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621210",
      "INDEX ITEM DESCRIPTION":
        "DDSs' (doctors of dental surgery) offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621210",
      "INDEX ITEM DESCRIPTION":
        "Dental surgeons' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621210",
      "INDEX ITEM DESCRIPTION": "Dentists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621210",
      "INDEX ITEM DESCRIPTION":
        "DMDs' (doctors of dental medicine) offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621210",
      "INDEX ITEM DESCRIPTION":
        "Doctors of dental medicine (DMDs) offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621210",
      "INDEX ITEM DESCRIPTION":
        "Doctors of dental surgery (DDSs) offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621210",
      "INDEX ITEM DESCRIPTION": "Endodontists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621210",
      "INDEX ITEM DESCRIPTION":
        "Family dentists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621210",
      "INDEX ITEM DESCRIPTION":
        "Oral and maxillofacial surgeons' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621210",
      "INDEX ITEM DESCRIPTION":
        "Oral pathologists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621210",
      "INDEX ITEM DESCRIPTION": "Orthodontists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621210",
      "INDEX ITEM DESCRIPTION":
        "Pathologists', oral, offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621210",
      "INDEX ITEM DESCRIPTION": "Periodontists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621210",
      "INDEX ITEM DESCRIPTION":
        "Prosthodontists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621210",
      "INDEX ITEM DESCRIPTION":
        "Surgeons', dental, offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621310",
      "INDEX ITEM DESCRIPTION": "Chiropractors' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621310",
      "INDEX ITEM DESCRIPTION":
        "DCs' (doctors of chiropractic) offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621310",
      "INDEX ITEM DESCRIPTION":
        "Doctors of chiropractic (DCs) offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621320",
      "INDEX ITEM DESCRIPTION":
        "Doctors of optometry (ODs) offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621320",
      "INDEX ITEM DESCRIPTION":
        "ODs' (doctors of optometry) offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621320",
      "INDEX ITEM DESCRIPTION": "Optometrists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621330",
      "INDEX ITEM DESCRIPTION":
        "Clinical psychologists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621330",
      "INDEX ITEM DESCRIPTION":
        "Doctors of psychology offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621330",
      "INDEX ITEM DESCRIPTION":
        "Psychoanalysts' (except MDs or DOs) offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621330",
      "INDEX ITEM DESCRIPTION":
        "Psychologists' offices (e.g., centers, clinics), clinical",
    },
    {
      NAICS22: "621330",
      "INDEX ITEM DESCRIPTION":
        "Psychotherapists' (except MDs or DOs) offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621330",
      "INDEX ITEM DESCRIPTION":
        "Social workers', mental health, offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621340",
      "INDEX ITEM DESCRIPTION":
        "Art therapists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621340",
      "INDEX ITEM DESCRIPTION": "Audiologists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621340",
      "INDEX ITEM DESCRIPTION":
        "Dance therapists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621340",
      "INDEX ITEM DESCRIPTION":
        "Equestrian physical therapists' offices (e.g., centers, clinics) ",
    },
    {
      NAICS22: "621340",
      "INDEX ITEM DESCRIPTION":
        "Exercise physiologists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621340",
      "INDEX ITEM DESCRIPTION":
        "Hearing testing services by offices of audiologists",
    },
    {
      NAICS22: "621340",
      "INDEX ITEM DESCRIPTION":
        "Industrial therapists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621340",
      "INDEX ITEM DESCRIPTION":
        "Music therapists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621340",
      "INDEX ITEM DESCRIPTION":
        "Occupational therapists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621340",
      "INDEX ITEM DESCRIPTION":
        "Pathologists', speech or voice, offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621340",
      "INDEX ITEM DESCRIPTION":
        "Physical therapists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621340",
      "INDEX ITEM DESCRIPTION":
        "Physical therapy offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621340",
      "INDEX ITEM DESCRIPTION":
        "Physical-integration practitioners' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621340",
      "INDEX ITEM DESCRIPTION":
        "Physiotherapists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621340",
      "INDEX ITEM DESCRIPTION":
        "Recreational (e.g., art, dance, music) therapists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621340",
      "INDEX ITEM DESCRIPTION":
        "Speech clinicians' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621340",
      "INDEX ITEM DESCRIPTION": "Speech defect clinics",
    },
    {
      NAICS22: "621340",
      "INDEX ITEM DESCRIPTION":
        "Speech pathologists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621340",
      "INDEX ITEM DESCRIPTION":
        "Speech therapists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621340",
      "INDEX ITEM DESCRIPTION":
        "Sports physical therapists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621340",
      "INDEX ITEM DESCRIPTION":
        "Voice pathologists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621391",
      "INDEX ITEM DESCRIPTION":
        "Doctors of podiatry (DPs) offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621391",
      "INDEX ITEM DESCRIPTION":
        "DPs' (doctors of podiatry) offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621391",
      "INDEX ITEM DESCRIPTION":
        "Foot specialists' (podiatry) offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621391",
      "INDEX ITEM DESCRIPTION": "Podiatrists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621391",
      "INDEX ITEM DESCRIPTION":
        "Popopediatricians' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621399",
      "INDEX ITEM DESCRIPTION":
        "Acupuncturists' (except MDs or DOs) offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621399",
      "INDEX ITEM DESCRIPTION":
        "Advanced practicing registered nurses’ (APRNs) offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621399",
      "INDEX ITEM DESCRIPTION":
        "Certified registered nurse anesthetists’ (CRNAs) offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621399",
      "INDEX ITEM DESCRIPTION":
        "Christian Science practitioners' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621399",
      "INDEX ITEM DESCRIPTION":
        "Clinical nurse specialists’ (CNSs) offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621399",
      "INDEX ITEM DESCRIPTION":
        "Clinical pharmacists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621399",
      "INDEX ITEM DESCRIPTION":
        "Dental hygienists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621399",
      "INDEX ITEM DESCRIPTION": "Denturists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621399",
      "INDEX ITEM DESCRIPTION": "Dietitians' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621399",
      "INDEX ITEM DESCRIPTION": "Herbalists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621399",
      "INDEX ITEM DESCRIPTION": "Home nursing services, private practice",
    },
    {
      NAICS22: "621399",
      "INDEX ITEM DESCRIPTION": "Homeopaths' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621399",
      "INDEX ITEM DESCRIPTION":
        "Hypnotherapists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621399",
      "INDEX ITEM DESCRIPTION":
        "Inhalation therapists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621399",
      "INDEX ITEM DESCRIPTION":
        "Licensed practical nurses' (LPNs) offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621399",
      "INDEX ITEM DESCRIPTION":
        "LPNs' (licensed practical nurses) offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621399",
      "INDEX ITEM DESCRIPTION":
        "Manual-arts therapists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621399",
      "INDEX ITEM DESCRIPTION":
        "Massage therapists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621399",
      "INDEX ITEM DESCRIPTION": "Midwives' offices (e.g., clinics)",
    },
    {
      NAICS22: "621399",
      "INDEX ITEM DESCRIPTION": "Naturopaths' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621399",
      "INDEX ITEM DESCRIPTION":
        "Nurse practitioners’ offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621399",
      "INDEX ITEM DESCRIPTION":
        "Nurses', licensed practical or registered, offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621399",
      "INDEX ITEM DESCRIPTION": "Nursing call centers",
    },
    {
      NAICS22: "621399",
      "INDEX ITEM DESCRIPTION": "Nutritionists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621399",
      "INDEX ITEM DESCRIPTION": "Ocularists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621399",
      "INDEX ITEM DESCRIPTION": "Orthotists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621399",
      "INDEX ITEM DESCRIPTION": "Paramedics' offices (e.g.,  centers, clinics)",
    },
    {
      NAICS22: "621399",
      "INDEX ITEM DESCRIPTION": "Pedorthics' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621399",
      "INDEX ITEM DESCRIPTION":
        "Physicians' assistants' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621399",
      "INDEX ITEM DESCRIPTION":
        "Practical nurses' offices (e.g., centers, clinics), licensed",
    },
    {
      NAICS22: "621399",
      "INDEX ITEM DESCRIPTION": "Prosthetists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621399",
      "INDEX ITEM DESCRIPTION":
        "Registered nurses' (RNs) offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621399",
      "INDEX ITEM DESCRIPTION":
        "Respiratory therapists' offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621399",
      "INDEX ITEM DESCRIPTION":
        "RNs' (registered nurses) offices (e.g., centers, clinics)",
    },
    {
      NAICS22: "621410",
      "INDEX ITEM DESCRIPTION": "Abortion clinics",
    },
    {
      NAICS22: "621410",
      "INDEX ITEM DESCRIPTION": "Birth control clinics",
    },
    {
      NAICS22: "621410",
      "INDEX ITEM DESCRIPTION": "Childbirth preparation classes",
    },
    {
      NAICS22: "621410",
      "INDEX ITEM DESCRIPTION": "Counseling services, family planning",
    },
    {
      NAICS22: "621410",
      "INDEX ITEM DESCRIPTION": "Family planning centers",
    },
    {
      NAICS22: "621410",
      "INDEX ITEM DESCRIPTION": "Family planning counseling services",
    },
    {
      NAICS22: "621410",
      "INDEX ITEM DESCRIPTION": "Fertility clinics",
    },
    {
      NAICS22: "621410",
      "INDEX ITEM DESCRIPTION": "Pregnancy counseling centers",
    },
    {
      NAICS22: "621410",
      "INDEX ITEM DESCRIPTION": "Reproductive health services centers",
    },
    {
      NAICS22: "621420",
      "INDEX ITEM DESCRIPTION":
        "Alcoholism treatment centers and clinics (except hospitals), outpatient",
    },
    {
      NAICS22: "621420",
      "INDEX ITEM DESCRIPTION":
        "Detoxification centers and clinics (except hospitals), outpatient",
    },
    {
      NAICS22: "621420",
      "INDEX ITEM DESCRIPTION":
        "Drug addiction treatment centers and clinics (except hospitals), outpatient",
    },
    {
      NAICS22: "621420",
      "INDEX ITEM DESCRIPTION":
        "Mental health centers and clinics (except hospitals), outpatient",
    },
    {
      NAICS22: "621420",
      "INDEX ITEM DESCRIPTION":
        "Outpatient mental health centers and clinics (except hospitals)",
    },
    {
      NAICS22: "621420",
      "INDEX ITEM DESCRIPTION":
        "Outpatient treatment centers and clinics (except hospitals) for substance abuse (i.e., alcoholism, drug addiction)",
    },
    {
      NAICS22: "621420",
      "INDEX ITEM DESCRIPTION":
        "Outpatient treatment centers and clinics for alcoholism",
    },
    {
      NAICS22: "621420",
      "INDEX ITEM DESCRIPTION":
        "Outpatient treatment centers and clinics for drug addiction",
    },
    {
      NAICS22: "621420",
      "INDEX ITEM DESCRIPTION":
        "Psychiatric centers and clinics (except hospitals), outpatient",
    },
    {
      NAICS22: "621420",
      "INDEX ITEM DESCRIPTION":
        "Substance abuse treatment centers and clinics (except hospitals), outpatient",
    },
    {
      NAICS22: "621491",
      "INDEX ITEM DESCRIPTION":
        "Group hospitalization plans providing health care services",
    },
    {
      NAICS22: "621491",
      "INDEX ITEM DESCRIPTION":
        "Health maintenance organization (HMO) medical centers and clinics",
    },
    {
      NAICS22: "621491",
      "INDEX ITEM DESCRIPTION":
        "HMO (health maintenance organization) medical centers and clinics",
    },
    {
      NAICS22: "621492",
      "INDEX ITEM DESCRIPTION": "Dialysis centers and clinics",
    },
    {
      NAICS22: "621492",
      "INDEX ITEM DESCRIPTION": "Hemodialysis centers and clinics",
    },
    {
      NAICS22: "621492",
      "INDEX ITEM DESCRIPTION": "Kidney dialysis centers and clinics",
    },
    {
      NAICS22: "621492",
      "INDEX ITEM DESCRIPTION": "Renal dialysis centers and clinics",
    },
    {
      NAICS22: "621493",
      "INDEX ITEM DESCRIPTION":
        "Ambulatory surgical centers and clinics, freestanding",
    },
    {
      NAICS22: "621493",
      "INDEX ITEM DESCRIPTION":
        "Emergency medical centers and clinics, freestanding",
    },
    {
      NAICS22: "621493",
      "INDEX ITEM DESCRIPTION":
        "Freestanding ambulatory surgical centers and clinics",
    },
    {
      NAICS22: "621493",
      "INDEX ITEM DESCRIPTION":
        "Freestanding emergency medical centers and clinics",
    },
    {
      NAICS22: "621493",
      "INDEX ITEM DESCRIPTION": "Laser surgery centers, freestanding",
    },
    {
      NAICS22: "621493",
      "INDEX ITEM DESCRIPTION": "Trauma centers (except hospitals), freestanding",
    },
    {
      NAICS22: "621493",
      "INDEX ITEM DESCRIPTION":
        "Urgent medical care centers and clinics (except hospitals), freestanding",
    },
    {
      NAICS22: "621498",
      "INDEX ITEM DESCRIPTION": "Biofeedback centers and clinics, outpatient",
    },
    {
      NAICS22: "621498",
      "INDEX ITEM DESCRIPTION":
        "Clinics/centers of health practitioners from more than one industry practicing within the same establishment",
    },
    {
      NAICS22: "621498",
      "INDEX ITEM DESCRIPTION":
        "Clinics/centers of health practitioners with multi-industry degrees",
    },
    {
      NAICS22: "621498",
      "INDEX ITEM DESCRIPTION":
        "Community health centers and clinics, outpatient",
    },
    {
      NAICS22: "621498",
      "INDEX ITEM DESCRIPTION": "Freestanding birth centers, outpatient",
    },
    {
      NAICS22: "621498",
      "INDEX ITEM DESCRIPTION":
        "Infusion therapy centers and clinics, outpatient",
    },
    {
      NAICS22: "621498",
      "INDEX ITEM DESCRIPTION": "Pain therapy centers and clinics, outpatient",
    },
    {
      NAICS22: "621498",
      "INDEX ITEM DESCRIPTION": "Sleep disorder centers and clinics, outpatient",
    },
    {
      NAICS22: "621511",
      "INDEX ITEM DESCRIPTION": "Bacteriological laboratories, diagnostic",
    },
    {
      NAICS22: "621511",
      "INDEX ITEM DESCRIPTION": "Bacteriological laboratories, medical",
    },
    {
      NAICS22: "621511",
      "INDEX ITEM DESCRIPTION": "Biological laboratories, diagnostic",
    },
    {
      NAICS22: "621511",
      "INDEX ITEM DESCRIPTION": "Blood analysis laboratories",
    },
    {
      NAICS22: "621511",
      "INDEX ITEM DESCRIPTION": "Cytology health laboratories",
    },
    {
      NAICS22: "621511",
      "INDEX ITEM DESCRIPTION": "DNA testing laboratories",
    },
    {
      NAICS22: "621511",
      "INDEX ITEM DESCRIPTION": "Forensic laboratories, medical",
    },
    {
      NAICS22: "621511",
      "INDEX ITEM DESCRIPTION": "Genetic testing laboratories",
    },
    {
      NAICS22: "621511",
      "INDEX ITEM DESCRIPTION":
        "Laboratories, medical (except radiological, X-ray)",
    },
    {
      NAICS22: "621511",
      "INDEX ITEM DESCRIPTION":
        "Laboratory testing services, medical (except radiological, X-ray)",
    },
    {
      NAICS22: "621511",
      "INDEX ITEM DESCRIPTION":
        "Medical laboratories (except radiological, X-ray)",
    },
    {
      NAICS22: "621511",
      "INDEX ITEM DESCRIPTION": "Medical pathology laboratories",
    },
    {
      NAICS22: "621511",
      "INDEX ITEM DESCRIPTION": "Mycology health laboratories",
    },
    {
      NAICS22: "621511",
      "INDEX ITEM DESCRIPTION": "Parasitology health laboratories",
    },
    {
      NAICS22: "621511",
      "INDEX ITEM DESCRIPTION": "Pathological analysis laboratories",
    },
    {
      NAICS22: "621511",
      "INDEX ITEM DESCRIPTION": "Pathology laboratories, medical",
    },
    {
      NAICS22: "621511",
      "INDEX ITEM DESCRIPTION": "Testing laboratories, medical",
    },
    {
      NAICS22: "621511",
      "INDEX ITEM DESCRIPTION": "Toxicology health laboratories",
    },
    {
      NAICS22: "621511",
      "INDEX ITEM DESCRIPTION": "Urinalysis laboratories",
    },
    {
      NAICS22: "621512",
      "INDEX ITEM DESCRIPTION":
        "CAT (computerized axial tomography) scanner centers",
    },
    {
      NAICS22: "621512",
      "INDEX ITEM DESCRIPTION": "Computer tomography (CT-SCAN) centers",
    },
    {
      NAICS22: "621512",
      "INDEX ITEM DESCRIPTION": "CT-SCAN (computer tomography) centers",
    },
    {
      NAICS22: "621512",
      "INDEX ITEM DESCRIPTION": "Dental X-ray laboratories",
    },
    {
      NAICS22: "621512",
      "INDEX ITEM DESCRIPTION": "Diagnostic imaging centers (medical)",
    },
    {
      NAICS22: "621512",
      "INDEX ITEM DESCRIPTION": "Laboratories, dental X-ray",
    },
    {
      NAICS22: "621512",
      "INDEX ITEM DESCRIPTION": "Laboratories, medical radiological or X-ray",
    },
    {
      NAICS22: "621512",
      "INDEX ITEM DESCRIPTION":
        "Laboratory testing services, medical radiological or X-ray",
    },
    {
      NAICS22: "621512",
      "INDEX ITEM DESCRIPTION": "Magnetic resonance imaging (MRI) centers",
    },
    {
      NAICS22: "621512",
      "INDEX ITEM DESCRIPTION": "Mammogram (i.e., breast imaging) centers",
    },
    {
      NAICS22: "621512",
      "INDEX ITEM DESCRIPTION": "Medical laboratories, radiological or X-ray",
    },
    {
      NAICS22: "621512",
      "INDEX ITEM DESCRIPTION": "Medical radiological laboratories",
    },
    {
      NAICS22: "621512",
      "INDEX ITEM DESCRIPTION": "Medical X-ray laboratories",
    },
    {
      NAICS22: "621512",
      "INDEX ITEM DESCRIPTION": "Mobile breast imaging centers",
    },
    {
      NAICS22: "621512",
      "INDEX ITEM DESCRIPTION": "Mobile X-ray facilities (medical)",
    },
    {
      NAICS22: "621512",
      "INDEX ITEM DESCRIPTION": "MRI (magnetic resonance imaging) centers",
    },
    {
      NAICS22: "621512",
      "INDEX ITEM DESCRIPTION":
        "Positron emission tomography (PET) scanner centers",
    },
    {
      NAICS22: "621512",
      "INDEX ITEM DESCRIPTION": "Radiological laboratories, medical",
    },
    {
      NAICS22: "621512",
      "INDEX ITEM DESCRIPTION": "Radiological laboratory services, medical",
    },
    {
      NAICS22: "621512",
      "INDEX ITEM DESCRIPTION":
        "Single photon emission computerized tomography (SPECT) centers",
    },
    {
      NAICS22: "621512",
      "INDEX ITEM DESCRIPTION": "Ultrasound imaging centers",
    },
    {
      NAICS22: "621512",
      "INDEX ITEM DESCRIPTION": "X-ray laboratories, medical or dental",
    },
    {
      NAICS22: "621610",
      "INDEX ITEM DESCRIPTION": "Home care of elderly, medical",
    },
    {
      NAICS22: "621610",
      "INDEX ITEM DESCRIPTION": "Home health agencies",
    },
    {
      NAICS22: "621610",
      "INDEX ITEM DESCRIPTION": "Home health care agencies",
    },
    {
      NAICS22: "621610",
      "INDEX ITEM DESCRIPTION": "Home infusion therapy services",
    },
    {
      NAICS22: "621610",
      "INDEX ITEM DESCRIPTION":
        "Home nursing services (except private practices)",
    },
    {
      NAICS22: "621610",
      "INDEX ITEM DESCRIPTION": "Hospice care services, in-home",
    },
    {
      NAICS22: "621610",
      "INDEX ITEM DESCRIPTION": "Nurse associations, visiting",
    },
    {
      NAICS22: "621610",
      "INDEX ITEM DESCRIPTION":
        "Nursing agencies, primarily providing home nursing services",
    },
    {
      NAICS22: "621610",
      "INDEX ITEM DESCRIPTION": "Visiting nurse associations",
    },
    {
      NAICS22: "621910",
      "INDEX ITEM DESCRIPTION": "Air ambulance services",
    },
    {
      NAICS22: "621910",
      "INDEX ITEM DESCRIPTION": "Ambulance services, air or ground",
    },
    {
      NAICS22: "621910",
      "INDEX ITEM DESCRIPTION":
        "Emergency medical transportation services, air or ground",
    },
    {
      NAICS22: "621910",
      "INDEX ITEM DESCRIPTION": "Rescue services, air",
    },
    {
      NAICS22: "621910",
      "INDEX ITEM DESCRIPTION": "Rescue services, medical",
    },
    {
      NAICS22: "621991",
      "INDEX ITEM DESCRIPTION": "Blood banks",
    },
    {
      NAICS22: "621991",
      "INDEX ITEM DESCRIPTION": "Blood donor stations",
    },
    {
      NAICS22: "621991",
      "INDEX ITEM DESCRIPTION": "Eye banks",
    },
    {
      NAICS22: "621991",
      "INDEX ITEM DESCRIPTION": "Human egg or ova banks",
    },
    {
      NAICS22: "621991",
      "INDEX ITEM DESCRIPTION": "Human embryo storage services",
    },
    {
      NAICS22: "621991",
      "INDEX ITEM DESCRIPTION": "Organ banks, body",
    },
    {
      NAICS22: "621991",
      "INDEX ITEM DESCRIPTION": "Organ donor centers, body",
    },
    {
      NAICS22: "621991",
      "INDEX ITEM DESCRIPTION": "Placenta banks",
    },
    {
      NAICS22: "621991",
      "INDEX ITEM DESCRIPTION": "Plasma collection services",
    },
    {
      NAICS22: "621991",
      "INDEX ITEM DESCRIPTION": "Plasmapheresis centers",
    },
    {
      NAICS22: "621991",
      "INDEX ITEM DESCRIPTION": "Sperm banks, human",
    },
    {
      NAICS22: "621999",
      "INDEX ITEM DESCRIPTION": "Blood pressure screening facilities",
    },
    {
      NAICS22: "621999",
      "INDEX ITEM DESCRIPTION": "Blood pressure screening services",
    },
    {
      NAICS22: "621999",
      "INDEX ITEM DESCRIPTION": "Employee drug testing services",
    },
    {
      NAICS22: "621999",
      "INDEX ITEM DESCRIPTION":
        "Head lice removal services (except by offices of health practitioners)",
    },
    {
      NAICS22: "621999",
      "INDEX ITEM DESCRIPTION":
        "Health screening services (except by offices of health practitioners)",
    },
    {
      NAICS22: "621999",
      "INDEX ITEM DESCRIPTION":
        "Hearing testing services (except by offices of audiologists)",
    },
    {
      NAICS22: "621999",
      "INDEX ITEM DESCRIPTION": "Medical care management services",
    },
    {
      NAICS22: "621999",
      "INDEX ITEM DESCRIPTION": "Medical case management services",
    },
    {
      NAICS22: "621999",
      "INDEX ITEM DESCRIPTION": "Pacemaker monitoring services",
    },
    {
      NAICS22: "621999",
      "INDEX ITEM DESCRIPTION":
        "Physical fitness evaluation services (except by offices of health practitioners)",
    },
    {
      NAICS22: "621999",
      "INDEX ITEM DESCRIPTION": "Smoking cessation programs",
    },
    {
      NAICS22: "621999",
      "INDEX ITEM DESCRIPTION": "Stop smoking clinics",
    },
    {
      NAICS22: "622110",
      "INDEX ITEM DESCRIPTION": "Children's hospitals, general",
    },
    {
      NAICS22: "622110",
      "INDEX ITEM DESCRIPTION": "General medical and surgical hospitals",
    },
    {
      NAICS22: "622110",
      "INDEX ITEM DESCRIPTION": "Hospitals, general medical and surgical",
    },
    {
      NAICS22: "622110",
      "INDEX ITEM DESCRIPTION": "Hospitals, general pediatric",
    },
    {
      NAICS22: "622110",
      "INDEX ITEM DESCRIPTION": "Micro-hospitals",
    },
    {
      NAICS22: "622110",
      "INDEX ITEM DESCRIPTION": "Osteopathic hospitals",
    },
    {
      NAICS22: "622210",
      "INDEX ITEM DESCRIPTION": "Alcoholism rehabilitation hospitals",
    },
    {
      NAICS22: "622210",
      "INDEX ITEM DESCRIPTION":
        "Children's hospitals, psychiatric or substance abuse",
    },
    {
      NAICS22: "622210",
      "INDEX ITEM DESCRIPTION": "Detoxification hospitals",
    },
    {
      NAICS22: "622210",
      "INDEX ITEM DESCRIPTION": "Drug addiction rehabilitation hospitals",
    },
    {
      NAICS22: "622210",
      "INDEX ITEM DESCRIPTION": "Hospitals for alcoholics",
    },
    {
      NAICS22: "622210",
      "INDEX ITEM DESCRIPTION": "Hospitals, addiction",
    },
    {
      NAICS22: "622210",
      "INDEX ITEM DESCRIPTION":
        "Hospitals, mental (except intellectual and developmental disability)",
    },
    {
      NAICS22: "622210",
      "INDEX ITEM DESCRIPTION": "Hospitals, psychiatric (except convalescent)",
    },
    {
      NAICS22: "622210",
      "INDEX ITEM DESCRIPTION": "Hospitals, psychiatric pediatric",
    },
    {
      NAICS22: "622210",
      "INDEX ITEM DESCRIPTION": "Hospitals, substance abuse",
    },
    {
      NAICS22: "622210",
      "INDEX ITEM DESCRIPTION":
        "Mental (except intellectual and developmental disability) hospitals",
    },
    {
      NAICS22: "622210",
      "INDEX ITEM DESCRIPTION": "Mental health hospitals",
    },
    {
      NAICS22: "622210",
      "INDEX ITEM DESCRIPTION": "Psychiatric hospitals (except convalescent)",
    },
    {
      NAICS22: "622210",
      "INDEX ITEM DESCRIPTION":
        "Rehabilitation hospitals, alcoholism and drug addiction",
    },
    {
      NAICS22: "622310",
      "INDEX ITEM DESCRIPTION": "Cancer hospitals",
    },
    {
      NAICS22: "622310",
      "INDEX ITEM DESCRIPTION":
        "Children's hospitals, specialty (except psychiatric, substance abuse)",
    },
    {
      NAICS22: "622310",
      "INDEX ITEM DESCRIPTION": "Chronic disease hospitals",
    },
    {
      NAICS22: "622310",
      "INDEX ITEM DESCRIPTION":
        "Extended care hospitals (except mental, substance abuse)",
    },
    {
      NAICS22: "622310",
      "INDEX ITEM DESCRIPTION": "Eye, ear, nose, and throat hospitals",
    },
    {
      NAICS22: "622310",
      "INDEX ITEM DESCRIPTION":
        "Hospitals, specialty (except psychiatric, substance abuse)",
    },
    {
      NAICS22: "622310",
      "INDEX ITEM DESCRIPTION": "Leprosy hospitals",
    },
    {
      NAICS22: "622310",
      "INDEX ITEM DESCRIPTION": "Maternity hospitals",
    },
    {
      NAICS22: "622310",
      "INDEX ITEM DESCRIPTION": "Neurological hospitals",
    },
    {
      NAICS22: "622310",
      "INDEX ITEM DESCRIPTION": "Obstetrical hospital",
    },
    {
      NAICS22: "622310",
      "INDEX ITEM DESCRIPTION": "Orthopedic hospitals",
    },
    {
      NAICS22: "622310",
      "INDEX ITEM DESCRIPTION": "Physical rehabilitation hospitals",
    },
    {
      NAICS22: "622310",
      "INDEX ITEM DESCRIPTION":
        "Rehabilitation hospitals (except alcoholism, drug addiction)",
    },
    {
      NAICS22: "622310",
      "INDEX ITEM DESCRIPTION":
        "Tuberculosis and other respiratory illness hospitals",
    },
    {
      NAICS22: "623110",
      "INDEX ITEM DESCRIPTION":
        "Assisted living facilities (without nursing facilities) for the elderly with nursing care",
    },
    {
      NAICS22: "623110",
      "INDEX ITEM DESCRIPTION":
        "Convalescent homes or convalescent hospitals (except psychiatric)",
    },
    {
      NAICS22: "623110",
      "INDEX ITEM DESCRIPTION": "Group homes for the disabled with nursing care",
    },
    {
      NAICS22: "623110",
      "INDEX ITEM DESCRIPTION": "Homes for the aged with nursing care",
    },
    {
      NAICS22: "623110",
      "INDEX ITEM DESCRIPTION": "Homes for the elderly with nursing care",
    },
    {
      NAICS22: "623110",
      "INDEX ITEM DESCRIPTION": "Hospices, inpatient care",
    },
    {
      NAICS22: "623110",
      "INDEX ITEM DESCRIPTION": "Nursing homes",
    },
    {
      NAICS22: "623110",
      "INDEX ITEM DESCRIPTION": "Rest homes with nursing care",
    },
    {
      NAICS22: "623110",
      "INDEX ITEM DESCRIPTION": "Retirement homes with nursing care",
    },
    {
      NAICS22: "623110",
      "INDEX ITEM DESCRIPTION": "Skilled nursing facilities",
    },
    {
      NAICS22: "623210",
      "INDEX ITEM DESCRIPTION":
        "Group homes, intellectual and developmental disability",
    },
    {
      NAICS22: "623210",
      "INDEX ITEM DESCRIPTION":
        "Homes with or without health care, intellectual and developmental disability",
    },
    {
      NAICS22: "623210",
      "INDEX ITEM DESCRIPTION":
        "Hospitals, intellectual and developmental disability",
    },
    {
      NAICS22: "623210",
      "INDEX ITEM DESCRIPTION":
        "Intellectual and developmental disability facilities (e.g., homes, hospitals, intermediate care facilities), residential",
    },
    {
      NAICS22: "623210",
      "INDEX ITEM DESCRIPTION": "Intellectual and developmental disability homes",
    },
    {
      NAICS22: "623210",
      "INDEX ITEM DESCRIPTION":
        "Intellectual and developmental disability hospitals",
    },
    {
      NAICS22: "623210",
      "INDEX ITEM DESCRIPTION":
        "Intellectual and developmental disability intermediate care facilities",
    },
    {
      NAICS22: "623210",
      "INDEX ITEM DESCRIPTION":
        "Intermediate care facilities, intellectual and developmental disability",
    },
    {
      NAICS22: "623220",
      "INDEX ITEM DESCRIPTION":
        "Alcoholism rehabilitation facilities (except licensed hospitals), residential",
    },
    {
      NAICS22: "623220",
      "INDEX ITEM DESCRIPTION":
        "Convalescent homes or hospitals for psychiatric patients",
    },
    {
      NAICS22: "623220",
      "INDEX ITEM DESCRIPTION":
        "Drug addiction rehabilitation facilities (except licensed hospitals), residential",
    },
    {
      NAICS22: "623220",
      "INDEX ITEM DESCRIPTION":
        "Halfway houses for patients with mental health illnesses",
    },
    {
      NAICS22: "623220",
      "INDEX ITEM DESCRIPTION":
        "Halfway houses, substance abuse (e.g., alcoholism, drug addiction)",
    },
    {
      NAICS22: "623220",
      "INDEX ITEM DESCRIPTION":
        "Homes for emotionally disturbed adults or children",
    },
    {
      NAICS22: "623220",
      "INDEX ITEM DESCRIPTION": "Homes, psychiatric convalescent",
    },
    {
      NAICS22: "623220",
      "INDEX ITEM DESCRIPTION": "Hospitals, psychiatric convalescent",
    },
    {
      NAICS22: "623220",
      "INDEX ITEM DESCRIPTION": "Mental health facilities, residential",
    },
    {
      NAICS22: "623220",
      "INDEX ITEM DESCRIPTION": "Mental health halfway houses",
    },
    {
      NAICS22: "623220",
      "INDEX ITEM DESCRIPTION": "Psychiatric convalescent homes or hospitals",
    },
    {
      NAICS22: "623220",
      "INDEX ITEM DESCRIPTION":
        "Residential group homes for the emotionally disturbed",
    },
    {
      NAICS22: "623220",
      "INDEX ITEM DESCRIPTION":
        "Substance abuse (i.e., alcoholism, drug addiction) halfway houses",
    },
    {
      NAICS22: "623220",
      "INDEX ITEM DESCRIPTION": "Substance abuse facilities, residential",
    },
    {
      NAICS22: "623311",
      "INDEX ITEM DESCRIPTION":
        "Assisted living facilities with on-site nursing facilities",
    },
    {
      NAICS22: "623311",
      "INDEX ITEM DESCRIPTION": "Continuing care retirement communities",
    },
    {
      NAICS22: "623311",
      "INDEX ITEM DESCRIPTION": "Retirement communities, continuing care",
    },
    {
      NAICS22: "623312",
      "INDEX ITEM DESCRIPTION":
        "Assisted living facilities for the elderly without nursing care",
    },
    {
      NAICS22: "623312",
      "INDEX ITEM DESCRIPTION": "Homes for the aged without nursing care",
    },
    {
      NAICS22: "623312",
      "INDEX ITEM DESCRIPTION": "Homes for the elderly without nursing care",
    },
    {
      NAICS22: "623312",
      "INDEX ITEM DESCRIPTION": "Old age homes without nursing care",
    },
    {
      NAICS22: "623312",
      "INDEX ITEM DESCRIPTION": "Old soldiers' homes without nursing care",
    },
    {
      NAICS22: "623312",
      "INDEX ITEM DESCRIPTION": "Rest homes without nursing care",
    },
    {
      NAICS22: "623312",
      "INDEX ITEM DESCRIPTION": "Retirement homes without nursing care",
    },
    {
      NAICS22: "623312",
      "INDEX ITEM DESCRIPTION": "Senior citizens' homes without nursing care",
    },
    {
      NAICS22: "623990",
      "INDEX ITEM DESCRIPTION": "Boot camps for delinquent youth",
    },
    {
      NAICS22: "623990",
      "INDEX ITEM DESCRIPTION":
        "Boys' and girls' residential facilities (e.g., homes, ranches, villages)",
    },
    {
      NAICS22: "623990",
      "INDEX ITEM DESCRIPTION":
        "Camps, boot or disciplinary (except correctional), for delinquent youth",
    },
    {
      NAICS22: "623990",
      "INDEX ITEM DESCRIPTION": "Child group foster homes",
    },
    {
      NAICS22: "623990",
      "INDEX ITEM DESCRIPTION": "Children's villages",
    },
    {
      NAICS22: "623990",
      "INDEX ITEM DESCRIPTION": "Delinquent youth halfway group homes",
    },
    {
      NAICS22: "623990",
      "INDEX ITEM DESCRIPTION": "Disciplinary camps for delinquent youth",
    },
    {
      NAICS22: "623990",
      "INDEX ITEM DESCRIPTION": "Group foster homes for children",
    },
    {
      NAICS22: "623990",
      "INDEX ITEM DESCRIPTION": "Group homes for the hearing impaired",
    },
    {
      NAICS22: "623990",
      "INDEX ITEM DESCRIPTION": "Group homes for the visually impaired",
    },
    {
      NAICS22: "623990",
      "INDEX ITEM DESCRIPTION":
        "Halfway group homes for delinquents and ex-offenders",
    },
    {
      NAICS22: "623990",
      "INDEX ITEM DESCRIPTION": "Homes for children with health care incidental",
    },
    {
      NAICS22: "623990",
      "INDEX ITEM DESCRIPTION": "Homes for unwed mothers",
    },
    {
      NAICS22: "623990",
      "INDEX ITEM DESCRIPTION": "Juvenile halfway group homes",
    },
    {
      NAICS22: "623990",
      "INDEX ITEM DESCRIPTION": "Orphanages",
    },
    {
      NAICS22: "624110",
      "INDEX ITEM DESCRIPTION": "Adoption agencies",
    },
    {
      NAICS22: "624110",
      "INDEX ITEM DESCRIPTION": "Adoption services, child",
    },
    {
      NAICS22: "624110",
      "INDEX ITEM DESCRIPTION": "Aid to families with dependent children (AFDC)",
    },
    {
      NAICS22: "624110",
      "INDEX ITEM DESCRIPTION": "Child guidance agencies",
    },
    {
      NAICS22: "624110",
      "INDEX ITEM DESCRIPTION": "Child welfare services",
    },
    {
      NAICS22: "624110",
      "INDEX ITEM DESCRIPTION":
        "Community centers (except recreational only), youth",
    },
    {
      NAICS22: "624110",
      "INDEX ITEM DESCRIPTION": "Foster care placement agencies",
    },
    {
      NAICS22: "624110",
      "INDEX ITEM DESCRIPTION": "Foster home placement services",
    },
    {
      NAICS22: "624110",
      "INDEX ITEM DESCRIPTION": "Self-help organizations, youth",
    },
    {
      NAICS22: "624110",
      "INDEX ITEM DESCRIPTION": "Teen outreach services",
    },
    {
      NAICS22: "624110",
      "INDEX ITEM DESCRIPTION": "Youth centers (except recreational only)",
    },
    {
      NAICS22: "624110",
      "INDEX ITEM DESCRIPTION": "Youth guidance organizations",
    },
    {
      NAICS22: "624110",
      "INDEX ITEM DESCRIPTION": "Youth self-help organizations",
    },
    {
      NAICS22: "624120",
      "INDEX ITEM DESCRIPTION":
        "Activity centers for disabled persons and the elderly",
    },
    {
      NAICS22: "624120",
      "INDEX ITEM DESCRIPTION": "Adult day care centers",
    },
    {
      NAICS22: "624120",
      "INDEX ITEM DESCRIPTION": "Centers, senior citizens'",
    },
    {
      NAICS22: "624120",
      "INDEX ITEM DESCRIPTION":
        "Community centers (except recreational only), adult",
    },
    {
      NAICS22: "624120",
      "INDEX ITEM DESCRIPTION":
        "Companion services for disabled persons and the elderly",
    },
    {
      NAICS22: "624120",
      "INDEX ITEM DESCRIPTION":
        "Day care centers for disabled persons and the elderly",
    },
    {
      NAICS22: "624120",
      "INDEX ITEM DESCRIPTION": "Day care centers, adult",
    },
    {
      NAICS22: "624120",
      "INDEX ITEM DESCRIPTION": "Disability support groups",
    },
    {
      NAICS22: "624120",
      "INDEX ITEM DESCRIPTION": "Home care of elderly, non-medical",
    },
    {
      NAICS22: "624120",
      "INDEX ITEM DESCRIPTION":
        "Homemaker's service for elderly or disabled persons, non-medical",
    },
    {
      NAICS22: "624120",
      "INDEX ITEM DESCRIPTION":
        "Self-help organizations for disabled persons and the elderly",
    },
    {
      NAICS22: "624120",
      "INDEX ITEM DESCRIPTION": "Senior citizens activity centers",
    },
    {
      NAICS22: "624120",
      "INDEX ITEM DESCRIPTION": "Senior citizens centers",
    },
    {
      NAICS22: "624190",
      "INDEX ITEM DESCRIPTION":
        "Alcoholism and drug addiction self-help organizations",
    },
    {
      NAICS22: "624190",
      "INDEX ITEM DESCRIPTION":
        "Alcoholism counseling (except medical treatment), nonresidential",
    },
    {
      NAICS22: "624190",
      "INDEX ITEM DESCRIPTION": "Alcoholism self-help organizations",
    },
    {
      NAICS22: "624190",
      "INDEX ITEM DESCRIPTION": "Community action service agencies",
    },
    {
      NAICS22: "624190",
      "INDEX ITEM DESCRIPTION":
        "Community health education services (except health care services)",
    },
    {
      NAICS22: "624190",
      "INDEX ITEM DESCRIPTION":
        "Counseling services (except by psychiatrists, psychoanalysts, or psychotherapists)",
    },
    {
      NAICS22: "624190",
      "INDEX ITEM DESCRIPTION": "Crisis intervention centers",
    },
    {
      NAICS22: "624190",
      "INDEX ITEM DESCRIPTION": "Drug addiction self-help organizations",
    },
    {
      NAICS22: "624190",
      "INDEX ITEM DESCRIPTION": "Ex-offender rehabilitation agencies",
    },
    {
      NAICS22: "624190",
      "INDEX ITEM DESCRIPTION": "Ex-offender self-help organizations",
    },
    {
      NAICS22: "624190",
      "INDEX ITEM DESCRIPTION": "Family social service agencies",
    },
    {
      NAICS22: "624190",
      "INDEX ITEM DESCRIPTION": "Family welfare services",
    },
    {
      NAICS22: "624190",
      "INDEX ITEM DESCRIPTION": "Hotline centers",
    },
    {
      NAICS22: "624190",
      "INDEX ITEM DESCRIPTION":
        "Individual and family social services, multi-purpose",
    },
    {
      NAICS22: "624190",
      "INDEX ITEM DESCRIPTION":
        "Marriage counseling services (except by offices of mental health practitioners)",
    },
    {
      NAICS22: "624190",
      "INDEX ITEM DESCRIPTION": "Mediation, social service, family, agencies",
    },
    {
      NAICS22: "624190",
      "INDEX ITEM DESCRIPTION": "Multiservice centers, neighborhood",
    },
    {
      NAICS22: "624190",
      "INDEX ITEM DESCRIPTION": "Offender self-help organizations",
    },
    {
      NAICS22: "624190",
      "INDEX ITEM DESCRIPTION": "Parenting support services",
    },
    {
      NAICS22: "624190",
      "INDEX ITEM DESCRIPTION": "Parole offices, privately operated",
    },
    {
      NAICS22: "624190",
      "INDEX ITEM DESCRIPTION": "Probation offices, privately operated",
    },
    {
      NAICS22: "624190",
      "INDEX ITEM DESCRIPTION": "Rape crisis centers",
    },
    {
      NAICS22: "624190",
      "INDEX ITEM DESCRIPTION":
        "Referral services for personal and social problems",
    },
    {
      NAICS22: "624190",
      "INDEX ITEM DESCRIPTION": "Rehabilitation agencies for offenders",
    },
    {
      NAICS22: "624190",
      "INDEX ITEM DESCRIPTION":
        "Self-help organizations (except for disabled persons, the elderly)",
    },
    {
      NAICS22: "624190",
      "INDEX ITEM DESCRIPTION": "Social service agencies, family",
    },
    {
      NAICS22: "624190",
      "INDEX ITEM DESCRIPTION": "Social service centers, multi-purpose",
    },
    {
      NAICS22: "624190",
      "INDEX ITEM DESCRIPTION": "Suicide crisis centers",
    },
    {
      NAICS22: "624190",
      "INDEX ITEM DESCRIPTION": "Support group services",
    },
    {
      NAICS22: "624190",
      "INDEX ITEM DESCRIPTION": "Telephone counseling services",
    },
    {
      NAICS22: "624190",
      "INDEX ITEM DESCRIPTION": "Travelers' aid centers",
    },
    {
      NAICS22: "624190",
      "INDEX ITEM DESCRIPTION": "Welfare service centers, multi-program",
    },
    {
      NAICS22: "624210",
      "INDEX ITEM DESCRIPTION": "Community meals, social services",
    },
    {
      NAICS22: "624210",
      "INDEX ITEM DESCRIPTION": "Food banks",
    },
    {
      NAICS22: "624210",
      "INDEX ITEM DESCRIPTION": "Food pantries",
    },
    {
      NAICS22: "624210",
      "INDEX ITEM DESCRIPTION": "Meal delivery programs",
    },
    {
      NAICS22: "624210",
      "INDEX ITEM DESCRIPTION": "Mobile soup kitchens",
    },
    {
      NAICS22: "624210",
      "INDEX ITEM DESCRIPTION": "Soup kitchens",
    },
    {
      NAICS22: "624221",
      "INDEX ITEM DESCRIPTION": "Battered women's shelters",
    },
    {
      NAICS22: "624221",
      "INDEX ITEM DESCRIPTION":
        "Emergency shelters (except for victims of domestic or international disasters or conflicts)",
    },
    {
      NAICS22: "624221",
      "INDEX ITEM DESCRIPTION": "Homeless shelters",
    },
    {
      NAICS22: "624221",
      "INDEX ITEM DESCRIPTION": "Runaway youth shelters",
    },
    {
      NAICS22: "624221",
      "INDEX ITEM DESCRIPTION":
        "Shelters (except for victims of domestic or international disasters or conflicts), emergency",
    },
    {
      NAICS22: "624221",
      "INDEX ITEM DESCRIPTION": "Shelters, battered women's",
    },
    {
      NAICS22: "624221",
      "INDEX ITEM DESCRIPTION": "Shelters, homeless",
    },
    {
      NAICS22: "624221",
      "INDEX ITEM DESCRIPTION": "Shelters, runaway youth",
    },
    {
      NAICS22: "624221",
      "INDEX ITEM DESCRIPTION":
        "Shelters, temporary (e.g., battered women's, homeless, runaway youth)",
    },
    {
      NAICS22: "624221",
      "INDEX ITEM DESCRIPTION":
        "Temporary housing for families of medical patients",
    },
    {
      NAICS22: "624221",
      "INDEX ITEM DESCRIPTION":
        "Temporary shelters (e.g., battered women's, homeless, runaway youth)",
    },
    {
      NAICS22: "624221",
      "INDEX ITEM DESCRIPTION": "Women's shelters, battered",
    },
    {
      NAICS22: "624229",
      "INDEX ITEM DESCRIPTION": "Energy assistance programs",
    },
    {
      NAICS22: "624229",
      "INDEX ITEM DESCRIPTION":
        "Home construction organizations, work (sweat) equity",
    },
    {
      NAICS22: "624229",
      "INDEX ITEM DESCRIPTION": "Housing assistance agencies",
    },
    {
      NAICS22: "624229",
      "INDEX ITEM DESCRIPTION": "Housing repair organizations, volunteer",
    },
    {
      NAICS22: "624229",
      "INDEX ITEM DESCRIPTION": "Transitional housing agencies",
    },
    {
      NAICS22: "624229",
      "INDEX ITEM DESCRIPTION": "Volunteer housing repair organizations",
    },
    {
      NAICS22: "624229",
      "INDEX ITEM DESCRIPTION":
        "Work (sweat) equity home construction organizations",
    },
    {
      NAICS22: "624230",
      "INDEX ITEM DESCRIPTION": "Disaster relief services",
    },
    {
      NAICS22: "624230",
      "INDEX ITEM DESCRIPTION": "Emergency relief services",
    },
    {
      NAICS22: "624230",
      "INDEX ITEM DESCRIPTION":
        "Emergency shelters for victims of domestic or international disasters or conflicts",
    },
    {
      NAICS22: "624230",
      "INDEX ITEM DESCRIPTION": "Immigrant resettlement services",
    },
    {
      NAICS22: "624230",
      "INDEX ITEM DESCRIPTION": "Refugee settlement services",
    },
    {
      NAICS22: "624230",
      "INDEX ITEM DESCRIPTION": "Relief services, disaster",
    },
    {
      NAICS22: "624230",
      "INDEX ITEM DESCRIPTION": "Relief services, emergency",
    },
    {
      NAICS22: "624230",
      "INDEX ITEM DESCRIPTION":
        "Shelters for victims of domestic or international disasters or conflicts, emergency",
    },
    {
      NAICS22: "624310",
      "INDEX ITEM DESCRIPTION":
        "Habilitation job counseling and training, vocational",
    },
    {
      NAICS22: "624310",
      "INDEX ITEM DESCRIPTION":
        "Job counseling, vocational rehabilitation or habilitation",
    },
    {
      NAICS22: "624310",
      "INDEX ITEM DESCRIPTION":
        "Job training, vocational rehabilitation or habilitation",
    },
    {
      NAICS22: "624310",
      "INDEX ITEM DESCRIPTION":
        "Rehabilitation job counseling and training, vocational",
    },
    {
      NAICS22: "624310",
      "INDEX ITEM DESCRIPTION":
        "Sheltered workshops (i.e., work experience centers)",
    },
    {
      NAICS22: "624310",
      "INDEX ITEM DESCRIPTION": "Vocational habilitation job counseling",
    },
    {
      NAICS22: "624310",
      "INDEX ITEM DESCRIPTION":
        "Vocational habilitation job training facilities (except schools)",
    },
    {
      NAICS22: "624310",
      "INDEX ITEM DESCRIPTION": "Vocational rehabilitation agencies",
    },
    {
      NAICS22: "624310",
      "INDEX ITEM DESCRIPTION": "Vocational rehabilitation job counseling",
    },
    {
      NAICS22: "624310",
      "INDEX ITEM DESCRIPTION":
        "Vocational rehabilitation job training facilities (except schools)",
    },
    {
      NAICS22: "624310",
      "INDEX ITEM DESCRIPTION":
        "Vocational rehabilitation or habilitation services (e.g., job counseling, job training, work experience)",
    },
    {
      NAICS22: "624310",
      "INDEX ITEM DESCRIPTION":
        "Work experience centers (i.e., sheltered workshops)",
    },
    {
      NAICS22: "624310",
      "INDEX ITEM DESCRIPTION": "Workshops for persons with disabilities",
    },
    {
      NAICS22: "624410",
      "INDEX ITEM DESCRIPTION":
        "Babysitting services in provider's own home, child care",
    },
    {
      NAICS22: "624410",
      "INDEX ITEM DESCRIPTION": "Babysitting services, child care",
    },
    {
      NAICS22: "624410",
      "INDEX ITEM DESCRIPTION":
        "Before-school and after-school educational programs, separate from schools",
    },
    {
      NAICS22: "624410",
      "INDEX ITEM DESCRIPTION": "Child care babysitting services",
    },
    {
      NAICS22: "624410",
      "INDEX ITEM DESCRIPTION": "Child care services",
    },
    {
      NAICS22: "624410",
      "INDEX ITEM DESCRIPTION": "Child care services in provider's own home",
    },
    {
      NAICS22: "624410",
      "INDEX ITEM DESCRIPTION":
        "Child care, before or after school, separate from schools",
    },
    {
      NAICS22: "624410",
      "INDEX ITEM DESCRIPTION": "Child day care centers",
    },
    {
      NAICS22: "624410",
      "INDEX ITEM DESCRIPTION": "Day care centers, child or infant",
    },
    {
      NAICS22: "624410",
      "INDEX ITEM DESCRIPTION": "Day care services, child or infant",
    },
    {
      NAICS22: "624410",
      "INDEX ITEM DESCRIPTION":
        "Family child care homes (excluding private households employing nannies)",
    },
    {
      NAICS22: "624410",
      "INDEX ITEM DESCRIPTION": "Group day care centers, child or infant",
    },
    {
      NAICS22: "624410",
      "INDEX ITEM DESCRIPTION":
        "Head Start and Early Head Start programs, separate from schools",
    },
    {
      NAICS22: "624410",
      "INDEX ITEM DESCRIPTION": "Infant care services",
    },
    {
      NAICS22: "624410",
      "INDEX ITEM DESCRIPTION": "Infant day care centers",
    },
    {
      NAICS22: "624410",
      "INDEX ITEM DESCRIPTION": "Nursery schools",
    },
    {
      NAICS22: "624410",
      "INDEX ITEM DESCRIPTION":
        "Pre-kindergarten centers (except part of elementary school system)",
    },
    {
      NAICS22: "624410",
      "INDEX ITEM DESCRIPTION": "Preschool centers",
    },
    {
      NAICS22: "711110",
      "INDEX ITEM DESCRIPTION": "Broadway theaters",
    },
    {
      NAICS22: "711110",
      "INDEX ITEM DESCRIPTION": "Burlesque companies",
    },
    {
      NAICS22: "711110",
      "INDEX ITEM DESCRIPTION": "Comedy troupes",
    },
    {
      NAICS22: "711110",
      "INDEX ITEM DESCRIPTION": "Community theaters",
    },
    {
      NAICS22: "711110",
      "INDEX ITEM DESCRIPTION": "Dinner theaters",
    },
    {
      NAICS22: "711110",
      "INDEX ITEM DESCRIPTION": "Improvisational theaters",
    },
    {
      NAICS22: "711110",
      "INDEX ITEM DESCRIPTION": "Mime theaters",
    },
    {
      NAICS22: "711110",
      "INDEX ITEM DESCRIPTION": "Musical theater companies or groups",
    },
    {
      NAICS22: "711110",
      "INDEX ITEM DESCRIPTION": "Musical theater productions, live",
    },
    {
      NAICS22: "711110",
      "INDEX ITEM DESCRIPTION": "Opera companies",
    },
    {
      NAICS22: "711110",
      "INDEX ITEM DESCRIPTION": "Puppet theaters",
    },
    {
      NAICS22: "711110",
      "INDEX ITEM DESCRIPTION": "Repertory companies, theatrical",
    },
    {
      NAICS22: "711110",
      "INDEX ITEM DESCRIPTION": "Road companies, theatrical",
    },
    {
      NAICS22: "711110",
      "INDEX ITEM DESCRIPTION": "Stock companies, theatrical",
    },
    {
      NAICS22: "711110",
      "INDEX ITEM DESCRIPTION": "Summer theaters",
    },
    {
      NAICS22: "711110",
      "INDEX ITEM DESCRIPTION": "Theater companies (except dance)",
    },
    {
      NAICS22: "711110",
      "INDEX ITEM DESCRIPTION": "Theater companies (except dance), amateur",
    },
    {
      NAICS22: "711110",
      "INDEX ITEM DESCRIPTION": "Theaters, dinner",
    },
    {
      NAICS22: "711110",
      "INDEX ITEM DESCRIPTION":
        "Theaters, live theatrical production (except dance)",
    },
    {
      NAICS22: "711110",
      "INDEX ITEM DESCRIPTION": "Theaters, musical",
    },
    {
      NAICS22: "711110",
      "INDEX ITEM DESCRIPTION": "Theatrical repertory companies",
    },
    {
      NAICS22: "711110",
      "INDEX ITEM DESCRIPTION": "Theatrical road companies",
    },
    {
      NAICS22: "711110",
      "INDEX ITEM DESCRIPTION": "Theatrical stock companies",
    },
    {
      NAICS22: "711110",
      "INDEX ITEM DESCRIPTION": "Vaudeville companies",
    },
    {
      NAICS22: "711120",
      "INDEX ITEM DESCRIPTION": "Ballet companies",
    },
    {
      NAICS22: "711120",
      "INDEX ITEM DESCRIPTION": "Ballet productions, live theatrical",
    },
    {
      NAICS22: "711120",
      "INDEX ITEM DESCRIPTION": "Classical dance companies",
    },
    {
      NAICS22: "711120",
      "INDEX ITEM DESCRIPTION": "Contemporary dance companies",
    },
    {
      NAICS22: "711120",
      "INDEX ITEM DESCRIPTION": "Dance companies",
    },
    {
      NAICS22: "711120",
      "INDEX ITEM DESCRIPTION": "Dance productions, live theatrical",
    },
    {
      NAICS22: "711120",
      "INDEX ITEM DESCRIPTION": "Dance theaters",
    },
    {
      NAICS22: "711120",
      "INDEX ITEM DESCRIPTION": "Dance troupes",
    },
    {
      NAICS22: "711120",
      "INDEX ITEM DESCRIPTION": "Folk dance companies",
    },
    {
      NAICS22: "711120",
      "INDEX ITEM DESCRIPTION": "Interpretive dance companies",
    },
    {
      NAICS22: "711120",
      "INDEX ITEM DESCRIPTION": "Jazz dance companies",
    },
    {
      NAICS22: "711120",
      "INDEX ITEM DESCRIPTION": "Modern dance companies",
    },
    {
      NAICS22: "711120",
      "INDEX ITEM DESCRIPTION": "Tap dance companies",
    },
    {
      NAICS22: "711120",
      "INDEX ITEM DESCRIPTION": "Theater companies, dance",
    },
    {
      NAICS22: "711120",
      "INDEX ITEM DESCRIPTION": "Theaters, dance",
    },
    {
      NAICS22: "711120",
      "INDEX ITEM DESCRIPTION": "Theatrical dance productions, live",
    },
    {
      NAICS22: "711130",
      "INDEX ITEM DESCRIPTION": "Bands",
    },
    {
      NAICS22: "711130",
      "INDEX ITEM DESCRIPTION": "Bands, dance",
    },
    {
      NAICS22: "711130",
      "INDEX ITEM DESCRIPTION": "Bands, musical",
    },
    {
      NAICS22: "711130",
      "INDEX ITEM DESCRIPTION": "Chamber musical groups",
    },
    {
      NAICS22: "711130",
      "INDEX ITEM DESCRIPTION": "Chamber orchestras",
    },
    {
      NAICS22: "711130",
      "INDEX ITEM DESCRIPTION": "Choirs",
    },
    {
      NAICS22: "711130",
      "INDEX ITEM DESCRIPTION": "Classical musical artists, independent",
    },
    {
      NAICS22: "711130",
      "INDEX ITEM DESCRIPTION": "Classical musical groups",
    },
    {
      NAICS22: "711130",
      "INDEX ITEM DESCRIPTION": "Concert artists, independent",
    },
    {
      NAICS22: "711130",
      "INDEX ITEM DESCRIPTION": "Country musical artists, independent",
    },
    {
      NAICS22: "711130",
      "INDEX ITEM DESCRIPTION": "Country musical groups",
    },
    {
      NAICS22: "711130",
      "INDEX ITEM DESCRIPTION": "Dance bands",
    },
    {
      NAICS22: "711130",
      "INDEX ITEM DESCRIPTION": "Drum and bugle corps (i.e., drill teams)",
    },
    {
      NAICS22: "711130",
      "INDEX ITEM DESCRIPTION": "Ensembles, musical",
    },
    {
      NAICS22: "711130",
      "INDEX ITEM DESCRIPTION": "Jazz musical artists, independent",
    },
    {
      NAICS22: "711130",
      "INDEX ITEM DESCRIPTION": "Jazz musical groups",
    },
    {
      NAICS22: "711130",
      "INDEX ITEM DESCRIPTION": "Musical artists, independent",
    },
    {
      NAICS22: "711130",
      "INDEX ITEM DESCRIPTION": "Musical groups (except musical theater groups)",
    },
    {
      NAICS22: "711130",
      "INDEX ITEM DESCRIPTION":
        "Musical productions (except musical theater productions), live",
    },
    {
      NAICS22: "711130",
      "INDEX ITEM DESCRIPTION": "Musicians, independent",
    },
    {
      NAICS22: "711130",
      "INDEX ITEM DESCRIPTION": "Opera singers, independent",
    },
    {
      NAICS22: "711130",
      "INDEX ITEM DESCRIPTION": "Orchestras",
    },
    {
      NAICS22: "711130",
      "INDEX ITEM DESCRIPTION": "Popular musical artists, independent",
    },
    {
      NAICS22: "711130",
      "INDEX ITEM DESCRIPTION": "Popular musical groups",
    },
    {
      NAICS22: "711130",
      "INDEX ITEM DESCRIPTION": "Rock musical artists, independent",
    },
    {
      NAICS22: "711130",
      "INDEX ITEM DESCRIPTION": "Rock musical groups",
    },
    {
      NAICS22: "711130",
      "INDEX ITEM DESCRIPTION": "Singers, independent",
    },
    {
      NAICS22: "711130",
      "INDEX ITEM DESCRIPTION": "Soloists, independent musical",
    },
    {
      NAICS22: "711130",
      "INDEX ITEM DESCRIPTION": "Symphony orchestras",
    },
    {
      NAICS22: "711130",
      "INDEX ITEM DESCRIPTION": "Vocalists, independent",
    },
    {
      NAICS22: "711190",
      "INDEX ITEM DESCRIPTION": "Carnival traveling shows",
    },
    {
      NAICS22: "711190",
      "INDEX ITEM DESCRIPTION": "Circus companies",
    },
    {
      NAICS22: "711190",
      "INDEX ITEM DESCRIPTION": "Circuses",
    },
    {
      NAICS22: "711190",
      "INDEX ITEM DESCRIPTION": "Horse shows",
    },
    {
      NAICS22: "711190",
      "INDEX ITEM DESCRIPTION": "Ice skating companies",
    },
    {
      NAICS22: "711190",
      "INDEX ITEM DESCRIPTION": "Ice skating shows",
    },
    {
      NAICS22: "711190",
      "INDEX ITEM DESCRIPTION": "Magic shows",
    },
    {
      NAICS22: "711190",
      "INDEX ITEM DESCRIPTION": "Traveling shows, carnival",
    },
    {
      NAICS22: "711211",
      "INDEX ITEM DESCRIPTION":
        "Baseball clubs, professional or semiprofessional",
    },
    {
      NAICS22: "711211",
      "INDEX ITEM DESCRIPTION":
        "Baseball teams, professional or semiprofessional",
    },
    {
      NAICS22: "711211",
      "INDEX ITEM DESCRIPTION":
        "Basketball clubs, professional or semiprofessional",
    },
    {
      NAICS22: "711211",
      "INDEX ITEM DESCRIPTION":
        "Basketball teams, professional or semiprofessional",
    },
    {
      NAICS22: "711211",
      "INDEX ITEM DESCRIPTION": "Boxing clubs, professional or semiprofessional",
    },
    {
      NAICS22: "711211",
      "INDEX ITEM DESCRIPTION":
        "Esports video gaming clubs or teams, professional or semiprofessional",
    },
    {
      NAICS22: "711211",
      "INDEX ITEM DESCRIPTION":
        "Football clubs, professional or semiprofessional",
    },
    {
      NAICS22: "711211",
      "INDEX ITEM DESCRIPTION":
        "Football teams, professional or semiprofessional",
    },
    {
      NAICS22: "711211",
      "INDEX ITEM DESCRIPTION": "Hockey clubs, professional or semiprofessional",
    },
    {
      NAICS22: "711211",
      "INDEX ITEM DESCRIPTION": "Hockey teams, professional or semiprofessional",
    },
    {
      NAICS22: "711211",
      "INDEX ITEM DESCRIPTION":
        "Ice hockey clubs, professional or semiprofessional",
    },
    {
      NAICS22: "711211",
      "INDEX ITEM DESCRIPTION":
        "Jai alai teams, professional or semiprofessional",
    },
    {
      NAICS22: "711211",
      "INDEX ITEM DESCRIPTION": "Major league baseball clubs",
    },
    {
      NAICS22: "711211",
      "INDEX ITEM DESCRIPTION": "Minor league baseball clubs",
    },
    {
      NAICS22: "711211",
      "INDEX ITEM DESCRIPTION": "Professional baseball clubs",
    },
    {
      NAICS22: "711211",
      "INDEX ITEM DESCRIPTION": "Professional football clubs",
    },
    {
      NAICS22: "711211",
      "INDEX ITEM DESCRIPTION": "Professional sports clubs",
    },
    {
      NAICS22: "711211",
      "INDEX ITEM DESCRIPTION":
        "Roller hockey clubs, professional or semiprofessional",
    },
    {
      NAICS22: "711211",
      "INDEX ITEM DESCRIPTION": "Semiprofessional baseball clubs",
    },
    {
      NAICS22: "711211",
      "INDEX ITEM DESCRIPTION": "Semiprofessional football clubs",
    },
    {
      NAICS22: "711211",
      "INDEX ITEM DESCRIPTION": "Semiprofessional sports clubs",
    },
    {
      NAICS22: "711211",
      "INDEX ITEM DESCRIPTION": "Soccer clubs, professional or semiprofessional",
    },
    {
      NAICS22: "711211",
      "INDEX ITEM DESCRIPTION": "Soccer teams, professional or semiprofessional",
    },
    {
      NAICS22: "711211",
      "INDEX ITEM DESCRIPTION": "Sports clubs, professional or semiprofessional",
    },
    {
      NAICS22: "711211",
      "INDEX ITEM DESCRIPTION": "Sports teams, professional or semiprofessional",
    },
    {
      NAICS22: "711212",
      "INDEX ITEM DESCRIPTION": "Automobile racetracks",
    },
    {
      NAICS22: "711212",
      "INDEX ITEM DESCRIPTION": "Dog racetracks",
    },
    {
      NAICS22: "711212",
      "INDEX ITEM DESCRIPTION": "Drag strips",
    },
    {
      NAICS22: "711212",
      "INDEX ITEM DESCRIPTION": "Greyhound dog racetracks",
    },
    {
      NAICS22: "711212",
      "INDEX ITEM DESCRIPTION": "Harness racetracks",
    },
    {
      NAICS22: "711212",
      "INDEX ITEM DESCRIPTION": "Horse racetracks",
    },
    {
      NAICS22: "711212",
      "INDEX ITEM DESCRIPTION": "Motorcycle racetracks",
    },
    {
      NAICS22: "711212",
      "INDEX ITEM DESCRIPTION": "Racetracks (e.g., automobile, dog, horse)",
    },
    {
      NAICS22: "711212",
      "INDEX ITEM DESCRIPTION": "Snowmobile racetracks",
    },
    {
      NAICS22: "711212",
      "INDEX ITEM DESCRIPTION": "Speedways",
    },
    {
      NAICS22: "711212",
      "INDEX ITEM DESCRIPTION": "Stock car racetracks",
    },
    {
      NAICS22: "711212",
      "INDEX ITEM DESCRIPTION": "Thoroughbred racetracks",
    },
    {
      NAICS22: "711219",
      "INDEX ITEM DESCRIPTION": "Athletes, amateur, independent",
    },
    {
      NAICS22: "711219",
      "INDEX ITEM DESCRIPTION":
        "Athletes, independent (i.e., participating in live sports events)",
    },
    {
      NAICS22: "711219",
      "INDEX ITEM DESCRIPTION": "Automobile racing teams",
    },
    {
      NAICS22: "711219",
      "INDEX ITEM DESCRIPTION": "Boxers, independent professional",
    },
    {
      NAICS22: "711219",
      "INDEX ITEM DESCRIPTION": "Dog owners, race (i.e., racing dogs)",
    },
    {
      NAICS22: "711219",
      "INDEX ITEM DESCRIPTION": "Dog racing kennels",
    },
    {
      NAICS22: "711219",
      "INDEX ITEM DESCRIPTION": "Drivers, harness or race car",
    },
    {
      NAICS22: "711219",
      "INDEX ITEM DESCRIPTION": "Figure skaters, independent",
    },
    {
      NAICS22: "711219",
      "INDEX ITEM DESCRIPTION":
        "Golfers, independent professional (i.e., participating in sports events)",
    },
    {
      NAICS22: "711219",
      "INDEX ITEM DESCRIPTION": "Harness drivers",
    },
    {
      NAICS22: "711219",
      "INDEX ITEM DESCRIPTION": "Horse racing stables",
    },
    {
      NAICS22: "711219",
      "INDEX ITEM DESCRIPTION": "Jockeys, horse racing",
    },
    {
      NAICS22: "711219",
      "INDEX ITEM DESCRIPTION": "Kennels, dog racing",
    },
    {
      NAICS22: "711219",
      "INDEX ITEM DESCRIPTION": "Mixed martial artists, independent professional",
    },
    {
      NAICS22: "711219",
      "INDEX ITEM DESCRIPTION": "Motorcycle racing teams",
    },
    {
      NAICS22: "711219",
      "INDEX ITEM DESCRIPTION":
        "Professional athletes, independent (i.e., participating in sports events)",
    },
    {
      NAICS22: "711219",
      "INDEX ITEM DESCRIPTION": "Race car drivers",
    },
    {
      NAICS22: "711219",
      "INDEX ITEM DESCRIPTION": "Race car owners (i.e., racing cars)",
    },
    {
      NAICS22: "711219",
      "INDEX ITEM DESCRIPTION": "Race dog owners (i.e., racing dogs)",
    },
    {
      NAICS22: "711219",
      "INDEX ITEM DESCRIPTION": "Racehorse owners (i.e., racing horses)",
    },
    {
      NAICS22: "711219",
      "INDEX ITEM DESCRIPTION": "Racehorse trainers",
    },
    {
      NAICS22: "711219",
      "INDEX ITEM DESCRIPTION": "Racehorse training",
    },
    {
      NAICS22: "711219",
      "INDEX ITEM DESCRIPTION": "Racing stables, horse",
    },
    {
      NAICS22: "711219",
      "INDEX ITEM DESCRIPTION":
        "Racing teams (e.g., automobile, motorcycle, snowmobile)",
    },
    {
      NAICS22: "711219",
      "INDEX ITEM DESCRIPTION": "Referees and umpires",
    },
    {
      NAICS22: "711219",
      "INDEX ITEM DESCRIPTION":
        "Skiers, independent (i.e., participating in sports events)",
    },
    {
      NAICS22: "711219",
      "INDEX ITEM DESCRIPTION": "Snowmobile racing teams",
    },
    {
      NAICS22: "711219",
      "INDEX ITEM DESCRIPTION":
        "Sports professionals, independent (i.e., participating in sports events)",
    },
    {
      NAICS22: "711219",
      "INDEX ITEM DESCRIPTION": "Sports team scouting services, independent",
    },
    {
      NAICS22: "711219",
      "INDEX ITEM DESCRIPTION": "Sports trainers, independent",
    },
    {
      NAICS22: "711219",
      "INDEX ITEM DESCRIPTION": "Stables, horse racing",
    },
    {
      NAICS22: "711219",
      "INDEX ITEM DESCRIPTION": "Stock car racing teams",
    },
    {
      NAICS22: "711219",
      "INDEX ITEM DESCRIPTION":
        "Tennis professionals, independent (i.e., participating in sports events)",
    },
    {
      NAICS22: "711219",
      "INDEX ITEM DESCRIPTION": "Training race dogs",
    },
    {
      NAICS22: "711219",
      "INDEX ITEM DESCRIPTION": "Training racehorses",
    },
    {
      NAICS22: "711219",
      "INDEX ITEM DESCRIPTION": "Wrestlers, independent professional",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Air show managers with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Air show organizers with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Air show promoters with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Arena operators",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Arts event managers with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Arts event organizers with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Arts event promoters with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Arts festival managers with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Arts festival organizers with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Arts festival promoters with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Beauty pageant managers with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Beauty pageant organizers with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Beauty pageant promoters with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Boxing event managers with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Boxing event organizers with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Boxing event promoters with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Concert hall operators",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Concert managers with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Concert organizers with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Concert promoters with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Dance festival managers with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Dance festival organizers with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Dance festival promoters with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Ethnic festival promoters with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Fair managers with facilities, agricultural",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Fair organizers with facilities, agricultural",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Fair promoters with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Fair promoters with facilities, agricultural",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Festival managers with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Festival of arts managers with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Festival of arts organizers with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Festival of arts promoters with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Festival organizers with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Festival promoters with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Heritage festival managers with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Heritage festival organizers with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Heritage festival promoters with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Horse show managers with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Horse show organizers with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Horse show promoters with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Live arts center operators",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Live theater operators",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Managers of agricultural fairs with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Managers of arts events with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Managers of festivals with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION":
        "Managers of live performing arts productions (e.g., concerts) with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Managers of sports events with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Music festival managers with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Music festival organizers with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Music festival promoters with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION":
        "Organizers of agricultural fairs with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Organizers of arts events with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Organizers of festivals with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION":
        "Organizers of live performing arts productions (e.g., concerts) with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Organizers of sports events with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Performing arts center operators",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Professional sports promoters with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Promoters of agricultural fairs with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Promoters of arts events with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Promoters of festivals with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION":
        "Promoters of live performing arts productions (e.g., concerts) with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Promoters of sports events with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Rodeo managers with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Rodeo organizers with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Rodeo promoters with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Sports arena operators",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Sports event managers with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Sports event organizers with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Sports event promoters with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Sports stadium operators",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Stadium operators",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Theater festival managers with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Theater festival organizers with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Theater festival promoters with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Theater operators",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Theatrical production managers with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION":
        "Theatrical production organizers with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Theatrical production promoters with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Wrestling event managers with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Wrestling event organizers with facilities",
    },
    {
      NAICS22: "711310",
      "INDEX ITEM DESCRIPTION": "Wrestling event promoters with facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Agricultural fair managers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Agricultural fair organizers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Agricultural fair promoters without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Air show managers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Air show organizers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Air show promoters without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Arts event managers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Arts event organizers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Arts event promoters without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Arts festival managers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Arts festival organizers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Arts festival promoters without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Beauty pageant managers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Beauty pageant organizers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Beauty pageant promoters without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION":
        "Booking agencies, theatrical (except motion picture)",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Boxing event managers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Boxing event organizers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Boxing event promoters without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Concert booking agencies",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Concert managers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Concert organizers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Concert promoters without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Dance festival managers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Dance festival organizers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Dance festival promoters without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Ethnic festival managers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Ethnic festival organizers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Ethnic festival promoters without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Fair managers without facilities, agricultural",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION":
        "Fair organizers without facilities, agricultural",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Fair promoters without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Fair promoters without facilities, agricultural",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Festival managers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Festival of arts managers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Festival of arts organizers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Festival of arts promoters without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Festival organizers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Festival promoters without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Heritage festival managers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Heritage festival organizers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Heritage festival promoters without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Horse show managers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Horse show organizers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Horse show promoters without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION":
        "Managers of agricultural fairs without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Managers of arts events without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Managers of festivals without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION":
        "Managers of live performing arts productions (e.g., concerts) without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Managers of sports events without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Music festival managers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Music festival organizers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Music festival promoters without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION":
        "Organizers of agricultural fairs without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Organizers of arts events without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Organizers of festivals without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION":
        "Organizers of live performing arts productions (e.g., concerts) without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Organizers of sports events without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION":
        "Professional sports promoters without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION":
        "Promoters of agricultural fairs without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Promoters of arts events without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Promoters of festivals without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION":
        "Promoters of live performing arts productions (e.g., concerts) without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Promoters of sports events without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Rodeo managers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Rodeo organizers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Rodeo promoters without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Sports event managers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Sports event organizers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Sports event promoters without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Theater festival managers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Theater festival organizers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Theater festival promoters without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION":
        "Theatrical booking agencies (except motion picture)",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION":
        "Theatrical production managers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION":
        "Theatrical production organizers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION":
        "Theatrical production promoters without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Wrestling event managers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Wrestling event organizers without facilities",
    },
    {
      NAICS22: "711320",
      "INDEX ITEM DESCRIPTION": "Wrestling event promoters without facilities",
    },
    {
      NAICS22: "711410",
      "INDEX ITEM DESCRIPTION": "Agents, artists'",
    },
    {
      NAICS22: "711410",
      "INDEX ITEM DESCRIPTION": "Agents, authors'",
    },
    {
      NAICS22: "711410",
      "INDEX ITEM DESCRIPTION": "Agents, celebrities'",
    },
    {
      NAICS22: "711410",
      "INDEX ITEM DESCRIPTION": "Agents, entertainers'",
    },
    {
      NAICS22: "711410",
      "INDEX ITEM DESCRIPTION": "Agents, modeling",
    },
    {
      NAICS22: "711410",
      "INDEX ITEM DESCRIPTION": "Agents, public figures'",
    },
    {
      NAICS22: "711410",
      "INDEX ITEM DESCRIPTION": "Agents, sports figures'",
    },
    {
      NAICS22: "711410",
      "INDEX ITEM DESCRIPTION": "Agents, talent",
    },
    {
      NAICS22: "711410",
      "INDEX ITEM DESCRIPTION": "Agents, theatrical talent",
    },
    {
      NAICS22: "711410",
      "INDEX ITEM DESCRIPTION": "Artists' agents or managers",
    },
    {
      NAICS22: "711410",
      "INDEX ITEM DESCRIPTION": "Authors' agents or managers",
    },
    {
      NAICS22: "711410",
      "INDEX ITEM DESCRIPTION": "Celebrities' agents or managers",
    },
    {
      NAICS22: "711410",
      "INDEX ITEM DESCRIPTION": "Entertainers' agents or managers",
    },
    {
      NAICS22: "711410",
      "INDEX ITEM DESCRIPTION": "Lecture bureaus",
    },
    {
      NAICS22: "711410",
      "INDEX ITEM DESCRIPTION": "Literary agents",
    },
    {
      NAICS22: "711410",
      "INDEX ITEM DESCRIPTION":
        "Management agencies for artists, entertainers, and other public figures",
    },
    {
      NAICS22: "711410",
      "INDEX ITEM DESCRIPTION": "Managers, authors'",
    },
    {
      NAICS22: "711410",
      "INDEX ITEM DESCRIPTION": "Managers, celebrities'",
    },
    {
      NAICS22: "711410",
      "INDEX ITEM DESCRIPTION": "Managers, entertainers'",
    },
    {
      NAICS22: "711410",
      "INDEX ITEM DESCRIPTION": "Managers, public figures'",
    },
    {
      NAICS22: "711410",
      "INDEX ITEM DESCRIPTION": "Managers, sports figures'",
    },
    {
      NAICS22: "711410",
      "INDEX ITEM DESCRIPTION": "Modeling agents",
    },
    {
      NAICS22: "711410",
      "INDEX ITEM DESCRIPTION": "Models' agents or managers",
    },
    {
      NAICS22: "711410",
      "INDEX ITEM DESCRIPTION": "Public figures' agents or managers",
    },
    {
      NAICS22: "711410",
      "INDEX ITEM DESCRIPTION": "Speakers' bureaus",
    },
    {
      NAICS22: "711410",
      "INDEX ITEM DESCRIPTION": "Sports figures' agents or managers",
    },
    {
      NAICS22: "711410",
      "INDEX ITEM DESCRIPTION": "Talent agencies",
    },
    {
      NAICS22: "711410",
      "INDEX ITEM DESCRIPTION": "Talent agents",
    },
    {
      NAICS22: "711410",
      "INDEX ITEM DESCRIPTION": "Theatrical talent agents",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Actors, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Actresses, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Animated cartoon artists, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Announcers, independent radio and television",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Art restorers, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION":
        "Artists (except musical, commercial, medical), independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Artists (i.e., painters), independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Authors, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Ballet dancers, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Cameramen, independent (freelance)",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Cartoonists, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Celebrity spokespersons, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Choreographers, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Cinematographers, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Comedians, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Composers, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Conductors, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION":
        "Conservators (i.e., art, artifact restorers), independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Costume designers, independent theatrical",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Dancers, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION":
        "Directors (i.e., film, motion picture, music, theatrical), independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Directors, independent motion picture",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Directors, independent music",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Disc jockeys, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Entertainers, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Ethnic dancers, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Film actors, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Film producers, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Folk dancers, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Ghost writers, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Independent museum exhibit designers",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Independent technical writers",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Interpretive dancers, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Jazz dancers, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Journalists, independent (freelance)",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Lecturers, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Lighting technicians, theatrical, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Magicians, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Models, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Motion picture directors, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Motion picture producers, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Motivational speakers, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Music arrangers, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Music directors, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "News correspondents, independent (freelance)",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Newspaper columnists, independent (freelance)",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Orchestra conductors, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Painters (i.e., artists), independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Painting restorers, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Performers (i.e., entertainers), independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Performing artists, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Photographers, independent artistic",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Photojournalists, independent (freelance)",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Playwrights, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Poets, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Political cartoonists, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Producers, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Radio commentators, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Record producers, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Recording technicians, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Reporters, independent (freelance)",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Scenery designers, independent theatrical",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Screenplay writers, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Script writers, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Sculptors, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Set designers, independent theatrical",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Sketch artists, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Song writers, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Speakers, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Special effect technicians, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Sports announcers, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION":
        "Stage set (e.g., concert, motion picture, television) erecting and dismantling, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Standup comedians, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Storytellers, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Taxidermists, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Technical writers, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Television producers, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Wildlife artists, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Writers of advertising copy, independent",
    },
    {
      NAICS22: "711510",
      "INDEX ITEM DESCRIPTION": "Writers, independent (freelance)",
    },
    {
      NAICS22: "712110",
      "INDEX ITEM DESCRIPTION": "Art galleries (except retail)",
    },
    {
      NAICS22: "712110",
      "INDEX ITEM DESCRIPTION": "Art museums",
    },
    {
      NAICS22: "712110",
      "INDEX ITEM DESCRIPTION": "Community museums",
    },
    {
      NAICS22: "712110",
      "INDEX ITEM DESCRIPTION": "Contemporary art museums",
    },
    {
      NAICS22: "712110",
      "INDEX ITEM DESCRIPTION": "Decorative art museums",
    },
    {
      NAICS22: "712110",
      "INDEX ITEM DESCRIPTION": "Fine arts museums",
    },
    {
      NAICS22: "712110",
      "INDEX ITEM DESCRIPTION": "Galleries, art (except retail)",
    },
    {
      NAICS22: "712110",
      "INDEX ITEM DESCRIPTION": "Halls of fame",
    },
    {
      NAICS22: "712110",
      "INDEX ITEM DESCRIPTION": "Herbariums",
    },
    {
      NAICS22: "712110",
      "INDEX ITEM DESCRIPTION": "Historical museums",
    },
    {
      NAICS22: "712110",
      "INDEX ITEM DESCRIPTION": "Human history museums",
    },
    {
      NAICS22: "712110",
      "INDEX ITEM DESCRIPTION": "Interactive museums",
    },
    {
      NAICS22: "712110",
      "INDEX ITEM DESCRIPTION": "Marine museums",
    },
    {
      NAICS22: "712110",
      "INDEX ITEM DESCRIPTION": "Military museums",
    },
    {
      NAICS22: "712110",
      "INDEX ITEM DESCRIPTION": "Mobile museums",
    },
    {
      NAICS22: "712110",
      "INDEX ITEM DESCRIPTION": "Multidisciplinary museums",
    },
    {
      NAICS22: "712110",
      "INDEX ITEM DESCRIPTION": "Museums",
    },
    {
      NAICS22: "712110",
      "INDEX ITEM DESCRIPTION": "Natural history museums",
    },
    {
      NAICS22: "712110",
      "INDEX ITEM DESCRIPTION": "Natural science museums",
    },
    {
      NAICS22: "712110",
      "INDEX ITEM DESCRIPTION": "Observatories (except research institutions)",
    },
    {
      NAICS22: "712110",
      "INDEX ITEM DESCRIPTION": "Planetariums",
    },
    {
      NAICS22: "712110",
      "INDEX ITEM DESCRIPTION": "Science and technology museums",
    },
    {
      NAICS22: "712110",
      "INDEX ITEM DESCRIPTION": "Sports halls of fame",
    },
    {
      NAICS22: "712110",
      "INDEX ITEM DESCRIPTION": "Traveling museum exhibits",
    },
    {
      NAICS22: "712110",
      "INDEX ITEM DESCRIPTION": "War museums",
    },
    {
      NAICS22: "712110",
      "INDEX ITEM DESCRIPTION": "Wax museums",
    },
    {
      NAICS22: "712120",
      "INDEX ITEM DESCRIPTION": "Archeological sites (i.e., public display)",
    },
    {
      NAICS22: "712120",
      "INDEX ITEM DESCRIPTION": "Battlefields",
    },
    {
      NAICS22: "712120",
      "INDEX ITEM DESCRIPTION": "Heritage villages",
    },
    {
      NAICS22: "712120",
      "INDEX ITEM DESCRIPTION": "Historical forts",
    },
    {
      NAICS22: "712120",
      "INDEX ITEM DESCRIPTION": "Historical ships",
    },
    {
      NAICS22: "712120",
      "INDEX ITEM DESCRIPTION": "Historical sites",
    },
    {
      NAICS22: "712120",
      "INDEX ITEM DESCRIPTION": "Pioneer villages",
    },
    {
      NAICS22: "712130",
      "INDEX ITEM DESCRIPTION": "Animal exhibits, live",
    },
    {
      NAICS22: "712130",
      "INDEX ITEM DESCRIPTION": "Animal safari parks",
    },
    {
      NAICS22: "712130",
      "INDEX ITEM DESCRIPTION": "Aquariums",
    },
    {
      NAICS22: "712130",
      "INDEX ITEM DESCRIPTION": "Arboreta",
    },
    {
      NAICS22: "712130",
      "INDEX ITEM DESCRIPTION": "Arboretums",
    },
    {
      NAICS22: "712130",
      "INDEX ITEM DESCRIPTION": "Aviaries",
    },
    {
      NAICS22: "712130",
      "INDEX ITEM DESCRIPTION": "Botanical gardens",
    },
    {
      NAICS22: "712130",
      "INDEX ITEM DESCRIPTION": "Conservatories, botanical",
    },
    {
      NAICS22: "712130",
      "INDEX ITEM DESCRIPTION": "Gardens, zoological or botanical",
    },
    {
      NAICS22: "712130",
      "INDEX ITEM DESCRIPTION": "Menageries",
    },
    {
      NAICS22: "712130",
      "INDEX ITEM DESCRIPTION": "Parks, wild animal",
    },
    {
      NAICS22: "712130",
      "INDEX ITEM DESCRIPTION": "Petting zoos",
    },
    {
      NAICS22: "712130",
      "INDEX ITEM DESCRIPTION": "Reptile exhibits, live",
    },
    {
      NAICS22: "712130",
      "INDEX ITEM DESCRIPTION": "Wild animal parks",
    },
    {
      NAICS22: "712130",
      "INDEX ITEM DESCRIPTION": "Zoological gardens",
    },
    {
      NAICS22: "712130",
      "INDEX ITEM DESCRIPTION": "Zoos",
    },
    {
      NAICS22: "712190",
      "INDEX ITEM DESCRIPTION": "Bird sanctuaries",
    },
    {
      NAICS22: "712190",
      "INDEX ITEM DESCRIPTION":
        "Caverns (i.e., natural wonder tourist attractions)",
    },
    {
      NAICS22: "712190",
      "INDEX ITEM DESCRIPTION": "Conservation areas",
    },
    {
      NAICS22: "712190",
      "INDEX ITEM DESCRIPTION": "Interpretive centers, nature",
    },
    {
      NAICS22: "712190",
      "INDEX ITEM DESCRIPTION": "National parks",
    },
    {
      NAICS22: "712190",
      "INDEX ITEM DESCRIPTION":
        "Natural wonder tourist attractions (e.g., caverns, waterfalls)",
    },
    {
      NAICS22: "712190",
      "INDEX ITEM DESCRIPTION": "Nature centers",
    },
    {
      NAICS22: "712190",
      "INDEX ITEM DESCRIPTION": "Nature parks",
    },
    {
      NAICS22: "712190",
      "INDEX ITEM DESCRIPTION": "Nature preserves",
    },
    {
      NAICS22: "712190",
      "INDEX ITEM DESCRIPTION": "Nature reserves",
    },
    {
      NAICS22: "712190",
      "INDEX ITEM DESCRIPTION": "Parks, national",
    },
    {
      NAICS22: "712190",
      "INDEX ITEM DESCRIPTION": "Parks, nature",
    },
    {
      NAICS22: "712190",
      "INDEX ITEM DESCRIPTION": "Provincial parks",
    },
    {
      NAICS22: "712190",
      "INDEX ITEM DESCRIPTION":
        "Waterfalls (i.e., natural wonder tourist attractions)",
    },
    {
      NAICS22: "712190",
      "INDEX ITEM DESCRIPTION": "Wildlife sanctuaries",
    },
    {
      NAICS22: "713110",
      "INDEX ITEM DESCRIPTION": "Amusement parks (e.g., theme, water)",
    },
    {
      NAICS22: "713110",
      "INDEX ITEM DESCRIPTION": "Parks (e.g., theme, water), amusement",
    },
    {
      NAICS22: "713110",
      "INDEX ITEM DESCRIPTION": "Piers, amusement",
    },
    {
      NAICS22: "713110",
      "INDEX ITEM DESCRIPTION": "Theme parks, amusement",
    },
    {
      NAICS22: "713110",
      "INDEX ITEM DESCRIPTION": "Water parks, amusement",
    },
    {
      NAICS22: "713120",
      "INDEX ITEM DESCRIPTION": "Amusement arcades",
    },
    {
      NAICS22: "713120",
      "INDEX ITEM DESCRIPTION":
        "Amusement device (except gambling) parlors, coin- or card-operated",
    },
    {
      NAICS22: "713120",
      "INDEX ITEM DESCRIPTION":
        "Amusement devices (except gambling) operated in own facilities",
    },
    {
      NAICS22: "713120",
      "INDEX ITEM DESCRIPTION": "Arcades, amusement",
    },
    {
      NAICS22: "713120",
      "INDEX ITEM DESCRIPTION": "Electronic game arcades",
    },
    {
      NAICS22: "713120",
      "INDEX ITEM DESCRIPTION": "Family fun centers",
    },
    {
      NAICS22: "713120",
      "INDEX ITEM DESCRIPTION": "Game rooms (except gambling)",
    },
    {
      NAICS22: "713120",
      "INDEX ITEM DESCRIPTION": "Indoor play areas",
    },
    {
      NAICS22: "713120",
      "INDEX ITEM DESCRIPTION": "Pinball arcades",
    },
    {
      NAICS22: "713120",
      "INDEX ITEM DESCRIPTION": "Video game arcades (except gambling)",
    },
    {
      NAICS22: "713210",
      "INDEX ITEM DESCRIPTION": "Casinos (except casino hotels)",
    },
    {
      NAICS22: "713210",
      "INDEX ITEM DESCRIPTION": "Casinos (except casino hotels) with racetrack",
    },
    {
      NAICS22: "713210",
      "INDEX ITEM DESCRIPTION": "Cruises, gambling",
    },
    {
      NAICS22: "713210",
      "INDEX ITEM DESCRIPTION":
        "Floating casinos (i.e., gambling cruises, riverboat casinos)",
    },
    {
      NAICS22: "713210",
      "INDEX ITEM DESCRIPTION": "Gambling cruises",
    },
    {
      NAICS22: "713210",
      "INDEX ITEM DESCRIPTION": "Riverboat casinos",
    },
    {
      NAICS22: "713210",
      "INDEX ITEM DESCRIPTION":
        "Stand-alone casinos (except slot machine parlors)",
    },
    {
      NAICS22: "713290",
      "INDEX ITEM DESCRIPTION": "Betting information services",
    },
    {
      NAICS22: "713290",
      "INDEX ITEM DESCRIPTION": "Bingo halls",
    },
    {
      NAICS22: "713290",
      "INDEX ITEM DESCRIPTION": "Bingo parlors",
    },
    {
      NAICS22: "713290",
      "INDEX ITEM DESCRIPTION": "Bookies",
    },
    {
      NAICS22: "713290",
      "INDEX ITEM DESCRIPTION": "Bookmakers",
    },
    {
      NAICS22: "713290",
      "INDEX ITEM DESCRIPTION": "Card rooms (e.g., poker rooms)",
    },
    {
      NAICS22: "713290",
      "INDEX ITEM DESCRIPTION":
        "Coin- or card-operated gambling device concession operators (i.e., supplying and servicing in others' facilities)",
    },
    {
      NAICS22: "713290",
      "INDEX ITEM DESCRIPTION":
        "Gambling control boards, operating gambling activities",
    },
    {
      NAICS22: "713290",
      "INDEX ITEM DESCRIPTION":
        "Gambling device arcades or parlors, coin- or card-operated",
    },
    {
      NAICS22: "713290",
      "INDEX ITEM DESCRIPTION":
        "Gambling device concession operators (i.e., supplying and servicing in others' facilities), coin- or card-operated",
    },
    {
      NAICS22: "713290",
      "INDEX ITEM DESCRIPTION":
        "Lottery control boards (i.e., operating lotteries)",
    },
    {
      NAICS22: "713290",
      "INDEX ITEM DESCRIPTION": "Lottery corporations",
    },
    {
      NAICS22: "713290",
      "INDEX ITEM DESCRIPTION":
        "Lottery ticket sales agents (except retail stores)",
    },
    {
      NAICS22: "713290",
      "INDEX ITEM DESCRIPTION": "Lottery ticket vendors (except retail stores)",
    },
    {
      NAICS22: "713290",
      "INDEX ITEM DESCRIPTION": "Off-track betting parlors",
    },
    {
      NAICS22: "713290",
      "INDEX ITEM DESCRIPTION": "Online gambling sites",
    },
    {
      NAICS22: "713290",
      "INDEX ITEM DESCRIPTION": "Online sports betting sites",
    },
    {
      NAICS22: "713290",
      "INDEX ITEM DESCRIPTION":
        "Slot machine concession operators (i.e., supplying and servicing in others' facilities)",
    },
    {
      NAICS22: "713290",
      "INDEX ITEM DESCRIPTION": "Slot machine parlors",
    },
    {
      NAICS22: "713290",
      "INDEX ITEM DESCRIPTION":
        "Video gambling device concession operators (i.e., supplying and servicing in others' facilities)",
    },
    {
      NAICS22: "713290",
      "INDEX ITEM DESCRIPTION":
        "Video gaming device concession operators (i.e., supplying and servicing in others' facilities)",
    },
    {
      NAICS22: "713910",
      "INDEX ITEM DESCRIPTION": "Country clubs",
    },
    {
      NAICS22: "713910",
      "INDEX ITEM DESCRIPTION": "Golf and country clubs",
    },
    {
      NAICS22: "713910",
      "INDEX ITEM DESCRIPTION": "Golf courses (except miniature, pitch-n-putt)",
    },
    {
      NAICS22: "713920",
      "INDEX ITEM DESCRIPTION": "Alpine skiing facilities without accommodations",
    },
    {
      NAICS22: "713920",
      "INDEX ITEM DESCRIPTION":
        "Cross country skiing facilities without accommodations",
    },
    {
      NAICS22: "713920",
      "INDEX ITEM DESCRIPTION":
        "Downhill skiing facilities without accommodations",
    },
    {
      NAICS22: "713920",
      "INDEX ITEM DESCRIPTION": "Four season ski resorts without accommodations",
    },
    {
      NAICS22: "713920",
      "INDEX ITEM DESCRIPTION": "Ski lift and tow operators",
    },
    {
      NAICS22: "713920",
      "INDEX ITEM DESCRIPTION": "Ski resorts without accommodations",
    },
    {
      NAICS22: "713920",
      "INDEX ITEM DESCRIPTION":
        "Skiing facilities, cross country, without accommodations",
    },
    {
      NAICS22: "713920",
      "INDEX ITEM DESCRIPTION":
        "Skiing facilities, downhill, without accommodations",
    },
    {
      NAICS22: "713930",
      "INDEX ITEM DESCRIPTION": "Boating clubs with marinas",
    },
    {
      NAICS22: "713930",
      "INDEX ITEM DESCRIPTION": "Marinas",
    },
    {
      NAICS22: "713930",
      "INDEX ITEM DESCRIPTION": "Marine basins, operation of",
    },
    {
      NAICS22: "713930",
      "INDEX ITEM DESCRIPTION": "Sailing clubs with marinas",
    },
    {
      NAICS22: "713930",
      "INDEX ITEM DESCRIPTION": "Yacht basins",
    },
    {
      NAICS22: "713930",
      "INDEX ITEM DESCRIPTION": "Yacht clubs with marinas",
    },
    {
      NAICS22: "713940",
      "INDEX ITEM DESCRIPTION": "Aerobic dance and exercise centers",
    },
    {
      NAICS22: "713940",
      "INDEX ITEM DESCRIPTION": "Athletic club facilities, physical fitness",
    },
    {
      NAICS22: "713940",
      "INDEX ITEM DESCRIPTION": "Body building studios, physical fitness",
    },
    {
      NAICS22: "713940",
      "INDEX ITEM DESCRIPTION": "Dance centers, aerobic",
    },
    {
      NAICS22: "713940",
      "INDEX ITEM DESCRIPTION": "Exercise centers",
    },
    {
      NAICS22: "713940",
      "INDEX ITEM DESCRIPTION": "Fitness centers",
    },
    {
      NAICS22: "713940",
      "INDEX ITEM DESCRIPTION": "Fitness salons",
    },
    {
      NAICS22: "713940",
      "INDEX ITEM DESCRIPTION": "Fitness spas without accommodations",
    },
    {
      NAICS22: "713940",
      "INDEX ITEM DESCRIPTION": "Gymnasiums",
    },
    {
      NAICS22: "713940",
      "INDEX ITEM DESCRIPTION": "Gyms, physical fitness",
    },
    {
      NAICS22: "713940",
      "INDEX ITEM DESCRIPTION": "Handball club facilities",
    },
    {
      NAICS22: "713940",
      "INDEX ITEM DESCRIPTION": "Health club facilities, physical fitness",
    },
    {
      NAICS22: "713940",
      "INDEX ITEM DESCRIPTION":
        "Health spas without accommodations, physical fitness",
    },
    {
      NAICS22: "713940",
      "INDEX ITEM DESCRIPTION": "Health studios, physical fitness",
    },
    {
      NAICS22: "713940",
      "INDEX ITEM DESCRIPTION": "Ice skating rinks",
    },
    {
      NAICS22: "713940",
      "INDEX ITEM DESCRIPTION": "Physical fitness centers",
    },
    {
      NAICS22: "713940",
      "INDEX ITEM DESCRIPTION": "Physical fitness facilities",
    },
    {
      NAICS22: "713940",
      "INDEX ITEM DESCRIPTION": "Physical fitness studios",
    },
    {
      NAICS22: "713940",
      "INDEX ITEM DESCRIPTION": "Pilates fitness studios or centers",
    },
    {
      NAICS22: "713940",
      "INDEX ITEM DESCRIPTION": "Racquetball club facilities",
    },
    {
      NAICS22: "713940",
      "INDEX ITEM DESCRIPTION": "Recreational sports club facilities",
    },
    {
      NAICS22: "713940",
      "INDEX ITEM DESCRIPTION": "Rinks, ice or roller skating",
    },
    {
      NAICS22: "713940",
      "INDEX ITEM DESCRIPTION": "Roller skating rinks",
    },
    {
      NAICS22: "713940",
      "INDEX ITEM DESCRIPTION": "Spas without accommodations, fitness",
    },
    {
      NAICS22: "713940",
      "INDEX ITEM DESCRIPTION": "Sports club facilities, physical fitness",
    },
    {
      NAICS22: "713940",
      "INDEX ITEM DESCRIPTION": "Squash club facilities",
    },
    {
      NAICS22: "713940",
      "INDEX ITEM DESCRIPTION": "Strength development centers",
    },
    {
      NAICS22: "713940",
      "INDEX ITEM DESCRIPTION": "Swimming pools",
    },
    {
      NAICS22: "713940",
      "INDEX ITEM DESCRIPTION": "Tennis club facilities",
    },
    {
      NAICS22: "713940",
      "INDEX ITEM DESCRIPTION": "Tennis courts",
    },
    {
      NAICS22: "713940",
      "INDEX ITEM DESCRIPTION": "Wave pools",
    },
    {
      NAICS22: "713940",
      "INDEX ITEM DESCRIPTION": "Weight training centers",
    },
    {
      NAICS22: "713940",
      "INDEX ITEM DESCRIPTION": "Yoga fitness studios or centers",
    },
    {
      NAICS22: "713950",
      "INDEX ITEM DESCRIPTION": "Bowling alleys",
    },
    {
      NAICS22: "713950",
      "INDEX ITEM DESCRIPTION": "Bowling centers",
    },
    {
      NAICS22: "713950",
      "INDEX ITEM DESCRIPTION": "Candle pin bowling alleys",
    },
    {
      NAICS22: "713950",
      "INDEX ITEM DESCRIPTION": "Candle pin bowling centers",
    },
    {
      NAICS22: "713950",
      "INDEX ITEM DESCRIPTION": "Duck pin bowling alleys",
    },
    {
      NAICS22: "713950",
      "INDEX ITEM DESCRIPTION": "Duck pin bowling centers",
    },
    {
      NAICS22: "713950",
      "INDEX ITEM DESCRIPTION": "Five pin bowling centers",
    },
    {
      NAICS22: "713950",
      "INDEX ITEM DESCRIPTION": "Ten pin bowling alleys",
    },
    {
      NAICS22: "713950",
      "INDEX ITEM DESCRIPTION": "Ten pin bowling centers",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Amateur sports teams, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION":
        "Amusement device (except gambling) concession operators (i.e., supplying and servicing in others' facilities)",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION":
        "Amusement ride concession operators (i.e., supplying and servicing in others' facilities)",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Archery ranges",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION":
        "Athletic clubs (i.e., sports teams) not operating sports facilities, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Aviation clubs, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Axe throwing clubs",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Ballrooms",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Baseball clubs, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Basketball clubs, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Bathing beaches",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Beach clubs, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Beaches, bathing",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Billiard parlors",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Billiard rooms",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Boating clubs without marinas",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Boccie ball courts",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Bowling leagues or teams, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Boxing clubs, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Boys' day camps (except instructional)",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Bridge clubs, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Camps (except instructional), day",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Canoeing, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION":
        "Carnival ride concession operators (i.e., supplying and servicing in others' facilities)",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Chess or bridge clubs, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION":
        "Coin- or card-operated nongambling amusement device concession operators (i.e., supplying and servicing in others' facilities)",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION":
        "Concession operators, amusement device (except gambling) and ride",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Curling facilities",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Dance halls",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION":
        "Discotheques (except those serving alcoholic beverages)",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Driving ranges, golf",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Escape game rooms",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Escape rooms",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION":
        "Esports video gaming clubs, teams, or leagues, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Fireworks display services",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Fishing clubs, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Fishing guide services",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Fishing piers",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Flying clubs, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Football clubs, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Galleries, shooting",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Girls' day camps (except instructional)",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Gocart raceways (i.e., amusement rides)",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Gocart tracks (i.e., amusement rides)",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Golf courses, miniature",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Golf courses, pitch-n-putt",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Golf driving ranges",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Golf practice ranges",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION":
        "Guide services (i.e., fishing, hunting, tourist)",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Guide services, fishing",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Guide services, hunting",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Guide services, tourist",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Gun clubs, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION":
        "Haunted houses and similar fright attractions, concession operators (i.e., supplying and servicing in others' facilities)",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Hockey clubs, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Hockey teams, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION":
        "Hookah lounges (except primarily selling food and beverages)",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Horse rental services, recreational saddle",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Horseback riding, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Hunting clubs, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Hunting guide services",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Ice hockey clubs, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION":
        "Jukebox concession operators (i.e., supplying and servicing in others' facilities)",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Kayaking, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Lawn bowling clubs",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Miniature golf courses",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Mountain hiking, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Nightclubs without alcoholic beverages",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Nudist camps without accommodations",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Observation towers",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION":
        "Outdoor adventure operations (e.g., white water rafting) without accommodations",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION":
        "Outfitters (i.e., providing trips and equipment)",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Pack trains (i.e., trail riding), recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION":
        "Paintball, laser tag, and similar fields and arenas",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Parasailing, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Pickleball clubs, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Picnic grounds",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION":
        "Pinball machine concession operators (i.e., supplying and servicing in others' facilities)",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Ping pong parlors",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Pool halls",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Pool parlors",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Pool rooms",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Racetracks, slot car (i.e., amusement devices)",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Raceways, gocart (i.e., amusement rides)",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Recreational camps without accommodations",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Recreational day camps (except instructional)",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION":
        "Recreational sports clubs (i.e., sports teams) not operating sports facilities",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Recreational sports teams and leagues",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Riding clubs, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Riding stables (except boarding horses)",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Rifle clubs, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "River rafting, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Rowing clubs, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Saddle horse rental services, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Sailing clubs without marinas",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Sea kayaking, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Shooting clubs, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Shooting galleries",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Shooting ranges",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Skeet shooting facilities",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Slot car racetracks (i.e., amusement devices)",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Snowmobiling, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Soccer clubs, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION":
        "Sports clubs (i.e., sports teams) not operating sports facilities, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Sports teams and leagues, recreational or youth",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Stables, riding",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Summer day camps (except instructional)",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Tourist guide services",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Trail riding, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Trampoline facilities, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Trapshooting facilities, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Waterslides (i.e., amusement rides)",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Wax figure exhibitions, amusement",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "White water rafting, recreational",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Yacht clubs without marinas",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Youth sports league teams",
    },
    {
      NAICS22: "713990",
      "INDEX ITEM DESCRIPTION": "Zip-line courses (i.e., amusement rides)",
    },
    {
      NAICS22: "721110",
      "INDEX ITEM DESCRIPTION":
        "Alpine skiing facilities with accommodations (i.e., ski resorts)",
    },
    {
      NAICS22: "721110",
      "INDEX ITEM DESCRIPTION": "Auto courts, lodging",
    },
    {
      NAICS22: "721110",
      "INDEX ITEM DESCRIPTION": "Automobile courts, lodging",
    },
    {
      NAICS22: "721110",
      "INDEX ITEM DESCRIPTION":
        "Health spas (i.e., physical fitness facilities) with accommodations",
    },
    {
      NAICS22: "721110",
      "INDEX ITEM DESCRIPTION":
        "Hotel management services (i.e., providing management and operating staff to run hotel)",
    },
    {
      NAICS22: "721110",
      "INDEX ITEM DESCRIPTION": "Hotels (except casino hotels)",
    },
    {
      NAICS22: "721110",
      "INDEX ITEM DESCRIPTION":
        "Hotels (except casino hotels) with golf courses, tennis courts, and/or other health spa facilities (i.e., resorts)",
    },
    {
      NAICS22: "721110",
      "INDEX ITEM DESCRIPTION": "Hotels, membership",
    },
    {
      NAICS22: "721110",
      "INDEX ITEM DESCRIPTION": "Hotels, resort, without casinos",
    },
    {
      NAICS22: "721110",
      "INDEX ITEM DESCRIPTION": "Hotels, seasonal, without casinos",
    },
    {
      NAICS22: "721110",
      "INDEX ITEM DESCRIPTION": "Membership hotels",
    },
    {
      NAICS22: "721110",
      "INDEX ITEM DESCRIPTION": "Motels",
    },
    {
      NAICS22: "721110",
      "INDEX ITEM DESCRIPTION": "Motor courts",
    },
    {
      NAICS22: "721110",
      "INDEX ITEM DESCRIPTION": "Motor hotels without casinos",
    },
    {
      NAICS22: "721110",
      "INDEX ITEM DESCRIPTION": "Motor inns",
    },
    {
      NAICS22: "721110",
      "INDEX ITEM DESCRIPTION": "Motor lodges",
    },
    {
      NAICS22: "721110",
      "INDEX ITEM DESCRIPTION": "Resort hotels without casinos",
    },
    {
      NAICS22: "721110",
      "INDEX ITEM DESCRIPTION": "Seasonal hotels without casinos",
    },
    {
      NAICS22: "721110",
      "INDEX ITEM DESCRIPTION": "Ski lodges and resorts with accommodations",
    },
    {
      NAICS22: "721110",
      "INDEX ITEM DESCRIPTION": "Summer resort hotels without casinos",
    },
    {
      NAICS22: "721110",
      "INDEX ITEM DESCRIPTION": "Tourist lodges",
    },
    {
      NAICS22: "721120",
      "INDEX ITEM DESCRIPTION": "Casino hotels",
    },
    {
      NAICS22: "721120",
      "INDEX ITEM DESCRIPTION": "Hotels, casino",
    },
    {
      NAICS22: "721120",
      "INDEX ITEM DESCRIPTION": "Hotels, resort, with casinos",
    },
    {
      NAICS22: "721120",
      "INDEX ITEM DESCRIPTION": "Hotels, seasonal, with casinos",
    },
    {
      NAICS22: "721120",
      "INDEX ITEM DESCRIPTION": "Resort hotels with casinos",
    },
    {
      NAICS22: "721191",
      "INDEX ITEM DESCRIPTION": "Bed and breakfast inns",
    },
    {
      NAICS22: "721191",
      "INDEX ITEM DESCRIPTION": "Inns, bed and breakfast",
    },
    {
      NAICS22: "721199",
      "INDEX ITEM DESCRIPTION": "Cabins, housekeeping",
    },
    {
      NAICS22: "721199",
      "INDEX ITEM DESCRIPTION": "Cottages, housekeeping",
    },
    {
      NAICS22: "721199",
      "INDEX ITEM DESCRIPTION": "Guest houses",
    },
    {
      NAICS22: "721199",
      "INDEX ITEM DESCRIPTION": "Hostels",
    },
    {
      NAICS22: "721199",
      "INDEX ITEM DESCRIPTION": "Housekeeping cabins",
    },
    {
      NAICS22: "721199",
      "INDEX ITEM DESCRIPTION": "Housekeeping cottages",
    },
    {
      NAICS22: "721199",
      "INDEX ITEM DESCRIPTION": "Tourist courts",
    },
    {
      NAICS22: "721199",
      "INDEX ITEM DESCRIPTION": "Tourist homes",
    },
    {
      NAICS22: "721199",
      "INDEX ITEM DESCRIPTION": "Youth hostels",
    },
    {
      NAICS22: "721211",
      "INDEX ITEM DESCRIPTION": "Campgrounds",
    },
    {
      NAICS22: "721211",
      "INDEX ITEM DESCRIPTION": "Campsites",
    },
    {
      NAICS22: "721211",
      "INDEX ITEM DESCRIPTION": "Recreational vehicle parks",
    },
    {
      NAICS22: "721211",
      "INDEX ITEM DESCRIPTION": "RV (recreational vehicle) parks",
    },
    {
      NAICS22: "721211",
      "INDEX ITEM DESCRIPTION": "Travel trailer campsites",
    },
    {
      NAICS22: "721214",
      "INDEX ITEM DESCRIPTION": "Boys' camps (except day, instructional)",
    },
    {
      NAICS22: "721214",
      "INDEX ITEM DESCRIPTION": "Camps (except day, instructional)",
    },
    {
      NAICS22: "721214",
      "INDEX ITEM DESCRIPTION": "Children's camps (except day, instructional)",
    },
    {
      NAICS22: "721214",
      "INDEX ITEM DESCRIPTION": "Dude ranches",
    },
    {
      NAICS22: "721214",
      "INDEX ITEM DESCRIPTION": "Fishing camps with accommodation facilities",
    },
    {
      NAICS22: "721214",
      "INDEX ITEM DESCRIPTION": "Girls' camps (except day, instructional)",
    },
    {
      NAICS22: "721214",
      "INDEX ITEM DESCRIPTION": "Guest ranches with accommodation facilities",
    },
    {
      NAICS22: "721214",
      "INDEX ITEM DESCRIPTION": "Hunting camps with accommodation facilities",
    },
    {
      NAICS22: "721214",
      "INDEX ITEM DESCRIPTION": "Nudist camps with accommodation facilities",
    },
    {
      NAICS22: "721214",
      "INDEX ITEM DESCRIPTION":
        "Outdoor adventure retreats with accommodation facilities",
    },
    {
      NAICS22: "721214",
      "INDEX ITEM DESCRIPTION":
        "Recreational camps with accommodation facilities (except campgrounds)",
    },
    {
      NAICS22: "721214",
      "INDEX ITEM DESCRIPTION": "Summer camps (except day, instructional)",
    },
    {
      NAICS22: "721214",
      "INDEX ITEM DESCRIPTION":
        "Trail riding camps with accommodation facilities",
    },
    {
      NAICS22: "721214",
      "INDEX ITEM DESCRIPTION":
        "Vacation camps (except campgrounds, day, instructional)",
    },
    {
      NAICS22: "721214",
      "INDEX ITEM DESCRIPTION": "Wilderness camps",
    },
    {
      NAICS22: "721310",
      "INDEX ITEM DESCRIPTION": "Boarding houses",
    },
    {
      NAICS22: "721310",
      "INDEX ITEM DESCRIPTION": "Clubs, residential",
    },
    {
      NAICS22: "721310",
      "INDEX ITEM DESCRIPTION": "Corporate rooming and boarding houses",
    },
    {
      NAICS22: "721310",
      "INDEX ITEM DESCRIPTION": "Dormitories, off campus",
    },
    {
      NAICS22: "721310",
      "INDEX ITEM DESCRIPTION": "Fraternity houses",
    },
    {
      NAICS22: "721310",
      "INDEX ITEM DESCRIPTION": "Migrant workers' camps",
    },
    {
      NAICS22: "721310",
      "INDEX ITEM DESCRIPTION": "Off campus dormitories",
    },
    {
      NAICS22: "721310",
      "INDEX ITEM DESCRIPTION": "Residence clubs, organizational",
    },
    {
      NAICS22: "721310",
      "INDEX ITEM DESCRIPTION": "Residential clubs",
    },
    {
      NAICS22: "721310",
      "INDEX ITEM DESCRIPTION": "Rooming and boarding houses",
    },
    {
      NAICS22: "721310",
      "INDEX ITEM DESCRIPTION": "Sorority houses",
    },
    {
      NAICS22: "721310",
      "INDEX ITEM DESCRIPTION": "Workers' camps",
    },
    {
      NAICS22: "721310",
      "INDEX ITEM DESCRIPTION": "Workers' dormitories",
    },
    {
      NAICS22: "722310",
      "INDEX ITEM DESCRIPTION": "Airline food services contractors",
    },
    {
      NAICS22: "722310",
      "INDEX ITEM DESCRIPTION":
        "Cafeteria food services contractors (e.g., government office cafeterias, hospital cafeterias, school cafeterias)",
    },
    {
      NAICS22: "722310",
      "INDEX ITEM DESCRIPTION":
        "Food concession contractors (e.g., convention facilities, entertainment facilities, sporting facilities)",
    },
    {
      NAICS22: "722310",
      "INDEX ITEM DESCRIPTION": "Food service contractors, airline",
    },
    {
      NAICS22: "722310",
      "INDEX ITEM DESCRIPTION": "Food service contractors, cafeteria",
    },
    {
      NAICS22: "722310",
      "INDEX ITEM DESCRIPTION":
        "Food service contractors, concession operators (e.g., convention facilities, entertainment facilities, sporting facilities)",
    },
    {
      NAICS22: "722310",
      "INDEX ITEM DESCRIPTION": "Food service contractors, industrial",
    },
    {
      NAICS22: "722310",
      "INDEX ITEM DESCRIPTION": "Food service contractors, institutional",
    },
    {
      NAICS22: "722310",
      "INDEX ITEM DESCRIPTION":
        "Industrial caterers (i.e., providing food services on a contractual arrangement (except single-event basis))",
    },
    {
      NAICS22: "722320",
      "INDEX ITEM DESCRIPTION": "Banquet halls with catering staff",
    },
    {
      NAICS22: "722320",
      "INDEX ITEM DESCRIPTION":
        "Bartender services including supply of equipment and alcohol",
    },
    {
      NAICS22: "722320",
      "INDEX ITEM DESCRIPTION":
        "Bartender services on own account (serving only)",
    },
    {
      NAICS22: "722320",
      "INDEX ITEM DESCRIPTION": "Caterers",
    },
    {
      NAICS22: "722320",
      "INDEX ITEM DESCRIPTION": "Catering services, social",
    },
    {
      NAICS22: "722330",
      "INDEX ITEM DESCRIPTION": "Beverage stands, nonalcoholic, mobile",
    },
    {
      NAICS22: "722330",
      "INDEX ITEM DESCRIPTION": "Canteens, mobile",
    },
    {
      NAICS22: "722330",
      "INDEX ITEM DESCRIPTION": "Coffee carts, mobile",
    },
    {
      NAICS22: "722330",
      "INDEX ITEM DESCRIPTION": "Concession snack stands, mobile",
    },
    {
      NAICS22: "722330",
      "INDEX ITEM DESCRIPTION": "Food carts and trucks, mobile",
    },
    {
      NAICS22: "722330",
      "INDEX ITEM DESCRIPTION": "Food concession stands, mobile",
    },
    {
      NAICS22: "722330",
      "INDEX ITEM DESCRIPTION": "Ice cream truck vendors",
    },
    {
      NAICS22: "722330",
      "INDEX ITEM DESCRIPTION": "Lunch wagons",
    },
    {
      NAICS22: "722330",
      "INDEX ITEM DESCRIPTION": "Mobile food stands",
    },
    {
      NAICS22: "722330",
      "INDEX ITEM DESCRIPTION": "Refreshment stands, mobile",
    },
    {
      NAICS22: "722330",
      "INDEX ITEM DESCRIPTION": "Snack stands, mobile",
    },
    {
      NAICS22: "722330",
      "INDEX ITEM DESCRIPTION": "Street vendors, food",
    },
    {
      NAICS22: "722410",
      "INDEX ITEM DESCRIPTION": "Alcoholic beverage drinking places",
    },
    {
      NAICS22: "722410",
      "INDEX ITEM DESCRIPTION":
        "Bars (i.e., drinking places), alcoholic beverage",
    },
    {
      NAICS22: "722410",
      "INDEX ITEM DESCRIPTION":
        "Brew pubs, primarily serving alcoholic beverages for immediate consumption",
    },
    {
      NAICS22: "722410",
      "INDEX ITEM DESCRIPTION": "Cocktail lounges",
    },
    {
      NAICS22: "722410",
      "INDEX ITEM DESCRIPTION": "Discotheques, alcoholic beverage",
    },
    {
      NAICS22: "722410",
      "INDEX ITEM DESCRIPTION":
        "Drinking places (i.e., bars, lounges, taverns), alcoholic",
    },
    {
      NAICS22: "722410",
      "INDEX ITEM DESCRIPTION": "Lounges, cocktail",
    },
    {
      NAICS22: "722410",
      "INDEX ITEM DESCRIPTION": "Nightclubs, alcoholic beverage",
    },
    {
      NAICS22: "722410",
      "INDEX ITEM DESCRIPTION": "Tap rooms (i.e., drinking places)",
    },
    {
      NAICS22: "722410",
      "INDEX ITEM DESCRIPTION": "Taverns (i.e., drinking places)",
    },
    {
      NAICS22: "722511",
      "INDEX ITEM DESCRIPTION": "Bagel shops, full service",
    },
    {
      NAICS22: "722511",
      "INDEX ITEM DESCRIPTION":
        "Brew pub restaurants, primarily serving meals, full service",
    },
    {
      NAICS22: "722511",
      "INDEX ITEM DESCRIPTION": "Diners, full service",
    },
    {
      NAICS22: "722511",
      "INDEX ITEM DESCRIPTION": "Doughnut shops, full service",
    },
    {
      NAICS22: "722511",
      "INDEX ITEM DESCRIPTION": "Family restaurants, full service",
    },
    {
      NAICS22: "722511",
      "INDEX ITEM DESCRIPTION": "Fine dining restaurants, full service",
    },
    {
      NAICS22: "722511",
      "INDEX ITEM DESCRIPTION": "Full service restaurants",
    },
    {
      NAICS22: "722511",
      "INDEX ITEM DESCRIPTION": "Pizza parlors, full service",
    },
    {
      NAICS22: "722511",
      "INDEX ITEM DESCRIPTION": "Pizzerias, full service",
    },
    {
      NAICS22: "722511",
      "INDEX ITEM DESCRIPTION": "Restaurants, full service",
    },
    {
      NAICS22: "722511",
      "INDEX ITEM DESCRIPTION": "Steak houses, full service",
    },
    {
      NAICS22: "722513",
      "INDEX ITEM DESCRIPTION": "Cafes, limited-service",
    },
    {
      NAICS22: "722513",
      "INDEX ITEM DESCRIPTION": "Carryout restaurants",
    },
    {
      NAICS22: "722513",
      "INDEX ITEM DESCRIPTION": "Delicatessen restaurants",
    },
    {
      NAICS22: "722513",
      "INDEX ITEM DESCRIPTION": "Diners, limited-service",
    },
    {
      NAICS22: "722513",
      "INDEX ITEM DESCRIPTION": "Drive-in restaurants",
    },
    {
      NAICS22: "722513",
      "INDEX ITEM DESCRIPTION": "Family restaurants, limited-service",
    },
    {
      NAICS22: "722513",
      "INDEX ITEM DESCRIPTION": "Fast casual restaurants",
    },
    {
      NAICS22: "722513",
      "INDEX ITEM DESCRIPTION": "Fast-food restaurants",
    },
    {
      NAICS22: "722513",
      "INDEX ITEM DESCRIPTION": "Pizza delivery shops",
    },
    {
      NAICS22: "722513",
      "INDEX ITEM DESCRIPTION": "Pizza parlors, limited-service",
    },
    {
      NAICS22: "722513",
      "INDEX ITEM DESCRIPTION": "Pizzerias, limited-service (e.g., takeout)",
    },
    {
      NAICS22: "722513",
      "INDEX ITEM DESCRIPTION": "Restaurants, carryout",
    },
    {
      NAICS22: "722513",
      "INDEX ITEM DESCRIPTION": "Restaurants, fast-food",
    },
    {
      NAICS22: "722513",
      "INDEX ITEM DESCRIPTION": "Sandwich shops, limited-service",
    },
    {
      NAICS22: "722513",
      "INDEX ITEM DESCRIPTION": "Steak houses, limited-service",
    },
    {
      NAICS22: "722513",
      "INDEX ITEM DESCRIPTION": "Sub shops, limited-service",
    },
    {
      NAICS22: "722513",
      "INDEX ITEM DESCRIPTION": "Takeout eating places",
    },
    {
      NAICS22: "722514",
      "INDEX ITEM DESCRIPTION": "Buffet eating places",
    },
    {
      NAICS22: "722514",
      "INDEX ITEM DESCRIPTION": "Cafeterias",
    },
    {
      NAICS22: "722515",
      "INDEX ITEM DESCRIPTION":
        "Bagel shops, on premise baking and carryout service",
    },
    {
      NAICS22: "722515",
      "INDEX ITEM DESCRIPTION":
        "Bakery cafes, on premise baking and selling for immediate consumption",
    },
    {
      NAICS22: "722515",
      "INDEX ITEM DESCRIPTION":
        "Beverage (e.g., coffee, juice, soft drink) bars, nonalcoholic, fixed location",
    },
    {
      NAICS22: "722515",
      "INDEX ITEM DESCRIPTION": "Canteens, fixed location",
    },
    {
      NAICS22: "722515",
      "INDEX ITEM DESCRIPTION": "Coffee shops, on premise brewing",
    },
    {
      NAICS22: "722515",
      "INDEX ITEM DESCRIPTION":
        "Confectionery snack shops, made on premises with carryout services",
    },
    {
      NAICS22: "722515",
      "INDEX ITEM DESCRIPTION":
        "Cookie shops, on premise baking and carryout service",
    },
    {
      NAICS22: "722515",
      "INDEX ITEM DESCRIPTION":
        "Doughnut shops, on premise baking and carryout service",
    },
    {
      NAICS22: "722515",
      "INDEX ITEM DESCRIPTION": "Fixed location refreshment stands",
    },
    {
      NAICS22: "722515",
      "INDEX ITEM DESCRIPTION": "Frozen custard stands, fixed location",
    },
    {
      NAICS22: "722515",
      "INDEX ITEM DESCRIPTION": "Frozen yogurt shops",
    },
    {
      NAICS22: "722515",
      "INDEX ITEM DESCRIPTION": "Ice cream parlors",
    },
    {
      NAICS22: "722515",
      "INDEX ITEM DESCRIPTION": "Juice bars, nonalcoholic, fixed location",
    },
    {
      NAICS22: "722515",
      "INDEX ITEM DESCRIPTION":
        "Pretzel shops, on premise baking and carryout service",
    },
    {
      NAICS22: "722515",
      "INDEX ITEM DESCRIPTION": "Refreshment stands, fixed location",
    },
    {
      NAICS22: "722515",
      "INDEX ITEM DESCRIPTION": "Smoothie shops",
    },
    {
      NAICS22: "722515",
      "INDEX ITEM DESCRIPTION":
        "Snack bars (e.g., cookies, popcorn, pretzels), fixed location",
    },
    {
      NAICS22: "722515",
      "INDEX ITEM DESCRIPTION":
        "Soft drink beverage bars, nonalcoholic, fixed location",
    },
    {
      NAICS22: "811111",
      "INDEX ITEM DESCRIPTION": "Automotive engine repair and replacement shops",
    },
    {
      NAICS22: "811111",
      "INDEX ITEM DESCRIPTION":
        "Automotive fleet repair and maintenance services",
    },
    {
      NAICS22: "811111",
      "INDEX ITEM DESCRIPTION":
        "Automotive repair and replacement shops, general",
    },
    {
      NAICS22: "811111",
      "INDEX ITEM DESCRIPTION": "Car repair shops, general",
    },
    {
      NAICS22: "811111",
      "INDEX ITEM DESCRIPTION": "Diesel engine repair shops, automotive",
    },
    {
      NAICS22: "811111",
      "INDEX ITEM DESCRIPTION": "Engine repair and replacement shops, automotive",
    },
    {
      NAICS22: "811111",
      "INDEX ITEM DESCRIPTION":
        "Garages, general automotive repair (except gasoline service stations)",
    },
    {
      NAICS22: "811111",
      "INDEX ITEM DESCRIPTION": "General automotive repair shops",
    },
    {
      NAICS22: "811111",
      "INDEX ITEM DESCRIPTION": "Mobile automotive and truck repair services",
    },
    {
      NAICS22: "811111",
      "INDEX ITEM DESCRIPTION":
        "Recreational vehicle (RV) repair and maintenance services, general",
    },
    {
      NAICS22: "811111",
      "INDEX ITEM DESCRIPTION": "Truck repair shops, general",
    },
    {
      NAICS22: "811114",
      "INDEX ITEM DESCRIPTION": "Automotive brake repair shops",
    },
    {
      NAICS22: "811114",
      "INDEX ITEM DESCRIPTION": "Automotive electrical repair shops",
    },
    {
      NAICS22: "811114",
      "INDEX ITEM DESCRIPTION":
        "Automotive exhaust system repair and replacement shops",
    },
    {
      NAICS22: "811114",
      "INDEX ITEM DESCRIPTION": "Automotive front end alignment shops",
    },
    {
      NAICS22: "811114",
      "INDEX ITEM DESCRIPTION": "Automotive radiator repair shops",
    },
    {
      NAICS22: "811114",
      "INDEX ITEM DESCRIPTION": "Automotive suspension repair shops",
    },
    {
      NAICS22: "811114",
      "INDEX ITEM DESCRIPTION": "Automotive transmission repair shops",
    },
    {
      NAICS22: "811114",
      "INDEX ITEM DESCRIPTION": "Automotive tune-up shops",
    },
    {
      NAICS22: "811114",
      "INDEX ITEM DESCRIPTION": "Brake repair shops, automotive",
    },
    {
      NAICS22: "811114",
      "INDEX ITEM DESCRIPTION": "Drive shaft repair shops, automotive",
    },
    {
      NAICS22: "811114",
      "INDEX ITEM DESCRIPTION": "Electrical repair shops, automotive",
    },
    {
      NAICS22: "811114",
      "INDEX ITEM DESCRIPTION":
        "Exhaust system repair and replacement shops, automotive",
    },
    {
      NAICS22: "811114",
      "INDEX ITEM DESCRIPTION": "Front end alignment shops, automotive",
    },
    {
      NAICS22: "811114",
      "INDEX ITEM DESCRIPTION": "Ignition and battery repair shops, automotive",
    },
    {
      NAICS22: "811114",
      "INDEX ITEM DESCRIPTION": "Muffler repair and replacement shops",
    },
    {
      NAICS22: "811114",
      "INDEX ITEM DESCRIPTION": "Radiator repair shops, automotive",
    },
    {
      NAICS22: "811114",
      "INDEX ITEM DESCRIPTION": "Suspension repair shops, automotive",
    },
    {
      NAICS22: "811114",
      "INDEX ITEM DESCRIPTION": "Transmission repair shops, automotive",
    },
    {
      NAICS22: "811114",
      "INDEX ITEM DESCRIPTION": "Tune-up shops, automotive",
    },
    {
      NAICS22: "811114",
      "INDEX ITEM DESCRIPTION": "Wheel alignment shops, automotive",
    },
    {
      NAICS22: "811121",
      "INDEX ITEM DESCRIPTION": "Antique and classic automotive restoration",
    },
    {
      NAICS22: "811121",
      "INDEX ITEM DESCRIPTION": "Automotive body shops",
    },
    {
      NAICS22: "811121",
      "INDEX ITEM DESCRIPTION": "Automotive paint shops",
    },
    {
      NAICS22: "811121",
      "INDEX ITEM DESCRIPTION": "Automotive upholstery shops",
    },
    {
      NAICS22: "811121",
      "INDEX ITEM DESCRIPTION": "Body conversion services, automotive",
    },
    {
      NAICS22: "811121",
      "INDEX ITEM DESCRIPTION": "Body shops, automotive",
    },
    {
      NAICS22: "811121",
      "INDEX ITEM DESCRIPTION": "Interior repair shops, automotive",
    },
    {
      NAICS22: "811121",
      "INDEX ITEM DESCRIPTION": "Paint shops, automotive",
    },
    {
      NAICS22: "811121",
      "INDEX ITEM DESCRIPTION":
        "Restoration shops, antique and classic automotive",
    },
    {
      NAICS22: "811121",
      "INDEX ITEM DESCRIPTION": "Truck trailer body shops",
    },
    {
      NAICS22: "811121",
      "INDEX ITEM DESCRIPTION": "Truck trailer paint and body repair",
    },
    {
      NAICS22: "811121",
      "INDEX ITEM DESCRIPTION": "Upholstery shops, automotive",
    },
    {
      NAICS22: "811121",
      "INDEX ITEM DESCRIPTION":
        "Van conversion shops (except on assembly line or factory basis)",
    },
    {
      NAICS22: "811122",
      "INDEX ITEM DESCRIPTION": "Automotive glass shops",
    },
    {
      NAICS22: "811122",
      "INDEX ITEM DESCRIPTION": "Glass installation, automotive repair",
    },
    {
      NAICS22: "811122",
      "INDEX ITEM DESCRIPTION": "Glass shops, automotive",
    },
    {
      NAICS22: "811122",
      "INDEX ITEM DESCRIPTION": "Glass tinting, automotive",
    },
    {
      NAICS22: "811122",
      "INDEX ITEM DESCRIPTION": "Glass work, automotive",
    },
    {
      NAICS22: "811122",
      "INDEX ITEM DESCRIPTION": "Window tinting, automotive",
    },
    {
      NAICS22: "811122",
      "INDEX ITEM DESCRIPTION": "Windshield repair shops, automotive",
    },
    {
      NAICS22: "811191",
      "INDEX ITEM DESCRIPTION": "Automotive oil change and lubrication shops",
    },
    {
      NAICS22: "811191",
      "INDEX ITEM DESCRIPTION": "Lubrication shops, automotive",
    },
    {
      NAICS22: "811191",
      "INDEX ITEM DESCRIPTION": "Oil change and lubrication shops, automotive",
    },
    {
      NAICS22: "811191",
      "INDEX ITEM DESCRIPTION": "Quick-lube shops",
    },
    {
      NAICS22: "811192",
      "INDEX ITEM DESCRIPTION": "Automotive detail shops",
    },
    {
      NAICS22: "811192",
      "INDEX ITEM DESCRIPTION":
        "Automotive detailing services (i.e., cleaning, polishing)",
    },
    {
      NAICS22: "811192",
      "INDEX ITEM DESCRIPTION": "Automotive washing and polishing",
    },
    {
      NAICS22: "811192",
      "INDEX ITEM DESCRIPTION": "Car detailers",
    },
    {
      NAICS22: "811192",
      "INDEX ITEM DESCRIPTION": "Car washes",
    },
    {
      NAICS22: "811192",
      "INDEX ITEM DESCRIPTION":
        "Detailing services (i.e., cleaning and polishing), automotive",
    },
    {
      NAICS22: "811192",
      "INDEX ITEM DESCRIPTION": "Mobile car and truck washes",
    },
    {
      NAICS22: "811192",
      "INDEX ITEM DESCRIPTION": "Self-service car washes",
    },
    {
      NAICS22: "811192",
      "INDEX ITEM DESCRIPTION": "Truck and bus washes",
    },
    {
      NAICS22: "811198",
      "INDEX ITEM DESCRIPTION": "Automotive air-conditioning repair shops",
    },
    {
      NAICS22: "811198",
      "INDEX ITEM DESCRIPTION": "Automotive emissions testing services",
    },
    {
      NAICS22: "811198",
      "INDEX ITEM DESCRIPTION": "Automotive rustproofing and undercoating shops",
    },
    {
      NAICS22: "811198",
      "INDEX ITEM DESCRIPTION": "Automotive safety inspection services",
    },
    {
      NAICS22: "811198",
      "INDEX ITEM DESCRIPTION":
        "Automotive tire repair (except retreading) shops",
    },
    {
      NAICS22: "811198",
      "INDEX ITEM DESCRIPTION": "Diagnostic centers without repair, automotive",
    },
    {
      NAICS22: "811198",
      "INDEX ITEM DESCRIPTION": "Emissions testing without repair, automotive",
    },
    {
      NAICS22: "811198",
      "INDEX ITEM DESCRIPTION": "Garages, do-it-yourself automotive repair",
    },
    {
      NAICS22: "811198",
      "INDEX ITEM DESCRIPTION": "Rustproofing shops, automotive",
    },
    {
      NAICS22: "811198",
      "INDEX ITEM DESCRIPTION": "Spray-on bedliner installation for trucks",
    },
    {
      NAICS22: "811198",
      "INDEX ITEM DESCRIPTION":
        "Tire repair shops (except retreading), automotive",
    },
    {
      NAICS22: "811198",
      "INDEX ITEM DESCRIPTION": "Undercoating shops, automotive",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION":
        "Broadcast equipment repair and maintenance services",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION":
        "Camera repair shops without retailing new cameras",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION":
        "Cellular telephone repair and maintenance services without retailing new cellular telephones",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION":
        "Communication equipment repair and maintenance services",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION":
        "Computer peripheral equipment repair and maintenance, without retailing new computer peripheral equipment",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION":
        "Computer repair and maintenance services, without retailing new computers",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION":
        "Consumer electronics repair and maintenance services without retailing new consumer electronics",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION":
        "Dental equipment repair and maintenance services",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION":
        "Diagnostic imaging equipment repair and maintenance services",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION":
        "Electrical measuring instrument repair and maintenance services",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION":
        "Facsimile machine repair and maintenance services",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION": "Fax machine repair and maintenance services",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION":
        "Laboratory instrument repair and maintenance services",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION":
        "Laptop repair and maintenance services, without retailing new laptops",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION":
        "Measuring instrument repair and maintenance services",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION":
        "Medical and surgical equipment repair and maintenance services",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION":
        "Meteorological instrument repair and maintenance services",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION":
        "Navigational instruments (e.g., radar, sonar) repair and maintenance services",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION": "Office machine repair and maintenance services",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION":
        "Optical instrument repair and maintenance services (e.g., microscopes, telescopes)",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION":
        "Photocopying machine repair and maintenance services without retailing new photocopying machines",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION":
        "Photographic equipment repair shops without retailing new photographic equipment",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION": "Precision equipment calibration",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION":
        "Public address system repair and maintenance services",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION":
        "Radar and sonar equipment repair and maintenance services",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION":
        "Radio repair and maintenance services without retailing new radios ",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION": "Radio repair, automotive, without retailing new",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION":
        "Stereo equipment repair shops without retailing new stereo equipment",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION":
        "Surgical instrument repair and maintenance services",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION":
        "Surveying instrument repair and maintenance services",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION":
        "Tablet repair and maintenance services, without retailing new tablets",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION":
        "Telephone equipment repair and maintenance services without retailing new telephone equipment",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION":
        "Television repair services without retailing new televisions",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION": "Two-way radio repair and maintenance services",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION": "Typewriter repair and maintenance services",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION":
        "Video cassette recorder (VCR) repair services without retailing new video cassette recorders",
    },
    {
      NAICS22: "811210",
      "INDEX ITEM DESCRIPTION":
        "Weighing equipment (e.g., balance, scales) repair and maintenance services",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION":
        "Agricultural machinery and equipment repair and maintenance services",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION":
        "Armature rewinding services (except on an assembly line or factory basis)",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION":
        "Blade sharpening, commercial and industrial machinery and equipment",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION": "Cargo container repair and maintenance services",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION":
        "Coil rewinding (except on an assembly line or factory basis)",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION":
        "Commercial and industrial machinery repair and maintenance services",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION":
        "Commercial gaming machine repair and maintenance services",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION":
        "Commercial refrigeration equipment repair and maintenance services",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION":
        "Construction machinery and equipment repair and maintenance services",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION":
        "Electric motor repair and maintenance services, commercial or industrial",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION":
        "Electrical generating and transmission equipment repair and maintenance services",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION": "Engine repair (except automotive, small engine)",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION":
        "Farm machinery and equipment repair and maintenance services",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION":
        "Fire extinguisher repair and maintenance, without installation",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION": "Food machinery repair and maintenance services",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION":
        "Forestry machinery and equipment repair and maintenance services",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION": "Forklift repair and maintenance services",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION":
        "Foundry machinery and equipment repair and maintenance services",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION":
        "Freezer, commercial, repair and maintenance services",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION":
        "Heavy machinery and equipment repair and maintenance services",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION":
        "Hydraulic equipment repair and maintenance services",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION":
        "Industrial equipment and machinery repair and maintenance services",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION":
        "Industrial truck (e.g., forklifts) repair and maintenance services",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION": "Machine tools repair and maintenance services",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION":
        "Material handling equipment repair and maintenance services",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION":
        "Mechanical power transmission equipment repair and maintenance services",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION":
        "Mining machinery and equipment repair and maintenance services",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION":
        "Motor repair and maintenance services, commercial or industrial",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION":
        "Oil and gas field machinery and equipment repair and maintenance services",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION":
        "Paper making machinery repair and maintenance services",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION":
        "Printing trade machinery repair and maintenance services",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION": "Reconditioning shipping barrels and drums",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION":
        "Refrigeration equipment repair and maintenance services, industrial and commercial-type",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION": "Restaurant fryer equipment cleaning services",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION":
        "Rewinding armatures (except on an assembly line or factory basis)",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION":
        "Service machinery and equipment repair and maintenance services",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION":
        "Textile machinery repair and maintenance services",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION":
        "Tractor, farm or construction equipment repair and maintenance services",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION":
        "Truck refrigeration repair and maintenance services",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION":
        "Waterless fire suppression system repair and maintenance, without installation",
    },
    {
      NAICS22: "811310",
      "INDEX ITEM DESCRIPTION":
        "Welding repair services (e.g., automotive, general)",
    },
    {
      NAICS22: "811411",
      "INDEX ITEM DESCRIPTION": "Engine repair, small",
    },
    {
      NAICS22: "811411",
      "INDEX ITEM DESCRIPTION":
        "Garden equipment repair and maintenance services without retailing new garden equipment",
    },
    {
      NAICS22: "811411",
      "INDEX ITEM DESCRIPTION": "Garden tool sharpening and repair services",
    },
    {
      NAICS22: "811411",
      "INDEX ITEM DESCRIPTION":
        "Handtools, power-driven, repair and maintenance services without retailing new power-driven handtools",
    },
    {
      NAICS22: "811411",
      "INDEX ITEM DESCRIPTION":
        "Lawn and garden equipment repair and maintenance services without retailing new lawn and garden equipment",
    },
    {
      NAICS22: "811411",
      "INDEX ITEM DESCRIPTION":
        "Lawnmower repair and maintenance shops without retailing new lawnmowers ",
    },
    {
      NAICS22: "811411",
      "INDEX ITEM DESCRIPTION":
        "Saw repair and maintenance (except sawmills) without retailing new saws",
    },
    {
      NAICS22: "811411",
      "INDEX ITEM DESCRIPTION": "Small engine repair and maintenance shops",
    },
    {
      NAICS22: "811411",
      "INDEX ITEM DESCRIPTION":
        "Tool, home and garden, sharpening and repair services without retailing new home and garden tools",
    },
    {
      NAICS22: "811411",
      "INDEX ITEM DESCRIPTION":
        "Tractor, lawn and garden, repair and maintenance services without retailing new lawn and garden tractors",
    },
    {
      NAICS22: "811412",
      "INDEX ITEM DESCRIPTION":
        "Air-conditioner, window, repair and maintenance services",
    },
    {
      NAICS22: "811412",
      "INDEX ITEM DESCRIPTION":
        "Appliance, household-type, repair and maintenance services without retailing new appliances",
    },
    {
      NAICS22: "811412",
      "INDEX ITEM DESCRIPTION":
        "Clothes dryer, household-type, repair and maintenance services without retailing new clothes dryers",
    },
    {
      NAICS22: "811412",
      "INDEX ITEM DESCRIPTION":
        "Dishwasher, household-type, repair and maintenance services without retailing new dishwashers",
    },
    {
      NAICS22: "811412",
      "INDEX ITEM DESCRIPTION":
        "Microwave oven, household-type, repair and maintenance services, without retailing new microwave ovens",
    },
    {
      NAICS22: "811412",
      "INDEX ITEM DESCRIPTION":
        "Oven, household-type, repair and maintenance services without retailing new ovens",
    },
    {
      NAICS22: "811412",
      "INDEX ITEM DESCRIPTION":
        "Refrigerator, household-type, repair and maintenance services without retailing new refrigerators",
    },
    {
      NAICS22: "811412",
      "INDEX ITEM DESCRIPTION":
        "Sewing machine, household-type, repair shops without retailing new sewing machines",
    },
    {
      NAICS22: "811412",
      "INDEX ITEM DESCRIPTION":
        "Stove, household-type, repair and maintenance services without retailing new stoves",
    },
    {
      NAICS22: "811412",
      "INDEX ITEM DESCRIPTION":
        "Washing machine, household-type, repair and maintenance services without retailing new washing machine",
    },
    {
      NAICS22: "811412",
      "INDEX ITEM DESCRIPTION":
        "Water heater repair and maintenance services without retailing new water heaters",
    },
    {
      NAICS22: "811420",
      "INDEX ITEM DESCRIPTION": "Aircraft upholstery repair",
    },
    {
      NAICS22: "811420",
      "INDEX ITEM DESCRIPTION": "Antique furniture repair and restoration shops",
    },
    {
      NAICS22: "811420",
      "INDEX ITEM DESCRIPTION": "Furniture refinishing shops",
    },
    {
      NAICS22: "811420",
      "INDEX ITEM DESCRIPTION": "Furniture repair shops",
    },
    {
      NAICS22: "811420",
      "INDEX ITEM DESCRIPTION": "Furniture reupholstering shops",
    },
    {
      NAICS22: "811420",
      "INDEX ITEM DESCRIPTION": "Restoration and repair of antique furniture",
    },
    {
      NAICS22: "811420",
      "INDEX ITEM DESCRIPTION": "Reupholstery shops, furniture",
    },
    {
      NAICS22: "811420",
      "INDEX ITEM DESCRIPTION":
        "Upholstery (except motor vehicle) repair services",
    },
    {
      NAICS22: "811430",
      "INDEX ITEM DESCRIPTION": "Boot repair shops without retailing new boots",
    },
    {
      NAICS22: "811430",
      "INDEX ITEM DESCRIPTION":
        "Leather goods repair shops without retailing new leather goods",
    },
    {
      NAICS22: "811430",
      "INDEX ITEM DESCRIPTION":
        "Luggage repair shops without retailing new luggage",
    },
    {
      NAICS22: "811430",
      "INDEX ITEM DESCRIPTION":
        "Saddlery repair shops without retailing new saddlery",
    },
    {
      NAICS22: "811430",
      "INDEX ITEM DESCRIPTION": "Shoe repair shops without retailing new shoes",
    },
    {
      NAICS22: "811490",
      "INDEX ITEM DESCRIPTION":
        "Bicycle repair and maintenance shops without retailing new bicycles",
    },
    {
      NAICS22: "811490",
      "INDEX ITEM DESCRIPTION":
        "Boat, pleasure, repair and maintenance services without retailing new boats",
    },
    {
      NAICS22: "811490",
      "INDEX ITEM DESCRIPTION": "China repair services",
    },
    {
      NAICS22: "811490",
      "INDEX ITEM DESCRIPTION": "Clock repair shops without retailing new clocks",
    },
    {
      NAICS22: "811490",
      "INDEX ITEM DESCRIPTION": "Clothing repair shops, alterations only",
    },
    {
      NAICS22: "811490",
      "INDEX ITEM DESCRIPTION":
        "Cutlery (e.g., knives, scissors) sharpening, household-type",
    },
    {
      NAICS22: "811490",
      "INDEX ITEM DESCRIPTION":
        "Exercise and athletic equipment repair and maintenance services without retailing new exercise and athletic equipment",
    },
    {
      NAICS22: "811490",
      "INDEX ITEM DESCRIPTION":
        "Fur garment repair shops without retailing new fur garments",
    },
    {
      NAICS22: "811490",
      "INDEX ITEM DESCRIPTION":
        "Garment alteration and/or repair shops without retailing new garments",
    },
    {
      NAICS22: "811490",
      "INDEX ITEM DESCRIPTION":
        "Gun repair and maintenance shops without retailing new guns",
    },
    {
      NAICS22: "811490",
      "INDEX ITEM DESCRIPTION": "Gunsmith shops without retailing new guns",
    },
    {
      NAICS22: "811490",
      "INDEX ITEM DESCRIPTION":
        "Jewelry repair shops without retailing new jewelry",
    },
    {
      NAICS22: "811490",
      "INDEX ITEM DESCRIPTION": "Key duplicating shops",
    },
    {
      NAICS22: "811490",
      "INDEX ITEM DESCRIPTION":
        "Motorboat (i.e., inboard and outboard) repair and maintenance services",
    },
    {
      NAICS22: "811490",
      "INDEX ITEM DESCRIPTION":
        "Motorcycle repair shops without retailing new motorcycles",
    },
    {
      NAICS22: "811490",
      "INDEX ITEM DESCRIPTION":
        "Musical instrument repair shops without retailing new musical instruments",
    },
    {
      NAICS22: "811490",
      "INDEX ITEM DESCRIPTION": "Outboard motor repair shops",
    },
    {
      NAICS22: "811490",
      "INDEX ITEM DESCRIPTION":
        "Pleasure boat maintenance services (e.g., cleaning, scaling, waxing)",
    },
    {
      NAICS22: "811490",
      "INDEX ITEM DESCRIPTION":
        "Sporting equipment repair and maintenance without retailing new sports equipment",
    },
    {
      NAICS22: "811490",
      "INDEX ITEM DESCRIPTION": "Tailor shops, alterations only",
    },
    {
      NAICS22: "811490",
      "INDEX ITEM DESCRIPTION": "Tuning and repair of musical instruments",
    },
    {
      NAICS22: "811490",
      "INDEX ITEM DESCRIPTION":
        "Venetian blind repair and maintenance shops without retailing new venetian blinds",
    },
    {
      NAICS22: "811490",
      "INDEX ITEM DESCRIPTION":
        "Watch repair shops without retailing new watches",
    },
    {
      NAICS22: "811490",
      "INDEX ITEM DESCRIPTION": "Window shade repair and maintenance shops",
    },
    {
      NAICS22: "812111",
      "INDEX ITEM DESCRIPTION": "Barber shops",
    },
    {
      NAICS22: "812111",
      "INDEX ITEM DESCRIPTION": "Hair stylist services, men's",
    },
    {
      NAICS22: "812111",
      "INDEX ITEM DESCRIPTION": "Hair stylist shops, men's",
    },
    {
      NAICS22: "812112",
      "INDEX ITEM DESCRIPTION": "Beautician services",
    },
    {
      NAICS22: "812112",
      "INDEX ITEM DESCRIPTION": "Beauty and barber shops, combined",
    },
    {
      NAICS22: "812112",
      "INDEX ITEM DESCRIPTION": "Beauty parlors",
    },
    {
      NAICS22: "812112",
      "INDEX ITEM DESCRIPTION": "Beauty salons",
    },
    {
      NAICS22: "812112",
      "INDEX ITEM DESCRIPTION": "Beauty shops",
    },
    {
      NAICS22: "812112",
      "INDEX ITEM DESCRIPTION": "Cosmetology salons or shops",
    },
    {
      NAICS22: "812112",
      "INDEX ITEM DESCRIPTION": "Esthetician (i.e., skin care) services",
    },
    {
      NAICS22: "812112",
      "INDEX ITEM DESCRIPTION": "Facial salons",
    },
    {
      NAICS22: "812112",
      "INDEX ITEM DESCRIPTION": "Hair stylist salons or shops, unisex or women's",
    },
    {
      NAICS22: "812112",
      "INDEX ITEM DESCRIPTION": "Hair stylist services, unisex or women's",
    },
    {
      NAICS22: "812112",
      "INDEX ITEM DESCRIPTION": "Hairdresser services",
    },
    {
      NAICS22: "812112",
      "INDEX ITEM DESCRIPTION": "Hairdressing salons or shops, unisex or women's",
    },
    {
      NAICS22: "812112",
      "INDEX ITEM DESCRIPTION": "Makeup (except permanent) salons",
    },
    {
      NAICS22: "812112",
      "INDEX ITEM DESCRIPTION": "Unisex hair stylist shops",
    },
    {
      NAICS22: "812113",
      "INDEX ITEM DESCRIPTION": "Manicure and pedicure salons",
    },
    {
      NAICS22: "812113",
      "INDEX ITEM DESCRIPTION": "Manicurist services",
    },
    {
      NAICS22: "812113",
      "INDEX ITEM DESCRIPTION": "Nail salons",
    },
    {
      NAICS22: "812113",
      "INDEX ITEM DESCRIPTION": "Pedicure and manicure salons",
    },
    {
      NAICS22: "812113",
      "INDEX ITEM DESCRIPTION": "Pedicurist services",
    },
    {
      NAICS22: "812191",
      "INDEX ITEM DESCRIPTION": "Diet centers, non-medical",
    },
    {
      NAICS22: "812191",
      "INDEX ITEM DESCRIPTION": "Diet workshops",
    },
    {
      NAICS22: "812191",
      "INDEX ITEM DESCRIPTION": "Weight loss centers, non-medical",
    },
    {
      NAICS22: "812191",
      "INDEX ITEM DESCRIPTION": "Weight reducing centers, non-medical",
    },
    {
      NAICS22: "812199",
      "INDEX ITEM DESCRIPTION": "Aqua therapy services, non-medical",
    },
    {
      NAICS22: "812199",
      "INDEX ITEM DESCRIPTION": "Baths, steam or turkish",
    },
    {
      NAICS22: "812199",
      "INDEX ITEM DESCRIPTION":
        "Color consulting services (i.e., personal care services)",
    },
    {
      NAICS22: "812199",
      "INDEX ITEM DESCRIPTION": "Day spas",
    },
    {
      NAICS22: "812199",
      "INDEX ITEM DESCRIPTION": "Depilatory (i.e., hair removal) salons",
    },
    {
      NAICS22: "812199",
      "INDEX ITEM DESCRIPTION": "Ear piercing services",
    },
    {
      NAICS22: "812199",
      "INDEX ITEM DESCRIPTION": "Electrolysis (i.e., hair removal) salons",
    },
    {
      NAICS22: "812199",
      "INDEX ITEM DESCRIPTION": "Eyebrow threading services",
    },
    {
      NAICS22: "812199",
      "INDEX ITEM DESCRIPTION":
        "Hair removal (i.e., depilatory, electrolysis, laser, waxing) services",
    },
    {
      NAICS22: "812199",
      "INDEX ITEM DESCRIPTION":
        "Hair replacement services (except by offices of physicians)",
    },
    {
      NAICS22: "812199",
      "INDEX ITEM DESCRIPTION": "Hair weaving services",
    },
    {
      NAICS22: "812199",
      "INDEX ITEM DESCRIPTION": "Makeup salons, permanent",
    },
    {
      NAICS22: "812199",
      "INDEX ITEM DESCRIPTION": "Massage wellness spas/centers",
    },
    {
      NAICS22: "812199",
      "INDEX ITEM DESCRIPTION": "Microblading tattoo services",
    },
    {
      NAICS22: "812199",
      "INDEX ITEM DESCRIPTION": "Saunas",
    },
    {
      NAICS22: "812199",
      "INDEX ITEM DESCRIPTION": "Scalp treating services",
    },
    {
      NAICS22: "812199",
      "INDEX ITEM DESCRIPTION": "Steam baths",
    },
    {
      NAICS22: "812199",
      "INDEX ITEM DESCRIPTION": "Sun tanning salons",
    },
    {
      NAICS22: "812199",
      "INDEX ITEM DESCRIPTION": "Tanning salons",
    },
    {
      NAICS22: "812199",
      "INDEX ITEM DESCRIPTION": "Tattoo parlors",
    },
    {
      NAICS22: "812199",
      "INDEX ITEM DESCRIPTION": "Turkish bathhouses",
    },
    {
      NAICS22: "812199",
      "INDEX ITEM DESCRIPTION": "Turkish baths",
    },
    {
      NAICS22: "812210",
      "INDEX ITEM DESCRIPTION": "Director services, funeral",
    },
    {
      NAICS22: "812210",
      "INDEX ITEM DESCRIPTION": "Embalming services",
    },
    {
      NAICS22: "812210",
      "INDEX ITEM DESCRIPTION": "Funeral director services",
    },
    {
      NAICS22: "812210",
      "INDEX ITEM DESCRIPTION": "Funeral homes",
    },
    {
      NAICS22: "812210",
      "INDEX ITEM DESCRIPTION": "Funeral homes combined with crematories",
    },
    {
      NAICS22: "812210",
      "INDEX ITEM DESCRIPTION": "Funeral parlors",
    },
    {
      NAICS22: "812210",
      "INDEX ITEM DESCRIPTION": "Human remains transportation services",
    },
    {
      NAICS22: "812210",
      "INDEX ITEM DESCRIPTION": "Mortician services",
    },
    {
      NAICS22: "812210",
      "INDEX ITEM DESCRIPTION": "Mortuaries",
    },
    {
      NAICS22: "812210",
      "INDEX ITEM DESCRIPTION": "Undertaker services",
    },
    {
      NAICS22: "812220",
      "INDEX ITEM DESCRIPTION": "Animal cemeteries",
    },
    {
      NAICS22: "812220",
      "INDEX ITEM DESCRIPTION": "Cemeteries",
    },
    {
      NAICS22: "812220",
      "INDEX ITEM DESCRIPTION": "Cemetery associations (i.e., operators)",
    },
    {
      NAICS22: "812220",
      "INDEX ITEM DESCRIPTION": "Cemetery management services",
    },
    {
      NAICS22: "812220",
      "INDEX ITEM DESCRIPTION": "Cemetery subdividers",
    },
    {
      NAICS22: "812220",
      "INDEX ITEM DESCRIPTION": "Columbariums",
    },
    {
      NAICS22: "812220",
      "INDEX ITEM DESCRIPTION":
        "Crematories (except combined with funeral homes)",
    },
    {
      NAICS22: "812220",
      "INDEX ITEM DESCRIPTION": "Mausoleums",
    },
    {
      NAICS22: "812220",
      "INDEX ITEM DESCRIPTION": "Memorial gardens (i.e., burial places)",
    },
    {
      NAICS22: "812220",
      "INDEX ITEM DESCRIPTION": "Pet cemeteries",
    },
    {
      NAICS22: "812220",
      "INDEX ITEM DESCRIPTION": "Pet crematories",
    },
    {
      NAICS22: "812310",
      "INDEX ITEM DESCRIPTION": "Automatic laundries, coin-operated",
    },
    {
      NAICS22: "812310",
      "INDEX ITEM DESCRIPTION": "Coin-operated drycleaners and laundries",
    },
    {
      NAICS22: "812310",
      "INDEX ITEM DESCRIPTION":
        "Coin-operated laundry and drycleaning routes (i.e., concession operators)",
    },
    {
      NAICS22: "812310",
      "INDEX ITEM DESCRIPTION":
        "Drycleaning machine routes (i.e., concession operators), coin-operated or similar self-service",
    },
    {
      NAICS22: "812310",
      "INDEX ITEM DESCRIPTION":
        "Drycleaning services, coin-operated or similar self-service",
    },
    {
      NAICS22: "812310",
      "INDEX ITEM DESCRIPTION": "Launderettes",
    },
    {
      NAICS22: "812310",
      "INDEX ITEM DESCRIPTION":
        "Laundries, coin-operated or similar self-service",
    },
    {
      NAICS22: "812310",
      "INDEX ITEM DESCRIPTION": "Laundromats",
    },
    {
      NAICS22: "812310",
      "INDEX ITEM DESCRIPTION":
        "Laundry machine routes (i.e., concession operators), coin-operated or similar self-service",
    },
    {
      NAICS22: "812310",
      "INDEX ITEM DESCRIPTION":
        "Laundry services, coin-operated or similar self-service",
    },
    {
      NAICS22: "812310",
      "INDEX ITEM DESCRIPTION": "Self-service drycleaners and laundries",
    },
    {
      NAICS22: "812320",
      "INDEX ITEM DESCRIPTION": "Agents, laundry and drycleaning",
    },
    {
      NAICS22: "812320",
      "INDEX ITEM DESCRIPTION": "Apparel pressing services",
    },
    {
      NAICS22: "812320",
      "INDEX ITEM DESCRIPTION": "Bobtailers, laundry and drycleaning",
    },
    {
      NAICS22: "812320",
      "INDEX ITEM DESCRIPTION":
        "Cleaners, drycleaning and laundry service (except coin-operated)",
    },
    {
      NAICS22: "812320",
      "INDEX ITEM DESCRIPTION":
        "Cleaning and dyeing plants (except rug cleaning plants)",
    },
    {
      NAICS22: "812320",
      "INDEX ITEM DESCRIPTION":
        "Collecting and distributing agents, laundry and drycleaning",
    },
    {
      NAICS22: "812320",
      "INDEX ITEM DESCRIPTION": "Curtain cleaning services",
    },
    {
      NAICS22: "812320",
      "INDEX ITEM DESCRIPTION": "Drapery cleaning services",
    },
    {
      NAICS22: "812320",
      "INDEX ITEM DESCRIPTION":
        "Drop-off and pick-up sites for laundries and drycleaners",
    },
    {
      NAICS22: "812320",
      "INDEX ITEM DESCRIPTION": "Drycleaner drop-off and pick-up sites",
    },
    {
      NAICS22: "812320",
      "INDEX ITEM DESCRIPTION": "Drycleaners (except coin-operated)",
    },
    {
      NAICS22: "812320",
      "INDEX ITEM DESCRIPTION": "Drycleaning plants (except rug cleaning plants)",
    },
    {
      NAICS22: "812320",
      "INDEX ITEM DESCRIPTION": "Drycleaning services (except coin-operated)",
    },
    {
      NAICS22: "812320",
      "INDEX ITEM DESCRIPTION": "Fur garment cleaning services",
    },
    {
      NAICS22: "812320",
      "INDEX ITEM DESCRIPTION":
        "Garment cleaning (e.g., fur, leather, suede) services",
    },
    {
      NAICS22: "812320",
      "INDEX ITEM DESCRIPTION": "Hand laundries",
    },
    {
      NAICS22: "812320",
      "INDEX ITEM DESCRIPTION": "Hat cleaning services",
    },
    {
      NAICS22: "812320",
      "INDEX ITEM DESCRIPTION":
        "Laundries (except coin-operated, linen supply, uniform supply)",
    },
    {
      NAICS22: "812320",
      "INDEX ITEM DESCRIPTION": "Laundry and drycleaning agents",
    },
    {
      NAICS22: "812320",
      "INDEX ITEM DESCRIPTION": "Laundry drop-off and pick-up sites",
    },
    {
      NAICS22: "812320",
      "INDEX ITEM DESCRIPTION":
        "Laundry services (except coin-operated, linen supply, uniform supply)",
    },
    {
      NAICS22: "812320",
      "INDEX ITEM DESCRIPTION": "Leather garment cleaning services",
    },
    {
      NAICS22: "812320",
      "INDEX ITEM DESCRIPTION":
        "Pick-up and drop-off sites for drycleaners and laundries",
    },
    {
      NAICS22: "812320",
      "INDEX ITEM DESCRIPTION": "Pillow cleaning services",
    },
    {
      NAICS22: "812320",
      "INDEX ITEM DESCRIPTION": "Power laundries, family",
    },
    {
      NAICS22: "812320",
      "INDEX ITEM DESCRIPTION": "Suede garment cleaning services",
    },
    {
      NAICS22: "812331",
      "INDEX ITEM DESCRIPTION": "Apron supply services",
    },
    {
      NAICS22: "812331",
      "INDEX ITEM DESCRIPTION": "Bed linen supply services",
    },
    {
      NAICS22: "812331",
      "INDEX ITEM DESCRIPTION":
        "Coat (e.g., barber's, beautician's, doctor's, nurse's) supply services",
    },
    {
      NAICS22: "812331",
      "INDEX ITEM DESCRIPTION":
        "Cooperative hospital laundries (i.e., linen supply services)",
    },
    {
      NAICS22: "812331",
      "INDEX ITEM DESCRIPTION": "Diaper supply services",
    },
    {
      NAICS22: "812331",
      "INDEX ITEM DESCRIPTION":
        "Gown (e.g., doctors, nurses, hospital, beauticians) supply services",
    },
    {
      NAICS22: "812331",
      "INDEX ITEM DESCRIPTION": "Laundries, linen and uniform supply",
    },
    {
      NAICS22: "812331",
      "INDEX ITEM DESCRIPTION": "Laundry services, linen supply",
    },
    {
      NAICS22: "812331",
      "INDEX ITEM DESCRIPTION": "Linen supply services",
    },
    {
      NAICS22: "812331",
      "INDEX ITEM DESCRIPTION": "Table linen supply services",
    },
    {
      NAICS22: "812331",
      "INDEX ITEM DESCRIPTION": "Towel (except shop, wiping) supply services",
    },
    {
      NAICS22: "812331",
      "INDEX ITEM DESCRIPTION": "Uniform (except industrial) supply services",
    },
    {
      NAICS22: "812332",
      "INDEX ITEM DESCRIPTION": "Clean room apparel supply services",
    },
    {
      NAICS22: "812332",
      "INDEX ITEM DESCRIPTION":
        "Dust control textile item (e.g., cloths, mats, mops, rugs, shop towels) supply services",
    },
    {
      NAICS22: "812332",
      "INDEX ITEM DESCRIPTION": "Flame resistant clothing supply services",
    },
    {
      NAICS22: "812332",
      "INDEX ITEM DESCRIPTION": "Industrial launderers",
    },
    {
      NAICS22: "812332",
      "INDEX ITEM DESCRIPTION": "Industrial uniform supply services",
    },
    {
      NAICS22: "812332",
      "INDEX ITEM DESCRIPTION": "Laundered mat and rug supply services",
    },
    {
      NAICS22: "812332",
      "INDEX ITEM DESCRIPTION": "Launderers, industrial",
    },
    {
      NAICS22: "812332",
      "INDEX ITEM DESCRIPTION": "Laundry services, industrial",
    },
    {
      NAICS22: "812332",
      "INDEX ITEM DESCRIPTION": "Mat and rug supply services",
    },
    {
      NAICS22: "812332",
      "INDEX ITEM DESCRIPTION": "Protective apparel supply services",
    },
    {
      NAICS22: "812332",
      "INDEX ITEM DESCRIPTION": "Radiation protection garment supply services",
    },
    {
      NAICS22: "812332",
      "INDEX ITEM DESCRIPTION": "Towel supply services, shop or wiping",
    },
    {
      NAICS22: "812332",
      "INDEX ITEM DESCRIPTION": "Uniform supply services, industrial",
    },
    {
      NAICS22: "812332",
      "INDEX ITEM DESCRIPTION":
        "Work clothing and uniform supply services, industrial",
    },
    {
      NAICS22: "812910",
      "INDEX ITEM DESCRIPTION": "Animal grooming services",
    },
    {
      NAICS22: "812910",
      "INDEX ITEM DESCRIPTION": "Animal shelters",
    },
    {
      NAICS22: "812910",
      "INDEX ITEM DESCRIPTION": "Boarding services, pet",
    },
    {
      NAICS22: "812910",
      "INDEX ITEM DESCRIPTION": "Dog pounds",
    },
    {
      NAICS22: "812910",
      "INDEX ITEM DESCRIPTION": "Grooming services, animal",
    },
    {
      NAICS22: "812910",
      "INDEX ITEM DESCRIPTION": "Guard dog training services",
    },
    {
      NAICS22: "812910",
      "INDEX ITEM DESCRIPTION": "Guide dog training services",
    },
    {
      NAICS22: "812910",
      "INDEX ITEM DESCRIPTION": "Kennels, pet boarding",
    },
    {
      NAICS22: "812910",
      "INDEX ITEM DESCRIPTION": "Obedience training services, pet",
    },
    {
      NAICS22: "812910",
      "INDEX ITEM DESCRIPTION": "Pedigree record services, pet",
    },
    {
      NAICS22: "812910",
      "INDEX ITEM DESCRIPTION": "Pet boarding services",
    },
    {
      NAICS22: "812910",
      "INDEX ITEM DESCRIPTION": "Pet grooming services",
    },
    {
      NAICS22: "812910",
      "INDEX ITEM DESCRIPTION": "Pet sitting services",
    },
    {
      NAICS22: "812910",
      "INDEX ITEM DESCRIPTION": "Pet training services",
    },
    {
      NAICS22: "812910",
      "INDEX ITEM DESCRIPTION": "Pet walking services",
    },
    {
      NAICS22: "812910",
      "INDEX ITEM DESCRIPTION": "Sitting services, pet",
    },
    {
      NAICS22: "812910",
      "INDEX ITEM DESCRIPTION":
        "Working, sporting, and service dog training services",
    },
    {
      NAICS22: "812921",
      "INDEX ITEM DESCRIPTION":
        "Film developing and printing (except motion picture, one-hour)",
    },
    {
      NAICS22: "812921",
      "INDEX ITEM DESCRIPTION": "Photofinishing labs (except one-hour)",
    },
    {
      NAICS22: "812921",
      "INDEX ITEM DESCRIPTION": "Photofinishing services (except one-hour)",
    },
    {
      NAICS22: "812922",
      "INDEX ITEM DESCRIPTION": "Film developing and printing, one-hour",
    },
    {
      NAICS22: "812922",
      "INDEX ITEM DESCRIPTION": "One-hour photofinishing services",
    },
    {
      NAICS22: "812922",
      "INDEX ITEM DESCRIPTION": "Photofinishing labs, one-hour",
    },
    {
      NAICS22: "812922",
      "INDEX ITEM DESCRIPTION": "Photofinishing services, one-hour",
    },
    {
      NAICS22: "812930",
      "INDEX ITEM DESCRIPTION": "Automobile parking garages or lots",
    },
    {
      NAICS22: "812930",
      "INDEX ITEM DESCRIPTION": "Garages, automobile parking",
    },
    {
      NAICS22: "812930",
      "INDEX ITEM DESCRIPTION": "Parking garages, automobile",
    },
    {
      NAICS22: "812930",
      "INDEX ITEM DESCRIPTION": "Parking lots, automobile",
    },
    {
      NAICS22: "812930",
      "INDEX ITEM DESCRIPTION": "Parking services, valet",
    },
    {
      NAICS22: "812930",
      "INDEX ITEM DESCRIPTION": "Valet parking services",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Astrology services",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Baby shoe bronzing services",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Bail bonding services",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Balloon-o-gram services",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION":
        "Blood pressure testing machine concession operators, coin- or card-operated",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Bondsperson services",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Check room services",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION":
        "Coin- or card-operated personal service machine (e.g., blood pressure, locker, photographic, scale, shoeshine) concession operators",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Comfort station operation",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Concierge services",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Consumer buying services",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION":
        "Credit card notification services (i.e., lost or stolen card reporting)",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Dating services",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION":
        "Discount buying services, including medical cards and similar negotiated discount plans for individuals",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION":
        "Doula services (providing coaching and support during childbirth)",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Escort services, social",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Fortune-telling services",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Genealogical investigation services",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "House sitting services",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Identity theft protection services",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Introduction services, social",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Lockers, coin- or card-operated, rental",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Numerology services",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION":
        "Online dating services (through a website or mobile application)",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Organizer services, personal",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Palm reading services",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Party planning services",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Pay telephone equipment concession operators",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Personal chef services",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Personal fitness training services",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Personal organizer services",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Personal shopping services",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION":
        "Photographic machine concession operators, coin- or card-operated",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Porter services",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Psychic services",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Rest room operation",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Shoeshine parlors",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Shoeshine services",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Shopping services, personal",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Singing telegram services",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Sitting services, house",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Social escort services",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Telegram services, singing",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Wedding chapels (except churches)",
    },
    {
      NAICS22: "812990",
      "INDEX ITEM DESCRIPTION": "Wedding planning services",
    },
    {
      NAICS22: "813110",
      "INDEX ITEM DESCRIPTION": "Bible societies",
    },
    {
      NAICS22: "813110",
      "INDEX ITEM DESCRIPTION": "Churches",
    },
    {
      NAICS22: "813110",
      "INDEX ITEM DESCRIPTION": "Convents (except schools)",
    },
    {
      NAICS22: "813110",
      "INDEX ITEM DESCRIPTION": "Ministries, religious",
    },
    {
      NAICS22: "813110",
      "INDEX ITEM DESCRIPTION": "Missions, religious organization",
    },
    {
      NAICS22: "813110",
      "INDEX ITEM DESCRIPTION": "Monasteries (except schools)",
    },
    {
      NAICS22: "813110",
      "INDEX ITEM DESCRIPTION": "Mosques, religious",
    },
    {
      NAICS22: "813110",
      "INDEX ITEM DESCRIPTION": "Places of worship",
    },
    {
      NAICS22: "813110",
      "INDEX ITEM DESCRIPTION": "Religious organizations",
    },
    {
      NAICS22: "813110",
      "INDEX ITEM DESCRIPTION": "Retreat houses, religious",
    },
    {
      NAICS22: "813110",
      "INDEX ITEM DESCRIPTION": "Shrines, religious",
    },
    {
      NAICS22: "813110",
      "INDEX ITEM DESCRIPTION": "Synagogues",
    },
    {
      NAICS22: "813110",
      "INDEX ITEM DESCRIPTION": "Temples, religious",
    },
    {
      NAICS22: "813211",
      "INDEX ITEM DESCRIPTION": "Charitable trusts, awarding grants",
    },
    {
      NAICS22: "813211",
      "INDEX ITEM DESCRIPTION": "Community foundations",
    },
    {
      NAICS22: "813211",
      "INDEX ITEM DESCRIPTION": "Corporate foundations, awarding grants",
    },
    {
      NAICS22: "813211",
      "INDEX ITEM DESCRIPTION": "Educational trusts, awarding grants",
    },
    {
      NAICS22: "813211",
      "INDEX ITEM DESCRIPTION": "Grantmaking foundations",
    },
    {
      NAICS22: "813211",
      "INDEX ITEM DESCRIPTION": "Philanthropic trusts, awarding grants",
    },
    {
      NAICS22: "813211",
      "INDEX ITEM DESCRIPTION":
        "Scholarship trusts (i.e., grantmaking, charitable trust foundations)",
    },
    {
      NAICS22: "813211",
      "INDEX ITEM DESCRIPTION": "Trusts, charitable, awarding grants",
    },
    {
      NAICS22: "813211",
      "INDEX ITEM DESCRIPTION": "Trusts, educational, awarding grants",
    },
    {
      NAICS22: "813211",
      "INDEX ITEM DESCRIPTION": "Trusts, religious, awarding grants",
    },
    {
      NAICS22: "813212",
      "INDEX ITEM DESCRIPTION": "Disease awareness fundraising organizations",
    },
    {
      NAICS22: "813212",
      "INDEX ITEM DESCRIPTION":
        "Disease research (e.g., cancer, heart) fundraising organizations",
    },
    {
      NAICS22: "813212",
      "INDEX ITEM DESCRIPTION": "Health research fundraising organizations",
    },
    {
      NAICS22: "813212",
      "INDEX ITEM DESCRIPTION":
        "Health research fundraising using a crowdfunding platform (except on a contract or fee basis)",
    },
    {
      NAICS22: "813212",
      "INDEX ITEM DESCRIPTION": "Voluntary health organizations",
    },
    {
      NAICS22: "813219",
      "INDEX ITEM DESCRIPTION":
        "Charitable fundraising using a crowdfunding platform (except on a contract or fee basis)",
    },
    {
      NAICS22: "813219",
      "INDEX ITEM DESCRIPTION": "Community chest fundraising organizations",
    },
    {
      NAICS22: "813219",
      "INDEX ITEM DESCRIPTION": "Federated charities",
    },
    {
      NAICS22: "813219",
      "INDEX ITEM DESCRIPTION": "United fund councils",
    },
    {
      NAICS22: "813219",
      "INDEX ITEM DESCRIPTION": "United funds for colleges",
    },
    {
      NAICS22: "813311",
      "INDEX ITEM DESCRIPTION": "Associations for retired persons, advocacy",
    },
    {
      NAICS22: "813311",
      "INDEX ITEM DESCRIPTION": "Civil liberties organizations",
    },
    {
      NAICS22: "813311",
      "INDEX ITEM DESCRIPTION": "Developmentally disabled advocacy organizations",
    },
    {
      NAICS22: "813311",
      "INDEX ITEM DESCRIPTION": "Human rights advocacy organizations",
    },
    {
      NAICS22: "813311",
      "INDEX ITEM DESCRIPTION":
        "Intellectually and developmentally disabled advocacy groups",
    },
    {
      NAICS22: "813311",
      "INDEX ITEM DESCRIPTION": "Senior citizens advocacy organizations",
    },
    {
      NAICS22: "813311",
      "INDEX ITEM DESCRIPTION": "Veterans' rights organizations",
    },
    {
      NAICS22: "813312",
      "INDEX ITEM DESCRIPTION": "Animal rights organizations",
    },
    {
      NAICS22: "813312",
      "INDEX ITEM DESCRIPTION": "Animal welfare associations or leagues",
    },
    {
      NAICS22: "813312",
      "INDEX ITEM DESCRIPTION": "Conservation advocacy organizations",
    },
    {
      NAICS22: "813312",
      "INDEX ITEM DESCRIPTION": "Environmental advocacy organizations",
    },
    {
      NAICS22: "813312",
      "INDEX ITEM DESCRIPTION": "Humane societies without animal shelters",
    },
    {
      NAICS22: "813312",
      "INDEX ITEM DESCRIPTION": "Natural resource preservation organizations",
    },
    {
      NAICS22: "813312",
      "INDEX ITEM DESCRIPTION": "Wildlife preservation organizations",
    },
    {
      NAICS22: "813319",
      "INDEX ITEM DESCRIPTION": "Accident prevention associations",
    },
    {
      NAICS22: "813319",
      "INDEX ITEM DESCRIPTION": "Antipoverty advocacy organizations",
    },
    {
      NAICS22: "813319",
      "INDEX ITEM DESCRIPTION": "Aviation advocacy organizations",
    },
    {
      NAICS22: "813319",
      "INDEX ITEM DESCRIPTION": "Community action advocacy organizations",
    },
    {
      NAICS22: "813319",
      "INDEX ITEM DESCRIPTION": "Drug abuse prevention advocacy organizations",
    },
    {
      NAICS22: "813319",
      "INDEX ITEM DESCRIPTION": "Drunk driving prevention advocacy organizations",
    },
    {
      NAICS22: "813319",
      "INDEX ITEM DESCRIPTION": "Firearms advocacy organizations",
    },
    {
      NAICS22: "813319",
      "INDEX ITEM DESCRIPTION": "Gun control organizations",
    },
    {
      NAICS22: "813319",
      "INDEX ITEM DESCRIPTION":
        "Hunting, fishing, and sport shooting advocacy organizations",
    },
    {
      NAICS22: "813319",
      "INDEX ITEM DESCRIPTION": "Neighborhood development advocacy organizations",
    },
    {
      NAICS22: "813319",
      "INDEX ITEM DESCRIPTION": "Peace advocacy organizations",
    },
    {
      NAICS22: "813319",
      "INDEX ITEM DESCRIPTION": "Public safety advocacy organizations",
    },
    {
      NAICS22: "813319",
      "INDEX ITEM DESCRIPTION": "Social change advocacy organizations",
    },
    {
      NAICS22: "813319",
      "INDEX ITEM DESCRIPTION": "Social service advocacy organizations",
    },
    {
      NAICS22: "813319",
      "INDEX ITEM DESCRIPTION":
        "Substance abuse prevention advocacy organizations",
    },
    {
      NAICS22: "813319",
      "INDEX ITEM DESCRIPTION": "Taxpayers' advocacy organizations",
    },
    {
      NAICS22: "813319",
      "INDEX ITEM DESCRIPTION": "Temperance organizations",
    },
    {
      NAICS22: "813319",
      "INDEX ITEM DESCRIPTION": "Tenants' advocacy associations",
    },
    {
      NAICS22: "813319",
      "INDEX ITEM DESCRIPTION": "Tenants' associations, advocacy",
    },
    {
      NAICS22: "813319",
      "INDEX ITEM DESCRIPTION":
        "World peace and understanding advocacy organizations",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Alumni associations",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Alumni clubs",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION":
        "Automobile clubs (except road and travel services)",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Book discussion clubs",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Booster clubs",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Boy guiding organizations",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Civic associations",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Classic car clubs",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Computer enthusiasts clubs",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Ethnic associations",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Fan clubs",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Farm granges",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION":
        "Fraternal associations or lodges, social or civic",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Fraternal lodges",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Fraternal organizations",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Fraternities (except residential)",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Garden clubs",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Girl guiding organizations",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Golden age clubs",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Granges",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Historical clubs",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Membership associations, civic or social",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Parent-teachers' associations",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Poetry clubs",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Public speaking improvement clubs",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Retirement associations, social",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Scouting organizations",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Senior citizens' associations, social",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Singing societies",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Social clubs",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Social organizations, civic and fraternal",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Sororities (except residential)",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Speakers' clubs",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Student clubs",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Students' associations",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Students' unions",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "University clubs",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Veterans'  membership organizations",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Women's auxiliaries",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Women's clubs",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Writing clubs",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Youth civic clubs",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Youth clubs (except recreational only)",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Youth farming organizations",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Youth scouting organizations",
    },
    {
      NAICS22: "813410",
      "INDEX ITEM DESCRIPTION": "Youth social clubs",
    },
    {
      NAICS22: "813910",
      "INDEX ITEM DESCRIPTION":
        "Agricultural organizations (except youth farming organizations, farm granges)",
    },
    {
      NAICS22: "813910",
      "INDEX ITEM DESCRIPTION": "Animal breeders' associations",
    },
    {
      NAICS22: "813910",
      "INDEX ITEM DESCRIPTION": "Bankers' associations",
    },
    {
      NAICS22: "813910",
      "INDEX ITEM DESCRIPTION": "Better business bureaus",
    },
    {
      NAICS22: "813910",
      "INDEX ITEM DESCRIPTION": "Boards of trade",
    },
    {
      NAICS22: "813910",
      "INDEX ITEM DESCRIPTION": "Business associations",
    },
    {
      NAICS22: "813910",
      "INDEX ITEM DESCRIPTION": "Chambers of commerce",
    },
    {
      NAICS22: "813910",
      "INDEX ITEM DESCRIPTION": "Construction associations",
    },
    {
      NAICS22: "813910",
      "INDEX ITEM DESCRIPTION": "Contractors' associations",
    },
    {
      NAICS22: "813910",
      "INDEX ITEM DESCRIPTION": "Distributors' associations",
    },
    {
      NAICS22: "813910",
      "INDEX ITEM DESCRIPTION": "Farmers' associations",
    },
    {
      NAICS22: "813910",
      "INDEX ITEM DESCRIPTION": "Farmers' unions",
    },
    {
      NAICS22: "813910",
      "INDEX ITEM DESCRIPTION": "Growers' associations",
    },
    {
      NAICS22: "813910",
      "INDEX ITEM DESCRIPTION": "Hospital associations",
    },
    {
      NAICS22: "813910",
      "INDEX ITEM DESCRIPTION": "Industrial associations",
    },
    {
      NAICS22: "813910",
      "INDEX ITEM DESCRIPTION": "Insurers' associations",
    },
    {
      NAICS22: "813910",
      "INDEX ITEM DESCRIPTION": "Junior chambers of commerce",
    },
    {
      NAICS22: "813910",
      "INDEX ITEM DESCRIPTION": "Manufacturers' associations",
    },
    {
      NAICS22: "813910",
      "INDEX ITEM DESCRIPTION": "Merchants' associations",
    },
    {
      NAICS22: "813910",
      "INDEX ITEM DESCRIPTION": "Mining associations",
    },
    {
      NAICS22: "813910",
      "INDEX ITEM DESCRIPTION": "Producers' associations",
    },
    {
      NAICS22: "813910",
      "INDEX ITEM DESCRIPTION": "Public utility associations",
    },
    {
      NAICS22: "813910",
      "INDEX ITEM DESCRIPTION": "Real estate boards",
    },
    {
      NAICS22: "813910",
      "INDEX ITEM DESCRIPTION": "Restaurant associations",
    },
    {
      NAICS22: "813910",
      "INDEX ITEM DESCRIPTION": "Retailers' associations",
    },
    {
      NAICS22: "813910",
      "INDEX ITEM DESCRIPTION": "Service industries associations",
    },
    {
      NAICS22: "813910",
      "INDEX ITEM DESCRIPTION": "Shipping companies' associations",
    },
    {
      NAICS22: "813910",
      "INDEX ITEM DESCRIPTION": "Trade associations",
    },
    {
      NAICS22: "813910",
      "INDEX ITEM DESCRIPTION": "Warehousing associations",
    },
    {
      NAICS22: "813910",
      "INDEX ITEM DESCRIPTION": "Wholesalers' associations",
    },
    {
      NAICS22: "813920",
      "INDEX ITEM DESCRIPTION": "Accountants' associations",
    },
    {
      NAICS22: "813920",
      "INDEX ITEM DESCRIPTION": "Architects' associations",
    },
    {
      NAICS22: "813920",
      "INDEX ITEM DESCRIPTION": "Bar associations",
    },
    {
      NAICS22: "813920",
      "INDEX ITEM DESCRIPTION": "Consultants' associations",
    },
    {
      NAICS22: "813920",
      "INDEX ITEM DESCRIPTION": "Dentists' associations",
    },
    {
      NAICS22: "813920",
      "INDEX ITEM DESCRIPTION": "Dietitians' associations",
    },
    {
      NAICS22: "813920",
      "INDEX ITEM DESCRIPTION": "Educators' associations",
    },
    {
      NAICS22: "813920",
      "INDEX ITEM DESCRIPTION": "Engineers' associations",
    },
    {
      NAICS22: "813920",
      "INDEX ITEM DESCRIPTION": "Health professionals' associations",
    },
    {
      NAICS22: "813920",
      "INDEX ITEM DESCRIPTION": "Hospital administrators' associations",
    },
    {
      NAICS22: "813920",
      "INDEX ITEM DESCRIPTION": "Learned societies",
    },
    {
      NAICS22: "813920",
      "INDEX ITEM DESCRIPTION": "Medical associations",
    },
    {
      NAICS22: "813920",
      "INDEX ITEM DESCRIPTION": "Nurses' associations",
    },
    {
      NAICS22: "813920",
      "INDEX ITEM DESCRIPTION": "Occupational therapists' associations",
    },
    {
      NAICS22: "813920",
      "INDEX ITEM DESCRIPTION": "Optometrists' associations",
    },
    {
      NAICS22: "813920",
      "INDEX ITEM DESCRIPTION": "Peer review boards",
    },
    {
      NAICS22: "813920",
      "INDEX ITEM DESCRIPTION": "Personnel management associations",
    },
    {
      NAICS22: "813920",
      "INDEX ITEM DESCRIPTION": "Pharmacists' associations",
    },
    {
      NAICS22: "813920",
      "INDEX ITEM DESCRIPTION": "Professional associations",
    },
    {
      NAICS22: "813920",
      "INDEX ITEM DESCRIPTION": "Professional membership associations",
    },
    {
      NAICS22: "813920",
      "INDEX ITEM DESCRIPTION": "Professional standards review boards",
    },
    {
      NAICS22: "813920",
      "INDEX ITEM DESCRIPTION": "Psychologists' associations",
    },
    {
      NAICS22: "813920",
      "INDEX ITEM DESCRIPTION": "Scientific associations",
    },
    {
      NAICS22: "813920",
      "INDEX ITEM DESCRIPTION": "Social workers' associations",
    },
    {
      NAICS22: "813920",
      "INDEX ITEM DESCRIPTION": "Standards review committees, professional",
    },
    {
      NAICS22: "813930",
      "INDEX ITEM DESCRIPTION": "Collective bargaining units",
    },
    {
      NAICS22: "813930",
      "INDEX ITEM DESCRIPTION":
        "Employees' associations for improvement of wages and working conditions",
    },
    {
      NAICS22: "813930",
      "INDEX ITEM DESCRIPTION": "Federation of workers, labor organizations",
    },
    {
      NAICS22: "813930",
      "INDEX ITEM DESCRIPTION": "Federations of labor",
    },
    {
      NAICS22: "813930",
      "INDEX ITEM DESCRIPTION": "Industrial labor unions",
    },
    {
      NAICS22: "813930",
      "INDEX ITEM DESCRIPTION": "Labor federations",
    },
    {
      NAICS22: "813930",
      "INDEX ITEM DESCRIPTION": "Labor unions (except apprenticeship programs)",
    },
    {
      NAICS22: "813930",
      "INDEX ITEM DESCRIPTION": "Trade unions (except apprenticeship programs)",
    },
    {
      NAICS22: "813930",
      "INDEX ITEM DESCRIPTION": "Trade unions, local",
    },
    {
      NAICS22: "813930",
      "INDEX ITEM DESCRIPTION": "Unions (except apprenticeship programs), labor",
    },
    {
      NAICS22: "813940",
      "INDEX ITEM DESCRIPTION": "Campaign organizations, political",
    },
    {
      NAICS22: "813940",
      "INDEX ITEM DESCRIPTION": "Constituencies' associations, political party",
    },
    {
      NAICS22: "813940",
      "INDEX ITEM DESCRIPTION": "Local political organizations",
    },
    {
      NAICS22: "813940",
      "INDEX ITEM DESCRIPTION": "PACs (Political Action Committees)",
    },
    {
      NAICS22: "813940",
      "INDEX ITEM DESCRIPTION": "Political action committees (PACs)",
    },
    {
      NAICS22: "813940",
      "INDEX ITEM DESCRIPTION": "Political campaign organizations",
    },
    {
      NAICS22: "813940",
      "INDEX ITEM DESCRIPTION": "Political organizations or clubs",
    },
    {
      NAICS22: "813940",
      "INDEX ITEM DESCRIPTION": "Political parties",
    },
    {
      NAICS22: "813990",
      "INDEX ITEM DESCRIPTION": "Athletic associations, regulatory",
    },
    {
      NAICS22: "813990",
      "INDEX ITEM DESCRIPTION": "Athletic leagues (i.e., regulating bodies)",
    },
    {
      NAICS22: "813990",
      "INDEX ITEM DESCRIPTION": "Condominium corporations",
    },
    {
      NAICS22: "813990",
      "INDEX ITEM DESCRIPTION": "Condominium owners' associations",
    },
    {
      NAICS22: "813990",
      "INDEX ITEM DESCRIPTION": "Cooperative owners' associations",
    },
    {
      NAICS22: "813990",
      "INDEX ITEM DESCRIPTION": "Homeowners' associations",
    },
    {
      NAICS22: "813990",
      "INDEX ITEM DESCRIPTION": "Homeowners' associations, condominium",
    },
    {
      NAICS22: "813990",
      "INDEX ITEM DESCRIPTION": "Property owners' associations",
    },
    {
      NAICS22: "813990",
      "INDEX ITEM DESCRIPTION": "Sports governing bodies",
    },
    {
      NAICS22: "813990",
      "INDEX ITEM DESCRIPTION": "Sports leagues (i.e., regulating bodies)",
    },
    {
      NAICS22: "813990",
      "INDEX ITEM DESCRIPTION": "Tenants' associations (except advocacy)",
    },
    {
      NAICS22: "814110",
      "INDEX ITEM DESCRIPTION":
        "Households, private, employing (e.g., cooks, maids, chauffeurs, gardeners)",
    },
    {
      NAICS22: "814110",
      "INDEX ITEM DESCRIPTION":
        "Households, private, employing domestic personnel",
    },
    {
      NAICS22: "814110",
      "INDEX ITEM DESCRIPTION": "Private households employing domestic personnel",
    },
    {
      NAICS22: "814110",
      "INDEX ITEM DESCRIPTION": "Private households with employees",
    },
    {
      NAICS22: "921110",
      "INDEX ITEM DESCRIPTION": "Advisory commissions, executive government",
    },
    {
      NAICS22: "921110",
      "INDEX ITEM DESCRIPTION": "City and town managers' offices",
    },
    {
      NAICS22: "921110",
      "INDEX ITEM DESCRIPTION": "County supervisors' and executives' offices",
    },
    {
      NAICS22: "921110",
      "INDEX ITEM DESCRIPTION":
        "Executive offices, federal, state, and local (e.g., governor, mayor, president)",
    },
    {
      NAICS22: "921110",
      "INDEX ITEM DESCRIPTION": "Governors' offices",
    },
    {
      NAICS22: "921110",
      "INDEX ITEM DESCRIPTION": "Mayor's offices",
    },
    {
      NAICS22: "921110",
      "INDEX ITEM DESCRIPTION": "President's office, United States",
    },
    {
      NAICS22: "921120",
      "INDEX ITEM DESCRIPTION": "Advisory commissions, legislative",
    },
    {
      NAICS22: "921120",
      "INDEX ITEM DESCRIPTION": "Boards of supervisors, county and local",
    },
    {
      NAICS22: "921120",
      "INDEX ITEM DESCRIPTION": "City and town councils",
    },
    {
      NAICS22: "921120",
      "INDEX ITEM DESCRIPTION": "Congress of the United States",
    },
    {
      NAICS22: "921120",
      "INDEX ITEM DESCRIPTION": "County commissioners",
    },
    {
      NAICS22: "921120",
      "INDEX ITEM DESCRIPTION": "Legislative assemblies",
    },
    {
      NAICS22: "921120",
      "INDEX ITEM DESCRIPTION":
        "Legislative bodies (e.g., federal, local, and state)",
    },
    {
      NAICS22: "921120",
      "INDEX ITEM DESCRIPTION": "Legislative commissions",
    },
    {
      NAICS22: "921120",
      "INDEX ITEM DESCRIPTION": "Study commissions, legislative",
    },
    {
      NAICS22: "921130",
      "INDEX ITEM DESCRIPTION": "Assessor's offices, tax",
    },
    {
      NAICS22: "921130",
      "INDEX ITEM DESCRIPTION": "Board of Governors, Federal Reserve",
    },
    {
      NAICS22: "921130",
      "INDEX ITEM DESCRIPTION": "Budget agencies, government",
    },
    {
      NAICS22: "921130",
      "INDEX ITEM DESCRIPTION":
        "Controllers' and comptrollers' offices, government",
    },
    {
      NAICS22: "921130",
      "INDEX ITEM DESCRIPTION": "Customs bureaus",
    },
    {
      NAICS22: "921130",
      "INDEX ITEM DESCRIPTION": "Federal Reserve Board of Governors",
    },
    {
      NAICS22: "921130",
      "INDEX ITEM DESCRIPTION": "Gambling control boards, nonoperating",
    },
    {
      NAICS22: "921130",
      "INDEX ITEM DESCRIPTION": "Internal Revenue Service",
    },
    {
      NAICS22: "921130",
      "INDEX ITEM DESCRIPTION": "Lottery control boards, nonoperating",
    },
    {
      NAICS22: "921130",
      "INDEX ITEM DESCRIPTION": "Property tax assessors' offices",
    },
    {
      NAICS22: "921130",
      "INDEX ITEM DESCRIPTION": "State tax commissions",
    },
    {
      NAICS22: "921130",
      "INDEX ITEM DESCRIPTION": "Taxation departments",
    },
    {
      NAICS22: "921130",
      "INDEX ITEM DESCRIPTION": "Treasurers' offices, government",
    },
    {
      NAICS22: "921140",
      "INDEX ITEM DESCRIPTION": "Executive and legislative office combinations",
    },
    {
      NAICS22: "921140",
      "INDEX ITEM DESCRIPTION": "Legislative and executive office combinations",
    },
    {
      NAICS22: "921150",
      "INDEX ITEM DESCRIPTION":
        "American Indian or Alaska Native tribal councils",
    },
    {
      NAICS22: "921150",
      "INDEX ITEM DESCRIPTION": "American Indian or Alaska Native tribal courts",
    },
    {
      NAICS22: "921150",
      "INDEX ITEM DESCRIPTION":
        "American Indian or Alaska Native, tribal chief's or chairman's office",
    },
    {
      NAICS22: "921150",
      "INDEX ITEM DESCRIPTION": "Courts, American Indian or Alaska Native",
    },
    {
      NAICS22: "921150",
      "INDEX ITEM DESCRIPTION": "Police, American Indian or Alaska Native tribal",
    },
    {
      NAICS22: "921150",
      "INDEX ITEM DESCRIPTION":
        "Tribal chief's or chairman's office, American Indian or Alaska Native",
    },
    {
      NAICS22: "921150",
      "INDEX ITEM DESCRIPTION":
        "Tribal councils, American Indian or Alaska Native",
    },
    {
      NAICS22: "921150",
      "INDEX ITEM DESCRIPTION": "Tribal courts, American Indian or Alaska Native",
    },
    {
      NAICS22: "921190",
      "INDEX ITEM DESCRIPTION": "Auditor's offices, government",
    },
    {
      NAICS22: "921190",
      "INDEX ITEM DESCRIPTION": "Civil rights commissions",
    },
    {
      NAICS22: "921190",
      "INDEX ITEM DESCRIPTION": "Civil service commissions",
    },
    {
      NAICS22: "921190",
      "INDEX ITEM DESCRIPTION": "Election boards",
    },
    {
      NAICS22: "921190",
      "INDEX ITEM DESCRIPTION": "General accounting offices, government",
    },
    {
      NAICS22: "921190",
      "INDEX ITEM DESCRIPTION": "General public administration",
    },
    {
      NAICS22: "921190",
      "INDEX ITEM DESCRIPTION": "General services departments, government",
    },
    {
      NAICS22: "921190",
      "INDEX ITEM DESCRIPTION": "Human rights commissions, government",
    },
    {
      NAICS22: "921190",
      "INDEX ITEM DESCRIPTION": "Indian affairs programs, government",
    },
    {
      NAICS22: "921190",
      "INDEX ITEM DESCRIPTION": "Personnel offices, government",
    },
    {
      NAICS22: "921190",
      "INDEX ITEM DESCRIPTION": "Public property management services, government",
    },
    {
      NAICS22: "921190",
      "INDEX ITEM DESCRIPTION": "Purchasing and supply agencies, government",
    },
    {
      NAICS22: "921190",
      "INDEX ITEM DESCRIPTION": "Supply agencies, government",
    },
    {
      NAICS22: "922110",
      "INDEX ITEM DESCRIPTION": "Administrative courts",
    },
    {
      NAICS22: "922110",
      "INDEX ITEM DESCRIPTION": "Circuit courts",
    },
    {
      NAICS22: "922110",
      "INDEX ITEM DESCRIPTION": "City or county courts",
    },
    {
      NAICS22: "922110",
      "INDEX ITEM DESCRIPTION":
        "Courts of law, civilian (except American Indian or Alaska Native)",
    },
    {
      NAICS22: "922110",
      "INDEX ITEM DESCRIPTION":
        "Courts, civilian (except American Indian or Alaska Native)",
    },
    {
      NAICS22: "922110",
      "INDEX ITEM DESCRIPTION": "Courts, small claims",
    },
    {
      NAICS22: "922110",
      "INDEX ITEM DESCRIPTION": "Sheriffs' offices, court functions only",
    },
    {
      NAICS22: "922110",
      "INDEX ITEM DESCRIPTION": "Traffic courts",
    },
    {
      NAICS22: "922120",
      "INDEX ITEM DESCRIPTION": "Alcohol, tobacco, and firearms control",
    },
    {
      NAICS22: "922120",
      "INDEX ITEM DESCRIPTION": "Criminal investigation offices, government",
    },
    {
      NAICS22: "922120",
      "INDEX ITEM DESCRIPTION": "DEA (Drug Enforcement Administration)",
    },
    {
      NAICS22: "922120",
      "INDEX ITEM DESCRIPTION": "Drug enforcement agencies and offices",
    },
    {
      NAICS22: "922120",
      "INDEX ITEM DESCRIPTION": "Federal Bureau of Investigation (FBI)",
    },
    {
      NAICS22: "922120",
      "INDEX ITEM DESCRIPTION": "Federal police services",
    },
    {
      NAICS22: "922120",
      "INDEX ITEM DESCRIPTION": "Highway patrols, police",
    },
    {
      NAICS22: "922120",
      "INDEX ITEM DESCRIPTION": "Housing police, government",
    },
    {
      NAICS22: "922120",
      "INDEX ITEM DESCRIPTION": "Marshals' offices",
    },
    {
      NAICS22: "922120",
      "INDEX ITEM DESCRIPTION": "Park police",
    },
    {
      NAICS22: "922120",
      "INDEX ITEM DESCRIPTION": "Police academies",
    },
    {
      NAICS22: "922120",
      "INDEX ITEM DESCRIPTION": "Police and fire departments, combined",
    },
    {
      NAICS22: "922120",
      "INDEX ITEM DESCRIPTION":
        "Police departments (except American Indian or Alaska Native)",
    },
    {
      NAICS22: "922120",
      "INDEX ITEM DESCRIPTION": "Sheriffs' offices (except court functions only)",
    },
    {
      NAICS22: "922120",
      "INDEX ITEM DESCRIPTION": "State police",
    },
    {
      NAICS22: "922120",
      "INDEX ITEM DESCRIPTION": "Transit police",
    },
    {
      NAICS22: "922130",
      "INDEX ITEM DESCRIPTION": "Attorney generals' offices",
    },
    {
      NAICS22: "922130",
      "INDEX ITEM DESCRIPTION": "District attorneys' offices",
    },
    {
      NAICS22: "922130",
      "INDEX ITEM DESCRIPTION": "Legal counsel offices, government",
    },
    {
      NAICS22: "922130",
      "INDEX ITEM DESCRIPTION": "Public defenders' offices",
    },
    {
      NAICS22: "922130",
      "INDEX ITEM DESCRIPTION": "Public prosecutors' offices",
    },
    {
      NAICS22: "922130",
      "INDEX ITEM DESCRIPTION": "Solicitors' offices, government",
    },
    {
      NAICS22: "922130",
      "INDEX ITEM DESCRIPTION": "U.S. attorneys' offices",
    },
    {
      NAICS22: "922140",
      "INDEX ITEM DESCRIPTION":
        "Correctional boot camps (except private operation of)",
    },
    {
      NAICS22: "922140",
      "INDEX ITEM DESCRIPTION":
        "Correctional institutions (except private operation of)",
    },
    {
      NAICS22: "922140",
      "INDEX ITEM DESCRIPTION": "Detention centers (except private operation of)",
    },
    {
      NAICS22: "922140",
      "INDEX ITEM DESCRIPTION":
        "Honor camps, correctional (except private operation of)",
    },
    {
      NAICS22: "922140",
      "INDEX ITEM DESCRIPTION":
        "Houses of correction (except private operation of)",
    },
    {
      NAICS22: "922140",
      "INDEX ITEM DESCRIPTION": "Jails (except private operation of)",
    },
    {
      NAICS22: "922140",
      "INDEX ITEM DESCRIPTION": "Penitentiaries (except private operation of)",
    },
    {
      NAICS22: "922140",
      "INDEX ITEM DESCRIPTION": "Prison farms (except private operation of)",
    },
    {
      NAICS22: "922140",
      "INDEX ITEM DESCRIPTION": "Prisons (except private operation of)",
    },
    {
      NAICS22: "922140",
      "INDEX ITEM DESCRIPTION": "Reformatories (except private operation of)",
    },
    {
      NAICS22: "922150",
      "INDEX ITEM DESCRIPTION": "Pardon boards and offices",
    },
    {
      NAICS22: "922150",
      "INDEX ITEM DESCRIPTION": "Parole offices, publicly administered",
    },
    {
      NAICS22: "922150",
      "INDEX ITEM DESCRIPTION": "Probation offices, publicly administered",
    },
    {
      NAICS22: "922150",
      "INDEX ITEM DESCRIPTION": "Public parole offices",
    },
    {
      NAICS22: "922150",
      "INDEX ITEM DESCRIPTION": "Public probation offices",
    },
    {
      NAICS22: "922150",
      "INDEX ITEM DESCRIPTION":
        "Rehabilitation services, correctional, government",
    },
    {
      NAICS22: "922160",
      "INDEX ITEM DESCRIPTION": "Ambulance and fire service combined",
    },
    {
      NAICS22: "922160",
      "INDEX ITEM DESCRIPTION": "Fire and rescue service",
    },
    {
      NAICS22: "922160",
      "INDEX ITEM DESCRIPTION":
        "Fire departments (e.g., government, volunteer (except private))",
    },
    {
      NAICS22: "922160",
      "INDEX ITEM DESCRIPTION": "Fire marshals' offices",
    },
    {
      NAICS22: "922160",
      "INDEX ITEM DESCRIPTION": "Fire prevention offices, government",
    },
    {
      NAICS22: "922160",
      "INDEX ITEM DESCRIPTION":
        "Firefighting (except forest), government and volunteer (except private)",
    },
    {
      NAICS22: "922160",
      "INDEX ITEM DESCRIPTION":
        "Firefighting services (except forest and private)",
    },
    {
      NAICS22: "922190",
      "INDEX ITEM DESCRIPTION": "Consumer product safety commissions",
    },
    {
      NAICS22: "922190",
      "INDEX ITEM DESCRIPTION": "Criminal justice statistics centers, government",
    },
    {
      NAICS22: "922190",
      "INDEX ITEM DESCRIPTION":
        "Disaster preparedness and management offices, government",
    },
    {
      NAICS22: "922190",
      "INDEX ITEM DESCRIPTION":
        "Emergency planning and management offices, government",
    },
    {
      NAICS22: "922190",
      "INDEX ITEM DESCRIPTION": "Law enforcement statistics centers, government",
    },
    {
      NAICS22: "922190",
      "INDEX ITEM DESCRIPTION":
        "Public safety bureaus and statistics centers, government",
    },
    {
      NAICS22: "922190",
      "INDEX ITEM DESCRIPTION": "Public safety statistics centers, government",
    },
    {
      NAICS22: "923110",
      "INDEX ITEM DESCRIPTION": "Certification of schools and teachers",
    },
    {
      NAICS22: "923110",
      "INDEX ITEM DESCRIPTION":
        "County supervisors of education (except school boards)",
    },
    {
      NAICS22: "923110",
      "INDEX ITEM DESCRIPTION": "Education offices, nonoperating",
    },
    {
      NAICS22: "923110",
      "INDEX ITEM DESCRIPTION": "Education program administration",
    },
    {
      NAICS22: "923110",
      "INDEX ITEM DESCRIPTION": "Education statistics centers, government",
    },
    {
      NAICS22: "923110",
      "INDEX ITEM DESCRIPTION": "State education departments",
    },
    {
      NAICS22: "923110",
      "INDEX ITEM DESCRIPTION": "Teacher certification bureaus",
    },
    {
      NAICS22: "923110",
      "INDEX ITEM DESCRIPTION": "University regents or boards, government",
    },
    {
      NAICS22: "923120",
      "INDEX ITEM DESCRIPTION": "Cancer detection program administration",
    },
    {
      NAICS22: "923120",
      "INDEX ITEM DESCRIPTION": "Communicable disease program administration",
    },
    {
      NAICS22: "923120",
      "INDEX ITEM DESCRIPTION": "Community health programs administration",
    },
    {
      NAICS22: "923120",
      "INDEX ITEM DESCRIPTION": "Coroners' offices",
    },
    {
      NAICS22: "923120",
      "INDEX ITEM DESCRIPTION": "Environmental health program administration",
    },
    {
      NAICS22: "923120",
      "INDEX ITEM DESCRIPTION": "Food service health inspections",
    },
    {
      NAICS22: "923120",
      "INDEX ITEM DESCRIPTION":
        "Health planning and development agencies, government",
    },
    {
      NAICS22: "923120",
      "INDEX ITEM DESCRIPTION": "Health program administration",
    },
    {
      NAICS22: "923120",
      "INDEX ITEM DESCRIPTION": "Health statistics centers, government",
    },
    {
      NAICS22: "923120",
      "INDEX ITEM DESCRIPTION": "Immunization program administration",
    },
    {
      NAICS22: "923120",
      "INDEX ITEM DESCRIPTION":
        "Maternity and child health program administration",
    },
    {
      NAICS22: "923120",
      "INDEX ITEM DESCRIPTION": "Mental health program administration",
    },
    {
      NAICS22: "923120",
      "INDEX ITEM DESCRIPTION":
        "Public health program administration, nonoperating",
    },
    {
      NAICS22: "923130",
      "INDEX ITEM DESCRIPTION": "Community social service program administration",
    },
    {
      NAICS22: "923130",
      "INDEX ITEM DESCRIPTION": "Equal employment opportunity offices",
    },
    {
      NAICS22: "923130",
      "INDEX ITEM DESCRIPTION":
        "Food distribution program administration, government",
    },
    {
      NAICS22: "923130",
      "INDEX ITEM DESCRIPTION":
        "Medical assistance programs administration, government",
    },
    {
      NAICS22: "923130",
      "INDEX ITEM DESCRIPTION": "Medicare and Medicaid administration",
    },
    {
      NAICS22: "923130",
      "INDEX ITEM DESCRIPTION": "Old age survivors and disability programs",
    },
    {
      NAICS22: "923130",
      "INDEX ITEM DESCRIPTION": "Railroad Retirement Board",
    },
    {
      NAICS22: "923130",
      "INDEX ITEM DESCRIPTION": "Social assistance cost-sharing, government",
    },
    {
      NAICS22: "923130",
      "INDEX ITEM DESCRIPTION": "Social Security Administration (SSA), federal",
    },
    {
      NAICS22: "923130",
      "INDEX ITEM DESCRIPTION": "Unemployment insurance program administration",
    },
    {
      NAICS22: "923130",
      "INDEX ITEM DESCRIPTION": "Welfare administration, nonoperating",
    },
    {
      NAICS22: "923130",
      "INDEX ITEM DESCRIPTION": "Welfare programs administration",
    },
    {
      NAICS22: "923130",
      "INDEX ITEM DESCRIPTION": "Women's bureaus",
    },
    {
      NAICS22: "923130",
      "INDEX ITEM DESCRIPTION": "Workers' compensation program administration",
    },
    {
      NAICS22: "923140",
      "INDEX ITEM DESCRIPTION": "Veterans' affairs offices",
    },
    {
      NAICS22: "923140",
      "INDEX ITEM DESCRIPTION":
        "Veterans' benefits program administration, government",
    },
    {
      NAICS22: "924110",
      "INDEX ITEM DESCRIPTION":
        "Enforcement of environmental and pollution control regulations",
    },
    {
      NAICS22: "924110",
      "INDEX ITEM DESCRIPTION": "Environmental protection program administration",
    },
    {
      NAICS22: "924110",
      "INDEX ITEM DESCRIPTION":
        "NOAA (National Oceanic and Atmospheric Administration)",
    },
    {
      NAICS22: "924110",
      "INDEX ITEM DESCRIPTION": "Pollution control program administration",
    },
    {
      NAICS22: "924110",
      "INDEX ITEM DESCRIPTION": "Sanitation engineering agencies, government",
    },
    {
      NAICS22: "924110",
      "INDEX ITEM DESCRIPTION": "Waste management program administration",
    },
    {
      NAICS22: "924110",
      "INDEX ITEM DESCRIPTION":
        "Water control and quality program administration",
    },
    {
      NAICS22: "924120",
      "INDEX ITEM DESCRIPTION": "Community recreation programs, government",
    },
    {
      NAICS22: "924120",
      "INDEX ITEM DESCRIPTION": "Conservation and reclamation agencies",
    },
    {
      NAICS22: "924120",
      "INDEX ITEM DESCRIPTION": "Fish and game agencies",
    },
    {
      NAICS22: "924120",
      "INDEX ITEM DESCRIPTION":
        "Fish and wildlife conservation program administration",
    },
    {
      NAICS22: "924120",
      "INDEX ITEM DESCRIPTION": "Game and inland fish agencies",
    },
    {
      NAICS22: "924120",
      "INDEX ITEM DESCRIPTION": "Game wardens",
    },
    {
      NAICS22: "924120",
      "INDEX ITEM DESCRIPTION": "Geological research program administration",
    },
    {
      NAICS22: "924120",
      "INDEX ITEM DESCRIPTION": "Land management program administration",
    },
    {
      NAICS22: "924120",
      "INDEX ITEM DESCRIPTION": "Parks and recreation commission, government",
    },
    {
      NAICS22: "924120",
      "INDEX ITEM DESCRIPTION":
        "Recreational programs administration, government",
    },
    {
      NAICS22: "924120",
      "INDEX ITEM DESCRIPTION": "Soil conservation services, government",
    },
    {
      NAICS22: "924120",
      "INDEX ITEM DESCRIPTION": "Weather research program administration",
    },
    {
      NAICS22: "924120",
      "INDEX ITEM DESCRIPTION": "Wildlife conservation agencies",
    },
    {
      NAICS22: "924120",
      "INDEX ITEM DESCRIPTION":
        "Wind and water erosion control agencies, government",
    },
    {
      NAICS22: "925110",
      "INDEX ITEM DESCRIPTION": "Building standards agencies, government",
    },
    {
      NAICS22: "925110",
      "INDEX ITEM DESCRIPTION": "Housing authorities, nonoperating",
    },
    {
      NAICS22: "925110",
      "INDEX ITEM DESCRIPTION":
        "Housing programs, planning and development, government",
    },
    {
      NAICS22: "925120",
      "INDEX ITEM DESCRIPTION": "Community development agencies, government",
    },
    {
      NAICS22: "925120",
      "INDEX ITEM DESCRIPTION": "County development agencies",
    },
    {
      NAICS22: "925120",
      "INDEX ITEM DESCRIPTION": "Land redevelopment agencies, government",
    },
    {
      NAICS22: "925120",
      "INDEX ITEM DESCRIPTION": "Redevelopment land agencies, government",
    },
    {
      NAICS22: "925120",
      "INDEX ITEM DESCRIPTION":
        "Regional planning and development program administration",
    },
    {
      NAICS22: "925120",
      "INDEX ITEM DESCRIPTION": "Urban planning commissions, government",
    },
    {
      NAICS22: "925120",
      "INDEX ITEM DESCRIPTION": "Zoning boards and commissions",
    },
    {
      NAICS22: "926110",
      "INDEX ITEM DESCRIPTION":
        "Arts and cultural program administration, government",
    },
    {
      NAICS22: "926110",
      "INDEX ITEM DESCRIPTION": "Consumer protection offices",
    },
    {
      NAICS22: "926110",
      "INDEX ITEM DESCRIPTION": "Councils of Economic Advisers",
    },
    {
      NAICS22: "926110",
      "INDEX ITEM DESCRIPTION":
        "Cultural and arts development support program administration",
    },
    {
      NAICS22: "926110",
      "INDEX ITEM DESCRIPTION": "Development assistance program administration",
    },
    {
      NAICS22: "926110",
      "INDEX ITEM DESCRIPTION": "Economic development agencies, government",
    },
    {
      NAICS22: "926110",
      "INDEX ITEM DESCRIPTION":
        "Energy development and conservation agencies, nonoperating",
    },
    {
      NAICS22: "926110",
      "INDEX ITEM DESCRIPTION": "Energy program administration",
    },
    {
      NAICS22: "926110",
      "INDEX ITEM DESCRIPTION": "Enterprise development program administration",
    },
    {
      NAICS22: "926110",
      "INDEX ITEM DESCRIPTION": "General economics statistical agencies",
    },
    {
      NAICS22: "926110",
      "INDEX ITEM DESCRIPTION": "Industrial development program administration",
    },
    {
      NAICS22: "926110",
      "INDEX ITEM DESCRIPTION": "Labor statistics agencies",
    },
    {
      NAICS22: "926110",
      "INDEX ITEM DESCRIPTION": "Small business development agencies",
    },
    {
      NAICS22: "926110",
      "INDEX ITEM DESCRIPTION": "Tourism development offices, government",
    },
    {
      NAICS22: "926110",
      "INDEX ITEM DESCRIPTION": "Trade commissions, government",
    },
    {
      NAICS22: "926110",
      "INDEX ITEM DESCRIPTION": "Trade development program administration",
    },
    {
      NAICS22: "926110",
      "INDEX ITEM DESCRIPTION": "Workforce Development Boards, nonoperating",
    },
    {
      NAICS22: "926120",
      "INDEX ITEM DESCRIPTION": "Aircraft inspection, government",
    },
    {
      NAICS22: "926120",
      "INDEX ITEM DESCRIPTION": "Coast Guard (except academy)",
    },
    {
      NAICS22: "926120",
      "INDEX ITEM DESCRIPTION":
        "Federal Aviation Administration (except air traffic control)",
    },
    {
      NAICS22: "926120",
      "INDEX ITEM DESCRIPTION":
        "Licensing of transportation equipment, facilities, and services",
    },
    {
      NAICS22: "926120",
      "INDEX ITEM DESCRIPTION": "Merchant Marine (except academy)",
    },
    {
      NAICS22: "926120",
      "INDEX ITEM DESCRIPTION": "Motor carrier licensing and inspection offices",
    },
    {
      NAICS22: "926120",
      "INDEX ITEM DESCRIPTION": "Motor vehicle licensing offices, government",
    },
    {
      NAICS22: "926120",
      "INDEX ITEM DESCRIPTION": "National Transportation Safety Board",
    },
    {
      NAICS22: "926120",
      "INDEX ITEM DESCRIPTION": "Port authorities and districts, nonoperating",
    },
    {
      NAICS22: "926120",
      "INDEX ITEM DESCRIPTION": "Public transportation commissions, nonoperating",
    },
    {
      NAICS22: "926120",
      "INDEX ITEM DESCRIPTION":
        "Railroad and warehouse commissions, nonoperating",
    },
    {
      NAICS22: "926120",
      "INDEX ITEM DESCRIPTION": "Transit systems and authorities, nonoperating",
    },
    {
      NAICS22: "926120",
      "INDEX ITEM DESCRIPTION": "Transportation departments, nonoperating",
    },
    {
      NAICS22: "926120",
      "INDEX ITEM DESCRIPTION": "Transportation regulatory agencies",
    },
    {
      NAICS22: "926120",
      "INDEX ITEM DESCRIPTION": "Transportation safety programs, government",
    },
    {
      NAICS22: "926130",
      "INDEX ITEM DESCRIPTION": "Communications commissions",
    },
    {
      NAICS22: "926130",
      "INDEX ITEM DESCRIPTION":
        "Communications licensing commissions and agencies",
    },
    {
      NAICS22: "926130",
      "INDEX ITEM DESCRIPTION":
        "Energy development and conservation programs, government",
    },
    {
      NAICS22: "926130",
      "INDEX ITEM DESCRIPTION": "Federal Communications Commission (FCC)",
    },
    {
      NAICS22: "926130",
      "INDEX ITEM DESCRIPTION": "Irrigation districts, nonoperating",
    },
    {
      NAICS22: "926130",
      "INDEX ITEM DESCRIPTION": "Licensing and inspecting of utilities",
    },
    {
      NAICS22: "926130",
      "INDEX ITEM DESCRIPTION": "Mosquito eradication districts",
    },
    {
      NAICS22: "926130",
      "INDEX ITEM DESCRIPTION":
        "Nuclear energy inspection and regulation offices",
    },
    {
      NAICS22: "926130",
      "INDEX ITEM DESCRIPTION":
        "Public service (except transportation) commissions, nonoperating",
    },
    {
      NAICS22: "926130",
      "INDEX ITEM DESCRIPTION":
        "Public utility (except transportation) commissions, nonoperating",
    },
    {
      NAICS22: "926130",
      "INDEX ITEM DESCRIPTION": "Regulation of utilities",
    },
    {
      NAICS22: "926130",
      "INDEX ITEM DESCRIPTION": "Sanitation districts, nonoperating",
    },
    {
      NAICS22: "926130",
      "INDEX ITEM DESCRIPTION": "Solar energy  regulation",
    },
    {
      NAICS22: "926130",
      "INDEX ITEM DESCRIPTION": "Wind generated electrical power regulation",
    },
    {
      NAICS22: "926140",
      "INDEX ITEM DESCRIPTION":
        "Agricultural cooperative extension program administration",
    },
    {
      NAICS22: "926140",
      "INDEX ITEM DESCRIPTION": "Agricultural marketing services government",
    },
    {
      NAICS22: "926140",
      "INDEX ITEM DESCRIPTION":
        "Agricultural pest and weed regulation, government",
    },
    {
      NAICS22: "926140",
      "INDEX ITEM DESCRIPTION": "Agriculture fair boards administration",
    },
    {
      NAICS22: "926140",
      "INDEX ITEM DESCRIPTION": "Animal quarantine service, government",
    },
    {
      NAICS22: "926140",
      "INDEX ITEM DESCRIPTION": "Food inspection agencies",
    },
    {
      NAICS22: "926140",
      "INDEX ITEM DESCRIPTION": "Pest control programs, agriculture, government",
    },
    {
      NAICS22: "926140",
      "INDEX ITEM DESCRIPTION":
        "Regulation and inspection of agricultural products",
    },
    {
      NAICS22: "926140",
      "INDEX ITEM DESCRIPTION": "Weed control, agriculture, government",
    },
    {
      NAICS22: "926150",
      "INDEX ITEM DESCRIPTION": "Alcoholic beverage control boards",
    },
    {
      NAICS22: "926150",
      "INDEX ITEM DESCRIPTION": "Banking regulatory agencies",
    },
    {
      NAICS22: "926150",
      "INDEX ITEM DESCRIPTION": "Building inspections, government",
    },
    {
      NAICS22: "926150",
      "INDEX ITEM DESCRIPTION": "Conciliation and mediation services, government",
    },
    {
      NAICS22: "926150",
      "INDEX ITEM DESCRIPTION": "Health professions licensure agencies",
    },
    {
      NAICS22: "926150",
      "INDEX ITEM DESCRIPTION": "Hospital licensure agencies",
    },
    {
      NAICS22: "926150",
      "INDEX ITEM DESCRIPTION": "Inspection for labor standards",
    },
    {
      NAICS22: "926150",
      "INDEX ITEM DESCRIPTION": "Insurance commissions, government",
    },
    {
      NAICS22: "926150",
      "INDEX ITEM DESCRIPTION":
        "Labor management negotiations boards, government",
    },
    {
      NAICS22: "926150",
      "INDEX ITEM DESCRIPTION":
        "Licensing and permit issuance for business operations, government",
    },
    {
      NAICS22: "926150",
      "INDEX ITEM DESCRIPTION":
        "Licensing and permit issuance for professional occupations, government",
    },
    {
      NAICS22: "926150",
      "INDEX ITEM DESCRIPTION": "Mediation and conciliation services, government",
    },
    {
      NAICS22: "926150",
      "INDEX ITEM DESCRIPTION": "Minimum wage program administration",
    },
    {
      NAICS22: "926150",
      "INDEX ITEM DESCRIPTION": "Occupational safety and health administration",
    },
    {
      NAICS22: "926150",
      "INDEX ITEM DESCRIPTION":
        "Occupational safety and health standards agencies",
    },
    {
      NAICS22: "926150",
      "INDEX ITEM DESCRIPTION": "Pet licensing",
    },
    {
      NAICS22: "926150",
      "INDEX ITEM DESCRIPTION": "Price control agencies",
    },
    {
      NAICS22: "926150",
      "INDEX ITEM DESCRIPTION": "Rent control agencies",
    },
    {
      NAICS22: "926150",
      "INDEX ITEM DESCRIPTION": "Securities regulation commissions",
    },
    {
      NAICS22: "926150",
      "INDEX ITEM DESCRIPTION":
        "Standards, setting and management, agencies, government",
    },
    {
      NAICS22: "926150",
      "INDEX ITEM DESCRIPTION": "Wage control agencies, government",
    },
    {
      NAICS22: "927110",
      "INDEX ITEM DESCRIPTION": "National Aeronautics and Space Administration",
    },
    {
      NAICS22: "927110",
      "INDEX ITEM DESCRIPTION": "Operating and launching government satellites",
    },
    {
      NAICS22: "927110",
      "INDEX ITEM DESCRIPTION": "Space flight operations, government",
    },
    {
      NAICS22: "927110",
      "INDEX ITEM DESCRIPTION": "Space research services, government",
    },
    {
      NAICS22: "928110",
      "INDEX ITEM DESCRIPTION": "Air Force",
    },
    {
      NAICS22: "928110",
      "INDEX ITEM DESCRIPTION": "Air traffic control, military",
    },
    {
      NAICS22: "928110",
      "INDEX ITEM DESCRIPTION": "Armed forces",
    },
    {
      NAICS22: "928110",
      "INDEX ITEM DESCRIPTION": "Army",
    },
    {
      NAICS22: "928110",
      "INDEX ITEM DESCRIPTION": "Courts, military",
    },
    {
      NAICS22: "928110",
      "INDEX ITEM DESCRIPTION": "Marine Corps",
    },
    {
      NAICS22: "928110",
      "INDEX ITEM DESCRIPTION": "Military bases and camps",
    },
    {
      NAICS22: "928110",
      "INDEX ITEM DESCRIPTION": "Military police",
    },
    {
      NAICS22: "928110",
      "INDEX ITEM DESCRIPTION": "Military reserve armories and bases",
    },
    {
      NAICS22: "928110",
      "INDEX ITEM DESCRIPTION": "Military training schools (except academies)",
    },
    {
      NAICS22: "928110",
      "INDEX ITEM DESCRIPTION": "National Guard",
    },
    {
      NAICS22: "928110",
      "INDEX ITEM DESCRIPTION": "Navy",
    },
    {
      NAICS22: "928110",
      "INDEX ITEM DESCRIPTION": "Space Force",
    },
    {
      NAICS22: "928120",
      "INDEX ITEM DESCRIPTION": "Consulates",
    },
    {
      NAICS22: "928120",
      "INDEX ITEM DESCRIPTION": "Diplomatic services",
    },
    {
      NAICS22: "928120",
      "INDEX ITEM DESCRIPTION":
        "Economic development assistance (i.e., international), government",
    },
    {
      NAICS22: "928120",
      "INDEX ITEM DESCRIPTION": "Embassies",
    },
    {
      NAICS22: "928120",
      "INDEX ITEM DESCRIPTION":
        "Foreign economic and social development services, government",
    },
    {
      NAICS22: "928120",
      "INDEX ITEM DESCRIPTION": "Foreign government service",
    },
    {
      NAICS22: "928120",
      "INDEX ITEM DESCRIPTION": "Foreign missions",
    },
    {
      NAICS22: "928120",
      "INDEX ITEM DESCRIPTION": "Immigration services",
    },
    {
      NAICS22: "928120",
      "INDEX ITEM DESCRIPTION": "International Monetary Fund",
    },
    {
      NAICS22: "928120",
      "INDEX ITEM DESCRIPTION":
        "Organization for Economic Cooperation and Development",
    },
    {
      NAICS22: "928120",
      "INDEX ITEM DESCRIPTION": "Organization of American States",
    },
    {
      NAICS22: "928120",
      "INDEX ITEM DESCRIPTION": "Passport issuing services",
    },
    {
      NAICS22: "928120",
      "INDEX ITEM DESCRIPTION": "Peace Corps",
    },
    {
      NAICS22: "928120",
      "INDEX ITEM DESCRIPTION": "State Department",
    },
    {
      NAICS22: "928120",
      "INDEX ITEM DESCRIPTION": "United Nations",
    },
    {
      NAICS22: "928120",
      "INDEX ITEM DESCRIPTION": "World Bank",
    },
    {
      NAICS22: "******",
      "INDEX ITEM DESCRIPTION": "Cards, publishing -- see specific product ",
    },
    {
      NAICS22: "******",
      "INDEX ITEM DESCRIPTION": "Clinics, medical -- see type ",
    },
    {
      NAICS22: "******",
      "INDEX ITEM DESCRIPTION": "Consultants -- see specific activity ",
    },
    {
      NAICS22: "******",
      "INDEX ITEM DESCRIPTION": "Contractors -- see specific activity ",
    },
    {
      NAICS22: "******",
      "INDEX ITEM DESCRIPTION":
        "Day camps, instructional -- see type of instruction ",
    },
    {
      NAICS22: "******",
      "INDEX ITEM DESCRIPTION": "Dealers -- see type ",
    },
    {
      NAICS22: "******",
      "INDEX ITEM DESCRIPTION": "Farming -- see type ",
    },
    {
      NAICS22: "******",
      "INDEX ITEM DESCRIPTION": "Hospitals -- see type ",
    },
    {
      NAICS22: "******",
      "INDEX ITEM DESCRIPTION": "Instruction -- see type of training ",
    },
    {
      NAICS22: "******",
      "INDEX ITEM DESCRIPTION": "Laboratories -- see specific type ",
    },
    {
      NAICS22: "******",
      "INDEX ITEM DESCRIPTION":
        "Leasing -- see type of property or article being leased ",
    },
    {
      NAICS22: "******",
      "INDEX ITEM DESCRIPTION":
        "Lessors -- see specific type of asset or property being rented or leased ",
    },
    {
      NAICS22: "******",
      "INDEX ITEM DESCRIPTION": "Mining -- see type ",
    },
    {
      NAICS22: "******",
      "INDEX ITEM DESCRIPTION": "Publishers -- see specific type ",
    },
    {
      NAICS22: "******",
      "INDEX ITEM DESCRIPTION":
        "Publishers and printing combined -- see specific type of publisher ",
    },
    {
      NAICS22: "******",
      "INDEX ITEM DESCRIPTION": "Publishers or publishing -- see specific type ",
    },
    {
      NAICS22: "******",
      "INDEX ITEM DESCRIPTION":
        "Rental -- see type of article or property being rented ",
    },
    {
      NAICS22: "******",
      "INDEX ITEM DESCRIPTION": "Repair -- see type of article being repaired ",
    },
    {
      NAICS22: "******",
      "INDEX ITEM DESCRIPTION": "Retail -- see type of dealer, shop, or store ",
    },
    {
      NAICS22: "******",
      "INDEX ITEM DESCRIPTION": "Shops -- see type ",
    },
    {
      NAICS22: "******",
      "INDEX ITEM DESCRIPTION": "Stores -- see type ",
    },
    {
      NAICS22: "******",
      "INDEX ITEM DESCRIPTION": "Tailors -- see specific apparel manufacturing ",
    },
    {
      NAICS22: "******",
      "INDEX ITEM DESCRIPTION": "Therapists' offices -- see type ",
    },
    {
      NAICS22: "******",
      "INDEX ITEM DESCRIPTION": "Transportation -- see mode ",
    },
    {
      NAICS22: "******",
      "INDEX ITEM DESCRIPTION": "Wholesale -- see type of product ",
    },
  ];
